'use strict';

var React = require('react');
var reactRouter = require('react-router');
var reactRedux = require('react-redux');
var apolloLinkHttp = require('apollo-link-http');
var apolloClient = require('apollo-client');
var gql = require('graphql-tag');
var ApolloLinkTimeout = require('apollo-link-timeout');
var apolloLink = require('apollo-link');
var delay = require('delay');
var experience = require('@foko/experience');
var axios = require('axios');
var qs = require('qs');
var strictlyTypedEvents = require('strictly-typed-events');
var tsUtil = require('@workforcesoftware/ts-util');
var connectedReactRouter = require('connected-react-router');
var Keycloak = require('keycloak-js');
var appendQuery = require('append-query');
var oidcClientTs = require('oidc-client-ts');
var promiseDelegate = require('promise-delegate');
var broadcastChannel = require('broadcast-channel');
var asyncWaitUntil = require('async-wait-until');
var uuid = require('uuid');
var jwtDecode = require('jwt-decode');
require('graphql/language/visitor');
var polished = require('polished');
var _ = require('lodash');
var lighthouseComponentLibrary = require('@workforcesoftware/lighthouse-component-library');
var localizationFramework = require('@workforcesoftware/localization-framework');
var require$$1 = require('object-assign');
var ReactDOM = require('react-dom');
var reactRouterDom = require('react-router-dom');
var i18next = require('i18next');
var reactI18next = require('react-i18next');
var titlecase = require('titlecase');
var MediaQuery = require('react-responsive');
var tsReactUtil = require('@workforcesoftware/ts-react-util');
var reactFontawesome = require('@fortawesome/react-fontawesome');
var freeSolidSvgIcons = require('@fortawesome/free-solid-svg-icons');
var reactDeviceDetect = require('react-device-detect');
var styled = require('styled-components');
var faTimes = require('@fortawesome/free-solid-svg-icons/faTimes');
var faCheckCircle = require('@fortawesome/free-solid-svg-icons/faCheckCircle');
var rem = require('polished/lib/helpers/rem');
var penpal = require('penpal');
var throttle$1 = require('throttleit');
var suiteIframeActivityRelay = require('@workforcesoftware/suite-iframe-activity-relay');
var redux = require('redux');
var reduxDevtoolsExtension = require('redux-devtools-extension');
var reduxThunk = require('redux-thunk');
var history$3 = require('history');
var cloneDeep = require('lodash/cloneDeep');
var storage = require('redux-persist/lib/storage');
var reduxPersist = require('redux-persist');
var autoMergeLevel2 = require('redux-persist/lib/stateReconciler/autoMergeLevel2');
var faAngleLeft = require('@fortawesome/free-solid-svg-icons/faAngleLeft');
var faAngleRight = require('@fortawesome/free-solid-svg-icons/faAngleRight');
var tsEnumUtil = require('ts-enum-util');
var Favicon = require('react-favicon');
var dateAndTime = require('@workforcesoftware/date-and-time');
var react = require('redux-persist/integration/react');
var storage$1 = require('@webcrypto/storage');
var reactIdleTimer = require('react-idle-timer');
require('@workforcesoftware/lighthouse-component-library/build/lighthouse.scss');
var luxon = require('luxon');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var gql__default = /*#__PURE__*/_interopDefault(gql);
var ApolloLinkTimeout__default = /*#__PURE__*/_interopDefault(ApolloLinkTimeout);
var delay__default = /*#__PURE__*/_interopDefault(delay);
var axios__default = /*#__PURE__*/_interopDefault(axios);
var Keycloak__default = /*#__PURE__*/_interopDefault(Keycloak);
var appendQuery__default = /*#__PURE__*/_interopDefault(appendQuery);
var ___default = /*#__PURE__*/_interopDefault(_);
var require$$1__default = /*#__PURE__*/_interopDefault(require$$1);
var ReactDOM__namespace = /*#__PURE__*/_interopNamespace(ReactDOM);
var i18next__default = /*#__PURE__*/_interopDefault(i18next);
var MediaQuery__default = /*#__PURE__*/_interopDefault(MediaQuery);
var styled__default = /*#__PURE__*/_interopDefault(styled);
var rem__default = /*#__PURE__*/_interopDefault(rem);
var throttle__default = /*#__PURE__*/_interopDefault(throttle$1);
var reduxThunk__default = /*#__PURE__*/_interopDefault(reduxThunk);
var cloneDeep__default = /*#__PURE__*/_interopDefault(cloneDeep);
var storage__default = /*#__PURE__*/_interopDefault(storage);
var autoMergeLevel2__default = /*#__PURE__*/_interopDefault(autoMergeLevel2);
var Favicon__default = /*#__PURE__*/_interopDefault(Favicon);

var framework;
var getFrameworkInstance = function () { return framework; };
var setFrameworkInstance = function (lighthouseFramework) {
    framework = lighthouseFramework;
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

/**
 *  For passing parameter to route, idPlaceholder is defined as a regex to
 *  allow any string at least one character long prefixed with colon.
 */
var idPlaceholder = /:\w+/g;
exports.FrameworkRouteIds = void 0;
(function (RouteIds) {
    RouteIds["Home"] = "home";
    RouteIds["Login"] = "login";
    RouteIds["WtaTokenLogin"] = "login/wta";
    RouteIds["WtaLogout"] = "logout/wta";
    RouteIds["Preferences"] = "preferences";
    RouteIds["POCChildIframe"] = "poc/childIframe";
    RouteIds["SpecificPreference"] = "singlePreference";
    RouteIds["ExternalPage"] = "externalPage";
    RouteIds["Authenticate"] = "authenticate";
    RouteIds["SystemConfig"] = "systemConfig";
    RouteIds["Launch"] = "launch";
    RouteIds["wfxMessageRoute"] = "/bare/messages";
    RouteIds["wfxBroadcastsRoute"] = "/bare/broadcasts/live";
    RouteIds["wfxTasksAssignedRoute"] = "/bare/tasks/assigned";
})(exports.FrameworkRouteIds || (exports.FrameworkRouteIds = {}));
var RouteIds = exports.FrameworkRouteIds;

var routes$1 = new Map();
var clearRoutes = function () {
    routes$1.clear();
};
var registerRoute = function (route) {
    if (routes$1.has(route.id)) {
        throw Error("Route with id: " + route.id + " already exists");
    }
    routes$1.set(route.id, route);
};
var registerRoutes = function (routeSpecifications) {
    return routeSpecifications.forEach(function (route) { return registerRoute(route); });
};
var findRouteByName = function (routeIdToFind, idToSubstitute) {
    var routeSpecification = routes$1.get(routeIdToFind);
    if (!routeSpecification) {
        global.console.warn("Route not found with id '" + routeIdToFind + "'");
        return;
    }
    var matchedIds = routeSpecification.route.match(idPlaceholder);
    if (matchedIds !== null) {
        if (!idToSubstitute) {
            throw Error("Route requires an id, but none is provided: " + routeSpecification.route);
        }
        return routeSpecification.route.replace(matchedIds[0], idToSubstitute);
    }
    return routeSpecification.route;
};
var getPublicRoutes = function () {
    return Array.from(routes$1.values()).filter(function (routeSpecification) {
        return !routeSpecification.restricted && !routeSpecification.auxiliary;
    });
};
var getPrivateRoutes = function () {
    return Array.from(routes$1.values()).filter(function (routeSpecification) {
        return routeSpecification.restricted && !routeSpecification.auxiliary;
    });
};
// TODO: This is a temporary solution to filter out routes that require
//  permissions. Ideally, whether or not a route requires permissions should be
//  defined in the route specification itself. As part of a future refactor,
//  we should consider adding a boolean property to the RouteSpecification
//  interface.
var routesToFilterBasedOnPermissions = [
    RouteIds.SystemConfig,
    RouteIds.POCChildIframe,
];
/**
 * Returns private internal routes that the user has permission to access. Currently the only route
 * that needs to be checked for permissions is the SystemConfig route. External route permissions
 * are checked in the external page view component.
 */
var getPrivateRoutesWithPermissions = function (navigationItems, featureFlags, isUiTestingMode) {
    return getPrivateRoutes().filter(function (routeSpecification) {
        if (isUiTestingMode) {
            return true;
        }
        if (routesToFilterBasedOnPermissions.indexOf(routeSpecification.id) !== -1) {
            if (routeSpecification.featureFlag) {
                // Return true if featureFlags contains the featureFlag key
                // and the feature flag is enabled
                if (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags[routeSpecification.featureFlag]) {
                    return true;
                }
            }
            // These are internal lthNavigation routes, e.g. preferences and logout.
            // Other types of navigation items do not have a value for the route key.
            for (var _i = 0, _a = Object.values(navigationItems); _i < _a.length; _i++) {
                var navItem = _a[_i];
                if (navItem.route && navItem.route === routeSpecification.id) {
                    return true;
                }
            }
            return false;
        }
        return true;
    });
};
var getAuxiliaryRoutes = function () {
    return Array.from(routes$1.values()).filter(function (routeSpecification) {
        return Boolean(routeSpecification.auxiliary);
    });
};
var routeContext = {
    clearRoutes: clearRoutes,
    registerRoutes: registerRoutes,
    findRouteByName: findRouteByName,
    getPublicRoutes: getPublicRoutes,
    getPrivateRoutes: getPrivateRoutes,
    getPrivateRoutesWithPermissions: getPrivateRoutesWithPermissions,
    getAuxiliaryRoutes: getAuxiliaryRoutes,
};
var RouteContext = React__namespace.createContext(routeContext);
/**
 * A HOC that adds routeContext param to any component that may receive such prop
 */
var wrapComponentInRouteContext = function (WrappedComponent) { return function (props) { return (React__namespace.createElement(RouteContext.Consumer, null, function (context) {
    // Hence casting props to P is necessary due to TypeScript issue
    // See: https://github.com/Microsoft/TypeScript/issues/28938
    return React__namespace.createElement(WrappedComponent, __assign({}, props, { routeContext: context }));
})); }; };

var Context = React__namespace.createContext({});

// TODO: LTH-3744 - Move configuration value into FrameworkConfiguration interface. The framework is not a module, and
//  module configuration should not contain framework configuration
/**
 * List of configuration values understood by the Framework.
 */
var ConfigurationValues$1;
(function (ConfigurationValues) {
    ConfigurationValues["DisableApplicationFrame"] = "disableApplicationFrame";
})(ConfigurationValues$1 || (ConfigurationValues$1 = {}));
/**
 * The internal name of this configuration module.
 * TODO: LTH-3744 - Remove this, this is framework config that should be part of FrameworkConfiguration. The `framework`
 *  is not a module
 */
var moduleName$1 = "framework";

/**
 * Config Properties
 */
var GRAPHQL_PATH = "graphql";
var SERVICE_BASE_URL = "serviceBaseURL";
var WTA_BASE_URL = "wtaBaseUrl";
var FS_BASE_URL = "fsBaseUrl";
var NAVIGATION_SERVICE = "navigation-service";
var USER_PREFERENCES_SERVICE_NAME$2 = "user-preferences";
var NAV_MY_TIME_SHEET_LNK_ID = "LINK/MY_TIME_SHEET_VALIDATE";
var NAV_GRP_TIME_ENTRY_LNK_ID = "LINK/GRP_TIME_ENTRY";

var store;
var persistor;
function setStore(newStore) {
    store = newStore;
}
function getStore() {
    return store;
}
function setPersistor(newPersistor) {
    persistor = newPersistor;
}
function getPersistor() {
    return persistor;
}

var hubCards$1 = [
	"scheduling-ui/schedule",
	"time/bankBalance",
	"time/timesheetSummaryCard",
	"time/timeSheetExceptionsCard",
	"time-off-ui/timeOffRequestCard",
	"clock-ui/clockCard",
	"data-insights-ui/overtimeCard",
	"data-insights-ui/scheduleVActualCard",
	"data-insights-ui/configurableCard"
];
var featuresEnabled$1 = {
	"ScheduleCard.QueryForData": true,
	"BankBalanceCard.QueryForData": true,
	"TimesheetSummaryCard.QueryForData": true,
	"TimeOffRequestCard.QueryForData": true,
	"UserPreferences.QueryForData": true,
	"TimeSheetExceptionsCard.QueryForData": true,
	"TimeSheetExceptionsCard.ShowCardActions": true,
	"DataInsightsUI.ShowCardActions": true
};
var inboxItems$1 = [
];
var realUser = {
	hubCards: hubCards$1,
	featuresEnabled: featuresEnabled$1,
	inboxItems: inboxItems$1
};

var organization = "wfs-supplies";
var name = "Betsy Draper";
var firstName = "Betsy";
var lastName = "Draper";
var initials = "BD";
var firstInitial = "B";
var lastInitial = "D";
var username = "betsy";
var password = "betsy";
var wtaBaseUrl = "https://attendance-demo-us4.qa.wfsaas.com/workforce/";
var fsBaseUrl = "https://scheduling-demo-us4.wfs.cloud/";
var menuItems = [
	{
		title: "Preferences"
	},
	{
		title: "Logout"
	}
];
var navigationItems = [
	{
		title: "Schedule",
		subMenu: [
			{
				title: "Group Calendars",
				externalPage: {
					sourceUrlKey: "wtaBaseUrl",
					relativePageUrl: "Calendar.do?action=groupLoad"
				}
			},
			{
				title: "Scheduling",
				externalPage: {
					sourceUrlKey: "wfsBaseUrl",
					relativePageUrl: "scheduling/router"
				}
			},
			{
				title: "Scheduling (Herald)",
				route: "herald"
			},
			{
				title: "Shift Management",
				route: "shift_management"
			},
			{
				title: "My Calendar",
				route: "myCalendar"
			}
		]
	},
	{
		title: "Time",
		subMenu: [
			{
				title: "My Timesheet",
				externalPage: {
					sourceUrlKey: "wtaBaseUrl",
					relativePageUrl: "TimeEntry.do?action=viewMyTimesheet&securityMode=employeeSelfEntry&asgnmtId=1959406282"
				}
			},
			{
				title: "Edit Employee Time",
				externalPage: {
					sourceUrlKey: "wtaBaseUrl",
					relativePageUrl: "ManagerFrame.do?action=createManagerFrame&timeSchedType=TIME_ENTRY"
				}
			},
			{
				title: "Edit Time for Groups",
				externalPage: {
					sourceUrlKey: "wtaBaseUrl",
					relativePageUrl: "groupTimeEntry.do?action=init"
				}
			},
			{
				title: "Approve Timesheets",
				externalPage: {
					sourceUrlKey: "wtaBaseUrl",
					relativePageUrl: "ApprovalWindow.do?action=create"
				}
			},
			{
				title: "View Reports",
				externalPage: {
					sourceUrlKey: "wtaBaseUrl",
					relativePageUrl: "Reports.do"
				}
			},
			{
				title: "Manage Delegations",
				externalPage: {
					sourceUrlKey: "wtaBaseUrl",
					relativePageUrl: "DelegationStart.do?action=create"
				}
			}
		]
	},
	{
		title: "Time Off",
		subMenu: [
			{
				title: "My Time Off",
				externalPage: {
					sourceUrlKey: "wtaBaseUrl",
					relativePageUrl: "EmployeeTimeoffRequestWindow.do?action=start"
				}
			},
			{
				title: "Review Time Off Requests",
				externalPage: {
					sourceUrlKey: "wtaBaseUrl",
					relativePageUrl: "ManagerTimeoffRequestWindow.do?action=create"
				}
			}
		]
	}
];
var allowAutoLogin = true;
var hiddenCards = [
];
var hubCards = [
	"scheduling-ui/schedule",
	"time/bankBalance",
	"time/timeSheetExceptionsCard",
	"time/timesheetSummaryCard",
	"time-off-ui/timeOffRequestCard"
];
var featuresEnabled = {
	"TimesheetSummaryCard.QueryForData": true
};
var inboxItems = [
	{
		id: "4",
		type: "urgentMessage",
		exceptionLevel: "URGENT",
		timeElapsed: "2",
		title: "missed punch",
		employeeName: "Wilton Betts",
		employeeId: "USA09-00",
		message: "03/21/2019: Employee was scheduled for 08:00, but has not yet arrived"
	},
	{
		id: "17",
		type: "shiftSwap",
		exceptionLevel: "",
		requestDateTime: "2019-03-14T10:00:00-05:00",
		requesterShift: {
			shiftId: "1",
			employeeId: "200",
			shiftStart: "2019-03-29T09:00:00-05:00",
			shiftEnd: "2019-03-29T17:00:00-05:00",
			name: "Billie Albert",
			duration: "10",
			jobName: "Job A",
			location: "Location 201",
			requiredSkills: [
				{
					skillTitle: "Shipping"
				}
			]
		},
		recipientShift: {
			shiftId: "2",
			employeeId: "300",
			shiftStart: "2019-04-01T09:00:00-05:00",
			shiftEnd: "2019-04-01T17:00:00-05:00",
			name: "Lon Mayer",
			duration: "10",
			jobName: "Job A",
			location: "Location 201",
			requiredSkills: [
				{
					skillTitle: "Shipping"
				}
			]
		},
		status: "ACCEPTED",
		source: "WTA",
		comments: "I've got family visiting from out of town and need a later shift!",
		exceptions: [
		]
	},
	{
		id: "1",
		type: "timeOffRequest",
		exceptionLevel: "",
		requestDateTime: "2019-03-21T10:00:00-06:00",
		employee: "Darwin Barry",
		startDate: "2019-09-06T09:00:00-06:00",
		endDate: "2019-09-06T17:00:00-06:00",
		initiationDate: "2019-03-21T10:00:00-06:00",
		leaveType: "Sick",
		reason: "Nature hike with my dog",
		unit: "Hours",
		bankBalances: [
			{
				transactionAmount: -8,
				endingAmount: 24,
				startingAmount: 32,
				transactionDate: "2019-09-06T09:00:00-06:00",
				bankName: "Sick"
			}
		]
	},
	{
		id: "3",
		type: "timeOffRequest",
		exceptionLevel: "",
		requestDateTime: "2019-03-21T10:00:00-06:00",
		employee: "Toni Riggs",
		startDate: "2019-10-11T09:00:00-06:00",
		endDate: "2019-10-11T17:00:00-06:00",
		initiationDate: "2019-03-21T10:00:00-06:00",
		leaveType: "Vacation",
		unit: "Hours",
		reason: "No comment",
		bankBalances: [
			{
				transactionAmount: -8,
				endingAmount: 24,
				startingAmount: 32,
				transactionDate: "2019-10-11T09:00:00-06:00",
				bankName: "Vacation"
			}
		]
	}
];
var time = {
	timesheets: [
		{
			id: 1,
			startDate: "2019-04-28T00:00:00-06:00",
			endDate: "2019-05-04T00:00:00-06:00",
			totalHours: "8",
			entries: [
				{
					id: 1,
					date: "2019-05-03T00:00:00-06:00",
					slices: [
						{
							id: 1,
							payCode: "Work",
							startTime: "2019-05-03T09:00:00-06:00",
							endTime: "2019-05-03T14:00:00-06:00",
							elapsedHours: 0
						}
					],
					exception: "NONE"
				},
				{
					id: 2,
					date: "2019-05-04T00:00:00-06:00",
					slices: [
						{
							id: 1,
							payCode: "Work",
							startTime: "2019-05-04T08:00:00-06:00",
							endTime: "2019-05-04T16:00:00-06:00",
							elapsedHours: 0
						}
					],
					exception: "NONE"
				},
				{
					id: 3,
					date: "2019-05-05T00:00:00-06:00",
					slices: [
						{
							id: 1,
							payCode: "Work",
							startTime: "2019-05-05T09:00:00-06:00",
							endTime: "2019-05-05T17:00:00-06:00",
							elapsedHours: 0
						}
					],
					exception: "NONE"
				},
				{
					id: 4,
					date: "2019-05-06T00:00:00-06:00",
					slices: [
						{
							id: 1,
							payCode: "Vacation",
							startTime: "",
							endTime: "",
							elapsedHours: 6
						}
					],
					exception: "NONE"
				}
			]
		}
	],
	bankBalances: [
		{
			name: "Sick",
			unit: "Hrs",
			balance: "8",
			bankId: "SICK"
		},
		{
			name: "Vacation",
			unit: "Hrs",
			balance: "20",
			bankId: "VAC"
		}
	],
	exceptions: [
		{
			date: "2019-03-21",
			employees: [
				{
					name: "Wilton Betts",
					exceptions: [
						{
							level: "WARNING",
							date: "2019-03-21T00:00:00-06:00",
							message: "Employee was scheduled for 08:00, but has not yet arrived",
							acknowledgementStatus: "N/A"
						}
					]
				}
			]
		},
		{
			date: "2019-03-20",
			employees: [
				{
					name: "Lanny Bloom",
					exceptions: [
						{
							level: "ERROR",
							date: "2019-03-20T00:00:00-06:00",
							message: "Time Entry: Missing In or Out time",
							acknowledgementStatus: "N/A"
						}
					]
				},
				{
					name: "Mary Leal",
					exceptions: [
						{
							level: "WARNING",
							date: "2019-03-20T00:00:00-06:00",
							message: "No time entered on a scheduled day",
							acknowledgementStatus: "N/A"
						}
					]
				}
			]
		}
	],
	exceptionsFilters: [
		"errors",
		"warnings"
	]
};
var scheduling = {
	schedule: {
		days: [
			{
				workDate: "2019-03-17",
				shifts: [
				]
			},
			{
				workDate: "2019-03-18",
				shifts: [
					{
						startAt: "2019-03-18T08:00:00",
						endAt: "2019-03-18T10:00:00",
						location: "Store 211"
					}
				]
			},
			{
				workDate: "2019-03-19",
				shifts: [
					{
						startAt: "2019-03-19T08:00:00",
						endAt: "2019-03-19T12:00:00",
						location: "Store 211"
					}
				]
			},
			{
				workDate: "2019-03-20",
				shifts: [
					{
						startAt: "2019-03-20T08:00:00",
						endAt: "2019-03-20T11:00:00",
						location: "Store 211"
					}
				]
			},
			{
				workDate: "2019-03-21",
				shifts: [
					{
						startAt: "2019-03-21T07:00:00",
						endAt: "2019-03-21T08:00:00",
						location: "Store 214"
					}
				]
			},
			{
				workDate: "2019-03-22",
				shifts: [
					{
						startAt: "2019-03-22T07:00:00",
						endAt: "2019-03-22T08:00:00",
						location: "Store 214"
					}
				]
			},
			{
				workDate: "2019-03-23",
				shifts: [
				]
			}
		]
	}
};
var notification = {
	title: "Dan Hadley hasn't clocked in",
	message: "Dan Hadley was scheduled to start at 9am",
	delay: 24
};
var betsy = {
	organization: organization,
	name: name,
	firstName: firstName,
	lastName: lastName,
	initials: initials,
	firstInitial: firstInitial,
	lastInitial: lastInitial,
	username: username,
	password: password,
	wtaBaseUrl: wtaBaseUrl,
	fsBaseUrl: fsBaseUrl,
	menuItems: menuItems,
	navigationItems: navigationItems,
	allowAutoLogin: allowAutoLogin,
	hiddenCards: hiddenCards,
	hubCards: hubCards,
	featuresEnabled: featuresEnabled,
	inboxItems: inboxItems,
	time: time,
	scheduling: scheduling,
	notification: notification
};

var users = {
    betsy: betsy,
};
var usersList = Object.values(users);

/**
 * Gets the mock data for the given username and organization.
 */
function getUserData(_a) {
    var username = _a.username, organization = _a.organization, name = _a.name, firstName = _a.firstName, lastName = _a.lastName;
    // This function assumes that the user's login attempt was successful.
    // We should NOT be trying to retrieve userdata if login was unsuccessful
    var lowercaseUsername = username.toLowerCase();
    var lowercaseOrganization = organization.toLowerCase();
    var userData = usersList.find(function (user) {
        return (user.username.toLowerCase() === lowercaseUsername &&
            user.organization.toLowerCase() === lowercaseOrganization);
    });
    // If no userData is found, use default data and populate its fields.
    if (!userData) {
        var nameData = name && firstName && lastName
            ? {
                name: name,
                firstName: firstName,
                lastName: lastName,
                firstInitial: firstName[0],
                lastInitial: lastName[0],
                initials: firstName[0] + lastName[0],
            }
            : {
                name: "",
                firstName: "",
                lastName: "",
                firstInitial: "",
                lastInitial: "",
                initials: "",
            };
        userData = __assign(__assign(__assign({}, realUser), nameData), { username: lowercaseUsername, organization: lowercaseOrganization });
    }
    return userData;
}
/**
 * Determine if feature is enabled for currently logged in user.
 *
 * @param featureId ID of feature to check if enabled.
 *                  Features that do not have an ID are always enabled.
 * @throws Error if user is not logged in.
 * @returns {boolean}
 */
function isFeatureEnabled(featureId) {
    if (!featureId) {
        throw new Error("Invalid feature: " + featureId);
    }
    var applicationState = getStore().getState();
    var featuresEnabled = {};
    if (!applicationState.loginDetails.bearerToken) {
        return false; // Not enabled in user data because there is no user data.
    }
    if (applicationState.mockedAccountData.data === null) {
        return false; // Not enabled in user data because there are no mocked features
    }
    featuresEnabled = applicationState.mockedAccountData.data.featuresEnabled;
    if (featuresEnabled) {
        return Boolean(featuresEnabled[featureId]);
    }
    return false;
}

/**
 * Checks if the WFS app was opened using a mobile device with Cordova.
 * @returns true if the app is using Cordova, false otherwise.
 */
var isCordovaDevice = function () {
    return !!window.cordova;
};
/**
 * Checks if the WFS app was opened using the mobile app.
 * @returns true if the WFS app is opened from the mobile app and NOT a mobile browser.
 *          This returns false if the WFS app is opened from the mobile browser.
 */
var isMobileDevice = function () {
    var cordova = window.cordova;
    return cordova && cordova.InAppBrowser;
};
/**
 * Checks if the WFS app was opened using the iOS mobile app.
 * @returns true if the WFS app is opened from the iOS mobile app and NOT a mobile browser.
 *          This returns false if the WFS app is opened from the mobile browser even if it's
 *          an iOS device.
 */
var isiOSDevice = function () {
    var device = window.device;
    return device && device.platform === "iOS";
};
/**
 * Checks if the WFS app was opened using the Android mobile app.
 * @returns true if the WFS app is opened from the Android mobile app and NOT a mobile browser.
 *          This returns false if the WFS app is opened from the mobile browser even if it's
 *          an Android device.
 */
var isAndroidDevice = function () {
    var device = window.device;
    return device && device.platform === "Android";
};
function openUrlInSystemBrowser(url) {
    window.open(url, "_system");
}

var WFX_API_BASE_URL_STAGING = "https://staging.foko-services.com";
var WFX_API_BASE_URL_PROD = "https://api-us.experience.workforcesoftware.com";
var WFX_APP_ID = "com.workforcesoftware.lighthouseapp";
var WFX_VALID_URL_PATTERN = /(^http:\/\/localhost:\d{4}\/)|(^https:\/\/pr-\d{4}-m-dot-foko-dev.uc.r.appspot.com\/)/;

/**
 * WFX feature flag key Enum
 * This should include any core WFX feature flags i.e. not temporary development ones like wfx_task_hubcard_assignee
 * @enum {string}
 */
exports.WfxFeatureFlagKey = void 0;
(function (WfxFeatureFlagKey) {
    WfxFeatureFlagKey["DIRECT_MESSAGING"] = "wfx";
    WfxFeatureFlagKey["TASKS"] = "wfx_tasks";
    WfxFeatureFlagKey["CHANNELS"] = "wfx_channels";
    WfxFeatureFlagKey["DOCS"] = "wfx_docs";
    WfxFeatureFlagKey["SUITE_DIRECT_MESSAGING"] = "wfx_new_dms";
    WfxFeatureFlagKey["BROADCASTS"] = "wfx_broadcasts";
})(exports.WfxFeatureFlagKey || (exports.WfxFeatureFlagKey = {}));

/**
 * Checks if any WFX features are enabled based on Feature Flags
 * @param {Object} featureFlags The feature flags object to pass in
 * @returns true if any of the WFX features are enabled, false if none are enabled
 */
var isAnyWfxFeatureFlagEnabled = function (featureFlags) {
    return Object.values(exports.WfxFeatureFlagKey).some(function (flagKey) { return featureFlags[flagKey]; });
};

/**
 * Verifies if the iframe's url is valid
 * @param {string} externalPageSrc - The source url for the iframe
 * @returns true if it is valid, false otherwise
 */
var isValidWfxUrl = function (externalPageSrc) {
    if (externalPageSrc === void 0) { externalPageSrc = ""; }
    var isStagingUrl = externalPageSrc.startsWith("https://web.staging.ex.wfs.cloud" /* Staging */);
    var isProdUrl = externalPageSrc.startsWith("https://web.ex.wfs.cloud" /* Production */);
    var isValidUrl = WFX_VALID_URL_PATTERN.test(externalPageSrc);
    return isValidUrl || isStagingUrl || isProdUrl;
};
/**
 * Logout from WFX session
 */
var wfxLogout = function () { return __awaiter(void 0, void 0, void 0, function () {
    var featureFlags;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                featureFlags = (_a = getFrameworkInstance()).getNamedFeatureFlags.apply(_a, Object.values(exports.WfxFeatureFlagKey));
                if (!isAnyWfxFeatureFlagEnabled(featureFlags)) return [3 /*break*/, 2];
                return [4 /*yield*/, experience.AuthService.logout()];
            case 1:
                _b.sent();
                _b.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); };
/**
 * Force logout from the WFX application.
 * @returns {Promise<void>} A promise that resolves when the logout is complete.
 */
var forceWfxLogout = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, experience.AuthService.logout()];
    });
}); };

var LATEST_ENVIRONMENT$1 = "latest";
var SPRINT_ENVIRONMENT$1 = "sprint";
var GRS_LATEST_URL = "https://grs-latest-us8.wfs.cloud/api/v1.0/accountInfo";
var GRS_SPRINT_URL = "https://grs-sprint-us8.wfs.cloud/api/v1.0/accountInfo";
var GRS_PROD_URL = "https://grs.wfs.cloud/api/v1.0/accountInfo";
var ORGANIZATION_ID_LOCAL_STORAGE_KEY = "organizationId";
var SKIP_ACCOUNT_SELECTION_LOCAL_STORAGE_KEY = "skipAccountSelection";
var ACCESS_TOKEN_LOCAL_STORAGE_KEY = "keycloakAccessToken";
var REFRESH_TOKEN_LOCAL_STORAGE_KEY = "keycloakRefreshToken";
var ID_TOKEN_LOCAL_STORAGE_KEY = "keycloakIdentityToken";
var ID_TOKEN_CLAIMS_STORAGE_KEY = "IdentityTokenClaims";
var SESSION_ID_STORAGE_KEY = "keycloakSessionId";
var KEYCLOAK_CLIENT_ID = "lighthouse";
// AIM
var AIM_ACCESS_TOKEN_LOCAL_STORAGE_KEY = "aimAccessToken";
var AIM_IDENTITY_TOKEN_LOCAL_STORAGE_KEY = "aimIdentityToken";
/**
 * The minimum time (in seconds) left on the token before it expires and we attempt to refresh it
 */
var TOKEN_REFRESH_BUFFER_SECONDS = 30;
/**
 * Only to be used for the purposes of InAppBrowser redirection from CAS
 * This is an invalid url that CAS will redirect to, which we'll use to know when the auth flow
 * is complete
 */
var INVALID_LOCALHOST_URL = "http://localhost";
/**
 * The URL scheme name used to identify callbacks for the browser-based SSO flow
 */
var SSO_BROWSER_LOGIN_SCHEME_NAME = "workforce";
/**
 * The scheme used for the SSO login flow for the mobile app
 */
var SSO_BROWSER_LOGIN_SCHEME = SSO_BROWSER_LOGIN_SCHEME_NAME + "://wfs.cloud";
/**
 * Error message for token refresh failure during session establishment
 */
var ESTABLISH_SESSION_TOKEN_REFRESH_FAILURE_ERROR = "Token refresh failure while establishing session";
var TOKEN_REFRESH_FAILED_MESSAGE = "refresh-failed";

function hasSkipAccountSelection() {
    return (localStorage.getItem(SKIP_ACCOUNT_SELECTION_LOCAL_STORAGE_KEY) === "true");
}
function setSkipAccountSelection(value) {
    localStorage.setItem(SKIP_ACCOUNT_SELECTION_LOCAL_STORAGE_KEY, String(value));
}
function clearSkipAccountSelection() {
    localStorage.removeItem(SKIP_ACCOUNT_SELECTION_LOCAL_STORAGE_KEY);
}

var AuthenticationStatus;
(function (AuthenticationStatus) {
    AuthenticationStatus["Initializing"] = "Initializing";
    AuthenticationStatus["Authenticated"] = "Authenticated";
    AuthenticationStatus["NotAuthenticated"] = "NotAuthenticated";
    AuthenticationStatus["LoggingOut"] = "LoggingOut";
    AuthenticationStatus["MockAuthenticated"] = "MockAuthenticated";
})(AuthenticationStatus || (AuthenticationStatus = {}));

/**
 * Predefined logout option presets for common use cases.
 * Use these instead of manually setting individual flags.
 */
var LogoutPresets = {
    /**
     * Full logout from all systems (default behavior).
     * Logs out from: AIM, Suite, WTA, DS, WFX
     */
    FULL: {},
    /**
     * AIM and Suite only logout - skips all downstream application logouts.
     * Use this when you only need to clear AIM session and Suite tokens
     * without affecting WTA, Scheduling, or Experience sessions.
     *
     * Logs out from: AIM, Suite
     * Skips: WTA, DS, WFX
     */
    AIM_AND_SUITE_ONLY: {
        skipWTALogout: true,
        skipDSLogout: true,
        skipWfxLogout: true,
    },
    /**
     * Logout without token - used when the access token may be invalid.
     * Performs full logout but doesn't include token in logout requests.
     */
    WITHOUT_TOKEN: {
        withoutToken: true,
    },
};

/**
 * Singleton instance of AuthenticationState
 */
var instance$1;
/**
 * State management class, usable by both AuthenticationManager and AuthenticationService implementations
 * Whenever this fires an event the AuthenticationManager should fire it too.
 */
var AuthenticationState = /** @class */ (function (_super) {
    __extends(AuthenticationState, _super);
    function AuthenticationState() {
        var _this = _super.call(this) || this;
        _this.authStatus = AuthenticationStatus.Initializing;
        /**
         * Used to block logout from happening on impersonation initiation
         * This happens before we've left the Suite to make a request to the impersonate endpoint on CAS
         */
        _this.impersonating = false;
        /**
         * Used to indicate that the impersonation query parameter is set to true
         * It will be true after the initial request to /impersonate in CAS returns
         * Unused by the Keycloak-js implementation
         * Skips/cancels logout if we've already returned from the initial impersonate call
         * (that call logs the user out anyways)
         * already and are just clearing Suite tokens before the new ones are set.
         */
        _this.impersonationQueryParameter = false;
        /**
         * Used to indicate whether account skip query parameters are set in the url.
         * The purpose of these query params is to trigger "immediate" login by forwarding to CAS
         * without asking the user to input an account.
         * This may be useful for Idp-Initiated SSO, where the user authenticates with the IdP first
         * and then redirects to the Suite, with the intent to "immediately" login by leveraging the IdP session.
         *
         * These are at the time of writing:
         * accountId={accountId}&skipAccountSelectionInput=true
         * These parameters will trigger a redirection to CAS to re-acquire a session
         */
        _this.skipAccountQueryParamsPresent = false;
        /**
         * Boolean indicating whether or not this instance of the Suite is the leader tab
         * The leader tab is responsible for refreshing tokens and other auth related
         * operations which only make sense for a single client.
         * Non-leader tabs on the other hand should avoid doing these operations
         * This helps simplify multi-tab auth behavior.
         * @private
         */
        _this.isLeaderTab = false;
        /**
         * Boolean indicating whether or not we're doing token login
         * Helps to hint to other parts of the auth system that we're in a special flow
         * This is helpful because the behavior for each type of auth flow can be different.
         * For example, WTA token login should not log the user out if token refresh fails
         * Instead we want to authenticate directly against CAS to get a new token.
         * @private
         */
        _this.performingTokenLogin = false;
        _this._isAimProvider = false;
        _this._useBrowserBasedSSO = false;
        // ------- Supporting multiple auth providers through the Gateway -------
        /**
         * Auth provider: "keycloak" or some other IdP
         * Comes from the response to the Gateway auth request
         */
        _this._authProvider = null;
        /**
         * Auth url returned from the GRS
         * Comes from the response to the Gateway auth request
         * Appending /.well-known/openid-configuration to this url gives the discovery url
         * The discovery url has all the other endpoints, which are also extensions of the base url.
         * E.g. base url: https://cas-latest-us8.wfs.cloud/auth/realms/gsd_us8_one
         * discovery url: https://cas-latest-us8.wfs.cloud/auth/realms/gsd_us8_one/.well-known/openid-configuration
         * authorization url: https://cas-latest-us8.wfs.cloud/auth/realms/gsd_us8_one/protocol/openid-connect/auth
         */
        _this._authUrl = null;
        // ------- AIM Authentication Provider Properties -------
        /**
         * AIM client identifier for web applications.
         *
         * This value is provided by the Gateway
         * when using AIM as the authentication provider. It's required for
         * establishing authentication sessions with AIM endpoints.
         *
         */
        _this._aimClientId = undefined;
        /**
         * AIM logout endpoint URL.
         *
         * This URL is used to properly terminate AIM authentication sessions.
         * The value is obtained from the Gateway
         * and should be used when logging out users authenticated via AIM.
         *
         */
        _this._aimLogoutUrl = undefined;
        /**
         * AIM SiteMinder session URL.
         *
         * This URL is used to check the status of the AIM session with SiteMinder.
         * It can be used to determine if the user's AIM session is still active.
         *
         */
        _this._aimSmSessionUrl = undefined;
        return _this;
    }
    AuthenticationState.getInstance = function () {
        if (!instance$1) {
            instance$1 = new AuthenticationState();
        }
        return instance$1;
    };
    /**
     * Updates the authentication status in the authentication state and emits an
     * event to notify listeners of the change. Warning: This has the side effect
     * of allowing the Suite to change behavior and trigger requests based on auth
     * status, so be careful to only set status to Authenticated after the Suite
     * is fully initialized.
     * @param authStatus
     */
    AuthenticationState.prototype.updateAuthStatus = function (authStatus) {
        if (authStatus !== this.authStatus) {
            console.log("[Auth] Status: " + this.authStatus + " \u2192 " + authStatus);
            this.authStatus = authStatus;
            this.emit.authStatusChange(this.authStatus);
        }
    };
    /**
     * Updates the account information in the authentication state and emits an
     * event to notify listeners of the change.
     * @param accountInfo
     */
    AuthenticationState.prototype.updateAccountInfo = function (accountInfo) {
        this.accountInfo = accountInfo;
        this.emit.accountInfoChange(accountInfo);
    };
    AuthenticationState.prototype.emitOidcUserInfoChanged = function (oidcUserInfo) {
        if (oidcUserInfo) {
            this.emit.oidcUserInfoChange(oidcUserInfo);
        }
        else {
            console.error("Cancelling emit since identity token is undefined");
        }
    };
    AuthenticationState.prototype.getAuthStatus = function () {
        return this.authStatus;
    };
    AuthenticationState.prototype.getAccountInfo = function () {
        return this.accountInfo;
    };
    AuthenticationState.prototype.setImpersonating = function (impersonating) {
        this.impersonating = impersonating;
    };
    AuthenticationState.prototype.getImpersonating = function () {
        return this.impersonating;
    };
    AuthenticationState.prototype.setImpersonationQueryParameter = function (impersonationQueryParameter) {
        this.impersonationQueryParameter = impersonationQueryParameter;
    };
    AuthenticationState.prototype.getImpersonationQueryParameter = function () {
        return this.impersonationQueryParameter;
    };
    AuthenticationState.prototype.setSkipAccountQueryParamsPresent = function (skipAccountQueryParamsPresent) {
        this.skipAccountQueryParamsPresent = skipAccountQueryParamsPresent;
    };
    AuthenticationState.prototype.getSkipAccountQueryParamsPresent = function () {
        return this.skipAccountQueryParamsPresent;
    };
    AuthenticationState.prototype.getIsLeaderTab = function () {
        return this.isLeaderTab;
    };
    AuthenticationState.prototype.setIsLeaderTab = function (isLeaderTab) {
        this.isLeaderTab = isLeaderTab;
    };
    AuthenticationState.prototype.getPerformingTokenLogin = function () {
        return this.performingTokenLogin;
    };
    AuthenticationState.prototype.setPerformingTokenLogin = function (performingTokenLogin) {
        this.performingTokenLogin = performingTokenLogin;
    };
    Object.defineProperty(AuthenticationState.prototype, "isAimProvider", {
        get: function () {
            return this._isAimProvider;
        },
        set: function (isAimProvider) {
            this._isAimProvider = isAimProvider;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthenticationState.prototype, "useBrowserBasedSSO", {
        get: function () {
            return this._useBrowserBasedSSO;
        },
        set: function (useBrowserBasedSSO) {
            this._useBrowserBasedSSO = useBrowserBasedSSO;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthenticationState.prototype, "authProvider", {
        /**
         * Specifies which auth provider is being used.
         * This will likely be either Keycloak or AIM.
         * There may be differences in the underlying behavior of auth between these two platforms.
         * This field should be used to determine which behavior to use.
         */
        get: function () {
            return this._authProvider;
        },
        set: function (authProvider) {
            this._authProvider = authProvider;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthenticationState.prototype, "authUrl", {
        /**
         * Specifies which auth url to use to connect. This is not used for the Keycloak implementation.
         * For the oidc-client-ts implementation, this can be used to talk to multiple auth urls
         * depending on account configuration.
         * This url is considered the "authority" for OIDC purposes and can also be referred to as an
         * authorityUrl. But for the purposes of conversation, it's best to call it an authUrl.
         */
        get: function () {
            return this._authUrl;
        },
        set: function (authUrl) {
            this._authUrl = authUrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthenticationState.prototype, "aimClientId", {
        /**
         * Gets the AIM client identifier.
         *
         * @returns The AIM client ID if available, undefined otherwise
         */
        get: function () {
            return this._aimClientId;
        },
        /**
         * Sets the AIM client identifier.
         *
         * @param aimClientId - The AIM client ID to set, or undefined to clear
         */
        set: function (aimClientId) {
            this._aimClientId = aimClientId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthenticationState.prototype, "aimLogoutUrl", {
        /**
         * Gets the AIM logout URL.
         *
         * @returns The AIM logout URL if available, undefined otherwise
         */
        get: function () {
            return this._aimLogoutUrl;
        },
        /**
         * Sets the AIM logout URL.
         *
         * @param aimLogoutUrl - The AIM logout URL to set, or undefined to clear
         */
        set: function (aimLogoutUrl) {
            this._aimLogoutUrl = aimLogoutUrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthenticationState.prototype, "aimSmSessionUrl", {
        /**
         * Gets the AIM SiteMinder session URL.
         *
         * @returns The AIM SiteMinder session URL if available, undefined otherwise
         */
        get: function () {
            return this._aimSmSessionUrl;
        },
        /**
         * Sets the AIM SiteMinder session URL.
         *
         * @param aimSmSessionUrl - The AIM SiteMinder session URL to set, or undefined to clear
         */
        set: function (aimSmSessionUrl) {
            this._aimSmSessionUrl = aimSmSessionUrl;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Clears all authentication state to default values.
     */
    AuthenticationState.prototype.clear = function () {
        this.authUrl = null;
        this.authProvider = null;
        this.isAimProvider = false;
        this.aimClientId = undefined;
        this.aimLogoutUrl = undefined;
        this.aimSmSessionUrl = undefined;
        this.useBrowserBasedSSO = false;
    };
    return AuthenticationState;
}(strictlyTypedEvents.WithEventEmitter));

var EMPTY_ACCOUNT_DATA = {
    accountDetail: {
        externalId: "",
        datacenter: "",
        internalId: "",
        deploymentSuffix: "",
        authentication: {
            useNewAuthFlow: false,
            useBrowserBasedSSO: false,
        },
    },
    environment: "",
};

/**
 * Used to set the identifier for the dynatrace session
 */
var setSessionIdentifier = function (accountExternalId, oidcUserInfo) {
    var username = oidcUserInfo.preferred_username;
    var firstname = oidcUserInfo.given_name || "noFirstName";
    var lastname = oidcUserInfo.family_name || "noLastName";
    if (window.dtrum) {
        window.dtrum.identifyUser(accountExternalId + "-" + username + "-" + firstname + "-" + lastname);
    }
};
/**
 * Adds user defined properties to the current session. In order for the property to show up in
 * dynatrace you'll need to enable & configure them by following the instructions listed here:
 * https://www.dynatrace.com/support/help/shortlink/user-session-properties
 *
 * According to the documentation, sendSessionProperties() accepts up to 4 arguments and
 * they must be in a certain order. (Longs, Dates, Strings, and then Floats)
 * @param sessionLongProp
 * @param sessionDateProp
 * @param sessionStringProp
 * @param sessionFloatProp
 */
var setSessionProperties = function (sessionLongProp, sessionDateProp, sessionStringProp, sessionFloatProp) {
    if (window.dtrum) {
        window.dtrum.sendSessionProperties(sessionLongProp, sessionDateProp, sessionStringProp, sessionFloatProp);
    }
};
/**
 * Sends a custom error with key and value as metadata
 *
 * @param type - the type of the error, e.g. 'validation error'
 * @param name - the error name, e.g. 'Email validation failed'
 * @param hint? - a hint to pinpoint the problem, e.g. content of the input element which
 * triggered the failed validation
 */
var reportCustomError = function (type, name, hint) {
    if (window.dtrum) {
        window.dtrum.reportCustomError(type, name, hint);
    }
};
/**
 * Ends the currently active Dynatrace session immediately.
 */
var endSession = function () {
    if (window.dtrum) {
        window.dtrum.endSession();
    }
};

var EMBEDDED_APP_PARAM = "embeddedApp";
/**
 * Returns true if the provided URL search params indicate that the app is embedded.
 * Note this should ONLY be used when initializing the framework. Once the framework
 *   is initialized, any code/module that needs to know if the App is embedded
 *   should use LighthouseFramework#isAppEmbedded
 * @param searchParams - URL search params
 * @return true if the provided URL search params indicate that the app is embedded.
 */
function getIsAppEmbeddedFromSearchParams(searchParams) {
    return searchParams.get(EMBEDDED_APP_PARAM) === "true";
}
/**
 * Updates the provided URL search params for building a URL to load the app with the "embedded app".
 * param set as desired.
 * @param searchParams - URL Search Params
 * @param isAppEmbedded - True to set the "embedded app' param, or false to ensure it is not present.
 */
function setIsAppEmbeddedInSearchParams(searchParams, isAppEmbedded) {
    if (isAppEmbedded) {
        searchParams.set(EMBEDDED_APP_PARAM, "true");
    }
    else {
        searchParams.delete(EMBEDDED_APP_PARAM);
    }
}

var LATEST_ENVIRONMENT = "latest";
var SPRINT_ENVIRONMENT = "sprint";
var PR_DEPLOYMENT_URL_MATCHER_REGEX = /https:\/\/lth-pr-\d+-dot-foko-dev\.uc\.r\.appspot\.com\//;
// query params
var SKIP_ACCOUNT_SELECTION_QUERY_PARAM = "skipAccountSelectionInput";
var IMPERSONATION_QUERY_PARAM = "impersonation";
var ACCOUNT_ID_QUERY_PARAM = "accountId";

/**
 * Gets a redirect URL for AIM only
 * @param queryString - optional query string
 */
var getRedirectUrlForAim = function () {
    return "" + getBaseLoginRedirectUrl();
};
/**
 * Gets a redirect URL for keycloak, possibly with given route and query string
 * @param route - optional string route e.g. /hub
 * @param queryString - optional query string
 */
var getRedirectUrlForKeycloak = function (route, queryString) {
    // If in embedded nav mode, when redirecting back to the App, need to stay in embedded nav mode
    var searchParams = new URLSearchParams(queryString);
    setIsAppEmbeddedInSearchParams(searchParams, getFrameworkInstance().isAppEmbedded());
    var finalQueryString = searchParams.toString();
    return getBaseLoginRedirectUrl() + "/" + (finalQueryString ? "?" + finalQueryString : "") + "#" + (route || "");
};
var getBaseLoginRedirectUrl = function () {
    // If the client is using cordova, provide the custom URL scheme that opens the app instead.
    return window.cordova ? "workforce://app" : window.location.origin;
};
/**
 * Gets a redirect URL with skipAccountSelectionInput=true for the given account
 * @param accountId - added on to the existing query string if one was provided, or used to create a new one with
 * skipAccountSelectionInput=true
 * @param route - optional string route e.g. /hub
 * @param queryString - optional query string
 */
var getRedirectUrlWithSkipAccountSelection = function (accountId, route, queryString) {
    var searchParams = new URLSearchParams(queryString);
    if (accountId) {
        searchParams.set(ACCOUNT_ID_QUERY_PARAM, accountId);
        searchParams.set(SKIP_ACCOUNT_SELECTION_QUERY_PARAM, "true");
    }
    var finalQueryString = searchParams.toString();
    return getRedirectUrlForKeycloak(route, finalQueryString);
};

/**
 * Available action types
 */
exports.SidebarIntegrationActionTypes = void 0;
(function (SidebarIntegrationActionTypes) {
    SidebarIntegrationActionTypes["OpenSidebar"] = "sidebarIntegration/open";
    SidebarIntegrationActionTypes["CloseSidebar"] = "sidebarIntegration/close";
})(exports.SidebarIntegrationActionTypes || (exports.SidebarIntegrationActionTypes = {}));

/**
 * A function that given the list of modules, returns the first sidebar that can handle
 * given event.
 *
 * @param {Module[]} modules List of registered modules
 * @param {String} event Event to be handled
 */
function getSidebarComponent(modules, event) {
    for (var _i = 0, modules_1 = modules; _i < modules_1.length; _i++) {
        var module_1 = modules_1[_i];
        if (!module_1.getSidebars) {
            // no handlers for this module
            continue;
        }
        for (var _a = 0, _b = module_1.getSidebars(); _a < _b.length; _a++) {
            var handler = _b[_a];
            if (handler.supportedEvents.indexOf(event) !== -1) {
                return handler.component;
            }
        }
    }
    return null;
}

/**
 * Starts processing given event in dedicated sidebar, if a sidebar for such event has been
 * registered.
 *
 * @param {String} event Event to be handled / sidebar type
 * @param {Object} sidebarProps Additional event props (passed down to sidebar component)
 * @param {DrawerProps} drawerProps Custom props to override default behavior
 *
 * @returns {ApplicationThunk}
 */
function openSidebar(event, sidebarProps, drawerProps) {
    return function (dispatch) {
        if (!getSidebarComponent(getFrameworkInstance().getModules(), event)) {
            global.console.warn("No sidebar found for event " + event);
            return Promise.reject();
        }
        dispatch({
            event: event,
            type: exports.SidebarIntegrationActionTypes.OpenSidebar,
            sidebarProps: sidebarProps || null,
            drawerProps: drawerProps || null,
        });
        return Promise.resolve();
    };
}
/**
 * Closes sidebar integration
 *
 * @returns {ApplicationThunk}
 */
function closeSidebar() {
    return function (dispatch) {
        dispatch({
            type: exports.SidebarIntegrationActionTypes.CloseSidebar,
        });
        return Promise.resolve();
    };
}

/**
 * Get the access token for currently logged in user.
 * This will throw an error if the user is not logged in
 * @returns Promise containing the token
 */
function getAccessToken() {
    return AuthenticationManager.getInstance().getAccessToken();
}

/**
 * Get the account info of the currently logged in user
 * This will return undefined if the user is not logged in
 * @returns {AccountInfo} or undefined
 */
function getAccountInfo() {
    return AuthenticationManager.getInstance().getAccountInfo();
}

/**
 * Get the account info for the current logged in user according to {@link AuthenticationManager}
 * @returns the account info for the current logged in user or undefined if being accessed by a page where the user is not authenticated
 */
function useAuthenticationManagerAccountInfo() {
    var authenticationManager = AuthenticationManager.getInstance();
    var _a = React.useState(authenticationManager.getAccountInfo()), accountInfo = _a[0], setAccountInfo = _a[1];
    React.useEffect(function () {
        var cancelSubscription = authenticationManager.subscribe({
            accountInfoChange: function (newAccountInfo) {
                setAccountInfo(newAccountInfo);
            },
        });
        return function () {
            cancelSubscription();
        };
    }, []);
    return accountInfo;
}

/**
 * Custom hook to get the current identity token according to {@link AuthenticationManager}
 * @returns current identity token for the authenticated user or undefined if user is not authenticated
 */
function useAuthenticationManagerOidcUserInfo() {
    var authenticationManager = AuthenticationManager.getInstance();
    var _a = React.useState(authenticationManager.getOidcUserInfo()), oidcUserInfo = _a[0], setOidcUserInfo = _a[1];
    React.useEffect(function () {
        var cancelSubscription = authenticationManager.subscribe({
            oidcUserInfoChange: function (newOidcUserInfo) {
                setOidcUserInfo(newOidcUserInfo);
            },
        });
        return function () {
            cancelSubscription();
        };
    }, []);
    return oidcUserInfo;
}

/**
 * Custom hook to get the current authentication status according to {@link AuthenticationManager}
 * @returns Current authentication status
 */
function useAuthenticationManagerStatus() {
    var authenticationManager = AuthenticationManager.getInstance();
    var _a = React.useState(authenticationManager.getAuthStatus()), authenticationStatus = _a[0], setAuthenticationStatus = _a[1];
    React.useEffect(function () {
        var cancelSubscription = authenticationManager.subscribe({
            authStatusChange: function (newAuthStatus) {
                setAuthenticationStatus(newAuthStatus);
            },
        });
        return function () {
            cancelSubscription();
        };
    }, []);
    return authenticationStatus;
}

var URL_OVERRIDES = "urlOverrides";
var LOCAL_URLS = "localServiceUrls";
/**
 * Creates of map of the url overrides from the environment variable if it exists
 */
var getUrlOverrides = function () {
    var urlOverrides = new Map();
    var localUrls = getFrameworkInstance()
        .getConfiguration()
        .get(URL_OVERRIDES, LOCAL_URLS);
    if (!localUrls) {
        return urlOverrides;
    }
    var services = localUrls.split(",");
    services.forEach(function (service) {
        var serviceEntry = service.split("=");
        urlOverrides.set(serviceEntry[0], serviceEntry[1]);
    });
    return urlOverrides;
};

// TODO: Add any missing regions and environments as necessary
/**
 * A subset of all possible ADP regions
 */
var AdpRegion;
(function (AdpRegion) {
    AdpRegion["NA"] = "na";
    AdpRegion["EMEA"] = "emea";
})(AdpRegion || (AdpRegion = {}));
/**
 * A subset of all possible ADP environments
 * Used for frontend mapping purposes only. We map certain environments
 * to specific frontend behaviors. For example:
 * DIT/DEV -> Suite should use "Latest" APIs
 * FIT -> Suite should use "Sprint" APIs
 * Anything else / "default behavior" -> Suite should use "Production" APIs
 * The full list of ADP environments is maintained by the backend services
 */
var AdpEnvironment;
(function (AdpEnvironment) {
    AdpEnvironment["DIT"] = "dit";
    AdpEnvironment["DEV"] = "dev";
    AdpEnvironment["IAT"] = "iat";
    AdpEnvironment["FIT"] = "fit";
    AdpEnvironment["PROD"] = "prod";
})(AdpEnvironment || (AdpEnvironment = {}));
/**
 * Defines the three possible ways the Suite can initialize its auth flow
 * Either we use the legacy auth flow with the account screen for legacy suite urls
 * Or we use the ADP auth flow without an account screen for ADP urls
 * Or we show an error page indicating that no region and environment could be
 * extracted from an ADP url
 */
var AuthFlow;
(function (AuthFlow) {
    AuthFlow["Legacy"] = "legacy";
    AuthFlow["Adp"] = "adp";
    AuthFlow["Error"] = "error";
})(AuthFlow || (AuthFlow = {}));

function isUiTestingMode() {
    var uiTestingMode = getFrameworkInstance()
        .getConfiguration()
        .get("uiTestingMode", "isUiTestingMode");
    if (uiTestingMode) {
        return true;
    }
    return false;
}

/**
 * Gets the deployment suffix for the environment.
 * TODO: Update this so that CAS handles this. When that happens
 * TODO: external account ID will need to be an argument as well since we aren't using it now.
 * @param environment
 */
var getDeploymentSuffix = function (accountData) {
    var deploymentSuffix;
    if (accountData.environment === LATEST_ENVIRONMENT ||
        accountData.environment === SPRINT_ENVIRONMENT) {
        deploymentSuffix = accountData.accountDetail.deploymentSuffix;
    }
    else if (accountData.accountDetail &&
        accountData.accountDetail.deploymentSuffix) {
        deploymentSuffix = accountData.accountDetail.deploymentSuffix;
    }
    else if (isUiTestingMode()) {
        deploymentSuffix = "mockSuffix";
    }
    else {
        throw new Error("No such environment: " + accountData.environment);
    }
    return deploymentSuffix;
};

/**
 * Provides the base URL for multitenant services like time-service, etc...
 * TODO: Get URL from global resolver when it's complete
 * @param environment
 * @param serviceName
 * @param isForConsolidatedHostnameGraphqlEndpoint - If true, then a URL with a
 *        common hostname and distinct path for the service will be generated.
 *        This is intended for GraphQL endpoints only. It is an optimization to
 *        get all GraphQL requests across all services to share a TCP connection
 *        over HTTP/2 to minimize latency in slow/unreliable internet connection
 *        situations.
 */
var getMultiTenantServiceBaseUrl = function (accountData, serviceName, isForConsolidatedHostnameGraphqlEndpoint) {
    if (isForConsolidatedHostnameGraphqlEndpoint === void 0) { isForConsolidatedHostnameGraphqlEndpoint = false; }
    var deploymentSuffix = getDeploymentSuffix(accountData);
    return isForConsolidatedHostnameGraphqlEndpoint
        ? "https://services" + deploymentSuffix + "/" + serviceName
        : "https://" + serviceName + deploymentSuffix;
};

var CAS_SERVICE_NAME = "cas";
function getCasBaseUrl(accountData) {
    var casBaseUrl = getUrlOverrides().has(CAS_SERVICE_NAME)
        ? getUrlOverrides().get(CAS_SERVICE_NAME)
        : getMultiTenantServiceBaseUrl(accountData, CAS_SERVICE_NAME);
    if (!casBaseUrl) {
        throw new Error("CAS Url undefined!");
    }
    return casBaseUrl;
}

function getAccountId$1(accountData) {
    var accountId = accountData.accountDetail.externalId;
    // Add environment prefix if necessary
    switch (accountData.environment) {
        case LATEST_ENVIRONMENT$1:
            return LATEST_ENVIRONMENT$1 + "-" + accountId;
        case SPRINT_ENVIRONMENT$1:
            return SPRINT_ENVIRONMENT$1 + "-" + accountId;
        default:
            return accountId;
    }
}
function getCasAugmentedLogoutUrl(accountData, sessionState, accessToken) {
    var skipAccountSelectionFeatureFlagValue = hasSkipAccountSelection();
    // An undefined accessToken will not be included in the query string.
    var params = qs.stringify({
        access_token: accessToken,
        redirect_uri: skipAccountSelectionFeatureFlagValue
            ? getRedirectUrlWithSkipAccountSelection(getAccountId$1(accountData))
            : getRedirectUrlForKeycloak(),
        session_state: sessionState,
    });
    var endpoint = "/aug/session/" + accountData.accountDetail.externalId + "/openid-connect/logout";
    var url = [endpoint, params].join("?");
    return new URL(url, getCasBaseUrl(accountData)).toString();
}

var reportLoginErrorDetailsToDynatrace = function (err, organizationId, isImpersonationEnabled, skippingAccountSelection) {
    var _a, _b;
    var errorDetails = {
        message: err === null || err === void 0 ? void 0 : err.message,
        stack: err === null || err === void 0 ? void 0 : err.stack,
        organizationId: organizationId,
        url: window.location.href,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
        isImpersonationEnabled: isImpersonationEnabled,
        skippingAccountSelection: skippingAccountSelection,
        request: ((_a = err) === null || _a === void 0 ? void 0 : _a.request) ? {
            responseURL: err.request.responseURL,
            status: err.request.status,
            readyState: err.request.readyState,
        }
            : undefined,
        response: ((_b = err) === null || _b === void 0 ? void 0 : _b.response) ? {
            status: err.response.status,
            statusText: err.response.statusText,
            data: err.response.data,
            headers: err.response.headers,
        }
            : undefined,
    };
    reportCustomError("Login Error", JSON.stringify(errorDetails));
};

/**
 * If the hyphen is missing then that must mean this is prod and does not have an environment prefix.
 * @param organizationId
 */
var getEnvironment = function (organizationId) {
    return organizationId.substr(0, organizationId.indexOf("-"));
};
/**
 * If the organization id is missing the hyphen then just return the org id as the accountId.
 * @param organizationId
 */
var getAccountId = function (organizationId) {
    var hyphenIndex = organizationId.lastIndexOf("-");
    return organizationId.substr(hyphenIndex + 1) || organizationId;
};
/**
 * Returns the correct GRS URL for a given environment string.
 * @param environment The environment string (e.g. "latest", "sprint", "")
 * where an empty string implies prod
 * @returns The corresponding GRS URL
 */
function getGrsUrlForEnvironment(environment) {
    switch (environment) {
        case WfsEnvironment.LATEST:
            return GRS_LATEST_URL;
        case WfsEnvironment.SPRINT:
            return GRS_SPRINT_URL;
        case WfsEnvironment.PROD:
            return GRS_PROD_URL;
        default:
            throw new Error("Unhandled environment: " + environment);
    }
}
/**
 * Returns the Global Resolver Service URL based on the organization ID and the current environment.
 * @param organizationId
 */
function getGrsUrl(organizationId) {
    return (getUrlOverrides().get("global-resolver-service") ||
        getGrsUrlForEnvironment(getEnvironment(organizationId)));
}
/**
 * Returns the Global Resolver Service URL based on the ADP environment
 * @param adpEnvironment
 */
function getGrsUrlBasedOnAdpEnvironment(adpEnvironment) {
    return (getUrlOverrides().get("global-resolver-service") ||
        getGrsUrlForEnvironment(mapAdpEnvToWfsEnv(adpEnvironment)));
}
/**
 * An internal enum representing the WFS environments that we map to in the
 * frontend. Prod is treated as an empty string since that is the default
 * behavior when no environment is specified.
 */
var WfsEnvironment;
(function (WfsEnvironment) {
    WfsEnvironment["LATEST"] = "latest";
    WfsEnvironment["SPRINT"] = "sprint";
    WfsEnvironment["PROD"] = "";
})(WfsEnvironment || (WfsEnvironment = {}));
/**
 * Maps an ADP environment string to a wfs environment.
 * DIT and DEV map to WfsEnvironment.LATEST,
 * FIT and IAT map to WfsEnvironment.SPRINT,
 * all others map to WfsEnvironment.PROD.
 * @param adpEnvironment ADP environment string
 * @returns WfsEnvironment enum value
 */
function mapAdpEnvToWfsEnv(adpEnvironment) {
    switch (adpEnvironment) {
        case AdpEnvironment.DIT:
        case AdpEnvironment.DEV:
            return WfsEnvironment.LATEST;
        case AdpEnvironment.FIT:
        case AdpEnvironment.IAT:
            return WfsEnvironment.SPRINT;
        default:
            return WfsEnvironment.PROD;
    }
}

exports.FeatureFlagKey = void 0;
(function (FeatureFlagKey) {
    FeatureFlagKey["Pendo"] = "pendo";
    FeatureFlagKey["HierarchicalAdminMenu"] = "hierarchical_admin_menu";
    FeatureFlagKey["UserPreferenceThemeSelection"] = "user_preference_theme_selection";
    FeatureFlagKey["DisplayMobileUnfriendlyLinks"] = "nav.display_mobile_unfriendly_links";
    FeatureFlagKey["UniversalAssistant"] = "universal_assistant_access";
    FeatureFlagKey["SetAccountTheme"] = "account_theme_selection";
    FeatureFlagKey["SetAccountLogo"] = "account_logo";
    FeatureFlagKey["AssistantCardsFilter"] = "filter_assistant_cards_by_groups";
    FeatureFlagKey["NextGenTimeFormatting"] = "next_gen_time_formatting";
    FeatureFlagKey["CollapsibleAssistant"] = "collapsible_assistant";
    FeatureFlagKey["SuiteAuthSkipAccountSelection"] = "suite_auth_skip_account_selection";
    FeatureFlagKey["PinAuthentication"] = "pin_authentication";
    FeatureFlagKey["SuiteSessionInactivity"] = "cfg_suite_session_inactivity_timeout";
    FeatureFlagKey["SuiteUseTokenBasedAuthenticationDemandScheduling"] = "cfg_suite_use_token_based_authentication_demand_scheduling";
    FeatureFlagKey["ADPCustomTheme"] = "adp_custom_theme";
    FeatureFlagKey["CustomAccountTheme"] = "custom_account_theme";
    FeatureFlagKey["WTA"] = "wta";
    FeatureFlagKey["DemandScheduling"] = "scheduling-f_and_s";
    FeatureFlagKey["MfeSupport"] = "suite_mfe_support";
    FeatureFlagKey["WTATokenBasedLogin"] = "cfg_suite_use_token_based_authentication_process";
})(exports.FeatureFlagKey || (exports.FeatureFlagKey = {}));

// This is queried for membership in a loop. It should be a Set so that checking membership is O(1).
var demoUserAccounts = new Set(usersList
    .filter(function (user) { return user.allowAutoLogin; })
    .map(function (user) { return user.organization; }));
/**
 * Provides the base url for single tenant services such as WTA and WFS
 * TODO: Get URL from global resolver when it's complete
 * @param accountId
 * @param environment
 */
var getWTABaseUrl = function (accountData) {
    var wtaUrlFromConfiguration = getFrameworkInstance()
        .getConfiguration()
        .get(WTA_BASE_URL, SERVICE_BASE_URL);
    if (wtaUrlFromConfiguration !== undefined) {
        return wtaUrlFromConfiguration + "/workforce/";
    }
    var account = accountData.accountDetail.externalId.replace(/_/g, "-");
    var deploymentSuffix = getDeploymentSuffix(accountData);
    return "https://" + account + ".wta" + deploymentSuffix + "/workforce/";
};
/**
 * Simple utility method to determine if a given URL matches the WT&A url constructed by the Suite
 * @param urlString
 */
var isWtaUrl = function (urlString) {
    var _a;
    var accountData = (_a = AuthenticationManager.getInstance().getAccountInfo()) === null || _a === void 0 ? void 0 : _a.accountData;
    if (!accountData) {
        console.warn("Could not identify WT&A url: account data not found");
        return false;
    }
    var wtaBaseUrlString = getWTABaseUrl(accountData);
    try {
        var url = new URL(urlString);
        var wtaUrl = new URL(wtaBaseUrlString);
        return url.host === wtaUrl.host;
    }
    catch (error) {
        console.error("Invalid URL passed to isWtaBaseUrl", error);
        return false;
    }
};
/**
 * Gets url for T&A's logout endpoint
 */
var getWtaLogoffUrl = function () {
    var authManager = AuthenticationManager.getInstance();
    var accountData = authManager.getAccountInfo().accountData;
    return getWTABaseUrl(accountData) + "Logoff.do";
};
/**
 * Returns a full url based on the parameters passed in
 * @param accountData
 * @param userId
 * @param urlType
 * @param sourceSystemUrl
 * @param relativePageUrl
 */
var getFullServiceURL = function (accountData, userId, urlType, sourceSystemUrl, relativePageUrl) {
    if (urlType === FS_BASE_URL) {
        return getWFSURL(accountData, relativePageUrl, userId);
    }
    var baseSingleTenantUrl = getWTABaseUrl(accountData);
    return appendQuery__default.default("" + baseSingleTenantUrl + relativePageUrl, {
        embeddedMode: "true",
        redirectOnLogin: "true",
    });
};
/**
 * Returns the appropriate demo URL based on the given parameters
 * @param urlType
 * @param sourceSystemUrl
 * @param relativeURL
 * @param wtaDemoUrl
 */
var getFullDemoURL = function (urlType, sourceSystemUrl, relativeURL, wtaDemoUrl) {
    if (urlType === FS_BASE_URL) {
        return "" + sourceSystemUrl + relativeURL;
    }
    return appendQuery__default.default("" + wtaDemoUrl + relativeURL, {
        embeddedMode: "true",
        redirectOnLogin: "true",
    });
};
/**
 * Creates the WFS formatted URL that is in the form:
 * https://<FnS-instance>
 * @param accountData
 */
var getDemandSchedulingBaseUrl = function (accountData) { var _a; return (_a = process.env.REACT_APP_FS_BASE_URL) !== null && _a !== void 0 ? _a : getMultiTenantServiceBaseUrl(accountData, "scheduling"); };
var useTokenBasedAuthForDemandScheduling = function () {
    return getFrameworkInstance().getNamedFeatureFlags(exports.FeatureFlagKey.SuiteUseTokenBasedAuthenticationDemandScheduling)[exports.FeatureFlagKey.SuiteUseTokenBasedAuthenticationDemandScheduling];
};
/**
 * Creates the URL to open in an IFRAME for Demand Scheduling pages.
 *
 * When using token-based auth, the URL is of the form:
 * https://<FnS-instance>/<relativePageUrl>
 *
 * Otherwise, the WFS formatted URL is of the form:
 * https://<FnS-instance>/auth/account/<internal_account_id>/wfsId/<user_id>/redirect/<url>
 *
 * @param accountData
 * @param relativePageUrl
 * @param wfsId
 */
var getWFSURL = function (accountData, relativePageUrl, wfsId) {
    return useTokenBasedAuthForDemandScheduling()
        ? getDemandSchedulingBaseUrl(accountData) + "/" + relativePageUrl
        : getMultiTenantServiceBaseUrl(accountData, "scheduling") + "/auth/account/" + accountData.accountDetail.externalId + "/user/" + wfsId + "/redirect/" + relativePageUrl;
};
/**
 * Simple utility method to get the URL for Demand Scheduling's token-based login endpoint
 * @param urlString
 */
var getDemandSchedulingAuthRedirectUrl = function (accountData) {
    return getDemandSchedulingBaseUrl(accountData) + "/auth/token";
};
/**
 * Creates the WTA formatted URL that is in the form:
 * https://<WTA-instance>/workforce/<replativePageUrl>
 * @param relativePageUrl
 */
var getWTAURL = function (relativePageUrl) {
    var authManager = AuthenticationManager.getInstance();
    // We are guaranteed to be authenticated when this function is called
    var accountData = authManager.getAccountInfo().accountData;
    var decodedToken = authManager.getOidcUserInfo();
    var sourceSystemUrl = getFrameworkInstance()
        .getConfiguration()
        .get(WTA_BASE_URL, SERVICE_BASE_URL);
    var wtaUrl = getFullServiceURL(accountData, decodedToken.wfs_id, WTA_BASE_URL, sourceSystemUrl, relativePageUrl);
    return wtaUrl;
};
/**
 * Checks if the account is a demo user.
 * @param account
 */
var isDemoUser = function (account) {
    return demoUserAccounts.has(account);
};

var NETWORK_ERROR = "NETWORK_ERROR";
var HUB_HASH = "#/hub";
function embedExternalPage(externalUrl) {
    // If the sidebar is open, we should close it
    var store = getStore();
    var state = store.getState();
    var dispatch = store.dispatch;
    if (state.sidebarIntegration.isOpened) {
        dispatch(closeSidebar());
    }
    // Embed an external page in the Lighthouse page.
    dispatch(connectedReactRouter.push("/" + RouteIds.ExternalPage + "/" + encodeURIComponent(externalUrl)));
}
function redirectToCasUrl(redirectUrl, mobileAppRedirectCallback) {
    return __awaiter(this, void 0, void 0, function () {
        var inAppBrowser_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isMobileDevice()) return [3 /*break*/, 1];
                    inAppBrowser_1 = openInAppBrowser(redirectUrl);
                    /**
                     * If the browser begins to load a page that contains 'workforce://' then
                     * CAS is trying to redirect us to the app so we need to handle that separately
                     * because the InAppBrowser doesn't support redirecting back to WebView
                     */
                    inAppBrowser_1.addEventListener("loadstop", function (_a) {
                        var url = _a.url;
                        /**
                         * The logout URL follows a chain of redirects (CAS → Scheduling → WTA → Logout),
                         * and the InAppBrowser handles them differently on Android and iOS.
                         * For both platforms, we receive only one `loadStop` event for the final redirect URL:
                         * https://wfx-integration-test2-s.wta-sprint-us8.wfs.cloud/workforce/Logoff.do
                         * ?postLogoffRedirectUrl=workforce://app/?accountId=sprint-wfx_integration_test2_s&skipAccountSelectionInput=true#
                         * Since the InAppBrowser plugin does not support Custom URL Schemes (e.g., `workforce://`),
                         * we need to manually close the InAppBrowser window whenever the URL contains `workforce://`.
                         *
                         * Additionally, this event will only trigger once the URL has fully loaded,
                         * ensuring that the WTA logout request is processed before the InAppBrowser is closed.
                         */
                        if (isWtaUrl(url)) {
                            if (!fullyDecodeUrl(url).includes("workforce://")) ;
                            else {
                                // The above condition being false means that CAS respected the signal to
                                // logout with workforce:// as the redirect. This means no custom logout URL
                                // was configured for an IDP and we can close the InAppBrowser.
                                inAppBrowser_1.close();
                            }
                        }
                        else {
                            // A loadstop event for a non-WT&A url indicates that logout has completed
                            // Therefore the InAppBrowser can be closed.
                            inAppBrowser_1.close();
                        }
                    });
                    // Error handling
                    inAppBrowser_1.addEventListener("loaderror", function (error) {
                        // The InAppBrowser has failed to load the page so we need to close it
                        console.log("Error while loading url in InAppBrowser: ", JSON.stringify(error));
                        inAppBrowser_1.close();
                    });
                    inAppBrowser_1.addEventListener("exit", function () {
                        mobileAppRedirectCallback === null || mobileAppRedirectCallback === void 0 ? void 0 : mobileAppRedirectCallback();
                        getStore().dispatch(connectedReactRouter.push(routeContext.findRouteByName(RouteIds.Home) || ""));
                    });
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, getPersistor().flush()];
                case 2:
                    _a.sent(); // Explicitly persist store to avoid redirection before store data is saved
                    window.location.href = redirectUrl;
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
var openInAppBrowser = function (url) {
    return window.cordova.InAppBrowser.open(url, "_blank", "location=no,zoom=no,toolbar=no,usewkwebview=yes");
};
var isAssistantViewable = function () {
    if (window.location.hash === HUB_HASH) {
        return true;
    }
    return false;
};
/**
 * If on a mobile device, opens the provided URL in the system browser. If on desktop, opens the URL in a new tab
 * @param url the full, encoded URL to navigate to
 */
function openUrlOutsideSuite(url) {
    if (isMobileDevice()) {
        openUrlInSystemBrowser(url);
    }
    else {
        openUrlInNewTab(url);
    }
}
function openUrlInNewTab(url) {
    // Just using `_blank` is a potential security vulnerability. This is the suggested solution
    // https://stackoverflow.com/questions/45046030/maintaining-href-open-in-new-tab-with-an-onclick-handler-in-react
    // https://www.jitbit.com/alexblog/256-targetblank---the-most-underestimated-vulnerability-ever/
    var newTab = window.open(url, "_blank", "noopener, noreferrer");
    if (newTab) {
        newTab.opener = null;
    }
}
var fullyDecodeUrl = function (encodedUrl) {
    var decodedUrl = encodedUrl;
    var previousUrl = "";
    // Keep decoding until there's no change
    while (decodedUrl !== previousUrl) {
        previousUrl = decodedUrl;
        decodedUrl = decodeURIComponent(decodedUrl);
    }
    return decodedUrl;
};

/**
 * Returns a boolean indicating whether or not the keycloak iFrame should be enabled.
 * It should not be enabled if the app is running in a development environment, or
 * if it is being served from a PR Deployment URL.
 * @returns True if keycloak iFrame should be enabled
 */
function getIsKeycloakLoginIframeEnabled() {
    return (process.env.NODE_ENV !== "development" &&
        !PR_DEPLOYMENT_URL_MATCHER_REGEX.test(window.location.href));
}

/**
 * List of known auth providers for the Suite that can be returned from the GRS response
 * Each of these providers may have small differences in their auth behavior so it can help to
 * distinguish between them in a clean way
 */
var AuthProvider;
(function (AuthProvider) {
    AuthProvider["Keycloak"] = "keycloak";
    AuthProvider["AIM"] = "aim";
})(AuthProvider || (AuthProvider = {}));

/**
 * The minimum time (in seconds) left on the token before it expires and we attempt to refresh it
 */
var MIN_TOKEN_VALIDITY = 30;
/**
 * Authentication Service class that handles all authentication related functions
 */
var KeycloakAuthenticationService = /** @class */ (function () {
    function KeycloakAuthenticationService(authenticationState) {
        this.authenticationState = authenticationState;
    }
    KeycloakAuthenticationService.prototype.establishSession = function () {
        var _this = this;
        return this.initializeKeycloak()
            .then(function () {
            if (_this.authenticationState.getAuthStatus() !==
                AuthenticationStatus.Authenticated) {
                throw new Error("Keycloak initialized but user is not authenticated");
            }
        })
            .catch(function (err) {
            var wrapped = new Error("Unable to initialize Keycloak");
            wrapped.cause = err;
            throw wrapped;
        });
    };
    /**
     * Get the current instance of the KeycloakAuthenticationService
     * @returns instance of the KeycloakAuthenticationService
     */
    KeycloakAuthenticationService.getInstance = function (authenticationState) {
        console.log("Keycloak instance");
        if (!KeycloakAuthenticationService.instance) {
            KeycloakAuthenticationService.instance = new KeycloakAuthenticationService(authenticationState);
        }
        return KeycloakAuthenticationService.instance;
    };
    /**
     * Log in to the application
     * @param redirectBackRoute - The route where user should be redirected after signing in
     * @returns Promise that resolves upon completion of login.
     */
    KeycloakAuthenticationService.prototype.login = function (redirectBackRoute) {
        var _this = this;
        return this.initializeKeycloak()
            .then(function () {
            return _this.keycloak.login({
                redirectUri: getRedirectUrlForKeycloak(redirectBackRoute),
            }).then(function () {
                if (!_this.keycloak.authenticated) {
                    getStore().dispatch(connectedReactRouter.push(routeContext.findRouteByName(exports.FrameworkRouteIds.Login) || ""));
                    _this.authenticationState.updateAuthStatus(AuthenticationStatus.NotAuthenticated);
                }
                else {
                    _this.authenticationState.updateAuthStatus(AuthenticationStatus.Authenticated);
                    _this.authenticationState.emitOidcUserInfoChanged(_this.getOidcUserInfo());
                }
            });
        })
            .catch(function (error) {
            global.console.log(error);
            _this.authenticationState.updateAuthStatus(AuthenticationStatus.NotAuthenticated);
            throw error;
        });
    };
    /**
     * Log out of the application
     * @param options - Optional logout options to control which systems to logout from
     */
    KeycloakAuthenticationService.prototype.logout = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var accessToken, sessionState, queryString, params;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.authenticationState.getAuthStatus() ===
                            AuthenticationStatus.MockAuthenticated) {
                            this.mockLogout();
                            return [2 /*return*/];
                        }
                        // If the account info isn't initialized, return early. We cannot properly redirect if we don't
                        // have an account.
                        if (!this.authenticationState.getAccountInfo()) {
                            console.log("WARNING: Unable to logout properly due to missing account info");
                            return [2 /*return*/];
                        }
                        // When user is already logged out, stop the process and return.
                        if (![
                            AuthenticationStatus.Authenticated,
                            AuthenticationStatus.Initializing,
                        ].includes(this.authenticationState.getAuthStatus())) {
                            console.warn("User is already logged out");
                            return [2 /*return*/];
                        }
                        // Update the status as soon as possible before doing anything async.
                        // This will allow other functions to return early and wait for the log out to complete,
                        // which prevents potential race conditions where other functions update the status before this one.
                        this.authenticationState.updateAuthStatus(AuthenticationStatus.LoggingOut);
                        accessToken = (options === null || options === void 0 ? void 0 : options.withoutToken) ? undefined
                            : window.localStorage.getItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY) ||
                                undefined;
                        sessionState = window.localStorage.getItem(SESSION_ID_STORAGE_KEY);
                        this.clearTokensInLocalStorage();
                        // end Dynatrace session
                        endSession();
                        getStore().dispatch({
                            type: "logoutSuccess" /* LogoutSuccess */,
                        });
                        if (!!(options === null || options === void 0 ? void 0 : options.skipWfxLogout)) return [3 /*break*/, 2];
                        return [4 /*yield*/, wfxLogout()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        // Avoids a race condition where the CAS iframe initiates a logout if the logout
                        // procedure triggered by impersonation takes too long.
                        // If logout takes too long, the CAS iframe will trigger a *second* logout which has
                        // the potential to cancel impersonation.
                        // Note that this will be false when the Suite loads again after returning from the
                        // impersonate call and that is expected.
                        // When it loads again, impersonate=true will be set in the query params,
                        // which we will also be able to detect in the next conditional block.
                        if (this.authenticationState.getImpersonating()) {
                            // Here we set impersonating to false in order to help avoid getting trapped in a state where
                            // we can never properly log out. This would probably only be relevant on the mobile app
                            // where the Suite might stay open and never fully refresh.
                            // Note that onAuthLogout() will never be triggered twice by CAS before CAS is able
                            // to authenticate again, so it's safe to set this to false here.
                            this.authenticationState.setImpersonating(false);
                            return [2 /*return*/];
                        }
                        queryString = window.location.search
                            ? window.location.search
                            : location.search;
                        params = qs.parse(queryString, { ignoreQueryPrefix: true });
                        if ((params === null || params === void 0 ? void 0 : params.impersonation) === "true") {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, redirectToCasUrl(getCasAugmentedLogoutUrl(
                            // accountInfo must exist for us to be authenticated in logout
                            this.authenticationState.getAccountInfo().accountData, sessionState, accessToken), function () {
                                // this code should only be executed on the native mobile app, as it's a handler for
                                // after CAS redirects us back to the main screen.
                                _this.authenticationState.updateAuthStatus(AuthenticationStatus.NotAuthenticated);
                                _this.authenticationState.emitOidcUserInfoChanged(_this.getOidcUserInfo());
                            })];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get the parsed CAS identity token.
     * @returns parsed CAS identity token or undefined if the user is not authenticated or keycloak is not initialized
     */
    KeycloakAuthenticationService.prototype.getOidcUserInfo = function () {
        var _a;
        return (_a = this.keycloak) === null || _a === void 0 ? void 0 : _a.idTokenParsed;
    };
    /**
     * Get the base64 access token
     * NOTE: Usage of this should only occur when authenticated. If you need
     *       to get the access token and don't know if you're authenticated, query
     *       the authentication status {@link AuthenticationManager.getAuthStatus}
     * @returns Promise containing the token
     */
    KeycloakAuthenticationService.prototype.getAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.authenticationState.getAuthStatus() ===
                            AuthenticationStatus.MockAuthenticated) {
                            return [2 /*return*/, "mocked"];
                        }
                        if (!this.keycloak) {
                            throw new Error("Keycloak instance unavailable. Cannot retrieve access token.");
                        }
                        return [4 /*yield*/, this.refreshTokenWithRetries()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.keycloak.token];
                }
            });
        });
    };
    /**
     * Attempt to refresh the token with the provided number of retries
     *
     * We want to ensure users are not logged out due to a single failure, so we want to retry up to
     * the given number of times. If we see consistent failures (6 failures in a row), it's acceptable to log the user out and
     * report an error to dynatrace.
     * @param retries number of retries for refreshing the token (5 by default)
     */
    KeycloakAuthenticationService.prototype.refreshTokenWithRetries = function (retries) {
        var _this = this;
        if (retries === void 0) { retries = 5; }
        var REFRESH_KEYCLOAK_ACCESS_TOKEN_ERROR_MAX_RETRIES = "Could not refresh keycloak access token. Exceeded max number of retries.";
        // keycloak is guaranteed to be define in this function because we only call this when we're refreshing tokens
        if (this.authenticationState.getImpersonating()) {
            // Make sure impersonation flow is not interrupted by token refresh.
            // This can trigger a logout which could potentially interrupt impersonation.
            return Promise.resolve();
        }
        return this.keycloak.updateToken(MIN_TOKEN_VALIDITY).catch(function () {
            if (retries === 0) {
                global.console.error(REFRESH_KEYCLOAK_ACCESS_TOKEN_ERROR_MAX_RETRIES);
                if (window.dtrum) {
                    window.dtrum.reportCustomError("Authentication Error", REFRESH_KEYCLOAK_ACCESS_TOKEN_ERROR_MAX_RETRIES);
                }
                _this.logout({ withoutToken: true });
                throw new Error(REFRESH_KEYCLOAK_ACCESS_TOKEN_ERROR_MAX_RETRIES);
            }
            global.console.warn("Refreshing keycloak access token failed. Retries remaining: " + retries);
            // wait half a second before retrying in case there were any network "hiccups"
            return tsUtil.wait(500).then(function () { return _this.refreshTokenWithRetries(retries - 1); });
        });
    };
    /**
     * Logs out of the application when logged in as a mocked users
     *    NOTE: This assumes we have to do no cleanup to anything and
     *    simply updates the authentication status and returns us to
     *    the organization panel
     */
    KeycloakAuthenticationService.prototype.mockLogout = function () {
        this.authenticationState.updateAuthStatus(AuthenticationStatus.NotAuthenticated);
        getStore().dispatch(connectedReactRouter.push(routeContext.findRouteByName(exports.FrameworkRouteIds.Login) || ""));
    };
    /**
     * Set the access, refresh, and identity tokens in local storage
     */
    KeycloakAuthenticationService.prototype.setTokensInLocalStorage = function () {
        // We only set the tokens when the keycloak instance and tokens are guaranteed to exist
        window.localStorage.setItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY, this.keycloak.token);
        window.localStorage.setItem(ID_TOKEN_LOCAL_STORAGE_KEY, this.keycloak.idToken);
        window.localStorage.setItem(REFRESH_TOKEN_LOCAL_STORAGE_KEY, this.keycloak.refreshToken);
        // This is technically included in the token but we're storing it separately
        window.localStorage.setItem(SESSION_ID_STORAGE_KEY, this.keycloak.sessionId);
    };
    /**
     * Clears the access, refresh, and identity tokens in local storage. Also clears the session ID.
     * Be sure to only call this after all the necessary information has been gathered to initiate a
     * proper logout
     */
    KeycloakAuthenticationService.prototype.clearTokensInLocalStorage = function () {
        window.localStorage.removeItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY);
        window.localStorage.removeItem(ID_TOKEN_LOCAL_STORAGE_KEY);
        window.localStorage.removeItem(REFRESH_TOKEN_LOCAL_STORAGE_KEY);
        window.localStorage.removeItem(SESSION_ID_STORAGE_KEY);
    };
    /**
     * Initialize keycloak-js instance
     * @param organizationId - Account name to validate using GRS
     * @returns Promise that resolves when keycloak is initialized
     */
    KeycloakAuthenticationService.prototype.initializeKeycloak = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var accountData, url, realm, authUrl, regex, match, accessTokenFromStorage, refreshTokenFromStorage, identityTokenFromStorage;
            var _this = this;
            return __generator(this, function (_b) {
                try {
                    accountData = (_a = this.authenticationState.getAccountInfo()) === null || _a === void 0 ? void 0 : _a.accountData;
                    if (!accountData) {
                        throw new Error("Keycloak instance cannot be initialized without account data");
                    }
                    url = "";
                    realm = "";
                    if (this.authenticationState.authProvider === AuthProvider.Keycloak &&
                        this.authenticationState.authUrl) {
                        try {
                            authUrl = new URL(this.authenticationState.authUrl);
                            url = authUrl.origin + "/auth";
                            regex = /\/auth\/realms\/([^/]+)(?:\/|$)/;
                            match = authUrl.pathname.match(regex);
                            realm = match ? match[1] : "";
                        }
                        catch (_c) {
                            // No op
                        }
                    }
                    if (!(url && realm)) {
                        url = getCasBaseUrl(accountData) + "/auth";
                        realm = accountData.accountDetail.externalId;
                    }
                    this.keycloak = Keycloak__default.default({
                        url: url,
                        realm: realm,
                        clientId: KEYCLOAK_CLIENT_ID,
                    });
                    this.keycloak.onAuthSuccess = function () {
                        _this.setTokensInLocalStorage();
                        _this.authenticationState.updateAuthStatus(AuthenticationStatus.Authenticated);
                        _this.authenticationState.emitOidcUserInfoChanged(_this.getOidcUserInfo());
                        // Mobile is handled differently, since we don't leave and navigate back like the web app
                        // so we need to handle pushing to "Home" in the authSuccess function.
                        if (isMobileDevice()) {
                            getStore().dispatch(connectedReactRouter.push(routeContext.findRouteByName(exports.FrameworkRouteIds.Home) || ""));
                        }
                    };
                    this.keycloak.onAuthError = function (errorData) {
                        global.console.log("Keycloak error", errorData);
                        if (_this.authenticationState.getAuthStatus() ===
                            AuthenticationStatus.LoggingOut) {
                            return;
                        }
                        _this.authenticationState.updateAuthStatus(AuthenticationStatus.NotAuthenticated);
                        _this.clearTokensInLocalStorage();
                    };
                    // onAuthLogout gets triggered by Keycloak after tokens have been cleared by Keycloak
                    this.keycloak.onAuthLogout = function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, this.logout({ withoutToken: true })];
                        });
                    }); };
                    this.keycloak.onTokenExpired = function () {
                        // Update the token whenever it gets expired.
                        // User needs to be authenticated to update the refresh token. We should never be in a situation where we don't have a refresh token.
                        if (_this.authenticationState.getAuthStatus() ===
                            AuthenticationStatus.Authenticated) {
                            _this.refreshTokenWithRetries();
                        }
                    };
                    this.keycloak.onAuthRefreshSuccess = function () {
                        // token refresh was successful so the identity token is guaranteed to exist since
                        // our identity token refreshes each time we refresh the access token
                        // keycloak is also guaranteed to exist since we're in a success function on the instance
                        _this.authenticationState.emitOidcUserInfoChanged(_this.getOidcUserInfo());
                        _this.setTokensInLocalStorage();
                    };
                    accessTokenFromStorage = window.localStorage.getItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY) ||
                        undefined;
                    refreshTokenFromStorage = window.localStorage.getItem(REFRESH_TOKEN_LOCAL_STORAGE_KEY) ||
                        undefined;
                    identityTokenFromStorage = window.localStorage.getItem(ID_TOKEN_LOCAL_STORAGE_KEY) || undefined;
                    return [2 /*return*/, this.keycloak
                            .init({
                            responseMode: "query",
                            pkceMethod: "S256",
                            token: accessTokenFromStorage,
                            refreshToken: refreshTokenFromStorage,
                            idToken: identityTokenFromStorage,
                            checkLoginIframe: getIsKeycloakLoginIframeEnabled(),
                        })
                            .then(function (authenticated) {
                            if (authenticated) {
                                _this.authenticationState.updateAuthStatus(AuthenticationStatus.Authenticated);
                                _this.authenticationState.emitOidcUserInfoChanged(_this.getOidcUserInfo());
                            }
                            else {
                                _this.authenticationState.updateAuthStatus(AuthenticationStatus.NotAuthenticated);
                            }
                        })
                            .catch(function (error) {
                            // if initialization fails the cached GRS account info should be cleared
                            // to prevent other initialization calls to fail due to a stale cached account info
                            global.console.error(error);
                            // This block typically triggers whenever the user has a valid token in storage,
                            // but then tries to re-initialize Keycloak with the token in storage, and the
                            // re-initialization fails.
                            // One way of triggering this is to log in with a valid session, close the tab,
                            // and then re-open it after the access token has expired.
                            // Another way of triggering it is to log in, then switch tabs and wait until your browser
                            // puts the tab in "discard" mode.
                            // Note that this can be triggered manually through chrome://discards on Chrome.
                            if (_this.authenticationState.getAuthStatus() ===
                                AuthenticationStatus.LoggingOut) {
                                // If logout has already initiated due to kc.clearToken() being called, simply wait for
                                // it to complete.
                                return;
                            }
                            else {
                                _this.authenticationState.updateAuthStatus(AuthenticationStatus.NotAuthenticated);
                            }
                        })];
                }
                catch (error) {
                    // If the account does not exist according to the GRS, it will respond with status code 404,
                    // which will cause the catch clause to trigger.
                    this.authenticationState.updateAuthStatus(AuthenticationStatus.NotAuthenticated);
                    global.console.error(error);
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Register iframe-parent communication handlers.
     * No-op for Keycloak as it doesn't support iframe parent communication.
     * This method exists to satisfy the AuthenticationService interface.
     */
    KeycloakAuthenticationService.prototype.registerIframeParentCommunication = function () {
        // No-op: Keycloak doesn't use iframe parent communication
    };
    /**
     * Unregister iframe-parent communication handlers.
     * No-op for Keycloak as it doesn't support iframe parent communication.
     * This method exists to satisfy the AuthenticationService interface.
     */
    KeycloakAuthenticationService.prototype.unregisterIframeParentCommunication = function () {
        // No-op: Keycloak doesn't use iframe parent communication
    };
    return KeycloakAuthenticationService;
}());

// TODO: Refactor to use useUuid() from "@workforcesoftware/ts-react-util"
function generateUUIDv4() {
    return uuid.v4();
}

/**
 * On the mobile app, we don't actually redirect away from the Suite. Instead we open a browser externally,
 * and wait for it to give us a proper sign in redirect url which we can parse.
 *
 * Authentication plugin selection follows this priority:
 *   - Browser-based SSO enabled:
 *       1. ASWebAuthSession  (iOS) — secure, in-process session with automatic callback handling
 *       2. BrowserTabs/Custom Chrome Tab  (Android) — intent-based flow; callback arrives via triggerPostCasAuthentication
 *   - Browser-based SSO disabled (legacy):
 *       3. InAppBrowser — embedded WebView with manual loadstart/loaderror event handling
 *
 * @param url - The IdP sign-in URL to open in the external browser
 * @returns A promise that resolves with the callback URL once authentication completes,
 *          or rejects with a descriptive error message if authentication fails or is cancelled
 */
function cordovaLoginRedirect(url) {
    return __awaiter(this, void 0, void 0, function () {
        var callbackUrlPromise, isBrowserBasedSSOLoginEnabled, windowRef_1, completed_1, closed_1, closeBrowser_1;
        return __generator(this, function (_a) {
            // Guard: this function relies on the Cordova runtime; reject early in non-Cordova contexts
            if (!window.cordova) {
                return [2 /*return*/, Promise.reject("cordovaLoginRedirect requires cordova")];
            }
            callbackUrlPromise = new promiseDelegate.PromiseDelegate();
            isBrowserBasedSSOLoginEnabled = AuthenticationState.getInstance()
                .useBrowserBasedSSO;
            if (isBrowserBasedSSOLoginEnabled) {
                // ── iOS: ASWebAuthSession ─────────────────────────────────────────────────
                // ASWebAuthSession opens the IdP URL in an isolated, secure browser session.
                // The OS intercepts the custom-scheme redirect (SSO_BROWSER_LOGIN_SCHEME) and
                // passes the full callback URL back to the success handler automatically.
                if (window.plugins.ASWebAuthSession) {
                    console.debug("Using ASWebAuthSession for authentication");
                    window.plugins.ASWebAuthSession.start(SSO_BROWSER_LOGIN_SCHEME_NAME, url, function (callbackUrl) {
                        if (callbackUrl &&
                            callbackUrl.indexOf(SSO_BROWSER_LOGIN_SCHEME) === 0) {
                            callbackUrlPromise.resolve(callbackUrl);
                        }
                        else {
                            callbackUrlPromise.reject("Received unexpected callback URL from ASWebAuthSession: " +
                                callbackUrl);
                        }
                    }, function (error) {
                        // Serialise the native error object so callers can diagnose the failure
                        callbackUrlPromise.reject("Encountered an error while trying to authenticate: " +
                            JSON.stringify(error));
                    });
                }
                // ── Android: Custom Chrome Tab (BrowserTabs plugin) ──────────────────────
                // On Android the plugin fires an intent that opens a Custom Chrome Tab and
                // returns immediately — there is no URL in the openUrl success callback.
                // Instead, the OS delivers the custom-scheme redirect URI to handleOpenURL
                // in the Cordova host, which calls triggerPostCasAuthentication on window.
                else if (window.cordova.plugins.browsertabs) {
                    console.debug("Using browsertabs for authentication");
                    // Register a one-shot global handler that the Cordova handleOpenURL hook calls
                    // once the IdP redirects back with the SSO callback URL.
                    // The handler is immediately cleared after use to prevent stale invocations.
                    window.triggerPostCasAuthentication = function (callbackUrl) {
                        // Clear the global handler so it cannot be invoked a second time
                        window.triggerPostCasAuthentication = undefined;
                        // Only resolve if the callback URL matches the expected SSO custom scheme
                        if (callbackUrl &&
                            callbackUrl.indexOf(SSO_BROWSER_LOGIN_SCHEME) === 0) {
                            callbackUrlPromise.resolve(callbackUrl);
                        }
                        else {
                            callbackUrlPromise.reject("Received unexpected callback URL from browsertabs: " + callbackUrl);
                        }
                    };
                    window.cordova.plugins.browsertabs.openUrl(url, { authSession: true, scheme: SSO_BROWSER_LOGIN_SCHEME_NAME }, function () {
                        // Success callback fires when the tab opens, not when auth completes.
                        // The actual callback URL arrives asynchronously via triggerPostCasAuthentication.
                    }, function (error) {
                        // Serialise the native error object so callers can diagnose the failure
                        callbackUrlPromise.reject("Encountered an error while trying to authenticate: " +
                            JSON.stringify(error));
                    });
                }
                else {
                    // Neither required plugin is available — cannot proceed with browser-based SSO
                    return [2 /*return*/, Promise.reject("Browser-based SSO requires ASWebAuthSession or BrowserTab plugin")];
                }
            }
            else {
                // ── Legacy: InAppBrowser (embedded WebView) ───────────────────────────────
                // Used when browser-based SSO is disabled. The IdP sign-in page is opened
                // inside an embedded WebView. Authentication completion is detected by
                // monitoring URL changes via the loadstart / loaderror events.
                if (window.cordova.InAppBrowser) {
                    console.debug("Using InAppBrowser for authentication");
                    windowRef_1 = window.cordova.InAppBrowser.open(url, "_blank", "location=no" // Hide the address bar to prevent manual URL manipulation
                    );
                    if (!windowRef_1) {
                        return [2 /*return*/, Promise.reject("Window failed to open")];
                    }
                    completed_1 = false;
                    closed_1 = false;
                    closeBrowser_1 = function () {
                        console.log("Closing InAppBrowser");
                        closed_1 = true;
                        windowRef_1.close();
                    };
                    // loadstart fires on every navigation attempt inside the WebView.
                    // The IdP redirects to a localhost URL after a successful sign-in, which
                    // cannot actually load — we intercept it here before the browser errors.
                    windowRef_1.addEventListener("loadstart", function (event) {
                        console.log("Loading...");
                        if (event.url.indexOf(INVALID_LOCALHOST_URL) === 0) {
                            // Detected the post-authentication localhost redirect — extract and resolve
                            closeBrowser_1();
                            callbackUrlPromise.resolve(event.url);
                            completed_1 = true;
                        }
                    });
                    // loaderror fires when the WebView cannot load a URL (e.g. the localhost redirect).
                    // A localhost URL here is expected and treated as a successful authentication signal;
                    // any other URL represents a genuine network or page error.
                    windowRef_1.addEventListener("loaderror", function (event) {
                        console.log("loaderror - Checking for valid callback url");
                        if (!completed_1) {
                            // Although this is an error, this could still be considered a "success" if the URL is localhost
                            if (event.url.indexOf(INVALID_LOCALHOST_URL) === 0) {
                                // Expected load failure on the localhost redirect — treat as authentication success
                                closeBrowser_1();
                                callbackUrlPromise.resolve(event.url);
                                completed_1 = true;
                            }
                            else {
                                // Genuine page load error on a non-localhost URL — authentication failed
                                closeBrowser_1();
                                callbackUrlPromise.reject("Encountered a page load error while trying to authenticate");
                            }
                        }
                    });
                    // exit fires when the InAppBrowser window is closed.
                    // If closed is false the user dismissed the window manually before auth completed.
                    windowRef_1.addEventListener("exit", function (event) {
                        if (!closed_1) {
                            // User manually closed the auth window without completing sign-in
                            callbackUrlPromise.reject("Couldn't login properly since the auth window was closed");
                        }
                    });
                }
                else {
                    // InAppBrowser plugin is not available in this Cordova environment
                    return [2 /*return*/, Promise.reject("cordovaLoginRedirect requires InAppBrowser")];
                }
            }
            return [2 /*return*/, callbackUrlPromise.promise];
        });
    });
}

/**
 * Service responsible for secure parent-iframe communication for user exchange.
 * Handles message passing between iframe and parent window using postMessage API.
 *
 * Both directions use "*" as the postMessage targetOrigin because on Cordova
 * the WebView assigns origins that are unpredictable and inconsistent between
 * frames (e.g., parent receives at "https://wfs.cloud" while iframe reports
 * "https://app-sprint-us8.wfs.cloud" as its window.location.origin).
 *
 * Security is enforced via isValidOrigin() which validates the sender's origin
 * (event.origin) on both sides before processing any message.
 */
var USER_REQUEST = "USER_REQUEST";
var USER_RESPONSE = "USER_RESPONSE";
var MESSAGE_TIMEOUT_MS = 5000; // Time to wait for parent response before timing out
var MESSAGE_EVENT = "message";
var parentResponderListener = null;
/**
 * Check if the current window is running inside an iframe.
 */
var isInsideIframe = function () { return window.self !== window.top; };
/**
 * Check if the origin of the event is valid.
 * @param origin - Origin of the event.
 * @returns True if the origin is valid, false otherwise.
 */
var isValidOrigin = function (origin) {
    return (origin.startsWith("http://localhost") || // Allow localhost patterns for dev
        origin === "https://wfs.cloud" || // Allow base domain for Android Cordova
        origin.startsWith("workforce://") || // Allow workforce:// scheme for iOS Cordova
        origin.endsWith(".wfs.cloud") // Allow all subdomains of .wfs.cloud for web prod
    );
};
/**
 * Request user from parent window.
 * Used by iframe to obtain authenticated user from the parent app.
 *
 * @param timeoutMs - Maximum time to wait for parent response (default: 5000ms)
 * @returns Promise resolving to User object or null if unavailable
 */
var requestUserFromParent = function (timeoutMs) {
    if (timeoutMs === void 0) { timeoutMs = MESSAGE_TIMEOUT_MS; }
    if (!isInsideIframe()) {
        return Promise.resolve(null);
    }
    var requestId = generateUUIDv4();
    return new Promise(function (resolve) {
        var messageTimeout;
        var cleanup = function () {
            if (messageTimeout) {
                clearTimeout(messageTimeout);
            }
            resetListenerRegistration();
        };
        var onMessageReceived = function (event) {
            if (!isValidOrigin(event.origin)) {
                return;
            }
            var data = event.data;
            if (!data ||
                data.type !== USER_RESPONSE ||
                data.requestId !== requestId) {
                return;
            }
            // Clean up
            cleanup();
            // Parse user from response and resolve the promise
            try {
                resolve(data.userStorageString
                    ? oidcClientTs.User.fromStorageString(data.userStorageString)
                    : null);
            }
            catch (error) {
                // Origin mismatch — not in expected Cordova iframe context
                console.debug("Failed to construct user from parent response", error);
                cleanup();
                resolve(null);
            }
        };
        // Set timeout to prevent indefinite waiting
        messageTimeout = setTimeout(function () {
            cleanup();
            resolve(null);
        }, timeoutMs);
        // Register message listener
        window.addEventListener(MESSAGE_EVENT, onMessageReceived);
        // Send request to parent.
        // Using "*" as targetOrigin because on Cordova the parent's receiving origin
        // (e.g., https://wfs.cloud) differs from what window.location.origin reports
        // in the iframe (e.g., https://app-sprint-us8.wfs.cloud).
        // Security is enforced on the parent side via isValidOrigin() which validates
        // the sender's origin before processing any request.
        window.parent.postMessage({
            type: USER_REQUEST,
            requestId: requestId,
        }, "*");
    });
};
/**
 * Register a responder in the parent window to handle iframe user requests.
 * Should only be called once in the parent (non-iframe) context.
 *
 * @param getUserCallback - Async function that returns the current user
 */
var registerParentResponder = function (getUserCallback) {
    if (parentResponderListener) {
        return;
    }
    parentResponderListener = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var data, origin, isOriginValid, user;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    data = event.data, origin = event.origin;
                    isOriginValid = isValidOrigin(origin);
                    if (!data || data.type !== USER_REQUEST || !isOriginValid) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, getUserCallback().catch(function () { return null; })];
                case 1:
                    user = _a.sent();
                    // Using "*" as targetOrigin because the iframe's receiving origin is
                    // unpredictable across environments (Cordova assigns different origins
                    // than the URL-based origin reported in event.origin).
                    // Security is enforced upstream: isValidOrigin() validates the sender,
                    // and event.source ensures the response only reaches the requesting window.
                    event.source.postMessage({
                        type: USER_RESPONSE,
                        requestId: data.requestId,
                        userStorageString: user ? user.toStorageString() : null,
                    }, "*");
                    return [2 /*return*/];
            }
        });
    }); };
    window.addEventListener(MESSAGE_EVENT, parentResponderListener);
};
/**
 * Reset the listener registration flag.
 * Useful for testing or re-initialization scenarios.
 */
var resetListenerRegistration = function () {
    if (parentResponderListener) {
        window.removeEventListener(MESSAGE_EVENT, parentResponderListener);
        parentResponderListener = null;
    }
};

/**
 * Returns the suite URL to use for ADP region/env detection.
 * Prefers REACT_APP_LOCAL_DEV_SUITE_URL if set, otherwise uses window.location.hostname.
 */
function getSuiteUrl() {
    var localDevSuiteUrl = process.env.REACT_APP_LOCAL_DEV_SUITE_URL;
    return localDevSuiteUrl || window.location.hostname;
}
/**
 * Returns whether or not the Suite is deployed on an ADP url.
 * Useful for allowing the Suite to behave differently when deployed
 * on those urls
 */
function isSuiteOnAdpUrl() {
    return getSuiteUrl().includes("adp.com");
}

/**
 * Authentication Service class that handles all authentication related functions.
 */
var OidcAuthenticationService = /** @class */ (function () {
    function OidcAuthenticationService(authProviderStrategy) {
        var _this = this;
        var _a, _b;
        /**
         * If we're in the process of refreshing the user, we don't want to fire off another request.
         * - An `undefined` value indicates that no promise is active.
         * - Any defined value indicates that a promise is currently being resolved.
         */
        this.getRefreshedUserPromise = undefined;
        this.authenticationState = AuthenticationState.getInstance();
        /**
         * A predicate function that returns the fresh token if available, or false otherwise
         * Arrow function syntax is used purposely to bind the value of "this" so
         * the function can be passed to external dependencies such as "waitUntil"
         */
        this.isTokenFresh = function () { return __awaiter(_this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userManager.getUser()];
                    case 1:
                        user = _a.sent();
                        if (user && !user.expired) {
                            return [2 /*return*/, user.access_token];
                        }
                        if (!user) {
                            console.log("User unloaded during token check...");
                        }
                        if (user && user.expired) {
                            console.log("Token expired during token check...");
                        }
                        return [2 /*return*/, false];
                }
            });
        }); };
        this.authProviderStrategy = authProviderStrategy;
        this.initializeAuthStateBasedOnQueryParams();
        this.initializeUserManager();
        (_b = (_a = this.authProviderStrategy).listenForSessionInvalidEvent) === null || _b === void 0 ? void 0 : _b.call(_a, function () {
            return _this.logout();
        });
        // On mobile, stop silent renew when backgrounded and restart on resume.
        // Cordova Android continues running JS timers while backgrounded but restricts network,
        // causing the SilentRenewService timer to fire and fail without network.
        // Registered in constructor (not initializeUserManager) to avoid duplicate listeners
        // since initializeUserManager is called on every login() call.
        if (isMobileDevice()) {
            document.addEventListener("pause", function () {
                _this.userManager.stopSilentRenew();
            });
            document.addEventListener("resume", function () { return __awaiter(_this, void 0, void 0, function () {
                var user, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(this.authenticationState.getAuthStatus() ===
                                AuthenticationStatus.Authenticated)) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.userManager.getUser()];
                        case 1:
                            user = _a.sent();
                            if (!(user && user.expired)) return [3 /*break*/, 5];
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            return [4 /*yield*/, this.signinSilent()];
                        case 3:
                            _a.sent();
                            return [3 /*break*/, 5];
                        case 4:
                            e_1 = _a.sent();
                            console.error("[Auth] Cordova resume - refresh failed, logging out:", e_1);
                            this.logout({ withoutToken: true });
                            return [2 /*return*/];
                        case 5:
                            this.userManager.startSilentRenew();
                            return [2 /*return*/];
                    }
                });
            }); });
        }
    }
    /**
     * Get the current instance of the OidcAuthenticationService
     * @returns instance of the OidcAuthenticationService
     */
    OidcAuthenticationService.getInstance = function (authProviderStrategy) {
        if (!authProviderStrategy) {
            throw new Error("authProviderStrategy is missing");
        }
        // Only create new instance if strategy changed or no instance exists
        if (!OidcAuthenticationService.instance ||
            OidcAuthenticationService.instance.authProviderStrategy
                .constructor !== authProviderStrategy.constructor) {
            OidcAuthenticationService.instance = new OidcAuthenticationService(authProviderStrategy);
        }
        return OidcAuthenticationService.instance;
    };
    /**
     * Log in to the application
     * @param redirectBackRoute - The route where user should be redirected after signing in
     * @returns A promise that resolves upon successful completion of sign-in or rejects if an error occurs.
     */
    OidcAuthenticationService.prototype.login = function (redirectBackRoute) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    this.initializeUserManager();
                    return [2 /*return*/, this.signin(redirectBackRoute)];
                }
                catch (error) {
                    console.error("Auth initialization failed");
                    this.authProviderStrategy.clearTokensInLocalStorage();
                    throw error;
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Logs the user out of the suite app.
     * This method handles different authentication statuses and ensures proper logout procedures,
     * including clearing tokens, updating authentication status, and redirecting to the CAS logout URL.
     *
     * @param options - Optional logout options to control which systems to logout from
     * @returns Promise that resolves when the logout process is complete.
     */
    OidcAuthenticationService.prototype.logout = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Always reset iframe parent communication listener on logout
                        resetListenerRegistration();
                        if (this.authenticationState.getAuthStatus() ===
                            AuthenticationStatus.MockAuthenticated) {
                            this.mockLogout();
                            return [2 /*return*/];
                        }
                        // When user is already logged out, stop the process and return.
                        if (![
                            AuthenticationStatus.Authenticated,
                            AuthenticationStatus.Initializing,
                        ].includes(this.authenticationState.getAuthStatus())) {
                            console.warn("User is already logged out");
                            return [2 /*return*/];
                        }
                        // Update the status as soon as possible before doing anything async.
                        // This will allow other functions to return early and wait for the log out to complete,
                        // which prevents potential race conditions where other functions update the status before this one.
                        try {
                            this.authenticationState.updateAuthStatus(AuthenticationStatus.LoggingOut);
                        }
                        catch (err) {
                            console.error(err);
                        }
                        return [4 /*yield*/, this.userManager.removeUser()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.userManager.clearStaleState()];
                    case 2:
                        _a.sent();
                        // end Dynatrace session
                        endSession();
                        getStore().dispatch({
                            type: "logoutSuccess" /* LogoutSuccess */,
                        });
                        if (!!(options === null || options === void 0 ? void 0 : options.skipWfxLogout)) return [3 /*break*/, 4];
                        return [4 /*yield*/, wfxLogout()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [4 /*yield*/, this.authProviderStrategy.logout(this.clearSession.bind(this), options)];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Retrieve normalized user info.
     *
     * Delegates to the configured AuthProviderStrategy which returns a OidcUserInfo
     * object normalized for the application's consumers. Returns undefined when
     * no token is available or parsing fails.
     *
     * @returns {OidcUserInfo | undefined} Normalized token claims or undefined
     */
    OidcAuthenticationService.prototype.getOidcUserInfo = function () {
        return this.authProviderStrategy.getOidcUserInfo();
    };
    /**
     * Get the base64 access token
     * NOTE: Usage of this should only occur when authenticated. If you need
     *       to get the access token and don't know if you're authenticated, query
     *       the authentication status {@link AuthenticationManager.getAuthStatus}
     * @returns Promise containing the token
     */
    OidcAuthenticationService.prototype.getAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Return a promise that *never* resolves if we are logging out.
                        // This will make it so that any active processes making calls to the backend get "frozen"
                        // This way, logout will stay deterministic
                        if (this.authenticationState.getAuthStatus() !==
                            AuthenticationStatus.Authenticated) {
                            return [2 /*return*/, new promiseDelegate.PromiseDelegate().promise];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.awaitFreshToken()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_1 = _a.sent();
                        throw new Error("Error while attempting to fetch access token: " + error_1.message);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Validates strategy configuration before proceeding with authentication flows.
     * This is important to call before initializing the UserManager and starting sign-in.
     * For some implementations, it can actually compute and store missing fields such as authUrl.
     * @private
     */
    OidcAuthenticationService.prototype.validateStrategyConfiguration = function () {
        var _a, _b;
        // Validate strategy configuration before proceeding
        try {
            (_b = (_a = this.authProviderStrategy).validateConfiguration) === null || _b === void 0 ? void 0 : _b.call(_a);
        }
        catch (error) {
            var strategyName = this.authProviderStrategy.constructor.name;
            console.error("Failed to validate authentication strategy: " + strategyName + ".", error);
            throw error;
        }
    };
    /**
     * Initializes parts of auth state based on the value of query params in the URL.
     * Useful for enabling certain behaviors on the web app, not as useful on the mobile app where
     * URLs aren't as easy to control.
     */
    OidcAuthenticationService.prototype.initializeAuthStateBasedOnQueryParams = function () {
        var queryString = window.location.search
            ? window.location.search
            : location.search;
        var params = qs.parse(queryString, { ignoreQueryPrefix: true });
        this.authenticationState.setImpersonationQueryParameter((params === null || params === void 0 ? void 0 : params.impersonation) === "true");
        this.authenticationState.setSkipAccountQueryParamsPresent((params === null || params === void 0 ? void 0 : params.skipAccountSelectionInput) === "true" && (params === null || params === void 0 ? void 0 : params.accountId));
    };
    /**
     * Call this when a session has been established but we need immediate session renewal due the user being expired
     * This will attempt to use the refresh token to re-establish a non-expired User object
     * If a session has not been established yet, such as during initialize(),
     * refreshUserAndInitializeKeycloakSession should be called instead
     */
    OidcAuthenticationService.prototype.getRefreshedUser = function () {
        var _this = this;
        // Refresh tokens are being fetched in the background by UI-modules even
        // though user is not authenticated which creates unnecessary requests to
        // the server and generates OIDC signin silent requests.
        // If the user is not authenticated, we should not be trying to get a token
        // This is a safeguard to prevent above mentioned issue
        if (this.authenticationState.getAuthStatus() !==
            AuthenticationStatus.Authenticated) {
            throw new Error("User is not authenticated, refresh token can't be fetched. Current status: " + this.authenticationState.getAuthStatus());
        }
        if (!this.getRefreshedUserPromise) {
            console.log("Token expired, attempting to refresh...");
            this.getRefreshedUserPromise = this.signinSilent()
                .then(function (refreshedUser) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (refreshedUser) {
                        console.log("Refresh succeeded");
                        return [2 /*return*/, refreshedUser];
                    }
                    else {
                        throw new Error("User not found even after refresh");
                    }
                });
            }); })
                .catch(function (reason) { return __awaiter(_this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!((_a = this.tokenRefreshElector) === null || _a === void 0 ? void 0 : _a.isLeader)) return [3 /*break*/, 2];
                            console.error("Token refresh failed:", reason);
                            return [4 /*yield*/, this.tokenRefreshElector.broadcastChannel.postMessage({
                                    type: TOKEN_REFRESH_FAILED_MESSAGE,
                                    error: reason.message,
                                })];
                        case 1:
                            _b.sent();
                            _b.label = 2;
                        case 2: return [4 /*yield*/, this.logout({ withoutToken: true })];
                        case 3:
                            _b.sent();
                            throw new Error("Error occurred while attempting to refresh access token:\n" + reason);
                    }
                });
            }); })
                .finally(function () {
                _this.getRefreshedUserPromise = undefined;
            });
        }
        return this.getRefreshedUserPromise;
    };
    /*
     * Refreshes the User without any human interaction.
     */
    OidcAuthenticationService.prototype.signinSilent = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.userManager.signinSilent(this.authProviderStrategy.getSigninSilentOptions())];
            });
        });
    };
    /**
     * Refreshes the access token and returns it
     */
    OidcAuthenticationService.prototype.getRefreshedToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getRefreshedUser()];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, user.access_token];
                    case 2:
                        e_2 = _a.sent();
                        throw e_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Checks if a valid (i.e. not expired) token is available and returns it.
     * If not, attempts to refresh the token and return the new one.
     * @private
     */
    OidcAuthenticationService.prototype.getValidToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var validToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.isTokenFresh()];
                    case 1:
                        validToken = _a.sent();
                        if (!validToken) {
                            return [2 /*return*/, this.getRefreshedToken()];
                        }
                        else {
                            return [2 /*return*/, validToken];
                        }
                }
            });
        });
    };
    /**
     * Wait until a refreshed token is available or throws an error on timeout.
     * waitUntil itself throws the Timeout error which is supposed to be caught by handlers.
     * There is another error thrown at the end if the accessToken received is falsy for some reason
     */
    OidcAuthenticationService.prototype.awaitFreshToken = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var tokenNotFoundMessage, token, e_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if ((_a = this.tokenRefreshElector) === null || _a === void 0 ? void 0 : _a.isLeader) {
                            return [2 /*return*/, this.getValidToken()];
                        }
                        tokenNotFoundMessage = "Token not found";
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, asyncWaitUntil.waitUntil(this.isTokenFresh, {
                                timeout: 5000,
                                intervalBetweenAttempts: 200,
                            })];
                    case 2:
                        token = _b.sent();
                        if (token) {
                            return [2 /*return*/, token];
                        }
                        throw new Error(tokenNotFoundMessage);
                    case 3:
                        e_3 = _b.sent();
                        if (e_3.message !== tokenNotFoundMessage) {
                            // On mobile, don't trigger a reactive refresh — let automaticSilentRenew
                            // (or the resume handler) handle it. This avoids a race condition where
                            // both the reactive path and the library attempt signinSilent() simultaneously,
                            // which fails with Keycloak's refresh token rotation (Revoke Refresh Token: ON).
                            if (isMobileDevice()) {
                                throw e_3;
                            }
                            return [2 /*return*/, this.getRefreshedToken()];
                        }
                        else {
                            throw e_3;
                        }
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Initiate either the regular sign-in flow using UserManager on the web app or an alternate
     * sign-in flow on the mobile app
     * @param redirectBackRoute - The route where user should be redirected after signing in
     */
    OidcAuthenticationService.prototype.signin = function (redirectBackRoute) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var nonce, redirect_uri, oidcClientSettings, oidcClient, signinRequest;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        nonce = generateUUIDv4();
                        if (!!isMobileDevice()) return [3 /*break*/, 1];
                        redirect_uri = redirectBackRoute
                            ? (_b = (_a = this.authProviderStrategy).getSignInRedirectUri) === null || _b === void 0 ? void 0 : _b.call(_a, redirectBackRoute) : undefined;
                        return [2 /*return*/, this.userManager.signinRedirect({
                                nonce: nonce,
                                redirect_uri: redirect_uri,
                            })];
                    case 1:
                        oidcClientSettings = this.authProviderStrategy.getOidcClientSettings();
                        oidcClient = new oidcClientTs.OidcClient(oidcClientSettings);
                        return [4 /*yield*/, oidcClient.createSigninRequest({
                                request_type: "si:r",
                                nonce: nonce,
                            })];
                    case 2:
                        signinRequest = _c.sent();
                        return [2 /*return*/, cordovaLoginRedirect(signinRequest.url)
                                .then(function (callbackUrl) {
                                return _this.userManager
                                    .signinCallback(callbackUrl)
                                    .then(function (user) { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                if (!user) return [3 /*break*/, 2];
                                                console.log("Callback successfully parsed on Cordova - initializing session");
                                                return [4 /*yield*/, this.initializeKeycloakSession()];
                                            case 1:
                                                _a.sent();
                                                this.authenticationState.updateAuthStatus(AuthenticationStatus.Authenticated);
                                                // Mobile is handled differently, since we don't leave and navigate back like the web app
                                                // so we need to handle pushing to "Home" in the authSuccess function.
                                                console.log("[Auth][Mobile] Login complete, dispatching push to Home");
                                                getStore().dispatch(connectedReactRouter.push(routeContext.findRouteByName(exports.FrameworkRouteIds.Home) || ""));
                                                return [3 /*break*/, 3];
                                            case 2:
                                                console.log("User is null after processing callback on mobile app");
                                                return [2 /*return*/, this.clearSession()];
                                            case 3: return [2 /*return*/];
                                        }
                                    });
                                }); })
                                    .catch(function (error) {
                                    console.log("Failed to process signin callback url: " + callbackUrl);
                                    console.log(error);
                                    throw error;
                                });
                            })
                                .catch(function (error) {
                                // If the user cancels the login process, we need to clear the OIDC keys from local storage to avoid any potential issues.
                                console.log("User has cancelled the login process: " + error);
                                _this.removeAllOidcKeys();
                            })];
                }
            });
        });
    };
    /**
     * Logs out of the application when logged in as a mocked users
     *    NOTE: This assumes we have to do no cleanup to anything and
     *    simply updates the authentication status and returns us to
     *    the organization panel
     */
    OidcAuthenticationService.prototype.mockLogout = function () {
        this.clearSession();
        getStore().dispatch(connectedReactRouter.push(routeContext.findRouteByName(exports.FrameworkRouteIds.Login) || ""));
    };
    /**
     * Set the access, refresh, and identity tokens in local storage
     * This is a way of syncing UserManager data to localStorage so that it can be accessed by
     * methods that DON'T return a promise. Such methods cannot wait for the UserManager.getUser()
     * promise.
     */
    OidcAuthenticationService.prototype.setTokensInLocalStorage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userManager.getUser().then(function (user) {
                            if (user === null) {
                                throw new Error("User not authenticated");
                            }
                            _this.authProviderStrategy.setTokensInLocalStorage(user);
                        })];
                    case 1: 
                    // We only set the tokens when the oidc instance and tokens are guaranteed to exist
                    return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Handles sign-in callback to manage user sessions, either by initializing the session or refreshing an expired user.
     * TODO SUITE-6189: Refactor this code to have a cleaner way of diverging
     *  between Keycloak and AIM implementations. This could use the Strategy
     *  pattern or something else to clean it up.
     * @returns Promise that resolves when UserManager is initialized.
     */
    OidcAuthenticationService.prototype.establishSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.userManager
                        .signinCallback()
                        .then(function (user) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    this.clearUrlOfQueryParams();
                                    if (!user) return [3 /*break*/, 2];
                                    // Setup multi-tab support
                                    return [4 /*yield*/, this.initializeTabElection()];
                                case 1:
                                    // Setup multi-tab support
                                    _a.sent();
                                    console.log("Callback successfully parsed - initializing session");
                                    if (this.authenticationState.isAimProvider) {
                                        return [2 /*return*/, this.setTokensInLocalStorage()];
                                    }
                                    else {
                                        return [2 /*return*/, this.initializeKeycloakSession()];
                                    }
                                case 2: throw new Error("User is null after processing callback");
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); })
                        .catch(function () { return __awaiter(_this, void 0, void 0, function () {
                        var parentUser;
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    if (!isInsideIframe()) return [3 /*break*/, 4];
                                    console.debug("signinCallback failed; attempting to get user from parent");
                                    return [4 /*yield*/, requestUserFromParent()];
                                case 1:
                                    parentUser = _b.sent();
                                    if (!parentUser) return [3 /*break*/, 3];
                                    return [4 /*yield*/, this.initSessionFromParentUser(parentUser)];
                                case 2:
                                    _b.sent();
                                    return [2 /*return*/];
                                case 3:
                                    console.warn("Failed to get user from parent or parent has no user");
                                    _b.label = 4;
                                case 4: 
                                // Setup multi-tab support
                                return [4 /*yield*/, this.initializeTabElection()];
                                case 5:
                                    // Setup multi-tab support
                                    _b.sent();
                                    if (!!((_a = this.tokenRefreshElector) === null || _a === void 0 ? void 0 : _a.isLeader)) return [3 /*break*/, 8];
                                    if (!this.authenticationState.getPerformingTokenLogin()) return [3 /*break*/, 7];
                                    // If we're performing token login, we must force a valid token here,
                                    // even if we aren't the leader tab. This technically breaks the rules
                                    // of leader tabs but as long as the leader tab is not unresponsive
                                    // and is actually doing its job of refreshing, this call will not
                                    // need to actually refresh the token.
                                    return [4 /*yield*/, this.getValidToken()];
                                case 6:
                                    // If we're performing token login, we must force a valid token here,
                                    // even if we aren't the leader tab. This technically breaks the rules
                                    // of leader tabs but as long as the leader tab is not unresponsive
                                    // and is actually doing its job of refreshing, this call will not
                                    // need to actually refresh the token.
                                    _b.sent();
                                    _b.label = 7;
                                case 7:
                                    if (this.authenticationState.isAimProvider) {
                                        return [2 /*return*/, this.setTokensInLocalStorage()];
                                    }
                                    else {
                                        return [2 /*return*/, this.initializeKeycloakSession()];
                                    }
                                case 8:
                                    if (this.authenticationState.isAimProvider) {
                                        return [2 /*return*/, this.setTokensInLocalStorage()];
                                    }
                                    else {
                                        return [2 /*return*/, this.refreshExistingKeycloakUser()];
                                    }
                            }
                        });
                    }); })];
            });
        });
    };
    /**
     * Tries to store a user in the UserManager if it has a storeUser method.
     * @param user - the user to store
     * @returns a promise that resolves to true if the user was stored, or false if it was not.
     */
    OidcAuthenticationService.prototype.tryToStoreUser = function (user) {
        var _a, _b;
        return (((_b = (_a = this.userManager).storeUser) === null || _b === void 0 ? void 0 : _b.call(_a, user).then(function () { return true; })) ||
            Promise.resolve(false));
    };
    /**
     * Initialize a session from a parent-provided user.
     * Prefers storing through UserManager, with a safe fallback to strategy storage.
     */
    OidcAuthenticationService.prototype.initSessionFromParentUser = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            var stored;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToStoreUser(user)];
                    case 1:
                        stored = _a.sent();
                        if (!stored) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.initializeKeycloakSession()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: 
                    // Fallback: store tokens directly when UserManager storage isn't available.
                    return [4 /*yield*/, this.authProviderStrategy.setTokensInLocalStorage(user)];
                    case 4:
                        // Fallback: store tokens directly when UserManager storage isn't available.
                        _a.sent();
                        this.authenticationState.updateAuthStatus(AuthenticationStatus.Authenticated);
                        _a.label = 5;
                    case 5:
                        console.debug("Session initialized successfully from parent user");
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Register iframe-parent communication handlers.
     * In parent context: registers responder to handle iframe user requests.
     * In iframe context: no action needed (requests are made on-demand).
     * Should be called when WTA/ExternalPageView is about to be opened.
     */
    OidcAuthenticationService.prototype.registerIframeParentCommunication = function () {
        var _this = this;
        // Do not register listeners in the iframe since they are registered on-demand when the iframe sends a request to the parent.
        // This is to avoid unnecessary listeners in case the iframe is never opened, and also
        // to avoid potential issues with multiple listeners being registered in the iframe if the iframe is opened multiple times.
        if (!isInsideIframe()) {
            registerParentResponder(function () { return _this.userManager.getUser(); });
        }
    };
    /**
     * Unregister iframe-parent communication handlers.
     * Should be called when WTA/ExternalPageView is unmounted or on cleanup.
     */
    OidcAuthenticationService.prototype.unregisterIframeParentCommunication = function () {
        resetListenerRegistration();
    };
    /**
     * After calling in signinCallback and successfully parsing the callback, we end up with a URL that still has the
     * OIDC query params in it (e.g. code, state, etc.). These query parameters are no longer required at that point
     * and can be cleared using this method.
     * @private
     */
    OidcAuthenticationService.prototype.clearUrlOfQueryParams = function () {
        var currentUrl = window.location.href;
        var currentUrlObj = new URL(currentUrl);
        currentUrlObj.search = "";
        window.history.replaceState(window.history.state, "", currentUrlObj.toString());
    };
    /**
     * Establishes a keycloak session by checking the userManager for an existing user.
     * If a user is found, it attempts to refresh the user's tokens and initialize the session.
     * This should only be called by the leader tab, since the leader tab is the
     * only one that should be managing token refreshes prior to session initialization.
     * If this is called when there is no user, an error will be thrown and
     * caught by the caller which will trigger a login attempt.
     * @private
     */
    OidcAuthenticationService.prototype.refreshExistingKeycloakUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.userManager.getUser().then(function (user) {
                        if (user) {
                            console.log("User successfully reloaded - initializing session");
                            return _this.refreshUserAndInitializeKeycloakSession();
                        }
                        else {
                            // No user was found and skip account was not present
                            // Therefore we should simply throw
                            throw new Error("User not found");
                        }
                    })];
            });
        });
    };
    /**
     * Call this when user is available but is potentially expired and a session has not been initialized yet
     * This will attempt to use the refresh token to re-initiate the session
     * If a user is expired in any other situation, such as during access token requests,
     * getRefreshedUser should be called instead
     */
    OidcAuthenticationService.prototype.refreshUserAndInitializeKeycloakSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var refreshedUser;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 7, , 13]);
                        console.log("Attempting to refresh token and initialize session");
                        return [4 /*yield*/, this.signinSilent()];
                    case 1:
                        refreshedUser = _a.sent();
                        if (!refreshedUser) return [3 /*break*/, 2];
                        return [2 /*return*/, this.initializeKeycloakSession()];
                    case 2:
                        if (!!this.authenticationState.getPerformingTokenLogin()) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.logout({ withoutToken: true })];
                    case 3:
                        _a.sent();
                        throw new Error(ESTABLISH_SESSION_TOKEN_REFRESH_FAILURE_ERROR);
                    case 4: 
                    // Delete the tokens and return a rejected promise so the caller can
                    // know that establishSession failed
                    return [4 /*yield*/, this.clearSession()];
                    case 5:
                        // Delete the tokens and return a rejected promise so the caller can
                        // know that establishSession failed
                        _a.sent();
                        return [2 /*return*/, Promise.reject(new Error(ESTABLISH_SESSION_TOKEN_REFRESH_FAILURE_ERROR))];
                    case 6: return [3 /*break*/, 13];
                    case 7:
                        _a.sent();
                        if (!(this.authenticationState.getImpersonationQueryParameter() ||
                            this.authenticationState.getSkipAccountQueryParamsPresent())) return [3 /*break*/, 8];
                        return [2 /*return*/, this.immediateLogin()];
                    case 8:
                        if (!!this.authenticationState.getPerformingTokenLogin()) return [3 /*break*/, 10];
                        return [4 /*yield*/, this.logout({ withoutToken: true })];
                    case 9:
                        _a.sent();
                        throw new Error(ESTABLISH_SESSION_TOKEN_REFRESH_FAILURE_ERROR);
                    case 10: 
                    // Delete the tokens and return a rejected promise so the caller can
                    // know that establishSession failed
                    return [4 /*yield*/, this.clearSession()];
                    case 11:
                        // Delete the tokens and return a rejected promise so the caller can
                        // know that establishSession failed
                        _a.sent();
                        return [2 /*return*/, Promise.reject(new Error(ESTABLISH_SESSION_TOKEN_REFRESH_FAILURE_ERROR))];
                    case 12: return [3 /*break*/, 13];
                    case 13: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Attempt reset of the session by logging into the configured auth provider
     * Useful in certain cases such as impersonation as well as IdP-initiated SSO login flows
     * where it is assumed that the user already has a session but needs to re-initiate OIDC
     * in order to get a new code and a fresh set of tokens.
     *
     * Because it's possible that the user has a set of tokens already stored when this method gets
     * triggered, the first thing we do is attempt to remove those tokens, so that new ones can be
     * set once we return to the Suite. This may seem like an edge case, but it's actually very common
     * that the user might already be logged into the Suite, closes the tab, and then re-accesses the Suite
     * through either impersonation or their IdP-initiated SSO flow before their previous session has
     * expired and the Suite has had a chance to clear out its existing tokens.
     */
    OidcAuthenticationService.prototype.immediateLogin = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.userManager.removeUser().finally(function () {
                        return _this.signin().catch(function () {
                            _this.clearSession();
                        });
                    })];
            });
        });
    };
    /**
     * Initializes the tab leader election process.
     * This method enables multi-tab suppport by ensuring there is a single elected leader tab
     * amongst all open tabs (of same broadcast channel name) responsible for managing token
     * expiration event handling. A leader tab deposed via user interaction, browser "unloading",
     * or crashing, will initiate the election of a new leader.
     */
    OidcAuthenticationService.prototype.initializeTabElection = function () {
        var _this = this;
        var tokenRefreshChannel = new broadcastChannel.BroadcastChannel("tokenRefresh");
        var expiringHandler = function () { return __awaiter(_this, void 0, void 0, function () {
            var e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getRefreshedUser()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_5 = _a.sent();
                        // getRefreshedUser() already triggers logout internally on refresh
                        // failure. If it throws because the user isn't authenticated, logout
                        // is unnecessary. Either way, just log here.
                        console.error("Failed to refresh when token expiring: ", e_5);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var expiredHandler = function () { return __awaiter(_this, void 0, void 0, function () {
            var e_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getRefreshedUser()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_6 = _a.sent();
                        // Same as above — getRefreshedUser handles logout on its own.
                        console.error("Failed to refresh when token expired: ", e_6);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.tokenRefreshElector = broadcastChannel.createLeaderElection(tokenRefreshChannel, {
            fallbackInterval: 2000,
            responseTime: 1000,
        });
        this.tokenRefreshElector.awaitLeadership().then(function () {
            console.log("This tab is now leader");
            _this.authenticationState.setIsLeaderTab(true);
            // Proactive removal of event handlers in the event that, somehow, awaitLeadership resolves twice for
            // the same leader (should _never_ happen). This is preventative and is an inexpensive safety measure.
            _this.userManager.events.removeAccessTokenExpiring(expiringHandler);
            _this.userManager.events.removeAccessTokenExpired(expiredHandler);
            _this.userManager.events.addAccessTokenExpiring(expiringHandler);
            _this.userManager.events.addAccessTokenExpired(expiredHandler);
        });
        return this.tokenRefreshElector.hasLeader();
    };
    /**
     * Initializes the UserManager instance.
     * This method retrieves account information, constructs the authority URL, and initializes the UserManager.
     * The only place in the code where user manager instances should be created.
     * Should only be called once per sign in attempt
     */
    OidcAuthenticationService.prototype.initializeUserManager = function () {
        var _this = this;
        this.validateStrategyConfiguration();
        var userManagerSettings = this.authProviderStrategy.getUserManagerSettings();
        this.userManager = new oidcClientTs.UserManager(userManagerSettings);
        this.userManager.events.addUserLoaded(function (user) {
            // Triggered each time tokens refresh as well as on the first token request
            return _this.setTokensInLocalStorage();
        });
        this.userManager.events.addUserSessionChanged(function () {
            console.log("User session changed - reinitializing check session iframe");
        });
        this.userManager.events.addUserSignedOut(function () {
            if (_this.authenticationState.getAuthStatus() ===
                AuthenticationStatus.Authenticated) {
                console.log("User signed out event - logging out");
                _this.logout({ withoutToken: true });
            }
        });
        this.userManager.events.addSilentRenewError(function (error) {
            console.error("[Auth] Silent renew failed:", error);
            if (_this.authenticationState.getAuthStatus() !==
                AuthenticationStatus.Authenticated) {
                return;
            }
            // On mobile, if this is a network error, don't logout — defer to resume handler.
            // The app may be backgrounded with no network; the resume handler will retry.
            var isNetworkError = error instanceof TypeError && error.message === "Failed to fetch";
            if (isMobileDevice() && isNetworkError) {
                console.warn("[Auth] Silent renew failed due to network (mobile) - deferring to resume handler");
                return;
            }
            _this.logout({ withoutToken: true });
        });
    };
    /**
     * Registers local session data and updates the auth state to Authenticated
     * If there's any issues with this process, throws an error after logging
     * Should only be called by the Keycloak implementation, because AIM has
     * additional steps to perform after setting tokens in local storage such as
     * fetching account info from the GRS endpoint and storing it in the
     * AuthenticationState
     * @private
     */
    OidcAuthenticationService.prototype.initializeKeycloakSession = function () {
        return this.setTokensInLocalStorage()
            .then(function () {
            console.log("Tokens successfully set");
        })
            .catch(function (error) {
            console.log("Error while attempting to initialize session:");
            console.error(error);
            throw error;
        });
    };
    /**
     * Clears all authentication session data and resets auth state.
     *
     * This method performs complete session cleanup:
     * 1. Clears provider-specific tokens via strategy (localStorage cleanup)
     * 2. Removes user from UserManager (OIDC client cleanup)
     * 3. Clears stale OIDC state
     * 4. Updates authentication status to NotAuthenticated
     *
     * Technically this could be called before the UserManager is instantiated, so we need to do
     * a check to make sure it's defined
     * If the user is authenticated and is getting logged out, call clearTokensInLocalStorage() instead
     * This should only be called for the mobile app on logout because we don't redirect away from Cordova.
     */
    OidcAuthenticationService.prototype.clearSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.authProviderStrategy.clearTokensInLocalStorage();
                        if (!this.userManager) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.userManager.removeUser().catch(function (error) {
                                console.error("Removing user from userManager failed: " + error);
                            })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.userManager.clearStaleState()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        /**
                         * Clear authentication state of AIM auth info only if we are not
                         * on an ADP url. In the mobile app and on wfs.cloud url deployments,
                         * this allows us to return to the account screen and begin
                         * the auth flow again using a user-entered account. For the adp.com url
                         * auth flow, the AIM info is static so there is no need to remove these
                         * variables on logout.
                         *
                         * Logout flows involving AIM:
                         * 1. After logout on an adp.com url, the Suite will go into a
                         * NotAuthenticated state, and that will trigger the rendering of the
                         * AuthFlowTrigger component. That component will trigger login once again.
                         * 2. After logout on the mobile app, the Suite will return to the same
                         * AuthFlowTrigger component, but since the AIM info has been cleared, the
                         * user will be able to enter new account information.
                         */
                        if (this.authenticationState.isAimProvider && !isSuiteOnAdpUrl()) {
                            console.log("[Auth] clearSession: clearing AIM auth state (non-adp.com URL)");
                            this.authenticationState.clear();
                        }
                        this.authenticationState.updateAuthStatus(AuthenticationStatus.NotAuthenticated);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Removes all OIDC keys from local storage
     * This is used to clear any OIDC keys that may have been set during the login process
     * but are not needed anymore.
     */
    // This is used in the mobile app when the user cancels the login process.
    OidcAuthenticationService.prototype.removeAllOidcKeys = function () {
        Object.keys(localStorage).forEach(function (key) {
            if (key.startsWith("oidc.")) {
                window.localStorage.removeItem(key);
            }
        });
    };
    return OidcAuthenticationService;
}());

var GATEWAY_URLS = {
    US_DIT: "https://iad-dit.api.us.wfs.cloud",
    US_FIT: "https://iad-fit.api.us.wfs.cloud",
    US_UAT: "https://api-uat.us.wfs.adp.com",
    US_PROD: "https://api.us.wfs.adp.com",
    EU_STAGE: "https://fra-uat.api.eu.wfs.cloud",
    EU_PROD: "https://api.eu.wfs.cloud",
};
var GATEWAY_URL_MAP = {
    na: {
        dit: GATEWAY_URLS.US_DIT,
        fit: GATEWAY_URLS.US_FIT,
        iat: GATEWAY_URLS.US_FIT,
        uat: GATEWAY_URLS.US_UAT,
        prod: GATEWAY_URLS.US_PROD,
    },
    emea: {
        dev: GATEWAY_URLS.US_DIT,
        staging: GATEWAY_URLS.EU_STAGE,
        prod: GATEWAY_URLS.EU_PROD,
    },
};

/**
 * Normalize provider-specific decoded token shapes into OidcUserInfo.
 * Pass provider ('keycloak' | 'aim') so extractors are explicit and removable.
 */
var TokenAdapter = /** @class */ (function () {
    function TokenAdapter(decodedToken, provider) {
        if (provider === void 0) { provider = AuthProvider.Keycloak; }
        this.extractors = {
            keycloak: function (parsedTokenData) { return ({
                preferred_username: parsedTokenData.preferred_username,
                given_name: parsedTokenData.given_name,
                family_name: parsedTokenData.family_name,
                name: parsedTokenData.name,
                account_internal_id: parsedTokenData.account_internal_id,
                wfs_id: parsedTokenData.wfs_id,
                email: parsedTokenData.email,
                impersonator: parsedTokenData.impersonator,
            }); },
            aim: function (parsedTokenData) {
                var _a;
                var customClaims = ((_a = parsedTokenData.token_details) === null || _a === void 0 ? void 0 : _a.custom_claim) || {};
                var givenName = customClaims.given_name;
                var familyName = customClaims.family_name;
                return {
                    preferred_username: customClaims.preferred_username,
                    given_name: givenName,
                    family_name: familyName,
                    name: ((givenName || "") +
                        (givenName && familyName ? " " : "") +
                        (familyName || "")).trim(),
                    account_internal_id: customClaims.ooid,
                    wfs_id: customClaims.aoid,
                };
            },
        };
        if (typeof decodedToken === "string") {
            if (!decodedToken) {
                throw new Error("TokenAdapter requires a non-empty decoded token string");
            }
            this.decodedToken = decodedToken;
        }
        else {
            this.decodedToken = JSON.stringify(decodedToken);
        }
        this.provider = provider;
    }
    /**
     * Parse the decoded token and return normalized OIDCUserInfo.
     * Returns undefined if no token supplied; throws on invalid JSON.
     */
    TokenAdapter.prototype.parseUserInfoFromJson = function () {
        var _a, _b;
        if (!this.decodedToken) {
            console.warn("TokenAdapter.parse called without decodedToken");
            return undefined;
        }
        var parsedToken;
        try {
            parsedToken = JSON.parse(this.decodedToken);
        }
        catch (err) {
            console.error("TokenAdapter: failed to parse decoded token:", err);
            return undefined;
        }
        var extractor = this.extractors[this.provider] || this.extractors.keycloak;
        var normalized = extractor(parsedToken);
        return {
            preferred_username: normalized.preferred_username || "",
            given_name: normalized.given_name || "",
            family_name: normalized.family_name || "",
            name: normalized.name || "",
            account_internal_id: normalized.account_internal_id || "",
            wfs_id: normalized.wfs_id || "",
            email: (_a = normalized.email) !== null && _a !== void 0 ? _a : null,
            impersonator: (_b = normalized.impersonator) !== null && _b !== void 0 ? _b : undefined,
        };
    };
    return TokenAdapter;
}());

/**
 * Custom event name dispatched when SM session is invalid and logout is required.
 * OidcAuthenticationService listens for this event to trigger logout.
 */
var SM_SESSION_INVALID_EVENT = "sm-session-invalid";
/**
 * AimSMSessionRefresher
 *
 * Periodically calls the SM session refresh endpoint to keep the SMSESSION alive
 * while the browser tab is visible. Provides start/stop lifecycle,
 * a single-run API, and guards to prevent concurrent requests.
 */
var AimSMSessionRefresher = /** @class */ (function () {
    /**
     * Create a new AimSMSessionRefresher.
     */
    function AimSMSessionRefresher() {
        this.isRunning = false;
        this.endpoint = AuthenticationState.getInstance().aimSmSessionUrl;
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
        this.handleWindowBlur = this.handleWindowBlur.bind(this);
        this.runOnce = this.runOnce.bind(this);
    }
    /**
     * Start periodic refreshing.
     * - Attaches visibility/blur listeners.
     * - Executes an immediate refresh (no-op when tab not visible).
     * - Schedules recurring refreshes at DEFAULT_INTERVAL_MS.
     *
     * Safe to call multiple times (idempotent).
     */
    AimSMSessionRefresher.prototype.start = function () {
        if (typeof window === "undefined" || typeof document === "undefined")
            return;
        window.addEventListener("visibilitychange", this.handleVisibilityChange);
        window.addEventListener("blur", this.handleWindowBlur);
        this.runOnce();
        this.ensureInterval();
    };
    /**
     * Stop periodic refreshing and remove attached listeners.
     */
    AimSMSessionRefresher.prototype.stop = function () {
        if (typeof window === "undefined" || typeof document === "undefined")
            return;
        this.clearInterval();
        window.removeEventListener("visibilitychange", this.handleVisibilityChange);
        window.removeEventListener("blur", this.handleWindowBlur);
    };
    /**
     * Perform a single SM session refresh call.
     * - No-op if the document is not visible.
     * - Prevents concurrent executions via isRunning guard.
     * - Throws on network/request errors so callers can observe failures.
     *
     * @returns The parsed response payload on success.
     */
    AimSMSessionRefresher.prototype.runOnce = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_1, status_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        if (typeof document !== "undefined" &&
                            document.visibilityState !== "visible") {
                            return [2 /*return*/];
                        }
                        if (this.isRunning)
                            return [2 /*return*/];
                        this.isRunning = true;
                        console.log("Testing SM Session Refresh API with axios...");
                        if (!this.endpoint) {
                            console.error("SM Session Refresh API endpoint is not defined");
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, axios__default.default.get(this.endpoint, {
                                withCredentials: true,
                                headers: {
                                    Accept: "application/json",
                                },
                                timeout: AimSMSessionRefresher.DEFAULT_TIMEOUT_MS,
                            })];
                    case 1:
                        response = _a.sent();
                        console.log("SM Session Refresh Success:" + JSON.stringify(response));
                        return [2 /*return*/];
                    case 2:
                        error_1 = _a.sent();
                        // Handle 4xx responses: trigger logout via event
                        if (axios__default.default.isAxiosError(error_1) && error_1.response) {
                            status_1 = error_1.response.status;
                            if (status_1 >= 400 && status_1 < 500) {
                                console.error("SM Session Refresh received " + status_1 + " response - triggering logout");
                                // Stop the interval to prevent further refresh attempts during logout
                                this.stop();
                                // Dispatch event for OidcAuthenticationService to handle logout
                                this.dispatchSessionInvalidEvent();
                                return [2 /*return*/];
                            }
                        }
                        console.error("SM Session Refresh Error:");
                        console.error(error_1);
                        return [3 /*break*/, 4];
                    case 3:
                        this.isRunning = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Ensure the periodic interval is scheduled.
     * Creates a setInterval that calls runOnce at intervalMs.
     */
    AimSMSessionRefresher.prototype.ensureInterval = function () {
        var _this = this;
        if (this.intervalId != null)
            return;
        this.intervalId = window.setInterval(function () {
            _this.runOnce();
        }, AimSMSessionRefresher.DEFAULT_INTERVAL_MS);
    };
    /**
     * Clear the scheduled periodic interval if present.
     */
    AimSMSessionRefresher.prototype.clearInterval = function () {
        if (this.intervalId != null) {
            clearInterval(this.intervalId);
            this.intervalId = undefined;
        }
    };
    /**
     * Visibility change handler:
     * - When visible, perform an immediate refresh and ensure interval is running.
     * - When hidden, stop the periodic interval.
     */
    AimSMSessionRefresher.prototype.handleVisibilityChange = function () {
        if (document.visibilityState === "visible") {
            this.runOnce();
            this.ensureInterval();
        }
        else {
            this.clearInterval();
        }
    };
    /**
     * Blur handler: stop periodic polling to avoid background activity.
     */
    AimSMSessionRefresher.prototype.handleWindowBlur = function () {
        this.clearInterval();
    };
    /**
     * Dispatches a custom event when session is invalid.
     * OidcAuthenticationService listens for this event to trigger logout.
     */
    AimSMSessionRefresher.prototype.dispatchSessionInvalidEvent = function () {
        if (typeof window !== "undefined") {
            window.dispatchEvent(new CustomEvent(SM_SESSION_INVALID_EVENT));
        }
    };
    AimSMSessionRefresher.DEFAULT_INTERVAL_MS = 60000;
    AimSMSessionRefresher.DEFAULT_TIMEOUT_MS = 10000;
    return AimSMSessionRefresher;
}());

/**
 * Authentication provider strategy for ADP Identity Management (AIM) integration.
 *
 * This strategy implements the AuthProviderStrategy interface specifically for AIM-based
 * authentication systems. AIM is ADP's identity provider that supports PKCE OAuth2 and OIDC
 * protocol with enhanced security features.
 *
 * Key features of AIM authentication:
 * - Dynamic client ID configuration per account
 * - No session state required
 * - Dedicated token storage keys separate from Keycloak
 * - Enhanced security validation and error handling
 *
 * @implements {AuthProviderStrategy}
 * @see {@link AuthProviderStrategy} For the strategy interface contract
 */
var AimAuthProviderStrategy = /** @class */ (function () {
    function AimAuthProviderStrategy() {
        /**
         * Shared authentication state instance containing AIM configuration.
         */
        this.authenticationState = AuthenticationState.getInstance();
    }
    /**
     * Gets the OIDC client settings for AIM authentication.
     *
     * AIM-specific configuration includes:
     * - Dynamic client ID from authentication state (not hardcoded)
     * - Empty `refreshTokenAllowedScope` as per AIM requirements
     * - AIM authority URL from gateway response
     *
     * @returns {OidcClientSettings} AIM-specific OIDC client configuration
     */
    AimAuthProviderStrategy.prototype.getOidcClientSettings = function () {
        return {
            authority: this.authenticationState.authUrl,
            client_id: this.authenticationState.aimClientId,
            redirect_uri: isMobileDevice()
                ? INVALID_LOCALHOST_URL
                : getRedirectUrlForAim(),
            refreshTokenAllowedScope: "",
        };
    };
    /**
     * Gets the complete UserManager settings for AIM authentication.
     *
     * Extends the basic OIDC settings with AIM-specific UserManager configuration.
     *
     * @returns {UserManagerSettings} Complete UserManager configuration with:
     *   - All settings from `getOidcClientSettings()`
     *   - `automaticSilentRenew`: false (AIM tokens have longer lifetimes)
     *   - `userStore`: localStorage-based storage for state persistence
     *   - `accessTokenExpiringNotificationTimeInSeconds`: Warning time before token expires
     */
    AimAuthProviderStrategy.prototype.getUserManagerSettings = function () {
        return __assign(__assign({}, this.getOidcClientSettings()), { automaticSilentRenew: false, silent_redirect_uri: window.location.origin + "/silent-sign-in-callback.html", userStore: new oidcClientTs.WebStorageStateStore({ store: window.localStorage }), accessTokenExpiringNotificationTimeInSeconds: TOKEN_REFRESH_BUFFER_SECONDS });
    };
    /**
     * Returns options for silent sign-in specific to AIM.
     *
     * GSO wants us to use iframe-based silent authentication,
     * so `forceIframeAuth` is set to `true`. The default, false,
     * is to use a refresh token.
     */
    AimAuthProviderStrategy.prototype.getSigninSilentOptions = function () {
        return { forceIframeAuth: true };
    };
    /**
     * Validates the current AIM authentication configuration.
     *
     * Performs comprehensive validation of AIM-specific configuration to ensure
     * all required values are present to initialize the UserManager.
     *
     * AIM-specific validation includes:
     * - Authority URL presence and format
     * - AIM client ID presence (must not be empty or 'lighthouse')
     *
     * @throws {Error} When configuration is invalid:
     *   - "Auth flow cannot be initialized without authority url" - missing authUrl
     *   - "Auth flow cannot be initialized without client ID" - missing or invalid aimClientId
     *
     */
    AimAuthProviderStrategy.prototype.validateConfiguration = function () {
        if (!this.authenticationState.authUrl) {
            throw new Error("Auth flow cannot be initialized without authority url");
        }
        var clientId = this.authenticationState.aimClientId;
        if (!clientId || clientId === KEYCLOAK_CLIENT_ID) {
            throw new Error("Auth flow cannot be initialized without valid AIM client ID. Current value: " +
                clientId);
        }
    };
    /**
     * Stores AIM authentication tokens in local storage.
     * Start SM refresher to keep session active while tab is open and tokens are valid
     *
     * Extracts and stores access tokens from the OIDC User object
     * using AIM-specific localStorage keys.
     *
     * @param {User} user - OIDC User object from successful authentication containing:
     *   - `access_token`: OAuth2 access token (always present)
     *   - `id_token`: OIDC identity token (present but not stored separately)
     *
     * @returns {Promise<void>} Promise that resolves when tokens are successfully stored, otherwise rejected promise
     * will be returned
     *
     * @throws {Error} When localStorage operations fail:
     *  - Storage quota exceeded, security restrictions, or other browser limitations
     */
    AimAuthProviderStrategy.prototype.setTokensInLocalStorage = function (user) {
        try {
            window.localStorage.setItem(AIM_ACCESS_TOKEN_LOCAL_STORAGE_KEY, user.access_token);
            if (user.id_token) {
                window.localStorage.setItem(AIM_IDENTITY_TOKEN_LOCAL_STORAGE_KEY, user.id_token);
            }
            this.startSmRefresherIfNeeded();
            return Promise.resolve();
        }
        catch (error) {
            console.error("Failed to store AIM tokens in localStorage:", error);
            return Promise.reject(new Error("Token storage failed: " + error.message));
        }
    };
    /**
     * Removes all AIM authentication tokens from browser local storage.
     *
     * Cleans up AIM-specific authentication data from localStorage, effectively
     * terminating the local user session. This method is called during:
     * - User-initiated logout from AIM
     * - Token validation failures
     * - Authentication errors requiring fresh login
     * - Stop SM refresher when user logs out or tokens are cleared
     *
     * Removes the following localStorage items:
     * - AIM access token
     * - AIM identity token
     *
     * @returns {void} No return value. Method is synchronous and fault-tolerant.
     *   If localStorage is unavailable or tokens don't exist, the method completes
     *   without error.
     *
     */
    AimAuthProviderStrategy.prototype.clearTokensInLocalStorage = function () {
        try {
            window.localStorage.removeItem(AIM_ACCESS_TOKEN_LOCAL_STORAGE_KEY);
            window.localStorage.removeItem(AIM_IDENTITY_TOKEN_LOCAL_STORAGE_KEY);
            this.stopSmRefresherIfNeeded();
        }
        catch (error) {
            console.error("An error occurred while clearing tokens from localStorage:", error);
        }
    };
    /**
     * Decode and normalize the stored AIM access token.
     *
     * Uses jwtDecode to decode the stored access token, then adapts the decoded payload
     * into the application's OidcUserInfo shape using TokenAdapter.
     *
     * @returns {OidcUserInfo | undefined} normalized token claims or undefined when no token exists
     */
    AimAuthProviderStrategy.prototype.getOidcUserInfo = function () {
        var token = window.localStorage.getItem(AIM_ACCESS_TOKEN_LOCAL_STORAGE_KEY);
        if (!token) {
            console.log("Access token is not found in local storage");
            return undefined;
        }
        try {
            if (typeof token !== "string" || token.split(".").length !== 3) {
                console.warn("AIM token has unexpected format");
                return undefined;
            }
            var decodedPayload = jwtDecode.jwtDecode(token);
            var adapter = new TokenAdapter(decodedPayload, AuthProvider.AIM);
            return adapter.parseUserInfoFromJson();
        }
        catch (err) {
            console.error("Failed to decode or parse AIM access token:", err);
            return undefined;
        }
    };
    /**
     * Performs logout for AIM:
     * - if WTA feature flag is enabled and not skipped, it performs T&A logout
     * - if DS feature flag is enabled and not skipped, it performs DS logout
     * - it performs ADP logout to revoke token from server and delete cookie from browser
     * - call callback method to clear tokens from local storage and update status to Not authenticated
     *
     * This method is async to allow the performWTALogout and performDSLogout to complete, but failures
     * during those calls are non-fatal and are only logged.
     *
     * @param clearSession - Callback to clear session data
     * @param options - Optional logout options to control which systems to logout from
     * @returns {Promise<void>}
     */
    AimAuthProviderStrategy.prototype.logout = function (clearSession, options) {
        return __awaiter(this, void 0, void 0, function () {
            var isWTAEnabled, isDemandSchedulingEnabled, err_1, err_2;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        isWTAEnabled = false;
                        isDemandSchedulingEnabled = false;
                        try {
                            (_a = getFrameworkInstance().getNamedFeatureFlags(exports.FeatureFlagKey.WTA, exports.FeatureFlagKey.DemandScheduling), _b = exports.FeatureFlagKey.WTA, isWTAEnabled = _a[_b], _c = exports.FeatureFlagKey.DemandScheduling, isDemandSchedulingEnabled = _a[_c]);
                        }
                        catch (err) {
                            console.warn("Feature flags unavailable:", err);
                        }
                        if (!(isWTAEnabled && !(options === null || options === void 0 ? void 0 : options.skipWTALogout))) return [3 /*break*/, 4];
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.performWTALogout()];
                    case 2:
                        _d.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _d.sent();
                        console.warn("WTA logout attempt failed during AIM logout:", err_1);
                        return [3 /*break*/, 4];
                    case 4:
                        if (!(isDemandSchedulingEnabled && !(options === null || options === void 0 ? void 0 : options.skipDSLogout))) return [3 /*break*/, 8];
                        _d.label = 5;
                    case 5:
                        _d.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this.performDSLogout()];
                    case 6:
                        _d.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        err_2 = _d.sent();
                        console.warn("DS logout attempt failed during AIM logout:", err_2);
                        return [3 /*break*/, 8];
                    case 8: return [4 /*yield*/, this.performADPLogout()];
                    case 9:
                        _d.sent();
                        clearSession();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Logs the user out of the ADP (AIM) system by POSTing an application/x-www-form-urlencoded
     * logout request to the configured AIM logout endpoint.
     *
     * Notes and requirements:
     * - Uses fetch with `redirect: 'manual'` to avoid automatic navigation in the browser.
     * - Cookies are sent using `credentials: 'include'`.
     *
     * @returns Promise<void>
     */
    AimAuthProviderStrategy.prototype.performADPLogout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var logoutURL, accessToken, clientId, userInfo, transId, formData, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logoutURL = this.authenticationState.aimLogoutUrl;
                        if (!logoutURL) {
                            console.warn("Logout URL missing: skipping ADP logout");
                            return [2 /*return*/];
                        }
                        accessToken = window.localStorage.getItem(AIM_ACCESS_TOKEN_LOCAL_STORAGE_KEY);
                        if (!accessToken) {
                            console.warn("Access token missing: skipping ADP logout");
                            return [2 /*return*/];
                        }
                        clientId = this.authenticationState.aimClientId;
                        if (!clientId) {
                            console.warn("Client ID missing: skipping ADP logout");
                            return [2 /*return*/];
                        }
                        userInfo = this.getOidcUserInfo();
                        transId = [
                            (userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username) && "username:" + userInfo.preferred_username,
                            (userInfo === null || userInfo === void 0 ? void 0 : userInfo.wfs_id) && "aoid:" + userInfo.wfs_id,
                            (userInfo === null || userInfo === void 0 ? void 0 : userInfo.account_internal_id) && "ooid:" + userInfo.account_internal_id,
                        ]
                            .filter(Boolean)
                            .join(", ");
                        formData = new URLSearchParams(__assign(__assign({ token_type_hint: "access_token", post_logout_redirect_uri: isMobileDevice()
                                ? "https://wfs.na.adp.com"
                                : window.location.origin }, (transId && { trans_id: transId })), { client_id: clientId, token: accessToken }));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetch(logoutURL, {
                                method: "POST",
                                body: formData.toString(),
                                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                                credentials: "include",
                                redirect: "manual",
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error("Error while logging out from ADP:", error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Attempts to log the user out of the T&A (WTA) system.
     *
     * - If account information is missing, this is a no-op and a warning is logged.
     * - Makes an HTTP GET request to the T&A Logoff endpoint and logs non-OK responses.
     * - Errors during the call are caught and logged, they do not interrupt the overall logout flow.
     *
     * @returns {Promise<void>}
     */
    AimAuthProviderStrategy.prototype.performWTALogout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var accountInfo, baseUrl, logoffEndpoint, taLogoutUrl, response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        accountInfo = this.authenticationState.getAccountInfo();
                        if (!accountInfo) {
                            console.warn("AccountInfo missing: skipping T&A logout");
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        baseUrl = getWTABaseUrl(accountInfo.accountData);
                        logoffEndpoint = "Logoff.do";
                        taLogoutUrl = baseUrl + logoffEndpoint;
                        return [4 /*yield*/, fetch(taLogoutUrl, {
                                method: "GET",
                                credentials: "include",
                            })];
                    case 2:
                        response = _a.sent();
                        if (!response.ok) {
                            console.warn("T&A logout call returned " + response.status + " " + response.statusText);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        console.warn("T&A logout call failed :", error_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Attempts to log the user out of the Demand Scheduling (DS) system.
     *
     * - If account information is missing, this is a no-op and a warning is logged.
     * - Makes an HTTP GET request to the DS logout endpoint and logs non-OK responses.
     * - Errors during the call are caught and logged, they do not interrupt the overall logout flow.
     *
     * @returns {Promise<void>}
     */
    AimAuthProviderStrategy.prototype.performDSLogout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var accountInfo, baseUrl, signoutEndpoint, dsLogoutUrl, response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        accountInfo = this.authenticationState.getAccountInfo();
                        if (!accountInfo) {
                            console.warn("AccountInfo missing: skipping DS logout");
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        baseUrl = getDemandSchedulingBaseUrl(accountInfo.accountData);
                        signoutEndpoint = "/signout/";
                        dsLogoutUrl = baseUrl + signoutEndpoint;
                        return [4 /*yield*/, fetch(dsLogoutUrl, {
                                method: "GET",
                                credentials: "include",
                            })];
                    case 2:
                        response = _a.sent();
                        if (!response.ok) {
                            console.warn("DS logout call returned " + response.status + " " + response.statusText);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        console.warn("DS logout call failed :", error_3);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Ensure an AimSMSessionRefresher instance exists.
     *
     * This method will create the refresher only once.
     * The refresher is not started here — callers should call startSmRefresherIfNeeded
     * when they want polling to begin.
     */
    AimAuthProviderStrategy.prototype.ensureSmRefresher = function () {
        if (!this.smRefresher) {
            this.smRefresher = new AimSMSessionRefresher();
        }
    };
    /**
     * Start the SM session refresher if it is not already running.
     *
     * Safe to call multiple times. The refresher internally guards against
     * duplicate intervals and will only perform polling while the tab is visible
     * and focused.
     */
    AimAuthProviderStrategy.prototype.startSmRefresherIfNeeded = function () {
        this.ensureSmRefresher();
        this.smRefresher.start();
    };
    /**
     * Stop the SM session refresher if it exists.
     *
     * Used during logout or when AIM tokens are cleared to stop background
     * polling and release associated event listeners/timers.
     */
    AimAuthProviderStrategy.prototype.stopSmRefresherIfNeeded = function () {
        if (this.smRefresher) {
            this.smRefresher.stop();
        }
    };
    /**
     * Registers an event listener for session invalid events from AimSMSessionRefresher.
     * When the SM session is detected as invalid (e.g., 4xx response or non-success status),
     * the provided callback is invoked to trigger logout.
     * @param logoutCallback - Callback function to invoke when session is invalid
     */
    AimAuthProviderStrategy.prototype.listenForSessionInvalidEvent = function (logoutCallback) {
        if (typeof window !== "undefined") {
            window.addEventListener(SM_SESSION_INVALID_EVENT, function () {
                console.log("SM session invalid event received - triggering logout");
                logoutCallback();
            });
        }
    };
    return AimAuthProviderStrategy;
}());

/**
 * Authentication provider strategy for Keycloak/CAS integration.
 *
 * This strategy implements the AuthProviderStrategy interface for Keycloak-based
 * authentication systems. It handles Keycloak-specific configuration including:
 * - Realm-based authority URL construction if AuthenticationState does not have it
 * - Session state management
 * - CAS identity token parsing
 * - Keycloak-specific token storage
 *
 * @implements {AuthProviderStrategy}
 */
var KeycloakAuthProviderStrategy = /** @class */ (function () {
    function KeycloakAuthProviderStrategy() {
        /**
         * Shared authentication state instance.
         */
        this.authenticationState = AuthenticationState.getInstance();
    }
    /**
     * Gets the OIDC client settings for Keycloak authentication.
     *
     * Configures the OIDC client for Keycloak with realm-based authority URL,
     * standard lighthouse client ID, and appropriate redirect URIs for web and mobile.
     * @throws {Error} When authUrl is not set in authentication state
     */
    KeycloakAuthProviderStrategy.prototype.getOidcClientSettings = function () {
        var isBrowserBasedSSOLoginEnabled = this.authenticationState
            .useBrowserBasedSSO;
        var mobileRedirectUri = isBrowserBasedSSOLoginEnabled
            ? SSO_BROWSER_LOGIN_SCHEME
            : INVALID_LOCALHOST_URL;
        return {
            authority: this.authenticationState.authUrl,
            client_id: KEYCLOAK_CLIENT_ID,
            redirect_uri: isMobileDevice()
                ? mobileRedirectUri
                : getRedirectUrlForKeycloak(),
        };
    };
    /**
     * Gets the complete UserManager settings for Keycloak authentication.
     *
     * Extends the basic OIDC settings with Keycloak-specific UserManager configuration
     * including session monitoring, and localStorage-based state storage.
     */
    KeycloakAuthProviderStrategy.prototype.getUserManagerSettings = function () {
        return __assign(__assign({}, this.getOidcClientSettings()), { automaticSilentRenew: isMobileDevice(), userStore: new oidcClientTs.WebStorageStateStore({ store: window.localStorage }), accessTokenExpiringNotificationTimeInSeconds: TOKEN_REFRESH_BUFFER_SECONDS, checkSessionIntervalInSeconds: 5 });
    };
    /**
     * Returns options for silent sign-in specific to Keycloak.
     *
     * Keycloak supports refresh-token-based silent renewal, so no special options
     * are required.
     */
    KeycloakAuthProviderStrategy.prototype.getSigninSilentOptions = function () {
        return {};
    };
    /**
     * Validates the current Keycloak authentication configuration.
     *
     * Performs comprehensive validation of Keycloak-specific configuration.
     * If the authority URL is missing, attempts to construct it from account data
     * using the realm-based approach: `{baseUrl}/auth/realms/{externalId}`.
     *
     * @returns {void}
     * @throws {Error} When configuration is invalid:
     *   - "Keycloak authentication flow cannot be initialized without account data" - missing account data
     *   - "Account external ID is required for realm construction" - missing external ID for realm
     *
     */
    KeycloakAuthProviderStrategy.prototype.validateConfiguration = function () {
        if (!this.authenticationState.authUrl) {
            throw new Error("Auth flow cannot be initialized without authority url");
        }
    };
    /**
     * Stores authentication tokens in local storage for Keycloak sessions.
     *
     * Extracts and stores all tokens and session information from the OIDC User object
     * into localStorage using standardized keys. For Keycloak, this includes:
     * - Access token for API authorization
     * - ID token containing user identity claims
     * - Refresh token for token renewal (if available)
     * - Session state for session monitoring
     * - Parsed ID token claims for easy access
     *
     * Also emits a parsed token change event for backward compatibility
     * with existing CAS-based authentication flows.
     *
     * @param {User} user - OIDC User object from successful authentication containing:
     *   - `access_token`: OAuth2 access token
     *   - `id_token`: OIDC identity token with user claims
     *   - `refresh_token`: Token for renewing access (required for Keycloak)
     *   - `session_state`: Keycloak session identifier (required)
     *   - `profile`: Parsed ID token claims
     *
     * @returns {Promise<void>} Promise that resolves when all tokens are stored successfully
     *
     * @throws {Error} When required tokens or session state are missing:
     *   - "Unable to find tokens" - when id_token or refresh_token are missing
     *   - "Unable to find session state" - when session_state is missing
     */
    KeycloakAuthProviderStrategy.prototype.setTokensInLocalStorage = function (user) {
        if (!user.id_token || !user.refresh_token) {
            return Promise.reject(new Error("Unable to find tokens"));
        }
        if (!user.session_state) {
            return Promise.reject(new Error("Unable to find session state"));
        }
        try {
            // Store tokens
            window.localStorage.setItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY, user.access_token);
            window.localStorage.setItem(ID_TOKEN_LOCAL_STORAGE_KEY, user.id_token);
            window.localStorage.setItem(REFRESH_TOKEN_LOCAL_STORAGE_KEY, user.refresh_token);
            window.localStorage.setItem(SESSION_ID_STORAGE_KEY, user.session_state);
            // Store parsed claims for easy access
            window.localStorage.setItem(ID_TOKEN_CLAIMS_STORAGE_KEY, JSON.stringify(user.profile));
            // Emit change event
            this.authenticationState.emitOidcUserInfoChanged(this.getOidcUserInfo());
            return Promise.resolve();
        }
        catch (error) {
            console.error("Error storing tokens in localStorage:", error);
            return Promise.reject(new Error("Failed to store authentication tokens"));
        }
    };
    /**
     * Clears the access, refresh, and identity tokens in local storage. Also clears the session ID.
     * Should only be called in 2 cases:
     * 1. When clearSession is called at any point to redirect the user to login screen
     * 2. When doing a logout, tokens should be cleared before redirecting
     */
    KeycloakAuthProviderStrategy.prototype.clearTokensInLocalStorage = function () {
        try {
            window.localStorage.removeItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY);
            window.localStorage.removeItem(ID_TOKEN_LOCAL_STORAGE_KEY);
            window.localStorage.removeItem(REFRESH_TOKEN_LOCAL_STORAGE_KEY);
            window.localStorage.removeItem(SESSION_ID_STORAGE_KEY);
            window.localStorage.removeItem(ID_TOKEN_CLAIMS_STORAGE_KEY);
        }
        catch (error) {
            console.error("An error occurred while clearing tokens from localStorage:", error);
        }
    };
    /**
     * getSignInRedirectUri
     *
     * Build a Keycloak-specific redirect URI that.
     * This URI is used as the `redirect_uri` parameter when initiating a web OIDC sign-in
     * so the application can restore navigation after authentication completes.
     *
     * @param {string} redirectBackRoute - in-app route to return to after authentication (e.g. "../performance/...")
     * @returns {string} fully-qualified redirect URI to pass to the OIDC authorization endpoint
     */
    KeycloakAuthProviderStrategy.prototype.getSignInRedirectUri = function (redirectBackRoute) {
        return getRedirectUrlForKeycloak(redirectBackRoute);
    };
    /**
     * Decode and normalize the stored Keycloak ID token claims.
     *
     * Reads the parsed ID token claims from localStorage (ID_TOKEN_CLAIMS_STORAGE_KEY),
     * parses the JSON, and adapts the payload into the application's OidcUserInfo shape
     * using TokenAdapter with the 'keycloak' provider extractor.
     *
     * @returns {OidcUserInfo | undefined} Normalized token claims, or undefined if no claims are found or parsing fails.
     */
    KeycloakAuthProviderStrategy.prototype.getOidcUserInfo = function () {
        var idTokenClaims = window.localStorage.getItem(ID_TOKEN_CLAIMS_STORAGE_KEY);
        if (!idTokenClaims) {
            console.warn("Identity token is not found in local storage");
            return undefined;
        }
        try {
            var adapter = new TokenAdapter(idTokenClaims, AuthProvider.Keycloak);
            return adapter.parseUserInfoFromJson();
        }
        catch (err) {
            console.error("Failed to parse stored ID token claims:", err);
            return undefined;
        }
    };
    /**
     * Perform logout flow for Keycloak/CAS.
     *
     * Behavior:
     * - Attempts to read account and session information from AuthenticationState/localStorage.
     * - Clears local tokens immediately.
     * - If impersonation is active, clears the impersonation flag and returns without redirecting to CAS.
     * - If account and session information are available, constructs a CAS-augmented logout URL
     *   and redirects to it. The clearSession callback is invoked after redirect completes.
     *
     *
     * @param clearSession - callback to clear local session state
     * @param options - Optional logout options (uses withoutToken flag)
     * @returns {Promise<void>} resolves after local cleanup or after attempting redirect
     */
    KeycloakAuthProviderStrategy.prototype.logout = function (clearSession, options) {
        return __awaiter(this, void 0, void 0, function () {
            var accountInfo, accessToken, sessionState;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        accountInfo = this.authenticationState.getAccountInfo();
                        if (!accountInfo) {
                            console.log("WARNING: Unable to logout properly due to missing account info");
                            return [2 /*return*/];
                        }
                        accessToken = (options === null || options === void 0 ? void 0 : options.withoutToken) ? undefined
                            : window.localStorage.getItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY) ||
                                undefined;
                        sessionState = window.localStorage.getItem(SESSION_ID_STORAGE_KEY);
                        this.clearTokensInLocalStorage();
                        // Avoids a race condition where the CAS iframe initiates a logout if the logout
                        // procedure triggered by impersonation takes too long.
                        // If logout takes too long, the CAS iframe will trigger a *second* logout which has
                        // the potential to cancel impersonation.
                        // Note that this will be false when the Suite loads again after returning from the
                        // impersonate call and that is expected.
                        // When it loads again, impersonate=true will be set in the query params,
                        // which we will also be able to detect in the next conditional block.
                        if (this.authenticationState.getImpersonating()) {
                            // Here we set impersonating to false in order to help avoid getting trapped in a state where
                            // we can never properly log out. This would probably only be relevant on the mobile app
                            // where the Suite might stay open and never fully refresh.
                            // Note that onAuthLogout() will never be triggered twice by CAS before CAS is able
                            // to authenticate again, so it's safe to set this to false here.
                            this.authenticationState.setImpersonating(false);
                            return [2 /*return*/];
                        }
                        if (!sessionState) {
                            console.debug("Skipping CAS logout: sessionState is missing");
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, redirectToCasUrl(getCasAugmentedLogoutUrl(
                            // accountInfo must exist for us to be authenticated in logout
                            this.authenticationState.getAccountInfo().accountData, sessionState, accessToken), function () {
                                // this code should only be executed on the native mobile app, as it's a handler for
                                // after CAS redirects us back to the main screen.
                                clearSession && clearSession();
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return KeycloakAuthProviderStrategy;
}());

/**
 * Factory class for creating authentication provider strategy instances.
 *
 * This factory implements the Strategy pattern to dynamically create the appropriate
 * authentication provider strategy based on the current authentication state configuration.
 * It determines whether to use AIM (ADP Identity Management) or Keycloak authentication
 * based on the provider type configured in the authentication state.
 *
 * The factory pattern provides several benefits:
 * - **Dynamic strategy selection**: Creates the correct provider based on runtime configuration
 * - **Centralized provider logic**: Single point for provider selection decisions
 * - **Type safety**: Returns properly typed AuthProviderStrategy instances
 *
 * Provider selection is based on the `isAimProvider` flag in AuthenticationState,
 * which is typically set during account initialization based on gateway responses
 *
 */
var AuthProviderStrategyFactory = /** @class */ (function () {
    function AuthProviderStrategyFactory() {
    }
    /**
     * Creates an authentication provider strategy instance.
     *
     * Analyzes the current authentication state to determine which authentication
     * provider strategy to instantiate. The selection is based on the `isAimProvider`
     * flag in the AuthenticationState singleton.
     *
     * **Provider Selection Logic:**
     * 1. Get AuthenticationState singleton instance
     * 2. Check `authState.isAimProvider` flag
     * 3. Create appropriate strategy (AIM or Keycloak)
     * 4. Return strategy instance (validation occurs during construction)
     *
     * @returns {AuthProviderStrategy} Authentication provider strategy instance.
     *   Returns either AimAuthProviderStrategy or KeycloakAuthProviderStrategy.
     *
     * @static
     * @see {@link AuthenticationState.isAimProvider} For provider selection flag
     * @see {@link AimAuthProviderStrategy} For AIM-specific implementation
     * @see {@link KeycloakAuthProviderStrategy} For Keycloak-specific implementation
     */
    AuthProviderStrategyFactory.create = function () {
        var authState = AuthenticationState.getInstance();
        if (authState.isAimProvider) {
            return new AimAuthProviderStrategy();
        }
        return new KeycloakAuthProviderStrategy();
    };
    return AuthProviderStrategyFactory;
}());

var RedirectActions;
(function (RedirectActions) {
    RedirectActions["SetRedirectBackRoute"] = "SetRedirectBackRoute";
    RedirectActions["ClearRedirectBackRoute"] = "ClearRedirectBackRoute";
})(RedirectActions || (RedirectActions = {}));

function setRedirectBackRoute(redirectBackRoute) {
    return {
        type: RedirectActions.SetRedirectBackRoute,
        redirectBackRoute: redirectBackRoute,
    };
}
function clearRedirectBackRoute() {
    return {
        type: RedirectActions.ClearRedirectBackRoute,
    };
}

var initialState$g = {
    redirectBackRoute: undefined,
};
var reducer$g = function (state, action) {
    if (state === void 0) { state = initialState$g; }
    switch (action.type) {
        case RedirectActions.SetRedirectBackRoute:
            return action.redirectBackRoute !== "/"
                ? __assign(__assign({}, state), { redirectBackRoute: action.redirectBackRoute }) : state;
        case RedirectActions.ClearRedirectBackRoute:
            return __assign(__assign({}, state), { redirectBackRoute: undefined });
        default:
            return state;
    }
};

/**
 * Selector to get the redirectBackRoute from the application state.
 */
var selectRedirectBackRoute = function (state) {
    return state.redirect.redirectBackRoute;
};

/**
 * Returns the url path as a route, preferring hash-based routing if present.
 * If the hash starts with "#/" or "#", it will be used as the route (with the "#" removed).
 * Otherwise, falls back to window.location.pathname.
 * WARNING: Does not take into account the state of the React router and specifically the
 * location object, so this should only be used when such context is not readily
 * available but needs to be parsed anyways. Do not call this from inside of a
 * component, use a React router hook instead.
 */
function parseRouteFromUrl() {
    var hash = window.location.hash;
    if (hash && hash.length > 1) {
        var route = hash.substring(1);
        if (route === "/")
            return undefined;
        return route.startsWith("/") ? route : "/" + route;
    }
    var pathname = window.location.pathname;
    return pathname === "/" ? undefined : pathname;
}

/** Compares 2 strings, ignoring case. */
function insensitiveCompare(a, b) {
    return a.localeCompare(b, [], { sensitivity: "accent" }) === 0;
}
/**
 * Singleton instance of AuthenticationManager
 */
var instance;
/**
 * Handles all authentication related functionality in the Suite
 */
var AuthenticationManager = /** @class */ (function (_super) {
    __extends(AuthenticationManager, _super);
    function AuthenticationManager() {
        var _this = _super.call(this) || this;
        /**
         * Allows callers of getInstance() to await on initialization and respond to the result of the
         * promise. Also useful for testing purposes
         */
        _this.initialization = undefined;
        /**
         * Executes only on MOBILE/CORDOVA apps
         * For the security reasons, we have to logs the user out of mobile app whenever app is opened freshly
         */
        _this.setupForceLogoutOnDeviceReady = function () {
            var handleForceLogout = function () { return __awaiter(_this, void 0, void 0, function () {
                var sessionId, wfxSession, existingWfsId, error_1;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 6, , 7]);
                            // Clear skip account selection flag from previous session — it should
                            // not survive across force logouts on mobile.
                            clearSkipAccountSelection();
                            sessionId = window.localStorage.getItem(SESSION_ID_STORAGE_KEY);
                            console.log("[Auth][Mobile] handleForceLogout: sessionId=" + (sessionId ? "present" : "null") + ", isAimProvider=" + this.authenticationState.isAimProvider);
                            if (!sessionId) return [3 /*break*/, 4];
                            wfxSession = window.localStorage.getItem(experience.LOCAL_STORAGE_KEYS.WFX_SESSION);
                            existingWfsId = (_a = JSON.parse(window.localStorage.getItem(experience.LOCAL_STORAGE_KEYS.WFS_WFX_SESSION) ||
                                "{}")) === null || _a === void 0 ? void 0 : _a.wfsUserId;
                            if (!(wfxSession && existingWfsId)) return [3 /*break*/, 2];
                            return [4 /*yield*/, forceWfxLogout()];
                        case 1:
                            _b.sent();
                            _b.label = 2;
                        case 2: return [4 /*yield*/, this.logout()];
                        case 3:
                            _b.sent();
                            return [3 /*break*/, 5];
                        case 4:
                            this.authenticationState.updateAuthStatus(AuthenticationStatus.NotAuthenticated);
                            _b.label = 5;
                        case 5: return [3 /*break*/, 7];
                        case 6:
                            error_1 = _b.sent();
                            console.error("Error during force logout:", error_1);
                            this.authenticationState.updateAuthStatus(AuthenticationStatus.NotAuthenticated);
                            return [3 /*break*/, 7];
                        case 7: return [2 /*return*/];
                    }
                });
            }); };
            // This event is dispatched from index.html and above handler function will handle the logout process
            document.addEventListener("deviceready", handleForceLogout, false);
        };
        _this.authenticationState = AuthenticationState.getInstance();
        _this.subscribeToAuthStateChanges();
        _this.isOidcAuthFlow = false;
        return _this;
    }
    /**
     * Get the current instance of the Authentication Manager
     * @returns instance of the Authentication Manager
     */
    AuthenticationManager.getInstance = function () {
        if (!instance) {
            instance = new AuthenticationManager();
        }
        return instance;
    };
    /**
     * Public initialization method. The only reason an organizationId should be
     * passed in here is if we want to use a different account than the one provided
     * through normal localStorage/query param means. Otherwise, the method will
     * automatically pick up the correct account name from its context. For
     * example, the WTA token auth flow provides an organizationId that should be
     * used instead.
     * @param organizationId
     */
    AuthenticationManager.prototype.initialize = function (organizationId) {
        var _this = this;
        if (!this.initialization) {
            this.initialization = organizationId
                ? this.initializeFromOrganizationId(organizationId, {
                    performingTokenLogin: true,
                })
                : this.initializeFromLocalStorage();
            this.initialization.catch(function () {
                _this.initialization = undefined;
            });
        }
        return this.initialization;
    };
    // ---------------------------------------------------------------------------------
    // ADP Auth Flow (no account screen)
    // TODO: SUITE-6073 - Extract this code into a standalone module
    /**
     * Initializes the ADP auth flow for the WFS Suite.
     * This is separate from the legacy auth flow which uses the account screen.
     * In this flow, we receive a token first from authentication and then later use that token
     * to determine which WFS account we're working with.
     */
    AuthenticationManager.prototype.initializeAdpAuthFlow = function (adpRegionEnv, wtaTokenFlowAccountId, config) {
        if (config === void 0) { config = {}; }
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b, isLogoutRoute, adpRegion, adpEnvironment, e_2, ooid;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = config.isLogoutRoute, isLogoutRoute = _b === void 0 ? false : _b;
                        adpRegion = adpRegionEnv.region, adpEnvironment = adpRegionEnv.environment;
                        // Do not set performingTokenLogin on the logout route — the intent is to
                        // log out, not to perform a token login. Setting it true would affect how
                        // OidcAuthenticationService handles token refresh failures.
                        if (!!wtaTokenFlowAccountId && !isLogoutRoute) {
                            this.authenticationState.setPerformingTokenLogin(true);
                        }
                        // TODO: SUITE-6031 - Implement better error handling for the ADP auth flow
                        if (!adpRegion || !adpEnvironment) {
                            throw new Error("ADP region or environment is missing. Received: region=\"" + adpRegion + "\", environment=\"" + adpEnvironment + "\"");
                        }
                        return [4 /*yield*/, this.initializeAimAuthState(adpRegion, adpEnvironment)];
                    case 1:
                        _c.sent();
                        // Set required variables before calling establishSession
                        this.isOidcAuthFlow = true;
                        this.authenticationService = OidcAuthenticationService.getInstance(AuthProviderStrategyFactory.create());
                        _c.label = 2;
                    case 2:
                        _c.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.authenticationService.establishSession()];
                    case 3:
                        _c.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        _c.sent();
                        return [2 /*return*/, this.handleAimProviderLogin()];
                    case 5:
                        _c.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this.initializeWfsAccountInfo(adpEnvironment)];
                    case 6:
                        _c.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        e_2 = _c.sent();
                        // TODO: Extend error handling behavior in SUITE-6031
                        console.error(e_2);
                        ooid = (_a = this.authenticationService.getOidcUserInfo()) === null || _a === void 0 ? void 0 : _a.account_internal_id;
                        reportLoginErrorDetailsToDynatrace(e_2, ooid);
                        this.authenticationState.updateAuthStatus(AuthenticationStatus.NotAuthenticated);
                        throw new Error("Failed to initialize WFS account info using GRS");
                    case 8:
                        this.authenticationState.updateAuthStatus(AuthenticationStatus.Authenticated);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Initializes the WFS account information for the authenticated user in the
     * ADP auth flow. This requires fetching account details from GRS using the
     * OOID from the user's token.
     * @param adpEnvironment - ADP environment that gets mapped to a GRS url.
     * @private
     */
    AuthenticationManager.prototype.initializeWfsAccountInfo = function (adpEnvironment) {
        return __awaiter(this, void 0, void 0, function () {
            var accountDetail, grsUrl, oidcUserInfo, response, wfsEnvironment, accountData, wfsEnvironmentPrefix, accountInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        grsUrl = getGrsUrlBasedOnAdpEnvironment(adpEnvironment);
                        oidcUserInfo = this.authenticationService.getOidcUserInfo();
                        if (!(oidcUserInfo === null || oidcUserInfo === void 0 ? void 0 : oidcUserInfo.account_internal_id)) {
                            throw new Error("Unable to extract OOID from token");
                        }
                        return [4 /*yield*/, axios__default.default.get(grsUrl, {
                                params: { ooid: oidcUserInfo.account_internal_id },
                            })];
                    case 1:
                        response = _a.sent();
                        if (!(response === null || response === void 0 ? void 0 : response.data)) {
                            throw new Error("Could not fetch Account details from GRS.");
                        }
                        accountDetail = response.data;
                        wfsEnvironment = mapAdpEnvToWfsEnv(adpEnvironment);
                        accountData = {
                            accountDetail: accountDetail,
                            environment: wfsEnvironment,
                        };
                        wfsEnvironmentPrefix = wfsEnvironment ? wfsEnvironment + "-" : "";
                        accountInfo = {
                            accountData: accountData,
                            organizationId: wfsEnvironmentPrefix + accountDetail.externalId,
                        };
                        this.authenticationState.updateAccountInfo(accountInfo);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Fetches authentication information from the appropriate gateway based on the provided ADP region and environment.
     * This information includes the authentication URL, client ID, and AIM mobile client ID.
     * The gateway URL is determined by the region and environment, and an HTTP GET request is made to retrieve the auth info.
     * If the request fails or the response is missing data, an error is thrown.
     * @param region - ADP region (e.g. "na", "emea")
     * @param environment - ADP environment (e.g. "prod", "staging")
     * @returns an object containing the authUrl, clientId, and aimMobileClientId
     * @private
     */
    AuthenticationManager.prototype.getAimAuthInfoFromProperGateway = function (region, environment) {
        return __awaiter(this, void 0, void 0, function () {
            var gatewayAdpRegionEnvUrl, response, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        gatewayAdpRegionEnvUrl = this.getGatewayUrl(region, environment) +
                            ("/aim-environments/" + region + "-" + environment);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios__default.default.get(gatewayAdpRegionEnvUrl)];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_3 = _a.sent();
                        // TODO: SUITE-6031 - Implement better error handling for the ADP auth flow
                        console.error("Error fetching auth info from gateway for ADP auth flow:", e_3);
                        throw new Error("Unable to fetch auth info from gateway for ADP auth flow.");
                    case 4:
                        if (!(response === null || response === void 0 ? void 0 : response.data)) {
                            throw new Error("Gateway response is missing data.");
                        }
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    /**
     * Returns the appropriate gateway URL based on the provided region and environment.
     * Throws an error if the region or environment is unknown.
     * @param region - ADP region (e.g. "na", "emea")
     * @param environment - ADP environment (e.g. "prod", "staging")
     * @returns the gateway URL for the specified region and environment
     * @private
     */
    AuthenticationManager.prototype.getGatewayUrl = function (region, environment) {
        var regionUrls = GATEWAY_URL_MAP[region.toLowerCase()];
        if (!regionUrls) {
            throw new Error("Unknown region: " + region);
        }
        var gatewayUrl = regionUrls[environment.toLowerCase()];
        if (!gatewayUrl) {
            throw new Error("Unknown environment: " + environment + " for region: " + region);
        }
        return gatewayUrl;
    };
    /**
     * Initializes the authentication state for AIM provider by fetching auth info
     * from the appropriate Gateway based on region and environment.
     * This is shared between the mobile AIM flow (initializeAccountInfo) and the
     * ADP auth flow (initializeAdpAuthFlow).
     * @param region - ADP region (e.g. "na", "emea")
     * @param environment - ADP environment (e.g. "dit", "prod")
     */
    AuthenticationManager.prototype.initializeAimAuthState = function (region, environment) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, authUrl, clientId, mobileClientId, smSessionUrl;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getAimAuthInfoFromProperGateway(region, environment)];
                    case 1:
                        _a = _b.sent(), authUrl = _a.authUrl, clientId = _a.clientId, mobileClientId = _a.mobileClientId, smSessionUrl = _a.smSessionUrl;
                        this.authenticationState.isAimProvider = true;
                        this.authenticationState.authProvider = AuthProvider.AIM;
                        this.authenticationState.authUrl = authUrl;
                        this.authenticationState.aimClientId = isCordovaDevice()
                            ? mobileClientId
                            : clientId;
                        this.authenticationState.aimLogoutUrl =
                            authUrl + "/auth/oauth/v2/osm_logout";
                        // Mobile (Cordova) uses token refresh, not SM session cookie refresh
                        this.authenticationState.aimSmSessionUrl = isCordovaDevice()
                            ? undefined
                            : smSessionUrl;
                        return [2 /*return*/];
                }
            });
        });
    };
    // ---------------------------------------------------------------------------------
    /**
     * Subscribes to authentication state changes and emits corresponding events.
     * This keeps the AuthenticationManager in sync with AuthenticationState updates,
     * such as authentication status, account info, and parsed token changes.
     *
     * @private
     */
    AuthenticationManager.prototype.subscribeToAuthStateChanges = function () {
        var _this = this;
        this.authenticationState.subscribe({
            authStatusChange: function (newAuthStatus) {
                _this.emit.authStatusChange(newAuthStatus);
            },
            accountInfoChange: function (newAccountInfo) {
                _this.emit.accountInfoChange(newAccountInfo);
            },
            oidcUserInfoChange: function (newOidcUserInfo) {
                _this.emit.oidcUserInfoChange(newOidcUserInfo);
            },
        });
    };
    /**
     * Initializes authentication state and account info for a given organization ID.
     * Handles session establishment and device-specific logic.
     *
     * @param organizationId - The organization ID to initialize authentication for.
     * @param config - Configuration object for initialization.
     *   @property performingTokenLogin - If true, sets performingTokenLogin (default: false).
     * @returns Promise that resolves when initialization is complete.
     */
    AuthenticationManager.prototype.initializeFromOrganizationId = function (organizationId, config) {
        if (config === void 0) { config = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, performingTokenLogin, err_1, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = config.performingTokenLogin, performingTokenLogin = _a === void 0 ? false : _a;
                        this.authenticationState.setPerformingTokenLogin(performingTokenLogin);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 7, , 8]);
                        return [4 /*yield*/, this.initializeAccountInfo(organizationId)];
                    case 2:
                        _b.sent();
                        if (!isCordovaDevice()) return [3 /*break*/, 3];
                        // Initialize and handle the logout flow for mobile apps when the app is reopened after being closed forcefully or after the device is restarted
                        this.setupForceLogoutOnDeviceReady();
                        return [3 /*break*/, 6];
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this.authenticationService.establishSession()];
                    case 4:
                        _b.sent();
                        this.authenticationState.updateAuthStatus(AuthenticationStatus.Authenticated);
                        return [3 /*break*/, 6];
                    case 5:
                        err_1 = _b.sent();
                        console.error(err_1);
                        // Only set NotAuthenticated if establishSession() hasn't already
                        // moved the status to a terminal state (e.g. NotAuthenticated via
                        // clearSession(), or LoggingOut). If the status is still Initializing,
                        // nothing has handled it yet and we need to set it here.
                        if (this.authenticationState.getAuthStatus() ===
                            AuthenticationStatus.Initializing) {
                            this.updateAuthStatus(AuthenticationStatus.NotAuthenticated);
                        }
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        error_2 = _b.sent();
                        console.error("Error during initialization: ", error_2);
                        this.updateAuthStatus(AuthenticationStatus.NotAuthenticated);
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Initializes authentication state and account info using organization ID from localStorage or query parameters.
     * If an organization ID is found, proceeds with initialization; otherwise, sets authentication status to NotAuthenticated.
     *
     * @returns Promise that resolves when initialization is complete or immediately if no organization ID is found.
     * @private
     */
    AuthenticationManager.prototype.initializeFromLocalStorage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var localStorageOrganizationId, queryString, params, organizationId;
            return __generator(this, function (_a) {
                localStorageOrganizationId = window.localStorage.getItem(ORGANIZATION_ID_LOCAL_STORAGE_KEY);
                queryString = window.location.search || location.search;
                params = qs.parse(queryString, { ignoreQueryPrefix: true });
                organizationId = (params === null || params === void 0 ? void 0 : params.accountId) || localStorageOrganizationId;
                if (organizationId) {
                    return [2 /*return*/, this.initializeFromOrganizationId(organizationId)];
                }
                else {
                    this.updateAuthStatus(AuthenticationStatus.NotAuthenticated);
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Get the current authentication status
     * @returns the current authentication status
     */
    AuthenticationManager.prototype.getAuthStatus = function () {
        return this.authenticationState.getAuthStatus();
    };
    /**
     * Get the parsed token.
     * @returns parsed token or undefined if the user is not authenticated or keycloak is not initialized
     */
    AuthenticationManager.prototype.getOidcUserInfo = function () {
        if (this.authenticationService) {
            return this.authenticationService.getOidcUserInfo();
        }
        else {
            return undefined;
        }
    };
    /**
     * Get the base64 access token
     * NOTE: Usage of this should only occur when authenticated. If you need
     *       to get the access token and don't know if you're authenticated, query
     *       the authentication status {@link AuthenticationManager.getAuthStatus}
     * @returns Promise containing the token
     */
    AuthenticationManager.prototype.getAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.authenticationService) {
                    return [2 /*return*/, this.authenticationService.getAccessToken()];
                }
                else {
                    throw new Error("Keycloak/Oidc instance unavailable. Cannot retrieve access token.");
                }
            });
        });
    };
    /**
     * Get the data for the current account (external ID, deployment, etc.)
     * @returns data for the current account or undefined if accessed before keycloak initialization
     */
    AuthenticationManager.prototype.getAccountInfo = function () {
        return this.authenticationState.getAccountInfo();
    };
    /**
     * Sets the value of impersonating to a given value
     * @param impersonating
     */
    AuthenticationManager.prototype.setImpersonating = function (impersonating) {
        this.authenticationState.setImpersonating(impersonating);
    };
    AuthenticationManager.prototype.updateAuthStatus = function (authStatus) {
        // do not emit a change if the authstatus didn't actually change
        if (authStatus === this.authenticationState.getAuthStatus()) {
            return;
        }
        if (this.authenticationState) {
            this.authenticationState.updateAuthStatus(authStatus);
        }
        else {
            this.emit.authStatusChange(authStatus);
        }
    };
    /**
     * Triggers login with the auth provider.
     * @param config - Optional configuration object that describes the login intent.
     *   @property organizationId - Account name (optional)
     *   @property skipInitialize - If true, skips initialization for the given account.
     *     NOTE: Initialization is also implicitly skipped if no account is provided.
     *   @property redirectBackRoute - The route where user should be redirected after signing in
     * @returns A promise that resolves upon successful login or rejects if an error occurs.
     */
    AuthenticationManager.prototype.login = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, organizationId, skipInitialize, redirectBackRoute, error_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 7, , 8]);
                        _a = config || {}, organizationId = _a.organizationId, skipInitialize = _a.skipInitialize, redirectBackRoute = _a.redirectBackRoute;
                        console.log("[Auth] login() called: organizationId=" + organizationId + ", skipInitialize=" + skipInitialize + ", isAimProvider=" + this.authenticationState.isAimProvider);
                        if (!(!skipInitialize && !!organizationId)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.initializeAccountInfo(organizationId)];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (!this.authenticationState.isAimProvider) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.handleAimProviderLogin(redirectBackRoute)];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, this.authenticationService.login(redirectBackRoute)];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        error_3 = _b.sent();
                        console.error("Error during login process:", error_3);
                        this.updateAuthStatus(AuthenticationStatus.NotAuthenticated);
                        throw error_3;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Handles login logic specific to AIM provider.
     * Specifically the redirectBackRoute needs to be stored in persistent state before we redirect for login.
     * This method will accept one that's provided, preferably from react-router, but as a backup it will parse the route
     * directly from the url. Obviously the former approach is recommended for consistency with react-router's internal
     * state.
     * @param providedRedirectBackRoute Optional route to redirect back after login.
     */
    AuthenticationManager.prototype.handleAimProviderLogin = function (providedRedirectBackRoute) {
        return __awaiter(this, void 0, void 0, function () {
            var redirectBackRoute, persistor, e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        redirectBackRoute = providedRedirectBackRoute || parseRouteFromUrl();
                        if (!redirectBackRoute) return [3 /*break*/, 4];
                        getStore().dispatch(setRedirectBackRoute(redirectBackRoute));
                        persistor = getPersistor();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, persistor.flush()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_4 = _a.sent();
                        console.warn("Error flushing persistor before login:", e_4);
                        return [3 /*break*/, 4];
                    case 4: return [4 /*yield*/, this.authenticationService.login()];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Log out of the suite app
     * Clear any localStorage entries that would prevent us from repeating auth initialization
     * on the next auth attempt.
     *
     * @param options - Optional logout options to control which systems to logout from
     */
    AuthenticationManager.prototype.logout = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.authenticationService.logout(options)];
            });
        });
    };
    /**
     * Register iframe-parent communication handlers.
     * Should be called when WTA/ExternalPageView is about to be opened.
     */
    AuthenticationManager.prototype.registerIframeParentCommunication = function () {
        if (this.authenticationService) {
            this.authenticationService.registerIframeParentCommunication();
        }
    };
    /**
     * Unregister iframe-parent communication handlers.
     * Should be called when WTA/ExternalPageView is unmounted or on cleanup.
     */
    AuthenticationManager.prototype.unregisterIframeParentCommunication = function () {
        if (this.authenticationService) {
            this.authenticationService.unregisterIframeParentCommunication();
        }
    };
    /**
     * Log in to the application with a mock user
     *    NOTE: The assumption is this is only called when AutoLogin component is present and clicked.
     *    This panel is only present during UI Integration Tests and specific environments where an
     *    environment variable is set. This should not be used elsewhere. We should be using real data
     *    where possible.
     * @param credentials - credentials for the mock user to log in as
     */
    AuthenticationManager.prototype.mockLogin = function (credentials) {
        var userInfo = getUserData({
            username: credentials.username,
            organization: credentials.account,
        });
        if (!userInfo) {
            return false;
        }
        if (insensitiveCompare(credentials.account, userInfo.organization) &&
            insensitiveCompare(credentials.username, userInfo.username) &&
            insensitiveCompare(credentials.password, userInfo.password)) {
            this.authenticationState.updateAuthStatus(AuthenticationStatus.MockAuthenticated);
            this.authenticationState.updateAccountInfo({
                accountData: EMPTY_ACCOUNT_DATA,
                organizationId: userInfo.organization,
            });
            return true;
        }
        return false;
    };
    /**
     * Returns whether or not we have attained leader tab status
     * Useful for determining whether or not the Suite should perform certain
     * operations. If multiple Suite tabs are open, only one can be the leader
     * tab at any given time.
     */
    AuthenticationManager.prototype.getLeaderTabStatus = function () {
        return this.authenticationState.getIsLeaderTab();
    };
    /**
     * Returns whether or not we are using the OIDC auth flow
     */
    AuthenticationManager.prototype.getIsOidcAuthFlow = function () {
        return this.isOidcAuthFlow;
    };
    /**
     * Returns whether or not the current authentication provider is AIM.
     * @returns {boolean} True if AIM provider is active, false otherwise.
     */
    AuthenticationManager.prototype.isAimProvider = function () {
        return this.authenticationState.isAimProvider;
    };
    /**
     * Makes calls to GRS to get account info that is required to make backend requests, including
     * the ones for auth. Establishes which authentication implementation to use based on the account
     * info: Either OIDCAuthenticationService or KeycloakAuthenticationService
     */
    AuthenticationManager.prototype.initializeAccountInfo = function (organizationId) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function () {
            var shouldSkipInitialize, preExistingAccountInfo, grsUrl, accountDetail, accountId, response, accountData, accountInfo, authConfig, shouldFetchAuthFromGateway, adpEnvironment, _f, region, environment, casBaseUrl, realm, error_4;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        shouldSkipInitialize = false;
                        preExistingAccountInfo = (_a = this.authenticationState) === null || _a === void 0 ? void 0 : _a.getAccountInfo();
                        if (!isCordovaDevice() &&
                            (preExistingAccountInfo === null || preExistingAccountInfo === void 0 ? void 0 : preExistingAccountInfo.organizationId) === organizationId &&
                            this.authenticationService) {
                            if (((_b = this.authenticationState) === null || _b === void 0 ? void 0 : _b.authUrl) && ((_c = this.authenticationState) === null || _c === void 0 ? void 0 : _c.authProvider)) {
                                shouldSkipInitialize = true;
                            }
                        }
                        if (shouldSkipInitialize) {
                            console.log("Skipping auth initialization");
                            return [2 /*return*/];
                        }
                        // Clear previous values of authenticationState because we're starting over
                        // from scratch. We are assuming from this point forward that nothing in
                        // authenticationState is still valid.
                        this.authenticationState.clear();
                        _g.label = 1;
                    case 1:
                        _g.trys.push([1, 6, , 7]);
                        grsUrl = getGrsUrl(organizationId);
                        accountDetail = void 0;
                        accountId = getAccountId(organizationId);
                        return [4 /*yield*/, axios__default.default.get(grsUrl, {
                                params: { externalId: accountId },
                            })];
                    case 2:
                        response = _g.sent();
                        if (!(response === null || response === void 0 ? void 0 : response.data)) {
                            throw new Error("Could not fetch Account details from GRS.");
                        }
                        accountDetail = response.data;
                        accountData = {
                            accountDetail: accountDetail,
                            environment: getEnvironment(organizationId),
                        };
                        accountInfo = {
                            accountData: accountData,
                            organizationId: organizationId,
                        };
                        this.authenticationState.updateAccountInfo(accountInfo);
                        authConfig = accountDetail.authentication;
                        // Initialize from auth config
                        if (!authConfig) {
                            this.isOidcAuthFlow = false;
                        }
                        // Propagates the flag to AuthenticationState so that other classes
                        // (KeycloakAuthProviderStrategy, cordovaLoginRedirect) can read it via the singleton
                        // without taking a direct dependency on AuthenticationManager.
                        this.authenticationState.useBrowserBasedSSO = (_d = authConfig === null || authConfig === void 0 ? void 0 : authConfig.useBrowserBasedSSO) !== null && _d !== void 0 ? _d : false;
                        shouldFetchAuthFromGateway = isCordovaDevice() && (authConfig === null || authConfig === void 0 ? void 0 : authConfig.authProvider) === AuthProvider.AIM;
                        if (!shouldFetchAuthFromGateway) return [3 /*break*/, 4];
                        // AIM always uses the OIDC flow — useNewAuthFlow flag is Keycloak-only and not consulted here.
                        this.isOidcAuthFlow = true;
                        adpEnvironment = accountDetail.adpEnvironment;
                        if (!adpEnvironment) {
                            throw new Error("AIM auth flow requires adpEnvironment from GRS response, but it was not provided.");
                        }
                        _f = adpEnvironment.split("-"), region = _f[0], environment = _f[1];
                        return [4 /*yield*/, this.initializeAimAuthState(region, environment)];
                    case 3:
                        _g.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        // useNewAuthFlow controls whether to use the OIDC flow (oidc-client-ts) or the legacy Keycloak flow.
                        this.isOidcAuthFlow = (_e = authConfig === null || authConfig === void 0 ? void 0 : authConfig.useNewAuthFlow) !== null && _e !== void 0 ? _e : false;
                        console.log("Using Keycloak realm-based auth URL");
                        casBaseUrl = getCasBaseUrl(accountData) + "/auth";
                        realm = accountData.accountDetail.externalId;
                        this.authenticationState.authUrl = casBaseUrl + "/realms/" + realm;
                        this.authenticationState.authProvider = AuthProvider.Keycloak;
                        _g.label = 5;
                    case 5:
                        if (this.isOidcAuthFlow) {
                            this.authenticationService = OidcAuthenticationService.getInstance(AuthProviderStrategyFactory.create());
                        }
                        else {
                            this.authenticationService = KeycloakAuthenticationService.getInstance(this.authenticationState);
                        }
                        window.localStorage.setItem(ORGANIZATION_ID_LOCAL_STORAGE_KEY, organizationId);
                        return [2 /*return*/, Promise.resolve("")];
                    case 6:
                        error_4 = _g.sent();
                        throw error_4;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    return AuthenticationManager;
}(strictlyTypedEvents.WithEventEmitter));

/**
 * Gets the service URL for a specified service
 *
 * @param serviceName - Service name to get the URL for
 * @param isForConsolidatedHostnameGraphqlEndpoint - If true, then a URL with a
 *        common hostname and distinct path for the service will be generated.
 *        This is intended for GraphQL endpoints only. It is an optimization to
 *        get all GraphQL requests across all services to share a TCP connection
 *        over HTTP/2 to minimize latency in slow/unreliable internet connection
 *        situations.
 *
 * @returns returns the service URL from the current value in state
 */
function getServiceUrl(serviceName, isForConsolidatedHostnameGraphqlEndpoint) {
    if (isForConsolidatedHostnameGraphqlEndpoint === void 0) { isForConsolidatedHostnameGraphqlEndpoint = false; }
    var _a;
    var accountData = (_a = AuthenticationManager.getInstance().getAccountInfo()) === null || _a === void 0 ? void 0 : _a.accountData;
    if (!accountData) {
        throw new Error("No account data present. Cannot complete query.");
    }
    return (getUrlOverrides().get(serviceName) ||
        getMultiTenantServiceBaseUrl(accountData, serviceName, isForConsolidatedHostnameGraphqlEndpoint));
}

var genericMessage = "Invariant Violation";
var _a$4 = Object.setPrototypeOf, setPrototypeOf$1 = _a$4 === void 0 ? function (obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : _a$4;
var InvariantError = /** @class */ (function (_super) {
    __extends(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) { message = genericMessage; }
        var _this = _super.call(this, typeof message === "number"
            ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)"
            : message) || this;
        _this.framesToPop = 1;
        _this.name = genericMessage;
        setPrototypeOf$1(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error));
function invariant(condition, message) {
    if (!condition) {
        throw new InvariantError(message);
    }
}
function wrapConsoleMethod(method) {
    return function () {
        return console[method].apply(console, arguments);
    };
}
(function (invariant) {
    invariant.warn = wrapConsoleMethod("warn");
    invariant.error = wrapConsoleMethod("error");
})(invariant || (invariant = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var processStub = { env: {} };
if (typeof process === "object") {
    processStub = process;
}
else
    try {
        // Using Function to evaluate this assignment in global scope also escapes
        // the strict mode of the current module, thereby allowing the assignment.
        // Inspired by https://github.com/facebook/regenerator/pull/369.
        Function("stub", "process = stub")(processStub);
    }
    catch (atLeastWeTried) {
        // The assignment can fail if a Content Security Policy heavy-handedly
        // forbids Function usage. In those environments, developers should take
        // extra care to replace process.env.NODE_ENV in their production builds,
        // or define an appropriate global.process polyfill.
    }

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getFragmentQueryDocument(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function (definition) {
        if (definition.kind === 'OperationDefinition') {
            throw process.env.NODE_ENV === "production" ? new InvariantError(11) : new InvariantError("Found a " + definition.operation + " operation" + (definition.name ? " named '" + definition.name.value + "'" : '') + ". " +
                'No operations are allowed when using a fragment as a query. Only fragments are allowed.');
        }
        if (definition.kind === 'FragmentDefinition') {
            fragments.push(definition);
        }
    });
    if (typeof actualFragmentName === 'undefined') {
        process.env.NODE_ENV === "production" ? invariant(fragments.length === 1, 12) : invariant(fragments.length === 1, "Found " + fragments.length + " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.");
        actualFragmentName = fragments[0].name.value;
    }
    var query = __assign(__assign({}, document), { definitions: __spreadArrays([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName,
                            },
                        },
                    ],
                },
            }
        ], document.definitions) });
    return query;
}

function queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery',
        },
        selectionSet: selectionSetFromObj(obj),
    };
    var out = {
        kind: 'Document',
        definitions: [op],
    };
    return out;
}
function fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType',
            },
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery',
        },
        selectionSet: selectionSetFromObj(obj),
    };
    var out = {
        kind: 'Document',
        definitions: [frag],
    };
    return out;
}
function selectionSetFromObj(obj) {
    if (typeof obj === 'number' ||
        typeof obj === 'boolean' ||
        typeof obj === 'string' ||
        typeof obj === 'undefined' ||
        obj === null) {
        return null;
    }
    if (Array.isArray(obj)) {
        return selectionSetFromObj(obj[0]);
    }
    var selections = [];
    Object.keys(obj).forEach(function (key) {
        var nestedSelSet = selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key,
            },
            selectionSet: nestedSelSet || undefined,
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections,
    };
    return selectionSet;
}
var justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename',
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null,
                    },
                ],
            },
        },
    ],
};

var ApolloCache = (function () {
    function ApolloCache() {
    }
    ApolloCache.prototype.transformDocument = function (document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function (document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic,
        });
    };
    ApolloCache.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.read({
            query: getFragmentQueryDocument(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic,
        });
    };
    ApolloCache.prototype.writeQuery = function (options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables,
        });
    };
    ApolloCache.prototype.writeFragment = function (options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: getFragmentQueryDocument(options.fragment, options.fragmentName),
        });
    };
    ApolloCache.prototype.writeData = function (_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: justTypenameQuery,
                });
            }
            catch (e) {
            }
            var __typename = (typenameResult && typenameResult.__typename) || '__ClientData';
            var dataToWrite = Object.assign({ __typename: __typename }, data);
            this.writeFragment({
                id: id,
                fragment: fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite,
            });
        }
        else {
            this.writeQuery({ query: queryFromPojo(data), data: data });
        }
    };
    return ApolloCache;
}());

var emptyCacheObj = {};
/**
 * A cache with "void" behavior which avoids storing anything in memory.
 * This is to help address performance concerns with Apollo's default InMemoryCache.
 * Read for more info: https://stackoverflow.com/a/76333054/2653390
 */
var ApolloVoidCache = /** @class */ (function (_super) {
    __extends(ApolloVoidCache, _super);
    function ApolloVoidCache() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ApolloVoidCache.prototype.diff = function (query) {
        return emptyCacheObj;
    };
    ApolloVoidCache.prototype.evict = function (query) {
        return { success: true };
    };
    ApolloVoidCache.prototype.extract = function (optimistic) {
        return emptyCacheObj;
    };
    ApolloVoidCache.prototype.performTransaction = function (transaction) {
        // do nothing
    };
    ApolloVoidCache.prototype.read = function (query) {
        return null;
    };
    ApolloVoidCache.prototype.recordOptimisticTransaction = function (transaction, id) {
        // do nothing
    };
    ApolloVoidCache.prototype.removeOptimistic = function (id) {
        // do nothing
    };
    ApolloVoidCache.prototype.reset = function () {
        return Promise.resolve(undefined);
    };
    ApolloVoidCache.prototype.restore = function (serializedState) {
        return this;
    };
    ApolloVoidCache.prototype.watch = function (watch) {
        return function () { return undefined; };
    };
    ApolloVoidCache.prototype.write = function (write) {
        // do nothing
    };
    return ApolloVoidCache;
}(ApolloCache));

/**
 * API Error Handler Types and Constants
 */
/**
 * ApiErrorType representing the different types of API errors that can occur
 * during API operations (GraphQL and REST). Each enum value maps to a specific type of error.
 */
exports.ApiErrorType = void 0;
(function (ApiErrorType) {
    ApiErrorType["BAD_REQUEST_ERROR"] = "BAD_REQUEST_ERROR";
    ApiErrorType["BAD_RESPONSE_ERROR"] = "BAD_RESPONSE_ERROR";
    ApiErrorType["FAILED_TO_CONNECT"] = "FAILED_TO_CONNECT";
    ApiErrorType["FORBIDDEN_ERROR"] = "FORBIDDEN_ERROR";
    ApiErrorType["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
    ApiErrorType["NOT_FOUND_ERROR"] = "NOT_FOUND_ERROR";
    ApiErrorType["TIMEOUT_ERROR"] = "TIMEOUT_ERROR";
    ApiErrorType["UNAUTHORIZED_ERROR"] = "UNAUTHORIZED_ERROR";
})(exports.ApiErrorType || (exports.ApiErrorType = {}));
/**
 * HTTP status code constants used for error classification
 */
var HTTP_STATUS_CODES = {
    /** Bad request status code */
    BAD_REQUEST: 400,
    /** Unauthorized - authentication required */
    UNAUTHORIZED: 401,
    /** Forbidden - access denied */
    FORBIDDEN: 403,
    /** Not found - resource doesn't exist */
    NOT_FOUND: 404,
    /** Request timeout status code */
    TIMEOUT: 408,
    /** Internal server error status code (5xx errors start here) */
    INTERNAL_SERVER_ERROR: 500,
};

/**
 * Maps HTTP status codes to their corresponding ApiErrorType
 * Used by both Axios and GraphQL error converters
 */
var mapStatusCodeToErrorType = function (statusCode) {
    switch (statusCode) {
        case HTTP_STATUS_CODES.UNAUTHORIZED:
            return exports.ApiErrorType.UNAUTHORIZED_ERROR;
        case HTTP_STATUS_CODES.FORBIDDEN:
            return exports.ApiErrorType.FORBIDDEN_ERROR;
        case HTTP_STATUS_CODES.NOT_FOUND:
            return exports.ApiErrorType.NOT_FOUND_ERROR;
        case HTTP_STATUS_CODES.BAD_REQUEST:
            return exports.ApiErrorType.BAD_REQUEST_ERROR;
        default:
            return exports.ApiErrorType.BAD_RESPONSE_ERROR;
    }
};

/**
 * Convert Apollo errors to generic API error format
 */
var graphqlErrorConverter = function (error, serviceName) {
    // Handle GraphQL errors
    if (error.graphQLErrors && error.graphQLErrors.length > 0) {
        return error.graphQLErrors.map(function (graphQLError) {
            var extensions = graphQLError.extensions;
            var errorId = extensions.errorId;
            return {
                type: exports.ApiErrorType.INTERNAL_SERVER_ERROR,
                serviceName: serviceName,
                errorId: errorId,
            };
        });
    }
    // Handle network errors
    if (error.networkError) {
        var networkError = error.networkError;
        var statusCode = networkError.statusCode;
        // Timeout error
        if (statusCode === HTTP_STATUS_CODES.TIMEOUT) {
            return [
                {
                    type: exports.ApiErrorType.TIMEOUT_ERROR,
                    serviceName: serviceName,
                },
            ];
        }
        // Internal server error (5xx)
        if (statusCode && statusCode >= HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR) {
            return [
                {
                    type: exports.ApiErrorType.INTERNAL_SERVER_ERROR,
                    serviceName: serviceName,
                    errorId: "",
                },
            ];
        }
        // Client error (4xx)
        if (statusCode) {
            return [
                {
                    type: mapStatusCodeToErrorType(statusCode),
                    serviceName: serviceName,
                    statusCode: statusCode,
                },
            ];
        }
    }
    // Fallback - connection failed
    return [
        {
            type: exports.ApiErrorType.FAILED_TO_CONNECT,
            serviceName: serviceName,
        },
    ];
};

/**
 * Convert Axios errors to generic API error format
 * Handles multiple validation errors if present in response
 */
var axiosErrorConverter = function (error, serviceName) {
    var _a, _b;
    var response = error.response;
    // Network error - no response
    if (!response) {
        return [
            {
                type: exports.ApiErrorType.FAILED_TO_CONNECT,
                serviceName: serviceName,
            },
        ];
    }
    var statusCode = response.status;
    var responseData = response.data;
    // Timeout error
    if (statusCode === HTTP_STATUS_CODES.TIMEOUT) {
        return [
            {
                type: exports.ApiErrorType.TIMEOUT_ERROR,
                serviceName: serviceName,
            },
        ];
    }
    // Internal server error (5xx)
    if (statusCode >= HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR) {
        return [
            {
                type: exports.ApiErrorType.INTERNAL_SERVER_ERROR,
                serviceName: serviceName,
                errorId: (_b = (_a = responseData === null || responseData === void 0 ? void 0 : responseData.errors) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.code,
            },
        ];
    }
    // First, identify error count to determine processing path
    var errors = responseData === null || responseData === void 0 ? void 0 : responseData.errors;
    var errorCount = errors ? errors.length : 0;
    // Handle multiple validation errors (4xx)
    if (errorCount > 1) {
        return __spreadArrays(errors.map(function () { return ({
            type: exports.ApiErrorType.BAD_RESPONSE_ERROR,
            serviceName: serviceName,
            statusCode: statusCode,
        }); }));
    }
    // Handle single error or no errors - identify specific error type
    return [
        {
            type: mapStatusCodeToErrorType(statusCode),
            serviceName: serviceName,
            statusCode: statusCode,
        },
    ];
};

/**
 * Action to add new errors to the store.
 * @returns {ApplicationThunk}
 */
var addApiErrors = function (errors) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch({
                type: "addApiErrors" /* AddApiErrors */,
                errors: errors,
            });
            return [2 /*return*/];
        });
    }); };
};
/**
 * Action to delete API error
 * @returns {ApplicationThunk}
 */
var deleteApiError = function (error) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch({
                type: "deleteApiError" /* DeleteApiError */,
                error: error,
            });
            return [2 /*return*/];
        });
    }); };
};
/**
 * Handles an error thrown by an ApolloClient and adds it to the Redux Store.
 * Uses the unified error handling for consistent error management.
 * @param error - The ApolloError to handle.
 * @param serviceName - the name of the Service that the request was sent to
 */
var handleGraphqlError = function (error, serviceName) {
    var apiErrors = graphqlErrorConverter(error, serviceName);
    var dispatch = getStore().dispatch;
    dispatch(addApiErrors(apiErrors));
};
/**
 * Handles an error thrown by REST API (Axios) and adds it to the Redux Store.
 * Uses the unified error handling for consistent error management.
 * @param error - The AxiosError to handle.
 * @param serviceName - the name of the Service that the request was sent to
 */
var handleRestApiError = function (error, serviceName) {
    var apiErrors = axiosErrorConverter(error, serviceName);
    // Add the errors to the Redux store
    var dispatch = getStore().dispatch;
    dispatch(addApiErrors(apiErrors));
};

var initialState$f = {
    errors: [],
};
/**
 * Reducer to manage API errors (GraphQL and REST).
 *
 * @param state The current state
 * @param action The action that has triggered the state change
 * @returns The modified state
 */
var ApiErrorReducer = function (state, action) {
    if (state === void 0) { state = initialState$f; }
    /**
     * Check which Action has been triggered
     */
    switch (action.type) {
        case "addApiErrors" /* AddApiErrors */: {
            return {
                errors: state.errors.concat(action.errors),
            };
        }
        case "deleteApiError" /* DeleteApiError */: {
            return {
                errors: state.errors.filter(function (error) { return error !== action.error; }),
            };
        }
        default:
            return state;
    }
};

// Abort query after 30 seconds by default
var DEFAULT_QUERY_TIMEOUT = 30 * 1000;
var createApolloClient = function (uri, accessToken, options) {
    if (options === void 0) { options = {}; }
    var globalHeaders = {
        Authorization: "Bearer " + accessToken,
        "Content-Security-Policy": "default-src 'none'",
        "X-XSS-Protection": "1; mode=block",
    };
    var fetchOptions = {
        headers: globalHeaders,
    };
    var links = [
        new ApolloLinkTimeout__default.default(options.timeout || DEFAULT_QUERY_TIMEOUT),
        apolloLinkHttp.createHttpLink({
            fetchOptions: fetchOptions,
            uri: uri,
            headers: globalHeaders,
        }),
    ];
    if (options.additionalLink) {
        links.unshift(options.additionalLink);
    }
    return new apolloClient.ApolloClient({
        link: apolloLink.from(links),
        cache: new ApolloVoidCache(),
        // Disable apollo's usage of the in-memory cache
        // See https://stackoverflow.com/a/48549667/2653390
        defaultOptions: {
            watchQuery: {
                fetchPolicy: "no-cache",
            },
            query: {
                fetchPolicy: "no-cache",
            },
        },
    });
};
/**
 * This function determines whether or not to invoke the graphql error handling
 * for a given ApolloError, based on the value of the `skipDefaultErrorHandling`
 * parameter.
 * @param error - The ApolloError to handle.
 * @param serviceName - the name of the Service that the request was sent to
 * @param skipDefaultErrorHandling - if true or undefined then the default error handling is
 *                        skipped. If it is a function then the function should return true to skip
 *                        default error handling, or false to use default error handling.
 */
function maybePerformDefaultErrorHandling(error, serviceName, skipDefaultErrorHandling) {
    var handleError;
    if (skipDefaultErrorHandling instanceof Function) {
        handleError = !skipDefaultErrorHandling(error);
    }
    else {
        handleError = skipDefaultErrorHandling === false;
    }
    if (handleError) {
        handleGraphqlError(error, serviceName);
    }
}
var graphqlServiceFactory = {
    /**
     * @deprecated -- Use getGraphQlObject function instead
     */
    create: function (loginDetails, serviceName, graphqlPath, introspectionQueryResultData, options) {
        if (options === void 0) { options = {}; }
        return graphqlServiceFactory.getGraphQlObject(serviceName, options);
    },
    getGraphQlObject: function (serviceName, serviceOptions) {
        if (serviceOptions === void 0) { serviceOptions = {}; }
        var serviceBaseURL = getServiceUrl(serviceName, true);
        var uri = serviceBaseURL + "/" + (serviceOptions.graphQlPath || GRAPHQL_PATH);
        var graphQlService = {
            query: function (query, variables, requestOptions) {
                if (requestOptions === void 0) { requestOptions = {}; }
                return AuthenticationManager.getInstance()
                    .getAccessToken()
                    .then(function (accessToken) {
                    var normalizedQuery = typeof query === "string"
                        ? gql__default.default(templateObject_1$K || (templateObject_1$K = __makeTemplateObject(["\n                    ", "\n                  "], ["\n                    ", "\n                  "])), query) : query;
                    var retry = requestOptions.retry;
                    if (retry && retry.times > 0) {
                        return (graphQlService
                            .query(normalizedQuery, variables, __assign(__assign({}, requestOptions), { retry: undefined }))
                            // Note that query can also fail on client-side runtime errors,
                            // (in addition to non-2xx responses and network errors).
                            // TODO: Don't retry on client-side runtime errors.
                            .catch(function (error) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, delay__default.default(retry.delay)];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/, graphqlServiceFactory
                                                .getGraphQlObject(serviceName, serviceOptions)
                                                .query(normalizedQuery, variables, __assign(__assign({}, requestOptions), { retry: __assign(__assign({}, retry), { times: retry.times - 1 }) }))];
                                }
                            });
                        }); }));
                    }
                    var client = createApolloClient(uri, accessToken, serviceOptions);
                    // Send the GraphQL query and handle errors
                    return client
                        .query({
                        query: normalizedQuery,
                        variables: variables,
                    })
                        .catch(function (error) {
                        maybePerformDefaultErrorHandling(error, serviceName, requestOptions.skipDefaultErrorHandling);
                        throw error; // Re-throw the error to propagate it further if needed
                    });
                });
            },
            mutate: function (mutation, variables, mutateOptions) {
                if (mutateOptions === void 0) { mutateOptions = {}; }
                return AuthenticationManager.getInstance()
                    .getAccessToken()
                    .then(function (accessToken) {
                    var normalizedMutation = typeof mutation === "string"
                        ? gql__default.default(templateObject_2$x || (templateObject_2$x = __makeTemplateObject(["\n                    ", "\n                  "], ["\n                    ", "\n                  "])), mutation) : mutation;
                    var client = createApolloClient(uri, accessToken, serviceOptions);
                    return client
                        .mutate({
                        mutation: normalizedMutation,
                        variables: variables,
                    })
                        .catch(function (error) {
                        maybePerformDefaultErrorHandling(error, serviceName, mutateOptions.skipDefaultErrorHandling);
                        throw error; // Re-throw the error to propagate it further if needed
                    });
                });
            },
        };
        return graphQlService;
    },
};
var templateObject_1$K, templateObject_2$x;

var getNavigationItemsQuery = "query NavigationItems {\n  NavigationItems\n}";

var getNavigationItems = function () {
    return getNavigationItemsHelper(graphqlServiceFactory);
};
var getNavigationItemsHelper = function (graphqlFactory) {
    return function (dispatch) {
        return graphqlFactory
            .getGraphQlObject(NAVIGATION_SERVICE)
            .query(getNavigationItemsQuery, {}, { retry: { times: 10, delay: 1000 } })
            .then(function (result) {
            var navigationAction = {
                type: "navigation/loadNavigationItems" /* LoadNavigationItems */,
                items: result.data.NavigationItems,
            };
            dispatch(navigationAction);
            return Promise.resolve();
        })
            .catch(function (error) {
            global.console.warn("Could not retrieve navigation Items. Loading default navigation items.", error);
            var navigationAction = {
                type: "navigation/loadDefaultNavigationItems" /* LoadDefaultNavigationItems */,
            };
            dispatch(navigationAction);
        });
    };
};
var routeToLink = function (link, history) {
    return function (dispatch, getState) {
        var applicationState = getState();
        // If the link we're routing to is the same as the current location path, just refresh the page.
        // if it is a mobile cordova app, just close the drawer without refreshing the page.
        if (!isCordovaDevice() &&
            link === applicationState.router.location.pathname) {
            history.go(0);
        }
        else {
            dispatch(connectedReactRouter.push(link));
        }
        return Promise.resolve();
    };
};

function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var propTypes = {exports: {}};

var reactIs$1 = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
	reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
	reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;
	return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development.AsyncMode = AsyncMode;
	reactIs_development.ConcurrentMode = ConcurrentMode;
	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

var hasRequiredReactIs;

function requireReactIs () {
	if (hasRequiredReactIs) return reactIs$1.exports;
	hasRequiredReactIs = 1;

	if (process.env.NODE_ENV === 'production') {
	  reactIs$1.exports = requireReactIs_production_min();
	} else {
	  reactIs$1.exports = requireReactIs_development();
	}
	return reactIs$1.exports;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has;
	hasRequiredHas = 1;
	has = Function.call.bind(Object.prototype.hasOwnProperty);
	return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = requireReactIs();
	var assign = require$$1__default.default;

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var has = requireHas();
	var checkPropTypes = requireCheckPropTypes();

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}

var propTypesExports = propTypes.exports;
var PropTypes = /*@__PURE__*/getDefaultExportFromCjs(propTypesExports);

function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}

function chainPropTypes(propType1, propType2) {
  if (process.env.NODE_ENV === 'production') {
    return function () {
      return null;
    };
  }

  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}

function _typeof$2(obj) {
  "@babel/helpers - typeof";

  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof$2(obj);
}

function isPlainObject(item) {
  return item && _typeof$2(item) === 'object' && item.constructor === Object;
}
function deepmerge(target, source) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    clone: true
  };
  var output = options.clone ? _extends$1({}, target) : target;

  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(function (key) {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }

      if (isPlainObject(source[key]) && key in target) {
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
}

function isClassComponent(elementType) {
  // elementType.prototype?.isReactComponent
  var _elementType$prototyp = elementType.prototype,
      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
  return Boolean(prototype.isReactComponent);
}

function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var safePropName = propFullName || propName;

  if (propValue == null) {
    return null;
  }

  var warningHint;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */

  if (typeof propValue === 'function' && !isClassComponent(propValue)) {
    warningHint = 'Did you accidentally provide a plain function component instead?';
  }

  if (warningHint !== undefined) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element type that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://mui.com/r/caveat-with-refs-guide');
  }

  return null;
}

var elementTypeAcceptingRef$1 = chainPropTypes(propTypesExports.elementType, elementTypeAcceptingRef);

function _toPrimitive(input, hint) {
  if (_typeof$2(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof$2(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof$2(key) === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
// Only exported for test purposes.
var specialProperty = "exact-prop: \u200B";
function exactProp(propTypes) {
  if (process.env.NODE_ENV === 'production') {
    return propTypes;
  }

  return _extends$1({}, propTypes, _defineProperty({}, specialProperty, function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });

    if (unsupportedProps.length > 0) {
      return new Error("The following props are not supported: ".concat(unsupportedProps.map(function (prop) {
        return "`".concat(prop, "`");
      }).join(', '), ". Please remove them."));
    }

    return null;
  }));
}

var reactIsExports = requireReactIs();

// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3

var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  var match = "".concat(fn).match(fnNameMatchRegex);
  var name = match && match[1];
  return name || '';
}
/**
 * @param {function} Component
 * @param {string} fallback
 * @returns {string | undefined}
 */

function getFunctionComponentName(Component) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName with added IE 11 support
 *
 * @param {React.ReactType} Component
 * @returns {string | undefined}
 */


function getDisplayName(Component) {
  if (Component == null) {
    return undefined;
  }

  if (typeof Component === 'string') {
    return Component;
  }

  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  }

  if (_typeof$2(Component) === 'object') {
    switch (Component.$$typeof) {
      case reactIsExports.ForwardRef:
        return getWrappedName(Component, Component.render, 'ForwardRef');

      case reactIsExports.Memo:
        return getWrappedName(Component, Component.type, 'memo');

      default:
        return undefined;
    }
  }

  return undefined;
}

function HTMLElementType(props, propName, componentName, location, propFullName) {
  if (process.env.NODE_ENV === 'production') {
    return null;
  }

  var propValue = props[propName];
  var safePropName = propFullName || propName;

  if (propValue == null) {
    return null;
  }

  if (propValue && propValue.nodeType !== 1) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an HTMLElement.");
  }

  return null;
}

var refType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);
var refType$1 = refType;

var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var nested = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */

var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js

function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$disableGloba = options.disableGlobal,
      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
      _options$seed = options.seed,
      seed = _options$seed === void 0 ? '' : _options$seed;
  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
  var ruleCounter = 0;

  var getNextCounterId = function getNextCounterId() {
    ruleCounter += 1;

    if (process.env.NODE_ENV !== 'production') {
      if (ruleCounter >= 1e10) {
        console.warn(['Material-UI: You might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join(''));
      }
    }

    return ruleCounter;
  };

  return function (rule, styleSheet) {
    var name = styleSheet.options.name; // Is a global static MUI style?

    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
      // We can use a shorthand class name, we never use the keys to style the components.
      if (pseudoClasses.indexOf(rule.key) !== -1) {
        return "Mui-".concat(rule.key);
      }

      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);

      if (!styleSheet.options.theme[nested] || seed !== '') {
        return prefix;
      }

      return "".concat(prefix, "-").concat(getNextCounterId());
    }

    if (process.env.NODE_ENV === 'production') {
      return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    }

    var suffix = "".concat(rule.key, "-").concat(getNextCounterId()); // Help with debuggability.

    if (styleSheet.options.classNamePrefix) {
      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
    }

    return "".concat(seedPrefix).concat(suffix);
  };
}

/* eslint-disable no-restricted-syntax */
function getThemeProps(params) {
  var theme = params.theme,
      name = params.name,
      props = params.props;

  if (!theme || !theme.props || !theme.props[name]) {
    return props;
  } // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221


  var defaultProps = theme.props[name];
  var propName;

  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }

  return props;
}

var isProduction = process.env.NODE_ENV === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

var _typeof$1 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser$1 = (typeof window === "undefined" ? "undefined" : _typeof$1(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof$1(document)) === 'object' && document.nodeType === 9;

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf$1(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$1(subClass, superClass);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
  if (style == null || typeof style !== 'object') return style;
  if (Array.isArray(style)) return style.map(cloneStyle);
  if (style.constructor !== plainObjectConstrurctor) return style;
  var newStyle = {};

  for (var name in style) {
    newStyle[name] = cloneStyle(style[name]);
  }

  return newStyle;
}

/**
 * Create a rule instance.
 */

function createRule(name, decl, options) {
  if (name === void 0) {
    name = 'unnamed';
  }

  var jss = options.jss;
  var declCopy = cloneStyle(decl);
  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule; // It is an at-rule and it has no instance.

  if (name[0] === '@') {
    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Unknown rule " + name) : void 0;
  }

  return null;
}

var join = function join(value, by) {
  var result = '';

  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }

  return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */


var toCssValue = function toCssValue(value) {
  if (!Array.isArray(value)) return value;
  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.

  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', '); // Add !important, because it was ignored.


  if (value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
};

function getWhitespaceSymbols(options) {
  if (options && options.format === false) {
    return {
      linebreak: '',
      space: ''
    };
  }

  return {
    linebreak: '\n',
    space: ' '
  };
}

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */

function indentStr(str, indent) {
  var result = '';

  for (var index = 0; index < indent; index++) {
    result += '  ';
  }

  return result + str;
}
/**
 * Converts a Rule to CSS string.
 */


function toCss(selector, style, options) {
  if (options === void 0) {
    options = {};
  }

  var result = '';
  if (!style) return result;
  var _options = options,
      _options$indent = _options.indent,
      indent = _options$indent === void 0 ? 0 : _options$indent;
  var fallbacks = style.fallbacks;

  if (options.format === false) {
    indent = -Infinity;
  }

  var _getWhitespaceSymbols = getWhitespaceSymbols(options),
      linebreak = _getWhitespaceSymbols.linebreak,
      space = _getWhitespaceSymbols.space;

  if (selector) indent++; // Apply fallbacks first.

  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];

        for (var prop in fallback) {
          var value = fallback[prop];

          if (value != null) {
            if (result) result += linebreak;
            result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];

        if (_value != null) {
          if (result) result += linebreak;
          result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];

    if (_value2 != null && _prop2 !== 'fallbacks') {
      if (result) result += linebreak;
      result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
    }
  } // Allow empty style in this case, because properties will be added dynamically.


  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.

  if (!selector) return result;
  indent--;
  if (result) result = "" + linebreak + result + linebreak;
  return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}

var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = (function (str) {
  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
});

var BaseStyleRule =
/*#__PURE__*/
function () {
  function BaseStyleRule(key, style, options) {
    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
        Renderer = options.Renderer;
    this.key = key;
    this.options = options;
    this.style = style;
    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
  }
  /**
   * Get or set a style property.
   */


  var _proto = BaseStyleRule.prototype;

  _proto.prop = function prop(name, value, options) {
    // It's a getter.
    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.

    var force = options ? options.force : false;
    if (!force && this.style[name] === value) return this;
    var newValue = value;

    if (!options || options.process !== false) {
      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
    }

    var isEmpty = newValue == null || newValue === false;
    var isDefined = name in this.style; // Value is empty and wasn't defined before.

    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.

    var remove = isEmpty && isDefined;
    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.

    if (this.renderable && this.renderer) {
      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
      return this;
    }

    var sheet = this.options.sheet;

    if (sheet && sheet.attached) {
      process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Rule is not linked. Missing sheet option "link: true".') : void 0;
    }

    return this;
  };

  return BaseStyleRule;
}();
var StyleRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  _inheritsLoose(StyleRule, _BaseStyleRule);

  function StyleRule(key, style, options) {
    var _this;

    _this = _BaseStyleRule.call(this, key, style, options) || this;
    var selector = options.selector,
        scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;

    if (selector) {
      _this.selectorText = selector;
    } else if (scoped !== false) {
      _this.id = generateId(_assertThisInitialized(_assertThisInitialized(_this)), sheet);
      _this.selectorText = "." + escape(_this.id);
    }

    return _this;
  }
  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  var _proto2 = StyleRule.prototype;

  /**
   * Apply rule to an element inline.
   */
  _proto2.applyTo = function applyTo(renderable) {
    var renderer = this.renderer;

    if (renderer) {
      var json = this.toJSON();

      for (var prop in json) {
        renderer.setProperty(renderable, prop, json[prop]);
      }
    }

    return this;
  }
  /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */
  ;

  _proto2.toJSON = function toJSON() {
    var json = {};

    for (var prop in this.style) {
      var value = this.style[prop];
      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
    }

    return json;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto2.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? _extends$1({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.selectorText, this.style, opts);
  };

  _createClass(StyleRule, [{
    key: "selector",
    set: function set(selector) {
      if (selector === this.selectorText) return;
      this.selectorText = selector;
      var renderer = this.renderer,
          renderable = this.renderable;
      if (!renderable || !renderer) return;
      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.

      if (!hasChanged) {
        renderer.replaceRule(renderable, this);
      }
    }
    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') {
      return null;
    }

    return new StyleRule(key, style, options);
  }
};

var defaultToStringOptions = {
  indent: 1,
  children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */

var ConditionalRule =
/*#__PURE__*/
function () {
  function ConditionalRule(key, styles, options) {
    this.type = 'conditional';
    this.isProcessed = false;
    this.key = key;
    var atMatch = key.match(atRegExp);
    this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.

    this.query = options.name || "@" + this.at;
    this.options = options;
    this.rules = new RuleList(_extends$1({}, options, {
      parent: this
    }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = ConditionalRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Replace rule, run plugins.
   */
  ;

  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions;
    }

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (options.indent == null) options.indent = defaultToStringOptions.indent;
    if (options.children == null) options.children = defaultToStringOptions.children;

    if (options.children === false) {
      return this.query + " {}";
    }

    var children = this.rules.toString(options);
    return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
  };

  return ConditionalRule;
}();
var keyRegExp = /@container|@media|@supports\s+/;
var pluginConditionalRule = {
  onCreateRule: function onCreateRule(key, styles, options) {
    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
  }
};

var defaultToStringOptions$1 = {
  indent: 1,
  children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */

var KeyframesRule =
/*#__PURE__*/
function () {
  function KeyframesRule(key, frames, options) {
    this.type = 'keyframes';
    this.at = '@keyframes';
    this.isProcessed = false;
    var nameMatch = key.match(nameRegExp);

    if (nameMatch && nameMatch[1]) {
      this.name = nameMatch[1];
    } else {
      this.name = 'noname';
      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Bad keyframes name " + key) : void 0;
    }

    this.key = this.type + "-" + this.name;
    this.options = options;
    var scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;
    this.id = scoped === false ? this.name : escape(generateId(this, sheet));
    this.rules = new RuleList(_extends$1({}, options, {
      parent: this
    }));

    for (var name in frames) {
      this.rules.add(name, frames[name], _extends$1({}, options, {
        parent: this
      }));
    }

    this.rules.process();
  }
  /**
   * Generates a CSS string.
   */


  var _proto = KeyframesRule.prototype;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions$1;
    }

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
    if (options.children == null) options.children = defaultToStringOptions$1.children;

    if (options.children === false) {
      return this.at + " " + this.id + " {}";
    }

    var children = this.rules.toString(options);
    if (children) children = "" + linebreak + children + linebreak;
    return this.at + " " + this.id + " {" + children + "}";
  };

  return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp$1 = /\$([\w-]+)/g;

var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
  if (typeof val === 'string') {
    return val.replace(refRegExp$1, function (match, name) {
      if (name in keyframes) {
        return keyframes[name];
      }

      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Referenced keyframes rule \"" + name + "\" is not defined.") : void 0;
      return match;
    });
  }

  return val;
};
/**
 * Replace the reference for a animation name.
 */


var replaceRef = function replaceRef(style, prop, keyframes) {
  var value = style[prop];
  var refKeyframe = findReferencedKeyframe(value, keyframes);

  if (refKeyframe !== value) {
    style[prop] = refKeyframe;
  }
};

var pluginKeyframesRule = {
  onCreateRule: function onCreateRule(key, frames, options) {
    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style' || !sheet) return style;
    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
    return style;
  },
  onChangeValue: function onChangeValue(val, prop, rule) {
    var sheet = rule.options.sheet;

    if (!sheet) {
      return val;
    }

    switch (prop) {
      case 'animation':
        return findReferencedKeyframe(val, sheet.keyframes);

      case 'animation-name':
        return findReferencedKeyframe(val, sheet.keyframes);

      default:
        return val;
    }
  }
};

var KeyframeRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  _inheritsLoose(KeyframeRule, _BaseStyleRule);

  function KeyframeRule() {
    return _BaseStyleRule.apply(this, arguments) || this;
  }

  var _proto = KeyframeRule.prototype;

  /**
   * Generates a CSS string.
   */
  _proto.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? _extends$1({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.key, this.style, opts);
  };

  return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (options.parent && options.parent.type === 'keyframes') {
      return new KeyframeRule(key, style, options);
    }

    return null;
  }
};

var FontFaceRule =
/*#__PURE__*/
function () {
  function FontFaceRule(key, style, options) {
    this.type = 'font-face';
    this.at = '@font-face';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = FontFaceRule.prototype;

  _proto.toString = function toString(options) {
    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (Array.isArray(this.style)) {
      var str = '';

      for (var index = 0; index < this.style.length; index++) {
        str += toCss(this.at, this.style[index]);
        if (this.style[index + 1]) str += linebreak;
      }

      return str;
    }

    return toCss(this.at, this.style, options);
  };

  return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
  }
};

var ViewportRule =
/*#__PURE__*/
function () {
  function ViewportRule(key, style, options) {
    this.type = 'viewport';
    this.at = '@viewport';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = ViewportRule.prototype;

  _proto.toString = function toString(options) {
    return toCss(this.key, this.style, options);
  };

  return ViewportRule;
}();
var pluginViewportRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
  }
};

var SimpleRule =
/*#__PURE__*/
function () {
  function SimpleRule(key, value, options) {
    this.type = 'simple';
    this.isProcessed = false;
    this.key = key;
    this.value = value;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  var _proto = SimpleRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.value)) {
      var str = '';

      for (var index = 0; index < this.value.length; index++) {
        str += this.key + " " + this.value[index] + ";";
        if (this.value[index + 1]) str += '\n';
      }

      return str;
    }

    return this.key + " " + this.value + ";";
  };

  return SimpleRule;
}();
var keysMap = {
  '@charset': true,
  '@import': true,
  '@namespace': true
};
var pluginSimpleRule = {
  onCreateRule: function onCreateRule(key, value, options) {
    return key in keysMap ? new SimpleRule(key, value, options) : null;
  }
};

var plugins$1 = [pluginStyleRule, pluginConditionalRule, pluginKeyframesRule, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];

var defaultUpdateOptions = {
  process: true
};
var forceUpdateOptions = {
  force: true,
  process: true
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */

};

var RuleList =
/*#__PURE__*/
function () {
  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.
  // Original styles object.
  // Used to ensure correct rules order.
  function RuleList(options) {
    this.map = {};
    this.raw = {};
    this.index = [];
    this.counter = 0;
    this.options = options;
    this.classes = options.classes;
    this.keyframes = options.keyframes;
  }
  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  var _proto = RuleList.prototype;

  _proto.add = function add(name, decl, ruleOptions) {
    var _this$options = this.options,
        parent = _this$options.parent,
        sheet = _this$options.sheet,
        jss = _this$options.jss,
        Renderer = _this$options.Renderer,
        generateId = _this$options.generateId,
        scoped = _this$options.scoped;

    var options = _extends$1({
      classes: this.classes,
      parent: parent,
      sheet: sheet,
      jss: jss,
      Renderer: Renderer,
      generateId: generateId,
      scoped: scoped,
      name: name,
      keyframes: this.keyframes,
      selector: undefined
    }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
    // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
    // we need to make the key unique within this RuleList instance scope.


    var key = name;

    if (name in this.raw) {
      key = name + "-d" + this.counter++;
    } // We need to save the original decl before creating the rule
    // because cache plugin needs to use it as a key to return a cached rule.


    this.raw[key] = decl;

    if (key in this.classes) {
      // E.g. rules inside of @media container
      options.selector = "." + escape(this.classes[key]);
    }

    var rule = createRule(key, decl, options);
    if (!rule) return null;
    this.register(rule);
    var index = options.index === undefined ? this.index.length : options.index;
    this.index.splice(index, 0, rule);
    return rule;
  }
  /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */
  ;

  _proto.replace = function replace(name, decl, ruleOptions) {
    var oldRule = this.get(name);
    var oldIndex = this.index.indexOf(oldRule);

    if (oldRule) {
      this.remove(oldRule);
    }

    var options = ruleOptions;
    if (oldIndex !== -1) options = _extends$1({}, ruleOptions, {
      index: oldIndex
    });
    return this.add(name, decl, options);
  }
  /**
   * Get a rule by name or selector.
   */
  ;

  _proto.get = function get(nameOrSelector) {
    return this.map[nameOrSelector];
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.remove = function remove(rule) {
    this.unregister(rule);
    delete this.raw[rule.key];
    this.index.splice(this.index.indexOf(rule), 1);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.index.indexOf(rule);
  }
  /**
   * Run `onProcessRule()` plugins on every rule.
   */
  ;

  _proto.process = function process() {
    var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
    // we end up with very hard-to-track-down side effects.

    this.index.slice(0).forEach(plugins.onProcessRule, plugins);
  }
  /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */
  ;

  _proto.register = function register(rule) {
    this.map[rule.key] = rule;

    if (rule instanceof StyleRule) {
      this.map[rule.selector] = rule;
      if (rule.id) this.classes[rule.key] = rule.id;
    } else if (rule instanceof KeyframesRule && this.keyframes) {
      this.keyframes[rule.name] = rule.id;
    }
  }
  /**
   * Unregister a rule.
   */
  ;

  _proto.unregister = function unregister(rule) {
    delete this.map[rule.key];

    if (rule instanceof StyleRule) {
      delete this.map[rule.selector];
      delete this.classes[rule.key];
    } else if (rule instanceof KeyframesRule) {
      delete this.keyframes[rule.name];
    }
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var name;
    var data;
    var options;

    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
      name = arguments.length <= 0 ? undefined : arguments[0];
      data = arguments.length <= 1 ? undefined : arguments[1];
      options = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      data = arguments.length <= 0 ? undefined : arguments[0];
      options = arguments.length <= 1 ? undefined : arguments[1];
      name = null;
    }

    if (name) {
      this.updateOne(this.get(name), data, options);
    } else {
      for (var index = 0; index < this.index.length; index++) {
        this.updateOne(this.index[index], data, options);
      }
    }
  }
  /**
   * Execute plugins, update rule props.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    if (options === void 0) {
      options = defaultUpdateOptions;
    }

    var _this$options2 = this.options,
        plugins = _this$options2.jss.plugins,
        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.

    if (rule.rules instanceof RuleList) {
      rule.rules.update(data, options);
      return;
    }

    var style = rule.style;
    plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.

    if (options.process && style && style !== rule.style) {
      // We need to run the plugins in case new `style` relies on syntax plugins.
      plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.

      for (var prop in rule.style) {
        var nextValue = rule.style[prop];
        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (nextValue !== prevValue) {
          rule.prop(prop, nextValue, forceUpdateOptions);
        }
      } // Remove props.


      for (var _prop in style) {
        var _nextValue = rule.style[_prop];
        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (_nextValue == null && _nextValue !== _prevValue) {
          rule.prop(_prop, null, forceUpdateOptions);
        }
      }
    }
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    var str = '';
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    for (var index = 0; index < this.index.length; index++) {
      var rule = this.index[index];
      var css = rule.toString(options); // No need to render an empty rule.

      if (!css && !link) continue;
      if (str) str += linebreak;
      str += css;
    }

    return str;
  };

  return RuleList;
}();

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(styles, options) {
    this.attached = false;
    this.deployed = false;
    this.classes = {};
    this.keyframes = {};
    this.options = _extends$1({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    });

    if (options.Renderer) {
      this.renderer = new options.Renderer(this);
    }

    this.rules = new RuleList(this.options);

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Attach renderable to the render tree.
   */


  var _proto = StyleSheet.prototype;

  _proto.attach = function attach() {
    if (this.attached) return this;
    if (this.renderer) this.renderer.attach();
    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.

    if (!this.deployed) this.deploy();
    return this;
  }
  /**
   * Remove renderable from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.attached) return this;
    if (this.renderer) this.renderer.detach();
    this.attached = false;
    return this;
  }
  /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */
  ;

  _proto.addRule = function addRule(name, decl, options) {
    var queue = this.queue; // Plugins can create rules.
    // In order to preserve the right order, we need to queue all `.addRule` calls,
    // which happen after the first `rules.add()` call.

    if (this.attached && !queue) this.queue = [];
    var rule = this.rules.add(name, decl, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);

    if (this.attached) {
      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (queue) queue.push(rule);else {
        this.insertRule(rule);

        if (this.queue) {
          this.queue.forEach(this.insertRule, this);
          this.queue = undefined;
        }
      }
      return rule;
    } // We can't add rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return rule;
  }
  /**
   * Replace a rule in the current stylesheet.
   */
  ;

  _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
    var oldRule = this.rules.get(nameOrSelector);
    if (!oldRule) return this.addRule(nameOrSelector, decl, options);
    var newRule = this.rules.replace(nameOrSelector, decl, options);

    if (newRule) {
      this.options.jss.plugins.onProcessRule(newRule);
    }

    if (this.attached) {
      if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (this.renderer) {
        if (!newRule) {
          this.renderer.deleteRule(oldRule);
        } else if (oldRule.renderable) {
          this.renderer.replaceRule(oldRule.renderable, newRule);
        }
      }

      return newRule;
    } // We can't replace rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return newRule;
  }
  /**
   * Insert rule into the StyleSheet
   */
  ;

  _proto.insertRule = function insertRule(rule) {
    if (this.renderer) {
      this.renderer.insertRule(rule);
    }
  }
  /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */
  ;

  _proto.addRules = function addRules(styles, options) {
    var added = [];

    for (var name in styles) {
      var rule = this.addRule(name, styles[name], options);
      if (rule) added.push(rule);
    }

    return added;
  }
  /**
   * Get a rule by name or selector.
   */
  ;

  _proto.getRule = function getRule(nameOrSelector) {
    return this.rules.get(nameOrSelector);
  }
  /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */
  ;

  _proto.deleteRule = function deleteRule(name) {
    var rule = typeof name === 'object' ? name : this.rules.get(name);

    if (!rule || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !rule.renderable) {
      return false;
    }

    this.rules.remove(rule);

    if (this.attached && rule.renderable && this.renderer) {
      return this.renderer.deleteRule(rule.renderable);
    }

    return true;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Deploy pure CSS string to a renderable.
   */
  ;

  _proto.deploy = function deploy() {
    if (this.renderer) this.renderer.deploy();
    this.deployed = true;
    return this;
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var _this$rules;

    (_this$rules = this.rules).update.apply(_this$rules, arguments);

    return this;
  }
  /**
   * Updates a single rule.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    this.rules.updateOne(rule, data, options);
    return this;
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return StyleSheet;
}();

var PluginsRegistry =
/*#__PURE__*/
function () {
  function PluginsRegistry() {
    this.plugins = {
      internal: [],
      external: []
    };
    this.registry = {};
  }

  var _proto = PluginsRegistry.prototype;

  /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */
  _proto.onCreateRule = function onCreateRule(name, decl, options) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var rule = this.registry.onCreateRule[i](name, decl, options);
      if (rule) return rule;
    }

    return null;
  }
  /**
   * Call `onProcessRule` hooks.
   */
  ;

  _proto.onProcessRule = function onProcessRule(rule) {
    if (rule.isProcessed) return;
    var sheet = rule.options.sheet;

    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
      this.registry.onProcessRule[i](rule, sheet);
    }

    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
    rule.isProcessed = true;
  }
  /**
   * Call `onProcessStyle` hooks.
   */
  ;

  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    }
  }
  /**
   * Call `onProcessSheet` hooks.
   */
  ;

  _proto.onProcessSheet = function onProcessSheet(sheet) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
      this.registry.onProcessSheet[i](sheet);
    }
  }
  /**
   * Call `onUpdate` hooks.
   */
  ;

  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
    for (var i = 0; i < this.registry.onUpdate.length; i++) {
      this.registry.onUpdate[i](data, rule, sheet, options);
    }
  }
  /**
   * Call `onChangeValue` hooks.
   */
  ;

  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
    var processedValue = value;

    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
    }

    return processedValue;
  }
  /**
   * Register a plugin.
   */
  ;

  _proto.use = function use(newPlugin, options) {
    if (options === void 0) {
      options = {
        queue: 'external'
      };
    }

    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.

    if (plugins.indexOf(newPlugin) !== -1) {
      return;
    }

    plugins.push(newPlugin);
    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
      for (var name in plugin) {
        if (name in registry) {
          registry[name].push(plugin[name]);
        } else {
          process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Unknown hook \"" + name + "\".") : void 0;
        }
      }

      return registry;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    });
  };

  return PluginsRegistry;
}();

/**
 * Sheets registry to access all instances in one place.
 */

var SheetsRegistry =
/*#__PURE__*/
function () {
  function SheetsRegistry() {
    this.registry = [];
  }

  var _proto = SheetsRegistry.prototype;

  /**
   * Register a Style Sheet.
   */
  _proto.add = function add(sheet) {
    var registry = this.registry;
    var index = sheet.options.index;
    if (registry.indexOf(sheet) !== -1) return;

    if (registry.length === 0 || index >= this.index) {
      registry.push(sheet);
      return;
    } // Find a position.


    for (var i = 0; i < registry.length; i++) {
      if (registry[i].options.index > index) {
        registry.splice(i, 0, sheet);
        return;
      }
    }
  }
  /**
   * Reset the registry.
   */
  ;

  _proto.reset = function reset() {
    this.registry = [];
  }
  /**
   * Remove a Style Sheet.
   */
  ;

  _proto.remove = function remove(sheet) {
    var index = this.registry.indexOf(sheet);
    this.registry.splice(index, 1);
  }
  /**
   * Convert all attached sheets to a CSS string.
   */
  ;

  _proto.toString = function toString(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        attached = _ref.attached,
        options = _objectWithoutPropertiesLoose(_ref, ["attached"]);

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    var css = '';

    for (var i = 0; i < this.registry.length; i++) {
      var sheet = this.registry[i];

      if (attached != null && sheet.attached !== attached) {
        continue;
      }

      if (css) css += linebreak;
      css += sheet.toString(options);
    }

    return css;
  };

  _createClass(SheetsRegistry, [{
    key: "index",

    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */

var sheets = new SheetsRegistry();

/* eslint-disable */

/**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */
var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();

var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.

var moduleId$1 = globalThis$1[ns]++;

var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

var createGenerateId = function createGenerateId(options) {
  if (options === void 0) {
    options = {};
  }

  var ruleCounter = 0;

  var generateId = function generateId(rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".") : void 0;
    }

    var jssId = '';
    var prefix = '';

    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix = sheet.options.classNamePrefix;
      }

      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }

    if (options.minify) {
      // Using "c" because a number can't be the first char in a class name.
      return "" + (prefix || 'c') + moduleId$1 + jssId + ruleCounter;
    }

    return prefix + rule.key + "-" + moduleId$1 + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
  };

  return generateId;
};

/**
 * Cache the value from the first time a function is called.
 */

var memoize = function memoize(fn) {
  var value;
  return function () {
    if (!value) value = fn();
    return value;
  };
};
/**
 * Get a style property value.
 */


var getPropertyValue = function getPropertyValue(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      return cssRule.attributeStyleMap.get(prop);
    }

    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
};
/**
 * Set a style property.
 */


var setProperty = function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = toCssValue(value);
    } // Support CSSTOM.


    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.set(prop, cssValue);
    } else {
      var indexOfImportantFlag = cssValue ? cssValue.indexOf('!important') : -1;
      var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
      cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? 'important' : '');
    }
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }

  return true;
};
/**
 * Remove a style property.
 */


var removeProperty = function removeProperty(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.delete(prop);
    } else {
      cssRule.style.removeProperty(prop);
    }
  } catch (err) {
    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] DOMException \"" + err.message + "\" was thrown. Tried to remove property \"" + prop + "\".") : void 0;
  }
};
/**
 * Set the selector.
 */


var setSelector = function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText; // Return false if setter was not successful.
  // Currently works in chrome only.

  return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */


var getHead = memoize(function () {
  return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */

function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find attached sheet with the highest index.
 */


function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find a comment with "jss" inside.
 */


function findCommentNode(text) {
  var head = getHead();

  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];

    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }

  return null;
}
/**
 * Find a node before which we can insert the sheet.
 */


function findPrevNode(options) {
  var registry = sheets.registry;

  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element
      };
    } // Otherwise insert after the last attached.


    sheet = findHighestSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element.nextSibling
      };
    }
  } // Try to find a comment placeholder if registry is empty.


  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);

    if (comment) {
      return {
        parent: comment.parentNode,
        node: comment.nextSibling
      };
    } // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.


    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Insertion point \"" + insertionPoint + "\" not found.") : void 0;
  }

  return false;
}
/**
 * Insert style element into the DOM.
 */


function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;
  var nextNode = findPrevNode(options);

  if (nextNode !== false && nextNode.parent) {
    nextNode.parent.insertBefore(style, nextNode.node);
    return;
  } // Works with iframes and any node types.


  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    var insertionPointElement = insertionPoint;
    var parentNode = insertionPointElement.parentNode;
    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Insertion point is not in the DOM.') : void 0;
    return;
  }

  getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */


var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var _insertRule = function insertRule(container, rule, index) {
  try {
    if ('insertRule' in container) {
      container.insertRule(rule, index);
    } // Keyframes rule.
    else if ('appendRule' in container) {
        container.appendRule(rule);
      }
  } catch (err) {
    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] " + err.message) : void 0;
    return false;
  }

  return container.cssRules[index];
};

var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong

  if (index === undefined || index > maxIndex) {
    // eslint-disable-next-line no-param-reassign
    return maxIndex;
  }

  return index;
};

var createStyle = function createStyle() {
  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
  // insert rules after we insert the style tag.
  // It seems to kick-off the source order specificity algorithm.

  el.textContent = '\n';
  return el;
};

var DomRenderer =
/*#__PURE__*/
function () {
  // Will be empty if link: true option is not set, because
  // it is only for use together with insertRule API.
  function DomRenderer(sheet) {
    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.hasInsertedRules = false;
    this.cssRules = [];
    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) sheets.add(sheet);
    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || createStyle();
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }
  /**
   * Insert style element into render tree.
   */


  var _proto = DomRenderer.prototype;

  _proto.attach = function attach() {
    // In the case the element node is external and it is already in the DOM.
    if (this.element.parentNode || !this.sheet) return;
    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
    // most browsers create a new CSSStyleSheet, except of all IEs.

    var deployed = Boolean(this.sheet && this.sheet.deployed);

    if (this.hasInsertedRules && deployed) {
      this.hasInsertedRules = false;
      this.deploy();
    }
  }
  /**
   * Remove style element from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.sheet) return;
    var parentNode = this.element.parentNode;
    if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
    // Though IE will keep them and we need a consistent behavior.

    if (this.sheet.options.link) {
      this.cssRules = [];
      this.element.textContent = '\n';
    }
  }
  /**
   * Inject CSS string into element.
   */
  ;

  _proto.deploy = function deploy() {
    var sheet = this.sheet;
    if (!sheet) return;

    if (sheet.options.link) {
      this.insertRules(sheet.rules);
      return;
    }

    this.element.textContent = "\n" + sheet.toString() + "\n";
  }
  /**
   * Insert RuleList into an element.
   */
  ;

  _proto.insertRules = function insertRules(rules, nativeParent) {
    for (var i = 0; i < rules.index.length; i++) {
      this.insertRule(rules.index[i], i, nativeParent);
    }
  }
  /**
   * Insert a rule into element.
   */
  ;

  _proto.insertRule = function insertRule(rule, index, nativeParent) {
    if (nativeParent === void 0) {
      nativeParent = this.element.sheet;
    }

    if (rule.rules) {
      var parent = rule;
      var latestNativeParent = nativeParent;

      if (rule.type === 'conditional' || rule.type === 'keyframes') {
        var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.


        latestNativeParent = _insertRule(nativeParent, parent.toString({
          children: false
        }), _insertionIndex);

        if (latestNativeParent === false) {
          return false;
        }

        this.refCssRule(rule, _insertionIndex, latestNativeParent);
      }

      this.insertRules(parent.rules, latestNativeParent);
      return latestNativeParent;
    }

    var ruleStr = rule.toString();
    if (!ruleStr) return false;
    var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);

    var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);

    if (nativeRule === false) {
      return false;
    }

    this.hasInsertedRules = true;
    this.refCssRule(rule, insertionIndex, nativeRule);
    return nativeRule;
  };

  _proto.refCssRule = function refCssRule(rule, index, cssRule) {
    rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
    // like rules inside media queries or keyframes

    if (rule.options.parent instanceof StyleSheet) {
      this.cssRules.splice(index, 0, cssRule);
    }
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.deleteRule = function deleteRule(cssRule) {
    var sheet = this.element.sheet;
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return true;
  }
  /**
   * Get index of a CSS Rule.
   */
  ;

  _proto.indexOf = function indexOf(cssRule) {
    return this.cssRules.indexOf(cssRule);
  }
  /**
   * Generate a new CSS rule and replace the existing one.
   */
  ;

  _proto.replaceRule = function replaceRule(cssRule, rule) {
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    this.element.sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return this.insertRule(rule, index);
  }
  /**
   * Get all rules elements.
   */
  ;

  _proto.getRules = function getRules() {
    return this.element.sheet.cssRules;
  };

  return DomRenderer;
}();

var instanceCounter = 0;

var Jss =
/*#__PURE__*/
function () {
  function Jss(options) {
    this.id = instanceCounter++;
    this.version = "10.10.0";
    this.plugins = new PluginsRegistry();
    this.options = {
      id: {
        minify: false
      },
      createGenerateId: createGenerateId,
      Renderer: isBrowser$1 ? DomRenderer : null,
      plugins: []
    };
    this.generateId = createGenerateId({
      minify: false
    });

    for (var i = 0; i < plugins$1.length; i++) {
      this.plugins.use(plugins$1[i], {
        queue: 'internal'
      });
    }

    this.setup(options);
  }
  /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */


  var _proto = Jss.prototype;

  _proto.setup = function setup(options) {
    if (options === void 0) {
      options = {};
    }

    if (options.createGenerateId) {
      this.options.createGenerateId = options.createGenerateId;
    }

    if (options.id) {
      this.options.id = _extends$1({}, this.options.id, options.id);
    }

    if (options.createGenerateId || options.id) {
      this.generateId = this.options.createGenerateId(this.options.id);
    }

    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;

    if ('Renderer' in options) {
      this.options.Renderer = options.Renderer;
    } // eslint-disable-next-line prefer-spread


    if (options.plugins) this.use.apply(this, options.plugins);
    return this;
  }
  /**
   * Create a Style Sheet.
   */
  ;

  _proto.createStyleSheet = function createStyleSheet(styles, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        index = _options.index;

    if (typeof index !== 'number') {
      index = sheets.index === 0 ? 0 : sheets.index + 1;
    }

    var sheet = new StyleSheet(styles, _extends$1({}, options, {
      jss: this,
      generateId: options.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: index
    }));
    this.plugins.onProcessSheet(sheet);
    return sheet;
  }
  /**
   * Detach the Style Sheet and remove it from the registry.
   */
  ;

  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
    sheet.detach();
    sheets.remove(sheet);
    return this;
  }
  /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */
  ;

  _proto.createRule = function createRule$1(name, style, options) {
    if (style === void 0) {
      style = {};
    }

    if (options === void 0) {
      options = {};
    }

    // Enable rule without name for inline styles.
    if (typeof name === 'object') {
      return this.createRule(undefined, name, style);
    }

    var ruleOptions = _extends$1({}, options, {
      name: name,
      jss: this,
      Renderer: this.options.Renderer
    });

    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
    if (!ruleOptions.classes) ruleOptions.classes = {};
    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};

    var rule = createRule(name, style, ruleOptions);

    if (rule) this.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */
  ;

  _proto.use = function use() {
    var _this = this;

    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }

    plugins.forEach(function (plugin) {
      _this.plugins.use(plugin);
    });
    return this;
  };

  return Jss;
}();

var createJss = function createJss(options) {
  return new Jss(options);
};

/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/
var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;

/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value;

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);

      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
createJss();

var now = Date.now();
var fnValuesNs = "fnValues" + now;
var fnRuleNs = "fnStyle" + ++now;

var functionPlugin = function functionPlugin() {
  return {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (typeof decl !== 'function') return null;
      var rule = createRule(name, {}, options);
      rule[fnRuleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle(style, rule) {
      // We need to extract function values from the declaration, so that we can keep core unaware of them.
      // We need to do that only once.
      // We don't need to extract functions on each style update, since this can happen only once.
      // We don't support function values inside of function rules.
      if (fnValuesNs in rule || fnRuleNs in rule) return style;
      var fnValues = {};

      for (var prop in style) {
        var value = style[prop];
        if (typeof value !== 'function') continue;
        delete style[prop];
        fnValues[prop] = value;
      }

      rule[fnValuesNs] = fnValues;
      return style;
    },
    onUpdate: function onUpdate(data, rule, sheet, options) {
      var styleRule = rule;
      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
      // will be returned from that function.

      if (fnRule) {
        // Empty object will remove all currently defined props
        // in case function rule returns a falsy value.
        styleRule.style = fnRule(data) || {};

        if (process.env.NODE_ENV === 'development') {
          for (var prop in styleRule.style) {
            if (typeof styleRule.style[prop] === 'function') {
              process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Function values inside function rules are not supported.') : void 0;
              break;
            }
          }
        }
      }

      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.

      if (fnValues) {
        for (var _prop in fnValues) {
          styleRule.prop(_prop, fnValues[_prop](data), options);
        }
      }
    }
  };
};

var functions = functionPlugin;

var at = '@global';
var atPrefix = '@global ';

var GlobalContainerRule =
/*#__PURE__*/
function () {
  function GlobalContainerRule(key, styles, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    this.rules = new RuleList(_extends$1({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = GlobalContainerRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (rule) this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Replace rule, run plugins.
   */
  ;

  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return GlobalContainerRule;
}();

var GlobalPrefixedRule =
/*#__PURE__*/
function () {
  function GlobalPrefixedRule(key, style, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    var selector = key.substr(atPrefix.length);
    this.rule = options.jss.createRule(selector, style, _extends$1({}, options, {
      parent: this
    }));
  }

  var _proto2 = GlobalPrefixedRule.prototype;

  _proto2.toString = function toString(options) {
    return this.rule ? this.rule.toString(options) : '';
  };

  return GlobalPrefixedRule;
}();

var separatorRegExp$1 = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp$1);
  var scoped = '';

  for (var i = 0; i < parts.length; i++) {
    scoped += scope + " " + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }

  return scoped;
}

function handleNestedGlobalContainerRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;
  var rules = style ? style[at] : null;
  if (!rules) return;

  for (var name in rules) {
    sheet.addRule(name, rules[name], _extends$1({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[at];
}

function handlePrefixedGlobalRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
    var selector = addScope(prop.substr(at.length), rule.selector);
    sheet.addRule(selector, style[prop], _extends$1({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */


function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (!name) return null;

    if (name === at) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;

    if (parent) {
      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
        options.scoped = false;
      }
    }

    if (!options.selector && options.scoped === false) {
      options.selector = name;
    }

    return null;
  }

  function onProcessRule(rule, sheet) {
    if (rule.type !== 'style' || !sheet) return;
    handleNestedGlobalContainerRule(rule, sheet);
    handlePrefixedGlobalRule(rule, sheet);
  }

  return {
    onCreateRule: onCreateRule,
    onProcessRule: onProcessRule
  };
}

var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */

function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container, sheet) {
    return function (match, key) {
      var rule = container.getRule(key) || sheet && sheet.getRule(key);

      if (rule) {
        return rule.selector;
      }

      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Could not find the referenced rule \"" + key + "\" in \"" + (container.options.meta || container.toString()) + "\".") : void 0;
      return key;
    };
  }

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);
    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.

        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, prevOptions) {
    // Options has been already created, now we only increase index.
    if (prevOptions) return _extends$1({}, prevOptions, {
      index: prevOptions.index + 1
    });
    var nestingLevel = rule.options.nestingLevel;
    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    var options = _extends$1({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.

    });

    delete options.name;
    return options;
  }

  function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style') return style;
    var styleRule = rule;
    var container = styleRule.options.parent;
    var options;
    var replaceRef;

    for (var prop in style) {
      var isNested = prop.indexOf('&') !== -1;
      var isNestedConditional = prop[0] === '@';
      if (!isNested && !isNestedConditional) continue;
      options = getOptions(styleRule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.

        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.

        selector = selector.replace(refRegExp, replaceRef);
        var name = styleRule.key + "-" + prop;

        if ('replaceRule' in container) {
          // for backward compatibility
          container.replaceRule(name, style[prop], _extends$1({}, options, {
            selector: selector
          }));
        } else {
          container.addRule(name, style[prop], _extends$1({}, options, {
            selector: selector
          }));
        }
      } else if (isNestedConditional) {
        // Place conditional right after the parent rule to ensure right ordering.
        container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
          selector: styleRule.selector
        });
      }

      delete style[prop];
    }

    return style;
  }

  return {
    onProcessStyle: onProcessStyle
  };
}

/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache$2 = {};

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache$2.hasOwnProperty(name)) {
    return cache$2[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower);
  return (cache$2[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/**
 * Convert camel cased property names to dash separated.
 */

function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    var key = prop.indexOf('--') === 0 ? prop : hyphenateStyleName(prop);
    converted[key] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */


function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }

      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    if (prop.indexOf('--') === 0) {
      return value;
    }

    var hyphenatedProp = hyphenateStyleName(prop); // There was no camel case in place

    if (prop === hyphenatedProp) return value;
    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.

    return null;
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

var px = hasCSSTOMSupport && CSS ? CSS.px : 'px';
var ms = hasCSSTOMSupport && CSS ? CSS.ms : 'ms';
var percent = hasCSSTOMSupport && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */

var defaultUnits = {
  // Animation properties
  'animation-delay': ms,
  'animation-duration': ms,
  // Background properties
  'background-position': px,
  'background-position-x': px,
  'background-position-y': px,
  'background-size': px,
  // Border Properties
  border: px,
  'border-bottom': px,
  'border-bottom-left-radius': px,
  'border-bottom-right-radius': px,
  'border-bottom-width': px,
  'border-left': px,
  'border-left-width': px,
  'border-radius': px,
  'border-right': px,
  'border-right-width': px,
  'border-top': px,
  'border-top-left-radius': px,
  'border-top-right-radius': px,
  'border-top-width': px,
  'border-width': px,
  'border-block': px,
  'border-block-end': px,
  'border-block-end-width': px,
  'border-block-start': px,
  'border-block-start-width': px,
  'border-block-width': px,
  'border-inline': px,
  'border-inline-end': px,
  'border-inline-end-width': px,
  'border-inline-start': px,
  'border-inline-start-width': px,
  'border-inline-width': px,
  'border-start-start-radius': px,
  'border-start-end-radius': px,
  'border-end-start-radius': px,
  'border-end-end-radius': px,
  // Margin properties
  margin: px,
  'margin-bottom': px,
  'margin-left': px,
  'margin-right': px,
  'margin-top': px,
  'margin-block': px,
  'margin-block-end': px,
  'margin-block-start': px,
  'margin-inline': px,
  'margin-inline-end': px,
  'margin-inline-start': px,
  // Padding properties
  padding: px,
  'padding-bottom': px,
  'padding-left': px,
  'padding-right': px,
  'padding-top': px,
  'padding-block': px,
  'padding-block-end': px,
  'padding-block-start': px,
  'padding-inline': px,
  'padding-inline-end': px,
  'padding-inline-start': px,
  // Mask properties
  'mask-position-x': px,
  'mask-position-y': px,
  'mask-size': px,
  // Width and height properties
  height: px,
  width: px,
  'min-height': px,
  'max-height': px,
  'min-width': px,
  'max-width': px,
  // Position properties
  bottom: px,
  left: px,
  top: px,
  right: px,
  inset: px,
  'inset-block': px,
  'inset-block-end': px,
  'inset-block-start': px,
  'inset-inline': px,
  'inset-inline-end': px,
  'inset-inline-start': px,
  // Shadow properties
  'box-shadow': px,
  'text-shadow': px,
  // Column properties
  'column-gap': px,
  'column-rule': px,
  'column-rule-width': px,
  'column-width': px,
  // Font and text properties
  'font-size': px,
  'font-size-delta': px,
  'letter-spacing': px,
  'text-decoration-thickness': px,
  'text-indent': px,
  'text-stroke': px,
  'text-stroke-width': px,
  'word-spacing': px,
  // Motion properties
  motion: px,
  'motion-offset': px,
  // Outline properties
  outline: px,
  'outline-offset': px,
  'outline-width': px,
  // Perspective properties
  perspective: px,
  'perspective-origin-x': percent,
  'perspective-origin-y': percent,
  // Transform properties
  'transform-origin': percent,
  'transform-origin-x': percent,
  'transform-origin-y': percent,
  'transform-origin-z': percent,
  // Transition properties
  'transition-delay': ms,
  'transition-duration': ms,
  // Alignment properties
  'vertical-align': px,
  'flex-basis': px,
  // Some random properties
  'shape-margin': px,
  size: px,
  gap: px,
  // Grid properties
  grid: px,
  'grid-gap': px,
  'row-gap': px,
  'grid-row-gap': px,
  'grid-column-gap': px,
  'grid-template-rows': px,
  'grid-template-columns': px,
  'grid-auto-rows': px,
  'grid-auto-columns': px,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  'box-shadow-x': px,
  'box-shadow-y': px,
  'box-shadow-blur': px,
  'box-shadow-spread': px,
  'font-line-height': px,
  'text-shadow-x': px,
  'text-shadow-y': px,
  'text-shadow-blur': px
};

/**
 * Clones the object and adds a camel cased property version.
 */

function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;

  var replace = function replace(str) {
    return str[1].toUpperCase();
  };

  var newObj = {};

  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }

  return newObj;
}

var units = addCamelCasedVersion(defaultUnits);
/**
 * Recursive deep style passing function
 */

function iterate(prop, value, options) {
  if (value == null) return value;

  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      value[i] = iterate(prop, value[i], options);
    }
  } else if (typeof value === 'object') {
    if (prop === 'fallbacks') {
      for (var innerProp in value) {
        value[innerProp] = iterate(innerProp, value[innerProp], options);
      }
    } else {
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
      }
    } // eslint-disable-next-line no-restricted-globals

  } else if (typeof value === 'number' && isNaN(value) === false) {
    var unit = options[prop] || units[prop]; // Add the unit if available, except for the special case of 0px.

    if (unit && !(value === 0 && unit === px)) {
      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
    }

    return value.toString();
  }

  return value;
}
/**
 * Add unit to numeric values.
 */


function defaultUnit(options) {
  if (options === void 0) {
    options = {};
  }

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
}

function _iterableToArray$1(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}

function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1();
}

// Export javascript style and css style vendor prefixes.
var js = '';
var css = '';
var vendor = '';
var browser = '';
var isTouch = isBrowser$1 && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.

if (isBrowser$1) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };

  var _document$createEleme = document.createElement('p'),
      style = _document$createEleme.style;

  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  } // Correctly detect the Edge browser.


  if (js === 'Webkit' && 'msHyphens' in style) {
    js = 'ms';
    css = jsCssMap.ms;
    browser = 'edge';
  } // Correctly detect the Safari browser.


  if (js === 'Webkit' && '-apple-trailing-word' in style) {
    vendor = 'apple';
  }
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */


var prefix = {
  js: js,
  css: css,
  vendor: vendor,
  browser: browser,
  isTouch: isTouch
};

/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */

function supportedKeyframes(key) {
  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
  // https://caniuse.com/#search=keyframes

  if (prefix.js === 'ms') return key;
  return "@" + prefix.css + "keyframes" + key.substr(10);
}

// https://caniuse.com/#search=appearance

var appearence = {
  noPrefill: ['appearance'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'appearance') return false;
    if (prefix.js === 'ms') return "-webkit-" + prop;
    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=color-adjust

var colorAdjust = {
  noPrefill: ['color-adjust'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'color-adjust') return false;
    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
    return prop;
  }
};

var regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */


function camelize(str) {
  return str.replace(regExp, toUpper);
}

/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function pascalize(str) {
  return camelize("-" + str);
}

// but we can use a longhand property instead.
// https://caniuse.com/#search=mask

var mask = {
  noPrefill: ['mask'],
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^mask/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var longhand = 'mask-image';

      if (camelize(longhand) in style) {
        return prop;
      }

      if (prefix.js + pascalize(longhand) in style) {
        return prefix.css + prop;
      }
    }

    return prop;
  }
};

// https://caniuse.com/#search=text-orientation

var textOrientation = {
  noPrefill: ['text-orientation'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'text-orientation') return false;

    if (prefix.vendor === 'apple' && !prefix.isTouch) {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=transform

var transform = {
  noPrefill: ['transform'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transform') return false;

    if (options.transform) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=transition

var transition = {
  noPrefill: ['transition'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transition') return false;

    if (options.transition) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=writing-mode

var writingMode = {
  noPrefill: ['writing-mode'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'writing-mode') return false;

    if (prefix.js === 'Webkit' || prefix.js === 'ms' && prefix.browser !== 'edge') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=user-select

var userSelect = {
  noPrefill: ['user-select'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'user-select') return false;

    if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177

var breakPropsOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^break-/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var jsProp = "WebkitColumn" + pascalize(prop);
      return jsProp in style ? prefix.css + "column-" + prop : false;
    }

    if (prefix.js === 'Moz') {
      var _jsProp = "page" + pascalize(prop);

      return _jsProp in style ? "page-" + prop : false;
    }

    return false;
  }
};

// See https://github.com/postcss/autoprefixer/issues/324.

var inlineLogicalOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
    if (prefix.js === 'Moz') return prop;
    var newProp = prop.replace('-inline', '');
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.

var unprefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    return camelize(prop) in style ? prop : false;
  }
};

var prefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.

    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.

    if (prop[0] === '-' && prop[1] === '-') return prop;
    if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.

    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
    return false;
  }
};

// https://caniuse.com/#search=scroll-snap

var scrollSnap = {
  supportedProperty: function supportedProperty(prop) {
    if (prop.substring(0, 11) !== 'scroll-snap') return false;

    if (prefix.js === 'ms') {
      return "" + prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=overscroll-behavior

var overscrollBehavior = {
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'overscroll-behavior') return false;

    if (prefix.js === 'ms') {
      return prefix.css + "scroll-chaining";
    }

    return prop;
  }
};

var propMap = {
  'flex-grow': 'flex-positive',
  'flex-shrink': 'flex-negative',
  'flex-basis': 'flex-preferred-size',
  'justify-content': 'flex-pack',
  order: 'flex-order',
  'align-items': 'flex-align',
  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.

}; // Support old flex spec from 2012.

var flex2012 = {
  supportedProperty: function supportedProperty(prop, style) {
    var newProp = propMap[prop];
    if (!newProp) return false;
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

var propMap$1 = {
  flex: 'box-flex',
  'flex-grow': 'box-flex',
  'flex-direction': ['box-orient', 'box-direction'],
  order: 'box-ordinal-group',
  'align-items': 'box-align',
  'flex-flow': ['box-orient', 'box-direction'],
  'justify-content': 'box-pack'
};
var propKeys = Object.keys(propMap$1);

var prefixCss = function prefixCss(p) {
  return prefix.css + p;
}; // Support old flex spec from 2009.


var flex2009 = {
  supportedProperty: function supportedProperty(prop, style, _ref) {
    var multiple = _ref.multiple;

    if (propKeys.indexOf(prop) > -1) {
      var newProp = propMap$1[prop];

      if (!Array.isArray(newProp)) {
        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
      }

      if (!multiple) return false;

      for (var i = 0; i < newProp.length; i++) {
        if (!(prefix.js + pascalize(newProp[0]) in style)) {
          return false;
        }
      }

      return newProp.map(prefixCss);
    }

    return false;
  }
};

// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'

var plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
var propertyDetectors = plugins.filter(function (p) {
  return p.supportedProperty;
}).map(function (p) {
  return p.supportedProperty;
});
var noPrefill = plugins.filter(function (p) {
  return p.noPrefill;
}).reduce(function (a, p) {
  a.push.apply(a, _toConsumableArray$1(p.noPrefill));
  return a;
}, []);

var el;
var cache = {};

if (isBrowser$1) {
  el = document.createElement('p'); // We test every property on vendor prefix requirement.
  // Once tested, result is cached. It gives us up to 70% perf boost.
  // http://jsperf.com/element-style-object-access-vs-plain-object
  //
  // Prefill cache with known css properties to reduce amount of
  // properties we need to feature test at runtime.
  // http://davidwalsh.name/vendor-prefix

  var computed = window.getComputedStyle(document.documentElement, '');

  for (var key$1 in computed) {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(key$1)) cache[computed[key$1]] = computed[key$1];
  } // Properties that cannot be correctly detected using the
  // cache prefill method.


  noPrefill.forEach(function (x) {
    return delete cache[x];
  });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */


function supportedProperty(prop, options) {
  if (options === void 0) {
    options = {};
  }

  // For server-side rendering.
  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.

  if (process.env.NODE_ENV !== 'benchmark' && cache[prop] != null) {
    return cache[prop];
  } // Check if 'transition' or 'transform' natively supported in browser.


  if (prop === 'transition' || prop === 'transform') {
    options[prop] = prop in el.style;
  } // Find a plugin for current prefix property.


  for (var i = 0; i < propertyDetectors.length; i++) {
    cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.

    if (cache[prop]) break;
  } // Reset styles for current property.
  // Firefox can even throw an error for invalid properties, e.g., "0".


  try {
    el.style[prop] = '';
  } catch (err) {
    return false;
  }

  return cache[prop];
}

var cache$1 = {};
var transitionProperties = {
  transition: 1,
  'transition-property': 1,
  '-webkit-transition': 1,
  '-webkit-transition-property': 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */

function prefixTransitionCallback(match, p1, p2) {
  if (p1 === 'var') return 'var';
  if (p1 === 'all') return 'all';
  if (p2 === 'all') return ', all';
  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
  if (!prefixedValue) return p1 || p2;
  return prefixedValue;
}

if (isBrowser$1) el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */

function supportedValue(property, value) {
  // For server-side rendering.
  var prefixedValue = value;
  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  // eslint-disable-next-line no-restricted-globals

  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
    return prefixedValue;
  } // Create cache key for current value.


  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.

  if (process.env.NODE_ENV !== 'benchmark' && cache$1[cacheKey] != null) {
    return cache$1[cacheKey];
  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.


  try {
    // Test value as it is.
    el$1.style[property] = prefixedValue;
  } catch (err) {
    // Return false if value not supported.
    cache$1[cacheKey] = false;
    return false;
  } // If 'transition' or 'transition-property' property.


  if (transitionProperties[property]) {
    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
  } else if (el$1.style[property] === '') {
    // Value with a vendor prefix.
    prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.

    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.

    el$1.style[property] = prefixedValue; // Return false if value not supported.

    if (el$1.style[property] === '') {
      cache$1[cacheKey] = false;
      return false;
    }
  } // Reset styles for current property.


  el$1.style[property] = ''; // Write current value to cache.

  cache$1[cacheKey] = prefixedValue;
  return cache$1[cacheKey];
}

/**
 * Add vendor prefix to a property name when needed.
 */

function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      var atRule = rule;
      atRule.at = supportedKeyframes(atRule.at);
    }
  }

  function prefixStyle(style) {
    for (var prop in style) {
      var value = style[prop];

      if (prop === 'fallbacks' && Array.isArray(value)) {
        style[prop] = value.map(prefixStyle);
        continue;
      }

      var changeProp = false;
      var supportedProp = supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;
      var changeValue = false;
      var supportedValue$1 = supportedValue(supportedProp, toCssValue(value));
      if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue$1 || value;
      }
    }

    return style;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    return prefixStyle(style);
  }

  function onChangeValue(value, prop) {
    return supportedValue(prop, toCssValue(value)) || value;
  }

  return {
    onProcessRule: onProcessRule,
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/**
 * Sort props by length.
 */
function jssPropsSort() {
  var sort = function sort(prop0, prop1) {
    if (prop0.length === prop1.length) {
      return prop0 > prop1 ? 1 : -1;
    }

    return prop0.length - prop1.length;
  };

  return {
    onProcessStyle: function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;
      var newStyle = {};
      var props = Object.keys(style).sort(sort);

      for (var i = 0; i < props.length; i++) {
        newStyle[props[i]] = style[props[i]];
      }

      return newStyle;
    }
  };
}

function jssPreset() {
  return {
    plugins: [functions(), jssGlobal(), jssNested(), camelCase(), defaultUnit(), // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : jssVendorPrefixer(), jssPropsSort()]
  };
}

function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses,
      Component = options.Component;

  if (!newClasses) {
    return baseClasses;
  }

  var nextClasses = _extends$1({}, baseClasses);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof newClasses === 'string') {
      console.error(["Material-UI: The value `".concat(newClasses, "` ") + "provided to the classes prop of ".concat(getDisplayName(Component), " is incorrect."), 'You might want to use the className prop instead.'].join('\n'));
      return baseClasses;
    }
  }

  Object.keys(newClasses).forEach(function (key) {
    if (process.env.NODE_ENV !== 'production') {
      if (!baseClasses[key] && newClasses[key]) {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not implemented in ".concat(getDisplayName(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n'));
      }

      if (newClasses[key] && typeof newClasses[key] !== 'string') {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not valid for ".concat(getDisplayName(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n'));
      }
    }

    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}

// Used https://github.com/thinkloop/multi-key-cache as inspiration
var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);

    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }

    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  delete: function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache.delete(key2);
  }
};
var multiKeyStore$1 = multiKeyStore;

var ThemeContext = React__namespace.default.createContext(null);

if (process.env.NODE_ENV !== 'production') {
  ThemeContext.displayName = 'ThemeContext';
}

var ThemeContext$1 = ThemeContext;

function useTheme$1() {
  var theme = React__namespace.default.useContext(ThemeContext$1);

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React__namespace.default.useDebugValue(theme);
  }

  return theme;
}

var jss = createJss(jssPreset()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.

var generateClassName$1 = createGenerateClassName(); // Exported for test purposes

var sheetsManager = new Map();
var defaultOptions = {
  disableGeneration: false,
  generateClassName: generateClassName$1,
  jss: jss,
  sheetsCache: null,
  sheetsManager: sheetsManager,
  sheetsRegistry: null
};
var StylesContext = React__namespace.default.createContext(defaultOptions);

if (process.env.NODE_ENV !== 'production') {
  StylesContext.displayName = 'StylesContext';
}

var injectFirstNode;
function StylesProvider(props) {
  var children = props.children,
      _props$injectFirst = props.injectFirst,
      injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst,
      _props$disableGenerat = props.disableGeneration,
      disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat,
      localOptions = _objectWithoutProperties(props, ["children", "injectFirst", "disableGeneration"]);

  var outerOptions = React__namespace.default.useContext(StylesContext);

  var context = _extends$1({}, outerOptions, {
    disableGeneration: disableGeneration
  }, localOptions);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof window === 'undefined' && !context.sheetsManager) {
      console.error('Material-UI: You need to use the ServerStyleSheets API when rendering on the server.');
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    if (context.jss.options.insertionPoint && injectFirst) {
      console.error('Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time.');
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    if (injectFirst && localOptions.jss) {
      console.error('Material-UI: You cannot use the jss and injectFirst props at the same time.');
    }
  }

  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
    if (!injectFirstNode) {
      var head = document.head;
      injectFirstNode = document.createComment('mui-inject-first');
      head.insertBefore(injectFirstNode, head.firstChild);
    }

    context.jss = createJss({
      plugins: jssPreset().plugins,
      insertionPoint: injectFirstNode
    });
  }

  return /*#__PURE__*/React__namespace.default.createElement(StylesContext.Provider, {
    value: context
  }, children);
}
process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node.isRequired,

  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
   */
  disableGeneration: PropTypes.bool,

  /**
   * JSS's class name generator.
   */
  generateClassName: PropTypes.func,

  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override Material-UI's styles, set this prop.
   */
  injectFirst: PropTypes.bool,

  /**
   * JSS's instance.
   */
  jss: PropTypes.object,

  /**
   * @ignore
   */
  serverGenerateClassName: PropTypes.func,

  /**
   * @ignore
   *
   * Beta feature.
   *
   * Cache for the sheets.
   */
  sheetsCache: PropTypes.object,

  /**
   * @ignore
   *
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: PropTypes.object,

  /**
   * @ignore
   *
   * Collect the sheets.
   */
  sheetsRegistry: PropTypes.object
} : void 0;

if (process.env.NODE_ENV !== 'production') {
  process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = exactProp(StylesProvider.propTypes) : void 0;
}

/* eslint-disable import/prefer-default-export */
// Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var indexCounter = -1e9;
function increment() {
  indexCounter += 1;

  if (process.env.NODE_ENV !== 'production') {
    if (indexCounter >= 0) {
      console.warn(['Material-UI: You might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n'));
    }
  }

  return indexCounter;
}

// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme = {};
var noopTheme$1 = noopTheme;

function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';

  if (process.env.NODE_ENV !== 'production') {
    if (_typeof$2(stylesOrCreator) !== 'object' && !themingEnabled) {
      console.error(['Material-UI: The `styles` argument provided is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n'));
    }
  }

  return {
    create: function create(theme, name) {
      var styles;

      try {
        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
      } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
          if (themingEnabled === true && theme === noopTheme$1) {
            // TODO: prepend error message/name instead
            console.error(['Material-UI: The `styles` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
          }
        }

        throw err;
      }

      if (!name || !theme.overrides || !theme.overrides[name]) {
        return styles;
      }

      var overrides = theme.overrides[name];

      var stylesWithOverrides = _extends$1({}, styles);

      Object.keys(overrides).forEach(function (key) {
        if (process.env.NODE_ENV !== 'production') {
          if (!stylesWithOverrides[key]) {
            console.warn(['Material-UI: You are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n'));
          }
        }

        stylesWithOverrides[key] = deepmerge(stylesWithOverrides[key], overrides[key]);
      });
      return stylesWithOverrides;
    },
    options: {}
  };
}

function getClasses(_ref, classes, Component) {
  var state = _ref.state,
      stylesOptions = _ref.stylesOptions;

  if (stylesOptions.disableGeneration) {
    return classes || {};
  }

  if (!state.cacheClasses) {
    state.cacheClasses = {
      // Cache for the finalized classes value.
      value: null,
      // Cache for the last used classes prop pointer.
      lastProp: null,
      // Cache for the last used rendered classes pointer.
      lastJSS: {}
    };
  } // Tracks if either the rendered classes or classes prop has changed,
  // requiring the generation of a new finalized classes object.


  var generate = false;

  if (state.classes !== state.cacheClasses.lastJSS) {
    state.cacheClasses.lastJSS = state.classes;
    generate = true;
  }

  if (classes !== state.cacheClasses.lastProp) {
    state.cacheClasses.lastProp = classes;
    generate = true;
  }

  if (generate) {
    state.cacheClasses.value = mergeClasses({
      baseClasses: state.cacheClasses.lastJSS,
      newClasses: classes,
      Component: Component
    });
  }

  return state.cacheClasses.value;
}

function attach(_ref2, props) {
  var state = _ref2.state,
      theme = _ref2.theme,
      stylesOptions = _ref2.stylesOptions,
      stylesCreator = _ref2.stylesCreator,
      name = _ref2.name;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = multiKeyStore$1.get(stylesOptions.sheetsManager, stylesCreator, theme);

  if (!sheetManager) {
    sheetManager = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    };
    multiKeyStore$1.set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
  }

  var options = _extends$1({}, stylesCreator.options, stylesOptions, {
    theme: theme,
    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
  });

  options.generateId = options.serverGenerateClassName || options.generateClassName;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    var staticSheet;

    if (stylesOptions.sheetsCache) {
      staticSheet = multiKeyStore$1.get(stylesOptions.sheetsCache, stylesCreator, theme);
    }

    var styles = stylesCreator.create(theme, name);

    if (!staticSheet) {
      staticSheet = stylesOptions.jss.createStyleSheet(styles, _extends$1({
        link: false
      }, options));
      staticSheet.attach();

      if (stylesOptions.sheetsCache) {
        multiKeyStore$1.set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
      }
    }

    if (sheetsRegistry) {
      sheetsRegistry.add(staticSheet);
    }

    sheetManager.staticSheet = staticSheet;
    sheetManager.dynamicStyles = getDynamicStyles(styles);
  }

  if (sheetManager.dynamicStyles) {
    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, _extends$1({
      link: true
    }, options));
    dynamicSheet.update(props);
    dynamicSheet.attach();
    state.dynamicSheet = dynamicSheet;
    state.classes = mergeClasses({
      baseClasses: sheetManager.staticSheet.classes,
      newClasses: dynamicSheet.classes
    });

    if (sheetsRegistry) {
      sheetsRegistry.add(dynamicSheet);
    }
  } else {
    state.classes = sheetManager.staticSheet.classes;
  }

  sheetManager.refs += 1;
}

function update$1(_ref3, props) {
  var state = _ref3.state;

  if (state.dynamicSheet) {
    state.dynamicSheet.update(props);
  }
}

function detach(_ref4) {
  var state = _ref4.state,
      theme = _ref4.theme,
      stylesOptions = _ref4.stylesOptions,
      stylesCreator = _ref4.stylesCreator;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = multiKeyStore$1.get(stylesOptions.sheetsManager, stylesCreator, theme);
  sheetManager.refs -= 1;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    multiKeyStore$1.delete(stylesOptions.sheetsManager, stylesCreator, theme);
    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(sheetManager.staticSheet);
    }
  }

  if (state.dynamicSheet) {
    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(state.dynamicSheet);
    }
  }
}

function useSynchronousEffect(func, values) {
  var key = React__namespace.default.useRef([]);
  var output; // Store "generation" key. Just returns a new object every time

  var currentKey = React__namespace.default.useMemo(function () {
    return {};
  }, values); // eslint-disable-line react-hooks/exhaustive-deps
  // "the first render", or "memo dropped the value"

  if (key.current !== currentKey) {
    key.current = currentKey;
    output = func();
  }

  React__namespace.default.useEffect(function () {
    return function () {
      if (output) {
        output();
      }
    };
  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
  );
}

function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var name = options.name,
      classNamePrefixOption = options.classNamePrefix,
      Component = options.Component,
      _options$defaultTheme = options.defaultTheme,
      defaultTheme = _options$defaultTheme === void 0 ? noopTheme$1 : _options$defaultTheme,
      stylesOptions2 = _objectWithoutProperties(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);

  var stylesCreator = getStylesCreator(stylesOrCreator);
  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
  stylesCreator.options = {
    index: increment(),
    name: name,
    meta: classNamePrefix,
    classNamePrefix: classNamePrefix
  };

  var useStyles = function useStyles() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var theme = useTheme$1() || defaultTheme;

    var stylesOptions = _extends$1({}, React__namespace.default.useContext(StylesContext), stylesOptions2);

    var instance = React__namespace.default.useRef();
    var shouldUpdate = React__namespace.default.useRef();
    useSynchronousEffect(function () {
      var current = {
        name: name,
        state: {},
        stylesCreator: stylesCreator,
        stylesOptions: stylesOptions,
        theme: theme
      };
      attach(current, props);
      shouldUpdate.current = false;
      instance.current = current;
      return function () {
        detach(current);
      };
    }, [theme, stylesCreator]);
    React__namespace.default.useEffect(function () {
      if (shouldUpdate.current) {
        update$1(instance.current, props);
      }

      shouldUpdate.current = true;
    });
    var classes = getClasses(instance.current, props.classes, Component);

    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      React__namespace.default.useDebugValue(classes);
    }

    return classes;
  };

  return useStyles;
}

var reactIs = requireReactIs();

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty$1 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var getPrototypeOf$1 = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf$1(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor$1(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty$1(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

var hoistNonReactStatics$1 = /*@__PURE__*/getDefaultExportFromCjs(hoistNonReactStatics_cjs);

// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.

var withStyles$1 = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var defaultTheme = options.defaultTheme,
        _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        name = options.name,
        stylesOptions = _objectWithoutProperties(options, ["defaultTheme", "withTheme", "name"]);

    if (process.env.NODE_ENV !== 'production') {
      if (Component === undefined) {
        throw new Error(['You are calling withStyles(styles)(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
      }
    }

    var classNamePrefix = name;

    if (process.env.NODE_ENV !== 'production') {
      if (!name) {
        // Provide a better DX outside production.
        var displayName = getDisplayName(Component);

        if (displayName !== undefined) {
          classNamePrefix = displayName;
        }
      }
    }

    var useStyles = makeStyles(stylesOrCreator, _extends$1({
      defaultTheme: defaultTheme,
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var WithStyles = /*#__PURE__*/React__namespace.default.forwardRef(function WithStyles(props, ref) {
      props.classes;
          var innerRef = props.innerRef,
          other = _objectWithoutProperties(props, ["classes", "innerRef"]); // The wrapper receives only user supplied props, which could be a subset of
      // the actual props Component might receive due to merging with defaultProps.
      // So copying it here would give us the same result in the wrapper as well.


      var classes = useStyles(_extends$1({}, Component.defaultProps, props));
      var theme;
      var more = other;

      if (typeof name === 'string' || withTheme) {
        // name and withTheme are invariant in the outer scope
        // eslint-disable-next-line react-hooks/rules-of-hooks
        theme = useTheme$1() || defaultTheme;

        if (name) {
          more = getThemeProps({
            theme: theme,
            name: name,
            props: other
          });
        } // Provide the theme to the wrapped component.
        // So we don't have to use the `withTheme()` Higher-order Component.


        if (withTheme && !more.theme) {
          more.theme = theme;
        }
      }

      return /*#__PURE__*/React__namespace.default.createElement(Component, _extends$1({
        ref: innerRef || ref,
        classes: classes
      }, more));
    });
    process.env.NODE_ENV !== "production" ? WithStyles.propTypes = {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: PropTypes.object,

      /**
       * Use that prop to pass a ref to the decorated component.
       * @deprecated
       */
      innerRef: chainPropTypes(PropTypes.oneOfType([PropTypes.func, PropTypes.object]), function (props) {
        if (props.innerRef == null) {
          return null;
        }

        return null; // return new Error(
        //   'Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' +
        //     'Refs are now automatically forwarded to the inner component.',
        // );
      })
    } : void 0;

    if (process.env.NODE_ENV !== 'production') {
      WithStyles.displayName = "WithStyles(".concat(getDisplayName(Component), ")");
    }

    hoistNonReactStatics$1(WithStyles, Component);

    if (process.env.NODE_ENV !== 'production') {
      // Exposed for test purposes.
      WithStyles.Naked = Component;
      WithStyles.options = options;
      WithStyles.useStyles = useStyles;
    }

    return WithStyles;
  };
};

var withStylesWithoutDefault = withStyles$1;

// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = _objectWithoutProperties(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end);

    if (endIndex === keys.length - 1) {
      return up(start);
    }

    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === 'number' ? values[keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  function width(key) {
    return values[key];
  }

  return _extends$1({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return _extends$1({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // To deprecate in v4.1
      //       warning(
      //         false,
      //         [
      //           'Material-UI: Theme.mixins.gutters() is deprecated.',
      //           'You can use the source of the mixin directly:',
      //           `
      // paddingLeft: theme.spacing(2),
      // paddingRight: theme.spacing(2),
      // [theme.breakpoints.up('sm')]: {
      //   paddingLeft: theme.spacing(3),
      //   paddingRight: theme.spacing(3),
      // },
      // `,
      //         ].join('\n'),
      //       );
      return _extends$1(_extends$1({
        paddingLeft: spacing(2),
        paddingRight: spacing(2)
      }, styles), {}, _defineProperty({}, breakpoints.up('sm'), _extends$1({
        paddingLeft: spacing(3),
        paddingRight: spacing(3)
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, _defineProperty(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), _defineProperty(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

var common = {
  black: '#000',
  white: '#fff'
};
var common$1 = common;

var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};
var grey$1 = grey;

var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};
var indigo$1 = indigo;

var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};
var pink$1 = pink;

var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
var red$1 = red;

var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
var orange$1 = orange;

var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
var blue$1 = blue;

var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
var green$1 = green;

/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (process.env.NODE_ENV !== 'production') {
    if (value < min || value > max) {
      console.error("Material-UI: The value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "]."));
    }
  }

  return Math.min(Math.max(min, value), max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function hexToRgb(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function (n, index) {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', '), ")") : '';
}
/**
 * Converts a color from hsl format to rgb format.
 *
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */

function hslToRgb(color) {
  color = decomposeColor(color);
  var _color = color,
      values = _color.values;
  var h = values[0];
  var s = values[1] / 100;
  var l = values[2] / 100;
  var a = s * Math.min(l, 1 - l);

  var f = function f(n) {
    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };

  var type = 'rgb';
  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];

  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }

  return recomposeColor({
    type: type,
    values: rgb
  });
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */

function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }

  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);

  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
    throw new Error(["Material-UI: Unsupported `".concat(color, "` color."), 'We support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().'].join('\n'));
  }

  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });
  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */

function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */

function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */

function getLuminance(color) {
  color = decomposeColor(color);
  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(function (val) {
    val /= 255; // normalized

    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
  }); // Truncate at 3 digits

  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function fade(color, value) {
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: common$1.white,
    default: grey$1[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
var dark = {
  text: {
    primary: common$1.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: grey$1[800],
    default: '#303030'
  },
  action: {
    active: common$1.white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};

function addLightOrDark(intent, direction, shade, tonalOffset) {
  var tonalOffsetLight = tonalOffset.light || tonalOffset;
  var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;

  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = lighten(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = darken(intent.main, tonalOffsetDark);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: indigo$1[300],
    main: indigo$1[500],
    dark: indigo$1[700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: pink$1.A200,
    main: pink$1.A400,
    dark: pink$1.A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: red$1[300],
    main: red$1[500],
    dark: red$1[700]
  } : _palette$error,
      _palette$warning = palette.warning,
      warning = _palette$warning === void 0 ? {
    light: orange$1[300],
    main: orange$1[500],
    dark: orange$1[700]
  } : _palette$warning,
      _palette$info = palette.info,
      info = _palette$info === void 0 ? {
    light: blue$1[300],
    main: blue$1[500],
    dark: blue$1[700]
  } : _palette$info,
      _palette$success = palette.success,
      success = _palette$success === void 0 ? {
    light: green$1[300],
    main: green$1[500],
    dark: green$1[700]
  } : _palette$success,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = _objectWithoutProperties(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54


  function getContrastText(background) {
    var contrastText = getContrastRatio(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (process.env.NODE_ENV !== 'production') {
      var contrast = getContrastRatio(background, contrastText);

      if (contrast < 3) {
        console.error(["Material-UI: The contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
      }
    }

    return contrastText;
  }

  var augmentColor = function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
    color = _extends$1({}, color);

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (!color.main) {
      throw new Error(['Material-UI: The color provided to augmentColor(color) is invalid.', "The color object needs to have a `main` property or a `".concat(mainShade, "` property.")].join('\n'));
    }

    if (typeof color.main !== 'string') {
      throw new Error(['Material-UI: The color provided to augmentColor(color) is invalid.', "`color.main` should be a string, but `".concat(JSON.stringify(color.main), "` was provided instead."), '', 'Did you intend to use one of the following approaches?', '', 'import { green } from "@material-ui/core/colors";', '', 'const theme1 = createMuiTheme({ palette: {', '  primary: green,', '} });', '', 'const theme2 = createMuiTheme({ palette: {', '  primary: { main: green[500] },', '} });'].join('\n'));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  };

  var types = {
    dark: dark,
    light: light
  };

  if (process.env.NODE_ENV !== 'production') {
    if (!types[type]) {
      console.error("Material-UI: The palette type `".concat(type, "` is not supported."));
    }
  }

  var paletteOutput = deepmerge(_extends$1({
    // A collection of common colors.
    common: common$1,
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor(primary),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor(error),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor(warning),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor(info),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor(success),
    // The grey colors.
    grey: grey$1,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other);
  return paletteOutput;
}

function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$fontWeightBold = _ref.fontWeightBold,
      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      allVariants = _ref.allVariants,
      pxToRem2 = _ref.pxToRem,
      other = _objectWithoutProperties(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof fontSize !== 'number') {
      console.error('Material-UI: `fontSize` is required to be a number.');
    }

    if (typeof htmlFontSize !== 'number') {
      console.error('Material-UI: `htmlFontSize` is required to be a number.');
    }
  }

  var coef = fontSize / 14;

  var pxToRem = pxToRem2 || function (size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };

  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return _extends$1(_extends$1(_extends$1({
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(letterSpacing / size), "em")
    } : {}), casing), allVariants);
  };

  var variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return deepmerge(_extends$1({
    htmlFontSize: htmlFontSize,
    pxToRem: pxToRem,
    round: round,
    // TODO v5: remove
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    fontWeightBold: fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep

  });
}

var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss


var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
var shadows$1 = shadows;

var shape = {
  borderRadius: 4
};
var shape$1 = shape;

var responsivePropType = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};
var responsivePropType$1 = responsivePropType;

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest();
}

var spacingKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY'];
function createUnarySpacing(theme) {
  var themeSpacing = theme.spacing || 8;

  if (typeof themeSpacing === 'number') {
    return function (abs) {
      if (process.env.NODE_ENV !== 'production') {
        if (typeof abs !== 'number') {
          console.error("Material-UI: Expected spacing argument to be a number, got ".concat(abs, "."));
        }
      }

      return themeSpacing * abs;
    };
  }

  if (Array.isArray(themeSpacing)) {
    return function (abs) {
      if (process.env.NODE_ENV !== 'production') {
        if (abs > themeSpacing.length - 1) {
          console.error(["Material-UI: The value provided (".concat(abs, ") overflows."), "The supported values are: ".concat(JSON.stringify(themeSpacing), "."), "".concat(abs, " > ").concat(themeSpacing.length - 1, ", you need to add the missing values.")].join('\n'));
        }
      }

      return themeSpacing[abs];
    };
  }

  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }

  if (process.env.NODE_ENV !== 'production') {
    console.error(["Material-UI: The `theme.spacing` value (".concat(themeSpacing, ") is invalid."), 'It should be a number, an array or a function.'].join('\n'));
  }

  return function () {
    return undefined;
  };
}

process.env.NODE_ENV !== 'production' ? spacingKeys.reduce(function (obj, key) {
  obj[key] = responsivePropType$1;
  return obj;
}, {}) : {};

var warnOnce;
function createSpacing() {
  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
  // Smaller components, such as icons and type, can align to a 4dp grid.
  // https://material.io/design/layout/understanding-layout.html#usage


  var transform = createUnarySpacing({
    spacing: spacingInput
  });

  var spacing = function spacing() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (process.env.NODE_ENV !== 'production') {
      if (!(args.length <= 4)) {
        console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(args.length));
      }
    }

    if (args.length === 0) {
      return transform(1);
    }

    if (args.length === 1) {
      return transform(args[0]);
    }

    return args.map(function (argument) {
      if (typeof argument === 'string') {
        return argument;
      }

      var output = transform(argument);
      return typeof output === 'number' ? "".concat(output, "px") : output;
    }).join(' ');
  }; // Backward compatibility, to remove in v5.


  Object.defineProperty(spacing, 'unit', {
    get: function get() {
      if (process.env.NODE_ENV !== 'production') {
        if (!warnOnce || process.env.NODE_ENV === 'test') {
          console.error(['Material-UI: theme.spacing.unit usage has been deprecated.', 'It will be removed in v5.', 'You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.', '', 'You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother.'].join('\n'));
        }

        warnOnce = true;
      }

      return spacingInput;
    }
  });
  spacing.mui = true;
  return spacing;
}

// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};

function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
}
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */


var transitions = {
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay,
        other = _objectWithoutProperties(options, ["duration", "easing", "delay"]);

    if (process.env.NODE_ENV !== 'production') {
      var isString = function isString(value) {
        return typeof value === 'string';
      };

      var isNumber = function isNumber(value) {
        return !isNaN(parseFloat(value));
      };

      if (!isString(props) && !Array.isArray(props)) {
        console.error('Material-UI: Argument "props" must be a string or Array.');
      }

      if (!isNumber(durationOption) && !isString(durationOption)) {
        console.error("Material-UI: Argument \"duration\" must be a number or a string but found ".concat(durationOption, "."));
      }

      if (!isString(easingOption)) {
        console.error('Material-UI: Argument "easing" must be a string.');
      }

      if (!isNumber(delay) && !isString(delay)) {
        console.error('Material-UI: Argument "delay" must be a number or a string.');
      }

      if (Object.keys(other).length !== 0) {
        console.error("Material-UI: Unrecognized argument(s) [".concat(Object.keys(other).join(','), "]."));
      }
    }

    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
};

// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
var zIndex$1 = zIndex;

function createMuiTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      spacingInput = options.spacing,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = _objectWithoutProperties(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);

  var palette = createPalette(paletteInput);
  var breakpoints = createBreakpoints(breakpointsInput);
  var spacing = createSpacing(spacingInput);
  var muiTheme = deepmerge({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: createMixins(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Provide default props
    shadows: shadows$1,
    typography: createTypography(palette, typographyInput),
    spacing: spacing,
    shape: shape$1,
    transitions: transitions,
    zIndex: zIndex$1
  }, other);

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  muiTheme = args.reduce(function (acc, argument) {
    return deepmerge(acc, argument);
  }, muiTheme);

  if (process.env.NODE_ENV !== 'production') {
    var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected'];

    var traverse = function traverse(node, parentKey) {
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax

      for (key in node) {
        var child = node[key];

        if (depth === 1) {
          if (key.indexOf('Mui') === 0 && child) {
            traverse(child, key, depth + 1);
          }
        } else if (pseudoClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          if (process.env.NODE_ENV !== 'production') {
            console.error(["Material-UI: The `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', 'Instead, you need to use the $ruleName syntax:', JSON.stringify({
              root: _defineProperty({}, "&$".concat(key), child)
            }, null, 2), '', 'https://material-ui.com/r/pseudo-classes-guide'].join('\n'));
          } // Remove the style to prevent global conflicts.


          node[key] = {};
        }
      }
    };

    traverse(muiTheme.overrides);
  }

  return muiTheme;
}

var defaultTheme = createMuiTheme();
var defaultTheme$1 = defaultTheme;

function withStyles(stylesOrCreator, options) {
  return withStylesWithoutDefault(stylesOrCreator, _extends$1({
    defaultTheme: defaultTheme$1
  }, options));
}

var styles$g = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end',
    flex: '0 0 auto'
  },

  /* Styles applied to the root element if `disableSpacing={false}`. */
  spacing: {
    '& > :not(:first-child)': {
      marginLeft: 8
    }
  }
};
var DialogActions = React__namespace.forwardRef(function DialogActions(props, ref) {
  var _props$disableSpacing = props.disableSpacing,
      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
      classes = props.classes,
      className = props.className,
      other = _objectWithoutProperties(props, ["disableSpacing", "classes", "className"]);

  return /*#__PURE__*/React__namespace.createElement("div", _extends$1({
    className: clsx(classes.root, className, !disableSpacing && classes.spacing),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? DialogActions.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the actions do not have additional margin.
   */
  disableSpacing: PropTypes.bool
} : void 0;
var DialogActions$1 = withStyles(styles$g, {
  name: 'MuiDialogActions'
})(DialogActions);

/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1-lts
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex$1(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex$1(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper$2 = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper$2.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper$2.placements = placements;
Popper$2.Defaults = Defaults;

var PopperJs = Popper$2;

// TODO v5: consider to make it private
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

function useForkRef(refA, refB) {
  /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */
  return React__namespace.useMemo(function () {
    if (refA == null && refB == null) {
      return null;
    }

    return function (refValue) {
      setRef(refA, refValue);
      setRef(refB, refValue);
    };
  }, [refA, refB]);
}

function getContainer(container) {
  container = typeof container === 'function' ? container() : container; // #StrictMode ready

  return ReactDOM__namespace.findDOMNode(container);
}

var useEnhancedEffect$4 = typeof window !== 'undefined' ? React__namespace.useLayoutEffect : React__namespace.useEffect;
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */

var Portal = React__namespace.forwardRef(function Portal(props, ref) {
  var children = props.children,
      container = props.container,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      onRendered = props.onRendered;

  var _React$useState = React__namespace.useState(null),
      mountNode = _React$useState[0],
      setMountNode = _React$useState[1];

  var handleRef = useForkRef(React__namespace.isValidElement(children) ? children.ref : null, ref);
  useEnhancedEffect$4(function () {
    if (!disablePortal) {
      setMountNode(getContainer(container) || document.body);
    }
  }, [container, disablePortal]);
  useEnhancedEffect$4(function () {
    if (mountNode && !disablePortal) {
      setRef(ref, mountNode);
      return function () {
        setRef(ref, null);
      };
    }

    return undefined;
  }, [ref, mountNode, disablePortal]);
  useEnhancedEffect$4(function () {
    if (onRendered && (mountNode || disablePortal)) {
      onRendered();
    }
  }, [onRendered, mountNode, disablePortal]);

  if (disablePortal) {
    if (React__namespace.isValidElement(children)) {
      return React__namespace.cloneElement(children, {
        ref: handleRef
      });
    }

    return children;
  }

  return mountNode ? ReactDOM__namespace.createPortal(children, mountNode) : mountNode;
});
process.env.NODE_ENV !== "production" ? Portal.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The children to render into the `container`.
   */
  children: PropTypes.node,

  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes.instanceOf(React__namespace.Component), PropTypes.func]),

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: PropTypes.bool,

  /**
   * Callback fired once the children has been mounted into the `container`.
   *
   * This prop will be deprecated and removed in v5, the ref can be used instead.
   */
  onRendered: PropTypes.func
} : void 0;

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line
  Portal['propTypes' + ''] = exactProp(Portal.propTypes);
}

var Portal$1 = Portal;

/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (acc, func) {
    if (func == null) {
      return acc;
    }

    if (process.env.NODE_ENV !== 'production') {
      if (typeof func !== 'function') {
        console.error('Material-UI: Invalid Argument Type, must only provide functions, undefined, or null.');
      }
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

function flipPlacement(placement, theme) {
  var direction = theme && theme.direction || 'ltr';

  if (direction === 'ltr') {
    return placement;
  }

  switch (placement) {
    case 'bottom-end':
      return 'bottom-start';

    case 'bottom-start':
      return 'bottom-end';

    case 'top-end':
      return 'top-start';

    case 'top-start':
      return 'top-end';

    default:
      return placement;
  }
}

function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

var useEnhancedEffect$3 = typeof window !== 'undefined' ? React__namespace.useLayoutEffect : React__namespace.useEffect;
var defaultPopperOptions = {};
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v1/) for positioning.
 */

var Popper = React__namespace.forwardRef(function Popper(props, ref) {
  var anchorEl = props.anchorEl,
      children = props.children,
      container = props.container,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      _props$keepMounted = props.keepMounted,
      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
      modifiers = props.modifiers,
      open = props.open,
      _props$placement = props.placement,
      initialPlacement = _props$placement === void 0 ? 'bottom' : _props$placement,
      _props$popperOptions = props.popperOptions,
      popperOptions = _props$popperOptions === void 0 ? defaultPopperOptions : _props$popperOptions,
      popperRefProp = props.popperRef,
      style = props.style,
      _props$transition = props.transition,
      transition = _props$transition === void 0 ? false : _props$transition,
      other = _objectWithoutProperties(props, ["anchorEl", "children", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition"]);

  var tooltipRef = React__namespace.useRef(null);
  var ownRef = useForkRef(tooltipRef, ref);
  var popperRef = React__namespace.useRef(null);
  var handlePopperRef = useForkRef(popperRef, popperRefProp);
  var handlePopperRefRef = React__namespace.useRef(handlePopperRef);
  useEnhancedEffect$3(function () {
    handlePopperRefRef.current = handlePopperRef;
  }, [handlePopperRef]);
  React__namespace.useImperativeHandle(popperRefProp, function () {
    return popperRef.current;
  }, []);

  var _React$useState = React__namespace.useState(true),
      exited = _React$useState[0],
      setExited = _React$useState[1];

  var theme = useTheme$1();
  var rtlPlacement = flipPlacement(initialPlacement, theme);
  /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */

  var _React$useState2 = React__namespace.useState(rtlPlacement),
      placement = _React$useState2[0],
      setPlacement = _React$useState2[1];

  React__namespace.useEffect(function () {
    if (popperRef.current) {
      popperRef.current.update();
    }
  });
  var handleOpen = React__namespace.useCallback(function () {
    if (!tooltipRef.current || !anchorEl || !open) {
      return;
    }

    if (popperRef.current) {
      popperRef.current.destroy();
      handlePopperRefRef.current(null);
    }

    var handlePopperUpdate = function handlePopperUpdate(data) {
      setPlacement(data.placement);
    };

    var resolvedAnchorEl = getAnchorEl(anchorEl);

    if (process.env.NODE_ENV !== 'production') {
      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
        var box = resolvedAnchorEl.getBoundingClientRect();

        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          console.warn(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      }
    }

    var popper = new PopperJs(getAnchorEl(anchorEl), tooltipRef.current, _extends$1(_extends$1({
      placement: rtlPlacement
    }, popperOptions), {}, {
      modifiers: _extends$1(_extends$1(_extends$1({}, disablePortal ? {} : {
        // It's using scrollParent by default, we can use the viewport when using a portal.
        preventOverflow: {
          boundariesElement: 'window'
        }
      }), modifiers), popperOptions.modifiers),
      // We could have been using a custom modifier like react-popper is doing.
      // But it seems this is the best public API for this use case.
      onCreate: createChainedFunction(handlePopperUpdate, popperOptions.onCreate),
      onUpdate: createChainedFunction(handlePopperUpdate, popperOptions.onUpdate)
    }));
    handlePopperRefRef.current(popper);
  }, [anchorEl, disablePortal, modifiers, open, rtlPlacement, popperOptions]);
  var handleRef = React__namespace.useCallback(function (node) {
    setRef(ownRef, node);
    handleOpen();
  }, [ownRef, handleOpen]);

  var handleEnter = function handleEnter() {
    setExited(false);
  };

  var handleClose = function handleClose() {
    if (!popperRef.current) {
      return;
    }

    popperRef.current.destroy();
    handlePopperRefRef.current(null);
  };

  var handleExited = function handleExited() {
    setExited(true);
    handleClose();
  };

  React__namespace.useEffect(function () {
    // Let's update the popper position.
    handleOpen();
  }, [handleOpen]);
  React__namespace.useEffect(function () {
    return function () {
      handleClose();
    };
  }, []);
  React__namespace.useEffect(function () {
    if (!open && !transition) {
      // Otherwise handleExited will call this.
      handleClose();
    }
  }, [open, transition]);

  if (!keepMounted && !open && (!transition || exited)) {
    return null;
  }

  var childProps = {
    placement: placement
  };

  if (transition) {
    childProps.TransitionProps = {
      in: open,
      onEnter: handleEnter,
      onExited: handleExited
    };
  }

  return /*#__PURE__*/React__namespace.createElement(Portal$1, {
    disablePortal: disablePortal,
    container: container
  }, /*#__PURE__*/React__namespace.createElement("div", _extends$1({
    ref: handleRef,
    role: "tooltip"
  }, other, {
    style: _extends$1({
      // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
      position: 'fixed',
      // Fix Popper.js display issue
      top: 0,
      left: 0,
      display: !open && keepMounted && !transition ? 'none' : null
    }, style)
  }), typeof children === 'function' ? children(childProps) : children));
});
process.env.NODE_ENV !== "production" ? Popper.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A HTML element, [referenceObject](https://popper.js.org/docs/v1/#referenceObject),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.object, PropTypes.func]), function (props) {
    if (props.open) {
      var resolvedAnchorEl = getAnchorEl(props.anchorEl);

      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
        var box = resolvedAnchorEl.getBoundingClientRect();

        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      } else if (!resolvedAnchorEl || typeof resolvedAnchorEl.clientWidth !== 'number' || typeof resolvedAnchorEl.clientHeight !== 'number' || typeof resolvedAnchorEl.getBoundingClientRect !== 'function') {
        return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'It should be an HTML element instance or a referenceObject ', '(https://popper.js.org/docs/v1/#referenceObject).'].join('\n'));
      }
    }

    return null;
  }),

  /**
   * Popper render function or node.
   */
  children: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes.node, PropTypes.func]).isRequired,

  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes.instanceOf(React__namespace.Component), PropTypes.func]),

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: PropTypes.bool,

  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   */
  keepMounted: PropTypes.bool,

  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v1/#modifiers).
   */
  modifiers: PropTypes.object,

  /**
   * If `true`, the popper is visible.
   */
  open: PropTypes.bool.isRequired,

  /**
   * Popper placement.
   */
  placement: PropTypes.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * Options provided to the [`popper.js`](https://popper.js.org/docs/v1/) instance.
   */
  popperOptions: PropTypes.object,

  /**
   * A ref that points to the used popper instance.
   */
  popperRef: refType$1,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * Help supporting a react-transition-group/Transition component.
   */
  transition: PropTypes.bool
} : void 0;
var Popper$1 = Popper;

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalize(string) {
  if (process.env.NODE_ENV !== 'production') {
    if (typeof string !== 'string') {
      throw new Error('Material-UI: capitalize(string) expects a string argument.');
    }
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

var styles$f = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      boxSizing: 'border-box',
      lineHeight: '48px',
      listStyle: 'none',
      color: theme.palette.text.secondary,
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(14)
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },

    /* Styles applied to the root element if `inset={true}`. */
    inset: {
      paddingLeft: 72
    },

    /* Styles applied to the root element if `disableSticky={false}`. */
    sticky: {
      position: 'sticky',
      top: 0,
      zIndex: 1,
      backgroundColor: 'inherit'
    }
  };
};
var ListSubheader = React__namespace.forwardRef(function ListSubheader(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'li' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$disableSticky = props.disableSticky,
      disableSticky = _props$disableSticky === void 0 ? false : _props$disableSticky,
      _props$inset = props.inset,
      inset = _props$inset === void 0 ? false : _props$inset,
      other = _objectWithoutProperties(props, ["classes", "className", "color", "component", "disableGutters", "disableSticky", "inset"]);

  return /*#__PURE__*/React__namespace.createElement(Component, _extends$1({
    className: clsx(classes.root, className, color !== 'default' && classes["color".concat(capitalize(color))], inset && classes.inset, !disableSticky && classes.sticky, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? ListSubheader.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'primary', 'inherit']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,

  /**
   * If `true`, the List Subheader will not have gutters.
   */
  disableGutters: PropTypes.bool,

  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   */
  disableSticky: PropTypes.bool,

  /**
   * If `true`, the List Subheader will be indented.
   */
  inset: PropTypes.bool
} : void 0;
var ListSubheader$1 = withStyles(styles$f, {
  name: 'MuiListSubheader'
})(ListSubheader);

var styles$e = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return _extends$1({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      transition: theme.transitions.create('box-shadow')
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      border: "1px solid ".concat(theme.palette.divider)
    }
  }, elevations);
};
var Paper = React__namespace.forwardRef(function Paper(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$square = props.square,
      square = _props$square === void 0 ? false : _props$square,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 1 : _props$elevation,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'elevation' : _props$variant,
      other = _objectWithoutProperties(props, ["classes", "className", "component", "square", "elevation", "variant"]);

  return /*#__PURE__*/React__namespace.createElement(Component, _extends$1({
    className: clsx(classes.root, className, variant === 'outlined' ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? Paper.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,

  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   */
  elevation: chainPropTypes(PropTypes.number, function (props) {
    var classes = props.classes,
        elevation = props.elevation; // in case `withStyles` fails to inject we don't need this warning

    if (classes === undefined) {
      return null;
    }

    if (elevation != null && classes["elevation".concat(elevation)] === undefined) {
      return new Error("Material-UI: This elevation `".concat(elevation, "` is not implemented."));
    }

    return null;
  }),

  /**
   * If `true`, rounded corners are disabled.
   */
  square: PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['elevation', 'outlined'])
} : void 0;
var Paper$1 = withStyles(styles$e, {
  name: 'MuiPaper'
})(Paper);

var useEnhancedEffect$2 = typeof window !== 'undefined' ? React__namespace.useLayoutEffect : React__namespace.useEffect;
/**
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 *
 * @param {function} fn
 */

function useEventCallback(fn) {
  var ref = React__namespace.useRef(fn);
  useEnhancedEffect$2(function () {
    ref.current = fn;
  });
  return React__namespace.useCallback(function () {
    return (ref.current).apply(void 0, arguments);
  }, []);
}

// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js
var hadKeyboardEvent = true;
var hadFocusVisibleRecently = false;
var hadFocusVisibleRecentlyTimeout = null;
var inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */

function focusTriggersKeyboardModality(node) {
  var type = node.type,
      tagName = node.tagName;

  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }

  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }

  if (node.isContentEditable) {
    return true;
  }

  return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */


function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }

  hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */


function handlePointerDown() {
  hadKeyboardEvent = false;
}

function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}

function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}

function isFocusVisible(event) {
  var target = event.target;

  try {
    return target.matches(':focus-visible');
  } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
  // we use our own heuristic for those browsers
  // rethrow might be better if it's not the expected error but do we really
  // want to crash if focus-visible malfunctioned?
  // no need for validFocusTarget check. the user does that by attaching it to
  // focusable events only


  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */


function handleBlurVisible() {
  // To detect a tab/window switch, we look for a blur event followed
  // rapidly by a visibility change.
  // If we don't see a visibility change within 100ms, it's probably a
  // regular focus change.
  hadFocusVisibleRecently = true;
  window.clearTimeout(hadFocusVisibleRecentlyTimeout);
  hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
    hadFocusVisibleRecently = false;
  }, 100);
}

function useIsFocusVisible() {
  var ref = React__namespace.useCallback(function (instance) {
    var node = ReactDOM__namespace.findDOMNode(instance);

    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React__namespace.useDebugValue(isFocusVisible);
  }

  return {
    isFocusVisible: isFocusVisible,
    onBlurVisible: handleBlurVisible,
    ref: ref
  };
}

var TransitionGroupContext = React__namespace.default.createContext(null);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && React.isValidElement(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) React.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return React.cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!React.isValidElement(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = React.isValidElement(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = React.cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = React.cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && React.isValidElement(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = React.cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends$1({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/React__namespace.default.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/React__namespace.default.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/React__namespace.default.createElement(Component, props, children));
  };

  return TransitionGroup;
}(React__namespace.default.Component);

TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps;
var TransitionGroup$1 = TransitionGroup;

var useEnhancedEffect$1 = typeof window === 'undefined' ? React__namespace.useEffect : React__namespace.useLayoutEffect;
/**
 * @ignore - internal component.
 */

function Ripple(props) {
  var classes = props.classes,
      _props$pulsate = props.pulsate,
      pulsate = _props$pulsate === void 0 ? false : _props$pulsate,
      rippleX = props.rippleX,
      rippleY = props.rippleY,
      rippleSize = props.rippleSize,
      inProp = props.in,
      _props$onExited = props.onExited,
      onExited = _props$onExited === void 0 ? function () {} : _props$onExited,
      timeout = props.timeout;

  var _React$useState = React__namespace.useState(false),
      leaving = _React$useState[0],
      setLeaving = _React$useState[1];

  var rippleClassName = clsx(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
  var rippleStyles = {
    width: rippleSize,
    height: rippleSize,
    top: -(rippleSize / 2) + rippleY,
    left: -(rippleSize / 2) + rippleX
  };
  var childClassName = clsx(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
  var handleExited = useEventCallback(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority

  useEnhancedEffect$1(function () {
    if (!inProp) {
      // react-transition-group#onExit
      setLeaving(true); // react-transition-group#onExited

      var timeoutId = setTimeout(handleExited, timeout);
      return function () {
        clearTimeout(timeoutId);
      };
    }

    return undefined;
  }, [handleExited, inProp, timeout]);
  return /*#__PURE__*/React__namespace.createElement("span", {
    className: rippleClassName,
    style: rippleStyles
  }, /*#__PURE__*/React__namespace.createElement("span", {
    className: childClassName
  }));
}

process.env.NODE_ENV !== "production" ? Ripple.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore - injected from TransitionGroup
   */
  in: PropTypes.bool,

  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: PropTypes.func,

  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: PropTypes.bool,

  /**
   * Diameter of the ripple.
   */
  rippleSize: PropTypes.number,

  /**
   * Horizontal position of the ripple center.
   */
  rippleX: PropTypes.number,

  /**
   * Vertical position of the ripple center.
   */
  rippleY: PropTypes.number,

  /**
   * exit delay
   */
  timeout: PropTypes.number.isRequired
} : void 0;

var DURATION = 550;
var DELAY_RIPPLE = 80;
var styles$d = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      overflow: 'hidden',
      pointerEvents: 'none',
      position: 'absolute',
      zIndex: 0,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: 'inherit'
    },

    /* Styles applied to the internal `Ripple` components `ripple` class. */
    ripple: {
      opacity: 0,
      position: 'absolute'
    },

    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
    rippleVisible: {
      opacity: 0.3,
      transform: 'scale(1)',
      animation: "$enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
    ripplePulsate: {
      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
    },

    /* Styles applied to the internal `Ripple` components `child` class. */
    child: {
      opacity: 1,
      display: 'block',
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      backgroundColor: 'currentColor'
    },

    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
    childLeaving: {
      opacity: 0,
      animation: "$exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
    childPulsate: {
      position: 'absolute',
      left: 0,
      top: 0,
      animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
    },
    '@keyframes enter': {
      '0%': {
        transform: 'scale(0)',
        opacity: 0.1
      },
      '100%': {
        transform: 'scale(1)',
        opacity: 0.3
      }
    },
    '@keyframes exit': {
      '0%': {
        opacity: 1
      },
      '100%': {
        opacity: 0
      }
    },
    '@keyframes pulsate': {
      '0%': {
        transform: 'scale(1)'
      },
      '50%': {
        transform: 'scale(0.92)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    }
  };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */

var TouchRipple = React__namespace.forwardRef(function TouchRipple(props, ref) {
  var _props$center = props.center,
      centerProp = _props$center === void 0 ? false : _props$center,
      classes = props.classes,
      className = props.className,
      other = _objectWithoutProperties(props, ["center", "classes", "className"]);

  var _React$useState = React__namespace.useState([]),
      ripples = _React$useState[0],
      setRipples = _React$useState[1];

  var nextKey = React__namespace.useRef(0);
  var rippleCallback = React__namespace.useRef(null);
  React__namespace.useEffect(function () {
    if (rippleCallback.current) {
      rippleCallback.current();
      rippleCallback.current = null;
    }
  }, [ripples]); // Used to filter out mouse emulated events on mobile.

  var ignoringMouseDown = React__namespace.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
  // We don't want to display the ripple for touch scroll events.

  var startTimer = React__namespace.useRef(null); // This is the hook called once the previous timeout is ready.

  var startTimerCommit = React__namespace.useRef(null);
  var container = React__namespace.useRef(null);
  React__namespace.useEffect(function () {
    return function () {
      clearTimeout(startTimer.current);
    };
  }, []);
  var startCommit = React__namespace.useCallback(function (params) {
    var pulsate = params.pulsate,
        rippleX = params.rippleX,
        rippleY = params.rippleY,
        rippleSize = params.rippleSize,
        cb = params.cb;
    setRipples(function (oldRipples) {
      return [].concat(_toConsumableArray$1(oldRipples), [/*#__PURE__*/React__namespace.createElement(Ripple, {
        key: nextKey.current,
        classes: classes,
        timeout: DURATION,
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize
      })]);
    });
    nextKey.current += 1;
    rippleCallback.current = cb;
  }, [classes]);
  var start = React__namespace.useCallback(function () {
    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var cb = arguments.length > 2 ? arguments[2] : undefined;
    var _options$pulsate = options.pulsate,
        pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
        _options$center = options.center,
        center = _options$center === void 0 ? centerProp || options.pulsate : _options$center,
        _options$fakeElement = options.fakeElement,
        fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;

    if (event.type === 'mousedown' && ignoringMouseDown.current) {
      ignoringMouseDown.current = false;
      return;
    }

    if (event.type === 'touchstart') {
      ignoringMouseDown.current = true;
    }

    var element = fakeElement ? null : container.current;
    var rect = element ? element.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    }; // Get the size of the ripple

    var rippleX;
    var rippleY;
    var rippleSize;

    if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
      rippleX = Math.round(rect.width / 2);
      rippleY = Math.round(rect.height / 2);
    } else {
      var _ref = event.touches ? event.touches[0] : event,
          clientX = _ref.clientX,
          clientY = _ref.clientY;

      rippleX = Math.round(clientX - rect.left);
      rippleY = Math.round(clientY - rect.top);
    }

    if (center) {
      rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.

      if (rippleSize % 2 === 0) {
        rippleSize += 1;
      }
    } else {
      var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
      var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
      rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
    } // Touche devices


    if (event.touches) {
      // check that this isn't another touchstart due to multitouch
      // otherwise we will only clear a single timer when unmounting while two
      // are running
      if (startTimerCommit.current === null) {
        // Prepare the ripple effect.
        startTimerCommit.current = function () {
          startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
          });
        }; // Delay the execution of the ripple effect.


        startTimer.current = setTimeout(function () {
          if (startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
          }
        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
      }
    } else {
      startCommit({
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize,
        cb: cb
      });
    }
  }, [centerProp, startCommit]);
  var pulsate = React__namespace.useCallback(function () {
    start({}, {
      pulsate: true
    });
  }, [start]);
  var stop = React__namespace.useCallback(function (event, cb) {
    clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
    // We still want to show ripple effect.

    if (event.type === 'touchend' && startTimerCommit.current) {
      event.persist();
      startTimerCommit.current();
      startTimerCommit.current = null;
      startTimer.current = setTimeout(function () {
        stop(event, cb);
      });
      return;
    }

    startTimerCommit.current = null;
    setRipples(function (oldRipples) {
      if (oldRipples.length > 0) {
        return oldRipples.slice(1);
      }

      return oldRipples;
    });
    rippleCallback.current = cb;
  }, []);
  React__namespace.useImperativeHandle(ref, function () {
    return {
      pulsate: pulsate,
      start: start,
      stop: stop
    };
  }, [pulsate, start, stop]);
  return /*#__PURE__*/React__namespace.createElement("span", _extends$1({
    className: clsx(classes.root, className),
    ref: container
  }, other), /*#__PURE__*/React__namespace.createElement(TransitionGroup$1, {
    component: null,
    exit: true
  }, ripples));
});
process.env.NODE_ENV !== "production" ? TouchRipple.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
var TouchRipple$1 = withStyles(styles$d, {
  flip: false,
  name: 'MuiTouchRipple'
})(React__namespace.memo(TouchRipple));

var styles$c = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none',
    // Reset
    '-webkit-appearance': 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    '&$disabled': {
      pointerEvents: 'none',
      // Disable link interactions
      cursor: 'default'
    },
    '@media print': {
      colorAdjust: 'exact'
    }
  },

  /* Pseudo-class applied to the root element if `disabled={true}`. */
  disabled: {},

  /* Pseudo-class applied to the root element if keyboard focused. */
  focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */

var ButtonBase = React__namespace.forwardRef(function ButtonBase(props, ref) {
  var action = props.action,
      buttonRefProp = props.buttonRef,
      _props$centerRipple = props.centerRipple,
      centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableRipple = props.disableRipple,
      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
      _props$disableTouchRi = props.disableTouchRipple,
      disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi,
      _props$focusRipple = props.focusRipple,
      focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple,
      focusVisibleClassName = props.focusVisibleClassName,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onFocusVisible = props.onFocusVisible,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      onTouchEnd = props.onTouchEnd,
      onTouchMove = props.onTouchMove,
      onTouchStart = props.onTouchStart,
      onDragLeave = props.onDragLeave,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
      TouchRippleProps = props.TouchRippleProps,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      other = _objectWithoutProperties(props, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]);

  var buttonRef = React__namespace.useRef(null);

  function getButtonNode() {
    // #StrictMode ready
    return ReactDOM__namespace.findDOMNode(buttonRef.current);
  }

  var rippleRef = React__namespace.useRef(null);

  var _React$useState = React__namespace.useState(false),
      focusVisible = _React$useState[0],
      setFocusVisible = _React$useState[1];

  if (disabled && focusVisible) {
    setFocusVisible(false);
  }

  var _useIsFocusVisible = useIsFocusVisible(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  React__namespace.useImperativeHandle(action, function () {
    return {
      focusVisible: function focusVisible() {
        setFocusVisible(true);
        buttonRef.current.focus();
      }
    };
  }, []);
  React__namespace.useEffect(function () {
    if (focusVisible && focusRipple && !disableRipple) {
      rippleRef.current.pulsate();
    }
  }, [disableRipple, focusRipple, focusVisible]);

  function useRippleHandler(rippleAction, eventCallback) {
    var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
    return useEventCallback(function (event) {
      if (eventCallback) {
        eventCallback(event);
      }

      var ignore = skipRippleAction;

      if (!ignore && rippleRef.current) {
        rippleRef.current[rippleAction](event);
      }

      return true;
    });
  }

  var handleMouseDown = useRippleHandler('start', onMouseDown);
  var handleDragLeave = useRippleHandler('stop', onDragLeave);
  var handleMouseUp = useRippleHandler('stop', onMouseUp);
  var handleMouseLeave = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      event.preventDefault();
    }

    if (onMouseLeave) {
      onMouseLeave(event);
    }
  });
  var handleTouchStart = useRippleHandler('start', onTouchStart);
  var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
  var handleTouchMove = useRippleHandler('stop', onTouchMove);
  var handleBlur = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      onBlurVisible(event);
      setFocusVisible(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  }, false);
  var handleFocus = useEventCallback(function (event) {
    // Fix for https://github.com/facebook/react/issues/7769
    if (!buttonRef.current) {
      buttonRef.current = event.currentTarget;
    }

    if (isFocusVisible(event)) {
      setFocusVisible(true);

      if (onFocusVisible) {
        onFocusVisible(event);
      }
    }

    if (onFocus) {
      onFocus(event);
    }
  });

  var isNonNativeButton = function isNonNativeButton() {
    var button = getButtonNode();
    return component && component !== 'button' && !(button.tagName === 'A' && button.href);
  };
  /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */


  var keydownRef = React__namespace.useRef(false);
  var handleKeyDown = useEventCallback(function (event) {
    // Check if key is already down to avoid repeats being counted as multiple activations
    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
      keydownRef.current = true;
      event.persist();
      rippleRef.current.stop(event, function () {
        rippleRef.current.start(event);
      });
    }

    if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
      event.preventDefault();
    }

    if (onKeyDown) {
      onKeyDown(event);
    } // Keyboard accessibility for non interactive elements


    if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
      event.preventDefault();

      if (onClick) {
        onClick(event);
      }
    }
  });
  var handleKeyUp = useEventCallback(function (event) {
    // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
    // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
    if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
      keydownRef.current = false;
      event.persist();
      rippleRef.current.stop(event, function () {
        rippleRef.current.pulsate(event);
      });
    }

    if (onKeyUp) {
      onKeyUp(event);
    } // Keyboard accessibility for non interactive elements


    if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) {
      onClick(event);
    }
  });
  var ComponentProp = component;

  if (ComponentProp === 'button' && other.href) {
    ComponentProp = 'a';
  }

  var buttonProps = {};

  if (ComponentProp === 'button') {
    buttonProps.type = type;
    buttonProps.disabled = disabled;
  } else {
    if (ComponentProp !== 'a' || !other.href) {
      buttonProps.role = 'button';
    }

    buttonProps['aria-disabled'] = disabled;
  }

  var handleUserRef = useForkRef(buttonRefProp, ref);
  var handleOwnRef = useForkRef(focusVisibleRef, buttonRef);
  var handleRef = useForkRef(handleUserRef, handleOwnRef);

  var _React$useState2 = React__namespace.useState(false),
      mountedState = _React$useState2[0],
      setMountedState = _React$useState2[1];

  React__namespace.useEffect(function () {
    setMountedState(true);
  }, []);
  var enableTouchRipple = mountedState && !disableRipple && !disabled;

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React__namespace.useEffect(function () {
      if (enableTouchRipple && !rippleRef.current) {
        console.error(['Material-UI: The `component` prop provided to ButtonBase is invalid.', 'Please make sure the children prop is rendered in this custom component.'].join('\n'));
      }
    }, [enableTouchRipple]);
  }

  return /*#__PURE__*/React__namespace.createElement(ComponentProp, _extends$1({
    className: clsx(classes.root, className, focusVisible && [classes.focusVisible, focusVisibleClassName], disabled && classes.disabled),
    onBlur: handleBlur,
    onClick: onClick,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    onMouseDown: handleMouseDown,
    onMouseLeave: handleMouseLeave,
    onMouseUp: handleMouseUp,
    onDragLeave: handleDragLeave,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    onTouchStart: handleTouchStart,
    ref: handleRef,
    tabIndex: disabled ? -1 : tabIndex
  }, buttonProps, other), children, enableTouchRipple ?
  /*#__PURE__*/

  /* TouchRipple is only needed client-side, x2 boost on the server. */
  React__namespace.createElement(TouchRipple$1, _extends$1({
    ref: rippleRef,
    center: centerRipple
  }, TouchRippleProps)) : null);
});
process.env.NODE_ENV !== "production" ? ButtonBase.propTypes = {
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: refType$1,

  /**
   * @ignore
   *
   * Use that prop to pass a ref to the native button component.
   * @deprecated Use `ref` instead.
   */
  buttonRef: refType$1,

  /**
   * If `true`, the ripples will be centered.
   * They won't start at the cursor interaction position.
   */
  centerRipple: PropTypes.bool,

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,

  /**
   * If `true`, the base button will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
   */
  disableRipple: PropTypes.bool,

  /**
   * If `true`, the touch ripple effect will be disabled.
   */
  disableTouchRipple: PropTypes.bool,

  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * `disableRipple` must also be `false`.
   */
  focusRipple: PropTypes.bool,

  /**
   * This prop can help a person know which element has the keyboard focus.
   * The class name will be applied when the element gain the focus through a keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  onDragLeave: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes.func,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,

  /**
   * @ignore
   */
  onMouseDown: PropTypes.func,

  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,

  /**
   * @ignore
   */
  onMouseUp: PropTypes.func,

  /**
   * @ignore
   */
  onTouchEnd: PropTypes.func,

  /**
   * @ignore
   */
  onTouchMove: PropTypes.func,

  /**
   * @ignore
   */
  onTouchStart: PropTypes.func,

  /**
   * @ignore
   */
  role: PropTypes.string,

  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: PropTypes.object,

  /**
   * Used to control the button's purpose.
   * This prop passes the value to the `type` attribute of the native button component.
   */
  type: PropTypes.oneOf(['submit', 'reset', 'button'])
} : void 0;
var ButtonBase$1 = withStyles(styles$c, {
  name: 'MuiButtonBase'
})(ButtonBase);

var styles$b = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      padding: 12,
      borderRadius: '50%',
      overflow: 'visible',
      // Explicitly set the default value to solve a bug on IE 11.
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        backgroundColor: fade(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        backgroundColor: 'transparent',
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -12,
      '$sizeSmall&': {
        marginLeft: -3
      }
    },

    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -12,
      '$sizeSmall&': {
        marginRight: -3
      }
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: fade(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: fade(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: 3,
      fontSize: theme.typography.pxToRem(18)
    },

    /* Styles applied to the children container element. */
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */

var IconButton = React__namespace.forwardRef(function IconButton(props, ref) {
  var _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = _objectWithoutProperties(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);

  return /*#__PURE__*/React__namespace.createElement(ButtonBase$1, _extends$1({
    className: clsx(classes.root, className, color !== 'default' && classes["color".concat(capitalize(color))], disabled && classes.disabled, size === "small" && classes["size".concat(capitalize(size))], {
      'start': classes.edgeStart,
      'end': classes.edgeEnd
    }[edge]),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref
  }, other), /*#__PURE__*/React__namespace.createElement("span", {
    className: classes.label
  }, children));
});
process.env.NODE_ENV !== "production" ? IconButton.propTypes = {
  /**
   * The icon element.
   */
  children: chainPropTypes(PropTypes.node, function (props) {
    var found = React__namespace.Children.toArray(props.children).some(function (child) {
      return React__namespace.isValidElement(child) && child.props.onClick;
    });

    if (found) {
      return new Error(['Material-UI: You are providing an onClick event listener ' + 'to a child of a button element.', 'Firefox will never trigger the event.', 'You should move the onClick listener to the parent button element.', 'https://github.com/mui-org/material-ui/issues/13957'].join('\n'));
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * If `true`, the button will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   * `disableRipple` must also be true.
   */
  disableFocusRipple: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   */
  edge: PropTypes.oneOf(['start', 'end', false]),

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: PropTypes.oneOf(['small', 'medium'])
} : void 0;
var IconButton$1 = withStyles(styles$b, {
  name: 'MuiIconButton'
})(IconButton);

var styles$a = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      fontSize: theme.typography.pxToRem(24),
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: theme.typography.pxToRem(20)
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: theme.typography.pxToRem(35)
    }
  };
};
var SvgIcon = React__namespace.forwardRef(function SvgIcon(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'inherit' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'svg' : _props$component,
      _props$fontSize = props.fontSize,
      fontSize = _props$fontSize === void 0 ? 'default' : _props$fontSize,
      htmlColor = props.htmlColor,
      titleAccess = props.titleAccess,
      _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
      other = _objectWithoutProperties(props, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);

  return /*#__PURE__*/React__namespace.createElement(Component, _extends$1({
    className: clsx(classes.root, className, color !== 'inherit' && classes["color".concat(capitalize(color))], fontSize !== 'default' && classes["fontSize".concat(capitalize(fontSize))]),
    focusable: "false",
    viewBox: viewBox,
    color: htmlColor,
    "aria-hidden": titleAccess ? undefined : true,
    role: titleAccess ? 'img' : undefined,
    ref: ref
  }, other), children, titleAccess ? /*#__PURE__*/React__namespace.createElement("title", null, titleAccess) : null);
});
process.env.NODE_ENV !== "production" ? SvgIcon.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Node passed into the SVG element.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   */
  color: PropTypes.oneOf(['action', 'disabled', 'error', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,

  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: PropTypes.oneOf(['default', 'inherit', 'large', 'small']),

  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: PropTypes.string,

  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this property.
   */
  shapeRendering: PropTypes.string,

  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: PropTypes.string,

  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: PropTypes.string
} : void 0;
SvgIcon.muiName = 'SvgIcon';
var SvgIcon$1 = withStyles(styles$a, {
  name: 'MuiSvgIcon'
})(SvgIcon);

/**
 * Private module reserved for @material-ui/x packages.
 */

function createSvgIcon(path, displayName) {
  var Component = React__namespace.default.memo(React__namespace.default.forwardRef(function (props, ref) {
    return /*#__PURE__*/React__namespace.default.createElement(SvgIcon$1, _extends$1({
      ref: ref
    }, props), path);
  }));

  if (process.env.NODE_ENV !== 'production') {
    Component.displayName = "".concat(displayName, "Icon");
  }

  Component.muiName = SvgIcon$1.muiName;
  return Component;
}

/**
 * @ignore - internal component.
 */

var CancelIcon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');

function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (process.env.NODE_ENV === 'production') {
    return null;
  }

  var propFullNameSafe = propFullName || propName;

  if (typeof props[propName] !== 'undefined') {
    return new Error("The prop `".concat(propFullNameSafe, "` is not supported. Please remove it."));
  }

  return null;
}

var styles$9 = function styles(theme) {
  var backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700];
  var deleteIconColor = fade(theme.palette.text.primary, 0.26);
  return {
    /* Styles applied to the root element. */
    root: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(13),
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 32,
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor: backgroundColor,
      borderRadius: 32 / 2,
      whiteSpace: 'nowrap',
      transition: theme.transitions.create(['background-color', 'box-shadow']),
      // label will inherit this from root, then `clickable` class overrides this for both
      cursor: 'default',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      textDecoration: 'none',
      border: 'none',
      // Remove `button` border
      padding: 0,
      // Remove `button` padding
      verticalAlign: 'middle',
      boxSizing: 'border-box',
      '&$disabled': {
        opacity: 0.5,
        pointerEvents: 'none'
      },
      '& $avatar': {
        marginLeft: 5,
        marginRight: -6,
        width: 24,
        height: 24,
        color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
        fontSize: theme.typography.pxToRem(12)
      },
      '& $avatarColorPrimary': {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.dark
      },
      '& $avatarColorSecondary': {
        color: theme.palette.secondary.contrastText,
        backgroundColor: theme.palette.secondary.dark
      },
      '& $avatarSmall': {
        marginLeft: 4,
        marginRight: -4,
        width: 18,
        height: 18,
        fontSize: theme.typography.pxToRem(10)
      }
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      height: 24
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `onClick` is defined or `clickable={true}`. */
    clickable: {
      userSelect: 'none',
      WebkitTapHighlightColor: 'transparent',
      cursor: 'pointer',
      '&:hover, &:focus': {
        backgroundColor: emphasize(backgroundColor, 0.08)
      },
      '&:active': {
        boxShadow: theme.shadows[1]
      }
    },

    /* Styles applied to the root element if `onClick` and `color="primary"` is defined or `clickable={true}`. */
    clickableColorPrimary: {
      '&:hover, &:focus': {
        backgroundColor: emphasize(theme.palette.primary.main, 0.08)
      }
    },

    /* Styles applied to the root element if `onClick` and `color="secondary"` is defined or `clickable={true}`. */
    clickableColorSecondary: {
      '&:hover, &:focus': {
        backgroundColor: emphasize(theme.palette.secondary.main, 0.08)
      }
    },

    /* Styles applied to the root element if `onDelete` is defined. */
    deletable: {
      '&:focus': {
        backgroundColor: emphasize(backgroundColor, 0.08)
      }
    },

    /* Styles applied to the root element if `onDelete` and `color="primary"` is defined. */
    deletableColorPrimary: {
      '&:focus': {
        backgroundColor: emphasize(theme.palette.primary.main, 0.2)
      }
    },

    /* Styles applied to the root element if `onDelete` and `color="secondary"` is defined. */
    deletableColorSecondary: {
      '&:focus': {
        backgroundColor: emphasize(theme.palette.secondary.main, 0.2)
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      backgroundColor: 'transparent',
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
        backgroundColor: fade(theme.palette.text.primary, theme.palette.action.hoverOpacity)
      },
      '& $avatar': {
        marginLeft: 4
      },
      '& $avatarSmall': {
        marginLeft: 2
      },
      '& $icon': {
        marginLeft: 4
      },
      '& $iconSmall': {
        marginLeft: 2
      },
      '& $deleteIcon': {
        marginRight: 5
      },
      '& $deleteIconSmall': {
        marginRight: 3
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      color: theme.palette.primary.main,
      border: "1px solid ".concat(theme.palette.primary.main),
      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
        backgroundColor: fade(theme.palette.primary.main, theme.palette.action.hoverOpacity)
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      color: theme.palette.secondary.main,
      border: "1px solid ".concat(theme.palette.secondary.main),
      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
        backgroundColor: fade(theme.palette.secondary.main, theme.palette.action.hoverOpacity)
      }
    },
    // TODO v5: remove

    /* Styles applied to the `avatar` element. */
    avatar: {},

    /* Styles applied to the `avatar` element if `size="small"`. */
    avatarSmall: {},

    /* Styles applied to the `avatar` element if `color="primary"`. */
    avatarColorPrimary: {},

    /* Styles applied to the `avatar` element if `color="secondary"`. */
    avatarColorSecondary: {},

    /* Styles applied to the `icon` element. */
    icon: {
      color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
      marginLeft: 5,
      marginRight: -6
    },

    /* Styles applied to the `icon` element if `size="small"`. */
    iconSmall: {
      width: 18,
      height: 18,
      marginLeft: 4,
      marginRight: -4
    },

    /* Styles applied to the `icon` element if `color="primary"`. */
    iconColorPrimary: {
      color: 'inherit'
    },

    /* Styles applied to the `icon` element if `color="secondary"`. */
    iconColorSecondary: {
      color: 'inherit'
    },

    /* Styles applied to the label `span` element. */
    label: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      paddingLeft: 12,
      paddingRight: 12,
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the label `span` element if `size="small"`. */
    labelSmall: {
      paddingLeft: 8,
      paddingRight: 8
    },

    /* Styles applied to the `deleteIcon` element. */
    deleteIcon: {
      WebkitTapHighlightColor: 'transparent',
      color: deleteIconColor,
      height: 22,
      width: 22,
      cursor: 'pointer',
      margin: '0 5px 0 -6px',
      '&:hover': {
        color: fade(deleteIconColor, 0.4)
      }
    },

    /* Styles applied to the `deleteIcon` element if `size="small"`. */
    deleteIconSmall: {
      height: 16,
      width: 16,
      marginRight: 4,
      marginLeft: -4
    },

    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="default"`. */
    deleteIconColorPrimary: {
      color: fade(theme.palette.primary.contrastText, 0.7),
      '&:hover, &:active': {
        color: theme.palette.primary.contrastText
      }
    },

    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="default"`. */
    deleteIconColorSecondary: {
      color: fade(theme.palette.secondary.contrastText, 0.7),
      '&:hover, &:active': {
        color: theme.palette.secondary.contrastText
      }
    },

    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="outlined"`. */
    deleteIconOutlinedColorPrimary: {
      color: fade(theme.palette.primary.main, 0.7),
      '&:hover, &:active': {
        color: theme.palette.primary.main
      }
    },

    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="outlined"`. */
    deleteIconOutlinedColorSecondary: {
      color: fade(theme.palette.secondary.main, 0.7),
      '&:hover, &:active': {
        color: theme.palette.secondary.main
      }
    }
  };
};

function isDeleteKeyboardEvent(keyboardEvent) {
  return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */


var Chip = React__namespace.forwardRef(function Chip(props, ref) {
  var avatarProp = props.avatar,
      classes = props.classes,
      className = props.className,
      clickableProp = props.clickable,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      ComponentProp = props.component,
      deleteIconProp = props.deleteIcon,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      iconProp = props.icon,
      label = props.label,
      onClick = props.onClick,
      onDelete = props.onDelete,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'default' : _props$variant,
      other = _objectWithoutProperties(props, ["avatar", "classes", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant"]);

  var chipRef = React__namespace.useRef(null);
  var handleRef = useForkRef(chipRef, ref);

  var handleDeleteIconClick = function handleDeleteIconClick(event) {
    // Stop the event from bubbling up to the `Chip`
    event.stopPropagation();

    if (onDelete) {
      onDelete(event);
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    // Ignore events from children of `Chip`.
    if (event.currentTarget === event.target && isDeleteKeyboardEvent(event)) {
      // will be handled in keyUp, otherwise some browsers
      // might init navigation
      event.preventDefault();
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  var handleKeyUp = function handleKeyUp(event) {
    // Ignore events from children of `Chip`.
    if (event.currentTarget === event.target) {
      if (onDelete && isDeleteKeyboardEvent(event)) {
        onDelete(event);
      } else if (event.key === 'Escape' && chipRef.current) {
        chipRef.current.blur();
      }
    }

    if (onKeyUp) {
      onKeyUp(event);
    }
  };

  var clickable = clickableProp !== false && onClick ? true : clickableProp;
  var small = size === 'small';
  var Component = ComponentProp || (clickable ? ButtonBase$1 : 'div');
  var moreProps = Component === ButtonBase$1 ? {
    component: 'div'
  } : {};
  var deleteIcon = null;

  if (onDelete) {
    var customClasses = clsx(color !== 'default' && (variant === "default" ? classes["deleteIconColor".concat(capitalize(color))] : classes["deleteIconOutlinedColor".concat(capitalize(color))]), small && classes.deleteIconSmall);
    deleteIcon = deleteIconProp && React__namespace.isValidElement(deleteIconProp) ? React__namespace.cloneElement(deleteIconProp, {
      className: clsx(deleteIconProp.props.className, classes.deleteIcon, customClasses),
      onClick: handleDeleteIconClick
    }) : /*#__PURE__*/React__namespace.createElement(CancelIcon, {
      className: clsx(classes.deleteIcon, customClasses),
      onClick: handleDeleteIconClick
    });
  }

  var avatar = null;

  if (avatarProp && React__namespace.isValidElement(avatarProp)) {
    avatar = React__namespace.cloneElement(avatarProp, {
      className: clsx(classes.avatar, avatarProp.props.className, small && classes.avatarSmall, color !== 'default' && classes["avatarColor".concat(capitalize(color))])
    });
  }

  var icon = null;

  if (iconProp && React__namespace.isValidElement(iconProp)) {
    icon = React__namespace.cloneElement(iconProp, {
      className: clsx(classes.icon, iconProp.props.className, small && classes.iconSmall, color !== 'default' && classes["iconColor".concat(capitalize(color))])
    });
  }

  if (process.env.NODE_ENV !== 'production') {
    if (avatar && icon) {
      console.error('Material-UI: The Chip component can not handle the avatar ' + 'and the icon prop at the same time. Pick one.');
    }
  }

  return /*#__PURE__*/React__namespace.createElement(Component, _extends$1({
    role: clickable || onDelete ? 'button' : undefined,
    className: clsx(classes.root, className, color !== 'default' && [classes["color".concat(capitalize(color))], clickable && classes["clickableColor".concat(capitalize(color))], onDelete && classes["deletableColor".concat(capitalize(color))]], variant !== "default" && [classes.outlined, {
      'primary': classes.outlinedPrimary,
      'secondary': classes.outlinedSecondary
    }[color]], disabled && classes.disabled, small && classes.sizeSmall, clickable && classes.clickable, onDelete && classes.deletable),
    "aria-disabled": disabled ? true : undefined,
    tabIndex: clickable || onDelete ? 0 : undefined,
    onClick: onClick,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    ref: handleRef
  }, moreProps, other), avatar || icon, /*#__PURE__*/React__namespace.createElement("span", {
    className: clsx(classes.label, small && classes.labelSmall)
  }, label), deleteIcon);
});
process.env.NODE_ENV !== "production" ? Chip.propTypes = {
  /**
   * Avatar element.
   */
  avatar: PropTypes.element,

  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: unsupportedProp,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If false, the chip will not be clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   */
  clickable: PropTypes.bool,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,

  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: PropTypes.element,

  /**
   * If `true`, the chip should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * Icon element.
   */
  icon: PropTypes.element,

  /**
   * The content of the label.
   */
  label: PropTypes.node,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * Callback function fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: PropTypes.func,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,

  /**
   * The size of the chip.
   */
  size: PropTypes.oneOf(['small', 'medium']),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['default', 'outlined'])
} : void 0;
var Chip$1 = withStyles(styles$9, {
  name: 'MuiChip'
})(Chip);

function isMuiElement(element, muiNames) {
  return React__namespace.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

function requirePropFactory(componentNameInError) {
  if (process.env.NODE_ENV === 'production') {
    return function () {
      return null;
    };
  }

  var requireProp = function requireProp(requiredProp) {
    return function (props, propName, componentName, location, propFullName) {
      var propFullNameSafe = propFullName || propName;

      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
        return new Error("The prop `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
      }

      return null;
    };
  };

  return requireProp;
}

/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
function useControlled(_ref) {
  var controlled = _ref.controlled,
      defaultProp = _ref.default,
      name = _ref.name,
      _ref$state = _ref.state,
      state = _ref$state === void 0 ? 'value' : _ref$state;

  var _React$useRef = React__namespace.useRef(controlled !== undefined),
      isControlled = _React$useRef.current;

  var _React$useState = React__namespace.useState(defaultProp),
      valueState = _React$useState[0],
      setValue = _React$useState[1];

  var value = isControlled ? controlled : valueState;

  if (process.env.NODE_ENV !== 'production') {
    React__namespace.useEffect(function () {
      if (isControlled !== (controlled !== undefined)) {
        console.error(["Material-UI: A component is changing the ".concat(isControlled ? '' : 'un', "controlled ").concat(state, " state of ").concat(name, " to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', "Decide between using a controlled or uncontrolled ".concat(name, " ") + 'element for the lifetime of the component.', "The nature of the state is determined during the first render, it's considered controlled if the value is not `undefined`.", 'More info: https://fb.me/react-controlled-components'].join('\n'));
      }
    }, [controlled]);

    var _React$useRef2 = React__namespace.useRef(defaultProp),
        defaultValue = _React$useRef2.current;

    React__namespace.useEffect(function () {
      if (defaultValue !== defaultProp) {
        console.error(["Material-UI: A component is changing the default ".concat(state, " state of an uncontrolled ").concat(name, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(name, ".")].join('\n'));
      }
    }, [JSON.stringify(defaultProp)]);
  }

  var setValueIfUncontrolled = React__namespace.useCallback(function (newValue) {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}

/**
 * Private module reserved for @material-ui/x packages.
 */

function useId(idOverride) {
  var _React$useState = React__namespace.useState(idOverride),
      defaultId = _React$useState[0],
      setDefaultId = _React$useState[1];

  var id = idOverride || defaultId;
  React__namespace.useEffect(function () {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the random value for client-side rendering only.
      // We can't use it server-side.
      setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
    }
  }, [defaultId]);
  return id;
}

/**
 * @ignore - internal component.
 */

var CloseIcon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

/**
 * @ignore - internal component.
 */

var ArrowDropDownIcon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

// Give up on IE 11 support for this feature

function stripDiacritics(string) {
  return typeof string.normalize !== 'undefined' ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : string;
}

function createFilterOptions() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$ignoreAccents = config.ignoreAccents,
      ignoreAccents = _config$ignoreAccents === void 0 ? true : _config$ignoreAccents,
      _config$ignoreCase = config.ignoreCase,
      ignoreCase = _config$ignoreCase === void 0 ? true : _config$ignoreCase,
      limit = config.limit,
      _config$matchFrom = config.matchFrom,
      matchFrom = _config$matchFrom === void 0 ? 'any' : _config$matchFrom,
      stringify = config.stringify,
      _config$trim = config.trim,
      trim = _config$trim === void 0 ? false : _config$trim;
  return function (options, _ref) {
    var inputValue = _ref.inputValue,
        getOptionLabel = _ref.getOptionLabel;
    var input = trim ? inputValue.trim() : inputValue;

    if (ignoreCase) {
      input = input.toLowerCase();
    }

    if (ignoreAccents) {
      input = stripDiacritics(input);
    }

    var filteredOptions = options.filter(function (option) {
      var candidate = (stringify || getOptionLabel)(option);

      if (ignoreCase) {
        candidate = candidate.toLowerCase();
      }

      if (ignoreAccents) {
        candidate = stripDiacritics(candidate);
      }

      return matchFrom === 'start' ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
    });
    return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
  };
} // To replace with .findIndex() once we stop IE 11 support.

function findIndex(array, comp) {
  for (var i = 0; i < array.length; i += 1) {
    if (comp(array[i])) {
      return i;
    }
  }

  return -1;
}

var defaultFilterOptions = createFilterOptions(); // Number of options to jump in list box when pageup and pagedown keys are used.

var pageSize = 5;
function useAutocomplete(props) {
  var _props$autoComplete = props.autoComplete,
      autoComplete = _props$autoComplete === void 0 ? false : _props$autoComplete,
      _props$autoHighlight = props.autoHighlight,
      autoHighlight = _props$autoHighlight === void 0 ? false : _props$autoHighlight,
      _props$autoSelect = props.autoSelect,
      autoSelect = _props$autoSelect === void 0 ? false : _props$autoSelect,
      _props$blurOnSelect = props.blurOnSelect,
      blurOnSelect = _props$blurOnSelect === void 0 ? false : _props$blurOnSelect,
      _props$clearOnBlur = props.clearOnBlur,
      clearOnBlur = _props$clearOnBlur === void 0 ? !props.freeSolo : _props$clearOnBlur,
      _props$clearOnEscape = props.clearOnEscape,
      clearOnEscape = _props$clearOnEscape === void 0 ? false : _props$clearOnEscape,
      _props$componentName = props.componentName,
      componentName = _props$componentName === void 0 ? 'useAutocomplete' : _props$componentName,
      _props$debug = props.debug,
      debug = _props$debug === void 0 ? false : _props$debug,
      _props$defaultValue = props.defaultValue,
      defaultValue = _props$defaultValue === void 0 ? props.multiple ? [] : null : _props$defaultValue,
      _props$disableClearab = props.disableClearable,
      disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab,
      _props$disableCloseOn = props.disableCloseOnSelect,
      disableCloseOnSelect = _props$disableCloseOn === void 0 ? false : _props$disableCloseOn,
      _props$disabledItemsF = props.disabledItemsFocusable,
      disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF,
      _props$disableListWra = props.disableListWrap,
      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
      _props$filterOptions = props.filterOptions,
      filterOptions = _props$filterOptions === void 0 ? defaultFilterOptions : _props$filterOptions,
      _props$filterSelected = props.filterSelectedOptions,
      filterSelectedOptions = _props$filterSelected === void 0 ? false : _props$filterSelected,
      _props$freeSolo = props.freeSolo,
      freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo,
      getOptionDisabled = props.getOptionDisabled,
      _props$getOptionLabel = props.getOptionLabel,
      getOptionLabel = _props$getOptionLabel === void 0 ? function (x) {
    return x;
  } : _props$getOptionLabel,
      _props$getOptionSelec = props.getOptionSelected,
      getOptionSelected = _props$getOptionSelec === void 0 ? function (option, value) {
    return option === value;
  } : _props$getOptionSelec,
      groupBy = props.groupBy,
      _props$handleHomeEndK = props.handleHomeEndKeys,
      handleHomeEndKeys = _props$handleHomeEndK === void 0 ? !props.freeSolo : _props$handleHomeEndK,
      idProp = props.id,
      _props$includeInputIn = props.includeInputInList,
      includeInputInList = _props$includeInputIn === void 0 ? false : _props$includeInputIn,
      inputValueProp = props.inputValue,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      onChange = props.onChange,
      onClose = props.onClose,
      onHighlightChange = props.onHighlightChange,
      onInputChange = props.onInputChange,
      onOpen = props.onOpen,
      openProp = props.open,
      _props$openOnFocus = props.openOnFocus,
      openOnFocus = _props$openOnFocus === void 0 ? false : _props$openOnFocus,
      options = props.options,
      _props$selectOnFocus = props.selectOnFocus,
      selectOnFocus = _props$selectOnFocus === void 0 ? !props.freeSolo : _props$selectOnFocus,
      valueProp = props.value;
  var id = useId(idProp);
  var ignoreFocus = React__namespace.useRef(false);
  var firstFocus = React__namespace.useRef(true);
  var inputRef = React__namespace.useRef(null);
  var listboxRef = React__namespace.useRef(null);

  var _React$useState = React__namespace.useState(null),
      anchorEl = _React$useState[0],
      setAnchorEl = _React$useState[1];

  var _React$useState2 = React__namespace.useState(-1),
      focusedTag = _React$useState2[0],
      setFocusedTag = _React$useState2[1];

  var defaultHighlighted = autoHighlight ? 0 : -1;
  var highlightedIndexRef = React__namespace.useRef(defaultHighlighted);

  var _useControlled = useControlled({
    controlled: valueProp,
    default: defaultValue,
    name: componentName
  }),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      value = _useControlled2[0],
      setValue = _useControlled2[1];

  var _useControlled3 = useControlled({
    controlled: inputValueProp,
    default: '',
    name: componentName,
    state: 'inputValue'
  }),
      _useControlled4 = _slicedToArray(_useControlled3, 2),
      inputValue = _useControlled4[0],
      setInputValue = _useControlled4[1];

  var _React$useState3 = React__namespace.useState(false),
      focused = _React$useState3[0],
      setFocused = _React$useState3[1];

  var resetInputValue = useEventCallback(function (event, newValue) {
    var newInputValue;

    if (multiple) {
      newInputValue = '';
    } else if (newValue == null) {
      newInputValue = '';
    } else {
      var optionLabel = getOptionLabel(newValue);

      if (process.env.NODE_ENV !== 'production') {
        if (typeof optionLabel !== 'string') {
          var erroneousReturn = optionLabel === undefined ? 'undefined' : "".concat(_typeof$2(optionLabel), " (").concat(optionLabel, ")");
          console.error("Material-UI: The `getOptionLabel` method of ".concat(componentName, " returned ").concat(erroneousReturn, " instead of a string for ").concat(JSON.stringify(newValue), "."));
        }
      }

      newInputValue = typeof optionLabel === 'string' ? optionLabel : '';
    }

    if (inputValue === newInputValue) {
      return;
    }

    setInputValue(newInputValue);

    if (onInputChange) {
      onInputChange(event, newInputValue, 'reset');
    }
  });
  React__namespace.useEffect(function () {
    resetInputValue(null, value);
  }, [value, resetInputValue]);

  var _useControlled5 = useControlled({
    controlled: openProp,
    default: false,
    name: componentName,
    state: 'open'
  }),
      _useControlled6 = _slicedToArray(_useControlled5, 2),
      open = _useControlled6[0],
      setOpenState = _useControlled6[1];

  var inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
  var popupOpen = open;
  var filteredOptions = popupOpen ? filterOptions(options.filter(function (option) {
    if (filterSelectedOptions && (multiple ? value : [value]).some(function (value2) {
      return value2 !== null && getOptionSelected(option, value2);
    })) {
      return false;
    }

    return true;
  }), // we use the empty string to manipulate `filterOptions` to not filter any options
  // i.e. the filter predicate always returns true
  {
    inputValue: inputValueIsSelectedValue ? '' : inputValue,
    getOptionLabel: getOptionLabel
  }) : [];

  if (process.env.NODE_ENV !== 'production') {
    if (value !== null && !freeSolo && options.length > 0) {
      var missingValue = (multiple ? value : [value]).filter(function (value2) {
        return !options.some(function (option) {
          return getOptionSelected(option, value2);
        });
      });

      if (missingValue.length > 0) {
        console.warn(["Material-UI: The value provided to ".concat(componentName, " is invalid."), "None of the options match with `".concat(missingValue.length > 1 ? JSON.stringify(missingValue) : JSON.stringify(missingValue[0]), "`."), 'You can use the `getOptionSelected` prop to customize the equality test.'].join('\n'));
      }
    }
  }

  var focusTag = useEventCallback(function (tagToFocus) {
    if (tagToFocus === -1) {
      inputRef.current.focus();
    } else {
      anchorEl.querySelector("[data-tag-index=\"".concat(tagToFocus, "\"]")).focus();
    }
  }); // Ensure the focusedTag is never inconsistent

  React__namespace.useEffect(function () {
    if (multiple && focusedTag > value.length - 1) {
      setFocusedTag(-1);
      focusTag(-1);
    }
  }, [value, multiple, focusedTag, focusTag]);

  function validOptionIndex(index, direction) {
    if (!listboxRef.current || index === -1) {
      return -1;
    }

    var nextFocus = index;

    while (true) {
      // Out of range
      if (direction === 'next' && nextFocus === filteredOptions.length || direction === 'previous' && nextFocus === -1) {
        return -1;
      }

      var option = listboxRef.current.querySelector("[data-option-index=\"".concat(nextFocus, "\"]")); // Same logic as MenuList.js

      var nextFocusDisabled = disabledItemsFocusable ? false : option && (option.disabled || option.getAttribute('aria-disabled') === 'true');

      if (option && !option.hasAttribute('tabindex') || nextFocusDisabled) {
        // Move to the next element.
        nextFocus += direction === 'next' ? 1 : -1;
      } else {
        return nextFocus;
      }
    }
  }

  var setHighlightedIndex = useEventCallback(function (index) {
    var reason = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'auto';
    var event = arguments.length > 2 ? arguments[2] : undefined;
    highlightedIndexRef.current = index; // does the index exist?

    if (index === -1) {
      inputRef.current.removeAttribute('aria-activedescendant');
    } else {
      inputRef.current.setAttribute('aria-activedescendant', "".concat(id, "-option-").concat(index));
    }

    if (!listboxRef.current) {
      return;
    }

    var prev = listboxRef.current.querySelector('[data-focus]');

    if (prev) {
      prev.removeAttribute('data-focus');
    }

    var listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]'); // "No results"

    if (!listboxNode) {
      return;
    }

    if (onHighlightChange) {
      onHighlightChange(event, filteredOptions[index], reason);
    }

    if (index === -1) {
      listboxNode.scrollTop = 0;
      return;
    }

    var option = listboxRef.current.querySelector("[data-option-index=\"".concat(index, "\"]"));

    if (!option) {
      return;
    }

    option.setAttribute('data-focus', 'true'); // Scroll active descendant into view.
    // Logic copied from https://www.w3.org/TR/wai-aria-practices/examples/listbox/js/listbox.js
    //
    // Consider this API instead once it has a better browser support:
    // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });

    if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse') {
      var element = option;
      var scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
      var elementBottom = element.offsetTop + element.offsetHeight;

      if (elementBottom > scrollBottom) {
        listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
      } else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) {
        listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
      }
    }
  });
  var changeHighlightedIndex = useEventCallback(function (diff, direction) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'auto';
    var event = arguments.length > 3 ? arguments[3] : undefined;

    if (!popupOpen) {
      return;
    }

    var getNextIndex = function getNextIndex() {
      var maxIndex = filteredOptions.length - 1;

      if (diff === 'reset') {
        return defaultHighlighted;
      }

      if (diff === 'start') {
        return 0;
      }

      if (diff === 'end') {
        return maxIndex;
      }

      var newIndex = highlightedIndexRef.current + diff;

      if (newIndex < 0) {
        if (newIndex === -1 && includeInputInList) {
          return -1;
        }

        if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) {
          return 0;
        }

        return maxIndex;
      }

      if (newIndex > maxIndex) {
        if (newIndex === maxIndex + 1 && includeInputInList) {
          return -1;
        }

        if (disableListWrap || Math.abs(diff) > 1) {
          return maxIndex;
        }

        return 0;
      }

      return newIndex;
    };

    var nextIndex = validOptionIndex(getNextIndex(), direction);
    setHighlightedIndex(nextIndex, reason, event);

    if (autoComplete && diff !== 'reset') {
      if (nextIndex === -1) {
        inputRef.current.value = inputValue;
      } else {
        var option = getOptionLabel(filteredOptions[nextIndex]);
        inputRef.current.value = option; // The portion of the selected suggestion that has not been typed by the user,
        // a completion string, appears inline after the input cursor in the textbox.

        var index = option.toLowerCase().indexOf(inputValue.toLowerCase());

        if (index === 0 && inputValue.length > 0) {
          inputRef.current.setSelectionRange(inputValue.length, option.length);
        }
      }
    }
  });
  React__namespace.useEffect(function () {
    if (!popupOpen) {
      return;
    }

    var valueItem = multiple ? value[0] : value; // The popup is empty

    if (filteredOptions.length === 0 || valueItem == null) {
      changeHighlightedIndex('reset', 'next');
      return;
    } // Synchronize the value with the highlighted index


    if (!filterSelectedOptions && valueItem != null) {
      var currentOption = filteredOptions[highlightedIndexRef.current]; // Keep the current highlighted index if possible

      if (multiple && currentOption && findIndex(value, function (val) {
        return getOptionSelected(currentOption, val);
      }) !== -1) {
        return;
      }

      var itemIndex = findIndex(filteredOptions, function (optionItem) {
        return getOptionSelected(optionItem, valueItem);
      });

      if (itemIndex === -1) {
        changeHighlightedIndex('reset', 'next');
      } else {
        setHighlightedIndex(itemIndex);
      }

      return;
    } // Keep the index in the boundaries


    if (highlightedIndexRef.current >= filteredOptions.length - 1) {
      setHighlightedIndex(filteredOptions.length - 1);
    } // Ignore filterOptions => options, getOptionSelected, getOptionLabel)
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [value, popupOpen, filterSelectedOptions, changeHighlightedIndex, setHighlightedIndex, inputValue, multiple]);

  var handleOpen = function handleOpen(event) {
    if (open) {
      return;
    }

    setOpenState(true);

    if (onOpen) {
      onOpen(event);
    }
  };

  var handleClose = function handleClose(event, reason) {
    if (!open) {
      return;
    }

    setOpenState(false);

    if (onClose) {
      onClose(event, reason);
    }
  };

  var handleValue = function handleValue(event, newValue, reason, details) {
    if (value === newValue) {
      return;
    }

    if (onChange) {
      onChange(event, newValue, reason, details);
    }

    setValue(newValue);
  };

  var isTouch = React__namespace.useRef(false);

  var selectNewValue = function selectNewValue(event, option) {
    var reasonProp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'select-option';
    var origin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'options';
    var reason = reasonProp;
    var newValue = option;

    if (multiple) {
      newValue = Array.isArray(value) ? _toConsumableArray$1(value) : [];

      if (process.env.NODE_ENV !== 'production') {
        var matches = newValue.filter(function (val) {
          return getOptionSelected(option, val);
        });

        if (matches.length > 1) {
          console.error(["Material-UI: The `getOptionSelected` method of ".concat(componentName, " do not handle the arguments correctly."), "The component expects a single value to match a given option but found ".concat(matches.length, " matches.")].join('\n'));
        }
      }

      var itemIndex = findIndex(newValue, function (valueItem) {
        return getOptionSelected(option, valueItem);
      });

      if (itemIndex === -1) {
        newValue.push(option);
      } else if (origin !== 'freeSolo') {
        newValue.splice(itemIndex, 1);
        reason = 'remove-option';
      }
    }

    resetInputValue(event, newValue);
    handleValue(event, newValue, reason, {
      option: option
    });

    if (!disableCloseOnSelect) {
      handleClose(event, reason);
    }

    if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) {
      inputRef.current.blur();
    }
  };

  function validTagIndex(index, direction) {
    if (index === -1) {
      return -1;
    }

    var nextFocus = index;

    while (true) {
      // Out of range
      if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) {
        return -1;
      }

      var option = anchorEl.querySelector("[data-tag-index=\"".concat(nextFocus, "\"]")); // Same logic as MenuList.js

      if (option && (!option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true')) {
        nextFocus += direction === 'next' ? 1 : -1;
      } else {
        return nextFocus;
      }
    }
  }

  var handleFocusTag = function handleFocusTag(event, direction) {
    if (!multiple) {
      return;
    }

    handleClose(event, 'toggleInput');
    var nextTag = focusedTag;

    if (focusedTag === -1) {
      if (inputValue === '' && direction === 'previous') {
        nextTag = value.length - 1;
      }
    } else {
      nextTag += direction === 'next' ? 1 : -1;

      if (nextTag < 0) {
        nextTag = 0;
      }

      if (nextTag === value.length) {
        nextTag = -1;
      }
    }

    nextTag = validTagIndex(nextTag, direction);
    setFocusedTag(nextTag);
    focusTag(nextTag);
  };

  var handleClear = function handleClear(event) {
    ignoreFocus.current = true;
    setInputValue('');

    if (onInputChange) {
      onInputChange(event, '', 'clear');
    }

    handleValue(event, multiple ? [] : null, 'clear');
  };

  var handleKeyDown = function handleKeyDown(other) {
    return function (event) {
      if (focusedTag !== -1 && ['ArrowLeft', 'ArrowRight'].indexOf(event.key) === -1) {
        setFocusedTag(-1);
        focusTag(-1);
      }

      switch (event.key) {
        case 'Home':
          if (popupOpen && handleHomeEndKeys) {
            // Prevent scroll of the page
            event.preventDefault();
            changeHighlightedIndex('start', 'next', 'keyboard', event);
          }

          break;

        case 'End':
          if (popupOpen && handleHomeEndKeys) {
            // Prevent scroll of the page
            event.preventDefault();
            changeHighlightedIndex('end', 'previous', 'keyboard', event);
          }

          break;

        case 'PageUp':
          // Prevent scroll of the page
          event.preventDefault();
          changeHighlightedIndex(-pageSize, 'previous', 'keyboard', event);
          handleOpen(event);
          break;

        case 'PageDown':
          // Prevent scroll of the page
          event.preventDefault();
          changeHighlightedIndex(pageSize, 'next', 'keyboard', event);
          handleOpen(event);
          break;

        case 'ArrowDown':
          // Prevent cursor move
          event.preventDefault();
          changeHighlightedIndex(1, 'next', 'keyboard', event);
          handleOpen(event);
          break;

        case 'ArrowUp':
          // Prevent cursor move
          event.preventDefault();
          changeHighlightedIndex(-1, 'previous', 'keyboard', event);
          handleOpen(event);
          break;

        case 'ArrowLeft':
          handleFocusTag(event, 'previous');
          break;

        case 'ArrowRight':
          handleFocusTag(event, 'next');
          break;

        case 'Enter':
          // Wait until IME is settled.
          if (event.which === 229) {
            break;
          }

          if (highlightedIndexRef.current !== -1 && popupOpen) {
            var option = filteredOptions[highlightedIndexRef.current];
            var disabled = getOptionDisabled ? getOptionDisabled(option) : false;

            if (disabled) {
              return;
            } // We don't want to validate the form.


            event.preventDefault();
            selectNewValue(event, option, 'select-option'); // Move the selection to the end.

            if (autoComplete) {
              inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
            }
          } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
            if (multiple) {
              // Allow people to add new values before they submit the form.
              event.preventDefault();
            }

            selectNewValue(event, inputValue, 'create-option', 'freeSolo');
          }

          break;

        case 'Escape':
          if (popupOpen) {
            // Avoid Opera to exit fullscreen mode.
            event.preventDefault(); // Avoid the Modal to handle the event.

            event.stopPropagation();
            handleClose(event, 'escape');
          } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0)) {
            // Avoid Opera to exit fullscreen mode.
            event.preventDefault(); // Avoid the Modal to handle the event.

            event.stopPropagation();
            handleClear(event);
          }

          break;

        case 'Backspace':
          if (multiple && inputValue === '' && value.length > 0) {
            var index = focusedTag === -1 ? value.length - 1 : focusedTag;

            var newValue = _toConsumableArray$1(value);

            newValue.splice(index, 1);
            handleValue(event, newValue, 'remove-option', {
              option: value[index]
            });
          }

          break;
      }

      if (other.onKeyDown) {
        other.onKeyDown(event);
      }
    };
  };

  var handleFocus = function handleFocus(event) {
    setFocused(true);

    if (openOnFocus && !ignoreFocus.current) {
      handleOpen(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    // Ignore the event when using the scrollbar with IE 11
    if (listboxRef.current !== null && document.activeElement === listboxRef.current.parentElement) {
      inputRef.current.focus();
      return;
    }

    setFocused(false);
    firstFocus.current = true;
    ignoreFocus.current = false;

    if (debug && inputValue !== '') {
      return;
    }

    if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) {
      selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
    } else if (autoSelect && freeSolo && inputValue !== '') {
      selectNewValue(event, inputValue, 'blur', 'freeSolo');
    } else if (clearOnBlur) {
      resetInputValue(event, value);
    }

    handleClose(event, 'blur');
  };

  var handleInputChange = function handleInputChange(event) {
    var newValue = event.target.value;

    if (inputValue !== newValue) {
      setInputValue(newValue);

      if (onInputChange) {
        onInputChange(event, newValue, 'input');
      }
    }

    if (newValue === '') {
      if (!disableClearable && !multiple) {
        handleValue(event, null, 'clear');
      }
    } else {
      handleOpen(event);
    }
  };

  var handleOptionMouseOver = function handleOptionMouseOver(event) {
    var index = Number(event.currentTarget.getAttribute('data-option-index'));
    setHighlightedIndex(index, 'mouse', event);
  };

  var handleOptionTouchStart = function handleOptionTouchStart() {
    isTouch.current = true;
  };

  var handleOptionClick = function handleOptionClick(event) {
    var index = Number(event.currentTarget.getAttribute('data-option-index'));
    selectNewValue(event, filteredOptions[index], 'select-option');
    isTouch.current = false;
  };

  var handleTagDelete = function handleTagDelete(index) {
    return function (event) {
      var newValue = _toConsumableArray$1(value);

      newValue.splice(index, 1);
      handleValue(event, newValue, 'remove-option', {
        option: value[index]
      });
    };
  };

  var handleListboxRef = useEventCallback(function (node) {
    setRef(listboxRef, node);

    if (!node) {
      return;
    } // Automatically select the first option as the listbox become visible.


    if (highlightedIndexRef.current === -1 && autoHighlight) {
      changeHighlightedIndex('reset', 'next');
    } else {
      // Restore the focus to the correct option.
      setHighlightedIndex(highlightedIndexRef.current);
    }
  });

  var handlePopupIndicator = function handlePopupIndicator(event) {
    if (open) {
      handleClose(event, 'toggleInput');
    } else {
      handleOpen(event);
    }
  }; // Prevent input blur when interacting with the combobox


  var handleMouseDown = function handleMouseDown(event) {
    if (event.target.getAttribute('id') !== id) {
      event.preventDefault();
    }
  }; // Focus the input when interacting with the combobox


  var handleClick = function handleClick() {
    inputRef.current.focus();

    if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) {
      inputRef.current.select();
    }

    firstFocus.current = false;
  };

  var handleInputMouseDown = function handleInputMouseDown(event) {
    if (inputValue === '' || !open) {
      handlePopupIndicator(event);
    }
  };

  var dirty = freeSolo && inputValue.length > 0;
  dirty = dirty || (multiple ? value.length > 0 : value !== null);
  var groupedOptions = filteredOptions;

  if (groupBy) {
    // used to keep track of key and indexes in the result array
    var indexBy = new Map();
    var warn = false;
    groupedOptions = filteredOptions.reduce(function (acc, option, index) {
      var group = groupBy(option);

      if (acc.length > 0 && acc[acc.length - 1].group === group) {
        acc[acc.length - 1].options.push(option);
      } else {
        if (process.env.NODE_ENV !== 'production') {
          if (indexBy.get(group) && !warn) {
            console.warn("Material-UI: The options provided combined with the `groupBy` method of ".concat(componentName, " returns duplicated headers."), 'You can solve the issue by sorting the options with the output of `groupBy`.');
            warn = true;
          }

          indexBy.set(group, true);
        }

        acc.push({
          key: index,
          index: index,
          group: group,
          options: [option]
        });
      }

      return acc;
    }, []);
  }

  return {
    getRootProps: function getRootProps() {
      var other = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _extends$1(_extends$1({
        'aria-owns': popupOpen ? "".concat(id, "-popup") : null,
        role: 'combobox',
        'aria-expanded': popupOpen
      }, other), {}, {
        onKeyDown: handleKeyDown(other),
        onMouseDown: handleMouseDown,
        onClick: handleClick
      });
    },
    getInputLabelProps: function getInputLabelProps() {
      return {
        id: "".concat(id, "-label"),
        htmlFor: id
      };
    },
    getInputProps: function getInputProps() {
      return {
        id: id,
        value: inputValue,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onChange: handleInputChange,
        onMouseDown: handleInputMouseDown,
        // if open then this is handled imperativeley so don't let react override
        // only have an opinion about this when closed
        'aria-activedescendant': popupOpen ? '' : null,
        'aria-autocomplete': autoComplete ? 'both' : 'list',
        'aria-controls': popupOpen ? "".concat(id, "-popup") : null,
        // Disable browser's suggestion that might overlap with the popup.
        // Handle autocomplete but not autofill.
        autoComplete: 'off',
        ref: inputRef,
        autoCapitalize: 'none',
        spellCheck: 'false'
      };
    },
    getClearProps: function getClearProps() {
      return {
        tabIndex: -1,
        onClick: handleClear
      };
    },
    getPopupIndicatorProps: function getPopupIndicatorProps() {
      return {
        tabIndex: -1,
        onClick: handlePopupIndicator
      };
    },
    getTagProps: function getTagProps(_ref2) {
      var index = _ref2.index;
      return {
        key: index,
        'data-tag-index': index,
        tabIndex: -1,
        onDelete: handleTagDelete(index)
      };
    },
    getListboxProps: function getListboxProps() {
      return {
        role: 'listbox',
        id: "".concat(id, "-popup"),
        'aria-labelledby': "".concat(id, "-label"),
        ref: handleListboxRef,
        onMouseDown: function onMouseDown(event) {
          // Prevent blur
          event.preventDefault();
        }
      };
    },
    getOptionProps: function getOptionProps(_ref3) {
      var index = _ref3.index,
          option = _ref3.option;
      var selected = (multiple ? value : [value]).some(function (value2) {
        return value2 != null && getOptionSelected(option, value2);
      });
      var disabled = getOptionDisabled ? getOptionDisabled(option) : false;
      return {
        key: index,
        tabIndex: -1,
        role: 'option',
        id: "".concat(id, "-option-").concat(index),
        onMouseOver: handleOptionMouseOver,
        onClick: handleOptionClick,
        onTouchStart: handleOptionTouchStart,
        'data-option-index': index,
        'aria-disabled': disabled,
        'aria-selected': selected
      };
    },
    id: id,
    inputValue: inputValue,
    value: value,
    dirty: dirty,
    popupOpen: popupOpen,
    focused: focused || focusedTag !== -1,
    anchorEl: anchorEl,
    setAnchorEl: setAnchorEl,
    focusedTag: focusedTag,
    groupedOptions: groupedOptions
  };
}

var styles$8 = function styles(theme) {
  var _option;

  return {
    /* Styles applied to the root element. */
    root: {
      '&:hover $clearIndicatorDirty, &$focused $clearIndicatorDirty': {
        visibility: 'visible'
      }
    },

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Pseudo-class applied to the root element if focused. */
    focused: {},

    /* Styles applied to the tag elements, e.g. the chips. */
    tag: {
      margin: 3,
      maxWidth: 'calc(100% - 6px)'
    },

    /* Styles applied to the tag elements, e.g. the chips if `size="small"`. */
    tagSizeSmall: {
      margin: 2,
      maxWidth: 'calc(100% - 4px)'
    },

    /* Styles applied when the popup icon is rendered. */
    hasPopupIcon: {},

    /* Styles applied when the clear icon is rendered. */
    hasClearIcon: {},

    /* Styles applied to the Input element. */
    inputRoot: {
      flexWrap: 'wrap',
      '$hasPopupIcon &, $hasClearIcon &': {
        paddingRight: 26 + 4
      },
      '$hasPopupIcon$hasClearIcon &': {
        paddingRight: 52 + 4
      },
      '& $input': {
        width: 0,
        minWidth: 30
      },
      '&[class*="MuiInput-root"]': {
        paddingBottom: 1,
        '& $input': {
          padding: 4
        },
        '& $input:first-child': {
          padding: '6px 0'
        }
      },
      '&[class*="MuiInput-root"][class*="MuiInput-marginDense"]': {
        '& $input': {
          padding: '4px 4px 5px'
        },
        '& $input:first-child': {
          padding: '3px 0 6px'
        }
      },
      '&[class*="MuiOutlinedInput-root"]': {
        padding: 9,
        '$hasPopupIcon &, $hasClearIcon &': {
          paddingRight: 26 + 4 + 9
        },
        '$hasPopupIcon$hasClearIcon &': {
          paddingRight: 52 + 4 + 9
        },
        '& $input': {
          padding: '9.5px 4px'
        },
        '& $input:first-child': {
          paddingLeft: 6
        },
        '& $endAdornment': {
          right: 9
        }
      },
      '&[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"]': {
        padding: 6,
        '& $input': {
          padding: '4.5px 4px'
        }
      },
      '&[class*="MuiFilledInput-root"]': {
        paddingTop: 19,
        paddingLeft: 8,
        '$hasPopupIcon &, $hasClearIcon &': {
          paddingRight: 26 + 4 + 9
        },
        '$hasPopupIcon$hasClearIcon &': {
          paddingRight: 52 + 4 + 9
        },
        '& $input': {
          padding: '9px 4px'
        },
        '& $endAdornment': {
          right: 9
        }
      },
      '&[class*="MuiFilledInput-root"][class*="MuiFilledInput-marginDense"]': {
        paddingBottom: 1,
        '& $input': {
          padding: '4.5px 4px'
        }
      }
    },

    /* Styles applied to the input element. */
    input: {
      flexGrow: 1,
      textOverflow: 'ellipsis',
      opacity: 0
    },

    /* Styles applied to the input element if tag focused. */
    inputFocused: {
      opacity: 1
    },

    /* Styles applied to the endAdornment element. */
    endAdornment: {
      // We use a position absolute to support wrapping tags.
      position: 'absolute',
      right: 0,
      top: 'calc(50% - 14px)' // Center vertically

    },

    /* Styles applied to the clear indicator. */
    clearIndicator: {
      marginRight: -2,
      padding: 4,
      visibility: 'hidden'
    },

    /* Styles applied to the clear indicator if the input is dirty. */
    clearIndicatorDirty: {},

    /* Styles applied to the popup indicator. */
    popupIndicator: {
      padding: 2,
      marginRight: -2
    },

    /* Styles applied to the popup indicator if the popup is open. */
    popupIndicatorOpen: {
      transform: 'rotate(180deg)'
    },

    /* Styles applied to the popper element. */
    popper: {
      zIndex: theme.zIndex.modal
    },

    /* Styles applied to the popper element if `disablePortal={true}`. */
    popperDisablePortal: {
      position: 'absolute'
    },

    /* Styles applied to the `Paper` component. */
    paper: _extends$1(_extends$1({}, theme.typography.body1), {}, {
      overflow: 'hidden',
      margin: '4px 0'
    }),

    /* Styles applied to the `listbox` component. */
    listbox: {
      listStyle: 'none',
      margin: 0,
      padding: '8px 0px',
      maxHeight: '40vh',
      overflow: 'auto'
    },

    /* Styles applied to the loading wrapper. */
    loading: {
      color: theme.palette.text.secondary,
      padding: '14px 16px'
    },

    /* Styles applied to the no option wrapper. */
    noOptions: {
      color: theme.palette.text.secondary,
      padding: '14px 16px'
    },

    /* Styles applied to the option elements. */
    option: (_option = {
      minHeight: 48,
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      cursor: 'pointer',
      paddingTop: 6,
      boxSizing: 'border-box',
      outline: '0',
      WebkitTapHighlightColor: 'transparent',
      paddingBottom: 6,
      paddingLeft: 16,
      paddingRight: 16
    }, _defineProperty(_option, theme.breakpoints.up('sm'), {
      minHeight: 'auto'
    }), _defineProperty(_option, '&[aria-selected="true"]', {
      backgroundColor: theme.palette.action.selected
    }), _defineProperty(_option, '&[data-focus="true"]', {
      backgroundColor: theme.palette.action.hover
    }), _defineProperty(_option, '&:active', {
      backgroundColor: theme.palette.action.selected
    }), _defineProperty(_option, '&[aria-disabled="true"]', {
      opacity: theme.palette.action.disabledOpacity,
      pointerEvents: 'none'
    }), _option),

    /* Styles applied to the group's label elements. */
    groupLabel: {
      backgroundColor: theme.palette.background.paper,
      top: -8
    },

    /* Styles applied to the group's ul elements. */
    groupUl: {
      padding: 0,
      '& $option': {
        paddingLeft: 24
      }
    }
  };
};

function DisablePortal(props) {
  // eslint-disable-next-line react/prop-types
  props.anchorEl;
      props.open;
      var other = _objectWithoutProperties(props, ["anchorEl", "open"]);

  return /*#__PURE__*/React__namespace.createElement("div", other);
}

var _ref$2 = /*#__PURE__*/React__namespace.createElement(CloseIcon, {
  fontSize: "small"
});

var _ref2 = /*#__PURE__*/React__namespace.createElement(ArrowDropDownIcon, null);

var Autocomplete = React__namespace.forwardRef(function Autocomplete(props, ref) {
  /* eslint-disable no-unused-vars */
  props.autoComplete;
      props.autoHighlight;
      props.autoSelect;
      props.blurOnSelect;
      var ChipProps = props.ChipProps,
      classes = props.classes,
      className = props.className,
      _props$clearOnBlur = props.clearOnBlur;
      _props$clearOnBlur === void 0 ? !props.freeSolo : _props$clearOnBlur;
      props.clearOnEscape;
      var _props$clearText = props.clearText,
      clearText = _props$clearText === void 0 ? 'Clear' : _props$clearText,
      _props$closeIcon = props.closeIcon,
      closeIcon = _props$closeIcon === void 0 ? _ref$2 : _props$closeIcon,
      _props$closeText = props.closeText,
      closeText = _props$closeText === void 0 ? 'Close' : _props$closeText;
      props.debug;
      var _props$defaultValue = props.defaultValue;
      _props$defaultValue === void 0 ? props.multiple ? [] : null : _props$defaultValue;
      var _props$disableClearab = props.disableClearable,
      disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab;
      props.disableCloseOnSelect;
      var _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled;
      props.disabledItemsFocusable;
      props.disableListWrap;
      var _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal;
      props.filterOptions;
      props.filterSelectedOptions;
      var _props$forcePopupIcon = props.forcePopupIcon,
      forcePopupIcon = _props$forcePopupIcon === void 0 ? 'auto' : _props$forcePopupIcon,
      _props$freeSolo = props.freeSolo,
      freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$getLimitTagsTe = props.getLimitTagsText,
      getLimitTagsText = _props$getLimitTagsTe === void 0 ? function (more) {
    return "+".concat(more);
  } : _props$getLimitTagsTe;
      props.getOptionDisabled;
      var _props$getOptionLabel = props.getOptionLabel,
      getOptionLabel = _props$getOptionLabel === void 0 ? function (x) {
    return x;
  } : _props$getOptionLabel;
      props.getOptionSelected;
      var groupBy = props.groupBy,
      _props$handleHomeEndK = props.handleHomeEndKeys;
      _props$handleHomeEndK === void 0 ? !props.freeSolo : _props$handleHomeEndK;
      props.id;
      props.includeInputInList;
      props.inputValue;
      var _props$limitTags = props.limitTags,
      limitTags = _props$limitTags === void 0 ? -1 : _props$limitTags,
      _props$ListboxCompone = props.ListboxComponent,
      ListboxComponent = _props$ListboxCompone === void 0 ? 'ul' : _props$ListboxCompone,
      ListboxProps = props.ListboxProps,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      _props$loadingText = props.loadingText,
      loadingText = _props$loadingText === void 0 ? 'Loading…' : _props$loadingText,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      _props$noOptionsText = props.noOptionsText,
      noOptionsText = _props$noOptionsText === void 0 ? 'No options' : _props$noOptionsText;
      props.onChange;
      props.onClose;
      props.onHighlightChange;
      props.onInputChange;
      props.onOpen;
      props.open;
      props.openOnFocus;
      var _props$openText = props.openText,
      openText = _props$openText === void 0 ? 'Open' : _props$openText;
      props.options;
      var _props$PaperComponent = props.PaperComponent,
      PaperComponent = _props$PaperComponent === void 0 ? Paper$1 : _props$PaperComponent,
      _props$PopperComponen = props.PopperComponent,
      PopperComponentProp = _props$PopperComponen === void 0 ? Popper$1 : _props$PopperComponen,
      _props$popupIcon = props.popupIcon,
      popupIcon = _props$popupIcon === void 0 ? _ref2 : _props$popupIcon,
      renderGroupProp = props.renderGroup,
      renderInput = props.renderInput,
      renderOptionProp = props.renderOption,
      renderTags = props.renderTags,
      _props$selectOnFocus = props.selectOnFocus;
      _props$selectOnFocus === void 0 ? !props.freeSolo : _props$selectOnFocus;
      var _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size;
      props.value;
      var other = _objectWithoutProperties(props, ["autoComplete", "autoHighlight", "autoSelect", "blurOnSelect", "ChipProps", "classes", "className", "clearOnBlur", "clearOnEscape", "clearText", "closeIcon", "closeText", "debug", "defaultValue", "disableClearable", "disableCloseOnSelect", "disabled", "disabledItemsFocusable", "disableListWrap", "disablePortal", "filterOptions", "filterSelectedOptions", "forcePopupIcon", "freeSolo", "fullWidth", "getLimitTagsText", "getOptionDisabled", "getOptionLabel", "getOptionSelected", "groupBy", "handleHomeEndKeys", "id", "includeInputInList", "inputValue", "limitTags", "ListboxComponent", "ListboxProps", "loading", "loadingText", "multiple", "noOptionsText", "onChange", "onClose", "onHighlightChange", "onInputChange", "onOpen", "open", "openOnFocus", "openText", "options", "PaperComponent", "PopperComponent", "popupIcon", "renderGroup", "renderInput", "renderOption", "renderTags", "selectOnFocus", "size", "value"]);
  /* eslint-enable no-unused-vars */


  var PopperComponent = disablePortal ? DisablePortal : PopperComponentProp;

  var _useAutocomplete = useAutocomplete(_extends$1(_extends$1({}, props), {}, {
    componentName: 'Autocomplete'
  })),
      getRootProps = _useAutocomplete.getRootProps,
      getInputProps = _useAutocomplete.getInputProps,
      getInputLabelProps = _useAutocomplete.getInputLabelProps,
      getPopupIndicatorProps = _useAutocomplete.getPopupIndicatorProps,
      getClearProps = _useAutocomplete.getClearProps,
      getTagProps = _useAutocomplete.getTagProps,
      getListboxProps = _useAutocomplete.getListboxProps,
      getOptionProps = _useAutocomplete.getOptionProps,
      value = _useAutocomplete.value,
      dirty = _useAutocomplete.dirty,
      id = _useAutocomplete.id,
      popupOpen = _useAutocomplete.popupOpen,
      focused = _useAutocomplete.focused,
      focusedTag = _useAutocomplete.focusedTag,
      anchorEl = _useAutocomplete.anchorEl,
      setAnchorEl = _useAutocomplete.setAnchorEl,
      inputValue = _useAutocomplete.inputValue,
      groupedOptions = _useAutocomplete.groupedOptions;

  var startAdornment;

  if (multiple && value.length > 0) {
    var getCustomizedTagProps = function getCustomizedTagProps(params) {
      return _extends$1({
        className: clsx(classes.tag, size === 'small' && classes.tagSizeSmall),
        disabled: disabled
      }, getTagProps(params));
    };

    if (renderTags) {
      startAdornment = renderTags(value, getCustomizedTagProps);
    } else {
      startAdornment = value.map(function (option, index) {
        return /*#__PURE__*/React__namespace.createElement(Chip$1, _extends$1({
          label: getOptionLabel(option),
          size: size
        }, getCustomizedTagProps({
          index: index
        }), ChipProps));
      });
    }
  }

  if (limitTags > -1 && Array.isArray(startAdornment)) {
    var more = startAdornment.length - limitTags;

    if (!focused && more > 0) {
      startAdornment = startAdornment.splice(0, limitTags);
      startAdornment.push( /*#__PURE__*/React__namespace.createElement("span", {
        className: classes.tag,
        key: startAdornment.length
      }, getLimitTagsText(more)));
    }
  }

  var defaultRenderGroup = function defaultRenderGroup(params) {
    return /*#__PURE__*/React__namespace.createElement("li", {
      key: params.key
    }, /*#__PURE__*/React__namespace.createElement(ListSubheader$1, {
      className: classes.groupLabel,
      component: "div"
    }, params.group), /*#__PURE__*/React__namespace.createElement("ul", {
      className: classes.groupUl
    }, params.children));
  };

  var renderGroup = renderGroupProp || defaultRenderGroup;
  var renderOption = renderOptionProp || getOptionLabel;

  var renderListOption = function renderListOption(option, index) {
    var optionProps = getOptionProps({
      option: option,
      index: index
    });
    return /*#__PURE__*/React__namespace.createElement("li", _extends$1({}, optionProps, {
      className: classes.option
    }), renderOption(option, {
      selected: optionProps['aria-selected'],
      inputValue: inputValue
    }));
  };

  var hasClearIcon = !disableClearable && !disabled;
  var hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement("div", _extends$1({
    ref: ref,
    className: clsx(classes.root, className, focused && classes.focused, fullWidth && classes.fullWidth, hasClearIcon && classes.hasClearIcon, hasPopupIcon && classes.hasPopupIcon)
  }, getRootProps(other)), renderInput({
    id: id,
    disabled: disabled,
    fullWidth: true,
    size: size === 'small' ? 'small' : undefined,
    InputLabelProps: getInputLabelProps(),
    InputProps: {
      ref: setAnchorEl,
      className: classes.inputRoot,
      startAdornment: startAdornment,
      endAdornment: /*#__PURE__*/React__namespace.createElement("div", {
        className: classes.endAdornment
      }, hasClearIcon ? /*#__PURE__*/React__namespace.createElement(IconButton$1, _extends$1({}, getClearProps(), {
        "aria-label": clearText,
        title: clearText,
        className: clsx(classes.clearIndicator, dirty && classes.clearIndicatorDirty)
      }), closeIcon) : null, hasPopupIcon ? /*#__PURE__*/React__namespace.createElement(IconButton$1, _extends$1({}, getPopupIndicatorProps(), {
        disabled: disabled,
        "aria-label": popupOpen ? closeText : openText,
        title: popupOpen ? closeText : openText,
        className: clsx(classes.popupIndicator, popupOpen && classes.popupIndicatorOpen)
      }), popupIcon) : null)
    },
    inputProps: _extends$1({
      className: clsx(classes.input, focusedTag === -1 && classes.inputFocused),
      disabled: disabled
    }, getInputProps())
  })), popupOpen && anchorEl ? /*#__PURE__*/React__namespace.createElement(PopperComponent, {
    className: clsx(classes.popper, disablePortal && classes.popperDisablePortal),
    style: {
      width: anchorEl ? anchorEl.clientWidth : null
    },
    role: "presentation",
    anchorEl: anchorEl,
    open: true
  }, /*#__PURE__*/React__namespace.createElement(PaperComponent, {
    className: classes.paper
  }, loading && groupedOptions.length === 0 ? /*#__PURE__*/React__namespace.createElement("div", {
    className: classes.loading
  }, loadingText) : null, groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/React__namespace.createElement("div", {
    className: classes.noOptions
  }, noOptionsText) : null, groupedOptions.length > 0 ? /*#__PURE__*/React__namespace.createElement(ListboxComponent, _extends$1({
    className: classes.listbox
  }, getListboxProps(), ListboxProps), groupedOptions.map(function (option, index) {
    if (groupBy) {
      return renderGroup({
        key: option.key,
        group: option.group,
        children: option.options.map(function (option2, index2) {
          return renderListOption(option2, option.index + index2);
        })
      });
    }

    return renderListOption(option, index);
  })) : null)) : null);
});
process.env.NODE_ENV !== "production" ? Autocomplete.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the portion of the selected suggestion that has not been typed by the user,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   */
  autoComplete: PropTypes.bool,

  /**
   * If `true`, the first option is automatically highlighted.
   */
  autoHighlight: PropTypes.bool,

  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   */
  autoSelect: PropTypes.bool,

  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   */
  blurOnSelect: PropTypes.oneOfType([PropTypes.oneOf(['mouse', 'touch']), PropTypes.bool]),

  /**
   * Props applied to the [`Chip`](/api/chip/) element.
   */
  ChipProps: PropTypes.object,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the input's text will be cleared on blur if no value is selected.
   *
   * Set to `true` if you want to help the user enter a new value.
   * Set to `false` if you want to help the user resume his search.
   */
  clearOnBlur: PropTypes.bool,

  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   */
  clearOnEscape: PropTypes.bool,

  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  clearText: PropTypes.string,

  /**
   * The icon to display in place of the default close icon.
   */
  closeIcon: PropTypes.node,

  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  closeText: PropTypes.string,

  /**
   * If `true`, the popup will ignore the blur event if the input is filled.
   * You can inspect the popup markup with your browser tools.
   * Consider this option when you need to customize the component.
   */
  debug: PropTypes.bool,

  /**
   * The default input value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.oneOfType([PropTypes.any, PropTypes.array]),

  /**
   * If `true`, the input can't be cleared.
   */
  disableClearable: PropTypes.bool,

  /**
   * If `true`, the popup won't close when a value is selected.
   */
  disableCloseOnSelect: PropTypes.bool,

  /**
   * If `true`, the input will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, will allow focus on disabled items.
   */
  disabledItemsFocusable: PropTypes.bool,

  /**
   * If `true`, the list box in the popup will not wrap focus.
   */
  disableListWrap: PropTypes.bool,

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: PropTypes.bool,

  /**
   * A filter function that determines the options that are eligible.
   *
   * @param {T[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {T[]}
   */
  filterOptions: PropTypes.func,

  /**
   * If `true`, hide the selected options from the list box.
   */
  filterSelectedOptions: PropTypes.bool,

  /**
   * Force the visibility display of the popup icon.
   */
  forcePopupIcon: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.bool]),

  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   */
  freeSolo: PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   */
  getLimitTagsText: PropTypes.func,

  /**
   * Used to determine the disabled state for a given option.
   *
   * @param {T} option The option to test.
   * @returns {boolean}
   */
  getOptionDisabled: PropTypes.func,

  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * @param {T} option
   * @returns {string}
   */
  getOptionLabel: PropTypes.func,

  /**
   * Used to determine if an option is selected, considering the current value.
   * Uses strict equality by default.
   *
   * @param {T} option The option to test.
   * @param {T} value The value to test against.
   * @returns {boolean}
   */
  getOptionSelected: PropTypes.func,

  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {T} options The options to group.
   * @returns {string}
   */
  groupBy: PropTypes.func,

  /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   */
  handleHomeEndKeys: PropTypes.bool,

  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: PropTypes.string,

  /**
   * If `true`, the highlight can move to the input.
   */
  includeInputInList: PropTypes.bool,

  /**
   * The input value.
   */
  inputValue: PropTypes.string,

  /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   */
  limitTags: PropTypes.number,

  /**
   * The component used to render the listbox.
   */
  ListboxComponent: PropTypes.elementType,

  /**
   * Props applied to the Listbox element.
   */
  ListboxProps: PropTypes.object,

  /**
   * If `true`, the component is in a loading state.
   */
  loading: PropTypes.bool,

  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  loadingText: PropTypes.node,

  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes.bool,

  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  noOptionsText: PropTypes.node,

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback.
   * @param {T} value The new value of the component.
   * @param {string} reason One of "create-option", "select-option", "remove-option", "blur" or "clear".
   */
  onChange: PropTypes.func,

  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"select-option"`, `"blur"`.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired when the highlight option changes.
   *
   * @param {object} event The event source of the callback.
   * @param {T} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"auto"`, `"mouse"`.
   */
  onHighlightChange: PropTypes.func,

  /**
   * Callback fired when the input value changes.
   *
   * @param {object} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`.
   */
  onInputChange: PropTypes.func,

  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,

  /**
   * Control the popup` open state.
   */
  open: PropTypes.bool,

  /**
   * If `true`, the popup will open on input focus.
   */
  openOnFocus: PropTypes.bool,

  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  openText: PropTypes.string,

  /**
   * Array of options.
   */
  options: PropTypes.array.isRequired,

  /**
   * The component used to render the body of the popup.
   */
  PaperComponent: PropTypes.elementType,

  /**
   * The component used to position the popup.
   */
  PopperComponent: PropTypes.elementType,

  /**
   * The icon to display in place of the default popup icon.
   */
  popupIcon: PropTypes.node,

  /**
   * Render the group.
   *
   * @param {any} option The group to render.
   * @returns {ReactNode}
   */
  renderGroup: PropTypes.func,

  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: PropTypes.func.isRequired,

  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {T} option The option to render.
   * @param {object} state The state of the component.
   * @returns {ReactNode}
   */
  renderOption: PropTypes.func,

  /**
   * Render the selected value.
   *
   * @param {T[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @returns {ReactNode}
   */
  renderTags: PropTypes.func,

  /**
   * If `true`, the input's text will be selected on focus.
   * It helps the user clear the selected value.
   */
  selectOnFocus: PropTypes.bool,

  /**
   * The size of the autocomplete.
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `getOptionSelected` prop.
   */
  value: PropTypes.oneOfType([PropTypes.any, PropTypes.array])
} : void 0;
var Autocomplete$1 = withStyles(styles$8, {
  name: 'MuiAutocomplete'
})(Autocomplete);

// TODO: Determine if there's a better place to put this.
//  Note that other UI modules put this in their src/module directory, but for the Framework that
//  directory is used for a different purpose than the modules: It is used to define the API for
//  UI modules to use to register themselves as modules.
//  This implies that either this file is fine where it is and the other stuff belongs
//  elsewhere, OR vice versa.
var moduleId = "framework";

var MENU_ITEMS$3 = {
	USER_PREFERENCES: {
		TARGET: "Preferences",
		NOTE: "The header of the user preference page (displayed in title case) where the user can manage its application preferences (language, landing page, etc)."
	}
};
var GREETING$3 = {
	MENU_TITLE: {
		TARGET: "Hello {{firstname}}",
		NOTE: "A short greeting message (displayed in sentence case) which remains on the user's screen as a label of a button that opens a menu with personal options."
	}
};
var RESET_PASSWORD$3 = {
	HEADING: {
		TARGET: "Reset Employee Password",
		NOTE: "The header of the modal (displayed in sentence case) used by the user to define a new password."
	},
	DESCRIPTION: {
		TARGET: " Use this form to reset an employee's password. Be sure to remember the new password and share it with them as soon as possible. This password is temporary and will need to be changed by the user on the next login.",
		NOTE: "Text paragraph (displayed in sentence case) presented in the password reset modal. Provides a brief instruction on how to use the password reset feature."
	},
	CANCEL_BUTTON: {
		TARGET: "Cancel",
		NOTE: "The caption of a button (displayed in Title case) present in the password reset modal. If the user clicks the password reset modal will be closed without applying the changes."
	},
	RESET_BUTTON: {
		TARGET: "Reset Password",
		NOTE: "The caption of a button (displayed in Title case) present in the password reset modal. By clicking the button the user confirms the password reset action."
	},
	RESETTING_BUTTON: {
		TARGET: "Resetting Password",
		NOTE: "The caption of the button (displayed in Title case) used by the user to confirm the password reset action. This caption replaces the original one while the application is processing the password reset action. The button is disabled during this processing period."
	},
	PASSWORD_SUCCESS: {
		TARGET: "Password reset successfully",
		NOTE: "A toast message (displayed in Sentence case) on the password reset modal. It notifies the user that the password was successfully reset."
	},
	MATCH_PASSWORD: {
		TARGET: "Passwords do not match.",
		NOTE: "Helper text (displayed in Sentence case) displayed below the password confirmation fields in case the password entered in the password fields does not match."
	},
	MINIMUM_REQUIREMENT: {
		TARGET: "Password does not meet minimum requirements.",
		NOTE: "Text message (displayed in Sentence case) displayed below the password reset fields and above the action confirmation buttons in case the new password does not meet minimum requirements."
	},
	CONFIRM_PASSWORD: {
		TARGET: "Confirm Password",
		NOTE: "Label of a text field input (displayed in Title case) for confirming the new password value (second password field input)."
	},
	ERROR_BLACKLISTED: {
		TARGET: "This password is blacklisted. Please use a different password.",
		NOTE: "Text message (in sentence case) shown below the password fields if the password reset operation failed due to the submission of a blacklisted password."
	},
	ERROR_LENGTH: {
		TARGET: "The password must have a minimum length of {{length}}",
		NOTE: "Text message (in sentence case) shown below the password fields if the password reset operation failed because the new password does not meet the minimum length requirement."
	},
	ERROR_REGEX: {
		TARGET: "The password does not match a custom regex pattern.",
		NOTE: "Text message (in sentence case) shown below the password fields if the password reset operation failed because the new password does not meet a specific pattern required for the user's context."
	},
	ERROR_GENERIC: {
		TARGET: "The password {{errorMessage}}",
		NOTE: "Text message (in sentence case) shown below the password fields if the password reset operation failed due to a generic error which description is sent by the Central Authentication Service."
	}
};
var USER_PREFERENCES$3 = {
	BACK_ARROW: {
		TARGET: "Back",
		NOTE: "Aria-label (used by a screen reader) to tell user that hitting this button will return them to the User Preferences Page"
	},
	LANDING_PAGE: {
		TARGET: "Landing Page",
		NOTE: "The title of the page (displayed in title case) in which the user is able to choose what page will the first page seen by the user right after login. This label is used in case of desktop devices."
	},
	LANGUAGE: {
		TARGET: "Language",
		NOTE: "The title of the Language and Localization page (displayed in Title case). It means that the user can configure different locale-specific and regional settings (such as language, date/time formats, etc.) on that page."
	},
	LANGUAGE_AND_LOCALIZATION: {
		TARGET: "Language and Localization",
		NOTE: "The user preference tab name of the Language and Localization page (displayed in Title case). It means that the user can configure different locale-specific and regional settings (such as language, date/time formats, etc.) on that page."
	},
	LANGUAGE_AND_LOCALIZATION_TITLE: {
		TARGET: "Language and Localization",
		NOTE: "The title of the Language and Localization page (displayed in Title case). It means that the user can configure different locale-specific and regional settings (such as language, date/time formats, etc.) on that page."
	},
	LANGUAGE_AND_LOCALIZATION_SUBTITLE: {
		TARGET: "Select the language and localization options below to be used throughout the WorkForce Suite.",
		NOTE: "The subtitle text of the Language and Localization page (displayed in Sentence case). It explains the settings that could be configured by the user on that page."
	},
	TIME_FORMAT_PREFERENCE_TITLE: {
		TARGET: "Time Format Preference",
		NOTE: "The title of the Time Format Preference section in the Language and Localization page (displayed in Title case). It means that the user can configure its own format setting (current account format setting, 12 hours, 24 hours, etc.)."
	},
	TIME_FORMATTING_ACCOUNT_CONFIG_DEFAULT_LABEL: {
		TARGET: "My organization's settings",
		NOTE: "The label of the AccountConfigDefault option (displayed in Sentence case). It means that the account configured time format will be used."
	},
	TIME_FORMATTING_ACCOUNT_CONFIG_DEFAULT_DESCRIPTION: {
		TARGET: "Time will displayed based on the setting chosen by a system administrator.",
		NOTE: "The description of the AccountConfigDefault option (displayed in Sentence case). It means that the account configured time format will be used."
	},
	TIME_FORMATTING_LOCALE_DEFAULT_LABEL: {
		TARGET: "My language / locale format",
		NOTE: "The label of the LocaleDefault option (displayed in Sentence case). It means that the time format will be based on User's selected language. For example: if the current selected language is Australian English it means that Australian time format will be used."
	},
	TIME_FORMATTING_LOCALE_DEFAULT_DESCRIPTION: {
		TARGET: "Time will be based on the language / location associated with the language selected above.",
		NOTE: "The description of the LocaleDefault option (displayed in Sentence case). It means that the time format will be based on User's selected language. For example: if the current selected language is Australian English it means that Australian time format will be used."
	},
	TIME_FORMATTING_FORCE_12_HOURS_LABEL: {
		TARGET: "12 hour display",
		NOTE: "The label of the Force12Hours option (displayed in Sentence case). It means that the time format will be 12 hours (AM/PM)."
	},
	TIME_FORMATTING_FORCE_12_HOURS_DESCRIPTION: {
		TARGET: "Time will display as 12:00 (AM/PM) regardless of language / location of your organization's settings.",
		NOTE: "The description of the Force12Hours option (displayed in Sentence case). It means that the time format will be 12 hours (AM/PM)."
	},
	TIME_FORMATTING_FORCE_24_HOURS_LABEL: {
		TARGET: "24 hour display",
		NOTE: "The label of the Force24Hours option (displayed in Sentence case). It means that the time format will be 00:00 - 24:00 hours (without AM/PM)."
	},
	TIME_FORMATTING_FORCE_24_HOURS_DESCRIPTION: {
		TARGET: "Time will display as 00:00 - 24:00 regardless of language / location of your organization's settings.",
		NOTE: "The description of the Force12Hours option (displayed in Sentence case). It means that the time format will be 00:00 - 24:00 hours (without AM/PM)."
	},
	SETTING_UPDATE_SUCCESS: {
		TARGET: "Setting updated successfully.",
		NOTE: "A toast message displayed in Sentence case. It notifies that the current settings has been saved successfully."
	},
	SETTING_UPDATE_FAILED: {
		TARGET: "Setting failed to update. Please, try again later.",
		NOTE: "A toast message displayed in Sentence case. It notifies that the current settings couldn't be saved."
	},
	THEME: {
		TARGET: "Theme",
		NOTE: "Label of a select field input (displayed in Title case) used to select the theme (application colors, fonts, etc) to be used on the application."
	},
	THEMES: {
		TARGET: "Themes",
		NOTE: "Title of the page (in title case), shown on desktop devices, where the user is able to choose its preferred theme (application colors, fonts, etc). Used both in header of the page and as description of menu entry in the side menu."
	},
	CHANGE_THEME: {
		TARGET: "Change Theme",
		NOTE: "Title of the page (in title case), shown on mobile devices, where the user is able to choose its preferred theme (application colors, fonts, etc). Used both in header of the page and as description of menu entry in the side menu."
	},
	CHANGE_LANGUAGE: {
		TARGET: "Change Language",
		NOTE: "Title of the page (in title case) where the user is able to change application's language. Used as header of the page on mobile devices."
	},
	CHANGE_LANDING_PAGE: {
		TARGET: "Change Landing Page",
		NOTE: "The title of the page (displayed in title case) in which the user is able to choose what page will the first page seen by the user right after login.  This label is used in case of mobile devices."
	},
	HUB_AND_ASSISTANT_EMPLOYEE_GROUPS: {
		TARGET: "Hub and Assistant Employee Groups",
		NOTE: "The label of the side menu entry (displayed in title case) that takes the user to the page where it is possible to select which assistant cards will be available for each employee group."
	},
	SAVE: {
		TARGET: "Save",
		NOTE: "The caption of a button (displayed in title case) displayed in user preferences pages. If the user clicks the button, the changes get saved."
	},
	LANDING_PAGE_DESCRIPTION: {
		TARGET: "Select the page you want to see when you log in to the WorkForce Suite.",
		NOTE: "A brief helper message (displayed in sentence case) presented on the page where the user is able to choose the landing page for the application. It is positioned right under the page header and helps the user on how to use the page."
	},
	HUB_PAGE: {
		TARGET: "Hub page",
		NOTE: "Text in title case that describes the radio button option for the default choice for landing page (the hub page)."
	},
	CUSTOM: {
		TARGET: "Custom",
		NOTE: "Text in title case that describes the radio button option that enables the user to customize which page will be used as the landing page."
	},
	CUSTOM_LANDING_PAGE: {
		TARGET: "Custom landing page",
		NOTE: "Text in title case used as a placeholder for the form field used to select the page that will be used as landing page."
	},
	LANDING_PAGE_RADIO_GROUP_ARIA_LABEL: {
		TARGET: "Choose whether to have a custom landing page, or default to the hub",
		NOTE: "Accessible name (aria label) for the field (radio button group) used to define the application landing page."
	},
	DISCARD_CHANGES: {
		TARGET: "Discard Changes",
		NOTE: "The caption of a button (displayed in title case) that discards unsaved changes to a user preference. It is presented in the footer of every user preference setting page."
	},
	CHANGES_SAVED: {
		TARGET: "Changes saved",
		NOTE: "The caption of a button (displayed in title case) that saves a user preference setting. It appears as a confirmation"
	}
};
var EMPLOYEE_GROUP_FILTERS$3 = {
	TITLE: {
		TARGET: "Hub and Assistant Employee Groups",
		NOTE: "The text header (displayed in title case) in the page where it is possible to select which assistant cards will be available for each employee group (user preference)."
	},
	DESCRIPTION: {
		TARGET: "Choose which group you'd like to see items for in the Hub and Assistant",
		NOTE: "Text paragraph (displayed in sentence case) presented in the Hub and Assistant Employee Groups preference page. Provides a brief instruction on how to use the page."
	}
};
var NAV_MENU$3 = {
	BURGER_MENU: {
		TARGET: "Suite Navigation Menu",
		NOTE: "Hamburger button that when clicked opens a dropdown with the naviagation items."
	},
	CLOSE_MENU: {
		TARGET: "Close navigation menu",
		NOTE: "Close button that when clicked closes the navigation menu."
	},
	BACK_ARROW: {
		TARGET: "Back",
		NOTE: "Aria-label (used by a screen reader) to tell user that hitting this button will return them to the navigation menu."
	},
	TOOLBAR: {
		TARGET: "Toolbar",
		NOTE: "Aria-label (used by a screen reader) to tell user that general top navigation toolbar that includes profile, assistant, and experience icons."
	},
	ADMIN: {
		TARGET: "Admin",
		NOTE: "Navigation menu main entry (display in title case) that groups links to most of the admin features.",
		WFX: {
			TARGET: "Enhanced Communications",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Experience' feature."
		},
		DEMAND_SCHEDULING: {
			TARGET: "Demand Scheduling",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Demand Scheduling' feature."
		},
		SCHEDULING_EMPLOYEE_ADMIN: {
			TARGET: "Scheduling - Employee Administration",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Scheduling Employee' feature."
		},
		SCHEDULING_MODEL_ADMIN: {
			TARGET: "Scheduling - Model Administration",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Scheduling Model' feature."
		},
		SCHEDULING_RULE_SETUP: {
			TARGET: "Scheduling - Rule Setup",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Scheduling Rule Setup' feature."
		},
		SCHEDULING_SECURITY_ADMIN: {
			TARGET: "Scheduling - Security Administration",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Scheduling Security' feature."
		},
		SCHEDULING_STANDARD_SCHEDULING: {
			TARGET: "Scheduling - Standard Scheduling",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Standard Scheduling' feature."
		},
		SYSTEM_SETUP: {
			TARGET: "System Setup",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'System Setup' feature."
		},
		TIME_JOB_DATA_MANAGEMENT: {
			TARGET: "Time - Jobs and Data Management",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Time - Job Data Management' feature."
		},
		TIME_USER_GROUP_MANAGEMENT: {
			TARGET: "Time - User and Group Management",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Time - User and Group Management' feature."
		},
		CLOCKING: {
			TARGET: "Clocking",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Clocking' feature."
		}
	},
	REPORTS: {
		TARGET: "Reports",
		NOTE: "Navigation menu main entry (display in title case) that groups links to application reports."
	},
	STAFF: {
		TARGET: "Staff",
		NOTE: ""
	},
	SUPPORT: {
		TARGET: "Support",
		NOTE: ""
	},
	TIME_OFF: {
		TARGET: "Time Off",
		NOTE: ""
	},
	TIMESHEET: {
		TARGET: "Timesheet",
		NOTE: ""
	},
	SCHEDULE: {
		TARGET: "Schedule",
		NOTE: ""
	},
	FORECAST: {
		TARGET: "Forecast",
		NOTE: ""
	},
	HELP: {
		TARGET: "Help",
		NOTE: "Navigation menu main entry (display in title case) that groups links to application help pages."
	},
	WFX: {
		TARGET: "Enhanced Communications",
		NOTE: "Navigation menu main entry (display in title case) that groups links to access Workforce Experience features."
	}
};
var NAV_LINKS$3 = {
	PREFERENCES: {
		TARGET: "Preferences",
		NOTE: "The title of a link (displayed in title case) in a navigation menu that takes the user to the page manages its application preferences (language, landing page, etc)."
	},
	IMPERSONATION: {
		TARGET: "Impersonate",
		NOTE: "Navigation menu entry (in title case) that links to the the impersonation modal dialog. It allows the current user to login the application as another user."
	},
	SIGN_OUT: {
		TARGET: "Sign Out",
		NOTE: "Text label (in title case) for the navigation menu entry that logs the user out of the application after clicked."
	},
	MY_TIMESHEET: {
		TARGET: "My Timesheet",
		NOTE: ""
	},
	VIEW_PAST_ASSIGNMENTS: {
		TARGET: "View Past Assignments",
		NOTE: ""
	},
	MY_NEXT_GEN_TIMESHEET: {
		TARGET: "My Next-Gen Timesheet",
		NOTE: ""
	},
	TIME_CLOCK: {
		TARGET: "Time Clock",
		NOTE: "Navigation menu label for the Time Clock page. The text is in Title Case."
	},
	PAYROLL_WEEKLY: {
		TARGET: "Payroll Weekly",
		NOTE: ""
	},
	AVAILABILITY: {
		TARGET: "Availability",
		NOTE: ""
	},
	MY_ACCOUNT: {
		TARGET: "My Account",
		NOTE: ""
	},
	AUTO_SCHEDULE: {
		TARGET: "Auto Schedule",
		NOTE: ""
	},
	MY_SCHEDULE_WFS: {
		TARGET: "My Schedule",
		NOTE: ""
	},
	AUTO_SCHEDULE_WFS: {
		TARGET: "Auto-Schedule",
		NOTE: ""
	},
	TIME_AND_ATTENDANCE: {
		TARGET: "Time and Attendance",
		NOTE: ""
	},
	SHIFT_SWAP: {
		TARGET: "Shift Swap",
		NOTE: ""
	},
	AVAILABILITY_TEMPLATE: {
		TARGET: "Availability Template",
		NOTE: ""
	},
	POINT_OF_SALE_ERRORS: {
		TARGET: "Point of Sale Errors",
		NOTE: ""
	},
	SHIFT_BIDDING: {
		TARGET: "My Shift Bidding",
		NOTE: ""
	},
	SHIFT_BIDDING_PREFERENCES: {
		TARGET: "My Shift Bidding Preferences",
		NOTE: ""
	},
	MANAGE_SHIFT_BIDDING: {
		TARGET: "Manage Shift Bidding",
		NOTE: ""
	},
	APPROVAL_AND_EXCEPTIONS: {
		TARGET: "Approval and Exceptions",
		NOTE: ""
	},
	SYSTEM_ADMINISTRATION: {
		TARGET: "System Administration",
		NOTE: "The title of a link (displayed in title case) in a navigation menu that takes the user to the System Administration Page"
	},
	CONFIG_AND_SECURITY_CHECK: {
		TARGET: "Configuration & Security Check",
		NOTE: "The title of a link (displayed in title case) in a navigation menu that takes the user to the Configuration and Security Check Page"
	},
	STATUS_SUMMARY: {
		TARGET: "Status Summary",
		NOTE: ""
	},
	COWORKER: {
		TARGET: "CoWorker Schedule",
		NOTE: ""
	},
	TIME_OFF_SUMMARY: {
		TARGET: "Time Off Summary",
		NOTE: ""
	},
	LIVE_ATTENDANCE_STATUS: {
		TARGET: "Live Attendance Status",
		NOTE: ""
	},
	MY_TIME_OFF_WFS: {
		TARGET: "My Time Off WFS",
		NOTE: ""
	},
	RESET_PASSWORD: {
		TARGET: "Reset Employee Password",
		NOTE: "The title of a link (displayed in title case) in a navigation menu that takes the user to the Reset Employee Password page"
	},
	DYNAMIC_SCHEDULING: {
		TARGET: "Dynamic Scheduling",
		NOTE: ""
	},
	VIEW_REPORTS_WFS: {
		TARGET: "View Scheduling Reports",
		NOTE: ""
	},
	MESSAGES: {
		TARGET: "Messages",
		NOTE: ""
	},
	PERSONAL_DATA_SUMMARY: {
		TARGET: "Personal Data Summary",
		NOTE: ""
	},
	TODAY_PREFERENCES: {
		TARGET: "Today Preferences",
		NOTE: ""
	},
	SCHEDULE_TEMPLATES: {
		TARGET: "Schedule templates",
		NOTE: ""
	},
	MANAGE_TIMESHEET: {
		TARGET: "Manage Timesheet",
		NOTE: ""
	},
	BUDGETING: {
		TARGET: "Budgeting",
		NOTE: ""
	},
	FORECAST: {
		TARGET: "Forecast",
		NOTE: ""
	},
	VIEW_FORECASTS: {
		TARGET: "Forecasts",
		NOTE: ""
	},
	TASK_EDITOR: {
		TARGET: "Tasks",
		NOTE: ""
	},
	SETTINGS: {
		TARGET: "Settings",
		NOTE: ""
	},
	ASSOCIATE_MANAGEMENT: {
		TARGET: "Associate Management",
		NOTE: "The title of a link (displayed in title case) in a navigation menu that takes the user to the Associate Management page"
	},
	EMPLOYEE_SETTINGS: {
		TARGET: "Employee Settings",
		NOTE: "The title of a link (displayed in title case) in a navigation menu that takes the user to the Employee Settings page"
	},
	MY_INFO: {
		TARGET: "My Info",
		NOTE: ""
	},
	SQL_REPORTS: {
		TARGET: "Scheduling Reports",
		NOTE: ""
	},
	ADVANCED_SCHEDULING_REPORTS: {
		TARGET: "Classic Job Scheduling Reports",
		NOTE: ""
	},
	MANAGE_TEMPLATES: {
		TARGET: "Manage Templates",
		NOTE: ""
	},
	GROUP_MESSAGING: {
		TARGET: "Group Messaging",
		NOTE: ""
	},
	MY_TIMESHEETS: {
		TARGET: "My Timesheets",
		NOTE: ""
	},
	FATIGUE_MANAGEMENT: {
		TARGET: "Fatigue Management",
		NOTE: ""
	},
	REVIEW_SWAP_REQUESTS: {
		TARGET: "Review Swap Requests",
		NOTE: ""
	},
	VIEW_REPORTS: {
		TARGET: "View Reports",
		NOTE: ""
	},
	ASSIGN_BADGES: {
		TARGET: "Assign Badges",
		NOTE: ""
	},
	ADMIN_BADGE_MAINTENANCE: {
		TARGET: "Badge Maintenance",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Badge Maintenance' feature"
	},
	ANALYTICS_REPORT: {
		TARGET: "Analytics Report",
		NOTE: ""
	},
	KPI_DASHBOARD: {
		TARGET: "KPI Dashboard",
		NOTE: ""
	},
	EDIT_EMPLOYEES: {
		TARGET: "My Employees' Data",
		NOTE: ""
	},
	MANUAL_CALLOUT_RULES: {
		TARGET: "Manual Callout Rules",
		NOTE: ""
	},
	ADMIN_CALLOUT_MANUAL_RULES: {
		TARGET: "Callout - Manual Rules",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Callout - Manual Rules' feature."
	},
	MY_CONTACT_PREFERENCES: {
		TARGET: "My Contact Preferences",
		NOTE: ""
	},
	MANAGE_NO_CALL_MODEL_LIST: {
		TARGET: "Manage No Call Model List",
		NOTE: ""
	},
	MANAGE_MODELS: {
		TARGET: "Manage Models",
		NOTE: ""
	},
	APPROVE_TIMESHEETS: {
		TARGET: "Approve Timesheets",
		NOTE: "The navigation link to the classic approval screen, displayed only in desktop as a submenu of Timesheet."
	},
	APPROVE_TIMESHEETS_NEXT_GEN: {
		TARGET: "Approve Timesheets",
		NOTE: "The navigation link to the next generation approval screen, displayed only in mobile as a submenu of Timesheet."
	},
	OVERTIME_TYPE: {
		TARGET: "Overtime Type",
		NOTE: ""
	},
	MANAGE_EMPLOYEE_LISTS: {
		TARGET: "Manage Employee Lists",
		NOTE: ""
	},
	MANAGE_USERS: {
		TARGET: "Manage Users",
		NOTE: ""
	},
	ADMIN_USERS_DATA: {
		TARGET: "Users Data",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Users Data' feature."
	},
	LINE_ITEM_APPROVAL: {
		TARGET: "Line Item Approval",
		NOTE: ""
	},
	EDIT_USER_GROUPS: {
		TARGET: "Edit User Groups",
		NOTE: ""
	},
	ROTATION_PATTERN_ASSIGNMENT: {
		TARGET: "Rotation Pattern Assignment",
		NOTE: ""
	},
	QUALIFICATIONS: {
		TARGET: "Qualifications",
		NOTE: ""
	},
	USER_SECURITY_MAINTENANCE: {
		TARGET: "User Security Maintenance",
		NOTE: ""
	},
	ADMIN_USER_SECURITY_MAINTENANCE: {
		TARGET: "User Roles and Security",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'User Roles and Security' feature."
	},
	ROTATION_PATTERN_MANAGEMENT: {
		TARGET: "Rotation Pattern Management",
		NOTE: ""
	},
	EMPLOYEE_SCHEDULE_MANAGEMENT: {
		TARGET: "Employee Schedule Management",
		NOTE: ""
	},
	WEB_CLOCK: {
		TARGET: "WebClock",
		NOTE: ""
	},
	LAUNCH_ADMIN_CLIENT: {
		TARGET: "Launch Admin Client",
		NOTE: ""
	},
	ADMIN_LAUNCH_ADMIN_CLIENT: {
		TARGET: "Launch WT&A Admin Client",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Launch WT&A Admin Client' feature."
	},
	CALLOUT_RESPONSES: {
		TARGET: "Callout Responses",
		NOTE: ""
	},
	MY_SWAP_REQUESTS: {
		TARGET: "My Swap Requests",
		NOTE: ""
	},
	COPY_SCHEDULE: {
		TARGET: "Copy Schedule",
		NOTE: ""
	},
	REASON_CODES: {
		TARGET: "Reason Codes",
		NOTE: ""
	},
	DELEGATION_MANAGEMENT: {
		TARGET: "Delegation Management",
		NOTE: ""
	},
	ADMIN_DELEGATIONS: {
		TARGET: "Delegations",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Delegations' feature."
	},
	DELEGATION_SUPER: {
		TARGET: "Manage All Delegations",
		NOTE: "Manage All Delegations menu option (for the Super Delegation system feature)."
	},
	ADMIN_DELEGATION_SUPER: {
		TARGET: "All Delegations",
		NOTE: "All Delegations (for the Super Delegation system feature)."
	},
	SHIFTS: {
		TARGET: "Shifts",
		NOTE: ""
	},
	MY_TIME_OFF: {
		TARGET: "My Time Off",
		NOTE: ""
	},
	VIEW_MY_TIME_OFF_REQUESTS: {
		TARGET: "View My Time Off",
		NOTE: "Sub-menu title within Time Off hub menu for new employee time off request list screen. It displays in Title case. Allow employees to view their time off requests list on new suite screen."
	},
	RUN_JOB: {
		TARGET: "Run Job",
		NOTE: ""
	},
	CREW_PRODUCTION: {
		TARGET: "Crew Production",
		NOTE: ""
	},
	ASSIGN_SCHEDULES: {
		TARGET: "Assign Schedules",
		NOTE: ""
	},
	POLICY_MAPPING_FOR_IMPORTS: {
		TARGET: "Policy Mapping for Imports",
		NOTE: ""
	},
	EMPLOYEES: {
		TARGET: "Employees",
		NOTE: ""
	},
	ADMIN_EMPLOYEES_DATA: {
		TARGET: "Employee Data",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Employees Data' feature."
	},
	GROUP_CALENDARS: {
		TARGET: "Group Calendars",
		NOTE: ""
	},
	ADJUST_BANK_BALANCES: {
		TARGET: "Adjust Bank Balances",
		NOTE: ""
	},
	ORGANIZATION: {
		TARGET: "Organization",
		NOTE: ""
	},
	RECALCULATE_ASSIGNMENT_GROUPS: {
		TARGET: "Recalculate Assignment Groups",
		NOTE: ""
	},
	ADMIN_RECALCULATE_EMPLOYEE_GROUPS: {
		TARGET: "Employee Groups - Recalculate",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Recalculate Employee Groups' feature."
	},
	MANAGE_STAFFING_REQUIREMENTS: {
		TARGET: "Manage Staffing Requirements",
		NOTE: ""
	},
	EDIT_PROFILES: {
		TARGET: "Edit Profiles",
		NOTE: ""
	},
	ADMIN_PROFILE_MANAGEMENT: {
		TARGET: "Profile Management",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Profile Management' feature."
	},
	EMPLOYEE_FILTERS: {
		TARGET: "Employee Filters",
		NOTE: ""
	},
	MODIFY_SCHEDULE: {
		TARGET: "Modify Schedule",
		NOTE: ""
	},
	BID_PACKAGE_ADMINISTRATION: {
		TARGET: "Bid Package Administration",
		NOTE: ""
	},
	MANAGE_GROUPS: {
		TARGET: "Manage Groups",
		NOTE: ""
	},
	ADMIN_CURRENT_EMPLOYEE_GROUPS: {
		TARGET: "Employee Groups - Current",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Current Employee Groups' feature."
	},
	SUBNAV_MANAGE_SUPER: {
		TARGET: "Manage Groups",
		NOTE: "General feature allowing the user to manage assignment groups through the Manage Groups menu option."
	},
	ADMIN_SUBNAV_MANAGE_SUPER: {
		TARGET: "Employee Groups - Current",
		NOTE: "General feature allowing the user manage existing assignment groups."
	},
	CREATE_GROUPS: {
		TARGET: "Create Groups",
		NOTE: ""
	},
	ADMIN_NEW_EMPLOYEE_GROUPS: {
		TARGET: "Employee Groups - New",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'New Employee Group' feature."
	},
	SUBNAV_CREATE_SUPER: {
		TARGET: "Create Groups",
		NOTE: "General feature allowing the user to create new assignment groups through the Create Groups menu option."
	},
	ADMIN_SUBNAV_CREATE_SUPER: {
		TARGET: "Employee Groups - New",
		NOTE: "General feature allowing the user create new assignment groups."
	},
	IMPORT_DATA: {
		TARGET: "Import Data",
		NOTE: ""
	},
	JOB_STATUS: {
		TARGET: "Job Status",
		NOTE: ""
	},
	ASSIGNMENT_RULES: {
		TARGET: "Assignment Rules",
		NOTE: ""
	},
	SCHEDULING_GROUPS: {
		TARGET: "Scheduling Groups",
		NOTE: ""
	},
	EMPLOYEE_CALENDARS: {
		TARGET: "Employee Calendars",
		NOTE: ""
	},
	STATION_MANAGEMENT: {
		TARGET: "Station Management",
		NOTE: ""
	},
	GROUP_TIME: {
		TARGET: "Group Timesheets",
		NOTE: ""
	},
	CALLOUT_RULE: {
		TARGET: "Callout Rule",
		NOTE: ""
	},
	DELETE_SCHEDULE: {
		TARGET: "Delete Schedule",
		NOTE: ""
	},
	LEAVE_SUMMARY: {
		TARGET: "Leave Summary",
		NOTE: "Allows employees to view their annual leave summary on classic Time off request screen."
	},
	LEAVE_REGULATIONS: {
		TARGET: "Leave Regulations",
		NOTE: ""
	},
	CHANGE_MY_PASSWORD: {
		TARGET: "Change My Password",
		NOTE: ""
	},
	MANAGE_GROUP_SCHEDULES: {
		TARGET: "Manage Group Schedules",
		NOTE: ""
	},
	MANAGE_ABSENCE_CASES: {
		TARGET: "Manage Absence Cases",
		NOTE: ""
	},
	COMPLIANCE_PORTAL: {
		TARGET: "Compliance Portal",
		NOTE: ""
	},
	COMPLIANCE_ON_DEMAND: {
		TARGET: "Compliance On Demand",
		NOTE: "Navigation submenu item (displayed in title case) providing access to Compliance on Demand"
	},
	DISPLAY_ELEMENTS: {
		TARGET: "Display Elements",
		NOTE: ""
	},
	SELECTION_CONSTRAINTS: {
		TARGET: "Selection Constraints",
		NOTE: ""
	},
	REVIEW_TIME_OFF_REQUESTS: {
		TARGET: "Review Time Off Requests",
		NOTE: ""
	},
	AUTO_SCHEDULE_STAFFING_CRITERIA: {
		TARGET: "Auto Schedule Staffing Criteria",
		NOTE: ""
	},
	ADMIN_AUTO_SCHEDULE_STAFFING_CRITERIA: {
		TARGET: "Autoschedule Staffing Criteria",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Autoschedule Staffing Criteria' feature."
	},
	CALLOUT_TERMINATION_CODE_SETS: {
		TARGET: "Callout Termination Code Sets",
		NOTE: ""
	},
	PERMISSION_SETUP: {
		TARGET: "Permission Setup",
		NOTE: ""
	},
	SCHEDULE_MAINTENANCE: {
		TARGET: "Schedule Maintenance",
		NOTE: ""
	},
	MODEL_FILTERS: {
		TARGET: "Model Filters",
		NOTE: ""
	},
	END_OF_PERIOD_PROCESSING: {
		TARGET: "End of Period Processing",
		NOTE: ""
	},
	SERVER_ADMINISTRATION: {
		TARGET: "Server Administration",
		NOTE: ""
	},
	RUN_AUTO_SCHEDULE: {
		TARGET: "Run Auto Schedule",
		NOTE: ""
	},
	CALLOUT: {
		TARGET: "Callout",
		NOTE: ""
	},
	FACILITIES: {
		TARGET: "Facilities",
		NOTE: ""
	},
	SELECTION_PREFERENCES: {
		TARGET: "Selection Preferences",
		NOTE: ""
	},
	"MANAGE_RETRO-CALC_TRIGGERS": {
		TARGET: "Manage Retro-Calc Triggers",
		NOTE: ""
	},
	"ADMIN_RETRO-CALC_TRIGGERS": {
		TARGET: "Retro-calc Triggers",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Retro-calc Triggers' feature."
	},
	CREW_MAINTENANCE: {
		TARGET: "Crew Maintenance",
		NOTE: ""
	},
	POST_EMPLOYEES: {
		TARGET: "Post Employees",
		NOTE: ""
	},
	SCHEDULE_PERIOD: {
		TARGET: "Schedule Period",
		NOTE: ""
	},
	LUNCH_AND_BREAK: {
		TARGET: "Lunch and Break",
		NOTE: ""
	},
	ADMIN_LUNCH_AND_BREAK: {
		TARGET: "Lunch & Break",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Lunch & Break' feature."
	},
	EDIT_ASSIGNMENTS: {
		TARGET: "Edit Assignments",
		NOTE: ""
	},
	ADMIN_ASSIGNMENT_DATA: {
		TARGET: "Assignment Data",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Assignment Data' feature."
	},
	OVERTIME_AND_COST_CONTROL: {
		TARGET: "Overtime and Cost Control",
		NOTE: ""
	},
	ADMIN_OVERTIME_AND_COST_CONTROL: {
		TARGET: "Overtime & Cost Control",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Overtime & Cost Control' feature."
	},
	MANAGE_EVENTS: {
		TARGET: "Manage Events",
		NOTE: ""
	},
	EMPLOYEE_TIME: {
		TARGET: "Employee Timesheets",
		NOTE: ""
	},
	EMPLOYEE_NEXT_GEN_TIMESHEETS: {
		TARGET: "Employee Next-Gen Timesheets",
		NOTE: ""
	},
	SCHEDULE_RULE_COPY: {
		TARGET: "Schedule Rule Copy",
		NOTE: ""
	},
	DEFAULT_LABOR_ALLOCATION: {
		TARGET: "Manage Default Labor Allocation",
		NOTE: ""
	},
	MY_DEFAULT_LABOR_ALLOCATION: {
		TARGET: "My Default Labor Allocation",
		NOTE: ""
	},
	VIEW_ANALYTICS: {
		TARGET: "View Analytics",
		NOTE: ""
	},
	SCHEDULING_UNITS: {
		TARGET: "Scheduling Units",
		NOTE: ""
	},
	AREAS: {
		TARGET: "Areas",
		NOTE: ""
	},
	OVERTIME_BANKS: {
		TARGET: "OverTime Banks",
		NOTE: ""
	},
	PASSWORD_MANAGEMENT: {
		TARGET: "Password Management",
		NOTE: ""
	},
	WEB_SERVICES_API_DOCUMENTATION: {
		TARGET: "Web Services API Documentation",
		NOTE: ""
	},
	REQUEST_ACCOMMODATION: {
		TARGET: "Request Accommodation",
		NOTE: ""
	},
	MY_SCHEDULE: {
		TARGET: "My Calendar",
		NOTE: ""
	},
	SCHEDULE_RULE_SWAP: {
		TARGET: "Schedule Rule Swap",
		NOTE: ""
	},
	MAINTAIN_LOOKUP_TABLES: {
		TARGET: "Maintain Lookup Tables",
		NOTE: ""
	},
	ADMIN_LOOKUP_TABLES: {
		TARGET: "Lookup Tables",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Lookup Tables' feature."
	},
	ADMIN_SCHEDULE_RULE_SWAP: {
		TARGET: "Schedule Rule Swap",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Schedule Rule Swap' feature."
	},
	EDIT_FIELD_LEVEL_PROFILE: {
		TARGET: "Edit Field Level Profile",
		NOTE: ""
	},
	LABOR_STANDARDS: {
		TARGET: "Labor Standards",
		NOTE: ""
	},
	HOLIDAY_MAINTENANCE: {
		TARGET: "Holiday Maintenance",
		NOTE: ""
	},
	ADMIN_HOLIDAY_DATES: {
		TARGET: "Holiday Dates",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Holiday Dates' feature."
	},
	MANAGE_EMPLOYEES: {
		TARGET: "Manage Employees",
		NOTE: ""
	},
	SCHEDULE: {
		TARGET: "Schedule",
		NOTE: ""
	},
	SCHEDULE_EDITOR: {
		TARGET: "Schedule Editor",
		NOTE: ""
	},
	PAY_RULES_EDITOR: {
		TARGET: "Pay Rules Editor",
		NOTE: "Navigation link (displayed in title case) providing access to the Pay Rules Editor."
	},
	SHIFT_MANAGEMENT: {
		TARGET: "Shift Management",
		NOTE: ""
	},
	CREW_MANAGEMENT_HELP: {
		TARGET: "Help - Crew Management",
		NOTE: ""
	},
	FATIGUE_MANAGEMENT_HELP: {
		TARGET: "Help - Fatigue Management",
		NOTE: ""
	},
	TIME_ATTENDANCE_HELP: {
		TARGET: "Help - Time",
		NOTE: ""
	},
	ABSENCE_COMPLIANCE_HELP: {
		TARGET: "Help - Absence Compliance",
		NOTE: ""
	},
	ADVANCED_SCHEDULER_HELP: {
		TARGET: "Help - Classic Job Scheduling",
		NOTE: ""
	},
	SYSTEM_CONFIG: {
		TARGET: "System Configuration",
		NOTE: ""
	},
	ADMIN_SUITE_CONFIG: {
		TARGET: "Suite Configuration",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Suite Configuration' feature."
	},
	ADMIN_EMPLOYEE_GROUPS: {
		TARGET: "Employee Groups",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Employee Groups' feature."
	},
	MY_BIDDING_WTA: {
		TARGET: "My Bidding",
		NOTE: ""
	},
	EMPLOYEE_VACATION_BIDDING_DASHBOARD: {
		TARGET: "Vacation Bidding",
		NOTE: "Navigation menu item (displayed in title case) providing access to the employee vacation bidding dashboard."
	},
	VACATION_BIDDING_ADMIN: {
		TARGET: "Manage Vacation Bidding",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for vacation bidding."
	},
	MY_CALENDAR: {
		TARGET: "My Calendar",
		NOTE: ""
	},
	TEAM_ABSENCE_CALENDAR: {
		TARGET: "Team Absence Calendar",
		NOTE: "Navigation menu label for the Team Absence Calendar page. The text is in Title Case."
	},
	EMPLOYEE_GROUPS: {
		TARGET: "Employee Groups",
		NOTE: ""
	},
	AS_USER_GROUPS: {
		TARGET: "Classic Job Scheduling User Groups",
		NOTE: ""
	},
	ADMIN_AS_USER_GROUPS: {
		TARGET: "Groups",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Groups' feature."
	},
	AUTOMATIC_CALLOUT_RULES: {
		TARGET: "Automatic Callout Rules",
		NOTE: ""
	},
	ADMIN_CALLOUT_AUTOMATIC_RULES: {
		TARGET: "Callout - Automatic Rules",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Callout - Automatic Rules' feature."
	},
	ADVANCED_SCHEDULER_USERS: {
		TARGET: "Classic Job Scheduling Users",
		NOTE: ""
	},
	ADMIN_ADVANCED_SCHEDULER_USERS: {
		TARGET: "Users",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Users' feature."
	},
	WFX: {
		TARGET: "Open Enhanced Communications",
		NOTE: ""
	},
	LOCATIONS: {
		TARGET: "Locations",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Locations' feature."
	},
	ORGANIZATION_SETTINGS: {
		TARGET: "Organization Settings",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Organization Settings' feature."
	},
	SYNC: {
		TARGET: "Sync",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Sync' feature."
	},
	USERS: {
		TARGET: "Users",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Users' feature."
	},
	USER_LISTS: {
		TARGET: "User Lists",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'User List' feature."
	},
	ML_FORECASTING: {
		TARGET: "Forecasting",
		NOTE: "Navigation menu label to take the user to the Forecasting page."
	},
	WFX_APP: {
		TARGET: "Enhanced Communications App",
		NOTE: "Navigation menu label (displayed in Title case) in the Experience dropdown to take the user to the experience standalone app in a seperate tab."
	},
	CHANNELS: {
		TARGET: "Channels",
		NOTE: "Navigation menu label (displayed in Title case) in the Experience dropdown to take the user to the Experience Channels page"
	},
	BROADCASTS: {
		TARGET: "Broadcasts",
		NOTE: "Navigation menu label (displayed in Title case) in the Experience dropdown to take the user to the Experience Broadcasts page"
	},
	TASKS: {
		TARGET: "Tasks",
		NOTE: "Navigation menu label (displayed in Title case) in the Experience dropdown to take the user to the Experience Tasks page."
	},
	DOCUMENTS: {
		TARGET: "Documents",
		NOTE: "Navigation menu label (displayed in Title case) in the Experience dropdown to take the user to the Experience Documents page."
	},
	WFX_ADMIN: {
		TARGET: "Enhanced Communications Admin",
		NOTE: "Navigation menu label (displayed in Title case) in the Admin dropdown to take the user to Experience Admin page."
	},
	ADMIN_MENU_HELP_LINK: {
		TARGET: "See what's new",
		NOTE: "this links to a navigation link that contains a document detailing the recent changes to the admin navigation organization"
	},
	VISIER_ANALYTICS: {
		TARGET: "Enhanced Analytics",
		NOTE: "This links to a navigation option for accessing the features of the external Visier Analytics tool."
	}
};
var ORGANIZATION_PANEL$A = {
	TITLE: {
		TARGET: "ADP WorkForce Suite Login",
		NOTE: "this is the heading (displayed in Title case) for the login screen"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "Typically this is a short abbreviation for your company. For help, contact an Administrator.",
		NOTE: "this is text (displayed in Sentence case) appearing underneath the textbox for account name where the user types in whatever their account name is"
	},
	INVALID_ACCOUNT: {
		TARGET: "Enter a valid Account",
		NOTE: "this is a message (displayed in Sentence case) that appears when you enter an account that doesn't exist"
	},
	GENERIC_ERROR: {
		TARGET: "Could not authenticate",
		NOTE: "this is a message (displayed in Sentence case) that appears when the user can't authenticate"
	},
	NETWORK_ERROR: {
		TARGET: "There was a problem reaching the server. Please check your connection",
		NOTE: "this is a message (displayed in Sentence case) that appears to the user when there's a network error when trying to login on the page"
	},
	ACCOUNT: {
		TARGET: "Account",
		NOTE: "this is for the orginazation account that the user is logging into"
	},
	BUTTON_NEXT: {
		TARGET: "Next",
		NOTE: "this is the next button that is clicked so the user can navigate to the next step of logging in"
	},
	SELECT_LANGUAGE: {
		TARGET: "Select Language",
		NOTE: "this is a button (displayed in Title case) that when clicked will present the user with other languages to select"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Change account name",
		NOTE: "Aria label for the edit account icon for voiceover"
	},
	CLOSE_SIDEBAR_ARIA_LABEL: {
		TARGET: "Close",
		NOTE: "Aria label for button that closes the right sidebar (drawer)"
	},
	SKIP_NAVIGATION: {
		TARGET: "Skip Navigation",
		NOTE: "this is a skip navigation button that when user click on this button will navigate to main content"
	}
};
var NAVIGATION_WARNING$3 = {
	UNSAVED_CHANGES_TEXT: {
		TARGET: "Do you want to stay on this page to save your changes or discard them and continue?",
		NOTE: "this text (displayed in Sentence case) is on an alert popup that pops up when a user tries to navigate off a page with unsaved changes"
	},
	UNSAVED_CHANGES_HEADING: {
		TARGET: "Unsaved Changes",
		NOTE: "This is the heading (displayed in Title case) that occurs in a popup to tell the user that they have unsaved changes"
	},
	DISCARD: {
		TARGET: "Discard",
		NOTE: "this is a button that the user can click to discard their unsaved changes and navigate off the page"
	},
	STAY_ON_PAGE: {
		TARGET: "Stay on the page",
		NOTE: "this is a button (displayed in Sentence case) that the user can click if they want to stay on the page instead of navigating off of it"
	}
};
var IMPERSONATION_DIALOG$3 = {
	HEADER: {
		TARGET: "Impersonate",
		NOTE: "header of the impersonate dialog where you choose a user to impersonate"
	},
	BUTTON_CANCEL: {
		TARGET: "Cancel",
		NOTE: "cancel button in impersonate dialog"
	},
	BUTTON_SUBMIT: {
		TARGET: "Impersonate",
		NOTE: "the button in dialoge when you want to confirm that you want to impersonate the user you selected"
	},
	HELPER_TEXT: {
		TARGET: "To impersonate a user, please select the user from the list.",
		NOTE: "text (displayed in Sentence case) above a dropdown where you choose which user you would like to impersonate"
	},
	NO_OPTION: {
		TARGET: "No users found",
		NOTE: "shows in dropdown (displayed in Sentence case) when there's no user found that you can impersonate"
	}
};
var IMPERSONATION_INDICATOR$3 = {
	MESSAGE: {
		TARGET: "Impersonating",
		NOTE: "Text that appears in app to indicate you're impersonating someone like this 'Impersonating {name of person you are impersonatin}'"
	}
};
var NOTIFICATION_MESSAGES$3 = {
	HUB_CARD_DISMISSED: {
		TARGET: "{{hubCardName}} Hub card removed.",
		NOTE: "notification generated (displayed in Title case) by app when a hub card is dismissed by user"
	},
	UNDO: {
		TARGET: "Undo",
		NOTE: "This text appears on the dismissal notification and when clicked will undo the dissimal of a notification"
	}
};
var ERROR_PAGE$3 = {
	SORRY: {
		TARGET: "Sorry",
		NOTE: "This is hover text for the sorry image that appears when an error has occured"
	},
	PAGE_NOT_FOUND: {
		TARGET: "The page you were looking for could not be found.",
		NOTE: "This text (displayed in Sentence case) is on a error page to indicate that the page the user tried to navigate to couldn't be found"
	},
	PERMISSION_DENIED: {
		TARGET: "Error 403 - You do not have permissions for this page.",
		NOTE: "This appears (displayed in Sentence case) on the error page when the user doesn't have permissions to navigate to that specific page"
	},
	CONTACT_IT: {
		TARGET: "Please contact your IT administrator for further assistance.",
		NOTE: "This text (displayed in Sentence case) is used on an error page to inform the user to contact IT admin to figure out why there was an error"
	},
	UNEXPECTED_ERROR: {
		TARGET: "We've encountered a problem and the service may be unavailable. Contact your Administrator for assistance.",
		NOTE: "this is the message (displayed in Sentence case) displayed on the page when an unexpected error occurs in the app"
	},
	TAKE_ME_HOME: {
		TARGET: "Take me home",
		NOTE: "This is the text (displayed in Sentence case) on a link that when clicked brings the user back to the main screen of app"
	}
};
var API_ERROR_DIALOG$1 = {
	ACTION: {
		CLOSE: {
			TARGET: "Close",
			NOTE: "The caption of a button displayed in multiple places. If the button is clicked, the dialog closes. It means that the user has read the text in the dialog and accepts it."
		}
	},
	FAILED_TO_CONNECT: {
		TITLE: {
			TARGET: "Failed To Connect To Service",
			NOTE: "The title of the Error Dialog (displayed in Title case). Has the server is not responded."
		},
		SERVICE_NAME: {
			TARGET: "Failed to connect to the {{serviceName}} service.",
			NOTE: "This is a service name message (displayed in Sentence case) when a particular service is failed."
		},
		DESCRIPTION: {
			TARGET: "If you continue to see this message, make a note of the service name above and contact your system administrator.",
			NOTE: "This is a message (displayed in Sentence case) when a particular service is failed."
		}
	},
	TIME_OUT: {
		TITLE: {
			TARGET: "Service Has Timed Out",
			NOTE: "The title of the Error Dialog (displayed in Title case). Has the server is not responded."
		},
		SERVICE_NAME: {
			TARGET: "The {{serviceName}} service is not responding.",
			NOTE: "This is a service name message (displayed in Sentence case) when a particular service is failed."
		},
		DESCRIPTION: {
			TARGET: "If you continue to see this message, make a note of the service name above and contact your system administrator.",
			NOTE: "This is a message (displayed in Sentence case) when a particular service is failed."
		}
	},
	INCORRECT_RESPONSE: {
		TITLE: {
			TARGET: "Service Has Provided An Incorrect Response",
			NOTE: "The title of the Error Dialog (displayed in Title case). Has the server is not responded."
		},
		SERVICE_NAME: {
			TARGET: "The {{serviceName}} service has responded with the following error;",
			NOTE: "This is a service name message (displayed in Sentence case) when a particular service is failed."
		},
		HTTP_STATUS_CODE: {
			TARGET: "HTTP Status Code: {{statusCode}}",
			NOTE: ""
		},
		DESCRIPTION: {
			TARGET: "If you continue to see this message, make a note of the service name and HTTP error code above and contact your system administrator.",
			NOTE: "This is a message (displayed in Sentence case) when a particular service is failed."
		}
	},
	INTERNAL_SERVER_ERROR: {
		TITLE: {
			TARGET: "Service Has Responded With An Error",
			NOTE: "The title of the Error Dialog (displayed in Title case). Has the server is not responded."
		},
		SERVICE_NAME: {
			TARGET: "The {{serviceName}} service has responded with the following error;",
			NOTE: "This is a service name message (displayed in Sentence case) when a particular service is failed."
		},
		DESCRIPTION: {
			TARGET: "If you continue to see this message, make a note of the service name and error code above and contact your system administrator.",
			NOTE: "This is a message (displayed in Sentence case) when a particular service is failed."
		}
	},
	INTERNAL_SERVER_ERROR_WITHOUT_ERROR_ID: {
		SERVICE_NAME: {
			TARGET: "The {{serviceName}} encountered an unexpected error and we are unable to track the issue at this time;",
			NOTE: "This message is shown when the service encounters an error but no error ID is available."
		},
		DESCRIPTION: {
			TARGET: "If you continue to see this message, make a note of the service name and contact your system administrator.",
			NOTE: "This is a message (displayed in Sentence case) when a particular service is failed."
		}
	}
};
var PIN$2 = {
	CREATE_PIN: {
		TARGET: "Create a PIN",
		NOTE: "The title for create PIN screen"
	},
	WELCOME_BACK: {
		TARGET: "Welcome back",
		NOTE: "The title for created PIN flow"
	},
	ENTER_YOUR_PIN: {
		TARGET: "Enter your PIN",
		NOTE: "Label indicating the user can type a PIN number."
	},
	CONFIRM_YOUR_PIN: {
		TARGET: "Confirm your PIN",
		NOTE: "Label indicating the user needs to confirm a PIN number."
	},
	YOUR_ACCOUNT_REQUIRES_PIN: {
		TARGET: "Your account requires a numeric PIN.",
		NOTE: "Modal description label indicating the user needs to set a PIN number."
	},
	MORE_DETAILS_MODAL: {
		MORE_DETAILS: {
			TARGET: "More details",
			NOTE: "Button label to open more details modal."
		},
		DESCRIPTION: {
			TARGET: "Your PIN is required to regain access to an active session (e.g. you minimized the app while being logged in)",
			NOTE: "More details modal description"
		},
		INFO_SWITCH_USERS: {
			TARGET: "You can switch users if a session is active (e.g. sharing a device)",
			NOTE: "More details modal description"
		},
		INFO_PIN_ATTEMPTS: {
			TARGET: "If you fail to enter your PIN correctly on three attempts, you'll be prompted to create a new PIN",
			NOTE: "More details modal description"
		},
		INFO_FORGOT_PIN: {
			TARGET: "If you forget your PIN, you can make a new one and the existing one will expire",
			NOTE: "More details modal description"
		}
	},
	BACK: {
		TARGET: "Back",
		NOTE: "Button label to go back to PIN creation screen"
	},
	PIN_DID_NOT_MATCH: {
		TARGET: "PIN entry did not match",
		NOTE: "Hint text to help the user"
	},
	ENTER_CREATED_PIN: {
		TARGET: "You will need to enter your PIN to regain access to your current session.",
		NOTE: "Instructions for accessing the current session"
	},
	SWITCH_USER: {
		TARGET: "Switch user",
		NOTE: "Text for switch user button"
	},
	USER_WILL_BE_LOGGED_OUT: {
		TARGET: "By confirming, the current user will be logged out and you will be asked to login.",
		NOTE: "Switch user modal description"
	},
	INCORRECT_PIN: {
		TARGET: "Incorrect PIN. {{numAttempts}} attempts remain.",
		NOTE: "Text to inform pin attempts left"
	},
	INCORRECT_PIN_FINAL_ATTEMPT: {
		TARGET: "Incorrect PIN. {{numAttempts}} attempt remains.",
		NOTE: "Text to inform only one pin attempts left"
	},
	INCORRECT_PIN_TITLE: {
		TARGET: "Incorrect PIN",
		NOTE: "Modal title"
	},
	INCORRECT_PIN_DESCRIPTION: {
		TARGET: "Your attempts to enter your PIN correctly have exceeded the allotted amount.",
		NOTE: "Modal content"
	},
	INCORRECT_PIN_TEXT: {
		TARGET: "Your PIN is now expired and you will be asked to create a new PIN upon logging in.",
		NOTE: "Modal content"
	},
	I_UNDERSTAND: {
		TARGET: "I Understand",
		NOTE: "Modal button"
	},
	FORGOT_PIN: {
		TARGET: "Forgot PIN",
		NOTE: "Forgot PIN button"
	},
	CREATE_NEW_PIN: {
		TARGET: "By confirming, your existing PIN will expire and you will be logged out. Upon login you will be asked to create a new PIN.",
		NOTE: "Forgot PIN modal description"
	},
	CONFIRM: {
		TARGET: "Confirm",
		NOTE: "Confirm button"
	}
};
var SESSION_INACTIVITY$2 = {
	WARNING_DIALOG: {
		LOG_OUT: {
			TARGET: "Log out",
			NOTE: "Dialog button to logout the user"
		},
		I_AM_STILL_HERE: {
			TARGET: "I'm still here",
			NOTE: "Dialog button to confirm that user is still using the app"
		},
		TITLE: {
			TARGET: "Session Timeout",
			NOTE: "Dialog title"
		},
		DESCRIPTION: {
			TARGET: "You’ve been inactive for an extended period of time. You’ll be automatically logged out after 5 minutes and unsaved data may be lost. Are you still there?",
			NOTE: "Dialog description"
		}
	},
	LOGOUT_ALERT: {
		TARGET: "You were logged out of your previous session due to inactivity.",
		NOTE: "An alert text to notify the user that they have been logged out due to inactivity."
	}
};
var en_US = {
	MENU_ITEMS: MENU_ITEMS$3,
	GREETING: GREETING$3,
	RESET_PASSWORD: RESET_PASSWORD$3,
	USER_PREFERENCES: USER_PREFERENCES$3,
	EMPLOYEE_GROUP_FILTERS: EMPLOYEE_GROUP_FILTERS$3,
	NAV_MENU: NAV_MENU$3,
	NAV_LINKS: NAV_LINKS$3,
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$A,
	NAVIGATION_WARNING: NAVIGATION_WARNING$3,
	IMPERSONATION_DIALOG: IMPERSONATION_DIALOG$3,
	IMPERSONATION_INDICATOR: IMPERSONATION_INDICATOR$3,
	NOTIFICATION_MESSAGES: NOTIFICATION_MESSAGES$3,
	ERROR_PAGE: ERROR_PAGE$3,
	API_ERROR_DIALOG: API_ERROR_DIALOG$1,
	PIN: PIN$2,
	SESSION_INACTIVITY: SESSION_INACTIVITY$2
};

localizationFramework.registerDefaultTranslations(moduleId, {
    "en-US": en_US,
});

var useTranslateFunction = localizationFramework.createModuleTranslateFunctionHook(moduleId);

var casUserAPI = "/aug/api/v1.0/user";
var getCasImpersonateEndpoint = function (accountId, queryString) {
    var url = casUserAPI + "/" + accountId + "/impersonate";
    return !!queryString ? [url, queryString].join("?") : url;
};
/**
 * CAS Url to impersonate a user
 * @param {string} wfsId
 * @returns {string} Url to impersonation API
 */
var getCasImpersonateUrl = function (wfsId) { return __awaiter(void 0, void 0, void 0, function () {
    var authManager, accountData, accessToken, queryParams;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                authManager = AuthenticationManager.getInstance();
                accountData = authManager.getAccountInfo().accountData;
                return [4 /*yield*/, authManager.getAccessToken()];
            case 1:
                accessToken = _a.sent();
                queryParams = {
                    access_token: accessToken,
                    wfs_id: wfsId,
                };
                return [2 /*return*/, new URL(getCasImpersonateEndpoint(accountData.accountDetail.externalId, qs.stringify(queryParams)), getCasBaseUrl(accountData)).toString()];
        }
    });
}); };
/**
 * Gets list of users who can be impersonated
 * @param query {string} - query to search, it can be the username or email of the user
 * @returns {AxiosPromise<any> }
 */
function getAllUsersToImpersonate(query) {
    return __awaiter(this, void 0, void 0, function () {
        var authManager, accessToken, accountData, AuthStr, usersToImpersonateUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    authManager = AuthenticationManager.getInstance();
                    return [4 /*yield*/, authManager.getAccessToken()];
                case 1:
                    accessToken = _a.sent();
                    accountData = authManager.getAccountInfo().accountData;
                    AuthStr = "Bearer " + accessToken;
                    usersToImpersonateUrl = new URL(casUserAPI + "/" + accountData.accountDetail.externalId + "/search?q=" + query + "&excludeUsersWithRequiredActions=true", getCasBaseUrl(accountData)).toString();
                    return [2 /*return*/, axios__default.default.get(usersToImpersonateUrl, {
                            headers: { Authorization: AuthStr },
                        })];
            }
        });
    });
}

/**
 * All the available actions that can be triggered to do with organization credentials panel
 */
var ImpersonationActionTypes;
(function (ImpersonationActionTypes) {
    ImpersonationActionTypes["ShowImpersonationDialog"] = "impersonation/showImpersonationDialog";
    ImpersonationActionTypes["HideImpersonationDialog"] = "impersonation/hideImpersonationDialog";
})(ImpersonationActionTypes || (ImpersonationActionTypes = {}));

/**
 * Define the initial state if none provided
 */
var initialState$e = {
    visible: false,
};
/**
 * Create a reducer that manipulates the impersonation dialog
 *
 * @param {ImpersonationState}  state  The current state
 * @param {ImpersonationAction} action The action that has triggered the state change
 *
 * @returns {ImpersonationState} The modified ImpersonationState
 */
var reducer$f = function (state, action) {
    if (state === void 0) { state = initialState$e; }
    /**
     * Check which Action has been triggered
     */
    switch (action.type) {
        case ImpersonationActionTypes.ShowImpersonationDialog: {
            return __assign(__assign({}, state), { visible: true });
        }
        case ImpersonationActionTypes.HideImpersonationDialog: {
            return __assign(__assign({}, state), { visible: false });
        }
    }
    return state;
};

/**
 * Opens Impersonation Dialog
 *
 * @returns {{type: ImpersonationActionTypes}}
 */
function showImpersonationDialog() {
    return {
        type: ImpersonationActionTypes.ShowImpersonationDialog,
    };
}
/**
 * Closes Impersonation Dialog
 *
 * @returns {{type: ImpersonationActionTypes}}
 */
function hideImpersonationDialog() {
    return {
        type: ImpersonationActionTypes.HideImpersonationDialog,
    };
}

var useTypedSelector = reactRedux.useSelector;

var StyleDialogActions = lighthouseComponentLibrary.styled(DialogActions$1)(templateObject_1$J || (templateObject_1$J = __makeTemplateObject(["\n  margin-right: ", ";\n  && {\n    padding-bottom: ", ";\n  }\n"], ["\n  margin-right: ", ";\n  && {\n    padding-bottom: ", ";\n  }\n"])), polished.rem("15px"), polished.rem("18px"));
var ImpersonateHeader = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_2$w || (templateObject_2$w = __makeTemplateObject(["\n  text-align: center;\n  && {\n    padding-top: ", ";\n  }\n"], ["\n  text-align: center;\n  && {\n    padding-top: ", ";\n  }\n"])), polished.rem("27px"));
var CssTextField = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.OutlinedTextField)(templateObject_3$p || (templateObject_3$p = __makeTemplateObject(["\n  & {\n    .MuiAutocomplete-inputRoot {\n      .MuiOutlinedInput-notchedOutline {\n        border-color: ", ";\n      }\n    }\n  }\n  & {\n    .MuiAutocomplete-inputRoot:hover {\n      .MuiOutlinedInput-notchedOutline {\n        border-color: ", ";\n      }\n    }\n  }\n  & {\n    .MuiAutocomplete-inputRoot.Mui-focused {\n      .MuiOutlinedInput-notchedOutline {\n        border-color: ", ";\n      }\n    }\n  }\n  & {\n    .MuiInputLabel-outlined.MuiInputLabel-shrink {\n      color: ", ";\n    }\n  }\n"], ["\n  & {\n    .MuiAutocomplete-inputRoot {\n      .MuiOutlinedInput-notchedOutline {\n        border-color: ",
    ";\n      }\n    }\n  }\n  & {\n    .MuiAutocomplete-inputRoot:hover {\n      .MuiOutlinedInput-notchedOutline {\n        border-color: ",
    ";\n      }\n    }\n  }\n  & {\n    .MuiAutocomplete-inputRoot.Mui-focused {\n      .MuiOutlinedInput-notchedOutline {\n        border-color: ",
    ";\n      }\n    }\n  }\n  & {\n    .MuiInputLabel-outlined.MuiInputLabel-shrink {\n      color: ", ";\n    }\n  }\n"])), function (props) {
    return lighthouseComponentLibrary.getThemeFromProps(props).colours.primary.main;
}, function (props) {
    return lighthouseComponentLibrary.getThemeFromProps(props).colours.primary.main;
}, function (props) {
    return lighthouseComponentLibrary.getThemeFromProps(props).colours.primary.main;
}, function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.primary.main; });
/**
 * Gets the name of the user from a `User` record
 *
 * @param user {User} - The user record to construct the name from
 *
 * @returns {string}
 */
var getUserFullName = function (user) {
    if (user) {
        return user.fullName;
    }
    return "";
};
/**
 * Used to determine if an option is selected.
 *
 * @param option {User} - The option to verify
 * @param value  {User} - The user from list
 *
 * @returns {boolean}
 */
var isCorrectOption = function (option, value) {
    return option.wfsId === value.wfsId;
};
var Impersonate = function () {
    var _a = React.useState([]), users = _a[0], setUsers = _a[1];
    var _b = React.useState(null), selectedUser = _b[0], setSelectedUser = _b[1];
    var _c = React.useState(true), isSubmitDisabled = _c[0], setIsSubmitDisabled = _c[1];
    var _d = React.useState(true), loading = _d[0], setLoading = _d[1];
    var visible = useTypedSelector(function (state) { return state.impersonation.visible; });
    var dispatch = reactRedux.useDispatch();
    var translate = useTranslateFunction();
    /** Time, in milliseconds, to wait between sending search requests */
    var WAIT_MILLISECONDS = 250;
    /** Reducing the traffic, as we assume a name consists of 3 letters minimum */
    var SEARCH_THRESHOLD = 3;
    var closeDialog = function () {
        dispatch(hideImpersonationDialog());
        setSelectedUser(null);
        setIsSubmitDisabled(true);
        setLoading(true);
        setUsers([]);
    };
    var impersonateUser = function () {
        dispatch(hideImpersonationDialog());
        if (selectedUser !== null) {
            getCasImpersonateUrl(selectedUser.wfsId).then(function (casImpersonateUrl) {
                // Inform the AuthenticationManager that we are impersonating in order to avoid race
                // conditions if one of the front-channel logout endpoints loads very slowly.
                var authManager = AuthenticationManager.getInstance();
                authManager.setImpersonating(true);
                redirectToCasUrl(casImpersonateUrl);
            });
        }
    };
    // TODO: Use ComboBoxInputProps when ComboBox has getOptionSelected property,
    // situated in lighthouse-component-library - INT-15640
    var renderInputs = function (params) {
        return (React__namespace.default.createElement(CssTextField, __assign({}, params, { name: "StyledUsersTextField", autoFocus: false, label: "Users", helperText: translate("IMPERSONATION_DIALOG.HELPER_TEXT") })));
    };
    /**
     * Gets available users based on the search `value`
     *
     * @param event {React.ChangeEvent<{}>} - The change event that triggered this callback
     * @param value {string}                - The term being searched for
     *
     * @return {Promise<void>}
     */
    var getAvailableUsers = function (event, value) { return __awaiter(void 0, void 0, void 0, function () {
        var response, availableUsers;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!value.length) {
                        setSelectedUser(null);
                        return [2 /*return*/];
                    }
                    if (!(value.length >= SEARCH_THRESHOLD)) return [3 /*break*/, 2];
                    return [4 /*yield*/, getAllUsersToImpersonate(value)];
                case 1:
                    response = _a.sent();
                    availableUsers = response.data.data;
                    setUsers(availableUsers);
                    setLoading(false);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    /**
     * Handler for when a user is selected or the textfield is cleared
     *
     * @param event {React.ChangeEvent<{}>} - The change event
     * @param user  {User[]}                - The new set of user
     *
     * @returns {void}
     */
    var userSelectedHandler = function (event, user) {
        if (user != null) {
            setSelectedUser(user);
            setIsSubmitDisabled(false);
        }
        else {
            // As the user has been removed from the Textfield, therefore, selected user should be reset
            setSelectedUser(null);
            setIsSubmitDisabled(true);
        }
    };
    return (React__namespace.default.createElement(lighthouseComponentLibrary.Dialog, { open: visible, onClose: closeDialog, fullScreen: false, "data-qa": "impersonateDialog" },
        React__namespace.default.createElement(ImpersonateHeader, { use: "h2Light", "data-qa": "impersonateDialogHeaderLabel" }, translate("IMPERSONATION_DIALOG.HEADER")),
        React__namespace.default.createElement(lighthouseComponentLibrary.DialogContent, { "data-qa": "impersonateDialogContent" },
            React__namespace.default.createElement(Autocomplete$1, { options: __spreadArrays(users), renderInput: renderInputs, getOptionLabel: getUserFullName, filterOptions: createFilterOptions({
                    stringify: function (option) {
                        return option.email + option.fullName + option.userName;
                    },
                }), getOptionSelected: isCorrectOption, multiple: false, onChange: userSelectedHandler, value: selectedUser || null, onInputChange: _.debounce(getAvailableUsers, WAIT_MILLISECONDS), loading: loading, noOptionsText: translate("IMPERSONATION_DIALOG.NO_OPTION") })),
        React__namespace.default.createElement(StyleDialogActions, { "data-qa": "impersonateDialogActions" },
            React__namespace.default.createElement(lighthouseComponentLibrary.Button, { onClick: closeDialog, type: "outline", text: translate("IMPERSONATION_DIALOG.BUTTON_CANCEL"), "data-qa": "cancelImpersonateButton" }),
            React__namespace.default.createElement(lighthouseComponentLibrary.Button, { onClick: impersonateUser, type: "solid", text: translate("IMPERSONATION_DIALOG.BUTTON_SUBMIT"), disabled: isSubmitDisabled, "data-qa": "submitImpersonateButton" }))));
};
var templateObject_1$J, templateObject_2$w, templateObject_3$p;

var initialState$d = {
    redirectRoute: undefined,
};
var reducer$e = function (state, action) {
    if (state === void 0) { state = initialState$d; }
    switch (action.type) {
        case "deeplink/routeToDeeplink" /* RouteToDeeplink */:
            return __assign(__assign({}, state), { redirectRoute: action.redirectRoute });
        case "deeplink/flushRedirectRoute" /* FlushRedirectRoute */:
            return __assign(__assign({}, state), { redirectRoute: undefined });
        default:
            return state;
    }
};

/**
 * Set Deeplink Redirect Route. Redirect Route is a route supported by the Lighthouse
 * Framework.
 * @param redirectRoute Framework route that the user should be redirected to
 * @returns Resolved Promise once the action has been dispatched.
 */
function setDeeplinkRedirectRoute(redirectRoute) {
    return function (dispatch) {
        var action = {
            type: "deeplink/routeToDeeplink" /* RouteToDeeplink */,
            redirectRoute: redirectRoute,
        };
        dispatch(action);
        return Promise.resolve();
    };
}
/**
 * Flush Deeplink Redirect Route, i.e, clear the redirect-route from the state.
 * @returns Resolved Promise once the action has been dispatched.
 */
function flushDeeplinkRedirectRoute() {
    return function (dispatch) {
        var action = {
            type: "deeplink/flushRedirectRoute" /* FlushRedirectRoute */,
        };
        dispatch(action);
        return Promise.resolve();
    };
}

var PasswordField = function (props) {
    var _a = React.useState(), showPassword = _a[0], setShowPassword = _a[1];
    var defaults = {
        name: "Password",
        fullWidth: true,
        label: "Password",
        error: false,
        required: true,
    };
    return (React__namespace.default.createElement(lighthouseComponentLibrary.TextField, __assign({}, props, { name: props.name || defaults.name, error: props.error || defaults.error, required: props.required || defaults.required, type: showPassword ? "text" : "password", label: props.label || defaults.label, fullWidth: props.fullWidth || defaults.fullWidth, trailingAdornment: React__namespace.default.createElement(lighthouseComponentLibrary.IconButton, { onClick: function () {
                return setShowPassword(function (previousShowPassword) { return !previousShowPassword; });
            } },
            React__namespace.default.createElement(lighthouseComponentLibrary.Icon, { icon: showPassword ? "hide" : "show", fontSize: "extraSmall" })) })));
};

var CAS_USER_API = "/aug/api/v1.0/user";
var ADMIN_API = "/auth/admin/realms";
/**
 * List of all users which match the query, maximum 20 to avoid latency/bandwidth issues
 * @param query - query to search, it can be the username or email of the user
 */
function getUsersThatMatchQuery(query) {
    return __awaiter(this, void 0, void 0, function () {
        var authManager, accessToken, accountData, AuthStr, userSearchUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    authManager = AuthenticationManager.getInstance();
                    return [4 /*yield*/, authManager.getAccessToken()];
                case 1:
                    accessToken = _a.sent();
                    accountData = authManager.getAccountInfo().accountData;
                    AuthStr = "Bearer " + accessToken;
                    userSearchUrl = new URL(CAS_USER_API + "/" + accountData.accountDetail.externalId + "/search?q=" + query, getCasBaseUrl(accountData)).toString();
                    return [2 /*return*/, axios__default.default.get(userSearchUrl, {
                            headers: { Authorization: AuthStr },
                        })];
            }
        });
    });
}
/**
 * Calls the keycloak API to reset the password for a user. This password reset will be temporary
 * @param keycloakUserId - The keycloak ID of the user
 * @param password - The new password to be set
 */
function resetPasswordInCas(keycloakUserId, password) {
    return __awaiter(this, void 0, void 0, function () {
        var authManager, accessToken, accountData, AuthStr, resetPasswordUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    authManager = AuthenticationManager.getInstance();
                    return [4 /*yield*/, authManager.getAccessToken()];
                case 1:
                    accessToken = _a.sent();
                    accountData = authManager.getAccountInfo().accountData;
                    AuthStr = "Bearer " + accessToken;
                    resetPasswordUrl = new URL(ADMIN_API + "/" + accountData.accountDetail.externalId + "/users/" + keycloakUserId + "/reset-password", getCasBaseUrl(accountData)).toString();
                    return [2 /*return*/, axios__default.default.put(resetPasswordUrl, {
                            type: "password",
                            value: password,
                            temporary: true,
                        }, {
                            headers: { Authorization: AuthStr },
                        })];
            }
        });
    });
}

/**
 * The Autocomplete dropdown to select users from CAS
 */
var SelectUser = function (props) {
    props.onUserSelected; var AutoCompleteProps = __rest(props, ["onUserSelected"]);
    var _a = React.useState([]), users = _a[0], setUsers = _a[1];
    var _b = React.useState(false), autoCompleteLoading = _b[0], setAutoCompleteLoading = _b[1];
    var _c = React.useState(""), inputValue = _c[0], setInputValue = _c[1];
    var loadUsersOnInput = React__namespace.default.useCallback(_.debounce(function (event, value) {
        getUsersThatMatchQuery(value).then(function (newValues) {
            setUsers(newValues.data.data);
            setAutoCompleteLoading(false);
        });
    }, 500), []);
    var handleInputChange = function (event, value, reason) {
        setInputValue(value);
        if (reason === "input") {
            setAutoCompleteLoading(true);
            loadUsersOnInput(event, value, reason);
        }
        else if (reason === "clear") {
            setUsers([]);
        }
    };
    return (React__namespace.default.createElement(Autocomplete$1, __assign({}, AutoCompleteProps, { options: users, size: props.size || "small", inputValue: inputValue, renderInput: renderInputs, getOptionLabel: function (user) { return user.fullName || ""; }, filterOptions: createFilterOptions({
            stringify: function (option) {
                return option.email + option.fullName + option.userName;
            },
        }), getOptionSelected: function (option, value) {
            return !!option && !!value && option.wfsId === value.wfsId;
        }, multiple: false, onChange: function (event, value) {
            props.onUserSelected(value);
        }, onInputChange: handleInputChange, loading: autoCompleteLoading, noOptionsText: inputValue.length
            ? "No users found"
            : "Start typing to search for users", popupIcon: React__namespace.default.createElement(lighthouseComponentLibrary.Icon, { icon: "angleDown", fontSize: "small", color: "primary" }), clearOnBlur: false, handleHomeEndKeys: true, "data-qa": "resetPasswordSelectUserAutocomplete" })));
};
/**
 * Renders inputs in the dropdown
 * @param params - Any arguments to pass on to the underlying component
 */
var renderInputs = function (params) {
    return (React__namespace.default.createElement(lighthouseComponentLibrary.TextField, __assign({}, params, { name: "StyledUsersTextField", autoFocus: false, label: "Users", required: true })));
};

var ResetPasswordContext = React__namespace.createContext({
    isOpen: false,
    setIsOpen: function () {
        return;
    },
});

/**
 * Takes an error description string from CAS as input and outputs a user-friendly error message
 * @param error - The error description received from CAS
 * @return The user-friendly error string
 */
function getUserFriendlyCasError(error, translate) {
    var errorMessage = error.split(":")[1].trim();
    if (errorMessage === "password is blacklisted.") {
        return translate("RESET_PASSWORD.ERROR_BLACKLISTED");
    }
    if (errorMessage.startsWith("minimum length")) {
        return translate("RESET_PASSWORD.ERROR_LENGTH", {
            length: errorMessage.substring(errorMessage.length - 3),
        });
    }
    if (errorMessage.startsWith("fails to match regex pattern")) {
        return translate("RESET_PASSWORD.ERROR_REGEX");
    }
    return translate("RESET_PASSWORD.ERROR_GENERIC", {
        errorMessage: errorMessage,
    });
}

/**
 * @ignore - internal component.
 */

var SuccessOutlinedIcon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');

/**
 * @ignore - internal component.
 */

var ReportProblemOutlinedIcon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');

/**
 * @ignore - internal component.
 */

var ErrorOutlineIcon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');

/**
 * @ignore - internal component.
 */

var InfoOutlinedIcon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');

var styles$7 = function styles(theme) {
  var getColor = theme.palette.type === 'light' ? darken : lighten;
  var getBackgroundColor = theme.palette.type === 'light' ? lighten : darken;
  return {
    /* Styles applied to the root element. */
    root: _extends$1(_extends$1({}, theme.typography.body2), {}, {
      borderRadius: theme.shape.borderRadius,
      backgroundColor: 'transparent',
      display: 'flex',
      padding: '6px 16px'
    }),

    /* Styles applied to the root element if `variant="standard"` and `color="success"`. */
    standardSuccess: {
      color: getColor(theme.palette.success.main, 0.6),
      backgroundColor: getBackgroundColor(theme.palette.success.main, 0.9),
      '& $icon': {
        color: theme.palette.success.main
      }
    },

    /* Styles applied to the root element if `variant="standard"` and `color="info"`. */
    standardInfo: {
      color: getColor(theme.palette.info.main, 0.6),
      backgroundColor: getBackgroundColor(theme.palette.info.main, 0.9),
      '& $icon': {
        color: theme.palette.info.main
      }
    },

    /* Styles applied to the root element if `variant="standard"` and `color="warning"`. */
    standardWarning: {
      color: getColor(theme.palette.warning.main, 0.6),
      backgroundColor: getBackgroundColor(theme.palette.warning.main, 0.9),
      '& $icon': {
        color: theme.palette.warning.main
      }
    },

    /* Styles applied to the root element if `variant="standard"` and `color="error"`. */
    standardError: {
      color: getColor(theme.palette.error.main, 0.6),
      backgroundColor: getBackgroundColor(theme.palette.error.main, 0.9),
      '& $icon': {
        color: theme.palette.error.main
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="success"`. */
    outlinedSuccess: {
      color: getColor(theme.palette.success.main, 0.6),
      border: "1px solid ".concat(theme.palette.success.main),
      '& $icon': {
        color: theme.palette.success.main
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="info"`. */
    outlinedInfo: {
      color: getColor(theme.palette.info.main, 0.6),
      border: "1px solid ".concat(theme.palette.info.main),
      '& $icon': {
        color: theme.palette.info.main
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="warning"`. */
    outlinedWarning: {
      color: getColor(theme.palette.warning.main, 0.6),
      border: "1px solid ".concat(theme.palette.warning.main),
      '& $icon': {
        color: theme.palette.warning.main
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="error"`. */
    outlinedError: {
      color: getColor(theme.palette.error.main, 0.6),
      border: "1px solid ".concat(theme.palette.error.main),
      '& $icon': {
        color: theme.palette.error.main
      }
    },

    /* Styles applied to the root element if `variant="filled"` and `color="success"`. */
    filledSuccess: {
      color: '#fff',
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: theme.palette.success.main
    },

    /* Styles applied to the root element if `variant="filled"` and `color="info"`. */
    filledInfo: {
      color: '#fff',
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: theme.palette.info.main
    },

    /* Styles applied to the root element if `variant="filled"` and `color="warning"`. */
    filledWarning: {
      color: '#fff',
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: theme.palette.warning.main
    },

    /* Styles applied to the root element if `variant="filled"` and `color="error"`. */
    filledError: {
      color: '#fff',
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: theme.palette.error.main
    },

    /* Styles applied to the icon wrapper element. */
    icon: {
      marginRight: 12,
      padding: '7px 0',
      display: 'flex',
      fontSize: 22,
      opacity: 0.9
    },

    /* Styles applied to the message wrapper element. */
    message: {
      padding: '8px 0'
    },

    /* Styles applied to the action wrapper element if `action` is provided. */
    action: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
      paddingLeft: 16,
      marginRight: -8
    }
  };
};
var defaultIconMapping = {
  success: /*#__PURE__*/React__namespace.createElement(SuccessOutlinedIcon, {
    fontSize: "inherit"
  }),
  warning: /*#__PURE__*/React__namespace.createElement(ReportProblemOutlinedIcon, {
    fontSize: "inherit"
  }),
  error: /*#__PURE__*/React__namespace.createElement(ErrorOutlineIcon, {
    fontSize: "inherit"
  }),
  info: /*#__PURE__*/React__namespace.createElement(InfoOutlinedIcon, {
    fontSize: "inherit"
  })
};

var _ref$1 = /*#__PURE__*/React__namespace.createElement(CloseIcon, {
  fontSize: "small"
});

var Alert = React__namespace.forwardRef(function Alert(props, ref) {
  var action = props.action,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$closeText = props.closeText,
      closeText = _props$closeText === void 0 ? 'Close' : _props$closeText,
      color = props.color,
      icon = props.icon,
      _props$iconMapping = props.iconMapping,
      iconMapping = _props$iconMapping === void 0 ? defaultIconMapping : _props$iconMapping,
      onClose = props.onClose,
      _props$role = props.role,
      role = _props$role === void 0 ? 'alert' : _props$role,
      _props$severity = props.severity,
      severity = _props$severity === void 0 ? 'success' : _props$severity,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = _objectWithoutProperties(props, ["action", "children", "classes", "className", "closeText", "color", "icon", "iconMapping", "onClose", "role", "severity", "variant"]);

  return /*#__PURE__*/React__namespace.createElement(Paper$1, _extends$1({
    role: role,
    square: true,
    elevation: 0,
    className: clsx(classes.root, classes["".concat(variant).concat(capitalize(color || severity))], className),
    ref: ref
  }, other), icon !== false ? /*#__PURE__*/React__namespace.createElement("div", {
    className: classes.icon
  }, icon || iconMapping[severity] || defaultIconMapping[severity]) : null, /*#__PURE__*/React__namespace.createElement("div", {
    className: classes.message
  }, children), action != null ? /*#__PURE__*/React__namespace.createElement("div", {
    className: classes.action
  }, action) : null, action == null && onClose ? /*#__PURE__*/React__namespace.createElement("div", {
    className: classes.action
  }, /*#__PURE__*/React__namespace.createElement(IconButton$1, {
    size: "small",
    "aria-label": closeText,
    title: closeText,
    color: "inherit",
    onClick: onClose
  }, _ref$1)) : null);
});
process.env.NODE_ENV !== "production" ? Alert.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The action to display. It renders after the message, at the end of the alert.
   */
  action: PropTypes.node,

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Override the default label for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  closeText: PropTypes.string,

  /**
   * The main color for the alert. Unless provided, the value is taken from the `severity` prop.
   */
  color: PropTypes.oneOf(['error', 'info', 'success', 'warning']),

  /**
   * Override the icon displayed before the children.
   * Unless provided, the icon is mapped to the value of the `severity` prop.
   */
  icon: PropTypes.node,

  /**
   * The component maps the `severity` prop to a range of different icons,
   * for instance success to `<SuccessOutlined>`.
   * If you wish to change this mapping, you can provide your own.
   * Alternatively, you can use the `icon` prop to override the icon displayed.
   */
  iconMapping: PropTypes.shape({
    error: PropTypes.node,
    info: PropTypes.node,
    success: PropTypes.node,
    warning: PropTypes.node
  }),

  /**
   * Callback fired when the component requests to be closed.
   * When provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,

  /**
   * The ARIA role attribute of the element.
   */
  role: PropTypes.string,

  /**
   * The severity of the alert. This defines the color and icon used.
   */
  severity: PropTypes.oneOf(['error', 'info', 'success', 'warning']),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
var Alert$1 = withStyles(styles$7, {
  name: 'MuiAlert'
})(Alert);

/**
 * Component to display the error when the password could not be reset
 */
var PasswordResetErrorAlert = function (props) {
    var translate = useTranslateFunction();
    if (!props.errorMessage) {
        return null;
    }
    props.errorMessage; var alertProps = __rest(props, ["errorMessage"]);
    return (React__namespace.default.createElement(Alert$1, __assign({}, alertProps, { severity: "error", icon: React__namespace.default.createElement(lighthouseComponentLibrary.Icon, { icon: "error", color: "error" }), "data-qa": "resetPasswordCasErrorAlert" }),
        translate("RESET_PASSWORD.MINIMUM_REQUIREMENT"), "\n" + props.errorMessage));
};

/**
 * FlexBox that aligns all its content to the right and provides appropriate gaps.
 */
var AlignRightFlexBox = lighthouseComponentLibrary.styled.div(templateObject_1$I || (templateObject_1$I = __makeTemplateObject(["\n  display: flex;\n  justify-content: end;\n  padding: ", " 0;\n  gap: ", ";\n"], ["\n  display: flex;\n  justify-content: end;\n  padding: ", " 0;\n  gap: ", ";\n"])), polished.rem("12px"), polished.rem("16px"));
var FlexBoxWithGaps = lighthouseComponentLibrary.styled.div(templateObject_2$v || (templateObject_2$v = __makeTemplateObject(["\n  display: flex;\n  gap: ", ";\n  flex-direction: column;\n"], ["\n  display: flex;\n  gap: ", ";\n  flex-direction: column;\n"])), polished.rem("16px"));
var HeaderWrapper = lighthouseComponentLibrary.styled.header(templateObject_3$o || (templateObject_3$o = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])));
var CloseButton = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Button)(templateObject_4$g || (templateObject_4$g = __makeTemplateObject(["\n  && {\n    cursor: pointer;\n    align-self: center;\n    justify-content: end;\n    color: #000000;\n    min-width: ", ";\n    height: ", ";\n    .button__text {\n      margin: ", ";\n    }\n\n    :hover {\n      background-color: transparent;\n    }\n  }\n"], ["\n  && {\n    cursor: pointer;\n    align-self: center;\n    justify-content: end;\n    color: #000000;\n    min-width: ", ";\n    height: ", ";\n    .button__text {\n      margin: ", ";\n    }\n\n    :hover {\n      background-color: transparent;\n    }\n  }\n"])), polished.rem("32px"), polished.rem("32px"), polished.rem("2px"));
/**
 * The main dialogue that holds all the content for the reset password dialogue
 */
var ResetPassword = function () {
    var _a = React.useState(null), selectedUser = _a[0], setSelectedUser = _a[1];
    var _b = React.useState(false), submitEnabled = _b[0], setSubmitEnabled = _b[1];
    var _c = React.useState(false), passwordMismatchError = _c[0], setPasswordMismatchError = _c[1];
    var _d = React.useState(""), passwordValue = _d[0], setPasswordValue = _d[1];
    var _e = React.useState(""), confirmPasswordValue = _e[0], setConfirmPasswordValue = _e[1];
    var _f = React.useState(false), passwordEnteredOnce = _f[0], setPasswordEnteredOnce = _f[1];
    var _g = React.useState(false), confirmPasswordEnteredOnce = _g[0], setConfirmPasswordEnteredOnce = _g[1];
    var _h = React.useState(false), resettingPassword = _h[0], setResettingPassword = _h[1];
    var _j = React.useState(false), notificationOpen = _j[0], setNotificationOpen = _j[1];
    var _k = React.useState(), errorFromCas = _k[0], setErrorFromCas = _k[1];
    var _l = React.useContext(ResetPasswordContext), isOpen = _l.isOpen, setIsOpen = _l.setIsOpen;
    var translate = useTranslateFunction();
    React.useEffect(function () {
        // Resetting the state when the dialogue is closed.
        // We have to do this unfortunately because the dialogue is never unmounted
        if (!isOpen) {
            setSelectedUser(null);
            setPasswordMismatchError(false);
            setPasswordValue("");
            setConfirmPasswordValue("");
            setPasswordEnteredOnce(false);
            setConfirmPasswordEnteredOnce(false);
            setResettingPassword(false);
            setErrorFromCas(undefined);
        }
    }, [isOpen]);
    React.useEffect(function () {
        setSubmitEnabled(passwordEnteredOnce &&
            confirmPasswordEnteredOnce &&
            !!passwordValue &&
            !!confirmPasswordValue &&
            !passwordMismatchError &&
            !resettingPassword &&
            !!selectedUser);
    }, [
        passwordEnteredOnce,
        confirmPasswordEnteredOnce,
        passwordValue,
        confirmPasswordValue,
        passwordMismatchError,
        resettingPassword,
        selectedUser,
    ]);
    React.useEffect(function () {
        setPasswordMismatchError(passwordEnteredOnce &&
            confirmPasswordEnteredOnce &&
            passwordValue !== confirmPasswordValue);
    }, [
        passwordEnteredOnce,
        confirmPasswordEnteredOnce,
        passwordValue,
        confirmPasswordValue,
    ]);
    // Handler for when the "reset password" button is clicked
    var handleResetPassword = React__namespace.default.useCallback(function () {
        setResettingPassword(true);
        setErrorFromCas(undefined);
        var userKeycloakId = selectedUser != null ? selectedUser.keycloakId : null;
        resetPasswordInCas(userKeycloakId, passwordValue)
            .then(function () {
            setResettingPassword(false);
            setIsOpen(false);
            setNotificationOpen(true);
        })
            .catch(function (reason) {
            setErrorFromCas(getUserFriendlyCasError(reason.response.data.error_description, translate));
            setResettingPassword(false);
        });
    }, [passwordValue]);
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        React__namespace.default.createElement(lighthouseComponentLibrary.ResponsiveDialog, { open: isOpen, fullScreen: false, "data-qa": "resetPasswordDialogue", maxWidth: "xs", onClose: function () { return setIsOpen(false); } },
            React__namespace.default.createElement(lighthouseComponentLibrary.DialogContent, { "data-qa": "resetPasswordDialogContent" },
                React__namespace.default.createElement("aside", null,
                    React__namespace.default.createElement(HeaderWrapper, null,
                        React__namespace.default.createElement(lighthouseComponentLibrary.Typography, { use: "h3" }, translate("RESET_PASSWORD.HEADING")),
                        React__namespace.default.createElement(CloseButton, { onClick: function () { return setIsOpen(false); }, type: "text", size: "small" },
                            React__namespace.default.createElement(lighthouseComponentLibrary.Icon, { icon: "close", fontSize: "extraSmall" })))),
                React__namespace.default.createElement(lighthouseComponentLibrary.Typography, { use: "body" }, translate("RESET_PASSWORD.DESCRIPTION")),
                React__namespace.default.createElement(FlexBoxWithGaps, null,
                    React__namespace.default.createElement(SelectUser, { onUserSelected: setSelectedUser }),
                    React__namespace.default.createElement(PasswordField, { onChange: function (event) {
                            setPasswordEnteredOnce(true);
                            setPasswordValue(event.target.value);
                        }, "data-qa": "resetPasswordPasswordField" }),
                    React__namespace.default.createElement(PasswordField, { name: "Confirm Password", label: translate("RESET_PASSWORD.CONFIRM_PASSWORD"), onChange: function (event) {
                            setConfirmPasswordEnteredOnce(true);
                            setConfirmPasswordValue(event.target.value);
                        }, helperText: passwordMismatchError
                            ? translate("RESET_PASSWORD.MATCH_PASSWORD")
                            : undefined, error: passwordMismatchError, "data-qa": "resetPasswordConfirmPasswordField" }),
                    React__namespace.default.createElement(PasswordResetErrorAlert, { errorMessage: errorFromCas, onClose: function () { return setErrorFromCas(undefined); } }),
                    React__namespace.default.createElement(AlignRightFlexBox, null,
                        React__namespace.default.createElement(lighthouseComponentLibrary.Button, { type: "outline", onClick: function () { return setIsOpen(false); }, "data-qa": "resetPasswordCancelButton" }, translate("RESET_PASSWORD.CANCEL_BUTTON")),
                        React__namespace.default.createElement(lighthouseComponentLibrary.Button, { type: "solid", disabled: !submitEnabled, iconRight: resettingPassword && React__namespace.default.createElement(lighthouseComponentLibrary.Spinner, { size: "EXTRA_SMALL" }), onClick: handleResetPassword, "data-qa": "resetPasswordResetPasswordButton" }, resettingPassword
                            ? translate("RESET_PASSWORD.RESETTING_BUTTON")
                            : translate("RESET_PASSWORD.RESET_BUTTON")))))),
        React__namespace.default.createElement(lighthouseComponentLibrary.Toast, { message: translate("RESET_PASSWORD.PASSWORD_SUCCESS"), onClose: function () { return setNotificationOpen(false); }, variant: "success", open: notificationOpen, dismissible: true, "data-qa": "resetPasswordSuccessfulToast" })));
};
var templateObject_1$I, templateObject_2$v, templateObject_3$o, templateObject_4$g;

var storedHistory;
/**
 * Sets a 'history' object for use by navigation.  This object is obtained by a react hook,
 * and therefore has restrictions on how it can be obtained.  There are use cases
 * where code which is not executing directly in a react component needs to push routes onto
 * history, or "navigate to a route".
 * This function allows storing of a history object for use by the navigateToRoute() function below,
 * which provides this ability to code which does not exist directly inside of a react component.
 *
 * @param history The history object to store and use when navigateToRoute() is called.
 */
function initializeNavigateToRoute(history) {
    storedHistory = history;
}
/**
 * Navigates to the passed route.
 * This function is made available so that consuming code can navigate
 * to the passed route without needed to know the underlying details of
 * how this is accomplished.
 *
 * This function may be called in code which does not live directly within
 * a react component.  The only requirement is that the above initializeNavigateToRoute()
 * method has previously been called so that this function has the mechanism to do what
 * it needs to do.  Otherwise, this is a noop.
 *
 * @param route The route within the application to navigate to.
 */
function navigateToRoute(route) {
    storedHistory === null || storedHistory === void 0 ? void 0 : storedHistory.push(route);
}

function InitializeNavigateToRoute() {
    var history = reactRouterDom.useHistory();
    initializeNavigateToRoute(history);
    return React__namespace.default.createElement(React__namespace.default.Fragment, null);
}

var navigationSkeleton$1 = [
    {
        id: "LINK/HUB",
    },
    {
        id: "MENU/SCHEDULE",
        subMenu: [
            {
                id: "LINK/EMPLOYEE_MY_CALENDAR_WFS",
            },
            {
                id: "LINK/EMPLOYEE_MY_CALENDAR_WFS_NATIVE",
            },
            {
                id: "LINK/MY_CALENDAR",
            },
            {
                id: "LINK/TEAM_ABSENCE_CALENDAR",
            },
            {
                id: "LINK/MY_SCHEDULE_WFS",
            },
            {
                id: "LINK/MY_SHIFT_MANAGEMENT_WFS",
            },
            {
                id: "LINK/SCHEDULE_WFS",
            },
            {
                id: "LINK/SCHEDULE_WFS_NATIVE",
            },
            {
                id: "LINK/SCHEDULE_WFS_HERALD",
            },
            {
                id: "LINK/SCHEDULE_JS_HERALD",
            },
            {
                id: "LINK/AUTO_SCHEDULE_WFS",
            },
            {
                id: "LINK/SHIFTMANAGEMENT_WFS",
            },
            {
                id: "LINK/SHIFTMANAGEMENT",
            },
            {
                id: "LINK/DYNAMIC_SCHEDULING",
            },
            {
                id: "LINK/SCHEDULE_TEMPLATES",
            },
            {
                id: "LINK/SCHEDULE_TEMPLATES_NATIVE",
            },
            {
                id: "LINK/MY_SWAP_REQUESTS",
            },
            {
                id: "LINK/SHIFT_SWAP_WFS",
            },
            {
                id: "LINK/AVAILABILITY",
            },
            {
                id: "LINK/AVAILABILITY_TEMPLATE",
            },
            {
                id: "LINK/SHIFT_BIDDING",
            },
            {
                id: "LINK/SHIFT_BIDDING_PREFERENCES",
            },
            {
                id: "LINK/MANAGE_SHIFT_BIDDING",
            },
            {
                id: "LINK/MY_BIDDING_WTA",
            },
            {
                id: "LINK/MANAGER_CALENDAR",
            },
            {
                id: "LINK/GROUP_CALENDAR",
            },
            {
                id: "LINK/COWORKER",
            },
            {
                id: "LINK/SCHEDULES_MAINTENANCE",
            },
            {
                id: "LINK/GRP_SCHEDULE_ENTRY",
            },
            {
                id: "LINK/MODIFY_SCHEDULE",
            },
            {
                id: "LINK/ADJ_BANKS",
            },
            {
                id: "LINK/CALLOUT",
            },
            {
                id: "LINK/UI_COPY_SCHED",
            },
            {
                id: "LINK/UI_DELETE_SCHED",
            },
            {
                id: "LINK/MANAGE_EMP_ASGNMT",
            },
            {
                id: "LINK/MANAGE_SLOT_GROUPS",
            },
            {
                id: "LINK/MANAGE_STAFF_REQ",
            },
            {
                id: "LINK/POST_EMPLOYEES",
            },
            {
                id: "LINK/MANAGER_SWAP_REQUESTS",
            },
            {
                id: "LINK/ASGN_ROT_PATTERN",
            },
            {
                id: "LINK/ROTATION_PATTERN",
            },
            {
                id: "LINK/RUN_AUTO_SCHEDULE",
            },
            {
                id: "LINK/STATUS_SUMMARY",
            },
        ],
    },
    {
        id: "MENU/TIME_OFF",
        subMenu: [
            {
                id: "LINK/TIME_OFF_REQUEST",
            },
            {
                id: "LINK/VIEW_MY_TIME_OFF_REQUESTS",
            },
            {
                id: "LINK/MY_TIME_OFF_WFS",
            },
            {
                id: "LINK/EMPLOYEE_ACCOMMODATION_REQUESTS",
            },
            {
                id: "LINK/MANAGER_TIMEOFF_REQUESTS",
            },
            {
                id: "LINK/TIME_OFF_SUMMARY",
            },
            {
                id: "LINK/LEAVE_SUMMARY",
            },
            {
                id: "LINK/LEAVE_REGULATIONS",
            },
            {
                id: "LINK/MANAGER_ABSENCE_TRACKING",
            },
            {
                id: "LINK/COMPLIANCE_PORTAL",
            },
            {
                id: "LINK/EMPLOYEE_VACATION_BIDDING_DASHBOARD",
            },
        ],
    },
    {
        id: "MENU/TIMESHEET",
        subMenu: [
            {
                id: "LINK/MY_TIME_SHEET_VALIDATE",
            },
            {
                id: "LINK/MY_NEXT_GEN_TIMESHEET",
            },
            {
                id: "LINK/VIEW_PAST_ASSIGNMENTS",
            },
            {
                id: "LINK/TIME_CLOCK",
            },
            {
                id: "LINK/WEB_CLOCK",
            },
            {
                id: "LINK/MANAGER_DEFAULT_LABOR_ALLOCATION",
            },
            {
                id: "LINK/MY_DEFAULT_LABOR_ALLOCATION",
            },
            {
                id: "LINK/MY_TIMESHEET",
            },
            {
                id: "LINK/MANAGE_TIMESHEET",
            },
            {
                id: "LINK/APPROVAL_AND_EXCEPTIONS",
            },
            {
                id: "LINK/LIVE_ATTENDANCE_STATUS",
            },
            {
                id: "LINK/PAYROLL_WEEKLY",
            },
            {
                id: "LINK/TIME_AND_ATTENDANCE",
            },
            {
                id: "LINK/MANAGER_TIME_ENTRY_VALIDATE",
            },
            {
                id: "LINK/MANAGER_NEXT_GEN_TIME_ENTRY",
            },
            {
                id: "LINK/GRP_TIME_ENTRY",
            },
            {
                id: "LINK/CREW_PRODUCTION",
            },
            {
                id: "LINK/MASS_EDIT_TIME",
            },
            {
                id: "LINK/APPROVAL",
            },
            {
                id: "LINK/APPROVAL_NEXT_GEN",
            },
            {
                id: "LINK/END_OF_PROCESSING_INSTRUCTIONS",
            },
            {
                id: "LINK/FATIGUE_ASSESSMENTS",
            },
            {
                id: "LINK/LINE_APPROVAL",
            },
            {
                id: "LINK/OVERTIME_BANKS",
            },
        ],
    },
    {
        id: "LINK/ML_FORECASTING",
    },
    {
        id: "MENU/FORECAST",
        subMenu: [
            {
                id: "LINK/FORECAST",
            },
            {
                id: "LINK/POINT_OF_SALE_ERRORS",
            },
        ],
    },
    {
        id: "MENU/REPORTS",
        subMenu: [
            {
                id: "LINK/GROUP_REPORTS",
            },
            {
                id: "LINK/KPI_DASHBOARD",
            },
            {
                id: "LINK/VIEW_ANALYTICS",
            },
            {
                id: "LINK/NEW_ANALYTICS_REPORT",
            },
            {
                id: "LINK/VIEW_REPORTS_WFS",
            },
            {
                id: "LINK/ADVANCED_SCHEDULING_REPORTS_WFS",
            },
            {
                id: "LINK/SQL_REPORTS",
            },
        ],
    },
    {
        id: "MENU/WFX",
        subMenu: [
            {
                id: "LINK/BROADCASTS",
            },
            {
                id: "LINK/CHANNELS",
            },
            {
                id: "LINK/TASKS",
            },
            {
                id: "LINK/DOCUMENTS",
            },
            {
                id: "LINK/WFX_APP",
            },
        ],
    },
    {
        id: "MENU/ADMIN",
        subMenu: [
            {
                id: "LINK/EMPLOYEE_GROUPS",
            },
            {
                id: "LINK/SYSTEM_CONFIG",
            },
            {
                id: "LINK/RESET_PASSWORD",
            },
            {
                id: "LINK/GROUP_MESSAGING",
            },
            {
                id: "LINK/BADGE_EDIT",
            },
            {
                id: "LINK/DELEGATION",
            },
            {
                id: "LINK/DELEGATION_SUPER",
            },
            {
                id: "LINK/SUBNAV_ASSIGNMENTS",
            },
            {
                id: "LINK/MGR_EMP_MAINTENANCE",
            },
            {
                id: "LINK/SUBNAV_EMPLOYEES",
            },
            {
                id: "LINK/CREW_MAINTENANCE",
            },
            {
                id: "LINK/SUBNAV_MANAGE",
            },
            {
                id: "LINK/SUBNAV_MANAGE_SUPER",
            },
            {
                id: "LINK/SUBNAV_CREATE",
            },
            {
                id: "LINK/SUBNAV_CREATE_SUPER",
            },
            {
                id: "LINK/SUBNAV_USERS",
            },
            {
                id: "LINK/MANAGE_PASSWORD",
            },
            {
                id: "LINK/USER_SECURITY_MAINTENANCE",
            },
            {
                id: "LINK/MANAGE_EMP",
            },
            {
                id: "LINK/NO_CALL_EMP_LIST",
            },
            {
                id: "LINK/EMPLOYEE_FILTER",
            },
            {
                id: "LINK/ADVANCED_SCHEDULER_USERS",
            },
            {
                id: "LINK/ADVANCED_SCHEDULER_USER_GROUPS",
            },
            {
                id: "LINK/EDIT_PROFILES",
            },
            {
                id: "LINK/FIELD_PROFILE",
            },
            {
                id: "LINK/SETUP_PERMISSIONS",
            },
            {
                id: "LINK/ASSOCIATE_MANAGEMENT",
            },
            {
                id: "LINK/BID_PACKAGE_ADMINISTRATION",
            },
            {
                id: "LINK/VACATION_BIDDING_ADMIN",
            },
            {
                id: "LINK/HOLIDAY_MAINTENANCE",
            },
            {
                id: "LINK/SCHEDULE_MAINTENANCE",
            },
            {
                id: "LINK/AREA",
            },
            {
                id: "LINK/ASGN_RULE",
            },
            {
                id: "LINK/AUTO_STAFF_CRIT",
            },
            {
                id: "LINK/AUTOMATIC_CALLOUT_RULES",
            },
            {
                id: "LINK/RULE_CANVASS_RESPONSE",
            },
            {
                id: "LINK/CALL_OUT_RULE",
            },
            {
                id: "LINK/RULE_CANVASS_TERM_CODES",
            },
            {
                id: "LINK/RULE_FM",
            },
            {
                id: "LINK/RULE_LABOR_STD",
            },
            {
                id: "LINK/RULE_LUNCH",
            },
            {
                id: "LINK/MANAGE_ASSSIGNMENTS",
            },
            {
                id: "LINK/NO_CALL_ASGN_LIST",
            },
            {
                id: "LINK/CANVASS_RULE",
            },
            {
                id: "LINK/ASGN_FILTER",
            },
            {
                id: "LINK/RULE_OT_COST",
            },
            {
                id: "LINK/RULE_OT_TYPES",
            },
            {
                id: "LINK/QUALIFICATION",
            },
            {
                id: "LINK/RULE_REASON_CODE",
            },
            {
                id: "LINK/RULE_SCH_PERIOD",
            },
            {
                id: "LINK/COPY_RULE",
            },
            {
                id: "LINK/SWAP_SCHED_RULE",
            },
            {
                id: "LINK/SCHEDULING_GROUP",
            },
            {
                id: "LINK/SCHEDULING_UNIT",
            },
            {
                id: "LINK/RULE_SEL_CONSTR",
            },
            {
                id: "LINK/RULE_SEL_PREF",
            },
            {
                id: "LINK/SHIFT",
            },
            {
                id: "LINK/MANAGE_STATIONS",
            },
            {
                id: "LINK/RUN_JOB",
            },
            {
                id: "LINK/JOB_STATUS",
            },
            {
                id: "LINK/IMPORT_DATA",
            },
            {
                id: "LINK/DOWNLOAD_ADMIN_CLIENT",
            },
            {
                id: "LINK/LD_UPLOAD_UTIL",
            },
            {
                id: "LINK/MANAGE_RETRO_TRIGGERS",
            },
            {
                id: "LINK/MANAGE_TEMPLATES",
            },
            {
                id: "LINK/POLICY_MAPPING_FOR_IMPORTS",
            },
            {
                id: "LINK/RECALC_ASSIGNMENT_GROUPS",
            },
            {
                id: "LINK/PAY_RULES_EDITOR",
            },
            {
                id: "LINK/SUBNAV_SERVER_ADMINISTRATION",
            },
            {
                id: "LINK/CONFIG_AND_SECURITY_CHECK",
            },
            {
                id: "LINK/UI_CALL_OUT",
            },
            {
                id: "LINK/FACILITY",
            },
            {
                id: "LINK/ORGANIZATION",
            },
            {
                id: "LINK/FORECASTING-CONFIGURATION",
            },
            {
                id: "LINK/SYSTEM_ADMINISTRATION",
            },
            {
                id: "LINK/WFX_ADMIN",
            },
        ],
    },
];
var getNavigationSkeleton = function () {
    return navigationSkeleton$1;
};

var NAVIGATION_ITEM_MENU_PREFIX = "MENU/";
var isMenu = function (navigationItem) {
    if (isNavigationItem(navigationItem)) {
        return navigationItem.getId().startsWith(NAVIGATION_ITEM_MENU_PREFIX);
    }
    return navigationItem.id.startsWith(NAVIGATION_ITEM_MENU_PREFIX);
};
var isNavigationItem = function (navigationItem) {
    return !!navigationItem.getId;
};
/**
 * Helper function for checking if nav item is part of the Experience menu
 * @param navigationItem of type NavigationItemsData
 * @returns true if item is part of Experience menu and false if not part of menu
 */
var isExperienceNavigationItem = function (navigationItem) {
    return (navigationItem.id === "LINK/WFX_APP" ||
        navigationItem.id === "LINK/CHANNELS" ||
        navigationItem.id === "LINK/TASKS" ||
        navigationItem.id === "LINK/DOCUMENTS" ||
        navigationItem.id === "LINK/BROADCASTS");
};

var userMenuSkeleton = [
    {
        id: "LINK/PREFERENCES",
    },
    {
        id: "LINK/MY_CONTACT_PREFERENCES",
    },
    {
        id: "LINK/CHANGE_PASSWORD",
    },
    {
        id: "LINK/MY_INFO",
    },
    {
        id: "LINK/MY_ACCOUNT",
    },
    {
        id: "LINK/PERSONAL_DATA_SUMMARY",
    },
    {
        id: "LINK/TODAY_PREFERENCES",
    },
    {
        id: "LINK/ADMINISTRATOR_SUPPORT",
    },
    {
        id: "LINK/MESSAGES",
    },
    {
        id: "LINK/IMPERSONATION",
    },
    {
        id: "LINK/SUITE_IMPERSONATION",
    },
    {
        id: "LINK/SIGN_OUT",
    },
];
var getUserMenuSkeleton = function () { return userMenuSkeleton; };

var _a$3;
/**
 * ID of the locale used to enable test mode.
 */
var TEST_MODE_LOCALE = "TEST_MODE_LOCALE";
var arabicLocaleWithLatinFormatting = "ar-SA-u-ca-gregory-nu-Latn";
var customFormatLocalesMap = (_a$3 = {},
    _a$3[TEST_MODE_LOCALE] = "en-US",
    _a$3["ar-SA"] = arabicLocaleWithLatinFormatting,
    _a$3);
/**
 * Gets the currently selected locale
 * @return {Locales}
 */
function getOptionalCustomFormatLocale() {
    var locale = getStore().getState().appLocalizationData
        .locale;
    return customFormatLocalesMap[locale] || locale;
}
/**
 * Wraps children components in a `@workforcesoftware/localization-framework` locale ID
 * context provider with the lighthouse-framework's current locale ID (based on user preference).
 */
var LocaleIdProvider = function (props) {
    var localeId = useTypedSelector(function (state) {
        var rawLocaleId = state.appLocalizationData.locale;
        return customFormatLocalesMap[rawLocaleId] || rawLocaleId;
    });
    return (React__namespace.default.createElement(localizationFramework.LocaleIdContext.Provider, { value: localeId }, props.children));
};
/**
 * Formats number according to selected locale
 *
 * @param {number} num - The number to be formatted
 * @param {NumberFormatOptions} options - Options for formatting
 * @return {string} Number formatted according to locale
 *
 * @deprecated Use `useNumberFormatter()` React hook from `@workforcesoftware/localization-framework`.
 */
var formatNumber$1 = function (num, options) {
    if (options === void 0) { options = defaultNumberOptions; }
    return Intl.NumberFormat(getOptionalCustomFormatLocale(), options).format(num);
};
var defaultNumberOptions = {};
/**
 * Formats DateTime according to selected locale
 *
 * @param {Date} date - The DateTime to be formatted
 * @param {DateTimeFormatOptions} options - Options for formatting
 * @return {string} DateTime formatted according to locale
 *
 * @deprecated Use `useDateTimeFormatter()` React hook from `@workforcesoftware/localization-framework`.
 */
var formatDateTime = function (date, options) {
    if (options === void 0) { options = defaultTimeOptions; }
    return Intl.DateTimeFormat(getOptionalCustomFormatLocale(), options).format(date);
};
var defaultTimeOptions = {
    day: "2-digit",
    month: "short",
};

var ORGANIZATION_PANEL$z = {
	TITLE: {
		TARGET: "WorkForce Suite Login"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "Typically, this is a short abbreviation for your company. For help, contact an Administrator."
	},
	INVALID_ACCOUNT: {
		TARGET: "Enter a valid Account"
	},
	GENERIC_ERROR: {
		TARGET: "Could not authenticate"
	},
	NETWORK_ERROR: {
		TARGET: "There was a problem reaching the server. Please check your connection"
	},
	ACCOUNT: {
		TARGET: "Account"
	},
	BUTTON_NEXT: {
		TARGET: "Next"
	},
	SELECT_LANGUAGE: {
		TARGET: "Select Language"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Change account name"
	}
};
var en_AU = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$z
};

var ORGANIZATION_PANEL$y = {
	TITLE: {
		TARGET: "WorkForce Suite Login"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "Typically this is a short abbreviation for your company. For help, contact an Administrator."
	},
	INVALID_ACCOUNT: {
		TARGET: "Enter a valid Account"
	},
	GENERIC_ERROR: {
		TARGET: "Could not authenticate"
	},
	NETWORK_ERROR: {
		TARGET: "There was a problem reaching the server. Please check your connection"
	},
	ACCOUNT: {
		TARGET: "Account"
	},
	BUTTON_NEXT: {
		TARGET: "Next"
	},
	SELECT_LANGUAGE: {
		TARGET: "Select Language"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Change account name"
	}
};
var en_GB = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$y
};

var ORGANIZATION_PANEL$x = {
	TITLE: {
		TARGET: "Workforce Software – Suite-Anmeldung"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "Meistens eine Abkürzung des Unternehmensnamens. Wenn Sie Hilfe benötigen, wenden Sie sich bitte an einen Administrator."
	},
	INVALID_ACCOUNT: {
		TARGET: "Bitte gültigen Benutzer eingeben"
	},
	GENERIC_ERROR: {
		TARGET: "Authentifizierung nicht möglich"
	},
	NETWORK_ERROR: {
		TARGET: "Keine Verbindung zum Server. Bitte überprüfen Sie Ihre Verbindung."
	},
	ACCOUNT: {
		TARGET: "Benutzer"
	},
	BUTTON_NEXT: {
		TARGET: "Weiter"
	},
	SELECT_LANGUAGE: {
		TARGET: "Sprache auswählen"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Kontoname ändern"
	}
};
var de_DE = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$x
};

var ORGANIZATION_PANEL$w = {
	TITLE: {
		TARGET: "Connexion WorkForce Suite"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "Il s'agit généralement d'une abréviation du nom de votre entreprise. Pour obtenir de l'aide, contactez un administrateur."
	},
	INVALID_ACCOUNT: {
		TARGET: "Entrer un compte valide"
	},
	GENERIC_ERROR: {
		TARGET: "Impossible d'authentifier"
	},
	NETWORK_ERROR: {
		TARGET: "Un problème est survenu en joignant le serveur. Veuillez vérifier la connexion"
	},
	ACCOUNT: {
		TARGET: "Compte"
	},
	BUTTON_NEXT: {
		TARGET: "Suivant"
	},
	SELECT_LANGUAGE: {
		TARGET: "Sélectionner la langue"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Changer le nom du compte"
	}
};
var fr_CA = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$w
};

var ORGANIZATION_PANEL$v = {
	TITLE: {
		TARGET: "Inicio de sesión de WorkForce Suite"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "Usualmente, esto es una abreviación de su empresa. Comuníquese con un administrador para obtener ayuda."
	},
	INVALID_ACCOUNT: {
		TARGET: "Ingrese una cuenta válida"
	},
	GENERIC_ERROR: {
		TARGET: "No se pudo autenticar"
	},
	NETWORK_ERROR: {
		TARGET: "Hubo un problema al comunicarse con el servidor. Verifique su conexión"
	},
	ACCOUNT: {
		TARGET: "Cuenta"
	},
	BUTTON_NEXT: {
		TARGET: "Siguiente"
	},
	SELECT_LANGUAGE: {
		TARGET: "Seleccionar idioma"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Cambiar nombre de cuenta"
	}
};
var es_US = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$v
};

var ORGANIZATION_PANEL$u = {
	TITLE: {
		TARGET: "Login no WorkForce Suite"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "Geralmente é uma mensagem curta da sua empresa. Em caso de dúvida, fale com um administrador."
	},
	INVALID_ACCOUNT: {
		TARGET: "Informe uma conta válida"
	},
	GENERIC_ERROR: {
		TARGET: "Não foi possível autenticar"
	},
	NETWORK_ERROR: {
		TARGET: "Erro ao conectar-se ao servidor. Verifique sua conexão."
	},
	ACCOUNT: {
		TARGET: "Conta"
	},
	BUTTON_NEXT: {
		TARGET: "Próximo"
	},
	SELECT_LANGUAGE: {
		TARGET: "Selecionar idioma"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Alterar nome da conta"
	}
};
var pt_BR = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$u
};

var ORGANIZATION_PANEL$t = {
	TITLE: {
		TARGET: "WorkForce Suite -kirjautuminen"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "Tämä on tyypillisesti lyhenne yrityksesi nimestä. Saat apua ottamalla yhteyden järjestelmänvalvojaan."
	},
	INVALID_ACCOUNT: {
		TARGET: "Anna kelvollinen tili"
	},
	GENERIC_ERROR: {
		TARGET: "Ei voitu todentaa"
	},
	NETWORK_ERROR: {
		TARGET: "Virhe yhteyden muodostamisessa palvelimeen. Tarkista yhteys"
	},
	ACCOUNT: {
		TARGET: "Tili"
	},
	BUTTON_NEXT: {
		TARGET: "Seuraava"
	},
	SELECT_LANGUAGE: {
		TARGET: "Valitse kieli"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Vaihda tilin nimi"
	}
};
var fi_FI = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$t
};

var ORGANIZATION_PANEL$s = {
	TITLE: {
		TARGET: "WorkForce Software ログイン"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "これは通常、あなたの会社の略称です。ヘルプが必要な場合は、管理者までお問い合わせください。"
	},
	INVALID_ACCOUNT: {
		TARGET: "有効なアカウントを入力してください。"
	},
	GENERIC_ERROR: {
		TARGET: "認証できませんでした。"
	},
	NETWORK_ERROR: {
		TARGET: "サーバーに接続中に問題が発生しました。接続を確認してください。"
	},
	ACCOUNT: {
		TARGET: "アカウント"
	},
	BUTTON_NEXT: {
		TARGET: "次へ"
	},
	SELECT_LANGUAGE: {
		TARGET: "言語の選択"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "アカウント名の変更"
	}
};
var ja_JP = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$s
};

var ORGANIZATION_PANEL$r = {
	TITLE: {
		TARGET: "Accesso a WorkForce Suite"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "Si tratta generalmente di un'abbreviazione dell'azienda. Per ricevere assistenza, contattare un amministratore."
	},
	INVALID_ACCOUNT: {
		TARGET: "Inserire un account valido"
	},
	GENERIC_ERROR: {
		TARGET: "Impossibile eseguire l'autenticazione"
	},
	NETWORK_ERROR: {
		TARGET: "Si è verificato un problema durante il tentativo di contattare il server. Verificare la connessione"
	},
	ACCOUNT: {
		TARGET: "Account"
	},
	BUTTON_NEXT: {
		TARGET: "Avanti"
	},
	SELECT_LANGUAGE: {
		TARGET: "Seleziona lingua"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Modifica nome account"
	}
};
var it_IT = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$r
};

var ORGANIZATION_PANEL$q = {
	TITLE: {
		TARGET: "WorkForce सुइट लॉगिन"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "आमतौर पर यह आपकी कंपनी का संक्षिप्त नाम है। मदद के लिए, व्यवस्थापक से संपर्क करें।"
	},
	INVALID_ACCOUNT: {
		TARGET: "कृपया एक मान्य खाता दर्ज करें"
	},
	GENERIC_ERROR: {
		TARGET: "प्राधिकृत नहीं कर सका"
	},
	NETWORK_ERROR: {
		TARGET: "सर्वर तक पहुंचने में समस्या थी। कृपया अपना कनेक्शन चेक करें"
	},
	ACCOUNT: {
		TARGET: "खाता"
	},
	BUTTON_NEXT: {
		TARGET: "अगला"
	},
	SELECT_LANGUAGE: {
		TARGET: "भाषा चुनें"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "अकाउंट का नाम बदलें"
	}
};
var hi_IN = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$q
};

var ORGANIZATION_PANEL$p = {
	TITLE: {
		TARGET: "WorkForce Suite Girişi"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "Bu genellikle şirket adınızın kısaltmasıdır. Yardım için bir yöneticiyle iletişime geçin."
	},
	INVALID_ACCOUNT: {
		TARGET: "Geçerli bir hesap girin"
	},
	GENERIC_ERROR: {
		TARGET: "Kimlik doğrulaması yapılamadı"
	},
	NETWORK_ERROR: {
		TARGET: "Sunucuya erişimde bir sorun oluştu. Lütfen bağlantınızı kontrol edin"
	},
	ACCOUNT: {
		TARGET: "Hesap"
	},
	BUTTON_NEXT: {
		TARGET: "Sonraki"
	},
	SELECT_LANGUAGE: {
		TARGET: "Dil Seç"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Hesap adını değiştir"
	}
};
var tr_TR = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$p
};

var ORGANIZATION_PANEL$o = {
	TITLE: {
		TARGET: "Вхід у WorkForce Suite"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "Зазвичай це скорочена назва компанії. За допомогою звертайтеся до адміністратора."
	},
	INVALID_ACCOUNT: {
		TARGET: "Введіть дійсне ім’я облікового запису"
	},
	GENERIC_ERROR: {
		TARGET: "Не вдається виконати автентифікацію"
	},
	NETWORK_ERROR: {
		TARGET: "Під час підְ’єднання сталася помилка. Перевірте з’єднання"
	},
	ACCOUNT: {
		TARGET: "Обліковий запис"
	},
	BUTTON_NEXT: {
		TARGET: "Далі"
	},
	SELECT_LANGUAGE: {
		TARGET: "Вибрати мову"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Змінити ім’я облікового запису"
	}
};
var uk_UA = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$o
};

var ORGANIZATION_PANEL$n = {
	TITLE: {
		TARGET: "Masuk Log WorkForce Suite"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "Biasanya dengan singkatan pendek nama perusahaan Anda. Untuk bantuan, hubungi Administrator."
	},
	INVALID_ACCOUNT: {
		TARGET: "Masukkan Akun yang valid"
	},
	GENERIC_ERROR: {
		TARGET: "Tidak dapat mengotentikasi"
	},
	NETWORK_ERROR: {
		TARGET: "Ada masalah saat menghubungi server. Silakan cek koneksi Anda"
	},
	ACCOUNT: {
		TARGET: "Akun"
	},
	BUTTON_NEXT: {
		TARGET: "Selanjutnya"
	},
	SELECT_LANGUAGE: {
		TARGET: "Pilih Bahasa"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Ubah nama akun"
	}
};
var id_ID = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$n
};

var ORGANIZATION_PANEL$m = {
	TITLE: {
		TARGET: "WorkForce Suite 登录"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "通常这是您所在公司的缩写。请联系管理员获得帮助。"
	},
	INVALID_ACCOUNT: {
		TARGET: "输入有效帐户"
	},
	GENERIC_ERROR: {
		TARGET: "无法验证"
	},
	NETWORK_ERROR: {
		TARGET: "访问服务器时出现问题。请检查网络连接"
	},
	ACCOUNT: {
		TARGET: "帐户"
	},
	BUTTON_NEXT: {
		TARGET: "下一页"
	},
	SELECT_LANGUAGE: {
		TARGET: "选择语言"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "更改帐户名"
	}
};
var zh_CN = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$m
};

var ORGANIZATION_PANEL$l = {
	TITLE: {
		TARGET: "Rakendusse WorkForce Suite sisselogimine"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "Tavaliselt on see sinu ettevõtte lühend. Abi saamiseks võta ühendust administraatoriga."
	},
	INVALID_ACCOUNT: {
		TARGET: "Sisesta kehtiv konto"
	},
	GENERIC_ERROR: {
		TARGET: "Autentimine ei õnnestunud"
	},
	NETWORK_ERROR: {
		TARGET: "Serveriga ühendamisel ilmnes probleem. Kontrolli oma ühendust"
	},
	ACCOUNT: {
		TARGET: "Konto"
	},
	BUTTON_NEXT: {
		TARGET: "Edasi"
	},
	SELECT_LANGUAGE: {
		TARGET: "Vali keel"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Muuda kontonime"
	}
};
var et_EE = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$l
};

var ORGANIZATION_PANEL$k = {
	TITLE: {
		TARGET: "Connexion à la suite WorkForce"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "En général, il existe une abréviation pour votre entreprise. Contactez un administrateur pour obtenir de l'aide."
	},
	INVALID_ACCOUNT: {
		TARGET: "Indiquez un compte valide."
	},
	GENERIC_ERROR: {
		TARGET: "Authentification impossible"
	},
	NETWORK_ERROR: {
		TARGET: "Un problème d'accès au serveur est survenu. Veuillez vérifier votre connexion."
	},
	ACCOUNT: {
		TARGET: "Compte"
	},
	BUTTON_NEXT: {
		TARGET: "Suivant"
	},
	SELECT_LANGUAGE: {
		TARGET: "Sélectionner la langue"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Modifier le nom du compte"
	}
};
var fr_FR = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$k
};

var ORGANIZATION_PANEL$j = {
	TITLE: {
		TARGET: "Inicio de sesión en WorkForce Suite"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "Esto suele ser una abreviación del nombre de su empresa. Si necesita ayuda, póngase en contacto con un administrador."
	},
	INVALID_ACCOUNT: {
		TARGET: "Introduzca una cuenta válida"
	},
	GENERIC_ERROR: {
		TARGET: "No se ha podido autenticar"
	},
	NETWORK_ERROR: {
		TARGET: "No se ha podido contactar con el servidor. Compruebe su conexión"
	},
	ACCOUNT: {
		TARGET: "Cuenta"
	},
	BUTTON_NEXT: {
		TARGET: "Siguiente"
	},
	SELECT_LANGUAGE: {
		TARGET: "Seleccionar idioma"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Cambiar nombre de la cuenta"
	}
};
var es_ES = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$j
};

var ORGANIZATION_PANEL$i = {
	TITLE: {
		TARGET: "WorkForce Suite inloggning"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "Vanligtvis är detta en kort förkortning av ditt företag. Kontakta administratören för att få hjälp."
	},
	INVALID_ACCOUNT: {
		TARGET: "Ange ett giltigt konto"
	},
	GENERIC_ERROR: {
		TARGET: "Det gick inte att autentisera"
	},
	NETWORK_ERROR: {
		TARGET: "Det gick inte att nå servern. Kontrollera din anslutning"
	},
	ACCOUNT: {
		TARGET: "Konto"
	},
	BUTTON_NEXT: {
		TARGET: "Nästa"
	},
	SELECT_LANGUAGE: {
		TARGET: "Välj språk"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Ändra kontonamn"
	}
};
var sv_SE = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$i
};

var ORGANIZATION_PANEL$h = {
	TITLE: {
		TARGET: "Вход в WorkForce Suite"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "Как правило, это сокращенное название компании. Для получения помощи обратитесь к администратору."
	},
	INVALID_ACCOUNT: {
		TARGET: "Введите действующую учетную запись"
	},
	GENERIC_ERROR: {
		TARGET: "Не удалось пройти аудетнификацию"
	},
	NETWORK_ERROR: {
		TARGET: "При попытке связаться с сервером возникла проблема. Проверьте подключение"
	},
	ACCOUNT: {
		TARGET: "Учетная запись"
	},
	BUTTON_NEXT: {
		TARGET: "Далее"
	},
	SELECT_LANGUAGE: {
		TARGET: "Выбрать язык"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Изменить имя учетной записи"
	}
};
var ru_RU = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$h
};

var ORGANIZATION_PANEL$g = {
	TITLE: {
		TARGET: "Đăng nhập Workforce Suite"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "Đây thường là tên viết tắt cho công ty của bạn. Để được trợ giúp, hãy liên hệ với Quản trị viên."
	},
	INVALID_ACCOUNT: {
		TARGET: "Nhập tài khoản hợp lệ"
	},
	GENERIC_ERROR: {
		TARGET: "Không thể xác thực"
	},
	NETWORK_ERROR: {
		TARGET: "Đã có lỗi khi kết nối với máy chủ. Vui lòng kiểm tra kết nối mạng của bạn"
	},
	ACCOUNT: {
		TARGET: "Tài khoản"
	},
	BUTTON_NEXT: {
		TARGET: "Tiếp theo"
	},
	SELECT_LANGUAGE: {
		TARGET: "Chọn ngôn ngữ"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Thay đổi tên tài khoản"
	}
};
var vi_VN = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$g
};

var ORGANIZATION_PANEL$f = {
	TITLE: {
		TARGET: "تسجيل دخول إلى WorkForce Suite"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "عادةً ما يكون هذا اختصارًا قصيرًا لشركتك. للحصول على المساعدة، اتصل بمالك النظام."
	},
	INVALID_ACCOUNT: {
		TARGET: "أدخل حسابًا صالحًا"
	},
	GENERIC_ERROR: {
		TARGET: "تعذرت المصادقة"
	},
	NETWORK_ERROR: {
		TARGET: "حدثت مشكلة في الوصول إلى الخادم. يرجى التحقق من اتصالك"
	},
	ACCOUNT: {
		TARGET: "حساب"
	},
	BUTTON_NEXT: {
		TARGET: "التالي"
	},
	SELECT_LANGUAGE: {
		TARGET: "تحديد اللغة"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "تغيير اسم الحساب"
	}
};
var ar_SA = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$f
};

var ORGANIZATION_PANEL$e = {
	TITLE: {
		TARGET: "Logowanie do pakietu WorkForce Suite"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "Zwykle jest to skrócona nazwy Twojej firmy. Aby uzyskać pomoc, skontaktuj się z administratorem."
	},
	INVALID_ACCOUNT: {
		TARGET: "Wprowadź prawidłowe konto"
	},
	GENERIC_ERROR: {
		TARGET: "Nie udało się uwierzytelnić"
	},
	NETWORK_ERROR: {
		TARGET: "Wystąpił problem podczas łączenia z serwerem. Sprawdź połączenie"
	},
	ACCOUNT: {
		TARGET: "Konto"
	},
	BUTTON_NEXT: {
		TARGET: "Dalej"
	},
	SELECT_LANGUAGE: {
		TARGET: "Wybierz język"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Zmień nazwę konta"
	}
};
var pl_PL = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$e
};

var ORGANIZATION_PANEL$d = {
	TITLE: {
		TARGET: "Inicio de sesión de WorkForce Suite"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "Usualmente, esto es una abreviación de su empresa. Comuníquese con un administrador para obtener ayuda."
	},
	INVALID_ACCOUNT: {
		TARGET: "Ingrese una cuenta válida"
	},
	GENERIC_ERROR: {
		TARGET: "No se pudo autenticar"
	},
	NETWORK_ERROR: {
		TARGET: "Hubo un problema al comunicarse con el servidor. Verifique su conexión"
	},
	ACCOUNT: {
		TARGET: "Cuenta"
	},
	BUTTON_NEXT: {
		TARGET: "Siguiente"
	},
	SELECT_LANGUAGE: {
		TARGET: "Seleccionar idioma"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Cambiar nombre de cuenta"
	}
};
var es_MX = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$d
};

var ORGANIZATION_PANEL$c = {
	TITLE: {
		TARGET: "WorkForce Suite Innlogging"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "Vanligvis er dette en kort forkortelse for din bedrift. For hjelp, kontakt en administrator."
	},
	INVALID_ACCOUNT: {
		TARGET: "Angi en gyldig konto"
	},
	GENERIC_ERROR: {
		TARGET: "Kunne ikke autentisere"
	},
	NETWORK_ERROR: {
		TARGET: "Det oppsto et problem med å nå serveren. Vennligst sjekk forbindelsen din"
	},
	ACCOUNT: {
		TARGET: "Konto"
	},
	BUTTON_NEXT: {
		TARGET: "Neste"
	},
	SELECT_LANGUAGE: {
		TARGET: "Velg språk"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Endre kontonavn"
	}
};
var no_NO = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$c
};

var ORGANIZATION_PANEL$b = {
	TITLE: {
		TARGET: "Conectare în suita WorkForce"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "De obicei, aceasta este o scurtă abreviere a companiei. Pentru ajutor, contactați un administrator."
	},
	INVALID_ACCOUNT: {
		TARGET: "Introduceți un cont valid"
	},
	GENERIC_ERROR: {
		TARGET: "Nu s-a putut autentifica"
	},
	NETWORK_ERROR: {
		TARGET: "A existat o problemă de acces la server. Verificați-vă conexiunea"
	},
	ACCOUNT: {
		TARGET: "Cont"
	},
	BUTTON_NEXT: {
		TARGET: "Înainte"
	},
	SELECT_LANGUAGE: {
		TARGET: "Selectare Limbă"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Schimbați numele contului"
	}
};
var ro_RO = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$b
};

var ORGANIZATION_PANEL$a = {
	TITLE: {
		TARGET: "WorkForce 스위트 로그인"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "일반적으로 회사의 짧은 약칭입니다. 도움이 필요하면 관리자에게 문의하시기 바랍니다."
	},
	INVALID_ACCOUNT: {
		TARGET: "유효한 계정을 입력하세요."
	},
	GENERIC_ERROR: {
		TARGET: "인증하지 못했습니다."
	},
	NETWORK_ERROR: {
		TARGET: "서버 연결에 문제가 있었습니다. 연결 상태를 확인하시기 바랍니다."
	},
	ACCOUNT: {
		TARGET: "계정"
	},
	BUTTON_NEXT: {
		TARGET: "다음"
	},
	SELECT_LANGUAGE: {
		TARGET: "언어 선택"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "계정 이름 변경"
	}
};
var ko_KR = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$a
};

var ORGANIZATION_PANEL$9 = {
	TITLE: {
		TARGET: "การเข้าสู่ระบบ Workforce Suite"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "โดยทั่วไปแล้ว นี่เป็นตัวย่อสั้น ๆ สำหรับบริษัทของคุณ หากต้องการความช่วยเหลือ โปรดติดต่อผู้ดูแลระบบ"
	},
	INVALID_ACCOUNT: {
		TARGET: "ใส่บัญชีที่ถูกต้อง"
	},
	GENERIC_ERROR: {
		TARGET: "ไม่สามารถตรวจสอบยืนยันได้"
	},
	NETWORK_ERROR: {
		TARGET: "เกิดปัญหาในการเข้าถึงเซิร์ฟเวอร์ โปรดตรวจสอบการเชื่อมต่อของคุณ"
	},
	ACCOUNT: {
		TARGET: "บัญชี"
	},
	BUTTON_NEXT: {
		TARGET: "ถัดไป"
	},
	SELECT_LANGUAGE: {
		TARGET: "เลือกภาษา"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "เปลี่ยนชื่อบัญชี"
	}
};
var th_TH = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$9
};

var ORGANIZATION_PANEL$8 = {
	TITLE: {
		TARGET: "Přihlášení do WorkForce Suite"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "Obvykle se jedná o krátkou zkratku vaší společnosti. Ohledně nápovědy kontaktujte správce."
	},
	INVALID_ACCOUNT: {
		TARGET: "Zadejte platný účet"
	},
	GENERIC_ERROR: {
		TARGET: "Ověření nebylo možné provést"
	},
	NETWORK_ERROR: {
		TARGET: "Došlo k problému při volání serveru. Zkontrolujte své připojení"
	},
	ACCOUNT: {
		TARGET: "Účet"
	},
	BUTTON_NEXT: {
		TARGET: "Další"
	},
	SELECT_LANGUAGE: {
		TARGET: "Vybrat jazyk"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Změnit název účtu"
	}
};
var cs_CZ = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$8
};

var ORGANIZATION_PANEL$7 = {
	TITLE: {
		TARGET: "WorkForce Suite-bejelentkezés"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "Ez általában az Ön vállalatának a rövid neve. Segítségért forduljon a rendszergazdához."
	},
	INVALID_ACCOUNT: {
		TARGET: "Érvényes fiókot adjon meg"
	},
	GENERIC_ERROR: {
		TARGET: "Nem sikerült a hitelesítés"
	},
	NETWORK_ERROR: {
		TARGET: "Hiba történt a kiszolgáló elérése közben. Ellenőrizze a kapcsolatot"
	},
	ACCOUNT: {
		TARGET: "Fiók"
	},
	BUTTON_NEXT: {
		TARGET: "Következő"
	},
	SELECT_LANGUAGE: {
		TARGET: "Nyelvválasztás"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Fióknév módosítása"
	}
};
var hu_HU = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$7
};

var ORGANIZATION_PANEL$6 = {
	TITLE: {
		TARGET: "WorkForce Suite 登入"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "通常這是您所在公司的縮寫。請聯絡管理員尋求協助。"
	},
	INVALID_ACCOUNT: {
		TARGET: "輸入有效帳戶"
	},
	GENERIC_ERROR: {
		TARGET: "無法驗證"
	},
	NETWORK_ERROR: {
		TARGET: "連線伺服器時發生問題。請檢查網路連線"
	},
	ACCOUNT: {
		TARGET: "帳戶"
	},
	BUTTON_NEXT: {
		TARGET: "下一步"
	},
	SELECT_LANGUAGE: {
		TARGET: "選擇語言"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "變更帳戶名"
	}
};
var zh_TW = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$6
};

var ORGANIZATION_PANEL$5 = {
	TITLE: {
		TARGET: "Login til WorkForce Suite"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "Dette er typisk en forkortelse for din virksomhed. Kontakt en administrator for at få hjælp."
	},
	INVALID_ACCOUNT: {
		TARGET: "Angiv en gyldig konto."
	},
	GENERIC_ERROR: {
		TARGET: "Kunne ikke godkende"
	},
	NETWORK_ERROR: {
		TARGET: "Der opstod et problem med serveren. Tjek din forbindelse"
	},
	ACCOUNT: {
		TARGET: "Konto"
	},
	BUTTON_NEXT: {
		TARGET: "Næste"
	},
	SELECT_LANGUAGE: {
		TARGET: "Vælg sprog"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Skift kontonavn"
	}
};
var da_DK = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$5
};

var ORGANIZATION_PANEL$4 = {
	TITLE: {
		TARGET: "Início de sessão no WorkForce Suite"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "Geralmente, esta é uma abreviatura para a sua empresa. Para obter ajuda, contacte um Administrador."
	},
	INVALID_ACCOUNT: {
		TARGET: "Introduza uma conta válida"
	},
	GENERIC_ERROR: {
		TARGET: "Não foi possível autenticar"
	},
	NETWORK_ERROR: {
		TARGET: "Ocorreu um erro ao alcançar o servidor. Verifique a sua ligação"
	},
	ACCOUNT: {
		TARGET: "Conta"
	},
	BUTTON_NEXT: {
		TARGET: "Seguinte"
	},
	SELECT_LANGUAGE: {
		TARGET: "Selecionar idioma"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Alterar nome da conta"
	}
};
var pt_PT = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$4
};

var ORGANIZATION_PANEL$3 = {
	TITLE: {
		TARGET: "Prijava v WorkForce Suite"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "Običajno je to kratka okrajšava vašega podjetja. Za pomoč se obrnite na skrbnika."
	},
	INVALID_ACCOUNT: {
		TARGET: "Vnesite veljaven račun"
	},
	GENERIC_ERROR: {
		TARGET: "Pristnosti ni bilo mogoče preveriti"
	},
	NETWORK_ERROR: {
		TARGET: "Pri vzpostavljanju povezave s strežnikom je prišlo do težave. Preverite povezavo"
	},
	ACCOUNT: {
		TARGET: "Račun"
	},
	BUTTON_NEXT: {
		TARGET: "Naprej"
	},
	SELECT_LANGUAGE: {
		TARGET: "Izberite jezik"
	}
};
var sl_SI = {
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$3
};

var MENU_ITEMS$2 = {
	USER_PREFERENCES: {
		TARGET: "Voorkeuren"
	}
};
var GREETING$2 = {
	MENU_TITLE: {
		TARGET: "Beste {{firstname}}"
	}
};
var RESET_PASSWORD$2 = {
	HEADING: {
		TARGET: "Wachtwoord medewerker opnieuw instellen"
	},
	DESCRIPTION: {
		TARGET: " Gebruik dit formulier om het wachtwoord van een medewerker opnieuw in te stellen. Onthoud het nieuwe wachtwoord goed en geef het zo snel mogelijk aan de medewerker door. Dit wachtwoord is tijdelijk en moet bij de volgende aanmelding door de gebruiker worden gewijzigd."
	},
	CANCEL_BUTTON: {
		TARGET: "Annuleren"
	},
	RESET_BUTTON: {
		TARGET: "Wachtwoord opnieuw instellen"
	},
	RESETTING_BUTTON: {
		TARGET: "Wachtwoord opnieuw instellen"
	},
	PASSWORD_SUCCESS: {
		TARGET: "Wachtwoord is opnieuw ingesteld"
	},
	MATCH_PASSWORD: {
		TARGET: "Wachtwoorden komen niet overeen."
	},
	MINIMUM_REQUIREMENT: {
		TARGET: "Wachtwoord voldoet niet aan de minimale vereisten."
	},
	CONFIRM_PASSWORD: {
		TARGET: "Wachtwoord bevestigen"
	},
	ERROR_BLACKLISTED: {
		TARGET: "Dit wachtwoord staat op de blokkeerlijst. Gebruik een ander wachtwoord."
	},
	ERROR_LENGTH: {
		TARGET: "Het wachtwoord moet minimaal {{length}} tekens lang zijn."
	},
	ERROR_REGEX: {
		TARGET: "Het wachtwoord voldoet niet aan een aangepast regex-patroon."
	},
	ERROR_GENERIC: {
		TARGET: "Het wachtwoord {{errorMessage}}"
	}
};
var USER_PREFERENCES$2 = {
	BACK_ARROW: {
		TARGET: "Terug"
	},
	LANDING_PAGE: {
		TARGET: "Startpagina"
	},
	LANGUAGE: {
		TARGET: "Taal"
	},
	LANGUAGE_AND_LOCALIZATION: {
		TARGET: "Taal en lokalisatie"
	},
	LANGUAGE_AND_LOCALIZATION_TITLE: {
		TARGET: "Taal en lokalisatie"
	},
	LANGUAGE_AND_LOCALIZATION_SUBTITLE: {
		TARGET: "Selecteer hieronder de opties voor taal en lokalisatie die overal in WorkForce Suite moeten worden gebruikt."
	},
	TIME_FORMAT_PREFERENCE_TITLE: {
		TARGET: "Voorkeur tijdnotatie"
	},
	TIME_FORMATTING_ACCOUNT_CONFIG_DEFAULT_LABEL: {
		TARGET: "Instellingen van mijn organisatie"
	},
	TIME_FORMATTING_ACCOUNT_CONFIG_DEFAULT_DESCRIPTION: {
		TARGET: "De tijd wordt weergegeven op basis van de instelling die is gekozen door de systeembeheerder."
	},
	TIME_FORMATTING_LOCALE_DEFAULT_LABEL: {
		TARGET: "Notatie op basis mijn taal/lokalisatie"
	},
	TIME_FORMATTING_LOCALE_DEFAULT_DESCRIPTION: {
		TARGET: "De tijd wordt gebaseerd op de taal/locatie die hoort bij de hierboven geselecteerde taal."
	},
	TIME_FORMATTING_FORCE_12_HOURS_LABEL: {
		TARGET: "12-uurs weergave"
	},
	TIME_FORMATTING_FORCE_12_HOURS_DESCRIPTION: {
		TARGET: "De tijd wordt weergegeven als 12:00 (AM/PM), ongeacht de taal/locatie in de instellingen van uw organisatie."
	},
	TIME_FORMATTING_FORCE_24_HOURS_LABEL: {
		TARGET: "24-uurs weergave"
	},
	TIME_FORMATTING_FORCE_24_HOURS_DESCRIPTION: {
		TARGET: "De tijd wordt weergegeven als 00:00 - 24:00, ongeacht de taal/locatie in de instellingen van uw organisatie."
	},
	SETTING_UPDATE_SUCCESS: {
		TARGET: "Instelling is bijgewerkt."
	},
	SETTING_UPDATE_FAILED: {
		TARGET: "Bijwerken van instelling is mislukt. Probeer het later opnieuw."
	},
	THEME: {
		TARGET: "Thema"
	},
	THEMES: {
		TARGET: "Thema's"
	},
	CHANGE_THEME: {
		TARGET: "Thema wijzigen"
	},
	CHANGE_LANGUAGE: {
		TARGET: "Taal wijzigen"
	},
	CHANGE_LANDING_PAGE: {
		TARGET: "Startpagina wijzigen"
	},
	HUB_AND_ASSISTANT_EMPLOYEE_GROUPS: {
		TARGET: "Medewerkergroepen hub en assistent"
	},
	SAVE: {
		TARGET: "Opslaan"
	},
	LANDING_PAGE_DESCRIPTION: {
		TARGET: "Selecteer de pagina die u wilt weergeven als u zich aanmeldt bij WorkForce Suite."
	},
	HUB_PAGE: {
		TARGET: "Hubpagina"
	},
	CUSTOM: {
		TARGET: "Aangepast"
	},
	CUSTOM_LANDING_PAGE: {
		TARGET: "Aangepaste startpagina"
	},
	LANDING_PAGE_RADIO_GROUP_ARIA_LABEL: {
		TARGET: "Wilt u een aangepaste startpagina weergeven of wilt u standaard naar de hub gaan?"
	},
	DISCARD_CHANGES: {
		TARGET: "Wijzigingen verwerpen"
	},
	CHANGES_SAVED: {
		TARGET: "Wijzigingen opgeslagen"
	}
};
var EMPLOYEE_GROUP_FILTERS$2 = {
	TITLE: {
		TARGET: "Medewerkergroepen hub en assistent"
	},
	DESCRIPTION: {
		TARGET: "Voor welke groep wilt u items zien in de hub en de assistent?"
	}
};
var NAV_MENU$2 = {
	ADMIN: {
		TARGET: "Beheerder"
	},
	REPORTS: {
		TARGET: "Rapporten"
	},
	STAFF: {
		TARGET: "Personeel"
	},
	SUPPORT: {
		TARGET: "Ondersteuning"
	},
	TIME_OFF: {
		TARGET: "Verlof"
	},
	TIMESHEET: {
		TARGET: "Urenstaat"
	},
	SCHEDULE: {
		TARGET: "Planning"
	},
	FORECAST: {
		TARGET: "Voorspelling"
	},
	HELP: {
		TARGET: "Help"
	},
	WFX: {
		TARGET: "Ervaring"
	}
};
var NAV_LINKS$2 = {
	PREFERENCES: {
		TARGET: "Voorkeuren"
	},
	IMPERSONATION: {
		TARGET: "Nabootsen"
	},
	SIGN_OUT: {
		TARGET: "Afmelden"
	},
	MY_TIMESHEET: {
		TARGET: "Mijn urenstaat"
	},
	VIEW_PAST_ASSIGNMENTS: {
		TARGET: "Eerdere opdrachten bekijken"
	},
	MY_NEXT_GEN_TIMESHEET: {
		TARGET: "Mijn Next-Gen-urenstaat"
	},
	TIME_CLOCK: {
		TARGET: "Klok"
	},
	PAYROLL_WEEKLY: {
		TARGET: "Wekelijkse loonlijst"
	},
	AVAILABILITY: {
		TARGET: "Beschikbaarheid"
	},
	MY_ACCOUNT: {
		TARGET: "Mijn account"
	},
	AUTO_SCHEDULE: {
		TARGET: "Automatisch plannen"
	},
	MY_SCHEDULE_WFS: {
		TARGET: "Mijn planning"
	},
	AUTO_SCHEDULE_WFS: {
		TARGET: "Automatische planning"
	},
	TIME_AND_ATTENDANCE: {
		TARGET: "Tijd en aanwezigheid"
	},
	SHIFT_SWAP: {
		TARGET: "Ploeg ruilen"
	},
	AVAILABILITY_TEMPLATE: {
		TARGET: "Beschikbaarheidssjabloon"
	},
	POINT_OF_SALE_ERRORS: {
		TARGET: "Fouten op verkooppunt"
	},
	SHIFT_BIDDING: {
		TARGET: "Mijn dienstbieding"
	},
	SHIFT_BIDDING_PREFERENCES: {
		TARGET: "Mijn voorkeuren voor dienstbiedingen"
	},
	MANAGE_SHIFT_BIDDING: {
		TARGET: "Dienstbiedingen beheren"
	},
	APPROVAL_AND_EXCEPTIONS: {
		TARGET: "Goedkeuring en uitzonderingen"
	},
	SYSTEM_ADMINISTRATION: {
		TARGET: "Systeembeheer"
	},
	STATUS_SUMMARY: {
		TARGET: "Statusoverzicht"
	},
	COWORKER: {
		TARGET: "Collegaplanning"
	},
	TIME_OFF_SUMMARY: {
		TARGET: "Verlofoverzicht"
	},
	LIVE_ATTENDANCE_STATUS: {
		TARGET: "Status live aanwezigheid"
	},
	MY_TIME_OFF_WFS: {
		TARGET: "Mijn verlof WFS"
	},
	DYNAMIC_SCHEDULING: {
		TARGET: "Dynamische planning"
	},
	VIEW_REPORTS_WFS: {
		TARGET: "Planningsrapporten weergeven"
	},
	MESSAGES: {
		TARGET: "Berichten"
	},
	PERSONAL_DATA_SUMMARY: {
		TARGET: "Overzicht persoonlijke gegevens"
	},
	TODAY_PREFERENCES: {
		TARGET: "Voorkeuren voor vandaag"
	},
	SCHEDULE_TEMPLATES: {
		TARGET: "Planningssjablonen"
	},
	MANAGE_TIMESHEET: {
		TARGET: "Urenstaat beheren"
	},
	BUDGETING: {
		TARGET: "Budgettering"
	},
	FORECAST: {
		TARGET: "Voorspelling"
	},
	VIEW_FORECASTS: {
		TARGET: "Voorspellingen"
	},
	TASK_EDITOR: {
		TARGET: "Taken"
	},
	SETTINGS: {
		TARGET: "Instellingen"
	},
	ASSOCIATE_MANAGEMENT: {
		TARGET: "Partnerbeheer"
	},
	MY_INFO: {
		TARGET: "Mijn gegevens"
	},
	SQL_REPORTS: {
		TARGET: "Planningsrapporten"
	},
	ADVANCED_SCHEDULING_REPORTS: {
		TARGET: "Rapporten planning taak Classic"
	},
	MANAGE_TEMPLATES: {
		TARGET: "Sjablonen beheren"
	},
	GROUP_MESSAGING: {
		TARGET: "Groepsberichten"
	},
	MY_TIMESHEETS: {
		TARGET: "Mijn urenstaten"
	},
	FATIGUE_MANAGEMENT: {
		TARGET: "Vermoeidheidsmanagement"
	},
	REVIEW_SWAP_REQUESTS: {
		TARGET: "Ruilaanvragen beoordelen"
	},
	VIEW_REPORTS: {
		TARGET: "Rapporten weergeven"
	},
	ASSIGN_BADGES: {
		TARGET: "Badges toewijzen"
	},
	ANALYTICS_REPORT: {
		TARGET: "Analyserapport"
	},
	KPI_DASHBOARD: {
		TARGET: "KPI-controlepaneel"
	},
	EDIT_EMPLOYEES: {
		TARGET: "Medewerkers bewerken"
	},
	MANUAL_CALLOUT_RULES: {
		TARGET: "Handmatige afroepregels"
	},
	MY_CONTACT_PREFERENCES: {
		TARGET: "Mijn contactvoorkeuren"
	},
	MANAGE_NO_CALL_MODEL_LIST: {
		TARGET: "Niet-oproepmodellijst beheren"
	},
	MANAGE_MODELS: {
		TARGET: "Modellen beheren"
	},
	APPROVE_TIMESHEETS: {
		TARGET: "Urenstaten goedkeuren"
	},
	APPROVE_TIMESHEETS_NEXT_GEN: {
		TARGET: "Urenstaten goedkeuren"
	},
	OVERTIME_TYPE: {
		TARGET: "Type overuren"
	},
	MANAGE_EMPLOYEE_LISTS: {
		TARGET: "Medewerkerlijsten beheren"
	},
	MANAGE_USERS: {
		TARGET: "Gebruikers beheren"
	},
	LINE_ITEM_APPROVAL: {
		TARGET: "Regelitemgoedkeuring"
	},
	EDIT_USER_GROUPS: {
		TARGET: "Gebruikersgroepen bewerken"
	},
	ROTATION_PATTERN_ASSIGNMENT: {
		TARGET: "Toewijzing rotatiepatroon"
	},
	QUALIFICATIONS: {
		TARGET: "Kwalificaties"
	},
	USER_SECURITY_MAINTENANCE: {
		TARGET: "Onderhoud gebruikersbeveiliging"
	},
	ROTATION_PATTERN_MANAGEMENT: {
		TARGET: "Beheer rotatiepatroon"
	},
	EMPLOYEE_SCHEDULE_MANAGEMENT: {
		TARGET: "Medewerkerplanning beheren"
	},
	WEB_CLOCK: {
		TARGET: "WebClock"
	},
	LAUNCH_ADMIN_CLIENT: {
		TARGET: "Beheerclient starten"
	},
	CALLOUT_RESPONSES: {
		TARGET: "Afroepantwoorden"
	},
	MY_SWAP_REQUESTS: {
		TARGET: "Mijn ruilaanvragen"
	},
	COPY_SCHEDULE: {
		TARGET: "Planning kopiëren"
	},
	REASON_CODES: {
		TARGET: "Redencodes"
	},
	DELEGATION_MANAGEMENT: {
		TARGET: "Delegeringsbeheer"
	},
	SHIFTS: {
		TARGET: "Ploegen"
	},
	MY_TIME_OFF: {
		TARGET: "Mijn verlof"
	},
	VIEW_MY_TIME_OFF_REQUESTS: {
		TARGET: "Mijn verlof weergeven"
	},
	RUN_JOB: {
		TARGET: "Taak uitvoeren"
	},
	CREW_PRODUCTION: {
		TARGET: "Teamproductie"
	},
	ASSIGN_SCHEDULES: {
		TARGET: "Planningen toewijzen"
	},
	POLICY_MAPPING_FOR_IMPORTS: {
		TARGET: "Beleidstoewijzing voor importbewerkingen"
	},
	EMPLOYEES: {
		TARGET: "Medewerkers"
	},
	GROUP_CALENDARS: {
		TARGET: "Groepskalenders"
	},
	ADJUST_BANK_BALANCES: {
		TARGET: "Voorraadsaldo's aanpassen"
	},
	ORGANIZATION: {
		TARGET: "Organisatie"
	},
	RECALCULATE_ASSIGNMENT_GROUPS: {
		TARGET: "Opdrachtgroepen opnieuw berekenen"
	},
	MANAGE_STAFFING_REQUIREMENTS: {
		TARGET: "Personeelsvereisten beheren"
	},
	EDIT_PROFILES: {
		TARGET: "Profielen bewerken"
	},
	EMPLOYEE_FILTERS: {
		TARGET: "Medewerkerfilters"
	},
	MODIFY_SCHEDULE: {
		TARGET: "Planning wijzigen"
	},
	BID_PACKAGE_ADMINISTRATION: {
		TARGET: "Biedpakketbeheer"
	},
	MANAGE_GROUPS: {
		TARGET: "Groepen beheren"
	},
	CREATE_GROUPS: {
		TARGET: "Groepen maken"
	},
	IMPORT_DATA: {
		TARGET: "Gegevens importeren"
	},
	JOB_STATUS: {
		TARGET: "Taakstatus"
	},
	ASSIGNMENT_RULES: {
		TARGET: "Toewijzingsregels"
	},
	SCHEDULING_GROUPS: {
		TARGET: "Planningsgroepen"
	},
	EMPLOYEE_CALENDARS: {
		TARGET: "Medewerkerkalenders"
	},
	STATION_MANAGEMENT: {
		TARGET: "Stationsbeheer"
	},
	GROUP_TIME: {
		TARGET: "Urenstaten groep"
	},
	CALLOUT_RULE: {
		TARGET: "Afroepregel"
	},
	DELETE_SCHEDULE: {
		TARGET: "Planning verwijderen"
	},
	LEAVE_SUMMARY: {
		TARGET: "Verlofoverzicht"
	},
	LEAVE_REGULATIONS: {
		TARGET: "Verlofregelingen"
	},
	CHANGE_MY_PASSWORD: {
		TARGET: "Mijn wachtwoord wijzigen"
	},
	MANAGE_GROUP_SCHEDULES: {
		TARGET: "Groepsplanningen beheren"
	},
	MANAGE_ABSENCE_CASES: {
		TARGET: "Afwezigheidsgevallen beheren"
	},
	COMPLIANCE_PORTAL: {
		TARGET: "Nalevingsportaal"
	},
	DISPLAY_ELEMENTS: {
		TARGET: "Weergave-elementen"
	},
	SELECTION_CONSTRAINTS: {
		TARGET: "Selectierandvoorwaarden"
	},
	REVIEW_TIME_OFF_REQUESTS: {
		TARGET: "Verlofaanvragen beoordelen"
	},
	AUTO_SCHEDULE_STAFFING_CRITERIA: {
		TARGET: "Criteria personeelsbezetting automatische planning"
	},
	CALLOUT_TERMINATION_CODE_SETS: {
		TARGET: "Codesets afroep opzegging"
	},
	PERMISSION_SETUP: {
		TARGET: "Rechten instellen"
	},
	SCHEDULE_MAINTENANCE: {
		TARGET: "Planningsonderhoud"
	},
	MODEL_FILTERS: {
		TARGET: "Modelfilters"
	},
	END_OF_PERIOD_PROCESSING: {
		TARGET: "Verwerking aan einde van periode"
	},
	SERVER_ADMINISTRATION: {
		TARGET: "Serverbeheer"
	},
	RUN_AUTO_SCHEDULE: {
		TARGET: "Automatische planning uitvoeren"
	},
	CALLOUT: {
		TARGET: "Afroepen"
	},
	FACILITIES: {
		TARGET: "Faciliteiten"
	},
	SELECTION_PREFERENCES: {
		TARGET: "Selectievoorkeuren"
	},
	"MANAGE_RETRO-CALC_TRIGGERS": {
		TARGET: "Triggers voor berekening met terugwerkende kracht beheren"
	},
	CREW_MAINTENANCE: {
		TARGET: "Teamonderhoud"
	},
	POST_EMPLOYEES: {
		TARGET: "Medewerkers publiceren"
	},
	SCHEDULE_PERIOD: {
		TARGET: "Planningsperiode"
	},
	LUNCH_AND_BREAK: {
		TARGET: "Lunch en pauze"
	},
	EDIT_ASSIGNMENTS: {
		TARGET: "Opdrachten bewerken"
	},
	OVERTIME_AND_COST_CONTROL: {
		TARGET: "Overuren en kostenbeheersing"
	},
	MANAGE_EVENTS: {
		TARGET: "Gebeurtenissen beheren"
	},
	EMPLOYEE_TIME: {
		TARGET: "Urenstaten medewerker"
	},
	EMPLOYEE_NEXT_GEN_TIMESHEETS: {
		TARGET: "Next-Gen-urenstaten medewerkers"
	},
	SCHEDULE_RULE_COPY: {
		TARGET: "Regels kopiëren plannen"
	},
	DEFAULT_LABOR_ALLOCATION: {
		TARGET: "Standaardarbeidstoewijzing beheren"
	},
	MY_DEFAULT_LABOR_ALLOCATION: {
		TARGET: "Mijn standaardarbeidstoewijzing"
	},
	VIEW_ANALYTICS: {
		TARGET: "Analyse bekijken"
	},
	SCHEDULING_UNITS: {
		TARGET: "Planningseenheden"
	},
	AREAS: {
		TARGET: "Gebieden"
	},
	OVERTIME_BANKS: {
		TARGET: "Voorraden overuren"
	},
	PASSWORD_MANAGEMENT: {
		TARGET: "Wachtwoordbeheer"
	},
	WEB_SERVICES_API_DOCUMENTATION: {
		TARGET: "Documentatie webservices-API"
	},
	REQUEST_ACCOMMODATION: {
		TARGET: "Accommodatie aanvragen"
	},
	MY_SCHEDULE: {
		TARGET: "Mijn kalender"
	},
	SCHEDULE_RULE_SWAP: {
		TARGET: "Planning voor regel ruilen"
	},
	MAINTAIN_LOOKUP_TABLES: {
		TARGET: "Opzoektabellen onderhouden"
	},
	EDIT_FIELD_LEVEL_PROFILE: {
		TARGET: "Veldniveauprofiel bewerken"
	},
	LABOR_STANDARDS: {
		TARGET: "Arbeidsnormen"
	},
	HOLIDAY_MAINTENANCE: {
		TARGET: "Feestdagonderhoud"
	},
	MANAGE_EMPLOYEES: {
		TARGET: "Medewerkers beheren"
	},
	SCHEDULE: {
		TARGET: "Planning"
	},
	SHIFT_MANAGEMENT: {
		TARGET: "Dienstbeheer"
	},
	CREW_MANAGEMENT_HELP: {
		TARGET: "Help - teammanagement"
	},
	FATIGUE_MANAGEMENT_HELP: {
		TARGET: "Help - vermoeidheidsmanagement"
	},
	TIME_ATTENDANCE_HELP: {
		TARGET: "Help - tijd"
	},
	ABSENCE_COMPLIANCE_HELP: {
		TARGET: "Help - naleving afwezigheid"
	},
	ADVANCED_SCHEDULER_HELP: {
		TARGET: "Help - klassieke taakplanning"
	},
	SYSTEM_CONFIG: {
		TARGET: "Systeemconfiguratie"
	},
	MY_BIDDING_WTA: {
		TARGET: "Mijn bieding"
	},
	MY_CALENDAR: {
		TARGET: "Mijn kalender"
	},
	TEAM_ABSENCE_CALENDAR: {
		TARGET: "Teamafwezigheidsagenda"
	},
	EMPLOYEE_GROUPS: {
		TARGET: "Medewerkergroepen"
	},
	AS_USER_GROUPS: {
		TARGET: "Gebruikersgroepen klassieke taakplanning"
	},
	AUTOMATIC_CALLOUT_RULES: {
		TARGET: "Automatische afroepregels"
	},
	ADVANCED_SCHEDULER_USERS: {
		TARGET: "Gebruikers klassieke taakplanning"
	},
	WFX: {
		TARGET: "Ervaring openen"
	},
	ML_FORECASTING: {
		TARGET: "Voorspellen"
	},
	WFX_APP: {
		TARGET: "Ervaringsapp"
	},
	CHANNELS: {
		TARGET: "Kanalen"
	},
	BROADCASTS: {
		TARGET: "Uitzendingen"
	},
	TASKS: {
		TARGET: "Taken"
	},
	DOCUMENTS: {
		TARGET: "Documenten"
	},
	WFX_ADMIN: {
		TARGET: "Ervaringsbeheer"
	}
};
var ORGANIZATION_PANEL$2 = {
	TITLE: {
		TARGET: "Aanmelding WorkForce Suite"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "Dit is meestal een afkorting van uw bedrijf. Neem voor hulp contact op met een beheerder."
	},
	INVALID_ACCOUNT: {
		TARGET: "Voer een geldige account in"
	},
	GENERIC_ERROR: {
		TARGET: "Verifiëren niet mogelijk."
	},
	NETWORK_ERROR: {
		TARGET: "Er is een probleem opgetreden, de server is niet bereikbaar. Controleer uw verbinding"
	},
	ACCOUNT: {
		TARGET: "Account"
	},
	BUTTON_NEXT: {
		TARGET: "Volgende"
	},
	SELECT_LANGUAGE: {
		TARGET: "Taal selecteren"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Accountnaam wijzigen"
	},
	CLOSE_SIDEBAR_ARIA_LABEL: {
		TARGET: "Zijbalk sluiten"
	}
};
var NAVIGATION_WARNING$2 = {
	UNSAVED_CHANGES_TEXT: {
		TARGET: "Wilt u op deze pagina blijven om uw wijzigingen op te slaan of wilt u ze verwerpen en doorgaan?"
	},
	UNSAVED_CHANGES_HEADING: {
		TARGET: "Niet-opgeslagen wijzigingen"
	},
	DISCARD: {
		TARGET: "Verwerpen"
	},
	STAY_ON_PAGE: {
		TARGET: "Op deze pagina blijven"
	}
};
var IMPERSONATION_DIALOG$2 = {
	HEADER: {
		TARGET: "Nabootsen"
	},
	BUTTON_CANCEL: {
		TARGET: "Annuleren"
	},
	BUTTON_SUBMIT: {
		TARGET: "Nabootsen"
	},
	HELPER_TEXT: {
		TARGET: "Wilt u een gebruiker nabootsen, selecteer die gebruiker dan in de lijst."
	},
	NO_OPTION: {
		TARGET: "Geen gebruikers gevonden"
	}
};
var IMPERSONATION_INDICATOR$2 = {
	MESSAGE: {
		TARGET: "Nabootsen"
	}
};
var NOTIFICATION_MESSAGES$2 = {
	HUB_CARD_DISMISSED: {
		TARGET: "Hubkaart {{hubCardName}} verwijderd."
	},
	UNDO: {
		TARGET: "Ongedaan maken"
	}
};
var ERROR_PAGE$2 = {
	SORRY: {
		TARGET: "Helaas"
	},
	PAGE_NOT_FOUND: {
		TARGET: "De gezochte pagina is niet gevonden."
	},
	PERMISSION_DENIED: {
		TARGET: "Fout 403: u hebt geen rechten voor deze pagina."
	},
	CONTACT_IT: {
		TARGET: "Neem contact op met uw IT-beheerder voor hulp."
	},
	UNEXPECTED_ERROR: {
		TARGET: "Er is een probleem opgetreden en de service is mogelijk niet beschikbaar. Neem contact op met uw systeembeheerder voor hulp."
	},
	TAKE_ME_HOME: {
		TARGET: "Naar start"
	}
};
var nl_NL = {
	MENU_ITEMS: MENU_ITEMS$2,
	GREETING: GREETING$2,
	RESET_PASSWORD: RESET_PASSWORD$2,
	USER_PREFERENCES: USER_PREFERENCES$2,
	EMPLOYEE_GROUP_FILTERS: EMPLOYEE_GROUP_FILTERS$2,
	NAV_MENU: NAV_MENU$2,
	NAV_LINKS: NAV_LINKS$2,
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$2,
	NAVIGATION_WARNING: NAVIGATION_WARNING$2,
	IMPERSONATION_DIALOG: IMPERSONATION_DIALOG$2,
	IMPERSONATION_INDICATOR: IMPERSONATION_INDICATOR$2,
	NOTIFICATION_MESSAGES: NOTIFICATION_MESSAGES$2,
	ERROR_PAGE: ERROR_PAGE$2
};

var MENU_ITEMS$1 = {
	USER_PREFERENCES: {
		TARGET: "Преференции",
		NOTE: "The header of the user preference page (displayed in title case) where the user can manage its application preferences (language, landing page, etc)."
	}
};
var GREETING$1 = {
	MENU_TITLE: {
		TARGET: "Здраво {{firstname}}",
		NOTE: "A short greeting message (displayed in sentence case) which remains on the user's screen as a label of a button that opens a menu with personal options."
	}
};
var RESET_PASSWORD$1 = {
	HEADING: {
		TARGET: "Ресетирање на лозинката за вработен",
		NOTE: "The header of the modal (displayed in sentence case) used by the user to define a new password."
	},
	DESCRIPTION: {
		TARGET: " Користете го овој формулар за да ресетирате лозинки на вработените. Не заборавајте да запомните ги новите лозинки и споделете ги со нив што е можно побрзо. Овие лозинки се привремени и корисниците ќе треба да ги сменат при следното најавување.",
		NOTE: "Text paragraph (displayed in sentence case) presented in the password reset modal. Provides a brief instruction on how to use the password reset feature."
	},
	CANCEL_BUTTON: {
		TARGET: "Откажи",
		NOTE: "The caption of a button (displayed in Title case) present in the password reset modal. If the user clicks the password reset modal will be closed without applying the changes."
	},
	RESET_BUTTON: {
		TARGET: "Ресетирање на лозинката",
		NOTE: "The caption of a button (displayed in Title case) present in the password reset modal. By clicking the button the user confirms the password reset action."
	},
	RESETTING_BUTTON: {
		TARGET: "Ресетирање на лозинката",
		NOTE: "The caption of the button (displayed in Title case) used by the user to confirm the password reset action. This caption replaces the original one while the application is processing the password reset action. The button is disabled during this processing period."
	},
	PASSWORD_SUCCESS: {
		TARGET: "Лозинката е успешно ресетирана",
		NOTE: "A toast message (displayed in Sentence case) on the password reset modal. It notifies the user that the password was successfully reset."
	},
	MATCH_PASSWORD: {
		TARGET: "Лозинките не се совпаѓаат.",
		NOTE: "Helper text (displayed in Sentence case) displayed below the password confirmation fields in case the password entered in the password fields does not match."
	},
	MINIMUM_REQUIREMENT: {
		TARGET: "Лозинката не ги исполнува минималните барања.",
		NOTE: "Text message (displayed in Sentence case) displayed below the password reset fields and above the action confirmation buttons in case the new password does not meet minimum requirements."
	},
	CONFIRM_PASSWORD: {
		TARGET: "Потврди лозинка",
		NOTE: "Label of a text field input (displayed in Title case) for confirming the new password value (second password field input)."
	},
	ERROR_BLACKLISTED: {
		TARGET: "Оваа лозинка е на црната листа. Ве молиме употребете друга лозинка.",
		NOTE: "Text message (in sentence case) shown below the password fields if the password reset operation failed due to the submission of a blacklisted password."
	},
	ERROR_LENGTH: {
		TARGET: "Лозинката мора да има минимална должина од {{length}}",
		NOTE: "Text message (in sentence case) shown below the password fields if the password reset operation failed because the new password does not meet the minimum length requirement."
	},
	ERROR_REGEX: {
		TARGET: "Лозинката не се совпаѓа со прилагоден regex шаблон.",
		NOTE: "Text message (in sentence case) shown below the password fields if the password reset operation failed because the new password does not meet a specific pattern required for the user's context."
	},
	ERROR_GENERIC: {
		TARGET: "Лозинката {{errorMessage}}",
		NOTE: "Text message (in sentence case) shown below the password fields if the password reset operation failed due to a generic error which description is sent by the Central Authentication Service."
	}
};
var USER_PREFERENCES$1 = {
	BACK_ARROW: {
		TARGET: "Назад",
		NOTE: "Aria-label (used by a screen reader) to tell user that hitting this button will return them to the User Preferences Page"
	},
	LANDING_PAGE: {
		TARGET: "Целна страница",
		NOTE: "The title of the page (displayed in title case) in which the user is able to choose what page will the first page seen by the user right after login. This label is used in case of desktop devices."
	},
	LANGUAGE: {
		TARGET: "Јазик",
		NOTE: "The title of the Language and Localization page (displayed in Title case). It means that the user can configure different locale-specific and regional settings (such as language, date/time formats, etc.) on that page."
	},
	LANGUAGE_AND_LOCALIZATION: {
		TARGET: "Јазик и локализација",
		NOTE: "The user preference tab name of the Language and Localization page (displayed in Title case). It means that the user can configure different locale-specific and regional settings (such as language, date/time formats, etc.) on that page."
	},
	LANGUAGE_AND_LOCALIZATION_TITLE: {
		TARGET: "Јазик и локализација",
		NOTE: "The title of the Language and Localization page (displayed in Title case). It means that the user can configure different locale-specific and regional settings (such as language, date/time formats, etc.) on that page."
	},
	LANGUAGE_AND_LOCALIZATION_SUBTITLE: {
		TARGET: "Изберете ги опциите за јазик и локализација подолу кои ќе се користат за целиот пакет на WorkForce.",
		NOTE: "The subtitle text of the Language and Localization page (displayed in Sentence case). It explains the settings that could be configured by the user on that page."
	},
	TIME_FORMAT_PREFERENCE_TITLE: {
		TARGET: "Преференција за форматот на времето",
		NOTE: "The title of the Time Format Preference section in the Language and Localization page (displayed in Title case). It means that the user can configure its own format setting (current account format setting, 12 hours, 24 hours, etc.)."
	},
	TIME_FORMATTING_ACCOUNT_CONFIG_DEFAULT_LABEL: {
		TARGET: "Поставки на мојата организација",
		NOTE: "The label of the AccountConfigDefault option (displayed in Sentence case). It means that the account configured time format will be used."
	},
	TIME_FORMATTING_ACCOUNT_CONFIG_DEFAULT_DESCRIPTION: {
		TARGET: "Времето ќе се прикажува врз основа на поставката избрана од системскиот администратор.",
		NOTE: "The description of the AccountConfigDefault option (displayed in Sentence case). It means that the account configured time format will be used."
	},
	TIME_FORMATTING_LOCALE_DEFAULT_LABEL: {
		TARGET: "Мојот јазик/формат на локацијата",
		NOTE: "The label of the LocaleDefault option (displayed in Sentence case). It means that the time format will be based on User's selected language. For example: if the current selected language is Australian English it means that Australian time format will be used."
	},
	TIME_FORMATTING_LOCALE_DEFAULT_DESCRIPTION: {
		TARGET: "Времето ќе се заснова врз јазикот/локацијата поврзани со избраниот јазик погоре.",
		NOTE: "The description of the LocaleDefault option (displayed in Sentence case). It means that the time format will be based on User's selected language. For example: if the current selected language is Australian English it means that Australian time format will be used."
	},
	TIME_FORMATTING_FORCE_12_HOURS_LABEL: {
		TARGET: "12-часовен приказ",
		NOTE: "The label of the Force12Hours option (displayed in Sentence case). It means that the time format will be 12 hours (AM/PM)."
	},
	TIME_FORMATTING_FORCE_12_HOURS_DESCRIPTION: {
		TARGET: "Времето ќе се прикажува како 12:00 (AM/PM) без разлика на поставките за јазикот или локацијата вашата организација.",
		NOTE: "The description of the Force12Hours option (displayed in Sentence case). It means that the time format will be 12 hours (AM/PM)."
	},
	TIME_FORMATTING_FORCE_24_HOURS_LABEL: {
		TARGET: "24-часовен приказ",
		NOTE: "The label of the Force24Hours option (displayed in Sentence case). It means that the time format will be 00:00 - 24:00 hours (without AM/PM)."
	},
	TIME_FORMATTING_FORCE_24_HOURS_DESCRIPTION: {
		TARGET: "Времето ќе се прикажува како 00:00 - 24:00 без разлика на поставките за јазикот или локацијата на вашата организација.",
		NOTE: "The description of the Force12Hours option (displayed in Sentence case). It means that the time format will be 00:00 - 24:00 hours (without AM/PM)."
	},
	SETTING_UPDATE_SUCCESS: {
		TARGET: "Поставката е успешно ажурирана.",
		NOTE: "A toast message displayed in Sentence case. It notifies that the current settings has been saved successfully."
	},
	SETTING_UPDATE_FAILED: {
		TARGET: "Поставката не успеа да се ажурира. Ве молам обидете се повторно подоцна.",
		NOTE: "A toast message displayed in Sentence case. It notifies that the current settings couldn't be saved."
	},
	THEME: {
		TARGET: "Тема",
		NOTE: "Label of a select field input (displayed in Title case) used to select the theme (application colors, fonts, etc) to be used on the application."
	},
	THEMES: {
		TARGET: "Теми",
		NOTE: "Title of the page (in title case), shown on desktop devices, where the user is able to choose its preferred theme (application colors, fonts, etc). Used both in header of the page and as description of menu entry in the side menu."
	},
	CHANGE_THEME: {
		TARGET: "Промена на темата",
		NOTE: "Title of the page (in title case), shown on mobile devices, where the user is able to choose its preferred theme (application colors, fonts, etc). Used both in header of the page and as description of menu entry in the side menu."
	},
	CHANGE_LANGUAGE: {
		TARGET: "Промена на јазикот",
		NOTE: "Title of the page (in title case) where the user is able to change application's language. Used as header of the page on mobile devices."
	},
	CHANGE_LANDING_PAGE: {
		TARGET: "Промена на целната страница",
		NOTE: "The title of the page (displayed in title case) in which the user is able to choose what page will the first page seen by the user right after login.  This label is used in case of mobile devices."
	},
	HUB_AND_ASSISTANT_EMPLOYEE_GROUPS: {
		TARGET: "Групи на вработени во центарот и помошниците",
		NOTE: "The label of the side menu entry (displayed in title case) that takes the user to the page where it is possible to select which assistant cards will be available for each employee group."
	},
	SAVE: {
		TARGET: "Зачувај",
		NOTE: "The caption of a button (displayed in title case) displayed in user preferences pages. If the user clicks the button, the changes get saved."
	},
	LANDING_PAGE_DESCRIPTION: {
		TARGET: "Изберете ја страницата што сакате да ја видите кога ќе се најавите во пакетот на WorkForce.",
		NOTE: "A brief helper message (displayed in sentence case) presented on the page where the user is able to choose the landing page for the application. It is positioned right under the page header and helps the user on how to use the page."
	},
	HUB_PAGE: {
		TARGET: "Страница на центарот",
		NOTE: "Text in title case that describes the radio button option for the default choice for landing page (the hub page)."
	},
	CUSTOM: {
		TARGET: "Прилагоди",
		NOTE: "Text in title case that describes the radio button option that enables the user to customize which page will be used as the landing page."
	},
	CUSTOM_LANDING_PAGE: {
		TARGET: "Прилагодена почетна страница",
		NOTE: "Text in title case used as a placeholder for the form field used to select the page that will be used as landing page."
	},
	LANDING_PAGE_RADIO_GROUP_ARIA_LABEL: {
		TARGET: "Изберете дали ќе имате прилагодена целна страница или ќе ја изберете онаа на центарот",
		NOTE: "Accessible name (aria label) for the field (radio button group) used to define the application landing page."
	},
	DISCARD_CHANGES: {
		TARGET: "Отфрли ги промените",
		NOTE: "The caption of a button (displayed in title case) that discards unsaved changes to a user preference. It is presented in the footer of every user preference setting page."
	},
	CHANGES_SAVED: {
		TARGET: "Промените се зачувани",
		NOTE: "The caption of a button (displayed in title case) that saves a user preference setting. It appears as a confirmation"
	}
};
var EMPLOYEE_GROUP_FILTERS$1 = {
	TITLE: {
		TARGET: "Групи на вработени во центарот и помошниците",
		NOTE: "The text header (displayed in title case) in the page where it is possible to select which assistant cards will be available for each employee group (user preference)."
	},
	DESCRIPTION: {
		TARGET: "Изберете која група сакате да ги гледа предметите во центарот и на помошникот",
		NOTE: "Text paragraph (displayed in sentence case) presented in the Hub and Assistant Employee Groups preference page. Provides a brief instruction on how to use the page."
	}
};
var NAV_MENU$1 = {
	BURGER_MENU: {
		TARGET: "Мени за навигација на пакетот",
		NOTE: "Hamburger button that when clicked opens a dropdown with the naviagation items."
	},
	CLOSE_MENU: {
		TARGET: "Затвори го менито за навигација",
		NOTE: "Close button that when clicked closes the navigation menu."
	},
	BACK_ARROW: {
		TARGET: "Назад",
		NOTE: "Aria-label (used by a screen reader) to tell user that hitting this button will return them to the navigation menu."
	},
	ADMIN: {
		TARGET: "Администрација",
		NOTE: "Navigation menu main entry (display in title case) that groups links to most of the admin features.",
		WFX: {
			TARGET: "Искуство",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Experience' feature."
		},
		DEMAND_SCHEDULING: {
			TARGET: "Распоредување на побарувачката",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Demand Scheduling' feature."
		},
		SCHEDULING_EMPLOYEE_ADMIN: {
			TARGET: "Распоредување - Администрација на вработените",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Scheduling Employee' feature."
		},
		SCHEDULING_MODEL_ADMIN: {
			TARGET: "Распоредување - Администрација на модели",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Scheduling Model' feature."
		},
		SCHEDULING_RULE_SETUP: {
			TARGET: "Распоредување - Поставување правила",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Scheduling Rule Setup' feature."
		},
		SCHEDULING_SECURITY_ADMIN: {
			TARGET: "Распоредување - Администрација на безбедноста",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Scheduling Security' feature."
		},
		SCHEDULING_STANDARD_SCHEDULING: {
			TARGET: "Распоредување - Стандардно распоредување",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Standard Scheduling' feature."
		},
		SYSTEM_SETUP: {
			TARGET: "Поставување на системот",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'System Setup' feature."
		},
		TIME_JOB_DATA_MANAGEMENT: {
			TARGET: "Време - Управување со работните места и податоците",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Time - Job Data Management' feature."
		},
		TIME_USER_GROUP_MANAGEMENT: {
			TARGET: "Време - Управување со корисниците и групите",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Time - User and Group Management' feature."
		},
		CLOCKING: {
			TARGET: "Саатница",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Clocking' feature."
		}
	},
	REPORTS: {
		TARGET: "Извештаи",
		NOTE: "Navigation menu main entry (display in title case) that groups links to application reports."
	},
	STAFF: {
		TARGET: "Персонал",
		NOTE: ""
	},
	SUPPORT: {
		TARGET: "Поддршка",
		NOTE: ""
	},
	TIME_OFF: {
		TARGET: "Слободно време",
		NOTE: ""
	},
	TIMESHEET: {
		TARGET: "Табела со работно време",
		NOTE: ""
	},
	SCHEDULE: {
		TARGET: "Распоред",
		NOTE: ""
	},
	FORECAST: {
		TARGET: "Прогноза",
		NOTE: ""
	},
	HELP: {
		TARGET: "Помош",
		NOTE: "Navigation menu main entry (display in title case) that groups links to application help pages."
	},
	WFX: {
		TARGET: "Искуство",
		NOTE: "Navigation menu main entry (display in title case) that groups links to access Workforce Experience features."
	}
};
var NAV_LINKS$1 = {
	PREFERENCES: {
		TARGET: "Преференции",
		NOTE: "The title of a link (displayed in title case) in a navigation menu that takes the user to the page manages its application preferences (language, landing page, etc)."
	},
	IMPERSONATION: {
		TARGET: "Имперсонација",
		NOTE: "Navigation menu entry (in title case) that links to the the impersonation modal dialog. It allows the current user to login the application as another user."
	},
	SIGN_OUT: {
		TARGET: "Одјави се",
		NOTE: "Text label (in title case) for the navigation menu entry that logs the user out of the application after clicked."
	},
	MY_TIMESHEET: {
		TARGET: "Мојата табела со работно време",
		NOTE: ""
	},
	VIEW_PAST_ASSIGNMENTS: {
		TARGET: "Погледнете ги претходните задачи",
		NOTE: ""
	},
	MY_NEXT_GEN_TIMESHEET: {
		TARGET: "Мојата табела со работно време од следната генерација",
		NOTE: ""
	},
	TIME_CLOCK: {
		TARGET: "Часовник",
		NOTE: "Navigation menu label for the Time Clock page. The text is in Title Case."
	},
	PAYROLL_WEEKLY: {
		TARGET: "Платен неделник",
		NOTE: ""
	},
	AVAILABILITY: {
		TARGET: "Достапност",
		NOTE: ""
	},
	MY_ACCOUNT: {
		TARGET: "Мојата сметка",
		NOTE: ""
	},
	AUTO_SCHEDULE: {
		TARGET: "Автоматски распоред",
		NOTE: ""
	},
	MY_SCHEDULE_WFS: {
		TARGET: "Мојот распоред",
		NOTE: ""
	},
	AUTO_SCHEDULE_WFS: {
		TARGET: "Автоматско распоредување",
		NOTE: ""
	},
	TIME_AND_ATTENDANCE: {
		TARGET: "Време и присуство",
		NOTE: ""
	},
	SHIFT_SWAP: {
		TARGET: "Замена на смени",
		NOTE: ""
	},
	AVAILABILITY_TEMPLATE: {
		TARGET: "Шаблон за достапност",
		NOTE: ""
	},
	POINT_OF_SALE_ERRORS: {
		TARGET: "Грешки на местото на продажба",
		NOTE: ""
	},
	SHIFT_BIDDING: {
		TARGET: "Мојата понуда за смени",
		NOTE: ""
	},
	SHIFT_BIDDING_PREFERENCES: {
		TARGET: "Моите преференции за понуда за смени",
		NOTE: ""
	},
	MANAGE_SHIFT_BIDDING: {
		TARGET: "Управување со понудата за смени",
		NOTE: ""
	},
	APPROVAL_AND_EXCEPTIONS: {
		TARGET: "Одобрување и исклучоци",
		NOTE: ""
	},
	SYSTEM_ADMINISTRATION: {
		TARGET: "Администрација на системот",
		NOTE: "The title of a link (displayed in title case) in a navigation menu that takes the user to the System Administration Page"
	},
	CONFIG_AND_SECURITY_CHECK: {
		TARGET: "Конфигурација и безбедносна проверка",
		NOTE: "The title of a link (displayed in title case) in a navigation menu that takes the user to the Configuration and Security Check Page"
	},
	STATUS_SUMMARY: {
		TARGET: "Резиме на статусот",
		NOTE: ""
	},
	COWORKER: {
		TARGET: "Распоред на CoWorker",
		NOTE: ""
	},
	TIME_OFF_SUMMARY: {
		TARGET: "Резиме на времето за одмор",
		NOTE: ""
	},
	LIVE_ATTENDANCE_STATUS: {
		TARGET: "Статус на присуството во живо",
		NOTE: ""
	},
	MY_TIME_OFF_WFS: {
		TARGET: "Моето слободно време на WFS",
		NOTE: ""
	},
	RESET_PASSWORD: {
		TARGET: "Ресетирање на лозинката за вработен",
		NOTE: "The title of a link (displayed in title case) in a navigation menu that takes the user to the Reset Employee Password page"
	},
	DYNAMIC_SCHEDULING: {
		TARGET: "Динамично распоредување",
		NOTE: ""
	},
	VIEW_REPORTS_WFS: {
		TARGET: "Погледнете ги извештаите за распоредување",
		NOTE: ""
	},
	MESSAGES: {
		TARGET: "Пораки",
		NOTE: ""
	},
	PERSONAL_DATA_SUMMARY: {
		TARGET: "Резиме на лични податоци",
		NOTE: ""
	},
	TODAY_PREFERENCES: {
		TARGET: "Денешни преференции",
		NOTE: ""
	},
	SCHEDULE_TEMPLATES: {
		TARGET: "Шаблони за распореди",
		NOTE: ""
	},
	MANAGE_TIMESHEET: {
		TARGET: "Управувај со табелата за работното време",
		NOTE: ""
	},
	BUDGETING: {
		TARGET: "Буџетирање",
		NOTE: ""
	},
	FORECAST: {
		TARGET: "Прогноза",
		NOTE: ""
	},
	VIEW_FORECASTS: {
		TARGET: "Прогнози",
		NOTE: ""
	},
	TASK_EDITOR: {
		TARGET: "Задачи",
		NOTE: ""
	},
	SETTINGS: {
		TARGET: "Поставки",
		NOTE: ""
	},
	ASSOCIATE_MANAGEMENT: {
		TARGET: "Управување со соработниците",
		NOTE: "The title of a link (displayed in title case) in a navigation menu that takes the user to the Associate Management page"
	},
	EMPLOYEE_SETTINGS: {
		TARGET: "Поставки за вработените",
		NOTE: "The title of a link (displayed in title case) in a navigation menu that takes the user to the Employee Settings page"
	},
	MY_INFO: {
		TARGET: "Мои информации",
		NOTE: ""
	},
	SQL_REPORTS: {
		TARGET: "Извештаи за распоредување",
		NOTE: ""
	},
	ADVANCED_SCHEDULING_REPORTS: {
		TARGET: "Извештаи за класично распоредување на работните места",
		NOTE: ""
	},
	MANAGE_TEMPLATES: {
		TARGET: "Управувај со шаблоните",
		NOTE: ""
	},
	GROUP_MESSAGING: {
		TARGET: "Групна порака",
		NOTE: ""
	},
	MY_TIMESHEETS: {
		TARGET: "Моите табели со работно време",
		NOTE: ""
	},
	FATIGUE_MANAGEMENT: {
		TARGET: "Справување со заморот",
		NOTE: ""
	},
	REVIEW_SWAP_REQUESTS: {
		TARGET: "Прегледајте ги барањата за замена",
		NOTE: ""
	},
	VIEW_REPORTS: {
		TARGET: "Погледнете ги извештаите",
		NOTE: ""
	},
	ASSIGN_BADGES: {
		TARGET: "Доделување значки",
		NOTE: ""
	},
	ADMIN_BADGE_MAINTENANCE: {
		TARGET: "Одржување на значките",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Badge Maintenance' feature"
	},
	ANALYTICS_REPORT: {
		TARGET: "Аналитички извештај",
		NOTE: ""
	},
	KPI_DASHBOARD: {
		TARGET: "Контролна табла за KPI",
		NOTE: ""
	},
	EDIT_EMPLOYEES: {
		TARGET: "Податоци за моите вработени",
		NOTE: ""
	},
	MANUAL_CALLOUT_RULES: {
		TARGET: "Правила за мануелно повикување на замена",
		NOTE: ""
	},
	ADMIN_CALLOUT_MANUAL_RULES: {
		TARGET: "Повикување на замена - Правила за мануелно повикување",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Callout - Manual Rules' feature."
	},
	MY_CONTACT_PREFERENCES: {
		TARGET: "Мои преференции за контактите",
		NOTE: ""
	},
	MANAGE_NO_CALL_MODEL_LIST: {
		TARGET: "Управување со листата на модели за исклучувања",
		NOTE: ""
	},
	MANAGE_MODELS: {
		TARGET: "Управување со модели",
		NOTE: ""
	},
	APPROVE_TIMESHEETS: {
		TARGET: "Одобри табели со работно време",
		NOTE: "The navigation link to the classic approval screen, displayed only in desktop as a submenu of Timesheet."
	},
	APPROVE_TIMESHEETS_NEXT_GEN: {
		TARGET: "Одобри табели со работно време",
		NOTE: "The navigation link to the next generation approval screen, displayed only in mobile as a submenu of Timesheet."
	},
	OVERTIME_TYPE: {
		TARGET: "Тип прекувремена работа",
		NOTE: ""
	},
	MANAGE_EMPLOYEE_LISTS: {
		TARGET: "Управување со листите на вработени",
		NOTE: ""
	},
	MANAGE_USERS: {
		TARGET: "Управување со корисниците",
		NOTE: ""
	},
	ADMIN_USERS_DATA: {
		TARGET: "Податоци за корисниците",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Users Data' feature."
	},
	LINE_ITEM_APPROVAL: {
		TARGET: "Одобрување ставки",
		NOTE: ""
	},
	EDIT_USER_GROUPS: {
		TARGET: "Уреди ги корисничките групи",
		NOTE: ""
	},
	ROTATION_PATTERN_ASSIGNMENT: {
		TARGET: "Доделување ротациски шеми",
		NOTE: ""
	},
	QUALIFICATIONS: {
		TARGET: "Квалификации",
		NOTE: ""
	},
	USER_SECURITY_MAINTENANCE: {
		TARGET: "Одржување на безбедноста на корисниците",
		NOTE: ""
	},
	ADMIN_USER_SECURITY_MAINTENANCE: {
		TARGET: "Улоги и безбедност на корисниците",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'User Roles and Security' feature."
	},
	ROTATION_PATTERN_MANAGEMENT: {
		TARGET: "Управување со ротациските шеми",
		NOTE: ""
	},
	EMPLOYEE_SCHEDULE_MANAGEMENT: {
		TARGET: "Управување со распоредот на вработените",
		NOTE: ""
	},
	WEB_CLOCK: {
		TARGET: "Веб-часовник",
		NOTE: ""
	},
	LAUNCH_ADMIN_CLIENT: {
		TARGET: "Стартувај администраторски клиент",
		NOTE: ""
	},
	ADMIN_LAUNCH_ADMIN_CLIENT: {
		TARGET: "Стартувај администраторски клиент на WT&A",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Launch WT&A Admin Client' feature."
	},
	CALLOUT_RESPONSES: {
		TARGET: "Одговори на повиците на замена",
		NOTE: ""
	},
	MY_SWAP_REQUESTS: {
		TARGET: "Моите барања за замена",
		NOTE: ""
	},
	COPY_SCHEDULE: {
		TARGET: "Распоред за копирање",
		NOTE: ""
	},
	REASON_CODES: {
		TARGET: "Кодови за причините",
		NOTE: ""
	},
	DELEGATION_MANAGEMENT: {
		TARGET: "Управување со делегирање",
		NOTE: ""
	},
	ADMIN_DELEGATIONS: {
		TARGET: "Делегации",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Delegations' feature."
	},
	SHIFTS: {
		TARGET: "Смени",
		NOTE: ""
	},
	MY_TIME_OFF: {
		TARGET: "Моето слободно време",
		NOTE: ""
	},
	VIEW_MY_TIME_OFF_REQUESTS: {
		TARGET: "Погледни го моето слободно време",
		NOTE: "Sub-menu title within Time Off hub menu for new employee time off request list screen. It displays in Title case. Allow employees to view their time off requests list on new suite screen."
	},
	RUN_JOB: {
		TARGET: "Изврши ја работата",
		NOTE: ""
	},
	CREW_PRODUCTION: {
		TARGET: "Продукција на екипа",
		NOTE: ""
	},
	ASSIGN_SCHEDULES: {
		TARGET: "Доделување распореди",
		NOTE: ""
	},
	POLICY_MAPPING_FOR_IMPORTS: {
		TARGET: "Мапирање политики за увоз",
		NOTE: ""
	},
	EMPLOYEES: {
		TARGET: "Вработени",
		NOTE: ""
	},
	ADMIN_EMPLOYEES_DATA: {
		TARGET: "Податоци за вработените",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Employees Data' feature."
	},
	GROUP_CALENDARS: {
		TARGET: "Групни календари",
		NOTE: ""
	},
	ADJUST_BANK_BALANCES: {
		TARGET: "Прилагодете ги банкарските салда",
		NOTE: ""
	},
	ORGANIZATION: {
		TARGET: "Организација",
		NOTE: ""
	},
	RECALCULATE_ASSIGNMENT_GROUPS: {
		TARGET: "Пресметајте ги групите за доделување",
		NOTE: ""
	},
	ADMIN_RECALCULATE_EMPLOYEE_GROUPS: {
		TARGET: "Групи на вработени - Пресметај",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Recalculate Employee Groups' feature."
	},
	MANAGE_STAFFING_REQUIREMENTS: {
		TARGET: "Управување со барањата за персонал",
		NOTE: ""
	},
	EDIT_PROFILES: {
		TARGET: "Уреди ги профилите",
		NOTE: ""
	},
	ADMIN_PROFILE_MANAGEMENT: {
		TARGET: "Управување со профилите",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Profile Management' feature."
	},
	EMPLOYEE_FILTERS: {
		TARGET: "Филтри за вработени",
		NOTE: ""
	},
	MODIFY_SCHEDULE: {
		TARGET: "Измени го распоредот",
		NOTE: ""
	},
	BID_PACKAGE_ADMINISTRATION: {
		TARGET: "Администрација на пакет понуди",
		NOTE: ""
	},
	MANAGE_GROUPS: {
		TARGET: "Управување со групи",
		NOTE: ""
	},
	ADMIN_CURRENT_EMPLOYEE_GROUPS: {
		TARGET: "Групи на вработени - Тековни",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Current Employee Groups' feature."
	},
	CREATE_GROUPS: {
		TARGET: "Креирај групи",
		NOTE: ""
	},
	ADMIN_NEW_EMPLOYEE_GROUPS: {
		TARGET: "Групи на вработени - Нови",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'New Employee Group' feature."
	},
	IMPORT_DATA: {
		TARGET: "Податоци за увоз",
		NOTE: ""
	},
	JOB_STATUS: {
		TARGET: "Статус на работата",
		NOTE: ""
	},
	ASSIGNMENT_RULES: {
		TARGET: "Правила за доделување",
		NOTE: ""
	},
	SCHEDULING_GROUPS: {
		TARGET: "Групи за распоредување",
		NOTE: ""
	},
	EMPLOYEE_CALENDARS: {
		TARGET: "Календари на вработените",
		NOTE: ""
	},
	STATION_MANAGEMENT: {
		TARGET: "Управување со станицата",
		NOTE: ""
	},
	GROUP_TIME: {
		TARGET: "Групни табели со работно време",
		NOTE: ""
	},
	CALLOUT_RULE: {
		TARGET: "Правило за повикување на замена",
		NOTE: ""
	},
	DELETE_SCHEDULE: {
		TARGET: "Избриши го распоредот",
		NOTE: ""
	},
	LEAVE_SUMMARY: {
		TARGET: "Резиме на времето за одмор",
		NOTE: "Allows employees to view their annual leave summary on classic Time off request screen."
	},
	LEAVE_REGULATIONS: {
		TARGET: "Правила за времето за одмор",
		NOTE: ""
	},
	CHANGE_MY_PASSWORD: {
		TARGET: "Промени ја лозинката",
		NOTE: ""
	},
	MANAGE_GROUP_SCHEDULES: {
		TARGET: "Управување со групни распореди",
		NOTE: ""
	},
	MANAGE_ABSENCE_CASES: {
		TARGET: "Управување со случаи на отсуство",
		NOTE: ""
	},
	COMPLIANCE_PORTAL: {
		TARGET: "Портал за усогласеност",
		NOTE: ""
	},
	DISPLAY_ELEMENTS: {
		TARGET: "Елементи на екранот",
		NOTE: ""
	},
	SELECTION_CONSTRAINTS: {
		TARGET: "Ограничувања на изборот",
		NOTE: ""
	},
	REVIEW_TIME_OFF_REQUESTS: {
		TARGET: "Прегледајте ги барањата за слободно време",
		NOTE: ""
	},
	AUTO_SCHEDULE_STAFFING_CRITERIA: {
		TARGET: "Критериуми за автоматско распоредување на персоналот",
		NOTE: ""
	},
	ADMIN_AUTO_SCHEDULE_STAFFING_CRITERIA: {
		TARGET: "Критериуми за автоматско распоредување на персоналот",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Autoschedule Staffing Criteria' feature."
	},
	CALLOUT_TERMINATION_CODE_SETS: {
		TARGET: "Групи кодови за отповикување на замената",
		NOTE: ""
	},
	PERMISSION_SETUP: {
		TARGET: "Поставување дозволи",
		NOTE: ""
	},
	SCHEDULE_MAINTENANCE: {
		TARGET: "Одржување на распоредот",
		NOTE: ""
	},
	MODEL_FILTERS: {
		TARGET: "Филтри за модели",
		NOTE: ""
	},
	END_OF_PERIOD_PROCESSING: {
		TARGET: "Обработка на крајот на периодот",
		NOTE: ""
	},
	SERVER_ADMINISTRATION: {
		TARGET: "Администрација на сервери",
		NOTE: ""
	},
	RUN_AUTO_SCHEDULE: {
		TARGET: "Изврши автоматско распоредување",
		NOTE: ""
	},
	CALLOUT: {
		TARGET: "Повик на замена",
		NOTE: ""
	},
	FACILITIES: {
		TARGET: "Објекти",
		NOTE: ""
	},
	SELECTION_PREFERENCES: {
		TARGET: "Преференции за избор",
		NOTE: ""
	},
	"MANAGE_RETRO-CALC_TRIGGERS": {
		TARGET: "Управување со активациите на ретроактивни пресметки",
		NOTE: ""
	},
	"ADMIN_RETRO-CALC_TRIGGERS": {
		TARGET: "Активации на ретроактивни пресметки",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Retro-calc Triggers' feature."
	},
	CREW_MAINTENANCE: {
		TARGET: "Одржување на екипажот",
		NOTE: ""
	},
	POST_EMPLOYEES: {
		TARGET: "Вработени на позицијата",
		NOTE: ""
	},
	SCHEDULE_PERIOD: {
		TARGET: "Направи распоред за периодот",
		NOTE: ""
	},
	LUNCH_AND_BREAK: {
		TARGET: "Ручек и пауза",
		NOTE: ""
	},
	ADMIN_LUNCH_AND_BREAK: {
		TARGET: "Ручек и пауза",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Lunch & Break' feature."
	},
	EDIT_ASSIGNMENTS: {
		TARGET: "Уреди ги задачите",
		NOTE: ""
	},
	ADMIN_ASSIGNMENT_DATA: {
		TARGET: "Податоци за доделувањето",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Assignment Data' feature."
	},
	OVERTIME_AND_COST_CONTROL: {
		TARGET: "Контрола на прекувремената работа и трошоците",
		NOTE: ""
	},
	ADMIN_OVERTIME_AND_COST_CONTROL: {
		TARGET: "Контрола на прекувремената работа и трошоците",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Overtime & Cost Control' feature."
	},
	MANAGE_EVENTS: {
		TARGET: "Управување со настани",
		NOTE: ""
	},
	EMPLOYEE_TIME: {
		TARGET: "Табели со работното време на вработените",
		NOTE: ""
	},
	EMPLOYEE_NEXT_GEN_TIMESHEETS: {
		TARGET: "Табели со работното време на вработените од следната генерација",
		NOTE: ""
	},
	SCHEDULE_RULE_COPY: {
		TARGET: "Копија на правилото за распоредување",
		NOTE: ""
	},
	DEFAULT_LABOR_ALLOCATION: {
		TARGET: "Управување со стандардната распределба на работната сила",
		NOTE: ""
	},
	MY_DEFAULT_LABOR_ALLOCATION: {
		TARGET: "Мојата стандардна распределба на работната сила",
		NOTE: ""
	},
	VIEW_ANALYTICS: {
		TARGET: "Погледни аналитика",
		NOTE: ""
	},
	SCHEDULING_UNITS: {
		TARGET: "Единици за распоредување",
		NOTE: ""
	},
	AREAS: {
		TARGET: "Области",
		NOTE: ""
	},
	OVERTIME_BANKS: {
		TARGET: "Фонд за прекувремени часови",
		NOTE: ""
	},
	PASSWORD_MANAGEMENT: {
		TARGET: "Управување со лозинки",
		NOTE: ""
	},
	WEB_SERVICES_API_DOCUMENTATION: {
		TARGET: "Документација за API за веб услуги",
		NOTE: ""
	},
	REQUEST_ACCOMMODATION: {
		TARGET: "Побарај сместување",
		NOTE: ""
	},
	MY_SCHEDULE: {
		TARGET: "Мојот календар",
		NOTE: ""
	},
	SCHEDULE_RULE_SWAP: {
		TARGET: "Замена на правилата за распоред",
		NOTE: ""
	},
	MAINTAIN_LOOKUP_TABLES: {
		TARGET: "Одржување на табелите за пребарување",
		NOTE: ""
	},
	ADMIN_LOOKUP_TABLES: {
		TARGET: "Табели за пребарување",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Lookup Tables' feature."
	},
	ADMIN_SCHEDULE_RULE_SWAP: {
		TARGET: "Замена на правилата за распоред",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Schedule Rule Swap' feature."
	},
	EDIT_FIELD_LEVEL_PROFILE: {
		TARGET: "Уреди го профилот на ниво на поле",
		NOTE: ""
	},
	LABOR_STANDARDS: {
		TARGET: "Работни стандарди",
		NOTE: ""
	},
	HOLIDAY_MAINTENANCE: {
		TARGET: "Одржување на времето за празниците",
		NOTE: ""
	},
	ADMIN_HOLIDAY_DATES: {
		TARGET: "Празнични датуми",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Holiday Dates' feature."
	},
	MANAGE_EMPLOYEES: {
		TARGET: "Управување со вработените",
		NOTE: ""
	},
	SCHEDULE: {
		TARGET: "Распоред",
		NOTE: ""
	},
	SCHEDULE_EDITOR: {
		TARGET: "Уредник на распоредот",
		NOTE: ""
	},
	SHIFT_MANAGEMENT: {
		TARGET: "Управување со смените",
		NOTE: ""
	},
	CREW_MANAGEMENT_HELP: {
		TARGET: "Помош - Управување со екипите",
		NOTE: ""
	},
	FATIGUE_MANAGEMENT_HELP: {
		TARGET: "Помош - Справување со замор",
		NOTE: ""
	},
	TIME_ATTENDANCE_HELP: {
		TARGET: "Помош - Време",
		NOTE: ""
	},
	ABSENCE_COMPLIANCE_HELP: {
		TARGET: "Помош - Усогласеност на отсуството",
		NOTE: ""
	},
	ADVANCED_SCHEDULER_HELP: {
		TARGET: "Помош - Класично распоредување на работните места",
		NOTE: ""
	},
	SYSTEM_CONFIG: {
		TARGET: "Конфигурација на системот",
		NOTE: ""
	},
	ADMIN_SUITE_CONFIG: {
		TARGET: "Конфигурација на пакетот",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Suite Configuration' feature."
	},
	ADMIN_EMPLOYEE_GROUPS: {
		TARGET: "Групи на вработени",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Employee Groups' feature."
	},
	MY_BIDDING_WTA: {
		TARGET: "Мојата понуда",
		NOTE: ""
	},
	MY_CALENDAR: {
		TARGET: "Мојот календар",
		NOTE: ""
	},
	TEAM_ABSENCE_CALENDAR: {
		TARGET: "Календар на отсуство на тимови",
		NOTE: "Navigation menu label for the Team Absence Calendar page. The text is in Title Case."
	},
	EMPLOYEE_GROUPS: {
		TARGET: "Групи на вработени",
		NOTE: ""
	},
	AS_USER_GROUPS: {
		TARGET: "Кориснички групи за класично распоредување на работните места",
		NOTE: ""
	},
	ADMIN_AS_USER_GROUPS: {
		TARGET: "Групи",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Groups' feature."
	},
	AUTOMATIC_CALLOUT_RULES: {
		TARGET: "Правила за автоматско повикување на замена",
		NOTE: ""
	},
	ADMIN_CALLOUT_AUTOMATIC_RULES: {
		TARGET: "Повик на замена - Автоматски правила",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Callout - Automatic Rules' feature."
	},
	ADVANCED_SCHEDULER_USERS: {
		TARGET: "Корисници на класичното распоредување на работните места",
		NOTE: ""
	},
	ADMIN_ADVANCED_SCHEDULER_USERS: {
		TARGET: "Корисници",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Users' feature."
	},
	WFX: {
		TARGET: "Отворено искуство",
		NOTE: ""
	},
	LOCATIONS: {
		TARGET: "Локации",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Locations' feature."
	},
	ORGANIZATION_SETTINGS: {
		TARGET: "Организациски поставки",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Organization Settings' feature."
	},
	SYNC: {
		TARGET: "Синхронизирај",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Sync' feature."
	},
	USERS: {
		TARGET: "Корисници",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Users' feature."
	},
	USER_LISTS: {
		TARGET: "Листи на корисници",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'User List' feature."
	},
	ML_FORECASTING: {
		TARGET: "Прогнозирање",
		NOTE: "Navigation menu label to take the user to the Forecasting page."
	},
	WFX_APP: {
		TARGET: "Апликација за искуството",
		NOTE: "Navigation menu label (displayed in Title case) in the Experience dropdown to take the user to the experience standalone app in a seperate tab."
	},
	CHANNELS: {
		TARGET: "Канали",
		NOTE: "Navigation menu label (displayed in Title case) in the Experience dropdown to take the user to the Experience Channels page"
	},
	BROADCASTS: {
		TARGET: "Емитувања",
		NOTE: "Navigation menu label (displayed in Title case) in the Experience dropdown to take the user to the Experience Broadcasts page"
	},
	TASKS: {
		TARGET: "Задачи",
		NOTE: "Navigation menu label (displayed in Title case) in the Experience dropdown to take the user to the Experience Tasks page."
	},
	DOCUMENTS: {
		TARGET: "Документи",
		NOTE: "Navigation menu label (displayed in Title case) in the Experience dropdown to take the user to the Experience Documents page."
	},
	WFX_ADMIN: {
		TARGET: "Администраторско искуство",
		NOTE: "Navigation menu label (displayed in Title case) in the Admin dropdown to take the user to Experience Admin page."
	},
	ADMIN_MENU_HELP_LINK: {
		TARGET: "Видете што има ново",
		NOTE: "this links to a navigation link that contains a document detailing the recent changes to the admin navigation organization"
	},
	VISIER_ANALYTICS: {
		TARGET: "Подобрена аналитика",
		NOTE: "This links to a navigation option for accessing the features of the external Visier Analytics tool."
	}
};
var ORGANIZATION_PANEL$1 = {
	TITLE: {
		TARGET: "Најава во пакетот на WorkForce",
		NOTE: "this is the heading (displayed in Title case) for the login screen"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "Обично ова е кратка скратеница за вашата компанија. За помош, контактирајте со администратор.",
		NOTE: "this is text (displayed in Sentence case) appearing underneath the textbox for account name where the user types in whatever their account name is"
	},
	INVALID_ACCOUNT: {
		TARGET: "Внесете важечка сметка",
		NOTE: "this is a message (displayed in Sentence case) that appears when you enter an account that doesn't exist"
	},
	GENERIC_ERROR: {
		TARGET: "Не можеше да се потврди автентикација",
		NOTE: "this is a message (displayed in Sentence case) that appears when the user can't authenticate"
	},
	NETWORK_ERROR: {
		TARGET: "Имаше проблем со пристапот до серверот. Ве молиме проверете ја вашата врска",
		NOTE: "this is a message (displayed in Sentence case) that appears to the user when there's a network error when trying to login on the page"
	},
	ACCOUNT: {
		TARGET: "Сметка",
		NOTE: "this is for the orginazation account that the user is logging into"
	},
	BUTTON_NEXT: {
		TARGET: "Следно",
		NOTE: "this is the next button that is clicked so the user can navigate to the next step of logging in"
	},
	SELECT_LANGUAGE: {
		TARGET: "Избор на јазик",
		NOTE: "this is a button (displayed in Title case) that when clicked will present the user with other languages to select"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Промена на името на сметката",
		NOTE: "Aria label for the edit account icon for voiceover"
	},
	CLOSE_SIDEBAR_ARIA_LABEL: {
		TARGET: "Затвори",
		NOTE: "Aria label for button that closes the right sidebar (drawer)"
	},
	SKIP_NAVIGATION: {
		TARGET: "Прескокни навигација",
		NOTE: "this is a skip navigation button that when user click on this button will navigate to main content"
	}
};
var NAVIGATION_WARNING$1 = {
	UNSAVED_CHANGES_TEXT: {
		TARGET: "Дали сакате да останете на оваа страница за да ги зачувате промените или да ги отфрлите и да продолжите?",
		NOTE: "this text (displayed in Sentence case) is on an alert popup that pops up when a user tries to navigate off a page with unsaved changes"
	},
	UNSAVED_CHANGES_HEADING: {
		TARGET: "Незачувани промени",
		NOTE: "This is the heading (displayed in Title case) that occurs in a popup to tell the user that they have unsaved changes"
	},
	DISCARD: {
		TARGET: "Отфрли",
		NOTE: "this is a button that the user can click to discard their unsaved changes and navigate off the page"
	},
	STAY_ON_PAGE: {
		TARGET: "Останете на страницата",
		NOTE: "this is a button (displayed in Sentence case) that the user can click if they want to stay on the page instead of navigating off of it"
	}
};
var IMPERSONATION_DIALOG$1 = {
	HEADER: {
		TARGET: "Имперсонација",
		NOTE: "header of the impersonate dialog where you choose a user to impersonate"
	},
	BUTTON_CANCEL: {
		TARGET: "Откажи",
		NOTE: "cancel button in impersonate dialog"
	},
	BUTTON_SUBMIT: {
		TARGET: "Имперсонација",
		NOTE: "the button in dialoge when you want to confirm that you want to impersonate the user you selected"
	},
	HELPER_TEXT: {
		TARGET: "За да имперсонирате корисник, ве молиме изберете го корисникот од листата.",
		NOTE: "text (displayed in Sentence case) above a dropdown where you choose which user you would like to impersonate"
	},
	NO_OPTION: {
		TARGET: "Нема пронајдени корисници",
		NOTE: "shows in dropdown (displayed in Sentence case) when there's no user found that you can impersonate"
	}
};
var IMPERSONATION_INDICATOR$1 = {
	MESSAGE: {
		TARGET: "Имперсонирање",
		NOTE: "Text that appears in app to indicate you're impersonating someone like this 'Impersonating {name of person you are impersonatin}'"
	}
};
var NOTIFICATION_MESSAGES$1 = {
	HUB_CARD_DISMISSED: {
		TARGET: "{{hubCardName}} Картичката за центарот е отстранета.",
		NOTE: "notification generated (displayed in Title case) by app when a hub card is dismissed by user"
	},
	UNDO: {
		TARGET: "Поништи",
		NOTE: "This text appears on the dismissal notification and when clicked will undo the dissimal of a notification"
	}
};
var ERROR_PAGE$1 = {
	SORRY: {
		TARGET: "Извинете",
		NOTE: "This is hover text for the sorry image that appears when an error has occured"
	},
	PAGE_NOT_FOUND: {
		TARGET: "Страницата што ја баравте не е најдена.",
		NOTE: "This text (displayed in Sentence case) is on a error page to indicate that the page the user tried to navigate to couldn't be found"
	},
	PERMISSION_DENIED: {
		TARGET: "Грешка 403 - Немате дозволи за оваа страница.",
		NOTE: "This appears (displayed in Sentence case) on the error page when the user doesn't have permissions to navigate to that specific page"
	},
	CONTACT_IT: {
		TARGET: "Ве молиме контактирајте го вашиот ИТ администратор за понатамошна помош.",
		NOTE: "This text (displayed in Sentence case) is used on an error page to inform the user to contact IT admin to figure out why there was an error"
	},
	UNEXPECTED_ERROR: {
		TARGET: "Се соочивме со проблем и услугата може да не биде достапна. Контактирајте со вашиот администратор за помош.",
		NOTE: "this is the message (displayed in Sentence case) displayed on the page when an unexpected error occurs in the app"
	},
	TAKE_ME_HOME: {
		TARGET: "Однеси ме дома",
		NOTE: "This is the text (displayed in Sentence case) on a link that when clicked brings the user back to the main screen of app"
	}
};
var GRAPHQL_ERROR_DIALOG = {
	ACTION: {
		CLOSE: {
			TARGET: "Затвори",
			NOTE: "The caption of a button displayed in multiple places. If the button is clicked, the dialog closes. It means that the user has read the text in the dialog and accepts it."
		}
	},
	FAILED_TO_CONNECT: {
		TITLE: {
			TARGET: "Неуспешно поврзување со услугата",
			NOTE: "The title of the Error Dialog (displayed in Title case). Has the server is not responded."
		},
		SERVICE_NAME: {
			TARGET: "Неуспешно поврзување со {{serviceName}} услугата.",
			NOTE: "This is a service name message (displayed in Sentence case) when a particular service is failed."
		},
		DESCRIPTION: {
			TARGET: "Ако оваа порака продолжи да се јавува, забележете го името на услугата погоре и контактирајте со вашиот системски администратор.",
			NOTE: "This is a message (displayed in Sentence case) when a particular service is failed."
		}
	},
	TIME_OUT: {
		TITLE: {
			TARGET: "Услугата истече",
			NOTE: "The title of the Error Dialog (displayed in Title case). Has the server is not responded."
		},
		SERVICE_NAME: {
			TARGET: "Услугата {{serviceName}} не дава одговор.",
			NOTE: "This is a service name message (displayed in Sentence case) when a particular service is failed."
		},
		DESCRIPTION: {
			TARGET: "Ако оваа порака продолжи да се јавува, забележете го името на услугата погоре и контактирајте со вашиот системски администратор.",
			NOTE: "This is a message (displayed in Sentence case) when a particular service is failed."
		}
	},
	INCORRECT_RESPONSE: {
		TITLE: {
			TARGET: "Услугата даде неточен одговор",
			NOTE: "The title of the Error Dialog (displayed in Title case). Has the server is not responded."
		},
		SERVICE_NAME: {
			TARGET: "Услугата {{serviceName}} одговори со следната грешка;",
			NOTE: "This is a service name message (displayed in Sentence case) when a particular service is failed."
		},
		HTTP_STATUS_CODE: {
			TARGET: "Код за статусот на HTTP: {{statusCode}}",
			NOTE: ""
		},
		DESCRIPTION: {
			TARGET: "Ако оваа порака продолжи да се јавува, забележете ги името на услугата и кодот за грешка на HTTP погоре и контактирајте со вашиот системски администратор.",
			NOTE: "This is a message (displayed in Sentence case) when a particular service is failed."
		}
	},
	INTERNAL_SERVER_ERROR: {
		TITLE: {
			TARGET: "Услугата одговори со грешка",
			NOTE: "The title of the Error Dialog (displayed in Title case). Has the server is not responded."
		},
		SERVICE_NAME: {
			TARGET: "Услугата {{serviceName}} одговори со следната грешка;",
			NOTE: "This is a service name message (displayed in Sentence case) when a particular service is failed."
		},
		DESCRIPTION: {
			TARGET: "Ако оваа порака продолжи да се јавува, забележете ги името на услугата и кодот за грешка погоре и контактирајте со вашиот системски администратор.",
			NOTE: "This is a message (displayed in Sentence case) when a particular service is failed."
		}
	},
	INTERNAL_SERVER_ERROR_WITHOUT_ERROR_ID: {
		SERVICE_NAME: {
			TARGET: "{{serviceName}} наиде на неочекувана грешка и во моментов не можеме да го следиме проблемот;",
			NOTE: "This message is shown when the service encounters an error but no error ID is available."
		},
		DESCRIPTION: {
			TARGET: "Ако оваа порака продолжи да се јавува, забележете го името на услугата и контактирајте со вашиот системски администратор.",
			NOTE: "This is a message (displayed in Sentence case) when a particular service is failed."
		}
	}
};
var PIN$1 = {
	CREATE_PIN: {
		TARGET: "Креирајте ПИН",
		NOTE: "The title for create PIN screen"
	},
	WELCOME_BACK: {
		TARGET: "Добредојдовте назад",
		NOTE: "The title for created PIN flow"
	},
	ENTER_YOUR_PIN: {
		TARGET: "Внесете го вашиот ПИН",
		NOTE: "Label indicating the user can type a PIN number."
	},
	CONFIRM_YOUR_PIN: {
		TARGET: "Потврдете го вашиот ПИН",
		NOTE: "Label indicating the user needs to confirm a PIN number."
	},
	YOUR_ACCOUNT_REQUIRES_PIN: {
		TARGET: "Вашата сметка бара нумерички ПИН.",
		NOTE: "Modal description label indicating the user needs to set a PIN number."
	},
	MORE_DETAILS_MODAL: {
		MORE_DETAILS: {
			TARGET: "Повеќе детали",
			NOTE: "Button label to open more details modal."
		},
		DESCRIPTION: {
			TARGET: "Вашиот ПИН е потребен за повторен пристап до активната сесија (на пр., сте ја минимизирале апликацијата додека сте биле најавени)",
			NOTE: "More details modal description"
		},
		INFO_SWITCH_USERS: {
			TARGET: "Може да смените корисници ако сесијата е активна (на пр. споделување уред)",
			NOTE: "More details modal description"
		},
		INFO_PIN_ATTEMPTS: {
			TARGET: "Ако не го внесете вашиот ПИН правилно при три обиди, ќе ви биде побарано да креирате нов ПИН",
			NOTE: "More details modal description"
		},
		INFO_FORGOT_PIN: {
			TARGET: "Ако сте го заборавиле ПИН-от, може да направите нов, а тековниот ќе истече",
			NOTE: "More details modal description"
		}
	},
	BACK: {
		TARGET: "Назад",
		NOTE: "Button label to go back to PIN creation screen"
	},
	PIN_DID_NOT_MATCH: {
		TARGET: "Внесениот ПИН не се совпадна",
		NOTE: "Hint text to help the user"
	},
	ENTER_CREATED_PIN: {
		TARGET: "Ќе треба да го внесете вашиот ПИН за повторно да добиете пристап до вашата тековна сесија.",
		NOTE: "Instructions for accessing the current session"
	},
	SWITCH_USER: {
		TARGET: "Промена на корисник",
		NOTE: "Text for switch user button"
	},
	USER_WILL_BE_LOGGED_OUT: {
		TARGET: "Со потврда, тековниот корисник ќе биде одјавен и ќе ви биде побарано да се најавите.",
		NOTE: "Switch user modal description"
	},
	INCORRECT_PIN: {
		TARGET: "Погрешен ПИН. {{numAttempts}} обиди остануваат.",
		NOTE: "Text to inform pin attempts left"
	},
	INCORRECT_PIN_FINAL_ATTEMPT: {
		TARGET: "Погрешен ПИН. Останува {{numAttempts}} обид.",
		NOTE: "Text to inform only one pin attempts left"
	},
	INCORRECT_PIN_TITLE: {
		TARGET: "Неточен ПИН",
		NOTE: "Modal title"
	},
	INCORRECT_PIN_DESCRIPTION: {
		TARGET: "Бројот на обидите да го внесете вашиот ПИН правилно го надминаа доделениот износ.",
		NOTE: "Modal content"
	},
	INCORRECT_PIN_TEXT: {
		TARGET: "Вашиот ПИН сега е истечен и ќе ви биде побарано да креирате нов ПИН откако ќе се најавите.",
		NOTE: "Modal content"
	},
	I_UNDERSTAND: {
		TARGET: "Разбирам",
		NOTE: "Modal button"
	},
	FORGOT_PIN: {
		TARGET: "Го заборавив ПИН-от",
		NOTE: "Forgot PIN button"
	},
	CREATE_NEW_PIN: {
		TARGET: "Со потврда, вашиот тековен ПИН ќе истече и ќе бидете одјавени. Откако ќе се највите, ќе ви биде побарано да креирате нов ПИН.",
		NOTE: "Forgot PIN modal description"
	},
	CONFIRM: {
		TARGET: "Потврди",
		NOTE: "Confirm button"
	}
};
var SESSION_INACTIVITY$1 = {
	WARNING_DIALOG: {
		LOG_OUT: {
			TARGET: "Одјави се",
			NOTE: "Dialog button to logout the user"
		},
		I_AM_STILL_HERE: {
			TARGET: "Сè уште сум тука",
			NOTE: "Dialog button to confirm that user is still using the app"
		},
		TITLE: {
			TARGET: "Истекување на времето на сесијата",
			NOTE: "Dialog title"
		},
		DESCRIPTION: {
			TARGET: "Бевте неактивни подолг период. Ќе бидете автоматски одјавени по 5 минути и незачуваните податоци може да се изгубат. Сè уште сте тука?",
			NOTE: "Dialog description"
		}
	},
	LOGOUT_ALERT: {
		TARGET: "Бевте одјавени од претходната сесија поради неактивност.",
		NOTE: "An alert text to notify the user that they have been logged out due to inactivity."
	}
};
var mk_MK = {
	MENU_ITEMS: MENU_ITEMS$1,
	GREETING: GREETING$1,
	RESET_PASSWORD: RESET_PASSWORD$1,
	USER_PREFERENCES: USER_PREFERENCES$1,
	EMPLOYEE_GROUP_FILTERS: EMPLOYEE_GROUP_FILTERS$1,
	NAV_MENU: NAV_MENU$1,
	NAV_LINKS: NAV_LINKS$1,
	ORGANIZATION_PANEL: ORGANIZATION_PANEL$1,
	NAVIGATION_WARNING: NAVIGATION_WARNING$1,
	IMPERSONATION_DIALOG: IMPERSONATION_DIALOG$1,
	IMPERSONATION_INDICATOR: IMPERSONATION_INDICATOR$1,
	NOTIFICATION_MESSAGES: NOTIFICATION_MESSAGES$1,
	ERROR_PAGE: ERROR_PAGE$1,
	GRAPHQL_ERROR_DIALOG: GRAPHQL_ERROR_DIALOG,
	PIN: PIN$1,
	SESSION_INACTIVITY: SESSION_INACTIVITY$1
};

var MENU_ITEMS = {
	USER_PREFERENCES: {
		TARGET: "Postavke",
		NOTE: "The header of the user preference page (displayed in title case) where the user can manage its application preferences (language, landing page, etc)."
	}
};
var GREETING = {
	MENU_TITLE: {
		TARGET: "Zdravo, {{firstname}}",
		NOTE: "A short greeting message (displayed in sentence case) which remains on the user's screen as a label of a button that opens a menu with personal options."
	}
};
var RESET_PASSWORD = {
	HEADING: {
		TARGET: "Resetujte lozinku zaposlenog",
		NOTE: "The header of the modal (displayed in sentence case) used by the user to define a new password."
	},
	DESCRIPTION: {
		TARGET: " Koristite ovaj obrazac za resetovanje lozinke zaposlenog. Obavezno zapamtite novu lozinku i podelite je s njim što je pre moguće. Ova lozinka je privremena i korisnik će morati da je promeni prilikom sledećeg prijavljivanja.",
		NOTE: "Text paragraph (displayed in sentence case) presented in the password reset modal. Provides a brief instruction on how to use the password reset feature."
	},
	CANCEL_BUTTON: {
		TARGET: "Otkaži",
		NOTE: "The caption of a button (displayed in Title case) present in the password reset modal. If the user clicks the password reset modal will be closed without applying the changes."
	},
	RESET_BUTTON: {
		TARGET: "Resetuj lozinku",
		NOTE: "The caption of a button (displayed in Title case) present in the password reset modal. By clicking the button the user confirms the password reset action."
	},
	RESETTING_BUTTON: {
		TARGET: "Resetovanje lozinke",
		NOTE: "The caption of the button (displayed in Title case) used by the user to confirm the password reset action. This caption replaces the original one while the application is processing the password reset action. The button is disabled during this processing period."
	},
	PASSWORD_SUCCESS: {
		TARGET: "Lozinka je uspešno resetovana",
		NOTE: "A toast message (displayed in Sentence case) on the password reset modal. It notifies the user that the password was successfully reset."
	},
	MATCH_PASSWORD: {
		TARGET: "Lozinke se ne podudaraju.",
		NOTE: "Helper text (displayed in Sentence case) displayed below the password confirmation fields in case the password entered in the password fields does not match."
	},
	MINIMUM_REQUIREMENT: {
		TARGET: "Lozinka ne ispunjava minimalne uslove.",
		NOTE: "Text message (displayed in Sentence case) displayed below the password reset fields and above the action confirmation buttons in case the new password does not meet minimum requirements."
	},
	CONFIRM_PASSWORD: {
		TARGET: "Potvrdite lozinku",
		NOTE: "Label of a text field input (displayed in Title case) for confirming the new password value (second password field input)."
	},
	ERROR_BLACKLISTED: {
		TARGET: "Ova lozinka je na crnoj listi. Koristite drugu lozinku.",
		NOTE: "Text message (in sentence case) shown below the password fields if the password reset operation failed due to the submission of a blacklisted password."
	},
	ERROR_LENGTH: {
		TARGET: "Minimalna dužina lozinke je {{length}}",
		NOTE: "Text message (in sentence case) shown below the password fields if the password reset operation failed because the new password does not meet the minimum length requirement."
	},
	ERROR_REGEX: {
		TARGET: "Lozinka ne odgovara prilagođenom regex obrascu.",
		NOTE: "Text message (in sentence case) shown below the password fields if the password reset operation failed because the new password does not meet a specific pattern required for the user's context."
	},
	ERROR_GENERIC: {
		TARGET: "Lozinka {{errorMessage}}",
		NOTE: "Text message (in sentence case) shown below the password fields if the password reset operation failed due to a generic error which description is sent by the Central Authentication Service."
	}
};
var USER_PREFERENCES = {
	BACK_ARROW: {
		TARGET: "Nazad",
		NOTE: "Aria-label (used by a screen reader) to tell user that hitting this button will return them to the User Preferences Page"
	},
	LANDING_PAGE: {
		TARGET: "Odredišna stranica",
		NOTE: "The title of the page (displayed in title case) in which the user is able to choose what page will the first page seen by the user right after login. This label is used in case of desktop devices."
	},
	LANGUAGE: {
		TARGET: "Jezik",
		NOTE: "The title of the Language and Localization page (displayed in Title case). It means that the user can configure different locale-specific and regional settings (such as language, date/time formats, etc.) on that page."
	},
	LANGUAGE_AND_LOCALIZATION: {
		TARGET: "Jezik i lokalizacija",
		NOTE: "The user preference tab name of the Language and Localization page (displayed in Title case). It means that the user can configure different locale-specific and regional settings (such as language, date/time formats, etc.) on that page."
	},
	LANGUAGE_AND_LOCALIZATION_TITLE: {
		TARGET: "Jezik i lokalizacija",
		NOTE: "The title of the Language and Localization page (displayed in Title case). It means that the user can configure different locale-specific and regional settings (such as language, date/time formats, etc.) on that page."
	},
	LANGUAGE_AND_LOCALIZATION_SUBTITLE: {
		TARGET: "Izaberite jezik i opcije lokalizacije u nastavku koje ćete koristiti u celom sistemu WorkForce Suite.",
		NOTE: "The subtitle text of the Language and Localization page (displayed in Sentence case). It explains the settings that could be configured by the user on that page."
	},
	TIME_FORMAT_PREFERENCE_TITLE: {
		TARGET: "Podešavanje formata vremena",
		NOTE: "The title of the Time Format Preference section in the Language and Localization page (displayed in Title case). It means that the user can configure its own format setting (current account format setting, 12 hours, 24 hours, etc.)."
	},
	TIME_FORMATTING_ACCOUNT_CONFIG_DEFAULT_LABEL: {
		TARGET: "Podešavanja moje organizacije",
		NOTE: "The label of the AccountConfigDefault option (displayed in Sentence case). It means that the account configured time format will be used."
	},
	TIME_FORMATTING_ACCOUNT_CONFIG_DEFAULT_DESCRIPTION: {
		TARGET: "Vreme će se prikazati na osnovu podešavanja koje je izabrao administrator sistema.",
		NOTE: "The description of the AccountConfigDefault option (displayed in Sentence case). It means that the account configured time format will be used."
	},
	TIME_FORMATTING_LOCALE_DEFAULT_LABEL: {
		TARGET: "Moj jezik / format lokalizacije",
		NOTE: "The label of the LocaleDefault option (displayed in Sentence case). It means that the time format will be based on User's selected language. For example: if the current selected language is Australian English it means that Australian time format will be used."
	},
	TIME_FORMATTING_LOCALE_DEFAULT_DESCRIPTION: {
		TARGET: "Vreme će se zasnivati na jeziku/lokaciji koji su povezani sa gore izabranim jezikom.",
		NOTE: "The description of the LocaleDefault option (displayed in Sentence case). It means that the time format will be based on User's selected language. For example: if the current selected language is Australian English it means that Australian time format will be used."
	},
	TIME_FORMATTING_FORCE_12_HOURS_LABEL: {
		TARGET: "12-časovni prikaz",
		NOTE: "The label of the Force12Hours option (displayed in Sentence case). It means that the time format will be 12 hours (AM/PM)."
	},
	TIME_FORMATTING_FORCE_12_HOURS_DESCRIPTION: {
		TARGET: "Vreme će se prikazivati kao 12:00 (pre podne / posle podne) bez obzira na jezik/lokaciju u podešavanjima organizacije.",
		NOTE: "The description of the Force12Hours option (displayed in Sentence case). It means that the time format will be 12 hours (AM/PM)."
	},
	TIME_FORMATTING_FORCE_24_HOURS_LABEL: {
		TARGET: "24-časovni prikaz",
		NOTE: "The label of the Force24Hours option (displayed in Sentence case). It means that the time format will be 00:00 - 24:00 hours (without AM/PM)."
	},
	TIME_FORMATTING_FORCE_24_HOURS_DESCRIPTION: {
		TARGET: "Vreme će se prikazivati kao 00:00 – 24:00 bez obzira na jezik/lokaciju u podešavanjima organizacije.",
		NOTE: "The description of the Force12Hours option (displayed in Sentence case). It means that the time format will be 00:00 - 24:00 hours (without AM/PM)."
	},
	SETTING_UPDATE_SUCCESS: {
		TARGET: "Podešavanje uspešno ažurirano.",
		NOTE: "A toast message displayed in Sentence case. It notifies that the current settings has been saved successfully."
	},
	SETTING_UPDATE_FAILED: {
		TARGET: "Ažuriranje podešavanja nije uspelo. Pokušajte ponovo kasnije.",
		NOTE: "A toast message displayed in Sentence case. It notifies that the current settings couldn't be saved."
	},
	THEME: {
		TARGET: "Tema",
		NOTE: "Label of a select field input (displayed in Title case) used to select the theme (application colors, fonts, etc) to be used on the application."
	},
	THEMES: {
		TARGET: "Teme",
		NOTE: "Title of the page (in title case), shown on desktop devices, where the user is able to choose its preferred theme (application colors, fonts, etc). Used both in header of the page and as description of menu entry in the side menu."
	},
	CHANGE_THEME: {
		TARGET: "Promena teme",
		NOTE: "Title of the page (in title case), shown on mobile devices, where the user is able to choose its preferred theme (application colors, fonts, etc). Used both in header of the page and as description of menu entry in the side menu."
	},
	CHANGE_LANGUAGE: {
		TARGET: "Promena jezika",
		NOTE: "Title of the page (in title case) where the user is able to change application's language. Used as header of the page on mobile devices."
	},
	CHANGE_LANDING_PAGE: {
		TARGET: "Promena odredišne stranice",
		NOTE: "The title of the page (displayed in title case) in which the user is able to choose what page will the first page seen by the user right after login.  This label is used in case of mobile devices."
	},
	HUB_AND_ASSISTANT_EMPLOYEE_GROUPS: {
		TARGET: "Centar i grupe zaposlenih pomoćnika",
		NOTE: "The label of the side menu entry (displayed in title case) that takes the user to the page where it is possible to select which assistant cards will be available for each employee group."
	},
	SAVE: {
		TARGET: "Sačuvaj",
		NOTE: "The caption of a button (displayed in title case) displayed in user preferences pages. If the user clicks the button, the changes get saved."
	},
	LANDING_PAGE_DESCRIPTION: {
		TARGET: "Izaberite stranicu koju želite da vidite kad se prijavite u WorkForce Suite.",
		NOTE: "A brief helper message (displayed in sentence case) presented on the page where the user is able to choose the landing page for the application. It is positioned right under the page header and helps the user on how to use the page."
	},
	HUB_PAGE: {
		TARGET: "Centralna stranica",
		NOTE: "Text in title case that describes the radio button option for the default choice for landing page (the hub page)."
	},
	CUSTOM: {
		TARGET: "Prilagođeno",
		NOTE: "Text in title case that describes the radio button option that enables the user to customize which page will be used as the landing page."
	},
	CUSTOM_LANDING_PAGE: {
		TARGET: "Prilagođena odredišna stranica",
		NOTE: "Text in title case used as a placeholder for the form field used to select the page that will be used as landing page."
	},
	LANDING_PAGE_RADIO_GROUP_ARIA_LABEL: {
		TARGET: "Izaberite da li želite da imate prilagođenu odredišnu stranicu ili podrazumevanu centralnu stranicu",
		NOTE: "Accessible name (aria label) for the field (radio button group) used to define the application landing page."
	},
	DISCARD_CHANGES: {
		TARGET: "Odbaci promene",
		NOTE: "The caption of a button (displayed in title case) that discards unsaved changes to a user preference. It is presented in the footer of every user preference setting page."
	},
	CHANGES_SAVED: {
		TARGET: "Promene su sačuvane",
		NOTE: "The caption of a button (displayed in title case) that saves a user preference setting. It appears as a confirmation"
	}
};
var EMPLOYEE_GROUP_FILTERS = {
	TITLE: {
		TARGET: "Centar i grupe zaposlenih pomoćnika",
		NOTE: "The text header (displayed in title case) in the page where it is possible to select which assistant cards will be available for each employee group (user preference)."
	},
	DESCRIPTION: {
		TARGET: "Izaberite za koju grupu želite da vidite stavke u Centru i Pomoćniku",
		NOTE: "Text paragraph (displayed in sentence case) presented in the Hub and Assistant Employee Groups preference page. Provides a brief instruction on how to use the page."
	}
};
var NAV_MENU = {
	BURGER_MENU: {
		TARGET: "Meni za navigaciju kroz Suite",
		NOTE: "Hamburger button that when clicked opens a dropdown with the naviagation items."
	},
	CLOSE_MENU: {
		TARGET: "Zatvori meni za navigaciju",
		NOTE: "Close button that when clicked closes the navigation menu."
	},
	BACK_ARROW: {
		TARGET: "Nazad",
		NOTE: "Aria-label (used by a screen reader) to tell user that hitting this button will return them to the navigation menu."
	},
	TOOLBAR: {
		TARGET: "Traka sa alatkama",
		NOTE: "Aria-label (used by a screen reader) to tell user that general top navigation toolbar that includes profile, assistant, and experience icons."
	},
	ADMIN: {
		TARGET: "Administrator",
		NOTE: "Navigation menu main entry (display in title case) that groups links to most of the admin features.",
		WFX: {
			TARGET: "Unapređena komunikacija",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Experience' feature."
		},
		DEMAND_SCHEDULING: {
			TARGET: "Planiranje prema potražnji",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Demand Scheduling' feature."
		},
		SCHEDULING_EMPLOYEE_ADMIN: {
			TARGET: "Planiranje – administracija zaposlenih",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Scheduling Employee' feature."
		},
		SCHEDULING_MODEL_ADMIN: {
			TARGET: "Planiranje – administracija modela",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Scheduling Model' feature."
		},
		SCHEDULING_RULE_SETUP: {
			TARGET: "Planiranje – podešavanje pravila",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Scheduling Rule Setup' feature."
		},
		SCHEDULING_SECURITY_ADMIN: {
			TARGET: "Planiranje – administracija bezbednosti",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Scheduling Security' feature."
		},
		SCHEDULING_STANDARD_SCHEDULING: {
			TARGET: "Planiranje – standardno planiranje",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Standard Scheduling' feature."
		},
		SYSTEM_SETUP: {
			TARGET: "Podešavanje sistema",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'System Setup' feature."
		},
		TIME_JOB_DATA_MANAGEMENT: {
			TARGET: "Vreme – upravljanje poslovima i podacima",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Time - Job Data Management' feature."
		},
		TIME_USER_GROUP_MANAGEMENT: {
			TARGET: "Vreme – upravljanje korisnicima i grupama",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Time - User and Group Management' feature."
		},
		CLOCKING: {
			TARGET: "Evidentiranje radnog vremena",
			NOTE: "Navigation submenu (displayed in title case) providing access to various administrative settings for the 'Clocking' feature."
		}
	},
	REPORTS: {
		TARGET: "Izveštaji",
		NOTE: "Navigation menu main entry (display in title case) that groups links to application reports."
	},
	STAFF: {
		TARGET: "Osoblje",
		NOTE: ""
	},
	SUPPORT: {
		TARGET: "Podrška",
		NOTE: ""
	},
	TIME_OFF: {
		TARGET: "Slobodno vreme",
		NOTE: ""
	},
	TIMESHEET: {
		TARGET: "Evidencija radnog vremena",
		NOTE: ""
	},
	SCHEDULE: {
		TARGET: "Raspored",
		NOTE: ""
	},
	FORECAST: {
		TARGET: "Prognoza",
		NOTE: ""
	},
	HELP: {
		TARGET: "Pomoć",
		NOTE: "Navigation menu main entry (display in title case) that groups links to application help pages."
	},
	WFX: {
		TARGET: "Unapređena komunikacija",
		NOTE: "Navigation menu main entry (display in title case) that groups links to access Workforce Experience features."
	}
};
var NAV_LINKS = {
	PREFERENCES: {
		TARGET: "Postavke",
		NOTE: "The title of a link (displayed in title case) in a navigation menu that takes the user to the page manages its application preferences (language, landing page, etc)."
	},
	IMPERSONATION: {
		TARGET: "Preuzimanje identiteta",
		NOTE: "Navigation menu entry (in title case) that links to the the impersonation modal dialog. It allows the current user to login the application as another user."
	},
	SIGN_OUT: {
		TARGET: "Odjavi me",
		NOTE: "Text label (in title case) for the navigation menu entry that logs the user out of the application after clicked."
	},
	MY_TIMESHEET: {
		TARGET: "Moja evidencija radnog vremena",
		NOTE: ""
	},
	VIEW_PAST_ASSIGNMENTS: {
		TARGET: "Prikaz prošlih zadataka",
		NOTE: ""
	},
	MY_NEXT_GEN_TIMESHEET: {
		TARGET: "Moja evidencija radnog vremena nove generacije",
		NOTE: ""
	},
	TIME_CLOCK: {
		TARGET: "Sat za evidenciju prisustva",
		NOTE: "Navigation menu label for the Time Clock page. The text is in Title Case."
	},
	PAYROLL_WEEKLY: {
		TARGET: "Nedeljni obračun zarada",
		NOTE: ""
	},
	AVAILABILITY: {
		TARGET: "Dostupnost",
		NOTE: ""
	},
	MY_ACCOUNT: {
		TARGET: "Moj nalog",
		NOTE: ""
	},
	AUTO_SCHEDULE: {
		TARGET: "Automatski raspored",
		NOTE: ""
	},
	MY_SCHEDULE_WFS: {
		TARGET: "Moj raspored",
		NOTE: ""
	},
	AUTO_SCHEDULE_WFS: {
		TARGET: "Automatski raspored",
		NOTE: ""
	},
	TIME_AND_ATTENDANCE: {
		TARGET: "Evidencija radnog vremena i prisustva",
		NOTE: ""
	},
	SHIFT_SWAP: {
		TARGET: "Zamena smena",
		NOTE: ""
	},
	AVAILABILITY_TEMPLATE: {
		TARGET: "Šablon dostupnosti",
		NOTE: ""
	},
	POINT_OF_SALE_ERRORS: {
		TARGET: "Greške na mestu prodaje",
		NOTE: ""
	},
	SHIFT_BIDDING: {
		TARGET: "Moje prijavljivanje za smene",
		NOTE: ""
	},
	SHIFT_BIDDING_PREFERENCES: {
		TARGET: "Postavke za moje prijavljivanje za smene",
		NOTE: ""
	},
	MANAGE_SHIFT_BIDDING: {
		TARGET: "Upravljanje prijavljivanjem za smene",
		NOTE: ""
	},
	APPROVAL_AND_EXCEPTIONS: {
		TARGET: "Odobrenje i izuzeci",
		NOTE: ""
	},
	SYSTEM_ADMINISTRATION: {
		TARGET: "Sistemska administracija",
		NOTE: "The title of a link (displayed in title case) in a navigation menu that takes the user to the System Administration Page"
	},
	CONFIG_AND_SECURITY_CHECK: {
		TARGET: "Konfiguracija i bezbednosna provera",
		NOTE: "The title of a link (displayed in title case) in a navigation menu that takes the user to the Configuration and Security Check Page"
	},
	STATUS_SUMMARY: {
		TARGET: "Rezime statusa",
		NOTE: ""
	},
	COWORKER: {
		TARGET: "Raspored kolega",
		NOTE: ""
	},
	TIME_OFF_SUMMARY: {
		TARGET: "Rezime slobodnog vremena",
		NOTE: ""
	},
	LIVE_ATTENDANCE_STATUS: {
		TARGET: "Status prisustva uživo",
		NOTE: ""
	},
	MY_TIME_OFF_WFS: {
		TARGET: "Moja odsustva – WFS",
		NOTE: ""
	},
	RESET_PASSWORD: {
		TARGET: "Resetujte lozinku zaposlenog",
		NOTE: "The title of a link (displayed in title case) in a navigation menu that takes the user to the Reset Employee Password page"
	},
	DYNAMIC_SCHEDULING: {
		TARGET: "Dinamičko planiranje",
		NOTE: ""
	},
	VIEW_REPORTS_WFS: {
		TARGET: "Pregled izveštaja o planiranju",
		NOTE: ""
	},
	MESSAGES: {
		TARGET: "Poruke",
		NOTE: ""
	},
	PERSONAL_DATA_SUMMARY: {
		TARGET: "Rezime ličnih podataka",
		NOTE: ""
	},
	TODAY_PREFERENCES: {
		TARGET: "Postavke za danas",
		NOTE: ""
	},
	SCHEDULE_TEMPLATES: {
		TARGET: "Šabloni rasporeda",
		NOTE: ""
	},
	MANAGE_TIMESHEET: {
		TARGET: "Upravljanje evidencijom radnog vremena",
		NOTE: ""
	},
	BUDGETING: {
		TARGET: "Planiranje budžeta",
		NOTE: ""
	},
	FORECAST: {
		TARGET: "Prognoza",
		NOTE: ""
	},
	VIEW_FORECASTS: {
		TARGET: "Prognoze",
		NOTE: ""
	},
	TASK_EDITOR: {
		TARGET: "Zadaci",
		NOTE: ""
	},
	SETTINGS: {
		TARGET: "Podešavanja",
		NOTE: ""
	},
	ASSOCIATE_MANAGEMENT: {
		TARGET: "Upravljanje saradnicima",
		NOTE: "The title of a link (displayed in title case) in a navigation menu that takes the user to the Associate Management page"
	},
	EMPLOYEE_SETTINGS: {
		TARGET: "Podešavanja zaposlenih",
		NOTE: "The title of a link (displayed in title case) in a navigation menu that takes the user to the Employee Settings page"
	},
	MY_INFO: {
		TARGET: "Moje informacije",
		NOTE: ""
	},
	SQL_REPORTS: {
		TARGET: "Izveštaji o planiranju",
		NOTE: ""
	},
	ADVANCED_SCHEDULING_REPORTS: {
		TARGET: "Standardni izveštaji o planiranju zadataka",
		NOTE: ""
	},
	MANAGE_TEMPLATES: {
		TARGET: "Upravljanje šablonima",
		NOTE: ""
	},
	GROUP_MESSAGING: {
		TARGET: "Grupne poruke",
		NOTE: ""
	},
	MY_TIMESHEETS: {
		TARGET: "Moje evidencije radnog vremena",
		NOTE: ""
	},
	FATIGUE_MANAGEMENT: {
		TARGET: "Upravljanje zamorom",
		NOTE: ""
	},
	REVIEW_SWAP_REQUESTS: {
		TARGET: "Pregled zahteva za zamenu",
		NOTE: ""
	},
	VIEW_REPORTS: {
		TARGET: "Prikaz izveštaja",
		NOTE: ""
	},
	ASSIGN_BADGES: {
		TARGET: "Dodelite značke",
		NOTE: ""
	},
	ADMIN_BADGE_MAINTENANCE: {
		TARGET: "Održavanje značaka",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Badge Maintenance' feature"
	},
	ANALYTICS_REPORT: {
		TARGET: "Izveštaj o analitici",
		NOTE: ""
	},
	KPI_DASHBOARD: {
		TARGET: "Kontrolna tabla sa KPI pokazateljima",
		NOTE: ""
	},
	EDIT_EMPLOYEES: {
		TARGET: "Podaci mojih zaposlenih",
		NOTE: ""
	},
	MANUAL_CALLOUT_RULES: {
		TARGET: "Pravila za ručni poziv zaposlenih",
		NOTE: ""
	},
	ADMIN_CALLOUT_MANUAL_RULES: {
		TARGET: "Pozivanje – ručna pravila",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Callout - Manual Rules' feature."
	},
	MY_CONTACT_PREFERENCES: {
		TARGET: "Moje postavke kontakta",
		NOTE: ""
	},
	MANAGE_NO_CALL_MODEL_LIST: {
		TARGET: "Upravljanje listom modela bez pozivanja",
		NOTE: ""
	},
	MANAGE_MODELS: {
		TARGET: "Upravljanje modelima",
		NOTE: ""
	},
	APPROVE_TIMESHEETS: {
		TARGET: "Odobravanje evidencije radnog vremena",
		NOTE: "The navigation link to the classic approval screen, displayed only in desktop as a submenu of Timesheet."
	},
	APPROVE_TIMESHEETS_NEXT_GEN: {
		TARGET: "Odobravanje evidencije radnog vremena",
		NOTE: "The navigation link to the next generation approval screen, displayed only in mobile as a submenu of Timesheet."
	},
	OVERTIME_TYPE: {
		TARGET: "Tip prekovremenog rada",
		NOTE: ""
	},
	MANAGE_EMPLOYEE_LISTS: {
		TARGET: "Upravljanje listama zaposlenih",
		NOTE: ""
	},
	MANAGE_USERS: {
		TARGET: "Upravljanje korisnicima",
		NOTE: ""
	},
	ADMIN_USERS_DATA: {
		TARGET: "Podaci o korisnicima",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Users Data' feature."
	},
	LINE_ITEM_APPROVAL: {
		TARGET: "Odobravanje pojedinačnih stavki",
		NOTE: ""
	},
	EDIT_USER_GROUPS: {
		TARGET: "Uređivanje korisničkih grupa",
		NOTE: ""
	},
	ROTATION_PATTERN_ASSIGNMENT: {
		TARGET: "Dodeljivanje obrazaca rotacije",
		NOTE: ""
	},
	QUALIFICATIONS: {
		TARGET: "Kvalifikacije",
		NOTE: ""
	},
	USER_SECURITY_MAINTENANCE: {
		TARGET: "Održavanje bezbednosti korisnika",
		NOTE: ""
	},
	ADMIN_USER_SECURITY_MAINTENANCE: {
		TARGET: "Korisničke uloge i bezbednost",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'User Roles and Security' feature."
	},
	ROTATION_PATTERN_MANAGEMENT: {
		TARGET: "Upravljanje obrascima rotacije",
		NOTE: ""
	},
	EMPLOYEE_SCHEDULE_MANAGEMENT: {
		TARGET: "Upravljanje rasporedom zaposlenih",
		NOTE: ""
	},
	WEB_CLOCK: {
		TARGET: "WebClock",
		NOTE: ""
	},
	LAUNCH_ADMIN_CLIENT: {
		TARGET: "Pokreni administratorski klijent",
		NOTE: ""
	},
	ADMIN_LAUNCH_ADMIN_CLIENT: {
		TARGET: "Pokreni WT&A administratorski klijent",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Launch WT&A Admin Client' feature."
	},
	CALLOUT_RESPONSES: {
		TARGET: "Odgovori na poziv zaposlenih",
		NOTE: ""
	},
	MY_SWAP_REQUESTS: {
		TARGET: "Moji zahtevi za zamenu",
		NOTE: ""
	},
	COPY_SCHEDULE: {
		TARGET: "Kopiraj raspored",
		NOTE: ""
	},
	REASON_CODES: {
		TARGET: "Šifre razloga",
		NOTE: ""
	},
	DELEGATION_MANAGEMENT: {
		TARGET: "Upravljanje delegiranjem",
		NOTE: ""
	},
	ADMIN_DELEGATIONS: {
		TARGET: "Delegiranja",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Delegations' feature."
	},
	DELEGATION_SUPER: {
		TARGET: "Upravljaj svim delegiranjima",
		NOTE: "Manage All Delegations menu option (for the Super Delegation system feature)."
	},
	ADMIN_DELEGATION_SUPER: {
		TARGET: "Sva delegiranja",
		NOTE: "All Delegations (for the Super Delegation system feature)."
	},
	SHIFTS: {
		TARGET: "Smene",
		NOTE: ""
	},
	MY_TIME_OFF: {
		TARGET: "Moje slobodno vreme",
		NOTE: ""
	},
	VIEW_MY_TIME_OFF_REQUESTS: {
		TARGET: "Prikaz mog slobodnog vremena",
		NOTE: "Sub-menu title within Time Off hub menu for new employee time off request list screen. It displays in Title case. Allow employees to view their time off requests list on new suite screen."
	},
	RUN_JOB: {
		TARGET: "Pokreni posao",
		NOTE: ""
	},
	CREW_PRODUCTION: {
		TARGET: "Učinak ekipe",
		NOTE: ""
	},
	ASSIGN_SCHEDULES: {
		TARGET: "Dodeljivanje rasporeda",
		NOTE: ""
	},
	POLICY_MAPPING_FOR_IMPORTS: {
		TARGET: "Mapiranje smernica za uvoz",
		NOTE: ""
	},
	EMPLOYEES: {
		TARGET: "Zaposleni",
		NOTE: ""
	},
	ADMIN_EMPLOYEES_DATA: {
		TARGET: "Podaci o zaposlenima",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Employees Data' feature."
	},
	GROUP_CALENDARS: {
		TARGET: "Grupni kalendari",
		NOTE: ""
	},
	ADJUST_BANK_BALANCES: {
		TARGET: "Prilagođavanje stanja fondova",
		NOTE: ""
	},
	ORGANIZATION: {
		TARGET: "Organizacija",
		NOTE: ""
	},
	RECALCULATE_ASSIGNMENT_GROUPS: {
		TARGET: "Ponovo izračunaj grupe za dodeljivanje",
		NOTE: ""
	},
	ADMIN_RECALCULATE_EMPLOYEE_GROUPS: {
		TARGET: "Grupe zaposlenih – ponovni obračun",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Recalculate Employee Groups' feature."
	},
	MANAGE_STAFFING_REQUIREMENTS: {
		TARGET: "Upravljanje potrebama za osobljem",
		NOTE: ""
	},
	EDIT_PROFILES: {
		TARGET: "Uređivanje profila",
		NOTE: ""
	},
	ADMIN_PROFILE_MANAGEMENT: {
		TARGET: "Upravljanje profilima",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Profile Management' feature."
	},
	EMPLOYEE_FILTERS: {
		TARGET: "Filteri za zaposlene",
		NOTE: ""
	},
	MODIFY_SCHEDULE: {
		TARGET: "Izmena rasporeda",
		NOTE: ""
	},
	BID_PACKAGE_ADMINISTRATION: {
		TARGET: "Administracija paketa za licitaciju",
		NOTE: ""
	},
	MANAGE_GROUPS: {
		TARGET: "Upravljanje grupama",
		NOTE: ""
	},
	ADMIN_CURRENT_EMPLOYEE_GROUPS: {
		TARGET: "Grupe zaposlenih – aktuelne",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Current Employee Groups' feature."
	},
	SUBNAV_MANAGE_SUPER: {
		TARGET: "Upravljanje grupama",
		NOTE: "General feature allowing the user to manage assignment groups through the Manage Groups menu option."
	},
	ADMIN_SUBNAV_MANAGE_SUPER: {
		TARGET: "Grupe zaposlenih – aktuelne",
		NOTE: "General feature allowing the user manage existing assignment groups."
	},
	CREATE_GROUPS: {
		TARGET: "Kreiranje grupa",
		NOTE: ""
	},
	ADMIN_NEW_EMPLOYEE_GROUPS: {
		TARGET: "Grupe zaposlenih – nove",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'New Employee Group' feature."
	},
	SUBNAV_CREATE_SUPER: {
		TARGET: "Kreiranje grupa",
		NOTE: "General feature allowing the user to create new assignment groups through the Create Groups menu option."
	},
	ADMIN_SUBNAV_CREATE_SUPER: {
		TARGET: "Grupe zaposlenih – nove",
		NOTE: "General feature allowing the user create new assignment groups."
	},
	IMPORT_DATA: {
		TARGET: "Uvoz podataka",
		NOTE: ""
	},
	JOB_STATUS: {
		TARGET: "Status posla",
		NOTE: ""
	},
	ASSIGNMENT_RULES: {
		TARGET: "Pravila dodeljivanja",
		NOTE: ""
	},
	SCHEDULING_GROUPS: {
		TARGET: "Grupe za raspored",
		NOTE: ""
	},
	EMPLOYEE_CALENDARS: {
		TARGET: "Kalendari zaposlenih",
		NOTE: ""
	},
	STATION_MANAGEMENT: {
		TARGET: "Upravljanje stanicama",
		NOTE: ""
	},
	GROUP_TIME: {
		TARGET: "Grupna evidencija radnog vremena",
		NOTE: ""
	},
	CALLOUT_RULE: {
		TARGET: "Pravilo za poziv zaposlenih",
		NOTE: ""
	},
	DELETE_SCHEDULE: {
		TARGET: "Brisanje rasporeda",
		NOTE: ""
	},
	LEAVE_SUMMARY: {
		TARGET: "Rezime odsustva",
		NOTE: "Allows employees to view their annual leave summary on classic Time off request screen."
	},
	LEAVE_REGULATIONS: {
		TARGET: "Propisi o odsustvu",
		NOTE: ""
	},
	CHANGE_MY_PASSWORD: {
		TARGET: "Promeni moju lozinku",
		NOTE: ""
	},
	MANAGE_GROUP_SCHEDULES: {
		TARGET: "Upravljajte grupnim rasporedima",
		NOTE: ""
	},
	MANAGE_ABSENCE_CASES: {
		TARGET: "Upravljajte slučajevima odsustva",
		NOTE: ""
	},
	COMPLIANCE_PORTAL: {
		TARGET: "Portal za usklađenost",
		NOTE: ""
	},
	DISPLAY_ELEMENTS: {
		TARGET: "Elementi prikaza",
		NOTE: ""
	},
	SELECTION_CONSTRAINTS: {
		TARGET: "Ograničenja izbora",
		NOTE: ""
	},
	REVIEW_TIME_OFF_REQUESTS: {
		TARGET: "Pregled zahteva za odsustvo",
		NOTE: ""
	},
	AUTO_SCHEDULE_STAFFING_CRITERIA: {
		TARGET: "Kriterijumi za automatsko raspoređivanje osoblja",
		NOTE: ""
	},
	ADMIN_AUTO_SCHEDULE_STAFFING_CRITERIA: {
		TARGET: "Kriterijumi za automatsko raspoređivanje osoblja",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Autoschedule Staffing Criteria' feature."
	},
	CALLOUT_TERMINATION_CODE_SETS: {
		TARGET: "Skupovi šifara za prekid poziva zaposlenih",
		NOTE: ""
	},
	PERMISSION_SETUP: {
		TARGET: "Podešavanje dozvole",
		NOTE: ""
	},
	SCHEDULE_MAINTENANCE: {
		TARGET: "Planiranje održavanja",
		NOTE: ""
	},
	MODEL_FILTERS: {
		TARGET: "Filteri modela",
		NOTE: ""
	},
	END_OF_PERIOD_PROCESSING: {
		TARGET: "Kraj obrade perioda",
		NOTE: ""
	},
	SERVER_ADMINISTRATION: {
		TARGET: "Administracija servera",
		NOTE: ""
	},
	RUN_AUTO_SCHEDULE: {
		TARGET: "Pokreni automatski raspored",
		NOTE: ""
	},
	CALLOUT: {
		TARGET: "Pozivanje",
		NOTE: ""
	},
	FACILITIES: {
		TARGET: "Objekti",
		NOTE: ""
	},
	SELECTION_PREFERENCES: {
		TARGET: "Postavke izbora",
		NOTE: ""
	},
	"MANAGE_RETRO-CALC_TRIGGERS": {
		TARGET: "Upravljanje okidačima za retroaktivni obračun",
		NOTE: ""
	},
	"ADMIN_RETRO-CALC_TRIGGERS": {
		TARGET: "Okidači za retroaktivni obračun",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Retro-calc Triggers' feature."
	},
	CREW_MAINTENANCE: {
		TARGET: "Održavanje ekipa",
		NOTE: ""
	},
	POST_EMPLOYEES: {
		TARGET: "Proknjiži zaposlene",
		NOTE: ""
	},
	SCHEDULE_PERIOD: {
		TARGET: "Period rasporeda",
		NOTE: ""
	},
	LUNCH_AND_BREAK: {
		TARGET: "Ručak i pauza",
		NOTE: ""
	},
	ADMIN_LUNCH_AND_BREAK: {
		TARGET: "Ručak i pauza",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Lunch & Break' feature."
	},
	EDIT_ASSIGNMENTS: {
		TARGET: "Uređivanje zadataka",
		NOTE: ""
	},
	ADMIN_ASSIGNMENT_DATA: {
		TARGET: "Podaci o zadatku",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Assignment Data' feature."
	},
	OVERTIME_AND_COST_CONTROL: {
		TARGET: "Kontrola prekovremenog rada i troškova",
		NOTE: ""
	},
	ADMIN_OVERTIME_AND_COST_CONTROL: {
		TARGET: "Kontrola prekovremenog rada i troškova",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Overtime & Cost Control' feature."
	},
	MANAGE_EVENTS: {
		TARGET: "Upravljanje događajima",
		NOTE: ""
	},
	EMPLOYEE_TIME: {
		TARGET: "Evidencija radnog vremena zaposlenih",
		NOTE: ""
	},
	EMPLOYEE_NEXT_GEN_TIMESHEETS: {
		TARGET: "Nova generacija evidencije radnog vremena zaposlenih",
		NOTE: ""
	},
	SCHEDULE_RULE_COPY: {
		TARGET: "Kopiranje pravila rasporeda",
		NOTE: ""
	},
	DEFAULT_LABOR_ALLOCATION: {
		TARGET: "Upravljanje podrazumevanom raspodelom rada",
		NOTE: ""
	},
	MY_DEFAULT_LABOR_ALLOCATION: {
		TARGET: "Moja podrazumevana raspodela rada",
		NOTE: ""
	},
	VIEW_ANALYTICS: {
		TARGET: "Prikaz analitike",
		NOTE: ""
	},
	SCHEDULING_UNITS: {
		TARGET: "Jedinice za raspoređivanje",
		NOTE: ""
	},
	AREAS: {
		TARGET: "Oblasti",
		NOTE: ""
	},
	OVERTIME_BANKS: {
		TARGET: "Fondovi prekovremenog rada",
		NOTE: ""
	},
	PASSWORD_MANAGEMENT: {
		TARGET: "Upravljanje lozinkom",
		NOTE: ""
	},
	WEB_SERVICES_API_DOCUMENTATION: {
		TARGET: "API dokumentacija za veb-usluge",
		NOTE: ""
	},
	REQUEST_ACCOMMODATION: {
		TARGET: "Podnesi zahtev za prilagođavanje",
		NOTE: ""
	},
	MY_SCHEDULE: {
		TARGET: "Moj kalendar",
		NOTE: ""
	},
	SCHEDULE_RULE_SWAP: {
		TARGET: "Zamena pravila rasporeda",
		NOTE: ""
	},
	MAINTAIN_LOOKUP_TABLES: {
		TARGET: "Održavanje tabela za proveru podataka",
		NOTE: ""
	},
	ADMIN_LOOKUP_TABLES: {
		TARGET: "Tabele za proveru podataka",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Lookup Tables' feature."
	},
	ADMIN_SCHEDULE_RULE_SWAP: {
		TARGET: "Zamena pravila rasporeda",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Schedule Rule Swap' feature."
	},
	EDIT_FIELD_LEVEL_PROFILE: {
		TARGET: "Izmeni profil na nivou polja",
		NOTE: ""
	},
	LABOR_STANDARDS: {
		TARGET: "Standardi rada",
		NOTE: ""
	},
	HOLIDAY_MAINTENANCE: {
		TARGET: "Održavanje praznika",
		NOTE: ""
	},
	ADMIN_HOLIDAY_DATES: {
		TARGET: "Datumi praznika",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Holiday Dates' feature."
	},
	MANAGE_EMPLOYEES: {
		TARGET: "Upravljanje zaposlenima",
		NOTE: ""
	},
	SCHEDULE: {
		TARGET: "Raspored",
		NOTE: ""
	},
	SCHEDULE_EDITOR: {
		TARGET: "Uređivanje rasporeda",
		NOTE: ""
	},
	SHIFT_MANAGEMENT: {
		TARGET: "Upravljanje smenama",
		NOTE: ""
	},
	CREW_MANAGEMENT_HELP: {
		TARGET: "Pomoć – upravljanje ekipama",
		NOTE: ""
	},
	FATIGUE_MANAGEMENT_HELP: {
		TARGET: "Pomoć – upravljanje zamorom",
		NOTE: ""
	},
	TIME_ATTENDANCE_HELP: {
		TARGET: "Pomoć – vreme",
		NOTE: ""
	},
	ABSENCE_COMPLIANCE_HELP: {
		TARGET: "Pomoć – usklađenost odsustva",
		NOTE: ""
	},
	ADVANCED_SCHEDULER_HELP: {
		TARGET: "Pomoć – klasično planiranje poslova",
		NOTE: ""
	},
	SYSTEM_CONFIG: {
		TARGET: "Konfiguracija sistema",
		NOTE: ""
	},
	ADMIN_SUITE_CONFIG: {
		TARGET: "Konfiguracija sistema Suite",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Suite Configuration' feature."
	},
	ADMIN_EMPLOYEE_GROUPS: {
		TARGET: "Grupe zaposlenih",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Employee Groups' feature."
	},
	MY_BIDDING_WTA: {
		TARGET: "Moje prijavljivanje",
		NOTE: ""
	},
	MY_CALENDAR: {
		TARGET: "Moj kalendar",
		NOTE: ""
	},
	TEAM_ABSENCE_CALENDAR: {
		TARGET: "Kalendar odsustva tima",
		NOTE: "Navigation menu label for the Team Absence Calendar page. The text is in Title Case."
	},
	EMPLOYEE_GROUPS: {
		TARGET: "Grupe zaposlenih",
		NOTE: ""
	},
	AS_USER_GROUPS: {
		TARGET: "Klasične korisničke grupe za planiranje poslova",
		NOTE: ""
	},
	ADMIN_AS_USER_GROUPS: {
		TARGET: "Grupe",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Groups' feature."
	},
	AUTOMATIC_CALLOUT_RULES: {
		TARGET: "Pravila za automatski poziv zaposlenih",
		NOTE: ""
	},
	ADMIN_CALLOUT_AUTOMATIC_RULES: {
		TARGET: "Poziv zaposlenih – automatska pravila",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Callout - Automatic Rules' feature."
	},
	ADVANCED_SCHEDULER_USERS: {
		TARGET: "Korisnici klasičnog planiranja poslova",
		NOTE: ""
	},
	ADMIN_ADVANCED_SCHEDULER_USERS: {
		TARGET: "Korisnici",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Users' feature."
	},
	WFX: {
		TARGET: "Otvorena unapređena komunikacija",
		NOTE: ""
	},
	LOCATIONS: {
		TARGET: "Lokacije",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Locations' feature."
	},
	ORGANIZATION_SETTINGS: {
		TARGET: "Podešavanja organizacije",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Organization Settings' feature."
	},
	SYNC: {
		TARGET: "Sinhronizacija",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Sync' feature."
	},
	USERS: {
		TARGET: "Korisnici",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'Users' feature."
	},
	USER_LISTS: {
		TARGET: "Liste korisnika",
		NOTE: "Navigation submenu item (displayed in title case) providing access to administrative settings for the 'User List' feature."
	},
	ML_FORECASTING: {
		TARGET: "Predviđanje",
		NOTE: "Navigation menu label to take the user to the Forecasting page."
	},
	WFX_APP: {
		TARGET: "Aplikacija za unapređenu komunikaciju",
		NOTE: "Navigation menu label (displayed in Title case) in the Experience dropdown to take the user to the experience standalone app in a seperate tab."
	},
	CHANNELS: {
		TARGET: "Kanali",
		NOTE: "Navigation menu label (displayed in Title case) in the Experience dropdown to take the user to the Experience Channels page"
	},
	BROADCASTS: {
		TARGET: "Emitovanja",
		NOTE: "Navigation menu label (displayed in Title case) in the Experience dropdown to take the user to the Experience Broadcasts page"
	},
	TASKS: {
		TARGET: "Zadaci",
		NOTE: "Navigation menu label (displayed in Title case) in the Experience dropdown to take the user to the Experience Tasks page."
	},
	DOCUMENTS: {
		TARGET: "Dokumenti",
		NOTE: "Navigation menu label (displayed in Title case) in the Experience dropdown to take the user to the Experience Documents page."
	},
	WFX_ADMIN: {
		TARGET: "Administrator za unapređenu komunikaciju",
		NOTE: "Navigation menu label (displayed in Title case) in the Admin dropdown to take the user to Experience Admin page."
	},
	ADMIN_MENU_HELP_LINK: {
		TARGET: "Pogledajte šta je novo",
		NOTE: "this links to a navigation link that contains a document detailing the recent changes to the admin navigation organization"
	},
	VISIER_ANALYTICS: {
		TARGET: "Poboljšana analitika",
		NOTE: "This links to a navigation option for accessing the features of the external Visier Analytics tool."
	}
};
var ORGANIZATION_PANEL = {
	TITLE: {
		TARGET: "Prijava u ADP WorkForce Suite",
		NOTE: "this is the heading (displayed in Title case) for the login screen"
	},
	DEFAULT_HELP_TEXT: {
		TARGET: "Obično je to kratka skraćenica za vašu kompaniju. Obratite se administratoru za pomoć.",
		NOTE: "this is text (displayed in Sentence case) appearing underneath the textbox for account name where the user types in whatever their account name is"
	},
	INVALID_ACCOUNT: {
		TARGET: "Unesite važeći nalog",
		NOTE: "this is a message (displayed in Sentence case) that appears when you enter an account that doesn't exist"
	},
	GENERIC_ERROR: {
		TARGET: "Nije moguće potvrditi identitet",
		NOTE: "this is a message (displayed in Sentence case) that appears when the user can't authenticate"
	},
	NETWORK_ERROR: {
		TARGET: "Došlo je do greške prilikom povezivanja sa serverom. Proverite vezu",
		NOTE: "this is a message (displayed in Sentence case) that appears to the user when there's a network error when trying to login on the page"
	},
	ACCOUNT: {
		TARGET: "Nalog",
		NOTE: "this is for the orginazation account that the user is logging into"
	},
	BUTTON_NEXT: {
		TARGET: "Sledeće",
		NOTE: "this is the next button that is clicked so the user can navigate to the next step of logging in"
	},
	SELECT_LANGUAGE: {
		TARGET: "Izaberite jezik",
		NOTE: "this is a button (displayed in Title case) that when clicked will present the user with other languages to select"
	},
	EDIT_ACCOUNT_ARIA_LABEL: {
		TARGET: "Promenite ime naloga",
		NOTE: "Aria label for the edit account icon for voiceover"
	},
	CLOSE_SIDEBAR_ARIA_LABEL: {
		TARGET: "Zatvori",
		NOTE: "Aria label for button that closes the right sidebar (drawer)"
	},
	SKIP_NAVIGATION: {
		TARGET: "Preskoči navigaciju",
		NOTE: "this is a skip navigation button that when user click on this button will navigate to main content"
	}
};
var NAVIGATION_WARNING = {
	UNSAVED_CHANGES_TEXT: {
		TARGET: "Želite li da ostanete na ovoj stranici i sačuvate izmene ili želite da ih odbacite i nastavite dalje?",
		NOTE: "this text (displayed in Sentence case) is on an alert popup that pops up when a user tries to navigate off a page with unsaved changes"
	},
	UNSAVED_CHANGES_HEADING: {
		TARGET: "Nesačuvane izmene",
		NOTE: "This is the heading (displayed in Title case) that occurs in a popup to tell the user that they have unsaved changes"
	},
	DISCARD: {
		TARGET: "Odbaci",
		NOTE: "this is a button that the user can click to discard their unsaved changes and navigate off the page"
	},
	STAY_ON_PAGE: {
		TARGET: "Ostani na stranici",
		NOTE: "this is a button (displayed in Sentence case) that the user can click if they want to stay on the page instead of navigating off of it"
	}
};
var IMPERSONATION_DIALOG = {
	HEADER: {
		TARGET: "Preuzimanje identiteta",
		NOTE: "header of the impersonate dialog where you choose a user to impersonate"
	},
	BUTTON_CANCEL: {
		TARGET: "Otkaži",
		NOTE: "cancel button in impersonate dialog"
	},
	BUTTON_SUBMIT: {
		TARGET: "Preuzimanje identiteta",
		NOTE: "the button in dialoge when you want to confirm that you want to impersonate the user you selected"
	},
	HELPER_TEXT: {
		TARGET: "Da biste se prijavili kao drugi korisnik, izaberite ga sa liste.",
		NOTE: "text (displayed in Sentence case) above a dropdown where you choose which user you would like to impersonate"
	},
	NO_OPTION: {
		TARGET: "Nije pronađen nijedan korisnik",
		NOTE: "shows in dropdown (displayed in Sentence case) when there's no user found that you can impersonate"
	}
};
var IMPERSONATION_INDICATOR = {
	MESSAGE: {
		TARGET: "Preuzimanje identiteta",
		NOTE: "Text that appears in app to indicate you're impersonating someone like this 'Impersonating {name of person you are impersonatin}'"
	}
};
var NOTIFICATION_MESSAGES = {
	HUB_CARD_DISMISSED: {
		TARGET: "{{hubCardName}} Kartica centra je uklonjena.",
		NOTE: "notification generated (displayed in Title case) by app when a hub card is dismissed by user"
	},
	UNDO: {
		TARGET: "Opozovi",
		NOTE: "This text appears on the dismissal notification and when clicked will undo the dissimal of a notification"
	}
};
var ERROR_PAGE = {
	SORRY: {
		TARGET: "Žao nam je",
		NOTE: "This is hover text for the sorry image that appears when an error has occured"
	},
	PAGE_NOT_FOUND: {
		TARGET: "Stranica koju ste tražili nije pronađena.",
		NOTE: "This text (displayed in Sentence case) is on a error page to indicate that the page the user tried to navigate to couldn't be found"
	},
	PERMISSION_DENIED: {
		TARGET: "Greška 403 – nemate dozvole za ovu stranicu.",
		NOTE: "This appears (displayed in Sentence case) on the error page when the user doesn't have permissions to navigate to that specific page"
	},
	CONTACT_IT: {
		TARGET: "Obratite se svom IT administratoru za dalju pomoć.",
		NOTE: "This text (displayed in Sentence case) is used on an error page to inform the user to contact IT admin to figure out why there was an error"
	},
	UNEXPECTED_ERROR: {
		TARGET: "Naišli smo na problem i usluga je možda nedostupna. Obratite se svom administratoru za pomoć.",
		NOTE: "this is the message (displayed in Sentence case) displayed on the page when an unexpected error occurs in the app"
	},
	TAKE_ME_HOME: {
		TARGET: "Želim da se vratim na početni ekran",
		NOTE: "This is the text (displayed in Sentence case) on a link that when clicked brings the user back to the main screen of app"
	}
};
var API_ERROR_DIALOG = {
	ACTION: {
		CLOSE: {
			TARGET: "Zatvori",
			NOTE: "The caption of a button displayed in multiple places. If the button is clicked, the dialog closes. It means that the user has read the text in the dialog and accepts it."
		}
	},
	FAILED_TO_CONNECT: {
		TITLE: {
			TARGET: "Povezivanje sa uslugom nije uspelo",
			NOTE: "The title of the Error Dialog (displayed in Title case). Has the server is not responded."
		},
		SERVICE_NAME: {
			TARGET: "Povezivanje sa uslugom {{serviceName}} nije uspelo.",
			NOTE: "This is a service name message (displayed in Sentence case) when a particular service is failed."
		},
		DESCRIPTION: {
			TARGET: "Ako se ova poruka i dalje pojavljuje, zapišite naziv gorenavedene usluge i obratite se svom administratoru sistema.",
			NOTE: "This is a message (displayed in Sentence case) when a particular service is failed."
		}
	},
	TIME_OUT: {
		TITLE: {
			TARGET: "Usluga je istekla",
			NOTE: "The title of the Error Dialog (displayed in Title case). Has the server is not responded."
		},
		SERVICE_NAME: {
			TARGET: "Usluga {{serviceName}} ne reaguje.",
			NOTE: "This is a service name message (displayed in Sentence case) when a particular service is failed."
		},
		DESCRIPTION: {
			TARGET: "Ako se ova poruka i dalje pojavljuje, zapišite naziv gorenavedene usluge i obratite se svom administratoru sistema.",
			NOTE: "This is a message (displayed in Sentence case) when a particular service is failed."
		}
	},
	INCORRECT_RESPONSE: {
		TITLE: {
			TARGET: "Usluga je pružila netačan odgovor",
			NOTE: "The title of the Error Dialog (displayed in Title case). Has the server is not responded."
		},
		SERVICE_NAME: {
			TARGET: "Usluga {{serviceName}} je odgovorila sa sledećom greškom;",
			NOTE: "This is a service name message (displayed in Sentence case) when a particular service is failed."
		},
		HTTP_STATUS_CODE: {
			TARGET: "Šifra HTTP statusa: {{statusCode}}",
			NOTE: ""
		},
		DESCRIPTION: {
			TARGET: "Ako se ova poruka i dalje pojavljuje, zapišite naziv gorenavedene usluge i HTTP šifre greške i obratite se svom administratoru sistema.",
			NOTE: "This is a message (displayed in Sentence case) when a particular service is failed."
		}
	},
	INTERNAL_SERVER_ERROR: {
		TITLE: {
			TARGET: "Usluga je odgovorila sa greškom",
			NOTE: "The title of the Error Dialog (displayed in Title case). Has the server is not responded."
		},
		SERVICE_NAME: {
			TARGET: "Usluga {{serviceName}} je odgovorila sa sledećom greškom;",
			NOTE: "This is a service name message (displayed in Sentence case) when a particular service is failed."
		},
		DESCRIPTION: {
			TARGET: "Ako nastavite da vidite ovu poruku, zabeležite ime usluge i kod greške iznad i obratite se administratoru sistema.",
			NOTE: "This is a message (displayed in Sentence case) when a particular service is failed."
		}
	},
	INTERNAL_SERVER_ERROR_WITHOUT_ERROR_ID: {
		SERVICE_NAME: {
			TARGET: "Usluga {{serviceName}} je naišla na neočekivanu grešku i trenutno nismo u mogućnosti da pratimo problem;",
			NOTE: "This message is shown when the service encounters an error but no error ID is available."
		},
		DESCRIPTION: {
			TARGET: "Ako se ova poruka i dalje pojavljuje, zapišite naziv usluge i obratite se svom administratoru sistema.",
			NOTE: "This is a message (displayed in Sentence case) when a particular service is failed."
		}
	}
};
var PIN = {
	CREATE_PIN: {
		TARGET: "Kreirajte PIN",
		NOTE: "The title for create PIN screen"
	},
	WELCOME_BACK: {
		TARGET: "Dobro došli nazad",
		NOTE: "The title for created PIN flow"
	},
	ENTER_YOUR_PIN: {
		TARGET: "Unesite PIN",
		NOTE: "Label indicating the user can type a PIN number."
	},
	CONFIRM_YOUR_PIN: {
		TARGET: "Potvrdite PIN",
		NOTE: "Label indicating the user needs to confirm a PIN number."
	},
	YOUR_ACCOUNT_REQUIRES_PIN: {
		TARGET: "Vaš nalog zahteva numerički PIN.",
		NOTE: "Modal description label indicating the user needs to set a PIN number."
	},
	MORE_DETAILS_MODAL: {
		MORE_DETAILS: {
			TARGET: "Više detalja",
			NOTE: "Button label to open more details modal."
		},
		DESCRIPTION: {
			TARGET: "PIN je potreban da biste ponovo dobili pristup aktivnoj sesiji (npr. ako ste umanjili aplikaciju dok ste prijavljeni)",
			NOTE: "More details modal description"
		},
		INFO_SWITCH_USERS: {
			TARGET: "Možete da promenite korisnika ako je sesija aktivna (npr. deljenje uređaja)",
			NOTE: "More details modal description"
		},
		INFO_PIN_ATTEMPTS: {
			TARGET: "Ako ne unesete pravilno PIN u tri pokušaja, od vas će biti zatraženo da kreirate novi PIN",
			NOTE: "More details modal description"
		},
		INFO_FORGOT_PIN: {
			TARGET: "Ako zaboravite svoj PIN, možete napraviti novi i postojeći će isteći",
			NOTE: "More details modal description"
		}
	},
	BACK: {
		TARGET: "Nazad",
		NOTE: "Button label to go back to PIN creation screen"
	},
	PIN_DID_NOT_MATCH: {
		TARGET: "Unos PIN-a se ne podudara",
		NOTE: "Hint text to help the user"
	},
	ENTER_CREATED_PIN: {
		TARGET: "Morate da unesete svoj PIN da biste ponovo dobili pristup trenutnoj sesiji.",
		NOTE: "Instructions for accessing the current session"
	},
	SWITCH_USER: {
		TARGET: "Promeni korisnika",
		NOTE: "Text for switch user button"
	},
	USER_WILL_BE_LOGGED_OUT: {
		TARGET: "Ako potvrdite, trenutni korisnik će biti odjavljen i od vas će biti zatraženo da se prijavite.",
		NOTE: "Switch user modal description"
	},
	INCORRECT_PIN: {
		TARGET: "Netačan PIN. Preostalo pokušaja: {{numAttempts}}.",
		NOTE: "Text to inform pin attempts left"
	},
	INCORRECT_PIN_FINAL_ATTEMPT: {
		TARGET: "Netačan PIN. Preostao je {{numAttempts}} pokušaj.",
		NOTE: "Text to inform only one pin attempts left"
	},
	INCORRECT_PIN_TITLE: {
		TARGET: "Netačan PIN",
		NOTE: "Modal title"
	},
	INCORRECT_PIN_DESCRIPTION: {
		TARGET: "Vaši pokušaji da ispravno unesete PIN premašili su dozvoljeni broj.",
		NOTE: "Modal content"
	},
	INCORRECT_PIN_TEXT: {
		TARGET: "PIN je sada istekao i od vas će biti zatraženo da kreirate novi PIN nakon prijavljivanja.",
		NOTE: "Modal content"
	},
	I_UNDERSTAND: {
		TARGET: "Razumem",
		NOTE: "Modal button"
	},
	FORGOT_PIN: {
		TARGET: "Zaboravili ste PIN",
		NOTE: "Forgot PIN button"
	},
	CREATE_NEW_PIN: {
		TARGET: "Ako potvrdite, vaš postojeći PIN će isteći i bićete odjavljeni. Nakon prijavljivanja od vas će biti zatraženo da kreirate novi PIN.",
		NOTE: "Forgot PIN modal description"
	},
	CONFIRM: {
		TARGET: "Potvrdi",
		NOTE: "Confirm button"
	}
};
var SESSION_INACTIVITY = {
	WARNING_DIALOG: {
		LOG_OUT: {
			TARGET: "Odjavi me",
			NOTE: "Dialog button to logout the user"
		},
		I_AM_STILL_HERE: {
			TARGET: "Još sam ovde",
			NOTE: "Dialog button to confirm that user is still using the app"
		},
		TITLE: {
			TARGET: "Istek sesije",
			NOTE: "Dialog title"
		},
		DESCRIPTION: {
			TARGET: "Bili ste neaktivni u dužem vremenskom periodu. Bićete automatski odjavljeni nakon 5 minuta i nesačuvani podaci mogu biti izgubljeni. Da li ste još tu?",
			NOTE: "Dialog description"
		}
	},
	LOGOUT_ALERT: {
		TARGET: "Bili ste odjavljeni iz prethodne sesije zbog neaktivnosti.",
		NOTE: "An alert text to notify the user that they have been logged out due to inactivity."
	}
};
var sr_RS = {
	MENU_ITEMS: MENU_ITEMS,
	GREETING: GREETING,
	RESET_PASSWORD: RESET_PASSWORD,
	USER_PREFERENCES: USER_PREFERENCES,
	EMPLOYEE_GROUP_FILTERS: EMPLOYEE_GROUP_FILTERS,
	NAV_MENU: NAV_MENU,
	NAV_LINKS: NAV_LINKS,
	ORGANIZATION_PANEL: ORGANIZATION_PANEL,
	NAVIGATION_WARNING: NAVIGATION_WARNING,
	IMPERSONATION_DIALOG: IMPERSONATION_DIALOG,
	IMPERSONATION_INDICATOR: IMPERSONATION_INDICATOR,
	NOTIFICATION_MESSAGES: NOTIFICATION_MESSAGES,
	ERROR_PAGE: ERROR_PAGE,
	API_ERROR_DIALOG: API_ERROR_DIALOG,
	PIN: PIN,
	SESSION_INACTIVITY: SESSION_INACTIVITY
};

function create$2() {
    i18next__default.default.use(reactI18next.initReactI18next).init({
        resources: {
            "en-US": {
                framework: en_US,
            },
            "en-GB": {
                framework: en_GB,
            },
            "en-AU": {
                framework: en_AU,
            },
            "de-DE": {
                framework: de_DE,
            },
            "fr-CA": {
                framework: fr_CA,
            },
            "es-US": {
                framework: es_US,
            },
            "pt-BR": {
                framework: pt_BR,
            },
            "fi-FI": {
                framework: fi_FI,
            },
            "ja-JP": {
                framework: ja_JP,
            },
            "it-IT": {
                framework: it_IT,
            },
            "hi-IN": {
                framework: hi_IN,
            },
            "tr-TR": {
                framework: tr_TR,
            },
            "uk-UA": {
                framework: uk_UA,
            },
            "zh-CN": {
                framework: zh_CN,
            },
            "id-ID": {
                framework: id_ID,
            },
            "et-EE": {
                framework: et_EE,
            },
            "fr-FR": {
                framework: fr_FR,
            },
            "es-ES": {
                framework: es_ES,
            },
            "sv-SE": {
                framework: sv_SE,
            },
            "ru-RU": {
                framework: ru_RU,
            },
            "vi-VN": {
                framework: vi_VN,
            },
            "ar-SA": {
                framework: ar_SA,
            },
            "pl-PL": {
                framework: pl_PL,
            },
            "es-MX": {
                framework: es_MX,
            },
            "no-NO": {
                framework: no_NO,
            },
            "ro-RO": {
                framework: ro_RO,
            },
            "ko-KR": {
                framework: ko_KR,
            },
            "th-TH": {
                framework: th_TH,
            },
            "cs-CZ": {
                framework: cs_CZ,
            },
            "hu-HU": {
                framework: hu_HU,
            },
            "zh-TW": {
                framework: zh_TW,
            },
            "da-DK": {
                framework: da_DK,
            },
            "pt-PT": {
                framework: pt_PT,
            },
            "sl-SI": {
                framework: sl_SI,
            },
            "nl-NL": {
                framework: nl_NL,
            },
            "mk-MK": {
                framework: mk_MK,
            },
            "sr-RS": {
                framework: sr_RS,
            },
        },
        lng: Locales.EnglishUS,
        fallbackLng: Locales.EnglishUS,
        interpolation: {
            escapeValue: false,
            format: formatFunction,
        },
        initImmediate: true,
    });
}
/**
 * Types of locales.
 */
var Locales;
(function (Locales) {
    Locales["EnglishUS"] = "en-US";
    Locales["EnglishGB"] = "en-GB";
    Locales["EnglishAU"] = "en-AU";
    Locales["GermanDE"] = "de-DE";
    Locales["FrenchCA"] = "fr-CA";
    Locales["SpanishMX"] = "es-MX";
    Locales["SpanishUS"] = "es-US";
    Locales["PortugueseBR"] = "pt-BR";
    Locales["FinnishFI"] = "fi-FI";
    Locales["JapaneseJP"] = "ja-JP";
    Locales["ItalianIT"] = "it-IT";
    Locales["ArabicSA"] = "ar-SA";
    Locales["HindiIN"] = "hi-IN";
    Locales["TurkishTR"] = "tr-TR";
    Locales["UkrainianUA"] = "uk-UA";
    Locales["ChineseCN"] = "zh-CN";
    Locales["BahasaIndonesianID"] = "id-ID";
    Locales["EstonianEE"] = "et-EE";
    Locales["FrenchFR"] = "fr-FR";
    Locales["SpanishES"] = "es-ES";
    Locales["SwedishSE"] = "sv-SE";
    Locales["RussianRU"] = "ru-RU";
    Locales["VietnameseVN"] = "vi-VN";
    Locales["PolishPL"] = "pl-PL";
    Locales["NorwegianNO"] = "no-NO";
    Locales["RomanianRO"] = "ro-RO";
    Locales["SouthKoreanKR"] = "ko-KR";
    Locales["ThaiTH"] = "th-TH";
    Locales["CzechCZ"] = "cs-CZ";
    Locales["HungarianHU"] = "hu-HU";
    Locales["ChineseTW"] = "zh-TW";
    Locales["DanishDK"] = "da-DK";
    Locales["PortuguesePT"] = "pt-PT";
    Locales["SlovenianSI"] = "sl-SI";
    Locales["DutchNL"] = "nl-NL";
    Locales["MacedonianMK"] = "mk-MK";
    Locales["SerbianSR"] = "sr-RS";
})(Locales || (Locales = {}));
/**
 * Defines the default locales for WalkMe.
 * This needs to be explicitly defined, because WalkMe treats the default language different
 * than the rest of the languages.
 */
Locales.EnglishUS;
/**
 * Defines the default locale for the application.
 * This is will be used as a default locale if a locale can't be defined neither for user preferences,
 * nor for account locale
 */
var appDefaultLocale = Locales.EnglishUS;
/**
 * Defines the default English (USA) locale for the application.
 */
var englishUSLocale = {
    code: Locales.EnglishUS,
    label: "English (USA)",
};
/**
 * Define the default locales used when the i18n-service is not available or returns no locales
 */
var defaultLocales = [
    {
        code: Locales.ArabicSA,
        label: "لعربية (ARB)",
    },
    {
        code: Locales.BahasaIndonesianID,
        label: "Bahasa Indonesia (IDN)",
    },
    {
        code: Locales.ChineseCN,
        label: "中文 (CHN)",
    },
    {
        code: Locales.ChineseTW,
        label: "国语 (CHT)",
    },
    {
        code: Locales.CzechCZ,
        label: "Čeština (CZE)",
    },
    {
        code: Locales.DanishDK,
        label: "Dansk (DAN)",
    },
    {
        code: Locales.GermanDE,
        label: "Deutsch (DEU)",
    },
    {
        code: Locales.EstonianEE,
        label: "Eesti (EST)",
    },
    {
        code: Locales.EnglishAU,
        label: "English (AUS)",
    },
    {
        code: Locales.EnglishGB,
        label: "English (GBR)",
    },
    englishUSLocale,
    {
        code: Locales.SpanishMX,
        label: "Español (LA)",
    },
    {
        code: Locales.SpanishES,
        label: "Español (SPA)",
    },
    {
        code: Locales.FrenchCA,
        label: "Français (CAN)",
    },
    {
        code: Locales.FrenchFR,
        label: "Français (FRA)",
    },
    {
        code: Locales.MacedonianMK,
        label: "Македонски јазик (MKD)",
    },
    {
        code: Locales.HungarianHU,
        label: "Magyar (HUN)",
    },
    {
        code: Locales.HindiIN,
        label: "हिन्दी (IND)",
    },
    {
        code: Locales.ItalianIT,
        label: "Italiano (ITA)",
    },
    {
        code: Locales.JapaneseJP,
        label: "日本語 (JPN)",
    },
    {
        code: Locales.SouthKoreanKR,
        label: "한국어 (KOR)",
    },
    {
        code: Locales.DutchNL,
        label: "nederlandse (NLD)",
    },
    {
        code: Locales.NorwegianNO,
        label: "Norsk (NOR)",
    },
    {
        code: Locales.PolishPL,
        label: "Polski (POL)",
    },
    {
        code: Locales.PortugueseBR,
        label: "Português (BRA)",
    },
    {
        code: Locales.PortuguesePT,
        label: "Português (POR)",
    },
    {
        code: Locales.RussianRU,
        label: "Русский (RUS)",
    },
    {
        code: Locales.RomanianRO,
        label: "Română (RON)",
    },
    {
        code: Locales.FinnishFI,
        label: "Suomi (FIN)",
    },
    {
        code: Locales.SlovenianSI,
        label: "Slovenščina (SVN)",
    },
    {
        code: Locales.SwedishSE,
        label: "Svenska (SWE)",
    },
    {
        code: Locales.SerbianSR,
        label: "Serbian (Serbia)",
    },
    {
        code: Locales.VietnameseVN,
        label: "Tiếng Việt (VIE)",
    },
    {
        code: Locales.TurkishTR,
        label: "Türkçe (TRK)",
    },
    {
        code: Locales.ThaiTH,
        label: "ภาษาไทย (THA)",
    },
    {
        code: Locales.UkrainianUA,
        label: "Українська (UKR)",
    },
    {
        code: TEST_MODE_LOCALE,
        label: "Test Mode",
    },
];
/**
 * @deprecated we no longer need i18next to format non-string types
 * Non-string types should be formatted using @workforcesoftware/localization-framework before
 * being passed into translate()
 * TODO: Remove this after all teams have started using hooks from
 *  @workforcesoftware/localization-framework
 */
var formatNumber = function (param, format) {
    switch (format) {
        case FORMAT_NUMBER:
            return formatNumber$1(param, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            });
        case FORMAT_DECIMAL:
            return formatNumber$1(param, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        case FORMAT_DECIMAL_NORMALIZED:
            return formatNumber$1(param, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            });
    }
    throw new Error("Incorrect format provided: " + format);
};
/**
 * @deprecated we no longer need i18next to format non-string types
 * Non-string types should be formatted using @workforcesoftware/localization-framework before
 * being passed into translate()
 * TODO: Remove this after all teams have started using hooks from
 *  @workforcesoftware/localization-framework
 */
var formatDate = function (date, format) {
    if (isValidDate(date)) {
        switch (format) {
            case FORMAT_DATE:
                return formatDateTime(date);
            case FORMAT_DATE_NUMERIC:
                return formatDateTime(date, {
                    year: "numeric",
                    month: "numeric",
                    day: "numeric",
                });
            case FORMAT_DATE_SHORT:
                return formatDateTime(date, {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                });
            case FORMAT_TIME:
                return formatDateTime(date, {
                    hour: "numeric",
                    minute: "numeric",
                });
        }
        throw new Error("Incorrect format provided: " + format);
    }
    else {
        throw new Error("Unable to format invalid date as " + format);
    }
};
/**
 * @deprecated we no longer need i18next to format non-string types
 * Non-string types should be formatted using @workforcesoftware/localization-framework before
 * being passed into translate()
 * TODO: Remove this after all teams have started using hooks from
 *  @workforcesoftware/localization-framework
 */
var formatFunction = function (param, format) {
    if (typeof param === "number") {
        return formatNumber(param, format);
    }
    if (param instanceof Date) {
        return formatDate(param, format);
    }
    throw new Error("Incorrect format provided: " + format);
};
var FORMAT_NUMBER = "number";
var FORMAT_DECIMAL = "decimal";
var FORMAT_DECIMAL_NORMALIZED = "decimal_normalized";
var FORMAT_DATE = "date";
var FORMAT_DATE_NUMERIC = "date_numeric";
var FORMAT_TIME = "time";
var FORMAT_DATE_SHORT = "date_short";
function isValidDate(date) {
    return !isNaN(date.getTime());
}

// Initialize i18next
create$2();
// Setup link between `localization-framework` and `i18next` that allows UI modules to register
// default translations via `localization-framework`.
localizationFramework.setDefaultTranslationsRegistrationHandler(function (moduleId, defaultTranslations) {
    Object.keys(defaultTranslations).forEach(function (language) {
        i18next__default.default.addResourceBundle(language, moduleId, defaultTranslations[language], true);
    });
});
/**
 * Gets the currently selected locale.
 * @return {Locales}
 */
var getLocale = function () {
    return getStore().getState().appLocalizationData.locale;
};
/**
 * Given a module, load the module's supported languages.
 *
 * @param module Module to load translations for.
 */
function loadTranslations(module) {
    if (!module.getI18nResources) {
        return;
    }
    var resources = module.getI18nResources();
    Object.keys(resources).forEach(function (language) {
        i18next__default.default.addResourceBundle(language, module.getId(), resources[language], true);
    });
}
/**
 * Create an I18n instance for use by the requested module.
 *
 * @param module Module to create the i18n instance for.
 */
var createI18n = function (module) {
    loadTranslations(module);
    return {
        translate: function (key, substitutions) {
            return translate(module.getId(), key, substitutions);
        },
        getTextDirection: function () { return i18next__default.default.dir(); },
    };
};
/**
 * Translates an item with a given key and moduleId.
 * This method must be used during the time of
 * component rendering and not earlier, in order to
 * avoid translating items to the wrong language.
 *
 * @deprecated Use the translate() function from @workforcesoftware/localization-framework instead
 * @param moduleId {string} The ID for the specific module.
 * @param key {string} The translation key for the specific item.
 * @param substitutions Substitutions for the given module.
 * @returns {string} The translation for the given item key and module.
 */
var translate = function (moduleId, key, substitutions) {
    var moduleIdKey = moduleId + ":" + key;
    var currentLocale = String(getLocale());
    if (TEST_MODE_LOCALE === currentLocale) {
        return moduleIdKey;
    }
    // Try accessing a key with a target field, otherwise default to normal key
    return i18next__default.default.t([moduleIdKey + ".TARGET", moduleIdKey], substitutions);
};

/**
 * Function that returns string as title case if currentLocale starts with en-
 * note doesn't remove capitals
 *
 * @param title {string} - The title you would like to be in title case
 *
 * @returns {string}
 */
var convertToTitleCase = function (title) {
    var locale = getStore().getState().appLocalizationData
        .locale;
    if (locale.startsWith("en-")) {
        return titlecase.toTitleCase(title);
    }
    return title;
};

var LINK = "LINK/";
var HELP_NAV_SUFFIX = "_HELP";
var CUSTOM_HELP_NAV_PREFIX = "CUSTOM_HELP";
var getExternalUrlForNavigationAndUserItems = function (navItem) {
    var state = getFrameworkInstance().getStore().getState();
    var authManager = AuthenticationManager.getInstance();
    // Navigation item retrieval happens after we authenticate, so we will have accountInfo
    var _a = authManager.getAccountInfo(), organizationId = _a.organizationId, accountData = _a.accountData;
    /**
     * The identity token exists in most cases except for when a user logs out in a separate tab.
     * MainView can call this when {@link AuthenticationManager} is logged out but before PrivateRoute
     * responds to the change and unmounts MainView. This results in an error trying to access the
     * `wfs_id` of the identity token. We just need to add error handling to this function
     * (pass an empty string as wfs_id if it doesn't exist) so that PrivateRoute can handle the changes
     * and prevent the application from getting into a white screen error.
     * TODO: Make this function accept the identity token and AccountInfo from wherever it gets called
     * to prevent this undefined check.
     */
    var decodedToken = authManager.getOidcUserInfo();
    if (navItem.externalPage &&
        navItem.externalPage.sourceUrlKey &&
        navItem.externalPage.relativePageUrl) {
        var sourceSystemUrl = getFrameworkInstance()
            .getConfiguration()
            .get(navItem.externalPage.sourceUrlKey, SERVICE_BASE_URL);
        var relativePageUrl = navItem.externalPage.relativePageUrl;
        if (isDemoUser(organizationId)) {
            // only attempt to access mockedAccountData when we know we're using a
            // mocked login
            var mockWtaBaseUrl = state.mockedAccountData.data.wtaBaseUrl;
            return getFullDemoURL(navItem.externalPage.sourceUrlKey, sourceSystemUrl, relativePageUrl, mockWtaBaseUrl);
        }
        return getFullServiceURL(accountData, (decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken.wfs_id) || "", navItem.externalPage.sourceUrlKey, sourceSystemUrl, relativePageUrl);
    }
    return undefined;
};
var isNavigationSkeletonItem = function (navItem) {
    return "subMenu" in navItem &&
        Array.isArray(navItem.subMenu) &&
        navItem.subMenu.length !== 0;
};
var isNestedMenuItem = function (navItem) {
    return "nestedSubMenu" in navItem &&
        Array.isArray(navItem.nestedSubMenu) &&
        navItem.nestedSubMenu.length !== 0;
};
var convertNavigationDataToNavigationItems = function (navItemsState, navItems) {
    // Fail fast if state is empty
    if (Object.keys(navItemsState).length === 0) {
        return [];
    }
    var navigationItems = [];
    navItems.forEach(function (navItem) {
        if (!navItemsState[navItem.id]) {
            return;
        }
        var getNestedSubNavItems = [];
        var getSubNavItems = [];
        if (isNavigationSkeletonItem(navItem)) {
            getSubNavItems = convertNavigationDataToNavigationItems(navItemsState, navItem.subMenu);
        }
        else if (isNestedMenuItem(navItem)) {
            getNestedSubNavItems = convertNavigationDataToNavigationItems(navItemsState, navItem.nestedSubMenu);
        }
        // replacing id with actual data
        var newNavItem = navItemsState[navItem.id];
        var routeId = newNavItem.route ||
            (newNavItem.externalPage || newNavItem.embeddedPage
                ? RouteIds.ExternalPage
                : "");
        if (!routeId && !isMenu(navItem) && !newNavItem.url) {
            global.console.warn("Route not defined for Navigation item with Route-id: ", newNavItem.id);
        }
        var title = newNavItem.translationKey
            ? translate("framework", newNavItem.translationKey)
            : newNavItem.title;
        navigationItems.push({
            getDisplayText: function () { return convertToTitleCase(title); },
            getId: function () { return navItem.id; },
            getRouteId: function () { return routeId; },
            getExternalUrl: function () {
                return newNavItem.embeddedPage
                    ? newNavItem.url
                    : getExternalUrlForNavigationAndUserItems(newNavItem);
            },
            getSubNavigationItems: function () { return getSubNavItems; },
            getNestedSubNavigationItems: function () { return getNestedSubNavItems; },
            externalNavigationUrl: newNavItem.embeddedPage
                ? undefined
                : newNavItem.url,
            hideInMobile: newNavItem.hideInMobile,
            hideInDesktop: newNavItem.hideInDesktop,
            isLegacyTimesheet: navItem.id === NAV_MY_TIME_SHEET_LNK_ID ? true : false,
            isGroupTimesheetEntry: navItem.id === NAV_GRP_TIME_ENTRY_LNK_ID ? true : false,
        });
    });
    return navigationItems;
};
var convertUserMenuDataToUserMenuItems = function (userMenuItems) {
    var navigationItems = [];
    getUserMenuSkeleton().forEach(function (skeletonItem) {
        var userMenuItem = userMenuItems[skeletonItem.id];
        if (!userMenuItem) {
            return;
        }
        var routeId = userMenuItem.route ||
            (userMenuItem.externalPage ? RouteIds.ExternalPage : "");
        if (!routeId) {
            global.console.warn("Route not defined for UserMenu item with Route-id: ", userMenuItem.id);
        }
        var title = userMenuItem.translationKey
            ? translate("framework", userMenuItem.translationKey)
            : userMenuItem.title;
        navigationItems.push({
            getDisplayText: function () { return convertToTitleCase(title); },
            getId: function () { return userMenuItem.id; },
            getRouteId: function () { return routeId; },
            getExternalUrl: function () {
                return getExternalUrlForNavigationAndUserItems(userMenuItem);
            },
            externalNavigationUrl: userMenuItem.url,
            hideInMobile: userMenuItem.hideInMobile,
        });
    });
    var helpLinks = getHelpLinkIds(userMenuItems);
    var helpNavigationItems = [];
    helpLinks.forEach(function (helpItem) {
        var userMenuItem = userMenuItems[helpItem.id];
        var title = userMenuItem.translationKey
            ? translate("framework", userMenuItem.translationKey)
            : userMenuItem.title;
        var routeId = userMenuItem.route ||
            (userMenuItem.externalPage ? RouteIds.ExternalPage : "");
        if (!routeId) {
            global.console.warn("Route not defined for UserMenu item with Route-id: ", userMenuItem.id);
        }
        helpNavigationItems.push({
            getDisplayText: function () { return convertToTitleCase(title); },
            getId: function () { return helpItem.id; },
            getRouteId: function () { return routeId; },
            getExternalUrl: function () {
                return getExternalUrlForNavigationAndUserItems(userMenuItem);
            },
            hideInMobile: userMenuItem.hideInMobile,
        });
    });
    var customHelpLinks = getCustomHelpLinkIds(userMenuItems);
    var customHelpNavigationItems = [];
    customHelpLinks.forEach(function (customHelpLink) {
        var userMenuItem = userMenuItems[customHelpLink.id];
        customHelpNavigationItems.push({
            getDisplayText: function () { return userMenuItem.title; },
            getId: function () { return customHelpLink.id; },
            getRouteId: function () { return ""; },
            externalNavigationUrl: userMenuItem.url,
            hideInMobile: userMenuItem.hideInMobile,
        });
    });
    var finalHelpNavigationItems = helpNavigationItems.concat(customHelpNavigationItems);
    return finalHelpNavigationItems.concat(navigationItems);
};
var getHelpLinkIds = function (navItemsMap) {
    var helpLinks = [];
    for (var key in navItemsMap) {
        if (key.startsWith(LINK) && key.endsWith(HELP_NAV_SUFFIX)) {
            helpLinks.push({ id: key });
        }
    }
    return helpLinks;
};
/**
 * Get Custom Help Links
 * @param navItemsMap navigation item map
 * @returns sorted custom help links
 */
var getCustomHelpLinkIds = function (navItemsMap) {
    var customHelpLinks = [];
    for (var key in navItemsMap) {
        if (key.startsWith(CUSTOM_HELP_NAV_PREFIX)) {
            customHelpLinks.push({ id: key });
        }
    }
    // sort custom help links by ids
    customHelpLinks.sort(function (item1, item2) {
        return item1.id.toUpperCase() < item2.id.toUpperCase()
            ? -1
            : item1.id.toUpperCase() > item2.id.toUpperCase()
                ? 1
                : 0;
    });
    return customHelpLinks;
};
/* Functions for mocked data */
var convertMockedNavigationDataToNavigationItems = function (navItems, state) {
    return navItems.map(function (navItem, index) {
        var getSubNavItems = navItem.subMenu && navItem.subMenu.length
            ? // recurse on subMenu
                convertMockedNavigationDataToNavigationItems(navItem.subMenu)
            : [];
        return {
            getDisplayText: function () { return navItem.title; },
            getId: function () { return index + "-" + navItem.title; },
            getRouteId: function () {
                return navItem.route ||
                    (navItem.externalPage ? RouteIds.ExternalPage : RouteIds.Home);
            },
            getExternalUrl: function () { return getExternalUrlForNavigationAndUserItems(navItem); },
            getSubNavigationItems: function () { return getSubNavItems; },
            externalNavigationUrl: navItem.url,
            hideInMobile: false,
        };
    });
};
var convertMockedUserMenuDataToUserMenuItems = function (menuItems) {
    if (menuItems) {
        return menuItems.map(function (menuItem, index) {
            var routeId = "";
            var id = "";
            if (menuItem.externalPage) {
                routeId = RouteIds.ExternalPage;
            }
            else if (menuItem.title === "Preferences") {
                routeId = RouteIds.Preferences;
            }
            // The logout mocked User Menu Item does not produce an ID of `LINK/SIGN_OUT`
            // so the MainView does not call AuthenticationManager.logout() when we click
            // the item. Hard Coding it to have the same ID as if we got it from the Navigation
            // Service allows us to call the logout function in mocked data
            if (menuItem.title === "Logout") {
                id = "LINK/SIGN_OUT";
            }
            else {
                id = index + "-" + menuItem.title;
            }
            return {
                getDisplayText: function () { return menuItem.title; },
                getId: function () { return id; },
                getRouteId: function () { return routeId; },
                getExternalUrl: function () {
                    return getExternalUrlForNavigationAndUserItems(menuItem);
                },
                externalNavigationUrl: menuItem.url,
                hideInMobile: false,
            };
        });
    }
    return [];
};

/**
 * Define the initial state if none provided
 */
var initialState$c = {
    isOpened: false,
    event: null,
    sidebarProps: null,
    drawerProps: null,
};
/**
 * Create a reducer that manipulates the sidebar integration state
 *
 * @param {SidebarIntegrationState} state The current state
 * @param {SidebarIntegrationAction} action The action that has triggered the state change
 *
 * @returns {SidebarIntegrationState} The modified state
 */
var reducer$d = function (state, action) {
    if (state === void 0) { state = initialState$c; }
    switch (action.type) {
        case exports.SidebarIntegrationActionTypes.OpenSidebar: {
            return __assign(__assign({}, state), { isOpened: true, event: action.event, sidebarProps: action.sidebarProps, drawerProps: action.drawerProps });
        }
        case exports.SidebarIntegrationActionTypes.CloseSidebar: {
            return __assign(__assign({}, state), { isOpened: false });
        }
    }
    return state;
};

function useTheme() {
    return React.useContext(lighthouseComponentLibrary.ThemeContext);
}

/**
 * React context for Feature Flags
 */
var FeatureFlagsContext = React__namespace.default.createContext(undefined);
/**
 * Custom React hook that returns the Feature Flags from {@link FeatureFlagsContext}.
 * @return The Feature Flags to {@link FeatureFlagsContext}
 */
function useFeatureFlagsContext() {
    return React.useContext(FeatureFlagsContext);
}

function getNamedFeatureFlags(rawFeatureFlags, names) {
    if (!rawFeatureFlags) {
        return undefined;
    }
    var result = {};
    var missingNames = [];
    // Build a result containing ONLY the requested flags, while also building
    // a list of any invalid flag names that were requested.
    // This filtered object simplifies/optimizes the implementation of the Proxy below...
    names.forEach(function (name) {
        var enabled = rawFeatureFlags[name];
        if (enabled === undefined) {
            result[name] = false;
            missingNames.push(name);
        }
        else {
            result[name] = enabled;
        }
    });
    // Log errors to both console and dynatrace if any of the feature flags were not found
    if (missingNames.length) {
        var baseErrorMessage = "The following requested feature flags do not exist: " + missingNames.join(", ");
        console.error(baseErrorMessage + "\n- Did you spell the feature flag name correctly?\n- Is this a new feature flag that hasn't been published yet?\n- Are you running a unit test that needs to mock a value for this feature flag?");
        reportCustomError("Missing requested feature flags", baseErrorMessage);
    }
    // Wrap the result in a proxy that allows only the requested flags to be accessed.
    //
    // It is possible for projects with "suppressImplicitAnyIndexErrors"
    // TS compiler option enabled to write code that attempts to access properties that do
    // not exist on the returned type (without triggering a compiler error). At runtime,
    // such property access would return `undefined` which would most likely be treated
    // "gracefully" as if the flag was false/off, without any console errors/etc.
    //
    // This runtime check is a last defense to warn developers during testing that they
    // forget to request a feature flag that they are attempting to access.
    return new Proxy(result, {
        get: function (target, key) {
            var value = target[key];
            if (value === undefined) {
                throw new Error("Attempted to access a feature flag that was not requested: " + String(key));
            }
            return value;
        },
    });
}

/**
 * Custom React hook that returns the Feature Flags from {@link FeatureFlagsContext}
 * by strictly define only the flags of interest in the consumer component.
 *
 * Use this instead of {@link useNamedFeatureFlags} if your component may be
 * rendered before feature flags are loaded, but you'll have to deal with the
 * flags object being potentially undefined.
 *
 * @param names List of Feature Flag names the consumer is interested in
 * The list of names is validated against the existence in the {@link FeatureFlagsContext}
 *
 * @return A type-safe mapping of feature flag name -> boolean for the specified flags,
 *         or undefined if the flags are not loaded yet.
 * @throws {Error} if a provided name is invalid (doesn't exist in the list of flags)
 */
function useNamedFeatureFlagsMaybeUndefined() {
    var names = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        names[_i] = arguments[_i];
    }
    var featureFlags = useFeatureFlagsContext();
    return React.useMemo(function () {
        return getNamedFeatureFlags(featureFlags, names);
    }, [featureFlags, names]);
}

/**
 * Custom React hook that returns the Feature Flags from {@link FeatureFlagsContext}
 * by strictly define only the flags of interest in the consumer component.
 *
 * Use this instead of {@link useNamedFeatureFlagsMaybeUndefined} if your
 * component is guaranteed to always be rendered AFTER feature flags are loaded,
 * so you don't have to deal with the flags object being potentially undefined.
 *
 * @param names List of Feature Flag names the consumer is interested in
 * The list of names is validated against the existence in the {@link FeatureFlagsContext}
 *
 * @return A type-safe mapping of feature flag name -> boolean for the specified flags,
 *         or undefined if the flags are not loaded yet.
 * @throws {Error} if feature flags are not loaded yet.
 * @throws {Error} if a provided name is invalid (doesn't exist in the list of flags)
 */
function useNamedFeatureFlags() {
    var names = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        names[_i] = arguments[_i];
    }
    var featureFlags = useNamedFeatureFlagsMaybeUndefined.apply(void 0, names);
    // Temporary hack: Pretend all requested feature flags are off if we haven't
    // loaded feature flags yet.
    // TODO: After EAG-5121 is fixed, change this to throw an error if the
    //       featureFlags are undefined, because we will now guarantee that
    //       the app is initialized before any component renders that would
    //       be using this hook.
    return React.useMemo(function () {
        if (!featureFlags) {
            var result_1 = {};
            names.forEach(function (name) {
                result_1[name] = false;
            });
            return result_1;
        }
        return featureFlags;
    }, [featureFlags]);
}

/**
 * A custom hook which returns the WFX Application URL specific to the current
 * environment. The accountInfo must be present and the isWfxFeatureEnabled flag
 * enabled or this hook will return undefined making WFX features relying on it
 * unavailable to the user or nonfunctional.
 *
 * @returns URL for WFX app based on environment or undefined if WFX feature flag is
 *  not enabled or account information does not exist
 */
function useWfxAppUrl() {
    var accountInfo = useAuthenticationManagerAccountInfo();
    var featureFlags = useNamedFeatureFlags.apply(void 0, Object.values(exports.WfxFeatureFlagKey));
    var isWfxFeatureEnabled = isAnyWfxFeatureFlagEnabled(featureFlags);
    if (!isWfxFeatureEnabled || !accountInfo) {
        return undefined;
    }
    return accountInfo.accountData.environment
        ? "https://web.staging.ex.wfs.cloud" /* Staging */
        : "https://web.ex.wfs.cloud" /* Production */;
}

/**
 * All the available actions that can be triggered to do with organization credentials panel
 */
var WfxUnreadDMIdsActionTypes;
(function (WfxUnreadDMIdsActionTypes) {
    WfxUnreadDMIdsActionTypes["SetIds"] = "setDMIds";
    WfxUnreadDMIdsActionTypes["RemoveId"] = "removeDMId";
    WfxUnreadDMIdsActionTypes["SelectedDMId"] = "selectedDMId";
})(WfxUnreadDMIdsActionTypes || (WfxUnreadDMIdsActionTypes = {}));

/**
 * Define the initial state if none provided
 */
var initialState$b = {
    ids: [],
    selectedDMId: "",
};
/**
 * Create a reducer that manipulates the impersonation dialog
 *
 * @param {WfxUnreadDMIdsState}  state  The current state
 * @param {WfxUnreadIdsAction} action The action that has triggered the state change
 *
 * @returns {WfxUnreadDMIds} The modified WfxUnreadDMIds
 */
var reducer$c = function (state, action) {
    if (state === void 0) { state = initialState$b; }
    /**
     * Check which Action has been triggered
     */
    switch (action.type) {
        case WfxUnreadDMIdsActionTypes.SetIds: {
            return __assign(__assign({}, state), { ids: getUnreadDMIds(action.ids, state.ids) });
        }
        case WfxUnreadDMIdsActionTypes.RemoveId: {
            return __assign(__assign({}, state), { ids: state.ids.filter(function (id) { return id !== action.id; }) });
        }
        case WfxUnreadDMIdsActionTypes.SelectedDMId: {
            return __assign(__assign({}, state), { selectedDMId: action.id });
        }
        default: {
            return state;
        }
    }
};
var getUnreadDMIds = function (unreadDMIds, storedDMIds) {
    // Just send the unreadDMIds whatever we received intially (when user logged in)
    if (unreadDMIds.length > 1) {
        return unreadDMIds;
    }
    // Add unique DM ids into the Redux store.
    // when we connect with WebSocket initially, we would get multiple DM Ids, but after
    // that we only get a single DM id at a time
    return unreadDMIds.length === 1 && !storedDMIds.includes(unreadDMIds[0])
        ? storedDMIds.concat(unreadDMIds[0])
        : storedDMIds;
};

/**
 * Set Unread DM Ids
 *
 * @returns {{type: WfxUnreadDMIdsActionTypes}}
 */
function setUnreadDMIds(ids) {
    return function (dispatch) {
        var action = {
            ids: ids,
            type: WfxUnreadDMIdsActionTypes.SetIds,
        };
        dispatch(action);
        return Promise.resolve();
    };
}
function removeReadDMId(id) {
    return function (dispatch) {
        var action = {
            id: id,
            type: WfxUnreadDMIdsActionTypes.RemoveId,
        };
        dispatch(action);
        return Promise.resolve();
    };
}
function setSelectedDMId(id) {
    return function (dispatch) {
        var action = {
            id: id,
            type: WfxUnreadDMIdsActionTypes.SelectedDMId,
        };
        dispatch(action);
        return Promise.resolve();
    };
}

/**
 * A custom hook that imparts local storage event listening behaviour
 *
 * @param key - a local storage item name
 */
function useLocaleStorageEventListener(key) {
    var _a = React.useState(undefined), event = _a[0], setEvent = _a[1];
    var _b = React.useState(window.localStorage.getItem(key)), currentValue = _b[0], setCurrentValue = _b[1];
    React.useEffect(function () {
        var handleEventDispatch = function (e) {
            if (e.key === key) {
                setEvent(e);
                setCurrentValue(e.newValue);
            }
        };
        window.addEventListener("storage", handleEventDispatch, false);
        return function () { return window.removeEventListener("storage", handleEventDispatch); };
    }, []);
    return { event: event, currentValue: currentValue };
}

/**
 * Check if there is a valid Wfx session in the local storage. This is used to determine
 * when to generate a new wfx session for the experience library
 * @returns true if there is a valid wfx session, false otherwise
 */
var hasValidWfxSession = function () {
    var _a, _b, _c;
    var authManager = AuthenticationManager.getInstance();
    var existingWfxSession = window.localStorage.getItem(experience.LOCAL_STORAGE_KEYS.WFX_SESSION);
    var existingWfxId = (_a = JSON.parse(existingWfxSession || "{}")) === null || _a === void 0 ? void 0 : _a.id;
    var existingWfsId = (_b = JSON.parse(window.localStorage.getItem(experience.LOCAL_STORAGE_KEYS.WFS_WFX_SESSION) || "{}")) === null || _b === void 0 ? void 0 : _b.wfsUserId;
    // compares the wfs id of the JWT token with the one stored in local storage.
    // If the wfs ids are the same, it means it's the same user so we don't want to generate
    // a new wfx session and if it's not the same then it means a different user logged in
    // and the current wfx session is not longer valid
    var currentWfsIdMatchesStored = ((_c = authManager.getOidcUserInfo()) === null || _c === void 0 ? void 0 : _c.wfs_id) === existingWfsId;
    return (existingWfxSession !== null &&
        existingWfxId &&
        existingWfsId !== null &&
        currentWfsIdMatchesStored);
};
/**
 * The initialization includes initializing the API module of the Experience library,
 * as well as logging into Experience to retrieve its access token, so as to enable
 * any component/module to simply import relevant services from the @foko/experience
 * package and call the functions as needed, without having to worry about fetching/maintaining
 * Experience access tokens or knowing routes/request structures for the API calls.
 */
var initializeExperience = function (isValidWfxSession) { return __awaiter(void 0, void 0, void 0, function () {
    var authManager, accessToken, accountInfo, accountId, decodedToken, wfsUserId, wfxApiBaseUrl, e_1;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                authManager = AuthenticationManager.getInstance();
                accessToken = window.localStorage.getItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY);
                accountInfo = authManager.getAccountInfo();
                accountId = (_b = (_a = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.accountData) === null || _a === void 0 ? void 0 : _a.accountDetail) === null || _b === void 0 ? void 0 : _b.externalId;
                decodedToken = authManager.getOidcUserInfo();
                wfsUserId = decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken.wfs_id;
                wfxApiBaseUrl = ((_c = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.accountData) === null || _c === void 0 ? void 0 : _c.environment) ? WFX_API_BASE_URL_STAGING
                    : WFX_API_BASE_URL_PROD;
                _d.label = 1;
            case 1:
                _d.trys.push([1, 3, , 4]);
                return [4 /*yield*/, experience.initWfxLibraryFromWfs(accessToken, wfsUserId, accountId, wfxApiBaseUrl, WFX_APP_ID, isValidWfxSession)];
            case 2:
                _d.sent();
                return [3 /*break*/, 4];
            case 3:
                e_1 = _d.sent();
                console.error("Failed to initialize Experience Library: " + e_1);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };

/** Currently when user moves from Hub/any menu items to DM screen or vice versa, navbar is re-rendered everytime
 *  hence the DM icon's active state is being lost, due to that reason, I have to use below band-aid solution (background-color) to
 *  just set active state of DM icon.
 *  Note: This should be replaced by proper solution when navbar redesign is implemented.
 */
var StyledIconButton = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.IconButton)(templateObject_1$H || (templateObject_1$H = __makeTemplateObject(["\n  &&& {\n    display: flex;\n    padding: 0.6rem;\n    margin-right: 0.7rem\n    background-color: ", ";\n    border-radius: ", ";\n    cursor: pointer;\n    &:hover {\n      background-color: ", ";\n    }\n    &:focus {\n      background-color: ", ";\n    }\n  }\n  & .MuiSvgIcon-root {\n    color: ", ";\n  }\n"], ["\n  &&& {\n    display: flex;\n    padding: 0.6rem;\n    margin-right: 0.7rem\n    background-color: ",
    ";\n    border-radius: ", ";\n    cursor: pointer;\n    &:hover {\n      background-color: ",
    ";\n    }\n    &:focus {\n      background-color: ",
    ";\n    }\n  }\n  & .MuiSvgIcon-root {\n    color: ", ";\n  }\n"])), function (props) {
    return window.location.href.indexOf(encodeURIComponent(RouteIds.wfxMessageRoute)) > -1
        ? lighthouseComponentLibrary.getThemeFromProps(props).components.navigation.hoverColor
        : "transparent";
}, polished.rem(4), function (props) {
    return lighthouseComponentLibrary.getThemeFromProps(props).components.navigation.hoverColor;
}, function (props) {
    return lighthouseComponentLibrary.getThemeFromProps(props).components.navigation.hoverColor;
}, function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.white; });
var WfXIcon = lighthouseComponentLibrary.styled(reactFontawesome.FontAwesomeIcon)(templateObject_2$u || (templateObject_2$u = __makeTemplateObject(["\n  && {\n    color: white;\n    @media (forced-colors: active) {\n      color: CanvasText;\n    }\n  }\n"], ["\n  && {\n    color: white;\n    @media (forced-colors: active) {\n      color: CanvasText;\n    }\n  }\n"])));
var StyledBadge = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Badge)(templateObject_3$n || (templateObject_3$n = __makeTemplateObject(["\n  & .MuiBadge-anchorOriginTopRightRectangle {\n    top: 0.6rem;\n    margin-right: 1rem;\n  }\n"], ["\n  & .MuiBadge-anchorOriginTopRightRectangle {\n    top: 0.6rem;\n    margin-right: 1rem;\n  }\n"])));
StyledIconButton.displayName = "WfxIconWrapper";
var WfxDMs = function (props) {
    var wfxUrl = useWfxAppUrl();
    var dispatch = reactRedux.useDispatch();
    var unreadDMIds = useTypedSelector(function (state) { return state.wfxUnreadDMIds.ids; });
    var wfsWfxSession = useLocaleStorageEventListener(experience.LOCAL_STORAGE_KEYS.WFS_WFX_SESSION).currentValue;
    var translate = useTranslateFunction();
    React.useEffect(function () {
        if (hasValidWfxSession()) {
            (function () { return __awaiter(void 0, void 0, void 0, function () {
                var badges, newActivityDmIds, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, experience.OrganizationsService.getBadges(false, true, false, false)];
                        case 1:
                            badges = _a.sent();
                            newActivityDmIds = badges.dms.hasNewActivity;
                            dispatch(setUnreadDMIds(newActivityDmIds));
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _a.sent();
                            console.warn("Failed to load WFX User badges.", error_1);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); })();
        }
    }, [wfsWfxSession]);
    React.useEffect(function () {
        var subscription = experience.Socket.subscribe(experience.Socket.Events.INBOX_BADGE_UPDATE, function (dmIds) {
            var selectedDMId = getStore().getState()
                .wfxUnreadDMIds.selectedDMId;
            var isWfxDMScreen = window.location.href.indexOf(encodeURIComponent(RouteIds.wfxMessageRoute)) > -1;
            // Don't update the badge count for the DM that user is actively using
            if (isWfxDMScreen && dmIds.length === 1 && dmIds[0] === selectedDMId) {
                return;
            }
            dispatch(setUnreadDMIds(dmIds));
        });
        return function () {
            if (subscription) {
                subscription.unsubscribe();
            }
        };
    }, []);
    var isWfxDmFlagEnabled = useNamedFeatureFlags(exports.WfxFeatureFlagKey.DIRECT_MESSAGING).wfx;
    if (!wfxUrl || !isWfxDmFlagEnabled || !hasValidWfxSession()) {
        // Don't render the WFX icon
        // * if there's no WFX URL available (e.g., account not yet known)
        // * if WFX DM feature flag is not enabled
        // * if the WFX session has not been established yet
        return null;
    }
    var wfxLink = "" + wfxUrl + RouteIds.wfxMessageRoute;
    var handleWfxIconClick = function () {
        embedExternalPage(encodeURI(wfxLink));
    };
    var iconTitle = translate("NAV_LINKS.WFX");
    return (React__namespace.default.createElement(StyledBadge, { badgeContent: unreadDMIds ? unreadDMIds.length : "", size: "medium" },
        React__namespace.default.createElement(StyledIconButton, { onClick: handleWfxIconClick, size: props.isViewportMediumWidth ? "medium" : "small", "data-qa": "wfxNavIcon", id: props.isViewportMediumWidth ? "wfx-nav-icon-md" : "wfx-nav-icon-sm", title: iconTitle, "aria-label": iconTitle },
            React__namespace.default.createElement(WfXIcon, { icon: freeSolidSvgIcons.faCommentAlt }))));
};
var templateObject_1$H, templateObject_2$u, templateObject_3$n;

var BetsyDraper = "data:image/jpeg;base64,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";

var Avatars = {
    BetsyDraper: BetsyDraper,
};

var getUserAvatar = function (name) {
    return Avatars[name];
};

var StyledMenuItem = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.MenuItem)(templateObject_1$G || (templateObject_1$G = __makeTemplateObject(["\n  &&& {\n    white-space: normal;\n    line-height: ", ";\n    padding: ", " ", " ", " ", ";\n  }\n"], ["\n  &&& {\n    white-space: normal;\n    line-height: ", ";\n    padding: ", " ", " ", " ", ";\n  }\n"])), polished.rem("24px"), polished.rem("14px"), polished.rem("22px"), polished.rem("14px"), polished.rem("32px"));
var StyledSubMenu = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.SubMenu)(templateObject_2$t || (templateObject_2$t = __makeTemplateObject(["\n  @media (max-width: ", ") {\n    &&& {\n      white-space: normal;\n      line-height: ", ";\n      padding: ", " ", " ", " ", ";\n    }\n    &&&.menu {\n      width: 100%;\n    }\n  }\n"], ["\n  @media (max-width: ", ") {\n    &&& {\n      white-space: normal;\n      line-height: ", ";\n      padding: ", " ", " ", " ", ";\n    }\n    &&&.menu {\n      width: 100%;\n    }\n  }\n"])), lighthouseComponentLibrary.getMaxBreakpoint("sm"), polished.rem("24px"), polished.rem("14px"), polished.rem("22px"), polished.rem("14px"), polished.rem("24px"));
// TODO: remove after we no longer the help link to exist
var HelpLink = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.MenuItem)(templateObject_3$m || (templateObject_3$m = __makeTemplateObject(["\n  &&& {\n    white-space: normal;\n    background: white;\n    color: #067eb0;\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  @media (max-width: ", ") {\n    &&& {\n      white-space: normal;\n      line-height: ", ";\n      padding: ", " ", " ", " ", ";\n      border-bottom: ", " solid grey;\n    }\n  }\n"], ["\n  &&& {\n    white-space: normal;\n    background: white;\n    color: #067eb0;\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  @media (max-width: ", ") {\n    &&& {\n      white-space: normal;\n      line-height: ", ";\n      padding: ", " ", " ", " ", ";\n      border-bottom: ", " solid grey;\n    }\n  }\n"])), lighthouseComponentLibrary.getMaxBreakpoint("sm"), polished.rem("24px"), polished.rem("14px"), polished.rem("22px"), polished.rem("14px"), polished.rem("48px"), polished.rem("1px"));
/**
 * Determine if the current ending of the route matches the link provided by the route context
 * @param link - the link we want to test
 * @param currentRoute - the current route of the app
 * return @boolean - true if the current route ends with the link, false otherwise
 */
function linkIsCurrentRoute(link, currentRoute) {
    return currentRoute.endsWith(link);
}
/**
 * Returns the URL to navigate to of the passed in navigation item
 *  or undefined if the specified navigation item does not exist in the route context
 * @param navItem - {@link NavigationItem} that we want to return the link for
 * @param routeContext - {@link RouteContextApi} the route context we use to get the link
 * @returns string | undefined
 */
function getLink(navItem, routeContext) {
    var _a;
    if (isMenu(navItem) && !navItem.externalNavigationUrl) {
        return undefined;
    }
    if (navItem.getRouteId() === RouteIds.ExternalPage) {
        if (navItem.getExternalUrl && navItem.getExternalUrl()) {
            return routeContext.findRouteByName(RouteIds.ExternalPage, encodeURIComponent(navItem.getExternalUrl()));
        }
        global.console.error("Navigation Item with ID: " + navItem.getId() + " has external page route ID but does not provide an external URL");
        return undefined;
    }
    if (navItem.getId() === "LINK/VISIER_ANALYTICS") {
        return getVisierAnalyticsUrl((_a = navItem.externalNavigationUrl) !== null && _a !== void 0 ? _a : "");
    }
    if (navItem.externalNavigationUrl) {
        return encodeURI(navItem.externalNavigationUrl);
    }
    return routeContext.findRouteByName(navItem.getRouteId());
}
function createNavItems(navItemData, isOnMobile, isHierarchicalAdminMenuFeatureEnabled, isLegacyLinksFeatureEnabled, routeContext, currentRoute, setIsResetPasswordDialogueOpen, closeSideBar, routeToLink, history, localization) {
    var MenuItemComponent = isHierarchicalAdminMenuFeatureEnabled
        ? lighthouseComponentLibrary.MenuItem
        : StyledMenuItem;
    return navItemData
        .map(function (navigationItem, index) {
        var _a;
        var item;
        var subNavigationItems = (_a = navigationItem.getSubNavigationItems) === null || _a === void 0 ? void 0 : _a.call(navigationItem);
        if (!!subNavigationItems && subNavigationItems.length) {
            var hasHelpLink_1 = false;
            var subNavItems = subNavigationItems
                .map(function (subNavItem) {
                var shouldBeActive;
                var link = getLink(subNavItem, routeContext);
                if (!!link) {
                    shouldBeActive = linkIsCurrentRoute(link, currentRoute);
                }
                // Hide mobile unfriendly links for mobile
                if (!isLegacyLinksFeatureEnabled) {
                    if (subNavItem.hideInMobile && isOnMobile) {
                        return null;
                    }
                }
                if (subNavItem.hideInDesktop && !isOnMobile) {
                    return null;
                }
                if (subNavItem.getId() === "LINK/RESET_PASSWORD") {
                    return (React__namespace.default.createElement(MenuItemComponent, { key: index + "-" + subNavItem.getRouteId() + "-dialog", title: subNavItem.getDisplayText(), id: "" + subNavItem.getRouteId() + subNavItem.getDisplayText(), "data-qa": "resetPasswordMenuItem", onClick: function () { return setIsResetPasswordDialogueOpen(true); }, active: shouldBeActive, disableLegacyView: isHierarchicalAdminMenuFeatureEnabled }));
                }
                if (subNavItem.getNestedSubNavigationItems &&
                    subNavItem.getNestedSubNavigationItems().length) {
                    var nestedSubNavItem = subNavItem
                        .getNestedSubNavigationItems()
                        .map(function (nestedItem) {
                        var shouldSubMenuBeActive;
                        var subMenulink = getLink(nestedItem, routeContext);
                        if (subMenulink) {
                            shouldSubMenuBeActive = linkIsCurrentRoute(subMenulink, currentRoute);
                        }
                        // Hide mobile unfriendly links for mobile
                        if (!isLegacyLinksFeatureEnabled) {
                            if (nestedItem.hideInMobile && isOnMobile) {
                                return null;
                            }
                        }
                        if (nestedItem.hideInDesktop && !isOnMobile) {
                            return null;
                        }
                        if (nestedItem.getId() === "LINK/RESET_PASSWORD") {
                            return (React__namespace.default.createElement(lighthouseComponentLibrary.SubMenuItem, { key: index + "-" + nestedItem.getRouteId() + "-dialog", title: nestedItem.getDisplayText(), id: "" + nestedItem.getRouteId() + nestedItem.getDisplayText(), "data-qa": "resetPasswordMenuItem", onClick: function () { return setIsResetPasswordDialogueOpen(true); }, active: shouldSubMenuBeActive }));
                        }
                        return (React__namespace.default.createElement(lighthouseComponentLibrary.SubMenuItem, { key: nestedItem.getId() + "-nestedsubnav", id: nestedItem.getId(), title: nestedItem.getDisplayText(), "data-qa": ___default.default.camelCase(nestedItem.getDisplayText()) + "Link", active: shouldSubMenuBeActive, onClick: createNavItemClickHandler(nestedItem, closeSideBar, routeToLink, history, subMenulink) }));
                    })
                        .filter(function (value) { return !!value; });
                    item = nestedSubNavItem.length && (React__namespace.default.createElement(StyledSubMenu, { key: index + "-" + subNavItem.getId() + "-nav", title: subNavItem.getDisplayText(), id: index + "-" + subNavItem.getId() + "-nav", "data-qa": ___default.default.camelCase(subNavItem.getDisplayText()) + "Link", localization: localization }, nestedSubNavItem));
                    return item;
                }
                else if (subNavItem.getId() === "LINK/ADMIN_MENU_HELP_LINK") {
                    // TODO: remove after we no longer the help link to exist
                    hasHelpLink_1 = true;
                    return (link && (React__namespace.default.createElement(HelpLink, { key: subNavItem.getId() + "-subnav", id: subNavItem.getId(), title: subNavItem.getDisplayText(), "data-qa": ___default.default.camelCase(subNavItem.getDisplayText()) + "Link", onClick: openAdminMenuHelpLink(subNavItem), active: shouldBeActive })));
                }
                else {
                    return (link && (React__namespace.default.createElement(MenuItemComponent, { key: subNavItem.getId() + "-subnav", id: subNavItem.getId(), title: subNavItem.getDisplayText(), disableLegacyView: isHierarchicalAdminMenuFeatureEnabled, "data-qa": ___default.default.camelCase(subNavItem.getDisplayText()) + "Link", onClick: createNavItemClickHandler(subNavItem, closeSideBar, routeToLink, history, link), active: shouldBeActive })));
                }
            })
                .filter(function (value) { return !!value; });
            // TODO: remove after we no longer the help link to exist
            if (hasHelpLink_1 && subNavItems.length === 1) {
                return null;
            }
            item = subNavItems.length && (React__namespace.default.createElement(lighthouseComponentLibrary.NavigationBarItem, { key: index + "-" + navigationItem.getId() + "-nav", title: navigationItem.getDisplayText(), id: index + "-" + navigationItem.getId() + "-nav", "data-qa": ___default.default.camelCase(navigationItem.getDisplayText()) + "Link" }, subNavItems));
        }
        else {
            if (navigationItem.hideInMobile && isOnMobile) {
                return null;
            }
            if (navigationItem.hideInDesktop && !isOnMobile) {
                return null;
            }
            var shouldBeActive = void 0;
            var link = getLink(navigationItem, routeContext);
            if (!!link) {
                shouldBeActive = linkIsCurrentRoute(link, currentRoute);
            }
            item = link && (React__namespace.default.createElement(lighthouseComponentLibrary.NavigationBarItem, { key: index + "-" + navigationItem.getId() + "-nav", title: navigationItem.getDisplayText(), id: index + "-" + navigationItem.getId() + "-nav", "data-qa": ___default.default.camelCase(navigationItem.getDisplayText()) + "Link", onClick: createNavItemClickHandler(navigationItem, closeSideBar, routeToLink, history, link), active: shouldBeActive }));
        }
        return item;
    })
        .filter(function (value) { return !!value; });
}
function getEnabledNavItems(navigationItems) {
    return navigationItems.filter(function (navigationItem) {
        if (navigationItem.getFeatureId) {
            return isFeatureEnabled(navigationItem.getFeatureId());
        }
        return true;
    });
}
/**
 * Opens the impersonation dialog, and closes the menu before to avoid intermittent issues
 *
 * @param showImpersonation {MainViewProps} - dispatch method to make dialog visible
 */
var openImpersonationDialog = function (showImpersonation) { return function () {
    showImpersonation();
}; };
var openHelpLinkInNewWindow = function (navItem) {
    return function () {
        if (isMenu(navItem)) {
            return undefined;
        }
        if (navItem.getExternalUrl && navItem.getExternalUrl()) {
            var url = navItem.getExternalUrl();
            if (isMobileDevice()) {
                // On a mobile device, open Help link using an in app browser
                openInAppBrowser(url);
            }
            else {
                window.open(url);
            }
        }
    };
};
// TODO: remove after we no longer the help link to exist
var openAdminMenuHelpLink = function (navItem) {
    return function () {
        if (isMenu(navItem)) {
            return undefined;
        }
        if (navItem.externalNavigationUrl) {
            var url = getWTAURL("SSO.do?Page=" + navItem.externalNavigationUrl);
            if (url) {
                if (isMobileDevice()) {
                    // On a mobile device, open Help link using an in app browser
                    openUrlOutsideSuite(url);
                }
                else {
                    window.open(url);
                }
            }
        }
    };
};
var openCustomHelpLinkInNewWindow = function (navItem) {
    return function () {
        if (isMenu(navItem)) {
            return undefined;
        }
        var url = navItem.externalNavigationUrl;
        if (url) {
            if (isMobileDevice()) {
                // On a mobile device, open Help link using an in app browser
                openUrlOutsideSuite(url);
            }
            else {
                window.open(url);
            }
        }
    };
};
/**
 * Returns a function for handling clicks on navigation items. The returned function determines whether to open the link
 * inside of the Suite or outside
 * @param navItem - the navigation item that needs click handling
 * @param closeSideBar - function to close an open side bar
 * @param routeToLink - function to route a link to the appropriate place inside the Suite
 * @param history - History object
 * @param link - the link to navigate to
 * @deprecated - This function should not be used anywhere else besides NavigationBarWrapper. It is only exported for the purposes
 * of unit testing
 */
function createNavItemClickHandler(navItem, closeSideBar, routeToLink, history, link) {
    return function () {
        if (!!link) {
            closeSideBar();
            if (navItem.externalNavigationUrl) {
                openUrlOutsideSuite(link);
            }
            else {
                routeToLink(link, history);
            }
        }
    };
}
function getUserMenu(hideNonMobileLinks, isAppEmbedded, isHierarchicalAdminMenuFeatureEnabled, firstName, lastName, name, menuItems, isImpersonationMode, routeContext, currentRoute, showImpersonation, closeSideBar, routeToLink, history) {
    /**
     * IDs of menu items that are to be hidden when the app is in "embedded" mode.
     * TODO-LTH-2870: This is a temporary hack that is coupled with the definitions of menu items from navigation-service.
     *                When moving the definitions of these menu items into the app/framework itself, determine the most
     *                appropriate way to keep track of which ones should be hidden when embedded.
     *                NOTE: Hidden-when-embedded menu items will likely be limited to only a subset of menu items
     *                      that are defined within the framework/app itself. If it is determined that some items defined
     *                      by navigation-service need to be hidden in embedded mode, than a better solution is to add
     *                      `hideInEmbeddedApp` boolean flags to menu item definitions from navigation-service, similar
     *                      to the existing `hideInMobile`.
     */
    var MENU_ITEM_IDS_OMITTED_FROM_EMBEDDED_APP = [
        "LINK/SIGN_OUT",
        "LINK/IMPERSONATION",
    ];
    var initials = "" + firstName[0] + lastName[0];
    return (React__namespace.default.createElement("nav", { "aria-labelledby": "user-menu-label" },
        React__namespace.default.createElement("span", { id: "user-menu-label" }),
        React__namespace.default.createElement(lighthouseComponentLibrary.Menu, { title: isAppEmbedded
                ? undefined
                : translate("framework", "GREETING.MENU_TITLE", {
                    firstname: firstName,
                }), iconAlt: initials, iconSrc: isAppEmbedded ? freeSolidSvgIcons.faCogs : getUserAvatar("" + firstName + lastName), "data-qa": "userMenu", employeeName: name, className: "user-menu" }, ___default.default(menuItems)
            .filter(function (menuItem) {
            // TODO: Need some investigation for Cordova as impersonation redirects you back
            // to application, therefore need to handle it properly to avoid disruption with
            // flow in mobile app
            return !((menuItem.getId() === "LINK/IMPERSONATION" &&
                (isMobileDevice() || isImpersonationMode)) ||
                (menuItem.getId() === "LINK/SUITE_IMPERSONATION" &&
                    (isMobileDevice() || isImpersonationMode)));
        })
            .filter(function (menuItem) {
            // Hide irrelevant menu items when in "embedded" mode
            return !(isAppEmbedded &&
                ___default.default.includes(MENU_ITEM_IDS_OMITTED_FROM_EMBEDDED_APP, menuItem.getId()));
        })
            .filter(function (menuItem) {
            // Hide "hide in mobile" links if applicable
            return !(hideNonMobileLinks && menuItem.hideInMobile);
        })
            .map(function (menuItem, index) {
            var shouldBeActive;
            var link = getLink(menuItem, routeContext);
            if (!!link) {
                shouldBeActive = linkIsCurrentRoute(link, currentRoute);
            }
            var menuId = menuItem.getId();
            if (menuId.startsWith(LINK) && menuId.endsWith(HELP_NAV_SUFFIX)) {
                return (React__namespace.default.createElement(lighthouseComponentLibrary.MenuItem, { key: menuId + "-subnav", id: menuId, title: menuItem.getDisplayText(), onClick: openHelpLinkInNewWindow(menuItem), "data-qa": ___default.default.camelCase(menuItem.getDisplayText()) + "Link", active: shouldBeActive, disableLegacyView: isHierarchicalAdminMenuFeatureEnabled }));
            }
            if (menuId.startsWith(CUSTOM_HELP_NAV_PREFIX)) {
                return (React__namespace.default.createElement(lighthouseComponentLibrary.MenuItem, { key: menuId + "-subnav", id: menuId, title: menuItem.getDisplayText(), onClick: openCustomHelpLinkInNewWindow(menuItem), "data-qa": ___default.default.camelCase(menuItem.getDisplayText()) + "Link", active: shouldBeActive, disableLegacyView: isHierarchicalAdminMenuFeatureEnabled }));
            }
            if (menuId === "LINK/IMPERSONATION") {
                return (React__namespace.default.createElement(lighthouseComponentLibrary.MenuItem, { key: index + "-" + menuItem.getRouteId() + "-dialog", id: "" + menuItem.getRouteId() + menuItem.getDisplayText(), title: translate("framework", "NAV_LINKS.IMPERSONATION"), onClick: openImpersonationDialog(showImpersonation), "data-qa": "impersonateUserMenuItem", active: shouldBeActive, disableLegacyView: isHierarchicalAdminMenuFeatureEnabled }));
            }
            if (menuId === "LINK/SUITE_IMPERSONATION") {
                if (!getFrameworkInstance().isFeatureEnabled("suite_impersonation_service")) {
                    return null;
                }
                return (React__namespace.default.createElement(lighthouseComponentLibrary.MenuItem, { key: index + "-" + menuItem.getRouteId() + "-suite-impersonation-dialog", id: "" + menuItem.getRouteId() + menuItem.getDisplayText(), title: menuItem.getDisplayText(), onClick: openImpersonationDialog(showImpersonation), "data-qa": "suiteImpersonateUserMenuItem", active: shouldBeActive, disableLegacyView: isHierarchicalAdminMenuFeatureEnabled }));
            }
            if (menuId === "LINK/SIGN_OUT") {
                return (React__namespace.default.createElement(lighthouseComponentLibrary.MenuItem, { key: index + "-" + menuItem.getRouteId() + "-logout", id: "" + menuItem.getRouteId() + menuItem.getDisplayText(), title: menuItem.getDisplayText(), onClick: function () { return AuthenticationManager.getInstance().logout(); }, "data-qa": "logoutUserMenuItem", disableLegacyView: isHierarchicalAdminMenuFeatureEnabled }));
            }
            return (React__namespace.default.createElement(lighthouseComponentLibrary.MenuItem, { key: index + "-" + menuItem.getRouteId() + "-emenu", id: "" + menuItem.getRouteId() + menuItem.getDisplayText(), title: menuItem.getDisplayText(), onClick: createNavItemClickHandler(menuItem, closeSideBar, routeToLink, history, getLink(menuItem, routeContext)), "data-qa": ___default.default.camelCase(menuItem.getDisplayText()) + "UserMenuItem", active: shouldBeActive, disableLegacyView: isHierarchicalAdminMenuFeatureEnabled }));
        })
            .value())));
}
function getNavigationBarItems(initialNavItems, propsNavigationItems, isOnMobile, isHierarchicalAdminMenuFeatureEnabled, isLegacyLinksFeatureEnabled, routeContext, currentRoute, setIsResetPasswordDialogueOpen, closeSideBar, routeToLink, history, localization) {
    var navItems = [];
    if (initialNavItems) {
        navItems.push.apply(navItems, createNavItems(getEnabledNavItems(initialNavItems), isOnMobile, isHierarchicalAdminMenuFeatureEnabled, isLegacyLinksFeatureEnabled, routeContext, currentRoute, setIsResetPasswordDialogueOpen, closeSideBar, routeToLink, history, localization));
    }
    if (propsNavigationItems) {
        navItems.push.apply(navItems, createNavItems(getEnabledNavItems(propsNavigationItems), isOnMobile, isHierarchicalAdminMenuFeatureEnabled, isLegacyLinksFeatureEnabled, routeContext, currentRoute, setIsResetPasswordDialogueOpen, closeSideBar, routeToLink, history, localization));
    }
    return navItems;
}
/**
 * Takes an external navigation URL and replaces placeholders with the organization ID and deployment suffix, then prefixes it with the CAS prefix.
 * @param {string} externalNavigationUrl The URL that may contain placeholders.
 * @returns {string | undefined} The modified URL or undefined if the account info is unavailable.
 */
var getVisierAnalyticsUrl = function (externalNavigationUrl) {
    var _a;
    var accountData = (_a = AuthenticationManager.getInstance().getAccountInfo()) === null || _a === void 0 ? void 0 : _a.accountData;
    if (!accountData || !externalNavigationUrl) {
        return undefined;
    }
    // Replace placeholders
    return externalNavigationUrl
        .replace("${deployment}", getDeploymentSuffix(accountData))
        .replace("${realm}", accountData.accountDetail.externalId);
};
var templateObject_1$G, templateObject_2$t, templateObject_3$m;

// CSS for iOS mobile only
var deviceBottomNotchFixCss = "\n  @media (orientation: portrait) {\n    @supports (-webkit-touch-callout: none) {\n      padding-bottom: calc(env(safe-area-inset-bottom) + " + polished.rem("20px") + ");\n    }\n  }\n";
var StyledMobileNavBar = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.NavigationBar)(templateObject_1$F || (templateObject_1$F = __makeTemplateObject(["\n  && {\n    overflow-x: hidden;\n    ", ";\n  }\n\n  && .button-bar {\n    display: block;\n  }\n\n  /* The library applies an ungated env(safe-area-inset-top) to the mobile drawer paper;\n     on Android the WebView is already inset below the status bar, so it adds an extra gap\n     above the menu's close (X). Limit the top inset to iOS. */\n  && .paper {\n    @media (orientation: portrait) {\n      padding-top: 0;\n      @supports (-webkit-touch-callout: none) {\n        padding-top: constant(safe-area-inset-top);\n        padding-top: env(safe-area-inset-top);\n      }\n    }\n  }\n"], ["\n  && {\n    overflow-x: hidden;\n    ", ";\n  }\n\n  && .button-bar {\n    display: block;\n  }\n\n  /* The library applies an ungated env(safe-area-inset-top) to the mobile drawer paper;\n     on Android the WebView is already inset below the status bar, so it adds an extra gap\n     above the menu's close (X). Limit the top inset to iOS. */\n  && .paper {\n    @media (orientation: portrait) {\n      padding-top: 0;\n      @supports (-webkit-touch-callout: none) {\n        padding-top: constant(safe-area-inset-top);\n        padding-top: env(safe-area-inset-top);\n      }\n    }\n  }\n"])), deviceBottomNotchFixCss);
var StyledDesktopNavBar = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.NavigationBar)(templateObject_2$s || (templateObject_2$s = __makeTemplateObject(["\n  && .logo {\n    max-width: ", ";\n    max-height: ", ";\n    height: 100%;\n    object-fit: contain;\n  }\n"], ["\n  && .logo {\n    max-width: ", ";\n    max-height: ", ";\n    height: 100%;\n    object-fit: contain;\n  }\n"])), polished.rem("150px"), polished.rem("40px"));
var Container$7 = lighthouseComponentLibrary.styled.div(templateObject_3$l || (templateObject_3$l = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var NavigationBarWrapper$1 = function (props) {
    var menuItems = props.menuItems, navigationItems = props.navigationItems;
    var framework = getFrameworkInstance();
    var currentRoute = useTypedSelector(function (state) { return state.router.location.pathname; });
    var desktopLogo = useTypedSelector(function (state) { return state.logos.DESKTOP_HEADER_LOGO; });
    var mockedName = useTypedSelector(function (state) { var _a, _b; return (_b = (_a = state.mockedAccountData) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.name; });
    var mockedFirstName = useTypedSelector(function (state) { var _a, _b; return (_b = (_a = state.mockedAccountData) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.firstName; });
    var mockedLastName = useTypedSelector(function (state) { var _a, _b; return (_b = (_a = state.mockedAccountData) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.lastName; });
    var _a = React.useState([]), initialNavItems = _a[0], setInitialNavigationItems = _a[1];
    var theme = useTheme();
    var translate = useTranslateFunction();
    var routeContext = React.useContext(RouteContext);
    var setIsResetPasswordDialogueOpen = React.useContext(ResetPasswordContext).setIsOpen;
    var isViewportMediumWidth = MediaQuery.useMediaQuery({
        query: "(min-width: " + lighthouseComponentLibrary.getMinBreakpoint("md")({ theme: theme }),
    });
    var isDesktop = !reactDeviceDetect.isMobile;
    var isAppEmbedded = framework.isAppEmbedded();
    // we should be authenticated and an identity token and account info should be present
    var oidcUserInfo = useAuthenticationManagerOidcUserInfo();
    var isImpersonationMode = !!(oidcUserInfo === null || oidcUserInfo === void 0 ? void 0 : oidcUserInfo.impersonator);
    var accountInfo = useAuthenticationManagerAccountInfo();
    var featureFlags = useNamedFeatureFlags(exports.FeatureFlagKey.DisplayMobileUnfriendlyLinks, exports.FeatureFlagKey.UniversalAssistant, exports.FeatureFlagKey.HierarchicalAdminMenu, exports.FeatureFlagKey.CollapsibleAssistant);
    var closeMenuLocalization = translate("NAV_MENU.CLOSE_MENU");
    var submenuLocalizationForAccessibility = {
        closeMenu: closeMenuLocalization,
        backArrow: translate("NAV_MENU.BACK_ARROW"),
    };
    var mobileNavBarLocalizationForAccessibility = {
        burgerMenu: translate("NAV_MENU.BURGER_MENU"),
        closeMenu: closeMenuLocalization,
    };
    var firstName;
    var lastName;
    var name;
    // if we're mocked, we wanna use mocked data since the identity token won't exist
    if (isDemoUser(accountInfo.organizationId)) {
        firstName = mockedFirstName;
        lastName = mockedLastName;
        name = mockedName;
    }
    else {
        firstName = (oidcUserInfo === null || oidcUserInfo === void 0 ? void 0 : oidcUserInfo.given_name) || "";
        lastName = (oidcUserInfo === null || oidcUserInfo === void 0 ? void 0 : oidcUserInfo.family_name) || "";
        name = (oidcUserInfo === null || oidcUserInfo === void 0 ? void 0 : oidcUserInfo.name) || "";
    }
    history$2 = reactRouterDom.useHistory();
    React.useEffect(function () {
        framework.getNavigationItems().then(function (navItems) {
            setInitialNavigationItems(navItems);
        });
    }, []);
    var isHierarchicalAdminMenu = featureFlags[exports.FeatureFlagKey.HierarchicalAdminMenu];
    var memoizedNonMobileUserMenu = tsReactUtil.useMemoWithLabel("userMenu", function () {
        return getUserMenu(false, isAppEmbedded, isHierarchicalAdminMenu, firstName, lastName, name, menuItems, isImpersonationMode, routeContext, currentRoute, props.showImpersonation, props.closeSideBar, props.routeToLink, history$2);
    }, [
        isAppEmbedded,
        isHierarchicalAdminMenu,
        firstName,
        lastName,
        name,
        menuItems,
        isImpersonationMode,
        routeContext,
        currentRoute,
        props.showImpersonation,
        props.closeSideBar,
        props.routeToLink,
        history$2,
    ]);
    var memoizedMobileUserMenu = tsReactUtil.useMemoWithLabel("userMenu", function () {
        return getUserMenu(true, isAppEmbedded, isHierarchicalAdminMenu, firstName, lastName, name, menuItems, isImpersonationMode, routeContext, currentRoute, props.showImpersonation, props.closeSideBar, props.routeToLink, history$2);
    }, [
        isAppEmbedded,
        isHierarchicalAdminMenu,
        firstName,
        lastName,
        name,
        menuItems,
        isImpersonationMode,
        routeContext,
        currentRoute,
        props.showImpersonation,
        props.closeSideBar,
        props.routeToLink,
        history$2,
    ]);
    var isLegacyLinksFeatureEnabled = featureFlags[exports.FeatureFlagKey.DisplayMobileUnfriendlyLinks];
    var memoizedMobileNavBarItems = tsReactUtil.useMemoWithLabel("mobileNavBarItems", function () {
        return getNavigationBarItems(initialNavItems, navigationItems, true, isHierarchicalAdminMenu, isLegacyLinksFeatureEnabled, routeContext, currentRoute, setIsResetPasswordDialogueOpen, props.closeSideBar, props.routeToLink, history$2, submenuLocalizationForAccessibility);
    }, [
        initialNavItems,
        navigationItems,
        isHierarchicalAdminMenu,
        isLegacyLinksFeatureEnabled,
        routeContext,
        currentRoute,
        setIsResetPasswordDialogueOpen,
        props.closeSideBar,
        props.routeToLink,
        history$2,
    ]);
    var memoizedNonMobileNavBarItems = tsReactUtil.useMemoWithLabel("nonMobileNavBarItems", function () {
        return getNavigationBarItems(initialNavItems, navigationItems, false, isHierarchicalAdminMenu, isLegacyLinksFeatureEnabled, routeContext, currentRoute, setIsResetPasswordDialogueOpen, props.closeSideBar, props.routeToLink, history$2);
    }, [
        initialNavItems,
        navigationItems,
        isHierarchicalAdminMenu,
        isLegacyLinksFeatureEnabled,
        routeContext,
        currentRoute,
        setIsResetPasswordDialogueOpen,
        props.closeSideBar,
        props.routeToLink,
        history$2,
    ]);
    var activeIdMatcher = function (navProps) {
        return !!navProps.active;
    };
    var hideAssistantIcon = function () {
        return (isAssistantViewable() || !featureFlags[exports.FeatureFlagKey.UniversalAssistant]);
    };
    var showAssistantIcon = function () {
        return featureFlags[exports.FeatureFlagKey.CollapsibleAssistant]
            ? true
            : !hideAssistantIcon();
    };
    var createToolBarItems = function () {
        var createdItems = [];
        if (showAssistantIcon()) {
            createdItems.push(framework.getAssistantIconComponent());
        }
        createdItems.push(WfxDMs({ isViewportMediumWidth: isViewportMediumWidth }));
        return [
            React__namespace.default.createElement(Container$7, { key: "toolbar-region", role: "region", "aria-label": translate("NAV_MENU.TOOLBAR") }, createdItems),
        ];
    };
    // Special case for desktop, return all mobile links regardless of breakpoint.
    // However, the small breakpoint should still be respected:
    // it should show the hamburger menu on desktop.
    if (isDesktop) {
        return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
            React__namespace.default.createElement(MediaQuery__default.default, { minWidth: lighthouseComponentLibrary.getMinBreakpoint("md")({ theme: theme }) },
                React__namespace.default.createElement("div", { role: "banner", className: "navigation-bar-wrapper" },
                    React__namespace.default.createElement(StyledDesktopNavBar, { dataQa: "navBar", activeItemMatcher: activeIdMatcher, menu: memoizedNonMobileUserMenu, hideLogo: isAppEmbedded, logoSrc: desktopLogo ? desktopLogo : undefined, toolbarIconItems: createToolBarItems() }, memoizedNonMobileNavBarItems))),
            React__namespace.default.createElement(MediaQuery__default.default, { maxWidth: lighthouseComponentLibrary.getMaxBreakpoint("sm")({ theme: theme }) },
                React__namespace.default.createElement("div", { role: "banner", className: "navigation-bar-wrapper" },
                    React__namespace.default.createElement(StyledMobileNavBar, { dataQa: "navBar", activeItemMatcher: activeIdMatcher, menu: memoizedNonMobileUserMenu, hideLogo: isAppEmbedded, logoSrc: desktopLogo ? desktopLogo : undefined, toolbarIconItems: createToolBarItems(), localization: mobileNavBarLocalizationForAccessibility }, memoizedNonMobileNavBarItems)))));
    }
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        React__namespace.default.createElement(MediaQuery__default.default, { minWidth: lighthouseComponentLibrary.getMinBreakpoint("md")({ theme: theme }), orientation: "portrait" },
            React__namespace.default.createElement("div", { role: "banner", className: "navigation-bar-wrapper" },
                React__namespace.default.createElement(StyledDesktopNavBar, { dataQa: "navBar", activeItemMatcher: activeIdMatcher, menu: memoizedNonMobileUserMenu, hideLogo: isAppEmbedded, logoSrc: desktopLogo ? desktopLogo : undefined, toolbarIconItems: createToolBarItems() }, memoizedNonMobileNavBarItems))),
        React__namespace.default.createElement(MediaQuery__default.default, { minWidth: lighthouseComponentLibrary.getMaxBreakpoint("md")({ theme: theme }), orientation: "landscape" },
            React__namespace.default.createElement("div", { role: "banner", className: "navigation-bar-wrapper" },
                React__namespace.default.createElement(StyledDesktopNavBar, { dataQa: "navBar", activeItemMatcher: activeIdMatcher, menu: memoizedNonMobileUserMenu, hideLogo: isAppEmbedded, logoSrc: desktopLogo ? desktopLogo : undefined, toolbarIconItems: createToolBarItems() }, memoizedNonMobileNavBarItems))),
        React__namespace.default.createElement(MediaQuery__default.default, { minWidth: lighthouseComponentLibrary.getMinBreakpoint("md")({ theme: theme }), maxWidth: lighthouseComponentLibrary.getMaxBreakpoint("md")({ theme: theme }), orientation: "landscape" },
            React__namespace.default.createElement("div", { role: "banner", className: "navigation-bar-wrapper" },
                React__namespace.default.createElement(StyledDesktopNavBar, { dataQa: "navBar", activeItemMatcher: activeIdMatcher, menu: memoizedMobileUserMenu, hideLogo: isAppEmbedded, logoSrc: desktopLogo ? desktopLogo : undefined, toolbarIconItems: createToolBarItems() }, memoizedMobileNavBarItems))),
        React__namespace.default.createElement(MediaQuery__default.default, { maxWidth: lighthouseComponentLibrary.getMaxBreakpoint("sm")({ theme: theme }) },
            React__namespace.default.createElement("div", { role: "banner", className: "navigation-bar-wrapper" },
                React__namespace.default.createElement(StyledMobileNavBar, { dataQa: "navBar", activeItemMatcher: activeIdMatcher, menu: memoizedMobileUserMenu, hideLogo: isAppEmbedded, logoSrc: desktopLogo ? desktopLogo : undefined, toolbarIconItems: createToolBarItems(), localization: mobileNavBarLocalizationForAccessibility }, memoizedMobileNavBarItems)))));
};
/**
 * Used to store the latest history provided by useHistory(). Is set once at the beginning of each render, and is
 * scoped in such a way that all functions within this module can access it.
 */
var history$2;
var templateObject_1$F, templateObject_2$s, templateObject_3$l;

var navigationSkeleton = [
    {
        id: "LINK/HUB",
    },
    {
        id: "MENU/SCHEDULE",
        subMenu: [
            {
                id: "LINK/EMPLOYEE_MY_CALENDAR_WFS",
            },
            {
                id: "LINK/EMPLOYEE_MY_CALENDAR_WFS_NATIVE",
            },
            {
                id: "LINK/MY_CALENDAR",
            },
            {
                id: "LINK/TEAM_ABSENCE_CALENDAR",
            },
            {
                id: "LINK/MY_SCHEDULE_WFS",
            },
            {
                id: "LINK/MY_SHIFT_MANAGEMENT_WFS",
            },
            {
                id: "LINK/SCHEDULE_WFS",
            },
            {
                id: "LINK/SCHEDULE_WFS_NATIVE",
            },
            {
                id: "LINK/SCHEDULE_WFS_HERALD",
            },
            {
                id: "LINK/SCHEDULE_JS_HERALD",
            },
            {
                id: "LINK/AUTO_SCHEDULE_WFS",
            },
            {
                id: "LINK/SHIFTMANAGEMENT_WFS",
            },
            {
                id: "LINK/SHIFTMANAGEMENT",
            },
            {
                id: "LINK/DYNAMIC_SCHEDULING",
            },
            {
                id: "LINK/SCHEDULE_TEMPLATES",
            },
            {
                id: "LINK/SCHEDULE_TEMPLATES_NATIVE",
            },
            {
                id: "LINK/MY_SWAP_REQUESTS",
            },
            {
                id: "LINK/SHIFT_SWAP_WFS",
            },
            {
                id: "LINK/AVAILABILITY",
            },
            {
                id: "LINK/AVAILABILITY_TEMPLATE",
            },
            {
                id: "LINK/SHIFT_BIDDING",
            },
            {
                id: "LINK/SHIFT_BIDDING_PREFERENCES",
            },
            {
                id: "LINK/MANAGE_SHIFT_BIDDING",
            },
            {
                id: "LINK/MY_BIDDING_WTA",
            },
            {
                id: "LINK/MANAGER_CALENDAR",
            },
            {
                id: "LINK/GROUP_CALENDAR",
            },
            {
                id: "LINK/COWORKER",
            },
            {
                id: "LINK/SCHEDULES_MAINTENANCE",
            },
            {
                id: "LINK/GRP_SCHEDULE_ENTRY",
            },
            {
                id: "LINK/MODIFY_SCHEDULE",
            },
            {
                id: "LINK/ADJ_BANKS",
            },
            {
                id: "LINK/CALLOUT",
            },
            {
                id: "LINK/UI_COPY_SCHED",
            },
            {
                id: "LINK/UI_DELETE_SCHED",
            },
            {
                id: "LINK/MANAGE_EMP_ASGNMT",
            },
            {
                id: "LINK/MANAGE_SLOT_GROUPS",
            },
            {
                id: "LINK/MANAGE_STAFF_REQ",
            },
            {
                id: "LINK/POST_EMPLOYEES",
            },
            {
                id: "LINK/MANAGER_SWAP_REQUESTS",
            },
            {
                id: "LINK/ASGN_ROT_PATTERN",
            },
            {
                id: "LINK/ROTATION_PATTERN",
            },
            {
                id: "LINK/RUN_AUTO_SCHEDULE",
            },
            {
                id: "LINK/STATUS_SUMMARY",
            },
        ],
    },
    {
        id: "MENU/TIME_OFF",
        subMenu: [
            {
                id: "LINK/TIME_OFF_REQUEST",
            },
            {
                id: "LINK/VIEW_MY_TIME_OFF_REQUESTS",
            },
            {
                id: "LINK/MY_TIME_OFF_WFS",
            },
            {
                id: "LINK/EMPLOYEE_ACCOMMODATION_REQUESTS",
            },
            {
                id: "LINK/MANAGER_TIMEOFF_REQUESTS",
            },
            {
                id: "LINK/TIME_OFF_SUMMARY",
            },
            {
                id: "LINK/LEAVE_SUMMARY",
            },
            {
                id: "LINK/LEAVE_REGULATIONS",
            },
            {
                id: "LINK/MANAGER_ABSENCE_TRACKING",
            },
            {
                id: "LINK/COMPLIANCE_PORTAL",
            },
            {
                id: "LINK/COMPLIANCE_ON_DEMAND",
            },
            {
                id: "LINK/EMPLOYEE_VACATION_BIDDING_DASHBOARD",
            },
        ],
    },
    {
        id: "MENU/TIMESHEET",
        subMenu: [
            {
                id: "LINK/MY_TIME_SHEET_VALIDATE",
            },
            {
                id: "LINK/MY_NEXT_GEN_TIMESHEET",
            },
            {
                id: "LINK/VIEW_PAST_ASSIGNMENTS",
            },
            {
                id: "LINK/TIME_CLOCK",
            },
            {
                id: "LINK/WEB_CLOCK",
            },
            {
                id: "LINK/MANAGER_DEFAULT_LABOR_ALLOCATION",
            },
            {
                id: "LINK/MY_DEFAULT_LABOR_ALLOCATION",
            },
            {
                id: "LINK/MY_TIMESHEET",
            },
            {
                id: "LINK/MANAGE_TIMESHEET",
            },
            {
                id: "LINK/APPROVAL_AND_EXCEPTIONS",
            },
            {
                id: "LINK/LIVE_ATTENDANCE_STATUS",
            },
            {
                id: "LINK/PAYROLL_WEEKLY",
            },
            {
                id: "LINK/TIME_AND_ATTENDANCE",
            },
            {
                id: "LINK/MANAGER_TIME_ENTRY_VALIDATE",
            },
            {
                id: "LINK/MANAGER_NEXT_GEN_TIME_ENTRY",
            },
            {
                id: "LINK/GRP_TIME_ENTRY",
            },
            {
                id: "LINK/CREW_PRODUCTION",
            },
            {
                id: "LINK/MASS_EDIT_TIME",
            },
            {
                id: "LINK/APPROVAL",
            },
            {
                id: "LINK/APPROVAL_NEXT_GEN",
            },
            {
                id: "LINK/END_OF_PROCESSING_INSTRUCTIONS",
            },
            {
                id: "LINK/FATIGUE_ASSESSMENTS",
            },
            {
                id: "LINK/LINE_APPROVAL",
            },
            {
                id: "LINK/OVERTIME_BANKS",
            },
        ],
    },
    {
        id: "LINK/ML_FORECASTING",
    },
    {
        id: "MENU/FORECAST",
        subMenu: [
            {
                id: "LINK/FORECAST",
            },
            {
                id: "LINK/POINT_OF_SALE_ERRORS",
            },
        ],
    },
    {
        id: "MENU/REPORTS",
        subMenu: [
            {
                id: "LINK/GROUP_REPORTS",
            },
            {
                id: "LINK/KPI_DASHBOARD",
            },
            {
                id: "LINK/VIEW_ANALYTICS",
            },
            {
                id: "LINK/NEW_ANALYTICS_REPORT",
            },
            {
                id: "LINK/VIEW_REPORTS_WFS",
            },
            {
                id: "LINK/ADVANCED_SCHEDULING_REPORTS_WFS",
            },
            {
                id: "LINK/SQL_REPORTS",
            },
            {
                id: "LINK/VISIER_ANALYTICS",
            },
        ],
    },
    {
        id: "MENU/WFX",
        subMenu: [
            {
                id: "LINK/BROADCASTS",
            },
            {
                id: "LINK/CHANNELS",
            },
            {
                id: "LINK/TASKS",
            },
            {
                id: "LINK/DOCUMENTS",
            },
            {
                id: "LINK/WFX_APP",
            },
        ],
    },
    {
        id: "MENU/ADMIN",
        subMenu: [
            {
                id: "LINK/ADMIN_MENU_HELP_LINK",
            },
            {
                id: "MENU/ADMIN/CLOCKING",
                nestedSubMenu: [
                    {
                        id: "LINK/ADMIN_BADGE_EDIT",
                    },
                ],
            },
            {
                id: "LINK/EMPLOYEE_GROUPS",
            },
            {
                id: "MENU/ADMIN/WFX",
                nestedSubMenu: [
                    {
                        id: "LINK/WFX_ADMIN_BROADCASTS",
                    },
                    {
                        id: "LINK/WFX_ADMIN_CHANNELS",
                    },
                    {
                        id: "LINK/WFX_ADMIN_DOCUMENTS",
                    },
                    {
                        id: "LINK/WFX_ADMIN_LOCATIONS",
                    },
                    {
                        id: "LINK/WFX_ADMIN_ORGANIZATION_SETTINGS",
                    },
                    {
                        id: "LINK/WFX_ADMIN_SYNC",
                    },
                    {
                        id: "LINK/WFX_ADMIN_TASKS",
                    },
                    {
                        id: "LINK/WFX_ADMIN_USERS",
                    },
                    {
                        id: "LINK/WFX_ADMIN_USER_LISTS",
                    },
                ],
            },
            {
                id: "MENU/ADMIN/DEMAND_SCHEDULING",
                nestedSubMenu: [
                    {
                        id: "LINK/EMPLOYEE_SETTINGS",
                    },
                    {
                        id: "LINK/SYSTEM_ADMINISTRATION",
                    },
                ],
            },
            {
                id: "MENU/ADMIN/SCHEDULING_EMPLOYEE_ADMIN",
                nestedSubMenu: [
                    {
                        id: "LINK/AREA",
                    },
                    {
                        id: "LINK/BID_PACKAGE_ADMINISTRATION",
                    },
                    {
                        id: "LINK/EMPLOYEE_FILTER",
                    },
                    {
                        id: "LINK/MANAGE_EMP",
                    },
                    {
                        id: "LINK/FACILITY",
                    },
                    {
                        id: "LINK/NO_CALL_EMP_LIST",
                    },
                    {
                        id: "LINK/ORGANIZATION",
                    },
                    {
                        id: "LINK/SCHEDULING_GROUP",
                    },
                    {
                        id: "LINK/SCHEDULING_UNIT",
                    },
                ],
            },
            {
                id: "LINK/VACATION_BIDDING_ADMIN",
            },
            {
                id: "MENU/ADMIN/SCHEDULING_MODEL_ADMIN",
                nestedSubMenu: [
                    {
                        id: "LINK/NO_CALL_ASGN_LIST",
                    },
                    {
                        id: "LINK/ASGN_FILTER",
                    },
                    {
                        id: "LINK/MANAGE_ASSSIGNMENTS",
                    },
                    {
                        id: "LINK/QUALIFICATION",
                    },
                    {
                        id: "LINK/SHIFT",
                    },
                    {
                        id: "LINK/MANAGE_STATIONS",
                    },
                ],
            },
            {
                id: "MENU/ADMIN/SCHEDULING_RULE_SETUP",
                nestedSubMenu: [
                    {
                        id: "LINK/ASGN_RULE",
                    },
                    {
                        id: "LINK/ADMIN_AUTO_STAFF_CRIT",
                    },
                    {
                        id: "LINK/ADMIN_AUTOMATIC_CALLOUT_RULES",
                    },
                    {
                        id: "LINK/ADMIN_CANVASS_RULE",
                    },
                    {
                        id: "LINK/RULE_CANVASS_RESPONSE",
                    },
                    {
                        id: "LINK/CALL_OUT_RULE",
                    },
                    {
                        id: "LINK/RULE_CANVASS_TERM_CODES",
                    },
                    {
                        id: "LINK/UI_CALL_OUT",
                    },
                    {
                        id: "LINK/RULE_FM",
                    },
                    {
                        id: "LINK/RULE_LABOR_STD",
                    },
                    {
                        id: "LINK/ADMIN_RULE_LUNCH",
                    },
                    {
                        id: "LINK/RULE_OT_TYPES",
                    },
                    {
                        id: "LINK/ADMIN_RULE_OT_COST",
                    },
                    {
                        id: "LINK/RULE_REASON_CODE",
                    },
                    {
                        id: "LINK/RULE_SCH_PERIOD",
                    },
                    {
                        id: "LINK/COPY_RULE",
                    },
                    {
                        id: "LINK/ADMIN_SWAP_SCHED_RULE",
                    },
                    {
                        id: "LINK/RULE_SEL_CONSTR",
                    },
                    {
                        id: "LINK/RULE_SEL_PREF",
                    },
                ],
            },
            {
                id: "MENU/ADMIN/SCHEDULING_SECURITY_ADMIN",
                nestedSubMenu: [
                    {
                        id: "LINK/FIELD_PROFILE",
                    },
                    {
                        id: "LINK/ADMIN_ADVANCED_SCHEDULER_USER_GROUPS",
                    },
                    {
                        id: "LINK/SETUP_PERMISSIONS",
                    },
                    {
                        id: "LINK/ADMIN_EDIT_PROFILES",
                    },
                    {
                        id: "LINK/ADMIN_ADVANCED_SCHEDULER_USERS",
                    },
                ],
            },
            {
                id: "MENU/ADMIN/SCHEDULING_STANDARD_SCHEDULING",
                nestedSubMenu: [
                    {
                        id: "LINK/SCHEDULE_MAINTENANCE",
                    },
                ],
            },
            {
                id: "MENU/ADMIN/SYSTEM_SETUP",
                nestedSubMenu: [
                    {
                        id: "LINK/PAY_RULES_EDITOR",
                    },
                    {
                        id: "LINK/ADMIN_SYSTEM_CONFIG",
                    },
                    {
                        id: "LINK/ADMIN_DOWNLOAD_CLIENT",
                    },
                    {
                        id: "LINK/POLICY_MAPPING_FOR_IMPORTS",
                    },
                    {
                        id: "LINK/RESET_PASSWORD",
                    },
                    {
                        id: "LINK/SUBNAV_SERVER_ADMINISTRATION",
                    },
                    {
                        id: "LINK/CONFIG_AND_SECURITY_CHECK",
                    },
                ],
            },
            {
                id: "MENU/ADMIN/TIME_JOB_DATA_MANAGEMENT",
                nestedSubMenu: [
                    {
                        id: "LINK/ADMIN_HOLIDAY_MAINTENANCE",
                    },
                    {
                        id: "LINK/IMPORT_DATA",
                    },
                    {
                        id: "LINK/JOB_STATUS",
                    },
                    {
                        id: "LINK/ADMIN_LD_UPLOAD_UTIL",
                    },
                    {
                        id: "LINK/ADMIN_MANAGE_RETRO_TRIGGERS",
                    },
                    {
                        id: "LINK/RUN_JOB",
                    },
                ],
            },
            {
                id: "MENU/ADMIN/TIME_USER_GROUP_MANAGEMENT",
                nestedSubMenu: [
                    {
                        id: "LINK/ADMIN_SUBNAV_ASSIGNMENTS",
                    },
                    {
                        id: "LINK/ADMIN_DELEGATION",
                    },
                    {
                        id: "LINK/ADMIN_DELEGATION_SUPER",
                    },
                    {
                        id: "LINK/ADMIN_SUBNAV_EMPLOYEES",
                    },
                    {
                        id: "LINK/MGR_EMP_MAINTENANCE",
                    },
                    {
                        id: "LINK/ADMIN_SUBNAV_MANAGE",
                    },
                    {
                        id: "LINK/ADMIN_SUBNAV_MANAGE_SUPER",
                    },
                    {
                        id: "LINK/ADMIN_SUBNAV_CREATE",
                    },
                    {
                        id: "LINK/ADMIN_SUBNAV_CREATE_SUPER",
                    },
                    {
                        id: "LINK/ADMIN_RECALC_ASSIGNMENT_GROUPS",
                    },
                    {
                        id: "LINK/GROUP_MESSAGING",
                    },
                    {
                        id: "LINK/ADMIN_SUBNAV_USERS",
                    },
                    {
                        id: "LINK/ADMIN_USER_SECURITY_MAINTENANCE",
                    },
                ],
            },
        ],
    },
];
var getNavigationSkeletonWithSubMenus = function () {
    return navigationSkeleton;
};

var mapSTP = function (state) {
    var navigationItems;
    var menuItems;
    var authManager = AuthenticationManager.getInstance();
    // NavigationBarWrapper is only rendered when we are authenticated
    if (isDemoUser(authManager.getAccountInfo().organizationId)) {
        navigationItems = convertMockedNavigationDataToNavigationItems(state.mockedAccountData.data.navigationItems);
        menuItems = convertMockedUserMenuDataToUserMenuItems(state.mockedAccountData.data.menuItems);
    }
    else {
        var navigationSkeleton = getFrameworkInstance().getNamedFeatureFlags(exports.FeatureFlagKey.HierarchicalAdminMenu).hierarchical_admin_menu
            ? getNavigationSkeletonWithSubMenus()
            : getNavigationSkeleton();
        navigationItems = convertNavigationDataToNavigationItems(state.navigationItems, navigationSkeleton);
        menuItems = convertUserMenuDataToUserMenuItems(state.navigationItems);
    }
    return {
        menuItems: menuItems,
        navigationItems: navigationItems,
    };
};
var mapDispatchToProps$6 = function (dispatch) { return ({
    routeToLink: function (link, history) {
        dispatch(routeToLink(link, history));
    },
    closeSideBar: function () {
        dispatch(closeSidebar());
    },
    showImpersonation: function () {
        dispatch(showImpersonationDialog());
    },
}); };
var NavigationBarWrapper = reactRedux.connect(mapSTP, mapDispatchToProps$6)(NavigationBarWrapper$1);

var NAV_BAR_HEIGHT = 56;

// CSS for iOS mobile only: insets content past the notch (top) and the
// home-indicator (bottom) safe areas.
var deviceSafeAreaInsetCss = "\n  @supports (-webkit-touch-callout: none) {\n    @media (orientation: portrait) {\n      margin-top: constant(safe-area-inset-top);\n      margin-top: env(safe-area-inset-top);\n    }\n    padding-bottom: constant(safe-area-inset-bottom);\n    padding-bottom: env(safe-area-inset-bottom);\n  }\n";
var StyledMainView = lighthouseComponentLibrary.styled.div(templateObject_1$E || (templateObject_1$E = __makeTemplateObject(["\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  flex-wrap: nowrap;\n  align-content: stretch;\n  align-items: flex-start;\n  flex-direction: column;\n  justify-content: flex-start;\n  background: ", ";\n  width: fit-content;\n  min-width: 100%;\n\n  && .navigation-bar-wrapper {\n    ", "\n  }\n\n  && .main-component-wrapper {\n    margin: 0;\n\n    ", ";\n\n    position: absolute;\n    top: ", ";\n    right: 0;\n    bottom: 0;\n    left: 0;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n\n    /* Landscape: keep content clear of the Dynamic Island / notch on the side. */\n    @supports (-webkit-touch-callout: none) {\n      padding-left: constant(safe-area-inset-left);\n      padding-left: env(safe-area-inset-left);\n      padding-right: constant(safe-area-inset-right);\n      padding-right: env(safe-area-inset-right);\n    }\n\n    background-color: ", ";\n  }\n"], ["\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  flex-wrap: nowrap;\n  align-content: stretch;\n  align-items: flex-start;\n  flex-direction: column;\n  justify-content: flex-start;\n  background: ", ";\n  width: fit-content;\n  min-width: 100%;\n\n  && .navigation-bar-wrapper {\n    ", "\n  }\n\n  && .main-component-wrapper {\n    margin: 0;\n\n    ", ";\n\n    position: absolute;\n    top: ", ";\n    right: 0;\n    bottom: 0;\n    left: 0;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n\n    /* Landscape: keep content clear of the Dynamic Island / notch on the side. */\n    @supports (-webkit-touch-callout: none) {\n      padding-left: constant(safe-area-inset-left);\n      padding-left: env(safe-area-inset-left);\n      padding-right: constant(safe-area-inset-right);\n      padding-right: env(safe-area-inset-right);\n    }\n\n    background-color: ",
    ";\n  }\n"])), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).backgrounds.mainBackground; }, deviceSafeAreaInsetCss, deviceSafeAreaInsetCss, polished.rem(NAV_BAR_HEIGHT + "px"), function (props) {
    return lighthouseComponentLibrary.getThemeFromProps(props).backgrounds.hubBackground;
});
/**
 * Time (in ms) to delay the rendering of NavigationBarWrapper by.
 * This value should be used to defer the rendering of the NavigationBarWrapper so as
 * to allow the actual content of the MainView to start rendering first.
 * For e.g., in case of the Hub page load, the hub cards start loading faster due to this.
 */
var NAVIGATION_BAR_WRAPPER_RENDER_DELAY = 100;
var MainView$1 = function (props) {
    var _a = React.useState(false), shouldRenderNavBar = _a[0], setShouldRenderNavBar = _a[1];
    history$1 = reactRouterDom.useHistory();
    var currentRouteState = useTypedSelector(function (state) { return state.router.location.pathname; });
    var deeplinkRedirectRoute = useTypedSelector(function (state) { return state.deeplinkRedirect.redirectRoute; });
    /**
     * If a redirectRoute is set in the DeeplinkRedirect state,
     * and if the current location is not the redirectRoute itself,
     * route to the redirectRoute and clear (flush) it from the state.
     */
    var handleDeeplinkRedirect = function () {
        if (deeplinkRedirectRoute &&
            history$1.location.pathname !== deeplinkRedirectRoute) {
            var dispatch = getStore().dispatch;
            dispatch(flushDeeplinkRedirectRoute());
            props.routeToLink(deeplinkRedirectRoute, history$1);
        }
    };
    React.useEffect(function () {
        // Defer the rendering of the NavigationBarWrapper so as to allow the actual content of the MainView to start rendering first.
        // In case of the Hub page load, the hub cards start loading faster due to this.
        setTimeout(function () {
            setShouldRenderNavBar(true);
        }, NAVIGATION_BAR_WRAPPER_RENDER_DELAY);
    }, []);
    React.useEffect(function () {
        var _a;
        if (!!window.dtrum) {
            var authManager = AuthenticationManager.getInstance();
            var accountExternalId = (_a = authManager.getAccountInfo()) === null || _a === void 0 ? void 0 : _a.accountData.accountDetail.externalId;
            var parsedToken = authManager.getOidcUserInfo();
            if (accountExternalId && parsedToken) {
                setSessionIdentifier(accountExternalId, parsedToken);
            }
        }
        handleDeeplinkRedirect();
    }, [window.dtrum]);
    React.useEffect(function () {
        // Typically, the router state gets updated when a navigation item is clicked.
        // However, when a page is opened in a new tab, the navigation item's click handler
        // is bypassed, preventing the router state from being updated. This useEffect ensures
        // that the router state's pathname gets updated when a page is opened in a new tab.
        if (history$1.action === "POP" &&
            currentRouteState !== history$1.location.pathname) {
            props.routeToLink(history$1.location.pathname, history$1);
        }
    }, [history$1.location.pathname]);
    React.useEffect(function () {
        handleDeeplinkRedirect();
    }, [deeplinkRedirectRoute]);
    var render = props.render, rest = __rest(props, ["render"]);
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        React__namespace.default.createElement(StyledMainView, null,
            React__namespace.default.createElement(InitializeNavigateToRoute, null),
            React__namespace.default.createElement(Impersonate, null),
            React__namespace.default.createElement(ResetPassword, null),
            shouldRenderNavBar ? React__namespace.default.createElement(NavigationBarWrapper, __assign({}, props)) : null,
            render(rest))));
};
/**
 * Used to store the latest history provided by useHistory(). Is set once at the beginning of each render, and is
 * scoped in such a way that all functions within this module can access it.
 */
var history$1;
var templateObject_1$E;

var mapDispatchToProps$5 = function (dispatch) { return ({
    routeToLink: function (link, history) {
        dispatch(routeToLink(link, history));
    },
}); };
var MainView = reactRedux.connect(null, mapDispatchToProps$5)(MainView$1);

/**
 * Styled Drawer
 */
var StyledTemporaryDrawer = styled__default.default(lighthouseComponentLibrary.Drawer)(templateObject_1$D || (templateObject_1$D = __makeTemplateObject(["\n  .ScrollingBodyContainer {\n    z-index: 2;\n  }\n  .ScrollingBody {\n    height: calc(100% - ", ");\n  }\n  .ScrollingBodyShrinkWrapper {\n    padding: ", " max(env(safe-area-inset-right), ", ")\n      ", " max(env(safe-area-inset-left), ", ");\n    height: calc(100% - ", ");\n  }\n  @media (max-width: ", ") {\n    aside {\n      padding-top: ", ";\n    }\n    .drawer__paper-root {\n      top: ", ";\n    }\n  }\n  @media (min-width: ", ") {\n    .drawer__paper-root {\n      top: ", ";\n    }\n  }\n  .ScrollingBodyHeader {\n    display: ", ";\n  }\n"], ["\n  .ScrollingBodyContainer {\n    z-index: 2;\n  }\n  .ScrollingBody {\n    height: calc(100% - ", ");\n  }\n  .ScrollingBodyShrinkWrapper {\n    padding: ", " max(env(safe-area-inset-right), ", ")\n      ", " max(env(safe-area-inset-left), ", ");\n    height: calc(100% - ", ");\n  }\n  @media (max-width: ", ") {\n    aside {\n      padding-top: ",
    ";\n    }\n    .drawer__paper-root {\n      top: ",
    ";\n    }\n  }\n  @media (min-width: ", ") {\n    .drawer__paper-root {\n      top: ",
    ";\n    }\n  }\n  .ScrollingBodyHeader {\n    display: ", ";\n  }\n"])), polished.rem(NAV_BAR_HEIGHT + "px"), polished.rem("8px"), polished.rem("16px"), polished.rem("8px"), polished.rem("16px"), polished.rem("16px"), lighthouseComponentLibrary.getMaxBreakpoint("sm"), function (props) {
    return props.isContentFullHeight ? 0 : "env(safe-area-inset-top)";
}, function (props) {
    return props.isContentFullHeight
        ? "env(safe-area-inset-top)"
        : "" + polished.rem(NAV_BAR_HEIGHT + "px");
}, lighthouseComponentLibrary.getMinBreakpoint("md"), function (props) {
    return props.isContentFullHeight ? 0 : "" + polished.rem(NAV_BAR_HEIGHT + "px");
}, function (props) { return (props.isContentFullHeight ? "none" : ""); });
var templateObject_1$D;

var NotificationType;
(function (NotificationType) {
    NotificationType[NotificationType["Closed"] = 0] = "Closed";
    NotificationType[NotificationType["SimpleNotification"] = 1] = "SimpleNotification";
    NotificationType[NotificationType["DismissibleNotification"] = 2] = "DismissibleNotification";
})(NotificationType || (NotificationType = {}));
exports.NotificationActionTypes = void 0;
(function (NotificationActionTypes) {
    NotificationActionTypes["SendNotification"] = "notification/send";
    NotificationActionTypes["SendDismissibleNotification"] = "notification/sendDismissible";
    NotificationActionTypes["CloseNotification"] = "notification/close";
    NotificationActionTypes["DismissHubCardNotification"] = "notification/hubCardDismissal";
})(exports.NotificationActionTypes || (exports.NotificationActionTypes = {}));

/**
 * Define the initial state if none provided
 */
var initialState$a = {
    message: undefined,
    hubCardId: undefined,
    hubCardIdToReinsertBeforeOnUndo: undefined,
    notificationType: NotificationType.Closed,
};
/**
 * Create a reducer that manipulates the notification state
 *
 * @param {NotificationState}  state  The current state
 * @param {NotificationAction} action The action that has triggered the state change
 *
 * @returns {NotificationState} The modified NotificationState
 */
var reducer$b = function (state, action) {
    if (state === void 0) { state = initialState$a; }
    /**
     * Check which Action has been triggered
     */
    switch (action.type) {
        case exports.NotificationActionTypes.SendNotification: {
            return {
                message: action.notification,
                notificationType: NotificationType.SimpleNotification,
            };
        }
        case exports.NotificationActionTypes.SendDismissibleNotification: {
            return {
                message: action.message,
                notificationType: NotificationType.DismissibleNotification,
            };
        }
        case exports.NotificationActionTypes.CloseNotification: {
            return initialState$a;
        }
        case exports.NotificationActionTypes.DismissHubCardNotification: {
            return {
                message: action.message,
                notificationType: NotificationType.DismissibleNotification,
                hubCardId: action.hubCardId,
                hubCardIdToReinsertBeforeOnUndo: action.hubCardIdToReinsertBeforeOnUndo,
                sideBarNotification: true,
            };
        }
    }
    return state;
};

// Create a context for the UserPreferenceManager
var UserPreferenceManagerContext = React.createContext(undefined);
UserPreferenceManagerContext.displayName = "UserPreferenceContext";
/**
 * Custom React hook that returns the UserPreferenceManager context.
 * @returns {UserPreferenceManager | undefined} The UserPreferenceManager context.
 */
function useUserPreferenceManagerContext() {
    return React.useContext(UserPreferenceManagerContext);
}

/**
 * Creates a custom hook for managing user preferences associated with a UI module.
 * @param uiModuleId - The ID of the UI module.
 * @returns A custom hook function to interact with user preferences.
 */
function createModuleUsePreferenceHook(uiModuleId) {
    return function (userPreferenceKey, withImmediateSave) {
        var userPreferenceManager = useUserPreferenceManagerContext();
        // Initialize the 'value' state with the user preference value.
        var _a = React.useState(function () {
            return userPreferenceManager === null || userPreferenceManager === void 0 ? void 0 : userPreferenceManager.getUserPreferenceValue(uiModuleId, userPreferenceKey);
        }), value = _a[0], setValue = _a[1];
        React.useEffect(function () {
            var cancelSubscription = userPreferenceManager === null || userPreferenceManager === void 0 ? void 0 : userPreferenceManager.subscribe({
                /**
                 * Callback function to handle changes in user preferences.
                 * @param moduleId - The module ID.
                 * @param key - The key of the preference.
                 * @param newValue - The new value of the preference.
                 */
                onUserPreferenceChange: function (moduleId, key, newValue) {
                    if (uiModuleId === moduleId && userPreferenceKey === key) {
                        // Update 'value' when the user preference changes.
                        setValue(newValue);
                    }
                },
            });
            // Ensure 'value' is up to date when the component mounts.
            setValue(userPreferenceManager === null || userPreferenceManager === void 0 ? void 0 : userPreferenceManager.getUserPreferenceValue(uiModuleId, userPreferenceKey));
            // Cleanup the subscription when the component unmounts.
            return function () {
                if (cancelSubscription) {
                    cancelSubscription();
                }
            };
        }, [userPreferenceManager, uiModuleId, userPreferenceKey]);
        /**
         * Sets the value of a user preference for the UI module.
         * @param newValue - The new value to set.
         */
        var setPreferenceValue = React.useCallback(function (newValue) {
            if (withImmediateSave) {
                return userPreferenceManager === null || userPreferenceManager === void 0 ? void 0 : userPreferenceManager.setUserPreferenceValueWithImmediateSave(uiModuleId, userPreferenceKey, newValue);
            }
            else {
                // Update the user preference value when 'setPreferenceValue' is called.
                userPreferenceManager === null || userPreferenceManager === void 0 ? void 0 : userPreferenceManager.setUserPreferenceValue(uiModuleId, userPreferenceKey, newValue);
                return;
            }
        }, [userPreferenceManager, uiModuleId, userPreferenceKey, withImmediateSave]);
        return [value, setPreferenceValue];
    };
}

/**
 * The user preferences module ID used by the framework to access backward compatibility.
 * This is utilized to retrieve user preferences entries that existed before the introduction of
 * {@link UserPreferenceManager}
 */
var FRAMEWORK_USER_PREFERENCES_MODULE_ID_BACK_COMPAT = "";

var useBackCompatPreference = createModuleUsePreferenceHook(FRAMEWORK_USER_PREFERENCES_MODULE_ID_BACK_COMPAT);

/**
 * Enumeration representing user preference keys for lighthouse-framework's preferences.
 * These keys are used to identify various user preferences within the application.
 */
exports.BackCompatUserPreferenceKey = void 0;
(function (BackCompatUserPreferenceKey) {
    /**
     * User's preferred landing page setting.
     */
    BackCompatUserPreferenceKey["LandingPage"] = "landingPage";
    /**
     * User's preferred theme for their account.
     */
    BackCompatUserPreferenceKey["Theme"] = "theme";
    /**
     * User's preferred language setting.
     */
    BackCompatUserPreferenceKey["Locale"] = "locale";
    /**
     * User's preferred assistant card filters.
     */
    BackCompatUserPreferenceKey["AssistantCardFilters"] = "assistantCardsFilters";
    /**
     * User's preferred time format.
     */
    BackCompatUserPreferenceKey["TimeFormat"] = "timeFormat";
    /**
     * List of hub cards accessible by the user.
     */
    BackCompatUserPreferenceKey["ExpectedHubCards"] = "expectedHubCards";
    /**
     * List of hub cards to appear on the hub page.
     */
    BackCompatUserPreferenceKey["HubCardCustomization"] = "hubCardCustomization";
})(exports.BackCompatUserPreferenceKey || (exports.BackCompatUserPreferenceKey = {}));

var UserPreferenceIds;
(function (UserPreferenceIds) {
    UserPreferenceIds["HubCardCustomization"] = "hubCardCustomization";
    UserPreferenceIds["ExpectedHubCards"] = "expectedHubCards";
})(UserPreferenceIds || (UserPreferenceIds = {}));
var UserPreferencesActionTypes;
(function (UserPreferencesActionTypes) {
    UserPreferencesActionTypes["LoadUserPreferences"] = "userpreference/load";
    UserPreferencesActionTypes["SaveUserPreferences"] = "userpreference/save";
})(UserPreferencesActionTypes || (UserPreferencesActionTypes = {}));

/**
 * Takes an object of hub cards and converts it to an array of hub card ids
 * @param hubCards - type object hub cards
 * @returns string array of the hub card ids
 */
function flattenHubCardIds(hubCards) {
    var hubCardsFlattened = _.flatten(Object.values(hubCards));
    return hubCardsFlattened.map(function (hubCard) { return hubCard.id; });
}
/**
 * Adds Hub card id to the list of hub card order and returns the updated
 * hub card order list
 * @param hubCardOrder - the current hub card order list
 * @param hubCardId - the id of the hub card to be added
 * @param insertBefore - optional param for re-ordering the hub card
 */
function getHubCardOrderWithAddedHubCard(hubCardOrder, hubCardId, insertBefore) {
    var newHubCardOrder = _.without(hubCardOrder, hubCardId);
    // If the we're adding the hub card before itself, and the hub card already
    // existed in the old list, then there's no change to be made: the card is
    // already where we want it to be.
    if (hubCardId === insertBefore &&
        newHubCardOrder.length < hubCardOrder.length) {
        return hubCardOrder;
    }
    var insertIndex = _.indexOf(newHubCardOrder, insertBefore);
    if (insertIndex === -1) {
        newHubCardOrder.push(hubCardId);
    }
    else {
        newHubCardOrder.splice(insertIndex, 0, hubCardId);
    }
    return newHubCardOrder;
}

var mapStateToProps$6 = function (state) {
    return {
        message: state.notification.message,
        hubCardId: state.notification.hubCardId,
        hubCardIdToReinsertBeforeOnUndo: state.notification.hubCardIdToReinsertBeforeOnUndo,
        notificationType: state.notification.notificationType,
        sideBarNotification: state.notification.sideBarNotification,
    };
};
var mapDispatchToProps$4 = function (dispatch) {
    return {
        onNotificationClose: function () {
            return dispatch({ type: exports.NotificationActionTypes.CloseNotification });
        },
    };
};
var NotificationHandler = function (props) {
    var _a = useBackCompatPreference(exports.BackCompatUserPreferenceKey.HubCardCustomization), savedHubCardCustomization = _a[0], setSavedHubCardCustomization = _a[1];
    var currentHubCardOrder = (savedHubCardCustomization === null || savedHubCardCustomization === void 0 ? void 0 : savedHubCardCustomization.hubCardOrder) || [];
    var theme = useTheme();
    if (!props.message) {
        return null;
    }
    if (props.sideBarNotification === true && props.isSideBar === false) {
        return null;
    }
    var undoHubCardDismissal = function () {
        var previousHubCardOrder = getHubCardOrderWithAddedHubCard(currentHubCardOrder, props.hubCardId, props.hubCardIdToReinsertBeforeOnUndo);
        if (previousHubCardOrder !== currentHubCardOrder) {
            setSavedHubCardCustomization({
                hubCardOrder: previousHubCardOrder,
            });
        }
        props.onNotificationClose();
    };
    var action = props.notificationType === NotificationType.DismissibleNotification ? (React__namespace.createElement(React__namespace.Fragment, null,
        props.hubCardId && (React__namespace.createElement(lighthouseComponentLibrary.Button, { type: "text", size: "small", onClick: undoHubCardDismissal }, translate("framework", "NOTIFICATION_MESSAGES.UNDO"))),
        React__namespace.createElement(lighthouseComponentLibrary.IconButton, { size: "small", "aria-label": "close", color: "inherit", onClick: props.onNotificationClose },
            React__namespace.createElement(reactFontawesome.FontAwesomeIcon, { icon: faTimes.faTimes, size: "sm" })))) : null;
    var NotificationComponent = props.notificationType === NotificationType.DismissibleNotification
        ? StyledNotification
        : lighthouseComponentLibrary.Notification;
    var message = (React__namespace.createElement(React__namespace.Fragment, null,
        props.notificationType === NotificationType.DismissibleNotification && (React__namespace.createElement(CheckIconContainer, null,
            React__namespace.createElement(reactFontawesome.FontAwesomeIcon, { icon: faCheckCircle.faCheckCircle, color: theme.colours.success.main, size: "lg" }))),
        props.notificationType === NotificationType.DismissibleNotification ? (React__namespace.createElement(StyledHubCardDismissalTypography, { use: "body" }, props.message)) : (React__namespace.createElement(StyledDefaultTypography, { use: "body" }, props.message))));
    var NOTIFICATION_DURATION = 6000;
    var DISMISSAL_NOTIFICATION_DURATION = 6000;
    return (React__namespace.createElement(NotificationComponent, { open: Boolean(props.message), message: message, positionHorizontal: "center", positionVertical: props.notificationType === NotificationType.DismissibleNotification
            ? "top"
            : "bottom", autoHideDuration: props.notificationType === NotificationType.DismissibleNotification
            ? DISMISSAL_NOTIFICATION_DURATION
            : NOTIFICATION_DURATION, onClose: props.onNotificationClose, disableClickAway: true, action: action }));
};
/**
 * Styled component for dismissible notifications
 */
var StyledNotification = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Notification)(templateObject_1$C || (templateObject_1$C = __makeTemplateObject(["\n  && .MuiSnackbarContent-root {\n    background-color: ", ";\n    color: ", ";\n    border: 1px solid\n      ", ";\n  }\n"], ["\n  && .MuiSnackbarContent-root {\n    background-color: ",
    ";\n    color: ",
    ";\n    border: 1px solid\n      ",
    ";\n  }\n"])), function (props) {
    return lighthouseComponentLibrary.getThemeFromProps(props).colours.white;
}, function (props) {
    return lighthouseComponentLibrary.getThemeFromProps(props).type.textColor;
}, function (props) {
    return lighthouseComponentLibrary.getThemeFromProps(props).colours.success.main;
});
var CheckIconContainer = lighthouseComponentLibrary.styled.div(templateObject_2$r || (templateObject_2$r = __makeTemplateObject(["\n  display: inline;\n  margin-left: 0;\n  margin-right: ", ";\n"], ["\n  display: inline;\n  margin-left: 0;\n  margin-right: ", ";\n"])), rem__default.default("8px"));
var StyledHubCardDismissalTypography = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_3$k || (templateObject_3$k = __makeTemplateObject(["\n  display: inline;\n"], ["\n  display: inline;\n"])));
var StyledDefaultTypography = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_4$f || (templateObject_4$f = __makeTemplateObject(["\n  display: inline;\n  color: ", ";\n"], ["\n  display: inline;\n  color: ",
    ";\n"])), function (props) {
    return lighthouseComponentLibrary.getThemeFromProps(props).colours.white;
});
var NotificationHandler$1 = reactRedux.connect(mapStateToProps$6, mapDispatchToProps$4)(NotificationHandler);
var templateObject_1$C, templateObject_2$r, templateObject_3$k, templateObject_4$f;

var SidebarIntegrationWrapper$1 = function (props) {
    var _a;
    var _b = React.useState(undefined), title = _b[0], setTitle = _b[1];
    var translate = useTranslateFunction();
    var hideBackdrop = ((_a = props.drawerProps) === null || _a === void 0 ? void 0 : _a.hideBackdrop) || false;
    function closeSidebar() {
        var _a;
        var close = true;
        if ((_a = props.drawerProps) === null || _a === void 0 ? void 0 : _a.onCloseHandler) {
            close = props.drawerProps.onCloseHandler();
        }
        if (close) {
            props.onClose();
        }
    }
    // Only Assistant Drawer is going to set with full height
    var isFullHeightDrawer = useNamedFeatureFlags(exports.FeatureFlagKey.CollapsibleAssistant)
        .collapsible_assistant && props.event === "assistant";
    return (React__namespace.default.createElement(StyledTemporaryDrawer, { notificationHandler: React__namespace.default.createElement(NotificationHandler$1, { isSideBar: true }), title: title, open: props.isOpened, onClose: closeSidebar, variant: "temporary", anchor: "right", "aria-hidden": !props.isOpened, isContentFullHeight: isFullHeightDrawer, closeButtonProps: {
            "aria-label": translate("ORGANIZATION_PANEL.CLOSE_SIDEBAR_ARIA_LABEL"),
        }, ModalProps: {
            hideBackdrop: hideBackdrop,
            container: document.getElementById("main-component-wrapper"),
            disablePortal: true,
            style: { overflow: "hidden", top: polished.rem(NAV_BAR_HEIGHT + "px") },
        } },
        React__namespace.default.createElement(Context.Consumer, null, function (framework) {
            if (props.event === null) {
                // no event handler component has been rendered yet
                return null;
            }
            var SidebarComponent = props.getSidebarComponent(framework.getModules(), props.event);
            if (!SidebarComponent) {
                throw new Error("No sidebar found for event: " + props.event);
            }
            return (React__namespace.default.createElement(SidebarComponent, __assign({}, props.sidebarProps, { event: props.event, setTitle: setTitle })));
        })));
};

/**
 * Map application state to wrapper component props
 */
function mapStateToProps$5(state) {
    return {
        getSidebarComponent: getSidebarComponent,
        isOpened: state.sidebarIntegration.isOpened,
        event: state.sidebarIntegration.event,
        sidebarProps: state.sidebarIntegration.sidebarProps,
        drawerProps: state.sidebarIntegration.drawerProps,
    };
}
/**
 * Map action dispatcher to wrapper component props
 */
function mapDispatchToProps$3(dispatch) {
    return {
        onClose: function () { return dispatch(closeSidebar()); },
    };
}
var SidebarIntegrationWrapper = reactRedux.connect(mapStateToProps$5, mapDispatchToProps$3)(SidebarIntegrationWrapper$1);

var StyledImpersonationIndicator = lighthouseComponentLibrary.styled.div(templateObject_1$B || (templateObject_1$B = __makeTemplateObject(["\n  background-color: ", ";\n  width: 100%;\n  height: ", ";\n"], ["\n  background-color: ",
    ";\n  width: 100%;\n  height: ", ";\n"])), function (props) {
    return lighthouseComponentLibrary.getThemeFromProps(props).colours.information.tone["50"];
}, polished.rem("60px"));
var StyledContentContainer = lighthouseComponentLibrary.styled.div(templateObject_2$q || (templateObject_2$q = __makeTemplateObject(["\n  display: flex; /* establish flex container */\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  padding: ", " ", ";\n"], ["\n  display: flex; /* establish flex container */\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  padding: ", " ", ";\n"])), polished.rem("16px"), polished.rem("8px"));
var StyledTypography$3 = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_3$j || (templateObject_3$j = __makeTemplateObject(["\n  padding: ", ";\n"], ["\n  padding: ", ";\n"])), polished.rem("4px"));
var StyledSpan = lighthouseComponentLibrary.styled.span(templateObject_4$e || (templateObject_4$e = __makeTemplateObject(["\n  padding: ", ";\n"], ["\n  padding: ", ";\n"])), polished.rem("2px"));
/**
 * Impersonation indicator to be shown suite wide when impersonating
 *
 * @return {React.ReactElement | null}
 */
var ImpersonationIndicator = function () {
    var _a;
    // organization ID must be present if the user is attempting to impersonate
    var organizationId = (_a = useAuthenticationManagerAccountInfo()) === null || _a === void 0 ? void 0 : _a.organizationId;
    // identity token must exist if the user is attempting to impersonate
    var token = useAuthenticationManagerOidcUserInfo();
    var translate = useTranslateFunction();
    if (organizationId && !isDemoUser(organizationId)) {
        var initials = useTypedSelector(function (state) { var _a; return (_a = state.mockedAccountData.data) === null || _a === void 0 ? void 0 : _a.initials; });
        var isAppEmbedded = getFrameworkInstance().isAppEmbedded();
        if (token === null || token === void 0 ? void 0 : token.impersonator) {
            return (React__namespace.createElement(StyledImpersonationIndicator, null,
                React__namespace.createElement(StyledContentContainer, null,
                    React__namespace.createElement(StyledTypography$3, { use: "body" }, translate("IMPERSONATION_INDICATOR.MESSAGE")),
                    React__namespace.createElement(lighthouseComponentLibrary.AvatarContainer, { iconSrc: isAppEmbedded
                            ? freeSolidSvgIcons.faCogs
                            : getUserAvatar("" + token.family_name + token.given_name), iconAlt: initials }),
                    React__namespace.createElement(StyledSpan, null, token.name))));
        }
    }
    return null;
};
var templateObject_1$B, templateObject_2$q, templateObject_3$j, templateObject_4$e;

/**
 * Create the Main View to hold other feature components, accordingly to framework configuration
 * TODO: Refactor this, this is extremely messy and difficult to understand.
 *  Also refactor it to use the useTranslateFunction() hook.
 */
var wrapComponentInMainView = (function (WrappedComponent) {
    var WrappedComponentWithRouter = reactRouter.withRouter(WrappedComponent);
    var SkipNavigation = styled__default.default(reactRouterDom.Link)(templateObject_1$A || (templateObject_1$A = __makeTemplateObject(["\n    position: absolute;\n    z-index: 999;\n    padding: 2px 10px 2px 10px;\n    background-color: black;\n    border: 1px solid #fff;\n    color: white;\n    left: -200em;\n    text-decoration: none;\n    &:focus {\n      left: 6.5em;\n      transform: translateX(-50%);\n    }\n  "], ["\n    position: absolute;\n    z-index: 999;\n    padding: 2px 10px 2px 10px;\n    background-color: black;\n    border: 1px solid #fff;\n    color: white;\n    left: -200em;\n    text-decoration: none;\n    &:focus {\n      left: 6.5em;\n      transform: translateX(-50%);\n    }\n  "])));
    return function (props) {
        var translate = useTranslateFunction();
        /**
         * Function to render wrapped component with appropriate props
         */
        var renderWrappedComponent = function (_a) {
            _a.logout; var rest = __rest(_a, ["logout"]);
            return (React__namespace.createElement("main", { className: "main-component-wrapper", id: "main-component-wrapper", tabIndex: -1 },
                React__namespace.createElement(ImpersonationIndicator, null),
                React__namespace.createElement(WrappedComponentWithRouter, __assign({}, rest)),
                React__namespace.createElement(SidebarIntegrationWrapper, null)));
        };
        var skipToMainContent = function () {
            var _a;
            (_a = document.getElementById("main-component-wrapper")) === null || _a === void 0 ? void 0 : _a.focus();
        };
        /**
         * Function to render wrapped component in MainView component
         */
        var renderWrappedComponentInMainView = function () { return (React__namespace.createElement(React__namespace.Fragment, null,
            React__namespace.createElement(SkipNavigation, { tabIndex: 0, className: "skip-to-content-link", onClick: skipToMainContent, to: {} }, translate("ORGANIZATION_PANEL.SKIP_NAVIGATION")),
            React__namespace.createElement(MainView, __assign({}, props, { render: renderWrappedComponent })))); };
        return (React__namespace.createElement(Context.Consumer, null, function (framework) {
            var disableFrame = framework
                .getConfiguration()
                .get(moduleName$1, ConfigurationValues$1.DisableApplicationFrame);
            return disableFrame
                ? renderWrappedComponent(props)
                : renderWrappedComponentInMainView();
        }));
    };
});
var templateObject_1$A;

/**
 * A custom hook which provides the externalPage <iframe> (restricted to an Experience origin)
 * with an access JWT allowing the Experience application to automatically authenticate the Experience
 * user associated with that token.
 *
 * It provides mechanism to expose methods to child application to delegate the responsibility for an action
 * to the parent. Similarly, after connection has been created, the parent can also access the methods exposed by child
 *
 *
 * The mechanism for safe, cross-origin provisioning is Window.postMessage()
 * https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage via the Penpal library
 * https://github.com/Aaronius/penpal
 *
 * @param externalPageFrame - a reference to the iframe html element
 */
function useWfxIFrameAccess(externalPageFrame) {
    var wfxAppUrl = useWfxAppUrl();
    var currentLocale = localizationFramework.useLocaleId();
    var dispatch = reactRedux.useDispatch();
    var connection = React.useRef();
    React.useEffect(function () {
        if (!externalPageFrame || !wfxAppUrl) {
            // There's nothing to do if there's no iFrame reference or
            // if there's no WFX App URL
            return;
        }
        /**
         * Keep track of whether this effect is "cancelled" due to dependencies
         * changing.
         */
        var cancelled = false;
        /**
         * Count of how many times the iframe has started loading.
         * Used to keep track of whether the asynchronous load implementation
         * is still relevant, or if another load has since begun.
         */
        var loadCount = 0;
        function handleLoad() {
            return __awaiter(this, void 0, void 0, function () {
                var loadNumber, isValidWfxChildOrigin;
                var _this = this;
                return __generator(this, function (_a) {
                    // Keep track of how many times the iframe has started loading
                    ++loadCount;
                    loadNumber = loadCount;
                    isValidWfxChildOrigin = isValidWfxUrl(externalPageFrame === null || externalPageFrame === void 0 ? void 0 : externalPageFrame.src);
                    if ((externalPageFrame === null || externalPageFrame === void 0 ? void 0 : externalPageFrame.src) && isValidWfxChildOrigin) {
                        (function () { return __awaiter(_this, void 0, void 0, function () {
                            var isValidWfxSession, child, wfxSession, wfxServicesAuth, wfxBaseApiUrl, error_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 3, , 4]);
                                        // we must destroy the existing connection or it will persist and receive messages indefinitely
                                        if (connection.current) {
                                            connection.current.destroy();
                                        }
                                        connection.current = penpal.connectToChild({
                                            iframe: externalPageFrame,
                                            methods: {
                                                /**
                                                 * The methods allows child IFrame to delegate opening external URL to the hosting parent
                                                 *
                                                 * @param url - external URL that WFX wants to open
                                                 */
                                                openWfxExternalUrl: function (url, useNavOpener) {
                                                    if (useNavOpener === void 0) { useNavOpener = false; }
                                                    var _a;
                                                    console.debug("openWfxExternalUrl called in framework", url);
                                                    if (useNavOpener) {
                                                        openUrlOutsideSuite(url);
                                                    }
                                                    else if ((_a = window === null || window === void 0 ? void 0 : window.cordova) === null || _a === void 0 ? void 0 : _a.plugins) {
                                                        window.open(url, "_system");
                                                    }
                                                    else {
                                                        window.open(url, "_blank");
                                                    }
                                                },
                                                /**
                                                 * The method allows child IFrame to have the hosting parent load IFrame URLs
                                                 *
                                                 * @param url - URL to load
                                                 */
                                                embedExternalPage: function (url) {
                                                    console.debug("embedExternalPage called in framework", url);
                                                    embedExternalPage(encodeURI(url));
                                                },
                                                /**
                                                 * The methods allows child IFrame to provide DM ids which are selected by user
                                                 *
                                                 * @param dmId - dmId which is being selected by user
                                                 */
                                                getSelectedDMId: function (dmId) {
                                                    dispatch(setSelectedDMId(dmId));
                                                    // get unread DM ids from Redux store
                                                    var unreadDMIds = getStore().getState()
                                                        .wfxUnreadDMIds.ids;
                                                    if (unreadDMIds.length && unreadDMIds.includes(dmId)) {
                                                        // Remove DM Ids which are selected (means those DMs have read by user)
                                                        // and store the new array to Redux store
                                                        dispatch(removeReadDMId(dmId));
                                                    }
                                                },
                                                /**
                                                 * Provisions an externalPage Experience application with the current
                                                 * Suite User Preference locale
                                                 *
                                                 * @returns {Promise<object>} the current locale
                                                 *
                                                 */
                                                getWfsLocale: function () {
                                                    return currentLocale;
                                                },
                                                /**
                                                 * Provisions an externalPage Experience application with the current
                                                 * Suite Deployment Origin
                                                 *
                                                 * @returns {Promise<object>} the current deployment origin
                                                 *
                                                 */
                                                getWfsDeploymentOrigin: function () {
                                                    if (isMobileDevice()) {
                                                        // mobile devices must use the relevant deployment origin (production/latest/sprint only)
                                                        // e.g. https://app-us8.wfs.cloud, https://app-latest-us8.wfs.cloud, https://app-sprint-us8.wfs.cloud
                                                        var authManager = AuthenticationManager.getInstance();
                                                        var accountData = authManager.getAccountInfo().accountData;
                                                        // prod suffix e.g.: -us8.wfs.cloud
                                                        // latest suffix e.g.: -latest-us8.wfs.cloud
                                                        // sprint suffix e.g.: -sprint-us8.wfs.cloud
                                                        var deploymentSuffix = getDeploymentSuffix(accountData);
                                                        return "https://app" + deploymentSuffix;
                                                    }
                                                    // web origin (unavailable to cordova app)
                                                    // e.g. https://app-us5.wfs.cloud, https://app-latest-us8.wfs.cloud, http://localhost:3000/,
                                                    //  https://lth-pr-2817-dot-foko-dev.uc.r.appspot.com, etc.
                                                    return window.location.origin;
                                                },
                                            },
                                            timeout: 5000,
                                            debug: true,
                                        });
                                        isValidWfxSession = hasValidWfxSession();
                                        return [4 /*yield*/, initializeExperience(isValidWfxSession)];
                                    case 1:
                                        _a.sent();
                                        return [4 /*yield*/, connection.current.promise];
                                    case 2:
                                        child = _a.sent();
                                        wfxSession = window.localStorage.getItem(experience.LOCAL_STORAGE_KEYS.WFX_SESSION);
                                        wfxServicesAuth = window.localStorage.getItem(experience.LOCAL_STORAGE_KEYS.WFX_SERVICES_AUTH);
                                        wfxBaseApiUrl = window.localStorage.getItem(experience.LOCAL_STORAGE_KEYS.WFX_BASE_API_URL);
                                        if (cancelled || loadNumber !== loadCount) {
                                            // If the effect is cancelled due to dependencies changing,
                                            // or if a subsequent iframe load has begun, then this load
                                            // that was being handled is no longer relevant, and we must
                                            // abort to avoid a race condition.
                                            return [2 /*return*/];
                                        }
                                        child.setWfxSession(wfxSession, wfxServicesAuth, wfxBaseApiUrl);
                                        return [3 /*break*/, 4];
                                    case 3:
                                        error_1 = _a.sent();
                                        global.console.error("useWfxIFrameAccess handleLoad error", error_1);
                                        return [3 /*break*/, 4];
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); })();
                    }
                    return [2 /*return*/];
                });
            });
        }
        externalPageFrame.addEventListener("load", handleLoad);
        return function () {
            cancelled = true;
            externalPageFrame.removeEventListener("load", handleLoad);
            if (connection.current) {
                connection.current.destroy();
            }
        };
    }, [externalPageFrame, wfxAppUrl]);
}

/**
 * Builds the vacation-bidding app base URL from account data.
 * The OCI gateway uses the format:
 *   https://api.{env}.wfs.cloud/vacation-bidding-app
 * where deploymentSuffix is like "-latest-us8.wfs.cloud"
 * or "-us8.wfs.cloud" (prod)
 *
 * The new AWS gateway uses:
 *   https://gw.dit.wfs.na.adp.com/vacation-bidding-app (Latest)
 *   https://gw.fit.wfs.na.adp.com/vacation-bidding-app (Sprint)
 *   https://gw.uat.wfs.na.adp.com/vacation-bidding-app (US0/UAT)
 *   https://gw.wfs.na.adp.com/vacation-bidding-app (US8/Prod NA)
 *   https://gw.wfs.ca.adp.com/vacation-bidding-app (CA3/Prod CA)
 *   https://gw.wfs.au.adp.com/vacation-bidding-app (AU3/Prod AU)
 *   https://gw.wfs.emea.adp.com/vacation-bidding-app (EU3/Prod EMEA)
 *
 * Examples:
 *   "-latest-us8.wfs.cloud"
 *     → "https://api.latest.wfs.cloud/vacation-bidding-app"
 *   "-sprint-us8.wfs.cloud"
 *     → "https://api.sprint.wfs.cloud/vacation-bidding-app"
 *   "-us8.wfs.cloud"
 *     → "https://api.us8.wfs.cloud/vacation-bidding-app"
 */
function getVacationBiddingAppUrl(deploymentSuffix) {
    // Remove leading "-" and trailing ".wfs.cloud" to get the middle part
    // e.g. "latest-us8", "sprint-us8", "us8"
    var middle = deploymentSuffix
        .replace(/^-/, "")
        .replace(/\.wfs\.cloud$/, "");
    // Replace dashes with dots for the gateway subdomain
    // "latest-us8" → "latest" (env), "us8" → "us8" (datacenter)
    var subdomain = middle.split("-")[0];
    return "https://api." + subdomain + ".wfs.cloud/vacation-bidding-app";
}
/**
 * Pattern that matches all known vacation-bidding hosting domains.
 * Covers:
 *  - OCI gateway:  https://api.{env}.wfs.cloud/vacation-bidding-app
 *  - AWS gateway (nonprod):  https://gw.{env}.wfs.{region}.adp.com/vacation-bidding-app
 *  - AWS gateway (prod):     https://gw.wfs.{region}.adp.com/vacation-bidding-app
 */
var VACATION_BIDDING_URL_PATTERN = /^https:\/\/(api[.-][a-zA-Z0-9-]*\.wfs\.cloud|gw(\.[a-zA-Z0-9-]+)?\.wfs\.[a-zA-Z0-9-]+\.adp\.com)\/vacation-bidding-app/;
function isVacationBiddingUrl(src, baseUrl) {
    return src.startsWith(baseUrl) || VACATION_BIDDING_URL_PATTERN.test(src);
}
function useVacationBiddingIFrameAccess(externalPageFrame) {
    var accountInfo = useAuthenticationManagerAccountInfo();
    React.useEffect(function () {
        if (!externalPageFrame || !accountInfo)
            return;
        var deploymentSuffix = getDeploymentSuffix(accountInfo.accountData);
        var vacationBiddingBaseUrl = getVacationBiddingAppUrl(deploymentSuffix);
        var iframeSrc = externalPageFrame.src || "";
        if (!isVacationBiddingUrl(iframeSrc, vacationBiddingBaseUrl))
            return;
        var cancelled = false;
        var loadCount = 0;
        var connectedChild = null;
        function handleLoad() {
            var _this = this;
            ++loadCount;
            var loadNumber = loadCount;
            var currentSrc = (externalPageFrame === null || externalPageFrame === void 0 ? void 0 : externalPageFrame.src) || "";
            if (!isVacationBiddingUrl(currentSrc, vacationBiddingBaseUrl))
                return;
            var childOrigin;
            try {
                childOrigin = new URL(currentSrc).origin;
            }
            catch (_e) {
                console.warn("[useVacationBiddingIFrameAccess] Invalid iframe URL:", currentSrc);
                return;
            }
            (function () { return __awaiter(_this, void 0, void 0, function () {
                var connection, child, accessToken, _e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!externalPageFrame)
                                return [2 /*return*/];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 4, , 5]);
                            connection = penpal.connectToChild({
                                iframe: externalPageFrame,
                                childOrigin: childOrigin,
                                timeout: 5000,
                            });
                            return [4 /*yield*/, connection.promise];
                        case 2:
                            child = _a.sent();
                            return [4 /*yield*/, getAccessToken()];
                        case 3:
                            accessToken = _a.sent();
                            if (cancelled || loadNumber !== loadCount)
                                return [2 /*return*/];
                            connectedChild = child;
                            child.setWfsToken(accessToken);
                            return [3 /*break*/, 5];
                        case 4:
                            _e_1 = _a.sent();
                            // Penpal timed out — child doesn't implement connectToParent yet
                            console.warn("[useVacationBiddingIFrameAccess] Penpal connection failed:", _e_1);
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            }); })();
        }
        var authManager = AuthenticationManager.getInstance();
        var handleTokenRefresh = function () {
            if (!connectedChild || cancelled)
                return;
            getAccessToken()
                .then(function (newToken) {
                if (connectedChild && !cancelled) {
                    connectedChild.setWfsToken(newToken);
                }
            })
                .catch(function (err) {
                console.warn("[useVacationBiddingIFrameAccess] Token refresh failed:", err);
            });
        };
        var cancelTokenRefreshSubscription = authManager.subscribe({
            oidcUserInfoChange: function () {
                handleTokenRefresh();
            },
        });
        externalPageFrame.addEventListener("load", handleLoad);
        // Watch for src attribute changes (navigating between externalPage routes)
        var srcObserver = new MutationObserver(function (mutations) {
            for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
                var m = mutations_1[_i];
                if (m.attributeName === "src") {
                    handleLoad();
                }
            }
        });
        srcObserver.observe(externalPageFrame, {
            attributes: true,
            attributeFilter: ["src"],
        });
        return function () {
            cancelled = true;
            connectedChild = null;
            externalPageFrame.removeEventListener("load", handleLoad);
            srcObserver.disconnect();
            cancelTokenRefreshSubscription();
        };
    }, [externalPageFrame, accountInfo]);
}

function createExternalUserActivityEventPublisher() {
    var listeners = new Set();
    var throttledPublish = throttle__default.default(function () {
        listeners.forEach(function (cb) {
            cb();
        });
    }, 1000);
    return {
        subscribe: function (cb) {
            listeners.add(cb);
            return function () { return listeners.delete(cb); };
        },
        publish: throttledPublish,
        clear: function () {
            listeners.clear();
        },
    };
}

/**
 * The default instance of the event publisher used for context.
 */
var externalUserActivityEventPublisher = createExternalUserActivityEventPublisher();
/**
 * React context for the ExternalUserActivityEventPublisher.
 */
var ExternalUserActivityEventPublisherContext = React.createContext(externalUserActivityEventPublisher);
/**
 * Hook to access the ExternalUserActivityEventPublisher from context.
 *
 * Throws an error if used outside the provider.
 *
 * @returns {ExternalUserActivityEventPublisher} The event publisher instance from context.
 * @throws {Error} If used outside of ExternalUserActivityEventPublisherProvider.
 */
var useExternalUserActivityEventPublisher = function () {
    var context = React.useContext(ExternalUserActivityEventPublisherContext);
    if (!context) {
        throw new Error("useExternalUserActivityEventPublisher must be used within an ExternalUserActivityEventPublisherProvider");
    }
    return context;
};
/**
 * Provider component for ExternalUserActivityEventPublisher context.
 */
var ExternalUserActivityEventPublisherProvider = function (_a) {
    var _b = _a.value, value = _b === void 0 ? externalUserActivityEventPublisher : _b, children = _a.children;
    return (React__namespace.default.createElement(ExternalUserActivityEventPublisherContext.Provider, { value: value }, children));
};

/*! @license DOMPurify 2.5.7 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.7/LICENSE */

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var hasOwnProperty = Object.hasOwnProperty,
  setPrototypeOf = Object.setPrototypeOf,
  isFrozen = Object.isFrozen,
  getPrototypeOf = Object.getPrototypeOf,
  getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var freeze = Object.freeze,
  seal = Object.seal,
  create$1 = Object.create; // eslint-disable-line import/no-mutable-exports
var _ref = typeof Reflect !== 'undefined' && Reflect,
  apply = _ref.apply,
  construct = _ref.construct;
if (!apply) {
  apply = function apply(fun, thisValue, args) {
    return fun.apply(thisValue, args);
  };
}
if (!freeze) {
  freeze = function freeze(x) {
    return x;
  };
}
if (!seal) {
  seal = function seal(x) {
    return x;
  };
}
if (!construct) {
  construct = function construct(Func, args) {
    return _construct(Func, _toConsumableArray(args));
  };
}
var arrayForEach = unapply(Array.prototype.forEach);
var arrayPop = unapply(Array.prototype.pop);
var arrayPush = unapply(Array.prototype.push);
var stringToLowerCase = unapply(String.prototype.toLowerCase);
var stringToString = unapply(String.prototype.toString);
var stringMatch = unapply(String.prototype.match);
var stringReplace = unapply(String.prototype.replace);
var stringIndexOf = unapply(String.prototype.indexOf);
var stringTrim = unapply(String.prototype.trim);
var regExpTest = unapply(RegExp.prototype.test);
var typeErrorCreate = unconstruct(TypeError);
function unapply(func) {
  return function (thisArg) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return apply(func, thisArg, args);
  };
}
function unconstruct(func) {
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return construct(func, args);
  };
}

/* Add properties to a lookup table */
function addToSet(set, array, transformCaseFunc) {
  var _transformCaseFunc;
  transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
  if (setPrototypeOf) {
    // Make 'in' and truthy checks like Boolean(set.constructor)
    // independent of any properties defined on Object.prototype.
    // Prevent prototype setters from intercepting set as a this value.
    setPrototypeOf(set, null);
  }
  var l = array.length;
  while (l--) {
    var element = array[l];
    if (typeof element === 'string') {
      var lcElement = transformCaseFunc(element);
      if (lcElement !== element) {
        // Config presets (e.g. tags.js, attrs.js) are immutable.
        if (!isFrozen(array)) {
          array[l] = lcElement;
        }
        element = lcElement;
      }
    }
    set[element] = true;
  }
  return set;
}

/* Shallow clone an object */
function clone(object) {
  var newObject = create$1(null);
  var property;
  for (property in object) {
    if (apply(hasOwnProperty, object, [property]) === true) {
      newObject[property] = object[property];
    }
  }
  return newObject;
}

/* IE10 doesn't support __lookupGetter__ so lets'
 * simulate it. It also automatically checks
 * if the prop is function or getter and behaves
 * accordingly. */
function lookupGetter(object, prop) {
  while (object !== null) {
    var desc = getOwnPropertyDescriptor(object, prop);
    if (desc) {
      if (desc.get) {
        return unapply(desc.get);
      }
      if (typeof desc.value === 'function') {
        return unapply(desc.value);
      }
    }
    object = getPrototypeOf(object);
  }
  function fallbackValue(element) {
    console.warn('fallback value for', element);
    return null;
  }
  return fallbackValue;
}

var html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']);

// SVG
var svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']);

// List of SVG elements that are disallowed by default.
// We still need to know them so that we can do namespace
// checks properly in case one wants to add them to
// allow-list.
var svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'fedropshadow', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
var mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']);

// Similarly to SVG, we want to know all MathML elements,
// even those that we disallow by default.
var mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
var text = freeze(['#text']);

var html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);
var svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
var mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

// eslint-disable-next-line unicorn/better-regex
var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
);
var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
);
var DOCTYPE_NAME = seal(/^html$/i);
var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);

var getGlobal = function getGlobal() {
  return typeof window === 'undefined' ? null : window;
};

/**
 * Creates a no-op policy for internal use only.
 * Don't export this function outside this module!
 * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
 * @param {Document} document The document object (to determine policy name suffix)
 * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
 * are not supported).
 */
var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
  if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
    return null;
  }

  // Allow the callers to control the unique policy name
  // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
  // Policy creation with duplicate names throws in Trusted Types.
  var suffix = null;
  var ATTR_NAME = 'data-tt-policy-suffix';
  if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
    suffix = document.currentScript.getAttribute(ATTR_NAME);
  }
  var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
  try {
    return trustedTypes.createPolicy(policyName, {
      createHTML: function createHTML(html) {
        return html;
      },
      createScriptURL: function createScriptURL(scriptUrl) {
        return scriptUrl;
      }
    });
  } catch (_) {
    // Policy creation failed (most likely another DOMPurify script has
    // already run). Skip creating the policy, as this will only cause errors
    // if TT are enforced.
    console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
    return null;
  }
};
function createDOMPurify() {
  var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
  var DOMPurify = function DOMPurify(root) {
    return createDOMPurify(root);
  };

  /**
   * Version label, exposed for easier checks
   * if DOMPurify is up to date or not
   */
  DOMPurify.version = '2.5.7';

  /**
   * Array of elements that DOMPurify removed during sanitation.
   * Empty if nothing was removed.
   */
  DOMPurify.removed = [];
  if (!window || !window.document || window.document.nodeType !== 9) {
    // Not running in a browser, provide a factory function
    // so that you can pass your own Window
    DOMPurify.isSupported = false;
    return DOMPurify;
  }
  var originalDocument = window.document;
  var document = window.document;
  var DocumentFragment = window.DocumentFragment,
    HTMLTemplateElement = window.HTMLTemplateElement,
    Node = window.Node,
    Element = window.Element,
    NodeFilter = window.NodeFilter,
    _window$NamedNodeMap = window.NamedNodeMap,
    NamedNodeMap = _window$NamedNodeMap === void 0 ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
    HTMLFormElement = window.HTMLFormElement,
    DOMParser = window.DOMParser,
    trustedTypes = window.trustedTypes;
  var ElementPrototype = Element.prototype;
  var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
  var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
  var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
  var getParentNode = lookupGetter(ElementPrototype, 'parentNode');

  // As per issue #47, the web-components registry is inherited by a
  // new document created via createHTMLDocument. As per the spec
  // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
  // a new empty registry is used when creating a template contents owner
  // document, so we use that as our parent document to ensure nothing
  // is inherited.
  if (typeof HTMLTemplateElement === 'function') {
    var template = document.createElement('template');
    if (template.content && template.content.ownerDocument) {
      document = template.content.ownerDocument;
    }
  }
  var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
  var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
  var _document = document,
    implementation = _document.implementation,
    createNodeIterator = _document.createNodeIterator,
    createDocumentFragment = _document.createDocumentFragment,
    getElementsByTagName = _document.getElementsByTagName;
  var importNode = originalDocument.importNode;
  var documentMode = {};
  try {
    documentMode = clone(document).documentMode ? document.documentMode : {};
  } catch (_) {}
  var hooks = {};

  /**
   * Expose whether this browser supports running the full DOMPurify.
   */
  DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
  var MUSTACHE_EXPR$1 = MUSTACHE_EXPR,
    ERB_EXPR$1 = ERB_EXPR,
    TMPLIT_EXPR$1 = TMPLIT_EXPR,
    DATA_ATTR$1 = DATA_ATTR,
    ARIA_ATTR$1 = ARIA_ATTR,
    IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA,
    ATTR_WHITESPACE$1 = ATTR_WHITESPACE,
    CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
  var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;

  /**
   * We consider the elements and attributes below to be safe. Ideally
   * don't add any new ones but feel free to remove unwanted ones.
   */

  /* allowed element names */
  var ALLOWED_TAGS = null;
  var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));

  /* Allowed attribute names */
  var ALLOWED_ATTR = null;
  var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));

  /*
   * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
   * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
   * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
   * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
   */
  var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
    tagNameCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    attributeNameCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: false
    }
  }));

  /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
  var FORBID_TAGS = null;

  /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
  var FORBID_ATTR = null;

  /* Decide if ARIA attributes are okay */
  var ALLOW_ARIA_ATTR = true;

  /* Decide if custom data attributes are okay */
  var ALLOW_DATA_ATTR = true;

  /* Decide if unknown protocols are okay */
  var ALLOW_UNKNOWN_PROTOCOLS = false;

  /* Decide if self-closing tags in attributes are allowed.
   * Usually removed due to a mXSS issue in jQuery 3.0 */
  var ALLOW_SELF_CLOSE_IN_ATTR = true;

  /* Output should be safe for common template engines.
   * This means, DOMPurify removes data attributes, mustaches and ERB
   */
  var SAFE_FOR_TEMPLATES = false;

  /* Output should be safe even for XML used within HTML and alike.
   * This means, DOMPurify removes comments when containing risky content.
   */
  var SAFE_FOR_XML = true;

  /* Decide if document with <html>... should be returned */
  var WHOLE_DOCUMENT = false;

  /* Track whether config is already set on this instance of DOMPurify. */
  var SET_CONFIG = false;

  /* Decide if all elements (e.g. style, script) must be children of
   * document.body. By default, browsers might move them to document.head */
  var FORCE_BODY = false;

  /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
   * string (or a TrustedHTML object if Trusted Types are supported).
   * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
   */
  var RETURN_DOM = false;

  /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
   * string  (or a TrustedHTML object if Trusted Types are supported) */
  var RETURN_DOM_FRAGMENT = false;

  /* Try to return a Trusted Type object instead of a string, return a string in
   * case Trusted Types are not supported  */
  var RETURN_TRUSTED_TYPE = false;

  /* Output should be free from DOM clobbering attacks?
   * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
   */
  var SANITIZE_DOM = true;

  /* Achieve full DOM Clobbering protection by isolating the namespace of named
   * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
   *
   * HTML/DOM spec rules that enable DOM Clobbering:
   *   - Named Access on Window (§7.3.3)
   *   - DOM Tree Accessors (§3.1.5)
   *   - Form Element Parent-Child Relations (§4.10.3)
   *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
   *   - HTMLCollection (§4.2.10.2)
   *
   * Namespace isolation is implemented by prefixing `id` and `name` attributes
   * with a constant string, i.e., `user-content-`
   */
  var SANITIZE_NAMED_PROPS = false;
  var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';

  /* Keep element content when removing element? */
  var KEEP_CONTENT = true;

  /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
   * of importing it into a new Document and returning a sanitized copy */
  var IN_PLACE = false;

  /* Allow usage of profiles like html, svg and mathMl */
  var USE_PROFILES = {};

  /* Tags to ignore content of when KEEP_CONTENT is true */
  var FORBID_CONTENTS = null;
  var DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);

  /* Tags that are safe for data: URIs */
  var DATA_URI_TAGS = null;
  var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);

  /* Attributes safe for values like "javascript:" */
  var URI_SAFE_ATTRIBUTES = null;
  var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
  var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
  var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
  var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
  /* Document namespace */
  var NAMESPACE = HTML_NAMESPACE;
  var IS_EMPTY_INPUT = false;

  /* Allowed XHTML+XML namespaces */
  var ALLOWED_NAMESPACES = null;
  var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);

  /* Parsing of strict XHTML documents */
  var PARSER_MEDIA_TYPE;
  var SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
  var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
  var transformCaseFunc;

  /* Keep a reference to config to pass to hooks */
  var CONFIG = null;

  /* Ideally, do not touch anything below this line */
  /* ______________________________________________ */

  var formElement = document.createElement('form');
  var isRegexOrFunction = function isRegexOrFunction(testValue) {
    return testValue instanceof RegExp || testValue instanceof Function;
  };

  /**
   * _parseConfig
   *
   * @param  {Object} cfg optional config literal
   */
  // eslint-disable-next-line complexity
  var _parseConfig = function _parseConfig(cfg) {
    if (CONFIG && CONFIG === cfg) {
      return;
    }

    /* Shield configuration object from tampering */
    if (!cfg || _typeof(cfg) !== 'object') {
      cfg = {};
    }

    /* Shield configuration object from prototype pollution */
    cfg = clone(cfg);
    PARSER_MEDIA_TYPE =
    // eslint-disable-next-line unicorn/prefer-includes
    SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;

    // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
    transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;

    /* Set configuration parameters */
    ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
    ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
    ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
    URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES),
    // eslint-disable-line indent
    cfg.ADD_URI_SAFE_ATTR,
    // eslint-disable-line indent
    transformCaseFunc // eslint-disable-line indent
    ) // eslint-disable-line indent
    : DEFAULT_URI_SAFE_ATTRIBUTES;
    DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS),
    // eslint-disable-line indent
    cfg.ADD_DATA_URI_TAGS,
    // eslint-disable-line indent
    transformCaseFunc // eslint-disable-line indent
    ) // eslint-disable-line indent
    : DEFAULT_DATA_URI_TAGS;
    FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
    FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
    FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
    USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
    ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
    ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
    ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
    ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
    SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
    SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
    WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
    RETURN_DOM = cfg.RETURN_DOM || false; // Default false
    RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
    RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
    FORCE_BODY = cfg.FORCE_BODY || false; // Default false
    SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
    SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
    KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
    IN_PLACE = cfg.IN_PLACE || false; // Default false
    IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
    NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
    CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
    if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
      CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
    }
    if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
      CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
    }
    if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
      CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
    }
    if (SAFE_FOR_TEMPLATES) {
      ALLOW_DATA_ATTR = false;
    }
    if (RETURN_DOM_FRAGMENT) {
      RETURN_DOM = true;
    }

    /* Parse profile info */
    if (USE_PROFILES) {
      ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
      ALLOWED_ATTR = [];
      if (USE_PROFILES.html === true) {
        addToSet(ALLOWED_TAGS, html$1);
        addToSet(ALLOWED_ATTR, html);
      }
      if (USE_PROFILES.svg === true) {
        addToSet(ALLOWED_TAGS, svg$1);
        addToSet(ALLOWED_ATTR, svg);
        addToSet(ALLOWED_ATTR, xml);
      }
      if (USE_PROFILES.svgFilters === true) {
        addToSet(ALLOWED_TAGS, svgFilters);
        addToSet(ALLOWED_ATTR, svg);
        addToSet(ALLOWED_ATTR, xml);
      }
      if (USE_PROFILES.mathMl === true) {
        addToSet(ALLOWED_TAGS, mathMl$1);
        addToSet(ALLOWED_ATTR, mathMl);
        addToSet(ALLOWED_ATTR, xml);
      }
    }

    /* Merge configuration parameters */
    if (cfg.ADD_TAGS) {
      if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
        ALLOWED_TAGS = clone(ALLOWED_TAGS);
      }
      addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
    }
    if (cfg.ADD_ATTR) {
      if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
        ALLOWED_ATTR = clone(ALLOWED_ATTR);
      }
      addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
    }
    if (cfg.ADD_URI_SAFE_ATTR) {
      addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
    }
    if (cfg.FORBID_CONTENTS) {
      if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
        FORBID_CONTENTS = clone(FORBID_CONTENTS);
      }
      addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
    }

    /* Add #text in case KEEP_CONTENT is set to true */
    if (KEEP_CONTENT) {
      ALLOWED_TAGS['#text'] = true;
    }

    /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */
    if (WHOLE_DOCUMENT) {
      addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
    }

    /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */
    if (ALLOWED_TAGS.table) {
      addToSet(ALLOWED_TAGS, ['tbody']);
      delete FORBID_TAGS.tbody;
    }

    // Prevent further manipulation of configuration.
    // Not available in IE8, Safari 5, etc.
    if (freeze) {
      freeze(cfg);
    }
    CONFIG = cfg;
  };
  var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
  var HTML_INTEGRATION_POINTS = addToSet({}, ['annotation-xml']);

  // Certain elements are allowed in both SVG and HTML
  // namespace. We need to specify them explicitly
  // so that they don't get erroneously deleted from
  // HTML namespace.
  var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);

  /* Keep track of all possible SVG and MathML tags
   * so that we can perform the namespace checks
   * correctly. */
  var ALL_SVG_TAGS = addToSet({}, svg$1);
  addToSet(ALL_SVG_TAGS, svgFilters);
  addToSet(ALL_SVG_TAGS, svgDisallowed);
  var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
  addToSet(ALL_MATHML_TAGS, mathMlDisallowed);

  /**
   *
   *
   * @param  {Element} element a DOM element whose namespace is being checked
   * @returns {boolean} Return false if the element has a
   *  namespace that a spec-compliant parser would never
   *  return. Return true otherwise.
   */
  var _checkValidNamespace = function _checkValidNamespace(element) {
    var parent = getParentNode(element);

    // In JSDOM, if we're inside shadow DOM, then parentNode
    // can be null. We just simulate parent in this case.
    if (!parent || !parent.tagName) {
      parent = {
        namespaceURI: NAMESPACE,
        tagName: 'template'
      };
    }
    var tagName = stringToLowerCase(element.tagName);
    var parentTagName = stringToLowerCase(parent.tagName);
    if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
      return false;
    }
    if (element.namespaceURI === SVG_NAMESPACE) {
      // The only way to switch from HTML namespace to SVG
      // is via <svg>. If it happens via any other tag, then
      // it should be killed.
      if (parent.namespaceURI === HTML_NAMESPACE) {
        return tagName === 'svg';
      }

      // The only way to switch from MathML to SVG is via`
      // svg if parent is either <annotation-xml> or MathML
      // text integration points.
      if (parent.namespaceURI === MATHML_NAMESPACE) {
        return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
      }

      // We only allow elements that are defined in SVG
      // spec. All others are disallowed in SVG namespace.
      return Boolean(ALL_SVG_TAGS[tagName]);
    }
    if (element.namespaceURI === MATHML_NAMESPACE) {
      // The only way to switch from HTML namespace to MathML
      // is via <math>. If it happens via any other tag, then
      // it should be killed.
      if (parent.namespaceURI === HTML_NAMESPACE) {
        return tagName === 'math';
      }

      // The only way to switch from SVG to MathML is via
      // <math> and HTML integration points
      if (parent.namespaceURI === SVG_NAMESPACE) {
        return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
      }

      // We only allow elements that are defined in MathML
      // spec. All others are disallowed in MathML namespace.
      return Boolean(ALL_MATHML_TAGS[tagName]);
    }
    if (element.namespaceURI === HTML_NAMESPACE) {
      // The only way to switch from SVG to HTML is via
      // HTML integration points, and from MathML to HTML
      // is via MathML text integration points
      if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
        return false;
      }
      if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
        return false;
      }

      // We disallow tags that are specific for MathML
      // or SVG and should never appear in HTML namespace
      return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
    }

    // For XHTML and XML documents that support custom namespaces
    if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
      return true;
    }

    // The code should never reach this place (this means
    // that the element somehow got namespace that is not
    // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
    // Return false just in case.
    return false;
  };

  /**
   * _forceRemove
   *
   * @param  {Node} node a DOM node
   */
  var _forceRemove = function _forceRemove(node) {
    arrayPush(DOMPurify.removed, {
      element: node
    });
    try {
      // eslint-disable-next-line unicorn/prefer-dom-node-remove
      node.parentNode.removeChild(node);
    } catch (_) {
      try {
        node.outerHTML = emptyHTML;
      } catch (_) {
        node.remove();
      }
    }
  };

  /**
   * _removeAttribute
   *
   * @param  {String} name an Attribute name
   * @param  {Node} node a DOM node
   */
  var _removeAttribute = function _removeAttribute(name, node) {
    try {
      arrayPush(DOMPurify.removed, {
        attribute: node.getAttributeNode(name),
        from: node
      });
    } catch (_) {
      arrayPush(DOMPurify.removed, {
        attribute: null,
        from: node
      });
    }
    node.removeAttribute(name);

    // We void attribute values for unremovable "is"" attributes
    if (name === 'is' && !ALLOWED_ATTR[name]) {
      if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
        try {
          _forceRemove(node);
        } catch (_) {}
      } else {
        try {
          node.setAttribute(name, '');
        } catch (_) {}
      }
    }
  };

  /**
   * _initDocument
   *
   * @param  {String} dirty a string of dirty markup
   * @return {Document} a DOM, filled with the dirty markup
   */
  var _initDocument = function _initDocument(dirty) {
    /* Create a HTML document */
    var doc;
    var leadingWhitespace;
    if (FORCE_BODY) {
      dirty = '<remove></remove>' + dirty;
    } else {
      /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
      var matches = stringMatch(dirty, /^[\r\n\t ]+/);
      leadingWhitespace = matches && matches[0];
    }
    if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
      // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
      dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
    }
    var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
    /*
     * Use the DOMParser API by default, fallback later if needs be
     * DOMParser not work for svg when has multiple root element.
     */
    if (NAMESPACE === HTML_NAMESPACE) {
      try {
        doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
      } catch (_) {}
    }

    /* Use createHTMLDocument in case DOMParser is not available */
    if (!doc || !doc.documentElement) {
      doc = implementation.createDocument(NAMESPACE, 'template', null);
      try {
        doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
      } catch (_) {
        // Syntax error if dirtyPayload is invalid xml
      }
    }
    var body = doc.body || doc.documentElement;
    if (dirty && leadingWhitespace) {
      body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
    }

    /* Work on whole document or just its body */
    if (NAMESPACE === HTML_NAMESPACE) {
      return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
    }
    return WHOLE_DOCUMENT ? doc.documentElement : body;
  };

  /**
   * _createIterator
   *
   * @param  {Document} root document/fragment to create iterator for
   * @return {Iterator} iterator instance
   */
  var _createIterator = function _createIterator(root) {
    return createNodeIterator.call(root.ownerDocument || root, root,
    // eslint-disable-next-line no-bitwise
    NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
  };

  /**
   * _isClobbered
   *
   * @param  {Node} elm element to check for clobbering attacks
   * @return {Boolean} true if clobbered, false if safe
   */
  var _isClobbered = function _isClobbered(elm) {
    return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
  };

  /**
   * _isNode
   *
   * @param  {Node} obj object to check whether it's a DOM node
   * @return {Boolean} true is object is a DOM node
   */
  var _isNode = function _isNode(object) {
    return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
  };

  /**
   * _executeHook
   * Execute user configurable hooks
   *
   * @param  {String} entryPoint  Name of the hook's entry point
   * @param  {Node} currentNode node to work on with the hook
   * @param  {Object} data additional hook parameters
   */
  var _executeHook = function _executeHook(entryPoint, currentNode, data) {
    if (!hooks[entryPoint]) {
      return;
    }
    arrayForEach(hooks[entryPoint], function (hook) {
      hook.call(DOMPurify, currentNode, data, CONFIG);
    });
  };

  /**
   * _sanitizeElements
   *
   * @protect nodeName
   * @protect textContent
   * @protect removeChild
   *
   * @param   {Node} currentNode to check for permission to exist
   * @return  {Boolean} true if node was killed, false if left alive
   */
  var _sanitizeElements = function _sanitizeElements(currentNode) {
    var content;

    /* Execute a hook if present */
    _executeHook('beforeSanitizeElements', currentNode, null);

    /* Check if element is clobbered or can clobber */
    if (_isClobbered(currentNode)) {
      _forceRemove(currentNode);
      return true;
    }

    /* Check if tagname contains Unicode */
    if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
      _forceRemove(currentNode);
      return true;
    }

    /* Now let's check the element's type and name */
    var tagName = transformCaseFunc(currentNode.nodeName);

    /* Execute a hook if present */
    _executeHook('uponSanitizeElement', currentNode, {
      tagName: tagName,
      allowedTags: ALLOWED_TAGS
    });

    /* Detect mXSS attempts abusing namespace confusion */
    if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
      _forceRemove(currentNode);
      return true;
    }

    /* Mitigate a problem with templates inside select */
    if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
      _forceRemove(currentNode);
      return true;
    }

    /* Remove any ocurrence of processing instructions */
    if (currentNode.nodeType === 7) {
      _forceRemove(currentNode);
      return true;
    }

    /* Remove any kind of possibly harmful comments */
    if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
      _forceRemove(currentNode);
      return true;
    }

    /* Remove element if anything forbids its presence */
    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
      /* Check if we have a custom element to handle */
      if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
        if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
        if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
      }

      /* Keep content except for bad-listed elements */
      if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
        var parentNode = getParentNode(currentNode) || currentNode.parentNode;
        var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
        if (childNodes && parentNode) {
          var childCount = childNodes.length;
          for (var i = childCount - 1; i >= 0; --i) {
            var childClone = cloneNode(childNodes[i], true);
            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
            parentNode.insertBefore(childClone, getNextSibling(currentNode));
          }
        }
      }
      _forceRemove(currentNode);
      return true;
    }

    /* Check whether element has a valid namespace */
    if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
      _forceRemove(currentNode);
      return true;
    }

    /* Make sure that older browsers don't get fallback-tag mXSS */
    if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
      _forceRemove(currentNode);
      return true;
    }

    /* Sanitize element content to be template-safe */
    if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
      /* Get the element's text content */
      content = currentNode.textContent;
      content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
      content = stringReplace(content, ERB_EXPR$1, ' ');
      content = stringReplace(content, TMPLIT_EXPR$1, ' ');
      if (currentNode.textContent !== content) {
        arrayPush(DOMPurify.removed, {
          element: currentNode.cloneNode()
        });
        currentNode.textContent = content;
      }
    }

    /* Execute a hook if present */
    _executeHook('afterSanitizeElements', currentNode, null);
    return false;
  };

  /**
   * _isValidAttribute
   *
   * @param  {string} lcTag Lowercase tag name of containing element.
   * @param  {string} lcName Lowercase attribute name.
   * @param  {string} value Attribute value.
   * @return {Boolean} Returns true if `value` is valid, otherwise false.
   */
  // eslint-disable-next-line complexity
  var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
    /* Make sure attribute cannot clobber */
    if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
      return false;
    }

    /* Allow valid data-* attributes: At least one character after "-"
        (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
        XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
        We don't need to check the value; it's always URI safe. */
    if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
      if (
      // First condition does a very basic check if a) it's basically a valid custom element tagname AND
      // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
      // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
      _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) ||
      // Alternative, second condition checks if it's an `is`-attribute, AND
      // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
      lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ; else {
        return false;
      }
      /* Check value is safe. First, is attr inert? If so, is safe */
    } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if (value) {
      return false;
    } else ;
    return true;
  };

  /**
   * _basicCustomElementCheck
   * checks if at least one dash is included in tagName, and it's not the first char
   * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
   * @param {string} tagName name of the tag of the node to sanitize
   */
  var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
    return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
  };

  /**
   * _sanitizeAttributes
   *
   * @protect attributes
   * @protect nodeName
   * @protect removeAttribute
   * @protect setAttribute
   *
   * @param  {Node} currentNode to sanitize
   */
  var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
    var attr;
    var value;
    var lcName;
    var l;
    /* Execute a hook if present */
    _executeHook('beforeSanitizeAttributes', currentNode, null);
    var attributes = currentNode.attributes;

    /* Check if we have attributes; if not we might have a text node */
    if (!attributes) {
      return;
    }
    var hookEvent = {
      attrName: '',
      attrValue: '',
      keepAttr: true,
      allowedAttributes: ALLOWED_ATTR
    };
    l = attributes.length;

    /* Go backwards over all attributes; safely remove bad ones */
    while (l--) {
      attr = attributes[l];
      var _attr = attr,
        name = _attr.name,
        namespaceURI = _attr.namespaceURI;
      value = name === 'value' ? attr.value : stringTrim(attr.value);
      lcName = transformCaseFunc(name);

      /* Execute a hook if present */
      hookEvent.attrName = lcName;
      hookEvent.attrValue = value;
      hookEvent.keepAttr = true;
      hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
      _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
      value = hookEvent.attrValue;

      /* Did the hooks approve of the attribute? */
      if (hookEvent.forceKeepAttr) {
        continue;
      }

      /* Remove attribute */
      _removeAttribute(name, currentNode);

      /* Did the hooks approve of the attribute? */
      if (!hookEvent.keepAttr) {
        continue;
      }

      /* Work around a security issue in jQuery 3.0 */
      if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
        _removeAttribute(name, currentNode);
        continue;
      }

      /* Sanitize attribute content to be template-safe */
      if (SAFE_FOR_TEMPLATES) {
        value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
        value = stringReplace(value, ERB_EXPR$1, ' ');
        value = stringReplace(value, TMPLIT_EXPR$1, ' ');
      }

      /* Is `value` valid for this attribute? */
      var lcTag = transformCaseFunc(currentNode.nodeName);
      if (!_isValidAttribute(lcTag, lcName, value)) {
        continue;
      }

      /* Full DOM Clobbering protection via namespace isolation,
       * Prefix id and name attributes with `user-content-`
       */
      if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
        // Remove the attribute with this value
        _removeAttribute(name, currentNode);

        // Prefix the value and later re-create the attribute with the sanitized value
        value = SANITIZE_NAMED_PROPS_PREFIX + value;
      }

      /* Work around a security issue with comments inside attributes */
      if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
        _removeAttribute(name, currentNode);
        continue;
      }

      /* Handle attributes that require Trusted Types */
      if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
        if (namespaceURI) ; else {
          switch (trustedTypes.getAttributeType(lcTag, lcName)) {
            case 'TrustedHTML':
              {
                value = trustedTypesPolicy.createHTML(value);
                break;
              }
            case 'TrustedScriptURL':
              {
                value = trustedTypesPolicy.createScriptURL(value);
                break;
              }
          }
        }
      }

      /* Handle invalid data-* attribute set by try-catching it */
      try {
        if (namespaceURI) {
          currentNode.setAttributeNS(namespaceURI, name, value);
        } else {
          /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
          currentNode.setAttribute(name, value);
        }
        if (_isClobbered(currentNode)) {
          _forceRemove(currentNode);
        } else {
          arrayPop(DOMPurify.removed);
        }
      } catch (_) {}
    }

    /* Execute a hook if present */
    _executeHook('afterSanitizeAttributes', currentNode, null);
  };

  /**
   * _sanitizeShadowDOM
   *
   * @param  {DocumentFragment} fragment to iterate over recursively
   */
  var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
    var shadowNode;
    var shadowIterator = _createIterator(fragment);

    /* Execute a hook if present */
    _executeHook('beforeSanitizeShadowDOM', fragment, null);
    while (shadowNode = shadowIterator.nextNode()) {
      /* Execute a hook if present */
      _executeHook('uponSanitizeShadowNode', shadowNode, null);

      /* Sanitize tags and elements */
      if (_sanitizeElements(shadowNode)) {
        continue;
      }

      /* Deep shadow DOM detected */
      if (shadowNode.content instanceof DocumentFragment) {
        _sanitizeShadowDOM(shadowNode.content);
      }

      /* Check attributes, sanitize if necessary */
      _sanitizeAttributes(shadowNode);
    }

    /* Execute a hook if present */
    _executeHook('afterSanitizeShadowDOM', fragment, null);
  };

  /**
   * Sanitize
   * Public method providing core sanitation functionality
   *
   * @param {String|Node} dirty string or DOM node
   * @param {Object} configuration object
   */
  // eslint-disable-next-line complexity
  DOMPurify.sanitize = function (dirty) {
    var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var body;
    var importedNode;
    var currentNode;
    var oldNode;
    var returnNode;
    /* Make sure we have a string to sanitize.
      DO NOT return early, as this will return the wrong type if
      the user has requested a DOM object rather than a string */
    IS_EMPTY_INPUT = !dirty;
    if (IS_EMPTY_INPUT) {
      dirty = '<!-->';
    }

    /* Stringify, in case dirty is an object */
    if (typeof dirty !== 'string' && !_isNode(dirty)) {
      if (typeof dirty.toString === 'function') {
        dirty = dirty.toString();
        if (typeof dirty !== 'string') {
          throw typeErrorCreate('dirty is not a string, aborting');
        }
      } else {
        throw typeErrorCreate('toString is not a function');
      }
    }

    /* Check we can run. Otherwise fall back or ignore */
    if (!DOMPurify.isSupported) {
      if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
        if (typeof dirty === 'string') {
          return window.toStaticHTML(dirty);
        }
        if (_isNode(dirty)) {
          return window.toStaticHTML(dirty.outerHTML);
        }
      }
      return dirty;
    }

    /* Assign config vars */
    if (!SET_CONFIG) {
      _parseConfig(cfg);
    }

    /* Clean up removed elements */
    DOMPurify.removed = [];

    /* Check if dirty is correctly typed for IN_PLACE */
    if (typeof dirty === 'string') {
      IN_PLACE = false;
    }
    if (IN_PLACE) {
      /* Do some early pre-sanitization to avoid unsafe root nodes */
      if (dirty.nodeName) {
        var tagName = transformCaseFunc(dirty.nodeName);
        if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
          throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
        }
      }
    } else if (dirty instanceof Node) {
      /* If dirty is a DOM element, append to an empty document to avoid
         elements being stripped by the parser */
      body = _initDocument('<!---->');
      importedNode = body.ownerDocument.importNode(dirty, true);
      if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
        /* Node is already a body, use as is */
        body = importedNode;
      } else if (importedNode.nodeName === 'HTML') {
        body = importedNode;
      } else {
        // eslint-disable-next-line unicorn/prefer-dom-node-append
        body.appendChild(importedNode);
      }
    } else {
      /* Exit directly if we have nothing to do */
      if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT &&
      // eslint-disable-next-line unicorn/prefer-includes
      dirty.indexOf('<') === -1) {
        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
      }

      /* Initialize the document to work on */
      body = _initDocument(dirty);

      /* Check we have a DOM node from the data */
      if (!body) {
        return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
      }
    }

    /* Remove first element node (ours) if FORCE_BODY is set */
    if (body && FORCE_BODY) {
      _forceRemove(body.firstChild);
    }

    /* Get node iterator */
    var nodeIterator = _createIterator(IN_PLACE ? dirty : body);

    /* Now start iterating over the created document */
    while (currentNode = nodeIterator.nextNode()) {
      /* Fix IE's strange behavior with manipulated textNodes #89 */
      if (currentNode.nodeType === 3 && currentNode === oldNode) {
        continue;
      }

      /* Sanitize tags and elements */
      if (_sanitizeElements(currentNode)) {
        continue;
      }

      /* Shadow DOM detected, sanitize it */
      if (currentNode.content instanceof DocumentFragment) {
        _sanitizeShadowDOM(currentNode.content);
      }

      /* Check attributes, sanitize if necessary */
      _sanitizeAttributes(currentNode);
      oldNode = currentNode;
    }
    oldNode = null;

    /* If we sanitized `dirty` in-place, return it. */
    if (IN_PLACE) {
      return dirty;
    }

    /* Return sanitized string or DOM */
    if (RETURN_DOM) {
      if (RETURN_DOM_FRAGMENT) {
        returnNode = createDocumentFragment.call(body.ownerDocument);
        while (body.firstChild) {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          returnNode.appendChild(body.firstChild);
        }
      } else {
        returnNode = body;
      }
      if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) {
        /*
          AdoptNode() is not used because internal state is not reset
          (e.g. the past names map of a HTMLFormElement), this is safe
          in theory but we would rather not risk another attack vector.
          The state that is cloned by importNode() is explicitly defined
          by the specs.
        */
        returnNode = importNode.call(originalDocument, returnNode, true);
      }
      return returnNode;
    }
    var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;

    /* Serialize doctype if allowed */
    if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
      serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
    }

    /* Sanitize final string template-safe */
    if (SAFE_FOR_TEMPLATES) {
      serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
      serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
      serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
    }
    return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
  };

  /**
   * Public method to set the configuration once
   * setConfig
   *
   * @param {Object} cfg configuration object
   */
  DOMPurify.setConfig = function (cfg) {
    _parseConfig(cfg);
    SET_CONFIG = true;
  };

  /**
   * Public method to remove the configuration
   * clearConfig
   *
   */
  DOMPurify.clearConfig = function () {
    CONFIG = null;
    SET_CONFIG = false;
  };

  /**
   * Public method to check if an attribute value is valid.
   * Uses last set config, if any. Otherwise, uses config defaults.
   * isValidAttribute
   *
   * @param  {string} tag Tag name of containing element.
   * @param  {string} attr Attribute name.
   * @param  {string} value Attribute value.
   * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
   */
  DOMPurify.isValidAttribute = function (tag, attr, value) {
    /* Initialize shared config vars if necessary. */
    if (!CONFIG) {
      _parseConfig({});
    }
    var lcTag = transformCaseFunc(tag);
    var lcName = transformCaseFunc(attr);
    return _isValidAttribute(lcTag, lcName, value);
  };

  /**
   * AddHook
   * Public method to add DOMPurify hooks
   *
   * @param {String} entryPoint entry point for the hook to add
   * @param {Function} hookFunction function to execute
   */
  DOMPurify.addHook = function (entryPoint, hookFunction) {
    if (typeof hookFunction !== 'function') {
      return;
    }
    hooks[entryPoint] = hooks[entryPoint] || [];
    arrayPush(hooks[entryPoint], hookFunction);
  };

  /**
   * RemoveHook
   * Public method to remove a DOMPurify hook at a given entryPoint
   * (pops it from the stack of hooks if more are present)
   *
   * @param {String} entryPoint entry point for the hook to remove
   * @return {Function} removed(popped) hook
   */
  DOMPurify.removeHook = function (entryPoint) {
    if (hooks[entryPoint]) {
      return arrayPop(hooks[entryPoint]);
    }
  };

  /**
   * RemoveHooks
   * Public method to remove all DOMPurify hooks at a given entryPoint
   *
   * @param  {String} entryPoint entry point for the hooks to remove
   */
  DOMPurify.removeHooks = function (entryPoint) {
    if (hooks[entryPoint]) {
      hooks[entryPoint] = [];
    }
  };

  /**
   * RemoveAllHooks
   * Public method to remove all DOMPurify hooks
   *
   */
  DOMPurify.removeAllHooks = function () {
    hooks = {};
  };
  return DOMPurify;
}
var purify = createDOMPurify();

var ALLOWED_IFRAME_PROTOCOLS = new Set(["http:", "https:"]);
/**
 * Safely decodes a URI component, returning the original value if decoding fails
 *
 * @param URIComponent - The URI component string to decode.
 * @return The decoded URI component string, or the original string if decoding fails.
 */
var safeDecodeURIComponent = function (URIComponent) {
    try {
        return decodeURIComponent(URIComponent);
    }
    catch (error) {
        console.log(error.message);
        return URIComponent;
    }
};
/**
 * Sanitizes and validates a URL for use in an iframe src attribute. It ensures that the URL uses
 * an allowed protocol (http or https) and prevents potential XSS attacks by sanitizing the input.
 *
 * @param rawUrl - The raw URL string to be sanitized and validated.
 * @return A sanitized and validated URL string that can be safely used in an iframe src attribute.
 * If the URL is invalid or uses a disallowed protocol, "about:blank" is returned instead.
 */
var getSanitizedIframeUrl = function (rawUrl) {
    var sanitizedUrl = purify.sanitize(rawUrl).trim();
    var decodedUrl = safeDecodeURIComponent(sanitizedUrl).trim();
    var parsedUrl = new URL(decodedUrl, window.location.origin);
    if (ALLOWED_IFRAME_PROTOCOLS.has(parsedUrl.protocol)) {
        return decodedUrl;
    }
    else {
        console.log("Blocked an invalid and/or potentially unsafe URL in iframe src:", decodedUrl);
        return "about:blank";
    }
};

var StyledIFrame$1 = lighthouseComponentLibrary.styled.iframe(templateObject_1$z || (templateObject_1$z = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  border: none;\n"], ["\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  border: none;\n"])));
function ExternalDemandSchedulingPageView(_a) {
    var accountData = _a.accountData, title = _a.title, iFrameSrc = _a.iFrameSrc;
    var formRef = React.useRef(null);
    var accessTokenInputRef = React.useRef(null);
    function autoSubmitForm() {
        return __awaiter(this, void 0, void 0, function () {
            var accessToken, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getAccessToken()];
                    case 1:
                        accessToken = _a.sent();
                        if (!formRef.current || !accessTokenInputRef.current) {
                            throw new Error("Form or access token input ref is not set");
                        }
                        accessTokenInputRef.current.value = accessToken;
                        formRef.current.submit();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        reportLoginErrorDetailsToDynatrace(err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    React.useEffect(function () {
        autoSubmitForm();
        // TODO: See https://workplacejira.atlassian.net/browse/SUITE-6553 for a task to support cancelling this useEffect.
    }, [iFrameSrc]);
    var iframeName = React.useMemo(function () { return uuid.v4(); }, []);
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        React__namespace.default.createElement("form", { ref: formRef, method: "POST", action: getDemandSchedulingAuthRedirectUrl(accountData), style: { display: "none" }, target: iframeName },
            React__namespace.default.createElement("input", { ref: accessTokenInputRef, type: "hidden", name: "token" }),
            React__namespace.default.createElement("input", { type: "hidden", name: "account_id", value: accountData.accountDetail.externalId }),
            React__namespace.default.createElement("input", { type: "hidden", name: "redirect_uri", value: iFrameSrc })),
        React__namespace.default.createElement(StyledIFrame$1, { title: title, name: iframeName })));
}
var templateObject_1$z;

var StyledIFrame = lighthouseComponentLibrary.styled.iframe(templateObject_1$y || (templateObject_1$y = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  border: none;\n"], ["\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  border: none;\n"])));
function ExternalPageView(_a) {
    var title = _a.title, match = _a.match, location = _a.location;
    var _b, _c;
    var rawIFrameSrc = "";
    var encodedExternalUrl = match.params.externalUrl;
    var urlInfo = (_b = location.state) === null || _b === void 0 ? void 0 : _b.urlInfo;
    // encodedDeeplinkUrlWithoutQuery does not get reset after being called so this if
    // statement is to validate whether the url is a deeplink or not
    if (urlInfo &&
        encodedExternalUrl === (urlInfo === null || urlInfo === void 0 ? void 0 : urlInfo.encodedDeeplinkUrlWithoutQuery)) {
        var decodedUrlWithoutQuery = safeDecodeURIComponent("" + (urlInfo === null || urlInfo === void 0 ? void 0 : urlInfo.encodedDeeplinkUrlWithoutQuery)).trim();
        // Set URL + query as the iFrame src.
        rawIFrameSrc = "" + decodedUrlWithoutQuery + ((urlInfo === null || urlInfo === void 0 ? void 0 : urlInfo.query) ? urlInfo === null || urlInfo === void 0 ? void 0 : urlInfo.query : "");
    }
    else {
        // if encodedExternalUrl does not match encodedDeeplinkUrlWithoutQuery or urlInfo is undefined
        // then the iframe src should be set to the external url
        rawIFrameSrc = encodedExternalUrl;
    }
    var iFrameSrc = getSanitizedIframeUrl(rawIFrameSrc);
    var _d = React.useState(), iframe = _d[0], setIframe = _d[1];
    // attempt to supply WFX app with access
    // token to auto-login the associated user
    useWfxIFrameAccess(iframe);
    useVacationBiddingIFrameAccess(iframe);
    // Listen for postMessage events and publish user activity
    var featureFlags = useNamedFeatureFlags(exports.FeatureFlagKey.SuiteSessionInactivity, exports.FeatureFlagKey.WTATokenBasedLogin);
    var suiteSessionInactivityFF = featureFlags[exports.FeatureFlagKey.SuiteSessionInactivity];
    var externalUserActivityEventPublisher = useExternalUserActivityEventPublisher();
    React.useEffect(function () {
        if (!suiteSessionInactivityFF) {
            return;
        }
        var handleMessage = function (event) {
            if (event.data && event.data.type === suiteIframeActivityRelay.USER_ACTIVITY_DETECTED) {
                externalUserActivityEventPublisher.publish();
            }
        };
        window.addEventListener("message", handleMessage);
        return function () {
            window.removeEventListener("message", handleMessage);
        };
    }, [externalUserActivityEventPublisher, suiteSessionInactivityFF]);
    var isWTATokenBasedLoginEnabled = featureFlags[exports.FeatureFlagKey.WTATokenBasedLogin];
    // Register iframe-parent communication for WTA pages on mobile only
    // Requires WTATokenBasedLogin feature to be enabled
    React.useEffect(function () {
        if (!isCordovaDevice() ||
            !isWTATokenBasedLoginEnabled ||
            !isWtaUrl(iFrameSrc)) {
            return;
        }
        var authManager = AuthenticationManager.getInstance();
        authManager.registerIframeParentCommunication();
        // Cleanup: unregister when component unmounts or URL changes away from WTA
        return function () {
            authManager.unregisterIframeParentCommunication();
        };
    }, [isWTATokenBasedLoginEnabled, iFrameSrc]);
    if (useTokenBasedAuthForDemandScheduling()) {
        var accountData = (_c = AuthenticationManager.getInstance().getAccountInfo()) === null || _c === void 0 ? void 0 : _c.accountData;
        if (!accountData) {
            console.warn("Could not identify Demand Scheduling url: account data not found");
            // White screen for now. See https://workplacejira.atlassian.net/browse/SUITE-6553 for a task to improve the error screen.
            return React__namespace.default.createElement("div", null);
        }
        if (iFrameSrc.startsWith(getDemandSchedulingBaseUrl(accountData))) {
            return (React__namespace.default.createElement(ExternalDemandSchedulingPageView, { accountData: accountData, title: title, iFrameSrc: iFrameSrc }));
        }
    }
    return (React__namespace.default.createElement(StyledIFrame, { title: title, ref: function (ref) {
            setIframe(ref || undefined);
        }, src: iFrameSrc, allow: "local-network-access" }));
}
var templateObject_1$y;

var ExternalPageViewWrapper = function (props) {
    return function (externalPageProps) { return (React__namespace.createElement(ExternalPageView, __assign({}, externalPageProps, props))); };
};

var RouteLink$1 = /** @class */ (function (_super) {
    __extends(RouteLink, _super);
    function RouteLink(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Function intended to handle the space bar key press on links
         * @param event
         */
        _this.handleKeyPress = function (event) {
            // 32 is the key code for spacebar
            if (event.which === 32) {
                _this.props.history.push({
                    pathname: _this.link,
                    state: {
                        prevPath: _this.props.currentPath,
                    },
                });
            }
        };
        return _this;
    }
    RouteLink.prototype.render = function () {
        var _this = this;
        return (React__namespace.createElement(RouteContext.Consumer, null, function (context) {
            var route = context.findRouteByName(_this.props.linkTo, _this.props.id);
            if (!route) {
                global.console.error("Could not create link named: ", _this.props.linkTo);
                return null;
            }
            _this.link = Boolean(_this.props.auxiliary)
                ? _this.props.currentPath + "/&" + route
                : route;
            return (React__namespace.createElement(reactRouterDom.Link, { onKeyPress: _this.handleKeyPress, className: _this.props.className || "", "data-qa": _this.props["data-qa"] || "", "aria-label": _this.props["aria-label"] || "", to: {
                    pathname: _this.link,
                    state: { prevPath: _this.props.currentPath },
                } }, _this.props.children));
        }));
    };
    return RouteLink;
}(React__namespace.Component));
var RouteLink$2 = reactRouterDom.withRouter(RouteLink$1);

var styles$6 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      margin: 0
    },

    /* Styles applied to the root element if `variant="body2"`. */
    body2: theme.typography.body2,

    /* Styles applied to the root element if `variant="body1"`. */
    body1: theme.typography.body1,

    /* Styles applied to the root element if `variant="caption"`. */
    caption: theme.typography.caption,

    /* Styles applied to the root element if `variant="button"`. */
    button: theme.typography.button,

    /* Styles applied to the root element if `variant="h1"`. */
    h1: theme.typography.h1,

    /* Styles applied to the root element if `variant="h2"`. */
    h2: theme.typography.h2,

    /* Styles applied to the root element if `variant="h3"`. */
    h3: theme.typography.h3,

    /* Styles applied to the root element if `variant="h4"`. */
    h4: theme.typography.h4,

    /* Styles applied to the root element if `variant="h5"`. */
    h5: theme.typography.h5,

    /* Styles applied to the root element if `variant="h6"`. */
    h6: theme.typography.h6,

    /* Styles applied to the root element if `variant="subtitle1"`. */
    subtitle1: theme.typography.subtitle1,

    /* Styles applied to the root element if `variant="subtitle2"`. */
    subtitle2: theme.typography.subtitle2,

    /* Styles applied to the root element if `variant="overline"`. */
    overline: theme.typography.overline,

    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
    srOnly: {
      position: 'absolute',
      height: 1,
      width: 1,
      overflow: 'hidden'
    },

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `nowrap={true}`. */
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the root element if `gutterBottom={true}`. */
    gutterBottom: {
      marginBottom: '0.35em'
    },

    /* Styles applied to the root element if `paragraph={true}`. */
    paragraph: {
      marginBottom: 16
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="textPrimary"`. */
    colorTextPrimary: {
      color: theme.palette.text.primary
    },

    /* Styles applied to the root element if `color="textSecondary"`. */
    colorTextSecondary: {
      color: theme.palette.text.secondary
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `display="inline"`. */
    displayInline: {
      display: 'inline'
    },

    /* Styles applied to the root element if `display="block"`. */
    displayBlock: {
      display: 'block'
    }
  };
};
var defaultVariantMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p'
};
var Typography = React__namespace.forwardRef(function Typography(props, ref) {
  var _props$align = props.align,
      align = _props$align === void 0 ? 'inherit' : _props$align,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'initial' : _props$color,
      component = props.component,
      _props$display = props.display,
      display = _props$display === void 0 ? 'initial' : _props$display,
      _props$gutterBottom = props.gutterBottom,
      gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom,
      _props$noWrap = props.noWrap,
      noWrap = _props$noWrap === void 0 ? false : _props$noWrap,
      _props$paragraph = props.paragraph,
      paragraph = _props$paragraph === void 0 ? false : _props$paragraph,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'body1' : _props$variant,
      _props$variantMapping = props.variantMapping,
      variantMapping = _props$variantMapping === void 0 ? defaultVariantMapping : _props$variantMapping,
      other = _objectWithoutProperties(props, ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"]);

  var Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
  return /*#__PURE__*/React__namespace.createElement(Component, _extends$1({
    className: clsx(classes.root, className, variant !== 'inherit' && classes[variant], color !== 'initial' && classes["color".concat(capitalize(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== 'inherit' && classes["align".concat(capitalize(align))], display !== 'initial' && classes["display".concat(capitalize(display))]),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? Typography.propTypes = {
  /**
   * Set the text-align on the component.
   */
  align: PropTypes.oneOf(['inherit', 'left', 'center', 'right', 'justify']),

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   * Overrides the behavior of the `variantMapping` prop.
   */
  component: PropTypes.elementType,

  /**
   * Controls the display type
   */
  display: PropTypes.oneOf(['initial', 'block', 'inline']),

  /**
   * If `true`, the text will have a bottom margin.
   */
  gutterBottom: PropTypes.bool,

  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   */
  noWrap: PropTypes.bool,

  /**
   * If `true`, the text will have a bottom margin.
   */
  paragraph: PropTypes.bool,

  /**
   * Applies the theme typography styles.
   */
  variant: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline', 'srOnly', 'inherit']),

  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   */
  variantMapping: PropTypes.object
} : void 0;
var Typography$1 = withStyles(styles$6, {
  name: 'MuiTypography'
})(Typography);

var styles$5 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      flex: '1 1 auto',
      WebkitOverflowScrolling: 'touch',
      // Add iOS momentum scrolling.
      overflowY: 'auto',
      padding: '8px 24px',
      '&:first-child': {
        // dialog without title
        paddingTop: 20
      }
    },

    /* Styles applied to the root element if `dividers={true}`. */
    dividers: {
      padding: '16px 24px',
      borderTop: "1px solid ".concat(theme.palette.divider),
      borderBottom: "1px solid ".concat(theme.palette.divider)
    }
  };
};
var DialogContent = React__namespace.forwardRef(function DialogContent(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$dividers = props.dividers,
      dividers = _props$dividers === void 0 ? false : _props$dividers,
      other = _objectWithoutProperties(props, ["classes", "className", "dividers"]);

  return /*#__PURE__*/React__namespace.createElement("div", _extends$1({
    className: clsx(classes.root, className, dividers && classes.dividers),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? DialogContent.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Display the top and bottom dividers.
   */
  dividers: PropTypes.bool
} : void 0;
var DialogContent$1 = withStyles(styles$5, {
  name: 'MuiDialogContent'
})(DialogContent);

var styles$4 = {
  /* Styles applied to the root element. */
  root: {
    marginBottom: 12
  }
};
var DialogContentText = React__namespace.forwardRef(function DialogContentText(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(Typography$1, _extends$1({
    component: "p",
    variant: "body1",
    color: "textSecondary",
    ref: ref
  }, props));
});
process.env.NODE_ENV !== "production" ? DialogContentText.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired
} : void 0;
var DialogContentText$1 = withStyles(styles$4, {
  name: 'MuiDialogContentText'
})(DialogContentText);

var styles$3 = {
  /* Styles applied to the root element. */
  root: {
    margin: 0,
    padding: '16px 24px',
    flex: '0 0 auto'
  }
};
var DialogTitle = React__namespace.forwardRef(function DialogTitle(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$disableTypogra = props.disableTypography,
      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
      other = _objectWithoutProperties(props, ["children", "classes", "className", "disableTypography"]);

  return /*#__PURE__*/React__namespace.createElement("div", _extends$1({
    className: clsx(classes.root, className),
    ref: ref
  }, other), disableTypography ? children : /*#__PURE__*/React__namespace.createElement(Typography$1, {
    component: "h2",
    variant: "h6"
  }, children));
});
process.env.NODE_ENV !== "production" ? DialogTitle.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the children won't be wrapped by a typography component.
   * For instance, this can be useful to render an h4 instead of the default h2.
   */
  disableTypography: PropTypes.bool
} : void 0;
var DialogTitle$1 = withStyles(styles$3, {
  name: 'MuiDialogTitle'
})(DialogTitle);

var SPACINGS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var GRID_SIZES = ['auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

function generateGrid(globalStyles, theme, breakpoint) {
  var styles = {};
  GRID_SIZES.forEach(function (size) {
    var key = "grid-".concat(breakpoint, "-").concat(size);

    if (size === true) {
      // For the auto layouting
      styles[key] = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: '100%'
      };
      return;
    }

    if (size === 'auto') {
      styles[key] = {
        flexBasis: 'auto',
        flexGrow: 0,
        maxWidth: 'none'
      };
      return;
    } // Keep 7 significant numbers.


    var width = "".concat(Math.round(size / 12 * 10e7) / 10e5, "%"); // Close to the bootstrap implementation:
    // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41

    styles[key] = {
      flexBasis: width,
      flexGrow: 0,
      maxWidth: width
    };
  }); // No need for a media query for the first size.

  if (breakpoint === 'xs') {
    _extends$1(globalStyles, styles);
  } else {
    globalStyles[theme.breakpoints.up(breakpoint)] = styles;
  }
}

function getOffset(val) {
  var div = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var parse = parseFloat(val);
  return "".concat(parse / div).concat(String(val).replace(String(parse), '') || 'px');
}

function generateGutter(theme, breakpoint) {
  var styles = {};
  SPACINGS.forEach(function (spacing) {
    var themeSpacing = theme.spacing(spacing);

    if (themeSpacing === 0) {
      return;
    }

    styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
      margin: "-".concat(getOffset(themeSpacing, 2)),
      width: "calc(100% + ".concat(getOffset(themeSpacing), ")"),
      '& > $item': {
        padding: getOffset(themeSpacing, 2)
      }
    };
  });
  return styles;
} // Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',


var styles$2 = function styles(theme) {
  return _extends$1(_extends$1({
    /* Styles applied to the root element. */
    root: {},

    /* Styles applied to the root element if `container={true}`. */
    container: {
      boxSizing: 'border-box',
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%'
    },

    /* Styles applied to the root element if `item={true}`. */
    item: {
      boxSizing: 'border-box',
      margin: '0' // For instance, it's useful when used with a `figure` element.

    },

    /* Styles applied to the root element if `zeroMinWidth={true}`. */
    zeroMinWidth: {
      minWidth: 0
    },

    /* Styles applied to the root element if `direction="column"`. */
    'direction-xs-column': {
      flexDirection: 'column'
    },

    /* Styles applied to the root element if `direction="column-reverse"`. */
    'direction-xs-column-reverse': {
      flexDirection: 'column-reverse'
    },

    /* Styles applied to the root element if `direction="row-reverse"`. */
    'direction-xs-row-reverse': {
      flexDirection: 'row-reverse'
    },

    /* Styles applied to the root element if `wrap="nowrap"`. */
    'wrap-xs-nowrap': {
      flexWrap: 'nowrap'
    },

    /* Styles applied to the root element if `wrap="reverse"`. */
    'wrap-xs-wrap-reverse': {
      flexWrap: 'wrap-reverse'
    },

    /* Styles applied to the root element if `alignItems="center"`. */
    'align-items-xs-center': {
      alignItems: 'center'
    },

    /* Styles applied to the root element if `alignItems="flex-start"`. */
    'align-items-xs-flex-start': {
      alignItems: 'flex-start'
    },

    /* Styles applied to the root element if `alignItems="flex-end"`. */
    'align-items-xs-flex-end': {
      alignItems: 'flex-end'
    },

    /* Styles applied to the root element if `alignItems="baseline"`. */
    'align-items-xs-baseline': {
      alignItems: 'baseline'
    },

    /* Styles applied to the root element if `alignContent="center"`. */
    'align-content-xs-center': {
      alignContent: 'center'
    },

    /* Styles applied to the root element if `alignContent="flex-start"`. */
    'align-content-xs-flex-start': {
      alignContent: 'flex-start'
    },

    /* Styles applied to the root element if `alignContent="flex-end"`. */
    'align-content-xs-flex-end': {
      alignContent: 'flex-end'
    },

    /* Styles applied to the root element if `alignContent="space-between"`. */
    'align-content-xs-space-between': {
      alignContent: 'space-between'
    },

    /* Styles applied to the root element if `alignContent="space-around"`. */
    'align-content-xs-space-around': {
      alignContent: 'space-around'
    },

    /* Styles applied to the root element if `justify="center"`. */
    'justify-xs-center': {
      justifyContent: 'center'
    },

    /* Styles applied to the root element if `justify="flex-end"`. */
    'justify-xs-flex-end': {
      justifyContent: 'flex-end'
    },

    /* Styles applied to the root element if `justify="space-between"`. */
    'justify-xs-space-between': {
      justifyContent: 'space-between'
    },

    /* Styles applied to the root element if `justify="space-around"`. */
    'justify-xs-space-around': {
      justifyContent: 'space-around'
    },

    /* Styles applied to the root element if `justify="space-evenly"`. */
    'justify-xs-space-evenly': {
      justifyContent: 'space-evenly'
    }
  }, generateGutter(theme, 'xs')), theme.breakpoints.keys.reduce(function (accumulator, key) {
    // Use side effect over immutability for better performance.
    generateGrid(accumulator, theme, key);
    return accumulator;
  }, {}));
};
var Grid = React__namespace.forwardRef(function Grid(props, ref) {
  var _props$alignContent = props.alignContent,
      alignContent = _props$alignContent === void 0 ? 'stretch' : _props$alignContent,
      _props$alignItems = props.alignItems,
      alignItems = _props$alignItems === void 0 ? 'stretch' : _props$alignItems,
      classes = props.classes,
      classNameProp = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$container = props.container,
      container = _props$container === void 0 ? false : _props$container,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'row' : _props$direction,
      _props$item = props.item,
      item = _props$item === void 0 ? false : _props$item,
      _props$justify = props.justify,
      justify = _props$justify === void 0 ? 'flex-start' : _props$justify,
      _props$lg = props.lg,
      lg = _props$lg === void 0 ? false : _props$lg,
      _props$md = props.md,
      md = _props$md === void 0 ? false : _props$md,
      _props$sm = props.sm,
      sm = _props$sm === void 0 ? false : _props$sm,
      _props$spacing = props.spacing,
      spacing = _props$spacing === void 0 ? 0 : _props$spacing,
      _props$wrap = props.wrap,
      wrap = _props$wrap === void 0 ? 'wrap' : _props$wrap,
      _props$xl = props.xl,
      xl = _props$xl === void 0 ? false : _props$xl,
      _props$xs = props.xs,
      xs = _props$xs === void 0 ? false : _props$xs,
      _props$zeroMinWidth = props.zeroMinWidth,
      zeroMinWidth = _props$zeroMinWidth === void 0 ? false : _props$zeroMinWidth,
      other = _objectWithoutProperties(props, ["alignContent", "alignItems", "classes", "className", "component", "container", "direction", "item", "justify", "lg", "md", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"]);

  var className = clsx(classes.root, classNameProp, container && [classes.container, spacing !== 0 && classes["spacing-xs-".concat(String(spacing))]], item && classes.item, zeroMinWidth && classes.zeroMinWidth, direction !== 'row' && classes["direction-xs-".concat(String(direction))], wrap !== 'wrap' && classes["wrap-xs-".concat(String(wrap))], alignItems !== 'stretch' && classes["align-items-xs-".concat(String(alignItems))], alignContent !== 'stretch' && classes["align-content-xs-".concat(String(alignContent))], justify !== 'flex-start' && classes["justify-xs-".concat(String(justify))], xs !== false && classes["grid-xs-".concat(String(xs))], sm !== false && classes["grid-sm-".concat(String(sm))], md !== false && classes["grid-md-".concat(String(md))], lg !== false && classes["grid-lg-".concat(String(lg))], xl !== false && classes["grid-xl-".concat(String(xl))]);
  return /*#__PURE__*/React__namespace.createElement(Component, _extends$1({
    className: className,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? Grid.propTypes = {
  /**
   * Defines the `align-content` style property.
   * It's applied for all screen sizes.
   */
  alignContent: PropTypes.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around']),

  /**
   * Defines the `align-items` style property.
   * It's applied for all screen sizes.
   */
  alignItems: PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,

  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   */
  container: PropTypes.bool,

  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   */
  direction: PropTypes.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),

  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   */
  item: PropTypes.bool,

  /**
   * Defines the `justify-content` style property.
   * It is applied for all screen sizes.
   */
  justify: PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly']),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `lg` breakpoint and wider screens if not overridden.
   */
  lg: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `md` breakpoint and wider screens if not overridden.
   */
  md: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `sm` breakpoint and wider screens if not overridden.
   */
  sm: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the space between the type `item` component.
   * It can only be used on a type `container` component.
   */
  spacing: PropTypes.oneOf(SPACINGS),

  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   */
  wrap: PropTypes.oneOf(['nowrap', 'wrap', 'wrap-reverse']),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `xl` breakpoint and wider screens.
   */
  xl: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for all the screen sizes with the lowest priority.
   */
  xs: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   */
  zeroMinWidth: PropTypes.bool
} : void 0;
var StyledGrid = withStyles(styles$2, {
  name: 'MuiGrid'
})(Grid);

if (process.env.NODE_ENV !== 'production') {
  var requireProp = requirePropFactory('Grid');
  StyledGrid.propTypes = _extends$1(_extends$1({}, StyledGrid.propTypes), {}, {
    alignContent: requireProp('container'),
    alignItems: requireProp('container'),
    direction: requireProp('container'),
    justify: requireProp('container'),
    lg: requireProp('item'),
    md: requireProp('item'),
    sm: requireProp('item'),
    spacing: requireProp('container'),
    wrap: requireProp('container'),
    xs: requireProp('item'),
    zeroMinWidth: requireProp('item')
  });
}

var Grid$1 = StyledGrid;

/**
 * @ignore - internal component.
 */

var ListContext = React__namespace.createContext({});

if (process.env.NODE_ENV !== 'production') {
  ListContext.displayName = 'ListContext';
}

var ListContext$1 = ListContext;

var styles$1 = {
  /* Styles applied to the root element. */
  root: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative'
  },

  /* Styles applied to the root element if `disablePadding={false}`. */
  padding: {
    paddingTop: 8,
    paddingBottom: 8
  },

  /* Styles applied to the root element if dense. */
  dense: {},

  /* Styles applied to the root element if a `subheader` is provided. */
  subheader: {
    paddingTop: 0
  }
};
var List$1 = React__namespace.forwardRef(function List(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'ul' : _props$component,
      _props$dense = props.dense,
      dense = _props$dense === void 0 ? false : _props$dense,
      _props$disablePadding = props.disablePadding,
      disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding,
      subheader = props.subheader,
      other = _objectWithoutProperties(props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);

  var context = React__namespace.useMemo(function () {
    return {
      dense: dense
    };
  }, [dense]);
  return /*#__PURE__*/React__namespace.createElement(ListContext$1.Provider, {
    value: context
  }, /*#__PURE__*/React__namespace.createElement(Component, _extends$1({
    className: clsx(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
    ref: ref
  }, other), subheader, children));
});
process.env.NODE_ENV !== "production" ? List$1.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   */
  dense: PropTypes.bool,

  /**
   * If `true`, vertical padding will be removed from the list.
   */
  disablePadding: PropTypes.bool,

  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: PropTypes.node
} : void 0;
var List$2 = withStyles(styles$1, {
  name: 'MuiList'
})(List$1);

var styles = function styles(theme) {
  return {
    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      textDecoration: 'none',
      width: '100%',
      boxSizing: 'border-box',
      textAlign: 'left',
      paddingTop: 8,
      paddingBottom: 8,
      '&$focusVisible': {
        backgroundColor: theme.palette.action.selected
      },
      '&$selected, &$selected:hover': {
        backgroundColor: theme.palette.action.selected
      },
      '&$disabled': {
        opacity: 0.5
      }
    },

    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
    container: {
      position: 'relative'
    },

    /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */
    focusVisible: {},

    /* Styles applied to the `component` element if dense. */
    dense: {
      paddingTop: 4,
      paddingBottom: 4
    },

    /* Styles applied to the `component` element if `alignItems="flex-start"`. */
    alignItemsFlexStart: {
      alignItems: 'flex-start'
    },

    /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the inner `component` element if `divider={true}`. */
    divider: {
      borderBottom: "1px solid ".concat(theme.palette.divider),
      backgroundClip: 'padding-box'
    },

    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },

    /* Styles applied to the inner `component` element if `button={true}`. */
    button: {
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
    secondaryAction: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    },

    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {}
  };
};
var useEnhancedEffect = typeof window === 'undefined' ? React__namespace.useEffect : React__namespace.useLayoutEffect;
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */

var ListItem = React__namespace.forwardRef(function ListItem(props, ref) {
  var _props$alignItems = props.alignItems,
      alignItems = _props$alignItems === void 0 ? 'center' : _props$alignItems,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      _props$button = props.button,
      button = _props$button === void 0 ? false : _props$button,
      childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      componentProp = props.component,
      _props$ContainerCompo = props.ContainerComponent,
      ContainerComponent = _props$ContainerCompo === void 0 ? 'li' : _props$ContainerCompo,
      _props$ContainerProps = props.ContainerProps;
  _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;

  var ContainerClassName = _props$ContainerProps.className,
      ContainerProps = _objectWithoutProperties(_props$ContainerProps, ["className"]),
      _props$dense = props.dense,
      dense = _props$dense === void 0 ? false : _props$dense,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$divider = props.divider,
      divider = _props$divider === void 0 ? false : _props$divider,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? false : _props$selected,
      other = _objectWithoutProperties(props, ["alignItems", "autoFocus", "button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"]);

  var context = React__namespace.useContext(ListContext$1);
  var childContext = {
    dense: dense || context.dense || false,
    alignItems: alignItems
  };
  var listItemRef = React__namespace.useRef(null);
  useEnhancedEffect(function () {
    if (autoFocus) {
      if (listItemRef.current) {
        listItemRef.current.focus();
      } else if (process.env.NODE_ENV !== 'production') {
        console.error('Material-UI: Unable to set focus to a ListItem whose component has not been rendered.');
      }
    }
  }, [autoFocus]);
  var children = React__namespace.Children.toArray(childrenProp);
  var hasSecondaryAction = children.length && isMuiElement(children[children.length - 1], ['ListItemSecondaryAction']);
  var handleOwnRef = React__namespace.useCallback(function (instance) {
    // #StrictMode ready
    listItemRef.current = ReactDOM__namespace.findDOMNode(instance);
  }, []);
  var handleRef = useForkRef(handleOwnRef, ref);

  var componentProps = _extends$1({
    className: clsx(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
    disabled: disabled
  }, other);

  var Component = componentProp || 'li';

  if (button) {
    componentProps.component = componentProp || 'div';
    componentProps.focusVisibleClassName = clsx(classes.focusVisible, focusVisibleClassName);
    Component = ButtonBase$1;
  }

  if (hasSecondaryAction) {
    // Use div by default.
    Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.

    if (ContainerComponent === 'li') {
      if (Component === 'li') {
        Component = 'div';
      } else if (componentProps.component === 'li') {
        componentProps.component = 'div';
      }
    }

    return /*#__PURE__*/React__namespace.createElement(ListContext$1.Provider, {
      value: childContext
    }, /*#__PURE__*/React__namespace.createElement(ContainerComponent, _extends$1({
      className: clsx(classes.container, ContainerClassName),
      ref: handleRef
    }, ContainerProps), /*#__PURE__*/React__namespace.createElement(Component, componentProps, children), children.pop()));
  }

  return /*#__PURE__*/React__namespace.createElement(ListContext$1.Provider, {
    value: childContext
  }, /*#__PURE__*/React__namespace.createElement(Component, _extends$1({
    ref: handleRef
  }, componentProps), children));
});
process.env.NODE_ENV !== "production" ? ListItem.propTypes = {
  /**
   * Defines the `align-items` style property.
   */
  alignItems: PropTypes.oneOf(['flex-start', 'center']),

  /**
   * If `true`, the list item will be focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   */
  autoFocus: PropTypes.bool,

  /**
   * If `true`, the list item will be a button (using `ButtonBase`). Props intended
   * for `ButtonBase` can then be applied to `ListItem`.
   */
  button: PropTypes.bool,

  /**
   * The content of the component. If a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: chainPropTypes(PropTypes.node, function (props) {
    var children = React__namespace.Children.toArray(props.children); // React.Children.toArray(props.children).findLastIndex(isListItemSecondaryAction)

    var secondaryActionIndex = -1;

    for (var i = children.length - 1; i >= 0; i -= 1) {
      var child = children[i];

      if (isMuiElement(child, ['ListItemSecondaryAction'])) {
        secondaryActionIndex = i;
        break;
      }
    } //  is ListItemSecondaryAction the last child of ListItem


    if (secondaryActionIndex !== -1 && secondaryActionIndex !== children.length - 1) {
      return new Error('Material-UI: You used an element after ListItemSecondaryAction. ' + 'For ListItem to detect that it has a secondary action ' + 'you must pass it as the last child to ListItem.');
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
   */
  component: PropTypes.elementType,

  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   */
  ContainerComponent: PropTypes.elementType,

  /**
   * Props applied to the container component if used.
   */
  ContainerProps: PropTypes.object,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
   */
  dense: PropTypes.bool,

  /**
   * If `true`, the list item will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: PropTypes.bool,

  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   */
  divider: PropTypes.bool,

  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,

  /**
   * Use to apply selected styling.
   */
  selected: PropTypes.bool
} : void 0;
var ListItem$1 = withStyles(styles, {
  name: 'MuiListItem'
})(ListItem);

var StyledDialogActions = lighthouseComponentLibrary.styled(DialogActions$1)(templateObject_1$x || (templateObject_1$x = __makeTemplateObject(["\n  && {\n    padding: ", ";\n  }\n  & :not(:first-child) {\n    margin-left: ", ";\n  }\n"], ["\n  && {\n    padding: ", ";\n  }\n  & :not(:first-child) {\n    margin-left: ", ";\n  }\n"])), polished.rem(8), polished.rem(8));
var StyledDialogContent$1 = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.DialogContent)(templateObject_2$p || (templateObject_2$p = __makeTemplateObject(["\n  && {\n    padding: ", " ", ";\n  }\n"], ["\n  && {\n    padding: ", " ", ";\n  }\n"])), polished.rem(8), polished.rem(24));
var StyledTypography$2 = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_3$i || (templateObject_3$i = __makeTemplateObject(["\n  margin: 0;\n  flex: 1;\n"], ["\n  margin: 0;\n  flex: 1;\n"])));
var StyledDialogTitle$1 = lighthouseComponentLibrary.styled(DialogTitle$1)(templateObject_4$d || (templateObject_4$d = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
/**
 * An alert that is shown if there are any unsaved changes on the page and the user tries to
 * navigate away
 * @param isOpen - If true, the alert is open
 * @param callbackOnButtonPress - Pass a function to be executed with argument 'true' if the
 * user chose to discard changes, and with 'false' if he/she decided to stay on the page.
 */
function UnsavedChangesAlert(_a) {
    var isOpen = _a.isOpen, callbackOnButtonPress = _a.callbackOnButtonPress;
    var translate = useTranslateFunction();
    var theme = useTheme();
    var proceedWithTransition = function () {
        if (callbackOnButtonPress) {
            callbackOnButtonPress(true);
        }
    };
    var blockTransition = function () {
        if (callbackOnButtonPress) {
            callbackOnButtonPress(false);
        }
    };
    // TODO: LTH-3153 - Move close icon to the component-library
    return (React__namespace.default.createElement(lighthouseComponentLibrary.Dialog, { open: isOpen, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", maxWidth: "xs", onClose: blockTransition },
        React__namespace.default.createElement(StyledDialogTitle$1, { disableTypography: true, id: "alert-dialog-title" },
            React__namespace.default.createElement(StyledTypography$2, { use: "h2" }, translate("NAVIGATION_WARNING.UNSAVED_CHANGES_HEADING")),
            React__namespace.default.createElement(lighthouseComponentLibrary.IconButton, { "aria-label": "close", onClick: blockTransition },
                React__namespace.default.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faTimes, color: theme.colours.grey.tone["800"] }))),
        React__namespace.default.createElement(StyledDialogContent$1, null,
            React__namespace.default.createElement(DialogContentText$1, { id: "alert-dialog-description" },
                React__namespace.default.createElement(StyledTypography$2, { use: "body" }, translate("NAVIGATION_WARNING.UNSAVED_CHANGES_TEXT")))),
        React__namespace.default.createElement(StyledDialogActions, { disableSpacing: true },
            React__namespace.default.createElement(lighthouseComponentLibrary.Button, { onClick: proceedWithTransition, type: "text" }, translate("NAVIGATION_WARNING.DISCARD")),
            React__namespace.default.createElement(lighthouseComponentLibrary.Button, { onClick: blockTransition, type: "text" }, translate("NAVIGATION_WARNING.STAY_ON_PAGE")))));
}
var templateObject_1$x, templateObject_2$p, templateObject_3$i, templateObject_4$d;

/**
 * Define the initial state if none provided
 */
var getInitialState$1 = function () {
    return {
        bearerToken: "",
        isLoggedIn: false,
        isloginError: false,
        username: "",
        refreshToken: "",
    };
};
/**
 * Create a reducer that manipulates the login details
 *
 * @param {LoginDetails}  state  The current login details
 * @param {LoginAction} action The action that has triggered the state change
 *
 * @returns {LoginDetails} The modified shift state
 */
var reducer$a = function (state, action) {
    if (state === void 0) { state = getInitialState$1(); }
    /**
     * Check which Action has been triggered
     */
    switch (action.type) {
        case "changeUsername" /* ChangeUsername */: {
            return __assign(__assign({}, state), { username: action.newUsername, isloginError: false });
        }
        case "loginSuccess" /* LoginSuccess */: {
            return __assign(__assign({}, state), { refreshToken: action.refreshToken, bearerToken: action.bearerToken, bearerExpiresAt: action.bearerExpiresAt, isLoggedIn: true });
        }
        case "refreshToken" /* RefreshToken */: {
            return __assign(__assign({}, state), { refreshToken: action.refreshToken, bearerToken: action.bearerToken, bearerExpiresAt: action.bearerExpiresAt });
        }
        case "loginError" /* LoginError */: {
            return __assign(__assign({}, state), { isloginError: true });
        }
        case "removeLoginError" /* RemoveLoginError */: {
            return __assign(__assign({}, state), { isloginError: false });
        }
    }
    return state;
};

var PropertyNameValues$1;
(function (PropertyNameValues) {
    PropertyNameValues["Organization"] = "organization";
    PropertyNameValues["Username"] = "username";
})(PropertyNameValues$1 || (PropertyNameValues$1 = {}));
var defaultPropertyNames = {
    organization: PropertyNameValues$1.Organization,
    username: PropertyNameValues$1.Username,
};
var defaultProperties = new Map();

/**
 * Define the initial state if none provided
 */
var getInitialState = function () {
    return {
        organizationId: defaultProperties.get(defaultPropertyNames.organization) || "",
        accountData: EMPTY_ACCOUNT_DATA,
        error: "",
        codeVerifier: "",
    };
};
/**
 * Create a reducer that manipulates the organization details
 *
 * @param {OrganizationCredentials}  state  The current state
 * @param {OrganizationAction} action The action that has triggered the state change
 *
 * @returns {OrganizationCredentials} The modified OrganizationCredentials
 */
var reducer$9 = function (state, action) {
    if (state === void 0) { state = getInitialState(); }
    /**
     * Check which Action has been triggered
     */
    switch (action.type) {
        case "organization/changeOrganizationId" /* ChangeOrganizationId */: {
            return __assign(__assign({}, state), { organizationId: action.newOrganizationId, accountData: action.accountData, error: "" });
        }
        case "organization/changeErrorState" /* ChangeErrorState */: {
            return __assign(__assign({}, state), { error: action.error });
        }
    }
    return state;
};

/**
 * Updates the organization ID Field
 * @param {string} newOrganizationId The new organization code to update to
 * @param {AccountData} accountData
 */
function changeOrganizationId(newOrganizationId, accountData) {
    return function (dispatch) {
        var action = {
            newOrganizationId: newOrganizationId,
            accountData: accountData,
            type: "organization/changeOrganizationId" /* ChangeOrganizationId */,
        };
        dispatch(action);
        return Promise.resolve();
    };
}
function changeOrganizationErrorState(error) {
    return function (dispatch) {
        var action = {
            error: error,
            type: "organization/changeErrorState" /* ChangeErrorState */,
        };
        dispatch(action);
        return Promise.resolve();
    };
}

/**
 * Updates the username
 *
 * @param {string} newUsername username to update
 */
function changeUsername(newUsername) {
    return function (dispatch) {
        dispatch({
            newUsername: newUsername,
            type: "changeUsername" /* ChangeUsername */,
        });
        return Promise.resolve();
    };
}
/**
 * Action Creator for login error messages
 *
 */
function showLoginError() {
    return function (dispatch) {
        dispatch({
            type: "loginError" /* LoginError */,
        });
        return Promise.resolve();
    };
}
/**
 * performs sign in operation
 *
 * @param {string} organizationId The organization entered by the user.
 * @param {string} username The username entered by the user
 * @param {string} password The password entered by the user
 */
function signIn(organizationId, username, password) {
    return function (dispatch) {
        var credentials = {
            username: username,
            password: password,
            account: organizationId,
        };
        if (AuthenticationManager.getInstance().mockLogin(credentials)) {
            dispatch({
                type: "loginSuccess" /* LoginSuccess */,
                bearerToken: "mocked",
                refreshToken: "mockedRefresh",
            });
            return dispatch(changeOrganizationId(organizationId, EMPTY_ACCOUNT_DATA));
        }
        else {
            return Promise.reject();
        }
    };
}
/**
 * Gets token and redirects to Home page if current path is not included in private routes list
 *
 * @param {() => Promise<string>} tokenFunction Function providing authentication token
 * @param RouteContextApi         routeContext  Route context object
 *
 * @return ApplicationThunk
 */
function authenticate(tokenFunction, routeContext) {
    return function (dispatch, getState) {
        return tokenFunction().then(function (token) {
            dispatch({
                type: "loginSuccess" /* LoginSuccess */,
                bearerToken: token,
                refreshToken: token,
            });
            if (undefined ===
                routeContext
                    .getPrivateRoutes()
                    .find(function (route) {
                    return route.route === getState().router.location.pathname;
                })) {
                var locationState = getState().router.location.state;
                dispatch(connectedReactRouter.push((locationState === null || locationState === void 0 ? void 0 : locationState.from.pathname) ||
                    routeContext.findRouteByName(RouteIds.Home) ||
                    "/"));
            }
        });
    };
}

/**
 * Define the initial state if none provided
 */
var initialState$9 = {
    hubCardCustomization: {
        hubCardOrder: undefined,
    },
    expectedHubCards: {},
};
/**
 * Create a reducer that manipulates the user preferences
 *
 * @param {UserPreferences} state The current state
 * @param {UserPreferencesAction} action The action that has triggered the state change
 *
 * @returns {UserPreferences} The modified state
 */
var reducer$8 = function (state, action) {
    if (state === void 0) { state = initialState$9; }
    /**
     * Check which Action has been triggered
     */
    switch (action.type) {
        case UserPreferencesActionTypes.SaveUserPreferences:
        case UserPreferencesActionTypes.LoadUserPreferences: {
            return __assign(__assign({}, state), action.userPreferences);
        }
    }
    return state;
};

var loadUserPreferencesQuery = "query UserPreferences($requiredPreferences: [String] = []){\nUserPreferences (requiredPreferences: $requiredPreferences){\n    preferenceId\n    value\n}\n}";

var saveUserPreferencesMutation = "mutation  UserPreferences($userPreferences: [UserPreferenceRecordInput]){\n    SaveUserPreferences(userPreferences: $userPreferences)\n}";

/**
 * Formats a module ID and key into a composite key string.
 * @param moduleId - The module ID.
 * @param key - The key.
 * @returns A string combining the module ID and key with a '|' separator.
 */
function formatModuleIdAndKey(moduleId, key) {
    // If moduleId is "" we return just the key for backwards compatibility
    // with the framework preferences. This is necessary for extractModuleIdAndKey.
    return moduleId ? moduleId + "|" + key : key;
}
/**
 * Extracts moduleId and key from a raw preference key string.
 *
 * @param rawPreferenceKey - The input string in the format "moduleId|key".
 * @returns An object containing moduleId and key.
 * @throws Throws an error if the input is empty or if the format is invalid.
 */
function extractModuleIdAndKey(rawPreferenceKey) {
    // Check if the input is empty
    if (!rawPreferenceKey) {
        throw new Error("Input cannot be empty");
    }
    // Regular expression to capture moduleId and key
    var parts = /([^|]*)\|(.+)/.exec(rawPreferenceKey);
    // If no match is found, it means it is a framework user preference
    if (!parts) {
        return {
            moduleId: "",
            key: rawPreferenceKey,
        };
    }
    // Return an object with moduleId and key extracted from the regular expression
    return {
        moduleId: parts[1],
        key: parts[2],
    };
}

/**
 * Manages user preferences and provides methods for retrieving and updating preferences.
 */
var UserPreferenceManager = /** @class */ (function (_super) {
    __extends(UserPreferenceManager, _super);
    /**
     * The current configs for all the modules.
     * These are needed to:
     * 1. initialize preferences with the default values,
     * 2. serialize the preferences before updating in the backend,
     * 3. deserialize the preference after getting the values from the backend.
     * Example:
     * {
     *   "module1": {
     *     "config": {
     *       "preference1": {
     *         "defaultValue": "value1",
     *         "serialize": <function>,
     *         "deserialize": <function>,
     *       },
     *       "preference2": {
     *         "defaultValue": "value2",
     *         "serialize": <function>,
     *         "deserialize": <function>,
     *       }
     *     },
     *   },
     *   "module2": {
     *     "config": {
     *       "preference3": {
     *         "defaultValue": "value3",
     *         "serialize": <function>,
     *         "deserialize": <function>,
     *       },
     *       "preference4": {
     *         "defaultValue": ["value4-1", "value4-2"],
     *         "serialize": <function>,
     *         "deserialize": <function>,
     *       }
     *     },
     *   }
     * }
     */
    function UserPreferenceManager(configs) {
        var _this = _super.call(this) || this;
        _this.configs = configs;
        _this.userPreferenceValues = {};
        _this.preferenceSaveOperations = [];
        return _this;
    }
    /**
     * Temporary method added to allow the Scheduling team to update to the new user preference hook architecture at their own pace.
     * https://workplacejira.atlassian.net/browse/SUITE-1792
     * Retrieves the reference to the singleton instance of the UserPreferenceManager.
     *
     * @returns Singleton instance of UserPreferenceManager.
     *
     * @deprecated Use {@link useBackCompatPreference} to retrieve and update values for a preference.
     */
    UserPreferenceManager.getInstance = function () {
        return UserPreferenceManager.instance;
    };
    /**
     * Temporary method added to allow Scheduling team to update to new user preference hook architecture at their own pace.
     * https://workplacejira.atlassian.net/browse/SUITE-1792
     * Set the singleton variable of the UserPreferenceManager to the new value.
     *
     * @param userPreferenceManager The instance of UserPreferenceManager to replace the existing singleton value.
     *
     * @deprecated Use {@link useBackCompatPreference} to retrieve and update values for a preference.
     */
    UserPreferenceManager.setInstance = function (userPreferenceManager) {
        UserPreferenceManager.instance = userPreferenceManager;
    };
    /**
     * This function ensures that all user preference module id and keys must
     * exist in the config before being retrieved. Otherwise, it will throw an error.
     * @param moduleId - the id of a UI module
     * @param key - the key of the user preference for this module id
     */
    UserPreferenceManager.prototype.validateModuleIdAndKey = function (moduleId, key) {
        if (!this.configs.hasOwnProperty(moduleId)) {
            throw new Error("\"" + moduleId + "\" does not exist in the user preference config");
        }
        if (!this.configs[moduleId].config.hasOwnProperty(key)) {
            throw new Error("\"" + key + "\" does not exist in \"" + moduleId + "\"'s user preference config");
        }
    };
    /**
     * Retrieves the value of a user preference.
     * @param moduleId - The module ID.
     * @param key - The key of the preference.
     * @returns The value of the user preference.
     */
    UserPreferenceManager.prototype.getUserPreferenceValue = function (moduleId, key) {
        this.validateModuleIdAndKey(moduleId, key);
        var rawKey = formatModuleIdAndKey(moduleId, key);
        if (this.userPreferenceValues.hasOwnProperty(rawKey)) {
            return this.userPreferenceValues[rawKey];
        }
        else {
            return this.configs[moduleId].config[key].defaultValue;
        }
    };
    /**
     * Iterates over the configuration to create a list of user preference ids to be passed as
     * a parameter for the backend user preference services call.
     * @returns A array of user preference ids based on the configuration from all modules
     */
    UserPreferenceManager.prototype.getUserPreferenceIds = function () {
        var _this = this;
        var userPreferenceIds = [];
        Object.keys(this.configs).forEach(function (moduleId) {
            if (_this.configs.hasOwnProperty(moduleId)) {
                var moduleConfig_1 = _this.configs[moduleId].config;
                Object.keys(moduleConfig_1).forEach(function (key) {
                    if (moduleConfig_1.hasOwnProperty(key)) {
                        var formattedKey = formatModuleIdAndKey(moduleId, key);
                        userPreferenceIds.push(formattedKey);
                    }
                });
            }
        });
        return userPreferenceIds;
    };
    /**
     * Sets the value of a user preference without returning anything.
     * If the value has changed, it is saved in the backend and an event is emitted.
     * @param moduleId - The module ID.
     * @param key - The key of the preference.
     * @param value - The new value to set.
     */
    UserPreferenceManager.prototype.setUserPreferenceValue = function (moduleId, key, value) {
        this.validateModuleIdAndKey(moduleId, key);
        if (this.isPreferenceValueUpdated(moduleId, key, value)) {
            this.userPreferenceValues[formatModuleIdAndKey(moduleId, key)] = value;
            this.saveUserPreference(moduleId, key, value);
            this.emit.onUserPreferenceChange(moduleId, key, value);
        }
    };
    /**
     * Sets the value of a user preference and returns a Promise.
     * This setter should be used when a promise is required to be returned
     * and handled within the component that called it. For example, showing
     * a toast to the user if the save did not succeed.
     *
     * @param moduleId - The module ID.
     * @param key - The key of the preference.
     * @param value - The new value to set.
     * @returns A Promise that resolves when the save is complete or is rejected if the save fails.
     */
    UserPreferenceManager.prototype.setUserPreferenceValueWithImmediateSave = function (moduleId, key, value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.validateModuleIdAndKey(moduleId, key);
                        if (!this.isPreferenceValueUpdated(moduleId, key, value)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.saveUserPreference(moduleId, key, value)];
                    case 1:
                        _a.sent();
                        this.userPreferenceValues[formatModuleIdAndKey(moduleId, key)] = value;
                        this.emit.onUserPreferenceChange(moduleId, key, value);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Checks if the value for peference has been changed or not.
     *
     * @param moduleId - The module ID associated with the user preference.
     * @param key - The key of the user preference.
     * @param value - The value of the user preference.
     * @returns Returns true if value has been updated.
     */
    UserPreferenceManager.prototype.isPreferenceValueUpdated = function (moduleId, key, value) {
        this.validateModuleIdAndKey(moduleId, key);
        return (this.serializeValue(moduleId, key, this.getUserPreferenceValue(moduleId, key)) !== this.serializeValue(moduleId, key, value));
    };
    /**
     * Loads user preferences from the backend and updates the local values.
     * @returns A Promise that resolves when the user preferences are successfully loaded.
     */
    UserPreferenceManager.prototype.loadUserPreferences = function () {
        var _this = this;
        var variables = {
            requiredPreferences: this.getUserPreferenceIds(),
        };
        return graphqlServiceFactory
            .getGraphQlObject(USER_PREFERENCES_SERVICE_NAME$2)
            .query(loadUserPreferencesQuery, variables)
            .then(function (result) {
            var _a;
            var userPreferencesResult = (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.UserPreferences;
            if (userPreferencesResult) {
                userPreferencesResult.forEach(function (userPreference) {
                    _this.userPreferenceValues[userPreference.preferenceId] = _this.deserializeValue(userPreference.preferenceId, userPreference.value);
                });
            }
        })
            .catch(function (error) {
            global.console.error("Error fetching user preferences", error);
        });
    };
    /**
     * Saves a user preference to the backend.
     * @param moduleId - The module ID.
     * @param key - The key of the preference.
     * @param value - The value to save.
     * @returns A Promise that resolves when the save is complete or is rejected if the save fails.
     */
    UserPreferenceManager.prototype.saveUserPreference = function (moduleId, key, value) {
        return __awaiter(this, void 0, void 0, function () {
            var formattedKey, serializedValue, variables, ignorableUserPreferenceSave, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.validateModuleIdAndKey(moduleId, key);
                        formattedKey = formatModuleIdAndKey(moduleId, key);
                        serializedValue = this.serializeValue(moduleId, key, value);
                        variables = {
                            userPreferences: [
                                {
                                    preferenceId: formattedKey,
                                    value: serializedValue,
                                },
                            ],
                        };
                        ignorableUserPreferenceSave = tsUtil.IgnorablePromise.of(graphqlServiceFactory
                            .getGraphQlObject(USER_PREFERENCES_SERVICE_NAME$2)
                            .mutate(saveUserPreferencesMutation, variables));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this.preferenceSaveOperations.push(ignorableUserPreferenceSave);
                        return [4 /*yield*/, ignorableUserPreferenceSave];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        console.error("Error occurred during saving the value " + value + " for module " + moduleId + " and key " + key);
                        console.error("Error updating user preferences", error_1);
                        throw error_1;
                    case 4:
                        this.preferenceSaveOperations = _.without(this.preferenceSaveOperations, ignorableUserPreferenceSave);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Serializes a user preference value based on configuration.
     * @param moduleId - The module ID.
     * @param key - The preference key.
     * @param value - The value to be serialized.
     * @returns The serialized user preference value.
     */
    UserPreferenceManager.prototype.serializeValue = function (moduleId, key, value) {
        this.validateModuleIdAndKey(moduleId, key);
        var userPreferenceConfig = this.configs[moduleId].config[key];
        var serialize = userPreferenceConfig.serialize;
        if (serialize) {
            // Serialize the value and return the result.
            return serialize(value);
        }
        // Return the value without any transformation if the config is not defined.
        if (typeof value === "string") {
            return value;
        }
        else {
            throw new Error("No serialize definition available for the non-string preference " + moduleId + "|" + key);
        }
    };
    /**
     * Deserializes a user preference value based on configuration.
     * @param moduleIdKey - The composite key for the module and key.
     * @param value - The serialized value as a string.
     * @returns The deserialized user preference value.
     */
    UserPreferenceManager.prototype.deserializeValue = function (moduleIdKey, value) {
        var _a = extractModuleIdAndKey(moduleIdKey), moduleId = _a.moduleId, key = _a.key;
        this.validateModuleIdAndKey(moduleId, key);
        var userPreferenceConfig = this.configs[moduleId].config[key];
        var deserialize = userPreferenceConfig.deserialize;
        if (deserialize) {
            try {
                // Deserialize the value and return the result.
                return deserialize(value);
            }
            catch (error) {
                // Fallback to the default value for the preference in case deserialization fails.
                console.error("Unable to deserialize the preference " + moduleIdKey + ", falling back to default value.");
                return userPreferenceConfig.defaultValue;
            }
        }
        else {
            // Deserialize can only be undefined for string preferences. In that case, we can return the value without any transformation.
            return value;
        }
    };
    /**
     * Remove the user preference values stored in the preference manager.
     * On removal, the manager would return the default values for the preferences.
     */
    UserPreferenceManager.prototype.resetUserPreferenceManager = function () {
        this.preferenceSaveOperations.forEach(function (saveOperation) {
            saveOperation.ignore();
        });
        this.preferenceSaveOperations = [];
        this.userPreferenceValues = {};
    };
    return UserPreferenceManager;
}(strictlyTypedEvents.WithEventEmitter));

var USER_PREFERENCES_SERVICE_NAME$1 = "user-preferences";
/**
 * Changes the locale for the user by updating the user preferences
 * @returns {ApplicationThunk}
 */
function changeLocale(locale) {
    if (locale === void 0) { locale = appDefaultLocale; }
    return function () {
        i18next__default.default.changeLanguage(locale);
        UserPreferenceManager.getInstance().setUserPreferenceValue(FRAMEWORK_USER_PREFERENCES_MODULE_ID_BACK_COMPAT, exports.BackCompatUserPreferenceKey.Locale, locale);
        return Promise.resolve();
    };
}
function updateUserPreferences(userPreferences, dispatch) {
    return dispatch(saveUserPreferences(graphqlServiceFactory, true, userPreferences));
}
/**
 * Saves the user preferences for the user
 * @returns {ApplicationThunk}
 */
function saveUserPreferences(graphqlServiceFactoryObject, shouldQueryData, userPreferences) {
    return function (dispatch) {
        userPreferences.forEach(function (userPreference) {
            var action = {
                type: UserPreferencesActionTypes.SaveUserPreferences,
                userPreferences: JSON.parse(userPreference.value),
            };
            dispatch(action);
        });
        var variables = {
            userPreferences: userPreferences,
        };
        if (shouldQueryData) {
            return graphqlServiceFactoryObject
                .getGraphQlObject(USER_PREFERENCES_SERVICE_NAME$1)
                .mutate(saveUserPreferencesMutation, variables)
                .catch(function (error) {
                global.console.error("Error updating user preferences", error);
                // TODO: Add error handling mechanism.
            });
        }
        return Promise.resolve();
    };
}

/**
 * Creates action to notify user of a hub card dismissal
 * @param message - Notification message.
 * @param hubCardId - ID of the removed hub card.
 * @param hubCardIdToReinsertBeforeOnUndo - ID of the hub card before which the removed hub card
 *        should be reinserted if the remove action is undone by the user (to return the removed
 *        card back to its original position).
 */
function generateHubCardDismissalNotification(message, hubCardId, hubCardIdToReinsertBeforeOnUndo) {
    return {
        message: message,
        hubCardId: hubCardId,
        hubCardIdToReinsertBeforeOnUndo: hubCardIdToReinsertBeforeOnUndo,
        type: exports.NotificationActionTypes.DismissHubCardNotification,
        sideBarNotification: true,
    };
}

/**
 * @deprecated this function is no longer being used
 * @param hubCardIdToRemove - ID of the hub card to remove.
 * @param hubCardIdToReinsertBeforeOnUndo - ID of the hub card before which the removed hub card
 *        should be reinserted if the remove action is undone by the user (to return the removed card
 *        back to its original position).
 * @param hubCardName - Display name of the hub card to remove.
 */
function removeHubCard(hubCardIdToRemove, hubCardIdToReinsertBeforeOnUndo, hubCardName) {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var hubCardCustomization, hubCardOrder, updatedHubCardCustomization;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    hubCardCustomization = getState().userPreferences
                        .hubCardCustomization;
                    hubCardOrder = (hubCardCustomization && hubCardCustomization.hubCardOrder) || [];
                    updatedHubCardCustomization = {
                        preferenceId: UserPreferenceIds.HubCardCustomization,
                        value: JSON.stringify(tsUtil.literal({
                            hubCardCustomization: {
                                hubCardOrder: ___default.default.reject(hubCardOrder, function (hubCardId) { return hubCardId === hubCardIdToRemove; }),
                            },
                        })),
                    };
                    return [4 /*yield*/, updateUserPreferences([updatedHubCardCustomization], dispatch)];
                case 1:
                    _a.sent();
                    return [2 /*return*/, dispatch(generateHubCardDismissalNotification(translate("framework", "NOTIFICATION_MESSAGES.HUB_CARD_DISMISSED", {
                            hubCardName: hubCardName,
                        }), hubCardIdToRemove, hubCardIdToReinsertBeforeOnUndo))];
            }
        });
    }); };
}
/**
 *  @deprecated this function is no longer being used
 */
function addHubCard(hubCardId, insertBefore) {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var oldHubCardOrder, newHubCardOrder, insertIndex, updateCardOrder;
        return __generator(this, function (_a) {
            oldHubCardOrder = getState().userPreferences.hubCardCustomization.hubCardOrder || [];
            newHubCardOrder = ___default.default.without(oldHubCardOrder, hubCardId);
            // If the we're adding the hub card before itself, and the hub card already
            // existed in the old list, then there's no change to be made: the card is
            // already where we want it to be.
            if (hubCardId === insertBefore &&
                newHubCardOrder.length < oldHubCardOrder.length) {
                return [2 /*return*/];
            }
            insertIndex = insertBefore
                ? ___default.default.indexOf(newHubCardOrder, insertBefore)
                : -1;
            if (insertIndex === -1) {
                newHubCardOrder.push(hubCardId);
            }
            else {
                newHubCardOrder.splice(insertIndex, 0, hubCardId);
            }
            updateCardOrder = {
                preferenceId: UserPreferenceIds.HubCardCustomization,
                value: JSON.stringify(tsUtil.literal({
                    hubCardCustomization: {
                        hubCardOrder: newHubCardOrder,
                    },
                })),
            };
            return [2 /*return*/, updateUserPreferences([updateCardOrder], dispatch)];
        });
    }); };
}
function initializeHubCardOrder(hubCardCustomization, expectedHubCardIds, allValidHubCardIds) {
    var hubCardOrder = (hubCardCustomization === null || hubCardCustomization === void 0 ? void 0 : hubCardCustomization.hubCardOrder) || [];
    if (hubCardOrder.length === 0) {
        // If no order is specified yet, then default to all valid hub cards, in whatever their natural/default order is
        return allValidHubCardIds;
    }
    var previousHubCardIds = flattenHubCardIds(expectedHubCardIds);
    var newHubCards = ___default.default.difference(allValidHubCardIds, previousHubCardIds);
    var newHubCardsRelativeToHubCardOrder = ___default.default.difference(newHubCards, hubCardOrder);
    if (newHubCardsRelativeToHubCardOrder.length) {
        var newHubCardOrder = hubCardOrder.concat(newHubCardsRelativeToHubCardOrder);
        return newHubCardOrder;
    }
    return;
}

/**
 * List of image type values used to determine the which image to get from the config service.
 */
exports.ImagePurpose = void 0;
(function (ImagePurpose) {
    ImagePurpose["SplashScreen"] = "SPLASH_SCREEN_LOGO";
    ImagePurpose["DesktopHeaderLogo"] = "DESKTOP_HEADER_LOGO";
    ImagePurpose["Favicon"] = "FAVICON";
})(exports.ImagePurpose || (exports.ImagePurpose = {}));
exports.LogoActionTypes = void 0;
(function (LogoActionTypes) {
    LogoActionTypes["LoadLogos"] = "system-config/loadLogos";
    LogoActionTypes["ChangeIsEnabled"] = "logos/changeIsEnabled";
    LogoActionTypes["ChangeLogos"] = "logos/changeLogos";
    LogoActionTypes["ClearLogos"] = "logos/clearLogos";
})(exports.LogoActionTypes || (exports.LogoActionTypes = {}));

var _a$2;
/**
 * Define the initial state if none provided
 */
var initialState$8 = (_a$2 = {},
    _a$2[exports.ImagePurpose.DesktopHeaderLogo] = "",
    _a$2[exports.ImagePurpose.SplashScreen] = "",
    _a$2[exports.ImagePurpose.Favicon] = "",
    _a$2.isEnabled = false,
    _a$2);
var reducer$7 = function (state, action) {
    if (state === void 0) { state = initialState$8; }
    switch (action.type) {
        case exports.LogoActionTypes.LoadLogos:
        case exports.LogoActionTypes.ChangeLogos:
            return __assign(__assign({}, state), action.logos);
        case exports.LogoActionTypes.ChangeIsEnabled:
            return __assign(__assign({}, state), { isEnabled: action.isEnabled });
        case exports.LogoActionTypes.ClearLogos:
            return initialState$8;
        default:
            return state;
    }
};

/**
 * Define the initial state if none provided
 */
var initialState$7 = {
    __schema: {
        types: [
            {
                kind: "",
                name: "",
                possibleTypes: [
                    {
                        name: "",
                    },
                ],
            },
        ],
    },
};
/**
 * Create a reducer that manipulates the schema
 *
 * @param {IntrospectionResultData} state The current state
 * @param {SchemaAction} action The action that has triggered the state change
 *
 * @returns {IntrospectionResultData} The modified state
 */
var reducer$6 = function (state, action) {
    if (state === void 0) { state = initialState$7; }
    /**
     * Check which Action has been triggered
     */
    switch (action.type) {
        case "schema/loadSchema" /* LoadSchema */: {
            return action.schema;
        }
    }
    return state;
};

/**
 * All the actions that can be triggered by Loading Data
 */
exports.MockAccountActions = void 0;
(function (MockAccountActions) {
    MockAccountActions["LoadData"] = "loadData";
    MockAccountActions["DismissInboxItem"] = "dismissInboxItem";
})(exports.MockAccountActions || (exports.MockAccountActions = {}));

function loadDataBasedOnUser(mockAccountDataMatcherParams) {
    return function (dispatch) {
        var loadDataAction = {
            type: exports.MockAccountActions.LoadData,
            data: getUserData(mockAccountDataMatcherParams),
        };
        dispatch(loadDataAction);
        return Promise.resolve();
    };
}

/**
 * Initial state
 */
var initialState$6 = {
    data: null,
};
/**
 * Reducer that loads mock data based on who the logged in user is then adds that data to the state.
 * @param state - The current state
 * @param action - The action that triggered the state change
 */
var reducer$5 = function (state, action) {
    if (state === void 0) { state = initialState$6; }
    switch (action.type) {
        case exports.MockAccountActions.LoadData: {
            return __assign(__assign({}, state), { data: action.data });
        }
        case exports.MockAccountActions.DismissInboxItem: {
            return __assign(__assign({}, state), { data: __assign(__assign({}, state.data), { inboxItems: filterItemsById(state.data.inboxItems, action.id) }) });
        }
    }
    return state;
};
/**
 * Filters out the provided ID from inboxItems
 * @param inboxItems - The inboxItems in the state
 * @param id - The ID to be filtered out
 */
var filterItemsById = function (inboxItems, id) {
    return inboxItems.filter(function (item) { return item.id !== id; });
};

var initialState$5 = {
    locales: [],
    defaultLocale: appDefaultLocale,
};
/**
 * Create a reducer that manipulates the locales
 *
 * @param {AccountLocales} state The current state
 * @param {AccountLocalizationAction} action The action that has triggered the state change
 * @returns {AllLocales} The modified state
 */
var reducer$4 = function (state, action) {
    if (state === void 0) { state = initialState$5; }
    /**
     * Check which Action has been triggered
     */
    switch (action.type) {
        case "localization/load" /* SetLocales */: {
            return __assign(__assign({}, state), { locales: action.locales });
        }
        case "localization/defaultLocale" /* SetDefaultLocale */: {
            return __assign(__assign({}, state), { defaultLocale: action.defaultLocale });
        }
    }
    return state;
};

var getLocalesQuery = "query Locales{\n  Locales{\n    code\n    label\n  }\n}";

var getTranslationsQuery = "query getTranslations($locale: String!) {\n   getTranslations(locale: $locale) {\n     moduleId,\n     moduleTranslations\n  }\n}";

var I18N_SERVICE_NAME$1 = "i18n";
/**
 * Gets the available locales for the user account from the i18n-service. If there is an exception
 * when trying to get the locales from the service or the returned result is only the test mode
 * locale then show the defined default locales.
 * @returns {ApplicationThunk}
 */
function getLocales(graphqlServiceFactoryObject) {
    return function (dispatch) {
        var variables = {};
        var actionType = "localization/load" /* SetLocales */;
        return graphqlServiceFactoryObject
            .getGraphQlObject(I18N_SERVICE_NAME$1)
            .query(getLocalesQuery, variables)
            .then(function (result) {
            var localesData = [];
            if (result.data.Locales && result.data.Locales.length > 0) {
                localesData = result.data.Locales;
            }
            // If there are no locales show only EnglishUS as a default language
            if (localesData.length === 0) {
                localesData.push(englishUSLocale);
            }
            var action = {
                type: actionType,
                locales: localesData,
            };
            return dispatch(action);
        })
            .catch(function (error) {
            global.console.error("Error fetching locales", error);
            var actionFailure = {
                type: actionType,
                locales: defaultLocales,
            };
            return dispatch(actionFailure);
        });
    };
}

var initialState$4 = {
    locale: appDefaultLocale,
    isLocaleChanged: false,
    syncedWithUserPreferences: false,
    translations: [],
};
/**
 * Create a reducer that manipulates the locales.
 *
 * @param state The current state
 * @param action The action that has triggered the state change
 * @returns The modified state
 */
var reducer$3 = function (state, action) {
    if (state === void 0) { state = initialState$4; }
    /**
     * Check which Action has been triggered
     */
    switch (action.type) {
        case "localization/changeAppLocale" /* ChangeAppLocale */: {
            return __assign(__assign({}, state), { locale: action.locale });
        }
        case "localization/changeLocaleSelectedFlag" /* ChangeLocaleSelectedFlag */: {
            return __assign(__assign({}, state), { isLocaleChanged: action.isLocaleChanged });
        }
        case "localization/syncedWithUserPreferences" /* ChangeSyncedWithUserPreferences */: {
            return __assign(__assign({}, state), { syncedWithUserPreferences: action.syncedWithUserPreferences });
        }
        case "localization/loadTranslations" /* LoadTranslations */:
        case "localization/deleteCachedTranslations" /* DeleteCachedTranslations */: {
            var newState = cloneDeep__default.default(state);
            newState.translations = action.translations;
            return newState;
        }
    }
    return state;
};

/**
 * Loads the translations in i18next library
 * @return {МoduleTranslation[]}
 */
var loadTranslationsIni18Library = function (locale, translations) {
    if (locale && translations) {
        translations.forEach(function (translation) {
            i18next__default.default.addResourceBundle(locale, translation.moduleId, JSON.parse(translation.moduleTranslations), true, true);
        });
    }
};

var I18N_SERVICE_NAME = "i18n";
/**
 * Action to change application locale in the store.
 */
function changeAppLocale(appLocale) {
    return function (dispatch) {
        var action = {
            type: "localization/changeAppLocale" /* ChangeAppLocale */,
            locale: appLocale,
        };
        dispatch(action);
        return Promise.resolve();
    };
}
/**
 * Action to change isLocaleChanged flag in the store.
 */
function changeLocaleSelectedFlag(isLocaleChangedFlag) {
    return function (dispatch) {
        var action = {
            type: "localization/changeLocaleSelectedFlag" /* ChangeLocaleSelectedFlag */,
            isLocaleChanged: isLocaleChangedFlag,
        };
        dispatch(action);
        return Promise.resolve();
    };
}
/**
 * Action to synchronize application locale, default locale and the locale from UserPreferences.
 */
function syncAppLocaleWithUserPreferences() {
    return function (dispatch, getState) {
        var applicationState = getState();
        var accountLocales = applicationState.accountLocales.locales;
        var appLocale = applicationState.appLocalizationData.locale;
        var defaultAccountLocale = applicationState.accountLocales.defaultLocale;
        var userPreferencesLocale = UserPreferenceManager.getInstance().getUserPreferenceValue(FRAMEWORK_USER_PREFERENCES_MODULE_ID_BACK_COMPAT, exports.BackCompatUserPreferenceKey.Locale);
        // Figure out the locale to be used for the user. The logic is the following:
        // 1. Use the locale selected on the Account Login screen (if it's valid) or
        // 2. Use the User Preferences locale (if it's valid) or
        // 3. Use the Account default locale (if it's valid) or
        // 4. Use the application default locale (English US).
        // TODO: this should be unit tested, it's complicated logic of selecting the app locale
        //       so it deserves a unit test.
        var currentLocale;
        if (applicationState.appLocalizationData.isLocaleChanged &&
            isLocaleValidForAccount(appLocale, accountLocales)) {
            // if the locale is changed on the Login screen and it's valid for the account
            // update the user preferences with that locale.
            i18next__default.default.changeLanguage(appLocale);
            UserPreferenceManager.getInstance().setUserPreferenceValue(FRAMEWORK_USER_PREFERENCES_MODULE_ID_BACK_COMPAT, exports.BackCompatUserPreferenceKey.Locale, appLocale);
            currentLocale = appLocale;
        }
        else if (userPreferencesLocale &&
            isLocaleValidForAccount(userPreferencesLocale, accountLocales)) {
            currentLocale = userPreferencesLocale;
        }
        else if (defaultAccountLocale &&
            isLocaleValidForAccount(defaultAccountLocale, accountLocales)) {
            currentLocale = defaultAccountLocale;
        }
        else {
            currentLocale = appDefaultLocale;
        }
        // load the translations from i18n-service
        dispatch(getTranslations(currentLocale));
        // change the locale of the application
        dispatch({
            type: "localization/changeAppLocale" /* ChangeAppLocale */,
            locale: currentLocale,
        });
        var syncedWithUserPreferencesAction = {
            type: "localization/syncedWithUserPreferences" /* ChangeSyncedWithUserPreferences */,
            syncedWithUserPreferences: true,
        };
        dispatch(syncedWithUserPreferencesAction);
        return Promise.resolve();
    };
}
/**
 * Check if a given locale is valid.
 * Locale is valid if it's part of the enabled locales for the account.
 */
function isLocaleValidForAccount(locale, accountLocales) {
    return (accountLocales && accountLocales.some(function (l) { return l.code === String(locale); }));
}
/**
 * Gets the translations per selected locale
 * @returns {ApplicationThunk}
 */
function getTranslations(locale) {
    if (locale === void 0) { locale = appDefaultLocale; }
    return function (dispatch, getState) {
        var variables = {
            locale: locale,
        };
        return graphqlServiceFactory
            .getGraphQlObject(I18N_SERVICE_NAME)
            .query(getTranslationsQuery, variables)
            .then(function (result) {
            var translationsData = result.data.getTranslations;
            loadTranslationsIni18Library(locale, translationsData);
            var action = {
                type: "localization/loadTranslations" /* LoadTranslations */,
                translations: translationsData,
            };
            dispatch(action);
            return Promise.resolve();
        })
            .catch(function (error) {
            global.console.error("Error fetching translations per locale " + locale + ": ", error);
            throw error;
        });
    };
}
/**
 * Deletes translations cached in Redux store
 * @returns {ApplicationThunk}
 */
function deleteCachedTranslations() {
    return function (dispatch) {
        var action = {
            type: "localization/deleteCachedTranslations" /* DeleteCachedTranslations */,
            translations: [],
        };
        dispatch(action);
        return Promise.resolve();
    };
}

var saveToSessionStorage = function (key, data) {
    try {
        sessionStorage.setItem(key, JSON.stringify(data));
    }
    catch (e) {
        global.console.warn("Could not store to session storage. Key: " + key);
    }
    return data;
};
var getFromSessionStorage = function (key) {
    try {
        var sessionData = sessionStorage.getItem(key);
        return sessionData ? JSON.parse(sessionData) : undefined;
    }
    catch (e) {
        global.console.warn("Could not retrieve from session storage. Key: " + key);
        return undefined;
    }
};
var SessionStorageKeys;
(function (SessionStorageKeys) {
    SessionStorageKeys["RouterLocation"] = "RouterLocation";
})(SessionStorageKeys || (SessionStorageKeys = {}));
var sessionStorageMiddleware = function () { return function (next) { return function (action) {
    if (action.type === connectedReactRouter.LOCATION_CHANGE) {
        if (!!action.payload.location.state) {
            saveToSessionStorage(SessionStorageKeys.RouterLocation, action.payload.location.state);
        }
        else {
            action.payload.location.state = getFromSessionStorage(SessionStorageKeys.RouterLocation);
        }
    }
    return next(action);
}; }; };

var rootReducerFactory = {
    create: function (appReducer) {
        return function (state, action) {
            if (action.type === "logoutSuccess" /* LogoutSuccess */) {
                return appReducer(
                // The state needed to be retained on logout should be added here.
                {
                    appLocalizationData: state.appLocalizationData,
                    router: state.router,
                    logos: state.logos,
                    accountTheme: state.accountTheme,
                    accountLocales: state.accountLocales,
                    themeData: state.themeData,
                    sessionInactivity: state.sessionInactivity,
                    userPreferences: __assign({}, initialState$9),
                    // `hierarchy` and `schedule` contain state for the Schedule Editor (Herald) that is persisted.
                    hierarchy: state.hierarchy,
                    schedule: state.schedule,
                }, action);
            }
            return appReducer(state, action);
        };
    },
};

/**
 * All default Nav Items we want. Add any links to this if we want them to be returned, regardless of what happens with the navigation service query
 */
var defaultNavItems = {
    "LINK/SIGN_OUT": {
        id: "LINK/SIGN_OUT",
        title: "Sign Out",
        translationKey: "NAV_LINKS.SIGN_OUT",
        hideInMobile: false,
    },
    "LINK/PREFERENCES": {
        id: "LINK/PREFERENCES",
        route: "preferences",
        title: "Preferences",
        translationKey: "NAV_LINKS.PREFERENCES",
        hideInMobile: false,
    },
};
var navigationItemsReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case "navigation/loadNavigationItems" /* LoadNavigationItems */:
            return action.items;
        case "navigation/loadDefaultNavigationItems" /* LoadDefaultNavigationItems */:
            return defaultNavItems;
        default:
            return state;
    }
};

var EmployeeGroupActionTypes;
(function (EmployeeGroupActionTypes) {
    EmployeeGroupActionTypes["LoadEmployeeGroups"] = "employeegroups/load";
})(EmployeeGroupActionTypes || (EmployeeGroupActionTypes = {}));

/**
 * Define the initial state if none provided for employee groups
 */
var initialState$3 = [];
/**
 * Create a reducer that manipulates the employee groups
 *
 * @param {EmployeeGroups}  state  The current employee groups
 * @param {EmployeeGroupAction} action The action that has triggered the state change
 *
 * @returns {EmployeeGroups} returns the list of employee groups
 */
var reducer$2 = function (state, action) {
    if (state === void 0) { state = initialState$3; }
    /**
     * Check which Action has been triggered
     */
    switch (action.type) {
        case EmployeeGroupActionTypes.LoadEmployeeGroups: {
            return action.employeeGroups;
        }
    }
    return state;
};

exports.AccountThemeActionTypes = void 0;
(function (AccountThemeActionTypes) {
    AccountThemeActionTypes["SetAccountTheme"] = "accountTheme/setAccountTheme";
})(exports.AccountThemeActionTypes || (exports.AccountThemeActionTypes = {}));

var initialState$2 = {
    themeKey: "",
    themeName: "",
};
var reducer$1 = function (state, action) {
    if (state === void 0) { state = initialState$2; }
    switch (action.type) {
        case exports.AccountThemeActionTypes.SetAccountTheme:
            return __assign(__assign({}, state), action.accountTheme);
        default:
            return state;
    }
};

/**
 * Types of themes.
 */
var CoreThemes;
(function (CoreThemes) {
    CoreThemes["DefaultTheme"] = "defaultTheme";
    // TODO: uncomment below line when dark theme is completely fixed
    // DarkTheme = "darkTheme"
})(CoreThemes || (CoreThemes = {}));

/**
 * The default themes should be always be available in the initial state.
 */
var initialState$1 = {
    availableThemes: [
        {
            id: CoreThemes.DefaultTheme,
            label: "Standard",
        },
    ],
};
/**
 * Create a reducer that manipulates the themes
 *
 * @param {ThemeData} state The current state
 * @param {ThemeDataAction} action The action that has triggered the state change
 * @returns {AllThemes} The modified state
 */
var reducer = function (state, action) {
    if (state === void 0) { state = initialState$1; }
    /**
     * Check which Action has been triggered
     */
    switch (action.type) {
        case "themes/preview" /* PreviewTheme */:
            return __assign(__assign({}, state), { previewTheme: action.theme });
    }
    return state;
};

/**
 * Applies a new previewTheme. If no theme is passed, this clears the previewTheme instead.
 * @returns {ThemeDataAction}
 */
function setPreviewTheme(theme) {
    return {
        theme: theme,
        type: "themes/preview" /* PreviewTheme */,
    };
}

/**
 * Initial state for the session inactivity reducer
 */
var initialState = {
    showAlert: false,
};
/**
 * Handles session inactivity-related state updates.
 *
 * @param {SessionInactivityState} state - The current state of session inactivity
 * @param {SessionInactivityAction} action - The dispatched action to update state
 * @returns {SessionInactivityState} The updated state based on the action type
 */
var sessionInactivityReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case "sessionInactivity/showAlert" /* showAlert */:
            return __assign(__assign({}, state), { showAlert: true });
        case "sessionInactivity/hideAlert" /* hideAlert */:
            return __assign(__assign({}, state), { showAlert: false });
        default:
            return state;
    }
};

/** Show the alert */
var showAlert = function () { return ({
    type: "sessionInactivity/showAlert" /* showAlert */,
}); };
/** Hide the alert */
var hideAlert = function () { return ({
    type: "sessionInactivity/hideAlert" /* hideAlert */,
}); };

var history = history$3.createHashHistory();
var baseReducers = {
    loginDetails: reducer$a,
    organizationCredentials: reducer$9,
    schema: reducer$6,
    mockedAccountData: reducer$5,
    notification: reducer$b,
    navigationItems: navigationItemsReducer,
    accountLocales: reducer$4,
    appLocalizationData: reducer$3,
    apiErrors: ApiErrorReducer,
    employeeGroups: reducer$2,
    logos: reducer$7,
    sidebarIntegration: reducer$d,
    accountTheme: reducer$1,
    themeData: reducer,
    impersonation: reducer$f,
    redirect: reducer$g,
    deeplinkRedirect: reducer$e,
    wfxUnreadDMIds: reducer$c,
    sessionInactivity: sessionInactivityReducer,
    router: connectedReactRouter.connectRouter(history),
};
/**
 * Creates a new state store from the structure provided by a given collection of modules.
 *
 * @param modules Modules to create state for.
 * @param initialState Initial state.
 *
 * @return Application state store.
 */
function createFromModuleList(modules, initialState) {
    if (initialState === void 0) { initialState = {}; }
    var storeData = getModuleStoreInfo(modules);
    return createStore(storeData.reducers, initialState, storeData.middleware);
}
/**
 * Creates a new state store from the set of reducers provided.
 *
 * @param reducers Additional State reducers.
 * @param initialState Initial state.
 * @param middleware Additional store middleware.
 * @param persistStoreBlackList Keys for the state that does not need to be persisted
 */
function createStore(reducers, initialState, middleware, 
/**
 * We are switching from blacklist to whitelist to only persist the keys that we need to persist.
 * Eventually every module would be expected to define a list of whitelist keys instead of blacklist.
 * As an immediate action, the blacklist values from modules would be ignored.
 */
persistStoreBlacklist) {
    if (reducers === void 0) { reducers = {}; }
    if (initialState === void 0) { initialState = {}; }
    if (middleware === void 0) { middleware = []; }
    /**
     * Initial whitelist should match what is defined in rootReducerFactory.ts as the "state to keep" when logged out
     * We can currently ignore the UI module blacklist. Since we're cherry picking certain keys from User Preferences,
     * we need to make use of Nested Persists: https://www.npmjs.com/package/redux-persist#nested-persists
     */
    var whitelist = [
        "appLocalizationData",
        "router",
        "logos",
        "accountTheme",
        "accountLocales",
        "sessionInactivity",
        "themeData",
        "redirect",
        "deeplinkRedirect",
    ];
    var persistConfig = {
        storage: storage__default.default,
        whitelist: whitelist,
        key: "root",
        stateReconciler: autoMergeLevel2__default.default,
    };
    var userPreferencesPersistConfig = {
        key: "userPreferences",
        storage: storage__default.default,
        whitelist: ["theme", "locale"],
    };
    var rootReducer = redux.combineReducers(__assign(__assign(__assign({}, baseReducers), reducers), { userPreferences: reduxPersist.persistReducer(userPreferencesPersistConfig, reducer$8) }));
    rootReducer = rootReducerFactory.create(rootReducer);
    var persistedReducer = reduxPersist.persistReducer(persistConfig, rootReducer);
    var store = redux.createStore(persistedReducer, initialState, reduxDevtoolsExtension.composeWithDevTools(redux.applyMiddleware.apply(void 0, __spreadArrays([connectedReactRouter.routerMiddleware(history),
        reduxThunk__default.default,
        sessionStorageMiddleware], middleware))));
    var persistor = reduxPersist.persistStore(store);
    return { store: store, persistor: persistor };
}
/**
 * Given a collection of modules, extracts all state store information.
 *
 * @param modules Application modules.
 */
function getModuleStoreInfo(modules) {
    return {
        reducers: getReducers(modules),
        middleware: getMiddleware(modules),
        persistenceBlacklist: getStateNotToPersist(modules),
    };
}
/**
 * Given all modules, extracts all module reducers.
 *
 * @param modules Application modules.
 */
function getReducers(modules) {
    var reducers = {};
    modules.forEach(function (module) {
        if (!module.getReducers) {
            return;
        }
        reducers = __assign(__assign({}, reducers), module.getReducers());
    });
    return reducers;
}
/**
 * Given all modules, extracts all reducers that should have persistence disabled
 *
 * @param modules Application modules.
 *
 * @returns {string[]}
 */
function getStateNotToPersist(modules) {
    var reducers = [];
    modules.forEach(function (module) {
        if (module.getStateNotToPersist) {
            reducers = __spreadArrays(reducers, module.getStateNotToPersist());
        }
    });
    return reducers;
}
/**
 * Given all modules, extracts all module middleware.
 *
 * @param modules Application modules.
 */
function getMiddleware(modules) {
    return _.flatMap(modules.map(function (module) {
        return module.getMiddleware ? module.getMiddleware() : [];
    }));
}

/**
 * This is a custom hook which blocks any navigation according to the first parameter passed
 * @param blockNavigation - Pass true if you want to block navigation (eg. if data is dirty)
 * @param whenBlockedCallback - The function to be executed when a page is blocked.
 * The logic to show a modal (eg. UnsavedChangesAlert) can be written in this function.
 * @return returns a function that when executed, unblocks and navigates to the last blocked page.
 */
var useBlockNavigation = function (blockNavigation, whenBlockedCallback) {
    var dispatch = reactRedux.useDispatch();
    var _a = React__namespace.default.useState(), targetLocation = _a[0], setTargetLocation = _a[1];
    var eventHandler = function (event) {
        event.preventDefault();
        event.returnValue = "";
    };
    var unblock = React.useRef();
    React.useEffect(function () {
        if (blockNavigation) {
            unblock.current = history.block(function (location) {
                setTargetLocation(location);
                whenBlockedCallback();
                return false;
            });
        }
        else if (unblock.current) {
            unblock.current();
        }
        return function () { return unblock.current && unblock.current(); };
    }, [blockNavigation]);
    React.useEffect(function () {
        if (blockNavigation) {
            window.addEventListener("beforeunload", eventHandler);
        }
        else {
            window.removeEventListener("beforeunload", eventHandler);
        }
        return function () {
            window.removeEventListener("beforeunload", eventHandler);
        };
    }, [blockNavigation]);
    var unblockAndNavigate = function () {
        if (unblock.current) {
            unblock.current();
        }
        if (targetLocation) {
            dispatch(connectedReactRouter.push(targetLocation.pathname || ""));
            setTargetLocation(undefined);
        }
    };
    return unblockAndNavigate;
};

var noop = function (value) {
    /* noop */
};
var UserPreferenceUnsavedChangesContext = React__namespace.default.createContext({
    setIsUnsavedChanges: noop,
    isUnsavedChanges: false,
});

var PageTitle = lighthouseComponentLibrary.styled.div(templateObject_1$w || (templateObject_1$w = __makeTemplateObject(["\n  padding: ", ";\n  box-shadow: 0 ", " ", " 0\n    ", ";\n  display: grid;\n  grid-template-columns: 1fr 14fr 1fr;\n  align-items: center;\n  box-sizing: border-box;\n  width: 100%;\n  align-self: flex-start;\n  & h2 {\n    margin-top: 0;\n    margin-bottom: 0;\n    white-space: nowrap;\n  }\n  button:focus {\n    outline: 2px solid var(--fc-button-border-color);\n  }\n"], ["\n  padding: ", ";\n  box-shadow: 0 ", " ", " 0\n    ", ";\n  display: grid;\n  grid-template-columns: 1fr 14fr 1fr;\n  align-items: center;\n  box-sizing: border-box;\n  width: 100%;\n  align-self: flex-start;\n  & h2 {\n    margin-top: 0;\n    margin-bottom: 0;\n    white-space: nowrap;\n  }\n  button:focus {\n    outline: 2px solid var(--fc-button-border-color);\n  }\n"])), polished.rem("12px"), polished.rem("1px"), polished.rem("4px"), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.grey.tone[300]; });
var StyledTitleTypography = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_2$o || (templateObject_2$o = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"])));
var StyledIconWrapper = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.IconButton)(templateObject_3$h || (templateObject_3$h = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var MobilePageHeader = function (props) {
    var translate = useTranslateFunction();
    var theme = useTheme();
    var icon = i18next__default.default.dir() === "ltr" ? faAngleLeft.faAngleLeft : faAngleRight.faAngleRight;
    return (React__namespace.default.createElement(PageTitle, null,
        React__namespace.default.createElement(StyledIconWrapper, { onClick: props.history.goBack, size: "small", "aria-label": translate("USER_PREFERENCES.BACK_ARROW") },
            React__namespace.default.createElement(reactFontawesome.FontAwesomeIcon, { icon: icon, size: "2x", color: theme.colours.primary.main })),
        React__namespace.default.createElement(StyledTitleTypography, { use: "h2" }, props.pageTitle)));
};
var MobilePageHeader$1 = reactRouterDom.withRouter(MobilePageHeader);
var templateObject_1$w, templateObject_2$o, templateObject_3$h;

/**
 * Sorts an array of ThemeDescriptors based on their labels.
 *
 * @param {ThemeDescriptor} a - The first ThemeDescriptor to compare.
 * @param {ThemeDescriptor} b - The second ThemeDescriptor to compare.
 * @return {number} Returns a negative number if a should be sorted before b,
 * a positive number if b should be sorted before a, or 0 if the labels are equal.
 */
var themeSortComparator = function (a, b) {
    if (a.id === CoreThemes.DefaultTheme) {
        return -1;
    }
    if (b.id === CoreThemes.DefaultTheme) {
        return 1;
    }
    var aValue = a.label.toUpperCase();
    var bValue = b.label.toUpperCase();
    if (aValue === bValue) {
        return 0;
    }
    return aValue > bValue ? 1 : -1;
};
/**
 * Sorts an array of Locale objects based on their labels.
 *
 * @param {Locale} a - The first Locale object to compare.
 * @param {Locale} b - The second Locale object to compare.
 * @return {number} Returns a negative number if a should be sorted before b,
 * a positive number if b should be sorted before a, or 0 if the labels are equal.
 */
var localeSortComparator = function (a, b) {
    var aValue = a.label.toUpperCase();
    var bValue = b.label.toUpperCase();
    if (aValue === bValue) {
        return 0;
    }
    return aValue > bValue ? 1 : -1;
};

var Container$6 = lighthouseComponentLibrary.styled.div(templateObject_1$v || (templateObject_1$v = __makeTemplateObject(["\n  display: block;\n  padding-bottom: ", ";\n"], ["\n  display: block;\n  padding-bottom: ", ";\n"])), polished.rem("32px"));
var Select$2 = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.SelectV2)(templateObject_2$n || (templateObject_2$n = __makeTemplateObject(["\n  width: ", ";\n"], ["\n  width: ", ";\n"])), polished.rem("272px"));
var LocaleSelector = function (props) {
    var onLocaleChange = props.onLocaleChange, selectedLocale = props.selectedLocale, locales = props.locales;
    var translate = useTranslateFunction();
    React.useEffect(function () {
        var _a;
        props.getAllLocales();
        var localeSelector = (_a = document.querySelector("[data-qa='localeSelector']")) === null || _a === void 0 ? void 0 : _a.firstElementChild;
        localeSelector === null || localeSelector === void 0 ? void 0 : localeSelector.setAttribute("id", "locale-selected");
        var labelID = localeSelector === null || localeSelector === void 0 ? void 0 : localeSelector.getAttribute("aria-labelledby");
        localeSelector === null || localeSelector === void 0 ? void 0 : localeSelector.setAttribute("aria-labelledby", "locale-selected " + labelID);
    }, []);
    var sortedLocales = locales && locales.length > 0 ? locales.sort(localeSortComparator) : [];
    // Array containing the supported languages' codes
    var supportedLocaleCodes = defaultLocales.map(function (locale) { return locale.code; });
    return (React__namespace.default.createElement(Container$6, null,
        React__namespace.default.createElement(Select$2, { "data-qa": "localeSelector", onChange: function (event) {
                onLocaleChange(event.target.value);
            }, label: translate("USER_PREFERENCES.LANGUAGE"), value: selectedLocale }, sortedLocales.map(function (locale) { return (React__namespace.default.createElement(lighthouseComponentLibrary.Option, { key: locale.code, "data-qa": locale.code, value: locale.code, disabled: 
            // We want the non-supported languages in the Suite to appear greyed out/disabled
            // Currently, both SpanishUS and SpanishMX have configurations in T&A, leading to the
            // same language, but only SpanishMX is supported in the Suite, which is why we
            // want to include SpanishUS as an enabled locale
            !supportedLocaleCodes.includes(locale.code) &&
                locale.code !== Locales.SpanishUS }, locale.label)); }))));
};
var mapStateToProps$4 = function (state) {
    return {
        locales: state.accountLocales.locales,
    };
};
var mapDispatchToProps$2 = function (dispatch) {
    return {
        getAllLocales: function () {
            dispatch(getLocales(graphqlServiceFactory));
        },
    };
};
var LocaleSelector$1 = reactRedux.connect(mapStateToProps$4, mapDispatchToProps$2)(LocaleSelector);
var templateObject_1$v, templateObject_2$n;

var StyledMobileFooterWrapper = lighthouseComponentLibrary.styled.div(templateObject_1$u || (templateObject_1$u = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n  position: sticky;\n  bottom: 0;\n  background: ", ";\n  padding: ", " ", ";\n  box-sizing: border-box;\n  width: 100%;\n  box-shadow: 0 ", " ", " 0\n    ", ";\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  position: sticky;\n  bottom: 0;\n  background: ", ";\n  padding: ", " ", ";\n  box-sizing: border-box;\n  width: 100%;\n  box-shadow: 0 ", " ", " 0\n    ", ";\n"])), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.grey.tone[50]; }, rem__default.default("8px"), rem__default.default("12px"), rem__default.default("-2px"), rem__default.default("4px"), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.grey.tone[300]; });
var MobileSaveButton = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Button)(templateObject_2$m || (templateObject_2$m = __makeTemplateObject(["\n  &&& {\n    margin-left: ", ";\n  }\n  [dir=\"rtl\"] &&& {\n    margin-right: ", ";\n  }\n"], ["\n  &&& {\n    margin-left: ", ";\n  }\n  [dir=\"rtl\"] &&& {\n    margin-right: ", ";\n  }\n"])), rem__default.default("16px"), rem__default.default("16px"));
var PanelFooter = lighthouseComponentLibrary.styled.div(templateObject_3$g || (templateObject_3$g = __makeTemplateObject(["\n  width: 100%;\n  position: fixed;\n  bottom: 0;\n  background-color: ", ";\n"], ["\n  width: 100%;\n  position: fixed;\n  bottom: 0;\n  background-color: ",
    ";\n"])), function (props) {
    return lighthouseComponentLibrary.getThemeFromProps(props).colours.grey.tone[50];
});
var DesktopSaveButton = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Button)(templateObject_4$c || (templateObject_4$c = __makeTemplateObject(["\n  && {\n    margin-top: ", ";\n    margin-bottom: ", ";\n    margin-right: ", ";\n  }\n  [dir=\"rtl\"] && {\n    margin-left: ", ";\n  }\n"], ["\n  && {\n    margin-top: ", ";\n    margin-bottom: ", ";\n    margin-right: ", ";\n  }\n  [dir=\"rtl\"] && {\n    margin-left: ", ";\n  }\n"])), rem__default.default("16px"), rem__default.default("16px"), rem__default.default("16px"), rem__default.default("16px"));
var FooterDivider = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Divider)(templateObject_5$9 || (templateObject_5$9 = __makeTemplateObject(["\n  && {\n    margin-left: ", ";\n  }\n  [dir=\"rtl\"] && {\n    margin-right: ", ";\n  }\n"], ["\n  && {\n    margin-left: ", ";\n  }\n  [dir=\"rtl\"] && {\n    margin-right: ", ";\n  }\n"])), rem__default.default("-15px"), rem__default.default("-15px"));
var UserPreferencesFooter = function (props) {
    var translate = useTranslateFunction();
    var theme = useTheme();
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        React__namespace.default.createElement(lighthouseComponentLibrary.MediaQuery, { minWidth: lighthouseComponentLibrary.getMinBreakpoint("md")({ theme: theme }) },
            React__namespace.default.createElement(PanelFooter, null,
                React__namespace.default.createElement(FooterDivider, null),
                React__namespace.default.createElement(DesktopSaveButton, { onClick: props.handleSaveClicked, disabled: props.buttonsDisabled, "data-qa": "savePreferenceButton" }, translate("USER_PREFERENCES.SAVE")),
                React__namespace.default.createElement(lighthouseComponentLibrary.Button, { onClick: props.handleDiscardChangesClicked, disabled: props.buttonsDisabled, "data-qa": "discardChangesPreferenceButton", type: "outline" }, translate("USER_PREFERENCES.DISCARD_CHANGES")))),
        React__namespace.default.createElement(lighthouseComponentLibrary.MediaQuery, { maxWidth: lighthouseComponentLibrary.getMaxBreakpoint("sm")({ theme: theme }) },
            React__namespace.default.createElement(StyledMobileFooterWrapper, null,
                React__namespace.default.createElement(lighthouseComponentLibrary.Button, { onClick: props.handleDiscardChangesClicked, type: "outline", "data-qa": "discardChangesPreferenceButton", disabled: props.buttonsDisabled }, translate("USER_PREFERENCES.DISCARD_CHANGES")),
                React__namespace.default.createElement(MobileSaveButton, { onClick: props.handleSaveClicked, disabled: props.buttonsDisabled, "data-qa": "savePreferenceButton" }, translate("USER_PREFERENCES.SAVE"))))));
};
var templateObject_1$u, templateObject_2$m, templateObject_3$g, templateObject_4$c, templateObject_5$9;

var PreferencePanelContainer = lighthouseComponentLibrary.styled.div(templateObject_1$t || (templateObject_1$t = __makeTemplateObject(["\n  padding-top: ", ";\n"], ["\n  padding-top: ", ";\n"])), polished.rem("4px"));
/**
 * @deprecated Exported for unit tests only!
 */
var PreferencePanelTitle = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_2$l || (templateObject_2$l = __makeTemplateObject(["\n  color: ", ";\n  margin-bottom: ", ";\n"], ["\n  color: ", ";\n  margin-bottom: ", ";\n"])), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.grey.tone[800]; }, polished.rem("16px"));
var PreferencePanelMessage = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_3$f || (templateObject_3$f = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.grey.tone[800]; });
lighthouseComponentLibrary.styled.div(templateObject_4$b || (templateObject_4$b = __makeTemplateObject(["\n  bottom: 0;\n  position: absolute;\n  width: 100%;\n"], ["\n  bottom: 0;\n  position: absolute;\n  width: 100%;\n"])));
lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Button)(templateObject_5$8 || (templateObject_5$8 = __makeTemplateObject(["\n  && {\n    margin-top: ", ";\n    margin-bottom: ", ";\n  }\n"], ["\n  && {\n    margin-top: ", ";\n    margin-bottom: ", ";\n  }\n"])), polished.rem("20px"), polished.rem("20px"));
lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Divider)(templateObject_6$4 || (templateObject_6$4 = __makeTemplateObject(["\n  && {\n    margin-left: ", ";\n  }\n  [dir=\"rtl\"] && {\n    margin-right: ", ";\n  }\n"], ["\n  && {\n    margin-left: ", ";\n  }\n  [dir=\"rtl\"] && {\n    margin-right: ", ";\n  }\n"])), polished.rem("-16px"), polished.rem("-16px"));
function PreferencePanelHeader(props) {
    return React__namespace.createElement(PreferencePanelTitle, { use: "h2" }, props.title);
}
function PreferencePanelSubheader(props) {
    return React__namespace.createElement(PreferencePanelTitle, { use: "h3" }, props.title);
}
function PreferencePanelDescription(props) {
    return (React__namespace.createElement(PreferencePanelMessage, { use: "body" }, props.message));
}
var templateObject_1$t, templateObject_2$l, templateObject_3$f, templateObject_4$b, templateObject_5$8, templateObject_6$4;

/**
 * Styled div for the main header container.
 */
var Container$5 = lighthouseComponentLibrary.styled.div(templateObject_1$s || (templateObject_1$s = __makeTemplateObject(["\n  display: block;\n  padding-bottom: ", ";\n  border-bottom: ", " solid\n    ", ";\n"], ["\n  display: block;\n  padding-bottom: ", ";\n  border-bottom: ", " solid\n    ", ";\n"])), polished.rem("16px"), polished.rem("1px"), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.grey.tone[300]; });
/**
 * Styled typography for heading subtitle.
 */
var Subtitle$1 = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_2$k || (templateObject_2$k = __makeTemplateObject(["\n  && {\n    padding-bottom: ", ";\n  }\n"], ["\n  && {\n    padding-bottom: ", ";\n  }\n"])), polished.rem("16px"));
/**
 * Displays the Language and Localization header section of the Language and Localization page.
 */
var LanguageAndLocalizationHeader = function () {
    var translate = useTranslateFunction();
    return (React__namespace.default.createElement(Container$5, null,
        React__namespace.default.createElement(Subtitle$1, { use: "body", "data-qa": "language-and-localization-header-subtitle" }, translate("USER_PREFERENCES.LANGUAGE_AND_LOCALIZATION_SUBTITLE"))));
};
var templateObject_1$s, templateObject_2$k;

/**
 * Possible time formats (12- vs 24-hour time) for the user preference setting.
 */
var TimeFormatUserPreference;
(function (TimeFormatUserPreference) {
    /**
     * Use the default setting from the account config.
     */
    TimeFormatUserPreference["AccountConfigDefault"] = "AccountConfigDefault";
    /**
     * Use the default 12- vs 24-hour format for the user's current locale.
     */
    TimeFormatUserPreference["LocaleDefault"] = "LocaleDefault";
    /**
     * Force time to 12-hour format regardless of the user's current locale.
     */
    TimeFormatUserPreference["Force12Hours"] = "Force12Hours";
    /**
     * Force time to 24-hour format regardless of the user's current locale.
     */
    TimeFormatUserPreference["Force24Hours"] = "Force24Hours";
})(TimeFormatUserPreference || (TimeFormatUserPreference = {}));

var TextsContainer = lighthouseComponentLibrary.styled.div(templateObject_1$r || (templateObject_1$r = __makeTemplateObject(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"])));
var TimeFormattingOptionLabel = function (props) {
    var _a, _b;
    var translate = useTranslateFunction();
    var labelKey = tsEnumUtil.$enum.mapValue(props.timeFormatOption).with((_a = {},
        _a[TimeFormatUserPreference.AccountConfigDefault] = "USER_PREFERENCES.TIME_FORMATTING_ACCOUNT_CONFIG_DEFAULT_LABEL",
        _a[TimeFormatUserPreference.LocaleDefault] = "USER_PREFERENCES.TIME_FORMATTING_LOCALE_DEFAULT_LABEL",
        _a[TimeFormatUserPreference.Force12Hours] = "USER_PREFERENCES.TIME_FORMATTING_FORCE_12_HOURS_LABEL",
        _a[TimeFormatUserPreference.Force24Hours] = "USER_PREFERENCES.TIME_FORMATTING_FORCE_24_HOURS_LABEL",
        _a));
    var descriptionKey = tsEnumUtil.$enum.mapValue(props.timeFormatOption).with((_b = {},
        _b[TimeFormatUserPreference.AccountConfigDefault] = "USER_PREFERENCES.TIME_FORMATTING_ACCOUNT_CONFIG_DEFAULT_DESCRIPTION",
        _b[TimeFormatUserPreference.LocaleDefault] = "USER_PREFERENCES.TIME_FORMATTING_LOCALE_DEFAULT_DESCRIPTION",
        _b[TimeFormatUserPreference.Force12Hours] = "USER_PREFERENCES.TIME_FORMATTING_FORCE_12_HOURS_DESCRIPTION",
        _b[TimeFormatUserPreference.Force24Hours] = "USER_PREFERENCES.TIME_FORMATTING_FORCE_24_HOURS_DESCRIPTION",
        _b));
    return (React__namespace.default.createElement(Container$4, null,
        React__namespace.default.createElement(TextsContainer, null,
            React__namespace.default.createElement(lighthouseComponentLibrary.Typography, { use: "body", "data-test-id": "user-preference-label-text", "data-qa": "time-format-user-preference-label-" + props.timeFormatOption }, translate(labelKey)),
            React__namespace.default.createElement(lighthouseComponentLibrary.Typography, { use: "body", "data-test-id": "user-preference-description-text", "data-qa": "time-format-user-preference-description-" + props.timeFormatOption }, translate(descriptionKey)))));
};
/**
 * Styled div for the time formatting section container.
 */
var Container$4 = lighthouseComponentLibrary.styled.div(templateObject_2$j || (templateObject_2$j = __makeTemplateObject(["\n  display: block;\n  margin-left: ", ";\n"], ["\n  display: block;\n  margin-left: ", ";\n"])), polished.rem("12px"));
/**
 * Displays the Time Formatting section of the Language and Localization page.
 */
var TimeFormattingPreference = function (props) {
    return (React__namespace.default.createElement(Container$4, null,
        React__namespace.default.createElement(lighthouseComponentLibrary.RadioGroup, { row: false, name: "time-formatting-user-preference-radio-group", radioProps: tsEnumUtil.$enum(TimeFormatUserPreference).map(function (formatOption) { return ({
                id: formatOption,
                onChange: function () { return props.onChange(formatOption); },
                checked: formatOption === props.timeFormatUserPreference,
                disabled: false,
                value: formatOption,
                name: "time-formatting-user-preference-radio",
                "data-qa": "time-format-user-preference-radio-" + formatOption,
                label: React__namespace.default.createElement(TimeFormattingOptionLabel, { timeFormatOption: formatOption }),
            }); }) })));
};
var templateObject_1$r, templateObject_2$j;

var HiddenIframe = lighthouseComponentLibrary.styled.iframe(templateObject_1$q || (templateObject_1$q = __makeTemplateObject(["\n  position: absolute;\n  width: 0px;\n  height: 0px;\n  border: none;\n"], ["\n  position: absolute;\n  width: 0px;\n  height: 0px;\n  border: none;\n"])));
var maxTimeSpentWaitingForLogoutToCompleteMs = 5000;
/**
 * A component that invalidates the current user's T&A session.
 * It should only be rendered by its parent only when we want to initiate a logout, and then
 * should remain consistently rendered by its parent until the onComplete event fires to indicate
 * that the logout attempt has completed. The parent component should then stop rendering
 * this component.
 *
 * onComplete events are guaranteed to trigger at some point regardless of success or failure.
 * If the logout attempt takes longer to load than the specified maximum time:
 * {@link maxTimeSpentWaitingForLogoutToCompleteMs},
 * then onComplete will be called with an isTimedOut=true parameter,
 * which allows the parent component to respond accordingly.
 */
var WtaSessionInvalidation = function (props) {
    var wtaLogoffUrl = getWtaLogoffUrl();
    var completed = React.useRef(false);
    var timeoutHandlerRef = React.useRef(function () { });
    React.useEffect(function () {
        timeoutHandlerRef.current = function () {
            if (!completed.current) {
                completed.current = true;
                props.onComplete(true);
            }
        };
    }, [props.onComplete]);
    // After maxTimeSpentWaitingForLogoutToCompleteMs, trigger onComplete.
    // However, if the component gets unmounted, cancel the timeout.
    React.useEffect(function () {
        var timeout = setTimeout(function () { return timeoutHandlerRef.current(); }, maxTimeSpentWaitingForLogoutToCompleteMs);
        return function () {
            clearTimeout(timeout);
        };
    }, []);
    return (React__namespace.default.createElement(HiddenIframe, { src: wtaLogoffUrl, onLoad: function () {
            if (!completed.current) {
                completed.current = true;
                props.onComplete(false);
            }
        }, sandbox: "", "aria-hidden": "true", tabIndex: -1, "data-testid": "wta-session-invalidation" }));
};
var templateObject_1$q;

var StyledContentSection$2 = lighthouseComponentLibrary.styled.div(templateObject_1$p || (templateObject_1$p = __makeTemplateObject(["\n  padding: ", " ", " 0;\n  flex: 1;\n  overflow-y: auto;\n"], ["\n  padding: ", " ", " 0;\n  flex: 1;\n  overflow-y: auto;\n"])), rem__default.default("16px"), rem__default.default("16px"));
/**
 * Wrapper for the mobile Language and Localization page.
 */
var MobilePageWrapper = lighthouseComponentLibrary.styled.div(templateObject_2$i || (templateObject_2$i = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  height: 100%;\n"], ["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  height: 100%;\n"])));
/**
 * Wrapper for the desktop Language and Localization page.
 */
var DesktopPageWrapper = lighthouseComponentLibrary.styled.div(templateObject_3$e || (templateObject_3$e = __makeTemplateObject(["\n  max-height: calc(\n    100% - 135px\n  ); /* 135px is roughly equal to the height of the header and footer combined on the panel */\n  overflow: auto;\n"], ["\n  max-height: calc(\n    100% - 135px\n  ); /* 135px is roughly equal to the height of the header and footer combined on the panel */\n  overflow: auto;\n"])));
/**
 * Wrapper for the Time Formatting section of the Language and Localization page.
 */
var TimeFormattingWrapper = lighthouseComponentLibrary.styled.div(templateObject_4$a || (templateObject_4$a = __makeTemplateObject(["\n  border-top: ", " solid\n    ", ";\n  border-bottom: ", " solid\n    ", ";\n"], ["\n  border-top: ", " solid\n    ", ";\n  border-bottom: ", " solid\n    ", ";\n"])), rem__default.default("1px"), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.grey.tone[300]; }, rem__default.default("1px"), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.grey.tone[300]; });
/**
 * Displays the Mobile view of the Language and Localization page.
 * @deprecated Exported for unit tests only!
 */
var MobileLocalePreference = function (props) {
    var isTimeFormattingVisible = useNamedFeatureFlags(exports.FeatureFlagKey.NextGenTimeFormatting).next_gen_time_formatting;
    var translate = useTranslateFunction();
    var localeNotChanged = props.selectedLocale === props.currentLocale;
    var buttonsDisabled = isTimeFormattingVisible
        ? localeNotChanged &&
            props.selectedTimeFormatUserPreference ===
                props.currentTimeFormatUserPreference
        : localeNotChanged;
    var languageHeaderTitle = isTimeFormattingVisible
        ? "USER_PREFERENCES.LANGUAGE_AND_LOCALIZATION_TITLE"
        : "USER_PREFERENCES.CHANGE_LANGUAGE";
    var languageHeaderTitleDataQA = isTimeFormattingVisible
        ? "language-and-localization-header-mobile"
        : "language-header-mobile";
    return (React__namespace.default.createElement(MobilePageWrapper, null,
        React__namespace.default.createElement(MobilePageHeader$1, { "data-qa": languageHeaderTitleDataQA, pageTitle: translate(languageHeaderTitle) }),
        React__namespace.default.createElement(StyledContentSection$2, null,
            isTimeFormattingVisible && React__namespace.default.createElement(LanguageAndLocalizationHeader, null),
            isTimeFormattingVisible && (React__namespace.default.createElement(PreferencePanelSubheader, { "data-qa": "language-subheader-mobile", title: translate("USER_PREFERENCES.LANGUAGE") })),
            React__namespace.default.createElement(LocaleSelector$1, { selectedLocale: props.selectedLocale || props.currentLocale, onLocaleChange: props.onLocaleChange }),
            isTimeFormattingVisible && (React__namespace.default.createElement(TimeFormattingWrapper, { "data-qa": "time-format-wrapper-mobile" },
                React__namespace.default.createElement(PreferencePanelSubheader, { "data-qa": "time-format-preference-subheader-mobile", title: translate("USER_PREFERENCES.TIME_FORMAT_PREFERENCE_TITLE") }),
                React__namespace.default.createElement(TimeFormattingPreference, { timeFormatUserPreference: props.selectedTimeFormatUserPreference, onChange: props.onTimeFormatChange })))),
        React__namespace.default.createElement(UserPreferencesFooter, { handleSaveClicked: props.handleSaveClicked, handleDiscardChangesClicked: props.handleDiscardChangesClicked, buttonsDisabled: buttonsDisabled })));
};
/**
 * Displays the Desktop view of the Language and Localization page.
 * @deprecated Exported for unit tests only!
 */
var DesktopLocalePreference = function (props) {
    var isTimeFormattingVisible = useNamedFeatureFlags(exports.FeatureFlagKey.NextGenTimeFormatting).next_gen_time_formatting;
    var translate = useTranslateFunction();
    var localeNotChanged = props.selectedLocale === props.currentLocale;
    var buttonsDisabled = isTimeFormattingVisible
        ? localeNotChanged &&
            props.selectedTimeFormatUserPreference ===
                props.currentTimeFormatUserPreference
        : localeNotChanged;
    var languageHeaderTitle = isTimeFormattingVisible
        ? "USER_PREFERENCES.LANGUAGE_AND_LOCALIZATION_TITLE"
        : "USER_PREFERENCES.LANGUAGE";
    var languageHeaderTitleDataQA = isTimeFormattingVisible
        ? "language-and-localization-header-desktop"
        : "language-header-desktop";
    return (React__namespace.default.createElement(DesktopPageWrapper, null,
        React__namespace.default.createElement(PreferencePanelContainer, null,
            React__namespace.default.createElement(PreferencePanelHeader, { "data-qa": languageHeaderTitleDataQA, title: translate(languageHeaderTitle) }),
            isTimeFormattingVisible && React__namespace.default.createElement(LanguageAndLocalizationHeader, null),
            isTimeFormattingVisible && (React__namespace.default.createElement(PreferencePanelSubheader, { "data-qa": "language-subheader-desktop", title: translate("USER_PREFERENCES.LANGUAGE") })),
            React__namespace.default.createElement(LocaleSelector$1, { selectedLocale: props.selectedLocale || props.currentLocale, onLocaleChange: props.onLocaleChange }),
            isTimeFormattingVisible && (React__namespace.default.createElement(TimeFormattingWrapper, { "data-qa": "time-format-wrapper-desktop" },
                React__namespace.default.createElement(PreferencePanelSubheader, { "data-qa": "time-format-preference-subheader-desktop", title: translate("USER_PREFERENCES.TIME_FORMAT_PREFERENCE_TITLE") }),
                React__namespace.default.createElement(TimeFormattingPreference, { timeFormatUserPreference: props.selectedTimeFormatUserPreference, onChange: props.onTimeFormatChange }))),
            React__namespace.default.createElement(UserPreferencesFooter, { handleSaveClicked: props.handleSaveClicked, handleDiscardChangesClicked: props.handleDiscardChangesClicked, buttonsDisabled: buttonsDisabled }))));
};
var LocalePreferences = function () {
    var setIsUnsavedChanges = React.useContext(UserPreferenceUnsavedChangesContext).setIsUnsavedChanges;
    var dispatch = getStore().dispatch;
    var _a = useBackCompatPreference(exports.BackCompatUserPreferenceKey.Locale, true), setSavedLocale = _a[1];
    var currentLocale = useTypedSelector(function (state) { return state.appLocalizationData.locale; });
    var _b = useBackCompatPreference(exports.BackCompatUserPreferenceKey.TimeFormat, true), savedTimeFormat = _b[0], setSavedTimeFormat = _b[1];
    var featureFlags = useNamedFeatureFlags.apply(void 0, Object.values(exports.WfxFeatureFlagKey));
    var isWfxFeatureEnabled = isAnyWfxFeatureFlagEnabled(featureFlags);
    // Sets the selected locale to be the currentLocale by default.
    var _c = React.useState(currentLocale), selectedLocale = _c[0], setSelectedLocale = _c[1];
    // Selected Time Format by the user. It's current Time Format by default.
    var _d = React.useState(savedTimeFormat), selectedTimeFormat = _d[0], setSelectedTimeFormat = _d[1];
    // Whether or not the User Preferences save recently succeeded, false by default
    var _e = React.useState(false), saveSucceeded = _e[0], setSaveSucceeded = _e[1];
    // Whether or not the User Preferences save recently failed, false by default
    var _f = React.useState(false), saveFailed = _f[0], setSaveFailed = _f[1];
    var _g = React.useState(false), invalidatingWtaSession = _g[0], setInvalidatingWtaSession = _g[1];
    // The success toast should open if a save recently succeeded and T&A has finished logging out
    var shouldOpenSuccessToast = saveSucceeded && !invalidatingWtaSession;
    // The failure toast should open if a save recently failed
    var shouldOpenFailureToast = saveFailed;
    React.useEffect(function () {
        setIsUnsavedChanges(!!currentLocale && currentLocale !== selectedLocale);
        return function () {
            setIsUnsavedChanges(false);
        };
    }, [currentLocale, selectedLocale]);
    React.useEffect(function () {
        setIsUnsavedChanges(!!savedTimeFormat && savedTimeFormat !== selectedTimeFormat);
        return function () {
            setIsUnsavedChanges(false);
        };
    }, [savedTimeFormat, selectedTimeFormat]);
    var handleSaveClicked = function () { return __awaiter(void 0, void 0, void 0, function () {
        var localeSaved, timeFormatSaved, error_1, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    localeSaved = false;
                    timeFormatSaved = false;
                    if (!(currentLocale !== selectedLocale)) return [3 /*break*/, 10];
                    // Invalidate the T&A session immediately if the locale is changing
                    // This is done in order to force T&A to create another session with the correct locale
                    // We are making the assumption that the locale will be synchronized from user preference
                    // service to WTA via kafka quicker than the user will navigate to an embedded WTA page after
                    // changing their language. This assumption may be false under certain circumstances, and we
                    // understand that this solution has its limitations.
                    setInvalidatingWtaSession(true);
                    // Sets the selected locale user preference for Integrated Experience.
                    if (isWfxFeatureEnabled) {
                        try {
                            experience.WfsIntegrationService === null || experience.WfsIntegrationService === void 0 ? void 0 : experience.WfsIntegrationService.setLocalePreference(selectedLocale);
                        }
                        catch (error) {
                            global.console.error("Locale " + selectedLocale + " could not be changed on WFX: " + error);
                        }
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 9, , 10]);
                    if (!(currentLocale === appDefaultLocale)) return [3 /*break*/, 3];
                    return [4 /*yield*/, dispatch(deleteCachedTranslations())];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [4 /*yield*/, dispatch(getTranslations(selectedLocale))];
                case 4:
                    _a.sent();
                    return [4 /*yield*/, dispatch(changeAppLocale(selectedLocale))];
                case 5:
                    _a.sent();
                    return [4 /*yield*/, i18next__default.default.changeLanguage(selectedLocale)];
                case 6:
                    _a.sent();
                    return [4 /*yield*/, setSavedLocale(selectedLocale)];
                case 7:
                    _a.sent();
                    localeSaved = true;
                    // Fetch Navigation items to refresh the menu item - Custom Help Links
                    return [4 /*yield*/, dispatch(getNavigationItems())];
                case 8:
                    // Fetch Navigation items to refresh the menu item - Custom Help Links
                    _a.sent();
                    return [3 /*break*/, 10];
                case 9:
                    error_1 = _a.sent();
                    global.console.error("Locale " + selectedLocale + " could not be changed: " + error_1);
                    setIsUnsavedChanges(true);
                    localeSaved = false;
                    return [3 /*break*/, 10];
                case 10:
                    if (!(savedTimeFormat !== selectedTimeFormat)) return [3 /*break*/, 14];
                    _a.label = 11;
                case 11:
                    _a.trys.push([11, 13, , 14]);
                    return [4 /*yield*/, setSavedTimeFormat(selectedTimeFormat)];
                case 12:
                    _a.sent();
                    timeFormatSaved = true;
                    return [3 /*break*/, 14];
                case 13:
                    error_2 = _a.sent();
                    global.console.error("Time format " + selectedTimeFormat + " could not be changed: " + error_2);
                    setIsUnsavedChanges(true);
                    timeFormatSaved = false;
                    return [3 /*break*/, 14];
                case 14:
                    if (localeSaved || timeFormatSaved) {
                        setSaveSucceeded(true);
                    }
                    else {
                        setSaveFailed(true);
                        setInvalidatingWtaSession(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDiscardChangesClicked = function () {
        setSelectedLocale(currentLocale);
        setSelectedTimeFormat(savedTimeFormat);
        setIsUnsavedChanges(false);
    };
    var onLocaleChange = function (locale) {
        setSelectedLocale(locale);
        setIsUnsavedChanges(true);
    };
    var onTimeFormatChange = function (timeFormatUserPreference) {
        setSelectedTimeFormat(timeFormatUserPreference);
        setIsUnsavedChanges(true);
    };
    var SuccessToast = function (_a) {
        var isOpen = _a.isOpen, onClose = _a.onClose, positionVertical = _a.positionVertical;
        var translate = useTranslateFunction();
        var message = translate("USER_PREFERENCES.SETTING_UPDATE_SUCCESS");
        return (React__namespace.default.createElement(lighthouseComponentLibrary.Toast, { message: message, onClose: onClose, variant: "success", open: isOpen, dismissible: true, positionVertical: positionVertical, "data-qa": "save-success-toast" }));
    };
    var FailureToast = function (_a) {
        var isOpen = _a.isOpen, onClose = _a.onClose, positionVertical = _a.positionVertical;
        var translate = useTranslateFunction();
        var message = translate("USER_PREFERENCES.SETTING_UPDATE_FAILED");
        return (React__namespace.default.createElement(lighthouseComponentLibrary.Toast, { message: message, onClose: onClose, variant: "error", open: isOpen, dismissible: true, positionVertical: positionVertical, "data-qa": "save-failure-toast" }));
    };
    var theme = useTheme();
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        React__namespace.default.createElement(lighthouseComponentLibrary.MediaQuery, { minWidth: lighthouseComponentLibrary.getMinBreakpoint("md")({ theme: theme }) },
            React__namespace.default.createElement(DesktopLocalePreference, { selectedLocale: selectedLocale, currentLocale: currentLocale, handleSaveClicked: handleSaveClicked, handleDiscardChangesClicked: handleDiscardChangesClicked, onLocaleChange: onLocaleChange, currentTimeFormatUserPreference: savedTimeFormat, selectedTimeFormatUserPreference: selectedTimeFormat, onTimeFormatChange: onTimeFormatChange }),
            React__namespace.default.createElement(SuccessToast, { isOpen: shouldOpenSuccessToast, onClose: function () { return setSaveSucceeded(false); }, positionVertical: "top" }),
            React__namespace.default.createElement(FailureToast, { isOpen: shouldOpenFailureToast, onClose: function () { return setSaveFailed(false); }, positionVertical: "top" })),
        React__namespace.default.createElement(lighthouseComponentLibrary.MediaQuery, { maxWidth: lighthouseComponentLibrary.getMaxBreakpoint("sm")({ theme: theme }) },
            React__namespace.default.createElement(MobileLocalePreference, { selectedLocale: selectedLocale, currentLocale: currentLocale, handleSaveClicked: handleSaveClicked, handleDiscardChangesClicked: handleDiscardChangesClicked, onLocaleChange: onLocaleChange, currentTimeFormatUserPreference: savedTimeFormat, selectedTimeFormatUserPreference: selectedTimeFormat, onTimeFormatChange: onTimeFormatChange }),
            React__namespace.default.createElement(SuccessToast, { isOpen: shouldOpenSuccessToast, onClose: function () { return setSaveSucceeded(false); }, positionVertical: "bottom" }),
            React__namespace.default.createElement(FailureToast, { isOpen: shouldOpenFailureToast, onClose: function () { return setSaveFailed(false); }, positionVertical: "bottom" })),
        invalidatingWtaSession && (React__namespace.default.createElement(WtaSessionInvalidation, { onComplete: function (isTimedOut) {
                if (isTimedOut) {
                    console.log("Timed out while attempting to log out of T&A");
                }
                else {
                    console.log("Successfully invalidated T&A session");
                }
                setInvalidatingWtaSession(false);
            } }))));
};
var templateObject_1$p, templateObject_2$i, templateObject_3$e, templateObject_4$a;

/**
 * Private recursive implementation of {@link getNavigationSkeletonItemParentId}
 * @param skeletonItemId - ID of the skeleton item whose parent is to be found.
 * @param potentialParentId - The ID of the parent whose children are being processed
 *                            (undefined if the top-level items are being processed).
 * @param potentialParentChildren - The child items to recursively search.
 */
function getNavigationSkeletonItemParentIdImpl(skeletonItemId, potentialParentId, potentialParentChildren) {
    return ___default.default(potentialParentChildren)
        .map(function (child) {
        if (child.id === skeletonItemId) {
            return potentialParentId;
        }
        else if (child.subMenu) {
            return getNavigationSkeletonItemParentIdImpl(skeletonItemId, child.id, child.subMenu);
        }
        else {
            return undefined;
        }
    })
        .compact()
        .first();
}
/**
 * Get the ID of the parent of a specified item within the navigation skeleton.
 * @param skeletonItemId - ID of the skeleton item whose parent is to be found.
 * @return the ID of the parent of the specified skeleton item.
 *         Undefined if either the specified item is not found, or the specified
 *         item is a top-level item.
 */
function getNavigationSkeletonItemParentId(skeletonItemId) {
    return getNavigationSkeletonItemParentIdImpl(skeletonItemId, undefined, getNavigationSkeleton());
}
/**
 * Private recursive implementation of {@link getFlattenedNavigationSkeleton}
 * @param skeletonItems - List of skeleton items to be flattened.
 * @return A flattened list of the entire tree structure of the provided skeleton items.
 */
function getFlattenedNavigationSkeletonImpl(skeletonItems) {
    return ___default.default.flatMap(skeletonItems, function (skeletonItem) {
        if (skeletonItem.subMenu) {
            return __spreadArrays([
                skeletonItem
            ], getFlattenedNavigationSkeletonImpl(skeletonItem.subMenu));
        }
        else {
            return [skeletonItem];
        }
    });
}
/**
 * Gets a flattened list containing all items in the recursively nested structure
 * of the navigation skeleton.
 * @return A flattened list of the entire tree structure of the navigation skeleton.
 */
function getFlattenedNavigationSkeleton() {
    if (!getFlattenedNavigationSkeleton_cachedResult) {
        getFlattenedNavigationSkeleton_cachedResult = getFlattenedNavigationSkeletonImpl(getNavigationSkeleton());
    }
    return getFlattenedNavigationSkeleton_cachedResult;
}
/**
 * Cached result used to optimize the implementation of {@link getFlattenedNavigationSkeleton}
 */
var getFlattenedNavigationSkeleton_cachedResult;

var _a$1;
/**
 * Possible values for the radio group that chooses between "default" and "custom".
 */
var DefaultOrCustom;
(function (DefaultOrCustom) {
    DefaultOrCustom["Default"] = "default";
    DefaultOrCustom["Custom"] = "custom";
})(DefaultOrCustom || (DefaultOrCustom = {}));
/**
 * Mapping of DefaultOrCustom values to translation keys for their labels.
 */
var DefaultOrCustomTranslationKeys = (_a$1 = {},
    _a$1[DefaultOrCustom.Default] = "USER_PREFERENCES.HUB_PAGE",
    _a$1[DefaultOrCustom.Custom] = "USER_PREFERENCES.CUSTOM",
    _a$1);
/** Component to render the Input element */
var LandingPageInput = function (props) {
    var translate = useTranslateFunction();
    return (React__namespace.default.createElement(lighthouseComponentLibrary.OutlinedTextField, __assign({}, props, { name: "landingPage", label: translate("USER_PREFERENCES.CUSTOM_LANDING_PAGE") })));
};
var LandingPageSelector = function (props) {
    // The default selected landing page is undefined. On the other hand,
    // a custom selected page should be defined by a string id, e.g. LINK/TIMESHEET.
    // Ideally this would be a boolean but the RadioGroup component only accepts string values.
    // An empty string value here just means that the Custom option was selected but no
    // landing page has been selected yet.
    var defaultOrCustomLandingPage = props.selectedLandingPage !== undefined
        ? DefaultOrCustom.Custom
        : DefaultOrCustom.Default;
    // The value that will be selected in the custom landing page combo box.
    // If the actual current landingPageLinkId is undefined ("default"),
    // then use defaultCustomLandingPageLinkId to indicate which value will be
    // selected if user switches to "custom".
    var selectedCustomLandingPageLinkId = props.selectedLandingPage !== undefined
        ? props.selectedLandingPage
        : props.savedLandingPage || undefined;
    var translate = useTranslateFunction();
    var translatedLabelsByNavigationItemId = React.useMemo(function () {
        return ___default.default.mapValues(props.navigationItems, function (navigationItem) {
            return navigationItem.translationKey
                ? translate(navigationItem.translationKey)
                : navigationItem.title;
        });
    }, [props.navigationItems]);
    // IDs of all navigation items that the user has access to be selected as the
    // custom landing page, in the order specified by the navigation skeleton.
    var landingPageLinkIds = React.useMemo(function () {
        return ___default.default(getFlattenedNavigationSkeleton())
            .filter(function (skeletonItem) {
            var navigationItem = props.navigationItems[skeletonItem.id];
            return (!!navigationItem &&
                !isMenu(navigationItem) &&
                !isExperienceNavigationItem(navigationItem));
        })
            .map(function (skeletonItem) { return skeletonItem.id; })
            .value();
    }, [props.navigationItems]);
    return (React__namespace.default.createElement(StyledDiv$1, null,
        React__namespace.default.createElement(PreferencePanelDescription, { message: translate("USER_PREFERENCES.LANDING_PAGE_DESCRIPTION") }),
        React__namespace.default.createElement(lighthouseComponentLibrary.RadioGroup, { row: false, radioProps: tsEnumUtil.$enum(DefaultOrCustom).map(function (defaultOrCustom) { return ({
                id: defaultOrCustom,
                value: defaultOrCustom,
                name: defaultOrCustom,
                label: translate(DefaultOrCustomTranslationKeys[defaultOrCustom]),
                disabled: false,
            }); }), name: "defaultOrCustomLandingPage", className: "defaultOrCustomLandingPage", value: defaultOrCustomLandingPage, onChange: function (event, newValue) {
                var _a;
                props.onLandingPageChange(tsEnumUtil.$enum
                    .mapValue(tsEnumUtil.$enum(DefaultOrCustom).asValueOrThrow(newValue))
                    .with((_a = {},
                    _a[DefaultOrCustom.Custom] = props.savedLandingPage || "",
                    _a[DefaultOrCustom.Default] = undefined,
                    _a)));
            }, "aria-label": translate("USER_PREFERENCES.LANDING_PAGE_RADIO_GROUP_ARIA_LABEL") }),
        React__namespace.default.createElement(lighthouseComponentLibrary.ComboBox, { className: "landingPageComboBox", value: selectedCustomLandingPageLinkId, options: landingPageLinkIds, getOptionLabel: function (linkId) {
                return (linkId && translatedLabelsByNavigationItemId[linkId]) || "";
            }, groupBy: function (linkId) {
                return translatedLabelsByNavigationItemId[
                // non-null assertion is safe because none of our options are null
                getNavigationSkeletonItemParentId(linkId)];
            }, renderInput: LandingPageInput, 
            // NOTE: explicit type signature required to disambiguate between
            //       single select vs multi-select variation of props interfaces for ComboBox
            onChange: function (event, linkId) {
                props.onLandingPageChange(linkId);
            }, disabled: defaultOrCustomLandingPage === DefaultOrCustom.Default, clearOnEscape: false, filterSelectedOptions: false, openOnFocus: false, "data-qa": "landingPageSelector", "aria-label": translate("USER_PREFERENCES.CUSTOM_LANDING_PAGE") })));
};
var StyledDiv$1 = lighthouseComponentLibrary.styled.div(templateObject_1$o || (templateObject_1$o = __makeTemplateObject(["\n  &&& .landingPageComboBox {\n    width: ", ";\n    /* Fix label placement in RTL mode */\n    [dir=\"rtl\"] & .MuiFormLabel-root {\n      right: ", ";\n    }\n  }\n"], ["\n  &&& .landingPageComboBox {\n    width: ", ";\n    /* Fix label placement in RTL mode */\n    [dir=\"rtl\"] & .MuiFormLabel-root {\n      right: ", ";\n    }\n  }\n"])), polished.rem("272px"), polished.rem("16px"));
function mapStateToProps$3(state) {
    return {
        navigationItems: state.navigationItems,
    };
}
var ConnectedLandingPageSelector = reactRedux.connect(mapStateToProps$3)(LandingPageSelector);
var templateObject_1$o;

var PageWrapper$1 = lighthouseComponentLibrary.styled.div(templateObject_1$n || (templateObject_1$n = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  height: 100%;\n"], ["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  height: 100%;\n"])));
var StyledContentSection$1 = lighthouseComponentLibrary.styled.div(templateObject_2$h || (templateObject_2$h = __makeTemplateObject(["\n  padding: ", " ", " 0;\n  flex: 1;\n  overflow-y: auto;\n"], ["\n  padding: ", " ", " 0;\n  flex: 1;\n  overflow-y: auto;\n"])), polished.rem("16px"), polished.rem("16px"));
var MobileLandingPagePreference = function (props) {
    var translate = useTranslateFunction();
    var buttonsDisabled = props.selectedLandingPage === props.savedLandingPage ||
        props.selectedLandingPage === "";
    return (React__namespace.default.createElement(PageWrapper$1, null,
        React__namespace.default.createElement(MobilePageHeader$1, { pageTitle: translate("USER_PREFERENCES.CHANGE_LANDING_PAGE") }),
        React__namespace.default.createElement(StyledContentSection$1, null,
            React__namespace.default.createElement(ConnectedLandingPageSelector, { selectedLandingPage: props.selectedLandingPage, savedLandingPage: props.savedLandingPage, onLandingPageChange: props.onLandingPageChange })),
        React__namespace.default.createElement(UserPreferencesFooter, { handleSaveClicked: props.handleSaveClicked, handleDiscardChangesClicked: props.handleDiscardChangesClicked, buttonsDisabled: buttonsDisabled })));
};
var DesktopLandingPagePreference = function (props) {
    var translate = useTranslateFunction();
    var buttonsDisabled = props.selectedLandingPage === props.savedLandingPage ||
        props.selectedLandingPage === "";
    return (React__namespace.default.createElement(PreferencePanelContainer, null,
        React__namespace.default.createElement(PreferencePanelHeader, { title: translate("USER_PREFERENCES.LANDING_PAGE") }),
        React__namespace.default.createElement(ConnectedLandingPageSelector, { selectedLandingPage: props.selectedLandingPage, savedLandingPage: props.savedLandingPage, onLandingPageChange: props.onLandingPageChange }),
        React__namespace.default.createElement(UserPreferencesFooter, { handleSaveClicked: props.handleSaveClicked, handleDiscardChangesClicked: props.handleDiscardChangesClicked, buttonsDisabled: buttonsDisabled })));
};
var LandingPagePreference = function () {
    var dispatch = reactRedux.useDispatch();
    var setIsUnsavedChanges = React.useContext(UserPreferenceUnsavedChangesContext).setIsUnsavedChanges;
    var translate = useTranslateFunction();
    var _a = useBackCompatPreference(exports.BackCompatUserPreferenceKey.LandingPage), savedLandingPage = _a[0], setSavedLandingPage = _a[1];
    var _b = React.useState(savedLandingPage), selectedLandingPage = _b[0], setSelectedLandingPage = _b[1];
    React.useEffect(function () {
        setIsUnsavedChanges(savedLandingPage !== selectedLandingPage && savedLandingPage !== "");
    }, [selectedLandingPage, savedLandingPage]);
    var handleSaveClicked = function () {
        setSavedLandingPage(selectedLandingPage);
        var notification = {
            type: exports.NotificationActionTypes.SendDismissibleNotification,
            message: translate("USER_PREFERENCES.CHANGES_SAVED"),
        };
        dispatch(notification);
    };
    var handleDiscardChangesClicked = function () {
        setSelectedLandingPage(savedLandingPage);
    };
    var onLandingPageChange = function (landingPage) {
        setSelectedLandingPage(landingPage);
    };
    var theme = useTheme();
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        React__namespace.default.createElement(lighthouseComponentLibrary.MediaQuery, { maxWidth: lighthouseComponentLibrary.getMaxBreakpoint("sm")({ theme: theme }) },
            React__namespace.default.createElement(MobileLandingPagePreference, { selectedLandingPage: selectedLandingPage, savedLandingPage: savedLandingPage, onLandingPageChange: onLandingPageChange, handleSaveClicked: handleSaveClicked, handleDiscardChangesClicked: handleDiscardChangesClicked })),
        React__namespace.default.createElement(lighthouseComponentLibrary.MediaQuery, { minWidth: lighthouseComponentLibrary.getMinBreakpoint("md")({ theme: theme }) },
            React__namespace.default.createElement(DesktopLandingPagePreference, { selectedLandingPage: selectedLandingPage, savedLandingPage: savedLandingPage, onLandingPageChange: onLandingPageChange, handleSaveClicked: handleSaveClicked, handleDiscardChangesClicked: handleDiscardChangesClicked }))));
};
var templateObject_1$n, templateObject_2$h;

/**
 *  Styled typography for heading title
 */
var Title$2 = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_1$m || (templateObject_1$m = __makeTemplateObject(["\n  && {\n    text-transform: none;\n    margin-bottom: 0;\n  }\n"], ["\n  && {\n    text-transform: none;\n    margin-bottom: 0;\n  }\n"])));
/**
 *  Styled typography for heading subtitle
 */
var Subtitle = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_2$g || (templateObject_2$g = __makeTemplateObject(["\n  && {\n    color: ", ";\n  }\n"], ["\n  && {\n    color: ", ";\n  }\n"])), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.grey.tone[700]; });
var Container$3 = lighthouseComponentLibrary.styled.div(templateObject_3$d || (templateObject_3$d = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var HeaderDiv = lighthouseComponentLibrary.styled.div(templateObject_4$9 || (templateObject_4$9 = __makeTemplateObject(["\n  display: block;\n  padding-bottom: ", ";\n  flex: 1;\n"], ["\n  display: block;\n  padding-bottom: ", ";\n  flex: 1;\n"])), polished.rem("12px"));
var AssistantCardsFilterPanelHeader = function () {
    var translate = useTranslateFunction();
    return (React__namespace.createElement(Container$3, null,
        React__namespace.createElement(HeaderDiv, null,
            React__namespace.createElement(Title$2, { use: "h2" }, translate("EMPLOYEE_GROUP_FILTERS.TITLE")),
            React__namespace.createElement(Subtitle, { use: "body" }, translate("EMPLOYEE_GROUP_FILTERS.DESCRIPTION")))));
};
var templateObject_1$m, templateObject_2$g, templateObject_3$d, templateObject_4$9;

var StyledGroupTitleTypography = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_1$l || (templateObject_1$l = __makeTemplateObject(["\n  && {\n    margin: 0;\n  }\n"], ["\n  && {\n    margin: 0;\n  }\n"])));
var SwitchContainer = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.TableCell)(templateObject_2$f || (templateObject_2$f = __makeTemplateObject(["\n  && {\n    white-space: nowrap;\n    padding-right: ", ";\n    [dir=\"rtl\"] & {\n      padding-left: ", ";\n    }\n  }\n"], ["\n  && {\n    white-space: nowrap;\n    padding-right: ", ";\n    [dir=\"rtl\"] & {\n      padding-left: ", ";\n    }\n  }\n"])), polished.rem("28px"), polished.rem("28px"));
var StyledTableRow = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.TableRow)(templateObject_3$c || (templateObject_3$c = __makeTemplateObject(["\n  &&:not(:last-child) {\n    border-bottom: ", " solid\n      ", ";\n  }\n"], ["\n  &&:not(:last-child) {\n    border-bottom: ", " solid\n      ", ";\n  }\n"])), polished.rem("1px"), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.grey.tone[300]; });
var TableFilters = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.CardTable)(templateObject_4$8 || (templateObject_4$8 = __makeTemplateObject(["\n  && {\n    margin: 0;\n  }\n"], ["\n  && {\n    margin: 0;\n  }\n"])));
var Wrapper = lighthouseComponentLibrary.styled.div(templateObject_5$7 || (templateObject_5$7 = __makeTemplateObject(["\n  @media (min-width: ", ") {\n    max-height: calc(\n      100% - 130px\n    ); /* 150px is roughly equal to the height of the header and footer combined on the panel */\n    overflow: auto;\n  }\n  @media (max-width: ", ") {\n    [dir=\"ltr\"] && {\n      padding-left: ", ";\n    }\n    [dir=\"rtl\"] && {\n      padding-right: ", ";\n    }\n  }\n"], ["\n  @media (min-width: ", ") {\n    max-height: calc(\n      100% - 130px\n    ); /* 150px is roughly equal to the height of the header and footer combined on the panel */\n    overflow: auto;\n  }\n  @media (max-width: ", ") {\n    [dir=\"ltr\"] && {\n      padding-left: ", ";\n    }\n    [dir=\"rtl\"] && {\n      padding-right: ", ";\n    }\n  }\n"])), lighthouseComponentLibrary.getMinBreakpoint("md"), lighthouseComponentLibrary.getMaxBreakpoint("sm"), polished.rem("16px"), polished.rem("16px"));
var AssistantCardsFilterContent = function () {
    var _a = React__namespace.useContext(UserPreferenceUnsavedChangesContext), isUnsavedChanges = _a.isUnsavedChanges, setIsUnsavedChanges = _a.setIsUnsavedChanges;
    var _b = useBackCompatPreference(exports.BackCompatUserPreferenceKey.AssistantCardFilters), savedAssistantFilters = _b[0], setSavedAssistantFilters = _b[1];
    var employeeGroups = useTypedSelector(function (state) { return state.employeeGroups; });
    var employeeGroupsWithDefaultFilters = employeeGroups.map(function (group) {
        return __assign(__assign({}, group), { groupStatus: true });
    });
    var assistantFilters = savedAssistantFilters.length > 0
        ? savedAssistantFilters
        : employeeGroupsWithDefaultFilters;
    var _c = React__namespace.useState(assistantFilters), assistantCardsFiltersState = _c[0], setAssistantCardsFiltersState = _c[1];
    var onChange = function (index) {
        return function (event, checked) {
            onFilterChange(index, event, checked);
            setIsUnsavedChanges(true);
        };
    };
    var onFilterChange = function (index, event, checked) {
        setAssistantCardsFiltersState(function (prevState) {
            var newState = __spreadArrays(prevState);
            newState[index] = __assign(__assign({}, prevState[index]), { groupStatus: checked });
            return newState;
        });
    };
    var handleSaveClicked = function () {
        setSavedAssistantFilters(assistantCardsFiltersState);
        setIsUnsavedChanges(false);
    };
    var handleDiscardChangesClicked = function () {
        setAssistantCardsFiltersState(assistantFilters);
        setIsUnsavedChanges(false);
    };
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement(Wrapper, null,
            React__namespace.createElement(AssistantCardsFilterPanelHeader, null),
            React__namespace.createElement(TableFilters, null, assistantCardsFiltersState.map(function (filter, index) {
                return (React__namespace.createElement(StyledTableRow, { key: index },
                    React__namespace.createElement(lighthouseComponentLibrary.TableHeader, null,
                        React__namespace.createElement(StyledGroupTitleTypography, { use: "h5" }, filter.groupLabel)),
                    React__namespace.createElement(SwitchContainer, { align: "right" },
                        React__namespace.createElement(lighthouseComponentLibrary.Switch, { checked: filter.groupStatus, onChange: onChange(index) }))));
            }))),
        React__namespace.createElement(UserPreferencesFooter, { handleSaveClicked: handleSaveClicked, handleDiscardChangesClicked: handleDiscardChangesClicked, buttonsDisabled: !isUnsavedChanges })));
};
var AssistantCardsFilterPanel = function () {
    var theme = useTheme();
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement(lighthouseComponentLibrary.MediaQuery, { minWidth: lighthouseComponentLibrary.getMinBreakpoint("md")({ theme: theme }) },
            React__namespace.createElement(AssistantCardsFilterContent, null)),
        React__namespace.createElement(lighthouseComponentLibrary.MediaQuery, { maxWidth: lighthouseComponentLibrary.getMaxBreakpoint("sm")({ theme: theme }) },
            React__namespace.createElement(MobilePageHeader$1, { pageTitle: "Assistant Cards Filter" }),
            React__namespace.createElement(AssistantCardsFilterContent, null))));
};
var templateObject_1$l, templateObject_2$f, templateObject_3$c, templateObject_4$8, templateObject_5$7;

var Select$1 = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Select)(templateObject_1$k || (templateObject_1$k = __makeTemplateObject(["\n  width: ", ";\n"], ["\n  width: ", ";\n"])), polished.rem("272px"));
var ThemeSelector = function (props) {
    var selectedTheme = props.selectedTheme;
    var translate = useTranslateFunction();
    var themes = useTypedSelector(function (state) { return state.themeData.availableThemes; });
    var sortedThemes = themes && themes.length > 0 ? themes.sort(themeSortComparator) : [];
    var handleThemeSelected = function (event) {
        var eventInfo = event.target;
        props.onThemeChange(eventInfo.value);
    };
    return (React__namespace.default.createElement(Select$1, __assign({ "data-qa": "themeSelector", onChange: handleThemeSelected, label: translate("USER_PREFERENCES.THEME"), outlined: true }, props, { value: selectedTheme }), sortedThemes.map(function (theme) { return (React__namespace.default.createElement(lighthouseComponentLibrary.Option, { key: theme.id, "data-qa": theme.id, value: theme.id }, theme.label)); })));
};
var templateObject_1$k;

var LOCAL_STORAGE_KEY = "theme";
var DEFAULT_THEME = "defaultTheme";
function getPersistedThemePreference() {
    return localStorage.getItem(LOCAL_STORAGE_KEY) || DEFAULT_THEME;
}
function setPersistedThemePreference(theme) {
    localStorage.setItem(LOCAL_STORAGE_KEY, theme);
}

var StyledContentSection = lighthouseComponentLibrary.styled.div(templateObject_1$j || (templateObject_1$j = __makeTemplateObject(["\n  padding: ", " ", " 0;\n  flex: 1;\n  overflow-y: auto;\n"], ["\n  padding: ", " ", " 0;\n  flex: 1;\n  overflow-y: auto;\n"])), polished.rem("16px"), polished.rem("16px"));
var PageWrapper = lighthouseComponentLibrary.styled.div(templateObject_2$e || (templateObject_2$e = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  height: 100%;\n"], ["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  height: 100%;\n"])));
var MobileThemePreference = function (props) {
    var translate = useTranslateFunction();
    var buttonsDisabled = props.selectedTheme === "" || props.selectedTheme === props.currentTheme;
    return (React__namespace.default.createElement(PageWrapper, null,
        React__namespace.default.createElement(MobilePageHeader$1, { pageTitle: translate("USER_PREFERENCES.CHANGE_THEME") }),
        React__namespace.default.createElement(StyledContentSection, null,
            React__namespace.default.createElement(ThemeSelector, { selectedTheme: props.selectedTheme || props.currentTheme, onThemeChange: props.onThemeChange })),
        React__namespace.default.createElement(UserPreferencesFooter, { handleSaveClicked: props.handleSaveClicked, handleDiscardChangesClicked: props.handleDiscardChangesClicked, buttonsDisabled: buttonsDisabled })));
};
var DesktopThemePreference = function (props) {
    var translate = useTranslateFunction();
    var buttonsDisabled = props.selectedTheme === "" || props.selectedTheme === props.currentTheme;
    return (React__namespace.default.createElement(PreferencePanelContainer, null,
        React__namespace.default.createElement(PreferencePanelHeader, { title: translate("USER_PREFERENCES.THEMES") }),
        React__namespace.default.createElement(ThemeSelector, { selectedTheme: props.selectedTheme || props.currentTheme, onThemeChange: props.onThemeChange }),
        React__namespace.default.createElement(UserPreferencesFooter, { handleSaveClicked: props.handleSaveClicked, handleDiscardChangesClicked: props.handleDiscardChangesClicked, buttonsDisabled: buttonsDisabled })));
};
var ThemePreferences = function () {
    var setIsUnsavedChanges = React.useContext(UserPreferenceUnsavedChangesContext).setIsUnsavedChanges;
    var _a = useBackCompatPreference(exports.BackCompatUserPreferenceKey.Theme), savedTheme = _a[0], setSavedTheme = _a[1];
    var _b = React.useState(savedTheme), selectedTheme = _b[0], setSelectedTheme = _b[1];
    var dispatch = reactRedux.useDispatch();
    React.useEffect(function () {
        setIsUnsavedChanges(savedTheme !== selectedTheme && savedTheme !== "");
    }, [selectedTheme, savedTheme]);
    var handleSaveClicked = function () {
        setPersistedThemePreference(selectedTheme);
        setSavedTheme(selectedTheme);
        dispatch(setPreviewTheme());
    };
    var handleDiscardChangesClicked = function () {
        setSelectedTheme(savedTheme);
        dispatch(setPreviewTheme());
    };
    var onThemeChange = function (theme) {
        setSelectedTheme(theme);
        dispatch(setPreviewTheme(theme));
    };
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        React__namespace.default.createElement(lighthouseComponentLibrary.MediaQuery, { minWidth: lighthouseComponentLibrary.getMinBreakpoint("md")({ theme: useTheme() }) },
            React__namespace.default.createElement(DesktopThemePreference, { selectedTheme: selectedTheme, currentTheme: savedTheme, handleSaveClicked: handleSaveClicked, handleDiscardChangesClicked: handleDiscardChangesClicked, onThemeChange: onThemeChange })),
        React__namespace.default.createElement(lighthouseComponentLibrary.MediaQuery, { maxWidth: lighthouseComponentLibrary.getMaxBreakpoint("sm")({ theme: useTheme() }) },
            React__namespace.default.createElement(MobileThemePreference, { selectedTheme: selectedTheme, currentTheme: savedTheme, handleSaveClicked: handleSaveClicked, handleDiscardChangesClicked: handleDiscardChangesClicked, onThemeChange: onThemeChange }))));
};
var templateObject_1$j, templateObject_2$e;

var MobilePreferenceSelector = function (props) {
    var preference = props.match.params.preference;
    var _a = React__namespace.useState(false), isAlertOpen = _a[0], setIsAlertOpen = _a[1];
    var _b = React__namespace.useState(false), isUnsavedChanges = _b[0], setIsUnsavedChanges = _b[1];
    var openAlert = function () {
        setIsAlertOpen(true);
    };
    var proceedWithNavigation = useBlockNavigation(isUnsavedChanges, openAlert);
    var alertCallback = function (allow) {
        if (allow) {
            proceedWithNavigation();
            setIsUnsavedChanges(false);
        }
        setIsAlertOpen(false);
    };
    return (React__namespace.createElement(UserPreferenceUnsavedChangesContext.Provider, { value: { setIsUnsavedChanges: setIsUnsavedChanges, isUnsavedChanges: isUnsavedChanges } },
        React__namespace.createElement(UnsavedChangesAlert, { isOpen: isAlertOpen, callbackOnButtonPress: alertCallback }),
        React__namespace.createElement(lighthouseComponentLibrary.MediaQuery, { minWidth: lighthouseComponentLibrary.getMinBreakpoint("md")({ theme: useTheme() }) },
            React__namespace.createElement(reactRouter.Redirect, { to: routeContext.findRouteByName(RouteIds.Preferences) || "" })),
        getPreferencePage(preference)));
};
var DesktopPreferenceSelector = function (props) {
    return getPreferencePage(props.preference);
};
var getPreferencePage = function (preference) {
    switch (preference) {
        case "locale" /* Locale */:
            return React__namespace.createElement(LocalePreferences, null);
        case "landingPage" /* LandingPage */:
            return React__namespace.createElement(LandingPagePreference, null);
        case "assistantCardsFilter" /* AssistantCardsFilter */:
            return React__namespace.createElement(AssistantCardsFilterPanel, null);
        case "themes" /* Themes */:
            return React__namespace.createElement(ThemePreferences, null);
        default:
            throw new Error("No preference page available for preference: " + preference);
    }
};

var getEmployeeGroupsQuery = "query AssistantEmployeeGroups {\n  AssistantEmployeeGroups {\n    groupId,\n    groupLabel\n  }\n}";

var USER_PREFERENCES_SERVICE_NAME = "user-preferences";
/**
 * Resets the employee groups
 *
 */
function resetEmployeeGroups() {
    var action = {
        type: EmployeeGroupActionTypes.LoadEmployeeGroups,
        employeeGroups: [],
    };
    return action;
}
/**
 * Loads employee groups for the manager
 * @returns {ApplicationThunk}
 */
function loadEmployeeGroups(assistantCardFilters, graphqlServiceFactoryObject) {
    var updatedAssistantCardsFilters = assistantCardFilters;
    return function (dispatch) {
        var actionType = EmployeeGroupActionTypes.LoadEmployeeGroups;
        return graphqlServiceFactoryObject
            .getGraphQlObject(USER_PREFERENCES_SERVICE_NAME)
            .query(getEmployeeGroupsQuery, {})
            .then(function (result) {
            if (result && result.data.AssistantEmployeeGroups !== null) {
                var empGroups_1 = result.data.AssistantEmployeeGroups;
                // dispatch the action to update assistantCards - all the logic here
                empGroups_1.forEach(function (item) {
                    var assistantFilterObject = assistantCardFilters.find(function (assistantCardFilter) {
                        return assistantCardFilter.groupId === item.groupId;
                    });
                    if (!assistantFilterObject) {
                        var newAssistantCardFilter = {
                            groupId: item.groupId,
                            groupLabel: item.groupLabel,
                            groupStatus: true,
                        };
                        updatedAssistantCardsFilters.push(newAssistantCardFilter);
                    }
                });
                updatedAssistantCardsFilters = updatedAssistantCardsFilters.filter(function (cardFilter) {
                    return empGroups_1.some(function (empGroup) { return empGroup.groupId === cardFilter.groupId; });
                });
                var action = {
                    type: actionType,
                    employeeGroups: result.data.AssistantEmployeeGroups,
                };
                dispatch(action);
            }
            else {
                dispatch(resetEmployeeGroups());
            }
            return updatedAssistantCardsFilters;
        })
            .catch(function (error) {
            dispatch(resetEmployeeGroups());
            throw new Error("Error occurred while fetching employee groups" + error);
        });
    };
}

var StyledUserPrefHeaderContainer = lighthouseComponentLibrary.styled.div(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n  flex: 1 0 100%;\n  padding-left: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  box-shadow: 0 ", " 0 0\n    ", ";\n  & h1 {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  [dir=\"rtl\"] & {\n    padding-right: ", ";\n  }\n"], ["\n  flex: 1 0 100%;\n  padding-left: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  box-shadow: 0 ", " 0 0\n    ", ";\n  & h1 {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  [dir=\"rtl\"] & {\n    padding-right: ", ";\n  }\n"])), polished.rem("16px"), polished.rem("12px"), polished.rem("12px"), polished.rem("1px"), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.grey.tone[300]; }, polished.rem("16px"));
var StyledUserPrefHeader = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_2$d || (templateObject_2$d = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.grey.tone[800]; });
var StyledPrefLink = lighthouseComponentLibrary.styled(RouteLink$2)(templateObject_3$b || (templateObject_3$b = __makeTemplateObject(["\n  display: block;\n  text-decoration: none;\n  padding: ", ";\n"], ["\n  display: block;\n  text-decoration: none;\n  padding: ", ";\n"])), polished.rem("16px"));
var StyledUserPrefTabSection = lighthouseComponentLibrary.styled.div(templateObject_4$7 || (templateObject_4$7 = __makeTemplateObject(["\n  flex: 1;\n"], ["\n  flex: 1;\n"])));
var StyledPrefLinkTypography = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_5$6 || (templateObject_5$6 = __makeTemplateObject(["\n  color: ", ";\n  margin: 0;\n"], ["\n  color: ", ";\n  margin: 0;\n"])), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.primary.tone[800]; });
var StyledUserPrefContentSection = lighthouseComponentLibrary.styled.div(templateObject_6$3 || (templateObject_6$3 = __makeTemplateObject(["\n  flex: 6;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  overflow-x: hidden;\n  [dir=\"ltr\"] && {\n    padding-left: ", ";\n  }\n  [dir=\"rtl\"] && {\n    padding-right: ", ";\n  }\n"], ["\n  flex: 6;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  overflow-x: hidden;\n  [dir=\"ltr\"] && {\n    padding-left: ", ";\n  }\n  [dir=\"rtl\"] && {\n    padding-right: ", ";\n  }\n"])), polished.rem("16px"), polished.rem("16px"));
var StyledUserPrefTabs = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Tabs)(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject(["\n  box-shadow: ", " 0 0 0\n    ", ";\n  height: 100%;\n  [dir=\"rtl\"] & {\n    box-shadow: ", " 0 0 0\n      ", ";\n  }\n  @media (min-width: 600px) {\n    && .MuiTab-root {\n      min-width: 0 !important;\n    }\n  }\n  [dir=\"rtl\"] && .MuiTab-root {\n    margin-right: ", ";\n  }\n  && .MuiTab-root {\n    padding-top: ", ";\n    padding-bottom: ", ";\n    min-width: 0px !important;\n    margin-left: ", ";\n    text-transform: unset;\n  }\n  && .MuiTab-root:hover {\n    box-shadow: ", " 0 0 0\n      ", ";\n  }\n  [dir=\"rtl\"] && .MuiTab-root:hover {\n    box-shadow: ", " 0 0 0\n      ", ";\n  }\n  && .MuiTabs-indicator {\n    display: none;\n  }\n  && .MuiTab-textColorInherit {\n    color: ", ";\n    opacity: 1;\n  }\n  && .MuiTab-textColorInherit.Mui-selected {\n    color: ", ";\n    box-shadow: ", " 0 0 0\n      ", ";\n  }\n  [dir=\"rtl\"] && .MuiTab-textColorInherit.Mui-selected {\n    box-shadow: ", " 0 0 0\n      ", ";\n  }\n"], ["\n  box-shadow: ", " 0 0 0\n    ", ";\n  height: 100%;\n  [dir=\"rtl\"] & {\n    box-shadow: ", " 0 0 0\n      ", ";\n  }\n  @media (min-width: 600px) {\n    && .MuiTab-root {\n      min-width: 0 !important;\n    }\n  }\n  [dir=\"rtl\"] && .MuiTab-root {\n    margin-right: ", ";\n  }\n  && .MuiTab-root {\n    padding-top: ", ";\n    padding-bottom: ", ";\n    min-width: 0px !important;\n    margin-left: ", ";\n    text-transform: unset;\n  }\n  && .MuiTab-root:hover {\n    box-shadow: ", " 0 0 0\n      ", ";\n  }\n  [dir=\"rtl\"] && .MuiTab-root:hover {\n    box-shadow: ", " 0 0 0\n      ", ";\n  }\n  && .MuiTabs-indicator {\n    display: none;\n  }\n  && .MuiTab-textColorInherit {\n    color: ", ";\n    opacity: 1;\n  }\n  && .MuiTab-textColorInherit.Mui-selected {\n    color: ", ";\n    box-shadow: ", " 0 0 0\n      ", ";\n  }\n  [dir=\"rtl\"] && .MuiTab-textColorInherit.Mui-selected {\n    box-shadow: ", " 0 0 0\n      ", ";\n  }\n"])), polished.rem("1px"), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.grey.tone[300]; }, polished.rem("-1px"), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.grey.tone[300]; }, polished.rem("4px"), polished.rem("12px"), polished.rem("12px"), polished.rem("4px"), polished.rem("-4px"), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.primary.tone[400]; }, polished.rem("4px"), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.primary.tone[400]; }, function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.primary.tone[800]; }, function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.grey.tone[800]; }, polished.rem("-4px"), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.primary.tone[400]; }, polished.rem("4px"), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.primary.tone[400]; });
var StyledUserPrefTab = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Tab)(templateObject_8$2 || (templateObject_8$2 = __makeTemplateObject(["\n  && span {\n    font-family: ", ";\n    font-weight: ", ";\n    letter-spacing: normal;\n    font-size: ", ";\n    line-height: ", ";\n    text-align: left;\n    display: inline;\n  }\n  [dir=\"rtl\"] && span {\n    text-align: right;\n  }\n"], ["\n  && span {\n    font-family: ", ";\n    font-weight: ",
    ";\n    letter-spacing: normal;\n    font-size: ", ";\n    line-height: ", ";\n    text-align: left;\n    display: inline;\n  }\n  [dir=\"rtl\"] && span {\n    text-align: right;\n  }\n"])), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).type.fontFamily; }, function (props) {
    return lighthouseComponentLibrary.getThemeFromProps(props).type.fontWeights.semiBold;
}, polished.rem("14px"), polished.rem("19px"));
var PreferenceContainer = lighthouseComponentLibrary.styled.div(templateObject_9$2 || (templateObject_9$2 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  overflow: hidden;\n  box-sizing: border-box;\n  height: 100%;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  overflow: hidden;\n  box-sizing: border-box;\n  height: 100%;\n"])));
function UserPreferences() {
    var _a = React.useState("locale" /* Locale */), selectedTab = _a[0], setSelectedTab = _a[1];
    var _b = React__namespace.default.useState(false), isUnsavedChanges = _b[0], setIsUnsavedChanges = _b[1];
    var _c = React__namespace.default.useState(selectedTab), nextSelectedTab = _c[0], setNextSelectedTab = _c[1];
    var _d = React__namespace.default.useState(false), isAlertOpen = _d[0], setIsAlertOpen = _d[1];
    var _e = React__namespace.default.useState(false), navigatedByState = _e[0], setNavigatedByState = _e[1];
    var openAlert = function (byState) {
        if (byState === void 0) { byState = false; }
        setNavigatedByState(byState);
        setIsAlertOpen(true);
    };
    var proceedWithNavigation = useBlockNavigation(isUnsavedChanges, openAlert);
    var featureFlags = useNamedFeatureFlags(exports.FeatureFlagKey.UserPreferenceThemeSelection, exports.FeatureFlagKey.AssistantCardsFilter, exports.FeatureFlagKey.NextGenTimeFormatting);
    var displayAssistantCardFilters = useTypedSelector(function (state) { return state.employeeGroups; });
    var hasPreviewTheme = useTypedSelector(function (state) { return state.themeData.previewTheme; });
    var dispatch = reactRedux.useDispatch();
    var translate = useTranslateFunction();
    var languageAndLocalizationTabLabel = featureFlags[exports.FeatureFlagKey.NextGenTimeFormatting]
        ? translate("USER_PREFERENCES.LANGUAGE_AND_LOCALIZATION")
        : translate("USER_PREFERENCES.LANGUAGE");
    var languageAndLocalizationTabDataQADesktop = featureFlags[exports.FeatureFlagKey.NextGenTimeFormatting]
        ? "language-and-localization-tab-desktop"
        : "language-tab-desktop";
    var languageAndLocalizationTabDataQAMobile = featureFlags[exports.FeatureFlagKey.NextGenTimeFormatting]
        ? "language-and-localization-tab-mobile"
        : "language-tab-mobile";
    var _f = useBackCompatPreference(exports.BackCompatUserPreferenceKey.AssistantCardFilters), savedAssistantFilters = _f[0], setSavedAssistantFilters = _f[1];
    React.useEffect(function () {
        if (featureFlags[exports.FeatureFlagKey.AssistantCardsFilter]) {
            dispatch(loadEmployeeGroups(savedAssistantFilters, graphqlServiceFactory))
                .then(function (updatedAssistantCardsFilters) {
                if (updatedAssistantCardsFilters.length > 0) {
                    setSavedAssistantFilters(updatedAssistantCardsFilters);
                }
            })
                .catch(function (error) {
                global.console.error("Unable to display assistant card filters ", error);
            });
        }
    }, [featureFlags[exports.FeatureFlagKey.AssistantCardsFilter]]);
    var handleTabChange = function (event, newValue) {
        setNextSelectedTab(newValue);
        if (isUnsavedChanges) {
            openAlert(true);
        }
        else {
            setSelectedTab(newValue);
        }
    };
    var alertCallback = function (allow) {
        if (allow) {
            navigatedByState
                ? setSelectedTab(nextSelectedTab)
                : proceedWithNavigation();
            setIsUnsavedChanges(false);
            if (hasPreviewTheme) {
                dispatch(setPreviewTheme());
            }
        }
        setIsAlertOpen(false);
    };
    var theme = useTheme();
    return (React__namespace.default.createElement(UserPreferenceUnsavedChangesContext.Provider, { value: { setIsUnsavedChanges: setIsUnsavedChanges, isUnsavedChanges: isUnsavedChanges } },
        React__namespace.default.createElement(UnsavedChangesAlert, { isOpen: isAlertOpen, callbackOnButtonPress: alertCallback }),
        React__namespace.default.createElement(lighthouseComponentLibrary.MediaQuery, { minWidth: lighthouseComponentLibrary.getMinBreakpoint("md")({ theme: theme }) },
            React__namespace.default.createElement(PreferenceContainer, null,
                React__namespace.default.createElement(StyledUserPrefHeaderContainer, null,
                    React__namespace.default.createElement(StyledUserPrefHeader, { use: "h1" }, translate("MENU_ITEMS.USER_PREFERENCES"))),
                React__namespace.default.createElement(StyledUserPrefTabSection, null,
                    React__namespace.default.createElement(StyledUserPrefTabs, { value: selectedTab, orientation: "vertical", onChange: handleTabChange, selectionFollowsFocus: true },
                        React__namespace.default.createElement(StyledUserPrefTab, { "data-qa": languageAndLocalizationTabDataQADesktop, value: "locale" /* Locale */, label: languageAndLocalizationTabLabel }),
                        React__namespace.default.createElement(StyledUserPrefTab, { value: "landingPage" /* LandingPage */, label: translate("USER_PREFERENCES.LANDING_PAGE") }),
                        featureFlags[exports.FeatureFlagKey.UserPreferenceThemeSelection] && (React__namespace.default.createElement(StyledUserPrefTab, { value: "themes" /* Themes */, label: translate("USER_PREFERENCES.THEMES") })),
                        displayAssistantCardFilters.length > 0 && (React__namespace.default.createElement(StyledUserPrefTab, { value: "assistantCardsFilter" /* AssistantCardsFilter */, label: translate("USER_PREFERENCES.HUB_AND_ASSISTANT_EMPLOYEE_GROUPS") })))),
                React__namespace.default.createElement(StyledUserPrefContentSection, null,
                    React__namespace.default.createElement(DesktopPreferenceSelector, { preference: selectedTab })))),
        React__namespace.default.createElement(lighthouseComponentLibrary.MediaQuery, { maxWidth: lighthouseComponentLibrary.getMaxBreakpoint("sm")({ theme: theme }) },
            React__namespace.default.createElement(StyledUserPrefHeaderContainer, null,
                React__namespace.default.createElement(StyledUserPrefHeader, { use: "h1" }, translate("MENU_ITEMS.USER_PREFERENCES"))),
            React__namespace.default.createElement("div", null,
                React__namespace.default.createElement(StyledPrefLink, { linkTo: RouteIds.SpecificPreference, id: "locale" /* Locale */ },
                    React__namespace.default.createElement(StyledPrefLinkTypography, { use: "h3", "data-qa": languageAndLocalizationTabDataQAMobile }, languageAndLocalizationTabLabel)),
                React__namespace.default.createElement(StyledPrefLink, { linkTo: RouteIds.SpecificPreference, id: "landingPage" /* LandingPage */ },
                    React__namespace.default.createElement(StyledPrefLinkTypography, { use: "h3" }, translate("USER_PREFERENCES.LANDING_PAGE"))),
                featureFlags[exports.FeatureFlagKey.UserPreferenceThemeSelection] && (React__namespace.default.createElement(StyledPrefLink, { linkTo: RouteIds.SpecificPreference, id: "themes" /* Themes */ },
                    React__namespace.default.createElement(StyledPrefLinkTypography, { use: "h3" }, translate("USER_PREFERENCES.THEMES")))),
                displayAssistantCardFilters.length > 0 && (React__namespace.default.createElement(StyledPrefLink, { linkTo: RouteIds.SpecificPreference, id: "assistantCardsFilter" /* AssistantCardsFilter */ },
                    React__namespace.default.createElement(StyledPrefLinkTypography, { use: "h3" }, translate("USER_PREFERENCES.HUB_AND_ASSISTANT_EMPLOYEE_GROUPS"))))))));
}
var templateObject_1$i, templateObject_2$d, templateObject_3$b, templateObject_4$7, templateObject_5$6, templateObject_6$3, templateObject_7$2, templateObject_8$2, templateObject_9$2;

var mapStateToProps$2 = function (state) {
    return {
        navigationItems: state.navigationItems,
    };
};
var mapDispatchToProps$1 = function (dispatch) {
    return {
        redirect: function (route) { return dispatch(connectedReactRouter.push(route)); },
    };
};
var redirect = function (redirectMethod, route) {
    window.setTimeout(function () { return redirectMethod(route); }, 0);
};
/**
 * Detects if the given navigation item is valid to redirect to.
 * Returns false if navigationItem is null or if it is supposed to be
 * hidden in mobile and we happen to be on a mobile resolution.
 * @param navigationItem
 * @param isMobile
 */
function isValidLandingPage(navigationItem, isMobile) {
    return !!navigationItem && !(navigationItem.hideInMobile && isMobile);
}
/**
 * Component responsible for determining the first page to display to the user.
 */
var HomeComponent = function (props) {
    var routeContext = React.useContext(RouteContext);
    var _a = useBackCompatPreference(exports.BackCompatUserPreferenceKey.LandingPage), landingPage = _a[0], setLandingPage = _a[1];
    var theme = useTheme();
    var isMobile = MediaQuery.useMediaQuery({
        query: "(max-width: " + lighthouseComponentLibrary.getMaxBreakpoint("sm")({ theme: theme }) + ")",
    });
    var authStatus = useAuthenticationManagerStatus();
    var redirectBackRoute = useTypedSelector(selectRedirectBackRoute);
    var dispatch = reactRedux.useDispatch();
    React.useEffect(function () {
        var _a;
        tsEnumUtil.$enum.visitValue(authStatus).with((_a = {},
            _a[AuthenticationStatus.Initializing] = function () {
                return;
            },
            _a[AuthenticationStatus.LoggingOut] = function () {
                return;
            },
            _a[AuthenticationStatus.NotAuthenticated] = function () {
                var query = "";
                if (window.cordova && hasSkipAccountSelection()) {
                    query = "?" + SKIP_ACCOUNT_SELECTION_QUERY_PARAM + "=true";
                }
                console.log("[Auth] Home: NotAuthenticated, redirecting to Login" + query);
                clearSkipAccountSelection();
                redirect(props.redirect, RouteIds.Login + query);
            },
            _a[AuthenticationStatus.MockAuthenticated] = function () {
                redirect(props.redirect, routeContext.getPrivateRoutes()[0].route);
            },
            _a[AuthenticationStatus.Authenticated] = function () { return __awaiter(void 0, void 0, void 0, function () {
                var landingPageRoute, navigationItem, targetRoute, persistor, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (landingPage) {
                                navigationItem = props.navigationItems[landingPage];
                                // navigationItem could be undefined here...but we need to define the cases when
                                // this happens
                                if (isValidLandingPage(navigationItem, isMobile)) {
                                    if (navigationItem.route) {
                                        landingPageRoute = navigationItem.route;
                                    }
                                    else if (navigationItem.externalPage &&
                                        navigationItem.externalPage.sourceUrlKey &&
                                        navigationItem.externalPage.relativePageUrl) {
                                        // Use similar logic to getLink from MainView.tsx to compute the URL to navigate to.
                                        landingPageRoute = routeContext.findRouteByName(RouteIds.ExternalPage, encodeURIComponent(getExternalUrlForNavigationAndUserItems(navigationItem)));
                                    }
                                    else {
                                        console.error("Unhandled custom landing page:", navigationItem);
                                    }
                                }
                                else if (!navigationItem) {
                                    console.warn("Couldn't find navigation data for: " + landingPage + ".\n                    User may have lost permission to view this link.");
                                    getPersistedThemePreference();
                                    setLandingPage(undefined);
                                }
                            }
                            targetRoute = redirectBackRoute ||
                                landingPageRoute ||
                                routeContext.getPrivateRoutes()[0].route;
                            if (!(redirectBackRoute !== undefined)) return [3 /*break*/, 4];
                            dispatch(clearRedirectBackRoute());
                            persistor = getPersistor();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, persistor.flush()];
                        case 2:
                            _a.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            e_1 = _a.sent();
                            console.warn("Error flushing persistor before redirect:", e_1);
                            return [3 /*break*/, 4];
                        case 4:
                            redirect(props.redirect, targetRoute);
                            return [2 /*return*/];
                    }
                });
            }); },
            _a));
    }, [authStatus]);
    return null;
};
var Home = reactRedux.connect(mapStateToProps$2, mapDispatchToProps$1)(HomeComponent);

var DEEPLINK_HANDLER_ROUTE = "/launch";

var CHANNELS_NAV_LINK_KEY = "LINK/CHANNELS";
var EXPERIENCE_NAV_LINK_KEY = "LINK/WFX_APP";
/**
 * Get Base URL of the Bare WFX deployment by the navigation-item key.
 * @param navLinkKey Key of Navigation-Item that should be used to get the base url
 * @returns Base URL of the deployed Bare Experience app.
 */
var getExperienceBaseUrl = function (navLinkKey) {
    var _a;
    var navigationItems = useTypedSelector(function (state) { return state.navigationItems; });
    var navLinkUrl = (_a = navigationItems[navLinkKey]) === null || _a === void 0 ? void 0 : _a.url;
    if (!navLinkUrl)
        return undefined;
    var linkParts = navLinkUrl === null || navLinkUrl === void 0 ? void 0 : navLinkUrl.split("/");
    if (linkParts.length < 3)
        return undefined;
    return "https://" + linkParts[2];
};
/**
 * Forwards a deeplink to the Experience app on an external page.
 * @param props DeeplinkHandlerProps
 */
var ExperienceDeeplinkHandler = function (props) {
    var decodedDeeplinkSubRouteWithoutQuery = props.decodedDeeplinkSubRouteWithoutQuery, query = props.query;
    var featureFlags = useNamedFeatureFlags.apply(void 0, Object.values(exports.WfxFeatureFlagKey));
    if (!isAnyWfxFeatureFlagEnabled(featureFlags))
        return React__namespace.default.createElement(reactRouterDom.Redirect, { to: "/" });
    var experienceBaseUrl = process.env.REACT_APP_WFX_BARE_BASE_URL;
    if (!experienceBaseUrl) {
        experienceBaseUrl = getExperienceBaseUrl(CHANNELS_NAV_LINK_KEY);
    }
    if (!experienceBaseUrl) {
        experienceBaseUrl = getExperienceBaseUrl(EXPERIENCE_NAV_LINK_KEY);
        if (!experienceBaseUrl)
            return React__namespace.default.createElement(reactRouterDom.Redirect, { to: "/" });
    }
    var encodedFrameBaseUrl = encodeURIComponent("" + experienceBaseUrl + DEEPLINK_HANDLER_ROUTE + "/bare");
    var encodedDeeplinkPathWithoutQuery = encodeURIComponent(decodedDeeplinkSubRouteWithoutQuery);
    var encodedDeeplinkUrlWithoutQuery = "" + encodedFrameBaseUrl + encodedDeeplinkPathWithoutQuery;
    var urlInfo = {
        encodedDeeplinkUrlWithoutQuery: encodedDeeplinkUrlWithoutQuery,
        query: query,
    };
    return (React__namespace.default.createElement(reactRouterDom.Redirect, { to: {
            pathname: "/externalPage/" + encodedDeeplinkUrlWithoutQuery,
            state: {
                urlInfo: urlInfo,
            },
        } }));
};

/**
 * The hardcoded list of supported link names and the Navigation Item IDs they map to
 * (see NavigationSkeleton).
 */
var SUPPORTED_NAV_LINKS = {
    "/schedule_wfs": "LINK/SCHEDULE_WFS",
    "/schedule_templates": "LINK/SCHEDULE_TEMPLATES",
    "/associate_management": "LINK/ASSOCIATE_MANAGEMENT",
    "/system_administration": "LINK/SYSTEM_ADMINISTRATION",
};
/**
 * Nav Item deeplink handler makes it possible to redirect users to deep, highly-customized URLs
 * within the Suite app, like iframe-embedded subpage that requires account ID & user ID in the
 * embedded URL (it would be impossible to display link to such a subpage in an external system as
 * they can't know our internal user IDs).
 *
 * Instead of taking the URL, it takes the name of the link which maps to navigation item ID
 * (see NavigationSkeleton). Then the link is resolved to a full Suite URL and user is redirected.
 *
 * Example:
 * - http://app-us8.wfs.cloud/#/launch/navlink/schedule_wfs will redirect user to something like
 *   http://app-us8.wfs.cloud/#/externalPage/https%3A%2F%2Fscheduling-us8.wfs.cloud%2Fauth%2Faccount%2Fteam_engage_one%2Fuser%2Fb3d6721f-48be-41a7-9994-4dad662c64f3%2Fredirect%2Fscheduling%2Frouter%2F
 */
var NavItemDeeplinkHandler = function (_a) {
    var decodedDeeplinkSubRouteWithoutQuery = _a.decodedDeeplinkSubRouteWithoutQuery;
    var _b, _c;
    var routeContext = React.useContext(RouteContext);
    var availableNavigationItems = useTypedSelector(function (state) { return state.navigationItems; });
    var navigationItem = React.useMemo(function () {
        var desiredNavlinkId = SUPPORTED_NAV_LINKS[decodedDeeplinkSubRouteWithoutQuery];
        if (!desiredNavlinkId) {
            return null;
        }
        return availableNavigationItems[desiredNavlinkId];
    }, [decodedDeeplinkSubRouteWithoutQuery, availableNavigationItems]);
    if (navigationItem === null || navigationItem === void 0 ? void 0 : navigationItem.route) {
        return React__namespace.default.createElement(reactRouterDom.Redirect, { to: navigationItem.route });
    }
    else if (((_b = navigationItem === null || navigationItem === void 0 ? void 0 : navigationItem.externalPage) === null || _b === void 0 ? void 0 : _b.sourceUrlKey) && ((_c = navigationItem === null || navigationItem === void 0 ? void 0 : navigationItem.externalPage) === null || _c === void 0 ? void 0 : _c.relativePageUrl)) {
        var route = routeContext.findRouteByName(RouteIds.ExternalPage, encodeURIComponent(getExternalUrlForNavigationAndUserItems(navigationItem)));
        if (route) {
            return React__namespace.default.createElement(reactRouterDom.Redirect, { to: route });
        }
    }
    // Fallback
    console.warn("Unable to determine route for sub-route: '" + decodedDeeplinkSubRouteWithoutQuery + "'", navigationItem);
    return React__namespace.default.createElement(reactRouterDom.Redirect, { to: "/" });
};

/**
 * Identifiers for applications that can be rendered on externalPages within
 * iFrames.
 */
var AppIdentifiers;
(function (AppIdentifiers) {
    AppIdentifiers["Experience"] = "experience";
    AppIdentifiers["NavigationItemLink"] = "navlink";
})(AppIdentifiers || (AppIdentifiers = {}));

/**
 * Map of AppIdentifier <-> DeeplinkHandler Component.
 * This Map can be used to load the appropriate DeeplinkHandler component
 * based on the Application identifier.
 * For e.g.: 'experience' app identifier is handled by ExperienceDeeplinkHandler.
 *
 * This map should be updated when deeplinking support needs to be added for any app.
 */
var AppIdentifierDeeplinkHandlerMap = new Map([
    [AppIdentifiers.Experience, ExperienceDeeplinkHandler],
    [AppIdentifiers.NavigationItemLink, NavItemDeeplinkHandler],
]);

/**
 * Handles Deeplinks.
 * Loads the appropriate Deeplink Handler component based on the
 * application identifier which in turn should redirect the user
 * to the externalPage route and load the appropriate iFrame.
 * @param props DeeplinksHandlerProps
 * @returns Component that handles the deeplink based on the Application Identifier
 */
var DeeplinksHandler = function (props) {
    var location = props.location;
    var query = location.search;
    var deeplinkPath = location.pathname.replace(DEEPLINK_HANDLER_ROUTE + "/", "");
    if (!deeplinkPath) {
        return React__namespace.default.createElement(reactRouterDom.Redirect, { to: "/" });
    }
    // Decode the deeplinkPath if it was encoded
    if (deeplinkPath.indexOf("/") === -1) {
        deeplinkPath = decodeURIComponent(deeplinkPath);
    }
    var urlParts = deeplinkPath.split("/", 1);
    if (!urlParts || urlParts.length < 1)
        return React__namespace.default.createElement(reactRouterDom.Redirect, { to: "/" });
    var appIdentifier = urlParts[0];
    var deeplinkSubRoute = deeplinkPath.replace(appIdentifier, "");
    var Component = AppIdentifierDeeplinkHandlerMap.get(appIdentifier);
    if (!Component)
        return React__namespace.default.createElement(reactRouterDom.Redirect, { to: "/" });
    return (React__namespace.default.createElement(Component, { decodedDeeplinkSubRouteWithoutQuery: deeplinkSubRoute, query: query }));
};

/**
 * This component is a proof of concept for simulating user activity
 * within an iframe and relaying that activity to the Suite parent window
 * via postMessage.
 * TODO: Remove this component once we have a real external activity source.
 */
var POCChildIframe = function () {
    var history = reactRouterDom.useHistory();
    React.useEffect(function () {
        if (!window.parent || window.parent === window) {
            return;
        }
        window.addEventListener("click", function () { return suiteIframeActivityRelay.relayUserActivityToSuite(); });
        window.addEventListener("keydown", function () { return suiteIframeActivityRelay.relayUserActivityToSuite(); });
        return function () {
            window.removeEventListener("click", function () { return suiteIframeActivityRelay.relayUserActivityToSuite(); });
            window.removeEventListener("keydown", function () { return suiteIframeActivityRelay.relayUserActivityToSuite(); });
        };
    }, []);
    var handleNavigate = function () {
        var currentUrl = window.location.href;
        var encodedUrl = encodeURIComponent(currentUrl);
        history.push("/externalPage/" + encodedUrl);
    };
    return (React__namespace.default.createElement("div", null,
        React__namespace.default.createElement(lighthouseComponentLibrary.Button, { onClick: handleNavigate }, "Embed this page in the Suite"),
        React__namespace.default.createElement("form", { style: { marginTop: 24 }, onSubmit: function (e) {
                e.preventDefault();
            } },
            React__namespace.default.createElement("div", { style: { marginBottom: 8 } },
                React__namespace.default.createElement("label", { htmlFor: "essay-textarea" },
                    React__namespace.default.createElement("b", null, "Write an essay about the Industrial Revolution."))),
            React__namespace.default.createElement("div", { style: { marginBottom: 8 } },
                React__namespace.default.createElement("textarea", { id: "essay-textarea", rows: 6, style: { width: "100%" } })),
            React__namespace.default.createElement(lighthouseComponentLibrary.Button, null, "Submit"))));
};

var loginToWtaAndRedirect = function (baseWtaUrl, accessToken) {
    console.log("Logging into WTA and redirecting...");
    var tokenLoginUrl = baseWtaUrl + "TokenLogon.do";
    // Create a form element
    var form = document.createElement("form");
    form.method = "POST";
    form.action = tokenLoginUrl;
    form.style.display = "none";
    // Add the token as a hidden input
    var tokenInput = document.createElement("input");
    tokenInput.type = "hidden";
    tokenInput.name = "AccessToken";
    tokenInput.value = accessToken;
    form.appendChild(tokenInput);
    // Append form to body and submit
    document.body.appendChild(form);
    form.submit();
};
var WtaTokenLogin = function () {
    var accountId = reactRouterDom.useParams().accountId;
    var location = reactRouterDom.useLocation();
    var dispatch = reactRedux.useDispatch();
    var authManager = AuthenticationManager.getInstance();
    var authStatus = useAuthenticationManagerStatus();
    var triggerWtaTokenLogin = function () {
        return authManager
            .getAccessToken()
            .then(function (token) {
            var accountInfo = authManager.getAccountInfo();
            if (accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.accountData) {
                var accountData = accountInfo.accountData;
                var wtaUrl = getWTABaseUrl(accountData);
                loginToWtaAndRedirect(wtaUrl, token);
            }
            else {
                // This is an unlikely error state and should never happen
                // But we can handle it anyways just to be safe
                console.error("No account info found after authentication");
                dispatch(connectedReactRouter.push("/"));
            }
        })
            .catch(function () {
            console.error("Failed to get access token for WTA login");
            dispatch(connectedReactRouter.push("/"));
        });
    };
    var authenticateUserAndReturn = function () {
        authManager.login({
            organizationId: accountId,
            skipInitialize: true,
            redirectBackRoute: location.pathname,
        });
    };
    React.useEffect(function () {
        if (authStatus === AuthenticationStatus.Initializing) ;
        else if (authStatus === AuthenticationStatus.Authenticated) {
            triggerWtaTokenLogin();
            return;
        }
        else if (authStatus === AuthenticationStatus.NotAuthenticated) {
            authenticateUserAndReturn();
            return;
        }
        else {
            // Redirect to home since there's no other sensible action here.
            dispatch(connectedReactRouter.push("/"));
            return;
        }
    }, [authStatus]);
    return null;
};

/**
 * Handles a Suite-only logout flow that clears AIM session and Suite tokens,
 * then redirects back to the WTA token login route to restart the AIM login flow.
 *
 * This component performs a "minimal" logout that only clears:
 * - AIM session (osm_logout)
 * - Suite localStorage tokens
 * - Suite session state
 *
 * It explicitly SKIPS:
 * - WTA/T&A logout (Logoff.do)
 * - Demand Scheduling logout
 * - WFX/Experience logout
 *
 * After logout completes (NotAuthenticated), redirects to /login/wta/:accountId
 * which triggers WtaTokenLogin to restart the AIM login flow.
 *
 * Route: /logout/wta  (no params required)
 */
var WtaAimLogout = function () {
    var authStatus = useAuthenticationManagerStatus();
    var dispatch = reactRedux.useDispatch();
    var organizationIdRef = React.useRef(undefined);
    React.useEffect(function () {
        var _a;
        if (authStatus === AuthenticationStatus.Authenticated) {
            var authManager = AuthenticationManager.getInstance();
            // Capture organizationId before logout clears account info.
            organizationIdRef.current = (_a = authManager.getAccountInfo()) === null || _a === void 0 ? void 0 : _a.organizationId;
            authManager.logout(LogoutPresets.AIM_AND_SUITE_ONLY);
        }
        else if (authStatus === AuthenticationStatus.NotAuthenticated) {
            // Use ref captured during Authenticated, or fall back to localStorage for
            // the case where Authenticated was never reached (e.g. logout triggered
            // directly by the manager on the logout route).
            var organizationId = organizationIdRef.current ||
                window.localStorage.getItem(ORGANIZATION_ID_LOCAL_STORAGE_KEY) ||
                undefined;
            if (organizationId) {
                var loginRoute = WTA_TOKEN_LOGIN_ROUTE.replace(":accountId", organizationId);
                dispatch(connectedReactRouter.push(loginRoute));
            }
        }
    }, [authStatus]);
    return null;
};

var AutoLoginPanel = /** @class */ (function (_super) {
    __extends(AutoLoginPanel, _super);
    function AutoLoginPanel(props) {
        return _super.call(this, props) || this;
    }
    AutoLoginPanel.prototype.render = function () {
        var _this = this;
        return (React__namespace.createElement(lighthouseComponentLibrary.Grid, null, this.props.users.map(function (userInfo, index) {
            var credentials = userInfo.credentials;
            return (React__namespace.createElement(StyledButton$1, { type: "text", key: index, "data-qa": "auto-login-button", onClick: _this.signIn(credentials.account, credentials.username, credentials.password) },
                React__namespace.createElement(StyledAvatar, { src: getUserAvatar("" + userInfo.firstName + userInfo.lastName) }),
                React__namespace.createElement(StyledTypography$1, { use: "body", colour: "white" }, userInfo.firstName + " " + userInfo.lastName)));
        })));
    };
    AutoLoginPanel.prototype.signIn = function (account, username, password) {
        var _this = this;
        return function () {
            _this.props.signIn(account, username, password);
        };
    };
    return AutoLoginPanel;
}(React__namespace.Component));
var StyledButton$1 = styled__default.default(lighthouseComponentLibrary.Button)(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n  grid-column: span 2;\n\n  & .button__text {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n"], ["\n  grid-column: span 2;\n\n  & .button__text {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n"])));
var StyledAvatar = styled__default.default(lighthouseComponentLibrary.Avatar)(templateObject_2$c || (templateObject_2$c = __makeTemplateObject(["\n  &&&& {\n    margin-right: 0;\n  }\n"], ["\n  &&&& {\n    margin-right: 0;\n  }\n"])));
var StyledTypography$1 = styled__default.default(lighthouseComponentLibrary.Typography)(templateObject_3$a || (templateObject_3$a = __makeTemplateObject(["\n  text-transform: none;\n"], ["\n  text-transform: none;\n"])));
var templateObject_1$h, templateObject_2$c, templateObject_3$a;

var signInFunction = function (organization, username, password) {
    var dispatch = getStore().dispatch;
    return dispatch(signIn(organization, username, password))
        .then(function () { return dispatch(changeUsername(username)); })
        .then(function () { return dispatch(loadDataBasedOnUser({ username: username, organization: organization })); })
        .then(function () { return dispatch(connectedReactRouter.push(routeContext.getPrivateRoutes()[0].route)); }, function () { return dispatch(showLoginError()); });
};
var mapStateToProps$1 = function () {
    return {
        users: loadAllUserData(),
    };
};
function loadAllUserData() {
    return usersList
        .filter(function (user) { return user.allowAutoLogin; })
        .map(function (user) { return ({
        firstName: user.firstName,
        lastName: user.lastName,
        credentials: {
            username: user.username,
            password: user.password,
            account: user.organization,
        },
    }); });
}
var mapDispatchToProps = function (dispatch) {
    return {
        signIn: signInFunction,
    };
};
var AutoLogin = reactRedux.connect(mapStateToProps$1, mapDispatchToProps)(AutoLoginPanel);

var workforce_the_worker = "data:image/svg+xml,%3Csvg%20width%3D%22128%22%20height%3D%22128%22%20viewBox%3D%220%200%20128%20128%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url%28%23clip0_15_15919%29%22%3E%3Cpath%20d%3D%22M96.5454%2014.4172C96.9056%2014.7775%2097.3267%2015.0629%2097.8085%2015.2734C98.2903%2015.4839%2098.8055%2015.589%2099.3551%2015.589C99.9044%2015.589%20100.42%2015.4835%20100.902%2015.2734C101.383%2015.0629%20101.804%2014.7775%20102.165%2014.4172C102.525%2014.0569%20102.811%2013.6358%20103.021%2013.154C103.232%2012.6722%20103.337%2012.157%20103.337%2011.6074C103.337%2011.0581%20103.231%2010.5422%20103.021%2010.0608C102.811%209.57935%20102.525%209.1583%20102.165%208.79761C101.805%208.43733%20101.384%208.15192%20100.902%207.94139C100.42%207.73086%2099.9044%207.62579%2099.3551%207.62579C98.8055%207.62579%2098.2903%207.73125%2097.8085%207.94139C97.3267%208.15192%2096.9056%208.43733%2096.5454%208.79761C96.1851%209.1579%2095.8993%209.57896%2095.6891%2010.0608C95.4786%2010.5426%2095.3735%2011.0581%2095.3735%2011.6074C95.3735%2012.157%2095.4786%2012.6722%2095.6891%2013.154C95.8993%2013.6358%2096.1847%2014.0569%2096.5454%2014.4172ZM96.3364%2010.3336C96.5077%209.93415%2096.7414%209.58641%2097.0374%209.29002C97.3334%208.99403%2097.6815%208.76037%2098.081%208.58905C98.4805%208.41772%2098.9051%208.33226%2099.3547%208.33226C99.8044%208.33226%20100.229%208.41772%20100.629%208.58905C101.028%208.76037%20101.376%208.99403%20101.672%209.29002C101.968%209.58641%20102.202%209.93415%20102.373%2010.3336C102.544%2010.7335%20102.63%2011.1577%20102.63%2011.6074C102.63%2012.0571%20102.544%2012.4817%20102.373%2012.8812C102.202%2013.2806%20101.968%2013.6288%20101.672%2013.9248C101.376%2014.2208%20101.028%2014.4544%20100.629%2014.6257C100.229%2014.7971%2099.8044%2014.8825%2099.3547%2014.8825C98.9051%2014.8825%2098.4805%2014.7971%2098.081%2014.6257C97.6815%2014.4544%2097.3334%2014.2208%2097.0374%2013.9248C96.7414%2013.6288%2096.5077%2013.281%2096.3364%2012.8812C96.1651%2012.4817%2096.0796%2012.0571%2096.0796%2011.6074C96.0796%2011.1581%2096.1651%2010.7335%2096.3364%2010.3336Z%22%20fill%3D%22%23D0271D%22%2F%3E%3Cpath%20d%3D%22M98.6595%2011.9923H99.2695L100.404%2013.8546H101.282L100.105%2011.9281C100.415%2011.8924%20100.673%2011.7748%20100.878%2011.5748C101.083%2011.3753%20101.186%2011.0754%20101.186%2010.6759C101.186%2010.2336%20101.056%209.89452%20100.795%209.6589C100.534%209.42328%20100.13%209.30566%2099.58%209.30566H97.8245V13.8546H98.6595V11.9923ZM98.6595%2010.0121H99.2695C99.3981%2010.0121%2099.5263%2010.0157%2099.6549%2010.0227C99.7835%2010.0298%2099.8992%2010.0549%20100.003%2010.0976C100.106%2010.1403%20100.19%2010.2046%20100.254%2010.2901C100.319%2010.3756%20100.351%2010.4936%20100.351%2010.6433C100.351%2010.7931%20100.319%2010.9107%20100.254%2010.9966C100.19%2011.082%20100.106%2011.1463%20100.003%2011.189C99.8992%2011.2318%2099.7831%2011.2584%2099.6549%2011.2694C99.5263%2011.28%2099.3981%2011.2855%2099.2695%2011.2855H98.6595V10.0121Z%22%20fill%3D%22%23D0271D%22%2F%3E%3Cpath%20d%3D%22M65.4841%2084.2404C86.8713%2084.2404%20104.271%2066.8406%20104.271%2045.4534C104.271%2024.0662%2086.8713%206.6665%2065.4841%206.6665C44.0969%206.6665%2026.6968%2024.0662%2026.6968%2045.4534C26.6968%2066.8406%2044.0969%2084.2404%2065.4841%2084.2404ZM65.4841%2024.5884C76.989%2024.5884%2086.3495%2033.9485%2086.3495%2045.4534C86.3495%2056.9588%2076.9894%2066.3188%2065.4841%2066.3188C53.9788%2066.3188%2044.6183%2056.9588%2044.6183%2045.4534C44.6183%2033.9481%2053.9788%2024.5884%2065.4841%2024.5884Z%22%20fill%3D%22%23D0271D%22%2F%3E%3Cpath%20d%3D%22M65.7643%2086.7783C43.0634%2086.7783%2023.7164%20100.847%2016.5835%20121.667H36.2422C42.1836%20109.42%2053.1887%20104.7%2065.7643%20104.7C78.3411%20104.7%2089.3458%20109.42%2095.2876%20121.667H114.946C107.814%20100.847%2088.4668%2086.7783%2065.7643%2086.7783Z%22%20fill%3D%22%23D0271D%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_15_15919%22%3E%3Crect%20width%3D%22115%22%20height%3D%22115%22%20fill%3D%22white%22%20transform%3D%22translate%287%206.6665%29%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";

var Logo = lighthouseComponentLibrary.styled.img(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n  @media (max-width: ", ") {\n    max-height: ", ";\n    max-width: ", ";\n  }\n  max-height: ", ";\n  max-width: ", ";\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n  align-self: flex-end;\n  margin: ", " 0;\n"], ["\n  @media (max-width: ", ") {\n    max-height: ", ";\n    max-width: ", ";\n  }\n  max-height: ", ";\n  max-width: ", ";\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n  align-self: flex-end;\n  margin: ", " 0;\n"])), lighthouseComponentLibrary.getMaxBreakpoint("default"), polished.rem("68px"), polished.rem("58px"), polished.rem("123px"), polished.rem("105px"), polished.rem("32px"));
var LogoContainer = lighthouseComponentLibrary.styled.div(templateObject_2$b || (templateObject_2$b = __makeTemplateObject(["\n  display: flex;\n  flex: 1;\n  align-self: center;\n"], ["\n  display: flex;\n  flex: 1;\n  align-self: center;\n"])));
/**
 * Organization Panel Logo component
 * @param props -- props for the logo
 */
var OrganizationPanelLogo = function (props) {
    return (React__namespace.createElement(LogoContainer, null,
        React__namespace.createElement(Logo, { alt: "Company Logo", src: props.logo ? props.logo : workforce_the_worker })));
};
var templateObject_1$g, templateObject_2$b;

var sorry = "data:image/svg+xml,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20viewBox%3D%220%200%20248.97%2092.8%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%238e9899%3B%7D.cls-2%7Bfill%3Aurl%28%23linear-gradient%29%3B%7D%3C%2Fstyle%3E%3ClinearGradient%20id%3D%22linear-gradient%22%20x1%3D%22-172.13%22%20y1%3D%22440.1%22%20x2%3D%22-171.13%22%20y2%3D%22440.1%22%20gradientTransform%3D%22matrix%2860.06%2C%200%2C%200%2C%20-60.06%2C%2010400.37%2C%2026483.09%29%22%20gradientUnits%3D%22userSpaceOnUse%22%3E%3Cstop%20offset%3D%220%22%20stop-color%3D%22%23129bd7%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%2353c0a2%22%2F%3E%3C%2FlinearGradient%3E%3C%2Fdefs%3E%3Cg%20id%3D%22Group_146%22%20data-name%3D%22Group%20146%22%3E%3Cpath%20id%3D%22Path_17%22%20data-name%3D%22Path%2017%22%20class%3D%22cls-1%22%20d%3D%22M132.58%2C23.5h11.7v6.85a14.68%2C14.68%2C0%2C0%2C1%2C5.05-6.15%2C12.19%2C12.19%2C0%2C0%2C1%2C6.9-2.1%2C12.78%2C12.78%2C0%2C0%2C1%2C5.55%2C1.4l-4.25%2C11.76a9.28%2C9.28%2C0%2C0%2C0-4-1.21q-3.15%2C0-5.32%2C3.9t-2.18%2C15.31l.05%2C2.65v22H132.57V23.51Z%22%20transform%3D%22translate%28-5.41%20-3.18%29%22%2F%3E%3Cpath%20id%3D%22Path_18%22%20data-name%3D%22Path%2018%22%20class%3D%22cls-1%22%20d%3D%22M171.72%2C23.5h11.7v6.85a14.68%2C14.68%2C0%2C0%2C1%2C5.05-6.15%2C12.19%2C12.19%2C0%2C0%2C1%2C6.9-2.1%2C12.78%2C12.78%2C0%2C0%2C1%2C5.55%2C1.4l-4.26%2C11.76a9.2%2C9.2%2C0%2C0%2C0-3.95-1.21q-3.15%2C0-5.33%2C3.9t-2.17%2C15.31l0%2C2.65v22H171.71V23.51Z%22%20transform%3D%22translate%28-5.41%20-3.18%29%22%2F%3E%3Cg%20id%3D%22Group_144%22%20data-name%3D%22Group%20144%22%3E%3Cpath%20id%3D%22Path_19%22%20data-name%3D%22Path%2019%22%20class%3D%22cls-1%22%20d%3D%22M217.61%2C85.68q3.9%2C0%2C5.61-2.06a9.76%2C9.76%2C0%2C0%2C0%2C2-5.46L209.67%2C22.75h14.84l8.23%2C38.32H233l7.21-38.32h14.21L241%2C74.45a104.4%2C104.4%2C0%2C0%2C1-3.55%2C11.18%2C19.37%2C19.37%2C0%2C0%2C1-4%2C6.59%2C11.18%2C11.18%2C0%2C0%2C1-5.56%2C3%2C39.42%2C39.42%2C0%2C0%2C1-8.19.72H213.9V85.37A21.86%2C21.86%2C0%2C0%2C0%2C217.61%2C85.68Z%22%20transform%3D%22translate%28-5.41%20-3.18%29%22%2F%3E%3C%2Fg%3E%3Cg%20id%3D%22Group_145%22%20data-name%3D%22Group%20145%22%3E%3Cpath%20id%3D%22Path_20%22%20data-name%3D%22Path%2020%22%20class%3D%22cls-1%22%20d%3D%22M20.24%2C57.36A23.68%2C23.68%2C0%2C0%2C0%2C20.65%2C62a8.23%2C8.23%2C0%2C0%2C0%2C1.54%2C3.56%2C7.55%2C7.55%2C0%2C0%2C0%2C3%2C2.26%2C12.07%2C12.07%2C0%2C0%2C0%2C4.79.83%2C9.49%2C9.49%2C0%2C0%2C0%2C6.13-2.22q2.73-2.2%2C2.73-6.85a12.39%2C12.39%2C0%2C0%2C0-.67-4.27A8.32%2C8.32%2C0%2C0%2C0%2C36%2C52.11a16%2C16%2C0%2C0%2C0-4.06-2.63%2C60.33%2C60.33%2C0%2C0%2C0-6.23-2.42%2C53%2C53%2C0%2C0%2C1-8.55-3.6%2C23.24%2C23.24%2C0%2C0%2C1-6-4.58A16.36%2C16.36%2C0%2C0%2C1%2C7.57%2C32.8a25.41%2C25.41%2C0%2C0%2C1-1.13-8q0-10.92%2C6.07-16.27T29.2%2C3.18a36.8%2C36.8%2C0%2C0%2C1%2C9.11%2C1.08%2C19.21%2C19.21%2C0%2C0%2C1%2C7.21%2C3.5%2C16.59%2C16.59%2C0%2C0%2C1%2C4.74%2C6.18A21.81%2C21.81%2C0%2C0%2C1%2C52%2C23V25H37.75c0-3.51-.62-6.2-1.86-8.09S32.6%2C14.1%2C29.71%2C14.1a10.18%2C10.18%2C0%2C0%2C0-4.12.72A6.89%2C6.89%2C0%2C0%2C0%2C23%2C16.73a6.38%2C6.38%2C0%2C0%2C0-1.34%2C2.72%2C13.78%2C13.78%2C0%2C0%2C0-.36%2C3.2%2C10.65%2C10.65%2C0%2C0%2C0%2C1.44%2C5.72q1.42%2C2.31%2C6.18%2C4.27l11.43%2C4.94a35.15%2C35.15%2C0%2C0%2C1%2C6.9%2C3.87%2C18.82%2C18.82%2C0%2C0%2C1%2C4.27%2C4.32%2C14.26%2C14.26%2C0%2C0%2C1%2C2.22%2C5.1%2C28.49%2C28.49%2C0%2C0%2C1%2C.62%2C6.18q0%2C11.64-6.75%2C16.94t-18.8%2C5.3q-12.55%2C0-18-5.46T5.41%2C58.18v-3H20.24Z%22%20transform%3D%22translate%28-5.41%20-3.18%29%22%2F%3E%3C%2Fg%3E%3C%2Fg%3E%3Cpath%20id%3D%22Union_1%22%20data-name%3D%22Union%201%22%20class%3D%22cls-2%22%20d%3D%22M62.92%2C50.54a30%2C30%2C0%2C1%2C1%2C30%2C30A30.07%2C30.07%2C0%2C0%2C1%2C62.92%2C50.54Zm6%2C0a24%2C24%2C0%2C1%2C0%2C24-24A24%2C24%2C0%2C0%2C0%2C69%2C50.54Zm31.87%2C10.68c-8.09-5.78-15.57-.12-15.64-.07a2.77%2C2.77%2C0%2C0%2C1-3.9-.5h0a2.78%2C2.78%2C0%2C0%2C1%2C.49-3.9h0a18.86%2C18.86%2C0%2C0%2C1%2C22.27-.06%2C2.78%2C2.78%2C0%2C0%2C1-3.23%2C4.53Zm-.55-15.63a3.47%2C3.47%2C0%2C0%2C1%2C3.47-3.47h0a3.47%2C3.47%2C0%2C1%2C1-3.47%2C3.47Zm-21.57%2C0a3.47%2C3.47%2C0%2C1%2C1%2C3.46%2C3.47%2C3.46%2C3.46%2C0%2C0%2C1-3.46-3.47Z%22%20transform%3D%22translate%28-5.41%20-3.18%29%22%2F%3E%3C%2Fsvg%3E";

var ErrorPageDiv = lighthouseComponentLibrary.styled.div(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n  && {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: ", ";\n    @media (max-width: ", ") {\n      height: 100%;\n      width: 100%;\n      transform: none;\n      top: 0;\n      left: 0;\n    }\n  }\n"], ["\n  && {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: ",
    ";\n    @media (max-width: ", ") {\n      height: 100%;\n      width: 100%;\n      transform: none;\n      top: 0;\n      left: 0;\n    }\n  }\n"])), function (props) {
    return lighthouseComponentLibrary.getThemeFromProps(props).backgrounds.hubBackground;
}, lighthouseComponentLibrary.getBreakpoint("sm"));
var ContentDiv = lighthouseComponentLibrary.styled.div(templateObject_2$a || (templateObject_2$a = __makeTemplateObject(["\n  padding: ", " ", ";\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n"], ["\n  padding: ", " ", ";\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n"])), polished.rem("32px"), polished.rem("64px"));
var SorryImage = lighthouseComponentLibrary.styled.img(templateObject_3$9 || (templateObject_3$9 = __makeTemplateObject(["\n  max-width: ", ";\n  @media (max-width: ", ") {\n    max-width: ", ";\n  }\n"], ["\n  max-width: ", ";\n  @media (max-width: ", ") {\n    max-width: ", ";\n  }\n"])), polished.rem("192px"), lighthouseComponentLibrary.getBreakpoint("sm"), polished.rem("128px"));
var ErrorMessages = lighthouseComponentLibrary.styled.div(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject(["\n  max-height: ", ";\n  overflow-y: auto;\n"], ["\n  max-height: ", ";\n  overflow-y: auto;\n"])), polished.rem("256px"));
var StyledH2Typography = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_5$5 || (templateObject_5$5 = __makeTemplateObject(["\n  line-height: ", ";\n  margin: 0;\n"], ["\n  line-height: ", ";\n  margin: 0;\n"])), polished.rem("24px"));
var StyledH3Typography = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject(["\n  line-height: ", ";\n"], ["\n  line-height: ", ";\n"])), polished.rem("16px"));
var Toolbar = lighthouseComponentLibrary.styled.div(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n  padding: ", " 0 0;\n  display: flex;\n  justify-content: flex-end;\n"], ["\n  padding: ", " 0 0;\n  display: flex;\n  justify-content: flex-end;\n"])), polished.rem("16px"));
var StyledLink = lighthouseComponentLibrary.styled(reactRouterDom.Link)(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["\n  text-decoration: none;\n"], ["\n  text-decoration: none;\n"])));
var StyledButton = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Button)(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject(["\n  && {\n    position: relative;\n    right: ", ";\n    [dir=\"rtl\"] & {\n      right: ", ";\n    }\n    @media (max-width: ", ") {\n      position: fixed;\n      bottom: ", ";\n      right: ", ";\n      [dir=\"rtl\"] & {\n        right: initial;\n        left: ", ";\n      }\n    }\n  }\n"], ["\n  && {\n    position: relative;\n    right: ", ";\n    [dir=\"rtl\"] & {\n      right: ", ";\n    }\n    @media (max-width: ", ") {\n      position: fixed;\n      bottom: ", ";\n      right: ", ";\n      [dir=\"rtl\"] & {\n        right: initial;\n        left: ", ";\n      }\n    }\n  }\n"])), polished.rem("-32px"), polished.rem("32px"), lighthouseComponentLibrary.getBreakpoint("sm"), polished.rem("32px"), polished.rem("32px"), polished.rem("32px"));
var ErrorPage = function (props) {
    var translate = useTranslateFunction();
    var toolbarContents = props.showTakeHomeButton ? (React__namespace.createElement(Toolbar, null,
        React__namespace.createElement(StyledLink, { to: "/" },
            React__namespace.createElement(StyledButton, { text: translate("ERROR_PAGE.TAKE_ME_HOME") })))) : ("");
    return (React__namespace.createElement(ErrorPageDiv, null,
        React__namespace.createElement(ContentDiv, null,
            React__namespace.createElement(SorryImage, { src: sorry, alt: translate("ERROR_PAGE.SORRY") }),
            React__namespace.createElement(ErrorMessages, null, props.children),
            toolbarContents)));
};
var templateObject_1$f, templateObject_2$a, templateObject_3$9, templateObject_4$6, templateObject_5$5, templateObject_6$2, templateObject_7$1, templateObject_8$1, templateObject_9$1;

var ProceedButton$1 = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Button)(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n  && {\n    color: #324fa5;\n    border: none;\n    height: ", ";\n    margin: ", " !important;\n    :hover {\n      background-color: #e8effa;\n      color: #20337d;\n    }\n    & svg {\n      width: ", ";\n      height: ", ";\n      padding: 0px;\n    }\n  }\n"], ["\n  && {\n    color: #324fa5;\n    border: none;\n    height: ", ";\n    margin: ", " !important;\n    :hover {\n      background-color: #e8effa;\n      color: #20337d;\n    }\n    & svg {\n      width: ", ";\n      height: ", ";\n      padding: 0px;\n    }\n  }\n"])), polished.rem("40px"), polished.rem("0px"), polished.rem("12px"), polished.rem("11px"));
var LocaleButton = function (props) {
    return (React__namespace.default.createElement(ProceedButton$1, { text: props.currentLocale, iconLeft: freeSolidSvgIcons.faGlobe, type: "text", className: "button-text", onClick: props.onClick }));
};
var templateObject_1$e;

/**
 * Function that returns the currently selected language
 * if it is supported in the App
 * or English if an unsupported language is selected
 *
 * @return A currentLocale that is either the currently selected language or English
 */
var useCurrentLocale = function () {
    var storedLocale = localizationFramework.useLocaleId();
    // Currently, in the Suite, we support only Spanish(MEX) translations,
    // but in WT&A, we have configurations for Spanish(US) and Spanish(MEX), which lead to the same language.
    // Therefore, we need to map both configurations to the Spanish(MEX).
    if (storedLocale === Locales.SpanishUS) {
        storedLocale = Locales.SpanishMX;
    }
    var currentLocale = defaultLocales.find(function (locale) { return locale.code === storedLocale; });
    return currentLocale === undefined ? englishUSLocale : currentLocale;
};

var TopDiv = lighthouseComponentLibrary.styled.div(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n  && {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    text-align: center;\n  }\n"], ["\n  && {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    text-align: center;\n  }\n"])));
var InnerDiv = lighthouseComponentLibrary.styled.div(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n  && {\n    height: ", ";\n    display: block;\n    text-align: center;\n    width: ", ";\n    @media (max-width: ", ") {\n      width: ", ";\n    }\n    @media (max-width: ", ") {\n      width: ", ";\n    }\n    @media (max-width: ", ") {\n      width: ", ";\n    }\n  }\n"], ["\n  && {\n    height: ", ";\n    display: block;\n    text-align: center;\n    width: ", ";\n    @media (max-width: ", ") {\n      width: ", ";\n    }\n    @media (max-width: ", ") {\n      width: ", ";\n    }\n    @media (max-width: ", ") {\n      width: ", ";\n    }\n  }\n"])), polished.rem("622px"), polished.rem("638px"), lighthouseComponentLibrary.getMaxBreakpoint("sm"), polished.rem("319px"), lighthouseComponentLibrary.getMaxBreakpoint("md"), polished.rem("638px"), lighthouseComponentLibrary.getMaxBreakpoint("lg"), polished.rem("638px"));
var StyledList = lighthouseComponentLibrary.styled(List$2)(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject(["\n  && {\n    component='nav';\n    display: flex;\n  }\n"], ["\n  && {\n    component='nav';\n    display: flex;\n  }\n"])));
var LocaleList = function (props) {
    var _a = React.useState(localizationFramework.useLocaleId()), setLocale = _a[1];
    var allLocales = defaultLocales || [];
    var dispatch = reactRedux.useDispatch();
    // The number of the locales in the first column of the list
    var numFirstColumnLocales = Math.ceil(allLocales.length / 2);
    // split the locales into 2 sections
    var localeList1 = [];
    var localeList2 = [];
    if (allLocales.length <= numFirstColumnLocales) {
        localeList1 = allLocales;
    }
    else {
        localeList1 = allLocales.slice(0, numFirstColumnLocales);
        localeList2 = allLocales.slice(numFirstColumnLocales, allLocales.length);
    }
    var createLocalesLinks = function (localeList) {
        // The currently selected language in the App
        var currentLocale = useCurrentLocale();
        // Filter out TEST_MODE_LOCALE before mapping
        var filteredLocales = localeList.filter(function (locale) { return locale.code !== TEST_MODE_LOCALE; });
        return filteredLocales.map(function (locale) { return (React__namespace.createElement("span", { key: locale.code },
            React__namespace.createElement(ListItem$1, { button: true, onClick: handleOnClick(locale), "data-qa": "localeList-" + locale.code, selected: locale.code === currentLocale.code, autoFocus: locale.code === currentLocale.code }, locale.label))); });
    };
    var handleLocaleClick = function (localeCode) {
        var locale = localeCode;
        dispatch(deleteCachedTranslations());
        dispatch(changeLocaleSelectedFlag(true));
        dispatch(changeAppLocale(locale));
        dispatch(hideAlert());
    };
    var handleOnClick = function (locale) {
        return function () {
            setLocale(locale.code);
            handleLocaleClick(locale.code);
            props.close();
        };
    };
    return (React__namespace.createElement(TopDiv, { "data-qa": "localeList" },
        React__namespace.createElement(InnerDiv, null,
            React__namespace.createElement(StyledList, null,
                React__namespace.createElement(Grid$1, { container: true, spacing: 0 },
                    React__namespace.createElement(Grid$1, { item: true, xs: 12, sm: 6 }, createLocalesLinks(localeList1)),
                    React__namespace.createElement(Grid$1, { item: true, xs: 12, sm: 6 }, createLocalesLinks(localeList2)))))));
};
var templateObject_1$d, templateObject_2$9, templateObject_3$8;

var StyledDialogTitle = lighthouseComponentLibrary.styled(DialogTitle$1)(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n"])), polished.rem("0px"));
var StyledDialogContent = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.DialogContent)(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n  gap: ", ";\n  padding-top: ", " !important;\n  padding-bottom: ", " !important;\n"], ["\n  gap: ", ";\n  padding-top: ", " !important;\n  padding-bottom: ", " !important;\n"])), polished.rem("0px"), polished.rem("0px"), polished.rem("0px"));
var StyledResponsiveDialog = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.ResponsiveDialog)(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject(["\n  & .MuiDialog-paperWidthSm {\n    max-width: ", ";\n    max-height: ", ";\n  }\n  & .MuiDialogContent-root {\n    overflow: inherit;\n  }\n"], ["\n  & .MuiDialog-paperWidthSm {\n    max-width: ", ";\n    max-height: ", ";\n  }\n  & .MuiDialogContent-root {\n    overflow: inherit;\n  }\n"])), polished.rem("638px"), polished.rem("676px"));
var StyledTypography = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject(["\n  margin: ", ";\n  flex: 1;\n"], ["\n  margin: ", ";\n  flex: 1;\n"])), polished.rem("0px"));
var IconContainer = lighthouseComponentLibrary.styled.div(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject(["    \n    display: flex;\n    align-items: center; \n    color: ", ";\n}"], ["    \n    display: flex;\n    align-items: center; \n    color: ", ";\n}"])), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.grey.tone[800]; });
var LocaleDialog = function (props) {
    var translate = useTranslateFunction();
    return (React__namespace.default.createElement(StyledResponsiveDialog, { open: props.isOpen, onClose: function () { return props.close(); } },
        React__namespace.default.createElement(StyledDialogTitle, { disableTypography: true },
            React__namespace.default.createElement(StyledTypography, { use: "h3" }, translate("ORGANIZATION_PANEL.SELECT_LANGUAGE")),
            React__namespace.default.createElement(lighthouseComponentLibrary.IconButton, { size: "small", onClick: function () { return props.close(); } },
                React__namespace.default.createElement(IconContainer, null,
                    React__namespace.default.createElement(lighthouseComponentLibrary.Icon, { fontSize: "extraSmall", icon: "close" })))),
        React__namespace.default.createElement(StyledDialogContent, null,
            React__namespace.default.createElement(LocaleList, { close: function () { return props.close(); } }))));
};
var templateObject_1$c, templateObject_2$8, templateObject_3$7, templateObject_4$5, templateObject_5$4;

var LocaleSelectionPanel = function () {
    var _a = React__namespace.default.useState(false), isDialogOpen = _a[0], setDialogOpen = _a[1];
    var currentLocale = useCurrentLocale();
    /**
     * Closes the Locale Dialog.
     */
    function closeLocaleDialog() {
        setDialogOpen(false);
    }
    return (React__namespace.default.createElement("div", null,
        React__namespace.default.createElement(LocaleButton, { onClick: function () {
                setDialogOpen(true);
            }, currentLocale: currentLocale.label }),
        React__namespace.default.createElement(LocaleDialog, { isOpen: isDialogOpen, close: closeLocaleDialog })));
};

/**
 * Extract the original route from which user has been redirected to the login screen, from
 * the given location state.
 *
 * @param history - History management object
 * @return The original route. i.e. `/scheduling` or null if not present.
 */
function getOriginalRouteFromHistory(history) {
    var _a, _b, _c, _d;
    var redirectedFromPathname = (_b = (_a = history.location.state) === null || _a === void 0 ? void 0 : _a.from) === null || _b === void 0 ? void 0 : _b.pathname;
    var redirectedFromSearch = (_d = (_c = history.location.state) === null || _c === void 0 ? void 0 : _c.from) === null || _d === void 0 ? void 0 : _d.search;
    if (redirectedFromPathname || redirectedFromSearch) {
        return (redirectedFromPathname || "") + (redirectedFromSearch || "");
    }
    return null;
}
/**
 * Once we redirect user back to the route they originally wanted, we need to clear the history
 * state. Otherwise, they may be unintentionally redirected again i.e. when they sign out and sign
 * in again, as the state will persist until the browser is closed.
 *
 * This function removes original route from history state.
 *
 * @param history - History management object
 */
function removeOriginalRouteFromHistoryState(history) {
    var historyState = history.location.state;
    if ((historyState === null || historyState === void 0 ? void 0 : historyState.from) !== undefined) {
        delete historyState.from;
        history.replace(__assign(__assign({}, history.location), { state: historyState }));
    }
}
/**
 * Extract the original route from which user has been redirected to the login screen and remove
 * it from history state.
 *
 * @param history - History management object
 * @return The original route. i.e. `/scheduling` or undefined if not present. Undefined is returned
 *         rather than null for convenience, so the return value of this function can be given
 *         as an optional argument (i.e. AuthenticationManager.login)
 */
function popOriginalRouteFromHistory(history) {
    var value = getOriginalRouteFromHistory(history);
    removeOriginalRouteFromHistoryState(history);
    return value === null ? undefined : value;
}

var CROSS_TAB_REFRESH = "CROSS_TAB_REFRESH";
var CROSS_TAB_LOGOUT = "CROSS_TAB_LOGOUT";
var LOGOUT_ALERT_INFO = "SESSION_INACTIVITY.LOGOUT_ALERT";

// Styled container for the alert with consistent spacing
var AlertContainer = styled__default.default.div(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  padding-bottom: ", ";\n"], ["\n  padding-bottom: ", ";\n"])), polished.rem("16px"));
/**
 * Displays an informational logout alert when the user's session is expired due to inactivity.
 *
 * @component
 * @example
 * ```tsx
 * <LogoutAlert isEnabled={true} />
 * ```
 *
 * @param {LogoutAlertProps} props - The props for the component.
 * @param {boolean} props.isEnabled - Flag to conditionally render the alert.
 * @returns {JSX.Element} The rendered LogoutAlert component.
 */
var LogoutAlert = function (_a) {
    var isEnabled = _a.isEnabled;
    var translate = useTranslateFunction();
    if (!isEnabled)
        return null;
    return (React__namespace.default.createElement(AlertContainer, null,
        React__namespace.default.createElement(lighthouseComponentLibrary.Alert, { severity: "info" }, translate(LOGOUT_ALERT_INFO))));
};
var templateObject_1$b;

var adpGraphic = "data:image/svg+xml,%3Csvg%20width%3D%22300%22%20height%3D%22280%22%20viewBox%3D%220%200%20300%20280%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%3Crect%20width%3D%22300%22%20height%3D%22280%22%20fill%3D%22url%28%23pattern0_96_8087%29%22%2F%3E%3Cdefs%3E%3Cpattern%20id%3D%22pattern0_96_8087%22%20patternContentUnits%3D%22objectBoundingBox%22%20width%3D%221%22%20height%3D%221%22%3E%3Cuse%20xlink%3Ahref%3D%22%23image0_96_8087%22%20transform%3D%22scale%280.00166667%200.00178571%29%22%2F%3E%3C%2Fpattern%3E%3Cimage%20id%3D%22image0_96_8087%22%20width%3D%22600%22%20height%3D%22560%22%20preserveAspectRatio%3D%22none%22%20xlink%3Ahref%3D%22data%3Aimage%2Fpng%3Bbase64%2CiVBORw0KGgoAAAANSUhEUgAAAlgAAAIwCAYAAABawRXrAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAACWKADAAQAAAABAAACMAAAAAAG3r4UAABAAElEQVR4Ae3dCbQdVZ3v8f%2Fe52a8CQYCoswBkoCRIffcMAhowHZicOqmFWne6l5PUIZGFBQSSEISRqe22%2B7G19r93utB%2B6k9qbTaT0XFIQgIyFJJAtot6nottigZiEnurferAJLhnnt3nVPnnNq1v2etI7mn%2FrXr%2F%2F%2Fsg%2Fyzq26VM14IIIBACQJZlh2kYb6m9wF6byphSIZAAAEEohUYiDZzEkcAgaoJLFNChz6d1KyqJUc%2BCCCAQC8FXC8PxrEQQKCeAlq9eokqu0Nv%2Fj%2BlnlNMVQggUFDAF4wnHAEEEBhLYIU%2BpLkaS4bPEEAgSQEarCSnnaIRKE9Aq1d%2FoNFOL29ERkIAAQTiF%2BBvnPHPIRUg0DcBNVd76%2BAP6H1w35LgwAgggEAFBVjBquCkkBICEQm8U7nSXEU0YaSKAAK9EWAFqzfOHAWB2glo9WqBirpH76m1K46CEEAAgQ4FWMHqEJDdEUhYYKVqp7lK%2BAtA6Qgg0FqAFazWNmxBAIEWAlq9erk2fb7F5rE%2B%2Fn%2F6ML%2F5KPfeG0uHzxBAoHYCNFi1m1IKQqC7AmqupugId%2Bq9KPBI%2F%2Bace4X2m6b4yYH7EIYAAggggAACCKQjoEbpHXqHvrYr8KR0dKgUAQQQQAABBBAoKKBm6SC9HwvtrhR3S8FDEI4AAggggAACCKQloIbpTwo0Vz9R7L5pCVEtAggggAACCCBQQEDN0hkFmqs89JICwxOKAAIIIIAAAgikJ6CG6UsFGqyvKpbbwKT3NaFiBBBAAAEEEAgVULN0QYHmKg89NXRs4hBAAAEEEEAAgeQE1CzN1Pu7edcU%2BPqb5JAoGAEEEEAAAQQQKCKgpmp1YGOVhz2u9xFFxicWAQQQQAABBBBISkDN0ly9n9Q79LU0KSCKRQABBBBAAAEEigqoq%2Frr0M5Kcev15tmERZGJRwABBBBAAIF0BNQsnVOgucpDz0tHh0oRQAABBBBAAIGCAmqWvN535V1T4OszBQ9BOAIIIIAAAgggkJaAmqq3BTZWedhWvUMf%2FJwWJNUigAACCCCAAAK5gJqlA%2FT%2BT71DXx9ADgEEEEAAAQQQQGAcAXVVHwrtrBT3H3rvN85wbEIAAQQQQAABBNIWULM0pPeo3qEvnjeY9leG6hFAAAEEEEBgIgF1VZ8P7awU95WJxmM7AggggAACCCCQtIAapnMLNFd56CuTBqN4BBBAAAEEEEBgPAE1S3vp%2Fb28awp8fXS88diGAAIIIIAAAggkL6CmakVgY5WHbdR7QfJoACCAAAIIIIAAAq0E1CwdpfcTeoe%2Blrcai88RQAABBBBAAAEEJKCuqsjzBtcqfhA4BBBAAAEEEEAAgRYCapbODl22ejruv7UYio8RQAABBBBAAAEEcgE1TfcWaLA%2BjRoCCCCAAAIIIIDAOAJqrC4q0FzloUPjDMcmBBBAAAEEEEAgbQE1S8%2FX%2B8d51xT4%2BmDaYlSPAAIIIIAAAghMIKCm6r2BjVUe9v%2F0PmiCIdmMAAIIIIAAAgikK6BmaWHeNRV4XZyuFpUjgAACCCCAAAIBAmqs%2FrFAc%2FVgwJCEIIAAAggggAAC6Qqosfq9As1VHnpOulpUjgACCCCAAAIITCCgZmmK3jxvcAInNiOAAAIIIIAAAsECaq6u0zv0tUGBRwcPTiACCCCAAAIIIJCagJqleXr%2FKrS7UtyNqRlRLwIIIIAAAgggUEhADdPHCjRX%2BWnEmYUOQDACCCCAAAIIIJCSgJqlxQWaqzz0%2FJR8qBUBBBBAAAEEECgsoIbpywUarM8XPgA7IIAAAggggAACKQmosXpLgeYqD31RSj7UigACCCCAAAIIFBJQs7Sv3v%2BRd02Br48UOgDBCCCAAAIIIIBAagJqqt4X2FjlYY%2FpfXBqRtSLAAIIIIAAAggEC6hZauq9Re%2FQ11XBgxOIAAIIIIAAAgikKKCu6l9COyvF3a33QIpO1IwAAggggAACCAQJqFn6nQLNVR762qCBCUIAAQQQQAABBFIUULM0Ve91edcU%2BPq7FJ2oGQEEEEAAAQQQCBZQU3VlYGOVh23T%2B6jgwQlEAAEEEEAAAQRSE1CzdITej%2Bsd%2BlqdmhH1IoAAAggggAAChQTUVX0ktLNS3CN6zy50AIIRQAABBBBAAIGUBNQsnVagucpDL0jJh1oRQACBXgu4Xh%2BQ4yGAQPkCapi%2BqFHPCBz5G865UwJjCUMgMoGhY725s5T0psgSJ92aCXDvm5pNKOWkJ6Dm6q2qOrS5yoGWp6dExYkI%2BIazj2RmixKplzIrLOArnBupIYDABAJqrmYpZMkEYTtvvk2rV%2FlqFy8EaifgbejyzBzNVe1mNs6CWMGKc97IGoFnBK7WHw555ocJ%2FvkLbb9lghg2IxCpQPP55uyaSJMn7RoKsIJVw0mlpDQEtHo1rEqLPEPw3Vq9%2BlEaOlSZmoD3tkw1759a3dRbXQEucq%2Fu3JAZAuMKqMH6ZwW8ZtygZzfeqz%2BeqgZry7Mf8ScE6iLQPNU7%2B7KqadSlIuqIX4AVrPjnkAoSFFBzlT8%2FMLS5yoWuo7lK8IuSSMnOZStUKs1VIvMdS5k0WLHMFHki8LSAmqv839si15p8Rs3V5wBEoI4CDRu%2BwJn7rTrWRk1xC9BgxT1%2FZJ%2BmwDtV9omBpeenBJcGxhKGQGQCx8%2FKXHZDZEmTbiICNFiJTDRl1kNAq1cHqpK8wQp95bdleDA0mDgEYhLwfuAK5Rv6W7QxlUauNRDgIvcaTCIlpCOgButDqvYtgRU%2Fqrhj1WD9MjCeMAQiEhh%2BoXfZ3Up4akRJk2pCAqxgJTTZlBq3gJqrl6iCCwtUcQPNVQEtQqMS8D7Lb7BLcxXVrKWVLCtYac031UYsoAbrDqW%2FOLCEL6u5Oj0wljAEohIYsObLR519PqqkSTY5AVawkptyCo5RQM3V7yvvxQVy58LfAliExiTQnKQL2%2FPbMvBCoNICPCqn0tNDcgiYqbnaRw6rClh8WKtXPG%2BwABih8Qh4c5dlZi%2BKJ2MyTVWAFaxUZ566YxLIf2vw4MCE8wvaWb0KxCIsNoH8eYNZ%2FvxNXghUXoAGq%2FJTRIIpC2j16gWqP%2F9V9NDXrVq9%2BlFoMHEIxCSg5w3mF7bzvMGYJi3hXLnIPeHJp%2FTqC6jB%2BriyPDcw0%2FsU9yI1WPnNRXkhUDOBodO8c1%2BtWVGUU2MBVrBqPLmUFreAmqtXqoLQ5iov9iaaq7jnnOxbCzjnubC9NQ9bKihAg1XBSSElBNRcTZHC6gIS%2F6rm6pMF4glFIBqBhjXf5Cx7aTQJkygCEqDB4muAQDUFLlVaw4GpbVNckWYscFjCEKiCwMnTMmdc2F6FqSCHQgI0WIW4CEag%2BwJavTpIR8kv5g19vV%2BrV2tCg4lDICYB77fm%2Fy4cG1PO5IpALsBF7nwPEKiYgBqsDyqlywLT%2BqnijleD9VhgPGEIRCRwwhzvRh5QwjMjSppUEdghwAoWXwQEKiSg5uoMpRPaXOWZ588bpLmq0BySSnkC3o9cr9ForsojZaQeCrCC1UNsDoXARAJqsPI7sOdNVsjrqwparAZLN7bmhUC9BBo2fKYeiXN7vaqimpQEWMFKabaptdICaq4uUIKhzVVey1Kaq0pPKcm1L%2BB0x3Zuy9C%2BH3tWQIAGqwKTQAoIqLnaSwpFLmz%2FWzVXX0cOgToKeGterGXZE%2BpYGzWlI0CDlc5cU2m1BfLnDR4dmOKvFLcyMJYwBCITWHiAfv2K1avIZo109xSgwdrThE8Q6KmAVq%2Fm6YBXFTjoe7R69XCBeEIRiEbAe5%2Ff8%2Bq50SRMogi0EOAi9xYwfIxArwTUYP21jpVffxXyyhurY9Rg8bzBEC1iIhNoDnln9yhp%2FtsU2cyR7p4CrGDtacInCPRMQM3Vq3Ww0OYqz2s5zVXPpocD9VjAuR2nvmmueuzO4bojwBe5O66MisCEAmqu8n%2F%2FvqV36CNxPqPm6pwJByYAgQgFGjb0%2Bsy5f4gwdVJGYEwBVrDGZOFDBHoicLmOEtpcbVfsqp5kxUEQ6LnAKTPVXK3s%2BWE5IAJdFKDB6iIuQyPQSkCrVwdoW5HbMtym1au7W43H5wjELOBty9uU%2FwtjroHcEdhdgFOEu4vwMwI9EFCD9Rc6zIWBh%2FqR4ppqsH4eGE8YAhEJHD%2FXu0Z%2BYXt%2BLzheCNRGgBWs2kwlhcQioOZqoXINba7ysm6luYpldsmzqIBuy3CN9qG5KgpHfOUFWMGq%2FBSRYN0E1GB9TjW9IrCur6m5Oi0wljAEohJoWPMs%2FarHZ6JKmmQRCBRgBSsQijAEyhBQc%2FUGjRPaXOWHvKmM4zIGApUUcO7aSuZFUgiUIECDVQIiQyAQIqDmaqbiijwC5O%2B1evXZkLGJQSA2Ad2W4aLMspNjy5t8EQgVGAgNJA4BBDoWeLtGCH3e4AbFru74iAyAQCUFmvvq1GB%2B7RUvBGorwApWbaeWwqokoNWrvLEq%2BrzB71WpBnJBoCwB73fcomROWeMxDgJVFOAi9yrOCjnVTkAN1t%2BqqPMDC1unuPy2DBsD4wlDICKBoWO9c%2FcpYf6CH9GskWpxAb7gxc3YA4FCAmquztIOoc1VPvYNNFeFiAmOSMA5n1%2BHyH97IpozUm1PgBWs9tzYC4FgATVY%2BR3YQx%2BJ82k1V%2FkDoHkhUDsBXdj%2BBj0S5%2B9rVxgFITCGAH%2BLGAOFjxAoS0DN1UUaK7S5yg9b5LcMy0qTcRDogcCCyWqulvXgQBwCgUoI0GBVYhpIoo4Caq6ep7qWF6jtg1q9yq9N4YVA7QS8TX2HilpQu8IoCIEWAjRYLWD4GIESBN6pMQ4MHOdnintPYCxhCEQmsOhwc3Z1ZEmTLgIdCdBgdcTHzgiMLaDVqyFtyf%2FGHvpaqdWrR0ODiUMgJgHvR1cp31kx5UyuCHQqwEXunQqyPwJjCKjB%2Bkd9%2FLoxNo310YNqro4dawOfIRC%2FwKIXeTf69fjroAIEigmwglXMi2gEJhRQc3WBgkKbq3w8nsc2oSoBsQo03AjP04x18si7IwEarI742BmBXQXUXE3RJ0t2%2FXTcnz6q1atPjxvBRgQiFdBtGf4gM%2FeSSNMnbQQ6EqDB6oiPnRHYQ%2BBd%2BiT0eYObFMvzBvcg5IN6CJwwW7dl4LYj9ZhMqmhDgAarDTR2QWAsAa1ezdXnV461rcVnf6LVq4dabONjBKIW8H4k%2Fy3aQ6MuguQR6ECAi9w7wGNXBHYWUIP1Uf183s6fjfPn72vbiWqwNowTwyYEIhVoDnln%2BYXtUyMtgLQR6FiAFayOCRkAATM1V%2Fl1JqHNVU6WP2%2BQ5oovTy0FnMuWqjCaq1rOLkWFCrCCFSpFHALjCKjBukObF48TsvOmL6q5%2Bq2dP%2BDPCNRFoGHDv5O57BN1qYc6EGhXgAarXTn2Q%2BBpATVXb9UfbysAcqoaLO4LVACM0FgEmpN0ajB%2F3BOPxIllysizawKcIuwaLQOnIKDmarbqLHJbhr%2BiuUrhm5Fmjd7cZaqc5irN6afq3QRYwdoNhB8RKCKgBuu9ig%2F9zcHHFDukBuvHRY5BLAJxCJwwx7uRu5Vr%2FpcOXggkL8AKVvJfAQDaFVBz1dS%2BlxbY%2F900VwW0CI1KQLdlyO8BR3MV1ayRbDcFWMHqpi5j11pADdanVeDZgUXmf7M%2FRQ3WtsB4whCISKB5qq69ujOihEkVga4LsILVdWIOUEcBNVe%2FrbpCm6uc4Caaqzp%2BE6gpF3DOliGBAAK7CtBg7erBTwhMKKDmKr%2B%2Fz40TBj4b8DE1V%2F%2F87I%2F8CYH6COh5gxfqVMjL61MRlSBQjgANVjmOjJKWQP6bUvMDS96uuFWBsYQhEJnAKTP1vMEiv0UbWX2ki0D7AjRY7duxZ4ICWr06XGVfW6D0W7R6xfMGC4ARGo%2BA91vy5mpOPBmTKQK9E%2BAi995Zc6QaCKjB%2BrDKeHNgKT9Q3AlqsP4rMJ4wBCISWHicd36NEuaROBHNGqn2ToAVrN5Zc6TIBdRc5c8bDG2u8mpX0lxFPumk31LAOX%2BDNtJctRRiQ%2BoCrGCl%2Fg2g%2FiABNVf5vytf0PuMoB3MvqHm6pTAWMIQiEpgwIZeOercZ6NKmmQR6LEAK1g9Budw0Qq8RZmHNld5kcujrZTEERhfwOnC9uvHD2ErAgjQYPEdQGACAa1e7a2QpROE7bz5Nq1efXHnD%2FgzAnUR8NZ8e2Z2Yl3qoQ4EuiVAg9UtWcatk8DVKubgwIJ%2BobibA2MJQyAygYUHmLP83wdeCCAwgQAN1gRAbE5bQKtXiyRwZQGF%2FHmDjxaIJxSBaAS89%2FktSp4bTcIkikAfBbjIvY%2F4HLr6Amqw%2FklZvjYw03sVlz9v8NeB8YQhEJHAjucNflkJNyJKmlQR6JsAK1h9o%2BfAVRdQc%2FUa5RjaXOXlXEdzVfVZJb92BfTdvl770ly1C8h%2ByQnQYCU35RQcIqDmKv93o8gjQG7Xf4A%2BFzI2MQjEJtCw4QucZS%2BNLW%2FyRaCfAjRY%2FdTn2FUWeJeSC%2F1NqS2KLfJbhlWum9wQ2E3gmL0zl63e7UN%2BRACBCQRosCYAYnN6Alq9OkhVv7NA5X%2Bu1avvFIgnFIFoBLxNulzJHhpNwiSKQEUEuMi9IhNBGtURUIN1m7J5a2BGP1LccWqwfhkYTxgCEQksfIGeN5j%2F8gaPxIlo1ki1GgKsYFVjHsiiIgJqrvLnDV5UIJ2baK4KaBEalYD3jfw6RJqrqGaNZKsiwApWVWaCPCohoAbrK0rkxYHJ3KHm6ozAWMIQiEpAzxt8hZ43yC9uRDVrJFslAVawqjQb5NJXATVXv68EQpurPNcb8v%2FhhUD9BJqTMudX1K8uKkKgdwI0WL2z5kgVFlBztY%2FSu75Aih%2FR6tWXCsQTikA0At7cZZllJ0eTMIkiUEEBGqwKTgop9UUg%2F63B0N%2BUelyxq%2FqSJQdFoOsCzeeby%2FLblPBCAIEOBGiwOsBj13oIaPXqKFVyRYFqeN5gASxC4xLwfscNdp8XV9Zki0D1BLjIvXpzQkY9FlCD9XEd8tzAw96vuJN0epDnDQaCERaTwMIX67YM%2BS968EIAgQ4FWMHqEJDd4xZQc3WWKghtrvJi89sy0FzFPe1k30JA3%2B1lLTbxMQIIFBRgBasgGOH1EVBzld%2Ff5069hwOryp83eHZgLGEIRCWg5w2ep0fifDSqpEkWgQoLsIJV4ckhta4LXKIjhDZXWxXL89i6PiUcoD8Ci6equbqmP8fmqAjUU4AGq57zSlUTCGj16mCF5HepDn39kVav7goNJg6BmAS835A%2FrPzYmHImVwSqLsApwqrPEPl1RUAN1p9q4EsDB%2F%2BJ4haqwXosMJ4wBCISWHS4d6MPKOEZESVNqghUXoAVrMpPEQmWLaDm6qUaM7S5yg9%2FA81V2bPAeFUR8H40v2M7zVVVJoQ8aiPAClZtppJCQgXUYH1RsWcExn9VzVX%2BAGheCNROQBe2n6lrr26vXWEUhEAFBFjBqsAkkELvBNRcna%2BjhTZXeWL5tSm8EKingBu9vp6FURUC%2FRcY6H8KZIBAbwTUXM3Uka4tcLSPavXq6wXiCUUgGgFvzUsys0XRJEyiCEQmwApWZBNGuh0J5M9XOzpwhCcUd31gLGEIRCaw8ABztjyypEkXgagEaLCimi6SbVdAq1fzte9VBfbPnze4vkA8oQhEI%2BC9z%2B95tX80CZMoAhEKcJF7hJNGysUF1GD9tfa6IHDPvLE6Vg3WlsB4whCISGDR8botw30RJUyqCEQpwApWlNNG0kUE1Fydo%2FjQ5iof%2BnqaqyLCxMYk4Fy2KqZ8yRWBWAVYwYp15sg7WEAN1j0Kbgbu8Gk1V68OjCUMgagEdFuG39ZtGT4ZVdIki0CkAqxgRTpxpB0moObqCkWGNlfbFbsybGSiEIhN4JSZaq74fsc2beQbrQANVrRTR%2BITCai5OkAxV08Ut9P227R6de9OP%2FNHBGoj4O3Xl6uYBbUpiEIQqLgApwgrPkGk176AGqy%2F0N4XBo6Qn0Z8sRqsJwPjCUMgIoGZ%2Bi3aKd8ya%2BwVUdKkikDUAtxoNOrpI%2FlWAmqujte20OYqH%2BYRvYe13%2FP0T%2F7ikYvwqoPA6M9%2B9l%2B%2FvOyy91w2Ojq618BAow41UQMCUQjwH5IopokkiwqoUcqfr3Zm0f2IRwABBBBAoAwBrsEqQ5ExKiWg5uo8JURzValZIRkEEEAgLQFWsNKa79pXq%2BYqf97gXXqHPhKn9iYUiAACCCDQewFWsHpvzhG7K%2FB2DU9z1V1jRkcAAQQQmECAFawJgNgcj4BWr%2FLGao3e%2FKZUPNNGpggggEAtBVjBquW0JlvUdaqc5irZ6adwBBBAoDoCrGBVZy7IpAMBrV7lF7XnvznICwEEEEAAgb4L0GD1fQpIoAwBNVi6iaItKmMsxkAAAQQQQKBTAU4RdirI%2Fn0XUHO1WknQXPV9JkgAAQQQQOAZAe7k%2FowE%2F4xSQM1V%2Fh2erPc%2F6v243vylQQi80hPQndp%2F9YUvrHnpI4%2F89JipU%2FN%2FJXghgEA%2FBThF2E99jt2xgBqs%2FDusRwi60Y4HYwAEIhZ43euueu4%2F%2FdMnv6G%2FbxyhZw5GXAmpI1APARqseswjVSCAQPICB%2FyV2ew%2FeGoRN0teAwAE%2Bi1Ag9XvGeD4CCCAQMcCC0%2F2bkCrVyzkdkzJAAiUJMD1KiVBMgwCCCDQLwHn%2FE00V%2F3S57gIjC1AgzW2C58igAACUQg0bPi%2F61TE4iiSJUkEEhLgFGFCk02pCCBQN4ETZns3cq%2BqOrRulVEPArELsIIV%2BwySPwIIJCvg%2FchVKp7mKtlvAIVXWYAVrCrPDrkhgAACLQWaQ97Z17V5assQNiCAQN8EWMHqGz0HRgABBNoXcM7yh5vTXLVPyJ4IdFWABqurvAyOAAIIlC%2BgC9t%2FW6cfXlf%2ByIyIAAJlCXCKsCxJxkEAAQR6ItCcpFOD%2BYXtx%2FTkcBwEAQTaEmAFqy02dkIAAQT6I%2BAtu1RHprnqDz9HRSBYgBWsYCoCEUAAgX4LLDzUO5%2BvXs3udyYcHwEExhdgBWt8H7YigAAClRHw3l%2BjZGiuKjMjJIJAawFWsFrbsAUBBBCokEDzVF17dWeFEiIVBBAYR4AVrHFw2IQAAghUReDp2zJUJR3yQACBCQRosCYAYjMCCCDQb4GGDV2k0w2v6HceHB8BBMIFOEUYbkUkAggg0AeBU2Z6t%2BUBHXhOHw7OIRFAoE0BVrDahGM3BBBAoBcC3m9ZquPQXPUCm2MgUKIAK1glYjIUAgggUK7A0LHeuTUac1q54zIaAgh0W4AVrG4LMz4CCCDQpoAubF%2BtXWmu2vRjNwT6KcAKVj%2F1OTYCCCDQQmDAhl456txnW2zmYwQQqLgAK1gVnyDSQwCBJAVc5tyKJCunaARqIkCDVZOJpAwEEKiPgLfmlZnZSfWpiEoQSE%2BAU4TpzTkVI4BApQUWHqDnDd6vFPerdJokhwAC4wqwgjUuDxsRQACB3gp438hvy0Bz1Vt2joZA6QKsYJVOyoAIIIBAuwJDp%2Bm2DHdo70a7I7AfAghUQ4AVrGrMA1kggAAC5pxbKQaaK74LCNRAgAarBpNICQggEL9Aw4Yv0CmF0%2BOvhAoQQCAX4BQh3wMEEECg7wLH7O3d5PuUxqF9T4UEEECgFAFWsEphZBAEEECgfQHvp7xNe9NctU%2FInghUToAVrMpNCQkhgEBaAs2jvLN89WpqWnVTLQL1FmAFq97zS3UIIFBxAe%2FtOqVIc1XxeSI9BIoKsIJVVIx4BBBAoCQBXdj%2Bqsxl%2F1rScAyDAAIVEmAFq0KTQSoIIJCSQHOSfs1oWUoVUysCKQkMpFQstSKAAAJVEfCWXarnDZ5clXzIAwEEyhXgFGG5noyGAAIIBAjseN7gtxW4f0AwIQggEKEApwgjnDRSRgCBuAWeft4gzVXc00j2CIwrwArWuDxsRAABBMoWWPhi7%2FxXyh6V8RBAoFoCrGBVaz7IBgEEai7gnM9vy8ALAQRqLkCDVfMJpjwEEKiOgG7L8EadNnhZdTIiEwQQ6JYApwi7Jcu4CCCAwC4Ci6d6t%2BEufXTsLh%2FzAwII1FKAFaxaTitFIYBA1QS833CtcqK5qtrEkA8CXRJgBatLsAyLAAIIPCvQPELPG7xfP8949jP%2BhAACdRZgBavOs0ttCCBQCQE9bzC%2FYzvNVSVmgyQQ6I0AK1i9ceYoCCCQqIAubD9Tzxu8PdHyKRuBZAVYwUp26ikcAQR6IuCyVT05DgdBAIFKCdBgVWo6SAYBBOok4K15iZ432KxTTdSCAAJhApwiDHMiCgEEECgo0Hy%2BLmy%2FVzs9v%2BCOhCOAQA0EWMGqwSRSAgIIVE9AF7YvUVY0V9WbGjJCoCcCrGD1hJmDIIBAWgILj9PzBvPbMvBCAIFEBVjBSnTiKRsBBLon4FxjdfdGZ2QEEIhBgAYrhlkiRwQQiEagYc1znWXnRJMwiSKAQFcEOEXYFVYGRQCBNAUWzPBu6hrVviDN%2BqkaAQSeEWAF6xkJ%2FokAAgh0KOBt2ts0BM1Vh47sjkAdBFjBqsMsUgMCCFRAYHi%2Bd9m3lMheFUiGFBBAoM8CrGD1eQI4PAII1EPA%2Byy%2FLQPNVT2mkyoQ6FiAFayOCRkAAQRSF%2BB5g6l%2FA6gfgT0FWMHa04RPEEAAgWICLltabAeiEUCg7gI0WHWfYepDAIGuCjRs6CI9b%2FCUrh6EwRFAIDoBThFGN2UkjAAC1RE4YbZ3I3crnznVyYlMEECgCgKsYFVhFsgBAQSiFPB%2BJD81SHMV5eyRNALdFWAFq7u%2BjI4AArUVWHS8d6P3qLxGbUukMAQQaFuAFay26dgRAQRSFnAuW6b6aa5S%2FhJQOwLjCNBgjYPDJgQQQGAsAd2W4Y163uDrx9rGZwgggEAuwClCvgcIIIBAIYHFA95teEC7vKDQbgQjgEBSAqxgJTXdFIsAAp0KeHviXRqD5qpTSPZHoOYCrGDVfIIpDwEEyhQ4YY5uy5Bf2L5PmaMyFgII1E%2BAFaz6zSkVIYBAlwR0W4bVGprmqku%2BDItAnQRYwarTbFILAgh0UaB5one2posHYGgEEKiRACtYNZpMSkEAge4JOGc3dW90RkYAgboJ0GDVbUapBwEEShfQ8wYv1HL%2FGaUPzIAIIFBbAU4R1nZqKQwBBMoR2PG8wW9rrEPKGY9REEAgBQFWsFKYZWpEAIG2BXRh%2B1XameaqbUF2RCBNAVaw0px3qkYAgSCBoaZ37msKnRoUThACCCDwtAArWHwVEEAAgRYCzrn8eYM0Vy18%2BBgBBFoL0GC1tmELAggkLKAL21%2BvJf7XJExA6Qgg0IEApwg7wGNXBBCoq8CCyd5NvVvVHVvXCqkLAQS6K8AKVnd9GR0BBCIU8DblEqVNcxXh3JEyAlURYAWrKjNBHgggUBGB5iG6Y3t%2BW4bZFUmINBBAIEIBVrAinDRSRgCB7gl4b0s0Os1V94gZGYEkBFjBSmKaKRIBBMIEFr7YO%2F%2BVsFiiEEAAgdYCrGC1tmELAggkJuCcvzaxkikXAQS6JECD1SVYhkUAgbgEdFuGi7Sk%2F%2FK4siZbBBCoqgCnCKs6M%2BSFAAI9FFgwQ7dl%2BI4OOKeHB%2BVQCCBQYwFWsGo8uZSGAAJhAt5PvU6RNFdhXEQhgECAACtYAUiEIIBAnQUWHqcL27%2BpCqfVuUpqQwCB3gqwgtVbb46GAAIVE9CF7SuVEs1VxeaFdBCIXYAVrNhnkPwRQKBtgQEbeuWoc59tewB2RAABBFoIsILVAoaPEUCg9gI%2Bc25F7aukQAQQ6IsADVZf2DkoAgj0W8Bb8x2Z2Un9zoPjI4BAPQU4RVjPeaUqBBAYV2DhAbqw%2FX6F7DduGBsRQACBNgVYwWoTjt0QQCBeAe8bS5U9zVW8U0jmCFRegBWsyk8RCSKAQLkCQ6d55%2B7QmI1yx2U0BBBA4FkBVrCeteBPCCCQgIBzbpXKpLlKYK4pEYF%2BCtBg9VOfYyOAQE8F9LzB87Vsv7inB%2BVgCCCQpACnCJOcdopGIEWBY%2Fb2bvK9qnxOitVTMwII9FaAFazeenM0BBDok4D3U96mQ9Nc9cmfwyKQmgArWKnNOPUikKTA8HzvsgdU%2BpQky6doBBDouQArWD0n54AIINBrAe%2BzZTomzVWv4TkeAgkLsIKV8ORTOgIpCDRs%2BMzMZbenUCs1IoBAdQRosKozF2SCAAKlCzQnNZx9lUfilA7LgAggMIEApwgnAGIzAgjEK%2BAtu5TmKt75I3MEYhZgBSvm2SN3BBAYR%2BC4A70byG%2FLsP84QWxCAAEEuiLAClZXWBkUAQT6LeD9QP68QZqrfk8Ex0cgUQFWsBKdeMpGoN4CzVO9szvrXSPVIYBAlQVYwary7JAbAgi0JeCcXdfWjuyEAAIIlCRAg1USJMMggEA1BHRbhvO0NP%2BKamRDFgggkKoApwhTnXnqRqCWAidP827rGpV2bC3LoygEEIhGgBWsaKaKRBFAYCIB77cuUQzN1URQbEcAga4LsILVdWIOgAACvRFoHqEL2%2B%2FXsWb05ngcBQEEEGgtwApWaxu2IIBARALe23KlS3MV0ZyRKgJ1FmAFq86zS20IJCLA8wYTmWjKRCAiAVawIposUkUAgbEF9DDn1WNv4VMEEECgPwI0WP1x56gIIFCSgLfmxRpqqKThGAYBBBAoRYBThKUwMggCCPRHYNHzvBvNnzd4QH%2BOz1ERQACBsQVYwRrbhU8RQCACAe9HrlWaNFcRzBUpIpCaACtYqc049SJQG4HmMbotw3dqUw6FIIBArQRYwarVdFIMAukIOOduTKdaKkUAgdgEaLBimzHyRQABa9jQ7zrLzoECAQQQqKoApwirOjPkhQACLQQWzPBuav68wQUtAvgYAQQQ6LsAK1h9nwISQACBIgLeplyueJqrImjEIoBAzwVYweo5OQdEAIH2BZpH6cL2u7T%2FXu2PwZ4IIIBA9wVYweq%2BMUdAAIGSBLzPlmoomquSPBkGAQS6J8AKVvdsGRkBBEoU0PMGX6VH4vxriUMyFAIIINA1AVawukbLwAggUKqA27F6VeqQDIYAAgh0S4AGq1uyjIsAAqUJ6LYMF2Vmp5Y2IAMhgAACXRbgFGGXgRkeAQQ6FTh5H%2B%2B25s8bPKzTkdgfAQQQ6JUAK1i9kuY4CCDQloD3W%2FPnDR7W1s7shAACCPRJgBWsPsFzWAQQCBEYXuhd9i1FDoREE4MAAghURYAVrKrMBHkggMAeAs7ZdfqQ5moPGT5AAIGqC9BgVX2GyA%2BBRAV0W4bz9LzB1ydaPmUjgEDkApwijHwCSR%2BBegosHvBuw3dU29H1rI%2BqEECg7gKsYNV9hqkPgQgFvG28WmnTXEU4d6SMAAJPCbCCxTcBAQQqJnD8Yd417lFSsyuWGOkggAACwQKsYAVTEYgAAr0Q8H5gtY5Dc9ULbI6BAAJdE2AFq2u0DIwAAsUFmid6Z2uK78ceCCCAQLUEWMGq1nyQDQJJC%2Bi2DDclDUDxCCBQGwEarNpMJYUgELdA%2FrxBLamfEXcVZI8AAgg8JcApQr4JCCBQAYEdzxu8T4kcUoFkSAEBBBDoWIAVrI4JGQABBDoV8H7blRqD5qpTSPZHAIHKCLCCVZmpIBEEUhUYanrnvqbqp6YqQN0IIFA%2FAVaw6jenVIRAVALO%2BRVKmOYqqlkjWQQQmEiABmsiIbYjgEDXBBrWfK2eN3hO1w7AwAgggECfBDhF2Cd4DosAAkdO8e45d8nhOCwQQACBugmwglW3GaUeBCIR8DbrEqVKcxXJfJEmAggUE2AFq5gX0QggUIrAiQd5t%2F0BDbVPKcMxCAIIIFAxAVawKjYhpINACgLeb79WddJcpTDZ1IhAogKsYCU68ZSNQL8EBmx48ajL7ujX8TkuAggg0AsBVrB6ocwxEEDgNwIjLlvymx%2F4AwIIIFBTARqsmk4sZSFQRQE9b%2FBCLZu%2FvIq5kRMCCCBQpgCnCMvUZCwEEBhH4JSZ3m3JL2yfM04QmxBAAIFaCLCCVYtppAgEqi%2Fg%2Fa%2BXKUuaq%2BpPFRkigEAJAqxglYDIEAggMJHA0LF63uAaRU2bKJLtCCCAQB0EWMGqwyxSAwIVF3DOXa8Uaa4qPk%2BkhwAC5QmwglWeJSMhgMAYAgM29MpR5z47xiY%2BQgABBGorwApWbaeWwhCogsC5jcy5FVXIhBwQQACBXgrQYPVSm2MhkJiAt0fekZmdlFjZlIsAAggYpwj5EiCAQJcEFh7gnb9fg%2B%2FXpQMwLAIIIFBZAVawKjs1JIZA3ALeN5aqApqruKeR7BFAoE0BVrDahGM3BBAYT2DoNN2W4cuK4C9x4zGxDQEEaivA%2F%2FnVdmopDIH%2BCTScu1FH5%2F9f%2BjcFHBkBBPoswP8B9nkCODwCdRNoWPNNurD9tLrVRT0IIIBAEQFOERbRIhYBBCYQOGZv7ybfo6DDJwhkMwIIIFBrAVawaj29FIdAbwW8n%2FI2HZHmqrfsHA0BBCoowApWBSeFlBCIU%2BD4ud41HlTuU%2BLMn6wRQACB8gRYwSrPkpEQSFpAt2XI79hOc5X0t4DiEUDgGQFWsJ6R4J8IINC2gC5sPytz9pm2B2BHBBBAoGYCrGDVbEIpB4HeCywe0DMhlvX%2BuBwRAQQQqK4ADVZ154bMEIhCwNuGS3VbhhOjSJYkEUAAgR4JcIqwR9AcBoF6Chx3oHcD96q2%2FetZH1UhgAAC7QmwgtWeG3shgIAEvB%2B4Vv%2BgueLbgAACCOwmwArWbiD8iAACoQLNU72zO0OjiUMAAQRSEmAFK6XZplYEShRwLlta4nAMhQACCNRKgAarVtNJMQj0RqBhw2905l7Vm6NxFAQQQCA%2BAU4RxjdnZIxAnwWa03VqcI2SOKbPiXB4BBBAoLICrGBVdmpIDIFqCnhvS5QZzVU1p4esEECgIgKsYFVkIkgDgTgEho70zt2nXGfEkS9ZIoAAAv0RYAWrP%2B4cFYEoBbx3%2BR3baa6inD2SRgCBXgqwgtVLbY6FQMQCurD9zMxlt0dcAqkjgAACPRNgBatn1BwIgbgF1FzdEHcFZI8AAgj0ToAGq3fWHAmBaAW8NS9W8gujLYDEEUAAgR4LcIqwx%2BAcDoH4BBY9z7vRe5T3gfHlTsYIIIBAfwRYweqPO0dFIBoB70fy5w3SXEUzYySKAAJVEGAFqwqzQA4IVFZg%2BIXeZQ9WNj0SQwABBCoqwApWRSeGtBCogoBzozdWIQ9yQAABBGIToMGKbcbIF4EeCTRs6A163uCre3Q4DoMAAgjUSoBThLWaTopBoCyBBTO8m%2FotjXZ0WSMyDgIIIJCSACtYKc02tSIQKOBt6h8qlOYq0IswBBBAYHcBVrB2F%2BFnBJIXaB7lnd0lhr2SpwAAAQQQaFOAFaw24dgNgboKeJ8tVW00V3WdYOpCAIGeCLCC1RNmDoJAHAIDNvSKUec%2BF0e2ZIkAAghUV4AVrOrODZkh0HOBzLn8pqK8EEAAAQQ6FKDB6hCQ3RGoi4Buy3BhZnZaXeqhDgQQQKCfApwi7Kc%2Bx0agMgInzPZuJH%2Fe4GGVSYlEEEAAgYgFWMGKePJIHYGyBPS8wSUa67CyxmMcBBBAIHUBVrBS%2FwZQPwI21PTOfVMQk8BAAAEEEChHgBWschwZBYFoBdxTF7bTXEU7gySOAAJVFKDBquKskBMCPRJo2PB5WsZ%2BXY8Ox2EQQACBZAQ4RZjMVFMoArsLnNvw7gcP6lMeibM7DT8jgAACHQqwgtUhILsjEKuAt0euVu40V7FOIHkjgEClBVjBqvT0kBwC3RI4%2FjDvGndr9H27dQTGRQABBFIWYAUr5dmn9mQFvB9YreJprpL9BlA4Agh0W4AVrG4LMz4ClRMYPsG77K7KpUVCCCCAQI0EWMGq0WRSCgIhAs5lN4fEEYMAAggg0L4ADVb7duyJQHQC3obfomXrM6JLnIQRQACByAQ4RRjZhJEuAu0LnLyPd1vv1%2F4Htz8GeyKAAAIIhAiwghWiRAwCNRDwfutVKoPmqgZzSQkIIFB9AVawqj9HZIhACQILh73zX9NAU0oYjCEQQAABBCYQYAVrAiA2I1AHAef8CtVBc1WHyaQGBBCIQoAGK4ppIkkE2hfQ8wZfraXqs9sfgT0RQAABBIoKcIqwqBjxCEQlcOQU756zRikfH1XaJIsAAghELsAKVuQTSPoIjCfgbdYl2k5zNR4S2xBAAIEuCLCC1QVUhkSgGgKLDvZu9AHlsnc18iELBBBAIB0BVrDSmWsqTUzA%2B9ElKpnmKrF5p1wEEKiGACtY1ZgHskCgVIEBG1486rI7Sh2UwRBAAAEEggUGgiMJRACBaAS2O1tqxt%2BfopkwEkUAgdoJ0GDVbkopKHWB59jQRb%2BygZeZjaROQf0IIIBA3wRosPpGv%2BuBHzWbtsUGl2Vmc7TlyV238hMCEwvouzM6w0ayz7sfv%2F6HNtmm2%2BjEOxGBAAIIINAVAc4hdIW1%2BKBrbfqFztxfFN%2BTPRB4SkAN1o6TgrO1cjXZMtorvhgIIIBAHwVosPqI%2F8yhH7G9n7Pdtj6gyTj0mc%2F4JwIIIIAAAgjEK8BtGiowdyO2dSnNVQUmghQQQAABBBAoSYAVrJIg2x1mnQ3md9n%2Bpt5T2x2D%2FRBAAAEEEECgWgKsYPV9PtxypUBz1fd5IAEEEEAAAQTKE2AFqzzLwiPpwvYzdWH77YV3ZAcEEEAAAQQQqLQAK1h9mp57zCY588v6dHgOiwACCCCAAAJdFKDB6iLueEM%2FxwbfYZadNF4M2xBAAAEEEEAgTgFOEfZh3tbatAO1enW%2FDr1vHw7PISMWyG8dOk33uNrftu2451V%2B7yteCCCAAALVE%2BBO7n2YE113da0OG9pc%2FbtuH3lVZiOj3hqT%2BpAuh6yAQP7Qm4be8%2B1J9wObsvF8mzPpcec%2FOM1GD6pAeqSAAAIIILCbAA3WbiDd%2FnGdzXixTg2%2BNfQ4mbn3zreN%2FxAaT1wKAptV5H7D%2Bh6puWINK4UZp0YEEIhPgAarx3OmB5jcrBWsoFOzCvrSXNv45z1OkcNVXmDxLO82%2FH3l0yRBBBBAIGEBLnLv4eSvt8Hz1Vy9KPSQI%2BZuVJPFEkUoWCJx3m%2B8QqUekUi5lIkAAghEKRC0khJlZRVL%2Boc2a9Y2236v%2BqXDQ1JTV%2FWX823Tm0NiiUlJ4Pi53jUeVMVTUqqaWhFAAIHYBFjB6tGMqbm6KrS5Ukq%2FbFjjlh6lxmEiEvC%2BsULp0lxFNGekigACaQrQYPVg3h%2BxveaquVKDFfbS6tW7j7QnHg6LJioVgYYNna0TxuenUi91IoAAAjEL0GD1YPZGbGSlDhO66vDQZNv0Rz1Ii0NEJXBuQ78bcV1UKZMsAgggkLAADVaXJ3%2BdTT9bhzivwGFWzTHbUiCe0AQEvP3gUq1snphAqZSIAAII1EKAi9y7OI358wb3ssGv6xCLAg%2Fz6Xm26dWBsYQlI3DiQd7lvyBhz02mZApFAAEEIhdgBauLE6jm6hINH9pcbTMbvbGL6TB0pALeb1%2Bi1GmuIp0%2F0kYAgTQFWMHq0rw%2FbNMOHjX%2FbQ0f9EgcTcT75tqm4Avhu5Q2w1ZOYPgU77KvVS4tEkIAAQQQGFeAFaxxedrfqJuEXqO9g5orxf1UNyB9d%2FtHY8%2B6CjiX5atXvBBAAAEEIhOgwerChK21maepYcpPDwa%2BslVH2safBQYTlohAw4bP08rmWYmUS5kIIIBArQRosLownd5Gg1cdnGVfn2eb%2F0cX0mDIqAUWzMhctjTqEkgeAQQQSFiABqvkyV9ng2%2FSr9O%2FKnTYzDz%2FEQ3FSijO%2B6nvUrkvTKhkSkUAAQRqJcBF7iVO53dtvxmTbPMaDbkgcNhP6LYMvxsYS1gyAkNHeufyX5CYmUzJFIoAAgjUTIAVrBIndJI9ebWGC22uNui3DJeVeHiGqomA97ZcpdBc1WQ%2BKQMBBNIUoMEqad4fspnzdR%2BrK8KHy95zlG1YGx5PZAoCurD9TMvcBSnUSo0IIIBAnQVosEqaXWejek6cmxE43PoZtvl9gbGEJSSgC9tvSqhcSkUAAQRqK0CDVcLUrrfp5%2Bhitt8LHUqxqw8w2xwaT1waAt6aF6vS49KolioRQACBegtwkXsJ86vfHLxPwxwfNpT71Dzb%2BJqwWKLSEThxfz1vUI%2BvtIPSqZlKEUAAgfoKsILV4dyutRmXaojA5konEW10ZYeHZPcaCni%2FTaeYaa5qOLWUhAACiQqwgtXBxP%2FABvffbnavhjgwbJjsg7qp6OVhsUSlI9A8xjt7QPXy72M6k06lCCBQcwFWsDqY4G2W5b9OH9hc2aMD5m7s4HDsWlMB53Z8L2iuajq%2FlIUAAmkK0GC1Oe%2Fft8Fjij1v0L3ncNv0n20ejt1qKvDU8wazc2paHmUhgAACyQrwt%2BY2p14Xtn9Kuwb9h1HI98y1TYvaPBS71VagOV2nBvML24%2BubYkUhgACCCQqwApWGxOfP29QuwU1V08Nn93QxmHYpeYC%2BpfvbSqR5qrm80x5CCCQpgArWAXnPX%2Fe4GTbfK8e6DwvcNe%2F0%2FMGg%2B%2BRFTgmYdELDB2t5w3epTJmRl8KBSCAAAII7CHACtYeJON%2FMGCbLg9vrrKNuk6LO3OPT5rkVj1vcIkKp7lKcvYpGgEEUhCgwSowy%2BttxgvUMF0Tuktm%2Fn1zbeP3QuOJS0NgwIZfxvMG05hrqkQAgXQFaLAKzH1m2VKFB6066NzrugGb9EcFhic0EYHMjV6bSKmUiQACCCQrMJBs5QUL14XtL9Mu54fuptOI1x9hj%2F8qNJ64NAQa1nyzvhsvSaNaqkQAAQTSFeAi98C5X2fT79SNtk8NCdd%2FQD833za9KiSWmJQETpjt3ci9qvjQlKqmVgQQQCBFAU4RBsz6Wpv%2B5tDm6qnhRlcEDEtIYgLej%2BTX79FcJTbvlIsAAmkKsII1wbzrwvb9dO1Vvupw8AShT292H5pnGy8OiyUqHYGFw975r6veyenUTKUIIIBAugKsYE0491m%2B6hDYXNkvRmz7rRMOSUByAs75%2FMJ2mqvkZp6CEUAgVQEarHFmXqcGF%2Bl6qj8cJ2S3TW7l0bbl33f7kB8TF9DzBt%2BopeLXJs5A%2BQgggEBSAjRY40y3N5%2FflmHSOCE7b7rvJ7bxz3f%2BgD8jYLZ4IHMZ1%2BTxVUAAAQQSE6DBajHh%2BfMGde1V8KqDs%2Bz60822txiOjxMV8LbxapV%2BVKLlUzYCCCCQrAAXuY8x9XeYDRxogw9qU%2Bh%2FGD%2Bm5w3mD4DmhcBOAgsP1YXt9%2BiDfXf6kD8igAACCCQgwArWGJN8oE3PL2wPba62jJi%2Ffoxh%2BChxAe%2FdahHQXCX%2BPaB8BBBIU4AGa7d5f8imztE9r67Y7eOWP%2Boi%2BA8cbRvWtQxgQ6ICQyfxvMFEp56yEUAAAQnQYO32NXDWWKWPZu%2F2casfH9pu029stZHP0xVwzvG9SHf6qRwBBBCgwdr5O%2FCwzXyRLkr7vZ0%2FG%2B%2FPWr26ZYE9tnG8GLalJ%2BCt%2BVZ9j85Ir3IqRgABBBB4RoCL3J%2BR0D%2FX2uCXBHL6Th%2BN98c7dWH7i8cLYFuKAifv493W%2B1V56M1pU0SiZgQQQKD2ApwifHqK9Uiciws0VzZq7vrafzsosLCA91uv0k40V4Xl2AEBBBColwArWJrP79pe%2B0yykQKrDjxvsF7%2FGpRVzVDTO%2FcNjcYjccoiZRwEEEAgUgFWsDRxaq7epX%2BErjr83NkIFzBH%2BoXvZtq6sH2lxqe56iYyYyOAAAKRCCTfYD1k04c1V28vMF%2FvmWtP%2FrhAPKEJCDRs6GwtB5%2BVQKmUiAACCCAQIJB8g9Uwt0pOoasOdzvb9McBroQkJXDklMztuKloUlVTLAIIIIBAa4GkG6x1Nv1s3WrhVa15dt2i5w2unmv2610%2F5afUBbzNukQGx6fuQP0IIIAAAs8KJHuR%2Bw%2FNpm6zwbtEceyzHK3%2FpEbs4%2FNt0xtaR7AlTYHmId7ZA6p9Vpr1UzUCCCCAwFgCya5gbbfBiwUS1Fwpbrs60ZvHAuSztAW8t%2Fy5lTRXaX8NqB4BBBDYQyDJFaxHbNohekBz8KqDM3fTXNt47R56fJC0wIA1Tx919qWkESgeAQQQQGBMgSRXsEassVQaoasOP1HsB8bU48OkBUaco%2BlO%2BhtA8QgggEBrgYHWm%2Bq55SGbcYZZ9pbQ6nRh%2B%2FK5tumx0Hji0hDQbRkuzCx7aRrVUiUCCCCAQFGB5E4RrrPBLwgp9D%2BMX9XzBl9SFJX4ugucuJd327%2BjKg%2Bte6XUhwACCCDQnkBSpwjX2vQLxRTaXGV63uDK9ljZq84C3m%2FLTw3SXNV5kqkNAQQQ6FAgmRWsH9qsWdtsW77qEPRIHF3Y%2FmFd2H5Rh77sXjOBAVv0W6Nu9P%2FWrCzKQQABBBAoWSCZa7DUXC2RXVBzpbjH9bzB1SVbM1wNBEZ99nLL7OcqJX9cUjJ%2FQanB1FECAggg0FOBJP4DsdYGj1OhayQ7NURXsdfowvZbQ2KJSU3g3IbZJ0ZSq5p6EUAAAQSKCSTRYOmROJ%2FQYsPvBNLcv802nbjAbGtgPGEIIIAAAggggMAuArW%2FyF0Xtp9ZoLnSOZ9sBc3VLt8RfkAAAQQQQACBggK1brC%2BazZZF6svL2Dy%2Bbm2%2BVMF4glFAAEEEEAAAQT2EKh1gzXZBt%2Buik%2Fco%2BqxP9im1av8Du%2B8EEAAAQQQQACBjgRq22CttWkHZmZXFtD5Y61efbtAPKEIIIAAAggggMCYArVtsHRqML8Z5H5jVr3nh49us8bNe37MJwgggAACCCCAQHGBWjZY622GHm%2FjLg7lyMzdusCe%2BEVoPHEIIIAAAggggMB4ArW80ahODQavRuk%2BFV%2BaZxv%2FbDwktiGAAAIIIIAAAkUEareCpYc5v8ksOzkcwXHH9nAsIhFAAAEEEEAgQKBWDVb%2BvEE1V6sC6n4m5H%2FqeYNffuYH%2FokAAggggAACCJQhUKsGa5tt128NuiMCYX7Z4ML2QCrCEEAAAQQQQKCIQG0arEdsr7lavXpnaPG69urWI%2ByJ9aHxxCGAAAIIIIAAAqECtWmwRmxkpYqeElj42gHb9IHAWMIQQAABBBBAAIFCArVosNbb9Fer6vMKVL5yjtmWAvGEIoAAAggggAACwQLRN1h3mA3oPlbXBVds7lPzbNPHwuOJRAABBBBAAAEEiglE32AdaDMuUcmLAsveltnIjYGxhCGAAAIIIIAAAm0JRN1gPWLTDtGF7ctDK9eF7R%2Bcb09%2BKzSeOAQQQAABBBBAoB2BqBus7eauVtGzAwv%2FiZ5PeGtgLGEIIIAAAggggEDbAtE2WGtt5qlqmPLTg0GvzLKVR9rGnwUFE4QAAggggAACCHQgEG2D5Wx0SXjd7pvzbfOHw%2BOJRAABBBBAAAEE2heIssHS8wbzWzKcGVq2rr0q0IyFjkocAggggAACCCAwtkB0DdZDtu9MlRJ8W4bM7ON63uBXxi6fTxFAAAEEEEAAgfIFomuwvG3JH4fzgjCKbKOZXxEWSxQCCCCAAAIIIFCOQFQNli5sP0q3ZbiiQOm3zrcNDxWIJxQBBBBAAAEEEOhYYKDjEXo4gC5sz08N5qcIJ3zpuqt1g7b5%2FRMGEoAAAggggAACCJQsEM0K1jqbfrZqP79A%2FTccYLa5QDyhCCCAAAIIIIBAKQLRNFhmbnV4xe5Tc23T34THE4kAAggggAACCJQnEEWDtdZmXKqSjw8vO%2BPC9nAsIhFAAAEEEECgZIHKN1g%2FsMH9nWXXhNat2D%2BdZ5vuD40nDgEEEEAAAQQQKFug8g3WiGXLVPRBgYU%2F2jB3Q2AsYQgggAACCCCAQFcEKt1gPWSDx2YFnjeo67Tee7ht%2Bs%2BuSDEoAggggAACCCAQKFDpBkvJ5atRuuNC0OveebbxT4IiCUIAAQQQQAABBLooUNkGa70N5rdkOCe0dl17VeC3DENHJQ4BonmqWwAACFJJREFUBBBAAAEEECguUMkG6wGzQZWyPLQcPW%2Fwb%2Bfa5n8JjScOAQQQQAABBBDopkAlG6ypNni5mqZ5YYVnG725m8NiiUIAAQQQQAABBLovULkGa73NeIFO9y0NLT0z%2F%2F65tvF7ofHEIYAAAggggAAC3RaoXIOVWXatrmufEVj4Wm%2BT3xcYSxgCCCCAAAIIINATgUo1WGtt8KWq%2Bk2hlesWDivm2i%2BeCI0nDgEEEEAAAQQQ6IVApRosnRq8vkDRn59vG%2F9PgXhCEUAAAQQQQACBnghUpsFaa9PfrFODp4ZW7Wz0%2BtBY4hBAAAEEEEAAgV4KVKLBethmPNeZC74tgxqxD821J9f0EopjIYAAAggggAACoQKVaLB0YfvVSvjgwKT%2Fa8C23xIYSxgCCCCAAAIIINBzgb43WDo1uEj3vPrD8MrdqsNty3%2BExxOJAAIIIIAAAgj0VqDvDZaZ120ZbFJg2d9%2BwjbeFhhLGAIIIIAAAggg0BeBgb4c9emDrrNB3ZIhe01oDvotw5XDZttC44lDAAEEEEAAAQT6IdC3Faw7zPLm7roCRX9Mzxv8VIF4QhFAAAEEEEAAgb4I9K3BOtCmX6OKjw6sekvDGisCYwlDAAEEEEAAAQT6KtCXBuv7NvUw3WrhitDKdRH8B46wJ9aHxhOHAAIIIIAAAgj0U6AvDZa3xioVPTuw8Icym3ZTYCxhCCCAAAIIIIBA3wV63mCttZmnOrMLQivX6tUtR9nPN4TGE4cAAggggAACCPRboKcNlpol9Vaj%2BepV4Cv72nzb9L8DgwlDAAEEEEAAAQQqIdDTBkuPxHmrOqzTQysfNc%2BF7aFYxCGAAAIIIIBAZQTU7%2FTm9V3ba59JNvKAjnZQ2BGz2%2BbZ5kvCYolCAAEEEEAAAQSqI9CzFSw1V%2B9S2YHNlf1cNxXlwvbqfE%2FIBAEEEEAAAQQKCPSkwXrYpjeV0ztC89Ky2nvn2pM%2FDo0nDgEEEEAAAQQQqJJATxqszNxqFR36vMG7zTZ9oEpI5IIAAggggAACCBQR6HqDtc6mn6XfHnxVeFLZyrlmvw6PJxIBBBBAAAEEEKiWQFcbrB%2BaTdWdGW4sUPIndGH77QXiCUUAAQQQQAABBCon0NUGa6sNXqqKjwusersubL85MJYwBBBAAAEEEECgsgJda7AesWmH6GL160Ir12lEXdi%2B%2Bb7QeOIQQAABBBBAAIGqCnStwRqxxlIVPSuw8J94c%2B8PjCUMAQQQQAABBBCotMBAN7J7yGacYZa9JXRsnRpcPtc2PRYaTxwCCCCAAAIIIFBlga6sYKlhCj41KJwv69TgX1UZidwQQAABBBBAAIEiAqU3WGtt%2BoW69ur00CR0anBVaCxxCCCAAAIIIIBADAKlNlg%2FtFmznLn82qugl2I%2FcqRtvCMomCAEEEAAAQQQQCASgVIbrG227RrVfVhg7Y87G2H1KhCLMAQQQAABBBCIR6C0BmutDeb3u7qiQOm3HGlPPlognlAEEEAAAQQQQCAKgdIaLFWbnxqcElj1A9t43mAgFWEIIIAAAgggEJtAKbdp0PMGz1bhvxtafH5bhgVmW0PjiUMAAQQQQAABBGIS0C%2F8dfb6rtnkSTZ4p0Y5IXCkf5tnm14RGEsYAggggAACCCAQnUDHpwjVXOXXXYU2V1u1erUkOiUSRgABBBBAAAEECgh01GCttWkH6lhXFTjeH%2Bumot8uEE8oAggggAACCCAQnUBHDZazRn7H9v0Cq350mzVuCYwlDAEEEEAAAQQQiFag7QZrvc14iZ43%2BNbQyjNzty6wJ34RGk8cAggggAACCCAQq0DbDVZmdnOBor843zb%2BWYF4QhFAAAEEEEAAgWgF2mqw1tngeVq9Ojm8ap43GG5FJAIIIIAAAgjELlC4wcqfN6jmalWBwv%2FXPNv41QLxhCKAAAIIIIAAAlELFG6wttl2%2FdagOzKw6sdHzBc5lRg4LGEIIIAAAggggEB1BQo1WN%2B3mfO0enVlaDmZZe892jasC40nDgEEEEAAAQQQqINAoUflNGx0hYqeGlK4bhG%2Fztnm94XEEoMAAggggAACCNRJIHgFa71Nf7UKf1No8fotw5VzzX4dGk8cAggggAACCCBQF4GgBkvNUkP3sVoeWrRi%2F0XPG%2FxoaDxxCCCAAAIIIIBAnQSCGqz1NniZim4GFr7NbPTGwFjCEEAAAQQQQACB2glM2GD9wKYeqqqXhVaua68%2BON823x0aTxwCCCCAAAIIIFA3gQkbLN1m4Z0qenZg4T91eiROYCxhCCCAAAIIIIBALQXGbbAetpkv0vVUl4ZW7ixbfqRt%2FFloPHEIIIAAAggggEAdBcZtsEZtdEl40W7NXNv8l%2BHxRCKAAAIIIIAAAvUUaNlg6cL281Xy2aFlZzZ6eWgscQgggAACCCCAQJ0FxrzR6EO278zMnrw2vPDsk%2FmF7T%2FUTUhHbe8p4fsRiQACCCCAAAII1E9gzAbL2RY9b9CODi%2FXnbTOBr%2Br%2BzOoMds6Gr4fkQgggAACCCCAQP0EdFeFXV%2FrbIYaq%2BwufTpz1y38hAACCCCAAAIIIBAiMMY1WNl12pHmKkSPGAQQQAABBBBAYAyBXVaw9LzBc3Rbhk%2BNEcdHCCCAAAIIIIAAAoECu6xgqblaGbgfYQgggAACCCCAAAItBH7TYK21GfkNRRe2iONjBBBAAAEEEEAAgUCBHacIH7YZzx217B7tc3DgfoQhgAACCCCAAAIItBDYsYKlm4Qu13aaqxZIfIwAAggggAACCBQRcOtt2kmZ%2BW8W2YlYBBBAAAEEEEAAgdYCA7qw%2FcqnN%2F9C%2F%2FzNNVmtd2ELAggggAACCCCAwHgC%2Fx87qY04ydRHPAAAAABJRU5ErkJggg%3D%3D%22%2F%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";

var SplashScreenDiv = lighthouseComponentLibrary.styled.div(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  && {\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    background: #f2f2f2;\n    @media (max-width: ", ") {\n      background: ", ";\n    }\n  }\n"], ["\n  && {\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    background: #f2f2f2;\n    @media (max-width: ", ") {\n      background: ", ";\n    }\n  }\n"])), lighthouseComponentLibrary.getMaxBreakpoint("default"), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.white; });
var SplashScreenImage = lighthouseComponentLibrary.styled.img(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  max-width: ", ";\n  max-height: ", ";\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  @media (max-width: ", ") {\n    top: 30%;\n  }\n"], ["\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  max-width: ", ";\n  max-height: ", ";\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  @media (max-width: ", ") {\n    top: 30%;\n  }\n"])), polished.rem("128px"), polished.rem("128px"), lighthouseComponentLibrary.getMaxBreakpoint("default"));
var GraphicImage = lighthouseComponentLibrary.styled.img(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n  position: fixed;\n  top: 50%;\n  right: 0;\n  @media (max-width: ", ") {\n    bottom: 0;\n    top: unset;\n  }\n"], ["\n  position: fixed;\n  top: 50%;\n  right: 0;\n  @media (max-width: ", ") {\n    bottom: 0;\n    top: unset;\n  }\n"])), lighthouseComponentLibrary.getMaxBreakpoint("default"));
function SplashScreen() {
    var splashScreenLogo = useTypedSelector(function (state) { return state.logos.SPLASH_SCREEN_LOGO; });
    return (React__namespace.createElement(SplashScreenDiv, null,
        React__namespace.createElement(SplashScreenImage, { src: splashScreenLogo || workforce_the_worker }),
        React__namespace.createElement(GraphicImage, { src: adpGraphic })));
}
var templateObject_1$a, templateObject_2$7, templateObject_3$6;

var _a;
var INVALID_ACCOUNT = "INVALID_ACCOUNT";
var UnexpectedError = "Error while proceeding to login. Organization ID:";
var AuthenticationPanel = lighthouseComponentLibrary.styled.div(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  && {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    ", "\n  }\n"], ["\n  && {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    ", "\n  }\n"])), deviceSafeAreaInsetCss);
var SkipAccountScreenWrapper = lighthouseComponentLibrary.styled.div(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n  @media (max-width: ", ") {\n    & img:nth-child(2) {\n      display: none;\n    }\n  }\n"], ["\n  @media (max-width: ", ") {\n    & img:nth-child(2) {\n      display: none;\n    }\n  }\n"])), lighthouseComponentLibrary.getMaxBreakpoint("default"));
var AuthenticationForm = lighthouseComponentLibrary.styled.form(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n  && {\n    display: flex;\n    flex-direction: column;\n    height: auto;\n    width: ", ";\n    @media (min-width: ", ") {\n      width: ", ";\n    }\n    @media (min-width: ", ") {\n      width: ", ";\n    }\n    @media (min-width: ", ") {\n      width: ", ";\n    }\n    background: ", ";\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n    padding: ", ";\n    border-radius: ", ";\n  }\n"], ["\n  && {\n    display: flex;\n    flex-direction: column;\n    height: auto;\n    width: ", ";\n    @media (min-width: ", ") {\n      width: ", ";\n    }\n    @media (min-width: ", ") {\n      width: ", ";\n    }\n    @media (min-width: ", ") {\n      width: ", ";\n    }\n    background: ", ";\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n    padding: ", ";\n    border-radius: ", ";\n  }\n"])), polished.rem("272px"), lighthouseComponentLibrary.getMinBreakpoint("sm"), polished.rem("439px"), lighthouseComponentLibrary.getMinBreakpoint("md"), polished.rem("350px"), lighthouseComponentLibrary.getMinBreakpoint("lg"), polished.rem("334px"), lighthouseComponentLibrary.getColor("white"), polished.rem("16px"), polished.rem("2px"));
var AuthenticationFormWrapper = lighthouseComponentLibrary.styled.div(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n  && {\n    display: flex;\n    flex: 1;\n    justify-content: center;\n    align-items: flex-start;\n    align-self: center;\n  }\n"], ["\n  && {\n    display: flex;\n    flex: 1;\n    justify-content: center;\n    align-items: flex-start;\n    align-self: center;\n  }\n"])));
var GreetingMessage = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var ProceedButton = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Button)(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n  align-self: flex-end;\n  &.button-contained {\n    background: #476bc3;\n    &:hover {\n      background: #324fa5;\n      color: ", ";\n    }\n  }\n"], ["\n  align-self: flex-end;\n  &.button-contained {\n    background: #476bc3;\n    &:hover {\n      background: #324fa5;\n      color: ", ";\n    }\n  }\n"])), lighthouseComponentLibrary.getColor("white"));
/**
 * @deprecated exported for unit testing purposes only
 */
var EditAccountButton = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.IconButton)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  align-self: flex-end;\n"], ["\n  align-self: flex-end;\n"])));
var LocaleDialogDiv = lighthouseComponentLibrary.styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  && {\n    align-self: center;\n    margin-top: ", ";\n  }\n"], ["\n  && {\n    align-self: center;\n    margin-top: ", ";\n  }\n"])), polished.rem("16px"));
var ReadOnlyAccountDiv = lighthouseComponentLibrary.styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  && {\n    align-items: center;\n    display: inline-flex;\n    border-bottom: ", " solid ", ";\n    margin-bottom: ", ";\n  }\n"], ["\n  && {\n    align-items: center;\n    display: inline-flex;\n    border-bottom: ", " solid ", ";\n    margin-bottom: ", ";\n  }\n"])), polished.rem("1px"), lighthouseComponentLibrary.getColor("grey", { shade: "main" }), polished.rem("16px"));
/**
 * @deprecated exported for unit testing purposes only
 */
var AccountIdLabel = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  && {\n    flex: 1;\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n  }\n"], ["\n  && {\n    flex: 1;\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n  }\n"])), lighthouseComponentLibrary.getColor("black"), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).type.body.fontSize; }, function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).type.body.fontWeight; });
var EditIcon = lighthouseComponentLibrary.styled(reactFontawesome.FontAwesomeIcon)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  && {\n    color: #476bc3;\n  }\n"], ["\n  && {\n    color: #476bc3;\n  }\n"])));
var AccountIcon = lighthouseComponentLibrary.styled(reactFontawesome.FontAwesomeIcon)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  && {\n    color: #476bc3;\n    margin-right: ", ";\n  }\n"], ["\n  && {\n    color: #476bc3;\n    margin-right: ", ";\n  }\n"])), polished.rem("4px"));
/**
 * @deprecated exported for unit testing purposes only
 */
var OrganizationTextField = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.OutlinedTextField)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  && {\n    margin: ", " 0;\n  }\n\n  &.organizationInputError,\n  &&:hover.organizationInputError {\n    .text-field__input-notched-outline {\n      border-color: ", ";\n    }\n\n    .text-field__form-helper-text-root,\n    .text-field__input-label-root {\n      color: ", ";\n    }\n\n    .text-field__input--focused {\n      .text-field__input-notched-outline {\n        border-color: ", ";\n      }\n    }\n  }\n\n  & {\n    .text-field__input-root:hover {\n      .text-field__input-notched-outline {\n        border-color: ", ";\n      }\n    }\n  }\n\n  & .text-field__form-helper-text-root {\n    font-size: ", ";\n    line-height: 18px;\n  }\n"], ["\n  && {\n    margin: ", " 0;\n  }\n\n  &.organizationInputError,\n  &&:hover.organizationInputError {\n    .text-field__input-notched-outline {\n      border-color: ", ";\n    }\n\n    .text-field__form-helper-text-root,\n    .text-field__input-label-root {\n      color: ", ";\n    }\n\n    .text-field__input--focused {\n      .text-field__input-notched-outline {\n        border-color: ", ";\n      }\n    }\n  }\n\n  & {\n    .text-field__input-root:hover {\n      .text-field__input-notched-outline {\n        border-color: ", ";\n      }\n    }\n  }\n\n  & .text-field__form-helper-text-root {\n    font-size: ", ";\n    line-height: 18px;\n  }\n"])), polished.rem("16px"), lighthouseComponentLibrary.getColor("error", { shade: "main" }), lighthouseComponentLibrary.getColor("error", { shade: "main" }), lighthouseComponentLibrary.getColor("error", { shade: "main" }), lighthouseComponentLibrary.getColor("primary", { shade: "main" }), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).type.subtitle1.fontSize; });
var errorMessages = (_a = {},
    _a[INVALID_ACCOUNT] = "ORGANIZATION_PANEL.INVALID_ACCOUNT",
    _a[NETWORK_ERROR] = "ORGANIZATION_PANEL.NETWORK_ERROR",
    _a);
function OrganizationPanel(props) {
    var _a;
    var _b = React.useState(((_a = useAuthenticationManagerAccountInfo()) === null || _a === void 0 ? void 0 : _a.organizationId) || ""), organizationId = _b[0], setOrganizationId = _b[1];
    // capturing account_name from the route if it exists. This is to support the scenario where a user is redirected to Lighthouse from an external page (e.g. Microsoft) and we want to pre-populate the organization ID field for them.
    // Regular login does not impact with this below implementation because organizationId in AuthenticationManager does not get populated until the login process, so we have to capture it here if it's being passed in through the route and set it directly in state to pre-populate the field and allow the user to proceed without having to re-enter their organization ID.
    React.useEffect(function () {
        var _a, _b, _c;
        var fromPathname = (_c = (_b = (_a = props.location) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.from) === null || _c === void 0 ? void 0 : _c.pathname;
        if (!fromPathname)
            return;
        var prefix = "/externalPage/";
        if (!fromPathname.startsWith(prefix))
            return;
        var encoded = fromPathname.slice(prefix.length);
        if (!encoded)
            return;
        try {
            var decodedExternalUrl = decodeURIComponent(encoded).trim();
            var url = new URL(decodedExternalUrl);
            var accountName = url.searchParams.get("account_name") || "";
            if (accountName.trim()) {
                setOrganizationId(accountName.trim());
            }
        }
        catch (_d) {
            // ignore
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var _c = React.useState(), error = _c[0], setError = _c[1];
    var _d = React.useState(!!organizationId), readOnly = _d[0], setReadOnly = _d[1];
    var _e = React.useState(false), isSubmitted = _e[0], setIsSubmitted = _e[1];
    var splashScreenLogo = useTypedSelector(function (state) { return state.logos.SPLASH_SCREEN_LOGO; });
    var showAlert = useTypedSelector(function (state) { var _a; return (_a = state === null || state === void 0 ? void 0 : state.sessionInactivity) === null || _a === void 0 ? void 0 : _a.showAlert; });
    var dispatch = reactRedux.useDispatch();
    var translate = useTranslateFunction();
    var fullUrl = window.location.href;
    // In cordova the # in the url comes before the query params
    // which prevents the params from being detected by window.location.search.
    // Removing the # will allow the params to be detected and retrievable using URLSearchParams.
    if (window.cordova && fullUrl.includes("#")) {
        fullUrl = fullUrl.replace("#", "");
    }
    var params = new URLSearchParams(new URL(fullUrl).search);
    var skipAccountSelectionInputParam = params.get(SKIP_ACCOUNT_SELECTION_QUERY_PARAM);
    var isImpersonationEnabled = tsReactUtil.useMemoWithLabel("impersonation", function () {
        var impersonationParam = params.get(IMPERSONATION_QUERY_PARAM);
        return impersonationParam === "true" && organizationId !== "";
    }, []);
    var helperText = error
        ? errorMessages[error]
        : "ORGANIZATION_PANEL.DEFAULT_HELP_TEXT";
    var _f = React.useState(skipAccountSelectionInputParam === "true" && organizationId !== ""), skippingAccountSelection = _f[0], setSkippingAccountSelection = _f[1];
    /**
     * This entire useEffect block is technical debt. For one, account skip should not be getting
     * handled in two different places like it is currently (AuthenticationManager and here). But
     * also, a UI component shouldn't be responsible for something as crucial as app initialization.
     * App initialization should happen in a higher order parent component (e.g. AppPanel) or
     * something more abstract such as the AuthenticationManager, which is used by the AppPanel.
     */
    React.useEffect(function () {
        if (isImpersonationEnabled || skippingAccountSelection) {
            console.log("[Auth][Mobile] OrganizationPanel auto-login: isImpersonation=" + isImpersonationEnabled + ", skippingAccountSelection=" + skippingAccountSelection + ", organizationId=" + organizationId);
            AuthenticationManager.getInstance()
                .login({
                organizationId: organizationId,
                redirectBackRoute: popOriginalRouteFromHistory(props.history),
            })
                .catch(function (err) {
                reportLoginErrorDetailsToDynatrace(err, organizationId, isImpersonationEnabled, skippingAccountSelection);
                console.log("Encountered error during account skip:");
                console.log(err);
                if ((err === null || err === void 0 ? void 0 : err.message) === "Network Error") {
                    setError(NETWORK_ERROR);
                }
                else if (isImpersonationEnabled) {
                    setError(INVALID_ACCOUNT);
                }
            })
                .finally(function () {
                setSkippingAccountSelection(false);
            });
        }
    }, []);
    React.useEffect(function () {
        var handleBeforeUnload = function () {
            dispatch(hideAlert());
        };
        // To hide inactivity logout alert on page refresh
        window.addEventListener("beforeunload", handleBeforeUnload);
        return function () {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);
    React.useEffect(function () {
        // Report form error to Dynatrace if there is one
        if (error && !!window.dtrum) {
            if (isImpersonationEnabled) {
                reportCustomError(UnexpectedError + " " + organizationId + ".", "Proceed to login failed");
            }
            else if (error === INVALID_ACCOUNT) {
                reportCustomError("Account validation error", helperText, organizationId);
            }
            else {
                reportCustomError("Account validation error", helperText);
            }
        }
    }, [error, window.dtrum]);
    if (isImpersonationEnabled && error) {
        return (React__namespace.default.createElement(ErrorPage, { showTakeHomeButton: false },
            React__namespace.default.createElement(StyledH3Typography, { use: "h3Light" }, translate("ERROR_PAGE.UNEXPECTED_ERROR"))));
    }
    if (skippingAccountSelection || isSubmitted) {
        return (React__namespace.default.createElement(SkipAccountScreenWrapper, null,
            React__namespace.default.createElement(SplashScreen, null)));
    }
    var accountField = readOnly && !error ? (React__namespace.default.createElement(ReadOnlyAccountDiv, null,
        React__namespace.default.createElement(AccountIcon, { icon: freeSolidSvgIcons.faBuilding, size: "lg" }),
        React__namespace.default.createElement(AccountIdLabel, { use: "body", "data-qa": "accountIdLabel" }, organizationId),
        React__namespace.default.createElement(EditAccountButton, { onClick: function () {
                setReadOnly(false);
                dispatch({
                    type: exports.LogoActionTypes.ClearLogos,
                });
                // User wants a different account, we should remove the local storage just in case
                // The account will get re-added if they accidentally clicked this anyway when they attempt to log in
                window.localStorage.removeItem(ORGANIZATION_ID_LOCAL_STORAGE_KEY);
            }, "aria-label": translate("ORGANIZATION_PANEL.EDIT_ACCOUNT_ARIA_LABEL") },
            React__namespace.default.createElement(EditIcon, { icon: freeSolidSvgIcons.faEdit, size: "xs" })))) : (React__namespace.default.createElement(OrganizationTextField, { defaultValue: organizationId, name: "OrganizationIdTextField", id: "OrganizationIdTextField", label: translate("ORGANIZATION_PANEL.ACCOUNT"), labelFor: "OrganizationIdTextField", helperText: translate(helperText), onChange: function (event) {
            setOrganizationId(event.currentTarget.value);
            if (!!error) {
                setError(undefined);
            }
        }, "data-qa": "organizationIdTextField", autoFocus: true, className: "text-field\n        " + (!!error ? "organizationInputError" : ""), autoCapitalize: "none", autoCorrect: "off", autoComplete: "off", required: true }));
    // TODO: This is to check if ui testing mode is enabled. We shouldn't need this when we remove
    //  our dependency on the mocked data under LTH-2788
    var uiTestingMode = isUiTestingMode();
    return (React__namespace.default.createElement(AuthenticationPanel, { "data-qa": "organizationPanel" },
        React__namespace.default.createElement(OrganizationPanelLogo, { logo: readOnly && splashScreenLogo ? splashScreenLogo : "" }),
        React__namespace.default.createElement(AuthenticationFormWrapper, null,
            React__namespace.default.createElement(AuthenticationForm, { onSubmit: function (event) {
                    if (event) {
                        event.preventDefault();
                    }
                    if (!!error) {
                        setError(undefined);
                    }
                    if (showAlert) {
                        dispatch(hideAlert());
                    }
                    setIsSubmitted(true);
                    AuthenticationManager.getInstance()
                        .login({
                        organizationId: organizationId,
                        redirectBackRoute: popOriginalRouteFromHistory(props.history),
                    })
                        .catch(function (err) {
                        reportLoginErrorDetailsToDynatrace(err, organizationId, false, false);
                        if ((err === null || err === void 0 ? void 0 : err.message) === "Network Error") {
                            setError(NETWORK_ERROR);
                        }
                        else {
                            setError(INVALID_ACCOUNT);
                        }
                        setIsSubmitted(false);
                    })
                        .finally(function () {
                        setIsSubmitted(false);
                    });
                }, "data-qa": "orgForm" },
                React__namespace.default.createElement(GreetingMessage, { use: "h5" }, translate("ORGANIZATION_PANEL.TITLE")),
                React__namespace.default.createElement(LogoutAlert, { isEnabled: showAlert }),
                accountField,
                React__namespace.default.createElement(ProceedButton, { eventType: "submit", disabled: !organizationId, "data-qa": "orgProceedButton" }, translate("ORGANIZATION_PANEL.BUTTON_NEXT")))),
        React__namespace.default.createElement(LocaleDialogDiv, null,
            React__namespace.default.createElement(LocaleSelectionPanel, null)),
        uiTestingMode && React__namespace.default.createElement(AutoLogin, null)));
}
var templateObject_1$9, templateObject_2$6, templateObject_3$5, templateObject_4$4, templateObject_5$3, templateObject_6$1, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;

/**
 * Utility function for determining whether or not we are using AIM as our auth provider.
 * This is superior to calling the authenticationManager method directly because
 * it is easier to mock in unit tests and provides a simple functional interface
 */
function isAimProvider() {
    var authenticationManager = AuthenticationManager.getInstance();
    return authenticationManager.isAimProvider();
}

/**
 * Conditionally renders OrganizationPanel or redirects immediately to AIM for login.
 *
 * - AIM on web: auto-redirects to AIM login (URL determines account), shows
 *   SplashScreen while waiting, redirects to "/" once authenticated.
 * - AIM on mobile: shows OrganizationPanel so users can switch accounts.
 *   Redirects to "/" if already authenticated.
 * - Keycloak (web or mobile): shows OrganizationPanel. On mobile, redirects
 *   to "/" if already authenticated. On web, stays on OrganizationPanel even
 *   when authenticated to allow account switching.
 *
 * @returns {JSX.Element | null}
 */
var AuthFlowTrigger = function (props) {
    var usingAimAsAuthProvider = isAimProvider();
    var authStatus = useAuthenticationManagerStatus();
    var authManager = AuthenticationManager.getInstance();
    var isMobile = isCordovaDevice();
    React.useEffect(function () {
        if (authStatus !== AuthenticationStatus.NotAuthenticated) {
            return;
        }
        // On mobile, do not auto-redirect to AIM — let the user initiate login
        // from OrganizationPanel so they can switch accounts if needed.
        if (usingAimAsAuthProvider && !isMobile) {
            console.log("----Redirecting to AIM----");
            authManager.login().catch(function (e) {
                // TODO SUITE-6031: Redirect to proper error page instead of just logging the error
                console.error(e);
            });
        }
    }, [authStatus]);
    if (usingAimAsAuthProvider && !isMobile) {
        return authStatus === AuthenticationStatus.Authenticated ? (React__namespace.default.createElement(reactRouterDom.Redirect, { to: "/" })) : (React__namespace.default.createElement(SplashScreen, null));
    }
    else {
        // On mobile, redirect to home if already authenticated — there's no reason
        // to stay on OrganizationPanel.
        // On web (Keycloak), allow OrganizationPanel even when authenticated so
        // users can switch accounts or debug.
        if (isMobile && authStatus === AuthenticationStatus.Authenticated) {
            return React__namespace.default.createElement(reactRouterDom.Redirect, { to: "/" });
        }
        return React__namespace.default.createElement(OrganizationPanel, __assign({}, props));
    }
};

var WTA_TOKEN_LOGIN_ROUTE = "/login/wta/:accountId";
var LOGOUT_ROUTE = "/logout/wta";
var Routes = function () {
    return [
        {
            id: RouteIds.Home,
            route: "/",
            component: Home,
            restricted: false,
            standalone: true,
        },
        {
            id: RouteIds.ExternalPage,
            route: "/externalPage/:externalUrl",
            component: ExternalPageViewWrapper({ title: "Embedded External Page" }),
            restricted: true,
            auxiliary: false,
        },
        {
            id: RouteIds.Launch,
            route: DEEPLINK_HANDLER_ROUTE + "/",
            component: DeeplinksHandler,
            restricted: true,
            auxiliary: false,
        },
        {
            id: RouteIds.Login,
            route: "/login",
            component: AuthFlowTrigger,
            restricted: false,
            standalone: true,
        },
        {
            id: RouteIds.WtaTokenLogin,
            route: WTA_TOKEN_LOGIN_ROUTE,
            component: WtaTokenLogin,
            restricted: false,
            standalone: true,
        },
        {
            id: RouteIds.WtaLogout,
            route: LOGOUT_ROUTE,
            component: WtaAimLogout,
            restricted: false,
            standalone: true,
        },
        {
            id: RouteIds.SpecificPreference,
            route: "/preferences/:preference",
            component: MobilePreferenceSelector,
            restricted: true,
        },
        {
            id: RouteIds.Preferences,
            route: "/preferences",
            component: UserPreferences,
            restricted: true,
        },
        {
            id: RouteIds.POCChildIframe,
            route: "/poc/childIframe",
            component: POCChildIframe,
            restricted: true,
            featureFlag: exports.FeatureFlagKey.SuiteSessionInactivity,
        },
    ];
};

/**
 * Service responsible for creating and sending platform notifications.
 */
var NotificationAPI = /** @class */ (function () {
    function NotificationAPI() {
    }
    NotificationAPI.send = function (title, message, delaySeconds) {
        var _this = this;
        // Note: Cordova has no type information for plugins, as these are project-dependent.
        var cordovaLib = window.cordova;
        if (cordovaLib) {
            cordovaLib.plugins.notification.local.schedule([
                {
                    title: title,
                    id: 1,
                    foreground: true,
                    priority: 1,
                    trigger: {
                        in: delaySeconds,
                        unit: "second",
                    },
                    text: message,
                },
            ]);
        }
        else {
            if ("Notification" in window) {
                if (Notification.permission === "granted") {
                    this.sendNotificationWithDelay(title, message, delaySeconds);
                }
                else if (Notification.permission !== "denied") {
                    Notification.requestPermission().then(function (permission) {
                        if (permission === "granted") {
                            _this.sendNotificationWithDelay(title, message, delaySeconds);
                        }
                    });
                }
            }
        }
    };
    /**
     * Creates and sends a browser notification
     *
     * See https://developer.mozilla.org/en-US/docs/Web/API/Notification/Notification for more info
     */
    NotificationAPI.createBrowserNotification = function (title, message) {
        var options = {
            body: message,
        };
        // tslint:disable-next-line:no-unused-expression
        new Notification(title, options);
    };
    /**
     * Sends the browser notification with a specified delay
     */
    NotificationAPI.sendNotificationWithDelay = function (title, message, delay) {
        var _this = this;
        setTimeout(function () { return _this.createBrowserNotification(title, message); }, delay * 1000);
    };
    return NotificationAPI;
}());

var Configuration$1 = /** @class */ (function () {
    /**
     * Adds new module configuration.
     * @param configuration Set of configuration keys and values.
     */
    function Configuration(configuration) {
        var _this = this;
        this.configuration = new Map();
        Object.keys(configuration).forEach(function (key) {
            _this.configuration.set(key, configuration[key]);
        });
    }
    /**
     * Retrieves a configuration value, given a specified module and key.
     *
     * @param module Configuration module.
     * @param key Configuration key.
     */
    Configuration.prototype.get = function (module, key) {
        var moduleConfig = this.configuration.get(module);
        if (!moduleConfig) {
            return undefined;
        }
        return moduleConfig[key];
    };
    return Configuration;
}());

var useHubCardOrder = function () {
    return useTypedSelector(function (state) { return state.userPreferences.hubCardCustomization.hubCardOrder; });
};
var useSidebarIntegration = function () {
    return useTypedSelector(function (state) { return state.sidebarIntegration; });
};
var getFrameworkStateHook = function (stateType) {
    switch (stateType) {
        case "hubCardOrder":
            return useHubCardOrder;
        case "sidebarIntegration":
            return useSidebarIntegration;
        default:
            throw new Error("No such state exported");
    }
};

var getHubCardOrder = function (applicationState) {
    var hubCardOrder = applicationState.userPreferences.hubCardCustomization.hubCardOrder;
    return (hubCardOrder || []);
};
var getSideBarIntegration = function (applicationState) {
    return applicationState.sidebarIntegration;
};
var getFrameworkStateSelector = function (stateType) {
    switch (stateType) {
        case "hubCardOrder":
            return getHubCardOrder;
        case "sidebarIntegration":
            return getSideBarIntegration;
        default:
            throw new Error("No such state exported");
    }
};

/**
 * @inheritdoc
 */
var LighthouseFrameworkImpl = /** @class */ (function () {
    /**
     * Creates a new framework instance, registering
     *  the passed modules and initializing the framework.
     * @param modulesToRegister
     * @param moduleConfiguration - moduleConfiguration to initialize framework with
     * @param frameworkConfiguration - configuration specific to the framework/App itself
     */
    function LighthouseFrameworkImpl(modulesToRegister, moduleConfiguration, frameworkConfiguration) {
        var _this = this;
        if (moduleConfiguration === void 0) { moduleConfiguration = {}; }
        if (frameworkConfiguration === void 0) { frameworkConfiguration = {}; }
        this.frameworkConfiguration = frameworkConfiguration;
        /**
         * @inheritDoc
         */
        this.getStore = getStore;
        /**
         * @inheritDoc
         */
        this.getFrameworkStateHook = getFrameworkStateHook;
        /**
         * @inheritDoc
         */
        this.getFrameworkStateSelector = getFrameworkStateSelector;
        this.featureFlags = undefined;
        this.modules = new Map();
        this.reducers = {};
        this.assistantCardConsumers = {};
        this.assistantCardProviders = [];
        modulesToRegister.forEach(function (module) { return _this.registerModule(module); });
        this.registerRoutes();
        modulesToRegister.forEach(function (module) {
            _this.registerAssistantCardHOC(module);
            _this.registerReducers(module);
            _this.registerAssistantCardProviders(module);
        });
        this.configuration = new Configuration$1(moduleConfiguration);
        var _a = createFromModuleList(this.getModules()), store = _a.store, persistor = _a.persistor;
        setStore(store);
        setPersistor(persistor);
        setFrameworkInstance(this);
    }
    /**
     * @inheritDoc
     */
    LighthouseFrameworkImpl.prototype.lazyLoadModule = function (module) {
        // Adds module to the private module list for this class.
        // Also calls a few methods on it for internal bookkeeping (setFrameworkInstance and setI18nInstance)
        this.registerModule(module);
        // Unfortunately registerRoutes needs to be called again in order to re-initialize all routes.
        // Thankfully this should all be done before the routeContext is used in rendering, so there will be no
        // post-render updates.
        this.registerRoutesForModule(module);
        // Skip registration of assistant card HOC, assistant card providers, and redux reducers.
        // TODO: Add in that functionality in order to support lazy loading any module and not just modules that don't
        // TODO: make use of these features.
    };
    /**
     * @inheritDoc
     */
    LighthouseFrameworkImpl.prototype.createAssistantCard = function (WrappedComponent) {
        if (this.createAssistantCardHOC) {
            return this.createAssistantCardHOC(WrappedComponent);
        }
        throw new Error("No createAssistantCard() higher order function was registered");
    };
    /**
     * @inheritDoc
     */
    LighthouseFrameworkImpl.prototype.getConfiguration = function () {
        return this.configuration;
    };
    /**
     * @inheritDoc
     */
    LighthouseFrameworkImpl.prototype.getRouteContext = function () {
        return routeContext;
    };
    /**
     * @inheritDoc
     */
    LighthouseFrameworkImpl.prototype.getAssistantCardProviders = function () {
        return this.assistantCardProviders;
    };
    /**
     * @inheritDoc
     */
    LighthouseFrameworkImpl.prototype.getModules = function () {
        return Array.from(this.modules.values());
    };
    /**
     * @inheritDoc
     */
    LighthouseFrameworkImpl.prototype.getNotificationService = function () {
        return NotificationAPI;
    };
    /**
     * @inheritDoc
     */
    LighthouseFrameworkImpl.prototype.getAssistant = function () {
        var modules = this.getModules();
        var assistant = null;
        modules.forEach(function (module) {
            if (module.getAssistant) {
                assistant = module.getAssistant();
            }
        });
        return assistant;
    };
    /**
     * @inheritDoc
     */
    LighthouseFrameworkImpl.prototype.getAssistantIconComponent = function () {
        var modules = this.getModules();
        var assistantIcon = null;
        modules.forEach(function (module) {
            if (module.getAssistantIcon) {
                assistantIcon = module.getAssistantIcon();
            }
        });
        return assistantIcon;
    };
    /**
     * @inheritDoc
     */
    LighthouseFrameworkImpl.prototype.reloadAllAssistantCards = function () {
        if (Object.keys(this.assistantCardConsumers).length > 0) {
            this.assistantCardProviders.forEach(function (provider) {
                try {
                    // TODO-LTH-3038: Call to startProducingCards does not guarantee immediate reload
                    //                of card as this is pretty much dependant on how the provider
                    //                implements it. Ideally introduce method in AssistantCardProvider
                    //                that can guarantee reload of data immediately.
                    provider.startProducingCards();
                }
                catch (e) {
                    global.console.error(e);
                }
            });
        }
    };
    /**
     * @inheritDoc
     */
    LighthouseFrameworkImpl.prototype.removeHubCard = function (hubCardIdToRemove, hubCardIdToReinsertBeforeOnUndo, hubCardName) {
        var dispatch = getFrameworkInstance().getStore()
            .dispatch;
        return dispatch(removeHubCard(hubCardIdToRemove, hubCardIdToReinsertBeforeOnUndo, hubCardName));
    };
    /**
     * @inheritDoc
     */
    LighthouseFrameworkImpl.prototype.addHubCard = function (hubCardIdToAdd, insertBefore) {
        var dispatch = getFrameworkInstance().getStore()
            .dispatch;
        return dispatch(addHubCard(hubCardIdToAdd, insertBefore));
    };
    /**
     * @inheritDoc
     */
    LighthouseFrameworkImpl.prototype.notifyOfAssistantCardsChange = function (assistantCardProvider) {
        Object.values(this.assistantCardConsumers).forEach(function (assistantCardConsumer) {
            try {
                assistantCardConsumer.notifyOfAssistantCardsChange(assistantCardProvider);
            }
            catch (e) {
                global.console.error(e);
            }
        });
    };
    /**
     * @inheritDoc
     */
    LighthouseFrameworkImpl.prototype.registerAssistantCardConsumer = function (assistantCardConsumer) {
        var consumerRegistrationCode = this.generateUniqueAssistantConsumerRegistrationCode();
        this.assistantCardConsumers[consumerRegistrationCode] = assistantCardConsumer;
        this.notifyAssistantCardProvidersOfConsumerChange();
        return consumerRegistrationCode;
    };
    /**
     * @inheritDoc
     */
    LighthouseFrameworkImpl.prototype.unRegisterAssistantCardConsumer = function (assistantCardConsumerRegistrationCode) {
        delete this.assistantCardConsumers[assistantCardConsumerRegistrationCode];
        if (Object.keys(this.assistantCardConsumers).length === 0) {
            this.notifyAssistantCardProvidersOfConsumerChange();
        }
    };
    /**
     * @inheritDoc
     */
    LighthouseFrameworkImpl.prototype.setRawFeatureFlags = function (featureFlags) {
        this.featureFlags = featureFlags;
    };
    /**
     * @inheritDoc
     */
    LighthouseFrameworkImpl.prototype.getNamedFeatureFlags = function () {
        var names = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            names[_i] = arguments[_i];
        }
        if (!this.featureFlags) {
            // Set all the Featureflags value to false when featureflag object got undefined
            var emptyFeatureFlags = {};
            for (var _a = 0, names_1 = names; _a < names_1.length; _a++) {
                var key = names_1[_a];
                emptyFeatureFlags[key] = false;
            }
            return emptyFeatureFlags;
        }
        var featureFlags = getNamedFeatureFlags(this.featureFlags, names);
        if (!featureFlags) {
            throw new Error("Feature flags not found: " + names);
        }
        return featureFlags;
    };
    /**
     * @inheritDoc
     */
    LighthouseFrameworkImpl.prototype.isFeatureEnabled = function (featureId) {
        var featureFlags = this.getNamedFeatureFlags(featureId);
        return featureFlags[featureId];
    };
    /**
     * @inheritDoc
     */
    LighthouseFrameworkImpl.prototype.isAppEmbedded = function () {
        return !!this.frameworkConfiguration.isAppEmbedded;
    };
    /**
     * @inheritdoc
     */
    LighthouseFrameworkImpl.prototype.setRedirectRoute = function (redirectUrl) {
        var dispatch = getStore().dispatch;
        dispatch(setDeeplinkRedirectRoute(redirectUrl));
    };
    /**
     * @inheritDoc
     */
    LighthouseFrameworkImpl.prototype.getNavigationItems = function () {
        return this.registerNavigationItems().then(function (navigations) {
            return Array.from(navigations.values());
        });
    };
    LighthouseFrameworkImpl.prototype.registerNavigationItems = function () {
        var navigations = new Map();
        // Call each module's async getNavigationItems() method.
        var getNavigationItems = this.getModules().map(function (module) {
            if (module.getNavigationItems) {
                return module.getNavigationItems();
            }
            return Promise.resolve([]);
        });
        // Wait for all promises to resolve, then register each navigation item.
        return Promise.all(getNavigationItems).then(function (allNavigationItems) {
            allNavigationItems.forEach(function (navigationItems) {
                navigationItems.map(function (navigation) {
                    if (navigations.has(navigation.getId())) {
                        throw new Error("Navigation with (id, name): " +
                            ("(" + navigation.getId() + ", " + navigation.getDisplayText() + ") already exists"));
                    }
                    navigations.set(navigation.getId(), navigation);
                });
            });
            return navigations;
        });
    };
    LighthouseFrameworkImpl.prototype.generateUniqueAssistantConsumerRegistrationCode = function () {
        return uuid.v4();
    };
    LighthouseFrameworkImpl.prototype.notifyAssistantCardProvidersOfConsumerChange = function () {
        if (Object.keys(this.assistantCardConsumers).length === 0) {
            this.assistantCardProviders.forEach(function (provider) {
                try {
                    provider.stopProducingCards();
                }
                catch (e) {
                    global.console.error(e);
                }
            });
        }
        else {
            this.assistantCardProviders.forEach(function (provider) {
                try {
                    provider.startProducingCards();
                }
                catch (e) {
                    global.console.error(e);
                }
            });
        }
    };
    LighthouseFrameworkImpl.prototype.registerRoutes = function () {
        routeContext.clearRoutes();
        this.getModules().forEach(this.registerRoutesForModule.bind(this));
        routeContext.registerRoutes(this.wrapRouteComponents(Routes()));
    };
    LighthouseFrameworkImpl.prototype.registerRoutesForModule = function (module) {
        if (!module.getRouteSpecifications) {
            return;
        }
        var routeSpecifications = this.wrapRouteComponents(module.getRouteSpecifications());
        routeContext.registerRoutes(routeSpecifications);
    };
    LighthouseFrameworkImpl.prototype.wrapRouteComponents = function (routeSpecifications) {
        routeSpecifications.forEach(function (route) {
            if (Boolean(route.auxiliary) || Boolean(route.standalone)) {
                route.component = wrapComponentInRouteContext(route.component);
            }
            else {
                route.component = wrapComponentInMainView(route.component);
            }
        });
        return routeSpecifications;
    };
    LighthouseFrameworkImpl.prototype.registerModule = function (module) {
        var _a;
        if (!!this.modules.get(module.getId())) {
            throw Error("Module with (id, name):\n      (" + module.getId() + ", " + module.getName() + " is already registered");
        }
        (_a = module.setFrameworkInstance) === null || _a === void 0 ? void 0 : _a.call(module, this);
        if (module.setI18nInstance) {
            module.setI18nInstance(createI18n(module));
        }
        this.modules.set(module.getId(), module);
    };
    LighthouseFrameworkImpl.prototype.registerReducers = function (module) {
        if (!module.getReducers) {
            return;
        }
        var reducers = module.getReducers();
        this.reducers = __assign(__assign({}, this.reducers), reducers);
    };
    LighthouseFrameworkImpl.prototype.registerAssistantCardProviders = function (module) {
        var _this = this;
        if (!module.getAssistantCardProviders) {
            return;
        }
        var providers = module.getAssistantCardProviders();
        if (!providers) {
            return;
        }
        providers.forEach(function (assistantCardProvider) {
            _this.assistantCardProviders.push(assistantCardProvider);
        });
    };
    LighthouseFrameworkImpl.prototype.registerAssistantCardHOC = function (module) {
        if (module.getCreateAssistantCardHOC) {
            if (this.createAssistantCardHOC) {
                throw Error("AssistantCard Higher Order Component already Registered." +
                    ("Cannot register HOC for Module: " + module.getName()));
            }
            this.createAssistantCardHOC = module.getCreateAssistantCardHOC();
        }
    };
    return LighthouseFrameworkImpl;
}());

var createAndInitializeLighthouseFramework = function (modulesToRegister, moduleConfiguration, frameworkConfiguration) {
    if (moduleConfiguration === void 0) { moduleConfiguration = {}; }
    if (frameworkConfiguration === void 0) { frameworkConfiguration = {}; }
    return new LighthouseFrameworkImpl(modulesToRegister, moduleConfiguration, frameworkConfiguration);
};

/**
 * List of configuration values understood by the authentication module.
 */
var ConfigurationValues;
(function (ConfigurationValues) {
    ConfigurationValues["GetToken"] = "getToken";
})(ConfigurationValues || (ConfigurationValues = {}));
/**
 * The internal name of this configuration module.
 */
var moduleName = "login";

/**
 * Wraps children components in a `@workforcesoftware/localization-framework` translate function
 * context provider and text direction context provider with values based on the lighthouse-framework's
 * current locale ID (based on user preference).
 */
var TranslateFunctionAndTextDirectionProvider = function (props) {
    var _a = reactI18next.useTranslation(), i18nextTranslate = _a[0], i18n = _a[1];
    var translateFunction = React.useCallback(function (moduleId, key, substitutions) {
        if (substitutions === void 0) { substitutions = {}; }
        var moduleIdKey = moduleId + ":" + key;
        // Try accessing a key with a target field, otherwise default to normal key
        return i18nextTranslate([moduleIdKey + ".TARGET", moduleIdKey], substitutions);
    }, [i18nextTranslate]);
    return (React__namespace.default.createElement(localizationFramework.TranslateFunctionContext.Provider, { value: translateFunction },
        React__namespace.default.createElement(localizationFramework.TextDirectionContext.Provider, { value: i18n.dir() }, props.children)));
};

/**
 * Hardware ID of the current Device.
 */
var hwid = "";
var attemptNumber = 0;
var registrationTimeout;
/**
 * Register Device for Push Notifications.
 * This will trigger all pending Push Notifications on start.
 */
function registerForPushNotifications(appId, fcmSenderId) {
    if (!window.plugins) {
        return console.info("Cordova plugin support not available");
    }
    var pushNotification = window.plugins.pushNotification;
    if (!pushNotification) {
        return console.error("Push notification support not available");
    }
    // set push notifications handler
    document.addEventListener("push-notification", notificationClickHandler);
    pushNotification.onDeviceReady({
        projectid: fcmSenderId,
        appid: appId,
        pw_appid: appId,
    });
    var scheduleDeviceRegistrationAttempt = function (token, delay) {
        if (registrationTimeout) {
            clearTimeout(registrationTimeout);
        }
        registrationTimeout = setTimeout(function () {
            attemptDeviceRegistration(token);
        }, delay);
    };
    var attemptDeviceRegistration = function (token) {
        global.console.log("Register for Push Notifications with token: ", token);
        attemptNumber++;
        global.console.log("Attempt number: " + attemptNumber);
        var authManager = AuthenticationManager.getInstance();
        if (authManager.getAuthStatus() === AuthenticationStatus.Authenticated) {
            var decodedToken = authManager.getOidcUserInfo();
            pushNotification.setUserId(decodedToken.account_internal_id + "|" + decodedToken.wfs_id);
            switch (attemptNumber) {
                case 1:
                    scheduleDeviceRegistrationAttempt(token, 1000);
                    break;
                case 2:
                    scheduleDeviceRegistrationAttempt(token, 3000);
                    break;
                case 3:
                    scheduleDeviceRegistrationAttempt(token, 10000);
                    break;
            }
        }
    };
    pushNotification.registerDevice(function (status) {
        pushNotification.getPushwooshHWID(function (token) {
            hwid = token;
        });
        attemptNumber = 0;
        scheduleDeviceRegistrationAttempt(status.pushToken, 500);
    }, function (error) {
        global.console.error("Failed to register for Push Notifications ", error);
    });
}
/**
 * Unregister Device from receiving Push Notifications.
 */
function unregisterFromPushNotifications() {
    if (!window.plugins) {
        return console.info("Cordova plugin support not available");
    }
    var pushNotification = window.plugins.pushNotification;
    if (!!pushNotification && !!hwid) {
        if (registrationTimeout) {
            clearTimeout(registrationTimeout);
        }
        pushNotification.setUserId(hwid); // restore the default User ID
        global.console.log("User detached from HWID: " + hwid);
    }
}
/**
 * Handles deeplink for Push notification
 * @param link Push Notification link
 */
function handleDeeplink(link) {
    var pathname = new URL(link).pathname;
    window.dispatchEvent(new CustomEvent("handleDeeplinkEvent", { detail: pathname }));
}
/**
 * Handles clicking on Push Notification
 * @param event Push Notification event object
 */
function notificationClickHandler(event) {
    var _a, _b;
    var notification = event.notification;
    var message = notification.message;
    var title = "";
    if (isAndroidDevice()) {
        var androidData = notification.android;
        if (!!androidData.header) {
            title = androidData.header + "\n";
        }
        alert("" + title + message);
        // Handle deeplink if present in custom data
        if ((_a = androidData === null || androidData === void 0 ? void 0 : androidData.userdata) === null || _a === void 0 ? void 0 : _a.notification_link) {
            var link = androidData.userdata.notification_link;
            handleDeeplink(link);
        }
    }
    else if (isiOSDevice()) {
        var iosData = notification.ios;
        if (!!iosData.aps.alert.title) {
            title = iosData.aps.alert.title + "\n";
        }
        var subtitle = "";
        if (!!iosData.aps.alert.subtitle) {
            subtitle = iosData.aps.alert.subtitle + "\n";
        }
        alert("" + title + subtitle + message);
        // Handle deeplink if present in custom data
        if ((_b = notification === null || notification === void 0 ? void 0 : notification.userdata) === null || _b === void 0 ? void 0 : _b.notification_link) {
            var link = notification.userdata.notification_link;
            handleDeeplink(link);
        }
    }
}

/**
 * Retrieves user preference initialization configurations for a given array of modules.
 * Returns a map of module IDs to their corresponding user preference init configs.
 *
 * @param modules - An array of Module objects.
 * @returns A map where keys are module IDs and values are user preference init configs.
 */
function getUserPreferenceInitConfigsByModuleId(modules) {
    var initConfigsByModuleId = {};
    modules.forEach(function (module) {
        var _a;
        var config = (_a = module === null || module === void 0 ? void 0 : module.getUserPreferencesConfig) === null || _a === void 0 ? void 0 : _a.call(module);
        if (config) {
            initConfigsByModuleId[module.getId()] = config;
        }
    });
    return initConfigsByModuleId;
}

/**
 * User preferences config for lighthouse-framework's user preferences.
 */
var backCompatUserPreferenceInitConfig = {
    config: {
        landingPage: {
            defaultValue: undefined,
            deserialize: function (value) {
                var _a;
                // DO NOT COPY THIS PATTERN. This deserialize function exists to make this new user preference
                // config design backwards compatible with the old framework preference design.
                return ((_a = JSON.parse(value)) === null || _a === void 0 ? void 0 : _a.landingPage) || undefined;
            },
            serialize: function (value) {
                // DO NOT COPY THIS PATTERN. This serialize function exists to make this new user preference
                // config design backwards compatible with the old framework preference design.
                return JSON.stringify({ landingPage: value });
            },
        },
        theme: {
            defaultValue: "",
            deserialize: function (value) {
                var _a;
                // DO NOT COPY THIS PATTERN. This deserialize function exists to make this new user preference
                // config design backwards compatible with the old framework preference design.
                return ((_a = JSON.parse(value)) === null || _a === void 0 ? void 0 : _a.theme) || "";
            },
            serialize: function (value) {
                // DO NOT COPY THIS PATTERN. This serialize function exists to make this new user preference
                // config design backwards compatible with the old framework preference design.
                return JSON.stringify({ theme: value });
            },
        },
        locale: {
            defaultValue: undefined,
            deserialize: function (value) {
                var _a;
                // DO NOT COPY THIS PATTERN. This deserialize function exists to make this new user preference
                // config design backwards compatible with the old framework preference design.
                return ((_a = JSON.parse(value)) === null || _a === void 0 ? void 0 : _a.locale) || undefined;
            },
            serialize: function (value) {
                // DO NOT COPY THIS PATTERN. This serialize function exists to make this new user preference
                // config design backwards compatible with the old framework preference design.
                return JSON.stringify({ locale: value });
            },
        },
        assistantCardsFilters: {
            defaultValue: [],
            deserialize: function (value) {
                var _a;
                // DO NOT COPY THIS PATTERN. This deserialize function exists to make this new user preference
                // config design backwards compatible with the old framework preference design.
                return ((_a = JSON.parse(value)) === null || _a === void 0 ? void 0 : _a.assistantCardsFilters) || undefined;
            },
            serialize: function (value) {
                // DO NOT COPY THIS PATTERN. This serialize function exists to make this new user preference
                // config design backwards compatible with the old framework preference design.
                return JSON.stringify({ assistantCardsFilters: value });
            },
        },
        timeFormat: {
            defaultValue: TimeFormatUserPreference.AccountConfigDefault,
            deserialize: function (value) {
                var _a;
                return tsEnumUtil.$enum(TimeFormatUserPreference).asValueOrDefault((_a = JSON.parse(value)) === null || _a === void 0 ? void 0 : _a.timeFormat, TimeFormatUserPreference.AccountConfigDefault);
            },
            serialize: function (value) {
                // DO NOT COPY THIS PATTERN. This serialize function exists to make this new user preference
                // config design backwards compatible with the old framework preference design.
                return JSON.stringify({ timeFormat: value });
            },
        },
        expectedHubCards: {
            defaultValue: {},
            deserialize: function (value) {
                var _a;
                // DO NOT COPY THIS PATTERN. This deserialize function exists to make this new user preference
                // config design backwards compatible with the old framework preference design.
                return ((_a = JSON.parse(value)) === null || _a === void 0 ? void 0 : _a.expectedHubCards) || {};
            },
            serialize: function (value) {
                // DO NOT COPY THIS PATTERN. This serialize function exists to make this new user preference
                // config design backwards compatible with the old framework preference design.
                return JSON.stringify({ expectedHubCards: value });
            },
        },
        hubCardCustomization: {
            defaultValue: { hubCardOrder: [] },
            deserialize: function (value) {
                var _a;
                // DO NOT COPY THIS PATTERN. This deserialize function exists to make this new user preference
                // config design backwards compatible with the old framework preference design.
                return ((_a = JSON.parse(value)) === null || _a === void 0 ? void 0 : _a.hubCardCustomization) || {};
            },
            serialize: function (value) {
                // DO NOT COPY THIS PATTERN. This serialize function exists to make this new user preference
                // config design backwards compatible with the old framework preference design.
                return JSON.stringify({ hubCardCustomization: value });
            },
        },
    },
};

var TimeFormat;
(function (TimeFormat) {
    TimeFormat["Force_12Hours"] = "FORCE_12_HOURS";
    TimeFormat["Force_24Hours"] = "FORCE_24_HOURS";
    TimeFormat["LocaleDefault"] = "LOCALE_DEFAULT";
})(TimeFormat || (TimeFormat = {}));
var PushWooshParamsFragmentDoc = { "kind": "Document", "definitions": [{ "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "PushWooshParams" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "PushWooshParams" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "appId" } }, { "kind": "Field", "name": { "kind": "Name", "value": "fcmSenderId" } }] } }] };
var AccountThemeFragmentDoc = { "kind": "Document", "definitions": [{ "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "AccountTheme" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "GQLTheme" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": { "kind": "Name", "value": "name" }, "name": { "kind": "Name", "value": "themeName" } }, { "kind": "Field", "alias": { "kind": "Name", "value": "key" }, "name": { "kind": "Name", "value": "themeKey" } }] } }] };
var AccountImageFragmentDoc = { "kind": "Document", "definitions": [{ "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "AccountImage" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "AccountImageTransaction" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "contentType" } }, { "kind": "Field", "name": { "kind": "Name", "value": "image" } }] } }] };
var FeatureFlagEntryFragmentDoc = { "kind": "Document", "definitions": [{ "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "FeatureFlagEntry" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "FeatureFlagEntry" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "enabled" } }] } }] };
var GetAccountConfigurationDocument = { "kind": "Document", "definitions": __spreadArrays([{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "getAccountConfiguration" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": { "kind": "Name", "value": "featureFlags" }, "name": { "kind": "Name", "value": "getFeatureFlags" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "FeatureFlagEntry" } }] } }, { "kind": "Field", "alias": { "kind": "Name", "value": "timeFormat" }, "name": { "kind": "Name", "value": "getTimeFormat" } }, { "kind": "Field", "alias": { "kind": "Name", "value": "defaultLocale" }, "name": { "kind": "Name", "value": "DefaultLocale" } }, { "kind": "Field", "alias": { "kind": "Name", "value": "pushWooshParams" }, "name": { "kind": "Name", "value": "getPushWooshParams" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "PushWooshParams" } }] } }, { "kind": "Field", "alias": { "kind": "Name", "value": "accountTheme" }, "name": { "kind": "Name", "value": "GetAccountTheme" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "AccountTheme" } }] } }, { "kind": "Field", "alias": { "kind": "Name", "value": "favicon" }, "name": { "kind": "Name", "value": "AccountImage" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "imagePurpose" }, "value": { "kind": "StringValue", "value": "FAVICON", "block": false } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "AccountImage" } }] } }, { "kind": "Field", "alias": { "kind": "Name", "value": "splashScreenLogo" }, "name": { "kind": "Name", "value": "AccountImage" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "imagePurpose" }, "value": { "kind": "StringValue", "value": "SPLASH_SCREEN_LOGO", "block": false } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "AccountImage" } }] } }, { "kind": "Field", "alias": { "kind": "Name", "value": "desktopHeaderLogo" }, "name": { "kind": "Name", "value": "AccountImage" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "imagePurpose" }, "value": { "kind": "StringValue", "value": "DESKTOP_HEADER_LOGO", "block": false } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "AccountImage" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "currentDate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "simulatedSystemDateConfig" } }] } }], FeatureFlagEntryFragmentDoc.definitions, PushWooshParamsFragmentDoc.definitions, AccountThemeFragmentDoc.definitions, AccountImageFragmentDoc.definitions) };
/**
 * Private implementation of creating the GraphQL service SDK.
 * @param serviceOptions - Options passed through to {@link GraphqlServiceFactory.getGraphQlObject}.
 * @returns A GraphQL service SDK implementation.
 */
function getSdk(serviceOptions) {
    var additionalLink = serviceOptions.additionalLink;
    var graphQLObject = graphqlServiceFactory
        .getGraphQlObject("configuration", __assign(__assign({}, serviceOptions), { additionalLink: additionalLink }));
    /**
     * Map of request ID -> pending promise for all pending requests.
     */
    var pendingRequests = {};
    /**
     * Used to generate unique request IDs.
     */
    var nextRequestId = 0;
    return {
        /**
         * Causes ALL pending requests from this API instance to be ignored.
         *
         * All promises that have been returned for pending requests are guaranteed
         * to never settle (resolve or reject).
         */
        ignoreAllPendingRequests: function () {
            for (var key in pendingRequests) {
                pendingRequests[key].ignore();
            }
        },
        getAccountConfiguration: function (variables, operationOptions) {
            var requestId = nextRequestId++;
            var request = new tsUtil.IgnorablePromise(function (resolve, reject, onIgnored) {
                var operationPromise = graphQLObject
                    .query(GetAccountConfigurationDocument, variables, operationOptions).then(function (response) {
                    delete pendingRequests[requestId];
                    // NOTE: typecast to any is necessary because the generics on GraphqlService methods are not setup correctly
                    resolve(response.data);
                }, function (reason) {
                    delete pendingRequests[requestId];
                    reject(reason);
                });
                onIgnored(function () {
                    delete pendingRequests[requestId];
                    // This is for forward-compatibility if `lighthouse-framework` is ever updated to return `IgnorablePromise`
                    // from its GraphQLObject. Propagate the ignoring to the original promise, in case it helps cancel the 
                    // pending request.       
                    if (tsUtil.isIgnorable(operationPromise)) {
                        operationPromise.ignore();
                    }
                });
            });
            pendingRequests[requestId] = request;
            return request;
        }
    };
}
/**
 * Get a new GraphQL service SDK interface implementation for the `configuration-service` service.
 * @param serviceOptions - Options passed through to {@link GraphqlServiceFactory.getGraphQlObject}.
 * @returns {ConfigurationServiceSdk} A GraphQL service SDK implementation for executing GraphQL operations on the `configuration-service` service.
 */
function getConfigurationServiceSdk(serviceOptions) {
    if (serviceOptions === void 0) { serviceOptions = {}; }
    {
        // return a "real" implementation of the SDK
        return getSdk(serviceOptions);
    }
}

/**
 * Return the Base64 image string for the given image params from the transaction
 * @param imageParams - The params for the image that include the type
 * and the content of the image
 * @return the Base64 image string for the given image params from the transaction
 */
function getBase64ImageString(imageParams) {
    return "data:" + imageParams.contentType + ";base64," + imageParams.image;
}

/**
 * Perform the main functions for logging into the application (query for feature flags, get navigation items, etc.)
 * @param authManager - Authentication Manager instance for the application
 */
function performLoginFunctions() {
    var dispatch = getStore().dispatch;
    // Dispatch requests to 3 services in parallel
    // A 4th request to the config service is also kicked off at this time in AppPanel.tsx
    // TODO: Obviously this is a mess. App init code needs to be cleaned up and organized better.
    // Note that doing it this way requires all of these requests to be successful, else the Suite initialization will fail.
    // The same holds true for the request to the Configuration Service in AppPanel
    // TODO: Reconsider if all requests absolutely need to be successful.
    // TODO: Perhaps the Suite can retain some of its functionality even if the individual services are down.
    // TODO: We definitely want the Suite to be as resilient as possible to reduce sev 1s.
    return Promise.all([
        dispatch(getNavigationItems()),
        dispatch(getLocales(graphqlServiceFactory)),
    ]).then(function () {
        dispatch(syncAppLocaleWithUserPreferences()).then(function () {
            dispatch(changeLocaleSelectedFlag(false));
        });
    });
}
/**
 * Takes the account configuration from the configuration service and
 * dispatches the appropriate actions to store locale, theme and branding data
 * in the Redux store.
 * It also registers for push notifications with pushwoosh.
 */
function storeAccountConfiguration(result) {
    var _a;
    var _b, _c;
    var dispatch = getStore().dispatch;
    // default the account locale to the app locale in case the account locale is not defined.
    dispatch({
        type: "localization/defaultLocale" /* SetDefaultLocale */,
        defaultLocale: result.defaultLocale || appDefaultLocale,
    });
    // set pushwoosh params
    if (result.pushWooshParams.appId && result.pushWooshParams.fcmSenderId) {
        registerForPushNotifications(result.pushWooshParams.appId, result.pushWooshParams.fcmSenderId);
    }
    else {
        console.info("Cannot get pushwoosh parameters. Pushwoosh feature flag is probably disabled");
    }
    // set account theme
    dispatch({
        type: exports.AccountThemeActionTypes.SetAccountTheme,
        accountTheme: {
            themeKey: ((_b = result.accountTheme) === null || _b === void 0 ? void 0 : _b.key) || null,
            themeName: ((_c = result.accountTheme) === null || _c === void 0 ? void 0 : _c.name) || null,
        },
    });
    // set account images
    var faviconUrl = result.favicon ? getBase64ImageString(result.favicon) : "";
    var splashScreenLogoUrl = result.splashScreenLogo
        ? getBase64ImageString(result.splashScreenLogo)
        : "";
    var desktopHeaderLogoUrl = result.desktopHeaderLogo
        ? getBase64ImageString(result.desktopHeaderLogo)
        : "";
    dispatch({
        type: exports.LogoActionTypes.LoadLogos,
        logos: (_a = {},
            _a[exports.ImagePurpose.Favicon] = faviconUrl,
            _a[exports.ImagePurpose.SplashScreen] = splashScreenLogoUrl,
            _a[exports.ImagePurpose.DesktopHeaderLogo] = desktopHeaderLogoUrl,
            _a),
    });
}

/**
 * Initialize pendo
 */
var initializePendo = function () {
    if (getFrameworkInstance().getNamedFeatureFlags(exports.FeatureFlagKey.Pendo).pendo) {
        var authManager = AuthenticationManager.getInstance();
        var accountInfo = authManager.getAccountInfo();
        var userInfo = authManager.getOidcUserInfo();
        var pendoData = {
            visitor: {
                id: userInfo === null || userInfo === void 0 ? void 0 : userInfo.wfs_id,
                firstName: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.given_name) || "",
                lastName: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.family_name) || "",
                email: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.email) || "",
            },
            account: {
                id: accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.accountData.accountDetail.internalId,
                name: accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.organizationId,
                environment: accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.accountData.environment,
                datacenter: accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.accountData.accountDetail.datacenter,
            },
        };
        window.dispatchEvent(new CustomEvent("loadPendo", { detail: pendoData }));
    }
};

/**
 * Initialize WalkMe
 */
var initializeWalkMe = function () {
    var _a;
    var env = process.env.NODE_ENV || "development";
    // There are three node environments: "development", "test", and "production".
    // WFS latest, sprint, and production environments are all considered "production"
    // node environments. WalkMe should only be initialized in production environments,
    // as it is not needed in development or test environments.
    if (env !== "production") {
        return;
    }
    // Guard for non-browser environments (SSR/tests)
    if (typeof window === "undefined" || typeof document === "undefined") {
        return;
    }
    var authManager = AuthenticationManager.getInstance();
    var userInfo = authManager.getOidcUserInfo();
    // Provision WalkMe with user data (UUID et al.) via the walkMeData configuration
    // object on the window. This is necessary for WalkMe to properly attribute user
    // interactions and provide a personalized experience.
    window.walkMeData = {
        wfsID: userInfo === null || userInfo === void 0 ? void 0 : userInfo.wfs_id,
    };
    var hostname = (_a = window.location) === null || _a === void 0 ? void 0 : _a.hostname;
    // Differentiate between actual staging (latest, sprint, PR) and production environments
    var isStagingEnv = (hostname === null || hostname === void 0 ? void 0 : hostname.includes("-latest")) || (hostname === null || hostname === void 0 ? void 0 : hostname.includes("-sprint")) || (hostname === null || hostname === void 0 ? void 0 : hostname.includes("lth-pr-")) ||
        false;
    var stagingPathSegment = isStagingEnv ? "/test" : "";
    // Construct a WalkMe agent URL specified to staging (latest, sprint, PR) and specific to production
    var agentSrc = "https://cdn.walkme.com/users/5755cce613bb473cbb20cf7e44f9c485" + stagingPathSegment + "/walkme_5755cce613bb473cbb20cf7e44f9c485_https.js";
    // Set config before script load
    window._walkmeConfig = { smartLoad: true };
    // Avoid duplicate injection if initializeWalkMe is called multiple times
    var existingScript = document.querySelector('script[data-walkme-agent="true"]');
    if (existingScript) {
        return;
    }
    // Apply and initialize the WalkMe agent
    var walkme = document.createElement("script");
    walkme.type = "text/javascript";
    walkme.async = true;
    walkme.src = agentSrc;
    walkme.dataset.walkmeAgent = "true";
    // Append the WalkMe script to the document head or body to load it asynchronously and early.
    var firstScript = document.getElementsByTagName("script")[0];
    if (firstScript === null || firstScript === void 0 ? void 0 : firstScript.parentNode) {
        firstScript.parentNode.insertBefore(walkme, firstScript);
    }
    else {
        (document.head || document.body || document.documentElement).appendChild(walkme);
    }
};

/**
 * Loading state for a Module's Hub Card specifications.
 */
var ModuleLoadingState;
(function (ModuleLoadingState) {
    /**
     * Loading, or loading not yet started. This is the initial state.
     */
    ModuleLoadingState[ModuleLoadingState["Loading"] = 0] = "Loading";
    /**
     * Hub Card specifications are successfully loaded.
     */
    ModuleLoadingState[ModuleLoadingState["Loaded"] = 1] = "Loaded";
    /**
     * Hub Card specifications failed to load.
     */
    ModuleLoadingState[ModuleLoadingState["Error"] = 2] = "Error";
})(ModuleLoadingState || (ModuleLoadingState = {}));
/**
 * Manages loading and rendering of Hub Cards.
 * - Instantiate this with a list of Module definitions,
 * then call {@link #loadHubCardSpecifications} to start loading cards.
 * - Subscribe to events to be notified as loading progresses.
 */
var HubCardManager = /** @class */ (function (_super) {
    __extends(HubCardManager, _super);
    /**
     * @param modules - All Modules that Hub Cards will be loaded from.
     */
    function HubCardManager(modules) {
        var _this = _super.call(this) || this;
        _this.modules = modules;
        /**
         * Maintains a Promise that will be settled when loading is complete.
         */
        _this.loadingPromiseDelegate = new promiseDelegate.PromiseDelegate();
        /**
         * Map of Module ID -> Module definitions.
         * NOTE: Not initialized until {@link #loadHubCardSpecifications} is called.
         */
        _this.modulesById = {};
        /**
         * Map of Hub Card ID -> Hub Card info.
         * NOTE: Not initialized until {@link #loadHubCardSpecifications} is called.
         * NOTE: This structure can contain "expected" Hub Cards
         */
        _this.hubCardsById = {};
        /**
         * True if hub cards are currently loading.
         */
        _this._isLoading = false;
        /**
         * True if all hub card loading has completed.
         */
        _this._hasLoaded = false;
        /**
         * Count of how many times hub card loading has been initiated.
         * Used to differentiate between completed promises/requests for a current
         * load vs. those for a previous abandoned load that should be ignored.
         * @private
         */
        _this.loadCount = 0;
        return _this;
    }
    /**
     * Emits the `loadingStatusChange` event with current loading status.
     */
    HubCardManager.prototype.emitLoadingStatusChange = function () {
        this.emit.loadingStatusChange(this._isLoading, this._hasLoaded);
    };
    /**
     * Emits the `loadingProgress` event with current loading progress.
     */
    HubCardManager.prototype.emitLoadingProgress = function () {
        this.emit.loadingProgress(this.getLoadingProgress());
    };
    /**
     * @returns True if hub cards are currently loading.
     */
    HubCardManager.prototype.isLoading = function () {
        return this._isLoading;
    };
    /**
     * @returns True if all hub card loading has completed.
     */
    HubCardManager.prototype.hasLoaded = function () {
        return this._hasLoaded;
    };
    /**
     * @returns A number ranging from 0 to 1 representing the percentage
     * of Modules that have completed.
     */
    HubCardManager.prototype.getLoadingProgress = function () {
        var _a = ___default.default.reduce(this.modulesById, function (_a, module) {
            var _b;
            var completedAccumulator = _a[0], totalAccumulator = _a[1];
            return [
                completedAccumulator +
                    tsEnumUtil.$enum.mapValue(module.loadingState).with((_b = {},
                        _b[ModuleLoadingState.Loading] = 0,
                        _b[ModuleLoadingState.Loaded] = 1,
                        _b[ModuleLoadingState.Error] = 1,
                        _b)),
                totalAccumulator + 1,
            ];
        }, [0, 0]), completedCount = _a[0], totalCount = _a[1];
        if (totalCount === 0) {
            // Special case for zero modules (avoid divide by zero).
            // Loading progress is 0 or 1, determined by whether we've loaded yet or not.
            return Number(this._hasLoaded);
        }
        else {
            return completedCount / totalCount;
        }
    };
    /**
     * Starts loading all Hub Card specifications from all Modules.
     * Subsequent attempts to load will re-initialize and start a fresh load.
     * If a previous pending load is interrupted, then the same promise is
     * still to indicate that loading is complete when the subsequent interrupting
     * load is complete.
     * @param expectedHubCards - Info about Hub Cards that are "expected" to load.
     *        Expected Hub Cards for Modules that are still loading will be reported as
     *        if they are real Hub Cards that exist in the Hub Card Manager.
     * @returns A Promise that resolves when loading is complete.
     */
    HubCardManager.prototype.loadHubCardSpecifications = function (expectedHubCards) {
        var _this = this;
        /**
         * Keeps track of whether responses should be processed or ignored
         */
        var loadNumber = ++this.loadCount;
        /**
         * True if loading was already in progress, interrupted by this call
         */
        var wasLoading = this._isLoading;
        /**
         * True if there was any loading progress, interrupted by this call
         */
        var hadProgress = this.getLoadingProgress() > 0;
        // If we've already settled the promise for the previous load, then we need
        // a fresh promise for this load. Otherwise, we will continue to use the
        // existing promise for a potentially interrupted previous load, because
        // other code may already have a reference to that promise and needs to know
        // when this load completes.
        if (this.loadingPromiseDelegate.settled) {
            this.loadingPromiseDelegate = new promiseDelegate.PromiseDelegate();
        }
        // Initialize data structures with "expected" hub cards...
        this.hubCardsById = {};
        this.modulesById = ___default.default(this.modules)
            .keyBy(function (module) { return module.id; })
            .mapValues(function (module) {
            // Initialize hubCardsById map with entries for all expected cards from each module.
            ___default.default.forEach(expectedHubCards[module.id], function (expectedHubCard) {
                _this.hubCardsById[expectedHubCard.id] = {
                    name: expectedHubCard.name,
                    moduleId: module.id,
                    specifications: undefined,
                };
            });
            // Create an entry for this module in the modulesById map
            return __assign(__assign({}, module), { loadingState: ModuleLoadingState.Loading, hubCardIds: ___default.default.map(expectedHubCards[module.id], function (expectedHubCard) { return expectedHubCard.id; }) });
        })
            .value();
        // Set loading status
        this._isLoading = true;
        this._hasLoaded = false;
        // Loading status is changing if we weren't already loading...
        if (!wasLoading) {
            this.emitLoadingStatusChange();
        }
        // Loading progress is changing if we already had some progress...
        if (hadProgress) {
            this.emitLoadingProgress();
        }
        Promise.all(
        // Load Hub Card specifications from all Modules...
        ___default.default(this.modulesById)
            .values()
            .map(function (module) {
            return module.hubCardFactory
                .getCardSpecifications()
                .then(function (specifications) {
                // Ignore responses for an abandoned load
                if (loadNumber !== _this.loadCount) {
                    return;
                }
                // Clear out all "expected" cards for this module
                ___default.default.forEach(module.hubCardIds, function (hubCardId) {
                    // Only delete the card if it is still loading (has no specifications yet)
                    // This handles an edge case where we have moved a hub card from one UI module
                    // to another, and that other module has already responded with this hub card.
                    if (_this.hubCardsById[hubCardId] !== undefined &&
                        _this.hubCardsById[hubCardId].specifications === undefined) {
                        delete _this.hubCardsById[hubCardId];
                    }
                });
                // Overwrite "expected" card IDs with actual card IDs
                module.hubCardIds = specifications.map(function (specification) {
                    return specification.getId();
                });
                // Store loaded cards info
                ___default.default.assign(_this.hubCardsById, ___default.default(specifications)
                    .keyBy(function (specification) { return specification.getId(); })
                    .mapValues(function (specification) {
                    return {
                        name: specification.getName(),
                        moduleId: module.id,
                        specifications: specification,
                    };
                })
                    .value());
                // Mark module as loaded and emit the loading progress event.
                module.loadingState = ModuleLoadingState.Loaded;
                _this.emitLoadingProgress();
            })
                .catch(function (reason) {
                // Ignore errors for an abandoned load
                if (loadNumber !== _this.loadCount) {
                    return;
                }
                var errorMessage = "Error retrieving hub cards for module: " + module.name;
                global.console.error(errorMessage, reason);
                reportCustomError("Hub Card Error", errorMessage);
                // Mark module as errored and emit the loading progress event.
                module.loadingState = ModuleLoadingState.Error;
                _this.emitLoadingProgress();
            });
        })
            .value())
            .then(function () {
            // Ignore completion of an abandoned load
            if (loadNumber !== _this.loadCount) {
                return;
            }
            // All loading is complete
            _this._isLoading = false;
            _this._hasLoaded = true;
            // If there are zero modules, then we need to emit the "loadingProgress"
            // event, since it never had a chance to be emitted as modules were loaded.
            if (___default.default.isEmpty(_this.modulesById)) {
                _this.emitLoadingProgress();
            }
            _this.emitLoadingStatusChange();
            _this.loadingPromiseDelegate.resolve();
        })
            .catch(function (reason) {
            // Ignore errors for an abandoned load
            if (loadNumber !== _this.loadCount) {
                return;
            }
            _this.loadingPromiseDelegate.reject(reason);
        });
        return this.loadingPromiseDelegate.promise;
    };
    /**
     * Gets information about Hub Cards that should be "expected" next time
     * the same user loads up the application, based on which Hub Cards actually
     * loaded this time. The returned structure should be provided as
     * {@link HubCardManagerConfig.expectedHubCards} in a subsequent instantiation
     * of a HubCardManager.
     * This method must not be called before loading is completed!
     * NOTE: Hub Cards that were expected this time, but whose Modules failed to
     * load, will still be included in the "next" expected Hub Cards structure.
     *
     * @returns Information about Hub Cards that should be "expected" next time
     * the same user loads up the application.
     * @throws {Error} if hub card loading is not yet complete.
     */
    HubCardManager.prototype.getNextExpectedHubCards = function () {
        var _this = this;
        if (!this._hasLoaded) {
            throw new Error("Hub cards have not been loaded yet!");
        }
        return (___default.default(this.modulesById)
            // Skip modules have have no card IDs expected/loaded
            .omitBy(function (module) { return ___default.default.isEmpty(module.hubCardIds); })
            .mapValues(function (module) {
            return module.hubCardIds.map(function (hubCardId) {
                return {
                    id: hubCardId,
                    name: _this.hubCardsById[hubCardId].name,
                };
            });
        })
            .value());
    };
    /**
     * Returns a list of all Hub Card IDs.
     * The order of the result is same order that each Module returns its Hub Cards
     * in, and overall in the order in which Modules were provided to the HubCardManager
     * constructor.
     * Returns an empty array if cards are not yet loaded.
     * @returns a list of all Hub Card IDs.
     */
    HubCardManager.prototype.getAllHubCardIds = function () {
        return ___default.default(this.modulesById)
            .map(function (module) { return module.hubCardIds; })
            .flatten()
            .value();
    };
    /**
     * Gets the display name of a Hub Card.
     * @param hubCardId - A valid Hub Card ID.
     * @returns The display name for the specified Hub Card.
     * @throws {Error} if an invalid Hub Card ID is provided.
     */
    HubCardManager.prototype.getHubCardName = function (hubCardId) {
        var hubCardInfo = this.hubCardsById[hubCardId];
        if (!hubCardInfo) {
            throw new Error("Invalid Hub Card ID: " + hubCardId);
        }
        return hubCardInfo.name;
    };
    /**
     * Renders the content of a Hub Card.
     * @param hubCardId - ID of the card to render.
     * @param editMode - True to render the card in "edit mode".
     * @param changeHubCardConfig - TODO: explain
     * @param renderHubCardLoadingPlaceholderContent - Render function for
     *        placeholder content of "expected" Hub Cards from Modules that
     *        are loading.
     * @param renderHubCardErrorPlaceholderContent - Render function for
     *        placeholder content of "expected" Hub Cards from Modules that
     *        failed to load.
     * @return The rendered Hub Card.
     * @throws {Error} if an invalid Hub Card ID  is provided.
     */
    HubCardManager.prototype.renderHubCardContent = function (hubCardId, editMode, changeHubCardConfig, renderHubCardLoadingPlaceholderContent, renderHubCardErrorPlaceholderContent) {
        var _a;
        var hubCardInfo = this.hubCardsById[hubCardId];
        if (!hubCardInfo) {
            throw new Error("Invalid Hub Card ID: " + hubCardId);
        }
        var moduleInfo = this.modulesById[hubCardInfo.moduleId];
        // Render the card content appropriately based on its loading status...
        return tsEnumUtil.$enum.visitValue(moduleInfo.loadingState).with((_a = {},
            _a[ModuleLoadingState.Loading] = function () {
                return renderHubCardLoadingPlaceholderContent({
                    hubCardId: hubCardId,
                    hubCardName: hubCardInfo.name,
                });
            },
            _a[ModuleLoadingState.Error] = function () {
                return renderHubCardErrorPlaceholderContent({
                    hubCardId: hubCardId,
                    hubCardName: hubCardInfo.name,
                });
            },
            _a[ModuleLoadingState.Loaded] = function () {
                return moduleInfo.hubCardFactory.create(
                // Non-null assertion is safe because specifications must exist if
                // card belongs to a Module that has loaded.
                hubCardInfo.specifications, editMode, changeHubCardConfig);
            },
            _a));
    };
    return HubCardManager;
}(strictlyTypedEvents.WithEventEmitter));

/**
 * React context for a {@link HubCardManager} instance.
 */
var HubCardManagerContext = React__namespace.createContext(new HubCardManager([]));
HubCardManagerContext.displayName = "HubCardManagerContext";

/**
 * Custom React hook that provides access to the state of the
 * {@link HubCardManager} provided by {@link HubCardManagerContext}.
 * @returns An up-to-date representation of the state of the HubCardManager
 * from HubCardManagerContext.
 */
function useHubCardManagerState() {
    var hubCardManager = React.useContext(HubCardManagerContext);
    var _a = tsReactUtil.useStateObject({
        isLoading: false,
        hasLoaded: false,
        loadingProgress: 0,
        hubCardIds: [],
    }), hubCardManagerState = _a[0], setHubCardManagerState = _a[1];
    var loadHubCardSpecifications = React.useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return hubCardManager.loadHubCardSpecifications.apply(hubCardManager, args);
    }, [hubCardManager]);
    var getHubCardName = React.useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return hubCardManager.getHubCardName.apply(hubCardManager, args);
    }, 
    // NOTE: Including `loadingProgress` as a dependency because the behavior of
    //       `getHubCardName` can change as more hub card info is loaded.
    //       We need this callback reference to change any time its result could
    //       be different to trigger a re-render of any component that is affected
    //       by the return value of this callback.
    [hubCardManager, hubCardManagerState.loadingProgress]);
    var renderHubCardContent = React.useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return hubCardManager.renderHubCardContent.apply(hubCardManager, args);
    }, 
    // NOTE: Including `loadingProgress` as a dependency because the behavior of
    //       `renderHubCardContent` can change as more hub card info is loaded.
    //       We need this callback reference to change any time its result could
    //       be different to trigger a re-render of any component that is affected
    //       by the return value of this callback.
    [hubCardManager, hubCardManagerState.loadingProgress]);
    // Handle changes to `hubCardManager` context
    React.useEffect(function () {
        // Initialize state
        setHubCardManagerState({
            isLoading: hubCardManager.isLoading(),
            hasLoaded: hubCardManager.hasLoaded(),
            loadingProgress: hubCardManager.getLoadingProgress(),
            hubCardIds: hubCardManager.getAllHubCardIds(),
        });
        // Subscribe to events to react to changes
        var cancelSubscription = hubCardManager.subscribe({
            loadingStatusChange: function (newIsLoading, newHasLoaded) {
                setHubCardManagerState(function (prevState) { return ({
                    isLoading: newIsLoading,
                    hasLoaded: newHasLoaded,
                    // When loading begins, the Hub Card IDs may have been updated due to
                    // "expected" hub cards being specified when starting the load.
                    hubCardIds: newIsLoading
                        ? hubCardManager.getAllHubCardIds()
                        : prevState.hubCardIds,
                }); });
            },
            loadingProgress: function (newLoadingProgress) {
                setHubCardManagerState({
                    loadingProgress: newLoadingProgress,
                    // Any time that loading progress updates, there could be a change in
                    // the list of valid hub card IDs.
                    hubCardIds: hubCardManager.getAllHubCardIds(),
                });
            },
        });
        // Cleanup by cancelling event subscriptions
        return function () {
            cancelSubscription();
        };
    }, [hubCardManager]);
    return __assign(__assign({}, hubCardManagerState), { renderHubCardContent: renderHubCardContent, getHubCardName: getHubCardName, loadHubCardSpecifications: loadHubCardSpecifications });
}

/**
 * Wraps children components in a `@workforcesoftware/localization-framework` time format
 * context provider with a value calculated based on the supplied account config and user preference
 * values.
 *
 * If the user preference value is {@link TimeFormatUserPreference.AccountConfigDefault}, then the
 * account config value is used. Otherwise, the user preference value is used.
 *
 * Wrap this component around children components that should receive this time format value.
 */
var TimeFormatProvider = function (props) {
    var savedTimeFormat = useBackCompatPreference(exports.BackCompatUserPreferenceKey.TimeFormat)[0];
    var timeFormat = tsReactUtil.useMemoWithLabel("timeFormat", function () {
        var _a, _b;
        if (!props.isFeatureEnabled) {
            return localizationFramework.TimeFormat.LocaleDefault;
        }
        var normalizedAccountConfigTimeFormat = tsEnumUtil.$enum
            .mapValue(props.accountConfigTimeFormat)
            .with((_a = {},
            _a[TimeFormat.LocaleDefault] = localizationFramework.TimeFormat.LocaleDefault,
            _a[TimeFormat.Force_12Hours] = localizationFramework.TimeFormat.Force12Hours,
            _a[TimeFormat.Force_24Hours] = localizationFramework.TimeFormat.Force24Hours,
            // Default if the account config value is not a valid enum value at runtime
            _a[tsEnumUtil.$enum.handleUnexpected] = localizationFramework.TimeFormat.LocaleDefault,
            _a));
        return tsEnumUtil.$enum.mapValue(savedTimeFormat).with((_b = {},
            _b[TimeFormatUserPreference.AccountConfigDefault] = normalizedAccountConfigTimeFormat,
            _b[TimeFormatUserPreference.LocaleDefault] = localizationFramework.TimeFormat.LocaleDefault,
            _b[TimeFormatUserPreference.Force12Hours] = localizationFramework.TimeFormat.Force12Hours,
            _b[TimeFormatUserPreference.Force24Hours] = localizationFramework.TimeFormat.Force24Hours,
            // Default if the user preference value is not a valid enum value at runtime
            _b[tsEnumUtil.$enum.handleUnexpected] = normalizedAccountConfigTimeFormat,
            _b));
    }, [props.isFeatureEnabled, props.accountConfigTimeFormat, savedTimeFormat]);
    return (React__namespace.default.createElement(localizationFramework.TimeFormatContext.Provider, { value: timeFormat }, props.children));
};

var I18n = function (props) {
    React.useEffect(function () {
        i18next__default.default.changeLanguage(props.language).then(function () {
            document.getElementsByTagName("body")[0].dir = "" + i18next__default.default.dir(props.language);
        });
    }, [props.language]);
    return null;
};

function renderSplashScreen() {
    return React__namespace.default.createElement(SplashScreen, null);
}
function PrivateRoute(props) {
    var _a;
    var _b;
    var Component = props.component, rest = __rest(props, ["component"]);
    var authStatus = useAuthenticationManagerStatus();
    var _c = (_b = props.location) !== null && _b !== void 0 ? _b : {}; _c.state; var restLocation = __rest(_c, ["state"]);
    return tsEnumUtil.$enum.visitValue(authStatus).with((_a = {},
        _a[AuthenticationStatus.Authenticated] = function () {
            return React__namespace.default.createElement(reactRouterDom.Route, __assign({ component: Component }, rest));
        },
        _a[AuthenticationStatus.MockAuthenticated] = function () {
            return React__namespace.default.createElement(reactRouterDom.Route, __assign({ component: Component }, rest));
        },
        _a[AuthenticationStatus.NotAuthenticated] = function () {
            if (window.cordova && hasSkipAccountSelection()) {
                console.log("[Auth] PrivateRoute: NotAuthenticated + cordova + hasSkipAccountSelection → redirecting to /login with skipAccountSelectionInput");
                clearSkipAccountSelection();
                return (React__namespace.default.createElement(reactRouterDom.Route, __assign({}, rest),
                    React__namespace.default.createElement(RouteContext.Consumer, null, function (routeContext) { return (React__namespace.default.createElement(reactRouterDom.Redirect, { to: {
                            pathname: routeContext.findRouteByName(RouteIds.Login),
                            search: "?" + SKIP_ACCOUNT_SELECTION_QUERY_PARAM + "=true",
                            state: { from: restLocation },
                        } })); })));
            }
            return (React__namespace.default.createElement(reactRouterDom.Route, __assign({}, rest),
                React__namespace.default.createElement(RouteContext.Consumer, null, function (routeContext) { return (React__namespace.default.createElement(reactRouterDom.Redirect, { to: {
                        pathname: routeContext.findRouteByName(RouteIds.Login),
                        state: { from: restLocation },
                    } })); })));
        },
        _a[AuthenticationStatus.Initializing] = renderSplashScreen,
        _a[AuthenticationStatus.LoggingOut] = renderSplashScreen,
        _a));
}

/**
 * An error page if AppPanel failed to load
 * @returns an error page
 */
var AppPanelError = function () {
    var translate = useTranslateFunction();
    return (React__namespace.default.createElement(ErrorPage, { showTakeHomeButton: true },
        React__namespace.default.createElement(StyledH2Typography, { use: "h2Light" }, translate("ERROR_PAGE.PAGE_NOT_FOUND")),
        React__namespace.default.createElement(StyledH3Typography, { use: "h3Light" }, translate("ERROR_PAGE.PERMISSION_DENIED")),
        React__namespace.default.createElement(StyledH3Typography, { use: "h3Light" }, translate("ERROR_PAGE.CONTACT_IT"))));
};

var ThemeWrapper = function (props) {
    var textDirection = localizationFramework.useTextDirection();
    return (React__namespace.default.createElement(lighthouseComponentLibrary.ComponentThemeProvider, { direction: textDirection, theme: props.theme }, props.children));
};

/**
 * @deprecated Exported only for unit test purposes
 */
var ApiErrorDialogTypography = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  margin: ", " ", ";\n"], ["\n  margin: ", " ", ";\n"])), polished.rem(10), polished.rem(20));
/**
 * ApiErrorDialog displays a modal dialog to
 * inform the user about specific API errors (GraphQL and REST). It provides detailed error
 * messages for various error types such as network failures, timeouts, incorrect
 * responses, or internal server errors.
 */
var ApiErrorDialog = function (props) {
    var translate = useTranslateFunction();
    var numberFormatter = localizationFramework.useNumberFormatter();
    var dialogTitle;
    var dialogContent;
    switch (props.error.type) {
        case exports.ApiErrorType.FAILED_TO_CONNECT:
            dialogTitle = translate("API_ERROR_DIALOG.FAILED_TO_CONNECT.TITLE");
            dialogContent = (React__namespace.default.createElement(React__namespace.default.Fragment, null,
                React__namespace.default.createElement(ApiErrorDialogTypography, { use: "body" }, translate("API_ERROR_DIALOG.FAILED_TO_CONNECT.SERVICE_NAME", {
                    serviceName: props.error.serviceName,
                })),
                React__namespace.default.createElement(ApiErrorDialogTypography, { use: "body" }, translate("API_ERROR_DIALOG.FAILED_TO_CONNECT.DESCRIPTION"))));
            break;
        case exports.ApiErrorType.TIMEOUT_ERROR:
            dialogTitle = translate("API_ERROR_DIALOG.TIME_OUT.TITLE");
            dialogContent = (React__namespace.default.createElement(React__namespace.default.Fragment, null,
                React__namespace.default.createElement(ApiErrorDialogTypography, { use: "body" }, translate("API_ERROR_DIALOG.TIME_OUT.SERVICE_NAME", {
                    serviceName: props.error.serviceName,
                })),
                React__namespace.default.createElement(ApiErrorDialogTypography, { use: "body" }, translate("API_ERROR_DIALOG.TIME_OUT.DESCRIPTION"))));
            break;
        case exports.ApiErrorType.BAD_RESPONSE_ERROR:
        case exports.ApiErrorType.BAD_REQUEST_ERROR:
        case exports.ApiErrorType.FORBIDDEN_ERROR:
        case exports.ApiErrorType.NOT_FOUND_ERROR:
        case exports.ApiErrorType.UNAUTHORIZED_ERROR:
            dialogTitle = translate("API_ERROR_DIALOG.INCORRECT_RESPONSE.TITLE");
            dialogContent = (React__namespace.default.createElement(React__namespace.default.Fragment, null,
                React__namespace.default.createElement(ApiErrorDialogTypography, { use: "body" }, translate("API_ERROR_DIALOG.INCORRECT_RESPONSE.SERVICE_NAME", {
                    serviceName: props.error.serviceName,
                })),
                React__namespace.default.createElement(ApiErrorDialogTypography, { use: "body" }, translate("API_ERROR_DIALOG.INCORRECT_RESPONSE.HTTP_STATUS_CODE", {
                    statusCode: numberFormatter.formatNumber(props.error.statusCode),
                })),
                React__namespace.default.createElement(ApiErrorDialogTypography, { use: "body" }, translate("API_ERROR_DIALOG.INCORRECT_RESPONSE.DESCRIPTION"))));
            break;
        case exports.ApiErrorType.INTERNAL_SERVER_ERROR:
            dialogTitle = translate("API_ERROR_DIALOG.INTERNAL_SERVER_ERROR.TITLE");
            dialogContent = props.error.errorId ? (React__namespace.default.createElement(React__namespace.default.Fragment, null,
                React__namespace.default.createElement(ApiErrorDialogTypography, { use: "body" }, translate("API_ERROR_DIALOG.INTERNAL_SERVER_ERROR.SERVICE_NAME", {
                    serviceName: props.error.serviceName,
                })),
                React__namespace.default.createElement(ApiErrorDialogTypography, { use: "body" }, props.error.errorId),
                React__namespace.default.createElement(ApiErrorDialogTypography, { use: "body" }, translate("API_ERROR_DIALOG.INTERNAL_SERVER_ERROR.DESCRIPTION")))) : (React__namespace.default.createElement(React__namespace.default.Fragment, null,
                React__namespace.default.createElement(ApiErrorDialogTypography, { use: "body" }, translate("API_ERROR_DIALOG.INTERNAL_SERVER_ERROR_WITHOUT_ERROR_ID.SERVICE_NAME", {
                    serviceName: props.error.serviceName,
                })),
                React__namespace.default.createElement(ApiErrorDialogTypography, { use: "body" }, translate("API_ERROR_DIALOG.INTERNAL_SERVER_ERROR_WITHOUT_ERROR_ID.DESCRIPTION"))));
            break;
        default:
            tsUtil.assertNever(props.error);
    }
    return (React__namespace.default.createElement(lighthouseComponentLibrary.Dialog, { open: props.isOpen, maxWidth: "sm", title: dialogTitle, variant: "error", onClose: function () { return props.onClose(); }, disablePadding: true, rightActions: React__namespace.default.createElement(lighthouseComponentLibrary.Button, { "data-qa": "error-dialog-close-button", type: "solid", "data-test-id": "error-dialog-close-button", onClick: function () { return props.onClose(); } }, translate("API_ERROR_DIALOG.ACTION.CLOSE")) }, dialogContent));
};
var templateObject_1$8;

var Modal = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Dialog)(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  & .MuiBackdrop-root {\n    backdrop-filter: blur(16px);\n    background: rgba(12, 17, 29, 0.7);\n  }\n  & .MuiDialog-paperFullScreen {\n    height: auto;\n    position: absolute;\n    bottom: 0;\n  }\n  &&& .username {\n    padding: ", " ", " !important;\n    gap: ", ";\n    & .MuiChip-label {\n      padding: 0 ", " !important;\n    }\n  }\n"], ["\n  & .MuiBackdrop-root {\n    backdrop-filter: blur(16px);\n    background: rgba(12, 17, 29, 0.7);\n  }\n  & .MuiDialog-paperFullScreen {\n    height: auto;\n    position: absolute;\n    bottom: 0;\n  }\n  &&& .username {\n    padding: ", " ", " !important;\n    gap: ", ";\n    & .MuiChip-label {\n      padding: 0 ", " !important;\n    }\n  }\n"])), polished.rem("3px"), polished.rem("4px"), polished.rem("8px"), polished.rem("4px"));
var ModalTitle$1 = lighthouseComponentLibrary.styled(DialogTitle$1)(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var Confirm = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Button)(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n  margin-left: ", " !important;\n"], ["\n  margin-left: ", " !important;\n"])), polished.rem("15px"));
var Description$1 = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n  margin-bottom: 0;\n"], ["\n  margin-bottom: 0;\n"])));
var PinModal = function (props) {
    var onClose = props.onClose, onConfirm = props.onConfirm, title = props.title, description = props.description, hideUsername = props.hideUsername, content = props.content;
    var identityToken = useAuthenticationManagerOidcUserInfo();
    var translate = useTranslateFunction();
    return (React__namespace.default.createElement(Modal, { open: true, disablePadding: true, fullScreen: true, rightActions: React__namespace.default.createElement(React__namespace.default.Fragment, null,
            React__namespace.default.createElement(lighthouseComponentLibrary.Button, { onClick: onClose, type: "outline" }, translate("PIN.BACK")),
            onConfirm ? (React__namespace.default.createElement(Confirm, { onClick: onConfirm }, translate("PIN.CONFIRM"))) : null) },
        React__namespace.default.createElement(ModalTitle$1, { disableTypography: true },
            React__namespace.default.createElement(lighthouseComponentLibrary.Typography, { use: "h2", disableMargins: true }, title),
            React__namespace.default.createElement("div", { style: { flex: 1 } }),
            React__namespace.default.createElement(lighthouseComponentLibrary.IconButton, { icon: "close", size: "medium", onClick: onClose })),
        React__namespace.default.createElement(DialogContent$1, null,
            hideUsername ? null : (React__namespace.default.createElement(lighthouseComponentLibrary.Chip, { className: "username", label: (identityToken === null || identityToken === void 0 ? void 0 : identityToken.preferred_username) || "", icon: React__namespace.default.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faUser }) })),
            content ? content : null,
            description ? (React__namespace.default.createElement(Description$1, { use: "body" }, description)) : null)));
};
var templateObject_1$7, templateObject_2$5, templateObject_3$4, templateObject_4$3;

var Details = lighthouseComponentLibrary.styled.div(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  background: ", ";\n  border: ", ";\n  padding: ", ";\n  border-radius: ", ";\n  margin-bottom: ", ";\n  &&& .detailsDescription {\n    margin-top: 0;\n  }\n  &&& .MuiButton-root {\n  padding: ", " ", "} !important;\n  }\n"], ["\n  background: ", ";\n  border: ",
    ";\n  padding: ", ";\n  border-radius: ", ";\n  margin-bottom: ", ";\n  &&& .detailsDescription {\n    margin-top: 0;\n  }\n  &&& .MuiButton-root {\n  padding: ", " ", "} !important;\n  }\n"])), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.grey.tone[50]; }, function (props) {
    return "1px solid  " + lighthouseComponentLibrary.getThemeFromProps(props).colours.grey.tone[200];
}, polished.rem("16px"), polished.rem("4px"), polished.rem("16px"), polished.rem("8px"), polished.rem("16px"));
var Description = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  background: ", ";\n  padding: ", ";\n  border-radius: ", ";\n"], ["\n  background: ", ";\n  padding: ", ";\n  border-radius: ", ";\n"])), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.grey.tone[50]; }, polished.rem("15px"), polished.rem("8px"));
var List = lighthouseComponentLibrary.styled.ul(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n  margin: 0;\n  padding-left: ", ";\n"], ["\n  margin: 0;\n  padding-left: ", ";\n"])), polished.rem("20px"));
var PinDetailsModal = function () {
    var translate = useTranslateFunction();
    var _a = React.useState(false), openMoreDetails = _a[0], setOpenMoreDetails = _a[1];
    var Content = (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        React__namespace.default.createElement(Description, { use: "body", disableMargins: true }, translate("PIN.MORE_DETAILS_MODAL.DESCRIPTION")),
        React__namespace.default.createElement(List, null,
            React__namespace.default.createElement("li", null,
                React__namespace.default.createElement(lighthouseComponentLibrary.Typography, { use: "body" }, translate("PIN.MORE_DETAILS_MODAL.INFO_SWITCH_USERS"))),
            React__namespace.default.createElement("li", null,
                React__namespace.default.createElement(lighthouseComponentLibrary.Typography, { use: "body" }, translate("PIN.MORE_DETAILS_MODAL.INFO_PIN_ATTEMPTS"))),
            React__namespace.default.createElement("li", null,
                React__namespace.default.createElement(lighthouseComponentLibrary.Typography, { use: "body" }, translate("PIN.MORE_DETAILS_MODAL.INFO_FORGOT_PIN"))))));
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        React__namespace.default.createElement(Details, null,
            React__namespace.default.createElement(lighthouseComponentLibrary.Typography, { use: "body", className: "detailsDescription" }, translate("PIN.YOUR_ACCOUNT_REQUIRES_PIN")),
            React__namespace.default.createElement(lighthouseComponentLibrary.Button, { onClick: function () { return setOpenMoreDetails(true); }, iconRight: freeSolidSvgIcons.faExclamationCircle, type: "outline" }, translate("PIN.MORE_DETAILS_MODAL.MORE_DETAILS"))),
        openMoreDetails ? (React__namespace.default.createElement(PinModal, { onClose: function () { return setOpenMoreDetails(false); }, title: translate("PIN.MORE_DETAILS_MODAL.MORE_DETAILS"), content: Content, hideUsername: true })) : null));
};
var templateObject_1$6, templateObject_2$4, templateObject_3$3;

var pinNumberToString = {
    1: "One",
    2: "Two",
};
var PIN_KEY = "pin";
var PIN_ATTEMPTS_KEY = "pin-attempts";
var MAX_PIN_ATTEMPTS = "3";
/**
 * Establishes and/or returns the Crypto Storage service used to save and load local encrypted data using IndexedDB
 * @param accountDetails - Account details i.e account id and user id
 */
var getCryptoStorage = function (accountDetails) {
    var baseKey = (accountDetails === null || accountDetails === void 0 ? void 0 : accountDetails.wfs_id) || "";
    var dbName = baseKey + (accountDetails === null || accountDetails === void 0 ? void 0 : accountDetails.account_internal_id);
    return new storage$1.CryptoStorage(baseKey, dbName);
};
/**
 * Loads and decrypts the stored data that matches PIN key.
 * @param accountDetails - Account details i.e account id and user id
 */
var getPin = function (accountDetails) { return __awaiter(void 0, void 0, void 0, function () {
    var cryptoStorage, pin;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                cryptoStorage = getCryptoStorage(accountDetails);
                return [4 /*yield*/, cryptoStorage.get(PIN_KEY)];
            case 1:
                pin = (_a.sent()) || "";
                return [2 /*return*/, pin];
        }
    });
}); };
/**
 * Encrypts and saves the PIN key and value.
 * @param accountDetails - Account details i.e account id and user id
 * @param pin - PIN number
 */
var setPin = function (accountDetails, pin) { return __awaiter(void 0, void 0, void 0, function () {
    var cryptoStorage;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                cryptoStorage = getCryptoStorage(accountDetails);
                return [4 /*yield*/, cryptoStorage.set(PIN_KEY, pin)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
/**
 * Loads and decrypts the stored pin attempts
 * @param accountDetails - Account details i.e account id and user id
 */
var getPinAttempts = function (accountDetails) { return __awaiter(void 0, void 0, void 0, function () {
    var cryptoStorage, pinAttempts;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                cryptoStorage = getCryptoStorage(accountDetails);
                return [4 /*yield*/, cryptoStorage.get(PIN_ATTEMPTS_KEY)];
            case 1:
                pinAttempts = (_a.sent()) || MAX_PIN_ATTEMPTS;
                return [2 /*return*/, [Number(pinAttempts), pinNumberToString === null || pinNumberToString === void 0 ? void 0 : pinNumberToString[Number(pinAttempts)]]];
        }
    });
}); };
/**
 * Encrypts and saves the pin attempts
 * @param accountDetails - Account details i.e account id and user id
 * @param attempt - PIN attempt value
 */
var setPinAttempts = function (accountDetails, attempt) { return __awaiter(void 0, void 0, void 0, function () {
    var cryptoStorage;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                cryptoStorage = getCryptoStorage(accountDetails);
                return [4 /*yield*/, cryptoStorage.set(PIN_ATTEMPTS_KEY, attempt)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
/**
 * Clean up encrypted pin attempt value
 * @param accountDetails - Account details i.e account id and user id
 */
var removePinAttempts = function (accountDetails) { return __awaiter(void 0, void 0, void 0, function () {
    var cryptoStorage;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                cryptoStorage = getCryptoStorage(accountDetails);
                return [4 /*yield*/, cryptoStorage.delete(PIN_ATTEMPTS_KEY)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
/**
 * Clean up encrypted data. Pin and pin attempts
 * @param accountDetails - Account details i.e account id and user id
 */
var removePin = function (accountDetails) { return __awaiter(void 0, void 0, void 0, function () {
    var cryptoStorage;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                cryptoStorage = getCryptoStorage(accountDetails);
                return [4 /*yield*/, cryptoStorage.clear()];
            case 1:
                _a.sent();
                return [4 /*yield*/, cryptoStorage.close()];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
/**
 * Checks if the PIN screen id="pin-modal" is removed from the body then logout
 * @param mutationList - List of mutation records
 * @param pinModal - The PIN modal element
 */
var pinContainerMutationCallback = function (mutationList, pinModal) {
    mutationList.forEach(function (mutation) {
        var isPinContainerRemoved = mutation.target === document.body &&
            Array.from(mutation.removedNodes).includes(pinModal);
        if (isPinContainerRemoved) {
            AuthenticationManager.getInstance().logout();
        }
    });
};
/**
 * Checks if the PIN container with id="pin-content" is removed
 * or the attributes were updated for the child node or pin container
 * @param mutationList - List of mutation records
 * @param childNode - The child node element
 */
var pinContentMutationCallback = function (mutationList, childNode) {
    var pinModal = document.getElementById("pin-modal");
    mutationList.forEach(function (mutation) {
        var isPinContainerRemoved = mutation.target === pinModal &&
            Array.from(mutation.removedNodes).includes(childNode);
        var isAttributesdUpdated = (mutation.target === childNode || mutation.target === pinModal) &&
            mutation.type === "attributes";
        if (isAttributesdUpdated || isPinContainerRemoved) {
            AuthenticationManager.getInstance().logout();
        }
    });
};

var ModalTitle = lighthouseComponentLibrary.styled(DialogTitle$1)(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  background: ", ";\n  & h3 {\n    margin-left: ", ";\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  background: ", ";\n  & h3 {\n    margin-left: ", ";\n  }\n"])), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.error.tone[50]; }, polished.rem("10px"));
var PinIncorrectModal = function (props) {
    var onClose = props.onClose;
    var translate = useTranslateFunction();
    var theme = useTheme();
    return (React__namespace.default.createElement(lighthouseComponentLibrary.Dialog, { open: true, disablePadding: true, variant: "error", rightActions: React__namespace.default.createElement(lighthouseComponentLibrary.Button, { onClick: onClose }, translate("PIN.I_UNDERSTAND")) },
        React__namespace.default.createElement(ModalTitle, { disableTypography: true },
            React__namespace.default.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faExclamationCircle, color: theme.colours.error.main, size: "lg" }),
            React__namespace.default.createElement(lighthouseComponentLibrary.Typography, { use: "h3", disableMargins: true }, translate("PIN.INCORRECT_PIN_TITLE")),
            React__namespace.default.createElement("div", { style: { flex: 1 } }),
            React__namespace.default.createElement(lighthouseComponentLibrary.IconButton, { icon: "close", size: "medium", onClick: onClose })),
        React__namespace.default.createElement(DialogContent$1, null,
            React__namespace.default.createElement(lighthouseComponentLibrary.Typography, { use: "body" }, translate("PIN.INCORRECT_PIN_DESCRIPTION")),
            React__namespace.default.createElement(lighthouseComponentLibrary.Typography, { use: "body" }, translate("PIN.INCORRECT_PIN_TEXT")))));
};
var templateObject_1$5;

var Container$2 = lighthouseComponentLibrary.styled.div(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  margin-top: ", ";\n  margin-bottom: ", ";\n  & .errorLabel {\n    color: ", ";\n  }\n"], ["\n  margin-top: ", ";\n  margin-bottom: ", ";\n  & .errorLabel {\n    color: ", ";\n  }\n"])), polished.rem("16px"), polished.rem("20px"), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.error.main; });
var Title$1 = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n"], ["\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n"])), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.black; }, polished.rem("14px"), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).type.fontWeights.semiBold; });
var PinForm = lighthouseComponentLibrary.styled.form(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  gap: ", ";\n  & .MuiFormControl-root {\n    align-items: center;\n  }\n  & .filled .MuiInputBase-root {\n    border: 2px solid\n      ", ";\n  }\n  & .MuiOutlinedInput-notchedOutline {\n    border: none;\n  }\n  & .MuiInputBase-root {\n    aspect-ratio: 1 / 1;\n    max-width: 100px;\n    border-radius: ", ";\n    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2);\n    border: 1px solid\n      ", ";\n    &.Mui-focused {\n      border: 2px solid\n        ", ";\n    }\n    & input {\n      font-size: ", ";\n      text-align: center;\n      padding: 0;\n      color: ", ";\n      height: auto !important;\n    }\n  }\n  & .MuiInputBase-root.Mui-error {\n    border-color: ", " !important;\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  gap: ", ";\n  & .MuiFormControl-root {\n    align-items: center;\n  }\n  & .filled .MuiInputBase-root {\n    border: 2px solid\n      ", ";\n  }\n  & .MuiOutlinedInput-notchedOutline {\n    border: none;\n  }\n  & .MuiInputBase-root {\n    aspect-ratio: 1 / 1;\n    max-width: 100px;\n    border-radius: ", ";\n    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2);\n    border: 1px solid\n      ", ";\n    &.Mui-focused {\n      border: 2px solid\n        ", ";\n    }\n    & input {\n      font-size: ", ";\n      text-align: center;\n      padding: 0;\n      color: ", ";\n      height: auto !important;\n    }\n  }\n  & .MuiInputBase-root.Mui-error {\n    border-color: ",
    " !important;\n  }\n"])), polished.rem("8px"), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.grey.tone[300]; }, polished.rem("8px"), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.grey.tone[300]; }, function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.primary.main; }, polished.rem("40px"), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.primary.tone[600]; }, function (props) {
    return lighthouseComponentLibrary.getThemeFromProps(props).colours.error.main;
});
var Actions = lighthouseComponentLibrary.styled.div(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: ", ";\n"])), polished.rem("50px"));
var Loading$1 = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Spinner)(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n  position: absolute;\n  background: rgba(255, 255, 255, 0.6);\n  width: 100%;\n  height: 100%;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n"], ["\n  position: absolute;\n  background: rgba(255, 255, 255, 0.6);\n  width: 100%;\n  height: 100%;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n"])));
var LOADING_TIMEOUT = 2000;
/**
 * Determines whether or not the current PIN is empty
 *
 * @param currentPin - Either "Enter your PIN" or "Confirm PIN" screen
 *
 * @returns {boolean}
 */
var isPinEmpty = function (currentPin) {
    return currentPin.every(function (digit) { return digit.length === 0; });
};
/**
 * Determines whether or not the PIN is has been entered
 *
 * @param currentPin - Either "Enter your PIN" or "Confirm PIN" screen
 *
 * @returns {boolean}
 */
var isPinEntered = function (currentPin) {
    return currentPin.every(function (digit) { return digit.length === 1; });
};
var PinContent = function (props) {
    var isPinCreation = props.isPinCreation, onClose = props.onClose, accountInfo = props.accountInfo, existingPin = props.existingPin;
    var translate = useTranslateFunction();
    var EMPTY_PIN = ["", "", "", ""];
    var _a = React.useState(EMPTY_PIN), pinNumber = _a[0], setPinNumber = _a[1];
    var _b = React.useState(EMPTY_PIN), confirmPinNumber = _b[0], setConfirmPinNumber = _b[1];
    var _c = React.useState(false), isConfirmingPin = _c[0], setIsConfirmingPin = _c[1];
    var _d = React.useState(false), isError = _d[0], setIsError = _d[1];
    var _e = React.useState(false), isLoading = _e[0], setIsLoading = _e[1];
    var _f = React.useState(false), isIncorrectPin = _f[0], setIsIncorrectPin = _f[1];
    var _g = React.useState([]), currentPinAttempts = _g[0], setCurrentPinAttempts = _g[1];
    var _h = React.useState(false), isForgotPin = _h[0], setIsForgotPin = _h[1];
    var pinRef = React.useRef([]);
    var confirmPinRef = React.useRef([]);
    var currentPin = isConfirmingPin ? confirmPinNumber : pinNumber;
    var currentPinRef = isConfirmingPin ? confirmPinRef : pinRef;
    React.useEffect(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var pinAttempts, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (isPinCreation) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, getPinAttempts(accountInfo)];
                    case 2:
                        pinAttempts = _a.sent();
                        setCurrentPinAttempts(pinAttempts);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error("Unable to get PIN Attempts", error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
    }, [pinNumber, isPinCreation]);
    React.useEffect(function () {
        // autofocus first input field if there is no pin
        if (isPinEmpty(currentPin)) {
            currentPinRef.current[0].focus();
        }
    }, [currentPin, isLoading]);
    React.useEffect(function () {
        // autofocus first input field if there is no pin
        if (isPinEmpty(currentPin)) {
            currentPinRef.current[0].focus();
        }
    }, [currentPin, isLoading]);
    var onPinValidateMatch = function () { return __awaiter(void 0, void 0, void 0, function () {
        var confirmPinTyped, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    confirmPinTyped = isConfirmingPin && isPinEntered(currentPin);
                    if (!confirmPinTyped) return [3 /*break*/, 6];
                    if (!(pinNumber.join("") === confirmPinNumber.join(""))) return [3 /*break*/, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, setPin(accountInfo, pinNumber.join(""))];
                case 2:
                    _a.sent();
                    onEnterApp();
                    setIsError(false);
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    console.error("Unable to set PIN", error_2);
                    return [3 /*break*/, 4];
                case 4: return [3 /*break*/, 6];
                case 5:
                    setIsError(true);
                    setConfirmPinNumber(EMPTY_PIN);
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var onEnterApp = function () {
        onShowLoading(function () { return onClose(); });
    };
    var onShowLoading = function (fn) {
        setIsLoading(true);
        setTimeout(function () {
            fn();
            setIsLoading(false);
        }, LOADING_TIMEOUT);
    };
    var expirePin = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, removePin(accountInfo)];
                case 1:
                    _a.sent();
                    setIsError(false);
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _a.sent();
                    console.error("Unable to remove PIN data", error_3);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onPinUnlock = function (pin) { return __awaiter(void 0, void 0, void 0, function () {
        var error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(isPinEntered(pin) && !isPinCreation)) return [3 /*break*/, 6];
                    if (!(pin.join("") === existingPin)) return [3 /*break*/, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, removePinAttempts(accountInfo)];
                case 2:
                    _a.sent();
                    setIsError(false);
                    onEnterApp();
                    return [3 /*break*/, 4];
                case 3:
                    error_4 = _a.sent();
                    console.error("Unable to remove PIN Attempt", error_4);
                    return [3 /*break*/, 4];
                case 4: return [3 /*break*/, 6];
                case 5:
                    if (currentPinAttempts[0] === 1) {
                        onShowLoading(function () {
                            expirePin();
                            setIsIncorrectPin(true);
                        });
                        return [2 /*return*/];
                    }
                    onShowLoading(function () { return __awaiter(void 0, void 0, void 0, function () {
                        var error_5;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    setIsError(true);
                                    setPinNumber(EMPTY_PIN);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, setPinAttempts(accountInfo, (currentPinAttempts[0] - 1).toString())];
                                case 2:
                                    _a.sent();
                                    setCurrentPinAttempts([
                                        currentPinAttempts[0] - 1,
                                        pinNumberToString === null || pinNumberToString === void 0 ? void 0 : pinNumberToString[Number(currentPinAttempts[0] - 1)],
                                    ]);
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_5 = _a.sent();
                                    console.error("Unable to set PIN Attempt", error_5);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); });
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var onFocusPrevInput = function (key, index) {
        // focus previous input
        if (key === "Backspace" && !currentPin[index] && index > 0) {
            currentPinRef.current[index - 1].focus();
            selectContent(currentPinRef.current[index - 1]);
        }
    };
    var selectContent = function (target) {
        var input = target;
        setTimeout(function () {
            input.setSelectionRange(0, input.value.length);
        }, 0);
    };
    var focusNextInput = function (value, index) {
        // focus next input
        if (value !== "" && index < 3) {
            currentPinRef.current[index + 1].focus();
            selectContent(currentPinRef.current[index + 1]);
        }
    };
    var onEnterPin = function (targetElement, index) {
        var target = targetElement;
        var value = target.value;
        var newPinNumber = __spreadArrays(currentPin);
        var isOneNumericDigit = /^[0-9]$/.test(value);
        if (isOneNumericDigit || value === "") {
            newPinNumber[index] = value;
            isConfirmingPin
                ? setConfirmPinNumber(newPinNumber)
                : setPinNumber(newPinNumber);
            focusNextInput(value, index);
            // It goes to the confirm PIN screen only if it's the PIN creation flow
            if (isPinEntered(newPinNumber) && !isConfirmingPin && isPinCreation) {
                onShowLoading(function () { return setIsConfirmingPin(true); });
            }
            onPinUnlock(newPinNumber);
        }
    };
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        React__namespace.default.createElement(Container$2, null,
            React__namespace.default.createElement(Title$1, { use: "body", disableMargins: true }, translate("" + (isConfirmingPin ? "PIN.CONFIRM_YOUR_PIN" : "PIN.ENTER_YOUR_PIN"))),
            React__namespace.default.createElement(PinForm, { autoComplete: "new-password" }, currentPin.map(function (pinDigit, index) { return (React__namespace.default.createElement(lighthouseComponentLibrary.TextField, { className: pinDigit.length > 0 ? "filled" : "", disabled: isLoading, name: "pin", onFocus: function (e) { return selectContent(e.currentTarget); }, error: isError, key: index, inputRef: function (input) {
                    return (currentPinRef.current[index] = input);
                }, type: "password", inputProps: {
                    pattern: "[0-9]",
                    maxLength: "1",
                    onContextMenu: function (e) { return e.preventDefault(); },
                    inputMode: "numeric",
                    onKeyUp: function () { return onPinValidateMatch(); },
                    onPointerUp: function (e) { return selectContent(e.currentTarget); },
                    onPaste: function (e) { return e.preventDefault(); },
                    onInput: function (e) { return onEnterPin(e.target, index); },
                }, onKeyDown: function (e) { return onFocusPrevInput(e.key, index); }, value: pinDigit })); })),
            isError ? (React__namespace.default.createElement(lighthouseComponentLibrary.Typography, { use: "body", className: "errorLabel" }, translate(isConfirmingPin
                ? "PIN.PIN_DID_NOT_MATCH"
                : currentPinAttempts[0] === 1
                    ? "PIN.INCORRECT_PIN_FINAL_ATTEMPT"
                    : "PIN.INCORRECT_PIN", { numAttempts: currentPinAttempts[1] }))) : null,
            React__namespace.default.createElement(Actions, null,
                isConfirmingPin ? (React__namespace.default.createElement(lighthouseComponentLibrary.Button, { disabled: isLoading, text: translate("PIN.BACK"), type: "outline", onClick: function () {
                        setIsConfirmingPin(false);
                        setPinNumber(EMPTY_PIN);
                        setConfirmPinNumber(EMPTY_PIN);
                        if (isError) {
                            setIsError(false);
                        }
                    } })) : null,
                React__namespace.default.createElement("div", { style: { flex: 1 } }),
                isPinCreation ? null : (React__namespace.default.createElement(lighthouseComponentLibrary.Button, { disabled: isLoading, text: translate("PIN.FORGOT_PIN"), type: "text", onClick: function () { return setIsForgotPin(true); } }))),
            isLoading ? React__namespace.default.createElement(Loading$1, null) : null),
        isIncorrectPin ? (React__namespace.default.createElement(PinIncorrectModal, { onClose: function () { return AuthenticationManager.getInstance().logout(); } })) : null,
        isForgotPin ? (React__namespace.default.createElement(PinModal, { title: translate("PIN.FORGOT_PIN"), description: translate("PIN.CREATE_NEW_PIN"), onClose: function () { return setIsForgotPin(false); }, onConfirm: function () {
                expirePin();
                AuthenticationManager.getInstance().logout();
            } })) : null));
};
var templateObject_1$4, templateObject_2$3, templateObject_3$2, templateObject_4$2, templateObject_5$2;

var Container$1 = lighthouseComponentLibrary.styled.div(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  padding: 0 ", ";\n  overflow: hidden;\n  padding-top: env(safe-area-inset-top, ", ");\n  padding-bottom: env(safe-area-inset-bottom, ", ");\n  position: fixed;\n  top: 0;\n  height: 100%;\n  width: -webkit-fill-available;\n  background: ", ";\n  z-index: 999;\n\n  &&& .username {\n    padding: ", " ", " !important;\n    gap: ", ";\n    & .MuiChip-label {\n      padding: 0 ", " !important;\n    }\n  }\n  &&& .MuiButton-root {\n    padding: ", " ", " !important;\n  }\n"], ["\n  padding: 0 ", ";\n  overflow: hidden;\n  padding-top: env(safe-area-inset-top, ", ");\n  padding-bottom: env(safe-area-inset-bottom, ", ");\n  position: fixed;\n  top: 0;\n  height: 100%;\n  width: -webkit-fill-available;\n  background: ", ";\n  z-index: 999;\n\n  &&& .username {\n    padding: ", " ", " !important;\n    gap: ", ";\n    & .MuiChip-label {\n      padding: 0 ", " !important;\n    }\n  }\n  &&& .MuiButton-root {\n    padding: ", " ", " !important;\n  }\n"])), polished.rem("30px"), polished.rem("16px"), polished.rem("16px"), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.white; }, polished.rem("3px"), polished.rem("4px"), polished.rem("8px"), polished.rem("4px"), polished.rem("8px"), polished.rem("16px"));
var Title = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  font-size: ", ";\n"], ["\n  font-size: ", ";\n"])), polished.rem("22.78px"));
var WelcomeLabel = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  margin-bottom: ", ";\n  color: ", ";\n"], ["\n  margin-bottom: ", ";\n  color: ", ";\n"])), polished.rem("30px"), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.grey.main; });
var SwitchUser = lighthouseComponentLibrary.styled.div(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n"])), polished.rem("4px"));
var Loading = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Spinner)(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n  position: absolute;\n  background: ", ";\n  width: 100%;\n  height: 100%;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1;\n"], ["\n  position: absolute;\n  background: ", ";\n  width: 100%;\n  height: 100%;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1;\n"])), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.white; });
var Pin = function (props) {
    var close = props.close;
    var _a = React.useState(false), isSwitchUser = _a[0], setIsSwitchUser = _a[1];
    var translate = useTranslateFunction();
    var identityToken = useAuthenticationManagerOidcUserInfo();
    var _b = React.useState(""), existingPin = _b[0], setExistingPin = _b[1];
    var _c = React.useState(true), isLoading = _c[0], setIsLoading = _c[1];
    React.useEffect(function () {
        var pinModal = document.getElementById("pin-modal");
        var pinContent = document.getElementById("pin-content");
        var observer = new MutationObserver(function (mutationList) {
            return pinContentMutationCallback(mutationList, pinContent);
        });
        // Observe the pinModal for changes in its attributes and child elements
        observer.observe(pinModal, {
            attributeFilter: ["style", "class"],
            attributes: true,
            childList: true,
            subtree: true,
        });
        return function () {
            observer.disconnect();
        };
    }, []);
    React.useEffect(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var pin, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getPin(identityToken)];
                    case 1:
                        pin = _a.sent();
                        setExistingPin(pin);
                        setIsLoading(false);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error("Unable to get PIN", error_1);
                        setIsLoading(false);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); })();
    }, []);
    // It will be false if there is an existing PIN set up
    var isCreatingPin = !existingPin;
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        React__namespace.default.createElement(Container$1, { id: "pin-content" },
            isLoading ? React__namespace.default.createElement(Loading, null) : null,
            React__namespace.default.createElement(Title, { use: "h3" }, translate("" + (isCreatingPin ? "PIN.CREATE_PIN" : "PIN.WELCOME_BACK"))),
            isCreatingPin ? React__namespace.default.createElement(PinDetailsModal, null) : null,
            isCreatingPin ? null : (React__namespace.default.createElement(WelcomeLabel, { use: "body" }, translate("PIN.ENTER_CREATED_PIN"))),
            React__namespace.default.createElement(SwitchUser, null,
                React__namespace.default.createElement(lighthouseComponentLibrary.Chip, { className: "username", label: (identityToken === null || identityToken === void 0 ? void 0 : identityToken.preferred_username) || "", icon: React__namespace.default.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faUser }) }),
                isCreatingPin ? null : (React__namespace.default.createElement(lighthouseComponentLibrary.Button, { text: translate("PIN.SWITCH_USER"), type: "text", onClick: function () { return setIsSwitchUser(true); } }))),
            React__namespace.default.createElement(PinContent, { onClose: close, isPinCreation: isCreatingPin, accountInfo: identityToken, existingPin: existingPin })),
        isSwitchUser ? (React__namespace.default.createElement(PinModal, { title: translate("PIN.SWITCH_USER"), onClose: function () { return setIsSwitchUser(false); }, description: translate("PIN.USER_WILL_BE_LOGGED_OUT"), onConfirm: function () { return __awaiter(void 0, void 0, void 0, function () {
                var error_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, removePinAttempts(identityToken)];
                        case 1:
                            _a.sent();
                            AuthenticationManager.getInstance().logout();
                            return [3 /*break*/, 3];
                        case 2:
                            error_2 = _a.sent();
                            console.error("Unable to remove PIN Attempt", error_2);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); } })) : null));
};
var templateObject_1$3, templateObject_2$2, templateObject_3$1, templateObject_4$1, templateObject_5$1;

/**
 * This component should be rendered when the parent component wishes to
 * initiate a cross-origin logout with a given url and wishes to execute an
 * (optional) callback upon completion
 * The logout url gets rendered as an iframe. This allows the browser to send
 * session cookies for any origin, regardless of whether or not it matches the
 * Suite's origin.
 * @param logoutUrl
 * @param onComplete
 * @constructor
 */
var CrossOriginLogout = function (_a) {
    var logoutUrl = _a.logoutUrl, onComplete = _a.onComplete;
    var timeoutIdRef = React.useRef();
    var iframeRef = React.useCallback(function (iframe) {
        if (timeoutIdRef.current) {
            clearTimeout(timeoutIdRef.current);
            timeoutIdRef.current = undefined;
        }
        if (!iframe) {
            return;
        }
        var completed = false;
        // The caller of onComplete
        var handleComplete = function () {
            // Never call onComplete twice
            if (completed) {
                return;
            }
            completed = true;
            onComplete === null || onComplete === void 0 ? void 0 : onComplete();
        };
        var handleLoad = function () {
            console.log("WTA logout successful");
            handleComplete();
        };
        var handleError = function (error) {
            console.error("Encountered an error while attempting to log out of WTA:");
            console.error(error);
            handleComplete();
        };
        iframe.onload = handleLoad;
        iframe.onerror = handleError;
        // Fallback mechanism in case the url is extremely unresponsive for some
        // reason. Ideally we should never have to do this but...
        // Let's just be on the safe side. :D
        timeoutIdRef.current = window.setTimeout(handleComplete, 5000);
    }, [onComplete]);
    return (React__namespace.default.createElement("iframe", { ref: iframeRef, src: logoutUrl, style: { display: "none" }, "aria-hidden": "true", tabIndex: -1, sandbox: "" }));
};

/**
 * Useful utility function for determining whether or not we are the leader tab
 * This is superior to calling the authenticationManager method directly because
 * it is easier to mock in unit tests
 */
function getLeaderTabStatus() {
    var authenticationManager = AuthenticationManager.getInstance();
    return authenticationManager.getLeaderTabStatus();
}

/**
 * Useful utility function for determining whether or not we are using
 * the OIDC auth flow implementation.
 * This is superior to calling the authenticationManager method directly because
 * it is easier to mock in unit tests
 */
function getIsOidcAuthFlow() {
    var authenticationManager = AuthenticationManager.getInstance();
    return authenticationManager.getIsOidcAuthFlow();
}

/**
 * Custom React hook to determine and apply the currently selected theme for the application.
 *
 * This hook selects the appropriate theme based on user preferences, preview mode, and account-level settings.
 * If the "Account Custom Theme" feature is enabled and the account theme is set to a custom value, it fetches
 * the custom theme JSON from a remote source and applies it dynamically.
 *
 * @param params
 * @param params.userPreferenceThemeFF - Feature flag indicating if user preference themes are enabled.
 * @param params.isAccountCustomThemeEnabled - Feature flag indicating if account custom themes are enabled.
 * @param params.isADPCustomThemeEnabled - Feature flag indicating if ADP custom themes are enabled.
 * @param params.previewTheme
 * @param params.theme - The user's selected theme.
 * @param params.accountTheme - The theme set at the account level, or null if not set.
 * @returns The selected theme object, which conforms to the `ThemeInterface`.
 *
 * @remarks
 * - If a preview theme is provided, it takes precedence.
 * - If the user preference theme feature flag is enabled, the user's selected theme is used.
 * - If the account theme is set to a custom theme and the feature flag is enabled, the custom theme is fetched and applied.
 * - Falls back to the default theme if none of the above conditions are met.
 */
function useSelectedTheme(_a) {
    var _this = this;
    var userPreferenceThemeFF = _a.userPreferenceThemeFF, isAccountCustomThemeEnabled = _a.isAccountCustomThemeEnabled, isADPCustomThemeEnabled = _a.isADPCustomThemeEnabled, previewTheme = _a.previewTheme, theme = _a.theme, accountTheme = _a.accountTheme;
    var dispatch = reactRedux.useDispatch();
    var _b = React.useState(lighthouseComponentLibrary.getThemesInformation()[CoreThemes.DefaultTheme]), selectedTheme = _b[0], setSelectedTheme = _b[1];
    React.useEffect(function () {
        var userTheme = "";
        if (userPreferenceThemeFF) {
            userTheme = theme;
        }
        var themeInformation = lighthouseComponentLibrary.getThemesInformation()[previewTheme || userTheme || accountTheme || CoreThemes.DefaultTheme];
        var authManager = AuthenticationManager.getInstance();
        var accountInfo = authManager.getAccountInfo();
        var organizationId = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.organizationId;
        var accountId = getAccountId(organizationId || "");
        if (!themeInformation ||
            (themeInformation.id === "adpBlueTheme" /* AdpBlueTheme */ &&
                !isADPCustomThemeEnabled) ||
            (themeInformation.id === "customAccountTheme" /* CustomAccountTheme */ &&
                !isAccountCustomThemeEnabled)) {
            // If the themeInformation is not found, we default to the DefaultTheme
            themeInformation = lighthouseComponentLibrary.getThemesInformation()[CoreThemes.DefaultTheme];
            dispatch({
                type: exports.AccountThemeActionTypes.SetAccountTheme,
                accountTheme: {
                    themeKey: CoreThemes.DefaultTheme,
                    themeName: CoreThemes.DefaultTheme,
                },
            });
            setSelectedTheme(lighthouseComponentLibrary.getThemesInformation()[CoreThemes.DefaultTheme]);
        }
        // If the Account Custom Theme feature flag is enabled, the account theme is set to CustomAccountTheme,
        // and an account ID exists, fetch the custom theme JSON from the CDN and apply it.
        if (isAccountCustomThemeEnabled &&
            accountTheme === "customAccountTheme" /* CustomAccountTheme */.toString() &&
            accountId) {
            // Custom theme URL patterns based on environment:
            // https://themes.wfs.cloud - prod
            // https://themes.latest.wfs.cloud - dit
            // https://themes.sprint.wfs.cloud - fit
            // https://themes.uat.wfs.cloud - uat
            var environment = getEnvironment(organizationId || "");
            // Construct the theme URL based on the account ID and environment
            // Example: https://themes.latest.wfs.cloud/wfx_triforce/theme.json
            var themeURL_1 = "https://themes" + (environment ? "." + environment : "") + ".wfs.cloud/" + accountId + "/theme.json";
            // Fetch and apply the custom theme
            (function () { return __awaiter(_this, void 0, void 0, function () {
                var response, themeJson;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log("Fetching custom theme: ", themeURL_1);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 4, , 5]);
                            return [4 /*yield*/, fetch(themeURL_1)];
                        case 2:
                            response = _a.sent();
                            if (!response.ok) {
                                throw new Error("Failed to fetch theme JSON from " + themeURL_1);
                            }
                            return [4 /*yield*/, response.json()];
                        case 3:
                            themeJson = (_a.sent());
                            setSelectedTheme(lighthouseComponentLibrary.applyCustomTheme(themeJson));
                            return [3 /*break*/, 5];
                        case 4:
                            _a.sent();
                            setSelectedTheme(themeInformation);
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            }); })();
        }
        else {
            setSelectedTheme(themeInformation);
        }
    }, [
        userPreferenceThemeFF,
        isAccountCustomThemeEnabled,
        isADPCustomThemeEnabled,
        previewTheme,
        theme,
        accountTheme,
    ]);
    return selectedTheme;
}

var StyledDiv = lighthouseComponentLibrary.styled.div(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  gap: ", ";\n  flex-wrap: wrap;\n\n  .MuiButtonBase-root {\n    flex: 1 0 auto;\n  }\n\n  @media (max-width: 400px) {\n    .MuiButtonBase-root {\n      flex-basis: max-content;\n    }\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  gap: ", ";\n  flex-wrap: wrap;\n\n  .MuiButtonBase-root {\n    flex: 1 0 auto;\n  }\n\n  @media (max-width: 400px) {\n    .MuiButtonBase-root {\n      flex-basis: max-content;\n    }\n  }\n"])), polished.rem("16px"));
var WarningDialog = function (props) {
    var onClose = props.onClose, onDismiss = props.onDismiss;
    var translate = useTranslateFunction();
    return (React__namespace.default.createElement(lighthouseComponentLibrary.Dialog, { open: true, disablePadding: true, title: translate("SESSION_INACTIVITY.WARNING_DIALOG.TITLE"), variant: "warning", className: "warning-dialog-class", rightActions: React__namespace.default.createElement(StyledDiv, { className: "rightAction_div" },
            React__namespace.default.createElement(lighthouseComponentLibrary.Button, { "data-qa": "logout-button", type: "outline", onClick: onClose }, translate("SESSION_INACTIVITY.WARNING_DIALOG.LOG_OUT")),
            React__namespace.default.createElement(lighthouseComponentLibrary.Button, { "data-qa": "dismiss-button", onClick: onDismiss }, translate("SESSION_INACTIVITY.WARNING_DIALOG.I_AM_STILL_HERE"))) },
        React__namespace.default.createElement(DialogContent$1, null, translate("SESSION_INACTIVITY.WARNING_DIALOG.DESCRIPTION"))));
};
var templateObject_1$2;

// Timer settings
var timeout = 20 * 60 * 1000; // Total time before idle
var promptBeforeIdle = 5 * 60 * 1000; // Time while prompt will be active
var throttle = 1000; // Throttle value to prevent overload of onAction calls
var eventsThrottle = 1000; // Prevents overload of events, saves CPU
var events = [
    "mousemove",
    "keydown",
    "wheel",
    "mousedown",
    "touchstart",
    "touchmove",
    "visibilitychange",
    "scroll",
];
/**
 * Suite inactivity timer that prompts the user to confirm that they're still
 * here after X amount of time. If they don't respond in Y amount of time,
 * they get automatically get logged out.
 *
 * In the final implementation:
 * X+Y = total inactivity timeout = 20 minutes
 * X = time before prompt = 15 minutes
 *
 * Change the settings above to make this case, but until then,
 * we run with X = Y = 15 seconds to simplify testing
 *
 * Much of this is implemented using the example from the documentation:
 * https://idletimer.dev/docs/getting-started/new#integrated-prompting
 */
var SuiteInactivityTimer = function (props) {
    var _a = React.useState(false), showPrompt = _a[0], setShowPrompt = _a[1];
    var dispatch = reactRedux.useDispatch();
    var externalUserActivityEventPublisher = useExternalUserActivityEventPublisher();
    // All events are disabled while the prompt is active except onAction and onMessage.
    var onPrompt = React.useCallback(function () {
        setShowPrompt(true);
    }, []);
    // onActive will only be called if `activate()` is called while `isPrompted()`is true
    var onActive = React.useCallback(function () {
        setShowPrompt(false);
    }, []);
    var onIdle = React.useCallback(function () {
        setShowPrompt(false);
        AuthenticationManager.getInstance().logout({ withoutToken: true });
        !hasSkipAccountSelection() && dispatch(showAlert());
    }, []);
    var onMessage = React.useCallback(function (data) {
        switch (data.action) {
            case CROSS_TAB_REFRESH:
                if (showPrompt) {
                    setShowPrompt(false);
                }
                break;
            case CROSS_TAB_LOGOUT:
                setShowPrompt(false);
                AuthenticationManager.getInstance().logout();
                break;
            default:
                console.error("Unknown message action received:", data.action);
                break;
        }
    }, [showPrompt]);
    var idleTimer = reactIdleTimer.useIdleTimer({
        disabled: !props.enabled,
        timeout: timeout,
        promptBeforeIdle: promptBeforeIdle,
        throttle: throttle,
        eventsThrottle: eventsThrottle,
        events: events,
        onActive: onActive,
        onPrompt: onPrompt,
        onIdle: onIdle,
        onMessage: onMessage,
        crossTab: true,
        syncTimers: 1000,
    });
    // Rudimentary implementation of still here and cordova app deeplinks
    var handleStillHere = function () {
        idleTimer.activate();
    };
    // Rudimentary implementation of user triggered logout
    var handleLogout = function () {
        idleTimer.message({ action: CROSS_TAB_LOGOUT }, true);
    };
    React.useEffect(function () {
        if (isCordovaDevice()) {
            window.addEventListener("push-notification", handleStillHere);
            window.addEventListener("handleDeeplinkEvent", handleStillHere);
            return function () {
                window.removeEventListener("push-notification", handleStillHere);
                window.removeEventListener("handleDeeplinkEvent", handleStillHere);
            };
        }
        return;
    }, [handleStillHere]);
    React.useEffect(function () {
        if (!isCordovaDevice()) {
            idleTimer.message({ action: CROSS_TAB_REFRESH });
        }
    }, []);
    React.useEffect(function () {
        return externalUserActivityEventPublisher.subscribe(function () {
            handleStillHere();
        });
    }, [handleStillHere, externalUserActivityEventPublisher]);
    return showPrompt ? (React__namespace.default.createElement(WarningDialog, { onDismiss: handleStillHere, onClose: handleLogout })) : null;
};

/**
 * Module-level cache for ADP region and environment data, keyed by host string.
 * Ensures extraction from a given host occurs only once per session.
 */
var cachedAdpRegionEnvData = {};
/**
 * Parses the given hostname to extract ADP environment and region information.
 * Handles both <environment>.wfs.<region>.adp.com and wfs.<region>.adp.com (production) formats.
 * Throws an error if extraction fails.
 *
 * @param host - The hostname to parse (e.g., "dit.wfs.na.adp.com" or "wfs.na.adp.com").
 * @returns The extracted ADP region and environment data.
 * @throws {Error} If the hostname does not match expected ADP patterns.
 * @private
 */
function extractAdpRegionEnvData(host) {
    // Match <environment>.wfs.<region>.adp.com
    var regexWithEnv = /^([^.]+)\.wfs\.([^.]+)\.adp\.com$/;
    var matchWithEnv = host.match(regexWithEnv);
    if (matchWithEnv) {
        return {
            environment: matchWithEnv[1],
            region: matchWithEnv[2],
        };
    }
    // Match wfs.<region>.adp.com (prod)
    var regexProd = /^wfs\.([^.]+)\.adp\.com$/;
    var matchProd = host.match(regexProd);
    if (matchProd) {
        return {
            environment: AdpEnvironment.PROD,
            region: matchProd[1],
        };
    }
    throw new Error("Unable to extract ADP region and environment from host: " + host);
}
/**
 * Retrieves the ADP region and environment data for the given host string.
 *
 * If the data for the host has already been extracted and cached, returns the cached value.
 * Otherwise, attempts to extract the data from the provided host,
 * caches it, and returns it. Throws an error if extraction fails or if the host is unavailable.
 *
 * @param host - The hostname to parse (e.g., "dit.wfs.na.adp.com" or "wfs.na.adp.com").
 * @returns The ADP region and environment data for the given host.
 * @throws {Error} If the host is unavailable or extraction fails.
 */
function getAdpRegionEnvData(host) {
    if (!host) {
        throw new Error("No host provided to extract ADP region and environment.");
    }
    if (cachedAdpRegionEnvData[host]) {
        return cachedAdpRegionEnvData[host];
    }
    var data = extractAdpRegionEnvData(host);
    cachedAdpRegionEnvData[host] = data;
    return data;
}

/**
 * Since AppPanel is outside of Router, we need a react-friendly
 * way to notify it when the route matches WTA_TOKEN_LOGIN_ROUTE
 * This component can also be reused or enhanced for future router-aware
 * communication with its parent component AppPanel. However, note that
 * this component is a necessary evil due to the current architecture.
 * The most simple and future-proof thing to do would be to move all AppPanel
 * initialization code inside of the ConnectedRouter component so we don't have
 * to rely on state lifting.
 * Since we don't have time to do that refactor, we're introducing this
 * component instead as an acceptable workaround.
 * @param onRouteMatch
 * @constructor
 */
var RouteAwareAuthInit = function (_a) {
    var onAccountIdFromRoute = _a.onAccountIdFromRoute, onAuthFlowStateDetermined = _a.onAuthFlowStateDetermined;
    var _b;
    var dispatch = reactRedux.useDispatch();
    var match = reactRouterDom.useRouteMatch(WTA_TOKEN_LOGIN_ROUTE);
    var logoutRouteMatch = reactRouterDom.useRouteMatch(LOGOUT_ROUTE);
    var redirectBackRoute = useTypedSelector(selectRedirectBackRoute);
    var isRedirectBackRouteWtaLogin = typeof redirectBackRoute === "string" &&
        /^\/login\/wta\/[^/]+$/.test(redirectBackRoute);
    React.useEffect(function () {
        var _a, _b;
        // If the redirectBackRoute matches the pattern, force this component to re-render with new route match info
        // An early return is necessary here to avoid calling onAccountIdFromRoute incorrectly
        var currentlyOnWtaTokenLoginRoute = !!(match && match.isExact);
        var currentlyOnLogoutRoute = !!(logoutRouteMatch && logoutRouteMatch.isExact);
        // Never follow a stale redirectBackRoute while on the logout route — doing so
        // would bypass WtaAimLogout entirely and cause re-authentication.
        if (currentlyOnLogoutRoute &&
            redirectBackRoute &&
            isRedirectBackRouteWtaLogin) {
            dispatch(clearRedirectBackRoute());
            return;
        }
        if (!currentlyOnWtaTokenLoginRoute &&
            redirectBackRoute &&
            isRedirectBackRouteWtaLogin) {
            dispatch(clearRedirectBackRoute());
            var persistor = getPersistor();
            persistor
                .flush()
                .catch(function (e) {
                console.warn("Error flushing persistor before redirect:", e);
            })
                .finally(function () {
                dispatch(connectedReactRouter.push(redirectBackRoute));
            });
            return;
        }
        onAccountIdFromRoute((_b = (_a = match === null || match === void 0 ? void 0 : match.params) === null || _a === void 0 ? void 0 : _a.accountId) !== null && _b !== void 0 ? _b : "");
        if (isSuiteOnAdpUrl()) {
            try {
                var adpRegionEnvData = getAdpRegionEnvData(getSuiteUrl());
                onAuthFlowStateDetermined({ flow: AuthFlow.Adp, adpRegionEnvData: adpRegionEnvData });
            }
            catch (e) {
                onAuthFlowStateDetermined({ flow: AuthFlow.Error, error: e });
            }
        }
        else {
            onAuthFlowStateDetermined({ flow: AuthFlow.Legacy });
        }
    }, [
        (_b = match === null || match === void 0 ? void 0 : match.params) === null || _b === void 0 ? void 0 : _b.accountId,
        match === null || match === void 0 ? void 0 : match.isExact,
        logoutRouteMatch === null || logoutRouteMatch === void 0 ? void 0 : logoutRouteMatch.isExact,
        onAccountIdFromRoute,
        onAuthFlowStateDetermined,
        redirectBackRoute,
        isRedirectBackRouteWtaLogin,
        dispatch,
    ]);
    return null;
};

/**
 * Lighthouse implementation of the shared shell `AppShell` contract.
 *
 * This class provides app-level shell services such as locale retrieval,
 * user identity, HTTP client access, and permission-based link checks.
 * Some methods are currently placeholders and intentionally reject until
 * integrated with the host shell.
 */
var LthAppShellImpl = /** @class */ (function () {
    function LthAppShellImpl() {
        var _this = this;
        /**
         * Returns the current application locale.
         *
         * The value is read from framework state and falls back to
         * `appDefaultLocale` when no locale is present.
         *
         * @see NOTE: It may be that MFEs expect the locale to be returned lowercase,
         *    e.g., "en-us" instead of "en-US".
         * @returns A promise resolving to the active locale string.
         */
        this.getLocale = function () {
            var state = getFrameworkInstance().getStore().getState();
            var locale = state.appLocalizationData.locale || appDefaultLocale;
            console.log("LthAppShellImpl.getLocale(): returning " + locale);
            return Promise.resolve(locale);
        };
        /**
         * Returns the current authenticated user identity.
         *
         * @returns A promise resolving to `Self`.
         * @throws Error Always throws until shell identity integration is implemented.
         */
        this.getSelf = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // TODO: replace with real shell identity lookup
                return [2 /*return*/, Promise.reject(new Error("LthAppShellImpl.getSelf is not implemented."))];
            });
        }); };
        /**
         * Returns a shell-provided HTTP client.
         *
         * @returns A promise resolving to an `HttpClient` instance.
         * @throws Error Always throws until shell HTTP client integration is implemented.
         */
        this.getHttpClient = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // TODO: replace with real shell HttpClient
                return [2 /*return*/, Promise.reject(new Error("LthAppShellImpl.getHttpClient is not implemented."))];
            });
        }); };
        /**
         * Returns navigation links available for the given permission.
         *
         * @param permission Permission used to filter or resolve links.
         * @returns A promise resolving to an array of `Link` objects.
         * @throws Error Always throws until shell link lookup integration is implemented.
         */
        this.getLinks = function (permission) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // TODO: replace with real shell Link lookup
                return [2 /*return*/, Promise.reject(new Error("LthAppShellImpl.getLinks is not implemented."))];
            });
        }); };
        /**
         * Indicates whether the given permission is granted.
         *
         * @param permission Permission to evaluate.
         * @returns A promise resolving to `true` if permitted; otherwise `false`.
         * @throws Error Always throws until shell permission integration is implemented.
         */
        this.isPermitted = function (permission) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // TODO: replace with real shell permission check
                return [2 /*return*/, Promise.reject(new Error("LthAppShellImpl.isPermitted is not implemented."))];
            });
        }); };
    }
    return LthAppShellImpl;
}());

/**
 * specifies a className/css selector production prefix to mitigate collisions
 * with MUI and ReactJSS names which both use the 'jss' prefix.
 */
var generateClassName = createGenerateClassName({
    productionPrefix: "lth",
});
var StyledAppPanel = lighthouseComponentLibrary.styled.div(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  width: inherit;\n  height: 100%;\n\n  /* TODO: This needs to probably be migrated to component library or fixed elsewhere */\n  p {\n    margin: 0;\n  }\n"], ["\n  width: inherit;\n  height: 100%;\n\n  /* TODO: This needs to probably be migrated to component library or fixed elsewhere */\n  p {\n    margin: 0;\n  }\n"])));
var FrameworkGlobalStyle = styled.createGlobalStyle(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  body {\n    height: 100%;\n    background: #F2F2F2 url(", ") no-repeat right 70%;\n    background-attachment: fixed;\n    @media (max-width: ", ") {\n      background-image: unset;\n    }\n\n    .app {\n      height: 100%;\n    }\n  }\n"], ["\n  body {\n    height: 100%;\n    background: #F2F2F2 url(", ") no-repeat right 70%;\n    background-attachment: fixed;\n    @media (max-width: ", ") {\n      background-image: unset;\n    }\n\n    .app {\n      height: 100%;\n    }\n  }\n"])), adpGraphic, lighthouseComponentLibrary.getMaxBreakpoint("default"));
var AppPanel = function (props) {
    var _a;
    var authenticationManager = AuthenticationManager.getInstance();
    // Fixed a MUI accessibility bug that improperly marks the root of the app as "aria-hidden" when modal components are displayed.
    // See this Github discussion for more details about the bug and proposed workarounds that guided our solution: https://github.com/mui/material-ui/issues/19450#issuecomment-1310163344
    // Observer to check if root element has aria-hidden attribute.
    React__namespace.default.useEffect(function () {
        if (!props.rootElement) {
            return;
        }
        var observer = new MutationObserver(function () {
            var _a;
            if ((_a = props.rootElement) === null || _a === void 0 ? void 0 : _a.getAttribute("aria-hidden")) {
                props.rootElement.removeAttribute("aria-hidden");
                var elements = document.querySelectorAll("body > [aria-hidden=true]");
                elements.forEach(function (element) {
                    element.removeAttribute("aria-hidden");
                });
            }
        });
        observer.observe(props.rootElement, {
            attributeFilter: ["aria-hidden"],
        });
        return function () {
            observer.disconnect();
        };
    }, [props.rootElement]);
    React.useEffect(function () {
        var _a;
        var initConfigsByModuleId = getUserPreferenceInitConfigsByModuleId(props.framework.getModules());
        var userPreferenceManager = new UserPreferenceManager(__assign(__assign({}, initConfigsByModuleId), (_a = {}, _a[FRAMEWORK_USER_PREFERENCES_MODULE_ID_BACK_COMPAT] = backCompatUserPreferenceInitConfig, _a)));
        UserPreferenceManager.setInstance(userPreferenceManager);
    }, []);
    var disableApplicationFrame = props.framework
        .getConfiguration()
        .get(moduleName$1, ConfigurationValues$1.DisableApplicationFrame);
    var dispatch = reactRedux.useDispatch();
    var locale = useTypedSelector(function (state) { return state.appLocalizationData.locale; });
    var translations = useTypedSelector(function (state) { return state.appLocalizationData.translations; });
    var favicon = useTypedSelector(function (state) { return state.logos.FAVICON; });
    var theme = useBackCompatPreference(exports.BackCompatUserPreferenceKey.Theme)[0];
    var previewTheme = useTypedSelector(function (state) { return state.themeData.previewTheme; });
    var accountTheme = useTypedSelector(function (state) { return state.accountTheme.themeKey; });
    var navigationItems = useTypedSelector(function (state) { return state.navigationItems; });
    var apiErrors = useTypedSelector(function (state) { return state.apiErrors; });
    var _b = React.useState(new HubCardManager([])), hubCardManager = _b[0], setHubCardManager = _b[1];
    var _c = React.useState(authenticationManager.getAuthStatus()), authManagerAuthStatus = _c[0], setAuthManagerAuthStatus = _c[1];
    var _d = React.useState(false), isAdminResetPasswordDialogueOpen = _d[0], setAdminIsResetPasswordDialogueOpen = _d[1];
    var _e = React.useState({}), featureFlags = _e[0], setFeatureFlags = _e[1];
    var userPreferenceThemeFF = featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags[exports.FeatureFlagKey.UserPreferenceThemeSelection];
    var isAccountCustomThemeEnabled = featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags[exports.FeatureFlagKey.CustomAccountTheme];
    var isADPCustomThemeEnabled = featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags[exports.FeatureFlagKey.ADPCustomTheme];
    var isMFESupportEnabled = featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags[exports.FeatureFlagKey.MfeSupport];
    var _f = React.useState(TimeFormat.LocaleDefault), accountConfigTimeFormat = _f[0], setAccountConfigTimeFormat = _f[1];
    var _g = React.useState(false), hasPerformedLoginFunctions = _g[0], setHasPerformedLoginFunctions = _g[1];
    var _h = React.useState(), simulatedSystemDate = _h[0], setSimulatedSystemDate = _h[1];
    var pinAuthenticationFF = featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags[exports.FeatureFlagKey.PinAuthentication];
    var _j = React.useState(!!pinAuthenticationFF && reactDeviceDetect.isMobile), showPinScreen = _j[0], setShowPinScreen = _j[1];
    var suiteSessionInactivityFF = featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags[exports.FeatureFlagKey.SuiteSessionInactivity];
    var _k = React.useState(undefined), wtaTokenFlowAccountId = _k[0], setWtaTokenFlowAccountId = _k[1];
    var _l = React.useState(undefined), requiresPostLoginInit = _l[0], setRequiresPostLoginInit = _l[1];
    var _m = React.useState(undefined), authFlowState = _m[0], setAuthFlowState = _m[1];
    var _o = React.useState(false), showLogout = _o[0], setShowLogout = _o[1];
    var logoutResolverRef = React.useRef(null);
    var logoutUrlRef = React.useRef(null);
    // Cache the function definition between re-renders
    // This is extremely important because AppPanel gets rendered multiple times.
    // This function gets passed as an event handler to a component's onComplete
    // and if this function ever changes, it can cause the hooks in the child
    // component to trigger multiple times. Don't remove this usage of useCallback
    // unless you know what you're doing.
    var handleLogoutComplete = React.useCallback(function () {
        if (logoutResolverRef.current) {
            logoutResolverRef.current();
            logoutResolverRef.current = null;
            logoutUrlRef.current = null;
        }
        setShowLogout(false);
    }, []);
    /**
     * Load the pinAuthenticationFF correctly and set the final value to show PIN screen
     */
    React.useEffect(function () {
        setShowPinScreen(!!pinAuthenticationFF && reactDeviceDetect.isMobile);
    }, [reactDeviceDetect.isMobile, pinAuthenticationFF]);
    React.useEffect(function () {
        // Show pin screen when returning from either minimized app or unlocked screen or changing mobile browser tabs
        var onAppResumed = function () {
            if (!!pinAuthenticationFF && reactDeviceDetect.isMobile && !document.hidden) {
                setShowPinScreen(true);
            }
        };
        document.addEventListener("visibilitychange", onAppResumed);
        return function () { return document.removeEventListener("visibilitychange", onAppResumed); };
    }, [pinAuthenticationFF, reactDeviceDetect.isMobile]);
    /**
     * Load the configuration for the account, including feature flags, time format, locale,
     * theme, and branding info. Initializes state and redux with the data fetched from the service.
     * For more information on all the data this retrieves, see configuration-service/operations.graphql
     */
    var loadAccountConfiguration = function () {
        return getConfigurationServiceSdk()
            .getAccountConfiguration({})
            .then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
            var accountfeatureFlags, isSimulatedDate, simulatedSystemDateValue, isValidWfxSession, lazyLoadedModules, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        accountfeatureFlags = {};
                        response.featureFlags.forEach(function (featureFlagEntry) {
                            accountfeatureFlags[featureFlagEntry.name] = featureFlagEntry.enabled;
                        });
                        isSimulatedDate = JSON.parse(response.simulatedSystemDateConfig).current_position !== 0;
                        simulatedSystemDateValue = isSimulatedDate
                            ? dateAndTime.DateWithoutTime.fromISO(response.currentDate)
                            : undefined;
                        setFeatureFlags(accountfeatureFlags);
                        setSimulatedSystemDate(simulatedSystemDateValue);
                        setAccountConfigTimeFormat(response.timeFormat);
                        setSkipAccountSelection(accountfeatureFlags[exports.FeatureFlagKey.SuiteAuthSkipAccountSelection]);
                        getFrameworkInstance().setRawFeatureFlags(accountfeatureFlags);
                        if (!isAnyWfxFeatureFlagEnabled(accountfeatureFlags)) return [3 /*break*/, 2];
                        isValidWfxSession = hasValidWfxSession();
                        return [4 /*yield*/, initializeExperience(isValidWfxSession)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        initializePendo();
                        initializeWalkMe();
                        // For backward compatibility with UI modules that were already
                        // implemented in terms of feature flag values being maintained in
                        // redux, we must propagate some specific feature flag values to redux.
                        dispatch({
                            type: exports.LogoActionTypes.ChangeIsEnabled,
                            isEnabled: accountfeatureFlags[exports.FeatureFlagKey.SetAccountLogo],
                        });
                        if (!props.lazyLoadModules) return [3 /*break*/, 6];
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, props.lazyLoadModules(accountfeatureFlags)];
                    case 4:
                        lazyLoadedModules = _a.sent();
                        lazyLoadedModules.forEach(function (module) {
                            getFrameworkInstance().lazyLoadModule(module);
                        });
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        console.error("Error while attempting to lazy load modules:\n" + e_1);
                        return [3 /*break*/, 6];
                    case 6:
                        storeAccountConfiguration(response);
                        return [2 /*return*/];
                }
            });
        }); })
            .catch(function () {
            console.error("Could not retrieve Account configuration from configuration service");
            // in case of error, default the locale and theme
            dispatch({
                type: "localization/defaultLocale" /* SetDefaultLocale */,
                defaultLocale: appDefaultLocale,
            });
            dispatch({
                type: exports.AccountThemeActionTypes.SetAccountTheme,
                accountTheme: {
                    themeKey: null,
                    themeName: null,
                },
            });
        })
            .finally(function () {
            // Regardless of whether or not feature flag loading and lazy module loading was successful,
            // we *need* to finish initialization of the HubCardManager
            // Initialize HubCardManager with info about all Modules that can produce Hub Cards
            var initializedHubCardManager = new HubCardManager(___default.default(props.framework.getModules())
                .filter(function (module) { return !!module.getHubCardFactory; })
                .map(function (module) {
                return {
                    id: module.getId(),
                    name: module.getName(),
                    hubCardFactory: module.getHubCardFactory(),
                };
            })
                .value());
            setHubCardManager(initializedHubCardManager);
        });
    };
    React.useEffect(function () {
        /**
         * Send logout signal to Wta through a hidden iframe request
         * Then stop rendering the iframe
         */
        var logoutOfWta = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // On the web app, we enable a certain method of skipping the wta logout
                // This is ONLY for the multi-tab implementation supported by the OIDC
                // auth flow. The Keycloak implementation will do this for every tab.
                if (!isCordovaDevice()) {
                    // If we're not the leader tab, we don't need to do this
                    // So simply return a resolved promise
                    if (getIsOidcAuthFlow() && !getLeaderTabStatus()) {
                        return [2 /*return*/, Promise.resolve()];
                    }
                }
                return [2 /*return*/, new Promise(function (resolve) {
                        logoutResolverRef.current = resolve;
                        logoutUrlRef.current = getWtaLogoffUrl();
                        setShowLogout(true);
                    })];
            });
        }); };
        var cancelSubscription = authenticationManager.subscribe({
            authStatusChange: function (newAuthStatus) {
                var _a;
                setAuthManagerAuthStatus(newAuthStatus);
                tsEnumUtil.$enum.visitValue(newAuthStatus).with((_a = {},
                    _a[AuthenticationStatus.Authenticated] = function () {
                        if (!requiresPostLoginInit) {
                            console.log("[Auth] AppPanel: Authenticated but requiresPostLoginInit=false, skipping initialization");
                            return;
                        }
                        console.log("[Auth] AppPanel: Authenticated, running post-login initialization...");
                        UserPreferenceManager.getInstance()
                            .loadUserPreferences()
                            .then(function () {
                            return Promise.all([
                                performLoginFunctions(),
                                loadAccountConfiguration(),
                                logoutOfWta(),
                            ]);
                        })
                            .catch(function (error) {
                            console.error("[Auth] AppPanel: performLoginFunctions failed:", error.message);
                            dispatch(changeOrganizationErrorState(error.message));
                            dispatch(connectedReactRouter.push(routeContext.findRouteByName(RouteIds.Login) || ""));
                        })
                            .finally(function () {
                            console.log("[Auth] AppPanel: hasPerformedLoginFunctions → true");
                            setHasPerformedLoginFunctions(true);
                        });
                    },
                    _a[AuthenticationStatus.LoggingOut] = function () {
                        unregisterFromPushNotifications();
                        UserPreferenceManager.getInstance().resetUserPreferenceManager();
                    },
                    _a[AuthenticationStatus.NotAuthenticated] = function () {
                        setHasPerformedLoginFunctions(false);
                        setFeatureFlags(undefined);
                        getFrameworkInstance().setRawFeatureFlags(undefined);
                    },
                    _a[AuthenticationStatus.Initializing] = ___default.default.noop,
                    _a[AuthenticationStatus.MockAuthenticated] = ___default.default.noop,
                    _a));
            },
        });
        return function () {
            cancelSubscription();
        };
    }, [requiresPostLoginInit, authenticationManager]);
    var selectedTheme = useSelectedTheme({
        userPreferenceThemeFF: userPreferenceThemeFF,
        isAccountCustomThemeEnabled: isAccountCustomThemeEnabled,
        isADPCustomThemeEnabled: isADPCustomThemeEnabled,
        previewTheme: previewTheme,
        theme: theme,
        accountTheme: accountTheme,
    });
    React.useEffect(function () {
        if (locale !== appDefaultLocale) {
            loadTranslationsIni18Library(locale, translations);
        }
    }, [locale]);
    React.useEffect(function () {
        var tokenFunction = props.framework
            .getConfiguration()
            .get(moduleName, ConfigurationValues.GetToken);
        if (tokenFunction && typeof tokenFunction === "function") {
            dispatch(authenticate(tokenFunction, props.framework.getRouteContext()));
        }
    }, []);
    React.useEffect(function () {
        var userPreferenceManagerInstance = UserPreferenceManager.getInstance();
        if (hubCardManager && userPreferenceManagerInstance) {
            var cancelSubscription_1 = hubCardManager.subscribe({
                loadingStatusChange: function (isLoading, hasLoaded) {
                    // When Hub Cards are completely loaded...
                    if (hasLoaded) {
                        // Initialize Hub Card order
                        var hubCardCustomization = userPreferenceManagerInstance.getUserPreferenceValue(FRAMEWORK_USER_PREFERENCES_MODULE_ID_BACK_COMPAT, exports.BackCompatUserPreferenceKey.HubCardCustomization);
                        var expectedHubCards = userPreferenceManagerInstance.getUserPreferenceValue(FRAMEWORK_USER_PREFERENCES_MODULE_ID_BACK_COMPAT, exports.BackCompatUserPreferenceKey.ExpectedHubCards);
                        var initializedHubCardOrder = initializeHubCardOrder(hubCardCustomization, expectedHubCards, hubCardManager.getAllHubCardIds());
                        if (initializedHubCardOrder) {
                            userPreferenceManagerInstance.setUserPreferenceValue(FRAMEWORK_USER_PREFERENCES_MODULE_ID_BACK_COMPAT, exports.BackCompatUserPreferenceKey.HubCardCustomization, {
                                hubCardOrder: initializedHubCardOrder,
                            });
                        }
                        // Update "expected hub cards" in User Preferences
                        userPreferenceManagerInstance.setUserPreferenceValue(FRAMEWORK_USER_PREFERENCES_MODULE_ID_BACK_COMPAT, exports.BackCompatUserPreferenceKey.ExpectedHubCards, hubCardManager.getNextExpectedHubCards());
                    }
                },
            });
            return function () {
                if (cancelSubscription_1)
                    cancelSubscription_1();
            };
        }
        return;
    }, [hubCardManager, UserPreferenceManager.getInstance()]);
    React.useEffect(function () {
        if (!pinAuthenticationFF)
            return;
        if (!showPinScreen)
            return;
        var pinContainer = document.getElementById("pin-modal");
        var observer = new MutationObserver(function (mutationList) {
            return pinContainerMutationCallback(mutationList, pinContainer);
        });
        // Observe the document.body to detect when the pinContainer is removed from the DOM
        observer.observe(document.body, {
            childList: true,
        });
        return function () {
            observer.disconnect();
        };
    }, [pinAuthenticationFF, showPinScreen]);
    // Handles authManager initialization
    React.useEffect(function () {
        if (authFlowState === undefined || wtaTokenFlowAccountId === undefined) {
            return;
        }
        // Skip initializeAdpAuthFlow on the logout route. At page load on /logout/wta
        // the auth status is still Initializing (WtaAimLogout hasn't called logout() yet),
        // so checking authManagerAuthStatus would not catch this case. history.location.pathname
        // is synchronously correct and can never be stale.
        var isOnLogoutRoute = history.location.pathname === LOGOUT_ROUTE;
        if (authFlowState.flow === AuthFlow.Adp) {
            authenticationManager.initializeAdpAuthFlow(authFlowState.adpRegionEnvData, wtaTokenFlowAccountId, { isLogoutRoute: isOnLogoutRoute });
        }
        else if (authFlowState.flow === AuthFlow.Error) {
            console.error(authFlowState.error);
            // TODO SUITE-6031: Define error handling behavior for this scenario.
        }
        else {
            authenticationManager.initialize(wtaTokenFlowAccountId);
        }
    }, [authFlowState === null || authFlowState === void 0 ? void 0 : authFlowState.flow, authFlowState === null || authFlowState === void 0 ? void 0 : authFlowState.error, wtaTokenFlowAccountId]);
    // Handles requiresPostLoginInit state
    React.useEffect(function () {
        if (wtaTokenFlowAccountId === undefined) {
            return;
        }
        setRequiresPostLoginInit(!wtaTokenFlowAccountId);
    }, [wtaTokenFlowAccountId]);
    /**
     * Initializes and registers the AppShell for Micro Frontend (MFE) support.
     *
     * When MFE support is enabled via feature flag, this effect creates a new AppShell instance
     * and exposes it globally via window['getAppShell'] to allow other micro frontends to access
     * shared shell functionality.
     *
     * @dependency isMFESupportEnabled - Feature flag that controls whether MFE support is enabled
     */
    React.useEffect(function () {
        if (!isMFESupportEnabled) {
            return;
        }
        console.log("MFESupport is enabled. Registering AppShell.");
        var appShell = new LthAppShellImpl();
        window.getAppShell = function () { return appShell; };
    }, [isMFESupportEnabled]);
    var showSplashScreen = tsEnumUtil.$enum.mapValue(authManagerAuthStatus).with((_a = {},
        _a[AuthenticationStatus.Initializing] = true,
        _a[AuthenticationStatus.LoggingOut] = true,
        _a[AuthenticationStatus.Authenticated] = !hasPerformedLoginFunctions,
        _a[AuthenticationStatus.MockAuthenticated] = false,
        _a[AuthenticationStatus.NotAuthenticated] = false,
        _a)) || !!wtaTokenFlowAccountId;
    if (showSplashScreen) {
        return (React__namespace.default.createElement(connectedReactRouter.ConnectedRouter, { history: history },
            React__namespace.default.createElement(SplashScreen, null),
            authManagerAuthStatus === AuthenticationStatus.Initializing && (React__namespace.default.createElement(RouteAwareAuthInit, { onAccountIdFromRoute: setWtaTokenFlowAccountId, onAuthFlowStateDetermined: setAuthFlowState })),
            React__namespace.default.createElement(reactRouterDom.Switch, null,
                React__namespace.default.createElement(reactRouterDom.Route, { key: "login/wta", exact: true, path: WTA_TOKEN_LOGIN_ROUTE, component: WtaTokenLogin }),
                React__namespace.default.createElement(reactRouterDom.Route, { key: "logout", exact: true, path: LOGOUT_ROUTE, component: WtaAimLogout })),
            showLogout && logoutUrlRef.current && logoutResolverRef.current && (React__namespace.default.createElement(CrossOriginLogout, { logoutUrl: logoutUrlRef.current, onComplete: handleLogoutComplete }))));
    }
    return (React__namespace.default.createElement(connectedReactRouter.ConnectedRouter, { history: history },
        React__namespace.default.createElement(UserPreferenceManagerContext.Provider, { value: UserPreferenceManager.getInstance() },
            React__namespace.default.createElement(FeatureFlagsContext.Provider, { value: featureFlags },
                React__namespace.default.createElement(Favicon__default.default, { url: favicon || "./favicon.ico" }),
                React__namespace.default.createElement(I18n, { language: locale }),
                !disableApplicationFrame && (React__namespace.default.createElement(lighthouseComponentLibrary.GlobalStyle, { theme: selectedTheme.theme })),
                React__namespace.default.createElement(FrameworkGlobalStyle, null),
                React__namespace.default.createElement(localizationFramework.SimulatedSystemDateContext.Provider, { value: simulatedSystemDate },
                    React__namespace.default.createElement(TranslateFunctionAndTextDirectionProvider, null,
                        React__namespace.default.createElement(LocaleIdProvider, null,
                            React__namespace.default.createElement(TimeFormatProvider, { isFeatureEnabled: !!(featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags[exports.FeatureFlagKey.NextGenTimeFormatting]), accountConfigTimeFormat: accountConfigTimeFormat },
                                React__namespace.default.createElement(react.PersistGate, { loading: null, persistor: getPersistor() },
                                    React__namespace.default.createElement(StylesProvider, { generateClassName: generateClassName },
                                        React__namespace.default.createElement(ThemeWrapper, { theme: selectedTheme.theme },
                                            React__namespace.default.createElement(Context.Provider, { value: props.framework },
                                                React__namespace.default.createElement(ExternalUserActivityEventPublisherProvider, null,
                                                    suiteSessionInactivityFF ? (React__namespace.default.createElement(SuiteInactivityTimer, { enabled: hasPerformedLoginFunctions })) : null,
                                                    React__namespace.default.createElement(HubCardManagerContext.Provider, { value: hubCardManager },
                                                        React__namespace.default.createElement(ResetPasswordContext.Provider, { value: {
                                                                isOpen: isAdminResetPasswordDialogueOpen,
                                                                setIsOpen: setAdminIsResetPasswordDialogueOpen,
                                                            } },
                                                            React__namespace.default.createElement(StyledAppPanel, null,
                                                                React__namespace.default.createElement(reactRouterDom.Switch, null,
                                                                    routeContext
                                                                        .getPublicRoutes()
                                                                        .map(function (routeSpecification) { return (React__namespace.default.createElement(reactRouterDom.Route, { key: routeSpecification.id, exact: true, path: routeSpecification.route, component: routeSpecification.component })); }),
                                                                    routeContext
                                                                        .getPrivateRoutesWithPermissions(navigationItems, featureFlags, isUiTestingMode())
                                                                        .map(function (routeSpecification) { return (React__namespace.default.createElement(PrivateRoute, { key: routeSpecification.id, path: routeSpecification.route, component: routeSpecification.component })); }),
                                                                    React__namespace.default.createElement(reactRouterDom.Route, { component: AppPanelError })),
                                                                React__namespace.default.createElement(reactRouterDom.Switch, null, routeContext
                                                                    .getAuxiliaryRoutes()
                                                                    .map(function (routeSpecification) { return (React__namespace.default.createElement(PrivateRoute, { key: routeSpecification.id, exact: true, path: "/(.*)/\\&" + routeSpecification.route, component: routeSpecification.component })); })),
                                                                React__namespace.default.createElement(NotificationHandler$1, { isSideBar: false }),
                                                                apiErrors.errors.length > 0 ? (React__namespace.default.createElement(ApiErrorDialog, { isOpen: true, error: apiErrors.errors[0], onClose: function () {
                                                                        dispatch(deleteApiError(apiErrors.errors[0]));
                                                                    } })) : null,
                                                                showPinScreen &&
                                                                    ReactDOM.createPortal(React__namespace.default.createElement(Pin, { close: function () { return setShowPinScreen(false); } }), document.getElementById("pin-modal"))))))))))))))))));
};
var templateObject_1$1, templateObject_2$1;

var mapStateToProps = function (state) {
    return {
        currentPath: state.router.location.pathname,
    };
};
var RouteLink = reactRedux.connect(mapStateToProps)(RouteLink$2);

var PropertyNameValues;
(function (PropertyNameValues) {
    PropertyNameValues["ServiceBaseURL"] = "assistant_serviceBaseURL";
})(PropertyNameValues || (PropertyNameValues = {}));
var configPropertyNames = {
    serviceBaseURL: PropertyNameValues.ServiceBaseURL,
};
var configProperties = new Map();

var defaultDateTimeOptions = {
    day: "2-digit",
    month: "short",
};
/**
 * TODO: This component is incomplete/broken because it unconditionally sets the `dateTime`
 *       attribute of the `time` element to be the date only. This really needs to be coordinated
 *       with what pieces of the date-time are being formatted for display. This is currently a
 *       broken design that needs a revisit.
 */
var FormattedDateTime = function (_a) {
    var date = _a.date, _b = _a.options, options = _b === void 0 ? defaultDateTimeOptions : _b;
    var luxonDateTime = luxon.DateTime.fromJSDate(date);
    var dateTimeFormatter = localizationFramework.useDateTimeFormatter();
    var contextualTimeZoneId = localizationFramework.useTimeZoneId();
    var timeZoneId = options.timeZone || contextualTimeZoneId;
    return (React__namespace.createElement("time", { dateTime: dateAndTime.DateWithoutTime.fromDateTime(luxonDateTime, timeZoneId).toISO() }, dateTimeFormatter.formatDateTime(luxonDateTime, options)));
};

/**
 * Formats the given number using the numberFormatter from Localization Framework
 * @deprecated Use useNumberFormatter hook from @workforcesoftware/localization-framework
 */
var NumberFormat = function (_a) {
    var num = _a.num, _b = _a.options, options = _b === void 0 ? {} : _b;
    var numberFormatter = localizationFramework.useNumberFormatter();
    return (React__namespace.createElement(React__namespace.Fragment, null, numberFormatter.formatNumber(num, options)));
};

var API_BASE_URL_DEFAULT = "https://api.latest.wfs.cloud/";
var DEFAULT_TIMEOUT = 5000;
var axiosInstance = null;
var initializationPromise = null;
/**
 * Initialize axios instance with base configuration and request interceptor
 * The interceptor ensures fresh token is applied to every request
 */
var initializeAxiosInstance = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        // Base axios instance configuration
        axiosInstance = axios__default.default.create({
            baseURL: API_BASE_URL_DEFAULT,
            timeout: DEFAULT_TIMEOUT,
        });
        axiosInstance.interceptors.request.use(function (config) { return __awaiter(void 0, void 0, void 0, function () {
            var accessToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, AuthenticationManager.getInstance().getAccessToken()];
                    case 1:
                        accessToken = _a.sent();
                        if (!accessToken) {
                            throw new Error("Failed to retrieve access token for API requests.");
                        }
                        config.headers = __assign(__assign({}, config.headers), { Authorization: "Bearer " + accessToken });
                        return [2 /*return*/, config];
                }
            });
        }); }, function (error) {
            return Promise.reject(error);
        });
        return [2 /*return*/];
    });
}); };
/**
 * Get the configured Axios instance with interceptors
 * Ensures fast execution and prevents race conditions during initialization
 * @returns Promise<AxiosInstance> - Configured Axios instance
 * @throws Error if initialization fails
 */
var createRestApiClient = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                // If already initialized, return the instance immediately
                if (axiosInstance) {
                    return [2 /*return*/, axiosInstance];
                }
                // If initialization is already in progress, wait for it
                if (!initializationPromise) {
                    // Start new initialization
                    initializationPromise = initializeAxiosInstance().catch(function (error) {
                        initializationPromise = null; // Reset on failure
                        throw new Error("REST API client initialization failed: " + (error.message || error));
                    });
                }
                // Wait for initialization to complete
                return [4 /*yield*/, initializationPromise];
            case 1:
                // Wait for initialization to complete
                _a.sent();
                if (!axiosInstance) {
                    throw new Error("REST API client initialization failed.");
                }
                return [2 /*return*/, axiosInstance];
        }
    });
}); };

/**
 * Determine if default error handling should be used
 * @param useDefaultErrorHandling - Use flag (boolean or function). Defaults to false if not provided.
 * @param error - The error to evaluate
 * @returns true if error handling should be used, false otherwise
 */
var shouldUseDefaultErrorHandling = function (useDefaultErrorHandling, error) {
    return useDefaultErrorHandling instanceof Function
        ? useDefaultErrorHandling(error)
        : useDefaultErrorHandling === true;
};
/**
 * Execute a generic API request
 * @param method HTTP method
 * @param url Request URL
 * @param params Request parameters
 * @param options Request options (headers, timeout, error handling)
 * @returns Promise with structured API response
 * @throws AxiosError on request failure
 */
var request = function (method, url, params, options) { return __awaiter(void 0, void 0, void 0, function () {
    var axiosInstance, response, _a, error_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, createRestApiClient()];
            case 1:
                axiosInstance = _b.sent();
                _b.label = 2;
            case 2:
                _b.trys.push([2, 15, , 16]);
                response = void 0;
                _a = method;
                switch (_a) {
                    case "GET": return [3 /*break*/, 3];
                    case "POST": return [3 /*break*/, 5];
                    case "PUT": return [3 /*break*/, 7];
                    case "PATCH": return [3 /*break*/, 9];
                    case "DELETE": return [3 /*break*/, 11];
                }
                return [3 /*break*/, 13];
            case 3: return [4 /*yield*/, axiosInstance.get(url, __assign(__assign({}, options), { params: params }))];
            case 4:
                response = _b.sent();
                return [3 /*break*/, 14];
            case 5: return [4 /*yield*/, axiosInstance.post(url, params, options)];
            case 6:
                response = _b.sent();
                return [3 /*break*/, 14];
            case 7: return [4 /*yield*/, axiosInstance.put(url, params, options)];
            case 8:
                response = _b.sent();
                return [3 /*break*/, 14];
            case 9: return [4 /*yield*/, axiosInstance.patch(url, params, options)];
            case 10:
                response = _b.sent();
                return [3 /*break*/, 14];
            case 11: return [4 /*yield*/, axiosInstance.delete(url, __assign(__assign({}, options), { params: params }))];
            case 12:
                response = _b.sent();
                return [3 /*break*/, 14];
            case 13: throw new Error("Unsupported HTTP method: " + method);
            case 14: return [2 /*return*/, {
                    status: response.status,
                    content: response.data,
                }];
            case 15:
                error_1 = _b.sent();
                // Handle errors with centralized error management
                if (error_1 instanceof axios.AxiosError && (options === null || options === void 0 ? void 0 : options.serviceName) &&
                    shouldUseDefaultErrorHandling(options === null || options === void 0 ? void 0 : options.useDefaultErrorHandling, error_1)) {
                    handleRestApiError(error_1, options.serviceName);
                }
                throw error_1;
            case 16: return [2 /*return*/];
        }
    });
}); };
/**
 * REST API Client namespace with automatic error handling
 * Supports structured params and normalized responses
 */
var RestApiClient = {
    get: function (url, params, options) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request("GET", url, params, options)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
    post: function (url, params, options) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request("POST", url, params, options)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
    put: function (url, params, options) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request("PUT", url, params, options)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
    patch: function (url, params, options) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request("PATCH", url, params, options)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
    delete: function (url, params, options) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request("DELETE", url, params, options)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
    request: request,
};

/**
 * This enum represents the possible values for the urgency value in AssistantCardCommonProperties.
 */
var AssistantCardUrgency;
(function (AssistantCardUrgency) {
    AssistantCardUrgency[AssistantCardUrgency["Standard"] = 0] = "Standard";
    AssistantCardUrgency[AssistantCardUrgency["Urgent"] = 1] = "Urgent";
    AssistantCardUrgency[AssistantCardUrgency["PastDue"] = 2] = "PastDue";
})(AssistantCardUrgency || (AssistantCardUrgency = {}));
var AssistantCardUrgency$1 = AssistantCardUrgency;

var assistantCardDummyHOC = function (WrappedComponent) {
    return function (props) { return React__namespace.createElement(WrappedComponent, __assign({}, props)); };
};

/**
 * Interface which each module will implement and export
 * the implementation of so the consuming application can
 * register the module and set up routes, navigation, etc.
 */
var DummyModuleForUseInWrapperTesting = /** @class */ (function () {
    function DummyModuleForUseInWrapperTesting() {
        /**
         * Universally unique ID of the module.
         */
        this.getId = function () { return "DummyModuleForUseInWrapperTesting"; };
        /**
         * Descriptive name of the module.  Useful for debugging and whatnot.
         * Not intended to be a display string for the end user.
         */
        this.getName = function () { return "Dummy Module For Use In wrapper.tsx"; };
        /**
         * Provides a way for the modules to receive an instance of the
         * framework from the consuming application.
         * @param frameworkInstance
         */
        this.setFrameworkInstance = function (instance) {
            return setFrameworkInstance(instance);
        };
        /**
         * Provides a way for the modules to receive an instance of the
         * internationalization API.
         * @param i18n
         */
        this.setI18nInstance = function (i18n) {
            return;
        };
        /**
         * Gets the list of routes this module would like registered with the routing system.
         */
        this.getRouteSpecifications = function () { return []; };
        /**
         * Gets the translation resources to be used with this module.
         */
        this.getI18nResources = function () { return ({}); };
        /**
         * Gets the application reducers for this Module.
         */
        this.getReducers = function () {
            return {};
        };
        this.getCreateAssistantCardHOC = function () { return assistantCardDummyHOC; };
    }
    return DummyModuleForUseInWrapperTesting;
}());

/**
 * Passes any dependencies as props to a component. This allows injecting external dependencies into the component as
 * opposed to having those dependencies internally inside the component.
 *
 * The typescript generic parameters are:
 *  D: the type of dependencies to inject
 *  O: The type of props without dependencies
 *
 */
function withDependencies(dependencies) {
    /**
     * Higher order component which passes global objects as dependencies
     * In the implementation it is component with default values of some props
     * It allows us to test components as units even if they are using some global functions or variables
     *
     * @param React.ComponentType<O&D> Component
     *
     * @return React.FunctionComponent<O>
     */
    return function (Component) {
        /**
         * React component rendered by HOC
         */
        return function (props) { return (React__namespace.createElement(Component, __assign({}, dependencies, props))); };
    };
}

/**
 * Get native route for a Deeplink that the react router can route to within the framework.
 *
 * E.g Deeplink: https://app-latest.wfs.cloud/launch/experience/communities/asdih123kjnaksjdewa2w/channels/asdjhb324ib021sadoj
 * Example deeplink gets converted to a Native Route that is handled by the framework, so that the react router can route to it:
 * /launch/experience%2Fcommunities%2Fasdih123kjnaksjdewa2w%2Fchannels%2Fasdjhb324ib021sadoj
 * @param deeplinkUrl Deeplink URL. Eg: https://app-latest.wfs.cloud/launch/experience/communities/asdih123kjnaksjdewa2w/channels/asdjhb324ib021sadoj
 * @returns Native route that can be handled by the framework and hence routed to by the react router.
 */
var getDeeplinkNativeRoute = function (deeplinkUrl) {
    var _a, _b;
    try {
        var url = new URL(deeplinkUrl);
        if ((_a = url === null || url === void 0 ? void 0 : url.hash) === null || _a === void 0 ? void 0 : _a.includes(DEEPLINK_HANDLER_ROUTE)) {
            return url.hash.substring(1);
        }
        if ((_b = url === null || url === void 0 ? void 0 : url.pathname) === null || _b === void 0 ? void 0 : _b.includes(DEEPLINK_HANDLER_ROUTE)) {
            return "" + url.pathname + url.search;
        }
        return deeplinkUrl;
    }
    catch (e) {
        console.error("Error while attempting to get deeplink native route:\n" + e);
        return deeplinkUrl;
    }
};

/**
 * Creates a mock implementation of {@link useNamedFeatureFlags} for use in
 * tests, using the provided mock feature flag values.
 *
 * Similar to the hook's real implementation, the returned mock implementation
 * will validate that all requested feature flags are present in the provided
 * mock data. This helps prevent false positives or failures that are hard to
 * track down due to forgetting to mock a feature flag that your component
 * depends on. Without validation, a forgotten feature flag would have a value
 * of undefined, which will most often be treated in the consuming code as if
 * the feature flag value is false.
 *
 * @param featureFlags - The mock feature flag values.
 * @return a mock implementation of {@link useNamedFeatureFlags}.
 *
 * @example
 * // Mock `useNamedFeatureFlags()`, but preserve all other original framework behavior
 * jest.mock("@workforcesoftware/lighthouse-framework", () => {
 *   return {
 *     ...jest.requireActual("@workforcesoftware/lighthouse-framework"),
 *     useNamedFeatureFlags: jest.fn(),
 *   };
 * });
 *
 * beforeEach(() => {
 *   // Mock default feature flag values for most unit tests
 *   mocked(useNamedFeatureFlags).mockImplementation(
 *     createUseNamedFeatureFlagsMock({
 *       [FeatureFlagKey.NextGenTimesheetReadWrite]: true,
 *     })
 *   );
 * });
 *
 * test("Feature flag disabled", () => {
 *   // Override default mocked feature flags for this specific test
 *   mocked(useNamedFeatureFlags).mockImplementation(
 *     createUseNamedFeatureFlagsMock({
 *       [FeatureFlagKey.NextGenTimesheetReadWrite]: false,
 *     })
 *   );
 *
 *   // ... do testing things
 * });
 */
function createUseNamedFeatureFlagsMockImplementation(featureFlags) {
    return function () {
        var names = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            names[_i] = arguments[_i];
        }
        return getNamedFeatureFlags(featureFlags, names);
    };
}

/**
 * MockPreferences class for mocking preferences and providing mock setter functions.
 * @template TypeMap - Generic type representing the map of preference keys and their types.
 */
var MockPreferences = /** @class */ (function (_super) {
    __extends(MockPreferences, _super);
    /**
     * Constructor for MockPreferences.
     * @param {TypeMap} initialValues - Initial values for the preferences.
     */
    function MockPreferences(initialValues) {
        var _this = _super.call(this) || this;
        _this.initialValues = initialValues;
        _this.values = __assign({}, initialValues);
        var setters = {};
        // Initialize mockSetters for each key in TypeMap
        Object.keys(initialValues).forEach(function (key) {
            setters[key] = jest.fn(function (value) { return Promise.resolve(); });
        });
        _this.mockSetters = setters;
        return _this;
    }
    /**
     * Get the current value of a preference key.
     * @param {Key} key - The key of the preference.
     * @returns {TypeMap[Key]} - The current value of the preference.
     */
    MockPreferences.prototype.get = function (key) {
        return this.values[key];
    };
    /**
     * Set a new value for a preference key.
     * @param {Key} key - The key of the preference.
     * @param {TypeMap[Key]} value - The new value for the preference.
     */
    MockPreferences.prototype.set = function (key, value) {
        this.values[key] = value;
        this.emit.valueChange(key, value);
    };
    /**
     * Get the mock setter function for a preference key.
     * @param {Key} key - The key of the preference.
     * @returns {jest.Mock<void | Promise<void>, [TypeMap[Key]]>} - The mock setter function.
     */
    MockPreferences.prototype.getMockSetter = function (key) {
        return this.mockSetters[key];
    };
    /**
     * Reset mock setters and values to their initial state.
     */
    MockPreferences.prototype.reset = function () {
        var _this = this;
        Object.keys(this.mockSetters).forEach(function (key) {
            var castKey = key;
            _this.mockSetters[castKey].mockClear();
            _this.values[castKey] = _this.initialValues[castKey];
            _this.emit.valueChange(castKey, _this.values[castKey]);
        });
    };
    /**
     * Create a mock implementation of the UsePreferenceHook for testing purposes.
     * @returns {UsePreferenceHook<TypeMap>} - The mock implementation of the UsePreferenceHook.
     */
    MockPreferences.prototype.createUsePreferenceHookMockImplementation = function () {
        var _this = this;
        return (function (key) {
            // Simple hack to force a re-render of the component to use a new preference value.
            // Just increment the numeric value.
            var _a = React.useState(0), setForceReRender = _a[1];
            if (!(key in _this.values)) {
                throw new Error("Attempted access to invalid user preference key \"" + key + "\". Did you forget to mock this preference?");
            }
            // force a re-render if the key param changes
            React.useEffect(function () {
                setForceReRender(function (prev) { return prev + 1; });
            }, [key]);
            // listen to the change event and force a re-render if the value for the current key is changed
            React.useEffect(function () {
                var cancel = _this.subscribe({
                    valueChange: function (changedKey) {
                        if (changedKey === key) {
                            setForceReRender(function (prev) { return prev + 1; });
                        }
                    },
                });
                return cancel;
            }, []);
            return [_this.values[key], _this.mockSetters[key]];
        });
    };
    return MockPreferences;
}(strictlyTypedEvents.WithEventEmitter));

/**
 * Represents a mock preferences creator for a given type map.
 * @template TypeMap - The type map representing preferences.
 */
var MockPreferencesCreator = /** @class */ (function () {
    function MockPreferencesCreator() {
    }
    /**
     * Creates a new instance of MockPreferences with the specified values.
     * @template Keys - The keys of the type map to be set.
     * @param {Pick<TypeMap, Keys>} values - The values to set for the specified keys.
     * @returns {MockPreferences<TypeMap>} - A new instance of MockPreferences with the specified values.
     */
    MockPreferencesCreator.prototype.with = function (values) {
        return new MockPreferences(values);
    };
    return MockPreferencesCreator;
}());
/**
 * Creates a new MockPreferencesCreator for a given type map.
 * @template TypeMap - The type map representing preferences.
 * @returns {MockPreferencesCreator<TypeMap>} - A new MockPreferencesCreator instance.
 */
function createMockPreferences() {
    return new MockPreferencesCreator();
}

/**
 * Helper function to force type safety onto a literal value.
 * When using this function, you should specify the type parameter.
 * Example:
 *   expect(foo).toEqual(literal<MyInterface>({
 *      // compiler validation here for type `MyInterface`
 *      foo: 10,
 *      bar: "hello"
 *   });
 * @param value - A value.
 * @return The value.
 * @deprecated moved to `@workforcesoftware/ts-util`
 */
function literal(value) {
    return value;
}
/**
 * Helper function to force type safety onto a literal value, but in special situations
 * where you intentionally only want/need to provide a partial implementation.
 * A good example is for mocking complex interfaces in unit tests, where your test is guaranteed to
 * only lead to a subset of methods on the interface being called. This gives you a type-safe
 * way to provide implementations for only the methods you care about.
 * When using this function, you should specify the type parameter.
 * Example:
 *   expect(foo).toEqual(partialAsComplete<MyInterface>({
 *      // compiler validation here for type `Partial<MyInterface>`
 *      foo: 10,
 *      bar: "hello"
 *   });
 * @param value - A a partial implementation of the specified type.
 * @return The provided partial value, but typecast as the non-partial type.
 * @deprecated moved to `@workforcesoftware/ts-util`
 */
function partialAsComplete(value) {
    return value;
}
/**
 * Helper function to force type safety onto a literal value, but in special situations
 * where you intentionally only want/need to provide a deep partial implementation.
 * A good example is for mocking complex redux store data in unit tests, where your test is guaranteed to
 * only depend on a subset of some nested data in the redux state. This gives you a type-safe
 * way to provide implementations for only the data you care about.
 * When using this function, you should specify the type parameter.
 * Example:
 *   expect(foo).toEqual(deepPartialAsComplete<MyInterface>({
 *      // compiler validation here for type `DeepPartial<MyInterface>`
 *      foo: 10,
 *      bar: "hello"
 *   });
 * @param value - A a deep partial implementation of the specified type.
 * @return The provided deep partial value, but typecast as the non-partial type.
 * @deprecated moved to `@workforcesoftware/ts-util`
 */
function deepPartialAsComplete(value) {
    return value;
}
/**
 * Typecasts a function to a Jest Mock function with the same signature.
 * This is useful when you have used jest.mock() to mock an entire module
 * and want to interact with one of the module's exported functions as a Jest Mock.
 * @example
 *
 *  jest.mock("../api");
 *  import { apiMethod } from "../api";
 *
 *  asJestMock(apiMethod).mockImplementation(() => "test");
 *
 * @param func - A function.
 * @return The same function, but typecast to a Jest Mock.
 * @deprecated moved to `@workforcesoftware/ts-jest-util`
 */
function asJestMock(func) {
    return func;
}
/**
 * Similar to {@link asJestMock}, but it allows you to provide a mock
 * implementation that returns only a partial implementation of the result.
 * This is useful when working with a mocked function that returns a large/complex
 * interface/object, but you only need to implement a part of the object/interface
 * for the purpose of your tests.
 * @example
 *
 *  jest.mock("../api");
 *  import { getComplexApi } from "../api";
 *
 *  asJestMockWithPartialResult(getComplexApi).mockImplementation(() => ({
 *    // only implement tha method that the tests depend upon
 *    apiMethodOne: () => "test"
 *  }));
 *
 * @param func - A function.
 * @return The same function, but typecast to a Jest Mock.
 * @deprecated moved to `@workforcesoftware/ts-jest-util`
 */
function asJestMockWithPartialResult(func) {
    return func;
}
/**
 * Typecasts an object to a Jest Mocked of the same type.
 * @example
 *
 *  jest.mock("../api");
 *  import { Api } from "../api";
 *
 *  const myApi = asJestMocked(new Api());
 *  myApi.myApiMethod.mockImplementation(() => "test");
 *
 * @param obj - The mocked object to be typecast.
 * @return the same object, but typecast to a Jest Mocked.
 * @deprecated moved to `@workforcesoftware/ts-jest-util`
 */
function asJestMocked(obj) {
    return obj;
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var BASE_PATH = "http://localhost:4010".replace(/\/+$/, "");
var Configuration = /** @class */ (function () {
    function Configuration(configuration) {
        if (configuration === void 0) { configuration = {}; }
        this.configuration = configuration;
    }
    Object.defineProperty(Configuration.prototype, "config", {
        set: function (configuration) {
            this.configuration = configuration;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Configuration.prototype, "basePath", {
        get: function () {
            return this.configuration.basePath != null ? this.configuration.basePath : BASE_PATH;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Configuration.prototype, "fetchApi", {
        get: function () {
            return this.configuration.fetchApi;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Configuration.prototype, "middleware", {
        get: function () {
            return this.configuration.middleware || [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Configuration.prototype, "queryParamsStringify", {
        get: function () {
            return this.configuration.queryParamsStringify || querystring;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Configuration.prototype, "username", {
        get: function () {
            return this.configuration.username;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Configuration.prototype, "password", {
        get: function () {
            return this.configuration.password;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Configuration.prototype, "apiKey", {
        get: function () {
            var apiKey = this.configuration.apiKey;
            if (apiKey) {
                return typeof apiKey === 'function' ? apiKey : function () { return apiKey; };
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Configuration.prototype, "accessToken", {
        get: function () {
            var _this = this;
            var accessToken = this.configuration.accessToken;
            if (accessToken) {
                return typeof accessToken === 'function' ? accessToken : function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                    return [2 /*return*/, accessToken];
                }); }); };
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Configuration.prototype, "headers", {
        get: function () {
            return this.configuration.headers;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Configuration.prototype, "credentials", {
        get: function () {
            return this.configuration.credentials;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Configuration.prototype, "defaultErrorHandler", {
        get: function () {
            return this.configuration.defaultErrorHandler;
        },
        enumerable: true,
        configurable: true
    });
    return Configuration;
}());
var DefaultConfig = new Configuration();
/**
 * This is the base class for all generated API classes.
 */
var BaseAPI = /** @class */ (function () {
    function BaseAPI(configuration) {
        var _this = this;
        if (configuration === void 0) { configuration = DefaultConfig; }
        this.configuration = configuration;
        this.fetchApi = function (url, init) { return __awaiter(_this, void 0, void 0, function () {
            var fetchParams, _i, _a, middleware, response, e_1, _b, _c, middleware, _d, _e, middleware;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        fetchParams = { url: url, init: init };
                        _i = 0, _a = this.middleware;
                        _f.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        middleware = _a[_i];
                        if (!middleware.pre) return [3 /*break*/, 3];
                        return [4 /*yield*/, middleware.pre(__assign({ fetch: this.fetchApi }, fetchParams))];
                    case 2:
                        fetchParams = (_f.sent()) || fetchParams;
                        _f.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        response = undefined;
                        _f.label = 5;
                    case 5:
                        _f.trys.push([5, 7, , 12]);
                        return [4 /*yield*/, (this.configuration.fetchApi || fetch)(fetchParams.url, fetchParams.init)];
                    case 6:
                        response = _f.sent();
                        return [3 /*break*/, 12];
                    case 7:
                        e_1 = _f.sent();
                        _b = 0, _c = this.middleware;
                        _f.label = 8;
                    case 8:
                        if (!(_b < _c.length)) return [3 /*break*/, 11];
                        middleware = _c[_b];
                        if (!middleware.onError) return [3 /*break*/, 10];
                        return [4 /*yield*/, middleware.onError({
                                fetch: this.fetchApi,
                                url: fetchParams.url,
                                init: fetchParams.init,
                                error: e_1,
                                response: response ? response.clone() : undefined,
                            })];
                    case 9:
                        response = (_f.sent()) || response;
                        _f.label = 10;
                    case 10:
                        _b++;
                        return [3 /*break*/, 8];
                    case 11:
                        if (response === undefined) {
                            if (e_1 instanceof Error) {
                                throw new FetchError(e_1, 'The request failed and the interceptors did not return an alternative response');
                            }
                            else {
                                throw e_1;
                            }
                        }
                        return [3 /*break*/, 12];
                    case 12:
                        _d = 0, _e = this.middleware;
                        _f.label = 13;
                    case 13:
                        if (!(_d < _e.length)) return [3 /*break*/, 16];
                        middleware = _e[_d];
                        if (!middleware.post) return [3 /*break*/, 15];
                        return [4 /*yield*/, middleware.post({
                                fetch: this.fetchApi,
                                url: fetchParams.url,
                                init: fetchParams.init,
                                response: response.clone(),
                            })];
                    case 14:
                        response = (_f.sent()) || response;
                        _f.label = 15;
                    case 15:
                        _d++;
                        return [3 /*break*/, 13];
                    case 16: return [2 /*return*/, response];
                }
            });
        }); };
        this.middleware = configuration.middleware;
    }
    BaseAPI.prototype.withMiddleware = function () {
        var _a;
        var middlewares = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            middlewares[_i] = arguments[_i];
        }
        var next = this.clone();
        next.middleware = (_a = next.middleware).concat.apply(_a, middlewares);
        return next;
    };
    BaseAPI.prototype.withPreMiddleware = function () {
        var preMiddlewares = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            preMiddlewares[_i] = arguments[_i];
        }
        var middlewares = preMiddlewares.map(function (pre) { return ({ pre: pre }); });
        return this.withMiddleware.apply(this, middlewares);
    };
    BaseAPI.prototype.withPostMiddleware = function () {
        var postMiddlewares = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            postMiddlewares[_i] = arguments[_i];
        }
        var middlewares = postMiddlewares.map(function (post) { return ({ post: post }); });
        return this.withMiddleware.apply(this, middlewares);
    };
    /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param mime - MIME (Multipurpose Internet Mail Extensions)
     * @return True if the given MIME is JSON, false otherwise.
     */
    BaseAPI.prototype.isJsonMime = function (mime) {
        if (!mime) {
            return false;
        }
        return BaseAPI.jsonRegex.test(mime);
    };
    BaseAPI.prototype.request = function (context, init) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.createFetchUrl(context);
                        return [4 /*yield*/, this.fetchApi(url, init)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BaseAPI.prototype.createApiRequestInit = function (context, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var headers, initOverrideFn, initParams, overriddenInit, _a, body;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        headers = Object.assign({}, this.configuration.headers, context.headers);
                        Object.keys(headers).forEach(function (key) { return headers[key] === undefined ? delete headers[key] : {}; });
                        initOverrideFn = typeof initOverrides === "function"
                            ? initOverrides
                            : function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                                return [2 /*return*/, initOverrides];
                            }); }); };
                        initParams = {
                            method: context.method,
                            headers: headers,
                            body: context.body,
                            credentials: this.configuration.credentials,
                        };
                        _a = [__assign({}, initParams)];
                        return [4 /*yield*/, initOverrideFn({
                                init: initParams,
                                context: context,
                            })];
                    case 1:
                        overriddenInit = __assign.apply(void 0, _a.concat([(_b.sent())]));
                        if (isFormData(overriddenInit.body)
                            || (overriddenInit.body instanceof URLSearchParams)
                            || isBlob(overriddenInit.body)) {
                            body = overriddenInit.body;
                        }
                        else if (this.isJsonMime(headers['Content-Type'])) {
                            body = JSON.stringify(overriddenInit.body);
                        }
                        else {
                            body = overriddenInit.body;
                        }
                        return [2 /*return*/, __assign(__assign({}, overriddenInit), { body: body })];
                }
            });
        });
    };
    BaseAPI.prototype.createFetchUrl = function (context) {
        var url = this.configuration.basePath + context.path;
        if (context.query !== undefined && Object.keys(context.query).length !== 0) {
            // only add the querystring to the URL if there are query parameters.
            // this is done to avoid urls ending with a "?" character which buggy webservers
            // do not handle correctly sometimes.
            url += '?' + this.configuration.queryParamsStringify(context.query);
        }
        return url;
    };
    BaseAPI.prototype.reportApiErrorToDefaultHandler = function (errorType, status) {
        var _a, _b;
        (_b = (_a = this.configuration).defaultErrorHandler) === null || _b === void 0 ? void 0 : _b.call(_a, errorType, status);
    };
    BaseAPI.prototype.reportApiNetworkError = function (errorHandler) {
        return __awaiter(this, void 0, void 0, function () {
            var entry, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(errorHandler === false)) return [3 /*break*/, 1];
                        return [2 /*return*/];
                    case 1:
                        if (!(typeof errorHandler === "object")) return [3 /*break*/, 5];
                        entry = errorHandler["network"];
                        if (!(entry === false)) return [3 /*break*/, 2];
                        return [2 /*return*/];
                    case 2:
                        _a = typeof entry === "function";
                        if (!_a) return [3 /*break*/, 4];
                        return [4 /*yield*/, entry()];
                    case 3:
                        _a = (_b.sent()) === false;
                        _b.label = 4;
                    case 4:
                        if (_a) {
                            return [2 /*return*/];
                        }
                        _b.label = 5;
                    case 5:
                        this.reportApiErrorToDefaultHandler("network");
                        return [2 /*return*/];
                }
            });
        });
    };
    BaseAPI.prototype.reportApiTimeoutError = function (errorHandler) {
        return __awaiter(this, void 0, void 0, function () {
            var entry, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(errorHandler === false)) return [3 /*break*/, 1];
                        return [2 /*return*/];
                    case 1:
                        if (!(typeof errorHandler === "object")) return [3 /*break*/, 5];
                        entry = errorHandler["timeout"];
                        if (!(entry === false)) return [3 /*break*/, 2];
                        return [2 /*return*/];
                    case 2:
                        _a = typeof entry === "function";
                        if (!_a) return [3 /*break*/, 4];
                        return [4 /*yield*/, entry()];
                    case 3:
                        _a = (_b.sent()) === false;
                        _b.label = 4;
                    case 4:
                        if (_a) {
                            return [2 /*return*/];
                        }
                        _b.label = 5;
                    case 5:
                        this.reportApiErrorToDefaultHandler("timeout");
                        return [2 /*return*/];
                }
            });
        });
    };
    BaseAPI.prototype.reportApiErrorResponse = function (response, errorHandler) {
        return __awaiter(this, void 0, void 0, function () {
            var status, entry, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        status = response.raw.status;
                        if (!(errorHandler === false)) return [3 /*break*/, 1];
                        return [2 /*return*/];
                    case 1:
                        if (!(typeof errorHandler === "object")) return [3 /*break*/, 5];
                        entry = (status in errorHandler)
                            ? errorHandler[status]
                            : errorHandler["other"];
                        if (!(entry === false)) return [3 /*break*/, 2];
                        return [2 /*return*/];
                    case 2:
                        _a = typeof entry === "function";
                        if (!_a) return [3 /*break*/, 4];
                        return [4 /*yield*/, entry(response)];
                    case 3:
                        _a = (_b.sent()) === false;
                        _b.label = 4;
                    case 4:
                        if (_a) {
                            return [2 /*return*/];
                        }
                        _b.label = 5;
                    case 5:
                        this.reportApiErrorToDefaultHandler("bad_response", status);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Create a shallow clone of `this` by constructing a new instance
     * and then shallow cloning data members.
     */
    BaseAPI.prototype.clone = function () {
        var constructor = this.constructor;
        var next = new constructor(this.configuration);
        next.middleware = this.middleware.slice();
        return next;
    };
    BaseAPI.jsonRegex = new RegExp('^(:?application\/json|[^;/ \t]+\/[^;/ \t]+[+]json)[ \t]*(:?;.*)?$', 'i');
    return BaseAPI;
}());
function isBlob(value) {
    return typeof Blob !== 'undefined' && value instanceof Blob;
}
function isFormData(value) {
    return typeof FormData !== "undefined" && value instanceof FormData;
}
var ResponseError = /** @class */ (function (_super) {
    __extends(ResponseError, _super);
    function ResponseError(response, msg) {
        var _this = _super.call(this, msg) || this;
        _this.response = response;
        _this.name = "ResponseError";
        return _this;
    }
    return ResponseError;
}(Error));
var FetchError = /** @class */ (function (_super) {
    __extends(FetchError, _super);
    function FetchError(cause, msg) {
        var _this = _super.call(this, msg) || this;
        _this.cause = cause;
        _this.name = "FetchError";
        return _this;
    }
    return FetchError;
}(Error));
var RequiredError = /** @class */ (function (_super) {
    __extends(RequiredError, _super);
    function RequiredError(field, msg) {
        var _this = _super.call(this, msg) || this;
        _this.field = field;
        _this.name = "RequiredError";
        return _this;
    }
    return RequiredError;
}(Error));
var COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
function querystring(params, prefix) {
    if (prefix === void 0) { prefix = ''; }
    return Object.keys(params)
        .map(function (key) { return querystringSingleKey(key, params[key], prefix); })
        .filter(function (part) { return part.length > 0; })
        .join('&');
}
function querystringSingleKey(key, value, keyPrefix) {
    if (keyPrefix === void 0) { keyPrefix = ''; }
    var fullKey = keyPrefix + (keyPrefix.length ? "[" + key + "]" : key);
    if (value instanceof Array) {
        var multiValue = value.map(function (singleValue) { return encodeURIComponent(String(singleValue)); })
            .join("&" + encodeURIComponent(fullKey) + "=");
        return encodeURIComponent(fullKey) + "=" + multiValue;
    }
    if (value instanceof Set) {
        var valueAsArray = Array.from(value);
        return querystringSingleKey(key, valueAsArray, keyPrefix);
    }
    if ((value instanceof luxon.DateTime) || (value instanceof dateAndTime.DateWithoutTime)) {
        return encodeURIComponent(fullKey) + "=" + encodeURIComponent(String(value.toISO()));
    }
    if (value instanceof Object) {
        return querystring(value, fullKey);
    }
    return encodeURIComponent(fullKey) + "=" + encodeURIComponent(String(value));
}
function exists(json, key) {
    var value = json[key];
    return value !== null && value !== undefined;
}
function mapValues(data, fn) {
    var result = {};
    for (var _i = 0, _a = Object.keys(data); _i < _a.length; _i++) {
        var key = _a[_i];
        result[key] = fn(data[key]);
    }
    return result;
}
function canConsumeForm(consumes) {
    for (var _i = 0, consumes_1 = consumes; _i < consumes_1.length; _i++) {
        var consume = consumes_1[_i];
        if ('multipart/form-data' === consume.contentType) {
            return true;
        }
    }
    return false;
}
var JSONApiResponse = /** @class */ (function () {
    function JSONApiResponse(raw, transformer) {
        if (transformer === void 0) { transformer = function (jsonValue) { return jsonValue; }; }
        this.raw = raw;
        this.transformer = transformer;
    }
    JSONApiResponse.prototype.value = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = {
                            status: this.raw.status
                        };
                        _b = this.transformer;
                        return [4 /*yield*/, this.raw.json()];
                    case 1: return [2 /*return*/, (_a.content = _b.apply(this, [_c.sent()]),
                            _a)];
                }
            });
        });
    };
    return JSONApiResponse;
}());
var VoidApiResponse = /** @class */ (function () {
    function VoidApiResponse(raw) {
        this.raw = raw;
    }
    VoidApiResponse.prototype.value = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, {
                        status: this.raw.status,
                        content: undefined
                    }];
            });
        });
    };
    return VoidApiResponse;
}());
var BlobApiResponse = /** @class */ (function () {
    function BlobApiResponse(raw) {
        this.raw = raw;
    }
    BlobApiResponse.prototype.value = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = {
                            status: this.raw.status
                        };
                        return [4 /*yield*/, this.raw.blob()];
                    case 1: return [2 /*return*/, (_a.content = _b.sent(),
                            _a)];
                }
            });
        });
    };
    return BlobApiResponse;
}());
var TextApiResponse = /** @class */ (function () {
    function TextApiResponse(raw) {
        this.raw = raw;
    }
    TextApiResponse.prototype.value = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = {
                            status: this.raw.status
                        };
                        return [4 /*yield*/, this.raw.text()];
                    case 1: return [2 /*return*/, (_a.content = _b.sent(),
                            _a)];
                }
            });
        });
    };
    return TextApiResponse;
}());

var runtime = /*#__PURE__*/Object.freeze({
    __proto__: null,
    BASE_PATH: BASE_PATH,
    BaseAPI: BaseAPI,
    BlobApiResponse: BlobApiResponse,
    COLLECTION_FORMATS: COLLECTION_FORMATS,
    Configuration: Configuration,
    DefaultConfig: DefaultConfig,
    FetchError: FetchError,
    JSONApiResponse: JSONApiResponse,
    RequiredError: RequiredError,
    ResponseError: ResponseError,
    TextApiResponse: TextApiResponse,
    VoidApiResponse: VoidApiResponse,
    canConsumeForm: canConsumeForm,
    exists: exists,
    mapValues: mapValues,
    querystring: querystring
});

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AbsenceCaseReasonRelationshipData interface.
 */
function instanceOfAbsenceCaseReasonRelationshipData(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function AbsenceCaseReasonRelationshipDataFromJSON(json) {
    return AbsenceCaseReasonRelationshipDataFromJSONTyped(json);
}
function AbsenceCaseReasonRelationshipDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
    };
}
function AbsenceCaseReasonRelationshipDataToJSON(json) {
    return AbsenceCaseReasonRelationshipDataToJSONTyped(json);
}
function AbsenceCaseReasonRelationshipDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseReasonRelationship interface.
 */
function instanceOfAbsenceCaseReasonRelationship(value) {
    return true;
}
function AbsenceCaseReasonRelationshipFromJSON(json) {
    return AbsenceCaseReasonRelationshipFromJSONTyped(json);
}
function AbsenceCaseReasonRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : AbsenceCaseReasonRelationshipDataFromJSON(json['data']),
    };
}
function AbsenceCaseReasonRelationshipToJSON(json) {
    return AbsenceCaseReasonRelationshipToJSONTyped(json);
}
function AbsenceCaseReasonRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': AbsenceCaseReasonRelationshipDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the EmployeeRelationshipData interface.
 */
function instanceOfEmployeeRelationshipData(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function EmployeeRelationshipDataFromJSON(json) {
    return EmployeeRelationshipDataFromJSONTyped(json);
}
function EmployeeRelationshipDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
    };
}
function EmployeeRelationshipDataToJSON(json) {
    return EmployeeRelationshipDataToJSONTyped(json);
}
function EmployeeRelationshipDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the EmployeeRelationship interface.
 */
function instanceOfEmployeeRelationship(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function EmployeeRelationshipFromJSON(json) {
    return EmployeeRelationshipFromJSONTyped(json);
}
function EmployeeRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': EmployeeRelationshipDataFromJSON(json['data']),
    };
}
function EmployeeRelationshipToJSON(json) {
    return EmployeeRelationshipToJSONTyped(json);
}
function EmployeeRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': EmployeeRelationshipDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UserRelationshipsDataInner interface.
 */
function instanceOfUserRelationshipsDataInner(value) {
    return true;
}
function UserRelationshipsDataInnerFromJSON(json) {
    return UserRelationshipsDataInnerFromJSONTyped(json);
}
function UserRelationshipsDataInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}
function UserRelationshipsDataInnerToJSON(json) {
    return UserRelationshipsDataInnerToJSONTyped(json);
}
function UserRelationshipsDataInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the UserRelationships interface.
 */
function instanceOfUserRelationships(value) {
    return true;
}
function UserRelationshipsFromJSON(json) {
    return UserRelationshipsFromJSONTyped(json);
}
function UserRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : (json['data'].map(UserRelationshipsDataInnerFromJSON)),
    };
}
function UserRelationshipsToJSON(json) {
    return UserRelationshipsToJSONTyped(json);
}
function UserRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': value['data'] == null ? undefined : (value['data'].map(UserRelationshipsDataInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AbsenceCaseLeaveTypeRelationshipDataInner interface.
 */
function instanceOfAbsenceCaseLeaveTypeRelationshipDataInner(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function AbsenceCaseLeaveTypeRelationshipDataInnerFromJSON(json) {
    return AbsenceCaseLeaveTypeRelationshipDataInnerFromJSONTyped(json);
}
function AbsenceCaseLeaveTypeRelationshipDataInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
    };
}
function AbsenceCaseLeaveTypeRelationshipDataInnerToJSON(json) {
    return AbsenceCaseLeaveTypeRelationshipDataInnerToJSONTyped(json);
}
function AbsenceCaseLeaveTypeRelationshipDataInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseLeaveTypeRelationship interface.
 */
function instanceOfAbsenceCaseLeaveTypeRelationship(value) {
    return true;
}
function AbsenceCaseLeaveTypeRelationshipFromJSON(json) {
    return AbsenceCaseLeaveTypeRelationshipFromJSONTyped(json);
}
function AbsenceCaseLeaveTypeRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : (json['data'].map(AbsenceCaseLeaveTypeRelationshipDataInnerFromJSON)),
    };
}
function AbsenceCaseLeaveTypeRelationshipToJSON(json) {
    return AbsenceCaseLeaveTypeRelationshipToJSONTyped(json);
}
function AbsenceCaseLeaveTypeRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': value['data'] == null ? undefined : (value['data'].map(AbsenceCaseLeaveTypeRelationshipDataInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseRelationships interface.
 */
function instanceOfAbsenceCaseRelationships(value) {
    if (!('employee' in value) || value['employee'] === undefined)
        return false;
    if (!('absenceCaseReason' in value) || value['absenceCaseReason'] === undefined)
        return false;
    return true;
}
function AbsenceCaseRelationshipsFromJSON(json) {
    return AbsenceCaseRelationshipsFromJSONTyped(json);
}
function AbsenceCaseRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'employee': EmployeeRelationshipFromJSON(json['employee']),
        'caseManagers': json['caseManagers'] == null ? undefined : UserRelationshipsFromJSON(json['caseManagers']),
        'absenceCaseReason': AbsenceCaseReasonRelationshipFromJSON(json['absenceCaseReason']),
        'eligibleLeaveTypes': json['eligibleLeaveTypes'] == null ? undefined : AbsenceCaseLeaveTypeRelationshipFromJSON(json['eligibleLeaveTypes']),
    };
}
function AbsenceCaseRelationshipsToJSON(json) {
    return AbsenceCaseRelationshipsToJSONTyped(json);
}
function AbsenceCaseRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'employee': EmployeeRelationshipToJSON(value['employee']),
        'caseManagers': UserRelationshipsToJSON(value['caseManagers']),
        'absenceCaseReason': AbsenceCaseReasonRelationshipToJSON(value['absenceCaseReason']),
        'eligibleLeaveTypes': AbsenceCaseLeaveTypeRelationshipToJSON(value['eligibleLeaveTypes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Current case status. There are specific transitions allowed for each individual state:
 * Starting State: PENDING in the case of a standard absence case, OPEN in the situation that a case is pre-approved.
 *
 * PENDING -> [DENIED, DELETED, CANCELLED, OPEN] OPEN -> [PENDING, DENIED, DELETED, APPROVED] DENIED -> [PENDING, OPEN]
 *
 * APPROVED -> [OPEN, CLOSED, DELETED] CLOSED -> [APPROVED, DELETED]
 *
 * CANCELLED -> [DELETED] APPROVED -> [OPEN, CLOSED, DELETED]
 *
 * DELETED -> [PENDING, OPEN, CLOSED, APPROVED]
 *
 * Refer to official product documentation on the practical user workflow for each of these states.
 * @export
 */
var Status = {
    Pending: 'PENDING',
    Open: 'OPEN',
    Approved: 'APPROVED',
    Denied: 'DENIED',
    Cancelled: 'CANCELLED',
    Closed: 'CLOSED',
    Deleted: 'DELETED'
};
function instanceOfStatus(value) {
    for (var key in Status) {
        if (Object.prototype.hasOwnProperty.call(Status, key)) {
            if (Status[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function StatusFromJSON(json) {
    return StatusFromJSONTyped(json);
}
function StatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function StatusToJSON(value) {
    return value;
}
function StatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Absence cases have multiple possible case types that change the nature of the time associated with it:
 *
 * CONTINUOUS - This case will result in a continuous block of time for the duration of the request being taken off. Example: military deployment.
 *
 * INTERMITTENT - This case will result in a non-continuous block of time for the duration of the request being taken off. Example: occasional physical therapy appointments on non-contiguous days in July while recovering from an injury.
 *
 * REDUCED_SCHEDULE - The case will result in a continuous block of days having a reduced schedule set on them. Example: afternoon court cases due to being the victim of a crime.
 * @export
 */
var CaseType = {
    Accommodation: 'ACCOMMODATION',
    Continuous: 'CONTINUOUS',
    Intermittent: 'INTERMITTENT',
    ReducedSchedule: 'REDUCED_SCHEDULE'
};
function instanceOfCaseType(value) {
    for (var key in CaseType) {
        if (Object.prototype.hasOwnProperty.call(CaseType, key)) {
            if (CaseType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function CaseTypeFromJSON(json) {
    return CaseTypeFromJSONTyped(json);
}
function CaseTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function CaseTypeToJSON(value) {
    return value;
}
function CaseTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseAttributes interface.
 */
function instanceOfAbsenceCaseAttributes(value) {
    if (!('caseType' in value) || value['caseType'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('startDate' in value) || value['startDate'] === undefined)
        return false;
    return true;
}
function AbsenceCaseAttributesFromJSON(json) {
    return AbsenceCaseAttributesFromJSONTyped(json);
}
function AbsenceCaseAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'displayId': json['displayId'] == null ? undefined : json['displayId'],
        'caseType': CaseTypeFromJSON(json['caseType']),
        'status': StatusFromJSON(json['status']),
        'startDate': (dateAndTime.DateWithoutTime.fromISO(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['endDate'])),
    };
}
function AbsenceCaseAttributesToJSON(json) {
    return AbsenceCaseAttributesToJSONTyped(json);
}
function AbsenceCaseAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'displayId': value['displayId'],
        'caseType': CaseTypeToJSON(value['caseType']),
        'status': StatusToJSON(value['status']),
        'startDate': value['startDate'].toISO(),
        'endDate': value['endDate'] == null ? value['endDate'] : value['endDate'].toISO(),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCase interface.
 */
function instanceOfAbsenceCase(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function AbsenceCaseFromJSON(json) {
    return AbsenceCaseFromJSONTyped(json);
}
function AbsenceCaseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': AbsenceCaseAttributesFromJSON(json['attributes']),
        'relationships': json['relationships'] == null ? undefined : AbsenceCaseRelationshipsFromJSON(json['relationships']),
    };
}
function AbsenceCaseToJSON(json) {
    return AbsenceCaseToJSONTyped(json);
}
function AbsenceCaseToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': AbsenceCaseAttributesToJSON(value['attributes']),
        'relationships': AbsenceCaseRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AbsenceCaseContactEmployeeRequestDataAttributes interface.
 */
function instanceOfAbsenceCaseContactEmployeeRequestDataAttributes(value) {
    if (!('sendToEmployee' in value) || value['sendToEmployee'] === undefined)
        return false;
    if (!('emailBody' in value) || value['emailBody'] === undefined)
        return false;
    if (!('emailSubject' in value) || value['emailSubject'] === undefined)
        return false;
    return true;
}
function AbsenceCaseContactEmployeeRequestDataAttributesFromJSON(json) {
    return AbsenceCaseContactEmployeeRequestDataAttributesFromJSONTyped(json);
}
function AbsenceCaseContactEmployeeRequestDataAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'sendToEmployee': json['sendToEmployee'],
        'additionalToSendTo': json['additionalToSendTo'] == null ? undefined : json['additionalToSendTo'],
        'emailBody': json['emailBody'],
        'emailSubject': json['emailSubject'],
    };
}
function AbsenceCaseContactEmployeeRequestDataAttributesToJSON(json) {
    return AbsenceCaseContactEmployeeRequestDataAttributesToJSONTyped(json);
}
function AbsenceCaseContactEmployeeRequestDataAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'sendToEmployee': value['sendToEmployee'],
        'additionalToSendTo': value['additionalToSendTo'],
        'emailBody': value['emailBody'],
        'emailSubject': value['emailSubject'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AbsenceCaseRelationshipData interface.
 */
function instanceOfAbsenceCaseRelationshipData(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function AbsenceCaseRelationshipDataFromJSON(json) {
    return AbsenceCaseRelationshipDataFromJSONTyped(json);
}
function AbsenceCaseRelationshipDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
    };
}
function AbsenceCaseRelationshipDataToJSON(json) {
    return AbsenceCaseRelationshipDataToJSONTyped(json);
}
function AbsenceCaseRelationshipDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseRelationship interface.
 */
function instanceOfAbsenceCaseRelationship(value) {
    return true;
}
function AbsenceCaseRelationshipFromJSON(json) {
    return AbsenceCaseRelationshipFromJSONTyped(json);
}
function AbsenceCaseRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : AbsenceCaseRelationshipDataFromJSON(json['data']),
    };
}
function AbsenceCaseRelationshipToJSON(json) {
    return AbsenceCaseRelationshipToJSONTyped(json);
}
function AbsenceCaseRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': AbsenceCaseRelationshipDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseContactEmployeeRequestDataRelationships interface.
 */
function instanceOfAbsenceCaseContactEmployeeRequestDataRelationships(value) {
    if (!('absenceCase' in value) || value['absenceCase'] === undefined)
        return false;
    return true;
}
function AbsenceCaseContactEmployeeRequestDataRelationshipsFromJSON(json) {
    return AbsenceCaseContactEmployeeRequestDataRelationshipsFromJSONTyped(json);
}
function AbsenceCaseContactEmployeeRequestDataRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'absenceCase': AbsenceCaseRelationshipFromJSON(json['absenceCase']),
    };
}
function AbsenceCaseContactEmployeeRequestDataRelationshipsToJSON(json) {
    return AbsenceCaseContactEmployeeRequestDataRelationshipsToJSONTyped(json);
}
function AbsenceCaseContactEmployeeRequestDataRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'absenceCase': AbsenceCaseRelationshipToJSON(value['absenceCase']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseContactEmployeeRequestData interface.
 */
function instanceOfAbsenceCaseContactEmployeeRequestData(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function AbsenceCaseContactEmployeeRequestDataFromJSON(json) {
    return AbsenceCaseContactEmployeeRequestDataFromJSONTyped(json);
}
function AbsenceCaseContactEmployeeRequestDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'attributes': AbsenceCaseContactEmployeeRequestDataAttributesFromJSON(json['attributes']),
        'relationships': json['relationships'] == null ? undefined : AbsenceCaseContactEmployeeRequestDataRelationshipsFromJSON(json['relationships']),
    };
}
function AbsenceCaseContactEmployeeRequestDataToJSON(json) {
    return AbsenceCaseContactEmployeeRequestDataToJSONTyped(json);
}
function AbsenceCaseContactEmployeeRequestDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'attributes': AbsenceCaseContactEmployeeRequestDataAttributesToJSON(value['attributes']),
        'relationships': AbsenceCaseContactEmployeeRequestDataRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseContactEmployeeRequest interface.
 */
function instanceOfAbsenceCaseContactEmployeeRequest(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function AbsenceCaseContactEmployeeRequestFromJSON(json) {
    return AbsenceCaseContactEmployeeRequestFromJSONTyped(json);
}
function AbsenceCaseContactEmployeeRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': AbsenceCaseContactEmployeeRequestDataFromJSON(json['data']),
    };
}
function AbsenceCaseContactEmployeeRequestToJSON(json) {
    return AbsenceCaseContactEmployeeRequestToJSONTyped(json);
}
function AbsenceCaseContactEmployeeRequestToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': AbsenceCaseContactEmployeeRequestDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseContactEmployeeResponseRelationships interface.
 */
function instanceOfAbsenceCaseContactEmployeeResponseRelationships(value) {
    if (!('employee' in value) || value['employee'] === undefined)
        return false;
    if (!('absenceCase' in value) || value['absenceCase'] === undefined)
        return false;
    return true;
}
function AbsenceCaseContactEmployeeResponseRelationshipsFromJSON(json) {
    return AbsenceCaseContactEmployeeResponseRelationshipsFromJSONTyped(json);
}
function AbsenceCaseContactEmployeeResponseRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'employee': EmployeeRelationshipFromJSON(json['employee']),
        'absenceCase': AbsenceCaseRelationshipFromJSON(json['absenceCase']),
    };
}
function AbsenceCaseContactEmployeeResponseRelationshipsToJSON(json) {
    return AbsenceCaseContactEmployeeResponseRelationshipsToJSONTyped(json);
}
function AbsenceCaseContactEmployeeResponseRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'employee': EmployeeRelationshipToJSON(value['employee']),
        'absenceCase': AbsenceCaseRelationshipToJSON(value['absenceCase']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseContactEmployeeResponseAttributes interface.
 */
function instanceOfAbsenceCaseContactEmployeeResponseAttributes(value) {
    if (!('submittedAt' in value) || value['submittedAt'] === undefined)
        return false;
    if (!('submittedBy' in value) || value['submittedBy'] === undefined)
        return false;
    if (!('notificationID' in value) || value['notificationID'] === undefined)
        return false;
    if (!('sendToEmployee' in value) || value['sendToEmployee'] === undefined)
        return false;
    if (!('emailBody' in value) || value['emailBody'] === undefined)
        return false;
    if (!('emailSubject' in value) || value['emailSubject'] === undefined)
        return false;
    return true;
}
function AbsenceCaseContactEmployeeResponseAttributesFromJSON(json) {
    return AbsenceCaseContactEmployeeResponseAttributesFromJSONTyped(json);
}
function AbsenceCaseContactEmployeeResponseAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'submittedAt': (luxon.DateTime.fromISO(json['submittedAt'])),
        'submittedBy': json['submittedBy'],
        'notificationID': json['notificationID'],
        'sendToEmployee': json['sendToEmployee'],
        'additionalToSendTo': json['additionalToSendTo'] == null ? undefined : json['additionalToSendTo'],
        'emailBody': json['emailBody'],
        'emailSubject': json['emailSubject'],
    };
}
function AbsenceCaseContactEmployeeResponseAttributesToJSON(json) {
    return AbsenceCaseContactEmployeeResponseAttributesToJSONTyped(json);
}
function AbsenceCaseContactEmployeeResponseAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'submittedAt': value['submittedAt'].toISO(),
        'submittedBy': value['submittedBy'],
        'notificationID': value['notificationID'],
        'sendToEmployee': value['sendToEmployee'],
        'additionalToSendTo': value['additionalToSendTo'],
        'emailBody': value['emailBody'],
        'emailSubject': value['emailSubject'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseContactEmployeeResponse interface.
 */
function instanceOfAbsenceCaseContactEmployeeResponse(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function AbsenceCaseContactEmployeeResponseFromJSON(json) {
    return AbsenceCaseContactEmployeeResponseFromJSONTyped(json);
}
function AbsenceCaseContactEmployeeResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'attributes': AbsenceCaseContactEmployeeResponseAttributesFromJSON(json['attributes']),
        'relationships': json['relationships'] == null ? undefined : AbsenceCaseContactEmployeeResponseRelationshipsFromJSON(json['relationships']),
    };
}
function AbsenceCaseContactEmployeeResponseToJSON(json) {
    return AbsenceCaseContactEmployeeResponseToJSONTyped(json);
}
function AbsenceCaseContactEmployeeResponseToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'attributes': AbsenceCaseContactEmployeeResponseAttributesToJSON(value['attributes']),
        'relationships': AbsenceCaseContactEmployeeResponseRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInner interface.
 */
function instanceOfAbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInner(value) {
    return true;
}
function AbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInnerFromJSON(json) {
    return AbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInnerFromJSONTyped(json);
}
function AbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'questionText': json['questionText'] == null ? undefined : json['questionText'],
        'answer': json['answer'] == null ? undefined : json['answer'],
    };
}
function AbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInnerToJSON(json) {
    return AbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInnerToJSONTyped(json);
}
function AbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'questionText': value['questionText'],
        'answer': value['answer'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var AbsenceCaseDetailsAttributesUsePaidTimeEnum = {
    Required: 'REQUIRED',
    EmployeeElected: 'EMPLOYEE_ELECTED',
    No: 'NO'
};
/**
 * @export
 */
var AbsenceCaseDetailsAttributesContactMethodEnum = {
    Email: 'EMAIL',
    InterofficeMail: 'INTEROFFICE_MAIL',
    PostalMail: 'POSTAL_MAIL'
};
/**
 * Check if a given object implements the AbsenceCaseDetailsAttributes interface.
 */
function instanceOfAbsenceCaseDetailsAttributes(value) {
    if (!('caseType' in value) || value['caseType'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('startDate' in value) || value['startDate'] === undefined)
        return false;
    if (!('usePaidTime' in value) || value['usePaidTime'] === undefined)
        return false;
    if (!('personAffected' in value) || value['personAffected'] === undefined)
        return false;
    return true;
}
function AbsenceCaseDetailsAttributesFromJSON(json) {
    return AbsenceCaseDetailsAttributesFromJSONTyped(json);
}
function AbsenceCaseDetailsAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'displayId': json['displayId'] == null ? undefined : json['displayId'],
        'caseType': CaseTypeFromJSON(json['caseType']),
        'status': StatusFromJSON(json['status']),
        'startDate': (dateAndTime.DateWithoutTime.fromISO(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['endDate'])),
        'usePaidTime': json['usePaidTime'],
        'contactMethod': json['contactMethod'] == null ? undefined : json['contactMethod'],
        'contactAddress': json['contactAddress'] == null ? undefined : json['contactAddress'],
        'personAffected': json['personAffected'],
        'caseNotes': json['caseNotes'] == null ? undefined : json['caseNotes'],
        'caseQuestionsAndAnswers': json['caseQuestionsAndAnswers'] == null ? undefined : (json['caseQuestionsAndAnswers'].map(AbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInnerFromJSON)),
    };
}
function AbsenceCaseDetailsAttributesToJSON(json) {
    return AbsenceCaseDetailsAttributesToJSONTyped(json);
}
function AbsenceCaseDetailsAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'displayId': value['displayId'],
        'caseType': CaseTypeToJSON(value['caseType']),
        'status': StatusToJSON(value['status']),
        'startDate': value['startDate'].toISO(),
        'endDate': value['endDate'] == null ? value['endDate'] : value['endDate'].toISO(),
        'usePaidTime': value['usePaidTime'],
        'contactMethod': value['contactMethod'],
        'contactAddress': value['contactAddress'],
        'personAffected': value['personAffected'],
        'caseNotes': value['caseNotes'],
        'caseQuestionsAndAnswers': value['caseQuestionsAndAnswers'] == null ? undefined : (value['caseQuestionsAndAnswers'].map(AbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AbsenceCaseDocumentsRelationshipDataInner interface.
 */
function instanceOfAbsenceCaseDocumentsRelationshipDataInner(value) {
    return true;
}
function AbsenceCaseDocumentsRelationshipDataInnerFromJSON(json) {
    return AbsenceCaseDocumentsRelationshipDataInnerFromJSONTyped(json);
}
function AbsenceCaseDocumentsRelationshipDataInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}
function AbsenceCaseDocumentsRelationshipDataInnerToJSON(json) {
    return AbsenceCaseDocumentsRelationshipDataInnerToJSONTyped(json);
}
function AbsenceCaseDocumentsRelationshipDataInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseDocumentsRelationship interface.
 */
function instanceOfAbsenceCaseDocumentsRelationship(value) {
    return true;
}
function AbsenceCaseDocumentsRelationshipFromJSON(json) {
    return AbsenceCaseDocumentsRelationshipFromJSONTyped(json);
}
function AbsenceCaseDocumentsRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : (json['data'].map(AbsenceCaseDocumentsRelationshipDataInnerFromJSON)),
    };
}
function AbsenceCaseDocumentsRelationshipToJSON(json) {
    return AbsenceCaseDocumentsRelationshipToJSONTyped(json);
}
function AbsenceCaseDocumentsRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': value['data'] == null ? undefined : (value['data'].map(AbsenceCaseDocumentsRelationshipDataInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AbsenceCaseLeaveEligibilityRelationshipDataInner interface.
 */
function instanceOfAbsenceCaseLeaveEligibilityRelationshipDataInner(value) {
    return true;
}
function AbsenceCaseLeaveEligibilityRelationshipDataInnerFromJSON(json) {
    return AbsenceCaseLeaveEligibilityRelationshipDataInnerFromJSONTyped(json);
}
function AbsenceCaseLeaveEligibilityRelationshipDataInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}
function AbsenceCaseLeaveEligibilityRelationshipDataInnerToJSON(json) {
    return AbsenceCaseLeaveEligibilityRelationshipDataInnerToJSONTyped(json);
}
function AbsenceCaseLeaveEligibilityRelationshipDataInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseLeaveEligibilityRelationship interface.
 */
function instanceOfAbsenceCaseLeaveEligibilityRelationship(value) {
    return true;
}
function AbsenceCaseLeaveEligibilityRelationshipFromJSON(json) {
    return AbsenceCaseLeaveEligibilityRelationshipFromJSONTyped(json);
}
function AbsenceCaseLeaveEligibilityRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : (json['data'].map(AbsenceCaseLeaveEligibilityRelationshipDataInnerFromJSON)),
    };
}
function AbsenceCaseLeaveEligibilityRelationshipToJSON(json) {
    return AbsenceCaseLeaveEligibilityRelationshipToJSONTyped(json);
}
function AbsenceCaseLeaveEligibilityRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': value['data'] == null ? undefined : (value['data'].map(AbsenceCaseLeaveEligibilityRelationshipDataInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AbsenceCaseProjectedUsagesRelationshipDataInner interface.
 */
function instanceOfAbsenceCaseProjectedUsagesRelationshipDataInner(value) {
    return true;
}
function AbsenceCaseProjectedUsagesRelationshipDataInnerFromJSON(json) {
    return AbsenceCaseProjectedUsagesRelationshipDataInnerFromJSONTyped(json);
}
function AbsenceCaseProjectedUsagesRelationshipDataInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}
function AbsenceCaseProjectedUsagesRelationshipDataInnerToJSON(json) {
    return AbsenceCaseProjectedUsagesRelationshipDataInnerToJSONTyped(json);
}
function AbsenceCaseProjectedUsagesRelationshipDataInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseProjectedUsagesRelationship interface.
 */
function instanceOfAbsenceCaseProjectedUsagesRelationship(value) {
    return true;
}
function AbsenceCaseProjectedUsagesRelationshipFromJSON(json) {
    return AbsenceCaseProjectedUsagesRelationshipFromJSONTyped(json);
}
function AbsenceCaseProjectedUsagesRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : (json['data'].map(AbsenceCaseProjectedUsagesRelationshipDataInnerFromJSON)),
    };
}
function AbsenceCaseProjectedUsagesRelationshipToJSON(json) {
    return AbsenceCaseProjectedUsagesRelationshipToJSONTyped(json);
}
function AbsenceCaseProjectedUsagesRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': value['data'] == null ? undefined : (value['data'].map(AbsenceCaseProjectedUsagesRelationshipDataInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseDetailsRelationships interface.
 */
function instanceOfAbsenceCaseDetailsRelationships(value) {
    if (!('employee' in value) || value['employee'] === undefined)
        return false;
    if (!('absenceCaseReason' in value) || value['absenceCaseReason'] === undefined)
        return false;
    if (!('projectedUsages' in value) || value['projectedUsages'] === undefined)
        return false;
    if (!('leaveEligibility' in value) || value['leaveEligibility'] === undefined)
        return false;
    return true;
}
function AbsenceCaseDetailsRelationshipsFromJSON(json) {
    return AbsenceCaseDetailsRelationshipsFromJSONTyped(json);
}
function AbsenceCaseDetailsRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'employee': EmployeeRelationshipFromJSON(json['employee']),
        'caseManagers': json['caseManagers'] == null ? undefined : UserRelationshipsFromJSON(json['caseManagers']),
        'absenceCaseReason': AbsenceCaseReasonRelationshipFromJSON(json['absenceCaseReason']),
        'documents': json['documents'] == null ? undefined : AbsenceCaseDocumentsRelationshipFromJSON(json['documents']),
        'projectedUsages': AbsenceCaseProjectedUsagesRelationshipFromJSON(json['projectedUsages']),
        'leaveEligibility': AbsenceCaseLeaveEligibilityRelationshipFromJSON(json['leaveEligibility']),
    };
}
function AbsenceCaseDetailsRelationshipsToJSON(json) {
    return AbsenceCaseDetailsRelationshipsToJSONTyped(json);
}
function AbsenceCaseDetailsRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'employee': EmployeeRelationshipToJSON(value['employee']),
        'caseManagers': UserRelationshipsToJSON(value['caseManagers']),
        'absenceCaseReason': AbsenceCaseReasonRelationshipToJSON(value['absenceCaseReason']),
        'documents': AbsenceCaseDocumentsRelationshipToJSON(value['documents']),
        'projectedUsages': AbsenceCaseProjectedUsagesRelationshipToJSON(value['projectedUsages']),
        'leaveEligibility': AbsenceCaseLeaveEligibilityRelationshipToJSON(value['leaveEligibility']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseDetails interface.
 */
function instanceOfAbsenceCaseDetails(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function AbsenceCaseDetailsFromJSON(json) {
    return AbsenceCaseDetailsFromJSONTyped(json);
}
function AbsenceCaseDetailsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': AbsenceCaseDetailsAttributesFromJSON(json['attributes']),
        'relationships': json['relationships'] == null ? undefined : AbsenceCaseDetailsRelationshipsFromJSON(json['relationships']),
    };
}
function AbsenceCaseDetailsToJSON(json) {
    return AbsenceCaseDetailsToJSONTyped(json);
}
function AbsenceCaseDetailsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': AbsenceCaseDetailsAttributesToJSON(value['attributes']),
        'relationships': AbsenceCaseDetailsRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var AbsenceCaseDocumentsReducedAttributesStatusEnum = {
    Active: 'ACTIVE',
    Archived: 'ARCHIVED',
    Deleted: 'DELETED',
    Future: 'FUTURE',
    NotApplicable: 'NOT APPLICABLE'
};
/**
 * @export
 */
var AbsenceCaseDocumentsReducedAttributesTriggerTypeEnum = {
    Created: 'CREATED',
    Completed: 'COMPLETED'
};
/**
 * Check if a given object implements the AbsenceCaseDocumentsReducedAttributes interface.
 */
function instanceOfAbsenceCaseDocumentsReducedAttributes(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
function AbsenceCaseDocumentsReducedAttributesFromJSON(json) {
    return AbsenceCaseDocumentsReducedAttributesFromJSONTyped(json);
}
function AbsenceCaseDocumentsReducedAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'attachedBy': json['attachedBy'] == null ? undefined : json['attachedBy'],
        'attachedDTTM': json['attachedDTTM'] == null ? undefined : (luxon.DateTime.fromISO(json['attachedDTTM'])),
        'contentType': json['contentType'] == null ? undefined : json['contentType'],
        'documentContent': json['documentContent'] == null ? undefined : json['documentContent'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'description': json['description'] == null ? undefined : json['description'],
        'documentSize': json['documentSize'] == null ? undefined : json['documentSize'],
        'status': json['status'],
        'sentToEmployee': json['sentToEmployee'] == null ? undefined : json['sentToEmployee'],
        'sentToEmployeeDTTM': json['sentToEmployeeDTTM'] == null ? undefined : (luxon.DateTime.fromISO(json['sentToEmployeeDTTM'])),
        'acknowledgedByEmployee': json['acknowledgedByEmployee'] == null ? undefined : json['acknowledgedByEmployee'],
        'acknowledgedByEmployeeDTTM': json['acknowledgedByEmployeeDTTM'] == null ? undefined : (luxon.DateTime.fromISO(json['acknowledgedByEmployeeDTTM'])),
        'sentToAnyone': json['sentToAnyone'] == null ? undefined : json['sentToAnyone'],
        'mostRecentlyReplacedBy': json['mostRecentlyReplacedBy'] == null ? undefined : json['mostRecentlyReplacedBy'],
        'mostRecentlyReplacedByDTTM': json['mostRecentlyReplacedByDTTM'] == null ? undefined : (luxon.DateTime.fromISO(json['mostRecentlyReplacedByDTTM'])),
        'visibleToEmployee': json['visibleToEmployee'] == null ? undefined : json['visibleToEmployee'],
        'triggerEventPolicy': json['triggerEventPolicy'] == null ? undefined : json['triggerEventPolicy'],
        'triggerType': json['triggerType'] == null ? undefined : json['triggerType'],
        'hasErrors': json['hasErrors'] == null ? undefined : json['hasErrors'],
    };
}
function AbsenceCaseDocumentsReducedAttributesToJSON(json) {
    return AbsenceCaseDocumentsReducedAttributesToJSONTyped(json);
}
function AbsenceCaseDocumentsReducedAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'attachedBy': value['attachedBy'],
        'attachedDTTM': value['attachedDTTM'] == null ? value['attachedDTTM'] : value['attachedDTTM'].toISO(),
        'contentType': value['contentType'],
        'documentContent': value['documentContent'],
        'fileName': value['fileName'],
        'description': value['description'],
        'documentSize': value['documentSize'],
        'status': value['status'],
        'sentToEmployee': value['sentToEmployee'],
        'sentToEmployeeDTTM': value['sentToEmployeeDTTM'] == null ? value['sentToEmployeeDTTM'] : value['sentToEmployeeDTTM'].toISO(),
        'acknowledgedByEmployee': value['acknowledgedByEmployee'],
        'acknowledgedByEmployeeDTTM': value['acknowledgedByEmployeeDTTM'] == null ? value['acknowledgedByEmployeeDTTM'] : value['acknowledgedByEmployeeDTTM'].toISO(),
        'sentToAnyone': value['sentToAnyone'],
        'mostRecentlyReplacedBy': value['mostRecentlyReplacedBy'],
        'mostRecentlyReplacedByDTTM': value['mostRecentlyReplacedByDTTM'] == null ? value['mostRecentlyReplacedByDTTM'] : value['mostRecentlyReplacedByDTTM'].toISO(),
        'visibleToEmployee': value['visibleToEmployee'],
        'triggerEventPolicy': value['triggerEventPolicy'],
        'triggerType': value['triggerType'],
        'hasErrors': value['hasErrors'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseDocumentsReduced interface.
 */
function instanceOfAbsenceCaseDocumentsReduced(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function AbsenceCaseDocumentsReducedFromJSON(json) {
    return AbsenceCaseDocumentsReducedFromJSONTyped(json);
}
function AbsenceCaseDocumentsReducedFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': AbsenceCaseDocumentsReducedAttributesFromJSON(json['attributes']),
    };
}
function AbsenceCaseDocumentsReducedToJSON(json) {
    return AbsenceCaseDocumentsReducedToJSONTyped(json);
}
function AbsenceCaseDocumentsReducedToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': AbsenceCaseDocumentsReducedAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var AbsenceCaseEditableAttributesUsePaidTimeEnum = {
    Required: 'REQUIRED',
    EmployeeElected: 'EMPLOYEE_ELECTED',
    No: 'NO'
};
/**
 * @export
 */
var AbsenceCaseEditableAttributesContactMethodEnum = {
    Email: 'EMAIL',
    InterofficeMail: 'INTEROFFICE_MAIL',
    PostalMail: 'POSTAL_MAIL'
};
/**
 * Check if a given object implements the AbsenceCaseEditableAttributes interface.
 */
function instanceOfAbsenceCaseEditableAttributes(value) {
    return true;
}
function AbsenceCaseEditableAttributesFromJSON(json) {
    return AbsenceCaseEditableAttributesFromJSONTyped(json);
}
function AbsenceCaseEditableAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'caseType': json['caseType'] == null ? undefined : CaseTypeFromJSON(json['caseType']),
        'startDate': json['startDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['endDate'])),
        'usePaidTime': json['usePaidTime'] == null ? undefined : json['usePaidTime'],
        'contactMethod': json['contactMethod'] == null ? undefined : json['contactMethod'],
        'contactAddress': json['contactAddress'] == null ? undefined : json['contactAddress'],
        'caseNotes': json['caseNotes'] == null ? undefined : json['caseNotes'],
    };
}
function AbsenceCaseEditableAttributesToJSON(json) {
    return AbsenceCaseEditableAttributesToJSONTyped(json);
}
function AbsenceCaseEditableAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'caseType': CaseTypeToJSON(value['caseType']),
        'startDate': value['startDate'] == null ? value['startDate'] : value['startDate'].toISO(),
        'endDate': value['endDate'] == null ? value['endDate'] : value['endDate'].toISO(),
        'usePaidTime': value['usePaidTime'],
        'contactMethod': value['contactMethod'],
        'contactAddress': value['contactAddress'],
        'caseNotes': value['caseNotes'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AbsenceCaseEventRelationshipDataAttributes interface.
 */
function instanceOfAbsenceCaseEventRelationshipDataAttributes(value) {
    return true;
}
function AbsenceCaseEventRelationshipDataAttributesFromJSON(json) {
    return AbsenceCaseEventRelationshipDataAttributesFromJSONTyped(json);
}
function AbsenceCaseEventRelationshipDataAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'displayId': json['displayId'] == null ? undefined : json['displayId'],
    };
}
function AbsenceCaseEventRelationshipDataAttributesToJSON(json) {
    return AbsenceCaseEventRelationshipDataAttributesToJSONTyped(json);
}
function AbsenceCaseEventRelationshipDataAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'displayId': value['displayId'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseEventRelationshipData interface.
 */
function instanceOfAbsenceCaseEventRelationshipData(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function AbsenceCaseEventRelationshipDataFromJSON(json) {
    return AbsenceCaseEventRelationshipDataFromJSONTyped(json);
}
function AbsenceCaseEventRelationshipDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': AbsenceCaseEventRelationshipDataAttributesFromJSON(json['attributes']),
    };
}
function AbsenceCaseEventRelationshipDataToJSON(json) {
    return AbsenceCaseEventRelationshipDataToJSONTyped(json);
}
function AbsenceCaseEventRelationshipDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': AbsenceCaseEventRelationshipDataAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseEventRelationship interface.
 */
function instanceOfAbsenceCaseEventRelationship(value) {
    return true;
}
function AbsenceCaseEventRelationshipFromJSON(json) {
    return AbsenceCaseEventRelationshipFromJSONTyped(json);
}
function AbsenceCaseEventRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : AbsenceCaseEventRelationshipDataFromJSON(json['data']),
    };
}
function AbsenceCaseEventRelationshipToJSON(json) {
    return AbsenceCaseEventRelationshipToJSONTyped(json);
}
function AbsenceCaseEventRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': AbsenceCaseEventRelationshipDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseHistoryEventRelationships interface.
 */
function instanceOfAbsenceCaseHistoryEventRelationships(value) {
    if (!('absenceCase' in value) || value['absenceCase'] === undefined)
        return false;
    return true;
}
function AbsenceCaseHistoryEventRelationshipsFromJSON(json) {
    return AbsenceCaseHistoryEventRelationshipsFromJSONTyped(json);
}
function AbsenceCaseHistoryEventRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'absenceCase': AbsenceCaseRelationshipFromJSON(json['absenceCase']),
    };
}
function AbsenceCaseHistoryEventRelationshipsToJSON(json) {
    return AbsenceCaseHistoryEventRelationshipsToJSONTyped(json);
}
function AbsenceCaseHistoryEventRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'absenceCase': AbsenceCaseRelationshipToJSON(value['absenceCase']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseHistoryEventAttributes interface.
 */
function instanceOfAbsenceCaseHistoryEventAttributes(value) {
    if (!('date' in value) || value['date'] === undefined)
        return false;
    if (!('eventDescription' in value) || value['eventDescription'] === undefined)
        return false;
    if (!('modifiedBy' in value) || value['modifiedBy'] === undefined)
        return false;
    return true;
}
function AbsenceCaseHistoryEventAttributesFromJSON(json) {
    return AbsenceCaseHistoryEventAttributesFromJSONTyped(json);
}
function AbsenceCaseHistoryEventAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'date': (luxon.DateTime.fromISO(json['date'])),
        'eventDescription': json['eventDescription'],
        'modifiedBy': json['modifiedBy'],
        'rolledbackHistoryEventId': json['rolledbackHistoryEventId'] == null ? undefined : json['rolledbackHistoryEventId'],
    };
}
function AbsenceCaseHistoryEventAttributesToJSON(json) {
    return AbsenceCaseHistoryEventAttributesToJSONTyped(json);
}
function AbsenceCaseHistoryEventAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'date': value['date'].toISO(),
        'eventDescription': value['eventDescription'],
        'modifiedBy': value['modifiedBy'],
        'rolledbackHistoryEventId': value['rolledbackHistoryEventId'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseHistoryEvent interface.
 */
function instanceOfAbsenceCaseHistoryEvent(value) {
    return true;
}
function AbsenceCaseHistoryEventFromJSON(json) {
    return AbsenceCaseHistoryEventFromJSONTyped(json);
}
function AbsenceCaseHistoryEventFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'attributes': json['attributes'] == null ? undefined : AbsenceCaseHistoryEventAttributesFromJSON(json['attributes']),
        'relationships': json['relationships'] == null ? undefined : AbsenceCaseHistoryEventRelationshipsFromJSON(json['relationships']),
    };
}
function AbsenceCaseHistoryEventToJSON(json) {
    return AbsenceCaseHistoryEventToJSONTyped(json);
}
function AbsenceCaseHistoryEventToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': AbsenceCaseHistoryEventAttributesToJSON(value['attributes']),
        'relationships': AbsenceCaseHistoryEventRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AbsenceCaseHistoryEventRelationshipData interface.
 */
function instanceOfAbsenceCaseHistoryEventRelationshipData(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function AbsenceCaseHistoryEventRelationshipDataFromJSON(json) {
    return AbsenceCaseHistoryEventRelationshipDataFromJSONTyped(json);
}
function AbsenceCaseHistoryEventRelationshipDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
    };
}
function AbsenceCaseHistoryEventRelationshipDataToJSON(json) {
    return AbsenceCaseHistoryEventRelationshipDataToJSONTyped(json);
}
function AbsenceCaseHistoryEventRelationshipDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseHistoryEventRelationship interface.
 */
function instanceOfAbsenceCaseHistoryEventRelationship(value) {
    return true;
}
function AbsenceCaseHistoryEventRelationshipFromJSON(json) {
    return AbsenceCaseHistoryEventRelationshipFromJSONTyped(json);
}
function AbsenceCaseHistoryEventRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : AbsenceCaseHistoryEventRelationshipDataFromJSON(json['data']),
    };
}
function AbsenceCaseHistoryEventRelationshipToJSON(json) {
    return AbsenceCaseHistoryEventRelationshipToJSONTyped(json);
}
function AbsenceCaseHistoryEventRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': AbsenceCaseHistoryEventRelationshipDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
var EligibleLeaveOverrideDtlQualificationResultEnum = {
    NotQualified: 'NOT_QUALIFIED',
    Qualified: 'QUALIFIED',
    Error: 'ERROR',
    WrongReason: 'WRONG_REASON'
};
/**
 * Check if a given object implements the EligibleLeaveOverrideDtl interface.
 */
function instanceOfEligibleLeaveOverrideDtl(value) {
    return true;
}
function EligibleLeaveOverrideDtlFromJSON(json) {
    return EligibleLeaveOverrideDtlFromJSONTyped(json);
}
function EligibleLeaveOverrideDtlFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'hrOverrideComments': json['hrOverrideComments'] == null ? undefined : json['hrOverrideComments'],
        'hrOverrideUser': json['hrOverrideUser'] == null ? undefined : json['hrOverrideUser'],
        'qualificationResult': json['qualificationResult'] == null ? undefined : json['qualificationResult'],
    };
}
function EligibleLeaveOverrideDtlToJSON(json) {
    return EligibleLeaveOverrideDtlToJSONTyped(json);
}
function EligibleLeaveOverrideDtlToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'hrOverrideComments': value['hrOverrideComments'],
        'hrOverrideUser': value['hrOverrideUser'],
        'qualificationResult': value['qualificationResult'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
var LeaveEligibilityDetailEvaluationResultEnum = {
    NotEvaluated: 'NOT_EVALUATED',
    MeetsQualification: 'MEETS_QUALIFICATION',
    DoesNotMeetQualification: 'DOES_NOT_MEET_QUALIFICATION',
    EvaluationError: 'EVALUATION_ERROR',
    InvalidReason: 'INVALID_REASON'
};
/**
 * Check if a given object implements the LeaveEligibilityDetail interface.
 */
function instanceOfLeaveEligibilityDetail(value) {
    return true;
}
function LeaveEligibilityDetailFromJSON(json) {
    return LeaveEligibilityDetailFromJSONTyped(json);
}
function LeaveEligibilityDetailFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'leaveEligibility': json['leaveEligibility'] == null ? undefined : json['leaveEligibility'],
        'absenceQualification': json['absenceQualification'] == null ? undefined : json['absenceQualification'],
        'evaluationResult': json['evaluationResult'] == null ? undefined : json['evaluationResult'],
        'reasonCode': json['reasonCode'] == null ? undefined : json['reasonCode'],
        'requiredLeaveEligibility': json['requiredLeaveEligibility'] == null ? undefined : json['requiredLeaveEligibility'],
        'customerQualification': json['customerQualification'] == null ? undefined : json['customerQualification'],
    };
}
function LeaveEligibilityDetailToJSON(json) {
    return LeaveEligibilityDetailToJSONTyped(json);
}
function LeaveEligibilityDetailToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'leaveEligibility': value['leaveEligibility'],
        'absenceQualification': value['absenceQualification'],
        'evaluationResult': value['evaluationResult'],
        'reasonCode': value['reasonCode'],
        'requiredLeaveEligibility': value['requiredLeaveEligibility'],
        'customerQualification': value['customerQualification'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the LeaveEligibility interface.
 */
function instanceOfLeaveEligibility(value) {
    return true;
}
function LeaveEligibilityFromJSON(json) {
    return LeaveEligibilityFromJSONTyped(json);
}
function LeaveEligibilityFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'absenceCase': json['absenceCase'] == null ? undefined : json['absenceCase'],
        'absenceLeaveType': json['absenceLeaveType'] == null ? undefined : json['absenceLeaveType'],
        'absenceCustomerLeavePolicy': json['absenceCustomerLeavePolicy'] == null ? undefined : json['absenceCustomerLeavePolicy'],
        'hrOverride': json['hrOverride'] == null ? undefined : json['hrOverride'],
        'leaveEligibility': json['leaveEligibility'] == null ? undefined : json['leaveEligibility'],
    };
}
function LeaveEligibilityToJSON(json) {
    return LeaveEligibilityToJSONTyped(json);
}
function LeaveEligibilityToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'absenceCase': value['absenceCase'],
        'absenceLeaveType': value['absenceLeaveType'],
        'absenceCustomerLeavePolicy': value['absenceCustomerLeavePolicy'],
        'hrOverride': value['hrOverride'],
        'leaveEligibility': value['leaveEligibility'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseLeaveEligibilityReducedAttributes interface.
 */
function instanceOfAbsenceCaseLeaveEligibilityReducedAttributes(value) {
    return true;
}
function AbsenceCaseLeaveEligibilityReducedAttributesFromJSON(json) {
    return AbsenceCaseLeaveEligibilityReducedAttributesFromJSONTyped(json);
}
function AbsenceCaseLeaveEligibilityReducedAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'leaveEligibility': json['leaveEligibility'] == null ? undefined : LeaveEligibilityFromJSON(json['leaveEligibility']),
        'leaveEligibilityDetail': json['leaveEligibilityDetail'] == null ? undefined : LeaveEligibilityDetailFromJSON(json['leaveEligibilityDetail']),
        'leaveEligibleOverrideDtl': json['leaveEligibleOverrideDtl'] == null ? undefined : EligibleLeaveOverrideDtlFromJSON(json['leaveEligibleOverrideDtl']),
    };
}
function AbsenceCaseLeaveEligibilityReducedAttributesToJSON(json) {
    return AbsenceCaseLeaveEligibilityReducedAttributesToJSONTyped(json);
}
function AbsenceCaseLeaveEligibilityReducedAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'leaveEligibility': LeaveEligibilityToJSON(value['leaveEligibility']),
        'leaveEligibilityDetail': LeaveEligibilityDetailToJSON(value['leaveEligibilityDetail']),
        'leaveEligibleOverrideDtl': EligibleLeaveOverrideDtlToJSON(value['leaveEligibleOverrideDtl']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseLeaveEligibilityReduced interface.
 */
function instanceOfAbsenceCaseLeaveEligibilityReduced(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function AbsenceCaseLeaveEligibilityReducedFromJSON(json) {
    return AbsenceCaseLeaveEligibilityReducedFromJSONTyped(json);
}
function AbsenceCaseLeaveEligibilityReducedFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': AbsenceCaseLeaveEligibilityReducedAttributesFromJSON(json['attributes']),
    };
}
function AbsenceCaseLeaveEligibilityReducedToJSON(json) {
    return AbsenceCaseLeaveEligibilityReducedToJSONTyped(json);
}
function AbsenceCaseLeaveEligibilityReducedToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': AbsenceCaseLeaveEligibilityReducedAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AbsenceCaseLeaveTypeReducedAttributes interface.
 */
function instanceOfAbsenceCaseLeaveTypeReducedAttributes(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('label' in value) || value['label'] === undefined)
        return false;
    return true;
}
function AbsenceCaseLeaveTypeReducedAttributesFromJSON(json) {
    return AbsenceCaseLeaveTypeReducedAttributesFromJSONTyped(json);
}
function AbsenceCaseLeaveTypeReducedAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'label': json['label'],
        'abbreviation': json['abbreviation'] == null ? undefined : json['abbreviation'],
    };
}
function AbsenceCaseLeaveTypeReducedAttributesToJSON(json) {
    return AbsenceCaseLeaveTypeReducedAttributesToJSONTyped(json);
}
function AbsenceCaseLeaveTypeReducedAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'label': value['label'],
        'abbreviation': value['abbreviation'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseLeaveTypeReduced interface.
 */
function instanceOfAbsenceCaseLeaveTypeReduced(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function AbsenceCaseLeaveTypeReducedFromJSON(json) {
    return AbsenceCaseLeaveTypeReducedFromJSONTyped(json);
}
function AbsenceCaseLeaveTypeReducedFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': AbsenceCaseLeaveTypeReducedAttributesFromJSON(json['attributes']),
    };
}
function AbsenceCaseLeaveTypeReducedToJSON(json) {
    return AbsenceCaseLeaveTypeReducedToJSONTyped(json);
}
function AbsenceCaseLeaveTypeReducedToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': AbsenceCaseLeaveTypeReducedAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the LeaveEligibleOverrideDtl interface.
 */
function instanceOfLeaveEligibleOverrideDtl(value) {
    return true;
}
function LeaveEligibleOverrideDtlFromJSON(json) {
    return LeaveEligibleOverrideDtlFromJSONTyped(json);
}
function LeaveEligibleOverrideDtlFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'allowedUsageStart': json['allowedUsageStart'] == null ? undefined : (luxon.DateTime.fromISO(json['allowedUsageStart'])),
        'allowedUsageEnd': json['allowedUsageEnd'] == null ? undefined : (luxon.DateTime.fromISO(json['allowedUsageEnd'])),
        'usageModifiedByHR': json['usageModifiedByHR'] == null ? undefined : json['usageModifiedByHR'],
    };
}
function LeaveEligibleOverrideDtlToJSON(json) {
    return LeaveEligibleOverrideDtlToJSONTyped(json);
}
function LeaveEligibleOverrideDtlToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'allowedUsageStart': value['allowedUsageStart'] == null ? value['allowedUsageStart'] : value['allowedUsageStart'].toISO(),
        'allowedUsageEnd': value['allowedUsageEnd'] == null ? value['allowedUsageEnd'] : value['allowedUsageEnd'].toISO(),
        'usageModifiedByHR': value['usageModifiedByHR'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var LeaveBalanceUnitEnum = {
    Hours: 'HOURS',
    Days: 'DAYS',
    Months: 'MONTHS',
    Weeks: 'WEEKS'
};
/**
 * Check if a given object implements the LeaveBalance interface.
 */
function instanceOfLeaveBalance(value) {
    return true;
}
function LeaveBalanceFromJSON(json) {
    return LeaveBalanceFromJSONTyped(json);
}
function LeaveBalanceFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'startingBalance': json['startingBalance'] == null ? undefined : json['startingBalance'],
        'endingBalance': json['endingBalance'] == null ? undefined : json['endingBalance'],
        'balanceAsOfGivenDate': json['balanceAsOfGivenDate'] == null ? undefined : json['balanceAsOfGivenDate'],
        'leaveType': json['leaveType'] == null ? undefined : json['leaveType'],
        'firstUsageDate': json['firstUsageDate'] == null ? undefined : (luxon.DateTime.fromISO(json['firstUsageDate'])),
        'unit': json['unit'] == null ? undefined : json['unit'],
    };
}
function LeaveBalanceToJSON(json) {
    return LeaveBalanceToJSONTyped(json);
}
function LeaveBalanceToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'startingBalance': value['startingBalance'],
        'endingBalance': value['endingBalance'],
        'balanceAsOfGivenDate': value['balanceAsOfGivenDate'],
        'leaveType': value['leaveType'],
        'firstUsageDate': value['firstUsageDate'] == null ? value['firstUsageDate'] : value['firstUsageDate'].toISO(),
        'unit': value['unit'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseProjectedUsagesReducedAttributes interface.
 */
function instanceOfAbsenceCaseProjectedUsagesReducedAttributes(value) {
    return true;
}
function AbsenceCaseProjectedUsagesReducedAttributesFromJSON(json) {
    return AbsenceCaseProjectedUsagesReducedAttributesFromJSONTyped(json);
}
function AbsenceCaseProjectedUsagesReducedAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'leaveBalance': json['leaveBalance'] == null ? undefined : LeaveBalanceFromJSON(json['leaveBalance']),
        'leaveEligibleOverrideDtl': json['leaveEligibleOverrideDtl'] == null ? undefined : LeaveEligibleOverrideDtlFromJSON(json['leaveEligibleOverrideDtl']),
    };
}
function AbsenceCaseProjectedUsagesReducedAttributesToJSON(json) {
    return AbsenceCaseProjectedUsagesReducedAttributesToJSONTyped(json);
}
function AbsenceCaseProjectedUsagesReducedAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'leaveBalance': LeaveBalanceToJSON(value['leaveBalance']),
        'leaveEligibleOverrideDtl': LeaveEligibleOverrideDtlToJSON(value['leaveEligibleOverrideDtl']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseProjectedUsagesReduced interface.
 */
function instanceOfAbsenceCaseProjectedUsagesReduced(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function AbsenceCaseProjectedUsagesReducedFromJSON(json) {
    return AbsenceCaseProjectedUsagesReducedFromJSONTyped(json);
}
function AbsenceCaseProjectedUsagesReducedFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': AbsenceCaseProjectedUsagesReducedAttributesFromJSON(json['attributes']),
    };
}
function AbsenceCaseProjectedUsagesReducedToJSON(json) {
    return AbsenceCaseProjectedUsagesReducedToJSONTyped(json);
}
function AbsenceCaseProjectedUsagesReducedToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': AbsenceCaseProjectedUsagesReducedAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the QuestionTreeNodesRelationshipDataInner interface.
 */
function instanceOfQuestionTreeNodesRelationshipDataInner(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function QuestionTreeNodesRelationshipDataInnerFromJSON(json) {
    return QuestionTreeNodesRelationshipDataInnerFromJSONTyped(json);
}
function QuestionTreeNodesRelationshipDataInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
    };
}
function QuestionTreeNodesRelationshipDataInnerToJSON(json) {
    return QuestionTreeNodesRelationshipDataInnerToJSONTyped(json);
}
function QuestionTreeNodesRelationshipDataInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the QuestionTreeNodesRelationship interface.
 */
function instanceOfQuestionTreeNodesRelationship(value) {
    return true;
}
function QuestionTreeNodesRelationshipFromJSON(json) {
    return QuestionTreeNodesRelationshipFromJSONTyped(json);
}
function QuestionTreeNodesRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : (json['data'].map(QuestionTreeNodesRelationshipDataInnerFromJSON)),
    };
}
function QuestionTreeNodesRelationshipToJSON(json) {
    return QuestionTreeNodesRelationshipToJSONTyped(json);
}
function QuestionTreeNodesRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': value['data'] == null ? undefined : (value['data'].map(QuestionTreeNodesRelationshipDataInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FormFieldRelationshipData interface.
 */
function instanceOfFormFieldRelationshipData(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function FormFieldRelationshipDataFromJSON(json) {
    return FormFieldRelationshipDataFromJSONTyped(json);
}
function FormFieldRelationshipDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
    };
}
function FormFieldRelationshipDataToJSON(json) {
    return FormFieldRelationshipDataToJSONTyped(json);
}
function FormFieldRelationshipDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the FormFieldRelationship interface.
 */
function instanceOfFormFieldRelationship(value) {
    return true;
}
function FormFieldRelationshipFromJSON(json) {
    return FormFieldRelationshipFromJSONTyped(json);
}
function FormFieldRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : FormFieldRelationshipDataFromJSON(json['data']),
    };
}
function FormFieldRelationshipToJSON(json) {
    return FormFieldRelationshipToJSONTyped(json);
}
function FormFieldRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': FormFieldRelationshipDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseQuestionRelationships interface.
 */
function instanceOfAbsenceCaseQuestionRelationships(value) {
    if (!('formField' in value) || value['formField'] === undefined)
        return false;
    if (!('questionTreeNodes' in value) || value['questionTreeNodes'] === undefined)
        return false;
    return true;
}
function AbsenceCaseQuestionRelationshipsFromJSON(json) {
    return AbsenceCaseQuestionRelationshipsFromJSONTyped(json);
}
function AbsenceCaseQuestionRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'formField': FormFieldRelationshipFromJSON(json['formField']),
        'questionTreeNodes': QuestionTreeNodesRelationshipFromJSON(json['questionTreeNodes']),
    };
}
function AbsenceCaseQuestionRelationshipsToJSON(json) {
    return AbsenceCaseQuestionRelationshipsToJSONTyped(json);
}
function AbsenceCaseQuestionRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'formField': FormFieldRelationshipToJSON(value['formField']),
        'questionTreeNodes': QuestionTreeNodesRelationshipToJSON(value['questionTreeNodes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AbsenceCaseQuestionAttributes interface.
 */
function instanceOfAbsenceCaseQuestionAttributes(value) {
    if (!('text' in value) || value['text'] === undefined)
        return false;
    if (!('helpHtml' in value) || value['helpHtml'] === undefined)
        return false;
    return true;
}
function AbsenceCaseQuestionAttributesFromJSON(json) {
    return AbsenceCaseQuestionAttributesFromJSONTyped(json);
}
function AbsenceCaseQuestionAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'text': json['text'],
        'helpHtml': json['helpHtml'],
    };
}
function AbsenceCaseQuestionAttributesToJSON(json) {
    return AbsenceCaseQuestionAttributesToJSONTyped(json);
}
function AbsenceCaseQuestionAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'text': value['text'],
        'helpHtml': value['helpHtml'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseQuestion interface.
 */
function instanceOfAbsenceCaseQuestion(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function AbsenceCaseQuestionFromJSON(json) {
    return AbsenceCaseQuestionFromJSONTyped(json);
}
function AbsenceCaseQuestionFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': AbsenceCaseQuestionAttributesFromJSON(json['attributes']),
        'relationships': json['relationships'] == null ? undefined : AbsenceCaseQuestionRelationshipsFromJSON(json['relationships']),
    };
}
function AbsenceCaseQuestionToJSON(json) {
    return AbsenceCaseQuestionToJSONTyped(json);
}
function AbsenceCaseQuestionToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': AbsenceCaseQuestionAttributesToJSON(value['attributes']),
        'relationships': AbsenceCaseQuestionRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseQuestionMeta interface.
 */
function instanceOfAbsenceCaseQuestionMeta(value) {
    return true;
}
function AbsenceCaseQuestionMetaFromJSON(json) {
    return AbsenceCaseQuestionMetaFromJSONTyped(json);
}
function AbsenceCaseQuestionMetaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'caseEndDate': json['caseEndDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['caseEndDate'])),
        'caseStartDate': json['caseStartDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['caseStartDate'])),
        'employeeMonthsOfService': json['employeeMonthsOfService'] == null ? undefined : json['employeeMonthsOfService'],
        'locationCode': json['locationCode'] == null ? undefined : json['locationCode'],
        'numberOfActiveEmployees': json['numberOfActiveEmployees'] == null ? undefined : json['numberOfActiveEmployees'],
        'numberOfActiveEmployeesInCompany': json['numberOfActiveEmployeesInCompany'] == null ? undefined : json['numberOfActiveEmployeesInCompany'],
        'numberOfActiveEmployeesInEmployeeGroup': json['numberOfActiveEmployeesInEmployeeGroup'] == null ? undefined : json['numberOfActiveEmployeesInEmployeeGroup'],
        'numberOfActiveEmployeesInLocation': json['numberOfActiveEmployeesInLocation'] == null ? undefined : json['numberOfActiveEmployeesInLocation'],
        'absenceReasonCode': json['absenceReasonCode'] == null ? undefined : json['absenceReasonCode'],
    };
}
function AbsenceCaseQuestionMetaToJSON(json) {
    return AbsenceCaseQuestionMetaToJSONTyped(json);
}
function AbsenceCaseQuestionMetaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'caseEndDate': value['caseEndDate'] == null ? value['caseEndDate'] : value['caseEndDate'].toISO(),
        'caseStartDate': value['caseStartDate'] == null ? value['caseStartDate'] : value['caseStartDate'].toISO(),
        'employeeMonthsOfService': value['employeeMonthsOfService'],
        'locationCode': value['locationCode'],
        'numberOfActiveEmployees': value['numberOfActiveEmployees'],
        'numberOfActiveEmployeesInCompany': value['numberOfActiveEmployeesInCompany'],
        'numberOfActiveEmployeesInEmployeeGroup': value['numberOfActiveEmployeesInEmployeeGroup'],
        'numberOfActiveEmployeesInLocation': value['numberOfActiveEmployeesInLocation'],
        'absenceReasonCode': value['absenceReasonCode'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AbsenceCaseReasonReducedAttributes interface.
 */
function instanceOfAbsenceCaseReasonReducedAttributes(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('label' in value) || value['label'] === undefined)
        return false;
    return true;
}
function AbsenceCaseReasonReducedAttributesFromJSON(json) {
    return AbsenceCaseReasonReducedAttributesFromJSONTyped(json);
}
function AbsenceCaseReasonReducedAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'label': json['label'],
    };
}
function AbsenceCaseReasonReducedAttributesToJSON(json) {
    return AbsenceCaseReasonReducedAttributesToJSONTyped(json);
}
function AbsenceCaseReasonReducedAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'label': value['label'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseReasonReduced interface.
 */
function instanceOfAbsenceCaseReasonReduced(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function AbsenceCaseReasonReducedFromJSON(json) {
    return AbsenceCaseReasonReducedFromJSONTyped(json);
}
function AbsenceCaseReasonReducedFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': AbsenceCaseReasonReducedAttributesFromJSON(json['attributes']),
    };
}
function AbsenceCaseReasonReducedToJSON(json) {
    return AbsenceCaseReasonReducedToJSONTyped(json);
}
function AbsenceCaseReasonReducedToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': AbsenceCaseReasonReducedAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseReduced interface.
 */
function instanceOfAbsenceCaseReduced(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function AbsenceCaseReducedFromJSON(json) {
    return AbsenceCaseReducedFromJSONTyped(json);
}
function AbsenceCaseReducedFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': AbsenceCaseAttributesFromJSON(json['attributes']),
    };
}
function AbsenceCaseReducedToJSON(json) {
    return AbsenceCaseReducedToJSONTyped(json);
}
function AbsenceCaseReducedToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': AbsenceCaseAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UpdateCaseManagerOperationRef interface.
 */
function instanceOfUpdateCaseManagerOperationRef(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('relationship' in value) || value['relationship'] === undefined)
        return false;
    return true;
}
function UpdateCaseManagerOperationRefFromJSON(json) {
    return UpdateCaseManagerOperationRefFromJSONTyped(json);
}
function UpdateCaseManagerOperationRefFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'id': json['id'],
        'relationship': json['relationship'],
    };
}
function UpdateCaseManagerOperationRefToJSON(json) {
    return UpdateCaseManagerOperationRefToJSONTyped(json);
}
function UpdateCaseManagerOperationRefToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'id': value['id'],
        'relationship': value['relationship'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
var UpdateLeaveEligibilityOperationDataAttributesQualificationResultEnum = {
    NotQualified: 'NOT_QUALIFIED',
    Qualified: 'QUALIFIED',
    Error: 'ERROR',
    WrongReason: 'WRONG_REASON'
};
/**
 * Check if a given object implements the UpdateLeaveEligibilityOperationDataAttributes interface.
 */
function instanceOfUpdateLeaveEligibilityOperationDataAttributes(value) {
    return true;
}
function UpdateLeaveEligibilityOperationDataAttributesFromJSON(json) {
    return UpdateLeaveEligibilityOperationDataAttributesFromJSONTyped(json);
}
function UpdateLeaveEligibilityOperationDataAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'hrOverride': json['hrOverride'] == null ? undefined : json['hrOverride'],
        'hrOverrideComments': json['hrOverrideComments'] == null ? undefined : json['hrOverrideComments'],
        'qualificationResult': json['qualificationResult'] == null ? undefined : json['qualificationResult'],
    };
}
function UpdateLeaveEligibilityOperationDataAttributesToJSON(json) {
    return UpdateLeaveEligibilityOperationDataAttributesToJSONTyped(json);
}
function UpdateLeaveEligibilityOperationDataAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'hrOverride': value['hrOverride'],
        'hrOverrideComments': value['hrOverrideComments'],
        'qualificationResult': value['qualificationResult'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the UpdateLeaveEligibilityOperationData interface.
 */
function instanceOfUpdateLeaveEligibilityOperationData(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function UpdateLeaveEligibilityOperationDataFromJSON(json) {
    return UpdateLeaveEligibilityOperationDataFromJSONTyped(json);
}
function UpdateLeaveEligibilityOperationDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'id': json['id'],
        'attributes': UpdateLeaveEligibilityOperationDataAttributesFromJSON(json['attributes']),
    };
}
function UpdateLeaveEligibilityOperationDataToJSON(json) {
    return UpdateLeaveEligibilityOperationDataToJSONTyped(json);
}
function UpdateLeaveEligibilityOperationDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'id': value['id'],
        'attributes': UpdateLeaveEligibilityOperationDataAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var AbsenceCaseUpdateRequestAtomicOperationsInnerOpEnum = {
    Update: 'update'
};
/**
 * Check if a given object implements the AbsenceCaseUpdateRequestAtomicOperationsInner interface.
 */
function instanceOfAbsenceCaseUpdateRequestAtomicOperationsInner(value) {
    if (!('op' in value) || value['op'] === undefined)
        return false;
    if (!('data' in value) || value['data'] === undefined)
        return false;
    if (!('ref' in value) || value['ref'] === undefined)
        return false;
    return true;
}
function AbsenceCaseUpdateRequestAtomicOperationsInnerFromJSON(json) {
    return AbsenceCaseUpdateRequestAtomicOperationsInnerFromJSONTyped(json);
}
function AbsenceCaseUpdateRequestAtomicOperationsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'op': json['op'],
        'data': UpdateLeaveEligibilityOperationDataFromJSON(json['data']),
        'ref': UpdateCaseManagerOperationRefFromJSON(json['ref']),
    };
}
function AbsenceCaseUpdateRequestAtomicOperationsInnerToJSON(json) {
    return AbsenceCaseUpdateRequestAtomicOperationsInnerToJSONTyped(json);
}
function AbsenceCaseUpdateRequestAtomicOperationsInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'op': value['op'],
        'data': UpdateLeaveEligibilityOperationDataToJSON(value['data']),
        'ref': UpdateCaseManagerOperationRefToJSON(value['ref']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseUpdateRequest interface.
 */
function instanceOfAbsenceCaseUpdateRequest(value) {
    if (!('atomicOperations' in value) || value['atomicOperations'] === undefined)
        return false;
    return true;
}
function AbsenceCaseUpdateRequestFromJSON(json) {
    return AbsenceCaseUpdateRequestFromJSONTyped(json);
}
function AbsenceCaseUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'atomicOperations': (json['atomic:operations'].map(AbsenceCaseUpdateRequestAtomicOperationsInnerFromJSON)),
    };
}
function AbsenceCaseUpdateRequestToJSON(json) {
    return AbsenceCaseUpdateRequestToJSONTyped(json);
}
function AbsenceCaseUpdateRequestToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'atomic:operations': (value['atomicOperations'].map(AbsenceCaseUpdateRequestAtomicOperationsInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseUpdateResultRelationships interface.
 */
function instanceOfAbsenceCaseUpdateResultRelationships(value) {
    return true;
}
function AbsenceCaseUpdateResultRelationshipsFromJSON(json) {
    return AbsenceCaseUpdateResultRelationshipsFromJSONTyped(json);
}
function AbsenceCaseUpdateResultRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'employee': json['employee'] == null ? undefined : EmployeeRelationshipFromJSON(json['employee']),
        'caseManagers': json['caseManagers'] == null ? undefined : UserRelationshipsFromJSON(json['caseManagers']),
        'projectedUsages': json['projectedUsages'] == null ? undefined : AbsenceCaseProjectedUsagesRelationshipFromJSON(json['projectedUsages']),
        'leaveEligibility': json['leaveEligibility'] == null ? undefined : AbsenceCaseLeaveEligibilityRelationshipFromJSON(json['leaveEligibility']),
    };
}
function AbsenceCaseUpdateResultRelationshipsToJSON(json) {
    return AbsenceCaseUpdateResultRelationshipsToJSONTyped(json);
}
function AbsenceCaseUpdateResultRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'employee': EmployeeRelationshipToJSON(value['employee']),
        'caseManagers': UserRelationshipsToJSON(value['caseManagers']),
        'projectedUsages': AbsenceCaseProjectedUsagesRelationshipToJSON(value['projectedUsages']),
        'leaveEligibility': AbsenceCaseLeaveEligibilityRelationshipToJSON(value['leaveEligibility']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseUpdateResponseAtomicResultsInnerData interface.
 */
function instanceOfAbsenceCaseUpdateResponseAtomicResultsInnerData(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function AbsenceCaseUpdateResponseAtomicResultsInnerDataFromJSON(json) {
    return AbsenceCaseUpdateResponseAtomicResultsInnerDataFromJSONTyped(json);
}
function AbsenceCaseUpdateResponseAtomicResultsInnerDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': AbsenceCaseLeaveEligibilityReducedAttributesFromJSON(json['attributes']),
        'relationships': json['relationships'] == null ? undefined : AbsenceCaseUpdateResultRelationshipsFromJSON(json['relationships']),
    };
}
function AbsenceCaseUpdateResponseAtomicResultsInnerDataToJSON(json) {
    return AbsenceCaseUpdateResponseAtomicResultsInnerDataToJSONTyped(json);
}
function AbsenceCaseUpdateResponseAtomicResultsInnerDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': AbsenceCaseLeaveEligibilityReducedAttributesToJSON(value['attributes']),
        'relationships': AbsenceCaseUpdateResultRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseUpdateResponseAtomicResultsInner interface.
 */
function instanceOfAbsenceCaseUpdateResponseAtomicResultsInner(value) {
    return true;
}
function AbsenceCaseUpdateResponseAtomicResultsInnerFromJSON(json) {
    return AbsenceCaseUpdateResponseAtomicResultsInnerFromJSONTyped(json);
}
function AbsenceCaseUpdateResponseAtomicResultsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : AbsenceCaseUpdateResponseAtomicResultsInnerDataFromJSON(json['data']),
    };
}
function AbsenceCaseUpdateResponseAtomicResultsInnerToJSON(json) {
    return AbsenceCaseUpdateResponseAtomicResultsInnerToJSONTyped(json);
}
function AbsenceCaseUpdateResponseAtomicResultsInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': AbsenceCaseUpdateResponseAtomicResultsInnerDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseUpdateResponse interface.
 */
function instanceOfAbsenceCaseUpdateResponse(value) {
    if (!('atomicResults' in value) || value['atomicResults'] === undefined)
        return false;
    return true;
}
function AbsenceCaseUpdateResponseFromJSON(json) {
    return AbsenceCaseUpdateResponseFromJSONTyped(json);
}
function AbsenceCaseUpdateResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'atomicResults': (json['atomic:results'].map(AbsenceCaseUpdateResponseAtomicResultsInnerFromJSON)),
    };
}
function AbsenceCaseUpdateResponseToJSON(json) {
    return AbsenceCaseUpdateResponseToJSONTyped(json);
}
function AbsenceCaseUpdateResponseToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'atomic:results': (value['atomicResults'].map(AbsenceCaseUpdateResponseAtomicResultsInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var AbsenceCaseUpdateResultAttributesUsePaidTimeEnum = {
    Required: 'REQUIRED',
    EmployeeElected: 'EMPLOYEE_ELECTED',
    No: 'NO'
};
/**
 * @export
 */
var AbsenceCaseUpdateResultAttributesContactMethodEnum = {
    Email: 'EMAIL',
    InterofficeMail: 'INTEROFFICE_MAIL',
    PostalMail: 'POSTAL_MAIL'
};
/**
 * Check if a given object implements the AbsenceCaseUpdateResultAttributes interface.
 */
function instanceOfAbsenceCaseUpdateResultAttributes(value) {
    return true;
}
function AbsenceCaseUpdateResultAttributesFromJSON(json) {
    return AbsenceCaseUpdateResultAttributesFromJSONTyped(json);
}
function AbsenceCaseUpdateResultAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'displayId': json['displayId'] == null ? undefined : json['displayId'],
        'caseType': json['caseType'] == null ? undefined : CaseTypeFromJSON(json['caseType']),
        'status': json['status'] == null ? undefined : StatusFromJSON(json['status']),
        'startDate': json['startDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['endDate'])),
        'usePaidTime': json['usePaidTime'] == null ? undefined : json['usePaidTime'],
        'contactMethod': json['contactMethod'] == null ? undefined : json['contactMethod'],
        'contactAddress': json['contactAddress'] == null ? undefined : json['contactAddress'],
        'personAffected': json['personAffected'] == null ? undefined : json['personAffected'],
        'caseNotes': json['caseNotes'] == null ? undefined : json['caseNotes'],
    };
}
function AbsenceCaseUpdateResultAttributesToJSON(json) {
    return AbsenceCaseUpdateResultAttributesToJSONTyped(json);
}
function AbsenceCaseUpdateResultAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'displayId': value['displayId'],
        'caseType': CaseTypeToJSON(value['caseType']),
        'status': StatusToJSON(value['status']),
        'startDate': value['startDate'] == null ? value['startDate'] : value['startDate'].toISO(),
        'endDate': value['endDate'] == null ? value['endDate'] : value['endDate'].toISO(),
        'usePaidTime': value['usePaidTime'],
        'contactMethod': value['contactMethod'],
        'contactAddress': value['contactAddress'],
        'personAffected': value['personAffected'],
        'caseNotes': value['caseNotes'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseUpdateResult interface.
 */
function instanceOfAbsenceCaseUpdateResult(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function AbsenceCaseUpdateResultFromJSON(json) {
    return AbsenceCaseUpdateResultFromJSONTyped(json);
}
function AbsenceCaseUpdateResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': AbsenceCaseUpdateResultAttributesFromJSON(json['attributes']),
        'relationships': json['relationships'] == null ? undefined : AbsenceCaseUpdateResultRelationshipsFromJSON(json['relationships']),
    };
}
function AbsenceCaseUpdateResultToJSON(json) {
    return AbsenceCaseUpdateResultToJSONTyped(json);
}
function AbsenceCaseUpdateResultToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': AbsenceCaseUpdateResultAttributesToJSON(value['attributes']),
        'relationships': AbsenceCaseUpdateResultRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AbsenceCaseUploadDocumentsRequestDataAttributes interface.
 */
function instanceOfAbsenceCaseUploadDocumentsRequestDataAttributes(value) {
    if (!('fileName' in value) || value['fileName'] === undefined)
        return false;
    if (!('fileContent' in value) || value['fileContent'] === undefined)
        return false;
    if (!('contentType' in value) || value['contentType'] === undefined)
        return false;
    if (!('fileDescription' in value) || value['fileDescription'] === undefined)
        return false;
    if (!('isDocumentComplete' in value) || value['isDocumentComplete'] === undefined)
        return false;
    if (!('isVisibleToEmployee' in value) || value['isVisibleToEmployee'] === undefined)
        return false;
    return true;
}
function AbsenceCaseUploadDocumentsRequestDataAttributesFromJSON(json) {
    return AbsenceCaseUploadDocumentsRequestDataAttributesFromJSONTyped(json);
}
function AbsenceCaseUploadDocumentsRequestDataAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fileName': json['fileName'],
        'fileContent': json['fileContent'],
        'contentType': json['contentType'],
        'fileDescription': json['fileDescription'],
        'comments': json['comments'] == null ? undefined : json['comments'],
        'isDocumentComplete': json['isDocumentComplete'],
        'isVisibleToEmployee': json['isVisibleToEmployee'],
    };
}
function AbsenceCaseUploadDocumentsRequestDataAttributesToJSON(json) {
    return AbsenceCaseUploadDocumentsRequestDataAttributesToJSONTyped(json);
}
function AbsenceCaseUploadDocumentsRequestDataAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'fileName': value['fileName'],
        'fileContent': value['fileContent'],
        'contentType': value['contentType'],
        'fileDescription': value['fileDescription'],
        'comments': value['comments'],
        'isDocumentComplete': value['isDocumentComplete'],
        'isVisibleToEmployee': value['isVisibleToEmployee'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseUploadDocumentsRequestData interface.
 */
function instanceOfAbsenceCaseUploadDocumentsRequestData(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function AbsenceCaseUploadDocumentsRequestDataFromJSON(json) {
    return AbsenceCaseUploadDocumentsRequestDataFromJSONTyped(json);
}
function AbsenceCaseUploadDocumentsRequestDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'attributes': AbsenceCaseUploadDocumentsRequestDataAttributesFromJSON(json['attributes']),
        'relationships': json['relationships'] == null ? undefined : AbsenceCaseContactEmployeeRequestDataRelationshipsFromJSON(json['relationships']),
    };
}
function AbsenceCaseUploadDocumentsRequestDataToJSON(json) {
    return AbsenceCaseUploadDocumentsRequestDataToJSONTyped(json);
}
function AbsenceCaseUploadDocumentsRequestDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'attributes': AbsenceCaseUploadDocumentsRequestDataAttributesToJSON(value['attributes']),
        'relationships': AbsenceCaseContactEmployeeRequestDataRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseUploadDocumentsRequest interface.
 */
function instanceOfAbsenceCaseUploadDocumentsRequest(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function AbsenceCaseUploadDocumentsRequestFromJSON(json) {
    return AbsenceCaseUploadDocumentsRequestFromJSONTyped(json);
}
function AbsenceCaseUploadDocumentsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': AbsenceCaseUploadDocumentsRequestDataFromJSON(json['data']),
    };
}
function AbsenceCaseUploadDocumentsRequestToJSON(json) {
    return AbsenceCaseUploadDocumentsRequestToJSONTyped(json);
}
function AbsenceCaseUploadDocumentsRequestToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': AbsenceCaseUploadDocumentsRequestDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseUploadDocumentsResponseAttributes interface.
 */
function instanceOfAbsenceCaseUploadDocumentsResponseAttributes(value) {
    if (!('submittedAt' in value) || value['submittedAt'] === undefined)
        return false;
    if (!('fileName' in value) || value['fileName'] === undefined)
        return false;
    if (!('fileDescription' in value) || value['fileDescription'] === undefined)
        return false;
    if (!('isDocumentComplete' in value) || value['isDocumentComplete'] === undefined)
        return false;
    if (!('isVisibleToEmployee' in value) || value['isVisibleToEmployee'] === undefined)
        return false;
    return true;
}
function AbsenceCaseUploadDocumentsResponseAttributesFromJSON(json) {
    return AbsenceCaseUploadDocumentsResponseAttributesFromJSONTyped(json);
}
function AbsenceCaseUploadDocumentsResponseAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'submittedAt': (luxon.DateTime.fromISO(json['submittedAt'])),
        'fileName': json['fileName'],
        'fileDescription': json['fileDescription'],
        'comments': json['comments'] == null ? undefined : json['comments'],
        'isDocumentComplete': json['isDocumentComplete'],
        'isVisibleToEmployee': json['isVisibleToEmployee'],
    };
}
function AbsenceCaseUploadDocumentsResponseAttributesToJSON(json) {
    return AbsenceCaseUploadDocumentsResponseAttributesToJSONTyped(json);
}
function AbsenceCaseUploadDocumentsResponseAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'submittedAt': value['submittedAt'].toISO(),
        'fileName': value['fileName'],
        'fileDescription': value['fileDescription'],
        'comments': value['comments'],
        'isDocumentComplete': value['isDocumentComplete'],
        'isVisibleToEmployee': value['isVisibleToEmployee'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseUploadDocumentsResponseRelationships interface.
 */
function instanceOfAbsenceCaseUploadDocumentsResponseRelationships(value) {
    if (!('absenceCase' in value) || value['absenceCase'] === undefined)
        return false;
    if (!('submittedBy' in value) || value['submittedBy'] === undefined)
        return false;
    return true;
}
function AbsenceCaseUploadDocumentsResponseRelationshipsFromJSON(json) {
    return AbsenceCaseUploadDocumentsResponseRelationshipsFromJSONTyped(json);
}
function AbsenceCaseUploadDocumentsResponseRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'absenceCase': AbsenceCaseRelationshipFromJSON(json['absenceCase']),
        'submittedBy': UserRelationshipsFromJSON(json['submittedBy']),
    };
}
function AbsenceCaseUploadDocumentsResponseRelationshipsToJSON(json) {
    return AbsenceCaseUploadDocumentsResponseRelationshipsToJSONTyped(json);
}
function AbsenceCaseUploadDocumentsResponseRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'absenceCase': AbsenceCaseRelationshipToJSON(value['absenceCase']),
        'submittedBy': UserRelationshipsToJSON(value['submittedBy']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseUploadDocumentsResponse interface.
 */
function instanceOfAbsenceCaseUploadDocumentsResponse(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function AbsenceCaseUploadDocumentsResponseFromJSON(json) {
    return AbsenceCaseUploadDocumentsResponseFromJSONTyped(json);
}
function AbsenceCaseUploadDocumentsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'attributes': AbsenceCaseUploadDocumentsResponseAttributesFromJSON(json['attributes']),
        'relationships': json['relationships'] == null ? undefined : AbsenceCaseUploadDocumentsResponseRelationshipsFromJSON(json['relationships']),
    };
}
function AbsenceCaseUploadDocumentsResponseToJSON(json) {
    return AbsenceCaseUploadDocumentsResponseToJSONTyped(json);
}
function AbsenceCaseUploadDocumentsResponseToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'attributes': AbsenceCaseUploadDocumentsResponseAttributesToJSON(value['attributes']),
        'relationships': AbsenceCaseUploadDocumentsResponseRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AbsenceCaseWorkflowEventTypeRelationshipData interface.
 */
function instanceOfAbsenceCaseWorkflowEventTypeRelationshipData(value) {
    return true;
}
function AbsenceCaseWorkflowEventTypeRelationshipDataFromJSON(json) {
    return AbsenceCaseWorkflowEventTypeRelationshipDataFromJSONTyped(json);
}
function AbsenceCaseWorkflowEventTypeRelationshipDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}
function AbsenceCaseWorkflowEventTypeRelationshipDataToJSON(json) {
    return AbsenceCaseWorkflowEventTypeRelationshipDataToJSONTyped(json);
}
function AbsenceCaseWorkflowEventTypeRelationshipDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseWorkflowEventTypeRelationship interface.
 */
function instanceOfAbsenceCaseWorkflowEventTypeRelationship(value) {
    return true;
}
function AbsenceCaseWorkflowEventTypeRelationshipFromJSON(json) {
    return AbsenceCaseWorkflowEventTypeRelationshipFromJSONTyped(json);
}
function AbsenceCaseWorkflowEventTypeRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : AbsenceCaseWorkflowEventTypeRelationshipDataFromJSON(json['data']),
    };
}
function AbsenceCaseWorkflowEventTypeRelationshipToJSON(json) {
    return AbsenceCaseWorkflowEventTypeRelationshipToJSONTyped(json);
}
function AbsenceCaseWorkflowEventTypeRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': AbsenceCaseWorkflowEventTypeRelationshipDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AbsenceCaseWorkflowEventEmployeeRelationshipData interface.
 */
function instanceOfAbsenceCaseWorkflowEventEmployeeRelationshipData(value) {
    return true;
}
function AbsenceCaseWorkflowEventEmployeeRelationshipDataFromJSON(json) {
    return AbsenceCaseWorkflowEventEmployeeRelationshipDataFromJSONTyped(json);
}
function AbsenceCaseWorkflowEventEmployeeRelationshipDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}
function AbsenceCaseWorkflowEventEmployeeRelationshipDataToJSON(json) {
    return AbsenceCaseWorkflowEventEmployeeRelationshipDataToJSONTyped(json);
}
function AbsenceCaseWorkflowEventEmployeeRelationshipDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseWorkflowEventEmployeeRelationship interface.
 */
function instanceOfAbsenceCaseWorkflowEventEmployeeRelationship(value) {
    return true;
}
function AbsenceCaseWorkflowEventEmployeeRelationshipFromJSON(json) {
    return AbsenceCaseWorkflowEventEmployeeRelationshipFromJSONTyped(json);
}
function AbsenceCaseWorkflowEventEmployeeRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : AbsenceCaseWorkflowEventEmployeeRelationshipDataFromJSON(json['data']),
    };
}
function AbsenceCaseWorkflowEventEmployeeRelationshipToJSON(json) {
    return AbsenceCaseWorkflowEventEmployeeRelationshipToJSONTyped(json);
}
function AbsenceCaseWorkflowEventEmployeeRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': AbsenceCaseWorkflowEventEmployeeRelationshipDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseWorkflowEventRelationships interface.
 */
function instanceOfAbsenceCaseWorkflowEventRelationships(value) {
    if (!('absenceCase' in value) || value['absenceCase'] === undefined)
        return false;
    if (!('employee' in value) || value['employee'] === undefined)
        return false;
    if (!('leaveType' in value) || value['leaveType'] === undefined)
        return false;
    if (!('absenceCaseWorkflowEventType' in value) || value['absenceCaseWorkflowEventType'] === undefined)
        return false;
    return true;
}
function AbsenceCaseWorkflowEventRelationshipsFromJSON(json) {
    return AbsenceCaseWorkflowEventRelationshipsFromJSONTyped(json);
}
function AbsenceCaseWorkflowEventRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'absenceCase': AbsenceCaseRelationshipFromJSON(json['absenceCase']),
        'employee': AbsenceCaseWorkflowEventEmployeeRelationshipFromJSON(json['employee']),
        'leaveType': AbsenceCaseLeaveTypeRelationshipFromJSON(json['leaveType']),
        'absenceCaseWorkflowEventType': AbsenceCaseWorkflowEventTypeRelationshipFromJSON(json['absenceCaseWorkflowEventType']),
    };
}
function AbsenceCaseWorkflowEventRelationshipsToJSON(json) {
    return AbsenceCaseWorkflowEventRelationshipsToJSONTyped(json);
}
function AbsenceCaseWorkflowEventRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'absenceCase': AbsenceCaseRelationshipToJSON(value['absenceCase']),
        'employee': AbsenceCaseWorkflowEventEmployeeRelationshipToJSON(value['employee']),
        'leaveType': AbsenceCaseLeaveTypeRelationshipToJSON(value['leaveType']),
        'absenceCaseWorkflowEventType': AbsenceCaseWorkflowEventTypeRelationshipToJSON(value['absenceCaseWorkflowEventType']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseWorkflowEventAttributes interface.
 */
function instanceOfAbsenceCaseWorkflowEventAttributes(value) {
    if (!('dueDate' in value) || value['dueDate'] === undefined)
        return false;
    return true;
}
function AbsenceCaseWorkflowEventAttributesFromJSON(json) {
    return AbsenceCaseWorkflowEventAttributesFromJSONTyped(json);
}
function AbsenceCaseWorkflowEventAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'dueDate': (dateAndTime.DateWithoutTime.fromISO(json['dueDate'])),
        'completionDate': json['completionDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['completionDate'])),
        'eventDescription': json['eventDescription'] == null ? undefined : json['eventDescription'],
        'eventComments': json['eventComments'] == null ? undefined : json['eventComments'],
        'waitingDescription': json['waitingDescription'] == null ? undefined : json['waitingDescription'],
    };
}
function AbsenceCaseWorkflowEventAttributesToJSON(json) {
    return AbsenceCaseWorkflowEventAttributesToJSONTyped(json);
}
function AbsenceCaseWorkflowEventAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'dueDate': value['dueDate'].toISO(),
        'completionDate': value['completionDate'] == null ? value['completionDate'] : value['completionDate'].toISO(),
        'eventDescription': value['eventDescription'],
        'eventComments': value['eventComments'],
        'waitingDescription': value['waitingDescription'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseWorkflowEvent interface.
 */
function instanceOfAbsenceCaseWorkflowEvent(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function AbsenceCaseWorkflowEventFromJSON(json) {
    return AbsenceCaseWorkflowEventFromJSONTyped(json);
}
function AbsenceCaseWorkflowEventFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': AbsenceCaseWorkflowEventAttributesFromJSON(json['attributes']),
        'relationships': json['relationships'] == null ? undefined : AbsenceCaseWorkflowEventRelationshipsFromJSON(json['relationships']),
    };
}
function AbsenceCaseWorkflowEventToJSON(json) {
    return AbsenceCaseWorkflowEventToJSONTyped(json);
}
function AbsenceCaseWorkflowEventToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': AbsenceCaseWorkflowEventAttributesToJSON(value['attributes']),
        'relationships': AbsenceCaseWorkflowEventRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AbsenceCaseWorkflowEventTypeReducedAttributes interface.
 */
function instanceOfAbsenceCaseWorkflowEventTypeReducedAttributes(value) {
    if (!('label' in value) || value['label'] === undefined)
        return false;
    if (!('displayOrder' in value) || value['displayOrder'] === undefined)
        return false;
    if (!('showToAdminOnly' in value) || value['showToAdminOnly'] === undefined)
        return false;
    if (!('visibleToEmployee' in value) || value['visibleToEmployee'] === undefined)
        return false;
    return true;
}
function AbsenceCaseWorkflowEventTypeReducedAttributesFromJSON(json) {
    return AbsenceCaseWorkflowEventTypeReducedAttributesFromJSONTyped(json);
}
function AbsenceCaseWorkflowEventTypeReducedAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'label': json['label'],
        'displayOrder': json['displayOrder'],
        'showToAdminOnly': json['showToAdminOnly'],
        'completedLabel': json['completedLabel'] == null ? undefined : json['completedLabel'],
        'visibleToEmployee': json['visibleToEmployee'],
        'eventComments': json['eventComments'] == null ? undefined : json['eventComments'],
    };
}
function AbsenceCaseWorkflowEventTypeReducedAttributesToJSON(json) {
    return AbsenceCaseWorkflowEventTypeReducedAttributesToJSONTyped(json);
}
function AbsenceCaseWorkflowEventTypeReducedAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'label': value['label'],
        'displayOrder': value['displayOrder'],
        'showToAdminOnly': value['showToAdminOnly'],
        'completedLabel': value['completedLabel'],
        'visibleToEmployee': value['visibleToEmployee'],
        'eventComments': value['eventComments'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCaseWorkflowEventTypeReduced interface.
 */
function instanceOfAbsenceCaseWorkflowEventTypeReduced(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function AbsenceCaseWorkflowEventTypeReducedFromJSON(json) {
    return AbsenceCaseWorkflowEventTypeReducedFromJSONTyped(json);
}
function AbsenceCaseWorkflowEventTypeReducedFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': AbsenceCaseWorkflowEventTypeReducedAttributesFromJSON(json['attributes']),
    };
}
function AbsenceCaseWorkflowEventTypeReducedToJSON(json) {
    return AbsenceCaseWorkflowEventTypeReducedToJSONTyped(json);
}
function AbsenceCaseWorkflowEventTypeReducedToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': AbsenceCaseWorkflowEventTypeReducedAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCreateCaseRequestDataRelationships interface.
 */
function instanceOfAbsenceCreateCaseRequestDataRelationships(value) {
    if (!('employee' in value) || value['employee'] === undefined)
        return false;
    return true;
}
function AbsenceCreateCaseRequestDataRelationshipsFromJSON(json) {
    return AbsenceCreateCaseRequestDataRelationshipsFromJSONTyped(json);
}
function AbsenceCreateCaseRequestDataRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'employee': EmployeeRelationshipFromJSON(json['employee']),
    };
}
function AbsenceCreateCaseRequestDataRelationshipsToJSON(json) {
    return AbsenceCreateCaseRequestDataRelationshipsToJSONTyped(json);
}
function AbsenceCreateCaseRequestDataRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'employee': EmployeeRelationshipToJSON(value['employee']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AbsenceCreateCaseRequestDataAttributesQuestionResponsesInner interface.
 */
function instanceOfAbsenceCreateCaseRequestDataAttributesQuestionResponsesInner(value) {
    return true;
}
function AbsenceCreateCaseRequestDataAttributesQuestionResponsesInnerFromJSON(json) {
    return AbsenceCreateCaseRequestDataAttributesQuestionResponsesInnerFromJSONTyped(json);
}
function AbsenceCreateCaseRequestDataAttributesQuestionResponsesInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'questionId': json['questionId'] == null ? undefined : json['questionId'],
        'questionResponse': json['questionResponse'] == null ? undefined : json['questionResponse'],
    };
}
function AbsenceCreateCaseRequestDataAttributesQuestionResponsesInnerToJSON(json) {
    return AbsenceCreateCaseRequestDataAttributesQuestionResponsesInnerToJSONTyped(json);
}
function AbsenceCreateCaseRequestDataAttributesQuestionResponsesInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'questionId': value['questionId'],
        'questionResponse': value['questionResponse'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * The type of the absence case being created.
 * ABSENCE - ABSENCE_CASE_REQUEST_TYPE.ABSENCE.
 * ACCOMMODATION - ABSENCE_CASE_REQUEST_TYPE.ACCOMMODATION.
 * @export
 */
var RequestType = {
    Absence: 'ABSENCE',
    Accommodation: 'ACCOMMODATION'
};
function instanceOfRequestType(value) {
    for (var key in RequestType) {
        if (Object.prototype.hasOwnProperty.call(RequestType, key)) {
            if (RequestType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function RequestTypeFromJSON(json) {
    return RequestTypeFromJSONTyped(json);
}
function RequestTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function RequestTypeToJSON(value) {
    return value;
}
function RequestTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCreateCaseRequestDataAttributes interface.
 */
function instanceOfAbsenceCreateCaseRequestDataAttributes(value) {
    if (!('startDate' in value) || value['startDate'] === undefined)
        return false;
    if (!('endDate' in value) || value['endDate'] === undefined)
        return false;
    if (!('requestType' in value) || value['requestType'] === undefined)
        return false;
    if (!('questionResponses' in value) || value['questionResponses'] === undefined)
        return false;
    return true;
}
function AbsenceCreateCaseRequestDataAttributesFromJSON(json) {
    return AbsenceCreateCaseRequestDataAttributesFromJSONTyped(json);
}
function AbsenceCreateCaseRequestDataAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'startDate': (dateAndTime.DateWithoutTime.fromISO(json['startDate'])),
        'endDate': (dateAndTime.DateWithoutTime.fromISO(json['endDate'])),
        'requestType': RequestTypeFromJSON(json['requestType']),
        'absenceReasonCode': json['absenceReasonCode'] == null ? undefined : json['absenceReasonCode'],
        'questionResponses': (json['questionResponses'].map(AbsenceCreateCaseRequestDataAttributesQuestionResponsesInnerFromJSON)),
    };
}
function AbsenceCreateCaseRequestDataAttributesToJSON(json) {
    return AbsenceCreateCaseRequestDataAttributesToJSONTyped(json);
}
function AbsenceCreateCaseRequestDataAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'startDate': value['startDate'].toISO(),
        'endDate': value['endDate'].toISO(),
        'requestType': RequestTypeToJSON(value['requestType']),
        'absenceReasonCode': value['absenceReasonCode'],
        'questionResponses': (value['questionResponses'].map(AbsenceCreateCaseRequestDataAttributesQuestionResponsesInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCreateCaseRequestData interface.
 */
function instanceOfAbsenceCreateCaseRequestData(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function AbsenceCreateCaseRequestDataFromJSON(json) {
    return AbsenceCreateCaseRequestDataFromJSONTyped(json);
}
function AbsenceCreateCaseRequestDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'attributes': AbsenceCreateCaseRequestDataAttributesFromJSON(json['attributes']),
        'relationships': json['relationships'] == null ? undefined : AbsenceCreateCaseRequestDataRelationshipsFromJSON(json['relationships']),
    };
}
function AbsenceCreateCaseRequestDataToJSON(json) {
    return AbsenceCreateCaseRequestDataToJSONTyped(json);
}
function AbsenceCreateCaseRequestDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'attributes': AbsenceCreateCaseRequestDataAttributesToJSON(value['attributes']),
        'relationships': AbsenceCreateCaseRequestDataRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCreateCaseRequest interface.
 */
function instanceOfAbsenceCreateCaseRequest(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function AbsenceCreateCaseRequestFromJSON(json) {
    return AbsenceCreateCaseRequestFromJSONTyped(json);
}
function AbsenceCreateCaseRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': AbsenceCreateCaseRequestDataFromJSON(json['data']),
    };
}
function AbsenceCreateCaseRequestToJSON(json) {
    return AbsenceCreateCaseRequestToJSONTyped(json);
}
function AbsenceCreateCaseRequestToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': AbsenceCreateCaseRequestDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCreateCaseResponseDataAttributes interface.
 */
function instanceOfAbsenceCreateCaseResponseDataAttributes(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('redirectToCaseList' in value) || value['redirectToCaseList'] === undefined)
        return false;
    if (!('creationDate' in value) || value['creationDate'] === undefined)
        return false;
    return true;
}
function AbsenceCreateCaseResponseDataAttributesFromJSON(json) {
    return AbsenceCreateCaseResponseDataAttributesFromJSONTyped(json);
}
function AbsenceCreateCaseResponseDataAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': json['status'],
        'displayId': json['displayId'] == null ? undefined : json['displayId'],
        'redirectToCaseList': json['redirectToCaseList'],
        'creationDate': (dateAndTime.DateWithoutTime.fromISO(json['creationDate'])),
    };
}
function AbsenceCreateCaseResponseDataAttributesToJSON(json) {
    return AbsenceCreateCaseResponseDataAttributesToJSONTyped(json);
}
function AbsenceCreateCaseResponseDataAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'status': value['status'],
        'displayId': value['displayId'],
        'redirectToCaseList': value['redirectToCaseList'],
        'creationDate': value['creationDate'].toISO(),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCreateCaseResponseData interface.
 */
function instanceOfAbsenceCreateCaseResponseData(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function AbsenceCreateCaseResponseDataFromJSON(json) {
    return AbsenceCreateCaseResponseDataFromJSONTyped(json);
}
function AbsenceCreateCaseResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': AbsenceCreateCaseResponseDataAttributesFromJSON(json['attributes']),
    };
}
function AbsenceCreateCaseResponseDataToJSON(json) {
    return AbsenceCreateCaseResponseDataToJSONTyped(json);
}
function AbsenceCreateCaseResponseDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': AbsenceCreateCaseResponseDataAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceCreateCaseResponse interface.
 */
function instanceOfAbsenceCreateCaseResponse(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function AbsenceCreateCaseResponseFromJSON(json) {
    return AbsenceCreateCaseResponseFromJSONTyped(json);
}
function AbsenceCreateCaseResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': AbsenceCreateCaseResponseDataFromJSON(json['data']),
    };
}
function AbsenceCreateCaseResponseToJSON(json) {
    return AbsenceCreateCaseResponseToJSONTyped(json);
}
function AbsenceCreateCaseResponseToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': AbsenceCreateCaseResponseDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the OverlapRuleInfo interface.
 */
function instanceOfOverlapRuleInfo(value) {
    return true;
}
function OverlapRuleInfoFromJSON(json) {
    return OverlapRuleInfoFromJSONTyped(json);
}
function OverlapRuleInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'] == null ? undefined : json['name'],
        'startDate': json['startDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['endDate'])),
    };
}
function OverlapRuleInfoToJSON(json) {
    return OverlapRuleInfoToJSONTyped(json);
}
function OverlapRuleInfoToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'startDate': value['startDate'] == null ? value['startDate'] : value['startDate'].toISO(),
        'endDate': value['endDate'] == null ? value['endDate'] : value['endDate'].toISO(),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceLimitMetaOverlappingCustomRulesInner interface.
 */
function instanceOfAbsenceLimitMetaOverlappingCustomRulesInner(value) {
    return true;
}
function AbsenceLimitMetaOverlappingCustomRulesInnerFromJSON(json) {
    return AbsenceLimitMetaOverlappingCustomRulesInnerFromJSONTyped(json);
}
function AbsenceLimitMetaOverlappingCustomRulesInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'conflictingRule': json['conflictingRule'] == null ? undefined : OverlapRuleInfoFromJSON(json['conflictingRule']),
        'conflictedRule': json['conflictedRule'] == null ? undefined : OverlapRuleInfoFromJSON(json['conflictedRule']),
    };
}
function AbsenceLimitMetaOverlappingCustomRulesInnerToJSON(json) {
    return AbsenceLimitMetaOverlappingCustomRulesInnerToJSONTyped(json);
}
function AbsenceLimitMetaOverlappingCustomRulesInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'conflictingRule': OverlapRuleInfoToJSON(value['conflictingRule']),
        'conflictedRule': OverlapRuleInfoToJSON(value['conflictedRule']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceLimitMeta interface.
 */
function instanceOfAbsenceLimitMeta(value) {
    return true;
}
function AbsenceLimitMetaFromJSON(json) {
    return AbsenceLimitMetaFromJSONTyped(json);
}
function AbsenceLimitMetaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'overlappingCustomRules': json['overlappingCustomRules'] == null ? undefined : (json['overlappingCustomRules'].map(AbsenceLimitMetaOverlappingCustomRulesInnerFromJSON)),
    };
}
function AbsenceLimitMetaToJSON(json) {
    return AbsenceLimitMetaToJSONTyped(json);
}
function AbsenceLimitMetaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'overlappingCustomRules': value['overlappingCustomRules'] == null ? undefined : (value['overlappingCustomRules'].map(AbsenceLimitMetaOverlappingCustomRulesInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Contains day of the week.
 * @export
 */
var DayOfWeek = {
    Sunday: 'SUNDAY',
    Monday: 'MONDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY',
    Thursday: 'THURSDAY',
    Friday: 'FRIDAY',
    Saturday: 'SATURDAY'
};
function instanceOfDayOfWeek(value) {
    for (var key in DayOfWeek) {
        if (Object.prototype.hasOwnProperty.call(DayOfWeek, key)) {
            if (DayOfWeek[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function DayOfWeekFromJSON(json) {
    return DayOfWeekFromJSONTyped(json);
}
function DayOfWeekFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function DayOfWeekToJSON(value) {
    return value;
}
function DayOfWeekToJSONTyped(value, ignoreDiscriminator) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the WeeklyLimitsInner interface.
 */
function instanceOfWeeklyLimitsInner(value) {
    return true;
}
function WeeklyLimitsInnerFromJSON(json) {
    return WeeklyLimitsInnerFromJSONTyped(json);
}
function WeeklyLimitsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'day': json['day'] == null ? undefined : DayOfWeekFromJSON(json['day']),
        'limit': json['limit'] == null ? undefined : json['limit'],
    };
}
function WeeklyLimitsInnerToJSON(json) {
    return WeeklyLimitsInnerToJSONTyped(json);
}
function WeeklyLimitsInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'day': DayOfWeekToJSON(value['day']),
        'limit': value['limit'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceLimitsDefaultRules interface.
 */
function instanceOfAbsenceLimitsDefaultRules(value) {
    return true;
}
function AbsenceLimitsDefaultRulesFromJSON(json) {
    return AbsenceLimitsDefaultRulesFromJSONTyped(json);
}
function AbsenceLimitsDefaultRulesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'limits': json['limits'] == null ? undefined : (json['limits'].map(WeeklyLimitsInnerFromJSON)),
    };
}
function AbsenceLimitsDefaultRulesToJSON(json) {
    return AbsenceLimitsDefaultRulesToJSONTyped(json);
}
function AbsenceLimitsDefaultRulesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'limits': value['limits'] == null ? undefined : (value['limits'].map(WeeklyLimitsInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceLimitsCustomRulesInner interface.
 */
function instanceOfAbsenceLimitsCustomRulesInner(value) {
    return true;
}
function AbsenceLimitsCustomRulesInnerFromJSON(json) {
    return AbsenceLimitsCustomRulesInnerFromJSONTyped(json);
}
function AbsenceLimitsCustomRulesInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'] == null ? undefined : json['name'],
        'ruleStartDate': json['ruleStartDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['ruleStartDate'])),
        'ruleEndDate': json['ruleEndDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['ruleEndDate'])),
        'limits': json['limits'] == null ? undefined : (json['limits'].map(WeeklyLimitsInnerFromJSON)),
    };
}
function AbsenceLimitsCustomRulesInnerToJSON(json) {
    return AbsenceLimitsCustomRulesInnerToJSONTyped(json);
}
function AbsenceLimitsCustomRulesInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'ruleStartDate': value['ruleStartDate'] == null ? value['ruleStartDate'] : value['ruleStartDate'].toISO(),
        'ruleEndDate': value['ruleEndDate'] == null ? value['ruleEndDate'] : value['ruleEndDate'].toISO(),
        'limits': value['limits'] == null ? undefined : (value['limits'].map(WeeklyLimitsInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceLimits interface.
 */
function instanceOfAbsenceLimits(value) {
    if (!('defaultRules' in value) || value['defaultRules'] === undefined)
        return false;
    return true;
}
function AbsenceLimitsFromJSON(json) {
    return AbsenceLimitsFromJSONTyped(json);
}
function AbsenceLimitsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'defaultRules': AbsenceLimitsDefaultRulesFromJSON(json['defaultRules']),
        'customRules': json['customRules'] == null ? undefined : (json['customRules'].map(AbsenceLimitsCustomRulesInnerFromJSON)),
    };
}
function AbsenceLimitsToJSON(json) {
    return AbsenceLimitsToJSONTyped(json);
}
function AbsenceLimitsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'defaultRules': AbsenceLimitsDefaultRulesToJSON(value['defaultRules']),
        'customRules': value['customRules'] == null ? undefined : (value['customRules'].map(AbsenceLimitsCustomRulesInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AbsenceReasonAttributes interface.
 */
function instanceOfAbsenceReasonAttributes(value) {
    if (!('absenceReasonCode' in value) || value['absenceReasonCode'] === undefined)
        return false;
    if (!('label' in value) || value['label'] === undefined)
        return false;
    return true;
}
function AbsenceReasonAttributesFromJSON(json) {
    return AbsenceReasonAttributesFromJSONTyped(json);
}
function AbsenceReasonAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'absenceReasonCode': json['absenceReasonCode'],
        'label': json['label'],
        'shortDescription': json['shortDescription'] == null ? undefined : json['shortDescription'],
        'toolTip': json['toolTip'] == null ? undefined : json['toolTip'],
    };
}
function AbsenceReasonAttributesToJSON(json) {
    return AbsenceReasonAttributesToJSONTyped(json);
}
function AbsenceReasonAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'absenceReasonCode': value['absenceReasonCode'],
        'label': value['label'],
        'shortDescription': value['shortDescription'],
        'toolTip': value['toolTip'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceReason interface.
 */
function instanceOfAbsenceReason(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function AbsenceReasonFromJSON(json) {
    return AbsenceReasonFromJSONTyped(json);
}
function AbsenceReasonFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': AbsenceReasonAttributesFromJSON(json['attributes']),
    };
}
function AbsenceReasonToJSON(json) {
    return AbsenceReasonToJSONTyped(json);
}
function AbsenceReasonToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': AbsenceReasonAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AbsenceTypeRelationshipsAllowedPayCodesDataInner interface.
 */
function instanceOfAbsenceTypeRelationshipsAllowedPayCodesDataInner(value) {
    return true;
}
function AbsenceTypeRelationshipsAllowedPayCodesDataInnerFromJSON(json) {
    return AbsenceTypeRelationshipsAllowedPayCodesDataInnerFromJSONTyped(json);
}
function AbsenceTypeRelationshipsAllowedPayCodesDataInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}
function AbsenceTypeRelationshipsAllowedPayCodesDataInnerToJSON(json) {
    return AbsenceTypeRelationshipsAllowedPayCodesDataInnerToJSONTyped(json);
}
function AbsenceTypeRelationshipsAllowedPayCodesDataInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceTypeRelationshipsAllowedPayCodes interface.
 */
function instanceOfAbsenceTypeRelationshipsAllowedPayCodes(value) {
    return true;
}
function AbsenceTypeRelationshipsAllowedPayCodesFromJSON(json) {
    return AbsenceTypeRelationshipsAllowedPayCodesFromJSONTyped(json);
}
function AbsenceTypeRelationshipsAllowedPayCodesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : (json['data'].map(AbsenceTypeRelationshipsAllowedPayCodesDataInnerFromJSON)),
    };
}
function AbsenceTypeRelationshipsAllowedPayCodesToJSON(json) {
    return AbsenceTypeRelationshipsAllowedPayCodesToJSONTyped(json);
}
function AbsenceTypeRelationshipsAllowedPayCodesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': value['data'] == null ? undefined : (value['data'].map(AbsenceTypeRelationshipsAllowedPayCodesDataInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the JobRelationshipsDataInner interface.
 */
function instanceOfJobRelationshipsDataInner(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function JobRelationshipsDataInnerFromJSON(json) {
    return JobRelationshipsDataInnerFromJSONTyped(json);
}
function JobRelationshipsDataInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
    };
}
function JobRelationshipsDataInnerToJSON(json) {
    return JobRelationshipsDataInnerToJSONTyped(json);
}
function JobRelationshipsDataInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the JobRelationships interface.
 */
function instanceOfJobRelationships(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function JobRelationshipsFromJSON(json) {
    return JobRelationshipsFromJSONTyped(json);
}
function JobRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(JobRelationshipsDataInnerFromJSON)),
    };
}
function JobRelationshipsToJSON(json) {
    return JobRelationshipsToJSONTyped(json);
}
function JobRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(JobRelationshipsDataInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AbsenceTypeRelationshipsDefaultPayCodeData interface.
 */
function instanceOfAbsenceTypeRelationshipsDefaultPayCodeData(value) {
    return true;
}
function AbsenceTypeRelationshipsDefaultPayCodeDataFromJSON(json) {
    return AbsenceTypeRelationshipsDefaultPayCodeDataFromJSONTyped(json);
}
function AbsenceTypeRelationshipsDefaultPayCodeDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}
function AbsenceTypeRelationshipsDefaultPayCodeDataToJSON(json) {
    return AbsenceTypeRelationshipsDefaultPayCodeDataToJSONTyped(json);
}
function AbsenceTypeRelationshipsDefaultPayCodeDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceTypeRelationshipsDefaultPayCode interface.
 */
function instanceOfAbsenceTypeRelationshipsDefaultPayCode(value) {
    return true;
}
function AbsenceTypeRelationshipsDefaultPayCodeFromJSON(json) {
    return AbsenceTypeRelationshipsDefaultPayCodeFromJSONTyped(json);
}
function AbsenceTypeRelationshipsDefaultPayCodeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : AbsenceTypeRelationshipsDefaultPayCodeDataFromJSON(json['data']),
    };
}
function AbsenceTypeRelationshipsDefaultPayCodeToJSON(json) {
    return AbsenceTypeRelationshipsDefaultPayCodeToJSONTyped(json);
}
function AbsenceTypeRelationshipsDefaultPayCodeToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': AbsenceTypeRelationshipsDefaultPayCodeDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceTypeRelationships interface.
 */
function instanceOfAbsenceTypeRelationships(value) {
    if (!('defaultPayCode' in value) || value['defaultPayCode'] === undefined)
        return false;
    if (!('allowedPayCodes' in value) || value['allowedPayCodes'] === undefined)
        return false;
    if (!('jobs' in value) || value['jobs'] === undefined)
        return false;
    if (!('employee' in value) || value['employee'] === undefined)
        return false;
    return true;
}
function AbsenceTypeRelationshipsFromJSON(json) {
    return AbsenceTypeRelationshipsFromJSONTyped(json);
}
function AbsenceTypeRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'defaultPayCode': AbsenceTypeRelationshipsDefaultPayCodeFromJSON(json['defaultPayCode']),
        'allowedPayCodes': AbsenceTypeRelationshipsAllowedPayCodesFromJSON(json['allowedPayCodes']),
        'jobs': JobRelationshipsFromJSON(json['jobs']),
        'employee': EmployeeRelationshipFromJSON(json['employee']),
    };
}
function AbsenceTypeRelationshipsToJSON(json) {
    return AbsenceTypeRelationshipsToJSONTyped(json);
}
function AbsenceTypeRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'defaultPayCode': AbsenceTypeRelationshipsDefaultPayCodeToJSON(value['defaultPayCode']),
        'allowedPayCodes': AbsenceTypeRelationshipsAllowedPayCodesToJSON(value['allowedPayCodes']),
        'jobs': JobRelationshipsToJSON(value['jobs']),
        'employee': EmployeeRelationshipToJSON(value['employee']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AbsenceTypeAttributes interface.
 */
function instanceOfAbsenceTypeAttributes(value) {
    return true;
}
function AbsenceTypeAttributesFromJSON(json) {
    return AbsenceTypeAttributesFromJSONTyped(json);
}
function AbsenceTypeAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'] == null ? undefined : json['name'],
    };
}
function AbsenceTypeAttributesToJSON(json) {
    return AbsenceTypeAttributesToJSONTyped(json);
}
function AbsenceTypeAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceType interface.
 */
function instanceOfAbsenceType(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    if (!('relationships' in value) || value['relationships'] === undefined)
        return false;
    return true;
}
function AbsenceTypeFromJSON(json) {
    return AbsenceTypeFromJSONTyped(json);
}
function AbsenceTypeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': AbsenceTypeAttributesFromJSON(json['attributes']),
        'relationships': AbsenceTypeRelationshipsFromJSON(json['relationships']),
    };
}
function AbsenceTypeToJSON(json) {
    return AbsenceTypeToJSONTyped(json);
}
function AbsenceTypeToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': AbsenceTypeAttributesToJSON(value['attributes']),
        'relationships': AbsenceTypeRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AbsenceTypeRelationshipData interface.
 */
function instanceOfAbsenceTypeRelationshipData(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function AbsenceTypeRelationshipDataFromJSON(json) {
    return AbsenceTypeRelationshipDataFromJSONTyped(json);
}
function AbsenceTypeRelationshipDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
    };
}
function AbsenceTypeRelationshipDataToJSON(json) {
    return AbsenceTypeRelationshipDataToJSONTyped(json);
}
function AbsenceTypeRelationshipDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AbsenceTypeRelationship interface.
 */
function instanceOfAbsenceTypeRelationship(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function AbsenceTypeRelationshipFromJSON(json) {
    return AbsenceTypeRelationshipFromJSONTyped(json);
}
function AbsenceTypeRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': AbsenceTypeRelationshipDataFromJSON(json['data']),
    };
}
function AbsenceTypeRelationshipToJSON(json) {
    return AbsenceTypeRelationshipToJSONTyped(json);
}
function AbsenceTypeRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': AbsenceTypeRelationshipDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AcceptedSchemaData interface.
 */
function instanceOfAcceptedSchemaData(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function AcceptedSchemaDataFromJSON(json) {
    return AcceptedSchemaDataFromJSONTyped(json);
}
function AcceptedSchemaDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
    };
}
function AcceptedSchemaDataToJSON(json) {
    return AcceptedSchemaDataToJSONTyped(json);
}
function AcceptedSchemaDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the AcceptedSchema interface.
 */
function instanceOfAcceptedSchema(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function AcceptedSchemaFromJSON(json) {
    return AcceptedSchemaFromJSONTyped(json);
}
function AcceptedSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': AcceptedSchemaDataFromJSON(json['data']),
    };
}
function AcceptedSchemaToJSON(json) {
    return AcceptedSchemaToJSONTyped(json);
}
function AcceptedSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': AcceptedSchemaDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ActivitiesLookupRelationshipTaskMetaLookup interface.
 */
function instanceOfActivitiesLookupRelationshipTaskMetaLookup(value) {
    return true;
}
function ActivitiesLookupRelationshipTaskMetaLookupFromJSON(json) {
    return ActivitiesLookupRelationshipTaskMetaLookupFromJSONTyped(json);
}
function ActivitiesLookupRelationshipTaskMetaLookupFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'] == null ? undefined : json['code'],
    };
}
function ActivitiesLookupRelationshipTaskMetaLookupToJSON(json) {
    return ActivitiesLookupRelationshipTaskMetaLookupToJSONTyped(json);
}
function ActivitiesLookupRelationshipTaskMetaLookupToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the ActivitiesLookupRelationshipTaskMeta interface.
 */
function instanceOfActivitiesLookupRelationshipTaskMeta(value) {
    return true;
}
function ActivitiesLookupRelationshipTaskMetaFromJSON(json) {
    return ActivitiesLookupRelationshipTaskMetaFromJSONTyped(json);
}
function ActivitiesLookupRelationshipTaskMetaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'lookup': json['lookup'] == null ? undefined : ActivitiesLookupRelationshipTaskMetaLookupFromJSON(json['lookup']),
    };
}
function ActivitiesLookupRelationshipTaskMetaToJSON(json) {
    return ActivitiesLookupRelationshipTaskMetaToJSONTyped(json);
}
function ActivitiesLookupRelationshipTaskMetaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'lookup': ActivitiesLookupRelationshipTaskMetaLookupToJSON(value['lookup']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var ActivitiesLookupRelationshipTaskTypeEnum = {
    Task: 'task'
};
/**
 * Check if a given object implements the ActivitiesLookupRelationshipTask interface.
 */
function instanceOfActivitiesLookupRelationshipTask(value) {
    return true;
}
function ActivitiesLookupRelationshipTaskFromJSON(json) {
    return ActivitiesLookupRelationshipTaskFromJSONTyped(json);
}
function ActivitiesLookupRelationshipTaskFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'meta': json['meta'] == null ? undefined : ActivitiesLookupRelationshipTaskMetaFromJSON(json['meta']),
    };
}
function ActivitiesLookupRelationshipTaskToJSON(json) {
    return ActivitiesLookupRelationshipTaskToJSONTyped(json);
}
function ActivitiesLookupRelationshipTaskToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'meta': ActivitiesLookupRelationshipTaskMetaToJSON(value['meta']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ActivitiesLookupRelationshipSchedulingUnitMetaLookup interface.
 */
function instanceOfActivitiesLookupRelationshipSchedulingUnitMetaLookup(value) {
    return true;
}
function ActivitiesLookupRelationshipSchedulingUnitMetaLookupFromJSON(json) {
    return ActivitiesLookupRelationshipSchedulingUnitMetaLookupFromJSONTyped(json);
}
function ActivitiesLookupRelationshipSchedulingUnitMetaLookupFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'] == null ? undefined : json['code'],
    };
}
function ActivitiesLookupRelationshipSchedulingUnitMetaLookupToJSON(json) {
    return ActivitiesLookupRelationshipSchedulingUnitMetaLookupToJSONTyped(json);
}
function ActivitiesLookupRelationshipSchedulingUnitMetaLookupToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the ActivitiesLookupRelationshipSchedulingUnitMeta interface.
 */
function instanceOfActivitiesLookupRelationshipSchedulingUnitMeta(value) {
    return true;
}
function ActivitiesLookupRelationshipSchedulingUnitMetaFromJSON(json) {
    return ActivitiesLookupRelationshipSchedulingUnitMetaFromJSONTyped(json);
}
function ActivitiesLookupRelationshipSchedulingUnitMetaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'lookup': json['lookup'] == null ? undefined : ActivitiesLookupRelationshipSchedulingUnitMetaLookupFromJSON(json['lookup']),
    };
}
function ActivitiesLookupRelationshipSchedulingUnitMetaToJSON(json) {
    return ActivitiesLookupRelationshipSchedulingUnitMetaToJSONTyped(json);
}
function ActivitiesLookupRelationshipSchedulingUnitMetaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'lookup': ActivitiesLookupRelationshipSchedulingUnitMetaLookupToJSON(value['lookup']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var ActivitiesLookupRelationshipSchedulingUnitTypeEnum = {
    SchedulingUnit: 'schedulingUnit'
};
/**
 * Check if a given object implements the ActivitiesLookupRelationshipSchedulingUnit interface.
 */
function instanceOfActivitiesLookupRelationshipSchedulingUnit(value) {
    return true;
}
function ActivitiesLookupRelationshipSchedulingUnitFromJSON(json) {
    return ActivitiesLookupRelationshipSchedulingUnitFromJSONTyped(json);
}
function ActivitiesLookupRelationshipSchedulingUnitFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'meta': json['meta'] == null ? undefined : ActivitiesLookupRelationshipSchedulingUnitMetaFromJSON(json['meta']),
    };
}
function ActivitiesLookupRelationshipSchedulingUnitToJSON(json) {
    return ActivitiesLookupRelationshipSchedulingUnitToJSONTyped(json);
}
function ActivitiesLookupRelationshipSchedulingUnitToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'meta': ActivitiesLookupRelationshipSchedulingUnitMetaToJSON(value['meta']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
var DiscriminatedFieldValueDatatypeEnum = {
    String: 'string',
    Number: 'number',
    Boolean: 'boolean',
    Date: 'date',
    DateTime: 'date-time'
};
/**
 * Check if a given object implements the DiscriminatedFieldValue interface.
 */
function instanceOfDiscriminatedFieldValue(value) {
    if (!('datatype' in value) || value['datatype'] === undefined)
        return false;
    return true;
}
function DiscriminatedFieldValueFromJSON(json) {
    return DiscriminatedFieldValueFromJSONTyped(json);
}
function DiscriminatedFieldValueFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'datatype': json['datatype'],
        'stringValue': json['stringValue'] == null ? undefined : json['stringValue'],
        'numberValue': json['numberValue'] == null ? undefined : json['numberValue'],
        'booleanValue': json['booleanValue'] == null ? undefined : json['booleanValue'],
        'dateValue': json['dateValue'] == null ? undefined : json['dateValue'],
        'datetimeValue': json['datetimeValue'] == null ? undefined : json['datetimeValue'],
    };
}
function DiscriminatedFieldValueToJSON(json) {
    return DiscriminatedFieldValueToJSONTyped(json);
}
function DiscriminatedFieldValueToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'datatype': value['datatype'],
        'stringValue': value['stringValue'],
        'numberValue': value['numberValue'],
        'booleanValue': value['booleanValue'],
        'dateValue': value['dateValue'],
        'datetimeValue': value['datetimeValue'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the ActivitiesLookupRelationship interface.
 */
function instanceOfActivitiesLookupRelationship(value) {
    return true;
}
function ActivitiesLookupRelationshipFromJSON(json) {
    return ActivitiesLookupRelationshipFromJSONTyped(json);
}
function ActivitiesLookupRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'startsAt': json['startsAt'] == null ? undefined : (luxon.DateTime.fromISO(json['startsAt'])),
        'endsAt': json['endsAt'] == null ? undefined : (luxon.DateTime.fromISO(json['endsAt'])),
        'payCodeId': json['payCodeId'] == null ? undefined : json['payCodeId'],
        'additionalInformation': json['additionalInformation'] == null ? undefined : (mapValues(json['additionalInformation'], DiscriminatedFieldValueFromJSON)),
        'task': json['task'] == null ? undefined : ActivitiesLookupRelationshipTaskFromJSON(json['task']),
        'schedulingUnit': json['schedulingUnit'] == null ? undefined : ActivitiesLookupRelationshipSchedulingUnitFromJSON(json['schedulingUnit']),
        'duration': json['duration'] == null ? undefined : json['duration'],
    };
}
function ActivitiesLookupRelationshipToJSON(json) {
    return ActivitiesLookupRelationshipToJSONTyped(json);
}
function ActivitiesLookupRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'startsAt': value['startsAt'] == null ? value['startsAt'] : value['startsAt'].toISO(),
        'endsAt': value['endsAt'] == null ? value['endsAt'] : value['endsAt'].toISO(),
        'payCodeId': value['payCodeId'],
        'additionalInformation': value['additionalInformation'] == null ? undefined : (mapValues(value['additionalInformation'], DiscriminatedFieldValueToJSON)),
        'task': ActivitiesLookupRelationshipTaskToJSON(value['task']),
        'schedulingUnit': ActivitiesLookupRelationshipSchedulingUnitToJSON(value['schedulingUnit']),
        'duration': value['duration'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ActivitiesRelationshipDataInner interface.
 */
function instanceOfActivitiesRelationshipDataInner(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function ActivitiesRelationshipDataInnerFromJSON(json) {
    return ActivitiesRelationshipDataInnerFromJSONTyped(json);
}
function ActivitiesRelationshipDataInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
    };
}
function ActivitiesRelationshipDataInnerToJSON(json) {
    return ActivitiesRelationshipDataInnerToJSONTyped(json);
}
function ActivitiesRelationshipDataInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the ActivitiesRelationship interface.
 */
function instanceOfActivitiesRelationship(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function ActivitiesRelationshipFromJSON(json) {
    return ActivitiesRelationshipFromJSONTyped(json);
}
function ActivitiesRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(ActivitiesRelationshipDataInnerFromJSON)),
    };
}
function ActivitiesRelationshipToJSON(json) {
    return ActivitiesRelationshipToJSONTyped(json);
}
function ActivitiesRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(ActivitiesRelationshipDataInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the BalanceAttributesTimeUnit interface.
 */
function instanceOfBalanceAttributesTimeUnit(value) {
    return true;
}
function BalanceAttributesTimeUnitFromJSON(json) {
    return BalanceAttributesTimeUnitFromJSONTyped(json);
}
function BalanceAttributesTimeUnitFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'codeValue': json['codeValue'] == null ? undefined : json['codeValue'],
        'shortName': json['shortName'] == null ? undefined : json['shortName'],
    };
}
function BalanceAttributesTimeUnitToJSON(json) {
    return BalanceAttributesTimeUnitToJSONTyped(json);
}
function BalanceAttributesTimeUnitToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'codeValue': value['codeValue'],
        'shortName': value['shortName'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
var NumberFormatOptionsStyleEnum = {
    Decimal: 'Decimal',
    Percent: 'Percent',
    Currency: 'Currency',
    ElapsedTime: 'ElapsedTime'
};
/**
 * Check if a given object implements the NumberFormatOptions interface.
 */
function instanceOfNumberFormatOptions(value) {
    if (!('style' in value) || value['style'] === undefined)
        return false;
    return true;
}
function NumberFormatOptionsFromJSON(json) {
    return NumberFormatOptionsFromJSONTyped(json);
}
function NumberFormatOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'style': json['style'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'useAccountingStyleCurrencySign': json['useAccountingStyleCurrencySign'] == null ? undefined : json['useAccountingStyleCurrencySign'],
        'preventGrouping': json['preventGrouping'] == null ? undefined : json['preventGrouping'],
        'minimumIntegerDigits': json['minimumIntegerDigits'] == null ? undefined : json['minimumIntegerDigits'],
        'minimumFractionDigits': json['minimumFractionDigits'] == null ? undefined : json['minimumFractionDigits'],
        'maximumFractionDigits': json['maximumFractionDigits'] == null ? undefined : json['maximumFractionDigits'],
    };
}
function NumberFormatOptionsToJSON(json) {
    return NumberFormatOptionsToJSONTyped(json);
}
function NumberFormatOptionsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'style': value['style'],
        'currencyCode': value['currencyCode'],
        'useAccountingStyleCurrencySign': value['useAccountingStyleCurrencySign'],
        'preventGrouping': value['preventGrouping'],
        'minimumIntegerDigits': value['minimumIntegerDigits'],
        'minimumFractionDigits': value['minimumFractionDigits'],
        'maximumFractionDigits': value['maximumFractionDigits'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BalanceAttributes interface.
 */
function instanceOfBalanceAttributes(value) {
    return true;
}
function BalanceAttributesFromJSON(json) {
    return BalanceAttributesFromJSONTyped(json);
}
function BalanceAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'balanceDate': json['balanceDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['balanceDate'])),
        'initialBalance': json['initialBalance'] == null ? undefined : json['initialBalance'],
        'accrued': json['accrued'] == null ? undefined : json['accrued'],
        'used': json['used'] == null ? undefined : json['used'],
        'cleared': json['cleared'] == null ? undefined : json['cleared'],
        'transferred': json['transferred'] == null ? undefined : json['transferred'],
        'terminated': json['terminated'] == null ? undefined : json['terminated'],
        'balance': json['balance'] == null ? undefined : json['balance'],
        'isVisibleToEmployee': json['isVisibleToEmployee'] == null ? undefined : json['isVisibleToEmployee'],
        'timeUnit': json['timeUnit'] == null ? undefined : BalanceAttributesTimeUnitFromJSON(json['timeUnit']),
        'numberFormatOptions': json['numberFormatOptions'] == null ? undefined : NumberFormatOptionsFromJSON(json['numberFormatOptions']),
        'updated': json['updated'] == null ? undefined : (luxon.DateTime.fromISO(json['updated'])),
    };
}
function BalanceAttributesToJSON(json) {
    return BalanceAttributesToJSONTyped(json);
}
function BalanceAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'balanceDate': value['balanceDate'] == null ? value['balanceDate'] : value['balanceDate'].toISO(),
        'initialBalance': value['initialBalance'],
        'accrued': value['accrued'],
        'used': value['used'],
        'cleared': value['cleared'],
        'transferred': value['transferred'],
        'terminated': value['terminated'],
        'balance': value['balance'],
        'isVisibleToEmployee': value['isVisibleToEmployee'],
        'timeUnit': BalanceAttributesTimeUnitToJSON(value['timeUnit']),
        'numberFormatOptions': NumberFormatOptionsToJSON(value['numberFormatOptions']),
        'updated': value['updated'] == null ? value['updated'] : value['updated'].toISO(),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the BalanceRelationshipsBankData interface.
 */
function instanceOfBalanceRelationshipsBankData(value) {
    return true;
}
function BalanceRelationshipsBankDataFromJSON(json) {
    return BalanceRelationshipsBankDataFromJSONTyped(json);
}
function BalanceRelationshipsBankDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}
function BalanceRelationshipsBankDataToJSON(json) {
    return BalanceRelationshipsBankDataToJSONTyped(json);
}
function BalanceRelationshipsBankDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BalanceRelationshipsBank interface.
 */
function instanceOfBalanceRelationshipsBank(value) {
    return true;
}
function BalanceRelationshipsBankFromJSON(json) {
    return BalanceRelationshipsBankFromJSONTyped(json);
}
function BalanceRelationshipsBankFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : BalanceRelationshipsBankDataFromJSON(json['data']),
    };
}
function BalanceRelationshipsBankToJSON(json) {
    return BalanceRelationshipsBankToJSONTyped(json);
}
function BalanceRelationshipsBankToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': BalanceRelationshipsBankDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BalanceRelationships interface.
 */
function instanceOfBalanceRelationships(value) {
    if (!('employee' in value) || value['employee'] === undefined)
        return false;
    if (!('jobs' in value) || value['jobs'] === undefined)
        return false;
    if (!('bank' in value) || value['bank'] === undefined)
        return false;
    return true;
}
function BalanceRelationshipsFromJSON(json) {
    return BalanceRelationshipsFromJSONTyped(json);
}
function BalanceRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'employee': EmployeeRelationshipFromJSON(json['employee']),
        'jobs': JobRelationshipsFromJSON(json['jobs']),
        'bank': BalanceRelationshipsBankFromJSON(json['bank']),
    };
}
function BalanceRelationshipsToJSON(json) {
    return BalanceRelationshipsToJSONTyped(json);
}
function BalanceRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'employee': EmployeeRelationshipToJSON(value['employee']),
        'jobs': JobRelationshipsToJSON(value['jobs']),
        'bank': BalanceRelationshipsBankToJSON(value['bank']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the Balance interface.
 */
function instanceOfBalance(value) {
    return true;
}
function BalanceFromJSON(json) {
    return BalanceFromJSONTyped(json);
}
function BalanceFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'attributes': json['attributes'] == null ? undefined : BalanceAttributesFromJSON(json['attributes']),
        'relationships': json['relationships'] == null ? undefined : BalanceRelationshipsFromJSON(json['relationships']),
    };
}
function BalanceToJSON(json) {
    return BalanceToJSONTyped(json);
}
function BalanceToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': BalanceAttributesToJSON(value['attributes']),
        'relationships': BalanceRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the BankAttributes interface.
 */
function instanceOfBankAttributes(value) {
    return true;
}
function BankAttributesFromJSON(json) {
    return BankAttributesFromJSONTyped(json);
}
function BankAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'shortName': json['shortName'] == null ? undefined : json['shortName'],
    };
}
function BankAttributesToJSON(json) {
    return BankAttributesToJSONTyped(json);
}
function BankAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'shortName': value['shortName'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the Bank interface.
 */
function instanceOfBank(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function BankFromJSON(json) {
    return BankFromJSONTyped(json);
}
function BankFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': json['attributes'] == null ? undefined : BankAttributesFromJSON(json['attributes']),
    };
}
function BankToJSON(json) {
    return BankToJSONTyped(json);
}
function BankToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': BankAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Represents included resources in bank responses.
 * @export
 */
var BankIncludeItem = {
    Employee: 'employee',
    Job: 'job'
};
function instanceOfBankIncludeItem(value) {
    for (var key in BankIncludeItem) {
        if (Object.prototype.hasOwnProperty.call(BankIncludeItem, key)) {
            if (BankIncludeItem[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function BankIncludeItemFromJSON(json) {
    return BankIncludeItemFromJSONTyped(json);
}
function BankIncludeItemFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function BankIncludeItemToJSON(value) {
    return value;
}
function BankIncludeItemToJSONTyped(value, ignoreDiscriminator) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the EmployeeBankRelationships interface.
 */
function instanceOfEmployeeBankRelationships(value) {
    if (!('employee' in value) || value['employee'] === undefined)
        return false;
    if (!('jobs' in value) || value['jobs'] === undefined)
        return false;
    return true;
}
function EmployeeBankRelationshipsFromJSON(json) {
    return EmployeeBankRelationshipsFromJSONTyped(json);
}
function EmployeeBankRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'employee': EmployeeRelationshipFromJSON(json['employee']),
        'jobs': JobRelationshipsFromJSON(json['jobs']),
    };
}
function EmployeeBankRelationshipsToJSON(json) {
    return EmployeeBankRelationshipsToJSONTyped(json);
}
function EmployeeBankRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'employee': EmployeeRelationshipToJSON(value['employee']),
        'jobs': JobRelationshipsToJSON(value['jobs']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the BankMetadataAttributesDisplayContexts interface.
 */
function instanceOfBankMetadataAttributesDisplayContexts(value) {
    if (!('timeOff' in value) || value['timeOff'] === undefined)
        return false;
    if (!('timesheet' in value) || value['timesheet'] === undefined)
        return false;
    if (!('hubCard' in value) || value['hubCard'] === undefined)
        return false;
    return true;
}
function BankMetadataAttributesDisplayContextsFromJSON(json) {
    return BankMetadataAttributesDisplayContextsFromJSONTyped(json);
}
function BankMetadataAttributesDisplayContextsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'timeOff': json['timeOff'],
        'timesheet': json['timesheet'],
        'hubCard': json['hubCard'],
    };
}
function BankMetadataAttributesDisplayContextsToJSON(json) {
    return BankMetadataAttributesDisplayContextsToJSONTyped(json);
}
function BankMetadataAttributesDisplayContextsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'timeOff': value['timeOff'],
        'timesheet': value['timesheet'],
        'hubCard': value['hubCard'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the BankMetadataAttributesBalanceLabel interface.
 */
function instanceOfBankMetadataAttributesBalanceLabel(value) {
    return true;
}
function BankMetadataAttributesBalanceLabelFromJSON(json) {
    return BankMetadataAttributesBalanceLabelFromJSONTyped(json);
}
function BankMetadataAttributesBalanceLabelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'codeValue': json['codeValue'] == null ? undefined : json['codeValue'],
        'shortName': json['shortName'] == null ? undefined : json['shortName'],
    };
}
function BankMetadataAttributesBalanceLabelToJSON(json) {
    return BankMetadataAttributesBalanceLabelToJSONTyped(json);
}
function BankMetadataAttributesBalanceLabelToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'codeValue': value['codeValue'],
        'shortName': value['shortName'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BankMetadataAttributes interface.
 */
function instanceOfBankMetadataAttributes(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('balanceLabel' in value) || value['balanceLabel'] === undefined)
        return false;
    if (!('balanceFormat' in value) || value['balanceFormat'] === undefined)
        return false;
    return true;
}
function BankMetadataAttributesFromJSON(json) {
    return BankMetadataAttributesFromJSONTyped(json);
}
function BankMetadataAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'balanceLabel': BankMetadataAttributesBalanceLabelFromJSON(json['balanceLabel']),
        'balanceFormat': NumberFormatOptionsFromJSON(json['balanceFormat']),
        'displayContexts': json['displayContexts'] == null ? undefined : BankMetadataAttributesDisplayContextsFromJSON(json['displayContexts']),
    };
}
function BankMetadataAttributesToJSON(json) {
    return BankMetadataAttributesToJSONTyped(json);
}
function BankMetadataAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'balanceLabel': BankMetadataAttributesBalanceLabelToJSON(value['balanceLabel']),
        'balanceFormat': NumberFormatOptionsToJSON(value['balanceFormat']),
        'displayContexts': BankMetadataAttributesDisplayContextsToJSON(value['displayContexts']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BankMetadata interface.
 */
function instanceOfBankMetadata(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    if (!('relationships' in value) || value['relationships'] === undefined)
        return false;
    return true;
}
function BankMetadataFromJSON(json) {
    return BankMetadataFromJSONTyped(json);
}
function BankMetadataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': BankMetadataAttributesFromJSON(json['attributes']),
        'relationships': EmployeeBankRelationshipsFromJSON(json['relationships']),
    };
}
function BankMetadataToJSON(json) {
    return BankMetadataToJSONTyped(json);
}
function BankMetadataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': BankMetadataAttributesToJSON(value['attributes']),
        'relationships': EmployeeBankRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Represents included resources in bank metadata responses.
 * @export
 */
var BankMetadataIncludeItem = {
    Employee: 'employee',
    Job: 'job'
};
function instanceOfBankMetadataIncludeItem(value) {
    for (var key in BankMetadataIncludeItem) {
        if (Object.prototype.hasOwnProperty.call(BankMetadataIncludeItem, key)) {
            if (BankMetadataIncludeItem[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function BankMetadataIncludeItemFromJSON(json) {
    return BankMetadataIncludeItemFromJSONTyped(json);
}
function BankMetadataIncludeItemFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function BankMetadataIncludeItemToJSON(value) {
    return value;
}
function BankMetadataIncludeItemToJSONTyped(value, ignoreDiscriminator) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PageMetadata interface.
 */
function instanceOfPageMetadata(value) {
    return true;
}
function PageMetadataFromJSON(json) {
    return PageMetadataFromJSONTyped(json);
}
function PageMetadataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'rangeTruncated': json['rangeTruncated'] == null ? undefined : json['rangeTruncated'],
    };
}
function PageMetadataToJSON(json) {
    return PageMetadataToJSONTyped(json);
}
function PageMetadataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'rangeTruncated': value['rangeTruncated'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BankMetadataMeta interface.
 */
function instanceOfBankMetadataMeta(value) {
    return true;
}
function BankMetadataMetaFromJSON(json) {
    return BankMetadataMetaFromJSONTyped(json);
}
function BankMetadataMetaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'page': json['page'] == null ? undefined : PageMetadataFromJSON(json['page']),
    };
}
function BankMetadataMetaToJSON(json) {
    return BankMetadataMetaToJSONTyped(json);
}
function BankMetadataMetaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'page': PageMetadataToJSON(value['page']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the BankPolicyRelationshipData interface.
 */
function instanceOfBankPolicyRelationshipData(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function BankPolicyRelationshipDataFromJSON(json) {
    return BankPolicyRelationshipDataFromJSONTyped(json);
}
function BankPolicyRelationshipDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
    };
}
function BankPolicyRelationshipDataToJSON(json) {
    return BankPolicyRelationshipDataToJSONTyped(json);
}
function BankPolicyRelationshipDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BankPolicyRelationship interface.
 */
function instanceOfBankPolicyRelationship(value) {
    return true;
}
function BankPolicyRelationshipFromJSON(json) {
    return BankPolicyRelationshipFromJSONTyped(json);
}
function BankPolicyRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : BankPolicyRelationshipDataFromJSON(json['data']),
    };
}
function BankPolicyRelationshipToJSON(json) {
    return BankPolicyRelationshipToJSONTyped(json);
}
function BankPolicyRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': BankPolicyRelationshipDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BankProjectionMeta interface.
 */
function instanceOfBankProjectionMeta(value) {
    if (!('createdDate' in value) || value['createdDate'] === undefined)
        return false;
    if (!('updatedDate' in value) || value['updatedDate'] === undefined)
        return false;
    return true;
}
function BankProjectionMetaFromJSON(json) {
    return BankProjectionMetaFromJSONTyped(json);
}
function BankProjectionMetaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'createdDate': (luxon.DateTime.fromISO(json['createdDate'])),
        'updatedDate': (luxon.DateTime.fromISO(json['updatedDate'])),
    };
}
function BankProjectionMetaToJSON(json) {
    return BankProjectionMetaToJSONTyped(json);
}
function BankProjectionMetaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'createdDate': value['createdDate'].toISO(),
        'updatedDate': value['updatedDate'].toISO(),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the EmployeeRelationships interface.
 */
function instanceOfEmployeeRelationships(value) {
    return true;
}
function EmployeeRelationshipsFromJSON(json) {
    return EmployeeRelationshipsFromJSONTyped(json);
}
function EmployeeRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : (json['data'].map(EmployeeRelationshipDataFromJSON)),
    };
}
function EmployeeRelationshipsToJSON(json) {
    return EmployeeRelationshipsToJSONTyped(json);
}
function EmployeeRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': value['data'] == null ? undefined : (value['data'].map(EmployeeRelationshipDataToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the BankProjectionBalanceRelationshipsDataInner interface.
 */
function instanceOfBankProjectionBalanceRelationshipsDataInner(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function BankProjectionBalanceRelationshipsDataInnerFromJSON(json) {
    return BankProjectionBalanceRelationshipsDataInnerFromJSONTyped(json);
}
function BankProjectionBalanceRelationshipsDataInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
    };
}
function BankProjectionBalanceRelationshipsDataInnerToJSON(json) {
    return BankProjectionBalanceRelationshipsDataInnerToJSONTyped(json);
}
function BankProjectionBalanceRelationshipsDataInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BankProjectionBalanceRelationships interface.
 */
function instanceOfBankProjectionBalanceRelationships(value) {
    return true;
}
function BankProjectionBalanceRelationshipsFromJSON(json) {
    return BankProjectionBalanceRelationshipsFromJSONTyped(json);
}
function BankProjectionBalanceRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : (json['data'].map(BankProjectionBalanceRelationshipsDataInnerFromJSON)),
    };
}
function BankProjectionBalanceRelationshipsToJSON(json) {
    return BankProjectionBalanceRelationshipsToJSONTyped(json);
}
function BankProjectionBalanceRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': value['data'] == null ? undefined : (value['data'].map(BankProjectionBalanceRelationshipsDataInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the BankProjectionGapRelationshipsDataInner interface.
 */
function instanceOfBankProjectionGapRelationshipsDataInner(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function BankProjectionGapRelationshipsDataInnerFromJSON(json) {
    return BankProjectionGapRelationshipsDataInnerFromJSONTyped(json);
}
function BankProjectionGapRelationshipsDataInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
    };
}
function BankProjectionGapRelationshipsDataInnerToJSON(json) {
    return BankProjectionGapRelationshipsDataInnerToJSONTyped(json);
}
function BankProjectionGapRelationshipsDataInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BankProjectionGapRelationships interface.
 */
function instanceOfBankProjectionGapRelationships(value) {
    return true;
}
function BankProjectionGapRelationshipsFromJSON(json) {
    return BankProjectionGapRelationshipsFromJSONTyped(json);
}
function BankProjectionGapRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : (json['data'].map(BankProjectionGapRelationshipsDataInnerFromJSON)),
    };
}
function BankProjectionGapRelationshipsToJSON(json) {
    return BankProjectionGapRelationshipsToJSONTyped(json);
}
function BankProjectionGapRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': value['data'] == null ? undefined : (value['data'].map(BankProjectionGapRelationshipsDataInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the BankProjectionEntryRelationshipsDataInner interface.
 */
function instanceOfBankProjectionEntryRelationshipsDataInner(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function BankProjectionEntryRelationshipsDataInnerFromJSON(json) {
    return BankProjectionEntryRelationshipsDataInnerFromJSONTyped(json);
}
function BankProjectionEntryRelationshipsDataInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
    };
}
function BankProjectionEntryRelationshipsDataInnerToJSON(json) {
    return BankProjectionEntryRelationshipsDataInnerToJSONTyped(json);
}
function BankProjectionEntryRelationshipsDataInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BankProjectionEntryRelationships interface.
 */
function instanceOfBankProjectionEntryRelationships(value) {
    return true;
}
function BankProjectionEntryRelationshipsFromJSON(json) {
    return BankProjectionEntryRelationshipsFromJSONTyped(json);
}
function BankProjectionEntryRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : (json['data'].map(BankProjectionEntryRelationshipsDataInnerFromJSON)),
    };
}
function BankProjectionEntryRelationshipsToJSON(json) {
    return BankProjectionEntryRelationshipsToJSONTyped(json);
}
function BankProjectionEntryRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': value['data'] == null ? undefined : (value['data'].map(BankProjectionEntryRelationshipsDataInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BankProjectionResponseRelationships interface.
 */
function instanceOfBankProjectionResponseRelationships(value) {
    if (!('employees' in value) || value['employees'] === undefined)
        return false;
    return true;
}
function BankProjectionResponseRelationshipsFromJSON(json) {
    return BankProjectionResponseRelationshipsFromJSONTyped(json);
}
function BankProjectionResponseRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'entries': json['entries'] == null ? undefined : BankProjectionEntryRelationshipsFromJSON(json['entries']),
        'balances': json['balances'] == null ? undefined : BankProjectionBalanceRelationshipsFromJSON(json['balances']),
        'gaps': json['gaps'] == null ? undefined : BankProjectionGapRelationshipsFromJSON(json['gaps']),
        'employees': EmployeeRelationshipsFromJSON(json['employees']),
        'jobs': json['jobs'] == null ? undefined : JobRelationshipsFromJSON(json['jobs']),
    };
}
function BankProjectionResponseRelationshipsToJSON(json) {
    return BankProjectionResponseRelationshipsToJSONTyped(json);
}
function BankProjectionResponseRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'entries': BankProjectionEntryRelationshipsToJSON(value['entries']),
        'balances': BankProjectionBalanceRelationshipsToJSON(value['balances']),
        'gaps': BankProjectionGapRelationshipsToJSON(value['gaps']),
        'employees': EmployeeRelationshipsToJSON(value['employees']),
        'jobs': JobRelationshipsToJSON(value['jobs']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ProjectionOverrides interface.
 */
function instanceOfProjectionOverrides(value) {
    return true;
}
function ProjectionOverridesFromJSON(json) {
    return ProjectionOverridesFromJSONTyped(json);
}
function ProjectionOverridesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'includePendingTimeOffRequests': json['includePendingTimeOffRequests'] == null ? undefined : json['includePendingTimeOffRequests'],
    };
}
function ProjectionOverridesToJSON(json) {
    return ProjectionOverridesToJSONTyped(json);
}
function ProjectionOverridesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'includePendingTimeOffRequests': value['includePendingTimeOffRequests'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var BankProjectionAttributesStatusEnum = {
    Pending: 'PENDING',
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Failed: 'FAILED'
};
/**
 * Check if a given object implements the BankProjectionAttributes interface.
 */
function instanceOfBankProjectionAttributes(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('startDate' in value) || value['startDate'] === undefined)
        return false;
    if (!('endDate' in value) || value['endDate'] === undefined)
        return false;
    return true;
}
function BankProjectionAttributesFromJSON(json) {
    return BankProjectionAttributesFromJSONTyped(json);
}
function BankProjectionAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': json['status'],
        'startDate': (dateAndTime.DateWithoutTime.fromISO(json['startDate'])),
        'endDate': (dateAndTime.DateWithoutTime.fromISO(json['endDate'])),
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'overrides': json['overrides'] == null ? undefined : ProjectionOverridesFromJSON(json['overrides']),
    };
}
function BankProjectionAttributesToJSON(json) {
    return BankProjectionAttributesToJSONTyped(json);
}
function BankProjectionAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'status': value['status'],
        'startDate': value['startDate'].toISO(),
        'endDate': value['endDate'].toISO(),
        'errorMessage': value['errorMessage'],
        'overrides': ProjectionOverridesToJSON(value['overrides']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BankProjection interface.
 */
function instanceOfBankProjection(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    if (!('relationships' in value) || value['relationships'] === undefined)
        return false;
    if (!('meta' in value) || value['meta'] === undefined)
        return false;
    return true;
}
function BankProjectionFromJSON(json) {
    return BankProjectionFromJSONTyped(json);
}
function BankProjectionFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': BankProjectionAttributesFromJSON(json['attributes']),
        'relationships': BankProjectionResponseRelationshipsFromJSON(json['relationships']),
        'meta': BankProjectionMetaFromJSON(json['meta']),
    };
}
function BankProjectionToJSON(json) {
    return BankProjectionToJSONTyped(json);
}
function BankProjectionToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': BankProjectionAttributesToJSON(value['attributes']),
        'relationships': BankProjectionResponseRelationshipsToJSON(value['relationships']),
        'meta': BankProjectionMetaToJSON(value['meta']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ProjectionScope interface.
 */
function instanceOfProjectionScope(value) {
    return true;
}
function ProjectionScopeFromJSON(json) {
    return ProjectionScopeFromJSONTyped(json);
}
function ProjectionScopeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'bankSet': json['bankSet'] == null ? undefined : json['bankSet'],
        'bankPolicyIds': json['bankPolicyIds'] == null ? undefined : json['bankPolicyIds'],
    };
}
function ProjectionScopeToJSON(json) {
    return ProjectionScopeToJSONTyped(json);
}
function ProjectionScopeToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'bankSet': value['bankSet'],
        'bankPolicyIds': value['bankPolicyIds'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BankProjectionCreateRequestDataAttributes interface.
 */
function instanceOfBankProjectionCreateRequestDataAttributes(value) {
    if (!('startDate' in value) || value['startDate'] === undefined)
        return false;
    if (!('endDate' in value) || value['endDate'] === undefined)
        return false;
    return true;
}
function BankProjectionCreateRequestDataAttributesFromJSON(json) {
    return BankProjectionCreateRequestDataAttributesFromJSONTyped(json);
}
function BankProjectionCreateRequestDataAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'startDate': (dateAndTime.DateWithoutTime.fromISO(json['startDate'])),
        'endDate': (dateAndTime.DateWithoutTime.fromISO(json['endDate'])),
        'overrides': json['overrides'] == null ? undefined : ProjectionOverridesFromJSON(json['overrides']),
        'scope': json['scope'] == null ? undefined : ProjectionScopeFromJSON(json['scope']),
    };
}
function BankProjectionCreateRequestDataAttributesToJSON(json) {
    return BankProjectionCreateRequestDataAttributesToJSONTyped(json);
}
function BankProjectionCreateRequestDataAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'startDate': value['startDate'].toISO(),
        'endDate': value['endDate'].toISO(),
        'overrides': ProjectionOverridesToJSON(value['overrides']),
        'scope': ProjectionScopeToJSON(value['scope']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the EmployeeRelationshipsWithLookupDataInnerMetaLookup interface.
 */
function instanceOfEmployeeRelationshipsWithLookupDataInnerMetaLookup(value) {
    return true;
}
function EmployeeRelationshipsWithLookupDataInnerMetaLookupFromJSON(json) {
    return EmployeeRelationshipsWithLookupDataInnerMetaLookupFromJSONTyped(json);
}
function EmployeeRelationshipsWithLookupDataInnerMetaLookupFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'clientPersonId': json['clientPersonId'] == null ? undefined : json['clientPersonId'],
    };
}
function EmployeeRelationshipsWithLookupDataInnerMetaLookupToJSON(json) {
    return EmployeeRelationshipsWithLookupDataInnerMetaLookupToJSONTyped(json);
}
function EmployeeRelationshipsWithLookupDataInnerMetaLookupToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'clientPersonId': value['clientPersonId'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the EmployeeRelationshipsWithLookupDataInnerMeta interface.
 */
function instanceOfEmployeeRelationshipsWithLookupDataInnerMeta(value) {
    return true;
}
function EmployeeRelationshipsWithLookupDataInnerMetaFromJSON(json) {
    return EmployeeRelationshipsWithLookupDataInnerMetaFromJSONTyped(json);
}
function EmployeeRelationshipsWithLookupDataInnerMetaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'lookup': json['lookup'] == null ? undefined : EmployeeRelationshipsWithLookupDataInnerMetaLookupFromJSON(json['lookup']),
    };
}
function EmployeeRelationshipsWithLookupDataInnerMetaToJSON(json) {
    return EmployeeRelationshipsWithLookupDataInnerMetaToJSONTyped(json);
}
function EmployeeRelationshipsWithLookupDataInnerMetaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'lookup': EmployeeRelationshipsWithLookupDataInnerMetaLookupToJSON(value['lookup']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the EmployeeRelationshipsWithLookupDataInner interface.
 */
function instanceOfEmployeeRelationshipsWithLookupDataInner(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function EmployeeRelationshipsWithLookupDataInnerFromJSON(json) {
    return EmployeeRelationshipsWithLookupDataInnerFromJSONTyped(json);
}
function EmployeeRelationshipsWithLookupDataInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'],
        'meta': json['meta'] == null ? undefined : EmployeeRelationshipsWithLookupDataInnerMetaFromJSON(json['meta']),
    };
}
function EmployeeRelationshipsWithLookupDataInnerToJSON(json) {
    return EmployeeRelationshipsWithLookupDataInnerToJSONTyped(json);
}
function EmployeeRelationshipsWithLookupDataInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'meta': EmployeeRelationshipsWithLookupDataInnerMetaToJSON(value['meta']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the EmployeeRelationshipsWithLookup interface.
 */
function instanceOfEmployeeRelationshipsWithLookup(value) {
    return true;
}
function EmployeeRelationshipsWithLookupFromJSON(json) {
    return EmployeeRelationshipsWithLookupFromJSONTyped(json);
}
function EmployeeRelationshipsWithLookupFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : (json['data'].map(EmployeeRelationshipsWithLookupDataInnerFromJSON)),
    };
}
function EmployeeRelationshipsWithLookupToJSON(json) {
    return EmployeeRelationshipsWithLookupToJSONTyped(json);
}
function EmployeeRelationshipsWithLookupToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': value['data'] == null ? undefined : (value['data'].map(EmployeeRelationshipsWithLookupDataInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BankProjectionRequestRelationships interface.
 */
function instanceOfBankProjectionRequestRelationships(value) {
    return true;
}
function BankProjectionRequestRelationshipsFromJSON(json) {
    return BankProjectionRequestRelationshipsFromJSONTyped(json);
}
function BankProjectionRequestRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'employees': json['employees'] == null ? undefined : EmployeeRelationshipsWithLookupFromJSON(json['employees']),
        'jobs': json['jobs'] == null ? undefined : JobRelationshipsFromJSON(json['jobs']),
    };
}
function BankProjectionRequestRelationshipsToJSON(json) {
    return BankProjectionRequestRelationshipsToJSONTyped(json);
}
function BankProjectionRequestRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'employees': EmployeeRelationshipsWithLookupToJSON(value['employees']),
        'jobs': JobRelationshipsToJSON(value['jobs']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var BankProjectionCreateRequestDataTypeEnum = {
    BankProjection: 'bank-projection'
};
/**
 * Check if a given object implements the BankProjectionCreateRequestData interface.
 */
function instanceOfBankProjectionCreateRequestData(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function BankProjectionCreateRequestDataFromJSON(json) {
    return BankProjectionCreateRequestDataFromJSONTyped(json);
}
function BankProjectionCreateRequestDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'attributes': BankProjectionCreateRequestDataAttributesFromJSON(json['attributes']),
        'relationships': json['relationships'] == null ? undefined : BankProjectionRequestRelationshipsFromJSON(json['relationships']),
    };
}
function BankProjectionCreateRequestDataToJSON(json) {
    return BankProjectionCreateRequestDataToJSONTyped(json);
}
function BankProjectionCreateRequestDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'attributes': BankProjectionCreateRequestDataAttributesToJSON(value['attributes']),
        'relationships': BankProjectionRequestRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BankProjectionCreateRequest interface.
 */
function instanceOfBankProjectionCreateRequest(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function BankProjectionCreateRequestFromJSON(json) {
    return BankProjectionCreateRequestFromJSONTyped(json);
}
function BankProjectionCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': BankProjectionCreateRequestDataFromJSON(json['data']),
    };
}
function BankProjectionCreateRequestToJSON(json) {
    return BankProjectionCreateRequestToJSONTyped(json);
}
function BankProjectionCreateRequestToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': BankProjectionCreateRequestDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the BidResourceData interface.
 */
function instanceOfBidResourceData(value) {
    return true;
}
function BidResourceDataFromJSON(json) {
    return BidResourceDataFromJSONTyped(json);
}
function BidResourceDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}
function BidResourceDataToJSON(json) {
    return BidResourceDataToJSONTyped(json);
}
function BidResourceDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BidRelationshipsBidSelections interface.
 */
function instanceOfBidRelationshipsBidSelections(value) {
    return true;
}
function BidRelationshipsBidSelectionsFromJSON(json) {
    return BidRelationshipsBidSelectionsFromJSONTyped(json);
}
function BidRelationshipsBidSelectionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : (json['data'].map(BidResourceDataFromJSON)),
    };
}
function BidRelationshipsBidSelectionsToJSON(json) {
    return BidRelationshipsBidSelectionsToJSONTyped(json);
}
function BidRelationshipsBidSelectionsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': value['data'] == null ? undefined : (value['data'].map(BidResourceDataToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BidRelationshipsEmployee interface.
 */
function instanceOfBidRelationshipsEmployee(value) {
    return true;
}
function BidRelationshipsEmployeeFromJSON(json) {
    return BidRelationshipsEmployeeFromJSONTyped(json);
}
function BidRelationshipsEmployeeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : BidResourceDataFromJSON(json['data']),
    };
}
function BidRelationshipsEmployeeToJSON(json) {
    return BidRelationshipsEmployeeToJSONTyped(json);
}
function BidRelationshipsEmployeeToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': BidResourceDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BidRelationshipsBidPackage interface.
 */
function instanceOfBidRelationshipsBidPackage(value) {
    return true;
}
function BidRelationshipsBidPackageFromJSON(json) {
    return BidRelationshipsBidPackageFromJSONTyped(json);
}
function BidRelationshipsBidPackageFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : BidResourceDataFromJSON(json['data']),
    };
}
function BidRelationshipsBidPackageToJSON(json) {
    return BidRelationshipsBidPackageToJSONTyped(json);
}
function BidRelationshipsBidPackageToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': BidResourceDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BidRelationships interface.
 */
function instanceOfBidRelationships(value) {
    return true;
}
function BidRelationshipsFromJSON(json) {
    return BidRelationshipsFromJSONTyped(json);
}
function BidRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'bidPackage': json['bidPackage'] == null ? undefined : BidRelationshipsBidPackageFromJSON(json['bidPackage']),
        'employee': json['employee'] == null ? undefined : BidRelationshipsEmployeeFromJSON(json['employee']),
        'bidSelections': json['bidSelections'] == null ? undefined : BidRelationshipsBidSelectionsFromJSON(json['bidSelections']),
    };
}
function BidRelationshipsToJSON(json) {
    return BidRelationshipsToJSONTyped(json);
}
function BidRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'bidPackage': BidRelationshipsBidPackageToJSON(value['bidPackage']),
        'employee': BidRelationshipsEmployeeToJSON(value['employee']),
        'bidSelections': BidRelationshipsBidSelectionsToJSON(value['bidSelections']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the BidAttributes interface.
 */
function instanceOfBidAttributes(value) {
    return true;
}
function BidAttributesFromJSON(json) {
    return BidAttributesFromJSONTyped(json);
}
function BidAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': json['status'] == null ? undefined : json['status'],
    };
}
function BidAttributesToJSON(json) {
    return BidAttributesToJSONTyped(json);
}
function BidAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'status': value['status'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BidMeta interface.
 */
function instanceOfBidMeta(value) {
    return true;
}
function BidMetaFromJSON(json) {
    return BidMetaFromJSONTyped(json);
}
function BidMetaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
        'createdAt': json['createdAt'] == null ? undefined : (luxon.DateTime.fromISO(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (luxon.DateTime.fromISO(json['updatedAt'])),
    };
}
function BidMetaToJSON(json) {
    return BidMetaToJSONTyped(json);
}
function BidMetaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'createdBy': value['createdBy'],
        'updatedBy': value['updatedBy'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISO(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISO(),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the Bid interface.
 */
function instanceOfBid(value) {
    return true;
}
function BidFromJSON(json) {
    return BidFromJSONTyped(json);
}
function BidFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'attributes': json['attributes'] == null ? undefined : BidAttributesFromJSON(json['attributes']),
        'relationships': json['relationships'] == null ? undefined : BidRelationshipsFromJSON(json['relationships']),
        'meta': json['meta'] == null ? undefined : BidMetaFromJSON(json['meta']),
    };
}
function BidToJSON(json) {
    return BidToJSONTyped(json);
}
function BidToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': BidAttributesToJSON(value['attributes']),
        'relationships': BidRelationshipsToJSON(value['relationships']),
        'meta': BidMetaToJSON(value['meta']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BidBlockAttributes interface.
 */
function instanceOfBidBlockAttributes(value) {
    return true;
}
function BidBlockAttributesFromJSON(json) {
    return BidBlockAttributesFromJSONTyped(json);
}
function BidBlockAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'bidBlockStartDate': json['bidBlockStartDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['bidBlockStartDate'])),
        'bidBlockEndDate': json['bidBlockEndDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['bidBlockEndDate'])),
        'actualLimit': json['actualLimit'] == null ? undefined : json['actualLimit'],
        'currentLimit': json['currentLimit'] == null ? undefined : json['currentLimit'],
    };
}
function BidBlockAttributesToJSON(json) {
    return BidBlockAttributesToJSONTyped(json);
}
function BidBlockAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'bidBlockStartDate': value['bidBlockStartDate'] == null ? value['bidBlockStartDate'] : value['bidBlockStartDate'].toISO(),
        'bidBlockEndDate': value['bidBlockEndDate'] == null ? value['bidBlockEndDate'] : value['bidBlockEndDate'].toISO(),
        'actualLimit': value['actualLimit'],
        'currentLimit': value['currentLimit'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BidBlock interface.
 */
function instanceOfBidBlock(value) {
    return true;
}
function BidBlockFromJSON(json) {
    return BidBlockFromJSONTyped(json);
}
function BidBlockFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'attributes': json['attributes'] == null ? undefined : BidBlockAttributesFromJSON(json['attributes']),
    };
}
function BidBlockToJSON(json) {
    return BidBlockToJSONTyped(json);
}
function BidBlockToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': BidBlockAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BidBlocksResponseSchema interface.
 */
function instanceOfBidBlocksResponseSchema(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function BidBlocksResponseSchemaFromJSON(json) {
    return BidBlocksResponseSchemaFromJSONTyped(json);
}
function BidBlocksResponseSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(BidBlockFromJSON)),
    };
}
function BidBlocksResponseSchemaToJSON(json) {
    return BidBlocksResponseSchemaToJSONTyped(json);
}
function BidBlocksResponseSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(BidBlockToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BidOptionsConfiguration interface.
 */
function instanceOfBidOptionsConfiguration(value) {
    if (!('blockDuration' in value) || value['blockDuration'] === undefined)
        return false;
    if (!('selectionsPerParticipant' in value) || value['selectionsPerParticipant'] === undefined)
        return false;
    return true;
}
function BidOptionsConfigurationFromJSON(json) {
    return BidOptionsConfigurationFromJSONTyped(json);
}
function BidOptionsConfigurationFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'blockDuration': json['blockDuration'],
        'weekStartsOn': json['weekStartsOn'] == null ? undefined : DayOfWeekFromJSON(json['weekStartsOn']),
        'selectionsPerParticipant': json['selectionsPerParticipant'],
    };
}
function BidOptionsConfigurationToJSON(json) {
    return BidOptionsConfigurationToJSONTyped(json);
}
function BidOptionsConfigurationToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'blockDuration': value['blockDuration'],
        'weekStartsOn': DayOfWeekToJSON(value['weekStartsOn']),
        'selectionsPerParticipant': value['selectionsPerParticipant'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the BiddingGroupsDataInner interface.
 */
function instanceOfBiddingGroupsDataInner(value) {
    return true;
}
function BiddingGroupsDataInnerFromJSON(json) {
    return BiddingGroupsDataInnerFromJSONTyped(json);
}
function BiddingGroupsDataInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}
function BiddingGroupsDataInnerToJSON(json) {
    return BiddingGroupsDataInnerToJSONTyped(json);
}
function BiddingGroupsDataInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BiddingGroups interface.
 */
function instanceOfBiddingGroups(value) {
    return true;
}
function BiddingGroupsFromJSON(json) {
    return BiddingGroupsFromJSONTyped(json);
}
function BiddingGroupsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : (json['data'].map(BiddingGroupsDataInnerFromJSON)),
    };
}
function BiddingGroupsToJSON(json) {
    return BiddingGroupsToJSONTyped(json);
}
function BiddingGroupsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': value['data'] == null ? undefined : (value['data'].map(BiddingGroupsDataInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BidPackageRelationships interface.
 */
function instanceOfBidPackageRelationships(value) {
    return true;
}
function BidPackageRelationshipsFromJSON(json) {
    return BidPackageRelationshipsFromJSONTyped(json);
}
function BidPackageRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'biddingGroups': json['biddingGroups'] == null ? undefined : BiddingGroupsFromJSON(json['biddingGroups']),
    };
}
function BidPackageRelationshipsToJSON(json) {
    return BidPackageRelationshipsToJSONTyped(json);
}
function BidPackageRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'biddingGroups': BiddingGroupsToJSON(value['biddingGroups']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RankingMethods interface.
 */
function instanceOfRankingMethods(value) {
    return true;
}
function RankingMethodsFromJSON(json) {
    return RankingMethodsFromJSONTyped(json);
}
function RankingMethodsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fieldName': json['fieldName'] == null ? undefined : json['fieldName'],
        'sortByAscending': json['sortByAscending'] == null ? undefined : json['sortByAscending'],
    };
}
function RankingMethodsToJSON(json) {
    return RankingMethodsToJSONTyped(json);
}
function RankingMethodsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'fieldName': value['fieldName'],
        'sortByAscending': value['sortByAscending'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ModuleError interface.
 */
function instanceOfModuleError(value) {
    return true;
}
function ModuleErrorFromJSON(json) {
    return ModuleErrorFromJSONTyped(json);
}
function ModuleErrorFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'detail': json['detail'] == null ? undefined : json['detail'],
        'parameter': json['parameter'] == null ? undefined : json['parameter'],
    };
}
function ModuleErrorToJSON(json) {
    return ModuleErrorToJSONTyped(json);
}
function ModuleErrorToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'detail': value['detail'],
        'parameter': value['parameter'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the Module interface.
 */
function instanceOfModule(value) {
    return true;
}
function ModuleFromJSON(json) {
    return ModuleFromJSONTyped(json);
}
function ModuleFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'] == null ? undefined : json['name'],
        'errors': json['errors'] == null ? undefined : (json['errors'].map(ModuleErrorFromJSON)),
        'status': json['status'] == null ? undefined : json['status'],
    };
}
function ModuleToJSON(json) {
    return ModuleToJSONTyped(json);
}
function ModuleToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'errors': value['errors'] == null ? undefined : (value['errors'].map(ModuleErrorToJSON)),
        'status': value['status'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BidPackageAttributes interface.
 */
function instanceOfBidPackageAttributes(value) {
    return true;
}
function BidPackageAttributesFromJSON(json) {
    return BidPackageAttributesFromJSONTyped(json);
}
function BidPackageAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'calendarPeriodStartDate': json['calendarPeriodStartDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['calendarPeriodStartDate'])),
        'calendarPeriodEndDate': json['calendarPeriodEndDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['calendarPeriodEndDate'])),
        'startSubmissionAfterPublish': json['startSubmissionAfterPublish'] == null ? undefined : json['startSubmissionAfterPublish'],
        'submissionPeriodStartDateTime': json['submissionPeriodStartDateTime'] == null ? undefined : (luxon.DateTime.fromISO(json['submissionPeriodStartDateTime'])),
        'submissionPeriodEndDateTime': json['submissionPeriodEndDateTime'] == null ? undefined : (luxon.DateTime.fromISO(json['submissionPeriodEndDateTime'])),
        'submissionPeriodTimeZone': json['submissionPeriodTimeZone'] == null ? undefined : json['submissionPeriodTimeZone'],
        'allowPreview': json['allowPreview'] == null ? undefined : json['allowPreview'],
        'previewDate': json['previewDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['previewDate'])),
        'absenceLimits': json['absenceLimits'] == null ? undefined : AbsenceLimitsFromJSON(json['absenceLimits']),
        'bidOptionsConfigurations': json['bidOptionsConfigurations'] == null ? undefined : BidOptionsConfigurationFromJSON(json['bidOptionsConfigurations']),
        'rankingMethods': json['rankingMethods'] == null ? undefined : RankingMethodsFromJSON(json['rankingMethods']),
        'tieBreakers': json['tieBreakers'] == null ? undefined : (json['tieBreakers'].map(RankingMethodsFromJSON)),
        'status': json['status'] == null ? undefined : json['status'],
        'module': json['module'] == null ? undefined : (json['module'].map(ModuleFromJSON)),
    };
}
function BidPackageAttributesToJSON(json) {
    return BidPackageAttributesToJSONTyped(json);
}
function BidPackageAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'title': value['title'],
        'description': value['description'],
        'calendarPeriodStartDate': value['calendarPeriodStartDate'] == null ? value['calendarPeriodStartDate'] : value['calendarPeriodStartDate'].toISO(),
        'calendarPeriodEndDate': value['calendarPeriodEndDate'] == null ? value['calendarPeriodEndDate'] : value['calendarPeriodEndDate'].toISO(),
        'startSubmissionAfterPublish': value['startSubmissionAfterPublish'],
        'submissionPeriodStartDateTime': value['submissionPeriodStartDateTime'] == null ? value['submissionPeriodStartDateTime'] : value['submissionPeriodStartDateTime'].toISO(),
        'submissionPeriodEndDateTime': value['submissionPeriodEndDateTime'] == null ? value['submissionPeriodEndDateTime'] : value['submissionPeriodEndDateTime'].toISO(),
        'submissionPeriodTimeZone': value['submissionPeriodTimeZone'],
        'allowPreview': value['allowPreview'],
        'previewDate': value['previewDate'] == null ? value['previewDate'] : value['previewDate'].toISO(),
        'absenceLimits': AbsenceLimitsToJSON(value['absenceLimits']),
        'bidOptionsConfigurations': BidOptionsConfigurationToJSON(value['bidOptionsConfigurations']),
        'rankingMethods': RankingMethodsToJSON(value['rankingMethods']),
        'tieBreakers': value['tieBreakers'] == null ? undefined : (value['tieBreakers'].map(RankingMethodsToJSON)),
        'status': value['status'],
        'module': value['module'] == null ? undefined : (value['module'].map(ModuleToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BidPackageMeta interface.
 */
function instanceOfBidPackageMeta(value) {
    return true;
}
function BidPackageMetaFromJSON(json) {
    return BidPackageMetaFromJSONTyped(json);
}
function BidPackageMetaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'absenceLimitMeta': json['absenceLimitMeta'] == null ? undefined : AbsenceLimitMetaFromJSON(json['absenceLimitMeta']),
    };
}
function BidPackageMetaToJSON(json) {
    return BidPackageMetaToJSONTyped(json);
}
function BidPackageMetaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'absenceLimitMeta': AbsenceLimitMetaToJSON(value['absenceLimitMeta']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BidPackage interface.
 */
function instanceOfBidPackage(value) {
    return true;
}
function BidPackageFromJSON(json) {
    return BidPackageFromJSONTyped(json);
}
function BidPackageFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'attributes': json['attributes'] == null ? undefined : BidPackageAttributesFromJSON(json['attributes']),
        'relationships': json['relationships'] == null ? undefined : BidPackageRelationshipsFromJSON(json['relationships']),
        'meta': json['meta'] == null ? undefined : BidPackageMetaFromJSON(json['meta']),
    };
}
function BidPackageToJSON(json) {
    return BidPackageToJSONTyped(json);
}
function BidPackageToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': BidPackageAttributesToJSON(value['attributes']),
        'relationships': BidPackageRelationshipsToJSON(value['relationships']),
        'meta': BidPackageMetaToJSON(value['meta']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BidPackageResponseSchema interface.
 */
function instanceOfBidPackageResponseSchema(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function BidPackageResponseSchemaFromJSON(json) {
    return BidPackageResponseSchemaFromJSONTyped(json);
}
function BidPackageResponseSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': BidPackageFromJSON(json['data']),
    };
}
function BidPackageResponseSchemaToJSON(json) {
    return BidPackageResponseSchemaToJSONTyped(json);
}
function BidPackageResponseSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': BidPackageToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BidResponseSchema interface.
 */
function instanceOfBidResponseSchema(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function BidResponseSchemaFromJSON(json) {
    return BidResponseSchemaFromJSONTyped(json);
}
function BidResponseSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': BidFromJSON(json['data']),
    };
}
function BidResponseSchemaToJSON(json) {
    return BidResponseSchemaToJSONTyped(json);
}
function BidResponseSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': BidToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the BidsResponseSchema interface.
 */
function instanceOfBidsResponseSchema(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function BidsResponseSchemaFromJSON(json) {
    return BidsResponseSchemaFromJSONTyped(json);
}
function BidsResponseSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(BidFromJSON)),
    };
}
function BidsResponseSchemaToJSON(json) {
    return BidsResponseSchemaToJSONTyped(json);
}
function BidsResponseSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(BidToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function FieldValueValueFromJSON(json) {
    return FieldValueValueFromJSONTyped(json);
}
function FieldValueValueFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (typeof json === 'number') {
        return json;
    }
    if (typeof json === 'string') {
        return json;
    }
    return {};
}
function FieldValueValueToJSON(json) {
    return FieldValueValueToJSONTyped(json);
}
function FieldValueValueToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    if (typeof value === 'number') {
        return value;
    }
    if (typeof value === 'string') {
        return value;
    }
    return {};
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var FieldValueDatatypeEnum = {
    String: 'string',
    Number: 'number',
    Boolean: 'boolean',
    Date: 'date',
    DateTime: 'date-time',
    Policy: 'policy'
};
/**
 * Check if a given object implements the FieldValue interface.
 */
function instanceOfFieldValue(value) {
    if (!('datatype' in value) || value['datatype'] === undefined)
        return false;
    if (!('value' in value) || value['value'] === undefined)
        return false;
    return true;
}
function FieldValueFromJSON(json) {
    return FieldValueFromJSONTyped(json);
}
function FieldValueFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'datatype': json['datatype'],
        'value': FieldValueValueFromJSON(json['value']),
    };
}
function FieldValueToJSON(json) {
    return FieldValueToJSONTyped(json);
}
function FieldValueToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'datatype': value['datatype'],
        'value': FieldValueValueToJSON(value['value']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the ChildGroupPolicy interface.
 */
function instanceOfChildGroupPolicy(value) {
    if (!('tableName' in value) || value['tableName'] === undefined)
        return false;
    if (!('fields' in value) || value['fields'] === undefined)
        return false;
    return true;
}
function ChildGroupPolicyFromJSON(json) {
    return ChildGroupPolicyFromJSONTyped(json);
}
function ChildGroupPolicyFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'tableName': json['tableName'],
        'fields': (mapValues(json['fields'], FieldValueFromJSON)),
    };
}
function ChildGroupPolicyToJSON(json) {
    return ChildGroupPolicyToJSONTyped(json);
}
function ChildGroupPolicyToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'tableName': value['tableName'],
        'fields': (mapValues(value['fields'], FieldValueToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ClockPunchMetadataAttributes interface.
 */
function instanceOfClockPunchMetadataAttributes(value) {
    if (!('swipePayCode' in value) || value['swipePayCode'] === undefined)
        return false;
    if (!('mealBreakPayCode' in value) || value['mealBreakPayCode'] === undefined)
        return false;
    if (!('jobTimeZone' in value) || value['jobTimeZone'] === undefined)
        return false;
    return true;
}
function ClockPunchMetadataAttributesFromJSON(json) {
    return ClockPunchMetadataAttributesFromJSONTyped(json);
}
function ClockPunchMetadataAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'swipePayCode': json['swipePayCode'],
        'mealBreakPayCode': json['mealBreakPayCode'],
        'jobTimeZone': json['jobTimeZone'],
    };
}
function ClockPunchMetadataAttributesToJSON(json) {
    return ClockPunchMetadataAttributesToJSONTyped(json);
}
function ClockPunchMetadataAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'swipePayCode': value['swipePayCode'],
        'mealBreakPayCode': value['mealBreakPayCode'],
        'jobTimeZone': value['jobTimeZone'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the Geolocation interface.
 */
function instanceOfGeolocation(value) {
    return true;
}
function GeolocationFromJSON(json) {
    return GeolocationFromJSONTyped(json);
}
function GeolocationFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'accuracy': json['accuracy'] == null ? undefined : json['accuracy'],
    };
}
function GeolocationToJSON(json) {
    return GeolocationToJSONTyped(json);
}
function GeolocationToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'accuracy': value['accuracy'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var SwipeAttributesSwipeDataEventTypeEnum = {
    SwipeIn: 'SWIPE_IN',
    SwipeOut: 'SWIPE_OUT',
    TransferPay: 'TRANSFER_PAY',
    SwipeAuto: 'SWIPE_AUTO',
    ConditionalTransfer: 'CONDITIONAL_TRANSFER',
    ElapsedTotal: 'ELAPSED_TOTAL'
};
/**
 * Check if a given object implements the SwipeAttributesSwipeData interface.
 */
function instanceOfSwipeAttributesSwipeData(value) {
    if (!('timestamp' in value) || value['timestamp'] === undefined)
        return false;
    if (!('eventType' in value) || value['eventType'] === undefined)
        return false;
    return true;
}
function SwipeAttributesSwipeDataFromJSON(json) {
    return SwipeAttributesSwipeDataFromJSONTyped(json);
}
function SwipeAttributesSwipeDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'timestamp': (luxon.DateTime.fromISO(json['timestamp'])),
        'payCode': json['payCode'] == null ? undefined : json['payCode'],
        'clockId': json['clockId'] == null ? undefined : json['clockId'],
        'swipeSource': json['swipeSource'] == null ? undefined : json['swipeSource'],
        'eventType': json['eventType'],
        'geolocation': json['geolocation'] == null ? undefined : GeolocationFromJSON(json['geolocation']),
        'ldData': json['ldData'] == null ? undefined : (mapValues(json['ldData'], DiscriminatedFieldValueFromJSON)),
    };
}
function SwipeAttributesSwipeDataToJSON(json) {
    return SwipeAttributesSwipeDataToJSONTyped(json);
}
function SwipeAttributesSwipeDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'timestamp': value['timestamp'].toISO(),
        'payCode': value['payCode'],
        'clockId': value['clockId'],
        'swipeSource': value['swipeSource'],
        'eventType': value['eventType'],
        'geolocation': GeolocationToJSON(value['geolocation']),
        'ldData': value['ldData'] == null ? undefined : (mapValues(value['ldData'], DiscriminatedFieldValueToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the SwipeAttributes interface.
 */
function instanceOfSwipeAttributes(value) {
    if (!('swipeData' in value) || value['swipeData'] === undefined)
        return false;
    return true;
}
function SwipeAttributesFromJSON(json) {
    return SwipeAttributesFromJSONTyped(json);
}
function SwipeAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'swipeData': SwipeAttributesSwipeDataFromJSON(json['swipeData']),
    };
}
function SwipeAttributesToJSON(json) {
    return SwipeAttributesToJSONTyped(json);
}
function SwipeAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'swipeData': SwipeAttributesSwipeDataToJSON(value['swipeData']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the Swipe interface.
 */
function instanceOfSwipe(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function SwipeFromJSON(json) {
    return SwipeFromJSONTyped(json);
}
function SwipeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': SwipeAttributesFromJSON(json['attributes']),
    };
}
function SwipeToJSON(json) {
    return SwipeToJSONTyped(json);
}
function SwipeToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': SwipeAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the ClockPunchMetadataRelationshipsLastPunch interface.
 */
function instanceOfClockPunchMetadataRelationshipsLastPunch(value) {
    return true;
}
function ClockPunchMetadataRelationshipsLastPunchFromJSON(json) {
    return ClockPunchMetadataRelationshipsLastPunchFromJSONTyped(json);
}
function ClockPunchMetadataRelationshipsLastPunchFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : SwipeFromJSON(json['data']),
    };
}
function ClockPunchMetadataRelationshipsLastPunchToJSON(json) {
    return ClockPunchMetadataRelationshipsLastPunchToJSONTyped(json);
}
function ClockPunchMetadataRelationshipsLastPunchToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': SwipeToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the ClockPunchMetadataRelationships interface.
 */
function instanceOfClockPunchMetadataRelationships(value) {
    return true;
}
function ClockPunchMetadataRelationshipsFromJSON(json) {
    return ClockPunchMetadataRelationshipsFromJSONTyped(json);
}
function ClockPunchMetadataRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'lastPunch': json['lastPunch'] == null ? undefined : ClockPunchMetadataRelationshipsLastPunchFromJSON(json['lastPunch']),
    };
}
function ClockPunchMetadataRelationshipsToJSON(json) {
    return ClockPunchMetadataRelationshipsToJSONTyped(json);
}
function ClockPunchMetadataRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'lastPunch': ClockPunchMetadataRelationshipsLastPunchToJSON(value['lastPunch']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the ClockPunchMetadata interface.
 */
function instanceOfClockPunchMetadata(value) {
    return true;
}
function ClockPunchMetadataFromJSON(json) {
    return ClockPunchMetadataFromJSONTyped(json);
}
function ClockPunchMetadataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'] == null ? undefined : json['type'],
        'attributes': json['attributes'] == null ? undefined : ClockPunchMetadataAttributesFromJSON(json['attributes']),
        'relationships': json['relationships'] == null ? undefined : ClockPunchMetadataRelationshipsFromJSON(json['relationships']),
    };
}
function ClockPunchMetadataToJSON(json) {
    return ClockPunchMetadataToJSONTyped(json);
}
function ClockPunchMetadataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'attributes': ClockPunchMetadataAttributesToJSON(value['attributes']),
        'relationships': ClockPunchMetadataRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the ClockPunchMetadataResponseSchema interface.
 */
function instanceOfClockPunchMetadataResponseSchema(value) {
    return true;
}
function ClockPunchMetadataResponseSchemaFromJSON(json) {
    return ClockPunchMetadataResponseSchemaFromJSONTyped(json);
}
function ClockPunchMetadataResponseSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : ClockPunchMetadataFromJSON(json['data']),
        'included': json['included'] == null ? undefined : (json['included'].map(SwipeFromJSON)),
    };
}
function ClockPunchMetadataResponseSchemaToJSON(json) {
    return ClockPunchMetadataResponseSchemaToJSONTyped(json);
}
function ClockPunchMetadataResponseSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': ClockPunchMetadataToJSON(value['data']),
        'included': value['included'] == null ? undefined : (value['included'].map(SwipeToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the CreateBidRequestSchemaData interface.
 */
function instanceOfCreateBidRequestSchemaData(value) {
    return true;
}
function CreateBidRequestSchemaDataFromJSON(json) {
    return CreateBidRequestSchemaDataFromJSONTyped(json);
}
function CreateBidRequestSchemaDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'] == null ? undefined : json['type'],
        'attributes': json['attributes'] == null ? undefined : BidAttributesFromJSON(json['attributes']),
        'relationships': json['relationships'] == null ? undefined : BidRelationshipsFromJSON(json['relationships']),
    };
}
function CreateBidRequestSchemaDataToJSON(json) {
    return CreateBidRequestSchemaDataToJSONTyped(json);
}
function CreateBidRequestSchemaDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'attributes': BidAttributesToJSON(value['attributes']),
        'relationships': BidRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the CreateBidRequestSchema interface.
 */
function instanceOfCreateBidRequestSchema(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function CreateBidRequestSchemaFromJSON(json) {
    return CreateBidRequestSchemaFromJSONTyped(json);
}
function CreateBidRequestSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': CreateBidRequestSchemaDataFromJSON(json['data']),
    };
}
function CreateBidRequestSchemaToJSON(json) {
    return CreateBidRequestSchemaToJSONTyped(json);
}
function CreateBidRequestSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': CreateBidRequestSchemaDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the CreateBidpackageRequestSchemaData interface.
 */
function instanceOfCreateBidpackageRequestSchemaData(value) {
    return true;
}
function CreateBidpackageRequestSchemaDataFromJSON(json) {
    return CreateBidpackageRequestSchemaDataFromJSONTyped(json);
}
function CreateBidpackageRequestSchemaDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'] == null ? undefined : json['type'],
        'attributes': json['attributes'] == null ? undefined : BidPackageAttributesFromJSON(json['attributes']),
        'relationships': json['relationships'] == null ? undefined : BidPackageRelationshipsFromJSON(json['relationships']),
        'meta': json['meta'] == null ? undefined : BidPackageMetaFromJSON(json['meta']),
    };
}
function CreateBidpackageRequestSchemaDataToJSON(json) {
    return CreateBidpackageRequestSchemaDataToJSONTyped(json);
}
function CreateBidpackageRequestSchemaDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'attributes': BidPackageAttributesToJSON(value['attributes']),
        'relationships': BidPackageRelationshipsToJSON(value['relationships']),
        'meta': BidPackageMetaToJSON(value['meta']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the CreateBidpackageRequestSchema interface.
 */
function instanceOfCreateBidpackageRequestSchema(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function CreateBidpackageRequestSchemaFromJSON(json) {
    return CreateBidpackageRequestSchemaFromJSONTyped(json);
}
function CreateBidpackageRequestSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': CreateBidpackageRequestSchemaDataFromJSON(json['data']),
    };
}
function CreateBidpackageRequestSchemaToJSON(json) {
    return CreateBidpackageRequestSchemaToJSONTyped(json);
}
function CreateBidpackageRequestSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': CreateBidpackageRequestSchemaDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
var PayRuleKeyValueRelationshipDataTypeEnum = {
    Constraint: 'constraint',
    Comparator: 'comparator',
    Period: 'period'
};
/**
 * Check if a given object implements the PayRuleKeyValueRelationshipData interface.
 */
function instanceOfPayRuleKeyValueRelationshipData(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function PayRuleKeyValueRelationshipDataFromJSON(json) {
    return PayRuleKeyValueRelationshipDataFromJSONTyped(json);
}
function PayRuleKeyValueRelationshipDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
    };
}
function PayRuleKeyValueRelationshipDataToJSON(json) {
    return PayRuleKeyValueRelationshipDataToJSONTyped(json);
}
function PayRuleKeyValueRelationshipDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the PayRuleKeyValueRelationship interface.
 */
function instanceOfPayRuleKeyValueRelationship(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function PayRuleKeyValueRelationshipFromJSON(json) {
    return PayRuleKeyValueRelationshipFromJSONTyped(json);
}
function PayRuleKeyValueRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': PayRuleKeyValueRelationshipDataFromJSON(json['data']),
    };
}
function PayRuleKeyValueRelationshipToJSON(json) {
    return PayRuleKeyValueRelationshipToJSONTyped(json);
}
function PayRuleKeyValueRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': PayRuleKeyValueRelationshipDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the CreatePayRuleRequestSchemaDataRelationships interface.
 */
function instanceOfCreatePayRuleRequestSchemaDataRelationships(value) {
    if (!('constraint' in value) || value['constraint'] === undefined)
        return false;
    if (!('comparator' in value) || value['comparator'] === undefined)
        return false;
    if (!('period' in value) || value['period'] === undefined)
        return false;
    return true;
}
function CreatePayRuleRequestSchemaDataRelationshipsFromJSON(json) {
    return CreatePayRuleRequestSchemaDataRelationshipsFromJSONTyped(json);
}
function CreatePayRuleRequestSchemaDataRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'constraint': PayRuleKeyValueRelationshipFromJSON(json['constraint']),
        'comparator': PayRuleKeyValueRelationshipFromJSON(json['comparator']),
        'period': PayRuleKeyValueRelationshipFromJSON(json['period']),
    };
}
function CreatePayRuleRequestSchemaDataRelationshipsToJSON(json) {
    return CreatePayRuleRequestSchemaDataRelationshipsToJSONTyped(json);
}
function CreatePayRuleRequestSchemaDataRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'constraint': PayRuleKeyValueRelationshipToJSON(value['constraint']),
        'comparator': PayRuleKeyValueRelationshipToJSON(value['comparator']),
        'period': PayRuleKeyValueRelationshipToJSON(value['period']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CreatePayRuleRequestSchemaBody interface.
 */
function instanceOfCreatePayRuleRequestSchemaBody(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('payCode' in value) || value['payCode'] === undefined)
        return false;
    if (!('priority' in value) || value['priority'] === undefined)
        return false;
    return true;
}
function CreatePayRuleRequestSchemaBodyFromJSON(json) {
    return CreatePayRuleRequestSchemaBodyFromJSONTyped(json);
}
function CreatePayRuleRequestSchemaBodyFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'payCode': json['payCode'],
        'priority': json['priority'],
    };
}
function CreatePayRuleRequestSchemaBodyToJSON(json) {
    return CreatePayRuleRequestSchemaBodyToJSONTyped(json);
}
function CreatePayRuleRequestSchemaBodyToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'payCode': value['payCode'],
        'priority': value['priority'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var CreatePayRuleRequestSchemaDataTypeEnum = {
    PayRule: 'payRule'
};
/**
 * Check if a given object implements the CreatePayRuleRequestSchemaData interface.
 */
function instanceOfCreatePayRuleRequestSchemaData(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    if (!('relationships' in value) || value['relationships'] === undefined)
        return false;
    return true;
}
function CreatePayRuleRequestSchemaDataFromJSON(json) {
    return CreatePayRuleRequestSchemaDataFromJSONTyped(json);
}
function CreatePayRuleRequestSchemaDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'attributes': CreatePayRuleRequestSchemaBodyFromJSON(json['attributes']),
        'relationships': CreatePayRuleRequestSchemaDataRelationshipsFromJSON(json['relationships']),
    };
}
function CreatePayRuleRequestSchemaDataToJSON(json) {
    return CreatePayRuleRequestSchemaDataToJSONTyped(json);
}
function CreatePayRuleRequestSchemaDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'attributes': CreatePayRuleRequestSchemaBodyToJSON(value['attributes']),
        'relationships': CreatePayRuleRequestSchemaDataRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the CreatePayRuleRequestSchema interface.
 */
function instanceOfCreatePayRuleRequestSchema(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function CreatePayRuleRequestSchemaFromJSON(json) {
    return CreatePayRuleRequestSchemaFromJSONTyped(json);
}
function CreatePayRuleRequestSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': CreatePayRuleRequestSchemaDataFromJSON(json['data']),
    };
}
function CreatePayRuleRequestSchemaToJSON(json) {
    return CreatePayRuleRequestSchemaToJSONTyped(json);
}
function CreatePayRuleRequestSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': CreatePayRuleRequestSchemaDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RoleRelationshipDataMetaLookup interface.
 */
function instanceOfRoleRelationshipDataMetaLookup(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
function RoleRelationshipDataMetaLookupFromJSON(json) {
    return RoleRelationshipDataMetaLookupFromJSONTyped(json);
}
function RoleRelationshipDataMetaLookupFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
    };
}
function RoleRelationshipDataMetaLookupToJSON(json) {
    return RoleRelationshipDataMetaLookupToJSONTyped(json);
}
function RoleRelationshipDataMetaLookupToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the RoleRelationshipDataMeta interface.
 */
function instanceOfRoleRelationshipDataMeta(value) {
    if (!('lookup' in value) || value['lookup'] === undefined)
        return false;
    return true;
}
function RoleRelationshipDataMetaFromJSON(json) {
    return RoleRelationshipDataMetaFromJSONTyped(json);
}
function RoleRelationshipDataMetaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'lookup': RoleRelationshipDataMetaLookupFromJSON(json['lookup']),
    };
}
function RoleRelationshipDataMetaToJSON(json) {
    return RoleRelationshipDataMetaToJSONTyped(json);
}
function RoleRelationshipDataMetaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'lookup': RoleRelationshipDataMetaLookupToJSON(value['lookup']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var RoleRelationshipDataTypeEnum = {
    Role: 'role'
};
/**
 * Check if a given object implements the RoleRelationshipData interface.
 */
function instanceOfRoleRelationshipData(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function RoleRelationshipDataFromJSON(json) {
    return RoleRelationshipDataFromJSONTyped(json);
}
function RoleRelationshipDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'],
        'meta': json['meta'] == null ? undefined : RoleRelationshipDataMetaFromJSON(json['meta']),
    };
}
function RoleRelationshipDataToJSON(json) {
    return RoleRelationshipDataToJSONTyped(json);
}
function RoleRelationshipDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'meta': RoleRelationshipDataMetaToJSON(value['meta']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the RoleRelationship interface.
 */
function instanceOfRoleRelationship(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function RoleRelationshipFromJSON(json) {
    return RoleRelationshipFromJSONTyped(json);
}
function RoleRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': RoleRelationshipDataFromJSON(json['data']),
    };
}
function RoleRelationshipToJSON(json) {
    return RoleRelationshipToJSONTyped(json);
}
function RoleRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': RoleRelationshipDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ReasonCodeRelationshipDataMetaLookup interface.
 */
function instanceOfReasonCodeRelationshipDataMetaLookup(value) {
    return true;
}
function ReasonCodeRelationshipDataMetaLookupFromJSON(json) {
    return ReasonCodeRelationshipDataMetaLookupFromJSONTyped(json);
}
function ReasonCodeRelationshipDataMetaLookupFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'] == null ? undefined : json['code'],
    };
}
function ReasonCodeRelationshipDataMetaLookupToJSON(json) {
    return ReasonCodeRelationshipDataMetaLookupToJSONTyped(json);
}
function ReasonCodeRelationshipDataMetaLookupToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the ReasonCodeRelationshipDataMeta interface.
 */
function instanceOfReasonCodeRelationshipDataMeta(value) {
    if (!('lookup' in value) || value['lookup'] === undefined)
        return false;
    return true;
}
function ReasonCodeRelationshipDataMetaFromJSON(json) {
    return ReasonCodeRelationshipDataMetaFromJSONTyped(json);
}
function ReasonCodeRelationshipDataMetaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'lookup': ReasonCodeRelationshipDataMetaLookupFromJSON(json['lookup']),
    };
}
function ReasonCodeRelationshipDataMetaToJSON(json) {
    return ReasonCodeRelationshipDataMetaToJSONTyped(json);
}
function ReasonCodeRelationshipDataMetaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'lookup': ReasonCodeRelationshipDataMetaLookupToJSON(value['lookup']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var ReasonCodeRelationshipDataTypeEnum = {
    ReasonCode: 'reasonCode'
};
/**
 * Check if a given object implements the ReasonCodeRelationshipData interface.
 */
function instanceOfReasonCodeRelationshipData(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function ReasonCodeRelationshipDataFromJSON(json) {
    return ReasonCodeRelationshipDataFromJSONTyped(json);
}
function ReasonCodeRelationshipDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'],
        'meta': json['meta'] == null ? undefined : ReasonCodeRelationshipDataMetaFromJSON(json['meta']),
    };
}
function ReasonCodeRelationshipDataToJSON(json) {
    return ReasonCodeRelationshipDataToJSONTyped(json);
}
function ReasonCodeRelationshipDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'meta': ReasonCodeRelationshipDataMetaToJSON(value['meta']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the ReasonCodeRelationship interface.
 */
function instanceOfReasonCodeRelationship(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function ReasonCodeRelationshipFromJSON(json) {
    return ReasonCodeRelationshipFromJSONTyped(json);
}
function ReasonCodeRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': ReasonCodeRelationshipDataFromJSON(json['data']),
    };
}
function ReasonCodeRelationshipToJSON(json) {
    return ReasonCodeRelationshipToJSONTyped(json);
}
function ReasonCodeRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': ReasonCodeRelationshipDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the SelectionConstraintRelationshipDataMetaLookup interface.
 */
function instanceOfSelectionConstraintRelationshipDataMetaLookup(value) {
    return true;
}
function SelectionConstraintRelationshipDataMetaLookupFromJSON(json) {
    return SelectionConstraintRelationshipDataMetaLookupFromJSONTyped(json);
}
function SelectionConstraintRelationshipDataMetaLookupFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'] == null ? undefined : json['name'],
    };
}
function SelectionConstraintRelationshipDataMetaLookupToJSON(json) {
    return SelectionConstraintRelationshipDataMetaLookupToJSONTyped(json);
}
function SelectionConstraintRelationshipDataMetaLookupToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the SelectionConstraintRelationshipDataMeta interface.
 */
function instanceOfSelectionConstraintRelationshipDataMeta(value) {
    if (!('lookup' in value) || value['lookup'] === undefined)
        return false;
    return true;
}
function SelectionConstraintRelationshipDataMetaFromJSON(json) {
    return SelectionConstraintRelationshipDataMetaFromJSONTyped(json);
}
function SelectionConstraintRelationshipDataMetaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'lookup': SelectionConstraintRelationshipDataMetaLookupFromJSON(json['lookup']),
    };
}
function SelectionConstraintRelationshipDataMetaToJSON(json) {
    return SelectionConstraintRelationshipDataMetaToJSONTyped(json);
}
function SelectionConstraintRelationshipDataMetaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'lookup': SelectionConstraintRelationshipDataMetaLookupToJSON(value['lookup']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var SelectionConstraintRelationshipDataTypeEnum = {
    SelectionConstraint: 'selectionConstraint'
};
/**
 * Check if a given object implements the SelectionConstraintRelationshipData interface.
 */
function instanceOfSelectionConstraintRelationshipData(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function SelectionConstraintRelationshipDataFromJSON(json) {
    return SelectionConstraintRelationshipDataFromJSONTyped(json);
}
function SelectionConstraintRelationshipDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'],
        'meta': json['meta'] == null ? undefined : SelectionConstraintRelationshipDataMetaFromJSON(json['meta']),
    };
}
function SelectionConstraintRelationshipDataToJSON(json) {
    return SelectionConstraintRelationshipDataToJSONTyped(json);
}
function SelectionConstraintRelationshipDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'meta': SelectionConstraintRelationshipDataMetaToJSON(value['meta']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the SelectionConstraintRelationship interface.
 */
function instanceOfSelectionConstraintRelationship(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function SelectionConstraintRelationshipFromJSON(json) {
    return SelectionConstraintRelationshipFromJSONTyped(json);
}
function SelectionConstraintRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': SelectionConstraintRelationshipDataFromJSON(json['data']),
    };
}
function SelectionConstraintRelationshipToJSON(json) {
    return SelectionConstraintRelationshipToJSONTyped(json);
}
function SelectionConstraintRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': SelectionConstraintRelationshipDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
var ShiftEventRelationshipDataTypeEnum = {
    Event: 'event'
};
/**
 * Check if a given object implements the ShiftEventRelationshipData interface.
 */
function instanceOfShiftEventRelationshipData(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function ShiftEventRelationshipDataFromJSON(json) {
    return ShiftEventRelationshipDataFromJSONTyped(json);
}
function ShiftEventRelationshipDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
    };
}
function ShiftEventRelationshipDataToJSON(json) {
    return ShiftEventRelationshipDataToJSONTyped(json);
}
function ShiftEventRelationshipDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the ShiftEventRelationship interface.
 */
function instanceOfShiftEventRelationship(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function ShiftEventRelationshipFromJSON(json) {
    return ShiftEventRelationshipFromJSONTyped(json);
}
function ShiftEventRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': ShiftEventRelationshipDataFromJSON(json['data']),
    };
}
function ShiftEventRelationshipToJSON(json) {
    return ShiftEventRelationshipToJSONTyped(json);
}
function ShiftEventRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': ShiftEventRelationshipDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the OvertimeTypeRelationshipDataMetaLookup interface.
 */
function instanceOfOvertimeTypeRelationshipDataMetaLookup(value) {
    return true;
}
function OvertimeTypeRelationshipDataMetaLookupFromJSON(json) {
    return OvertimeTypeRelationshipDataMetaLookupFromJSONTyped(json);
}
function OvertimeTypeRelationshipDataMetaLookupFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'] == null ? undefined : json['code'],
    };
}
function OvertimeTypeRelationshipDataMetaLookupToJSON(json) {
    return OvertimeTypeRelationshipDataMetaLookupToJSONTyped(json);
}
function OvertimeTypeRelationshipDataMetaLookupToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the OvertimeTypeRelationshipDataMeta interface.
 */
function instanceOfOvertimeTypeRelationshipDataMeta(value) {
    if (!('lookup' in value) || value['lookup'] === undefined)
        return false;
    return true;
}
function OvertimeTypeRelationshipDataMetaFromJSON(json) {
    return OvertimeTypeRelationshipDataMetaFromJSONTyped(json);
}
function OvertimeTypeRelationshipDataMetaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'lookup': OvertimeTypeRelationshipDataMetaLookupFromJSON(json['lookup']),
    };
}
function OvertimeTypeRelationshipDataMetaToJSON(json) {
    return OvertimeTypeRelationshipDataMetaToJSONTyped(json);
}
function OvertimeTypeRelationshipDataMetaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'lookup': OvertimeTypeRelationshipDataMetaLookupToJSON(value['lookup']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var OvertimeTypeRelationshipDataTypeEnum = {
    OvertimeType: 'overtimeType'
};
/**
 * Check if a given object implements the OvertimeTypeRelationshipData interface.
 */
function instanceOfOvertimeTypeRelationshipData(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function OvertimeTypeRelationshipDataFromJSON(json) {
    return OvertimeTypeRelationshipDataFromJSONTyped(json);
}
function OvertimeTypeRelationshipDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'],
        'meta': json['meta'] == null ? undefined : OvertimeTypeRelationshipDataMetaFromJSON(json['meta']),
    };
}
function OvertimeTypeRelationshipDataToJSON(json) {
    return OvertimeTypeRelationshipDataToJSONTyped(json);
}
function OvertimeTypeRelationshipDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'meta': OvertimeTypeRelationshipDataMetaToJSON(value['meta']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the OvertimeTypeRelationship interface.
 */
function instanceOfOvertimeTypeRelationship(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function OvertimeTypeRelationshipFromJSON(json) {
    return OvertimeTypeRelationshipFromJSONTyped(json);
}
function OvertimeTypeRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': OvertimeTypeRelationshipDataFromJSON(json['data']),
    };
}
function OvertimeTypeRelationshipToJSON(json) {
    return OvertimeTypeRelationshipToJSONTyped(json);
}
function OvertimeTypeRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': OvertimeTypeRelationshipDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ShiftEmployeeRelationshipDataMetaLookup interface.
 */
function instanceOfShiftEmployeeRelationshipDataMetaLookup(value) {
    if (!('clientPersonId' in value) || value['clientPersonId'] === undefined)
        return false;
    return true;
}
function ShiftEmployeeRelationshipDataMetaLookupFromJSON(json) {
    return ShiftEmployeeRelationshipDataMetaLookupFromJSONTyped(json);
}
function ShiftEmployeeRelationshipDataMetaLookupFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'clientPersonId': json['clientPersonId'],
    };
}
function ShiftEmployeeRelationshipDataMetaLookupToJSON(json) {
    return ShiftEmployeeRelationshipDataMetaLookupToJSONTyped(json);
}
function ShiftEmployeeRelationshipDataMetaLookupToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'clientPersonId': value['clientPersonId'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the ShiftEmployeeRelationshipDataMeta interface.
 */
function instanceOfShiftEmployeeRelationshipDataMeta(value) {
    if (!('lookup' in value) || value['lookup'] === undefined)
        return false;
    return true;
}
function ShiftEmployeeRelationshipDataMetaFromJSON(json) {
    return ShiftEmployeeRelationshipDataMetaFromJSONTyped(json);
}
function ShiftEmployeeRelationshipDataMetaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'lookup': ShiftEmployeeRelationshipDataMetaLookupFromJSON(json['lookup']),
    };
}
function ShiftEmployeeRelationshipDataMetaToJSON(json) {
    return ShiftEmployeeRelationshipDataMetaToJSONTyped(json);
}
function ShiftEmployeeRelationshipDataMetaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'lookup': ShiftEmployeeRelationshipDataMetaLookupToJSON(value['lookup']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var ShiftEmployeeRelationshipDataTypeEnum = {
    Employee: 'employee'
};
/**
 * Check if a given object implements the ShiftEmployeeRelationshipData interface.
 */
function instanceOfShiftEmployeeRelationshipData(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function ShiftEmployeeRelationshipDataFromJSON(json) {
    return ShiftEmployeeRelationshipDataFromJSONTyped(json);
}
function ShiftEmployeeRelationshipDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'],
        'meta': json['meta'] == null ? undefined : ShiftEmployeeRelationshipDataMetaFromJSON(json['meta']),
    };
}
function ShiftEmployeeRelationshipDataToJSON(json) {
    return ShiftEmployeeRelationshipDataToJSONTyped(json);
}
function ShiftEmployeeRelationshipDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'meta': ShiftEmployeeRelationshipDataMetaToJSON(value['meta']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the ShiftEmployeeRelationship interface.
 */
function instanceOfShiftEmployeeRelationship(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function ShiftEmployeeRelationshipFromJSON(json) {
    return ShiftEmployeeRelationshipFromJSONTyped(json);
}
function ShiftEmployeeRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': ShiftEmployeeRelationshipDataFromJSON(json['data']),
    };
}
function ShiftEmployeeRelationshipToJSON(json) {
    return ShiftEmployeeRelationshipToJSONTyped(json);
}
function ShiftEmployeeRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': ShiftEmployeeRelationshipDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the CreateShiftRelationships interface.
 */
function instanceOfCreateShiftRelationships(value) {
    return true;
}
function CreateShiftRelationshipsFromJSON(json) {
    return CreateShiftRelationshipsFromJSONTyped(json);
}
function CreateShiftRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'employee': json['employee'] == null ? undefined : ShiftEmployeeRelationshipFromJSON(json['employee']),
        'role': json['role'] == null ? undefined : RoleRelationshipFromJSON(json['role']),
        'reasonCode': json['reasonCode'] == null ? undefined : ReasonCodeRelationshipFromJSON(json['reasonCode']),
        'overtimeType': json['overtimeType'] == null ? undefined : OvertimeTypeRelationshipFromJSON(json['overtimeType']),
        'selectionConstraint': json['selectionConstraint'] == null ? undefined : SelectionConstraintRelationshipFromJSON(json['selectionConstraint']),
        'event': json['event'] == null ? undefined : ShiftEventRelationshipFromJSON(json['event']),
    };
}
function CreateShiftRelationshipsToJSON(json) {
    return CreateShiftRelationshipsToJSONTyped(json);
}
function CreateShiftRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'employee': ShiftEmployeeRelationshipToJSON(value['employee']),
        'role': RoleRelationshipToJSON(value['role']),
        'reasonCode': ReasonCodeRelationshipToJSON(value['reasonCode']),
        'overtimeType': OvertimeTypeRelationshipToJSON(value['overtimeType']),
        'selectionConstraint': SelectionConstraintRelationshipToJSON(value['selectionConstraint']),
        'event': ShiftEventRelationshipToJSON(value['event']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the CreateSingleShiftBreak interface.
 */
function instanceOfCreateSingleShiftBreak(value) {
    if (!('startsAt' in value) || value['startsAt'] === undefined)
        return false;
    if (!('endsAt' in value) || value['endsAt'] === undefined)
        return false;
    if (!('isPaid' in value) || value['isPaid'] === undefined)
        return false;
    return true;
}
function CreateSingleShiftBreakFromJSON(json) {
    return CreateSingleShiftBreakFromJSONTyped(json);
}
function CreateSingleShiftBreakFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'startsAt': (luxon.DateTime.fromISO(json['startsAt'])),
        'endsAt': (luxon.DateTime.fromISO(json['endsAt'])),
        'isPaid': json['isPaid'],
    };
}
function CreateSingleShiftBreakToJSON(json) {
    return CreateSingleShiftBreakToJSONTyped(json);
}
function CreateSingleShiftBreakToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'startsAt': value['startsAt'].toISO(),
        'endsAt': value['endsAt'].toISO(),
        'isPaid': value['isPaid'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var CreateShiftRequestSchemaBodyStatusEnum = {
    Draft: 'DRAFT',
    Offered: 'OFFERED',
    Assigned: 'ASSIGNED',
    Published: 'PUBLISHED',
    Confirmed: 'CONFIRMED',
    Cancelled: 'CANCELLED'
};
/**
 * Check if a given object implements the CreateShiftRequestSchemaBody interface.
 */
function instanceOfCreateShiftRequestSchemaBody(value) {
    if (!('breaks' in value) || value['breaks'] === undefined)
        return false;
    return true;
}
function CreateShiftRequestSchemaBodyFromJSON(json) {
    return CreateShiftRequestSchemaBodyFromJSONTyped(json);
}
function CreateShiftRequestSchemaBodyFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'startsAt': json['startsAt'] == null ? undefined : (luxon.DateTime.fromISO(json['startsAt'])),
        'endsAt': json['endsAt'] == null ? undefined : (luxon.DateTime.fromISO(json['endsAt'])),
        'activities': json['activities'] == null ? undefined : (json['activities'].map(ActivitiesLookupRelationshipFromJSON)),
        'breaks': (json['breaks'].map(CreateSingleShiftBreakFromJSON)),
        'workOrder': json['workOrder'] == null ? undefined : json['workOrder'],
        'status': json['status'] == null ? undefined : json['status'],
        'comments': json['comments'] == null ? undefined : json['comments'],
        'workDate': json['workDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['workDate'])),
    };
}
function CreateShiftRequestSchemaBodyToJSON(json) {
    return CreateShiftRequestSchemaBodyToJSONTyped(json);
}
function CreateShiftRequestSchemaBodyToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'startsAt': value['startsAt'] == null ? value['startsAt'] : value['startsAt'].toISO(),
        'endsAt': value['endsAt'] == null ? value['endsAt'] : value['endsAt'].toISO(),
        'activities': value['activities'] == null ? undefined : (value['activities'].map(ActivitiesLookupRelationshipToJSON)),
        'breaks': (value['breaks'].map(CreateSingleShiftBreakToJSON)),
        'workOrder': value['workOrder'],
        'status': value['status'],
        'comments': value['comments'],
        'workDate': value['workDate'] == null ? value['workDate'] : value['workDate'].toISO(),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var CreateShiftRequestSchemaDataTypeEnum = {
    Shift: 'shift'
};
/**
 * Check if a given object implements the CreateShiftRequestSchemaData interface.
 */
function instanceOfCreateShiftRequestSchemaData(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function CreateShiftRequestSchemaDataFromJSON(json) {
    return CreateShiftRequestSchemaDataFromJSONTyped(json);
}
function CreateShiftRequestSchemaDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'attributes': CreateShiftRequestSchemaBodyFromJSON(json['attributes']),
        'relationships': json['relationships'] == null ? undefined : CreateShiftRelationshipsFromJSON(json['relationships']),
    };
}
function CreateShiftRequestSchemaDataToJSON(json) {
    return CreateShiftRequestSchemaDataToJSONTyped(json);
}
function CreateShiftRequestSchemaDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'attributes': CreateShiftRequestSchemaBodyToJSON(value['attributes']),
        'relationships': CreateShiftRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the SaveShiftRequestMetaSchema interface.
 */
function instanceOfSaveShiftRequestMetaSchema(value) {
    return true;
}
function SaveShiftRequestMetaSchemaFromJSON(json) {
    return SaveShiftRequestMetaSchemaFromJSONTyped(json);
}
function SaveShiftRequestMetaSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'acknowledgedErrors': json['acknowledgedErrors'] == null ? undefined : json['acknowledgedErrors'],
    };
}
function SaveShiftRequestMetaSchemaToJSON(json) {
    return SaveShiftRequestMetaSchemaToJSONTyped(json);
}
function SaveShiftRequestMetaSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'acknowledgedErrors': value['acknowledgedErrors'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the CreateShiftRequestSchema interface.
 */
function instanceOfCreateShiftRequestSchema(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function CreateShiftRequestSchemaFromJSON(json) {
    return CreateShiftRequestSchemaFromJSONTyped(json);
}
function CreateShiftRequestSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': CreateShiftRequestSchemaDataFromJSON(json['data']),
        'meta': json['meta'] == null ? undefined : SaveShiftRequestMetaSchemaFromJSON(json['meta']),
    };
}
function CreateShiftRequestSchemaToJSON(json) {
    return CreateShiftRequestSchemaToJSONTyped(json);
}
function CreateShiftRequestSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': CreateShiftRequestSchemaDataToJSON(value['data']),
        'meta': SaveShiftRequestMetaSchemaToJSON(value['meta']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimesheetEntryAttributesRequestSchema interface.
 */
function instanceOfTimesheetEntryAttributesRequestSchema(value) {
    return true;
}
function TimesheetEntryAttributesRequestSchemaFromJSON(json) {
    return TimesheetEntryAttributesRequestSchemaFromJSONTyped(json);
}
function TimesheetEntryAttributesRequestSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fields': json['fields'] == null ? undefined : (mapValues(json['fields'], DiscriminatedFieldValueFromJSON)),
    };
}
function TimesheetEntryAttributesRequestSchemaToJSON(json) {
    return TimesheetEntryAttributesRequestSchemaToJSONTyped(json);
}
function TimesheetEntryAttributesRequestSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'fields': value['fields'] == null ? undefined : (mapValues(value['fields'], DiscriminatedFieldValueToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the GroupRelationshipData interface.
 */
function instanceOfGroupRelationshipData(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function GroupRelationshipDataFromJSON(json) {
    return GroupRelationshipDataFromJSONTyped(json);
}
function GroupRelationshipDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
    };
}
function GroupRelationshipDataToJSON(json) {
    return GroupRelationshipDataToJSONTyped(json);
}
function GroupRelationshipDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the GroupRelationship interface.
 */
function instanceOfGroupRelationship(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function GroupRelationshipFromJSON(json) {
    return GroupRelationshipFromJSONTyped(json);
}
function GroupRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': GroupRelationshipDataFromJSON(json['data']),
    };
}
function GroupRelationshipToJSON(json) {
    return GroupRelationshipToJSONTyped(json);
}
function GroupRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': GroupRelationshipDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the JobRelationshipData interface.
 */
function instanceOfJobRelationshipData(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function JobRelationshipDataFromJSON(json) {
    return JobRelationshipDataFromJSONTyped(json);
}
function JobRelationshipDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
    };
}
function JobRelationshipDataToJSON(json) {
    return JobRelationshipDataToJSONTyped(json);
}
function JobRelationshipDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the JobRelationship interface.
 */
function instanceOfJobRelationship(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function JobRelationshipFromJSON(json) {
    return JobRelationshipFromJSONTyped(json);
}
function JobRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': JobRelationshipDataFromJSON(json['data']),
    };
}
function JobRelationshipToJSON(json) {
    return JobRelationshipToJSONTyped(json);
}
function JobRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': JobRelationshipDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimesheetEntryRelationshipsRequestSchema interface.
 */
function instanceOfTimesheetEntryRelationshipsRequestSchema(value) {
    if (!('employee' in value) || value['employee'] === undefined)
        return false;
    if (!('job' in value) || value['job'] === undefined)
        return false;
    return true;
}
function TimesheetEntryRelationshipsRequestSchemaFromJSON(json) {
    return TimesheetEntryRelationshipsRequestSchemaFromJSONTyped(json);
}
function TimesheetEntryRelationshipsRequestSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'employee': EmployeeRelationshipFromJSON(json['employee']),
        'job': JobRelationshipFromJSON(json['job']),
        'group': json['group'] == null ? undefined : GroupRelationshipFromJSON(json['group']),
    };
}
function TimesheetEntryRelationshipsRequestSchemaToJSON(json) {
    return TimesheetEntryRelationshipsRequestSchemaToJSONTyped(json);
}
function TimesheetEntryRelationshipsRequestSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'employee': EmployeeRelationshipToJSON(value['employee']),
        'job': JobRelationshipToJSON(value['job']),
        'group': GroupRelationshipToJSON(value['group']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the CreateTimesheetEntryRequestSchemaData interface.
 */
function instanceOfCreateTimesheetEntryRequestSchemaData(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    if (!('relationships' in value) || value['relationships'] === undefined)
        return false;
    return true;
}
function CreateTimesheetEntryRequestSchemaDataFromJSON(json) {
    return CreateTimesheetEntryRequestSchemaDataFromJSONTyped(json);
}
function CreateTimesheetEntryRequestSchemaDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'attributes': TimesheetEntryAttributesRequestSchemaFromJSON(json['attributes']),
        'relationships': TimesheetEntryRelationshipsRequestSchemaFromJSON(json['relationships']),
    };
}
function CreateTimesheetEntryRequestSchemaDataToJSON(json) {
    return CreateTimesheetEntryRequestSchemaDataToJSONTyped(json);
}
function CreateTimesheetEntryRequestSchemaDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'attributes': TimesheetEntryAttributesRequestSchemaToJSON(value['attributes']),
        'relationships': TimesheetEntryRelationshipsRequestSchemaToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the CreateTimesheetEntryRequestSchema interface.
 */
function instanceOfCreateTimesheetEntryRequestSchema(value) {
    return true;
}
function CreateTimesheetEntryRequestSchemaFromJSON(json) {
    return CreateTimesheetEntryRequestSchemaFromJSONTyped(json);
}
function CreateTimesheetEntryRequestSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : CreateTimesheetEntryRequestSchemaDataFromJSON(json['data']),
    };
}
function CreateTimesheetEntryRequestSchemaToJSON(json) {
    return CreateTimesheetEntryRequestSchemaToJSONTyped(json);
}
function CreateTimesheetEntryRequestSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': CreateTimesheetEntryRequestSchemaDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the CreatedSwipeResponse interface.
 */
function instanceOfCreatedSwipeResponse(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function CreatedSwipeResponseFromJSON(json) {
    return CreatedSwipeResponseFromJSONTyped(json);
}
function CreatedSwipeResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': SwipeFromJSON(json['data']),
    };
}
function CreatedSwipeResponseToJSON(json) {
    return CreatedSwipeResponseToJSONTyped(json);
}
function CreatedSwipeResponseToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': SwipeToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimeOffRequestResponseMeta interface.
 */
function instanceOfTimeOffRequestResponseMeta(value) {
    if (!('submittedDate' in value) || value['submittedDate'] === undefined)
        return false;
    if (!('updatedDate' in value) || value['updatedDate'] === undefined)
        return false;
    return true;
}
function TimeOffRequestResponseMetaFromJSON(json) {
    return TimeOffRequestResponseMetaFromJSONTyped(json);
}
function TimeOffRequestResponseMetaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'submittedDate': (luxon.DateTime.fromISO(json['submittedDate'])),
        'updatedDate': (luxon.DateTime.fromISO(json['updatedDate'])),
    };
}
function TimeOffRequestResponseMetaToJSON(json) {
    return TimeOffRequestResponseMetaToJSONTyped(json);
}
function TimeOffRequestResponseMetaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'submittedDate': value['submittedDate'].toISO(),
        'updatedDate': value['updatedDate'].toISO(),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PayCodeRelationshipsDataInner interface.
 */
function instanceOfPayCodeRelationshipsDataInner(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function PayCodeRelationshipsDataInnerFromJSON(json) {
    return PayCodeRelationshipsDataInnerFromJSONTyped(json);
}
function PayCodeRelationshipsDataInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
    };
}
function PayCodeRelationshipsDataInnerToJSON(json) {
    return PayCodeRelationshipsDataInnerToJSONTyped(json);
}
function PayCodeRelationshipsDataInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the PayCodeRelationships interface.
 */
function instanceOfPayCodeRelationships(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function PayCodeRelationshipsFromJSON(json) {
    return PayCodeRelationshipsFromJSONTyped(json);
}
function PayCodeRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(PayCodeRelationshipsDataInnerFromJSON)),
    };
}
function PayCodeRelationshipsToJSON(json) {
    return PayCodeRelationshipsToJSONTyped(json);
}
function PayCodeRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(PayCodeRelationshipsDataInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimeOffRequestResponseRelationships interface.
 */
function instanceOfTimeOffRequestResponseRelationships(value) {
    if (!('employee' in value) || value['employee'] === undefined)
        return false;
    if (!('job' in value) || value['job'] === undefined)
        return false;
    if (!('absenceType' in value) || value['absenceType'] === undefined)
        return false;
    if (!('payCode' in value) || value['payCode'] === undefined)
        return false;
    return true;
}
function TimeOffRequestResponseRelationshipsFromJSON(json) {
    return TimeOffRequestResponseRelationshipsFromJSONTyped(json);
}
function TimeOffRequestResponseRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'employee': EmployeeRelationshipFromJSON(json['employee']),
        'job': JobRelationshipFromJSON(json['job']),
        'absenceType': AbsenceTypeRelationshipFromJSON(json['absenceType']),
        'payCode': PayCodeRelationshipsFromJSON(json['payCode']),
    };
}
function TimeOffRequestResponseRelationshipsToJSON(json) {
    return TimeOffRequestResponseRelationshipsToJSONTyped(json);
}
function TimeOffRequestResponseRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'employee': EmployeeRelationshipToJSON(value['employee']),
        'job': JobRelationshipToJSON(value['job']),
        'absenceType': AbsenceTypeRelationshipToJSON(value['absenceType']),
        'payCode': PayCodeRelationshipsToJSON(value['payCode']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the DurationDateTime interface.
 */
function instanceOfDurationDateTime(value) {
    if (!('startDateTime' in value) || value['startDateTime'] === undefined)
        return false;
    if (!('endDateTime' in value) || value['endDateTime'] === undefined)
        return false;
    return true;
}
function DurationDateTimeFromJSON(json) {
    return DurationDateTimeFromJSONTyped(json);
}
function DurationDateTimeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'startDateTime': (luxon.DateTime.fromISO(json['startDateTime'])),
        'endDateTime': (luxon.DateTime.fromISO(json['endDateTime'])),
    };
}
function DurationDateTimeToJSON(json) {
    return DurationDateTimeToJSONTyped(json);
}
function DurationDateTimeToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'startDateTime': value['startDateTime'].toISO(),
        'endDateTime': value['endDateTime'].toISO(),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DurationQuantity interface.
 */
function instanceOfDurationQuantity(value) {
    if (!('quantity' in value) || value['quantity'] === undefined)
        return false;
    return true;
}
function DurationQuantityFromJSON(json) {
    return DurationQuantityFromJSONTyped(json);
}
function DurationQuantityFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'quantity': json['quantity'],
    };
}
function DurationQuantityToJSON(json) {
    return DurationQuantityToJSONTyped(json);
}
function DurationQuantityToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'quantity': value['quantity'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
function DurationFromJSON(json) {
    return DurationFromJSONTyped(json);
}
function DurationFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfDurationDateTime(json)) {
        return DurationDateTimeFromJSONTyped(json);
    }
    if (instanceOfDurationQuantity(json)) {
        return DurationQuantityFromJSONTyped(json);
    }
    return {};
}
function DurationToJSON(json) {
    return DurationToJSONTyped(json);
}
function DurationToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfDurationDateTime(value)) {
        return DurationDateTimeToJSON(value);
    }
    if (instanceOfDurationQuantity(value)) {
        return DurationQuantityToJSON(value);
    }
    return {};
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimeOffRequestDetailsInner interface.
 */
function instanceOfTimeOffRequestDetailsInner(value) {
    return true;
}
function TimeOffRequestDetailsInnerFromJSON(json) {
    return TimeOffRequestDetailsInnerFromJSONTyped(json);
}
function TimeOffRequestDetailsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'date': json['date'] == null ? undefined : json['date'],
        'payCodeId': json['payCodeId'] == null ? undefined : json['payCodeId'],
        'duration': json['duration'] == null ? undefined : DurationFromJSON(json['duration']),
    };
}
function TimeOffRequestDetailsInnerToJSON(json) {
    return TimeOffRequestDetailsInnerToJSONTyped(json);
}
function TimeOffRequestDetailsInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'date': value['date'],
        'payCodeId': value['payCodeId'],
        'duration': DurationToJSON(value['duration']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * The levels of the exception severity.
 * @export
 */
var Severity = {
    NoException: 'NO_EXCEPTION',
    InfoNoAction: 'INFO_NO_ACTION',
    InfoActionMaybeRequired: 'INFO_ACTION_MAYBE_REQUIRED',
    Warning: 'WARNING',
    WarningPaidDifferently: 'WARNING_PAID_DIFFERENTLY',
    ErrorNotPaid: 'ERROR_NOT_PAID',
    ErrorTimesheetNotPaid: 'ERROR_TIMESHEET_NOT_PAID',
    Error: 'ERROR',
    Unspecified: 'UNSPECIFIED'
};
function instanceOfSeverity(value) {
    for (var key in Severity) {
        if (Object.prototype.hasOwnProperty.call(Severity, key)) {
            if (Severity[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function SeverityFromJSON(json) {
    return SeverityFromJSONTyped(json);
}
function SeverityFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function SeverityToJSON(value) {
    return value;
}
function SeverityToJSONTyped(value, ignoreDiscriminator) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimeOffRequestException interface.
 */
function instanceOfTimeOffRequestException(value) {
    return true;
}
function TimeOffRequestExceptionFromJSON(json) {
    return TimeOffRequestExceptionFromJSONTyped(json);
}
function TimeOffRequestExceptionFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'date': json['date'] == null ? undefined : json['date'],
        'message': json['message'] == null ? undefined : json['message'],
        'severity': json['severity'] == null ? undefined : SeverityFromJSON(json['severity']),
        'twikiFormatted': json['twikiFormatted'] == null ? undefined : json['twikiFormatted'],
    };
}
function TimeOffRequestExceptionToJSON(json) {
    return TimeOffRequestExceptionToJSONTyped(json);
}
function TimeOffRequestExceptionToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'date': value['date'],
        'message': value['message'],
        'severity': SeverityToJSON(value['severity']),
        'twikiFormatted': value['twikiFormatted'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimeOffRequestResponseAttributes interface.
 */
function instanceOfTimeOffRequestResponseAttributes(value) {
    if (!('approvalStatus' in value) || value['approvalStatus'] === undefined)
        return false;
    if (!('startDate' in value) || value['startDate'] === undefined)
        return false;
    if (!('endDate' in value) || value['endDate'] === undefined)
        return false;
    if (!('timeOffRequestDetails' in value) || value['timeOffRequestDetails'] === undefined)
        return false;
    return true;
}
function TimeOffRequestResponseAttributesFromJSON(json) {
    return TimeOffRequestResponseAttributesFromJSONTyped(json);
}
function TimeOffRequestResponseAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'approvalStatus': json['approvalStatus'],
        'startDate': (dateAndTime.DateWithoutTime.fromISO(json['startDate'])),
        'endDate': (dateAndTime.DateWithoutTime.fromISO(json['endDate'])),
        'comment': json['comment'] == null ? undefined : json['comment'],
        'timeOffRequestDetails': (json['timeOffRequestDetails'].map(TimeOffRequestDetailsInnerFromJSON)),
        'timeOffRequestExceptions': json['timeOffRequestExceptions'] == null ? undefined : (json['timeOffRequestExceptions'].map(TimeOffRequestExceptionFromJSON)),
    };
}
function TimeOffRequestResponseAttributesToJSON(json) {
    return TimeOffRequestResponseAttributesToJSONTyped(json);
}
function TimeOffRequestResponseAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'approvalStatus': value['approvalStatus'],
        'startDate': value['startDate'].toISO(),
        'endDate': value['endDate'].toISO(),
        'comment': value['comment'],
        'timeOffRequestDetails': (value['timeOffRequestDetails'].map(TimeOffRequestDetailsInnerToJSON)),
        'timeOffRequestExceptions': value['timeOffRequestExceptions'] == null ? undefined : (value['timeOffRequestExceptions'].map(TimeOffRequestExceptionToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimeOff interface.
 */
function instanceOfTimeOff(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    if (!('meta' in value) || value['meta'] === undefined)
        return false;
    if (!('relationships' in value) || value['relationships'] === undefined)
        return false;
    return true;
}
function TimeOffFromJSON(json) {
    return TimeOffFromJSONTyped(json);
}
function TimeOffFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': TimeOffRequestResponseAttributesFromJSON(json['attributes']),
        'meta': TimeOffRequestResponseMetaFromJSON(json['meta']),
        'relationships': TimeOffRequestResponseRelationshipsFromJSON(json['relationships']),
    };
}
function TimeOffToJSON(json) {
    return TimeOffToJSONTyped(json);
}
function TimeOffToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': TimeOffRequestResponseAttributesToJSON(value['attributes']),
        'meta': TimeOffRequestResponseMetaToJSON(value['meta']),
        'relationships': TimeOffRequestResponseRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the CreatedTimeOffResponse interface.
 */
function instanceOfCreatedTimeOffResponse(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function CreatedTimeOffResponseFromJSON(json) {
    return CreatedTimeOffResponseFromJSONTyped(json);
}
function CreatedTimeOffResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': TimeOffFromJSON(json['data']),
    };
}
function CreatedTimeOffResponseToJSON(json) {
    return CreatedTimeOffResponseToJSONTyped(json);
}
function CreatedTimeOffResponseToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': TimeOffToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DailyDurationQuantity interface.
 */
function instanceOfDailyDurationQuantity(value) {
    return true;
}
function DailyDurationQuantityFromJSON(json) {
    return DailyDurationQuantityFromJSONTyped(json);
}
function DailyDurationQuantityFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
    };
}
function DailyDurationQuantityToJSON(json) {
    return DailyDurationQuantityToJSONTyped(json);
}
function DailyDurationQuantityToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'quantity': value['quantity'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DailyDurationStartTimeQuantity interface.
 */
function instanceOfDailyDurationStartTimeQuantity(value) {
    if (!('startTime' in value) || value['startTime'] === undefined)
        return false;
    if (!('quantity' in value) || value['quantity'] === undefined)
        return false;
    return true;
}
function DailyDurationStartTimeQuantityFromJSON(json) {
    return DailyDurationStartTimeQuantityFromJSONTyped(json);
}
function DailyDurationStartTimeQuantityFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'startTime': json['startTime'],
        'quantity': json['quantity'],
    };
}
function DailyDurationStartTimeQuantityToJSON(json) {
    return DailyDurationStartTimeQuantityToJSONTyped(json);
}
function DailyDurationStartTimeQuantityToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'startTime': value['startTime'],
        'quantity': value['quantity'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DailyDurationTime interface.
 */
function instanceOfDailyDurationTime(value) {
    return true;
}
function DailyDurationTimeFromJSON(json) {
    return DailyDurationTimeFromJSONTyped(json);
}
function DailyDurationTimeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'startTime': json['startTime'] == null ? undefined : json['startTime'],
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
    };
}
function DailyDurationTimeToJSON(json) {
    return DailyDurationTimeToJSONTyped(json);
}
function DailyDurationTimeToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'startTime': value['startTime'],
        'endTime': value['endTime'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
function DailyDurationFromJSON(json) {
    return DailyDurationFromJSONTyped(json);
}
function DailyDurationFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    {
        return DailyDurationQuantityFromJSONTyped(json);
    }
}
function DailyDurationToJSON(json) {
    return DailyDurationToJSONTyped(json);
}
function DailyDurationToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    {
        return DailyDurationQuantityToJSON(value);
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DataElementAttributes interface.
 */
function instanceOfDataElementAttributes(value) {
    return true;
}
function DataElementAttributesFromJSON(json) {
    return DataElementAttributesFromJSONTyped(json);
}
function DataElementAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fieldName': json['fieldName'] == null ? undefined : json['fieldName'],
        'displayLabel': json['displayLabel'] == null ? undefined : json['displayLabel'],
        'dataEntities': json['dataEntities'] == null ? undefined : json['dataEntities'],
    };
}
function DataElementAttributesToJSON(json) {
    return DataElementAttributesToJSONTyped(json);
}
function DataElementAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'fieldName': value['fieldName'],
        'displayLabel': value['displayLabel'],
        'dataEntities': value['dataEntities'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the DataElement interface.
 */
function instanceOfDataElement(value) {
    return true;
}
function DataElementFromJSON(json) {
    return DataElementFromJSONTyped(json);
}
function DataElementFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'attributes': json['attributes'] == null ? undefined : DataElementAttributesFromJSON(json['attributes']),
    };
}
function DataElementToJSON(json) {
    return DataElementToJSONTyped(json);
}
function DataElementToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': DataElementAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DataV1AbsenceReasonsFilterParameter interface.
 */
function instanceOfDataV1AbsenceReasonsFilterParameter(value) {
    return true;
}
function DataV1AbsenceReasonsFilterParameterFromJSON(json) {
    return DataV1AbsenceReasonsFilterParameterFromJSONTyped(json);
}
function DataV1AbsenceReasonsFilterParameterFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'employeeGuid': json['employeeGuid'] == null ? undefined : json['employeeGuid'],
        'clientPersonId': json['clientPersonId'] == null ? undefined : json['clientPersonId'],
        'absenceReasonCodes': json['absenceReasonCodes'] == null ? undefined : json['absenceReasonCodes'],
    };
}
function DataV1AbsenceReasonsFilterParameterToJSON(json) {
    return DataV1AbsenceReasonsFilterParameterToJSONTyped(json);
}
function DataV1AbsenceReasonsFilterParameterToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'employeeGuid': value['employeeGuid'],
        'clientPersonId': value['clientPersonId'],
        'absenceReasonCodes': value['absenceReasonCodes'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DataV1CaseChangesFilterParameter interface.
 */
function instanceOfDataV1CaseChangesFilterParameter(value) {
    return true;
}
function DataV1CaseChangesFilterParameterFromJSON(json) {
    return DataV1CaseChangesFilterParameterFromJSONTyped(json);
}
function DataV1CaseChangesFilterParameterFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'caseId': json['caseId'] == null ? undefined : json['caseId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
    };
}
function DataV1CaseChangesFilterParameterToJSON(json) {
    return DataV1CaseChangesFilterParameterToJSONTyped(json);
}
function DataV1CaseChangesFilterParameterToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'caseId': value['caseId'],
        'userId': value['userId'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DataV1EmployeesFilterParameter interface.
 */
function instanceOfDataV1EmployeesFilterParameter(value) {
    return true;
}
function DataV1EmployeesFilterParameterFromJSON(json) {
    return DataV1EmployeesFilterParameterFromJSONTyped(json);
}
function DataV1EmployeesFilterParameterFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'clientPersonId': json['clientPersonId'] == null ? undefined : json['clientPersonId'],
        'employeeId': json['employeeId'] == null ? undefined : json['employeeId'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'absenceCompany': json['absenceCompany'] == null ? undefined : json['absenceCompany'],
        'absenceEmployeeGroup': json['absenceEmployeeGroup'] == null ? undefined : json['absenceEmployeeGroup'],
        'absenceLocationCode': json['absenceLocationCode'] == null ? undefined : json['absenceLocationCode'],
        'excludeInactiveEmployees': json['excludeInactiveEmployees'] == null ? undefined : json['excludeInactiveEmployees'],
    };
}
function DataV1EmployeesFilterParameterToJSON(json) {
    return DataV1EmployeesFilterParameterToJSONTyped(json);
}
function DataV1EmployeesFilterParameterToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'clientPersonId': value['clientPersonId'],
        'employeeId': value['employeeId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'absenceCompany': value['absenceCompany'],
        'absenceEmployeeGroup': value['absenceEmployeeGroup'],
        'absenceLocationCode': value['absenceLocationCode'],
        'excludeInactiveEmployees': value['excludeInactiveEmployees'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the DeleteTimesheetEntryRequestSchemaData interface.
 */
function instanceOfDeleteTimesheetEntryRequestSchemaData(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('relationships' in value) || value['relationships'] === undefined)
        return false;
    return true;
}
function DeleteTimesheetEntryRequestSchemaDataFromJSON(json) {
    return DeleteTimesheetEntryRequestSchemaDataFromJSONTyped(json);
}
function DeleteTimesheetEntryRequestSchemaDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'relationships': TimesheetEntryRelationshipsRequestSchemaFromJSON(json['relationships']),
    };
}
function DeleteTimesheetEntryRequestSchemaDataToJSON(json) {
    return DeleteTimesheetEntryRequestSchemaDataToJSONTyped(json);
}
function DeleteTimesheetEntryRequestSchemaDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'relationships': TimesheetEntryRelationshipsRequestSchemaToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the DeleteTimesheetEntryRequestSchema interface.
 */
function instanceOfDeleteTimesheetEntryRequestSchema(value) {
    return true;
}
function DeleteTimesheetEntryRequestSchemaFromJSON(json) {
    return DeleteTimesheetEntryRequestSchemaFromJSONTyped(json);
}
function DeleteTimesheetEntryRequestSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : DeleteTimesheetEntryRequestSchemaDataFromJSON(json['data']),
    };
}
function DeleteTimesheetEntryRequestSchemaToJSON(json) {
    return DeleteTimesheetEntryRequestSchemaToJSONTyped(json);
}
function DeleteTimesheetEntryRequestSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': DeleteTimesheetEntryRequestSchemaDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the EmployeeAttributes interface.
 */
function instanceOfEmployeeAttributes(value) {
    return true;
}
function EmployeeAttributesFromJSON(json) {
    return EmployeeAttributesFromJSONTyped(json);
}
function EmployeeAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'clientPersonId': json['clientPersonId'] == null ? undefined : json['clientPersonId'],
        'displayId': json['displayId'] == null ? undefined : json['displayId'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'middleNames': json['middleNames'] == null ? undefined : json['middleNames'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'startEffectiveDate': json['startEffectiveDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['startEffectiveDate'])),
        'endEffectiveDate': json['endEffectiveDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['endEffectiveDate'])),
        'absenceLocationCode': json['absenceLocationCode'] == null ? undefined : json['absenceLocationCode'],
        'absenceCompany': json['absenceCompany'] == null ? undefined : json['absenceCompany'],
        'absenceEmployeeGroup': json['absenceEmployeeGroup'] == null ? undefined : json['absenceEmployeeGroup'],
    };
}
function EmployeeAttributesToJSON(json) {
    return EmployeeAttributesToJSONTyped(json);
}
function EmployeeAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'clientPersonId': value['clientPersonId'],
        'displayId': value['displayId'],
        'displayName': value['displayName'],
        'firstName': value['firstName'],
        'middleNames': value['middleNames'],
        'lastName': value['lastName'],
        'startEffectiveDate': value['startEffectiveDate'] == null ? value['startEffectiveDate'] : value['startEffectiveDate'].toISO(),
        'endEffectiveDate': value['endEffectiveDate'] == null ? value['endEffectiveDate'] : value['endEffectiveDate'].toISO(),
        'absenceLocationCode': value['absenceLocationCode'],
        'absenceCompany': value['absenceCompany'],
        'absenceEmployeeGroup': value['absenceEmployeeGroup'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the Employee interface.
 */
function instanceOfEmployee(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function EmployeeFromJSON(json) {
    return EmployeeFromJSONTyped(json);
}
function EmployeeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': EmployeeAttributesFromJSON(json['attributes']),
    };
}
function EmployeeToJSON(json) {
    return EmployeeToJSONTyped(json);
}
function EmployeeToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': EmployeeAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the EmployeeBankAttributesTimeUnit interface.
 */
function instanceOfEmployeeBankAttributesTimeUnit(value) {
    return true;
}
function EmployeeBankAttributesTimeUnitFromJSON(json) {
    return EmployeeBankAttributesTimeUnitFromJSONTyped(json);
}
function EmployeeBankAttributesTimeUnitFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'codeValue': json['codeValue'] == null ? undefined : json['codeValue'],
        'shortName': json['shortName'] == null ? undefined : json['shortName'],
    };
}
function EmployeeBankAttributesTimeUnitToJSON(json) {
    return EmployeeBankAttributesTimeUnitToJSONTyped(json);
}
function EmployeeBankAttributesTimeUnitToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'codeValue': value['codeValue'],
        'shortName': value['shortName'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the EmployeeBankAttributes interface.
 */
function instanceOfEmployeeBankAttributes(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('timeUnit' in value) || value['timeUnit'] === undefined)
        return false;
    if (!('balanceDate' in value) || value['balanceDate'] === undefined)
        return false;
    if (!('balance' in value) || value['balance'] === undefined)
        return false;
    return true;
}
function EmployeeBankAttributesFromJSON(json) {
    return EmployeeBankAttributesFromJSONTyped(json);
}
function EmployeeBankAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'timeUnit': EmployeeBankAttributesTimeUnitFromJSON(json['timeUnit']),
        'balanceDate': (dateAndTime.DateWithoutTime.fromISO(json['balanceDate'])),
        'balance': json['balance'],
    };
}
function EmployeeBankAttributesToJSON(json) {
    return EmployeeBankAttributesToJSONTyped(json);
}
function EmployeeBankAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'timeUnit': EmployeeBankAttributesTimeUnitToJSON(value['timeUnit']),
        'balanceDate': value['balanceDate'].toISO(),
        'balance': value['balance'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the EmployeeBankMeta interface.
 */
function instanceOfEmployeeBankMeta(value) {
    if (!('updatedDate' in value) || value['updatedDate'] === undefined)
        return false;
    return true;
}
function EmployeeBankMetaFromJSON(json) {
    return EmployeeBankMetaFromJSONTyped(json);
}
function EmployeeBankMetaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'updatedDate': (luxon.DateTime.fromISO(json['updatedDate'])),
        'bankPolicyId': json['bankPolicyId'] == null ? undefined : json['bankPolicyId'],
        'numberFormatOptions': json['numberFormatOptions'] == null ? undefined : NumberFormatOptionsFromJSON(json['numberFormatOptions']),
    };
}
function EmployeeBankMetaToJSON(json) {
    return EmployeeBankMetaToJSONTyped(json);
}
function EmployeeBankMetaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'updatedDate': value['updatedDate'].toISO(),
        'bankPolicyId': value['bankPolicyId'],
        'numberFormatOptions': NumberFormatOptionsToJSON(value['numberFormatOptions']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the EmployeeBank interface.
 */
function instanceOfEmployeeBank(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    if (!('meta' in value) || value['meta'] === undefined)
        return false;
    if (!('relationships' in value) || value['relationships'] === undefined)
        return false;
    return true;
}
function EmployeeBankFromJSON(json) {
    return EmployeeBankFromJSONTyped(json);
}
function EmployeeBankFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': EmployeeBankAttributesFromJSON(json['attributes']),
        'meta': EmployeeBankMetaFromJSON(json['meta']),
        'relationships': EmployeeBankRelationshipsFromJSON(json['relationships']),
    };
}
function EmployeeBankToJSON(json) {
    return EmployeeBankToJSONTyped(json);
}
function EmployeeBankToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': EmployeeBankAttributesToJSON(value['attributes']),
        'meta': EmployeeBankMetaToJSON(value['meta']),
        'relationships': EmployeeBankRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the EmployeeCardAttributes interface.
 */
function instanceOfEmployeeCardAttributes(value) {
    return true;
}
function EmployeeCardAttributesFromJSON(json) {
    return EmployeeCardAttributesFromJSONTyped(json);
}
function EmployeeCardAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'clientPersonId': json['clientPersonId'] == null ? undefined : json['clientPersonId'],
        'displayId': json['displayId'] == null ? undefined : json['displayId'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'middleNames': json['middleNames'] == null ? undefined : json['middleNames'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
    };
}
function EmployeeCardAttributesToJSON(json) {
    return EmployeeCardAttributesToJSONTyped(json);
}
function EmployeeCardAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'clientPersonId': value['clientPersonId'],
        'displayId': value['displayId'],
        'displayName': value['displayName'],
        'firstName': value['firstName'],
        'middleNames': value['middleNames'],
        'lastName': value['lastName'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the EmployeeCard interface.
 */
function instanceOfEmployeeCard(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function EmployeeCardFromJSON(json) {
    return EmployeeCardFromJSONTyped(json);
}
function EmployeeCardFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': json['attributes'] == null ? undefined : EmployeeCardAttributesFromJSON(json['attributes']),
    };
}
function EmployeeCardToJSON(json) {
    return EmployeeCardToJSONTyped(json);
}
function EmployeeCardToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': EmployeeCardAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the JobResourceRelationships interface.
 */
function instanceOfJobResourceRelationships(value) {
    if (!('employee' in value) || value['employee'] === undefined)
        return false;
    return true;
}
function JobResourceRelationshipsFromJSON(json) {
    return JobResourceRelationshipsFromJSONTyped(json);
}
function JobResourceRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'employee': EmployeeRelationshipFromJSON(json['employee']),
    };
}
function JobResourceRelationshipsToJSON(json) {
    return JobResourceRelationshipsToJSONTyped(json);
}
function JobResourceRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'employee': EmployeeRelationshipToJSON(value['employee']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the JobAttributes interface.
 */
function instanceOfJobAttributes(value) {
    if (!('clientEmployeeJobId' in value) || value['clientEmployeeJobId'] === undefined)
        return false;
    if (!('jobDescription' in value) || value['jobDescription'] === undefined)
        return false;
    return true;
}
function JobAttributesFromJSON(json) {
    return JobAttributesFromJSONTyped(json);
}
function JobAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'clientEmployeeJobId': json['clientEmployeeJobId'],
        'jobDescription': json['jobDescription'],
        'effectiveDate': json['effectiveDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['effectiveDate'])),
        'endEffectiveDate': json['endEffectiveDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['endEffectiveDate'])),
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'isPrimary': json['isPrimary'] == null ? undefined : json['isPrimary'],
        'jobCode': json['jobCode'] == null ? undefined : json['jobCode'],
        'locationId': json['locationId'] == null ? undefined : json['locationId'],
        'costCenter': json['costCenter'] == null ? undefined : json['costCenter'],
        'timeZone': json['timeZone'] == null ? undefined : json['timeZone'],
    };
}
function JobAttributesToJSON(json) {
    return JobAttributesToJSONTyped(json);
}
function JobAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'clientEmployeeJobId': value['clientEmployeeJobId'],
        'jobDescription': value['jobDescription'],
        'effectiveDate': value['effectiveDate'] == null ? value['effectiveDate'] : value['effectiveDate'].toISO(),
        'endEffectiveDate': value['endEffectiveDate'] == null ? value['endEffectiveDate'] : value['endEffectiveDate'].toISO(),
        'isActive': value['isActive'],
        'isPrimary': value['isPrimary'],
        'jobCode': value['jobCode'],
        'locationId': value['locationId'],
        'costCenter': value['costCenter'],
        'timeZone': value['timeZone'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var JobResourceTypeEnum = {
    Job: 'job'
};
/**
 * Check if a given object implements the JobResource interface.
 */
function instanceOfJobResource(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    if (!('relationships' in value) || value['relationships'] === undefined)
        return false;
    return true;
}
function JobResourceFromJSON(json) {
    return JobResourceFromJSONTyped(json);
}
function JobResourceFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': JobAttributesFromJSON(json['attributes']),
        'relationships': JobResourceRelationshipsFromJSON(json['relationships']),
    };
}
function JobResourceToJSON(json) {
    return JobResourceToJSONTyped(json);
}
function JobResourceToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': JobAttributesToJSON(value['attributes']),
        'relationships': JobResourceRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the EmployeesJobResponse interface.
 */
function instanceOfEmployeesJobResponse(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    if (!('included' in value) || value['included'] === undefined)
        return false;
    return true;
}
function EmployeesJobResponseFromJSON(json) {
    return EmployeesJobResponseFromJSONTyped(json);
}
function EmployeesJobResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': JobResourceFromJSON(json['data']),
        'included': (json['included'].map(EmployeeFromJSON)),
    };
}
function EmployeesJobResponseToJSON(json) {
    return EmployeesJobResponseToJSONTyped(json);
}
function EmployeesJobResponseToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': JobResourceToJSON(value['data']),
        'included': (value['included'].map(EmployeeToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the EmployeesJobsResponse interface.
 */
function instanceOfEmployeesJobsResponse(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    if (!('included' in value) || value['included'] === undefined)
        return false;
    return true;
}
function EmployeesJobsResponseFromJSON(json) {
    return EmployeesJobsResponseFromJSONTyped(json);
}
function EmployeesJobsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(JobResourceFromJSON)),
        'included': (json['included'].map(EmployeeFromJSON)),
    };
}
function EmployeesJobsResponseToJSON(json) {
    return EmployeesJobsResponseToJSONTyped(json);
}
function EmployeesJobsResponseToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(JobResourceToJSON)),
        'included': (value['included'].map(EmployeeToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
function EntryFieldFromJSON(json) {
    return EntryFieldFromJSONTyped(json);
}
function EntryFieldFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfDurationDateTime(json)) {
        return DurationDateTimeFromJSONTyped(json);
    }
    if (typeof json === 'number') {
        return json;
    }
    return {};
}
function EntryFieldToJSON(json) {
    return EntryFieldToJSONTyped(json);
}
function EntryFieldToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfDurationDateTime(value)) {
        return DurationDateTimeToJSON(value);
    }
    if (typeof value === 'number') {
        return value;
    }
    return {};
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Allowed entry type with this pay code resource.
 * @export
 */
var EntryType = {
    DateTime: 'DATE_TIME',
    Date: 'DATE',
    Time: 'TIME',
    ElapsedTime: 'ELAPSED_TIME',
    Number: 'NUMBER',
    Boolean: 'BOOLEAN',
    RelativeDateTime: 'RELATIVE_DATE_TIME',
    MonetaryAmount: 'MONETARY_AMOUNT',
    String: 'STRING'
};
function instanceOfEntryType(value) {
    for (var key in EntryType) {
        if (Object.prototype.hasOwnProperty.call(EntryType, key)) {
            if (EntryType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function EntryTypeFromJSON(json) {
    return EntryTypeFromJSONTyped(json);
}
function EntryTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function EntryTypeToJSON(value) {
    return value;
}
function EntryTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ErrorResponse interface.
 */
function instanceOfErrorResponse(value) {
    if (!('errors' in value) || value['errors'] === undefined)
        return false;
    return true;
}
function ErrorResponseFromJSON(json) {
    return ErrorResponseFromJSONTyped(json);
}
function ErrorResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'errors': json['errors'],
    };
}
function ErrorResponseToJSON(json) {
    return ErrorResponseToJSONTyped(json);
}
function ErrorResponseToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'errors': value['errors'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ErrorSource interface.
 */
function instanceOfErrorSource(value) {
    return true;
}
function ErrorSourceFromJSON(json) {
    return ErrorSourceFromJSONTyped(json);
}
function ErrorSourceFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'pointer': json['pointer'] == null ? undefined : json['pointer'],
        'parameter': json['parameter'] == null ? undefined : json['parameter'],
        'header': json['header'] == null ? undefined : json['header'],
    };
}
function ErrorSourceToJSON(json) {
    return ErrorSourceToJSONTyped(json);
}
function ErrorSourceToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'pointer': value['pointer'],
        'parameter': value['parameter'],
        'header': value['header'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ExceptionsRelationshipDataInner interface.
 */
function instanceOfExceptionsRelationshipDataInner(value) {
    return true;
}
function ExceptionsRelationshipDataInnerFromJSON(json) {
    return ExceptionsRelationshipDataInnerFromJSONTyped(json);
}
function ExceptionsRelationshipDataInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}
function ExceptionsRelationshipDataInnerToJSON(json) {
    return ExceptionsRelationshipDataInnerToJSONTyped(json);
}
function ExceptionsRelationshipDataInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the ExceptionsRelationship interface.
 */
function instanceOfExceptionsRelationship(value) {
    return true;
}
function ExceptionsRelationshipFromJSON(json) {
    return ExceptionsRelationshipFromJSONTyped(json);
}
function ExceptionsRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : (json['data'].map(ExceptionsRelationshipDataInnerFromJSON)),
    };
}
function ExceptionsRelationshipToJSON(json) {
    return ExceptionsRelationshipToJSONTyped(json);
}
function ExceptionsRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': value['data'] == null ? undefined : (value['data'].map(ExceptionsRelationshipDataInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FormFieldsReducedAttributesOptionsInner interface.
 */
function instanceOfFormFieldsReducedAttributesOptionsInner(value) {
    return true;
}
function FormFieldsReducedAttributesOptionsInnerFromJSON(json) {
    return FormFieldsReducedAttributesOptionsInnerFromJSONTyped(json);
}
function FormFieldsReducedAttributesOptionsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'label': json['label'] == null ? undefined : json['label'],
        'value': json['value'] == null ? undefined : json['value'],
        'labelCategoryForSelect': json['labelCategoryForSelect'] == null ? undefined : json['labelCategoryForSelect'],
    };
}
function FormFieldsReducedAttributesOptionsInnerToJSON(json) {
    return FormFieldsReducedAttributesOptionsInnerToJSONTyped(json);
}
function FormFieldsReducedAttributesOptionsInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'label': value['label'],
        'value': value['value'],
        'labelCategoryForSelect': value['labelCategoryForSelect'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var FormFieldsReducedAttributesFormFieldTypeEnum = {
    Checkbox: 'CHECKBOX',
    Checklist: 'CHECKLIST',
    HorizontalRadio: 'HORIZONTAL_RADIO',
    Select: 'SELECT',
    Text: 'TEXT',
    Textarea: 'TEXTAREA',
    VerticalRadio: 'VERTICAL_RADIO'
};
/**
 * Check if a given object implements the FormFieldsReducedAttributes interface.
 */
function instanceOfFormFieldsReducedAttributes(value) {
    if (!('formField' in value) || value['formField'] === undefined)
        return false;
    if (!('formFieldType' in value) || value['formFieldType'] === undefined)
        return false;
    return true;
}
function FormFieldsReducedAttributesFromJSON(json) {
    return FormFieldsReducedAttributesFromJSONTyped(json);
}
function FormFieldsReducedAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'formField': json['formField'],
        'formFieldType': json['formFieldType'],
        'fieldFormatPolicy': json['fieldFormatPolicy'] == null ? undefined : json['fieldFormatPolicy'],
        'validationScript': json['validationScript'] == null ? undefined : json['validationScript'],
        'options': json['options'] == null ? undefined : (json['options'].map(FormFieldsReducedAttributesOptionsInnerFromJSON)),
    };
}
function FormFieldsReducedAttributesToJSON(json) {
    return FormFieldsReducedAttributesToJSONTyped(json);
}
function FormFieldsReducedAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'formField': value['formField'],
        'formFieldType': value['formFieldType'],
        'fieldFormatPolicy': value['fieldFormatPolicy'],
        'validationScript': value['validationScript'],
        'options': value['options'] == null ? undefined : (value['options'].map(FormFieldsReducedAttributesOptionsInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the FormFieldsReduced interface.
 */
function instanceOfFormFieldsReduced(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function FormFieldsReducedFromJSON(json) {
    return FormFieldsReducedFromJSONTyped(json);
}
function FormFieldsReducedFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': FormFieldsReducedAttributesFromJSON(json['attributes']),
    };
}
function FormFieldsReducedToJSON(json) {
    return FormFieldsReducedToJSONTyped(json);
}
function FormFieldsReducedToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': FormFieldsReducedAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the GetAbsenceCaseQuestionsFilterParameter interface.
 */
function instanceOfGetAbsenceCaseQuestionsFilterParameter(value) {
    return true;
}
function GetAbsenceCaseQuestionsFilterParameterFromJSON(json) {
    return GetAbsenceCaseQuestionsFilterParameterFromJSONTyped(json);
}
function GetAbsenceCaseQuestionsFilterParameterFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'employeeGuid': json['employeeGuid'] == null ? undefined : json['employeeGuid'],
        'clientPersonId': json['clientPersonId'] == null ? undefined : json['clientPersonId'],
        'startDate': json['startDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['endDate'])),
        'requestType': json['requestType'] == null ? undefined : RequestTypeFromJSON(json['requestType']),
        'absenceReasonCode': json['absenceReasonCode'] == null ? undefined : json['absenceReasonCode'],
    };
}
function GetAbsenceCaseQuestionsFilterParameterToJSON(json) {
    return GetAbsenceCaseQuestionsFilterParameterToJSONTyped(json);
}
function GetAbsenceCaseQuestionsFilterParameterToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'employeeGuid': value['employeeGuid'],
        'clientPersonId': value['clientPersonId'],
        'startDate': value['startDate'] == null ? value['startDate'] : value['startDate'].toISO(),
        'endDate': value['endDate'] == null ? value['endDate'] : value['endDate'].toISO(),
        'requestType': RequestTypeToJSON(value['requestType']),
        'absenceReasonCode': value['absenceReasonCode'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the GetAbsenceCaseWorkflowEventsFilterParameter interface.
 */
function instanceOfGetAbsenceCaseWorkflowEventsFilterParameter(value) {
    return true;
}
function GetAbsenceCaseWorkflowEventsFilterParameterFromJSON(json) {
    return GetAbsenceCaseWorkflowEventsFilterParameterFromJSONTyped(json);
}
function GetAbsenceCaseWorkflowEventsFilterParameterFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'caseIds': json['caseIds'] == null ? undefined : json['caseIds'],
        'dueDates': json['dueDates'] == null ? undefined : json['dueDates'],
        'assignedAdmins': json['assignedAdmins'] == null ? undefined : json['assignedAdmins'],
        'caseStatuses': json['caseStatuses'] == null ? undefined : (json['caseStatuses'].map(StatusFromJSON)),
        'isEventCompleted': json['isEventCompleted'] == null ? undefined : json['isEventCompleted'],
        'completionDates': json['completionDates'] == null ? undefined : json['completionDates'],
    };
}
function GetAbsenceCaseWorkflowEventsFilterParameterToJSON(json) {
    return GetAbsenceCaseWorkflowEventsFilterParameterToJSONTyped(json);
}
function GetAbsenceCaseWorkflowEventsFilterParameterToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'caseIds': value['caseIds'],
        'dueDates': value['dueDates'],
        'assignedAdmins': value['assignedAdmins'],
        'caseStatuses': value['caseStatuses'] == null ? undefined : (value['caseStatuses'].map(StatusToJSON)),
        'isEventCompleted': value['isEventCompleted'],
        'completionDates': value['completionDates'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var GetAbsenceCasesFilterParameterCaseTypesEnum = {
    Continuous: 'CONTINUOUS',
    Intermittent: 'INTERMITTENT',
    ReducedSchedule: 'REDUCED_SCHEDULE'
};
/**
 * Check if a given object implements the GetAbsenceCasesFilterParameter interface.
 */
function instanceOfGetAbsenceCasesFilterParameter(value) {
    return true;
}
function GetAbsenceCasesFilterParameterFromJSON(json) {
    return GetAbsenceCasesFilterParameterFromJSONTyped(json);
}
function GetAbsenceCasesFilterParameterFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'assignedTo': json['assignedTo'] == null ? undefined : json['assignedTo'],
        'caseReasons': json['caseReasons'] == null ? undefined : json['caseReasons'],
        'status': json['status'] == null ? undefined : (json['status'].map(StatusFromJSON)),
        'caseTypes': json['caseTypes'] == null ? undefined : json['caseTypes'],
    };
}
function GetAbsenceCasesFilterParameterToJSON(json) {
    return GetAbsenceCasesFilterParameterToJSONTyped(json);
}
function GetAbsenceCasesFilterParameterToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'assignedTo': value['assignedTo'],
        'caseReasons': value['caseReasons'],
        'status': value['status'] == null ? undefined : (value['status'].map(StatusToJSON)),
        'caseTypes': value['caseTypes'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the GetAbsenceCasesPageParameter interface.
 */
function instanceOfGetAbsenceCasesPageParameter(value) {
    return true;
}
function GetAbsenceCasesPageParameterFromJSON(json) {
    return GetAbsenceCasesPageParameterFromJSONTyped(json);
}
function GetAbsenceCasesPageParameterFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'size': json['size'] == null ? undefined : json['size'],
        'before': json['before'] == null ? undefined : json['before'],
        'after': json['after'] == null ? undefined : json['after'],
    };
}
function GetAbsenceCasesPageParameterToJSON(json) {
    return GetAbsenceCasesPageParameterToJSONTyped(json);
}
function GetAbsenceCasesPageParameterToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'size': value['size'],
        'before': value['before'],
        'after': value['after'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the GetAbsenceTypesFilterParameter interface.
 */
function instanceOfGetAbsenceTypesFilterParameter(value) {
    return true;
}
function GetAbsenceTypesFilterParameterFromJSON(json) {
    return GetAbsenceTypesFilterParameterFromJSONTyped(json);
}
function GetAbsenceTypesFilterParameterFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'clientPersonId': json['clientPersonId'] == null ? undefined : json['clientPersonId'],
        'asOfDate': json['asOfDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['asOfDate'])),
        'jobId': json['jobId'] == null ? undefined : json['jobId'],
    };
}
function GetAbsenceTypesFilterParameterToJSON(json) {
    return GetAbsenceTypesFilterParameterToJSONTyped(json);
}
function GetAbsenceTypesFilterParameterToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'clientPersonId': value['clientPersonId'],
        'asOfDate': value['asOfDate'] == null ? value['asOfDate'] : value['asOfDate'].toISO(),
        'jobId': value['jobId'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the GetBankMetadataFilterParameter interface.
 */
function instanceOfGetBankMetadataFilterParameter(value) {
    return true;
}
function GetBankMetadataFilterParameterFromJSON(json) {
    return GetBankMetadataFilterParameterFromJSONTyped(json);
}
function GetBankMetadataFilterParameterFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'employeeId': json['employeeId'] == null ? undefined : json['employeeId'],
        'clientPersonId': json['clientPersonId'] == null ? undefined : json['clientPersonId'],
        'jobId': json['jobId'] == null ? undefined : json['jobId'],
        'asOfDate': json['asOfDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['asOfDate'])),
    };
}
function GetBankMetadataFilterParameterToJSON(json) {
    return GetBankMetadataFilterParameterToJSONTyped(json);
}
function GetBankMetadataFilterParameterToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'employeeId': value['employeeId'],
        'clientPersonId': value['clientPersonId'],
        'jobId': value['jobId'],
        'asOfDate': value['asOfDate'] == null ? value['asOfDate'] : value['asOfDate'].toISO(),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the GetBanksFilterParameter interface.
 */
function instanceOfGetBanksFilterParameter(value) {
    return true;
}
function GetBanksFilterParameterFromJSON(json) {
    return GetBanksFilterParameterFromJSONTyped(json);
}
function GetBanksFilterParameterFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'employeeId': json['employeeId'] == null ? undefined : json['employeeId'],
        'clientPersonId': json['clientPersonId'] == null ? undefined : json['clientPersonId'],
        'jobId': json['jobId'] == null ? undefined : json['jobId'],
        'bankSet': json['bankSet'] == null ? undefined : json['bankSet'],
        'bankPolicyIds': json['bankPolicyIds'] == null ? undefined : json['bankPolicyIds'],
    };
}
function GetBanksFilterParameterToJSON(json) {
    return GetBanksFilterParameterToJSONTyped(json);
}
function GetBanksFilterParameterToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'employeeId': value['employeeId'],
        'clientPersonId': value['clientPersonId'],
        'jobId': value['jobId'],
        'bankSet': value['bankSet'],
        'bankPolicyIds': value['bankPolicyIds'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the GetJobFilterParameter interface.
 */
function instanceOfGetJobFilterParameter(value) {
    return true;
}
function GetJobFilterParameterFromJSON(json) {
    return GetJobFilterParameterFromJSONTyped(json);
}
function GetJobFilterParameterFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'asOfDate': json['asOfDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['asOfDate'])),
    };
}
function GetJobFilterParameterToJSON(json) {
    return GetJobFilterParameterToJSONTyped(json);
}
function GetJobFilterParameterToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'asOfDate': value['asOfDate'] == null ? value['asOfDate'] : value['asOfDate'].toISO(),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the GetJobsFilterParameter interface.
 */
function instanceOfGetJobsFilterParameter(value) {
    return true;
}
function GetJobsFilterParameterFromJSON(json) {
    return GetJobsFilterParameterFromJSONTyped(json);
}
function GetJobsFilterParameterFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'clientPersonId': json['clientPersonId'] == null ? undefined : json['clientPersonId'],
        'employeeId': json['employeeId'] == null ? undefined : json['employeeId'],
        'clientEmployeeJobId': json['clientEmployeeJobId'] == null ? undefined : json['clientEmployeeJobId'],
        'asOfDate': json['asOfDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['asOfDate'])),
    };
}
function GetJobsFilterParameterToJSON(json) {
    return GetJobsFilterParameterToJSONTyped(json);
}
function GetJobsFilterParameterToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'clientPersonId': value['clientPersonId'],
        'employeeId': value['employeeId'],
        'clientEmployeeJobId': value['clientEmployeeJobId'],
        'asOfDate': value['asOfDate'] == null ? value['asOfDate'] : value['asOfDate'].toISO(),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the GetPoliciesFilterParameter interface.
 */
function instanceOfGetPoliciesFilterParameter(value) {
    if (!('policyType' in value) || value['policyType'] === undefined)
        return false;
    return true;
}
function GetPoliciesFilterParameterFromJSON(json) {
    return GetPoliciesFilterParameterFromJSONTyped(json);
}
function GetPoliciesFilterParameterFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'policyType': json['policyType'],
        'policyId': json['policyId'] == null ? undefined : json['policyId'],
        'effectiveDate': json['effectiveDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['effectiveDate'])),
    };
}
function GetPoliciesFilterParameterToJSON(json) {
    return GetPoliciesFilterParameterToJSONTyped(json);
}
function GetPoliciesFilterParameterToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'policyType': value['policyType'],
        'policyId': value['policyId'],
        'effectiveDate': value['effectiveDate'] == null ? value['effectiveDate'] : value['effectiveDate'].toISO(),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the GetPolicySetDetailsFilterParameter interface.
 */
function instanceOfGetPolicySetDetailsFilterParameter(value) {
    if (!('policyTypes' in value) || value['policyTypes'] === undefined)
        return false;
    return true;
}
function GetPolicySetDetailsFilterParameterFromJSON(json) {
    return GetPolicySetDetailsFilterParameterFromJSONTyped(json);
}
function GetPolicySetDetailsFilterParameterFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'policyTypes': json['policyTypes'],
        'policySetId': json['policySetId'] == null ? undefined : json['policySetId'],
        'effectiveDate': json['effectiveDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['effectiveDate'])),
    };
}
function GetPolicySetDetailsFilterParameterToJSON(json) {
    return GetPolicySetDetailsFilterParameterToJSONTyped(json);
}
function GetPolicySetDetailsFilterParameterToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'policyTypes': value['policyTypes'],
        'policySetId': value['policySetId'],
        'effectiveDate': value['effectiveDate'] == null ? value['effectiveDate'] : value['effectiveDate'].toISO(),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
var GetPolicyTypesFilterParameterTableTypeEnum = {
    Master: 'master',
    MasterEff: 'masterEff',
    RuleDetail: 'ruleDetail',
    MasterDetail: 'masterDetail'
};
/**
 * Check if a given object implements the GetPolicyTypesFilterParameter interface.
 */
function instanceOfGetPolicyTypesFilterParameter(value) {
    return true;
}
function GetPolicyTypesFilterParameterFromJSON(json) {
    return GetPolicyTypesFilterParameterFromJSONTyped(json);
}
function GetPolicyTypesFilterParameterFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'tableType': json['tableType'] == null ? undefined : json['tableType'],
    };
}
function GetPolicyTypesFilterParameterToJSON(json) {
    return GetPolicyTypesFilterParameterToJSONTyped(json);
}
function GetPolicyTypesFilterParameterToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'tableType': value['tableType'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the GetShiftsFilterParameter interface.
 */
function instanceOfGetShiftsFilterParameter(value) {
    return true;
}
function GetShiftsFilterParameterFromJSON(json) {
    return GetShiftsFilterParameterFromJSONTyped(json);
}
function GetShiftsFilterParameterFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'startAt': json['startAt'] == null ? undefined : (luxon.DateTime.fromISO(json['startAt'])),
        'endAt': json['endAt'] == null ? undefined : (luxon.DateTime.fromISO(json['endAt'])),
        'clientPersonIds': json['clientPersonIds'] == null ? undefined : json['clientPersonIds'],
        'employeeIds': json['employeeIds'] == null ? undefined : json['employeeIds'],
    };
}
function GetShiftsFilterParameterToJSON(json) {
    return GetShiftsFilterParameterToJSONTyped(json);
}
function GetShiftsFilterParameterToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'startAt': value['startAt'] == null ? value['startAt'] : value['startAt'].toISO(),
        'endAt': value['endAt'] == null ? value['endAt'] : value['endAt'].toISO(),
        'clientPersonIds': value['clientPersonIds'],
        'employeeIds': value['employeeIds'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the GetTimeEntriesByIdFilterParameter interface.
 */
function instanceOfGetTimeEntriesByIdFilterParameter(value) {
    return true;
}
function GetTimeEntriesByIdFilterParameterFromJSON(json) {
    return GetTimeEntriesByIdFilterParameterFromJSONTyped(json);
}
function GetTimeEntriesByIdFilterParameterFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'clientPersonId': json['clientPersonId'] == null ? undefined : json['clientPersonId'],
        'selectedPeriodLabel': json['selectedPeriodLabel'] == null ? undefined : json['selectedPeriodLabel'],
    };
}
function GetTimeEntriesByIdFilterParameterToJSON(json) {
    return GetTimeEntriesByIdFilterParameterToJSONTyped(json);
}
function GetTimeEntriesByIdFilterParameterToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'clientPersonId': value['clientPersonId'],
        'selectedPeriodLabel': value['selectedPeriodLabel'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the GetTimeOffRequestsFilterParameter interface.
 */
function instanceOfGetTimeOffRequestsFilterParameter(value) {
    return true;
}
function GetTimeOffRequestsFilterParameterFromJSON(json) {
    return GetTimeOffRequestsFilterParameterFromJSONTyped(json);
}
function GetTimeOffRequestsFilterParameterFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'clientPersonId': json['clientPersonId'] == null ? undefined : json['clientPersonId'],
        'startDate': json['startDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['endDate'])),
        'statusList': json['statusList'] == null ? undefined : json['statusList'],
        'assignmentGroups': json['assignmentGroups'] == null ? undefined : json['assignmentGroups'],
    };
}
function GetTimeOffRequestsFilterParameterToJSON(json) {
    return GetTimeOffRequestsFilterParameterToJSONTyped(json);
}
function GetTimeOffRequestsFilterParameterToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'clientPersonId': value['clientPersonId'],
        'startDate': value['startDate'] == null ? value['startDate'] : value['startDate'].toISO(),
        'endDate': value['endDate'] == null ? value['endDate'] : value['endDate'].toISO(),
        'statusList': value['statusList'],
        'assignmentGroups': value['assignmentGroups'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the GetTimeOffRequestsPageParameter interface.
 */
function instanceOfGetTimeOffRequestsPageParameter(value) {
    return true;
}
function GetTimeOffRequestsPageParameterFromJSON(json) {
    return GetTimeOffRequestsPageParameterFromJSONTyped(json);
}
function GetTimeOffRequestsPageParameterFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'size': json['size'] == null ? undefined : json['size'],
        'before': json['before'] == null ? undefined : json['before'],
        'after': json['after'] == null ? undefined : json['after'],
    };
}
function GetTimeOffRequestsPageParameterToJSON(json) {
    return GetTimeOffRequestsPageParameterToJSONTyped(json);
}
function GetTimeOffRequestsPageParameterToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'size': value['size'],
        'before': value['before'],
        'after': value['after'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the GetTimesheetApprovalLayoutFilterParameter interface.
 */
function instanceOfGetTimesheetApprovalLayoutFilterParameter(value) {
    return true;
}
function GetTimesheetApprovalLayoutFilterParameterFromJSON(json) {
    return GetTimesheetApprovalLayoutFilterParameterFromJSONTyped(json);
}
function GetTimesheetApprovalLayoutFilterParameterFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'clientPersonId': json['clientPersonId'] == null ? undefined : json['clientPersonId'],
    };
}
function GetTimesheetApprovalLayoutFilterParameterToJSON(json) {
    return GetTimesheetApprovalLayoutFilterParameterToJSONTyped(json);
}
function GetTimesheetApprovalLayoutFilterParameterToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'groupId': value['groupId'],
        'clientPersonId': value['clientPersonId'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the GetTimesheetEntriesFilterParameter interface.
 */
function instanceOfGetTimesheetEntriesFilterParameter(value) {
    return true;
}
function GetTimesheetEntriesFilterParameterFromJSON(json) {
    return GetTimesheetEntriesFilterParameterFromJSONTyped(json);
}
function GetTimesheetEntriesFilterParameterFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'clientPersonId': json['clientPersonId'] == null ? undefined : json['clientPersonId'],
        'jobId': json['jobId'] == null ? undefined : json['jobId'],
        'startDate': json['startDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['endDate'])),
    };
}
function GetTimesheetEntriesFilterParameterToJSON(json) {
    return GetTimesheetEntriesFilterParameterToJSONTyped(json);
}
function GetTimesheetEntriesFilterParameterToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'clientPersonId': value['clientPersonId'],
        'jobId': value['jobId'],
        'startDate': value['startDate'] == null ? value['startDate'] : value['startDate'].toISO(),
        'endDate': value['endDate'] == null ? value['endDate'] : value['endDate'].toISO(),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the GetTimesheetExceptionsFilterParameter interface.
 */
function instanceOfGetTimesheetExceptionsFilterParameter(value) {
    return true;
}
function GetTimesheetExceptionsFilterParameterFromJSON(json) {
    return GetTimesheetExceptionsFilterParameterFromJSONTyped(json);
}
function GetTimesheetExceptionsFilterParameterFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'clientPersonId': json['clientPersonId'] == null ? undefined : json['clientPersonId'],
        'fromDate': json['fromDate'] == null ? undefined : json['fromDate'],
        'toDate': json['toDate'] == null ? undefined : json['toDate'],
        'payPeriod': json['payPeriod'] == null ? undefined : json['payPeriod'],
        'jobId': json['jobId'] == null ? undefined : json['jobId'],
        'showAssistantExceptionsOnly': json['showAssistantExceptionsOnly'] == null ? undefined : json['showAssistantExceptionsOnly'],
    };
}
function GetTimesheetExceptionsFilterParameterToJSON(json) {
    return GetTimesheetExceptionsFilterParameterToJSONTyped(json);
}
function GetTimesheetExceptionsFilterParameterToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'clientPersonId': value['clientPersonId'],
        'fromDate': value['fromDate'],
        'toDate': value['toDate'],
        'payPeriod': value['payPeriod'],
        'jobId': value['jobId'],
        'showAssistantExceptionsOnly': value['showAssistantExceptionsOnly'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the GetTimesheetsFilterParameter interface.
 */
function instanceOfGetTimesheetsFilterParameter(value) {
    return true;
}
function GetTimesheetsFilterParameterFromJSON(json) {
    return GetTimesheetsFilterParameterFromJSONTyped(json);
}
function GetTimesheetsFilterParameterFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'employeeId': json['employeeId'] == null ? undefined : json['employeeId'],
        'clientPersonId': json['clientPersonId'] == null ? undefined : json['clientPersonId'],
        'jobId': json['jobId'] == null ? undefined : json['jobId'],
        'selectedDate': json['selectedDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['selectedDate'])),
        'version': json['version'] == null ? undefined : json['version'],
        'category': json['category'] == null ? undefined : json['category'],
        'approvalStatus': json['approvalStatus'] == null ? undefined : json['approvalStatus'],
    };
}
function GetTimesheetsFilterParameterToJSON(json) {
    return GetTimesheetsFilterParameterToJSONTyped(json);
}
function GetTimesheetsFilterParameterToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'groupId': value['groupId'],
        'employeeId': value['employeeId'],
        'clientPersonId': value['clientPersonId'],
        'jobId': value['jobId'],
        'selectedDate': value['selectedDate'] == null ? value['selectedDate'] : value['selectedDate'].toISO(),
        'version': value['version'],
        'category': value['category'],
        'approvalStatus': value['approvalStatus'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the HelloResponseAttributes interface.
 */
function instanceOfHelloResponseAttributes(value) {
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function HelloResponseAttributesFromJSON(json) {
    return HelloResponseAttributesFromJSONTyped(json);
}
function HelloResponseAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'message': json['message'],
    };
}
function HelloResponseAttributesToJSON(json) {
    return HelloResponseAttributesToJSONTyped(json);
}
function HelloResponseAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'message': value['message'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the HelloResponseSchemaData interface.
 */
function instanceOfHelloResponseSchemaData(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function HelloResponseSchemaDataFromJSON(json) {
    return HelloResponseSchemaDataFromJSONTyped(json);
}
function HelloResponseSchemaDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': HelloResponseAttributesFromJSON(json['attributes']),
    };
}
function HelloResponseSchemaDataToJSON(json) {
    return HelloResponseSchemaDataToJSONTyped(json);
}
function HelloResponseSchemaDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': HelloResponseAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the HelloResponseSchema interface.
 */
function instanceOfHelloResponseSchema(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function HelloResponseSchemaFromJSON(json) {
    return HelloResponseSchemaFromJSONTyped(json);
}
function HelloResponseSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': HelloResponseSchemaDataFromJSON(json['data']),
    };
}
function HelloResponseSchemaToJSON(json) {
    return HelloResponseSchemaToJSONTyped(json);
}
function HelloResponseSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': HelloResponseSchemaDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Represents includable resources in job responses.
 * @export
 */
var IncludeParamsForJobsItem = {
    Employee: 'employee'
};
function instanceOfIncludeParamsForJobsItem(value) {
    for (var key in IncludeParamsForJobsItem) {
        if (Object.prototype.hasOwnProperty.call(IncludeParamsForJobsItem, key)) {
            if (IncludeParamsForJobsItem[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function IncludeParamsForJobsItemFromJSON(json) {
    return IncludeParamsForJobsItemFromJSONTyped(json);
}
function IncludeParamsForJobsItemFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function IncludeParamsForJobsItemToJSON(value) {
    return value;
}
function IncludeParamsForJobsItemToJSONTyped(value, ignoreDiscriminator) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the IncludedAbsenceTypeInformationAttributes interface.
 */
function instanceOfIncludedAbsenceTypeInformationAttributes(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
function IncludedAbsenceTypeInformationAttributesFromJSON(json) {
    return IncludedAbsenceTypeInformationAttributesFromJSONTyped(json);
}
function IncludedAbsenceTypeInformationAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
    };
}
function IncludedAbsenceTypeInformationAttributesToJSON(json) {
    return IncludedAbsenceTypeInformationAttributesToJSONTyped(json);
}
function IncludedAbsenceTypeInformationAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the IncludedAbsenceTypeInformation interface.
 */
function instanceOfIncludedAbsenceTypeInformation(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function IncludedAbsenceTypeInformationFromJSON(json) {
    return IncludedAbsenceTypeInformationFromJSONTyped(json);
}
function IncludedAbsenceTypeInformationFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': IncludedAbsenceTypeInformationAttributesFromJSON(json['attributes']),
    };
}
function IncludedAbsenceTypeInformationToJSON(json) {
    return IncludedAbsenceTypeInformationToJSONTyped(json);
}
function IncludedAbsenceTypeInformationToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': IncludedAbsenceTypeInformationAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the IncludedEmployeeInformationAttributes interface.
 */
function instanceOfIncludedEmployeeInformationAttributes(value) {
    if (!('clientPersonId' in value) || value['clientPersonId'] === undefined)
        return false;
    return true;
}
function IncludedEmployeeInformationAttributesFromJSON(json) {
    return IncludedEmployeeInformationAttributesFromJSONTyped(json);
}
function IncludedEmployeeInformationAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'clientPersonId': json['clientPersonId'],
        'displayId': json['displayId'] == null ? undefined : json['displayId'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'middleNames': json['middleNames'] == null ? undefined : json['middleNames'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
    };
}
function IncludedEmployeeInformationAttributesToJSON(json) {
    return IncludedEmployeeInformationAttributesToJSONTyped(json);
}
function IncludedEmployeeInformationAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'clientPersonId': value['clientPersonId'],
        'displayId': value['displayId'],
        'displayName': value['displayName'],
        'firstName': value['firstName'],
        'middleNames': value['middleNames'],
        'lastName': value['lastName'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the IncludedEmployeeInformation interface.
 */
function instanceOfIncludedEmployeeInformation(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function IncludedEmployeeInformationFromJSON(json) {
    return IncludedEmployeeInformationFromJSONTyped(json);
}
function IncludedEmployeeInformationFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': IncludedEmployeeInformationAttributesFromJSON(json['attributes']),
    };
}
function IncludedEmployeeInformationToJSON(json) {
    return IncludedEmployeeInformationToJSONTyped(json);
}
function IncludedEmployeeInformationToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': IncludedEmployeeInformationAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the IncludedJobInformationAttributes interface.
 */
function instanceOfIncludedJobInformationAttributes(value) {
    if (!('clientEmployeeJobId' in value) || value['clientEmployeeJobId'] === undefined)
        return false;
    return true;
}
function IncludedJobInformationAttributesFromJSON(json) {
    return IncludedJobInformationAttributesFromJSONTyped(json);
}
function IncludedJobInformationAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'clientEmployeeJobId': json['clientEmployeeJobId'],
        'jobDescription': json['jobDescription'] == null ? undefined : json['jobDescription'],
        'timeZone': json['timeZone'] == null ? undefined : json['timeZone'],
    };
}
function IncludedJobInformationAttributesToJSON(json) {
    return IncludedJobInformationAttributesToJSONTyped(json);
}
function IncludedJobInformationAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'clientEmployeeJobId': value['clientEmployeeJobId'],
        'jobDescription': value['jobDescription'],
        'timeZone': value['timeZone'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the IncludedJobInformation interface.
 */
function instanceOfIncludedJobInformation(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function IncludedJobInformationFromJSON(json) {
    return IncludedJobInformationFromJSONTyped(json);
}
function IncludedJobInformationFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': IncludedJobInformationAttributesFromJSON(json['attributes']),
    };
}
function IncludedJobInformationToJSON(json) {
    return IncludedJobInformationToJSONTyped(json);
}
function IncludedJobInformationToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': IncludedJobInformationAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the IncludedPayCodeWithEntryFieldAttributes interface.
 */
function instanceOfIncludedPayCodeWithEntryFieldAttributes(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('entryType' in value) || value['entryType'] === undefined)
        return false;
    if (!('entryLabel' in value) || value['entryLabel'] === undefined)
        return false;
    return true;
}
function IncludedPayCodeWithEntryFieldAttributesFromJSON(json) {
    return IncludedPayCodeWithEntryFieldAttributesFromJSONTyped(json);
}
function IncludedPayCodeWithEntryFieldAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'entryType': EntryTypeFromJSON(json['entryType']),
        'entryLabel': json['entryLabel'],
    };
}
function IncludedPayCodeWithEntryFieldAttributesToJSON(json) {
    return IncludedPayCodeWithEntryFieldAttributesToJSONTyped(json);
}
function IncludedPayCodeWithEntryFieldAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'entryType': EntryTypeToJSON(value['entryType']),
        'entryLabel': value['entryLabel'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the IncludedPayCodeWithEntryField interface.
 */
function instanceOfIncludedPayCodeWithEntryField(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function IncludedPayCodeWithEntryFieldFromJSON(json) {
    return IncludedPayCodeWithEntryFieldFromJSONTyped(json);
}
function IncludedPayCodeWithEntryFieldFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': IncludedPayCodeWithEntryFieldAttributesFromJSON(json['attributes']),
    };
}
function IncludedPayCodeWithEntryFieldToJSON(json) {
    return IncludedPayCodeWithEntryFieldToJSONTyped(json);
}
function IncludedPayCodeWithEntryFieldToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': IncludedPayCodeWithEntryFieldAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
function IncludedAbsenceTypeResponseFromJSON(json) {
    return IncludedAbsenceTypeResponseFromJSONTyped(json);
}
function IncludedAbsenceTypeResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfIncludedEmployeeInformation(json)) {
        return IncludedEmployeeInformationFromJSONTyped(json);
    }
    if (instanceOfIncludedJobInformation(json)) {
        return IncludedJobInformationFromJSONTyped(json);
    }
    if (instanceOfIncludedPayCodeWithEntryField(json)) {
        return IncludedPayCodeWithEntryFieldFromJSONTyped(json);
    }
    return {};
}
function IncludedAbsenceTypeResponseToJSON(json) {
    return IncludedAbsenceTypeResponseToJSONTyped(json);
}
function IncludedAbsenceTypeResponseToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfIncludedEmployeeInformation(value)) {
        return IncludedEmployeeInformationToJSON(value);
    }
    if (instanceOfIncludedJobInformation(value)) {
        return IncludedJobInformationToJSON(value);
    }
    if (instanceOfIncludedPayCodeWithEntryField(value)) {
        return IncludedPayCodeWithEntryFieldToJSON(value);
    }
    return {};
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the InlineObjectIncludedInner interface.
 */
function instanceOfInlineObjectIncludedInner(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function InlineObjectIncludedInnerFromJSON(json) {
    return InlineObjectIncludedInnerFromJSONTyped(json);
}
function InlineObjectIncludedInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': json['attributes'] == null ? undefined : BankAttributesFromJSON(json['attributes']),
    };
}
function InlineObjectIncludedInnerToJSON(json) {
    return InlineObjectIncludedInnerToJSONTyped(json);
}
function InlineObjectIncludedInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': BankAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the InlineObject interface.
 */
function instanceOfInlineObject(value) {
    return true;
}
function InlineObjectFromJSON(json) {
    return InlineObjectFromJSONTyped(json);
}
function InlineObjectFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : (json['data'].map(BalanceFromJSON)),
        'included': json['included'] == null ? undefined : (json['included'].map(InlineObjectIncludedInnerFromJSON)),
    };
}
function InlineObjectToJSON(json) {
    return InlineObjectToJSONTyped(json);
}
function InlineObjectToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': value['data'] == null ? undefined : (value['data'].map(BalanceToJSON)),
        'included': value['included'] == null ? undefined : (value['included'].map(InlineObjectIncludedInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the InlineObject1MetaPage interface.
 */
function instanceOfInlineObject1MetaPage(value) {
    return true;
}
function InlineObject1MetaPageFromJSON(json) {
    return InlineObject1MetaPageFromJSONTyped(json);
}
function InlineObject1MetaPageFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'rangeTruncated': json['rangeTruncated'] == null ? undefined : json['rangeTruncated'],
        'maxPageSize': json['maxPageSize'] == null ? undefined : json['maxPageSize'],
    };
}
function InlineObject1MetaPageToJSON(json) {
    return InlineObject1MetaPageToJSONTyped(json);
}
function InlineObject1MetaPageToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'rangeTruncated': value['rangeTruncated'],
        'maxPageSize': value['maxPageSize'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the InlineObject1Meta interface.
 */
function instanceOfInlineObject1Meta(value) {
    return true;
}
function InlineObject1MetaFromJSON(json) {
    return InlineObject1MetaFromJSONTyped(json);
}
function InlineObject1MetaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'page': json['page'] == null ? undefined : InlineObject1MetaPageFromJSON(json['page']),
    };
}
function InlineObject1MetaToJSON(json) {
    return InlineObject1MetaToJSONTyped(json);
}
function InlineObject1MetaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'page': InlineObject1MetaPageToJSON(value['page']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the InlineObject1Links interface.
 */
function instanceOfInlineObject1Links(value) {
    return true;
}
function InlineObject1LinksFromJSON(json) {
    return InlineObject1LinksFromJSONTyped(json);
}
function InlineObject1LinksFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'next': json['next'] == null ? undefined : json['next'],
        'prev': json['prev'] == null ? undefined : json['prev'],
    };
}
function InlineObject1LinksToJSON(json) {
    return InlineObject1LinksToJSONTyped(json);
}
function InlineObject1LinksToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'next': value['next'],
        'prev': value['prev'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimeOffRequestResourceAttributes interface.
 */
function instanceOfTimeOffRequestResourceAttributes(value) {
    if (!('startDate' in value) || value['startDate'] === undefined)
        return false;
    if (!('endDate' in value) || value['endDate'] === undefined)
        return false;
    if (!('approvalStatus' in value) || value['approvalStatus'] === undefined)
        return false;
    if (!('timeOffRequestDetails' in value) || value['timeOffRequestDetails'] === undefined)
        return false;
    return true;
}
function TimeOffRequestResourceAttributesFromJSON(json) {
    return TimeOffRequestResourceAttributesFromJSONTyped(json);
}
function TimeOffRequestResourceAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'startDate': (dateAndTime.DateWithoutTime.fromISO(json['startDate'])),
        'endDate': (dateAndTime.DateWithoutTime.fromISO(json['endDate'])),
        'comment': json['comment'] == null ? undefined : json['comment'],
        'approvalStatus': json['approvalStatus'],
        'timeOffRequestDetails': (json['timeOffRequestDetails'].map(TimeOffRequestDetailsInnerFromJSON)),
    };
}
function TimeOffRequestResourceAttributesToJSON(json) {
    return TimeOffRequestResourceAttributesToJSONTyped(json);
}
function TimeOffRequestResourceAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'startDate': value['startDate'].toISO(),
        'endDate': value['endDate'].toISO(),
        'comment': value['comment'],
        'approvalStatus': value['approvalStatus'],
        'timeOffRequestDetails': (value['timeOffRequestDetails'].map(TimeOffRequestDetailsInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimeOffRequestResourceRelationships interface.
 */
function instanceOfTimeOffRequestResourceRelationships(value) {
    if (!('employee' in value) || value['employee'] === undefined)
        return false;
    if (!('job' in value) || value['job'] === undefined)
        return false;
    if (!('absenceType' in value) || value['absenceType'] === undefined)
        return false;
    if (!('payCode' in value) || value['payCode'] === undefined)
        return false;
    return true;
}
function TimeOffRequestResourceRelationshipsFromJSON(json) {
    return TimeOffRequestResourceRelationshipsFromJSONTyped(json);
}
function TimeOffRequestResourceRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'employee': EmployeeRelationshipFromJSON(json['employee']),
        'job': JobRelationshipFromJSON(json['job']),
        'absenceType': AbsenceTypeRelationshipFromJSON(json['absenceType']),
        'payCode': PayCodeRelationshipsFromJSON(json['payCode']),
    };
}
function TimeOffRequestResourceRelationshipsToJSON(json) {
    return TimeOffRequestResourceRelationshipsToJSONTyped(json);
}
function TimeOffRequestResourceRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'employee': EmployeeRelationshipToJSON(value['employee']),
        'job': JobRelationshipToJSON(value['job']),
        'absenceType': AbsenceTypeRelationshipToJSON(value['absenceType']),
        'payCode': PayCodeRelationshipsToJSON(value['payCode']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimeOffRequestResource interface.
 */
function instanceOfTimeOffRequestResource(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    if (!('meta' in value) || value['meta'] === undefined)
        return false;
    if (!('relationships' in value) || value['relationships'] === undefined)
        return false;
    return true;
}
function TimeOffRequestResourceFromJSON(json) {
    return TimeOffRequestResourceFromJSONTyped(json);
}
function TimeOffRequestResourceFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': TimeOffRequestResourceAttributesFromJSON(json['attributes']),
        'meta': TimeOffRequestResponseMetaFromJSON(json['meta']),
        'relationships': TimeOffRequestResourceRelationshipsFromJSON(json['relationships']),
    };
}
function TimeOffRequestResourceToJSON(json) {
    return TimeOffRequestResourceToJSONTyped(json);
}
function TimeOffRequestResourceToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': TimeOffRequestResourceAttributesToJSON(value['attributes']),
        'meta': TimeOffRequestResponseMetaToJSON(value['meta']),
        'relationships': TimeOffRequestResourceRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
function TimeOffRequestListIncludedFromJSON(json) {
    return TimeOffRequestListIncludedFromJSONTyped(json);
}
function TimeOffRequestListIncludedFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfIncludedAbsenceTypeInformation(json)) {
        return IncludedAbsenceTypeInformationFromJSONTyped(json);
    }
    if (instanceOfIncludedEmployeeInformation(json)) {
        return IncludedEmployeeInformationFromJSONTyped(json);
    }
    if (instanceOfIncludedJobInformation(json)) {
        return IncludedJobInformationFromJSONTyped(json);
    }
    if (instanceOfIncludedPayCodeWithEntryField(json)) {
        return IncludedPayCodeWithEntryFieldFromJSONTyped(json);
    }
    return {};
}
function TimeOffRequestListIncludedToJSON(json) {
    return TimeOffRequestListIncludedToJSONTyped(json);
}
function TimeOffRequestListIncludedToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfIncludedAbsenceTypeInformation(value)) {
        return IncludedAbsenceTypeInformationToJSON(value);
    }
    if (instanceOfIncludedEmployeeInformation(value)) {
        return IncludedEmployeeInformationToJSON(value);
    }
    if (instanceOfIncludedJobInformation(value)) {
        return IncludedJobInformationToJSON(value);
    }
    if (instanceOfIncludedPayCodeWithEntryField(value)) {
        return IncludedPayCodeWithEntryFieldToJSON(value);
    }
    return {};
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the InlineObject1 interface.
 */
function instanceOfInlineObject1(value) {
    return true;
}
function InlineObject1FromJSON(json) {
    return InlineObject1FromJSONTyped(json);
}
function InlineObject1FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'meta': json['meta'] == null ? undefined : InlineObject1MetaFromJSON(json['meta']),
        'links': json['links'] == null ? undefined : InlineObject1LinksFromJSON(json['links']),
        'data': json['data'] == null ? undefined : (json['data'].map(TimeOffRequestResourceFromJSON)),
        'included': json['included'] == null ? undefined : (json['included'].map(TimeOffRequestListIncludedFromJSON)),
    };
}
function InlineObject1ToJSON(json) {
    return InlineObject1ToJSONTyped(json);
}
function InlineObject1ToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'meta': InlineObject1MetaToJSON(value['meta']),
        'links': InlineObject1LinksToJSON(value['links']),
        'data': value['data'] == null ? undefined : (value['data'].map(TimeOffRequestResourceToJSON)),
        'included': value['included'] == null ? undefined : (value['included'].map(TimeOffRequestListIncludedToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the InlineObject10 interface.
 */
function instanceOfInlineObject10(value) {
    return true;
}
function InlineObject10FromJSON(json) {
    return InlineObject10FromJSONTyped(json);
}
function InlineObject10FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : (json['data'].map(AbsenceTypeFromJSON)),
        'included': json['included'] == null ? undefined : (json['included'].map(IncludedAbsenceTypeResponseFromJSON)),
    };
}
function InlineObject10ToJSON(json) {
    return InlineObject10ToJSONTyped(json);
}
function InlineObject10ToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': value['data'] == null ? undefined : (value['data'].map(AbsenceTypeToJSON)),
        'included': value['included'] == null ? undefined : (value['included'].map(IncludedAbsenceTypeResponseToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the InlineObject11 interface.
 */
function instanceOfInlineObject11(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function InlineObject11FromJSON(json) {
    return InlineObject11FromJSONTyped(json);
}
function InlineObject11FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(EmployeeFromJSON)),
    };
}
function InlineObject11ToJSON(json) {
    return InlineObject11ToJSONTyped(json);
}
function InlineObject11ToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(EmployeeToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the InlineObject2IncludedInner interface.
 */
function instanceOfInlineObject2IncludedInner(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function InlineObject2IncludedInnerFromJSON(json) {
    return InlineObject2IncludedInnerFromJSONTyped(json);
}
function InlineObject2IncludedInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': AbsenceCaseLeaveTypeReducedAttributesFromJSON(json['attributes']),
    };
}
function InlineObject2IncludedInnerToJSON(json) {
    return InlineObject2IncludedInnerToJSONTyped(json);
}
function InlineObject2IncludedInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': AbsenceCaseLeaveTypeReducedAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the InlineObject2 interface.
 */
function instanceOfInlineObject2(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function InlineObject2FromJSON(json) {
    return InlineObject2FromJSONTyped(json);
}
function InlineObject2FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'links': json['links'] == null ? undefined : InlineObject1LinksFromJSON(json['links']),
        'data': (json['data'].map(AbsenceCaseFromJSON)),
        'included': json['included'] == null ? undefined : (json['included'].map(InlineObject2IncludedInnerFromJSON)),
    };
}
function InlineObject2ToJSON(json) {
    return InlineObject2ToJSONTyped(json);
}
function InlineObject2ToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'links': InlineObject1LinksToJSON(value['links']),
        'data': (value['data'].map(AbsenceCaseToJSON)),
        'included': value['included'] == null ? undefined : (value['included'].map(InlineObject2IncludedInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the InlineObject3IncludedInner interface.
 */
function instanceOfInlineObject3IncludedInner(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function InlineObject3IncludedInnerFromJSON(json) {
    return InlineObject3IncludedInnerFromJSONTyped(json);
}
function InlineObject3IncludedInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': AbsenceCaseWorkflowEventTypeReducedAttributesFromJSON(json['attributes']),
    };
}
function InlineObject3IncludedInnerToJSON(json) {
    return InlineObject3IncludedInnerToJSONTyped(json);
}
function InlineObject3IncludedInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': AbsenceCaseWorkflowEventTypeReducedAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the InlineObject3 interface.
 */
function instanceOfInlineObject3(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function InlineObject3FromJSON(json) {
    return InlineObject3FromJSONTyped(json);
}
function InlineObject3FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(AbsenceCaseWorkflowEventFromJSON)),
        'included': json['included'] == null ? undefined : (json['included'].map(InlineObject3IncludedInnerFromJSON)),
    };
}
function InlineObject3ToJSON(json) {
    return InlineObject3ToJSONTyped(json);
}
function InlineObject3ToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(AbsenceCaseWorkflowEventToJSON)),
        'included': value['included'] == null ? undefined : (value['included'].map(InlineObject3IncludedInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the InlineObject4IncludedInner interface.
 */
function instanceOfInlineObject4IncludedInner(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function InlineObject4IncludedInnerFromJSON(json) {
    return InlineObject4IncludedInnerFromJSONTyped(json);
}
function InlineObject4IncludedInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': AbsenceCaseAttributesFromJSON(json['attributes']),
        'relationships': json['relationships'] == null ? undefined : AbsenceCaseRelationshipsFromJSON(json['relationships']),
    };
}
function InlineObject4IncludedInnerToJSON(json) {
    return InlineObject4IncludedInnerToJSONTyped(json);
}
function InlineObject4IncludedInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': AbsenceCaseAttributesToJSON(value['attributes']),
        'relationships': AbsenceCaseRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the InlineObject4 interface.
 */
function instanceOfInlineObject4(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function InlineObject4FromJSON(json) {
    return InlineObject4FromJSONTyped(json);
}
function InlineObject4FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': AbsenceCaseContactEmployeeResponseFromJSON(json['data']),
        'included': json['included'] == null ? undefined : (json['included'].map(InlineObject4IncludedInnerFromJSON)),
    };
}
function InlineObject4ToJSON(json) {
    return InlineObject4ToJSONTyped(json);
}
function InlineObject4ToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': AbsenceCaseContactEmployeeResponseToJSON(value['data']),
        'included': value['included'] == null ? undefined : (value['included'].map(InlineObject4IncludedInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the InlineObject5IncludedInner interface.
 */
function instanceOfInlineObject5IncludedInner(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function InlineObject5IncludedInnerFromJSON(json) {
    return InlineObject5IncludedInnerFromJSONTyped(json);
}
function InlineObject5IncludedInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': AbsenceCaseLeaveEligibilityReducedAttributesFromJSON(json['attributes']),
    };
}
function InlineObject5IncludedInnerToJSON(json) {
    return InlineObject5IncludedInnerToJSONTyped(json);
}
function InlineObject5IncludedInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': AbsenceCaseLeaveEligibilityReducedAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the InlineObject5 interface.
 */
function instanceOfInlineObject5(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function InlineObject5FromJSON(json) {
    return InlineObject5FromJSONTyped(json);
}
function InlineObject5FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': AbsenceCaseDetailsFromJSON(json['data']),
        'included': json['included'] == null ? undefined : (json['included'].map(InlineObject5IncludedInnerFromJSON)),
    };
}
function InlineObject5ToJSON(json) {
    return InlineObject5ToJSONTyped(json);
}
function InlineObject5ToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': AbsenceCaseDetailsToJSON(value['data']),
        'included': value['included'] == null ? undefined : (value['included'].map(InlineObject5IncludedInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the InlineObject6 interface.
 */
function instanceOfInlineObject6(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function InlineObject6FromJSON(json) {
    return InlineObject6FromJSONTyped(json);
}
function InlineObject6FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'links': json['links'] == null ? undefined : InlineObject1LinksFromJSON(json['links']),
        'data': (json['data'].map(AbsenceCaseHistoryEventFromJSON)),
        'included': json['included'] == null ? undefined : (json['included'].map(AbsenceCaseEventRelationshipFromJSON)),
    };
}
function InlineObject6ToJSON(json) {
    return InlineObject6ToJSONTyped(json);
}
function InlineObject6ToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'links': InlineObject1LinksToJSON(value['links']),
        'data': (value['data'].map(AbsenceCaseHistoryEventToJSON)),
        'included': value['included'] == null ? undefined : (value['included'].map(AbsenceCaseEventRelationshipToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the InlineObject7 interface.
 */
function instanceOfInlineObject7(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function InlineObject7FromJSON(json) {
    return InlineObject7FromJSONTyped(json);
}
function InlineObject7FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(AbsenceReasonFromJSON)),
    };
}
function InlineObject7ToJSON(json) {
    return InlineObject7ToJSONTyped(json);
}
function InlineObject7ToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(AbsenceReasonToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
var NextQuestionOptionMatchingTypeEnum = {
    Contains: 'CONTAINS',
    True: 'TRUE',
    False: 'FALSE',
    GreaterThan: 'GREATER_THAN',
    LessThan: 'LESS_THAN',
    NotNull: 'NOT_NULL',
    IsNull: 'IS_NULL',
    Equal: 'EQUAL',
    NotEqual: 'NOT_EQUAL'
};
/**
 * Check if a given object implements the NextQuestionOption interface.
 */
function instanceOfNextQuestionOption(value) {
    return true;
}
function NextQuestionOptionFromJSON(json) {
    return NextQuestionOptionFromJSONTyped(json);
}
function NextQuestionOptionFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'questionNodeId': json['questionNodeId'] == null ? undefined : json['questionNodeId'],
        'matchingType': json['matchingType'] == null ? undefined : json['matchingType'],
        'matchingValue': json['matchingValue'] == null ? undefined : json['matchingValue'],
        'isDefault': json['isDefault'] == null ? undefined : json['isDefault'],
    };
}
function NextQuestionOptionToJSON(json) {
    return NextQuestionOptionToJSONTyped(json);
}
function NextQuestionOptionToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'questionNodeId': value['questionNodeId'],
        'matchingType': value['matchingType'],
        'matchingValue': value['matchingValue'],
        'isDefault': value['isDefault'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the QuestionTreeNodesReducedAttributes interface.
 */
function instanceOfQuestionTreeNodesReducedAttributes(value) {
    if (!('questionId' in value) || value['questionId'] === undefined)
        return false;
    if (!('answerRequired' in value) || value['answerRequired'] === undefined)
        return false;
    if (!('qualificationScript' in value) || value['qualificationScript'] === undefined)
        return false;
    if (!('childOptions' in value) || value['childOptions'] === undefined)
        return false;
    if (!('siblingOptions' in value) || value['siblingOptions'] === undefined)
        return false;
    if (!('topLevelQuestionTreeNode' in value) || value['topLevelQuestionTreeNode'] === undefined)
        return false;
    return true;
}
function QuestionTreeNodesReducedAttributesFromJSON(json) {
    return QuestionTreeNodesReducedAttributesFromJSONTyped(json);
}
function QuestionTreeNodesReducedAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'questionId': json['questionId'],
        'answerRequired': json['answerRequired'],
        'qualificationScript': json['qualificationScript'],
        'childOptions': (json['childOptions'].map(NextQuestionOptionFromJSON)),
        'siblingOptions': (json['siblingOptions'].map(NextQuestionOptionFromJSON)),
        'topLevelQuestionTreeNode': json['topLevelQuestionTreeNode'],
    };
}
function QuestionTreeNodesReducedAttributesToJSON(json) {
    return QuestionTreeNodesReducedAttributesToJSONTyped(json);
}
function QuestionTreeNodesReducedAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'questionId': value['questionId'],
        'answerRequired': value['answerRequired'],
        'qualificationScript': value['qualificationScript'],
        'childOptions': (value['childOptions'].map(NextQuestionOptionToJSON)),
        'siblingOptions': (value['siblingOptions'].map(NextQuestionOptionToJSON)),
        'topLevelQuestionTreeNode': value['topLevelQuestionTreeNode'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the QuestionTreeNodesReduced interface.
 */
function instanceOfQuestionTreeNodesReduced(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function QuestionTreeNodesReducedFromJSON(json) {
    return QuestionTreeNodesReducedFromJSONTyped(json);
}
function QuestionTreeNodesReducedFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': QuestionTreeNodesReducedAttributesFromJSON(json['attributes']),
    };
}
function QuestionTreeNodesReducedToJSON(json) {
    return QuestionTreeNodesReducedToJSONTyped(json);
}
function QuestionTreeNodesReducedToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': QuestionTreeNodesReducedAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the InlineObject8Included interface.
 */
function instanceOfInlineObject8Included(value) {
    return true;
}
function InlineObject8IncludedFromJSON(json) {
    return InlineObject8IncludedFromJSONTyped(json);
}
function InlineObject8IncludedFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'formFields': json['formFields'] == null ? undefined : (json['formFields'].map(FormFieldsReducedFromJSON)),
        'questionTreeNodes': json['questionTreeNodes'] == null ? undefined : (json['questionTreeNodes'].map(QuestionTreeNodesReducedFromJSON)),
    };
}
function InlineObject8IncludedToJSON(json) {
    return InlineObject8IncludedToJSONTyped(json);
}
function InlineObject8IncludedToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'formFields': value['formFields'] == null ? undefined : (value['formFields'].map(FormFieldsReducedToJSON)),
        'questionTreeNodes': value['questionTreeNodes'] == null ? undefined : (value['questionTreeNodes'].map(QuestionTreeNodesReducedToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the InlineObject8 interface.
 */
function instanceOfInlineObject8(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function InlineObject8FromJSON(json) {
    return InlineObject8FromJSONTyped(json);
}
function InlineObject8FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'meta': json['meta'] == null ? undefined : AbsenceCaseQuestionMetaFromJSON(json['meta']),
        'data': (json['data'].map(AbsenceCaseQuestionFromJSON)),
        'included': json['included'] == null ? undefined : InlineObject8IncludedFromJSON(json['included']),
    };
}
function InlineObject8ToJSON(json) {
    return InlineObject8ToJSONTyped(json);
}
function InlineObject8ToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'meta': AbsenceCaseQuestionMetaToJSON(value['meta']),
        'data': (value['data'].map(AbsenceCaseQuestionToJSON)),
        'included': InlineObject8IncludedToJSON(value['included']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UserCardAttributes interface.
 */
function instanceOfUserCardAttributes(value) {
    return true;
}
function UserCardAttributesFromJSON(json) {
    return UserCardAttributesFromJSONTyped(json);
}
function UserCardAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'middleNames': json['middleNames'] == null ? undefined : json['middleNames'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'emailAddress': json['emailAddress'] == null ? undefined : json['emailAddress'],
    };
}
function UserCardAttributesToJSON(json) {
    return UserCardAttributesToJSONTyped(json);
}
function UserCardAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'firstName': value['firstName'],
        'middleNames': value['middleNames'],
        'lastName': value['lastName'],
        'emailAddress': value['emailAddress'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var InlineObject9IncludedInnerOneOfTypeEnum = {
    User: 'user'
};
/**
 * Check if a given object implements the InlineObject9IncludedInnerOneOf interface.
 */
function instanceOfInlineObject9IncludedInnerOneOf(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function InlineObject9IncludedInnerOneOfFromJSON(json) {
    return InlineObject9IncludedInnerOneOfFromJSONTyped(json);
}
function InlineObject9IncludedInnerOneOfFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'],
        'attributes': json['attributes'] == null ? undefined : UserCardAttributesFromJSON(json['attributes']),
    };
}
function InlineObject9IncludedInnerOneOfToJSON(json) {
    return InlineObject9IncludedInnerOneOfToJSONTyped(json);
}
function InlineObject9IncludedInnerOneOfToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': UserCardAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var InlineObject9IncludedInnerOneOf1TypeEnum = {
    AbsenceCase: 'absenceCase'
};
/**
 * Check if a given object implements the InlineObject9IncludedInnerOneOf1 interface.
 */
function instanceOfInlineObject9IncludedInnerOneOf1(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function InlineObject9IncludedInnerOneOf1FromJSON(json) {
    return InlineObject9IncludedInnerOneOf1FromJSONTyped(json);
}
function InlineObject9IncludedInnerOneOf1FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': AbsenceCaseAttributesFromJSON(json['attributes']),
        'relationships': json['relationships'] == null ? undefined : AbsenceCaseRelationshipsFromJSON(json['relationships']),
    };
}
function InlineObject9IncludedInnerOneOf1ToJSON(json) {
    return InlineObject9IncludedInnerOneOf1ToJSONTyped(json);
}
function InlineObject9IncludedInnerOneOf1ToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': AbsenceCaseAttributesToJSON(value['attributes']),
        'relationships': AbsenceCaseRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
function InlineObject9IncludedInnerFromJSON(json) {
    return InlineObject9IncludedInnerFromJSONTyped(json);
}
function InlineObject9IncludedInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfInlineObject9IncludedInnerOneOf(json)) {
        return InlineObject9IncludedInnerOneOfFromJSONTyped(json);
    }
    if (instanceOfInlineObject9IncludedInnerOneOf1(json)) {
        return InlineObject9IncludedInnerOneOf1FromJSONTyped(json);
    }
    return {};
}
function InlineObject9IncludedInnerToJSON(json) {
    return InlineObject9IncludedInnerToJSONTyped(json);
}
function InlineObject9IncludedInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfInlineObject9IncludedInnerOneOf(value)) {
        return InlineObject9IncludedInnerOneOfToJSON(value);
    }
    if (instanceOfInlineObject9IncludedInnerOneOf1(value)) {
        return InlineObject9IncludedInnerOneOf1ToJSON(value);
    }
    return {};
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the InlineObject9 interface.
 */
function instanceOfInlineObject9(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function InlineObject9FromJSON(json) {
    return InlineObject9FromJSONTyped(json);
}
function InlineObject9FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': AbsenceCaseUploadDocumentsResponseFromJSON(json['data']),
        'included': json['included'] == null ? undefined : (json['included'].map(InlineObject9IncludedInnerFromJSON)),
    };
}
function InlineObject9ToJSON(json) {
    return InlineObject9ToJSONTyped(json);
}
function InlineObject9ToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': AbsenceCaseUploadDocumentsResponseToJSON(value['data']),
        'included': value['included'] == null ? undefined : (value['included'].map(InlineObject9IncludedInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the JobCardAttributes interface.
 */
function instanceOfJobCardAttributes(value) {
    return true;
}
function JobCardAttributesFromJSON(json) {
    return JobCardAttributesFromJSONTyped(json);
}
function JobCardAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'clientEmployeeJobId': json['clientEmployeeJobId'] == null ? undefined : json['clientEmployeeJobId'],
        'jobDescription': json['jobDescription'] == null ? undefined : json['jobDescription'],
    };
}
function JobCardAttributesToJSON(json) {
    return JobCardAttributesToJSONTyped(json);
}
function JobCardAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'clientEmployeeJobId': value['clientEmployeeJobId'],
        'jobDescription': value['jobDescription'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the JobCard interface.
 */
function instanceOfJobCard(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function JobCardFromJSON(json) {
    return JobCardFromJSONTyped(json);
}
function JobCardFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': json['attributes'] == null ? undefined : JobCardAttributesFromJSON(json['attributes']),
    };
}
function JobCardToJSON(json) {
    return JobCardToJSONTyped(json);
}
function JobCardToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': JobCardAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the Links interface.
 */
function instanceOfLinks(value) {
    if (!('prev' in value) || value['prev'] === undefined)
        return false;
    if (!('next' in value) || value['next'] === undefined)
        return false;
    return true;
}
function LinksFromJSON(json) {
    return LinksFromJSONTyped(json);
}
function LinksFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'prev': json['prev'],
        'next': json['next'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
    };
}
function LinksToJSON(json) {
    return LinksToJSONTyped(json);
}
function LinksToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'prev': value['prev'],
        'next': value['next'],
        'first': value['first'],
        'last': value['last'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the ListBankMetadataResponseSchema interface.
 */
function instanceOfListBankMetadataResponseSchema(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    if (!('links' in value) || value['links'] === undefined)
        return false;
    if (!('meta' in value) || value['meta'] === undefined)
        return false;
    return true;
}
function ListBankMetadataResponseSchemaFromJSON(json) {
    return ListBankMetadataResponseSchemaFromJSONTyped(json);
}
function ListBankMetadataResponseSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(BankMetadataFromJSON)),
        'links': LinksFromJSON(json['links']),
        'meta': BankMetadataMetaFromJSON(json['meta']),
    };
}
function ListBankMetadataResponseSchemaToJSON(json) {
    return ListBankMetadataResponseSchemaToJSONTyped(json);
}
function ListBankMetadataResponseSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(BankMetadataToJSON)),
        'links': LinksToJSON(value['links']),
        'meta': BankMetadataMetaToJSON(value['meta']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
function ListBanksResponseIncludedItemFromJSON(json) {
    return ListBanksResponseIncludedItemFromJSONTyped(json);
}
function ListBanksResponseIncludedItemFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfIncludedEmployeeInformation(json)) {
        return IncludedEmployeeInformationFromJSONTyped(json);
    }
    if (instanceOfIncludedJobInformation(json)) {
        return IncludedJobInformationFromJSONTyped(json);
    }
    return {};
}
function ListBanksResponseIncludedItemToJSON(json) {
    return ListBanksResponseIncludedItemToJSONTyped(json);
}
function ListBanksResponseIncludedItemToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfIncludedEmployeeInformation(value)) {
        return IncludedEmployeeInformationToJSON(value);
    }
    if (instanceOfIncludedJobInformation(value)) {
        return IncludedJobInformationToJSON(value);
    }
    return {};
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the Meta interface.
 */
function instanceOfMeta(value) {
    return true;
}
function MetaFromJSON(json) {
    return MetaFromJSONTyped(json);
}
function MetaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'page': json['page'] == null ? undefined : PageMetadataFromJSON(json['page']),
    };
}
function MetaToJSON(json) {
    return MetaToJSONTyped(json);
}
function MetaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'page': PageMetadataToJSON(value['page']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the ListBanksResponseSchema interface.
 */
function instanceOfListBanksResponseSchema(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function ListBanksResponseSchemaFromJSON(json) {
    return ListBanksResponseSchemaFromJSONTyped(json);
}
function ListBanksResponseSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'meta': json['meta'] == null ? undefined : MetaFromJSON(json['meta']),
        'links': json['links'] == null ? undefined : LinksFromJSON(json['links']),
        'data': (json['data'].map(EmployeeBankFromJSON)),
        'included': json['included'] == null ? undefined : (json['included'].map(ListBanksResponseIncludedItemFromJSON)),
    };
}
function ListBanksResponseSchemaToJSON(json) {
    return ListBanksResponseSchemaToJSONTyped(json);
}
function ListBanksResponseSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'meta': MetaToJSON(value['meta']),
        'links': LinksToJSON(value['links']),
        'data': (value['data'].map(EmployeeBankToJSON)),
        'included': value['included'] == null ? undefined : (value['included'].map(ListBanksResponseIncludedItemToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the ListBidPackagesResponseSchema interface.
 */
function instanceOfListBidPackagesResponseSchema(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function ListBidPackagesResponseSchemaFromJSON(json) {
    return ListBidPackagesResponseSchemaFromJSONTyped(json);
}
function ListBidPackagesResponseSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(BidPackageFromJSON)),
        'links': json['links'] == null ? undefined : LinksFromJSON(json['links']),
    };
}
function ListBidPackagesResponseSchemaToJSON(json) {
    return ListBidPackagesResponseSchemaToJSONTyped(json);
}
function ListBidPackagesResponseSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(BidPackageToJSON)),
        'links': LinksToJSON(value['links']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ListDataElementsFilterParameter interface.
 */
function instanceOfListDataElementsFilterParameter(value) {
    return true;
}
function ListDataElementsFilterParameterFromJSON(json) {
    return ListDataElementsFilterParameterFromJSONTyped(json);
}
function ListDataElementsFilterParameterFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'dataEntities': json['dataEntities'] == null ? undefined : json['dataEntities'],
    };
}
function ListDataElementsFilterParameterToJSON(json) {
    return ListDataElementsFilterParameterToJSONTyped(json);
}
function ListDataElementsFilterParameterToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'dataEntities': value['dataEntities'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the ListDataElementsResponseSchema interface.
 */
function instanceOfListDataElementsResponseSchema(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function ListDataElementsResponseSchemaFromJSON(json) {
    return ListDataElementsResponseSchemaFromJSONTyped(json);
}
function ListDataElementsResponseSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(DataElementFromJSON)),
    };
}
function ListDataElementsResponseSchemaToJSON(json) {
    return ListDataElementsResponseSchemaToJSONTyped(json);
}
function ListDataElementsResponseSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(DataElementToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ShiftIncludedObject interface.
 */
function instanceOfShiftIncludedObject(value) {
    return true;
}
function ShiftIncludedObjectFromJSON(json) {
    return ShiftIncludedObjectFromJSONTyped(json);
}
function ShiftIncludedObjectFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'attributes': json['attributes'] == null ? undefined : json['attributes'],
    };
}
function ShiftIncludedObjectToJSON(json) {
    return ShiftIncludedObjectToJSONTyped(json);
}
function ShiftIncludedObjectToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': value['attributes'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the SingleShiftRelationships interface.
 */
function instanceOfSingleShiftRelationships(value) {
    return true;
}
function SingleShiftRelationshipsFromJSON(json) {
    return SingleShiftRelationshipsFromJSONTyped(json);
}
function SingleShiftRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'activities': json['activities'] == null ? undefined : ActivitiesRelationshipFromJSON(json['activities']),
        'employee': json['employee'] == null ? undefined : EmployeeRelationshipFromJSON(json['employee']),
        'role': json['role'] == null ? undefined : RoleRelationshipFromJSON(json['role']),
        'reasonCode': json['reasonCode'] == null ? undefined : ReasonCodeRelationshipFromJSON(json['reasonCode']),
        'overtimeType': json['overtimeType'] == null ? undefined : OvertimeTypeRelationshipFromJSON(json['overtimeType']),
        'selectionConstraint': json['selectionConstraint'] == null ? undefined : SelectionConstraintRelationshipFromJSON(json['selectionConstraint']),
        'event': json['event'] == null ? undefined : ShiftEventRelationshipFromJSON(json['event']),
    };
}
function SingleShiftRelationshipsToJSON(json) {
    return SingleShiftRelationshipsToJSONTyped(json);
}
function SingleShiftRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'activities': ActivitiesRelationshipToJSON(value['activities']),
        'employee': EmployeeRelationshipToJSON(value['employee']),
        'role': RoleRelationshipToJSON(value['role']),
        'reasonCode': ReasonCodeRelationshipToJSON(value['reasonCode']),
        'overtimeType': OvertimeTypeRelationshipToJSON(value['overtimeType']),
        'selectionConstraint': SelectionConstraintRelationshipToJSON(value['selectionConstraint']),
        'event': ShiftEventRelationshipToJSON(value['event']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the SingleShiftBreak interface.
 */
function instanceOfSingleShiftBreak(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('startsAt' in value) || value['startsAt'] === undefined)
        return false;
    if (!('endsAt' in value) || value['endsAt'] === undefined)
        return false;
    if (!('isPaid' in value) || value['isPaid'] === undefined)
        return false;
    return true;
}
function SingleShiftBreakFromJSON(json) {
    return SingleShiftBreakFromJSONTyped(json);
}
function SingleShiftBreakFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'startsAt': (luxon.DateTime.fromISO(json['startsAt'])),
        'endsAt': (luxon.DateTime.fromISO(json['endsAt'])),
        'isPaid': json['isPaid'],
    };
}
function SingleShiftBreakToJSON(json) {
    return SingleShiftBreakToJSONTyped(json);
}
function SingleShiftBreakToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'startsAt': value['startsAt'].toISO(),
        'endsAt': value['endsAt'].toISO(),
        'isPaid': value['isPaid'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var SingleShiftAttributesStatusEnum = {
    Draft: 'DRAFT',
    Offered: 'OFFERED',
    Assigned: 'ASSIGNED',
    Published: 'PUBLISHED',
    Confirmed: 'CONFIRMED',
    Cancelled: 'CANCELLED'
};
/**
 * Check if a given object implements the SingleShiftAttributes interface.
 */
function instanceOfSingleShiftAttributes(value) {
    return true;
}
function SingleShiftAttributesFromJSON(json) {
    return SingleShiftAttributesFromJSONTyped(json);
}
function SingleShiftAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'startsAt': json['startsAt'] == null ? undefined : (luxon.DateTime.fromISO(json['startsAt'])),
        'endsAt': json['endsAt'] == null ? undefined : (luxon.DateTime.fromISO(json['endsAt'])),
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
        'status': json['status'] == null ? undefined : json['status'],
        'breaks': json['breaks'] == null ? undefined : (json['breaks'].map(SingleShiftBreakFromJSON)),
        'comments': json['comments'] == null ? undefined : json['comments'],
    };
}
function SingleShiftAttributesToJSON(json) {
    return SingleShiftAttributesToJSONTyped(json);
}
function SingleShiftAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'startsAt': value['startsAt'] == null ? value['startsAt'] : value['startsAt'].toISO(),
        'endsAt': value['endsAt'] == null ? value['endsAt'] : value['endsAt'].toISO(),
        'status': value['status'],
        'breaks': value['breaks'] == null ? undefined : (value['breaks'].map(SingleShiftBreakToJSON)),
        'comments': value['comments'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var SingleShiftTypeEnum = {
    Shift: 'shift'
};
/**
 * Check if a given object implements the SingleShift interface.
 */
function instanceOfSingleShift(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('relationships' in value) || value['relationships'] === undefined)
        return false;
    return true;
}
function SingleShiftFromJSON(json) {
    return SingleShiftFromJSONTyped(json);
}
function SingleShiftFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': json['attributes'] == null ? undefined : SingleShiftAttributesFromJSON(json['attributes']),
        'relationships': SingleShiftRelationshipsFromJSON(json['relationships']),
    };
}
function SingleShiftToJSON(json) {
    return SingleShiftToJSONTyped(json);
}
function SingleShiftToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': SingleShiftAttributesToJSON(value['attributes']),
        'relationships': SingleShiftRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the ListShiftsResponseSchema interface.
 */
function instanceOfListShiftsResponseSchema(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function ListShiftsResponseSchemaFromJSON(json) {
    return ListShiftsResponseSchemaFromJSONTyped(json);
}
function ListShiftsResponseSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'links': json['links'] == null ? undefined : LinksFromJSON(json['links']),
        'data': (json['data'].map(SingleShiftFromJSON)),
        'included': json['included'] == null ? undefined : (json['included'].map(ShiftIncludedObjectFromJSON)),
    };
}
function ListShiftsResponseSchemaToJSON(json) {
    return ListShiftsResponseSchemaToJSONTyped(json);
}
function ListShiftsResponseSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'links': LinksToJSON(value['links']),
        'data': (value['data'].map(SingleShiftToJSON)),
        'included': value['included'] == null ? undefined : (value['included'].map(ShiftIncludedObjectToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the MasterPolicy interface.
 */
function instanceOfMasterPolicy(value) {
    if (!('fields' in value) || value['fields'] === undefined)
        return false;
    return true;
}
function MasterPolicyFromJSON(json) {
    return MasterPolicyFromJSONTyped(json);
}
function MasterPolicyFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fields': (mapValues(json['fields'], FieldValueFromJSON)),
    };
}
function MasterPolicyToJSON(json) {
    return MasterPolicyToJSONTyped(json);
}
function MasterPolicyToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'fields': (mapValues(value['fields'], FieldValueToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the ModelError interface.
 */
function instanceOfModelError(value) {
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
function ModelErrorFromJSON(json) {
    return ModelErrorFromJSONTyped(json);
}
function ModelErrorFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'title': json['title'],
        'status': json['status'],
        'detail': json['detail'] == null ? undefined : json['detail'],
        'source': json['source'] == null ? undefined : ErrorSourceFromJSON(json['source']),
        'code': json['code'] == null ? undefined : json['code'],
        'id': json['id'] == null ? undefined : json['id'],
        'meta': json['meta'] == null ? undefined : json['meta'],
    };
}
function ModelErrorToJSON(json) {
    return ModelErrorToJSONTyped(json);
}
function ModelErrorToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'title': value['title'],
        'status': value['status'],
        'detail': value['detail'],
        'source': ErrorSourceToJSON(value['source']),
        'code': value['code'],
        'id': value['id'],
        'meta': value['meta'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PageData interface.
 */
function instanceOfPageData(value) {
    return true;
}
function PageDataFromJSON(json) {
    return PageDataFromJSONTyped(json);
}
function PageDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'size': json['size'] == null ? undefined : json['size'],
        'before': json['before'] == null ? undefined : json['before'],
        'after': json['after'] == null ? undefined : json['after'],
    };
}
function PageDataToJSON(json) {
    return PageDataToJSONTyped(json);
}
function PageDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'size': value['size'],
        'before': value['before'],
        'after': value['after'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PayCodeCardAttributes interface.
 */
function instanceOfPayCodeCardAttributes(value) {
    if (!('payCode' in value) || value['payCode'] === undefined)
        return false;
    return true;
}
function PayCodeCardAttributesFromJSON(json) {
    return PayCodeCardAttributesFromJSONTyped(json);
}
function PayCodeCardAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'payCode': json['payCode'],
        'entryLabel': json['entryLabel'] == null ? undefined : json['entryLabel'],
    };
}
function PayCodeCardAttributesToJSON(json) {
    return PayCodeCardAttributesToJSONTyped(json);
}
function PayCodeCardAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'payCode': value['payCode'],
        'entryLabel': value['entryLabel'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the PayCodeCard interface.
 */
function instanceOfPayCodeCard(value) {
    return true;
}
function PayCodeCardFromJSON(json) {
    return PayCodeCardFromJSONTyped(json);
}
function PayCodeCardFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'attributes': json['attributes'] == null ? undefined : PayCodeCardAttributesFromJSON(json['attributes']),
    };
}
function PayCodeCardToJSON(json) {
    return PayCodeCardToJSONTyped(json);
}
function PayCodeCardToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': PayCodeCardAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PayCodeRelationshipData interface.
 */
function instanceOfPayCodeRelationshipData(value) {
    return true;
}
function PayCodeRelationshipDataFromJSON(json) {
    return PayCodeRelationshipDataFromJSONTyped(json);
}
function PayCodeRelationshipDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}
function PayCodeRelationshipDataToJSON(json) {
    return PayCodeRelationshipDataToJSONTyped(json);
}
function PayCodeRelationshipDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the PayCodeRelationship interface.
 */
function instanceOfPayCodeRelationship(value) {
    return true;
}
function PayCodeRelationshipFromJSON(json) {
    return PayCodeRelationshipFromJSONTyped(json);
}
function PayCodeRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : PayCodeRelationshipDataFromJSON(json['data']),
    };
}
function PayCodeRelationshipToJSON(json) {
    return PayCodeRelationshipToJSONTyped(json);
}
function PayCodeRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': PayCodeRelationshipDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PayRuleAttributes interface.
 */
function instanceOfPayRuleAttributes(value) {
    return true;
}
function PayRuleAttributesFromJSON(json) {
    return PayRuleAttributesFromJSONTyped(json);
}
function PayRuleAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'] == null ? undefined : json['name'],
        'payCode': json['payCode'] == null ? undefined : json['payCode'],
        'priority': json['priority'] == null ? undefined : json['priority'],
    };
}
function PayRuleAttributesToJSON(json) {
    return PayRuleAttributesToJSONTyped(json);
}
function PayRuleAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'payCode': value['payCode'],
        'priority': value['priority'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the PayRuleRelationships interface.
 */
function instanceOfPayRuleRelationships(value) {
    return true;
}
function PayRuleRelationshipsFromJSON(json) {
    return PayRuleRelationshipsFromJSONTyped(json);
}
function PayRuleRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'constraint': json['constraint'] == null ? undefined : PayRuleKeyValueRelationshipFromJSON(json['constraint']),
        'comparator': json['comparator'] == null ? undefined : PayRuleKeyValueRelationshipFromJSON(json['comparator']),
        'period': json['period'] == null ? undefined : PayRuleKeyValueRelationshipFromJSON(json['period']),
    };
}
function PayRuleRelationshipsToJSON(json) {
    return PayRuleRelationshipsToJSONTyped(json);
}
function PayRuleRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'constraint': PayRuleKeyValueRelationshipToJSON(value['constraint']),
        'comparator': PayRuleKeyValueRelationshipToJSON(value['comparator']),
        'period': PayRuleKeyValueRelationshipToJSON(value['period']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var PayRuleTypeEnum = {
    PayRule: 'payRule'
};
/**
 * Check if a given object implements the PayRule interface.
 */
function instanceOfPayRule(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    if (!('relationships' in value) || value['relationships'] === undefined)
        return false;
    return true;
}
function PayRuleFromJSON(json) {
    return PayRuleFromJSONTyped(json);
}
function PayRuleFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': PayRuleAttributesFromJSON(json['attributes']),
        'relationships': PayRuleRelationshipsFromJSON(json['relationships']),
    };
}
function PayRuleToJSON(json) {
    return PayRuleToJSONTyped(json);
}
function PayRuleToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': PayRuleAttributesToJSON(value['attributes']),
        'relationships': PayRuleRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PayRuleIncludedObjectAttributes interface.
 */
function instanceOfPayRuleIncludedObjectAttributes(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
function PayRuleIncludedObjectAttributesFromJSON(json) {
    return PayRuleIncludedObjectAttributesFromJSONTyped(json);
}
function PayRuleIncludedObjectAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
    };
}
function PayRuleIncludedObjectAttributesToJSON(json) {
    return PayRuleIncludedObjectAttributesToJSONTyped(json);
}
function PayRuleIncludedObjectAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var PayRuleIncludedObjectTypeEnum = {
    Constraint: 'constraint',
    Comparator: 'comparator',
    Period: 'period'
};
/**
 * Check if a given object implements the PayRuleIncludedObject interface.
 */
function instanceOfPayRuleIncludedObject(value) {
    return true;
}
function PayRuleIncludedObjectFromJSON(json) {
    return PayRuleIncludedObjectFromJSONTyped(json);
}
function PayRuleIncludedObjectFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'attributes': json['attributes'] == null ? undefined : PayRuleIncludedObjectAttributesFromJSON(json['attributes']),
    };
}
function PayRuleIncludedObjectToJSON(json) {
    return PayRuleIncludedObjectToJSONTyped(json);
}
function PayRuleIncludedObjectToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': PayRuleIncludedObjectAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the PayRuleCollectionResponseSchema interface.
 */
function instanceOfPayRuleCollectionResponseSchema(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function PayRuleCollectionResponseSchemaFromJSON(json) {
    return PayRuleCollectionResponseSchemaFromJSONTyped(json);
}
function PayRuleCollectionResponseSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'links': json['links'] == null ? undefined : LinksFromJSON(json['links']),
        'data': (json['data'].map(PayRuleFromJSON)),
        'included': json['included'] == null ? undefined : (json['included'].map(PayRuleIncludedObjectFromJSON)),
    };
}
function PayRuleCollectionResponseSchemaToJSON(json) {
    return PayRuleCollectionResponseSchemaToJSONTyped(json);
}
function PayRuleCollectionResponseSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'links': LinksToJSON(value['links']),
        'data': (value['data'].map(PayRuleToJSON)),
        'included': value['included'] == null ? undefined : (value['included'].map(PayRuleIncludedObjectToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the PayRuleConstraintRelationships interface.
 */
function instanceOfPayRuleConstraintRelationships(value) {
    return true;
}
function PayRuleConstraintRelationshipsFromJSON(json) {
    return PayRuleConstraintRelationshipsFromJSONTyped(json);
}
function PayRuleConstraintRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'comparators': json['comparators'] == null ? undefined : (json['comparators'].map(PayRuleKeyValueRelationshipFromJSON)),
        'periods': json['periods'] == null ? undefined : (json['periods'].map(PayRuleKeyValueRelationshipFromJSON)),
    };
}
function PayRuleConstraintRelationshipsToJSON(json) {
    return PayRuleConstraintRelationshipsToJSONTyped(json);
}
function PayRuleConstraintRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'comparators': value['comparators'] == null ? undefined : (value['comparators'].map(PayRuleKeyValueRelationshipToJSON)),
        'periods': value['periods'] == null ? undefined : (value['periods'].map(PayRuleKeyValueRelationshipToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PayRuleConstraintAttributes interface.
 */
function instanceOfPayRuleConstraintAttributes(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
function PayRuleConstraintAttributesFromJSON(json) {
    return PayRuleConstraintAttributesFromJSONTyped(json);
}
function PayRuleConstraintAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
    };
}
function PayRuleConstraintAttributesToJSON(json) {
    return PayRuleConstraintAttributesToJSONTyped(json);
}
function PayRuleConstraintAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var PayRuleConstraintTypeEnum = {
    PayRuleConstraint: 'payRuleConstraint'
};
/**
 * Check if a given object implements the PayRuleConstraint interface.
 */
function instanceOfPayRuleConstraint(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    if (!('relationships' in value) || value['relationships'] === undefined)
        return false;
    return true;
}
function PayRuleConstraintFromJSON(json) {
    return PayRuleConstraintFromJSONTyped(json);
}
function PayRuleConstraintFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': PayRuleConstraintAttributesFromJSON(json['attributes']),
        'relationships': PayRuleConstraintRelationshipsFromJSON(json['relationships']),
    };
}
function PayRuleConstraintToJSON(json) {
    return PayRuleConstraintToJSONTyped(json);
}
function PayRuleConstraintToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': PayRuleConstraintAttributesToJSON(value['attributes']),
        'relationships': PayRuleConstraintRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the PayRuleConstraintCollectionResponseSchema interface.
 */
function instanceOfPayRuleConstraintCollectionResponseSchema(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function PayRuleConstraintCollectionResponseSchemaFromJSON(json) {
    return PayRuleConstraintCollectionResponseSchemaFromJSONTyped(json);
}
function PayRuleConstraintCollectionResponseSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'links': json['links'] == null ? undefined : LinksFromJSON(json['links']),
        'data': (json['data'].map(PayRuleConstraintFromJSON)),
        'included': json['included'] == null ? undefined : (json['included'].map(PayRuleIncludedObjectFromJSON)),
    };
}
function PayRuleConstraintCollectionResponseSchemaToJSON(json) {
    return PayRuleConstraintCollectionResponseSchemaToJSONTyped(json);
}
function PayRuleConstraintCollectionResponseSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'links': LinksToJSON(value['links']),
        'data': (value['data'].map(PayRuleConstraintToJSON)),
        'included': value['included'] == null ? undefined : (value['included'].map(PayRuleIncludedObjectToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the PolicyAttributes interface.
 */
function instanceOfPolicyAttributes(value) {
    if (!('masterPolicies' in value) || value['masterPolicies'] === undefined)
        return false;
    return true;
}
function PolicyAttributesFromJSON(json) {
    return PolicyAttributesFromJSONTyped(json);
}
function PolicyAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'masterPolicies': (json['masterPolicies'].map(MasterPolicyFromJSON)),
        'childGroupPolicies': json['childGroupPolicies'] == null ? undefined : (json['childGroupPolicies'].map(ChildGroupPolicyFromJSON)),
    };
}
function PolicyAttributesToJSON(json) {
    return PolicyAttributesToJSONTyped(json);
}
function PolicyAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'masterPolicies': (value['masterPolicies'].map(MasterPolicyToJSON)),
        'childGroupPolicies': value['childGroupPolicies'] == null ? undefined : (value['childGroupPolicies'].map(ChildGroupPolicyToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the Policy interface.
 */
function instanceOfPolicy(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function PolicyFromJSON(json) {
    return PolicyFromJSONTyped(json);
}
function PolicyFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': PolicyAttributesFromJSON(json['attributes']),
    };
}
function PolicyToJSON(json) {
    return PolicyToJSONTyped(json);
}
function PolicyToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': PolicyAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the PoliciesResponseSchema interface.
 */
function instanceOfPoliciesResponseSchema(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function PoliciesResponseSchemaFromJSON(json) {
    return PoliciesResponseSchemaFromJSONTyped(json);
}
function PoliciesResponseSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(PolicyFromJSON)),
    };
}
function PoliciesResponseSchemaToJSON(json) {
    return PoliciesResponseSchemaToJSONTyped(json);
}
function PoliciesResponseSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(PolicyToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the PolicySetDetailRecord interface.
 */
function instanceOfPolicySetDetailRecord(value) {
    if (!('tableName' in value) || value['tableName'] === undefined)
        return false;
    if (!('fields' in value) || value['fields'] === undefined)
        return false;
    return true;
}
function PolicySetDetailRecordFromJSON(json) {
    return PolicySetDetailRecordFromJSONTyped(json);
}
function PolicySetDetailRecordFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'tableName': json['tableName'],
        'fields': (mapValues(json['fields'], FieldValueFromJSON)),
    };
}
function PolicySetDetailRecordToJSON(json) {
    return PolicySetDetailRecordToJSONTyped(json);
}
function PolicySetDetailRecordToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'tableName': value['tableName'],
        'fields': (mapValues(value['fields'], FieldValueToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the PolicySetDetailsAttributes interface.
 */
function instanceOfPolicySetDetailsAttributes(value) {
    if (!('fields' in value) || value['fields'] === undefined)
        return false;
    if (!('policySetDetails' in value) || value['policySetDetails'] === undefined)
        return false;
    return true;
}
function PolicySetDetailsAttributesFromJSON(json) {
    return PolicySetDetailsAttributesFromJSONTyped(json);
}
function PolicySetDetailsAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fields': (mapValues(json['fields'], FieldValueFromJSON)),
        'policySetDetails': (json['policySetDetails'].map(PolicySetDetailRecordFromJSON)),
    };
}
function PolicySetDetailsAttributesToJSON(json) {
    return PolicySetDetailsAttributesToJSONTyped(json);
}
function PolicySetDetailsAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'fields': (mapValues(value['fields'], FieldValueToJSON)),
        'policySetDetails': (value['policySetDetails'].map(PolicySetDetailRecordToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the PolicySetDetails interface.
 */
function instanceOfPolicySetDetails(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function PolicySetDetailsFromJSON(json) {
    return PolicySetDetailsFromJSONTyped(json);
}
function PolicySetDetailsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': PolicySetDetailsAttributesFromJSON(json['attributes']),
    };
}
function PolicySetDetailsToJSON(json) {
    return PolicySetDetailsToJSONTyped(json);
}
function PolicySetDetailsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': PolicySetDetailsAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the PolicySetDetailsResponseSchema interface.
 */
function instanceOfPolicySetDetailsResponseSchema(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function PolicySetDetailsResponseSchemaFromJSON(json) {
    return PolicySetDetailsResponseSchemaFromJSONTyped(json);
}
function PolicySetDetailsResponseSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(PolicySetDetailsFromJSON)),
    };
}
function PolicySetDetailsResponseSchemaToJSON(json) {
    return PolicySetDetailsResponseSchemaToJSONTyped(json);
}
function PolicySetDetailsResponseSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(PolicySetDetailsToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
var PolicyTypeAttributesTableTypeEnum = {
    RuleMaster: 'RULE_MASTER',
    RuleMasterEff: 'RULE_MASTER_EFF',
    RuleDetail: 'RULE_DETAIL',
    RuleMasterDetail: 'RULE_MASTER_DETAIL'
};
/**
 * Check if a given object implements the PolicyTypeAttributes interface.
 */
function instanceOfPolicyTypeAttributes(value) {
    if (!('description' in value) || value['description'] === undefined)
        return false;
    if (!('tableType' in value) || value['tableType'] === undefined)
        return false;
    if (!('policyCategoryLabel' in value) || value['policyCategoryLabel'] === undefined)
        return false;
    return true;
}
function PolicyTypeAttributesFromJSON(json) {
    return PolicyTypeAttributesFromJSONTyped(json);
}
function PolicyTypeAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'description': json['description'],
        'tableType': json['tableType'],
        'policyCategoryLabel': json['policyCategoryLabel'],
    };
}
function PolicyTypeAttributesToJSON(json) {
    return PolicyTypeAttributesToJSONTyped(json);
}
function PolicyTypeAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'description': value['description'],
        'tableType': value['tableType'],
        'policyCategoryLabel': value['policyCategoryLabel'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the PolicyType interface.
 */
function instanceOfPolicyType(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function PolicyTypeFromJSON(json) {
    return PolicyTypeFromJSONTyped(json);
}
function PolicyTypeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': PolicyTypeAttributesFromJSON(json['attributes']),
    };
}
function PolicyTypeToJSON(json) {
    return PolicyTypeToJSONTyped(json);
}
function PolicyTypeToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': PolicyTypeAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the PolicyTypesResponseSchema interface.
 */
function instanceOfPolicyTypesResponseSchema(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function PolicyTypesResponseSchemaFromJSON(json) {
    return PolicyTypesResponseSchemaFromJSONTyped(json);
}
function PolicyTypesResponseSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(PolicyTypeFromJSON)),
    };
}
function PolicyTypesResponseSchemaToJSON(json) {
    return PolicyTypesResponseSchemaToJSONTyped(json);
}
function PolicyTypesResponseSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(PolicyTypeToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the ProjectionBalanceRelationships interface.
 */
function instanceOfProjectionBalanceRelationships(value) {
    if (!('bankPolicy' in value) || value['bankPolicy'] === undefined)
        return false;
    if (!('employee' in value) || value['employee'] === undefined)
        return false;
    if (!('jobs' in value) || value['jobs'] === undefined)
        return false;
    return true;
}
function ProjectionBalanceRelationshipsFromJSON(json) {
    return ProjectionBalanceRelationshipsFromJSONTyped(json);
}
function ProjectionBalanceRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'bankPolicy': BankPolicyRelationshipFromJSON(json['bankPolicy']),
        'employee': EmployeeRelationshipFromJSON(json['employee']),
        'jobs': JobRelationshipsFromJSON(json['jobs']),
    };
}
function ProjectionBalanceRelationshipsToJSON(json) {
    return ProjectionBalanceRelationshipsToJSONTyped(json);
}
function ProjectionBalanceRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'bankPolicy': BankPolicyRelationshipToJSON(value['bankPolicy']),
        'employee': EmployeeRelationshipToJSON(value['employee']),
        'jobs': JobRelationshipsToJSON(value['jobs']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the ProjectionBalanceAttributes interface.
 */
function instanceOfProjectionBalanceAttributes(value) {
    if (!('balanceDate' in value) || value['balanceDate'] === undefined)
        return false;
    if (!('initialBalance' in value) || value['initialBalance'] === undefined)
        return false;
    if (!('finalBalance' in value) || value['finalBalance'] === undefined)
        return false;
    if (!('accrued' in value) || value['accrued'] === undefined)
        return false;
    if (!('used' in value) || value['used'] === undefined)
        return false;
    if (!('cleared' in value) || value['cleared'] === undefined)
        return false;
    if (!('transferred' in value) || value['transferred'] === undefined)
        return false;
    if (!('terminated' in value) || value['terminated'] === undefined)
        return false;
    return true;
}
function ProjectionBalanceAttributesFromJSON(json) {
    return ProjectionBalanceAttributesFromJSONTyped(json);
}
function ProjectionBalanceAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'balanceDate': (dateAndTime.DateWithoutTime.fromISO(json['balanceDate'])),
        'initialBalance': json['initialBalance'],
        'finalBalance': json['finalBalance'],
        'accrued': json['accrued'],
        'used': json['used'],
        'cleared': json['cleared'],
        'transferred': json['transferred'],
        'terminated': json['terminated'],
    };
}
function ProjectionBalanceAttributesToJSON(json) {
    return ProjectionBalanceAttributesToJSONTyped(json);
}
function ProjectionBalanceAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'balanceDate': value['balanceDate'].toISO(),
        'initialBalance': value['initialBalance'],
        'finalBalance': value['finalBalance'],
        'accrued': value['accrued'],
        'used': value['used'],
        'cleared': value['cleared'],
        'transferred': value['transferred'],
        'terminated': value['terminated'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the ProjectionBalance interface.
 */
function instanceOfProjectionBalance(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    if (!('relationships' in value) || value['relationships'] === undefined)
        return false;
    return true;
}
function ProjectionBalanceFromJSON(json) {
    return ProjectionBalanceFromJSONTyped(json);
}
function ProjectionBalanceFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': ProjectionBalanceAttributesFromJSON(json['attributes']),
        'relationships': ProjectionBalanceRelationshipsFromJSON(json['relationships']),
    };
}
function ProjectionBalanceToJSON(json) {
    return ProjectionBalanceToJSONTyped(json);
}
function ProjectionBalanceToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': ProjectionBalanceAttributesToJSON(value['attributes']),
        'relationships': ProjectionBalanceRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
var ProjectionEntryRelationshipsContentTypeEnum = {
    Balance: 'balance',
    Gap: 'gap'
};
/**
 * Check if a given object implements the ProjectionEntryRelationshipsContent interface.
 */
function instanceOfProjectionEntryRelationshipsContent(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function ProjectionEntryRelationshipsContentFromJSON(json) {
    return ProjectionEntryRelationshipsContentFromJSONTyped(json);
}
function ProjectionEntryRelationshipsContentFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
    };
}
function ProjectionEntryRelationshipsContentToJSON(json) {
    return ProjectionEntryRelationshipsContentToJSONTyped(json);
}
function ProjectionEntryRelationshipsContentToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the ProjectionEntryRelationships interface.
 */
function instanceOfProjectionEntryRelationships(value) {
    if (!('content' in value) || value['content'] === undefined)
        return false;
    return true;
}
function ProjectionEntryRelationshipsFromJSON(json) {
    return ProjectionEntryRelationshipsFromJSONTyped(json);
}
function ProjectionEntryRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'content': ProjectionEntryRelationshipsContentFromJSON(json['content']),
    };
}
function ProjectionEntryRelationshipsToJSON(json) {
    return ProjectionEntryRelationshipsToJSONTyped(json);
}
function ProjectionEntryRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'content': ProjectionEntryRelationshipsContentToJSON(value['content']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the ProjectionEntry interface.
 */
function instanceOfProjectionEntry(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('relationships' in value) || value['relationships'] === undefined)
        return false;
    return true;
}
function ProjectionEntryFromJSON(json) {
    return ProjectionEntryFromJSONTyped(json);
}
function ProjectionEntryFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'relationships': ProjectionEntryRelationshipsFromJSON(json['relationships']),
    };
}
function ProjectionEntryToJSON(json) {
    return ProjectionEntryToJSONTyped(json);
}
function ProjectionEntryToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'relationships': ProjectionEntryRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var ProjectionGapAttributesCategoryEnum = {
    UncalculablePeriod: 'UNCALCULABLE_PERIOD',
    BankNotInPolicy: 'BANK_NOT_IN_POLICY',
    Unclassified: 'UNCLASSIFIED'
};
/**
 * Check if a given object implements the ProjectionGapAttributes interface.
 */
function instanceOfProjectionGapAttributes(value) {
    if (!('gapDate' in value) || value['gapDate'] === undefined)
        return false;
    if (!('category' in value) || value['category'] === undefined)
        return false;
    return true;
}
function ProjectionGapAttributesFromJSON(json) {
    return ProjectionGapAttributesFromJSONTyped(json);
}
function ProjectionGapAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'gapDate': (dateAndTime.DateWithoutTime.fromISO(json['gapDate'])),
        'category': json['category'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}
function ProjectionGapAttributesToJSON(json) {
    return ProjectionGapAttributesToJSONTyped(json);
}
function ProjectionGapAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'gapDate': value['gapDate'].toISO(),
        'category': value['category'],
        'description': value['description'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the ProjectionGapRelationships interface.
 */
function instanceOfProjectionGapRelationships(value) {
    if (!('bankPolicy' in value) || value['bankPolicy'] === undefined)
        return false;
    if (!('employee' in value) || value['employee'] === undefined)
        return false;
    if (!('jobs' in value) || value['jobs'] === undefined)
        return false;
    return true;
}
function ProjectionGapRelationshipsFromJSON(json) {
    return ProjectionGapRelationshipsFromJSONTyped(json);
}
function ProjectionGapRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'bankPolicy': BankPolicyRelationshipFromJSON(json['bankPolicy']),
        'employee': EmployeeRelationshipFromJSON(json['employee']),
        'jobs': JobRelationshipsFromJSON(json['jobs']),
    };
}
function ProjectionGapRelationshipsToJSON(json) {
    return ProjectionGapRelationshipsToJSONTyped(json);
}
function ProjectionGapRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'bankPolicy': BankPolicyRelationshipToJSON(value['bankPolicy']),
        'employee': EmployeeRelationshipToJSON(value['employee']),
        'jobs': JobRelationshipsToJSON(value['jobs']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the ProjectionGap interface.
 */
function instanceOfProjectionGap(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    if (!('relationships' in value) || value['relationships'] === undefined)
        return false;
    return true;
}
function ProjectionGapFromJSON(json) {
    return ProjectionGapFromJSONTyped(json);
}
function ProjectionGapFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': ProjectionGapAttributesFromJSON(json['attributes']),
        'relationships': ProjectionGapRelationshipsFromJSON(json['relationships']),
    };
}
function ProjectionGapToJSON(json) {
    return ProjectionGapToJSONTyped(json);
}
function ProjectionGapToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': ProjectionGapAttributesToJSON(value['attributes']),
        'relationships': ProjectionGapRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
function PostBankProjectionIncludedItemFromJSON(json) {
    return PostBankProjectionIncludedItemFromJSONTyped(json);
}
function PostBankProjectionIncludedItemFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfIncludedEmployeeInformation(json)) {
        return IncludedEmployeeInformationFromJSONTyped(json);
    }
    if (instanceOfIncludedJobInformation(json)) {
        return IncludedJobInformationFromJSONTyped(json);
    }
    if (instanceOfProjectionBalance(json)) {
        return ProjectionBalanceFromJSONTyped(json);
    }
    if (instanceOfProjectionEntry(json)) {
        return ProjectionEntryFromJSONTyped(json);
    }
    if (instanceOfProjectionGap(json)) {
        return ProjectionGapFromJSONTyped(json);
    }
    return {};
}
function PostBankProjectionIncludedItemToJSON(json) {
    return PostBankProjectionIncludedItemToJSONTyped(json);
}
function PostBankProjectionIncludedItemToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfIncludedEmployeeInformation(value)) {
        return IncludedEmployeeInformationToJSON(value);
    }
    if (instanceOfIncludedJobInformation(value)) {
        return IncludedJobInformationToJSON(value);
    }
    if (instanceOfProjectionBalance(value)) {
        return ProjectionBalanceToJSON(value);
    }
    if (instanceOfProjectionEntry(value)) {
        return ProjectionEntryToJSON(value);
    }
    if (instanceOfProjectionGap(value)) {
        return ProjectionGapToJSON(value);
    }
    return {};
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the PostBankProjectionResponseSchema interface.
 */
function instanceOfPostBankProjectionResponseSchema(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function PostBankProjectionResponseSchemaFromJSON(json) {
    return PostBankProjectionResponseSchemaFromJSONTyped(json);
}
function PostBankProjectionResponseSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': BankProjectionFromJSON(json['data']),
        'included': json['included'] == null ? undefined : (json['included'].map(PostBankProjectionIncludedItemFromJSON)),
    };
}
function PostBankProjectionResponseSchemaToJSON(json) {
    return PostBankProjectionResponseSchemaToJSONTyped(json);
}
function PostBankProjectionResponseSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': BankProjectionToJSON(value['data']),
        'included': value['included'] == null ? undefined : (value['included'].map(PostBankProjectionIncludedItemToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Represents included resources in timesheet responses.
 * @export
 */
var PostTimesheetEntryIncludeItem = {
    Employee: 'employee',
    Job: 'job',
    Timesheet: 'timesheet',
    TimesheetException: 'timesheetException'
};
function instanceOfPostTimesheetEntryIncludeItem(value) {
    for (var key in PostTimesheetEntryIncludeItem) {
        if (Object.prototype.hasOwnProperty.call(PostTimesheetEntryIncludeItem, key)) {
            if (PostTimesheetEntryIncludeItem[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function PostTimesheetEntryIncludeItemFromJSON(json) {
    return PostTimesheetEntryIncludeItemFromJSONTyped(json);
}
function PostTimesheetEntryIncludeItemFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function PostTimesheetEntryIncludeItemToJSON(value) {
    return value;
}
function PostTimesheetEntryIncludeItemToJSONTyped(value, ignoreDiscriminator) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimesheetExceptionRelationships interface.
 */
function instanceOfTimesheetExceptionRelationships(value) {
    return true;
}
function TimesheetExceptionRelationshipsFromJSON(json) {
    return TimesheetExceptionRelationshipsFromJSONTyped(json);
}
function TimesheetExceptionRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'employee': json['employee'] == null ? undefined : EmployeeRelationshipFromJSON(json['employee']),
        'job': json['job'] == null ? undefined : JobRelationshipFromJSON(json['job']),
    };
}
function TimesheetExceptionRelationshipsToJSON(json) {
    return TimesheetExceptionRelationshipsToJSONTyped(json);
}
function TimesheetExceptionRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'employee': EmployeeRelationshipToJSON(value['employee']),
        'job': JobRelationshipToJSON(value['job']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * The choice to override the exception, it is not nullable. NONE - no override, PRIMARY - for primary acknowledgement, SECONDARY - for secondary acknowledgement.
 * @export
 */
var SelectedOverrideChoice = {
    None: 'NONE',
    Primary: 'PRIMARY',
    Secondary: 'SECONDARY'
};
function instanceOfSelectedOverrideChoice(value) {
    for (var key in SelectedOverrideChoice) {
        if (Object.prototype.hasOwnProperty.call(SelectedOverrideChoice, key)) {
            if (SelectedOverrideChoice[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function SelectedOverrideChoiceFromJSON(json) {
    return SelectedOverrideChoiceFromJSONTyped(json);
}
function SelectedOverrideChoiceFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function SelectedOverrideChoiceToJSON(value) {
    return value;
}
function SelectedOverrideChoiceToJSONTyped(value, ignoreDiscriminator) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimesheetExceptionAttributes interface.
 */
function instanceOfTimesheetExceptionAttributes(value) {
    return true;
}
function TimesheetExceptionAttributesFromJSON(json) {
    return TimesheetExceptionAttributesFromJSONTyped(json);
}
function TimesheetExceptionAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'message': json['message'] == null ? undefined : json['message'],
        'workDate': json['workDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['workDate'])),
        'severity': json['severity'] == null ? undefined : SeverityFromJSON(json['severity']),
        'overridden': json['overridden'] == null ? undefined : json['overridden'],
        'isTwikiFormattingEnabled': json['isTwikiFormattingEnabled'] == null ? undefined : json['isTwikiFormattingEnabled'],
        'selectedOverrideChoice': json['selectedOverrideChoice'] == null ? undefined : SelectedOverrideChoiceFromJSON(json['selectedOverrideChoice']),
        'overrideExceptionCustomLabels': json['overrideExceptionCustomLabels'] == null ? undefined : json['overrideExceptionCustomLabels'],
        'dismissedFromAssistant': json['dismissedFromAssistant'] == null ? undefined : json['dismissedFromAssistant'],
    };
}
function TimesheetExceptionAttributesToJSON(json) {
    return TimesheetExceptionAttributesToJSONTyped(json);
}
function TimesheetExceptionAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'message': value['message'],
        'workDate': value['workDate'] == null ? value['workDate'] : value['workDate'].toISO(),
        'severity': SeverityToJSON(value['severity']),
        'overridden': value['overridden'],
        'isTwikiFormattingEnabled': value['isTwikiFormattingEnabled'],
        'selectedOverrideChoice': SelectedOverrideChoiceToJSON(value['selectedOverrideChoice']),
        'overrideExceptionCustomLabels': value['overrideExceptionCustomLabels'],
        'dismissedFromAssistant': value['dismissedFromAssistant'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimesheetException interface.
 */
function instanceOfTimesheetException(value) {
    return true;
}
function TimesheetExceptionFromJSON(json) {
    return TimesheetExceptionFromJSONTyped(json);
}
function TimesheetExceptionFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'attributes': json['attributes'] == null ? undefined : TimesheetExceptionAttributesFromJSON(json['attributes']),
        'relationships': json['relationships'] == null ? undefined : TimesheetExceptionRelationshipsFromJSON(json['relationships']),
    };
}
function TimesheetExceptionToJSON(json) {
    return TimesheetExceptionToJSONTyped(json);
}
function TimesheetExceptionToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': TimesheetExceptionAttributesToJSON(value['attributes']),
        'relationships': TimesheetExceptionRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the TimeEntriesRelationshipDataInner interface.
 */
function instanceOfTimeEntriesRelationshipDataInner(value) {
    return true;
}
function TimeEntriesRelationshipDataInnerFromJSON(json) {
    return TimeEntriesRelationshipDataInnerFromJSONTyped(json);
}
function TimeEntriesRelationshipDataInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}
function TimeEntriesRelationshipDataInnerToJSON(json) {
    return TimeEntriesRelationshipDataInnerToJSONTyped(json);
}
function TimeEntriesRelationshipDataInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimeEntriesRelationship interface.
 */
function instanceOfTimeEntriesRelationship(value) {
    return true;
}
function TimeEntriesRelationshipFromJSON(json) {
    return TimeEntriesRelationshipFromJSONTyped(json);
}
function TimeEntriesRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : (json['data'].map(TimeEntriesRelationshipDataInnerFromJSON)),
    };
}
function TimeEntriesRelationshipToJSON(json) {
    return TimeEntriesRelationshipToJSONTyped(json);
}
function TimeEntriesRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': value['data'] == null ? undefined : (value['data'].map(TimeEntriesRelationshipDataInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimesheetSchemaRelationships interface.
 */
function instanceOfTimesheetSchemaRelationships(value) {
    if (!('employee' in value) || value['employee'] === undefined)
        return false;
    if (!('job' in value) || value['job'] === undefined)
        return false;
    if (!('timeEntries' in value) || value['timeEntries'] === undefined)
        return false;
    if (!('exceptions' in value) || value['exceptions'] === undefined)
        return false;
    return true;
}
function TimesheetSchemaRelationshipsFromJSON(json) {
    return TimesheetSchemaRelationshipsFromJSONTyped(json);
}
function TimesheetSchemaRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'employee': EmployeeRelationshipFromJSON(json['employee']),
        'job': JobRelationshipFromJSON(json['job']),
        'timeEntries': TimeEntriesRelationshipFromJSON(json['timeEntries']),
        'exceptions': ExceptionsRelationshipFromJSON(json['exceptions']),
    };
}
function TimesheetSchemaRelationshipsToJSON(json) {
    return TimesheetSchemaRelationshipsToJSONTyped(json);
}
function TimesheetSchemaRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'employee': EmployeeRelationshipToJSON(value['employee']),
        'job': JobRelationshipToJSON(value['job']),
        'timeEntries': TimeEntriesRelationshipToJSON(value['timeEntries']),
        'exceptions': ExceptionsRelationshipToJSON(value['exceptions']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
var TimesheetSchemaAttributesApprovalDataCategoryEnum = {
    CurrentPeriod: 'CURRENT_PERIOD',
    AutoAmended: 'AUTO_AMENDED',
    UserAmended: 'USER_AMENDED',
    Closed: 'CLOSED'
};
/**
 * Check if a given object implements the TimesheetSchemaAttributesApprovalData interface.
 */
function instanceOfTimesheetSchemaAttributesApprovalData(value) {
    if (!('category' in value) || value['category'] === undefined)
        return false;
    if (!('approvalCalcValueHash' in value) || value['approvalCalcValueHash'] === undefined)
        return false;
    if (!('approvalCalcValues' in value) || value['approvalCalcValues'] === undefined)
        return false;
    if (!('isReadOnly' in value) || value['isReadOnly'] === undefined)
        return false;
    if (!('readOnlyReason' in value) || value['readOnlyReason'] === undefined)
        return false;
    return true;
}
function TimesheetSchemaAttributesApprovalDataFromJSON(json) {
    return TimesheetSchemaAttributesApprovalDataFromJSONTyped(json);
}
function TimesheetSchemaAttributesApprovalDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'category': json['category'],
        'approvalCalcValueHash': json['approvalCalcValueHash'],
        'approvalCalcValues': json['approvalCalcValues'],
        'isReadOnly': json['isReadOnly'],
        'readOnlyReason': json['readOnlyReason'],
    };
}
function TimesheetSchemaAttributesApprovalDataToJSON(json) {
    return TimesheetSchemaAttributesApprovalDataToJSONTyped(json);
}
function TimesheetSchemaAttributesApprovalDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'category': value['category'],
        'approvalCalcValueHash': value['approvalCalcValueHash'],
        'approvalCalcValues': value['approvalCalcValues'],
        'isReadOnly': value['isReadOnly'],
        'readOnlyReason': value['readOnlyReason'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
var TimesheetSchemaAttributesTimesheetStateApprovalStatusEnum = {
    Unapproved: 'UNAPPROVED',
    ApprovedAtLowerLevel: 'APPROVED_AT_LOWER_LEVEL',
    ApprovedAtMyLevel: 'APPROVED_AT_MY_LEVEL',
    ApprovedAtHigherLevel: 'APPROVED_AT_HIGHER_LEVEL',
    Rejected: 'REJECTED',
    Locked: 'LOCKED',
    Closed: 'CLOSED'
};
/**
 * Check if a given object implements the TimesheetSchemaAttributesTimesheetState interface.
 */
function instanceOfTimesheetSchemaAttributesTimesheetState(value) {
    if (!('currentApprovalLevel' in value) || value['currentApprovalLevel'] === undefined)
        return false;
    if (!('currentManagerApprovalLevel' in value) || value['currentManagerApprovalLevel'] === undefined)
        return false;
    if (!('employeeApproval' in value) || value['employeeApproval'] === undefined)
        return false;
    return true;
}
function TimesheetSchemaAttributesTimesheetStateFromJSON(json) {
    return TimesheetSchemaAttributesTimesheetStateFromJSONTyped(json);
}
function TimesheetSchemaAttributesTimesheetStateFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'currentApprovalLevel': json['currentApprovalLevel'],
        'currentManagerApprovalLevel': json['currentManagerApprovalLevel'],
        'employeeApproval': json['employeeApproval'],
        'approvalStatus': json['approvalStatus'] == null ? undefined : json['approvalStatus'],
    };
}
function TimesheetSchemaAttributesTimesheetStateToJSON(json) {
    return TimesheetSchemaAttributesTimesheetStateToJSONTyped(json);
}
function TimesheetSchemaAttributesTimesheetStateToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'currentApprovalLevel': value['currentApprovalLevel'],
        'currentManagerApprovalLevel': value['currentManagerApprovalLevel'],
        'employeeApproval': value['employeeApproval'],
        'approvalStatus': value['approvalStatus'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimesheetSchemaAttributes interface.
 */
function instanceOfTimesheetSchemaAttributes(value) {
    if (!('startDate' in value) || value['startDate'] === undefined)
        return false;
    if (!('endDate' in value) || value['endDate'] === undefined)
        return false;
    if (!('version' in value) || value['version'] === undefined)
        return false;
    if (!('concurrencyId' in value) || value['concurrencyId'] === undefined)
        return false;
    if (!('timesheetState' in value) || value['timesheetState'] === undefined)
        return false;
    return true;
}
function TimesheetSchemaAttributesFromJSON(json) {
    return TimesheetSchemaAttributesFromJSONTyped(json);
}
function TimesheetSchemaAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'startDate': (dateAndTime.DateWithoutTime.fromISO(json['startDate'])),
        'endDate': (dateAndTime.DateWithoutTime.fromISO(json['endDate'])),
        'version': json['version'],
        'concurrencyId': json['concurrencyId'],
        'timesheetState': TimesheetSchemaAttributesTimesheetStateFromJSON(json['timesheetState']),
        'approvalData': json['approvalData'] == null ? undefined : TimesheetSchemaAttributesApprovalDataFromJSON(json['approvalData']),
        'timesheetResults': json['timesheetResults'] == null ? undefined : json['timesheetResults'],
    };
}
function TimesheetSchemaAttributesToJSON(json) {
    return TimesheetSchemaAttributesToJSONTyped(json);
}
function TimesheetSchemaAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'startDate': value['startDate'].toISO(),
        'endDate': value['endDate'].toISO(),
        'version': value['version'],
        'concurrencyId': value['concurrencyId'],
        'timesheetState': TimesheetSchemaAttributesTimesheetStateToJSON(value['timesheetState']),
        'approvalData': TimesheetSchemaAttributesApprovalDataToJSON(value['approvalData']),
        'timesheetResults': value['timesheetResults'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the TimesheetSchemaMeta interface.
 */
function instanceOfTimesheetSchemaMeta(value) {
    if (!('grandTotal' in value) || value['grandTotal'] === undefined)
        return false;
    return true;
}
function TimesheetSchemaMetaFromJSON(json) {
    return TimesheetSchemaMetaFromJSONTyped(json);
}
function TimesheetSchemaMetaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'grandTotal': json['grandTotal'],
    };
}
function TimesheetSchemaMetaToJSON(json) {
    return TimesheetSchemaMetaToJSONTyped(json);
}
function TimesheetSchemaMetaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'grandTotal': value['grandTotal'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimesheetSchema interface.
 */
function instanceOfTimesheetSchema(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    if (!('relationships' in value) || value['relationships'] === undefined)
        return false;
    return true;
}
function TimesheetSchemaFromJSON(json) {
    return TimesheetSchemaFromJSONTyped(json);
}
function TimesheetSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': TimesheetSchemaAttributesFromJSON(json['attributes']),
        'relationships': TimesheetSchemaRelationshipsFromJSON(json['relationships']),
        'meta': json['meta'] == null ? undefined : TimesheetSchemaMetaFromJSON(json['meta']),
    };
}
function TimesheetSchemaToJSON(json) {
    return TimesheetSchemaToJSONTyped(json);
}
function TimesheetSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': TimesheetSchemaAttributesToJSON(value['attributes']),
        'relationships': TimesheetSchemaRelationshipsToJSON(value['relationships']),
        'meta': TimesheetSchemaMetaToJSON(value['meta']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the PostTimesheetEntryResponseSchemaIncludedInner interface.
 */
function instanceOfPostTimesheetEntryResponseSchemaIncludedInner(value) {
    return true;
}
function PostTimesheetEntryResponseSchemaIncludedInnerFromJSON(json) {
    return PostTimesheetEntryResponseSchemaIncludedInnerFromJSONTyped(json);
}
function PostTimesheetEntryResponseSchemaIncludedInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'employee': json['employee'] == null ? undefined : IncludedEmployeeInformationFromJSON(json['employee']),
        'job': json['job'] == null ? undefined : IncludedJobInformationFromJSON(json['job']),
        'timesheet': json['timesheet'] == null ? undefined : TimesheetSchemaFromJSON(json['timesheet']),
        'timesheetException': json['timesheetException'] == null ? undefined : (json['timesheetException'].map(TimesheetExceptionFromJSON)),
    };
}
function PostTimesheetEntryResponseSchemaIncludedInnerToJSON(json) {
    return PostTimesheetEntryResponseSchemaIncludedInnerToJSONTyped(json);
}
function PostTimesheetEntryResponseSchemaIncludedInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'employee': IncludedEmployeeInformationToJSON(value['employee']),
        'job': IncludedJobInformationToJSON(value['job']),
        'timesheet': TimesheetSchemaToJSON(value['timesheet']),
        'timesheetException': value['timesheetException'] == null ? undefined : (value['timesheetException'].map(TimesheetExceptionToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the TimesheetEntryResourceMeta interface.
 */
function instanceOfTimesheetEntryResourceMeta(value) {
    return true;
}
function TimesheetEntryResourceMetaFromJSON(json) {
    return TimesheetEntryResourceMetaFromJSONTyped(json);
}
function TimesheetEntryResourceMetaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'isReadOnly': json['isReadOnly'] == null ? undefined : json['isReadOnly'],
    };
}
function TimesheetEntryResourceMetaToJSON(json) {
    return TimesheetEntryResourceMetaToJSONTyped(json);
}
function TimesheetEntryResourceMetaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'isReadOnly': value['isReadOnly'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the TimesheetRelationshipData interface.
 */
function instanceOfTimesheetRelationshipData(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function TimesheetRelationshipDataFromJSON(json) {
    return TimesheetRelationshipDataFromJSONTyped(json);
}
function TimesheetRelationshipDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
    };
}
function TimesheetRelationshipDataToJSON(json) {
    return TimesheetRelationshipDataToJSONTyped(json);
}
function TimesheetRelationshipDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimesheetRelationship interface.
 */
function instanceOfTimesheetRelationship(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function TimesheetRelationshipFromJSON(json) {
    return TimesheetRelationshipFromJSONTyped(json);
}
function TimesheetRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': TimesheetRelationshipDataFromJSON(json['data']),
    };
}
function TimesheetRelationshipToJSON(json) {
    return TimesheetRelationshipToJSONTyped(json);
}
function TimesheetRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': TimesheetRelationshipDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the PostTimesheetEntryResponseSchemaDataRelationships interface.
 */
function instanceOfPostTimesheetEntryResponseSchemaDataRelationships(value) {
    return true;
}
function PostTimesheetEntryResponseSchemaDataRelationshipsFromJSON(json) {
    return PostTimesheetEntryResponseSchemaDataRelationshipsFromJSONTyped(json);
}
function PostTimesheetEntryResponseSchemaDataRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'timesheet': json['timesheet'] == null ? undefined : TimesheetRelationshipFromJSON(json['timesheet']),
        'employee': json['employee'] == null ? undefined : EmployeeRelationshipFromJSON(json['employee']),
        'job': json['job'] == null ? undefined : JobRelationshipFromJSON(json['job']),
    };
}
function PostTimesheetEntryResponseSchemaDataRelationshipsToJSON(json) {
    return PostTimesheetEntryResponseSchemaDataRelationshipsToJSONTyped(json);
}
function PostTimesheetEntryResponseSchemaDataRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'timesheet': TimesheetRelationshipToJSON(value['timesheet']),
        'employee': EmployeeRelationshipToJSON(value['employee']),
        'job': JobRelationshipToJSON(value['job']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the PostTimesheetEntryResponseSchemaDataAttributes interface.
 */
function instanceOfPostTimesheetEntryResponseSchemaDataAttributes(value) {
    if (!('workDate' in value) || value['workDate'] === undefined)
        return false;
    if (!('entryField' in value) || value['entryField'] === undefined)
        return false;
    if (!('payCodeId' in value) || value['payCodeId'] === undefined)
        return false;
    return true;
}
function PostTimesheetEntryResponseSchemaDataAttributesFromJSON(json) {
    return PostTimesheetEntryResponseSchemaDataAttributesFromJSONTyped(json);
}
function PostTimesheetEntryResponseSchemaDataAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'concurrencyId': json['concurrencyId'] == null ? undefined : json['concurrencyId'],
        'totals': json['totals'] == null ? undefined : json['totals'],
        'workDate': (dateAndTime.DateWithoutTime.fromISO(json['workDate'])),
        'entryField': EntryFieldFromJSON(json['entryField']),
        'payCodeId': json['payCodeId'],
        'fields': json['fields'] == null ? undefined : (mapValues(json['fields'], DiscriminatedFieldValueFromJSON)),
    };
}
function PostTimesheetEntryResponseSchemaDataAttributesToJSON(json) {
    return PostTimesheetEntryResponseSchemaDataAttributesToJSONTyped(json);
}
function PostTimesheetEntryResponseSchemaDataAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'concurrencyId': value['concurrencyId'],
        'totals': value['totals'],
        'workDate': value['workDate'].toISO(),
        'entryField': EntryFieldToJSON(value['entryField']),
        'payCodeId': value['payCodeId'],
        'fields': value['fields'] == null ? undefined : (mapValues(value['fields'], DiscriminatedFieldValueToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the PostTimesheetEntryResponseSchemaData interface.
 */
function instanceOfPostTimesheetEntryResponseSchemaData(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    if (!('relationships' in value) || value['relationships'] === undefined)
        return false;
    return true;
}
function PostTimesheetEntryResponseSchemaDataFromJSON(json) {
    return PostTimesheetEntryResponseSchemaDataFromJSONTyped(json);
}
function PostTimesheetEntryResponseSchemaDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': PostTimesheetEntryResponseSchemaDataAttributesFromJSON(json['attributes']),
        'relationships': PostTimesheetEntryResponseSchemaDataRelationshipsFromJSON(json['relationships']),
        'meta': json['meta'] == null ? undefined : TimesheetEntryResourceMetaFromJSON(json['meta']),
    };
}
function PostTimesheetEntryResponseSchemaDataToJSON(json) {
    return PostTimesheetEntryResponseSchemaDataToJSONTyped(json);
}
function PostTimesheetEntryResponseSchemaDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': PostTimesheetEntryResponseSchemaDataAttributesToJSON(value['attributes']),
        'relationships': PostTimesheetEntryResponseSchemaDataRelationshipsToJSON(value['relationships']),
        'meta': TimesheetEntryResourceMetaToJSON(value['meta']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the PostTimesheetEntryResponseSchema interface.
 */
function instanceOfPostTimesheetEntryResponseSchema(value) {
    return true;
}
function PostTimesheetEntryResponseSchemaFromJSON(json) {
    return PostTimesheetEntryResponseSchemaFromJSONTyped(json);
}
function PostTimesheetEntryResponseSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : PostTimesheetEntryResponseSchemaDataFromJSON(json['data']),
        'included': json['included'] == null ? undefined : (json['included'].map(PostTimesheetEntryResponseSchemaIncludedInnerFromJSON)),
    };
}
function PostTimesheetEntryResponseSchemaToJSON(json) {
    return PostTimesheetEntryResponseSchemaToJSONTyped(json);
}
function PostTimesheetEntryResponseSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': PostTimesheetEntryResponseSchemaDataToJSON(value['data']),
        'included': value['included'] == null ? undefined : (value['included'].map(PostTimesheetEntryResponseSchemaIncludedInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Represents an item included in a projection, such as an employee, job,
 * balance, entry, or gap.
 * @export
 */
var ProjectionIncludeItem = {
    Employee: 'employee',
    Job: 'job',
    Balance: 'balance',
    Entry: 'entry',
    Gap: 'gap'
};
function instanceOfProjectionIncludeItem(value) {
    for (var key in ProjectionIncludeItem) {
        if (Object.prototype.hasOwnProperty.call(ProjectionIncludeItem, key)) {
            if (ProjectionIncludeItem[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function ProjectionIncludeItemFromJSON(json) {
    return ProjectionIncludeItemFromJSONTyped(json);
}
function ProjectionIncludeItemFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ProjectionIncludeItemToJSON(value) {
    return value;
}
function ProjectionIncludeItemToJSONTyped(value, ignoreDiscriminator) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RollbackAbsenceCaseHistoryEventRequestDataAttributes interface.
 */
function instanceOfRollbackAbsenceCaseHistoryEventRequestDataAttributes(value) {
    if (!('comments' in value) || value['comments'] === undefined)
        return false;
    return true;
}
function RollbackAbsenceCaseHistoryEventRequestDataAttributesFromJSON(json) {
    return RollbackAbsenceCaseHistoryEventRequestDataAttributesFromJSONTyped(json);
}
function RollbackAbsenceCaseHistoryEventRequestDataAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'comments': json['comments'],
    };
}
function RollbackAbsenceCaseHistoryEventRequestDataAttributesToJSON(json) {
    return RollbackAbsenceCaseHistoryEventRequestDataAttributesToJSONTyped(json);
}
function RollbackAbsenceCaseHistoryEventRequestDataAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'comments': value['comments'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the RollbackAbsenceCaseHistoryEventRequestDataRelationships interface.
 */
function instanceOfRollbackAbsenceCaseHistoryEventRequestDataRelationships(value) {
    if (!('absenceCase' in value) || value['absenceCase'] === undefined)
        return false;
    if (!('historyEventRollback' in value) || value['historyEventRollback'] === undefined)
        return false;
    return true;
}
function RollbackAbsenceCaseHistoryEventRequestDataRelationshipsFromJSON(json) {
    return RollbackAbsenceCaseHistoryEventRequestDataRelationshipsFromJSONTyped(json);
}
function RollbackAbsenceCaseHistoryEventRequestDataRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'absenceCase': AbsenceCaseRelationshipFromJSON(json['absenceCase']),
        'historyEventRollback': AbsenceCaseHistoryEventRelationshipFromJSON(json['historyEventRollback']),
    };
}
function RollbackAbsenceCaseHistoryEventRequestDataRelationshipsToJSON(json) {
    return RollbackAbsenceCaseHistoryEventRequestDataRelationshipsToJSONTyped(json);
}
function RollbackAbsenceCaseHistoryEventRequestDataRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'absenceCase': AbsenceCaseRelationshipToJSON(value['absenceCase']),
        'historyEventRollback': AbsenceCaseHistoryEventRelationshipToJSON(value['historyEventRollback']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var RollbackAbsenceCaseHistoryEventRequestDataTypeEnum = {
    AbsenceCaseHistoryEvent: 'absenceCaseHistoryEvent'
};
/**
 * Check if a given object implements the RollbackAbsenceCaseHistoryEventRequestData interface.
 */
function instanceOfRollbackAbsenceCaseHistoryEventRequestData(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    if (!('relationships' in value) || value['relationships'] === undefined)
        return false;
    return true;
}
function RollbackAbsenceCaseHistoryEventRequestDataFromJSON(json) {
    return RollbackAbsenceCaseHistoryEventRequestDataFromJSONTyped(json);
}
function RollbackAbsenceCaseHistoryEventRequestDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'attributes': RollbackAbsenceCaseHistoryEventRequestDataAttributesFromJSON(json['attributes']),
        'relationships': RollbackAbsenceCaseHistoryEventRequestDataRelationshipsFromJSON(json['relationships']),
    };
}
function RollbackAbsenceCaseHistoryEventRequestDataToJSON(json) {
    return RollbackAbsenceCaseHistoryEventRequestDataToJSONTyped(json);
}
function RollbackAbsenceCaseHistoryEventRequestDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'attributes': RollbackAbsenceCaseHistoryEventRequestDataAttributesToJSON(value['attributes']),
        'relationships': RollbackAbsenceCaseHistoryEventRequestDataRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the RollbackAbsenceCaseHistoryEventRequest interface.
 */
function instanceOfRollbackAbsenceCaseHistoryEventRequest(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function RollbackAbsenceCaseHistoryEventRequestFromJSON(json) {
    return RollbackAbsenceCaseHistoryEventRequestFromJSONTyped(json);
}
function RollbackAbsenceCaseHistoryEventRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': RollbackAbsenceCaseHistoryEventRequestDataFromJSON(json['data']),
    };
}
function RollbackAbsenceCaseHistoryEventRequestToJSON(json) {
    return RollbackAbsenceCaseHistoryEventRequestToJSONTyped(json);
}
function RollbackAbsenceCaseHistoryEventRequestToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': RollbackAbsenceCaseHistoryEventRequestDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the RollbackAbsenceCaseHistoryEventResponseDataAttributes interface.
 */
function instanceOfRollbackAbsenceCaseHistoryEventResponseDataAttributes(value) {
    if (!('submittedAt' in value) || value['submittedAt'] === undefined)
        return false;
    if (!('submittedBy' in value) || value['submittedBy'] === undefined)
        return false;
    if (!('comments' in value) || value['comments'] === undefined)
        return false;
    if (!('date' in value) || value['date'] === undefined)
        return false;
    if (!('eventDescription' in value) || value['eventDescription'] === undefined)
        return false;
    if (!('modifiedBy' in value) || value['modifiedBy'] === undefined)
        return false;
    return true;
}
function RollbackAbsenceCaseHistoryEventResponseDataAttributesFromJSON(json) {
    return RollbackAbsenceCaseHistoryEventResponseDataAttributesFromJSONTyped(json);
}
function RollbackAbsenceCaseHistoryEventResponseDataAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'submittedAt': (luxon.DateTime.fromISO(json['submittedAt'])),
        'submittedBy': json['submittedBy'],
        'comments': json['comments'],
        'date': (luxon.DateTime.fromISO(json['date'])),
        'eventDescription': json['eventDescription'],
        'modifiedBy': json['modifiedBy'],
    };
}
function RollbackAbsenceCaseHistoryEventResponseDataAttributesToJSON(json) {
    return RollbackAbsenceCaseHistoryEventResponseDataAttributesToJSONTyped(json);
}
function RollbackAbsenceCaseHistoryEventResponseDataAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'submittedAt': value['submittedAt'].toISO(),
        'submittedBy': value['submittedBy'],
        'comments': value['comments'],
        'date': value['date'].toISO(),
        'eventDescription': value['eventDescription'],
        'modifiedBy': value['modifiedBy'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the RollbackAbsenceCaseHistoryEventResponseDataRelationships interface.
 */
function instanceOfRollbackAbsenceCaseHistoryEventResponseDataRelationships(value) {
    if (!('absenceCase' in value) || value['absenceCase'] === undefined)
        return false;
    if (!('historyEvent' in value) || value['historyEvent'] === undefined)
        return false;
    return true;
}
function RollbackAbsenceCaseHistoryEventResponseDataRelationshipsFromJSON(json) {
    return RollbackAbsenceCaseHistoryEventResponseDataRelationshipsFromJSONTyped(json);
}
function RollbackAbsenceCaseHistoryEventResponseDataRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'absenceCase': AbsenceCaseRelationshipFromJSON(json['absenceCase']),
        'historyEvent': AbsenceCaseHistoryEventRelationshipFromJSON(json['historyEvent']),
    };
}
function RollbackAbsenceCaseHistoryEventResponseDataRelationshipsToJSON(json) {
    return RollbackAbsenceCaseHistoryEventResponseDataRelationshipsToJSONTyped(json);
}
function RollbackAbsenceCaseHistoryEventResponseDataRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'absenceCase': AbsenceCaseRelationshipToJSON(value['absenceCase']),
        'historyEvent': AbsenceCaseHistoryEventRelationshipToJSON(value['historyEvent']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var RollbackAbsenceCaseHistoryEventResponseDataTypeEnum = {
    AbsenceCaseHistoryEvent: 'absenceCaseHistoryEvent'
};
/**
 * Check if a given object implements the RollbackAbsenceCaseHistoryEventResponseData interface.
 */
function instanceOfRollbackAbsenceCaseHistoryEventResponseData(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    if (!('relationships' in value) || value['relationships'] === undefined)
        return false;
    return true;
}
function RollbackAbsenceCaseHistoryEventResponseDataFromJSON(json) {
    return RollbackAbsenceCaseHistoryEventResponseDataFromJSONTyped(json);
}
function RollbackAbsenceCaseHistoryEventResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'id': json['id'],
        'attributes': RollbackAbsenceCaseHistoryEventResponseDataAttributesFromJSON(json['attributes']),
        'relationships': RollbackAbsenceCaseHistoryEventResponseDataRelationshipsFromJSON(json['relationships']),
    };
}
function RollbackAbsenceCaseHistoryEventResponseDataToJSON(json) {
    return RollbackAbsenceCaseHistoryEventResponseDataToJSONTyped(json);
}
function RollbackAbsenceCaseHistoryEventResponseDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'id': value['id'],
        'attributes': RollbackAbsenceCaseHistoryEventResponseDataAttributesToJSON(value['attributes']),
        'relationships': RollbackAbsenceCaseHistoryEventResponseDataRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the RollbackAbsenceCaseHistoryEventResponseIncludedInner interface.
 */
function instanceOfRollbackAbsenceCaseHistoryEventResponseIncludedInner(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function RollbackAbsenceCaseHistoryEventResponseIncludedInnerFromJSON(json) {
    return RollbackAbsenceCaseHistoryEventResponseIncludedInnerFromJSONTyped(json);
}
function RollbackAbsenceCaseHistoryEventResponseIncludedInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': AbsenceCaseHistoryEventAttributesFromJSON(json['attributes']),
        'relationships': json['relationships'] == null ? undefined : AbsenceCaseHistoryEventRelationshipsFromJSON(json['relationships']),
    };
}
function RollbackAbsenceCaseHistoryEventResponseIncludedInnerToJSON(json) {
    return RollbackAbsenceCaseHistoryEventResponseIncludedInnerToJSONTyped(json);
}
function RollbackAbsenceCaseHistoryEventResponseIncludedInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': AbsenceCaseHistoryEventAttributesToJSON(value['attributes']),
        'relationships': AbsenceCaseHistoryEventRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the RollbackAbsenceCaseHistoryEventResponse interface.
 */
function instanceOfRollbackAbsenceCaseHistoryEventResponse(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function RollbackAbsenceCaseHistoryEventResponseFromJSON(json) {
    return RollbackAbsenceCaseHistoryEventResponseFromJSONTyped(json);
}
function RollbackAbsenceCaseHistoryEventResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': RollbackAbsenceCaseHistoryEventResponseDataFromJSON(json['data']),
        'included': json['included'] == null ? undefined : (json['included'].map(RollbackAbsenceCaseHistoryEventResponseIncludedInnerFromJSON)),
    };
}
function RollbackAbsenceCaseHistoryEventResponseToJSON(json) {
    return RollbackAbsenceCaseHistoryEventResponseToJSONTyped(json);
}
function RollbackAbsenceCaseHistoryEventResponseToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': RollbackAbsenceCaseHistoryEventResponseDataToJSON(value['data']),
        'included': value['included'] == null ? undefined : (value['included'].map(RollbackAbsenceCaseHistoryEventResponseIncludedInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the SinglePayRuleResponseSchema interface.
 */
function instanceOfSinglePayRuleResponseSchema(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function SinglePayRuleResponseSchemaFromJSON(json) {
    return SinglePayRuleResponseSchemaFromJSONTyped(json);
}
function SinglePayRuleResponseSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': PayRuleFromJSON(json['data']),
    };
}
function SinglePayRuleResponseSchemaToJSON(json) {
    return SinglePayRuleResponseSchemaToJSONTyped(json);
}
function SinglePayRuleResponseSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': PayRuleToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the SingleShiftResponseSchema interface.
 */
function instanceOfSingleShiftResponseSchema(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function SingleShiftResponseSchemaFromJSON(json) {
    return SingleShiftResponseSchemaFromJSONTyped(json);
}
function SingleShiftResponseSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': SingleShiftFromJSON(json['data']),
    };
}
function SingleShiftResponseSchemaToJSON(json) {
    return SingleShiftResponseSchemaToJSONTyped(json);
}
function SingleShiftResponseSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': SingleShiftToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the SubmitTimeOffRequestDetail interface.
 */
function instanceOfSubmitTimeOffRequestDetail(value) {
    if (!('dailyDuration' in value) || value['dailyDuration'] === undefined)
        return false;
    if (!('payCodeId' in value) || value['payCodeId'] === undefined)
        return false;
    return true;
}
function SubmitTimeOffRequestDetailFromJSON(json) {
    return SubmitTimeOffRequestDetailFromJSONTyped(json);
}
function SubmitTimeOffRequestDetailFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'dailyDuration': DailyDurationFromJSON(json['dailyDuration']),
        'payCodeId': json['payCodeId'],
    };
}
function SubmitTimeOffRequestDetailToJSON(json) {
    return SubmitTimeOffRequestDetailToJSONTyped(json);
}
function SubmitTimeOffRequestDetailToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'dailyDuration': DailyDurationToJSON(value['dailyDuration']),
        'payCodeId': value['payCodeId'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the SubmitTimeOffRequestBody interface.
 */
function instanceOfSubmitTimeOffRequestBody(value) {
    if (!('absenceTypeId' in value) || value['absenceTypeId'] === undefined)
        return false;
    if (!('startDate' in value) || value['startDate'] === undefined)
        return false;
    if (!('endDate' in value) || value['endDate'] === undefined)
        return false;
    if (!('timeOffRequestDetail' in value) || value['timeOffRequestDetail'] === undefined)
        return false;
    return true;
}
function SubmitTimeOffRequestBodyFromJSON(json) {
    return SubmitTimeOffRequestBodyFromJSONTyped(json);
}
function SubmitTimeOffRequestBodyFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'absenceTypeId': json['absenceTypeId'],
        'startDate': (dateAndTime.DateWithoutTime.fromISO(json['startDate'])),
        'endDate': (dateAndTime.DateWithoutTime.fromISO(json['endDate'])),
        'comment': json['comment'] == null ? undefined : json['comment'],
        'timeOffRequestDetail': SubmitTimeOffRequestDetailFromJSON(json['timeOffRequestDetail']),
    };
}
function SubmitTimeOffRequestBodyToJSON(json) {
    return SubmitTimeOffRequestBodyToJSONTyped(json);
}
function SubmitTimeOffRequestBodyToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'absenceTypeId': value['absenceTypeId'],
        'startDate': value['startDate'].toISO(),
        'endDate': value['endDate'].toISO(),
        'comment': value['comment'],
        'timeOffRequestDetail': SubmitTimeOffRequestDetailToJSON(value['timeOffRequestDetail']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the SubmitTimeOffRequestDataRelationships interface.
 */
function instanceOfSubmitTimeOffRequestDataRelationships(value) {
    if (!('employee' in value) || value['employee'] === undefined)
        return false;
    return true;
}
function SubmitTimeOffRequestDataRelationshipsFromJSON(json) {
    return SubmitTimeOffRequestDataRelationshipsFromJSONTyped(json);
}
function SubmitTimeOffRequestDataRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'employee': EmployeeRelationshipFromJSON(json['employee']),
        'job': json['job'] == null ? undefined : JobRelationshipFromJSON(json['job']),
    };
}
function SubmitTimeOffRequestDataRelationshipsToJSON(json) {
    return SubmitTimeOffRequestDataRelationshipsToJSONTyped(json);
}
function SubmitTimeOffRequestDataRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'employee': EmployeeRelationshipToJSON(value['employee']),
        'job': JobRelationshipToJSON(value['job']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the SubmitTimeOffRequestData interface.
 */
function instanceOfSubmitTimeOffRequestData(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    if (!('relationships' in value) || value['relationships'] === undefined)
        return false;
    return true;
}
function SubmitTimeOffRequestDataFromJSON(json) {
    return SubmitTimeOffRequestDataFromJSONTyped(json);
}
function SubmitTimeOffRequestDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'attributes': SubmitTimeOffRequestBodyFromJSON(json['attributes']),
        'relationships': SubmitTimeOffRequestDataRelationshipsFromJSON(json['relationships']),
    };
}
function SubmitTimeOffRequestDataToJSON(json) {
    return SubmitTimeOffRequestDataToJSONTyped(json);
}
function SubmitTimeOffRequestDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'attributes': SubmitTimeOffRequestBodyToJSON(value['attributes']),
        'relationships': SubmitTimeOffRequestDataRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the SubmitTimeOffRequest interface.
 */
function instanceOfSubmitTimeOffRequest(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function SubmitTimeOffRequestFromJSON(json) {
    return SubmitTimeOffRequestFromJSONTyped(json);
}
function SubmitTimeOffRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': SubmitTimeOffRequestDataFromJSON(json['data']),
    };
}
function SubmitTimeOffRequestToJSON(json) {
    return SubmitTimeOffRequestToJSONTyped(json);
}
function SubmitTimeOffRequestToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': SubmitTimeOffRequestDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the SwipeRequestData interface.
 */
function instanceOfSwipeRequestData(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function SwipeRequestDataFromJSON(json) {
    return SwipeRequestDataFromJSONTyped(json);
}
function SwipeRequestDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'attributes': SwipeAttributesFromJSON(json['attributes']),
    };
}
function SwipeRequestDataToJSON(json) {
    return SwipeRequestDataToJSONTyped(json);
}
function SwipeRequestDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'attributes': SwipeAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the SwipeRequest interface.
 */
function instanceOfSwipeRequest(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function SwipeRequestFromJSON(json) {
    return SwipeRequestFromJSONTyped(json);
}
function SwipeRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': SwipeRequestDataFromJSON(json['data']),
    };
}
function SwipeRequestToJSON(json) {
    return SwipeRequestToJSONTyped(json);
}
function SwipeRequestToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': SwipeRequestDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the TimeEntryResponseDataInner interface.
 */
function instanceOfTimeEntryResponseDataInner(value) {
    return true;
}
function TimeEntryResponseDataInnerFromJSON(json) {
    return TimeEntryResponseDataInnerFromJSONTyped(json);
}
function TimeEntryResponseDataInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'attributes': json['attributes'] == null ? undefined : json['attributes'],
        'relationships': json['relationships'] == null ? undefined : json['relationships'],
    };
}
function TimeEntryResponseDataInnerToJSON(json) {
    return TimeEntryResponseDataInnerToJSONTyped(json);
}
function TimeEntryResponseDataInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': value['attributes'],
        'relationships': value['relationships'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimeEntryResponseMetaPeriodsInner interface.
 */
function instanceOfTimeEntryResponseMetaPeriodsInner(value) {
    return true;
}
function TimeEntryResponseMetaPeriodsInnerFromJSON(json) {
    return TimeEntryResponseMetaPeriodsInnerFromJSONTyped(json);
}
function TimeEntryResponseMetaPeriodsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'periodLabel': json['periodLabel'] == null ? undefined : json['periodLabel'],
        'startDate': json['startDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['endDate'])),
    };
}
function TimeEntryResponseMetaPeriodsInnerToJSON(json) {
    return TimeEntryResponseMetaPeriodsInnerToJSONTyped(json);
}
function TimeEntryResponseMetaPeriodsInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'periodLabel': value['periodLabel'],
        'startDate': value['startDate'] == null ? value['startDate'] : value['startDate'].toISO(),
        'endDate': value['endDate'] == null ? value['endDate'] : value['endDate'].toISO(),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimeEntryResponseMeta interface.
 */
function instanceOfTimeEntryResponseMeta(value) {
    return true;
}
function TimeEntryResponseMetaFromJSON(json) {
    return TimeEntryResponseMetaFromJSONTyped(json);
}
function TimeEntryResponseMetaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'totalHours': json['totalHours'] == null ? undefined : json['totalHours'],
        'selectedPeriodLabel': json['selectedPeriodLabel'] == null ? undefined : json['selectedPeriodLabel'],
        'periods': json['periods'] == null ? undefined : (json['periods'].map(TimeEntryResponseMetaPeriodsInnerFromJSON)),
    };
}
function TimeEntryResponseMetaToJSON(json) {
    return TimeEntryResponseMetaToJSONTyped(json);
}
function TimeEntryResponseMetaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'totalHours': value['totalHours'],
        'selectedPeriodLabel': value['selectedPeriodLabel'],
        'periods': value['periods'] == null ? undefined : (value['periods'].map(TimeEntryResponseMetaPeriodsInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimeEntryResponse interface.
 */
function instanceOfTimeEntryResponse(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    if (!('included' in value) || value['included'] === undefined)
        return false;
    if (!('meta' in value) || value['meta'] === undefined)
        return false;
    return true;
}
function TimeEntryResponseFromJSON(json) {
    return TimeEntryResponseFromJSONTyped(json);
}
function TimeEntryResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(TimeEntryResponseDataInnerFromJSON)),
        'included': json['included'],
        'meta': TimeEntryResponseMetaFromJSON(json['meta']),
    };
}
function TimeEntryResponseToJSON(json) {
    return TimeEntryResponseToJSONTyped(json);
}
function TimeEntryResponseToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(TimeEntryResponseDataInnerToJSON)),
        'included': value['included'],
        'meta': TimeEntryResponseMetaToJSON(value['meta']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
var TimeOffRequestEventDataAttributesEventStatusEnum = {
    Approved: 'APPROVED',
    Rejected: 'REJECTED',
    Cancelled: 'CANCELLED'
};
/**
 * Check if a given object implements the TimeOffRequestEventDataAttributes interface.
 */
function instanceOfTimeOffRequestEventDataAttributes(value) {
    if (!('eventStatus' in value) || value['eventStatus'] === undefined)
        return false;
    return true;
}
function TimeOffRequestEventDataAttributesFromJSON(json) {
    return TimeOffRequestEventDataAttributesFromJSONTyped(json);
}
function TimeOffRequestEventDataAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'eventStatus': json['eventStatus'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}
function TimeOffRequestEventDataAttributesToJSON(json) {
    return TimeOffRequestEventDataAttributesToJSONTyped(json);
}
function TimeOffRequestEventDataAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'eventStatus': value['eventStatus'],
        'comment': value['comment'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the TimeOffRequestRelationshipData interface.
 */
function instanceOfTimeOffRequestRelationshipData(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function TimeOffRequestRelationshipDataFromJSON(json) {
    return TimeOffRequestRelationshipDataFromJSONTyped(json);
}
function TimeOffRequestRelationshipDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
    };
}
function TimeOffRequestRelationshipDataToJSON(json) {
    return TimeOffRequestRelationshipDataToJSONTyped(json);
}
function TimeOffRequestRelationshipDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimeOffRequestRelationship interface.
 */
function instanceOfTimeOffRequestRelationship(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function TimeOffRequestRelationshipFromJSON(json) {
    return TimeOffRequestRelationshipFromJSONTyped(json);
}
function TimeOffRequestRelationshipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': TimeOffRequestRelationshipDataFromJSON(json['data']),
    };
}
function TimeOffRequestRelationshipToJSON(json) {
    return TimeOffRequestRelationshipToJSONTyped(json);
}
function TimeOffRequestRelationshipToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': TimeOffRequestRelationshipDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimeOffRequestEventDataRelationships interface.
 */
function instanceOfTimeOffRequestEventDataRelationships(value) {
    if (!('timeOffRequest' in value) || value['timeOffRequest'] === undefined)
        return false;
    return true;
}
function TimeOffRequestEventDataRelationshipsFromJSON(json) {
    return TimeOffRequestEventDataRelationshipsFromJSONTyped(json);
}
function TimeOffRequestEventDataRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'timeOffRequest': TimeOffRequestRelationshipFromJSON(json['timeOffRequest']),
    };
}
function TimeOffRequestEventDataRelationshipsToJSON(json) {
    return TimeOffRequestEventDataRelationshipsToJSONTyped(json);
}
function TimeOffRequestEventDataRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'timeOffRequest': TimeOffRequestRelationshipToJSON(value['timeOffRequest']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimeOffRequestEventData interface.
 */
function instanceOfTimeOffRequestEventData(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    if (!('relationships' in value) || value['relationships'] === undefined)
        return false;
    return true;
}
function TimeOffRequestEventDataFromJSON(json) {
    return TimeOffRequestEventDataFromJSONTyped(json);
}
function TimeOffRequestEventDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'attributes': TimeOffRequestEventDataAttributesFromJSON(json['attributes']),
        'relationships': TimeOffRequestEventDataRelationshipsFromJSON(json['relationships']),
    };
}
function TimeOffRequestEventDataToJSON(json) {
    return TimeOffRequestEventDataToJSONTyped(json);
}
function TimeOffRequestEventDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'attributes': TimeOffRequestEventDataAttributesToJSON(value['attributes']),
        'relationships': TimeOffRequestEventDataRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimeOffRequestEvent interface.
 */
function instanceOfTimeOffRequestEvent(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function TimeOffRequestEventFromJSON(json) {
    return TimeOffRequestEventFromJSONTyped(json);
}
function TimeOffRequestEventFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': TimeOffRequestEventDataFromJSON(json['data']),
    };
}
function TimeOffRequestEventToJSON(json) {
    return TimeOffRequestEventToJSONTyped(json);
}
function TimeOffRequestEventToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': TimeOffRequestEventDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the TimeOffRequestEventResponseDataRelationshipsEventSubmittedByData interface.
 */
function instanceOfTimeOffRequestEventResponseDataRelationshipsEventSubmittedByData(value) {
    return true;
}
function TimeOffRequestEventResponseDataRelationshipsEventSubmittedByDataFromJSON(json) {
    return TimeOffRequestEventResponseDataRelationshipsEventSubmittedByDataFromJSONTyped(json);
}
function TimeOffRequestEventResponseDataRelationshipsEventSubmittedByDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}
function TimeOffRequestEventResponseDataRelationshipsEventSubmittedByDataToJSON(json) {
    return TimeOffRequestEventResponseDataRelationshipsEventSubmittedByDataToJSONTyped(json);
}
function TimeOffRequestEventResponseDataRelationshipsEventSubmittedByDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimeOffRequestEventResponseDataRelationshipsEventSubmittedBy interface.
 */
function instanceOfTimeOffRequestEventResponseDataRelationshipsEventSubmittedBy(value) {
    return true;
}
function TimeOffRequestEventResponseDataRelationshipsEventSubmittedByFromJSON(json) {
    return TimeOffRequestEventResponseDataRelationshipsEventSubmittedByFromJSONTyped(json);
}
function TimeOffRequestEventResponseDataRelationshipsEventSubmittedByFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : TimeOffRequestEventResponseDataRelationshipsEventSubmittedByDataFromJSON(json['data']),
    };
}
function TimeOffRequestEventResponseDataRelationshipsEventSubmittedByToJSON(json) {
    return TimeOffRequestEventResponseDataRelationshipsEventSubmittedByToJSONTyped(json);
}
function TimeOffRequestEventResponseDataRelationshipsEventSubmittedByToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': TimeOffRequestEventResponseDataRelationshipsEventSubmittedByDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimeOffRequestEventResponseDataRelationships interface.
 */
function instanceOfTimeOffRequestEventResponseDataRelationships(value) {
    return true;
}
function TimeOffRequestEventResponseDataRelationshipsFromJSON(json) {
    return TimeOffRequestEventResponseDataRelationshipsFromJSONTyped(json);
}
function TimeOffRequestEventResponseDataRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'timeOffRequest': json['timeOffRequest'] == null ? undefined : TimeOffRequestRelationshipFromJSON(json['timeOffRequest']),
        'eventSubmittedBy': json['eventSubmittedBy'] == null ? undefined : TimeOffRequestEventResponseDataRelationshipsEventSubmittedByFromJSON(json['eventSubmittedBy']),
    };
}
function TimeOffRequestEventResponseDataRelationshipsToJSON(json) {
    return TimeOffRequestEventResponseDataRelationshipsToJSONTyped(json);
}
function TimeOffRequestEventResponseDataRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'timeOffRequest': TimeOffRequestRelationshipToJSON(value['timeOffRequest']),
        'eventSubmittedBy': TimeOffRequestEventResponseDataRelationshipsEventSubmittedByToJSON(value['eventSubmittedBy']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the TimeOffRequestEventResponseDataAttributes interface.
 */
function instanceOfTimeOffRequestEventResponseDataAttributes(value) {
    if (!('eventStatus' in value) || value['eventStatus'] === undefined)
        return false;
    return true;
}
function TimeOffRequestEventResponseDataAttributesFromJSON(json) {
    return TimeOffRequestEventResponseDataAttributesFromJSONTyped(json);
}
function TimeOffRequestEventResponseDataAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'eventStatus': json['eventStatus'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}
function TimeOffRequestEventResponseDataAttributesToJSON(json) {
    return TimeOffRequestEventResponseDataAttributesToJSONTyped(json);
}
function TimeOffRequestEventResponseDataAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'eventStatus': value['eventStatus'],
        'comment': value['comment'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimeOffRequestEventResponseData interface.
 */
function instanceOfTimeOffRequestEventResponseData(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function TimeOffRequestEventResponseDataFromJSON(json) {
    return TimeOffRequestEventResponseDataFromJSONTyped(json);
}
function TimeOffRequestEventResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': TimeOffRequestEventResponseDataAttributesFromJSON(json['attributes']),
        'relationships': json['relationships'] == null ? undefined : TimeOffRequestEventResponseDataRelationshipsFromJSON(json['relationships']),
    };
}
function TimeOffRequestEventResponseDataToJSON(json) {
    return TimeOffRequestEventResponseDataToJSONTyped(json);
}
function TimeOffRequestEventResponseDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': TimeOffRequestEventResponseDataAttributesToJSON(value['attributes']),
        'relationships': TimeOffRequestEventResponseDataRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimeOffRequestEventResponse interface.
 */
function instanceOfTimeOffRequestEventResponse(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function TimeOffRequestEventResponseFromJSON(json) {
    return TimeOffRequestEventResponseFromJSONTyped(json);
}
function TimeOffRequestEventResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': TimeOffRequestEventResponseDataFromJSON(json['data']),
    };
}
function TimeOffRequestEventResponseToJSON(json) {
    return TimeOffRequestEventResponseToJSONTyped(json);
}
function TimeOffRequestEventResponseToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': TimeOffRequestEventResponseDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerColumnTypeEnum = {
    Formula: 'Formula',
    ApprovalCheckBox: 'Approval Check Box',
    PayNowCheckBox: 'Pay Now Check Box',
    AssignmentDescription: 'Assignment Description',
    DisplayEmployee: 'Display Employee',
    PayPeriodBegin: 'Pay Period Begin',
    PayPeriodEnd: 'Pay Period End',
    EmployeeName: 'Employee Name',
    EmployeeSubmitted: 'Employee Submitted?',
    AutoAmended: 'Auto Amended?',
    Amended: 'Amended?',
    Closed: 'Closed?',
    CurrentApprovalLevel: 'Current Approval Level',
    Approved: 'Approved?',
    TimesheetChangeCount: 'Timesheet Change Count'
};
/**
 * Check if a given object implements the TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInner interface.
 */
function instanceOfTimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInner(value) {
    return true;
}
function TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerFromJSON(json) {
    return TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerFromJSONTyped(json);
}
function TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'columnId': json['columnId'] == null ? undefined : json['columnId'],
        'columnLabel': json['columnLabel'] == null ? undefined : json['columnLabel'],
        'columnType': json['columnType'] == null ? undefined : json['columnType'],
        'columnName': json['columnName'] == null ? undefined : json['columnName'],
        'columnColor': json['columnColor'] == null ? undefined : json['columnColor'],
        'numberFormatOptions': json['numberFormatOptions'] == null ? undefined : NumberFormatOptionsFromJSON(json['numberFormatOptions']),
    };
}
function TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerToJSON(json) {
    return TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerToJSONTyped(json);
}
function TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'columnId': value['columnId'],
        'columnLabel': value['columnLabel'],
        'columnType': value['columnType'],
        'columnName': value['columnName'],
        'columnColor': value['columnColor'],
        'numberFormatOptions': NumberFormatOptionsToJSON(value['numberFormatOptions']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimesheetApprovalLayoutResponseDataInnerAttributes interface.
 */
function instanceOfTimesheetApprovalLayoutResponseDataInnerAttributes(value) {
    return true;
}
function TimesheetApprovalLayoutResponseDataInnerAttributesFromJSON(json) {
    return TimesheetApprovalLayoutResponseDataInnerAttributesFromJSONTyped(json);
}
function TimesheetApprovalLayoutResponseDataInnerAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'approvalConfirmationMessage': json['approvalConfirmationMessage'] == null ? undefined : json['approvalConfirmationMessage'],
        'approvalConfirmationCheckboxLabel': json['approvalConfirmationCheckboxLabel'] == null ? undefined : json['approvalConfirmationCheckboxLabel'],
        'layoutColumns': json['layoutColumns'] == null ? undefined : (json['layoutColumns'].map(TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerFromJSON)),
    };
}
function TimesheetApprovalLayoutResponseDataInnerAttributesToJSON(json) {
    return TimesheetApprovalLayoutResponseDataInnerAttributesToJSONTyped(json);
}
function TimesheetApprovalLayoutResponseDataInnerAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'approvalConfirmationMessage': value['approvalConfirmationMessage'],
        'approvalConfirmationCheckboxLabel': value['approvalConfirmationCheckboxLabel'],
        'layoutColumns': value['layoutColumns'] == null ? undefined : (value['layoutColumns'].map(TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimesheetApprovalLayoutResponseDataInner interface.
 */
function instanceOfTimesheetApprovalLayoutResponseDataInner(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function TimesheetApprovalLayoutResponseDataInnerFromJSON(json) {
    return TimesheetApprovalLayoutResponseDataInnerFromJSONTyped(json);
}
function TimesheetApprovalLayoutResponseDataInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': json['attributes'] == null ? undefined : TimesheetApprovalLayoutResponseDataInnerAttributesFromJSON(json['attributes']),
    };
}
function TimesheetApprovalLayoutResponseDataInnerToJSON(json) {
    return TimesheetApprovalLayoutResponseDataInnerToJSONTyped(json);
}
function TimesheetApprovalLayoutResponseDataInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': TimesheetApprovalLayoutResponseDataInnerAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimesheetApprovalLayoutResponse interface.
 */
function instanceOfTimesheetApprovalLayoutResponse(value) {
    return true;
}
function TimesheetApprovalLayoutResponseFromJSON(json) {
    return TimesheetApprovalLayoutResponseFromJSONTyped(json);
}
function TimesheetApprovalLayoutResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : (json['data'].map(TimesheetApprovalLayoutResponseDataInnerFromJSON)),
    };
}
function TimesheetApprovalLayoutResponseToJSON(json) {
    return TimesheetApprovalLayoutResponseToJSONTyped(json);
}
function TimesheetApprovalLayoutResponseToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': value['data'] == null ? undefined : (value['data'].map(TimesheetApprovalLayoutResponseDataInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimesheetEntryDataIncludedInner interface.
 */
function instanceOfTimesheetEntryDataIncludedInner(value) {
    return true;
}
function TimesheetEntryDataIncludedInnerFromJSON(json) {
    return TimesheetEntryDataIncludedInnerFromJSONTyped(json);
}
function TimesheetEntryDataIncludedInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'employees': json['employees'] == null ? undefined : (json['employees'].map(IncludedEmployeeInformationFromJSON)),
        'jobs': json['jobs'] == null ? undefined : (json['jobs'].map(IncludedJobInformationFromJSON)),
        'payCodes': json['payCodes'] == null ? undefined : (json['payCodes'].map(PayCodeCardFromJSON)),
    };
}
function TimesheetEntryDataIncludedInnerToJSON(json) {
    return TimesheetEntryDataIncludedInnerToJSONTyped(json);
}
function TimesheetEntryDataIncludedInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'employees': value['employees'] == null ? undefined : (value['employees'].map(IncludedEmployeeInformationToJSON)),
        'jobs': value['jobs'] == null ? undefined : (value['jobs'].map(IncludedJobInformationToJSON)),
        'payCodes': value['payCodes'] == null ? undefined : (value['payCodes'].map(PayCodeCardToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimesheetEntryResourceRelationships interface.
 */
function instanceOfTimesheetEntryResourceRelationships(value) {
    return true;
}
function TimesheetEntryResourceRelationshipsFromJSON(json) {
    return TimesheetEntryResourceRelationshipsFromJSONTyped(json);
}
function TimesheetEntryResourceRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'employee': json['employee'] == null ? undefined : EmployeeRelationshipFromJSON(json['employee']),
        'job': json['job'] == null ? undefined : JobRelationshipFromJSON(json['job']),
        'payCode': json['payCode'] == null ? undefined : PayCodeRelationshipFromJSON(json['payCode']),
    };
}
function TimesheetEntryResourceRelationshipsToJSON(json) {
    return TimesheetEntryResourceRelationshipsToJSONTyped(json);
}
function TimesheetEntryResourceRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'employee': EmployeeRelationshipToJSON(value['employee']),
        'job': JobRelationshipToJSON(value['job']),
        'payCode': PayCodeRelationshipToJSON(value['payCode']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimesheetEntryResourceAttributes interface.
 */
function instanceOfTimesheetEntryResourceAttributes(value) {
    if (!('workDate' in value) || value['workDate'] === undefined)
        return false;
    if (!('entryField' in value) || value['entryField'] === undefined)
        return false;
    if (!('payCodeId' in value) || value['payCodeId'] === undefined)
        return false;
    return true;
}
function TimesheetEntryResourceAttributesFromJSON(json) {
    return TimesheetEntryResourceAttributesFromJSONTyped(json);
}
function TimesheetEntryResourceAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'totals': json['totals'] == null ? undefined : json['totals'],
        'workDate': (dateAndTime.DateWithoutTime.fromISO(json['workDate'])),
        'entryField': EntryFieldFromJSON(json['entryField']),
        'payCodeId': json['payCodeId'],
        'fields': json['fields'] == null ? undefined : (mapValues(json['fields'], DiscriminatedFieldValueFromJSON)),
    };
}
function TimesheetEntryResourceAttributesToJSON(json) {
    return TimesheetEntryResourceAttributesToJSONTyped(json);
}
function TimesheetEntryResourceAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'totals': value['totals'],
        'workDate': value['workDate'].toISO(),
        'entryField': EntryFieldToJSON(value['entryField']),
        'payCodeId': value['payCodeId'],
        'fields': value['fields'] == null ? undefined : (mapValues(value['fields'], DiscriminatedFieldValueToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimesheetEntryResource interface.
 */
function instanceOfTimesheetEntryResource(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function TimesheetEntryResourceFromJSON(json) {
    return TimesheetEntryResourceFromJSONTyped(json);
}
function TimesheetEntryResourceFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': TimesheetEntryResourceAttributesFromJSON(json['attributes']),
        'meta': json['meta'] == null ? undefined : TimesheetEntryResourceMetaFromJSON(json['meta']),
        'relationships': json['relationships'] == null ? undefined : TimesheetEntryResourceRelationshipsFromJSON(json['relationships']),
    };
}
function TimesheetEntryResourceToJSON(json) {
    return TimesheetEntryResourceToJSONTyped(json);
}
function TimesheetEntryResourceToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': TimesheetEntryResourceAttributesToJSON(value['attributes']),
        'meta': TimesheetEntryResourceMetaToJSON(value['meta']),
        'relationships': TimesheetEntryResourceRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimesheetEntryData interface.
 */
function instanceOfTimesheetEntryData(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function TimesheetEntryDataFromJSON(json) {
    return TimesheetEntryDataFromJSONTyped(json);
}
function TimesheetEntryDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(TimesheetEntryResourceFromJSON)),
        'included': json['included'] == null ? undefined : (json['included'].map(TimesheetEntryDataIncludedInnerFromJSON)),
    };
}
function TimesheetEntryDataToJSON(json) {
    return TimesheetEntryDataToJSONTyped(json);
}
function TimesheetEntryDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(TimesheetEntryResourceToJSON)),
        'included': value['included'] == null ? undefined : (value['included'].map(TimesheetEntryDataIncludedInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Represents included resources in timesheet responses.
 * @export
 */
var TimesheetEntryIncludeItem = {
    Employee: 'employee',
    Job: 'job'
};
function instanceOfTimesheetEntryIncludeItem(value) {
    for (var key in TimesheetEntryIncludeItem) {
        if (Object.prototype.hasOwnProperty.call(TimesheetEntryIncludeItem, key)) {
            if (TimesheetEntryIncludeItem[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function TimesheetEntryIncludeItemFromJSON(json) {
    return TimesheetEntryIncludeItemFromJSONTyped(json);
}
function TimesheetEntryIncludeItemFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function TimesheetEntryIncludeItemToJSON(value) {
    return value;
}
function TimesheetEntryIncludeItemToJSONTyped(value, ignoreDiscriminator) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimesheetExceptionPatchRequestDataAttributes interface.
 */
function instanceOfTimesheetExceptionPatchRequestDataAttributes(value) {
    return true;
}
function TimesheetExceptionPatchRequestDataAttributesFromJSON(json) {
    return TimesheetExceptionPatchRequestDataAttributesFromJSONTyped(json);
}
function TimesheetExceptionPatchRequestDataAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'overridden': json['overridden'] == null ? undefined : json['overridden'],
        'selectedOverrideChoice': json['selectedOverrideChoice'] == null ? undefined : SelectedOverrideChoiceFromJSON(json['selectedOverrideChoice']),
        'dismissedFromAssistant': json['dismissedFromAssistant'] == null ? undefined : json['dismissedFromAssistant'],
    };
}
function TimesheetExceptionPatchRequestDataAttributesToJSON(json) {
    return TimesheetExceptionPatchRequestDataAttributesToJSONTyped(json);
}
function TimesheetExceptionPatchRequestDataAttributesToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'overridden': value['overridden'],
        'selectedOverrideChoice': SelectedOverrideChoiceToJSON(value['selectedOverrideChoice']),
        'dismissedFromAssistant': value['dismissedFromAssistant'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimesheetExceptionPatchRequestData interface.
 */
function instanceOfTimesheetExceptionPatchRequestData(value) {
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function TimesheetExceptionPatchRequestDataFromJSON(json) {
    return TimesheetExceptionPatchRequestDataFromJSONTyped(json);
}
function TimesheetExceptionPatchRequestDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'attributes': TimesheetExceptionPatchRequestDataAttributesFromJSON(json['attributes']),
    };
}
function TimesheetExceptionPatchRequestDataToJSON(json) {
    return TimesheetExceptionPatchRequestDataToJSONTyped(json);
}
function TimesheetExceptionPatchRequestDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': TimesheetExceptionPatchRequestDataAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimesheetExceptionPatchRequest interface.
 */
function instanceOfTimesheetExceptionPatchRequest(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function TimesheetExceptionPatchRequestFromJSON(json) {
    return TimesheetExceptionPatchRequestFromJSONTyped(json);
}
function TimesheetExceptionPatchRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': TimesheetExceptionPatchRequestDataFromJSON(json['data']),
    };
}
function TimesheetExceptionPatchRequestToJSON(json) {
    return TimesheetExceptionPatchRequestToJSONTyped(json);
}
function TimesheetExceptionPatchRequestToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': TimesheetExceptionPatchRequestDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
function TimesheetExceptionsIncludedFromJSON(json) {
    return TimesheetExceptionsIncludedFromJSONTyped(json);
}
function TimesheetExceptionsIncludedFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    switch (json['type']) {
        case 'employee':
            return Object.assign({}, IncludedEmployeeInformationFromJSONTyped(json), { type: 'employee' });
        case 'job':
            return Object.assign({}, IncludedJobInformationFromJSONTyped(json), { type: 'job' });
        default:
            return json;
    }
}
function TimesheetExceptionsIncludedToJSON(json) {
    return TimesheetExceptionsIncludedToJSONTyped(json);
}
function TimesheetExceptionsIncludedToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    switch (value['type']) {
        case 'employee':
            return Object.assign({}, IncludedEmployeeInformationToJSON(value), { type: 'employee' });
        case 'job':
            return Object.assign({}, IncludedJobInformationToJSON(value), { type: 'job' });
        default:
            return value;
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimesheetExceptionsMeta interface.
 */
function instanceOfTimesheetExceptionsMeta(value) {
    return true;
}
function TimesheetExceptionsMetaFromJSON(json) {
    return TimesheetExceptionsMetaFromJSONTyped(json);
}
function TimesheetExceptionsMetaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'page': json['page'] == null ? undefined : PageMetadataFromJSON(json['page']),
    };
}
function TimesheetExceptionsMetaToJSON(json) {
    return TimesheetExceptionsMetaToJSONTyped(json);
}
function TimesheetExceptionsMetaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'page': PageMetadataToJSON(value['page']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimesheetExceptionsResponseSchema interface.
 */
function instanceOfTimesheetExceptionsResponseSchema(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function TimesheetExceptionsResponseSchemaFromJSON(json) {
    return TimesheetExceptionsResponseSchemaFromJSONTyped(json);
}
function TimesheetExceptionsResponseSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'meta': json['meta'] == null ? undefined : TimesheetExceptionsMetaFromJSON(json['meta']),
        'links': json['links'] == null ? undefined : LinksFromJSON(json['links']),
        'data': (json['data'].map(TimesheetExceptionFromJSON)),
        'included': json['included'] == null ? undefined : (json['included'].map(TimesheetExceptionsIncludedFromJSON)),
    };
}
function TimesheetExceptionsResponseSchemaToJSON(json) {
    return TimesheetExceptionsResponseSchemaToJSONTyped(json);
}
function TimesheetExceptionsResponseSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'meta': TimesheetExceptionsMetaToJSON(value['meta']),
        'links': LinksToJSON(value['links']),
        'data': (value['data'].map(TimesheetExceptionToJSON)),
        'included': value['included'] == null ? undefined : (value['included'].map(TimesheetExceptionsIncludedToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Represents included resources in timesheet responses.
 * @export
 */
var TimesheetIncludeItem = {
    Employee: 'employee',
    Job: 'job',
    TimesheetEntry: 'timesheetEntry',
    TimesheetException: 'timesheetException'
};
function instanceOfTimesheetIncludeItem(value) {
    for (var key in TimesheetIncludeItem) {
        if (Object.prototype.hasOwnProperty.call(TimesheetIncludeItem, key)) {
            if (TimesheetIncludeItem[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function TimesheetIncludeItemFromJSON(json) {
    return TimesheetIncludeItemFromJSONTyped(json);
}
function TimesheetIncludeItemFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function TimesheetIncludeItemToJSON(value) {
    return value;
}
function TimesheetIncludeItemToJSONTyped(value, ignoreDiscriminator) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimesheetResponseIncludedInner interface.
 */
function instanceOfTimesheetResponseIncludedInner(value) {
    return true;
}
function TimesheetResponseIncludedInnerFromJSON(json) {
    return TimesheetResponseIncludedInnerFromJSONTyped(json);
}
function TimesheetResponseIncludedInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'employees': json['employees'] == null ? undefined : (json['employees'].map(IncludedEmployeeInformationFromJSON)),
        'jobs': json['jobs'] == null ? undefined : (json['jobs'].map(IncludedJobInformationFromJSON)),
        'timesheetExceptions': json['timesheetExceptions'] == null ? undefined : (json['timesheetExceptions'].map(TimesheetExceptionFromJSON)),
        'timesheetEntries': json['timesheetEntries'] == null ? undefined : (json['timesheetEntries'].map(TimesheetEntryResourceFromJSON)),
    };
}
function TimesheetResponseIncludedInnerToJSON(json) {
    return TimesheetResponseIncludedInnerToJSONTyped(json);
}
function TimesheetResponseIncludedInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'employees': value['employees'] == null ? undefined : (value['employees'].map(IncludedEmployeeInformationToJSON)),
        'jobs': value['jobs'] == null ? undefined : (value['jobs'].map(IncludedJobInformationToJSON)),
        'timesheetExceptions': value['timesheetExceptions'] == null ? undefined : (value['timesheetExceptions'].map(TimesheetExceptionToJSON)),
        'timesheetEntries': value['timesheetEntries'] == null ? undefined : (value['timesheetEntries'].map(TimesheetEntryResourceToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the TimesheetResponse interface.
 */
function instanceOfTimesheetResponse(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function TimesheetResponseFromJSON(json) {
    return TimesheetResponseFromJSONTyped(json);
}
function TimesheetResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(TimesheetSchemaFromJSON)),
        'included': json['included'] == null ? undefined : (json['included'].map(TimesheetResponseIncludedInnerFromJSON)),
    };
}
function TimesheetResponseToJSON(json) {
    return TimesheetResponseToJSONTyped(json);
}
function TimesheetResponseToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(TimesheetSchemaToJSON)),
        'included': value['included'] == null ? undefined : (value['included'].map(TimesheetResponseIncludedInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the UpdateAbsenceCaseOperationData interface.
 */
function instanceOfUpdateAbsenceCaseOperationData(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function UpdateAbsenceCaseOperationDataFromJSON(json) {
    return UpdateAbsenceCaseOperationDataFromJSONTyped(json);
}
function UpdateAbsenceCaseOperationDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'id': json['id'],
        'attributes': AbsenceCaseEditableAttributesFromJSON(json['attributes']),
    };
}
function UpdateAbsenceCaseOperationDataToJSON(json) {
    return UpdateAbsenceCaseOperationDataToJSONTyped(json);
}
function UpdateAbsenceCaseOperationDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'id': value['id'],
        'attributes': AbsenceCaseEditableAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var UpdateAbsenceCaseOperationOpEnum = {
    Update: 'update'
};
/**
 * Check if a given object implements the UpdateAbsenceCaseOperation interface.
 */
function instanceOfUpdateAbsenceCaseOperation(value) {
    if (!('op' in value) || value['op'] === undefined)
        return false;
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function UpdateAbsenceCaseOperationFromJSON(json) {
    return UpdateAbsenceCaseOperationFromJSONTyped(json);
}
function UpdateAbsenceCaseOperationFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'op': json['op'],
        'data': UpdateAbsenceCaseOperationDataFromJSON(json['data']),
    };
}
function UpdateAbsenceCaseOperationToJSON(json) {
    return UpdateAbsenceCaseOperationToJSONTyped(json);
}
function UpdateAbsenceCaseOperationToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'op': value['op'],
        'data': UpdateAbsenceCaseOperationDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UpdateCaseManagerOperationDataInner interface.
 */
function instanceOfUpdateCaseManagerOperationDataInner(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    return true;
}
function UpdateCaseManagerOperationDataInnerFromJSON(json) {
    return UpdateCaseManagerOperationDataInnerFromJSONTyped(json);
}
function UpdateCaseManagerOperationDataInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'id': json['id'],
    };
}
function UpdateCaseManagerOperationDataInnerToJSON(json) {
    return UpdateCaseManagerOperationDataInnerToJSONTyped(json);
}
function UpdateCaseManagerOperationDataInnerToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'id': value['id'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var UpdateCaseManagerOperationOpEnum = {
    Update: 'update'
};
/**
 * Check if a given object implements the UpdateCaseManagerOperation interface.
 */
function instanceOfUpdateCaseManagerOperation(value) {
    if (!('op' in value) || value['op'] === undefined)
        return false;
    if (!('ref' in value) || value['ref'] === undefined)
        return false;
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function UpdateCaseManagerOperationFromJSON(json) {
    return UpdateCaseManagerOperationFromJSONTyped(json);
}
function UpdateCaseManagerOperationFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'op': json['op'],
        'ref': UpdateCaseManagerOperationRefFromJSON(json['ref']),
        'data': (json['data'].map(UpdateCaseManagerOperationDataInnerFromJSON)),
    };
}
function UpdateCaseManagerOperationToJSON(json) {
    return UpdateCaseManagerOperationToJSONTyped(json);
}
function UpdateCaseManagerOperationToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'op': value['op'],
        'ref': UpdateCaseManagerOperationRefToJSON(value['ref']),
        'data': (value['data'].map(UpdateCaseManagerOperationDataInnerToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var UpdateLeaveEligibilityOperationOpEnum = {
    Update: 'update'
};
/**
 * Check if a given object implements the UpdateLeaveEligibilityOperation interface.
 */
function instanceOfUpdateLeaveEligibilityOperation(value) {
    if (!('op' in value) || value['op'] === undefined)
        return false;
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function UpdateLeaveEligibilityOperationFromJSON(json) {
    return UpdateLeaveEligibilityOperationFromJSONTyped(json);
}
function UpdateLeaveEligibilityOperationFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'op': json['op'],
        'data': UpdateLeaveEligibilityOperationDataFromJSON(json['data']),
    };
}
function UpdateLeaveEligibilityOperationToJSON(json) {
    return UpdateLeaveEligibilityOperationToJSONTyped(json);
}
function UpdateLeaveEligibilityOperationToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'op': value['op'],
        'data': UpdateLeaveEligibilityOperationDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UpdatePayRuleRequestSchemaBody interface.
 */
function instanceOfUpdatePayRuleRequestSchemaBody(value) {
    return true;
}
function UpdatePayRuleRequestSchemaBodyFromJSON(json) {
    return UpdatePayRuleRequestSchemaBodyFromJSONTyped(json);
}
function UpdatePayRuleRequestSchemaBodyFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'] == null ? undefined : json['name'],
        'payCode': json['payCode'] == null ? undefined : json['payCode'],
        'priority': json['priority'] == null ? undefined : json['priority'],
    };
}
function UpdatePayRuleRequestSchemaBodyToJSON(json) {
    return UpdatePayRuleRequestSchemaBodyToJSONTyped(json);
}
function UpdatePayRuleRequestSchemaBodyToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'payCode': value['payCode'],
        'priority': value['priority'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var UpdatePayRuleRequestSchemaDataTypeEnum = {
    PayRule: 'payRule'
};
/**
 * Check if a given object implements the UpdatePayRuleRequestSchemaData interface.
 */
function instanceOfUpdatePayRuleRequestSchemaData(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    return true;
}
function UpdatePayRuleRequestSchemaDataFromJSON(json) {
    return UpdatePayRuleRequestSchemaDataFromJSONTyped(json);
}
function UpdatePayRuleRequestSchemaDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'id': json['id'],
        'attributes': json['attributes'] == null ? undefined : UpdatePayRuleRequestSchemaBodyFromJSON(json['attributes']),
        'relationships': json['relationships'] == null ? undefined : PayRuleRelationshipsFromJSON(json['relationships']),
    };
}
function UpdatePayRuleRequestSchemaDataToJSON(json) {
    return UpdatePayRuleRequestSchemaDataToJSONTyped(json);
}
function UpdatePayRuleRequestSchemaDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'id': value['id'],
        'attributes': UpdatePayRuleRequestSchemaBodyToJSON(value['attributes']),
        'relationships': PayRuleRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the UpdatePayRuleRequestSchema interface.
 */
function instanceOfUpdatePayRuleRequestSchema(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function UpdatePayRuleRequestSchemaFromJSON(json) {
    return UpdatePayRuleRequestSchemaFromJSONTyped(json);
}
function UpdatePayRuleRequestSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': UpdatePayRuleRequestSchemaDataFromJSON(json['data']),
    };
}
function UpdatePayRuleRequestSchemaToJSON(json) {
    return UpdatePayRuleRequestSchemaToJSONTyped(json);
}
function UpdatePayRuleRequestSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': UpdatePayRuleRequestSchemaDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the UpdateProjectedUsageOperationData interface.
 */
function instanceOfUpdateProjectedUsageOperationData(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    return true;
}
function UpdateProjectedUsageOperationDataFromJSON(json) {
    return UpdateProjectedUsageOperationDataFromJSONTyped(json);
}
function UpdateProjectedUsageOperationDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'id': json['id'],
        'attributes': LeaveEligibleOverrideDtlFromJSON(json['attributes']),
    };
}
function UpdateProjectedUsageOperationDataToJSON(json) {
    return UpdateProjectedUsageOperationDataToJSONTyped(json);
}
function UpdateProjectedUsageOperationDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'id': value['id'],
        'attributes': LeaveEligibleOverrideDtlToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var UpdateProjectedUsageOperationOpEnum = {
    Update: 'update'
};
/**
 * Check if a given object implements the UpdateProjectedUsageOperation interface.
 */
function instanceOfUpdateProjectedUsageOperation(value) {
    if (!('op' in value) || value['op'] === undefined)
        return false;
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function UpdateProjectedUsageOperationFromJSON(json) {
    return UpdateProjectedUsageOperationFromJSONTyped(json);
}
function UpdateProjectedUsageOperationFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'op': json['op'],
        'data': UpdateProjectedUsageOperationDataFromJSON(json['data']),
    };
}
function UpdateProjectedUsageOperationToJSON(json) {
    return UpdateProjectedUsageOperationToJSONTyped(json);
}
function UpdateProjectedUsageOperationToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'op': value['op'],
        'data': UpdateProjectedUsageOperationDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the UpdateShiftRelationships interface.
 */
function instanceOfUpdateShiftRelationships(value) {
    return true;
}
function UpdateShiftRelationshipsFromJSON(json) {
    return UpdateShiftRelationshipsFromJSONTyped(json);
}
function UpdateShiftRelationshipsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'employee': json['employee'] == null ? undefined : ShiftEmployeeRelationshipFromJSON(json['employee']),
        'role': json['role'] == null ? undefined : RoleRelationshipFromJSON(json['role']),
        'reasonCode': json['reasonCode'] == null ? undefined : ReasonCodeRelationshipFromJSON(json['reasonCode']),
        'overtimeType': json['overtimeType'] == null ? undefined : OvertimeTypeRelationshipFromJSON(json['overtimeType']),
        'selectionConstraint': json['selectionConstraint'] == null ? undefined : SelectionConstraintRelationshipFromJSON(json['selectionConstraint']),
        'event': json['event'] == null ? undefined : ShiftEventRelationshipFromJSON(json['event']),
    };
}
function UpdateShiftRelationshipsToJSON(json) {
    return UpdateShiftRelationshipsToJSONTyped(json);
}
function UpdateShiftRelationshipsToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'employee': ShiftEmployeeRelationshipToJSON(value['employee']),
        'role': RoleRelationshipToJSON(value['role']),
        'reasonCode': ReasonCodeRelationshipToJSON(value['reasonCode']),
        'overtimeType': OvertimeTypeRelationshipToJSON(value['overtimeType']),
        'selectionConstraint': SelectionConstraintRelationshipToJSON(value['selectionConstraint']),
        'event': ShiftEventRelationshipToJSON(value['event']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the UpdateShiftRequestSchemaBody interface.
 */
function instanceOfUpdateShiftRequestSchemaBody(value) {
    return true;
}
function UpdateShiftRequestSchemaBodyFromJSON(json) {
    return UpdateShiftRequestSchemaBodyFromJSONTyped(json);
}
function UpdateShiftRequestSchemaBodyFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'startsAt': json['startsAt'] == null ? undefined : (luxon.DateTime.fromISO(json['startsAt'])),
        'endsAt': json['endsAt'] == null ? undefined : (luxon.DateTime.fromISO(json['endsAt'])),
        'comments': json['comments'] == null ? undefined : json['comments'],
        'workDate': json['workDate'] == null ? undefined : (dateAndTime.DateWithoutTime.fromISO(json['workDate'])),
        'workOrder': json['workOrder'] == null ? undefined : json['workOrder'],
    };
}
function UpdateShiftRequestSchemaBodyToJSON(json) {
    return UpdateShiftRequestSchemaBodyToJSONTyped(json);
}
function UpdateShiftRequestSchemaBodyToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'startsAt': value['startsAt'] == null ? value['startsAt'] : value['startsAt'].toISO(),
        'endsAt': value['endsAt'] == null ? value['endsAt'] : value['endsAt'].toISO(),
        'comments': value['comments'],
        'workDate': value['workDate'] == null ? value['workDate'] : value['workDate'].toISO(),
        'workOrder': value['workOrder'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * @export
 */
var UpdateShiftRequestSchemaDataTypeEnum = {
    Shift: 'shift'
};
/**
 * Check if a given object implements the UpdateShiftRequestSchemaData interface.
 */
function instanceOfUpdateShiftRequestSchemaData(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    return true;
}
function UpdateShiftRequestSchemaDataFromJSON(json) {
    return UpdateShiftRequestSchemaDataFromJSONTyped(json);
}
function UpdateShiftRequestSchemaDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'id': json['id'],
        'attributes': json['attributes'] == null ? undefined : UpdateShiftRequestSchemaBodyFromJSON(json['attributes']),
        'relationships': json['relationships'] == null ? undefined : UpdateShiftRelationshipsFromJSON(json['relationships']),
    };
}
function UpdateShiftRequestSchemaDataToJSON(json) {
    return UpdateShiftRequestSchemaDataToJSONTyped(json);
}
function UpdateShiftRequestSchemaDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'id': value['id'],
        'attributes': UpdateShiftRequestSchemaBodyToJSON(value['attributes']),
        'relationships': UpdateShiftRelationshipsToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the UpdateShiftRequestSchema interface.
 */
function instanceOfUpdateShiftRequestSchema(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function UpdateShiftRequestSchemaFromJSON(json) {
    return UpdateShiftRequestSchemaFromJSONTyped(json);
}
function UpdateShiftRequestSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': UpdateShiftRequestSchemaDataFromJSON(json['data']),
        'meta': json['meta'] == null ? undefined : SaveShiftRequestMetaSchemaFromJSON(json['meta']),
    };
}
function UpdateShiftRequestSchemaToJSON(json) {
    return UpdateShiftRequestSchemaToJSONTyped(json);
}
function UpdateShiftRequestSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': UpdateShiftRequestSchemaDataToJSON(value['data']),
        'meta': SaveShiftRequestMetaSchemaToJSON(value['meta']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the UpdateTimesheetEntryRequestSchemaData interface.
 */
function instanceOfUpdateTimesheetEntryRequestSchemaData(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('attributes' in value) || value['attributes'] === undefined)
        return false;
    if (!('relationships' in value) || value['relationships'] === undefined)
        return false;
    return true;
}
function UpdateTimesheetEntryRequestSchemaDataFromJSON(json) {
    return UpdateTimesheetEntryRequestSchemaDataFromJSONTyped(json);
}
function UpdateTimesheetEntryRequestSchemaDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'attributes': TimesheetEntryAttributesRequestSchemaFromJSON(json['attributes']),
        'relationships': TimesheetEntryRelationshipsRequestSchemaFromJSON(json['relationships']),
    };
}
function UpdateTimesheetEntryRequestSchemaDataToJSON(json) {
    return UpdateTimesheetEntryRequestSchemaDataToJSONTyped(json);
}
function UpdateTimesheetEntryRequestSchemaDataToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': TimesheetEntryAttributesRequestSchemaToJSON(value['attributes']),
        'relationships': TimesheetEntryRelationshipsRequestSchemaToJSON(value['relationships']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the UpdateTimesheetEntryRequestSchema interface.
 */
function instanceOfUpdateTimesheetEntryRequestSchema(value) {
    return true;
}
function UpdateTimesheetEntryRequestSchemaFromJSON(json) {
    return UpdateTimesheetEntryRequestSchemaFromJSONTyped(json);
}
function UpdateTimesheetEntryRequestSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : UpdateTimesheetEntryRequestSchemaDataFromJSON(json['data']),
    };
}
function UpdateTimesheetEntryRequestSchemaToJSON(json) {
    return UpdateTimesheetEntryRequestSchemaToJSONTyped(json);
}
function UpdateTimesheetEntryRequestSchemaToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'data': UpdateTimesheetEntryRequestSchemaDataToJSON(value['data']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @ts-ignore
/**
 * Check if a given object implements the UserCard interface.
 */
function instanceOfUserCard(value) {
    return true;
}
function UserCardFromJSON(json) {
    return UserCardFromJSONTyped(json);
}
function UserCardFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'attributes': json['attributes'] == null ? undefined : UserCardAttributesFromJSON(json['attributes']),
    };
}
function UserCardToJSON(json) {
    return UserCardToJSONTyped(json);
}
function UserCardToJSONTyped(value, ignoreDiscriminator) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'attributes': UserCardAttributesToJSON(value['attributes']),
    };
}

/* tslint:disable */
/* eslint-disable */

var index$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    AbsenceCaseAttributesFromJSON: AbsenceCaseAttributesFromJSON,
    AbsenceCaseAttributesFromJSONTyped: AbsenceCaseAttributesFromJSONTyped,
    AbsenceCaseAttributesToJSON: AbsenceCaseAttributesToJSON,
    AbsenceCaseAttributesToJSONTyped: AbsenceCaseAttributesToJSONTyped,
    AbsenceCaseContactEmployeeRequestDataAttributesFromJSON: AbsenceCaseContactEmployeeRequestDataAttributesFromJSON,
    AbsenceCaseContactEmployeeRequestDataAttributesFromJSONTyped: AbsenceCaseContactEmployeeRequestDataAttributesFromJSONTyped,
    AbsenceCaseContactEmployeeRequestDataAttributesToJSON: AbsenceCaseContactEmployeeRequestDataAttributesToJSON,
    AbsenceCaseContactEmployeeRequestDataAttributesToJSONTyped: AbsenceCaseContactEmployeeRequestDataAttributesToJSONTyped,
    AbsenceCaseContactEmployeeRequestDataFromJSON: AbsenceCaseContactEmployeeRequestDataFromJSON,
    AbsenceCaseContactEmployeeRequestDataFromJSONTyped: AbsenceCaseContactEmployeeRequestDataFromJSONTyped,
    AbsenceCaseContactEmployeeRequestDataRelationshipsFromJSON: AbsenceCaseContactEmployeeRequestDataRelationshipsFromJSON,
    AbsenceCaseContactEmployeeRequestDataRelationshipsFromJSONTyped: AbsenceCaseContactEmployeeRequestDataRelationshipsFromJSONTyped,
    AbsenceCaseContactEmployeeRequestDataRelationshipsToJSON: AbsenceCaseContactEmployeeRequestDataRelationshipsToJSON,
    AbsenceCaseContactEmployeeRequestDataRelationshipsToJSONTyped: AbsenceCaseContactEmployeeRequestDataRelationshipsToJSONTyped,
    AbsenceCaseContactEmployeeRequestDataToJSON: AbsenceCaseContactEmployeeRequestDataToJSON,
    AbsenceCaseContactEmployeeRequestDataToJSONTyped: AbsenceCaseContactEmployeeRequestDataToJSONTyped,
    AbsenceCaseContactEmployeeRequestFromJSON: AbsenceCaseContactEmployeeRequestFromJSON,
    AbsenceCaseContactEmployeeRequestFromJSONTyped: AbsenceCaseContactEmployeeRequestFromJSONTyped,
    AbsenceCaseContactEmployeeRequestToJSON: AbsenceCaseContactEmployeeRequestToJSON,
    AbsenceCaseContactEmployeeRequestToJSONTyped: AbsenceCaseContactEmployeeRequestToJSONTyped,
    AbsenceCaseContactEmployeeResponseAttributesFromJSON: AbsenceCaseContactEmployeeResponseAttributesFromJSON,
    AbsenceCaseContactEmployeeResponseAttributesFromJSONTyped: AbsenceCaseContactEmployeeResponseAttributesFromJSONTyped,
    AbsenceCaseContactEmployeeResponseAttributesToJSON: AbsenceCaseContactEmployeeResponseAttributesToJSON,
    AbsenceCaseContactEmployeeResponseAttributesToJSONTyped: AbsenceCaseContactEmployeeResponseAttributesToJSONTyped,
    AbsenceCaseContactEmployeeResponseFromJSON: AbsenceCaseContactEmployeeResponseFromJSON,
    AbsenceCaseContactEmployeeResponseFromJSONTyped: AbsenceCaseContactEmployeeResponseFromJSONTyped,
    AbsenceCaseContactEmployeeResponseRelationshipsFromJSON: AbsenceCaseContactEmployeeResponseRelationshipsFromJSON,
    AbsenceCaseContactEmployeeResponseRelationshipsFromJSONTyped: AbsenceCaseContactEmployeeResponseRelationshipsFromJSONTyped,
    AbsenceCaseContactEmployeeResponseRelationshipsToJSON: AbsenceCaseContactEmployeeResponseRelationshipsToJSON,
    AbsenceCaseContactEmployeeResponseRelationshipsToJSONTyped: AbsenceCaseContactEmployeeResponseRelationshipsToJSONTyped,
    AbsenceCaseContactEmployeeResponseToJSON: AbsenceCaseContactEmployeeResponseToJSON,
    AbsenceCaseContactEmployeeResponseToJSONTyped: AbsenceCaseContactEmployeeResponseToJSONTyped,
    AbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInnerFromJSON: AbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInnerFromJSON,
    AbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInnerFromJSONTyped: AbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInnerFromJSONTyped,
    AbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInnerToJSON: AbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInnerToJSON,
    AbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInnerToJSONTyped: AbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInnerToJSONTyped,
    AbsenceCaseDetailsAttributesContactMethodEnum: AbsenceCaseDetailsAttributesContactMethodEnum,
    AbsenceCaseDetailsAttributesFromJSON: AbsenceCaseDetailsAttributesFromJSON,
    AbsenceCaseDetailsAttributesFromJSONTyped: AbsenceCaseDetailsAttributesFromJSONTyped,
    AbsenceCaseDetailsAttributesToJSON: AbsenceCaseDetailsAttributesToJSON,
    AbsenceCaseDetailsAttributesToJSONTyped: AbsenceCaseDetailsAttributesToJSONTyped,
    AbsenceCaseDetailsAttributesUsePaidTimeEnum: AbsenceCaseDetailsAttributesUsePaidTimeEnum,
    AbsenceCaseDetailsFromJSON: AbsenceCaseDetailsFromJSON,
    AbsenceCaseDetailsFromJSONTyped: AbsenceCaseDetailsFromJSONTyped,
    AbsenceCaseDetailsRelationshipsFromJSON: AbsenceCaseDetailsRelationshipsFromJSON,
    AbsenceCaseDetailsRelationshipsFromJSONTyped: AbsenceCaseDetailsRelationshipsFromJSONTyped,
    AbsenceCaseDetailsRelationshipsToJSON: AbsenceCaseDetailsRelationshipsToJSON,
    AbsenceCaseDetailsRelationshipsToJSONTyped: AbsenceCaseDetailsRelationshipsToJSONTyped,
    AbsenceCaseDetailsToJSON: AbsenceCaseDetailsToJSON,
    AbsenceCaseDetailsToJSONTyped: AbsenceCaseDetailsToJSONTyped,
    AbsenceCaseDocumentsReducedAttributesFromJSON: AbsenceCaseDocumentsReducedAttributesFromJSON,
    AbsenceCaseDocumentsReducedAttributesFromJSONTyped: AbsenceCaseDocumentsReducedAttributesFromJSONTyped,
    AbsenceCaseDocumentsReducedAttributesStatusEnum: AbsenceCaseDocumentsReducedAttributesStatusEnum,
    AbsenceCaseDocumentsReducedAttributesToJSON: AbsenceCaseDocumentsReducedAttributesToJSON,
    AbsenceCaseDocumentsReducedAttributesToJSONTyped: AbsenceCaseDocumentsReducedAttributesToJSONTyped,
    AbsenceCaseDocumentsReducedAttributesTriggerTypeEnum: AbsenceCaseDocumentsReducedAttributesTriggerTypeEnum,
    AbsenceCaseDocumentsReducedFromJSON: AbsenceCaseDocumentsReducedFromJSON,
    AbsenceCaseDocumentsReducedFromJSONTyped: AbsenceCaseDocumentsReducedFromJSONTyped,
    AbsenceCaseDocumentsReducedToJSON: AbsenceCaseDocumentsReducedToJSON,
    AbsenceCaseDocumentsReducedToJSONTyped: AbsenceCaseDocumentsReducedToJSONTyped,
    AbsenceCaseDocumentsRelationshipDataInnerFromJSON: AbsenceCaseDocumentsRelationshipDataInnerFromJSON,
    AbsenceCaseDocumentsRelationshipDataInnerFromJSONTyped: AbsenceCaseDocumentsRelationshipDataInnerFromJSONTyped,
    AbsenceCaseDocumentsRelationshipDataInnerToJSON: AbsenceCaseDocumentsRelationshipDataInnerToJSON,
    AbsenceCaseDocumentsRelationshipDataInnerToJSONTyped: AbsenceCaseDocumentsRelationshipDataInnerToJSONTyped,
    AbsenceCaseDocumentsRelationshipFromJSON: AbsenceCaseDocumentsRelationshipFromJSON,
    AbsenceCaseDocumentsRelationshipFromJSONTyped: AbsenceCaseDocumentsRelationshipFromJSONTyped,
    AbsenceCaseDocumentsRelationshipToJSON: AbsenceCaseDocumentsRelationshipToJSON,
    AbsenceCaseDocumentsRelationshipToJSONTyped: AbsenceCaseDocumentsRelationshipToJSONTyped,
    AbsenceCaseEditableAttributesContactMethodEnum: AbsenceCaseEditableAttributesContactMethodEnum,
    AbsenceCaseEditableAttributesFromJSON: AbsenceCaseEditableAttributesFromJSON,
    AbsenceCaseEditableAttributesFromJSONTyped: AbsenceCaseEditableAttributesFromJSONTyped,
    AbsenceCaseEditableAttributesToJSON: AbsenceCaseEditableAttributesToJSON,
    AbsenceCaseEditableAttributesToJSONTyped: AbsenceCaseEditableAttributesToJSONTyped,
    AbsenceCaseEditableAttributesUsePaidTimeEnum: AbsenceCaseEditableAttributesUsePaidTimeEnum,
    AbsenceCaseEventRelationshipDataAttributesFromJSON: AbsenceCaseEventRelationshipDataAttributesFromJSON,
    AbsenceCaseEventRelationshipDataAttributesFromJSONTyped: AbsenceCaseEventRelationshipDataAttributesFromJSONTyped,
    AbsenceCaseEventRelationshipDataAttributesToJSON: AbsenceCaseEventRelationshipDataAttributesToJSON,
    AbsenceCaseEventRelationshipDataAttributesToJSONTyped: AbsenceCaseEventRelationshipDataAttributesToJSONTyped,
    AbsenceCaseEventRelationshipDataFromJSON: AbsenceCaseEventRelationshipDataFromJSON,
    AbsenceCaseEventRelationshipDataFromJSONTyped: AbsenceCaseEventRelationshipDataFromJSONTyped,
    AbsenceCaseEventRelationshipDataToJSON: AbsenceCaseEventRelationshipDataToJSON,
    AbsenceCaseEventRelationshipDataToJSONTyped: AbsenceCaseEventRelationshipDataToJSONTyped,
    AbsenceCaseEventRelationshipFromJSON: AbsenceCaseEventRelationshipFromJSON,
    AbsenceCaseEventRelationshipFromJSONTyped: AbsenceCaseEventRelationshipFromJSONTyped,
    AbsenceCaseEventRelationshipToJSON: AbsenceCaseEventRelationshipToJSON,
    AbsenceCaseEventRelationshipToJSONTyped: AbsenceCaseEventRelationshipToJSONTyped,
    AbsenceCaseFromJSON: AbsenceCaseFromJSON,
    AbsenceCaseFromJSONTyped: AbsenceCaseFromJSONTyped,
    AbsenceCaseHistoryEventAttributesFromJSON: AbsenceCaseHistoryEventAttributesFromJSON,
    AbsenceCaseHistoryEventAttributesFromJSONTyped: AbsenceCaseHistoryEventAttributesFromJSONTyped,
    AbsenceCaseHistoryEventAttributesToJSON: AbsenceCaseHistoryEventAttributesToJSON,
    AbsenceCaseHistoryEventAttributesToJSONTyped: AbsenceCaseHistoryEventAttributesToJSONTyped,
    AbsenceCaseHistoryEventFromJSON: AbsenceCaseHistoryEventFromJSON,
    AbsenceCaseHistoryEventFromJSONTyped: AbsenceCaseHistoryEventFromJSONTyped,
    AbsenceCaseHistoryEventRelationshipDataFromJSON: AbsenceCaseHistoryEventRelationshipDataFromJSON,
    AbsenceCaseHistoryEventRelationshipDataFromJSONTyped: AbsenceCaseHistoryEventRelationshipDataFromJSONTyped,
    AbsenceCaseHistoryEventRelationshipDataToJSON: AbsenceCaseHistoryEventRelationshipDataToJSON,
    AbsenceCaseHistoryEventRelationshipDataToJSONTyped: AbsenceCaseHistoryEventRelationshipDataToJSONTyped,
    AbsenceCaseHistoryEventRelationshipFromJSON: AbsenceCaseHistoryEventRelationshipFromJSON,
    AbsenceCaseHistoryEventRelationshipFromJSONTyped: AbsenceCaseHistoryEventRelationshipFromJSONTyped,
    AbsenceCaseHistoryEventRelationshipToJSON: AbsenceCaseHistoryEventRelationshipToJSON,
    AbsenceCaseHistoryEventRelationshipToJSONTyped: AbsenceCaseHistoryEventRelationshipToJSONTyped,
    AbsenceCaseHistoryEventRelationshipsFromJSON: AbsenceCaseHistoryEventRelationshipsFromJSON,
    AbsenceCaseHistoryEventRelationshipsFromJSONTyped: AbsenceCaseHistoryEventRelationshipsFromJSONTyped,
    AbsenceCaseHistoryEventRelationshipsToJSON: AbsenceCaseHistoryEventRelationshipsToJSON,
    AbsenceCaseHistoryEventRelationshipsToJSONTyped: AbsenceCaseHistoryEventRelationshipsToJSONTyped,
    AbsenceCaseHistoryEventToJSON: AbsenceCaseHistoryEventToJSON,
    AbsenceCaseHistoryEventToJSONTyped: AbsenceCaseHistoryEventToJSONTyped,
    AbsenceCaseLeaveEligibilityReducedAttributesFromJSON: AbsenceCaseLeaveEligibilityReducedAttributesFromJSON,
    AbsenceCaseLeaveEligibilityReducedAttributesFromJSONTyped: AbsenceCaseLeaveEligibilityReducedAttributesFromJSONTyped,
    AbsenceCaseLeaveEligibilityReducedAttributesToJSON: AbsenceCaseLeaveEligibilityReducedAttributesToJSON,
    AbsenceCaseLeaveEligibilityReducedAttributesToJSONTyped: AbsenceCaseLeaveEligibilityReducedAttributesToJSONTyped,
    AbsenceCaseLeaveEligibilityReducedFromJSON: AbsenceCaseLeaveEligibilityReducedFromJSON,
    AbsenceCaseLeaveEligibilityReducedFromJSONTyped: AbsenceCaseLeaveEligibilityReducedFromJSONTyped,
    AbsenceCaseLeaveEligibilityReducedToJSON: AbsenceCaseLeaveEligibilityReducedToJSON,
    AbsenceCaseLeaveEligibilityReducedToJSONTyped: AbsenceCaseLeaveEligibilityReducedToJSONTyped,
    AbsenceCaseLeaveEligibilityRelationshipDataInnerFromJSON: AbsenceCaseLeaveEligibilityRelationshipDataInnerFromJSON,
    AbsenceCaseLeaveEligibilityRelationshipDataInnerFromJSONTyped: AbsenceCaseLeaveEligibilityRelationshipDataInnerFromJSONTyped,
    AbsenceCaseLeaveEligibilityRelationshipDataInnerToJSON: AbsenceCaseLeaveEligibilityRelationshipDataInnerToJSON,
    AbsenceCaseLeaveEligibilityRelationshipDataInnerToJSONTyped: AbsenceCaseLeaveEligibilityRelationshipDataInnerToJSONTyped,
    AbsenceCaseLeaveEligibilityRelationshipFromJSON: AbsenceCaseLeaveEligibilityRelationshipFromJSON,
    AbsenceCaseLeaveEligibilityRelationshipFromJSONTyped: AbsenceCaseLeaveEligibilityRelationshipFromJSONTyped,
    AbsenceCaseLeaveEligibilityRelationshipToJSON: AbsenceCaseLeaveEligibilityRelationshipToJSON,
    AbsenceCaseLeaveEligibilityRelationshipToJSONTyped: AbsenceCaseLeaveEligibilityRelationshipToJSONTyped,
    AbsenceCaseLeaveTypeReducedAttributesFromJSON: AbsenceCaseLeaveTypeReducedAttributesFromJSON,
    AbsenceCaseLeaveTypeReducedAttributesFromJSONTyped: AbsenceCaseLeaveTypeReducedAttributesFromJSONTyped,
    AbsenceCaseLeaveTypeReducedAttributesToJSON: AbsenceCaseLeaveTypeReducedAttributesToJSON,
    AbsenceCaseLeaveTypeReducedAttributesToJSONTyped: AbsenceCaseLeaveTypeReducedAttributesToJSONTyped,
    AbsenceCaseLeaveTypeReducedFromJSON: AbsenceCaseLeaveTypeReducedFromJSON,
    AbsenceCaseLeaveTypeReducedFromJSONTyped: AbsenceCaseLeaveTypeReducedFromJSONTyped,
    AbsenceCaseLeaveTypeReducedToJSON: AbsenceCaseLeaveTypeReducedToJSON,
    AbsenceCaseLeaveTypeReducedToJSONTyped: AbsenceCaseLeaveTypeReducedToJSONTyped,
    AbsenceCaseLeaveTypeRelationshipDataInnerFromJSON: AbsenceCaseLeaveTypeRelationshipDataInnerFromJSON,
    AbsenceCaseLeaveTypeRelationshipDataInnerFromJSONTyped: AbsenceCaseLeaveTypeRelationshipDataInnerFromJSONTyped,
    AbsenceCaseLeaveTypeRelationshipDataInnerToJSON: AbsenceCaseLeaveTypeRelationshipDataInnerToJSON,
    AbsenceCaseLeaveTypeRelationshipDataInnerToJSONTyped: AbsenceCaseLeaveTypeRelationshipDataInnerToJSONTyped,
    AbsenceCaseLeaveTypeRelationshipFromJSON: AbsenceCaseLeaveTypeRelationshipFromJSON,
    AbsenceCaseLeaveTypeRelationshipFromJSONTyped: AbsenceCaseLeaveTypeRelationshipFromJSONTyped,
    AbsenceCaseLeaveTypeRelationshipToJSON: AbsenceCaseLeaveTypeRelationshipToJSON,
    AbsenceCaseLeaveTypeRelationshipToJSONTyped: AbsenceCaseLeaveTypeRelationshipToJSONTyped,
    AbsenceCaseProjectedUsagesReducedAttributesFromJSON: AbsenceCaseProjectedUsagesReducedAttributesFromJSON,
    AbsenceCaseProjectedUsagesReducedAttributesFromJSONTyped: AbsenceCaseProjectedUsagesReducedAttributesFromJSONTyped,
    AbsenceCaseProjectedUsagesReducedAttributesToJSON: AbsenceCaseProjectedUsagesReducedAttributesToJSON,
    AbsenceCaseProjectedUsagesReducedAttributesToJSONTyped: AbsenceCaseProjectedUsagesReducedAttributesToJSONTyped,
    AbsenceCaseProjectedUsagesReducedFromJSON: AbsenceCaseProjectedUsagesReducedFromJSON,
    AbsenceCaseProjectedUsagesReducedFromJSONTyped: AbsenceCaseProjectedUsagesReducedFromJSONTyped,
    AbsenceCaseProjectedUsagesReducedToJSON: AbsenceCaseProjectedUsagesReducedToJSON,
    AbsenceCaseProjectedUsagesReducedToJSONTyped: AbsenceCaseProjectedUsagesReducedToJSONTyped,
    AbsenceCaseProjectedUsagesRelationshipDataInnerFromJSON: AbsenceCaseProjectedUsagesRelationshipDataInnerFromJSON,
    AbsenceCaseProjectedUsagesRelationshipDataInnerFromJSONTyped: AbsenceCaseProjectedUsagesRelationshipDataInnerFromJSONTyped,
    AbsenceCaseProjectedUsagesRelationshipDataInnerToJSON: AbsenceCaseProjectedUsagesRelationshipDataInnerToJSON,
    AbsenceCaseProjectedUsagesRelationshipDataInnerToJSONTyped: AbsenceCaseProjectedUsagesRelationshipDataInnerToJSONTyped,
    AbsenceCaseProjectedUsagesRelationshipFromJSON: AbsenceCaseProjectedUsagesRelationshipFromJSON,
    AbsenceCaseProjectedUsagesRelationshipFromJSONTyped: AbsenceCaseProjectedUsagesRelationshipFromJSONTyped,
    AbsenceCaseProjectedUsagesRelationshipToJSON: AbsenceCaseProjectedUsagesRelationshipToJSON,
    AbsenceCaseProjectedUsagesRelationshipToJSONTyped: AbsenceCaseProjectedUsagesRelationshipToJSONTyped,
    AbsenceCaseQuestionAttributesFromJSON: AbsenceCaseQuestionAttributesFromJSON,
    AbsenceCaseQuestionAttributesFromJSONTyped: AbsenceCaseQuestionAttributesFromJSONTyped,
    AbsenceCaseQuestionAttributesToJSON: AbsenceCaseQuestionAttributesToJSON,
    AbsenceCaseQuestionAttributesToJSONTyped: AbsenceCaseQuestionAttributesToJSONTyped,
    AbsenceCaseQuestionFromJSON: AbsenceCaseQuestionFromJSON,
    AbsenceCaseQuestionFromJSONTyped: AbsenceCaseQuestionFromJSONTyped,
    AbsenceCaseQuestionMetaFromJSON: AbsenceCaseQuestionMetaFromJSON,
    AbsenceCaseQuestionMetaFromJSONTyped: AbsenceCaseQuestionMetaFromJSONTyped,
    AbsenceCaseQuestionMetaToJSON: AbsenceCaseQuestionMetaToJSON,
    AbsenceCaseQuestionMetaToJSONTyped: AbsenceCaseQuestionMetaToJSONTyped,
    AbsenceCaseQuestionRelationshipsFromJSON: AbsenceCaseQuestionRelationshipsFromJSON,
    AbsenceCaseQuestionRelationshipsFromJSONTyped: AbsenceCaseQuestionRelationshipsFromJSONTyped,
    AbsenceCaseQuestionRelationshipsToJSON: AbsenceCaseQuestionRelationshipsToJSON,
    AbsenceCaseQuestionRelationshipsToJSONTyped: AbsenceCaseQuestionRelationshipsToJSONTyped,
    AbsenceCaseQuestionToJSON: AbsenceCaseQuestionToJSON,
    AbsenceCaseQuestionToJSONTyped: AbsenceCaseQuestionToJSONTyped,
    AbsenceCaseReasonReducedAttributesFromJSON: AbsenceCaseReasonReducedAttributesFromJSON,
    AbsenceCaseReasonReducedAttributesFromJSONTyped: AbsenceCaseReasonReducedAttributesFromJSONTyped,
    AbsenceCaseReasonReducedAttributesToJSON: AbsenceCaseReasonReducedAttributesToJSON,
    AbsenceCaseReasonReducedAttributesToJSONTyped: AbsenceCaseReasonReducedAttributesToJSONTyped,
    AbsenceCaseReasonReducedFromJSON: AbsenceCaseReasonReducedFromJSON,
    AbsenceCaseReasonReducedFromJSONTyped: AbsenceCaseReasonReducedFromJSONTyped,
    AbsenceCaseReasonReducedToJSON: AbsenceCaseReasonReducedToJSON,
    AbsenceCaseReasonReducedToJSONTyped: AbsenceCaseReasonReducedToJSONTyped,
    AbsenceCaseReasonRelationshipDataFromJSON: AbsenceCaseReasonRelationshipDataFromJSON,
    AbsenceCaseReasonRelationshipDataFromJSONTyped: AbsenceCaseReasonRelationshipDataFromJSONTyped,
    AbsenceCaseReasonRelationshipDataToJSON: AbsenceCaseReasonRelationshipDataToJSON,
    AbsenceCaseReasonRelationshipDataToJSONTyped: AbsenceCaseReasonRelationshipDataToJSONTyped,
    AbsenceCaseReasonRelationshipFromJSON: AbsenceCaseReasonRelationshipFromJSON,
    AbsenceCaseReasonRelationshipFromJSONTyped: AbsenceCaseReasonRelationshipFromJSONTyped,
    AbsenceCaseReasonRelationshipToJSON: AbsenceCaseReasonRelationshipToJSON,
    AbsenceCaseReasonRelationshipToJSONTyped: AbsenceCaseReasonRelationshipToJSONTyped,
    AbsenceCaseReducedFromJSON: AbsenceCaseReducedFromJSON,
    AbsenceCaseReducedFromJSONTyped: AbsenceCaseReducedFromJSONTyped,
    AbsenceCaseReducedToJSON: AbsenceCaseReducedToJSON,
    AbsenceCaseReducedToJSONTyped: AbsenceCaseReducedToJSONTyped,
    AbsenceCaseRelationshipDataFromJSON: AbsenceCaseRelationshipDataFromJSON,
    AbsenceCaseRelationshipDataFromJSONTyped: AbsenceCaseRelationshipDataFromJSONTyped,
    AbsenceCaseRelationshipDataToJSON: AbsenceCaseRelationshipDataToJSON,
    AbsenceCaseRelationshipDataToJSONTyped: AbsenceCaseRelationshipDataToJSONTyped,
    AbsenceCaseRelationshipFromJSON: AbsenceCaseRelationshipFromJSON,
    AbsenceCaseRelationshipFromJSONTyped: AbsenceCaseRelationshipFromJSONTyped,
    AbsenceCaseRelationshipToJSON: AbsenceCaseRelationshipToJSON,
    AbsenceCaseRelationshipToJSONTyped: AbsenceCaseRelationshipToJSONTyped,
    AbsenceCaseRelationshipsFromJSON: AbsenceCaseRelationshipsFromJSON,
    AbsenceCaseRelationshipsFromJSONTyped: AbsenceCaseRelationshipsFromJSONTyped,
    AbsenceCaseRelationshipsToJSON: AbsenceCaseRelationshipsToJSON,
    AbsenceCaseRelationshipsToJSONTyped: AbsenceCaseRelationshipsToJSONTyped,
    AbsenceCaseToJSON: AbsenceCaseToJSON,
    AbsenceCaseToJSONTyped: AbsenceCaseToJSONTyped,
    AbsenceCaseUpdateRequestAtomicOperationsInnerFromJSON: AbsenceCaseUpdateRequestAtomicOperationsInnerFromJSON,
    AbsenceCaseUpdateRequestAtomicOperationsInnerFromJSONTyped: AbsenceCaseUpdateRequestAtomicOperationsInnerFromJSONTyped,
    AbsenceCaseUpdateRequestAtomicOperationsInnerOpEnum: AbsenceCaseUpdateRequestAtomicOperationsInnerOpEnum,
    AbsenceCaseUpdateRequestAtomicOperationsInnerToJSON: AbsenceCaseUpdateRequestAtomicOperationsInnerToJSON,
    AbsenceCaseUpdateRequestAtomicOperationsInnerToJSONTyped: AbsenceCaseUpdateRequestAtomicOperationsInnerToJSONTyped,
    AbsenceCaseUpdateRequestFromJSON: AbsenceCaseUpdateRequestFromJSON,
    AbsenceCaseUpdateRequestFromJSONTyped: AbsenceCaseUpdateRequestFromJSONTyped,
    AbsenceCaseUpdateRequestToJSON: AbsenceCaseUpdateRequestToJSON,
    AbsenceCaseUpdateRequestToJSONTyped: AbsenceCaseUpdateRequestToJSONTyped,
    AbsenceCaseUpdateResponseAtomicResultsInnerDataFromJSON: AbsenceCaseUpdateResponseAtomicResultsInnerDataFromJSON,
    AbsenceCaseUpdateResponseAtomicResultsInnerDataFromJSONTyped: AbsenceCaseUpdateResponseAtomicResultsInnerDataFromJSONTyped,
    AbsenceCaseUpdateResponseAtomicResultsInnerDataToJSON: AbsenceCaseUpdateResponseAtomicResultsInnerDataToJSON,
    AbsenceCaseUpdateResponseAtomicResultsInnerDataToJSONTyped: AbsenceCaseUpdateResponseAtomicResultsInnerDataToJSONTyped,
    AbsenceCaseUpdateResponseAtomicResultsInnerFromJSON: AbsenceCaseUpdateResponseAtomicResultsInnerFromJSON,
    AbsenceCaseUpdateResponseAtomicResultsInnerFromJSONTyped: AbsenceCaseUpdateResponseAtomicResultsInnerFromJSONTyped,
    AbsenceCaseUpdateResponseAtomicResultsInnerToJSON: AbsenceCaseUpdateResponseAtomicResultsInnerToJSON,
    AbsenceCaseUpdateResponseAtomicResultsInnerToJSONTyped: AbsenceCaseUpdateResponseAtomicResultsInnerToJSONTyped,
    AbsenceCaseUpdateResponseFromJSON: AbsenceCaseUpdateResponseFromJSON,
    AbsenceCaseUpdateResponseFromJSONTyped: AbsenceCaseUpdateResponseFromJSONTyped,
    AbsenceCaseUpdateResponseToJSON: AbsenceCaseUpdateResponseToJSON,
    AbsenceCaseUpdateResponseToJSONTyped: AbsenceCaseUpdateResponseToJSONTyped,
    AbsenceCaseUpdateResultAttributesContactMethodEnum: AbsenceCaseUpdateResultAttributesContactMethodEnum,
    AbsenceCaseUpdateResultAttributesFromJSON: AbsenceCaseUpdateResultAttributesFromJSON,
    AbsenceCaseUpdateResultAttributesFromJSONTyped: AbsenceCaseUpdateResultAttributesFromJSONTyped,
    AbsenceCaseUpdateResultAttributesToJSON: AbsenceCaseUpdateResultAttributesToJSON,
    AbsenceCaseUpdateResultAttributesToJSONTyped: AbsenceCaseUpdateResultAttributesToJSONTyped,
    AbsenceCaseUpdateResultAttributesUsePaidTimeEnum: AbsenceCaseUpdateResultAttributesUsePaidTimeEnum,
    AbsenceCaseUpdateResultFromJSON: AbsenceCaseUpdateResultFromJSON,
    AbsenceCaseUpdateResultFromJSONTyped: AbsenceCaseUpdateResultFromJSONTyped,
    AbsenceCaseUpdateResultRelationshipsFromJSON: AbsenceCaseUpdateResultRelationshipsFromJSON,
    AbsenceCaseUpdateResultRelationshipsFromJSONTyped: AbsenceCaseUpdateResultRelationshipsFromJSONTyped,
    AbsenceCaseUpdateResultRelationshipsToJSON: AbsenceCaseUpdateResultRelationshipsToJSON,
    AbsenceCaseUpdateResultRelationshipsToJSONTyped: AbsenceCaseUpdateResultRelationshipsToJSONTyped,
    AbsenceCaseUpdateResultToJSON: AbsenceCaseUpdateResultToJSON,
    AbsenceCaseUpdateResultToJSONTyped: AbsenceCaseUpdateResultToJSONTyped,
    AbsenceCaseUploadDocumentsRequestDataAttributesFromJSON: AbsenceCaseUploadDocumentsRequestDataAttributesFromJSON,
    AbsenceCaseUploadDocumentsRequestDataAttributesFromJSONTyped: AbsenceCaseUploadDocumentsRequestDataAttributesFromJSONTyped,
    AbsenceCaseUploadDocumentsRequestDataAttributesToJSON: AbsenceCaseUploadDocumentsRequestDataAttributesToJSON,
    AbsenceCaseUploadDocumentsRequestDataAttributesToJSONTyped: AbsenceCaseUploadDocumentsRequestDataAttributesToJSONTyped,
    AbsenceCaseUploadDocumentsRequestDataFromJSON: AbsenceCaseUploadDocumentsRequestDataFromJSON,
    AbsenceCaseUploadDocumentsRequestDataFromJSONTyped: AbsenceCaseUploadDocumentsRequestDataFromJSONTyped,
    AbsenceCaseUploadDocumentsRequestDataToJSON: AbsenceCaseUploadDocumentsRequestDataToJSON,
    AbsenceCaseUploadDocumentsRequestDataToJSONTyped: AbsenceCaseUploadDocumentsRequestDataToJSONTyped,
    AbsenceCaseUploadDocumentsRequestFromJSON: AbsenceCaseUploadDocumentsRequestFromJSON,
    AbsenceCaseUploadDocumentsRequestFromJSONTyped: AbsenceCaseUploadDocumentsRequestFromJSONTyped,
    AbsenceCaseUploadDocumentsRequestToJSON: AbsenceCaseUploadDocumentsRequestToJSON,
    AbsenceCaseUploadDocumentsRequestToJSONTyped: AbsenceCaseUploadDocumentsRequestToJSONTyped,
    AbsenceCaseUploadDocumentsResponseAttributesFromJSON: AbsenceCaseUploadDocumentsResponseAttributesFromJSON,
    AbsenceCaseUploadDocumentsResponseAttributesFromJSONTyped: AbsenceCaseUploadDocumentsResponseAttributesFromJSONTyped,
    AbsenceCaseUploadDocumentsResponseAttributesToJSON: AbsenceCaseUploadDocumentsResponseAttributesToJSON,
    AbsenceCaseUploadDocumentsResponseAttributesToJSONTyped: AbsenceCaseUploadDocumentsResponseAttributesToJSONTyped,
    AbsenceCaseUploadDocumentsResponseFromJSON: AbsenceCaseUploadDocumentsResponseFromJSON,
    AbsenceCaseUploadDocumentsResponseFromJSONTyped: AbsenceCaseUploadDocumentsResponseFromJSONTyped,
    AbsenceCaseUploadDocumentsResponseRelationshipsFromJSON: AbsenceCaseUploadDocumentsResponseRelationshipsFromJSON,
    AbsenceCaseUploadDocumentsResponseRelationshipsFromJSONTyped: AbsenceCaseUploadDocumentsResponseRelationshipsFromJSONTyped,
    AbsenceCaseUploadDocumentsResponseRelationshipsToJSON: AbsenceCaseUploadDocumentsResponseRelationshipsToJSON,
    AbsenceCaseUploadDocumentsResponseRelationshipsToJSONTyped: AbsenceCaseUploadDocumentsResponseRelationshipsToJSONTyped,
    AbsenceCaseUploadDocumentsResponseToJSON: AbsenceCaseUploadDocumentsResponseToJSON,
    AbsenceCaseUploadDocumentsResponseToJSONTyped: AbsenceCaseUploadDocumentsResponseToJSONTyped,
    AbsenceCaseWorkflowEventAttributesFromJSON: AbsenceCaseWorkflowEventAttributesFromJSON,
    AbsenceCaseWorkflowEventAttributesFromJSONTyped: AbsenceCaseWorkflowEventAttributesFromJSONTyped,
    AbsenceCaseWorkflowEventAttributesToJSON: AbsenceCaseWorkflowEventAttributesToJSON,
    AbsenceCaseWorkflowEventAttributesToJSONTyped: AbsenceCaseWorkflowEventAttributesToJSONTyped,
    AbsenceCaseWorkflowEventEmployeeRelationshipDataFromJSON: AbsenceCaseWorkflowEventEmployeeRelationshipDataFromJSON,
    AbsenceCaseWorkflowEventEmployeeRelationshipDataFromJSONTyped: AbsenceCaseWorkflowEventEmployeeRelationshipDataFromJSONTyped,
    AbsenceCaseWorkflowEventEmployeeRelationshipDataToJSON: AbsenceCaseWorkflowEventEmployeeRelationshipDataToJSON,
    AbsenceCaseWorkflowEventEmployeeRelationshipDataToJSONTyped: AbsenceCaseWorkflowEventEmployeeRelationshipDataToJSONTyped,
    AbsenceCaseWorkflowEventEmployeeRelationshipFromJSON: AbsenceCaseWorkflowEventEmployeeRelationshipFromJSON,
    AbsenceCaseWorkflowEventEmployeeRelationshipFromJSONTyped: AbsenceCaseWorkflowEventEmployeeRelationshipFromJSONTyped,
    AbsenceCaseWorkflowEventEmployeeRelationshipToJSON: AbsenceCaseWorkflowEventEmployeeRelationshipToJSON,
    AbsenceCaseWorkflowEventEmployeeRelationshipToJSONTyped: AbsenceCaseWorkflowEventEmployeeRelationshipToJSONTyped,
    AbsenceCaseWorkflowEventFromJSON: AbsenceCaseWorkflowEventFromJSON,
    AbsenceCaseWorkflowEventFromJSONTyped: AbsenceCaseWorkflowEventFromJSONTyped,
    AbsenceCaseWorkflowEventRelationshipsFromJSON: AbsenceCaseWorkflowEventRelationshipsFromJSON,
    AbsenceCaseWorkflowEventRelationshipsFromJSONTyped: AbsenceCaseWorkflowEventRelationshipsFromJSONTyped,
    AbsenceCaseWorkflowEventRelationshipsToJSON: AbsenceCaseWorkflowEventRelationshipsToJSON,
    AbsenceCaseWorkflowEventRelationshipsToJSONTyped: AbsenceCaseWorkflowEventRelationshipsToJSONTyped,
    AbsenceCaseWorkflowEventToJSON: AbsenceCaseWorkflowEventToJSON,
    AbsenceCaseWorkflowEventToJSONTyped: AbsenceCaseWorkflowEventToJSONTyped,
    AbsenceCaseWorkflowEventTypeReducedAttributesFromJSON: AbsenceCaseWorkflowEventTypeReducedAttributesFromJSON,
    AbsenceCaseWorkflowEventTypeReducedAttributesFromJSONTyped: AbsenceCaseWorkflowEventTypeReducedAttributesFromJSONTyped,
    AbsenceCaseWorkflowEventTypeReducedAttributesToJSON: AbsenceCaseWorkflowEventTypeReducedAttributesToJSON,
    AbsenceCaseWorkflowEventTypeReducedAttributesToJSONTyped: AbsenceCaseWorkflowEventTypeReducedAttributesToJSONTyped,
    AbsenceCaseWorkflowEventTypeReducedFromJSON: AbsenceCaseWorkflowEventTypeReducedFromJSON,
    AbsenceCaseWorkflowEventTypeReducedFromJSONTyped: AbsenceCaseWorkflowEventTypeReducedFromJSONTyped,
    AbsenceCaseWorkflowEventTypeReducedToJSON: AbsenceCaseWorkflowEventTypeReducedToJSON,
    AbsenceCaseWorkflowEventTypeReducedToJSONTyped: AbsenceCaseWorkflowEventTypeReducedToJSONTyped,
    AbsenceCaseWorkflowEventTypeRelationshipDataFromJSON: AbsenceCaseWorkflowEventTypeRelationshipDataFromJSON,
    AbsenceCaseWorkflowEventTypeRelationshipDataFromJSONTyped: AbsenceCaseWorkflowEventTypeRelationshipDataFromJSONTyped,
    AbsenceCaseWorkflowEventTypeRelationshipDataToJSON: AbsenceCaseWorkflowEventTypeRelationshipDataToJSON,
    AbsenceCaseWorkflowEventTypeRelationshipDataToJSONTyped: AbsenceCaseWorkflowEventTypeRelationshipDataToJSONTyped,
    AbsenceCaseWorkflowEventTypeRelationshipFromJSON: AbsenceCaseWorkflowEventTypeRelationshipFromJSON,
    AbsenceCaseWorkflowEventTypeRelationshipFromJSONTyped: AbsenceCaseWorkflowEventTypeRelationshipFromJSONTyped,
    AbsenceCaseWorkflowEventTypeRelationshipToJSON: AbsenceCaseWorkflowEventTypeRelationshipToJSON,
    AbsenceCaseWorkflowEventTypeRelationshipToJSONTyped: AbsenceCaseWorkflowEventTypeRelationshipToJSONTyped,
    AbsenceCreateCaseRequestDataAttributesFromJSON: AbsenceCreateCaseRequestDataAttributesFromJSON,
    AbsenceCreateCaseRequestDataAttributesFromJSONTyped: AbsenceCreateCaseRequestDataAttributesFromJSONTyped,
    AbsenceCreateCaseRequestDataAttributesQuestionResponsesInnerFromJSON: AbsenceCreateCaseRequestDataAttributesQuestionResponsesInnerFromJSON,
    AbsenceCreateCaseRequestDataAttributesQuestionResponsesInnerFromJSONTyped: AbsenceCreateCaseRequestDataAttributesQuestionResponsesInnerFromJSONTyped,
    AbsenceCreateCaseRequestDataAttributesQuestionResponsesInnerToJSON: AbsenceCreateCaseRequestDataAttributesQuestionResponsesInnerToJSON,
    AbsenceCreateCaseRequestDataAttributesQuestionResponsesInnerToJSONTyped: AbsenceCreateCaseRequestDataAttributesQuestionResponsesInnerToJSONTyped,
    AbsenceCreateCaseRequestDataAttributesToJSON: AbsenceCreateCaseRequestDataAttributesToJSON,
    AbsenceCreateCaseRequestDataAttributesToJSONTyped: AbsenceCreateCaseRequestDataAttributesToJSONTyped,
    AbsenceCreateCaseRequestDataFromJSON: AbsenceCreateCaseRequestDataFromJSON,
    AbsenceCreateCaseRequestDataFromJSONTyped: AbsenceCreateCaseRequestDataFromJSONTyped,
    AbsenceCreateCaseRequestDataRelationshipsFromJSON: AbsenceCreateCaseRequestDataRelationshipsFromJSON,
    AbsenceCreateCaseRequestDataRelationshipsFromJSONTyped: AbsenceCreateCaseRequestDataRelationshipsFromJSONTyped,
    AbsenceCreateCaseRequestDataRelationshipsToJSON: AbsenceCreateCaseRequestDataRelationshipsToJSON,
    AbsenceCreateCaseRequestDataRelationshipsToJSONTyped: AbsenceCreateCaseRequestDataRelationshipsToJSONTyped,
    AbsenceCreateCaseRequestDataToJSON: AbsenceCreateCaseRequestDataToJSON,
    AbsenceCreateCaseRequestDataToJSONTyped: AbsenceCreateCaseRequestDataToJSONTyped,
    AbsenceCreateCaseRequestFromJSON: AbsenceCreateCaseRequestFromJSON,
    AbsenceCreateCaseRequestFromJSONTyped: AbsenceCreateCaseRequestFromJSONTyped,
    AbsenceCreateCaseRequestToJSON: AbsenceCreateCaseRequestToJSON,
    AbsenceCreateCaseRequestToJSONTyped: AbsenceCreateCaseRequestToJSONTyped,
    AbsenceCreateCaseResponseDataAttributesFromJSON: AbsenceCreateCaseResponseDataAttributesFromJSON,
    AbsenceCreateCaseResponseDataAttributesFromJSONTyped: AbsenceCreateCaseResponseDataAttributesFromJSONTyped,
    AbsenceCreateCaseResponseDataAttributesToJSON: AbsenceCreateCaseResponseDataAttributesToJSON,
    AbsenceCreateCaseResponseDataAttributesToJSONTyped: AbsenceCreateCaseResponseDataAttributesToJSONTyped,
    AbsenceCreateCaseResponseDataFromJSON: AbsenceCreateCaseResponseDataFromJSON,
    AbsenceCreateCaseResponseDataFromJSONTyped: AbsenceCreateCaseResponseDataFromJSONTyped,
    AbsenceCreateCaseResponseDataToJSON: AbsenceCreateCaseResponseDataToJSON,
    AbsenceCreateCaseResponseDataToJSONTyped: AbsenceCreateCaseResponseDataToJSONTyped,
    AbsenceCreateCaseResponseFromJSON: AbsenceCreateCaseResponseFromJSON,
    AbsenceCreateCaseResponseFromJSONTyped: AbsenceCreateCaseResponseFromJSONTyped,
    AbsenceCreateCaseResponseToJSON: AbsenceCreateCaseResponseToJSON,
    AbsenceCreateCaseResponseToJSONTyped: AbsenceCreateCaseResponseToJSONTyped,
    AbsenceLimitMetaFromJSON: AbsenceLimitMetaFromJSON,
    AbsenceLimitMetaFromJSONTyped: AbsenceLimitMetaFromJSONTyped,
    AbsenceLimitMetaOverlappingCustomRulesInnerFromJSON: AbsenceLimitMetaOverlappingCustomRulesInnerFromJSON,
    AbsenceLimitMetaOverlappingCustomRulesInnerFromJSONTyped: AbsenceLimitMetaOverlappingCustomRulesInnerFromJSONTyped,
    AbsenceLimitMetaOverlappingCustomRulesInnerToJSON: AbsenceLimitMetaOverlappingCustomRulesInnerToJSON,
    AbsenceLimitMetaOverlappingCustomRulesInnerToJSONTyped: AbsenceLimitMetaOverlappingCustomRulesInnerToJSONTyped,
    AbsenceLimitMetaToJSON: AbsenceLimitMetaToJSON,
    AbsenceLimitMetaToJSONTyped: AbsenceLimitMetaToJSONTyped,
    AbsenceLimitsCustomRulesInnerFromJSON: AbsenceLimitsCustomRulesInnerFromJSON,
    AbsenceLimitsCustomRulesInnerFromJSONTyped: AbsenceLimitsCustomRulesInnerFromJSONTyped,
    AbsenceLimitsCustomRulesInnerToJSON: AbsenceLimitsCustomRulesInnerToJSON,
    AbsenceLimitsCustomRulesInnerToJSONTyped: AbsenceLimitsCustomRulesInnerToJSONTyped,
    AbsenceLimitsDefaultRulesFromJSON: AbsenceLimitsDefaultRulesFromJSON,
    AbsenceLimitsDefaultRulesFromJSONTyped: AbsenceLimitsDefaultRulesFromJSONTyped,
    AbsenceLimitsDefaultRulesToJSON: AbsenceLimitsDefaultRulesToJSON,
    AbsenceLimitsDefaultRulesToJSONTyped: AbsenceLimitsDefaultRulesToJSONTyped,
    AbsenceLimitsFromJSON: AbsenceLimitsFromJSON,
    AbsenceLimitsFromJSONTyped: AbsenceLimitsFromJSONTyped,
    AbsenceLimitsToJSON: AbsenceLimitsToJSON,
    AbsenceLimitsToJSONTyped: AbsenceLimitsToJSONTyped,
    AbsenceReasonAttributesFromJSON: AbsenceReasonAttributesFromJSON,
    AbsenceReasonAttributesFromJSONTyped: AbsenceReasonAttributesFromJSONTyped,
    AbsenceReasonAttributesToJSON: AbsenceReasonAttributesToJSON,
    AbsenceReasonAttributesToJSONTyped: AbsenceReasonAttributesToJSONTyped,
    AbsenceReasonFromJSON: AbsenceReasonFromJSON,
    AbsenceReasonFromJSONTyped: AbsenceReasonFromJSONTyped,
    AbsenceReasonToJSON: AbsenceReasonToJSON,
    AbsenceReasonToJSONTyped: AbsenceReasonToJSONTyped,
    AbsenceTypeAttributesFromJSON: AbsenceTypeAttributesFromJSON,
    AbsenceTypeAttributesFromJSONTyped: AbsenceTypeAttributesFromJSONTyped,
    AbsenceTypeAttributesToJSON: AbsenceTypeAttributesToJSON,
    AbsenceTypeAttributesToJSONTyped: AbsenceTypeAttributesToJSONTyped,
    AbsenceTypeFromJSON: AbsenceTypeFromJSON,
    AbsenceTypeFromJSONTyped: AbsenceTypeFromJSONTyped,
    AbsenceTypeRelationshipDataFromJSON: AbsenceTypeRelationshipDataFromJSON,
    AbsenceTypeRelationshipDataFromJSONTyped: AbsenceTypeRelationshipDataFromJSONTyped,
    AbsenceTypeRelationshipDataToJSON: AbsenceTypeRelationshipDataToJSON,
    AbsenceTypeRelationshipDataToJSONTyped: AbsenceTypeRelationshipDataToJSONTyped,
    AbsenceTypeRelationshipFromJSON: AbsenceTypeRelationshipFromJSON,
    AbsenceTypeRelationshipFromJSONTyped: AbsenceTypeRelationshipFromJSONTyped,
    AbsenceTypeRelationshipToJSON: AbsenceTypeRelationshipToJSON,
    AbsenceTypeRelationshipToJSONTyped: AbsenceTypeRelationshipToJSONTyped,
    AbsenceTypeRelationshipsAllowedPayCodesDataInnerFromJSON: AbsenceTypeRelationshipsAllowedPayCodesDataInnerFromJSON,
    AbsenceTypeRelationshipsAllowedPayCodesDataInnerFromJSONTyped: AbsenceTypeRelationshipsAllowedPayCodesDataInnerFromJSONTyped,
    AbsenceTypeRelationshipsAllowedPayCodesDataInnerToJSON: AbsenceTypeRelationshipsAllowedPayCodesDataInnerToJSON,
    AbsenceTypeRelationshipsAllowedPayCodesDataInnerToJSONTyped: AbsenceTypeRelationshipsAllowedPayCodesDataInnerToJSONTyped,
    AbsenceTypeRelationshipsAllowedPayCodesFromJSON: AbsenceTypeRelationshipsAllowedPayCodesFromJSON,
    AbsenceTypeRelationshipsAllowedPayCodesFromJSONTyped: AbsenceTypeRelationshipsAllowedPayCodesFromJSONTyped,
    AbsenceTypeRelationshipsAllowedPayCodesToJSON: AbsenceTypeRelationshipsAllowedPayCodesToJSON,
    AbsenceTypeRelationshipsAllowedPayCodesToJSONTyped: AbsenceTypeRelationshipsAllowedPayCodesToJSONTyped,
    AbsenceTypeRelationshipsDefaultPayCodeDataFromJSON: AbsenceTypeRelationshipsDefaultPayCodeDataFromJSON,
    AbsenceTypeRelationshipsDefaultPayCodeDataFromJSONTyped: AbsenceTypeRelationshipsDefaultPayCodeDataFromJSONTyped,
    AbsenceTypeRelationshipsDefaultPayCodeDataToJSON: AbsenceTypeRelationshipsDefaultPayCodeDataToJSON,
    AbsenceTypeRelationshipsDefaultPayCodeDataToJSONTyped: AbsenceTypeRelationshipsDefaultPayCodeDataToJSONTyped,
    AbsenceTypeRelationshipsDefaultPayCodeFromJSON: AbsenceTypeRelationshipsDefaultPayCodeFromJSON,
    AbsenceTypeRelationshipsDefaultPayCodeFromJSONTyped: AbsenceTypeRelationshipsDefaultPayCodeFromJSONTyped,
    AbsenceTypeRelationshipsDefaultPayCodeToJSON: AbsenceTypeRelationshipsDefaultPayCodeToJSON,
    AbsenceTypeRelationshipsDefaultPayCodeToJSONTyped: AbsenceTypeRelationshipsDefaultPayCodeToJSONTyped,
    AbsenceTypeRelationshipsFromJSON: AbsenceTypeRelationshipsFromJSON,
    AbsenceTypeRelationshipsFromJSONTyped: AbsenceTypeRelationshipsFromJSONTyped,
    AbsenceTypeRelationshipsToJSON: AbsenceTypeRelationshipsToJSON,
    AbsenceTypeRelationshipsToJSONTyped: AbsenceTypeRelationshipsToJSONTyped,
    AbsenceTypeToJSON: AbsenceTypeToJSON,
    AbsenceTypeToJSONTyped: AbsenceTypeToJSONTyped,
    AcceptedSchemaDataFromJSON: AcceptedSchemaDataFromJSON,
    AcceptedSchemaDataFromJSONTyped: AcceptedSchemaDataFromJSONTyped,
    AcceptedSchemaDataToJSON: AcceptedSchemaDataToJSON,
    AcceptedSchemaDataToJSONTyped: AcceptedSchemaDataToJSONTyped,
    AcceptedSchemaFromJSON: AcceptedSchemaFromJSON,
    AcceptedSchemaFromJSONTyped: AcceptedSchemaFromJSONTyped,
    AcceptedSchemaToJSON: AcceptedSchemaToJSON,
    AcceptedSchemaToJSONTyped: AcceptedSchemaToJSONTyped,
    ActivitiesLookupRelationshipFromJSON: ActivitiesLookupRelationshipFromJSON,
    ActivitiesLookupRelationshipFromJSONTyped: ActivitiesLookupRelationshipFromJSONTyped,
    ActivitiesLookupRelationshipSchedulingUnitFromJSON: ActivitiesLookupRelationshipSchedulingUnitFromJSON,
    ActivitiesLookupRelationshipSchedulingUnitFromJSONTyped: ActivitiesLookupRelationshipSchedulingUnitFromJSONTyped,
    ActivitiesLookupRelationshipSchedulingUnitMetaFromJSON: ActivitiesLookupRelationshipSchedulingUnitMetaFromJSON,
    ActivitiesLookupRelationshipSchedulingUnitMetaFromJSONTyped: ActivitiesLookupRelationshipSchedulingUnitMetaFromJSONTyped,
    ActivitiesLookupRelationshipSchedulingUnitMetaLookupFromJSON: ActivitiesLookupRelationshipSchedulingUnitMetaLookupFromJSON,
    ActivitiesLookupRelationshipSchedulingUnitMetaLookupFromJSONTyped: ActivitiesLookupRelationshipSchedulingUnitMetaLookupFromJSONTyped,
    ActivitiesLookupRelationshipSchedulingUnitMetaLookupToJSON: ActivitiesLookupRelationshipSchedulingUnitMetaLookupToJSON,
    ActivitiesLookupRelationshipSchedulingUnitMetaLookupToJSONTyped: ActivitiesLookupRelationshipSchedulingUnitMetaLookupToJSONTyped,
    ActivitiesLookupRelationshipSchedulingUnitMetaToJSON: ActivitiesLookupRelationshipSchedulingUnitMetaToJSON,
    ActivitiesLookupRelationshipSchedulingUnitMetaToJSONTyped: ActivitiesLookupRelationshipSchedulingUnitMetaToJSONTyped,
    ActivitiesLookupRelationshipSchedulingUnitToJSON: ActivitiesLookupRelationshipSchedulingUnitToJSON,
    ActivitiesLookupRelationshipSchedulingUnitToJSONTyped: ActivitiesLookupRelationshipSchedulingUnitToJSONTyped,
    ActivitiesLookupRelationshipSchedulingUnitTypeEnum: ActivitiesLookupRelationshipSchedulingUnitTypeEnum,
    ActivitiesLookupRelationshipTaskFromJSON: ActivitiesLookupRelationshipTaskFromJSON,
    ActivitiesLookupRelationshipTaskFromJSONTyped: ActivitiesLookupRelationshipTaskFromJSONTyped,
    ActivitiesLookupRelationshipTaskMetaFromJSON: ActivitiesLookupRelationshipTaskMetaFromJSON,
    ActivitiesLookupRelationshipTaskMetaFromJSONTyped: ActivitiesLookupRelationshipTaskMetaFromJSONTyped,
    ActivitiesLookupRelationshipTaskMetaLookupFromJSON: ActivitiesLookupRelationshipTaskMetaLookupFromJSON,
    ActivitiesLookupRelationshipTaskMetaLookupFromJSONTyped: ActivitiesLookupRelationshipTaskMetaLookupFromJSONTyped,
    ActivitiesLookupRelationshipTaskMetaLookupToJSON: ActivitiesLookupRelationshipTaskMetaLookupToJSON,
    ActivitiesLookupRelationshipTaskMetaLookupToJSONTyped: ActivitiesLookupRelationshipTaskMetaLookupToJSONTyped,
    ActivitiesLookupRelationshipTaskMetaToJSON: ActivitiesLookupRelationshipTaskMetaToJSON,
    ActivitiesLookupRelationshipTaskMetaToJSONTyped: ActivitiesLookupRelationshipTaskMetaToJSONTyped,
    ActivitiesLookupRelationshipTaskToJSON: ActivitiesLookupRelationshipTaskToJSON,
    ActivitiesLookupRelationshipTaskToJSONTyped: ActivitiesLookupRelationshipTaskToJSONTyped,
    ActivitiesLookupRelationshipTaskTypeEnum: ActivitiesLookupRelationshipTaskTypeEnum,
    ActivitiesLookupRelationshipToJSON: ActivitiesLookupRelationshipToJSON,
    ActivitiesLookupRelationshipToJSONTyped: ActivitiesLookupRelationshipToJSONTyped,
    ActivitiesRelationshipDataInnerFromJSON: ActivitiesRelationshipDataInnerFromJSON,
    ActivitiesRelationshipDataInnerFromJSONTyped: ActivitiesRelationshipDataInnerFromJSONTyped,
    ActivitiesRelationshipDataInnerToJSON: ActivitiesRelationshipDataInnerToJSON,
    ActivitiesRelationshipDataInnerToJSONTyped: ActivitiesRelationshipDataInnerToJSONTyped,
    ActivitiesRelationshipFromJSON: ActivitiesRelationshipFromJSON,
    ActivitiesRelationshipFromJSONTyped: ActivitiesRelationshipFromJSONTyped,
    ActivitiesRelationshipToJSON: ActivitiesRelationshipToJSON,
    ActivitiesRelationshipToJSONTyped: ActivitiesRelationshipToJSONTyped,
    BalanceAttributesFromJSON: BalanceAttributesFromJSON,
    BalanceAttributesFromJSONTyped: BalanceAttributesFromJSONTyped,
    BalanceAttributesTimeUnitFromJSON: BalanceAttributesTimeUnitFromJSON,
    BalanceAttributesTimeUnitFromJSONTyped: BalanceAttributesTimeUnitFromJSONTyped,
    BalanceAttributesTimeUnitToJSON: BalanceAttributesTimeUnitToJSON,
    BalanceAttributesTimeUnitToJSONTyped: BalanceAttributesTimeUnitToJSONTyped,
    BalanceAttributesToJSON: BalanceAttributesToJSON,
    BalanceAttributesToJSONTyped: BalanceAttributesToJSONTyped,
    BalanceFromJSON: BalanceFromJSON,
    BalanceFromJSONTyped: BalanceFromJSONTyped,
    BalanceRelationshipsBankDataFromJSON: BalanceRelationshipsBankDataFromJSON,
    BalanceRelationshipsBankDataFromJSONTyped: BalanceRelationshipsBankDataFromJSONTyped,
    BalanceRelationshipsBankDataToJSON: BalanceRelationshipsBankDataToJSON,
    BalanceRelationshipsBankDataToJSONTyped: BalanceRelationshipsBankDataToJSONTyped,
    BalanceRelationshipsBankFromJSON: BalanceRelationshipsBankFromJSON,
    BalanceRelationshipsBankFromJSONTyped: BalanceRelationshipsBankFromJSONTyped,
    BalanceRelationshipsBankToJSON: BalanceRelationshipsBankToJSON,
    BalanceRelationshipsBankToJSONTyped: BalanceRelationshipsBankToJSONTyped,
    BalanceRelationshipsFromJSON: BalanceRelationshipsFromJSON,
    BalanceRelationshipsFromJSONTyped: BalanceRelationshipsFromJSONTyped,
    BalanceRelationshipsToJSON: BalanceRelationshipsToJSON,
    BalanceRelationshipsToJSONTyped: BalanceRelationshipsToJSONTyped,
    BalanceToJSON: BalanceToJSON,
    BalanceToJSONTyped: BalanceToJSONTyped,
    BankAttributesFromJSON: BankAttributesFromJSON,
    BankAttributesFromJSONTyped: BankAttributesFromJSONTyped,
    BankAttributesToJSON: BankAttributesToJSON,
    BankAttributesToJSONTyped: BankAttributesToJSONTyped,
    BankFromJSON: BankFromJSON,
    BankFromJSONTyped: BankFromJSONTyped,
    BankIncludeItem: BankIncludeItem,
    BankIncludeItemFromJSON: BankIncludeItemFromJSON,
    BankIncludeItemFromJSONTyped: BankIncludeItemFromJSONTyped,
    BankIncludeItemToJSON: BankIncludeItemToJSON,
    BankIncludeItemToJSONTyped: BankIncludeItemToJSONTyped,
    BankMetadataAttributesBalanceLabelFromJSON: BankMetadataAttributesBalanceLabelFromJSON,
    BankMetadataAttributesBalanceLabelFromJSONTyped: BankMetadataAttributesBalanceLabelFromJSONTyped,
    BankMetadataAttributesBalanceLabelToJSON: BankMetadataAttributesBalanceLabelToJSON,
    BankMetadataAttributesBalanceLabelToJSONTyped: BankMetadataAttributesBalanceLabelToJSONTyped,
    BankMetadataAttributesDisplayContextsFromJSON: BankMetadataAttributesDisplayContextsFromJSON,
    BankMetadataAttributesDisplayContextsFromJSONTyped: BankMetadataAttributesDisplayContextsFromJSONTyped,
    BankMetadataAttributesDisplayContextsToJSON: BankMetadataAttributesDisplayContextsToJSON,
    BankMetadataAttributesDisplayContextsToJSONTyped: BankMetadataAttributesDisplayContextsToJSONTyped,
    BankMetadataAttributesFromJSON: BankMetadataAttributesFromJSON,
    BankMetadataAttributesFromJSONTyped: BankMetadataAttributesFromJSONTyped,
    BankMetadataAttributesToJSON: BankMetadataAttributesToJSON,
    BankMetadataAttributesToJSONTyped: BankMetadataAttributesToJSONTyped,
    BankMetadataFromJSON: BankMetadataFromJSON,
    BankMetadataFromJSONTyped: BankMetadataFromJSONTyped,
    BankMetadataIncludeItem: BankMetadataIncludeItem,
    BankMetadataIncludeItemFromJSON: BankMetadataIncludeItemFromJSON,
    BankMetadataIncludeItemFromJSONTyped: BankMetadataIncludeItemFromJSONTyped,
    BankMetadataIncludeItemToJSON: BankMetadataIncludeItemToJSON,
    BankMetadataIncludeItemToJSONTyped: BankMetadataIncludeItemToJSONTyped,
    BankMetadataMetaFromJSON: BankMetadataMetaFromJSON,
    BankMetadataMetaFromJSONTyped: BankMetadataMetaFromJSONTyped,
    BankMetadataMetaToJSON: BankMetadataMetaToJSON,
    BankMetadataMetaToJSONTyped: BankMetadataMetaToJSONTyped,
    BankMetadataToJSON: BankMetadataToJSON,
    BankMetadataToJSONTyped: BankMetadataToJSONTyped,
    BankPolicyRelationshipDataFromJSON: BankPolicyRelationshipDataFromJSON,
    BankPolicyRelationshipDataFromJSONTyped: BankPolicyRelationshipDataFromJSONTyped,
    BankPolicyRelationshipDataToJSON: BankPolicyRelationshipDataToJSON,
    BankPolicyRelationshipDataToJSONTyped: BankPolicyRelationshipDataToJSONTyped,
    BankPolicyRelationshipFromJSON: BankPolicyRelationshipFromJSON,
    BankPolicyRelationshipFromJSONTyped: BankPolicyRelationshipFromJSONTyped,
    BankPolicyRelationshipToJSON: BankPolicyRelationshipToJSON,
    BankPolicyRelationshipToJSONTyped: BankPolicyRelationshipToJSONTyped,
    BankProjectionAttributesFromJSON: BankProjectionAttributesFromJSON,
    BankProjectionAttributesFromJSONTyped: BankProjectionAttributesFromJSONTyped,
    BankProjectionAttributesStatusEnum: BankProjectionAttributesStatusEnum,
    BankProjectionAttributesToJSON: BankProjectionAttributesToJSON,
    BankProjectionAttributesToJSONTyped: BankProjectionAttributesToJSONTyped,
    BankProjectionBalanceRelationshipsDataInnerFromJSON: BankProjectionBalanceRelationshipsDataInnerFromJSON,
    BankProjectionBalanceRelationshipsDataInnerFromJSONTyped: BankProjectionBalanceRelationshipsDataInnerFromJSONTyped,
    BankProjectionBalanceRelationshipsDataInnerToJSON: BankProjectionBalanceRelationshipsDataInnerToJSON,
    BankProjectionBalanceRelationshipsDataInnerToJSONTyped: BankProjectionBalanceRelationshipsDataInnerToJSONTyped,
    BankProjectionBalanceRelationshipsFromJSON: BankProjectionBalanceRelationshipsFromJSON,
    BankProjectionBalanceRelationshipsFromJSONTyped: BankProjectionBalanceRelationshipsFromJSONTyped,
    BankProjectionBalanceRelationshipsToJSON: BankProjectionBalanceRelationshipsToJSON,
    BankProjectionBalanceRelationshipsToJSONTyped: BankProjectionBalanceRelationshipsToJSONTyped,
    BankProjectionCreateRequestDataAttributesFromJSON: BankProjectionCreateRequestDataAttributesFromJSON,
    BankProjectionCreateRequestDataAttributesFromJSONTyped: BankProjectionCreateRequestDataAttributesFromJSONTyped,
    BankProjectionCreateRequestDataAttributesToJSON: BankProjectionCreateRequestDataAttributesToJSON,
    BankProjectionCreateRequestDataAttributesToJSONTyped: BankProjectionCreateRequestDataAttributesToJSONTyped,
    BankProjectionCreateRequestDataFromJSON: BankProjectionCreateRequestDataFromJSON,
    BankProjectionCreateRequestDataFromJSONTyped: BankProjectionCreateRequestDataFromJSONTyped,
    BankProjectionCreateRequestDataToJSON: BankProjectionCreateRequestDataToJSON,
    BankProjectionCreateRequestDataToJSONTyped: BankProjectionCreateRequestDataToJSONTyped,
    BankProjectionCreateRequestDataTypeEnum: BankProjectionCreateRequestDataTypeEnum,
    BankProjectionCreateRequestFromJSON: BankProjectionCreateRequestFromJSON,
    BankProjectionCreateRequestFromJSONTyped: BankProjectionCreateRequestFromJSONTyped,
    BankProjectionCreateRequestToJSON: BankProjectionCreateRequestToJSON,
    BankProjectionCreateRequestToJSONTyped: BankProjectionCreateRequestToJSONTyped,
    BankProjectionEntryRelationshipsDataInnerFromJSON: BankProjectionEntryRelationshipsDataInnerFromJSON,
    BankProjectionEntryRelationshipsDataInnerFromJSONTyped: BankProjectionEntryRelationshipsDataInnerFromJSONTyped,
    BankProjectionEntryRelationshipsDataInnerToJSON: BankProjectionEntryRelationshipsDataInnerToJSON,
    BankProjectionEntryRelationshipsDataInnerToJSONTyped: BankProjectionEntryRelationshipsDataInnerToJSONTyped,
    BankProjectionEntryRelationshipsFromJSON: BankProjectionEntryRelationshipsFromJSON,
    BankProjectionEntryRelationshipsFromJSONTyped: BankProjectionEntryRelationshipsFromJSONTyped,
    BankProjectionEntryRelationshipsToJSON: BankProjectionEntryRelationshipsToJSON,
    BankProjectionEntryRelationshipsToJSONTyped: BankProjectionEntryRelationshipsToJSONTyped,
    BankProjectionFromJSON: BankProjectionFromJSON,
    BankProjectionFromJSONTyped: BankProjectionFromJSONTyped,
    BankProjectionGapRelationshipsDataInnerFromJSON: BankProjectionGapRelationshipsDataInnerFromJSON,
    BankProjectionGapRelationshipsDataInnerFromJSONTyped: BankProjectionGapRelationshipsDataInnerFromJSONTyped,
    BankProjectionGapRelationshipsDataInnerToJSON: BankProjectionGapRelationshipsDataInnerToJSON,
    BankProjectionGapRelationshipsDataInnerToJSONTyped: BankProjectionGapRelationshipsDataInnerToJSONTyped,
    BankProjectionGapRelationshipsFromJSON: BankProjectionGapRelationshipsFromJSON,
    BankProjectionGapRelationshipsFromJSONTyped: BankProjectionGapRelationshipsFromJSONTyped,
    BankProjectionGapRelationshipsToJSON: BankProjectionGapRelationshipsToJSON,
    BankProjectionGapRelationshipsToJSONTyped: BankProjectionGapRelationshipsToJSONTyped,
    BankProjectionMetaFromJSON: BankProjectionMetaFromJSON,
    BankProjectionMetaFromJSONTyped: BankProjectionMetaFromJSONTyped,
    BankProjectionMetaToJSON: BankProjectionMetaToJSON,
    BankProjectionMetaToJSONTyped: BankProjectionMetaToJSONTyped,
    BankProjectionRequestRelationshipsFromJSON: BankProjectionRequestRelationshipsFromJSON,
    BankProjectionRequestRelationshipsFromJSONTyped: BankProjectionRequestRelationshipsFromJSONTyped,
    BankProjectionRequestRelationshipsToJSON: BankProjectionRequestRelationshipsToJSON,
    BankProjectionRequestRelationshipsToJSONTyped: BankProjectionRequestRelationshipsToJSONTyped,
    BankProjectionResponseRelationshipsFromJSON: BankProjectionResponseRelationshipsFromJSON,
    BankProjectionResponseRelationshipsFromJSONTyped: BankProjectionResponseRelationshipsFromJSONTyped,
    BankProjectionResponseRelationshipsToJSON: BankProjectionResponseRelationshipsToJSON,
    BankProjectionResponseRelationshipsToJSONTyped: BankProjectionResponseRelationshipsToJSONTyped,
    BankProjectionToJSON: BankProjectionToJSON,
    BankProjectionToJSONTyped: BankProjectionToJSONTyped,
    BankToJSON: BankToJSON,
    BankToJSONTyped: BankToJSONTyped,
    BidAttributesFromJSON: BidAttributesFromJSON,
    BidAttributesFromJSONTyped: BidAttributesFromJSONTyped,
    BidAttributesToJSON: BidAttributesToJSON,
    BidAttributesToJSONTyped: BidAttributesToJSONTyped,
    BidBlockAttributesFromJSON: BidBlockAttributesFromJSON,
    BidBlockAttributesFromJSONTyped: BidBlockAttributesFromJSONTyped,
    BidBlockAttributesToJSON: BidBlockAttributesToJSON,
    BidBlockAttributesToJSONTyped: BidBlockAttributesToJSONTyped,
    BidBlockFromJSON: BidBlockFromJSON,
    BidBlockFromJSONTyped: BidBlockFromJSONTyped,
    BidBlockToJSON: BidBlockToJSON,
    BidBlockToJSONTyped: BidBlockToJSONTyped,
    BidBlocksResponseSchemaFromJSON: BidBlocksResponseSchemaFromJSON,
    BidBlocksResponseSchemaFromJSONTyped: BidBlocksResponseSchemaFromJSONTyped,
    BidBlocksResponseSchemaToJSON: BidBlocksResponseSchemaToJSON,
    BidBlocksResponseSchemaToJSONTyped: BidBlocksResponseSchemaToJSONTyped,
    BidFromJSON: BidFromJSON,
    BidFromJSONTyped: BidFromJSONTyped,
    BidMetaFromJSON: BidMetaFromJSON,
    BidMetaFromJSONTyped: BidMetaFromJSONTyped,
    BidMetaToJSON: BidMetaToJSON,
    BidMetaToJSONTyped: BidMetaToJSONTyped,
    BidOptionsConfigurationFromJSON: BidOptionsConfigurationFromJSON,
    BidOptionsConfigurationFromJSONTyped: BidOptionsConfigurationFromJSONTyped,
    BidOptionsConfigurationToJSON: BidOptionsConfigurationToJSON,
    BidOptionsConfigurationToJSONTyped: BidOptionsConfigurationToJSONTyped,
    BidPackageAttributesFromJSON: BidPackageAttributesFromJSON,
    BidPackageAttributesFromJSONTyped: BidPackageAttributesFromJSONTyped,
    BidPackageAttributesToJSON: BidPackageAttributesToJSON,
    BidPackageAttributesToJSONTyped: BidPackageAttributesToJSONTyped,
    BidPackageFromJSON: BidPackageFromJSON,
    BidPackageFromJSONTyped: BidPackageFromJSONTyped,
    BidPackageMetaFromJSON: BidPackageMetaFromJSON,
    BidPackageMetaFromJSONTyped: BidPackageMetaFromJSONTyped,
    BidPackageMetaToJSON: BidPackageMetaToJSON,
    BidPackageMetaToJSONTyped: BidPackageMetaToJSONTyped,
    BidPackageRelationshipsFromJSON: BidPackageRelationshipsFromJSON,
    BidPackageRelationshipsFromJSONTyped: BidPackageRelationshipsFromJSONTyped,
    BidPackageRelationshipsToJSON: BidPackageRelationshipsToJSON,
    BidPackageRelationshipsToJSONTyped: BidPackageRelationshipsToJSONTyped,
    BidPackageResponseSchemaFromJSON: BidPackageResponseSchemaFromJSON,
    BidPackageResponseSchemaFromJSONTyped: BidPackageResponseSchemaFromJSONTyped,
    BidPackageResponseSchemaToJSON: BidPackageResponseSchemaToJSON,
    BidPackageResponseSchemaToJSONTyped: BidPackageResponseSchemaToJSONTyped,
    BidPackageToJSON: BidPackageToJSON,
    BidPackageToJSONTyped: BidPackageToJSONTyped,
    BidRelationshipsBidPackageFromJSON: BidRelationshipsBidPackageFromJSON,
    BidRelationshipsBidPackageFromJSONTyped: BidRelationshipsBidPackageFromJSONTyped,
    BidRelationshipsBidPackageToJSON: BidRelationshipsBidPackageToJSON,
    BidRelationshipsBidPackageToJSONTyped: BidRelationshipsBidPackageToJSONTyped,
    BidRelationshipsBidSelectionsFromJSON: BidRelationshipsBidSelectionsFromJSON,
    BidRelationshipsBidSelectionsFromJSONTyped: BidRelationshipsBidSelectionsFromJSONTyped,
    BidRelationshipsBidSelectionsToJSON: BidRelationshipsBidSelectionsToJSON,
    BidRelationshipsBidSelectionsToJSONTyped: BidRelationshipsBidSelectionsToJSONTyped,
    BidRelationshipsEmployeeFromJSON: BidRelationshipsEmployeeFromJSON,
    BidRelationshipsEmployeeFromJSONTyped: BidRelationshipsEmployeeFromJSONTyped,
    BidRelationshipsEmployeeToJSON: BidRelationshipsEmployeeToJSON,
    BidRelationshipsEmployeeToJSONTyped: BidRelationshipsEmployeeToJSONTyped,
    BidRelationshipsFromJSON: BidRelationshipsFromJSON,
    BidRelationshipsFromJSONTyped: BidRelationshipsFromJSONTyped,
    BidRelationshipsToJSON: BidRelationshipsToJSON,
    BidRelationshipsToJSONTyped: BidRelationshipsToJSONTyped,
    BidResourceDataFromJSON: BidResourceDataFromJSON,
    BidResourceDataFromJSONTyped: BidResourceDataFromJSONTyped,
    BidResourceDataToJSON: BidResourceDataToJSON,
    BidResourceDataToJSONTyped: BidResourceDataToJSONTyped,
    BidResponseSchemaFromJSON: BidResponseSchemaFromJSON,
    BidResponseSchemaFromJSONTyped: BidResponseSchemaFromJSONTyped,
    BidResponseSchemaToJSON: BidResponseSchemaToJSON,
    BidResponseSchemaToJSONTyped: BidResponseSchemaToJSONTyped,
    BidToJSON: BidToJSON,
    BidToJSONTyped: BidToJSONTyped,
    BiddingGroupsDataInnerFromJSON: BiddingGroupsDataInnerFromJSON,
    BiddingGroupsDataInnerFromJSONTyped: BiddingGroupsDataInnerFromJSONTyped,
    BiddingGroupsDataInnerToJSON: BiddingGroupsDataInnerToJSON,
    BiddingGroupsDataInnerToJSONTyped: BiddingGroupsDataInnerToJSONTyped,
    BiddingGroupsFromJSON: BiddingGroupsFromJSON,
    BiddingGroupsFromJSONTyped: BiddingGroupsFromJSONTyped,
    BiddingGroupsToJSON: BiddingGroupsToJSON,
    BiddingGroupsToJSONTyped: BiddingGroupsToJSONTyped,
    BidsResponseSchemaFromJSON: BidsResponseSchemaFromJSON,
    BidsResponseSchemaFromJSONTyped: BidsResponseSchemaFromJSONTyped,
    BidsResponseSchemaToJSON: BidsResponseSchemaToJSON,
    BidsResponseSchemaToJSONTyped: BidsResponseSchemaToJSONTyped,
    CaseType: CaseType,
    CaseTypeFromJSON: CaseTypeFromJSON,
    CaseTypeFromJSONTyped: CaseTypeFromJSONTyped,
    CaseTypeToJSON: CaseTypeToJSON,
    CaseTypeToJSONTyped: CaseTypeToJSONTyped,
    ChildGroupPolicyFromJSON: ChildGroupPolicyFromJSON,
    ChildGroupPolicyFromJSONTyped: ChildGroupPolicyFromJSONTyped,
    ChildGroupPolicyToJSON: ChildGroupPolicyToJSON,
    ChildGroupPolicyToJSONTyped: ChildGroupPolicyToJSONTyped,
    ClockPunchMetadataAttributesFromJSON: ClockPunchMetadataAttributesFromJSON,
    ClockPunchMetadataAttributesFromJSONTyped: ClockPunchMetadataAttributesFromJSONTyped,
    ClockPunchMetadataAttributesToJSON: ClockPunchMetadataAttributesToJSON,
    ClockPunchMetadataAttributesToJSONTyped: ClockPunchMetadataAttributesToJSONTyped,
    ClockPunchMetadataFromJSON: ClockPunchMetadataFromJSON,
    ClockPunchMetadataFromJSONTyped: ClockPunchMetadataFromJSONTyped,
    ClockPunchMetadataRelationshipsFromJSON: ClockPunchMetadataRelationshipsFromJSON,
    ClockPunchMetadataRelationshipsFromJSONTyped: ClockPunchMetadataRelationshipsFromJSONTyped,
    ClockPunchMetadataRelationshipsLastPunchFromJSON: ClockPunchMetadataRelationshipsLastPunchFromJSON,
    ClockPunchMetadataRelationshipsLastPunchFromJSONTyped: ClockPunchMetadataRelationshipsLastPunchFromJSONTyped,
    ClockPunchMetadataRelationshipsLastPunchToJSON: ClockPunchMetadataRelationshipsLastPunchToJSON,
    ClockPunchMetadataRelationshipsLastPunchToJSONTyped: ClockPunchMetadataRelationshipsLastPunchToJSONTyped,
    ClockPunchMetadataRelationshipsToJSON: ClockPunchMetadataRelationshipsToJSON,
    ClockPunchMetadataRelationshipsToJSONTyped: ClockPunchMetadataRelationshipsToJSONTyped,
    ClockPunchMetadataResponseSchemaFromJSON: ClockPunchMetadataResponseSchemaFromJSON,
    ClockPunchMetadataResponseSchemaFromJSONTyped: ClockPunchMetadataResponseSchemaFromJSONTyped,
    ClockPunchMetadataResponseSchemaToJSON: ClockPunchMetadataResponseSchemaToJSON,
    ClockPunchMetadataResponseSchemaToJSONTyped: ClockPunchMetadataResponseSchemaToJSONTyped,
    ClockPunchMetadataToJSON: ClockPunchMetadataToJSON,
    ClockPunchMetadataToJSONTyped: ClockPunchMetadataToJSONTyped,
    CreateBidRequestSchemaDataFromJSON: CreateBidRequestSchemaDataFromJSON,
    CreateBidRequestSchemaDataFromJSONTyped: CreateBidRequestSchemaDataFromJSONTyped,
    CreateBidRequestSchemaDataToJSON: CreateBidRequestSchemaDataToJSON,
    CreateBidRequestSchemaDataToJSONTyped: CreateBidRequestSchemaDataToJSONTyped,
    CreateBidRequestSchemaFromJSON: CreateBidRequestSchemaFromJSON,
    CreateBidRequestSchemaFromJSONTyped: CreateBidRequestSchemaFromJSONTyped,
    CreateBidRequestSchemaToJSON: CreateBidRequestSchemaToJSON,
    CreateBidRequestSchemaToJSONTyped: CreateBidRequestSchemaToJSONTyped,
    CreateBidpackageRequestSchemaDataFromJSON: CreateBidpackageRequestSchemaDataFromJSON,
    CreateBidpackageRequestSchemaDataFromJSONTyped: CreateBidpackageRequestSchemaDataFromJSONTyped,
    CreateBidpackageRequestSchemaDataToJSON: CreateBidpackageRequestSchemaDataToJSON,
    CreateBidpackageRequestSchemaDataToJSONTyped: CreateBidpackageRequestSchemaDataToJSONTyped,
    CreateBidpackageRequestSchemaFromJSON: CreateBidpackageRequestSchemaFromJSON,
    CreateBidpackageRequestSchemaFromJSONTyped: CreateBidpackageRequestSchemaFromJSONTyped,
    CreateBidpackageRequestSchemaToJSON: CreateBidpackageRequestSchemaToJSON,
    CreateBidpackageRequestSchemaToJSONTyped: CreateBidpackageRequestSchemaToJSONTyped,
    CreatePayRuleRequestSchemaBodyFromJSON: CreatePayRuleRequestSchemaBodyFromJSON,
    CreatePayRuleRequestSchemaBodyFromJSONTyped: CreatePayRuleRequestSchemaBodyFromJSONTyped,
    CreatePayRuleRequestSchemaBodyToJSON: CreatePayRuleRequestSchemaBodyToJSON,
    CreatePayRuleRequestSchemaBodyToJSONTyped: CreatePayRuleRequestSchemaBodyToJSONTyped,
    CreatePayRuleRequestSchemaDataFromJSON: CreatePayRuleRequestSchemaDataFromJSON,
    CreatePayRuleRequestSchemaDataFromJSONTyped: CreatePayRuleRequestSchemaDataFromJSONTyped,
    CreatePayRuleRequestSchemaDataRelationshipsFromJSON: CreatePayRuleRequestSchemaDataRelationshipsFromJSON,
    CreatePayRuleRequestSchemaDataRelationshipsFromJSONTyped: CreatePayRuleRequestSchemaDataRelationshipsFromJSONTyped,
    CreatePayRuleRequestSchemaDataRelationshipsToJSON: CreatePayRuleRequestSchemaDataRelationshipsToJSON,
    CreatePayRuleRequestSchemaDataRelationshipsToJSONTyped: CreatePayRuleRequestSchemaDataRelationshipsToJSONTyped,
    CreatePayRuleRequestSchemaDataToJSON: CreatePayRuleRequestSchemaDataToJSON,
    CreatePayRuleRequestSchemaDataToJSONTyped: CreatePayRuleRequestSchemaDataToJSONTyped,
    CreatePayRuleRequestSchemaDataTypeEnum: CreatePayRuleRequestSchemaDataTypeEnum,
    CreatePayRuleRequestSchemaFromJSON: CreatePayRuleRequestSchemaFromJSON,
    CreatePayRuleRequestSchemaFromJSONTyped: CreatePayRuleRequestSchemaFromJSONTyped,
    CreatePayRuleRequestSchemaToJSON: CreatePayRuleRequestSchemaToJSON,
    CreatePayRuleRequestSchemaToJSONTyped: CreatePayRuleRequestSchemaToJSONTyped,
    CreateShiftRelationshipsFromJSON: CreateShiftRelationshipsFromJSON,
    CreateShiftRelationshipsFromJSONTyped: CreateShiftRelationshipsFromJSONTyped,
    CreateShiftRelationshipsToJSON: CreateShiftRelationshipsToJSON,
    CreateShiftRelationshipsToJSONTyped: CreateShiftRelationshipsToJSONTyped,
    CreateShiftRequestSchemaBodyFromJSON: CreateShiftRequestSchemaBodyFromJSON,
    CreateShiftRequestSchemaBodyFromJSONTyped: CreateShiftRequestSchemaBodyFromJSONTyped,
    CreateShiftRequestSchemaBodyStatusEnum: CreateShiftRequestSchemaBodyStatusEnum,
    CreateShiftRequestSchemaBodyToJSON: CreateShiftRequestSchemaBodyToJSON,
    CreateShiftRequestSchemaBodyToJSONTyped: CreateShiftRequestSchemaBodyToJSONTyped,
    CreateShiftRequestSchemaDataFromJSON: CreateShiftRequestSchemaDataFromJSON,
    CreateShiftRequestSchemaDataFromJSONTyped: CreateShiftRequestSchemaDataFromJSONTyped,
    CreateShiftRequestSchemaDataToJSON: CreateShiftRequestSchemaDataToJSON,
    CreateShiftRequestSchemaDataToJSONTyped: CreateShiftRequestSchemaDataToJSONTyped,
    CreateShiftRequestSchemaDataTypeEnum: CreateShiftRequestSchemaDataTypeEnum,
    CreateShiftRequestSchemaFromJSON: CreateShiftRequestSchemaFromJSON,
    CreateShiftRequestSchemaFromJSONTyped: CreateShiftRequestSchemaFromJSONTyped,
    CreateShiftRequestSchemaToJSON: CreateShiftRequestSchemaToJSON,
    CreateShiftRequestSchemaToJSONTyped: CreateShiftRequestSchemaToJSONTyped,
    CreateSingleShiftBreakFromJSON: CreateSingleShiftBreakFromJSON,
    CreateSingleShiftBreakFromJSONTyped: CreateSingleShiftBreakFromJSONTyped,
    CreateSingleShiftBreakToJSON: CreateSingleShiftBreakToJSON,
    CreateSingleShiftBreakToJSONTyped: CreateSingleShiftBreakToJSONTyped,
    CreateTimesheetEntryRequestSchemaDataFromJSON: CreateTimesheetEntryRequestSchemaDataFromJSON,
    CreateTimesheetEntryRequestSchemaDataFromJSONTyped: CreateTimesheetEntryRequestSchemaDataFromJSONTyped,
    CreateTimesheetEntryRequestSchemaDataToJSON: CreateTimesheetEntryRequestSchemaDataToJSON,
    CreateTimesheetEntryRequestSchemaDataToJSONTyped: CreateTimesheetEntryRequestSchemaDataToJSONTyped,
    CreateTimesheetEntryRequestSchemaFromJSON: CreateTimesheetEntryRequestSchemaFromJSON,
    CreateTimesheetEntryRequestSchemaFromJSONTyped: CreateTimesheetEntryRequestSchemaFromJSONTyped,
    CreateTimesheetEntryRequestSchemaToJSON: CreateTimesheetEntryRequestSchemaToJSON,
    CreateTimesheetEntryRequestSchemaToJSONTyped: CreateTimesheetEntryRequestSchemaToJSONTyped,
    CreatedSwipeResponseFromJSON: CreatedSwipeResponseFromJSON,
    CreatedSwipeResponseFromJSONTyped: CreatedSwipeResponseFromJSONTyped,
    CreatedSwipeResponseToJSON: CreatedSwipeResponseToJSON,
    CreatedSwipeResponseToJSONTyped: CreatedSwipeResponseToJSONTyped,
    CreatedTimeOffResponseFromJSON: CreatedTimeOffResponseFromJSON,
    CreatedTimeOffResponseFromJSONTyped: CreatedTimeOffResponseFromJSONTyped,
    CreatedTimeOffResponseToJSON: CreatedTimeOffResponseToJSON,
    CreatedTimeOffResponseToJSONTyped: CreatedTimeOffResponseToJSONTyped,
    DailyDurationFromJSON: DailyDurationFromJSON,
    DailyDurationFromJSONTyped: DailyDurationFromJSONTyped,
    DailyDurationQuantityFromJSON: DailyDurationQuantityFromJSON,
    DailyDurationQuantityFromJSONTyped: DailyDurationQuantityFromJSONTyped,
    DailyDurationQuantityToJSON: DailyDurationQuantityToJSON,
    DailyDurationQuantityToJSONTyped: DailyDurationQuantityToJSONTyped,
    DailyDurationStartTimeQuantityFromJSON: DailyDurationStartTimeQuantityFromJSON,
    DailyDurationStartTimeQuantityFromJSONTyped: DailyDurationStartTimeQuantityFromJSONTyped,
    DailyDurationStartTimeQuantityToJSON: DailyDurationStartTimeQuantityToJSON,
    DailyDurationStartTimeQuantityToJSONTyped: DailyDurationStartTimeQuantityToJSONTyped,
    DailyDurationTimeFromJSON: DailyDurationTimeFromJSON,
    DailyDurationTimeFromJSONTyped: DailyDurationTimeFromJSONTyped,
    DailyDurationTimeToJSON: DailyDurationTimeToJSON,
    DailyDurationTimeToJSONTyped: DailyDurationTimeToJSONTyped,
    DailyDurationToJSON: DailyDurationToJSON,
    DailyDurationToJSONTyped: DailyDurationToJSONTyped,
    DataElementAttributesFromJSON: DataElementAttributesFromJSON,
    DataElementAttributesFromJSONTyped: DataElementAttributesFromJSONTyped,
    DataElementAttributesToJSON: DataElementAttributesToJSON,
    DataElementAttributesToJSONTyped: DataElementAttributesToJSONTyped,
    DataElementFromJSON: DataElementFromJSON,
    DataElementFromJSONTyped: DataElementFromJSONTyped,
    DataElementToJSON: DataElementToJSON,
    DataElementToJSONTyped: DataElementToJSONTyped,
    DataV1AbsenceReasonsFilterParameterFromJSON: DataV1AbsenceReasonsFilterParameterFromJSON,
    DataV1AbsenceReasonsFilterParameterFromJSONTyped: DataV1AbsenceReasonsFilterParameterFromJSONTyped,
    DataV1AbsenceReasonsFilterParameterToJSON: DataV1AbsenceReasonsFilterParameterToJSON,
    DataV1AbsenceReasonsFilterParameterToJSONTyped: DataV1AbsenceReasonsFilterParameterToJSONTyped,
    DataV1CaseChangesFilterParameterFromJSON: DataV1CaseChangesFilterParameterFromJSON,
    DataV1CaseChangesFilterParameterFromJSONTyped: DataV1CaseChangesFilterParameterFromJSONTyped,
    DataV1CaseChangesFilterParameterToJSON: DataV1CaseChangesFilterParameterToJSON,
    DataV1CaseChangesFilterParameterToJSONTyped: DataV1CaseChangesFilterParameterToJSONTyped,
    DataV1EmployeesFilterParameterFromJSON: DataV1EmployeesFilterParameterFromJSON,
    DataV1EmployeesFilterParameterFromJSONTyped: DataV1EmployeesFilterParameterFromJSONTyped,
    DataV1EmployeesFilterParameterToJSON: DataV1EmployeesFilterParameterToJSON,
    DataV1EmployeesFilterParameterToJSONTyped: DataV1EmployeesFilterParameterToJSONTyped,
    DayOfWeek: DayOfWeek,
    DayOfWeekFromJSON: DayOfWeekFromJSON,
    DayOfWeekFromJSONTyped: DayOfWeekFromJSONTyped,
    DayOfWeekToJSON: DayOfWeekToJSON,
    DayOfWeekToJSONTyped: DayOfWeekToJSONTyped,
    DeleteTimesheetEntryRequestSchemaDataFromJSON: DeleteTimesheetEntryRequestSchemaDataFromJSON,
    DeleteTimesheetEntryRequestSchemaDataFromJSONTyped: DeleteTimesheetEntryRequestSchemaDataFromJSONTyped,
    DeleteTimesheetEntryRequestSchemaDataToJSON: DeleteTimesheetEntryRequestSchemaDataToJSON,
    DeleteTimesheetEntryRequestSchemaDataToJSONTyped: DeleteTimesheetEntryRequestSchemaDataToJSONTyped,
    DeleteTimesheetEntryRequestSchemaFromJSON: DeleteTimesheetEntryRequestSchemaFromJSON,
    DeleteTimesheetEntryRequestSchemaFromJSONTyped: DeleteTimesheetEntryRequestSchemaFromJSONTyped,
    DeleteTimesheetEntryRequestSchemaToJSON: DeleteTimesheetEntryRequestSchemaToJSON,
    DeleteTimesheetEntryRequestSchemaToJSONTyped: DeleteTimesheetEntryRequestSchemaToJSONTyped,
    DiscriminatedFieldValueDatatypeEnum: DiscriminatedFieldValueDatatypeEnum,
    DiscriminatedFieldValueFromJSON: DiscriminatedFieldValueFromJSON,
    DiscriminatedFieldValueFromJSONTyped: DiscriminatedFieldValueFromJSONTyped,
    DiscriminatedFieldValueToJSON: DiscriminatedFieldValueToJSON,
    DiscriminatedFieldValueToJSONTyped: DiscriminatedFieldValueToJSONTyped,
    DurationDateTimeFromJSON: DurationDateTimeFromJSON,
    DurationDateTimeFromJSONTyped: DurationDateTimeFromJSONTyped,
    DurationDateTimeToJSON: DurationDateTimeToJSON,
    DurationDateTimeToJSONTyped: DurationDateTimeToJSONTyped,
    DurationFromJSON: DurationFromJSON,
    DurationFromJSONTyped: DurationFromJSONTyped,
    DurationQuantityFromJSON: DurationQuantityFromJSON,
    DurationQuantityFromJSONTyped: DurationQuantityFromJSONTyped,
    DurationQuantityToJSON: DurationQuantityToJSON,
    DurationQuantityToJSONTyped: DurationQuantityToJSONTyped,
    DurationToJSON: DurationToJSON,
    DurationToJSONTyped: DurationToJSONTyped,
    EligibleLeaveOverrideDtlFromJSON: EligibleLeaveOverrideDtlFromJSON,
    EligibleLeaveOverrideDtlFromJSONTyped: EligibleLeaveOverrideDtlFromJSONTyped,
    EligibleLeaveOverrideDtlQualificationResultEnum: EligibleLeaveOverrideDtlQualificationResultEnum,
    EligibleLeaveOverrideDtlToJSON: EligibleLeaveOverrideDtlToJSON,
    EligibleLeaveOverrideDtlToJSONTyped: EligibleLeaveOverrideDtlToJSONTyped,
    EmployeeAttributesFromJSON: EmployeeAttributesFromJSON,
    EmployeeAttributesFromJSONTyped: EmployeeAttributesFromJSONTyped,
    EmployeeAttributesToJSON: EmployeeAttributesToJSON,
    EmployeeAttributesToJSONTyped: EmployeeAttributesToJSONTyped,
    EmployeeBankAttributesFromJSON: EmployeeBankAttributesFromJSON,
    EmployeeBankAttributesFromJSONTyped: EmployeeBankAttributesFromJSONTyped,
    EmployeeBankAttributesTimeUnitFromJSON: EmployeeBankAttributesTimeUnitFromJSON,
    EmployeeBankAttributesTimeUnitFromJSONTyped: EmployeeBankAttributesTimeUnitFromJSONTyped,
    EmployeeBankAttributesTimeUnitToJSON: EmployeeBankAttributesTimeUnitToJSON,
    EmployeeBankAttributesTimeUnitToJSONTyped: EmployeeBankAttributesTimeUnitToJSONTyped,
    EmployeeBankAttributesToJSON: EmployeeBankAttributesToJSON,
    EmployeeBankAttributesToJSONTyped: EmployeeBankAttributesToJSONTyped,
    EmployeeBankFromJSON: EmployeeBankFromJSON,
    EmployeeBankFromJSONTyped: EmployeeBankFromJSONTyped,
    EmployeeBankMetaFromJSON: EmployeeBankMetaFromJSON,
    EmployeeBankMetaFromJSONTyped: EmployeeBankMetaFromJSONTyped,
    EmployeeBankMetaToJSON: EmployeeBankMetaToJSON,
    EmployeeBankMetaToJSONTyped: EmployeeBankMetaToJSONTyped,
    EmployeeBankRelationshipsFromJSON: EmployeeBankRelationshipsFromJSON,
    EmployeeBankRelationshipsFromJSONTyped: EmployeeBankRelationshipsFromJSONTyped,
    EmployeeBankRelationshipsToJSON: EmployeeBankRelationshipsToJSON,
    EmployeeBankRelationshipsToJSONTyped: EmployeeBankRelationshipsToJSONTyped,
    EmployeeBankToJSON: EmployeeBankToJSON,
    EmployeeBankToJSONTyped: EmployeeBankToJSONTyped,
    EmployeeCardAttributesFromJSON: EmployeeCardAttributesFromJSON,
    EmployeeCardAttributesFromJSONTyped: EmployeeCardAttributesFromJSONTyped,
    EmployeeCardAttributesToJSON: EmployeeCardAttributesToJSON,
    EmployeeCardAttributesToJSONTyped: EmployeeCardAttributesToJSONTyped,
    EmployeeCardFromJSON: EmployeeCardFromJSON,
    EmployeeCardFromJSONTyped: EmployeeCardFromJSONTyped,
    EmployeeCardToJSON: EmployeeCardToJSON,
    EmployeeCardToJSONTyped: EmployeeCardToJSONTyped,
    EmployeeFromJSON: EmployeeFromJSON,
    EmployeeFromJSONTyped: EmployeeFromJSONTyped,
    EmployeeRelationshipDataFromJSON: EmployeeRelationshipDataFromJSON,
    EmployeeRelationshipDataFromJSONTyped: EmployeeRelationshipDataFromJSONTyped,
    EmployeeRelationshipDataToJSON: EmployeeRelationshipDataToJSON,
    EmployeeRelationshipDataToJSONTyped: EmployeeRelationshipDataToJSONTyped,
    EmployeeRelationshipFromJSON: EmployeeRelationshipFromJSON,
    EmployeeRelationshipFromJSONTyped: EmployeeRelationshipFromJSONTyped,
    EmployeeRelationshipToJSON: EmployeeRelationshipToJSON,
    EmployeeRelationshipToJSONTyped: EmployeeRelationshipToJSONTyped,
    EmployeeRelationshipsFromJSON: EmployeeRelationshipsFromJSON,
    EmployeeRelationshipsFromJSONTyped: EmployeeRelationshipsFromJSONTyped,
    EmployeeRelationshipsToJSON: EmployeeRelationshipsToJSON,
    EmployeeRelationshipsToJSONTyped: EmployeeRelationshipsToJSONTyped,
    EmployeeRelationshipsWithLookupDataInnerFromJSON: EmployeeRelationshipsWithLookupDataInnerFromJSON,
    EmployeeRelationshipsWithLookupDataInnerFromJSONTyped: EmployeeRelationshipsWithLookupDataInnerFromJSONTyped,
    EmployeeRelationshipsWithLookupDataInnerMetaFromJSON: EmployeeRelationshipsWithLookupDataInnerMetaFromJSON,
    EmployeeRelationshipsWithLookupDataInnerMetaFromJSONTyped: EmployeeRelationshipsWithLookupDataInnerMetaFromJSONTyped,
    EmployeeRelationshipsWithLookupDataInnerMetaLookupFromJSON: EmployeeRelationshipsWithLookupDataInnerMetaLookupFromJSON,
    EmployeeRelationshipsWithLookupDataInnerMetaLookupFromJSONTyped: EmployeeRelationshipsWithLookupDataInnerMetaLookupFromJSONTyped,
    EmployeeRelationshipsWithLookupDataInnerMetaLookupToJSON: EmployeeRelationshipsWithLookupDataInnerMetaLookupToJSON,
    EmployeeRelationshipsWithLookupDataInnerMetaLookupToJSONTyped: EmployeeRelationshipsWithLookupDataInnerMetaLookupToJSONTyped,
    EmployeeRelationshipsWithLookupDataInnerMetaToJSON: EmployeeRelationshipsWithLookupDataInnerMetaToJSON,
    EmployeeRelationshipsWithLookupDataInnerMetaToJSONTyped: EmployeeRelationshipsWithLookupDataInnerMetaToJSONTyped,
    EmployeeRelationshipsWithLookupDataInnerToJSON: EmployeeRelationshipsWithLookupDataInnerToJSON,
    EmployeeRelationshipsWithLookupDataInnerToJSONTyped: EmployeeRelationshipsWithLookupDataInnerToJSONTyped,
    EmployeeRelationshipsWithLookupFromJSON: EmployeeRelationshipsWithLookupFromJSON,
    EmployeeRelationshipsWithLookupFromJSONTyped: EmployeeRelationshipsWithLookupFromJSONTyped,
    EmployeeRelationshipsWithLookupToJSON: EmployeeRelationshipsWithLookupToJSON,
    EmployeeRelationshipsWithLookupToJSONTyped: EmployeeRelationshipsWithLookupToJSONTyped,
    EmployeeToJSON: EmployeeToJSON,
    EmployeeToJSONTyped: EmployeeToJSONTyped,
    EmployeesJobResponseFromJSON: EmployeesJobResponseFromJSON,
    EmployeesJobResponseFromJSONTyped: EmployeesJobResponseFromJSONTyped,
    EmployeesJobResponseToJSON: EmployeesJobResponseToJSON,
    EmployeesJobResponseToJSONTyped: EmployeesJobResponseToJSONTyped,
    EmployeesJobsResponseFromJSON: EmployeesJobsResponseFromJSON,
    EmployeesJobsResponseFromJSONTyped: EmployeesJobsResponseFromJSONTyped,
    EmployeesJobsResponseToJSON: EmployeesJobsResponseToJSON,
    EmployeesJobsResponseToJSONTyped: EmployeesJobsResponseToJSONTyped,
    EntryFieldFromJSON: EntryFieldFromJSON,
    EntryFieldFromJSONTyped: EntryFieldFromJSONTyped,
    EntryFieldToJSON: EntryFieldToJSON,
    EntryFieldToJSONTyped: EntryFieldToJSONTyped,
    EntryType: EntryType,
    EntryTypeFromJSON: EntryTypeFromJSON,
    EntryTypeFromJSONTyped: EntryTypeFromJSONTyped,
    EntryTypeToJSON: EntryTypeToJSON,
    EntryTypeToJSONTyped: EntryTypeToJSONTyped,
    ErrorResponseFromJSON: ErrorResponseFromJSON,
    ErrorResponseFromJSONTyped: ErrorResponseFromJSONTyped,
    ErrorResponseToJSON: ErrorResponseToJSON,
    ErrorResponseToJSONTyped: ErrorResponseToJSONTyped,
    ErrorSourceFromJSON: ErrorSourceFromJSON,
    ErrorSourceFromJSONTyped: ErrorSourceFromJSONTyped,
    ErrorSourceToJSON: ErrorSourceToJSON,
    ErrorSourceToJSONTyped: ErrorSourceToJSONTyped,
    ExceptionsRelationshipDataInnerFromJSON: ExceptionsRelationshipDataInnerFromJSON,
    ExceptionsRelationshipDataInnerFromJSONTyped: ExceptionsRelationshipDataInnerFromJSONTyped,
    ExceptionsRelationshipDataInnerToJSON: ExceptionsRelationshipDataInnerToJSON,
    ExceptionsRelationshipDataInnerToJSONTyped: ExceptionsRelationshipDataInnerToJSONTyped,
    ExceptionsRelationshipFromJSON: ExceptionsRelationshipFromJSON,
    ExceptionsRelationshipFromJSONTyped: ExceptionsRelationshipFromJSONTyped,
    ExceptionsRelationshipToJSON: ExceptionsRelationshipToJSON,
    ExceptionsRelationshipToJSONTyped: ExceptionsRelationshipToJSONTyped,
    FieldValueDatatypeEnum: FieldValueDatatypeEnum,
    FieldValueFromJSON: FieldValueFromJSON,
    FieldValueFromJSONTyped: FieldValueFromJSONTyped,
    FieldValueToJSON: FieldValueToJSON,
    FieldValueToJSONTyped: FieldValueToJSONTyped,
    FieldValueValueFromJSON: FieldValueValueFromJSON,
    FieldValueValueFromJSONTyped: FieldValueValueFromJSONTyped,
    FieldValueValueToJSON: FieldValueValueToJSON,
    FieldValueValueToJSONTyped: FieldValueValueToJSONTyped,
    FormFieldRelationshipDataFromJSON: FormFieldRelationshipDataFromJSON,
    FormFieldRelationshipDataFromJSONTyped: FormFieldRelationshipDataFromJSONTyped,
    FormFieldRelationshipDataToJSON: FormFieldRelationshipDataToJSON,
    FormFieldRelationshipDataToJSONTyped: FormFieldRelationshipDataToJSONTyped,
    FormFieldRelationshipFromJSON: FormFieldRelationshipFromJSON,
    FormFieldRelationshipFromJSONTyped: FormFieldRelationshipFromJSONTyped,
    FormFieldRelationshipToJSON: FormFieldRelationshipToJSON,
    FormFieldRelationshipToJSONTyped: FormFieldRelationshipToJSONTyped,
    FormFieldsReducedAttributesFormFieldTypeEnum: FormFieldsReducedAttributesFormFieldTypeEnum,
    FormFieldsReducedAttributesFromJSON: FormFieldsReducedAttributesFromJSON,
    FormFieldsReducedAttributesFromJSONTyped: FormFieldsReducedAttributesFromJSONTyped,
    FormFieldsReducedAttributesOptionsInnerFromJSON: FormFieldsReducedAttributesOptionsInnerFromJSON,
    FormFieldsReducedAttributesOptionsInnerFromJSONTyped: FormFieldsReducedAttributesOptionsInnerFromJSONTyped,
    FormFieldsReducedAttributesOptionsInnerToJSON: FormFieldsReducedAttributesOptionsInnerToJSON,
    FormFieldsReducedAttributesOptionsInnerToJSONTyped: FormFieldsReducedAttributesOptionsInnerToJSONTyped,
    FormFieldsReducedAttributesToJSON: FormFieldsReducedAttributesToJSON,
    FormFieldsReducedAttributesToJSONTyped: FormFieldsReducedAttributesToJSONTyped,
    FormFieldsReducedFromJSON: FormFieldsReducedFromJSON,
    FormFieldsReducedFromJSONTyped: FormFieldsReducedFromJSONTyped,
    FormFieldsReducedToJSON: FormFieldsReducedToJSON,
    FormFieldsReducedToJSONTyped: FormFieldsReducedToJSONTyped,
    GeolocationFromJSON: GeolocationFromJSON,
    GeolocationFromJSONTyped: GeolocationFromJSONTyped,
    GeolocationToJSON: GeolocationToJSON,
    GeolocationToJSONTyped: GeolocationToJSONTyped,
    GetAbsenceCaseQuestionsFilterParameterFromJSON: GetAbsenceCaseQuestionsFilterParameterFromJSON,
    GetAbsenceCaseQuestionsFilterParameterFromJSONTyped: GetAbsenceCaseQuestionsFilterParameterFromJSONTyped,
    GetAbsenceCaseQuestionsFilterParameterToJSON: GetAbsenceCaseQuestionsFilterParameterToJSON,
    GetAbsenceCaseQuestionsFilterParameterToJSONTyped: GetAbsenceCaseQuestionsFilterParameterToJSONTyped,
    GetAbsenceCaseWorkflowEventsFilterParameterFromJSON: GetAbsenceCaseWorkflowEventsFilterParameterFromJSON,
    GetAbsenceCaseWorkflowEventsFilterParameterFromJSONTyped: GetAbsenceCaseWorkflowEventsFilterParameterFromJSONTyped,
    GetAbsenceCaseWorkflowEventsFilterParameterToJSON: GetAbsenceCaseWorkflowEventsFilterParameterToJSON,
    GetAbsenceCaseWorkflowEventsFilterParameterToJSONTyped: GetAbsenceCaseWorkflowEventsFilterParameterToJSONTyped,
    GetAbsenceCasesFilterParameterCaseTypesEnum: GetAbsenceCasesFilterParameterCaseTypesEnum,
    GetAbsenceCasesFilterParameterFromJSON: GetAbsenceCasesFilterParameterFromJSON,
    GetAbsenceCasesFilterParameterFromJSONTyped: GetAbsenceCasesFilterParameterFromJSONTyped,
    GetAbsenceCasesFilterParameterToJSON: GetAbsenceCasesFilterParameterToJSON,
    GetAbsenceCasesFilterParameterToJSONTyped: GetAbsenceCasesFilterParameterToJSONTyped,
    GetAbsenceCasesPageParameterFromJSON: GetAbsenceCasesPageParameterFromJSON,
    GetAbsenceCasesPageParameterFromJSONTyped: GetAbsenceCasesPageParameterFromJSONTyped,
    GetAbsenceCasesPageParameterToJSON: GetAbsenceCasesPageParameterToJSON,
    GetAbsenceCasesPageParameterToJSONTyped: GetAbsenceCasesPageParameterToJSONTyped,
    GetAbsenceTypesFilterParameterFromJSON: GetAbsenceTypesFilterParameterFromJSON,
    GetAbsenceTypesFilterParameterFromJSONTyped: GetAbsenceTypesFilterParameterFromJSONTyped,
    GetAbsenceTypesFilterParameterToJSON: GetAbsenceTypesFilterParameterToJSON,
    GetAbsenceTypesFilterParameterToJSONTyped: GetAbsenceTypesFilterParameterToJSONTyped,
    GetBankMetadataFilterParameterFromJSON: GetBankMetadataFilterParameterFromJSON,
    GetBankMetadataFilterParameterFromJSONTyped: GetBankMetadataFilterParameterFromJSONTyped,
    GetBankMetadataFilterParameterToJSON: GetBankMetadataFilterParameterToJSON,
    GetBankMetadataFilterParameterToJSONTyped: GetBankMetadataFilterParameterToJSONTyped,
    GetBanksFilterParameterFromJSON: GetBanksFilterParameterFromJSON,
    GetBanksFilterParameterFromJSONTyped: GetBanksFilterParameterFromJSONTyped,
    GetBanksFilterParameterToJSON: GetBanksFilterParameterToJSON,
    GetBanksFilterParameterToJSONTyped: GetBanksFilterParameterToJSONTyped,
    GetJobFilterParameterFromJSON: GetJobFilterParameterFromJSON,
    GetJobFilterParameterFromJSONTyped: GetJobFilterParameterFromJSONTyped,
    GetJobFilterParameterToJSON: GetJobFilterParameterToJSON,
    GetJobFilterParameterToJSONTyped: GetJobFilterParameterToJSONTyped,
    GetJobsFilterParameterFromJSON: GetJobsFilterParameterFromJSON,
    GetJobsFilterParameterFromJSONTyped: GetJobsFilterParameterFromJSONTyped,
    GetJobsFilterParameterToJSON: GetJobsFilterParameterToJSON,
    GetJobsFilterParameterToJSONTyped: GetJobsFilterParameterToJSONTyped,
    GetPoliciesFilterParameterFromJSON: GetPoliciesFilterParameterFromJSON,
    GetPoliciesFilterParameterFromJSONTyped: GetPoliciesFilterParameterFromJSONTyped,
    GetPoliciesFilterParameterToJSON: GetPoliciesFilterParameterToJSON,
    GetPoliciesFilterParameterToJSONTyped: GetPoliciesFilterParameterToJSONTyped,
    GetPolicySetDetailsFilterParameterFromJSON: GetPolicySetDetailsFilterParameterFromJSON,
    GetPolicySetDetailsFilterParameterFromJSONTyped: GetPolicySetDetailsFilterParameterFromJSONTyped,
    GetPolicySetDetailsFilterParameterToJSON: GetPolicySetDetailsFilterParameterToJSON,
    GetPolicySetDetailsFilterParameterToJSONTyped: GetPolicySetDetailsFilterParameterToJSONTyped,
    GetPolicyTypesFilterParameterFromJSON: GetPolicyTypesFilterParameterFromJSON,
    GetPolicyTypesFilterParameterFromJSONTyped: GetPolicyTypesFilterParameterFromJSONTyped,
    GetPolicyTypesFilterParameterTableTypeEnum: GetPolicyTypesFilterParameterTableTypeEnum,
    GetPolicyTypesFilterParameterToJSON: GetPolicyTypesFilterParameterToJSON,
    GetPolicyTypesFilterParameterToJSONTyped: GetPolicyTypesFilterParameterToJSONTyped,
    GetShiftsFilterParameterFromJSON: GetShiftsFilterParameterFromJSON,
    GetShiftsFilterParameterFromJSONTyped: GetShiftsFilterParameterFromJSONTyped,
    GetShiftsFilterParameterToJSON: GetShiftsFilterParameterToJSON,
    GetShiftsFilterParameterToJSONTyped: GetShiftsFilterParameterToJSONTyped,
    GetTimeEntriesByIdFilterParameterFromJSON: GetTimeEntriesByIdFilterParameterFromJSON,
    GetTimeEntriesByIdFilterParameterFromJSONTyped: GetTimeEntriesByIdFilterParameterFromJSONTyped,
    GetTimeEntriesByIdFilterParameterToJSON: GetTimeEntriesByIdFilterParameterToJSON,
    GetTimeEntriesByIdFilterParameterToJSONTyped: GetTimeEntriesByIdFilterParameterToJSONTyped,
    GetTimeOffRequestsFilterParameterFromJSON: GetTimeOffRequestsFilterParameterFromJSON,
    GetTimeOffRequestsFilterParameterFromJSONTyped: GetTimeOffRequestsFilterParameterFromJSONTyped,
    GetTimeOffRequestsFilterParameterToJSON: GetTimeOffRequestsFilterParameterToJSON,
    GetTimeOffRequestsFilterParameterToJSONTyped: GetTimeOffRequestsFilterParameterToJSONTyped,
    GetTimeOffRequestsPageParameterFromJSON: GetTimeOffRequestsPageParameterFromJSON,
    GetTimeOffRequestsPageParameterFromJSONTyped: GetTimeOffRequestsPageParameterFromJSONTyped,
    GetTimeOffRequestsPageParameterToJSON: GetTimeOffRequestsPageParameterToJSON,
    GetTimeOffRequestsPageParameterToJSONTyped: GetTimeOffRequestsPageParameterToJSONTyped,
    GetTimesheetApprovalLayoutFilterParameterFromJSON: GetTimesheetApprovalLayoutFilterParameterFromJSON,
    GetTimesheetApprovalLayoutFilterParameterFromJSONTyped: GetTimesheetApprovalLayoutFilterParameterFromJSONTyped,
    GetTimesheetApprovalLayoutFilterParameterToJSON: GetTimesheetApprovalLayoutFilterParameterToJSON,
    GetTimesheetApprovalLayoutFilterParameterToJSONTyped: GetTimesheetApprovalLayoutFilterParameterToJSONTyped,
    GetTimesheetEntriesFilterParameterFromJSON: GetTimesheetEntriesFilterParameterFromJSON,
    GetTimesheetEntriesFilterParameterFromJSONTyped: GetTimesheetEntriesFilterParameterFromJSONTyped,
    GetTimesheetEntriesFilterParameterToJSON: GetTimesheetEntriesFilterParameterToJSON,
    GetTimesheetEntriesFilterParameterToJSONTyped: GetTimesheetEntriesFilterParameterToJSONTyped,
    GetTimesheetExceptionsFilterParameterFromJSON: GetTimesheetExceptionsFilterParameterFromJSON,
    GetTimesheetExceptionsFilterParameterFromJSONTyped: GetTimesheetExceptionsFilterParameterFromJSONTyped,
    GetTimesheetExceptionsFilterParameterToJSON: GetTimesheetExceptionsFilterParameterToJSON,
    GetTimesheetExceptionsFilterParameterToJSONTyped: GetTimesheetExceptionsFilterParameterToJSONTyped,
    GetTimesheetsFilterParameterFromJSON: GetTimesheetsFilterParameterFromJSON,
    GetTimesheetsFilterParameterFromJSONTyped: GetTimesheetsFilterParameterFromJSONTyped,
    GetTimesheetsFilterParameterToJSON: GetTimesheetsFilterParameterToJSON,
    GetTimesheetsFilterParameterToJSONTyped: GetTimesheetsFilterParameterToJSONTyped,
    GroupRelationshipDataFromJSON: GroupRelationshipDataFromJSON,
    GroupRelationshipDataFromJSONTyped: GroupRelationshipDataFromJSONTyped,
    GroupRelationshipDataToJSON: GroupRelationshipDataToJSON,
    GroupRelationshipDataToJSONTyped: GroupRelationshipDataToJSONTyped,
    GroupRelationshipFromJSON: GroupRelationshipFromJSON,
    GroupRelationshipFromJSONTyped: GroupRelationshipFromJSONTyped,
    GroupRelationshipToJSON: GroupRelationshipToJSON,
    GroupRelationshipToJSONTyped: GroupRelationshipToJSONTyped,
    HelloResponseAttributesFromJSON: HelloResponseAttributesFromJSON,
    HelloResponseAttributesFromJSONTyped: HelloResponseAttributesFromJSONTyped,
    HelloResponseAttributesToJSON: HelloResponseAttributesToJSON,
    HelloResponseAttributesToJSONTyped: HelloResponseAttributesToJSONTyped,
    HelloResponseSchemaDataFromJSON: HelloResponseSchemaDataFromJSON,
    HelloResponseSchemaDataFromJSONTyped: HelloResponseSchemaDataFromJSONTyped,
    HelloResponseSchemaDataToJSON: HelloResponseSchemaDataToJSON,
    HelloResponseSchemaDataToJSONTyped: HelloResponseSchemaDataToJSONTyped,
    HelloResponseSchemaFromJSON: HelloResponseSchemaFromJSON,
    HelloResponseSchemaFromJSONTyped: HelloResponseSchemaFromJSONTyped,
    HelloResponseSchemaToJSON: HelloResponseSchemaToJSON,
    HelloResponseSchemaToJSONTyped: HelloResponseSchemaToJSONTyped,
    IncludeParamsForJobsItem: IncludeParamsForJobsItem,
    IncludeParamsForJobsItemFromJSON: IncludeParamsForJobsItemFromJSON,
    IncludeParamsForJobsItemFromJSONTyped: IncludeParamsForJobsItemFromJSONTyped,
    IncludeParamsForJobsItemToJSON: IncludeParamsForJobsItemToJSON,
    IncludeParamsForJobsItemToJSONTyped: IncludeParamsForJobsItemToJSONTyped,
    IncludedAbsenceTypeInformationAttributesFromJSON: IncludedAbsenceTypeInformationAttributesFromJSON,
    IncludedAbsenceTypeInformationAttributesFromJSONTyped: IncludedAbsenceTypeInformationAttributesFromJSONTyped,
    IncludedAbsenceTypeInformationAttributesToJSON: IncludedAbsenceTypeInformationAttributesToJSON,
    IncludedAbsenceTypeInformationAttributesToJSONTyped: IncludedAbsenceTypeInformationAttributesToJSONTyped,
    IncludedAbsenceTypeInformationFromJSON: IncludedAbsenceTypeInformationFromJSON,
    IncludedAbsenceTypeInformationFromJSONTyped: IncludedAbsenceTypeInformationFromJSONTyped,
    IncludedAbsenceTypeInformationToJSON: IncludedAbsenceTypeInformationToJSON,
    IncludedAbsenceTypeInformationToJSONTyped: IncludedAbsenceTypeInformationToJSONTyped,
    IncludedAbsenceTypeResponseFromJSON: IncludedAbsenceTypeResponseFromJSON,
    IncludedAbsenceTypeResponseFromJSONTyped: IncludedAbsenceTypeResponseFromJSONTyped,
    IncludedAbsenceTypeResponseToJSON: IncludedAbsenceTypeResponseToJSON,
    IncludedAbsenceTypeResponseToJSONTyped: IncludedAbsenceTypeResponseToJSONTyped,
    IncludedEmployeeInformationAttributesFromJSON: IncludedEmployeeInformationAttributesFromJSON,
    IncludedEmployeeInformationAttributesFromJSONTyped: IncludedEmployeeInformationAttributesFromJSONTyped,
    IncludedEmployeeInformationAttributesToJSON: IncludedEmployeeInformationAttributesToJSON,
    IncludedEmployeeInformationAttributesToJSONTyped: IncludedEmployeeInformationAttributesToJSONTyped,
    IncludedEmployeeInformationFromJSON: IncludedEmployeeInformationFromJSON,
    IncludedEmployeeInformationFromJSONTyped: IncludedEmployeeInformationFromJSONTyped,
    IncludedEmployeeInformationToJSON: IncludedEmployeeInformationToJSON,
    IncludedEmployeeInformationToJSONTyped: IncludedEmployeeInformationToJSONTyped,
    IncludedJobInformationAttributesFromJSON: IncludedJobInformationAttributesFromJSON,
    IncludedJobInformationAttributesFromJSONTyped: IncludedJobInformationAttributesFromJSONTyped,
    IncludedJobInformationAttributesToJSON: IncludedJobInformationAttributesToJSON,
    IncludedJobInformationAttributesToJSONTyped: IncludedJobInformationAttributesToJSONTyped,
    IncludedJobInformationFromJSON: IncludedJobInformationFromJSON,
    IncludedJobInformationFromJSONTyped: IncludedJobInformationFromJSONTyped,
    IncludedJobInformationToJSON: IncludedJobInformationToJSON,
    IncludedJobInformationToJSONTyped: IncludedJobInformationToJSONTyped,
    IncludedPayCodeWithEntryFieldAttributesFromJSON: IncludedPayCodeWithEntryFieldAttributesFromJSON,
    IncludedPayCodeWithEntryFieldAttributesFromJSONTyped: IncludedPayCodeWithEntryFieldAttributesFromJSONTyped,
    IncludedPayCodeWithEntryFieldAttributesToJSON: IncludedPayCodeWithEntryFieldAttributesToJSON,
    IncludedPayCodeWithEntryFieldAttributesToJSONTyped: IncludedPayCodeWithEntryFieldAttributesToJSONTyped,
    IncludedPayCodeWithEntryFieldFromJSON: IncludedPayCodeWithEntryFieldFromJSON,
    IncludedPayCodeWithEntryFieldFromJSONTyped: IncludedPayCodeWithEntryFieldFromJSONTyped,
    IncludedPayCodeWithEntryFieldToJSON: IncludedPayCodeWithEntryFieldToJSON,
    IncludedPayCodeWithEntryFieldToJSONTyped: IncludedPayCodeWithEntryFieldToJSONTyped,
    InlineObject10FromJSON: InlineObject10FromJSON,
    InlineObject10FromJSONTyped: InlineObject10FromJSONTyped,
    InlineObject10ToJSON: InlineObject10ToJSON,
    InlineObject10ToJSONTyped: InlineObject10ToJSONTyped,
    InlineObject11FromJSON: InlineObject11FromJSON,
    InlineObject11FromJSONTyped: InlineObject11FromJSONTyped,
    InlineObject11ToJSON: InlineObject11ToJSON,
    InlineObject11ToJSONTyped: InlineObject11ToJSONTyped,
    InlineObject1FromJSON: InlineObject1FromJSON,
    InlineObject1FromJSONTyped: InlineObject1FromJSONTyped,
    InlineObject1LinksFromJSON: InlineObject1LinksFromJSON,
    InlineObject1LinksFromJSONTyped: InlineObject1LinksFromJSONTyped,
    InlineObject1LinksToJSON: InlineObject1LinksToJSON,
    InlineObject1LinksToJSONTyped: InlineObject1LinksToJSONTyped,
    InlineObject1MetaFromJSON: InlineObject1MetaFromJSON,
    InlineObject1MetaFromJSONTyped: InlineObject1MetaFromJSONTyped,
    InlineObject1MetaPageFromJSON: InlineObject1MetaPageFromJSON,
    InlineObject1MetaPageFromJSONTyped: InlineObject1MetaPageFromJSONTyped,
    InlineObject1MetaPageToJSON: InlineObject1MetaPageToJSON,
    InlineObject1MetaPageToJSONTyped: InlineObject1MetaPageToJSONTyped,
    InlineObject1MetaToJSON: InlineObject1MetaToJSON,
    InlineObject1MetaToJSONTyped: InlineObject1MetaToJSONTyped,
    InlineObject1ToJSON: InlineObject1ToJSON,
    InlineObject1ToJSONTyped: InlineObject1ToJSONTyped,
    InlineObject2FromJSON: InlineObject2FromJSON,
    InlineObject2FromJSONTyped: InlineObject2FromJSONTyped,
    InlineObject2IncludedInnerFromJSON: InlineObject2IncludedInnerFromJSON,
    InlineObject2IncludedInnerFromJSONTyped: InlineObject2IncludedInnerFromJSONTyped,
    InlineObject2IncludedInnerToJSON: InlineObject2IncludedInnerToJSON,
    InlineObject2IncludedInnerToJSONTyped: InlineObject2IncludedInnerToJSONTyped,
    InlineObject2ToJSON: InlineObject2ToJSON,
    InlineObject2ToJSONTyped: InlineObject2ToJSONTyped,
    InlineObject3FromJSON: InlineObject3FromJSON,
    InlineObject3FromJSONTyped: InlineObject3FromJSONTyped,
    InlineObject3IncludedInnerFromJSON: InlineObject3IncludedInnerFromJSON,
    InlineObject3IncludedInnerFromJSONTyped: InlineObject3IncludedInnerFromJSONTyped,
    InlineObject3IncludedInnerToJSON: InlineObject3IncludedInnerToJSON,
    InlineObject3IncludedInnerToJSONTyped: InlineObject3IncludedInnerToJSONTyped,
    InlineObject3ToJSON: InlineObject3ToJSON,
    InlineObject3ToJSONTyped: InlineObject3ToJSONTyped,
    InlineObject4FromJSON: InlineObject4FromJSON,
    InlineObject4FromJSONTyped: InlineObject4FromJSONTyped,
    InlineObject4IncludedInnerFromJSON: InlineObject4IncludedInnerFromJSON,
    InlineObject4IncludedInnerFromJSONTyped: InlineObject4IncludedInnerFromJSONTyped,
    InlineObject4IncludedInnerToJSON: InlineObject4IncludedInnerToJSON,
    InlineObject4IncludedInnerToJSONTyped: InlineObject4IncludedInnerToJSONTyped,
    InlineObject4ToJSON: InlineObject4ToJSON,
    InlineObject4ToJSONTyped: InlineObject4ToJSONTyped,
    InlineObject5FromJSON: InlineObject5FromJSON,
    InlineObject5FromJSONTyped: InlineObject5FromJSONTyped,
    InlineObject5IncludedInnerFromJSON: InlineObject5IncludedInnerFromJSON,
    InlineObject5IncludedInnerFromJSONTyped: InlineObject5IncludedInnerFromJSONTyped,
    InlineObject5IncludedInnerToJSON: InlineObject5IncludedInnerToJSON,
    InlineObject5IncludedInnerToJSONTyped: InlineObject5IncludedInnerToJSONTyped,
    InlineObject5ToJSON: InlineObject5ToJSON,
    InlineObject5ToJSONTyped: InlineObject5ToJSONTyped,
    InlineObject6FromJSON: InlineObject6FromJSON,
    InlineObject6FromJSONTyped: InlineObject6FromJSONTyped,
    InlineObject6ToJSON: InlineObject6ToJSON,
    InlineObject6ToJSONTyped: InlineObject6ToJSONTyped,
    InlineObject7FromJSON: InlineObject7FromJSON,
    InlineObject7FromJSONTyped: InlineObject7FromJSONTyped,
    InlineObject7ToJSON: InlineObject7ToJSON,
    InlineObject7ToJSONTyped: InlineObject7ToJSONTyped,
    InlineObject8FromJSON: InlineObject8FromJSON,
    InlineObject8FromJSONTyped: InlineObject8FromJSONTyped,
    InlineObject8IncludedFromJSON: InlineObject8IncludedFromJSON,
    InlineObject8IncludedFromJSONTyped: InlineObject8IncludedFromJSONTyped,
    InlineObject8IncludedToJSON: InlineObject8IncludedToJSON,
    InlineObject8IncludedToJSONTyped: InlineObject8IncludedToJSONTyped,
    InlineObject8ToJSON: InlineObject8ToJSON,
    InlineObject8ToJSONTyped: InlineObject8ToJSONTyped,
    InlineObject9FromJSON: InlineObject9FromJSON,
    InlineObject9FromJSONTyped: InlineObject9FromJSONTyped,
    InlineObject9IncludedInnerFromJSON: InlineObject9IncludedInnerFromJSON,
    InlineObject9IncludedInnerFromJSONTyped: InlineObject9IncludedInnerFromJSONTyped,
    InlineObject9IncludedInnerOneOf1FromJSON: InlineObject9IncludedInnerOneOf1FromJSON,
    InlineObject9IncludedInnerOneOf1FromJSONTyped: InlineObject9IncludedInnerOneOf1FromJSONTyped,
    InlineObject9IncludedInnerOneOf1ToJSON: InlineObject9IncludedInnerOneOf1ToJSON,
    InlineObject9IncludedInnerOneOf1ToJSONTyped: InlineObject9IncludedInnerOneOf1ToJSONTyped,
    InlineObject9IncludedInnerOneOf1TypeEnum: InlineObject9IncludedInnerOneOf1TypeEnum,
    InlineObject9IncludedInnerOneOfFromJSON: InlineObject9IncludedInnerOneOfFromJSON,
    InlineObject9IncludedInnerOneOfFromJSONTyped: InlineObject9IncludedInnerOneOfFromJSONTyped,
    InlineObject9IncludedInnerOneOfToJSON: InlineObject9IncludedInnerOneOfToJSON,
    InlineObject9IncludedInnerOneOfToJSONTyped: InlineObject9IncludedInnerOneOfToJSONTyped,
    InlineObject9IncludedInnerOneOfTypeEnum: InlineObject9IncludedInnerOneOfTypeEnum,
    InlineObject9IncludedInnerToJSON: InlineObject9IncludedInnerToJSON,
    InlineObject9IncludedInnerToJSONTyped: InlineObject9IncludedInnerToJSONTyped,
    InlineObject9ToJSON: InlineObject9ToJSON,
    InlineObject9ToJSONTyped: InlineObject9ToJSONTyped,
    InlineObjectFromJSON: InlineObjectFromJSON,
    InlineObjectFromJSONTyped: InlineObjectFromJSONTyped,
    InlineObjectIncludedInnerFromJSON: InlineObjectIncludedInnerFromJSON,
    InlineObjectIncludedInnerFromJSONTyped: InlineObjectIncludedInnerFromJSONTyped,
    InlineObjectIncludedInnerToJSON: InlineObjectIncludedInnerToJSON,
    InlineObjectIncludedInnerToJSONTyped: InlineObjectIncludedInnerToJSONTyped,
    InlineObjectToJSON: InlineObjectToJSON,
    InlineObjectToJSONTyped: InlineObjectToJSONTyped,
    JobAttributesFromJSON: JobAttributesFromJSON,
    JobAttributesFromJSONTyped: JobAttributesFromJSONTyped,
    JobAttributesToJSON: JobAttributesToJSON,
    JobAttributesToJSONTyped: JobAttributesToJSONTyped,
    JobCardAttributesFromJSON: JobCardAttributesFromJSON,
    JobCardAttributesFromJSONTyped: JobCardAttributesFromJSONTyped,
    JobCardAttributesToJSON: JobCardAttributesToJSON,
    JobCardAttributesToJSONTyped: JobCardAttributesToJSONTyped,
    JobCardFromJSON: JobCardFromJSON,
    JobCardFromJSONTyped: JobCardFromJSONTyped,
    JobCardToJSON: JobCardToJSON,
    JobCardToJSONTyped: JobCardToJSONTyped,
    JobRelationshipDataFromJSON: JobRelationshipDataFromJSON,
    JobRelationshipDataFromJSONTyped: JobRelationshipDataFromJSONTyped,
    JobRelationshipDataToJSON: JobRelationshipDataToJSON,
    JobRelationshipDataToJSONTyped: JobRelationshipDataToJSONTyped,
    JobRelationshipFromJSON: JobRelationshipFromJSON,
    JobRelationshipFromJSONTyped: JobRelationshipFromJSONTyped,
    JobRelationshipToJSON: JobRelationshipToJSON,
    JobRelationshipToJSONTyped: JobRelationshipToJSONTyped,
    JobRelationshipsDataInnerFromJSON: JobRelationshipsDataInnerFromJSON,
    JobRelationshipsDataInnerFromJSONTyped: JobRelationshipsDataInnerFromJSONTyped,
    JobRelationshipsDataInnerToJSON: JobRelationshipsDataInnerToJSON,
    JobRelationshipsDataInnerToJSONTyped: JobRelationshipsDataInnerToJSONTyped,
    JobRelationshipsFromJSON: JobRelationshipsFromJSON,
    JobRelationshipsFromJSONTyped: JobRelationshipsFromJSONTyped,
    JobRelationshipsToJSON: JobRelationshipsToJSON,
    JobRelationshipsToJSONTyped: JobRelationshipsToJSONTyped,
    JobResourceFromJSON: JobResourceFromJSON,
    JobResourceFromJSONTyped: JobResourceFromJSONTyped,
    JobResourceRelationshipsFromJSON: JobResourceRelationshipsFromJSON,
    JobResourceRelationshipsFromJSONTyped: JobResourceRelationshipsFromJSONTyped,
    JobResourceRelationshipsToJSON: JobResourceRelationshipsToJSON,
    JobResourceRelationshipsToJSONTyped: JobResourceRelationshipsToJSONTyped,
    JobResourceToJSON: JobResourceToJSON,
    JobResourceToJSONTyped: JobResourceToJSONTyped,
    JobResourceTypeEnum: JobResourceTypeEnum,
    LeaveBalanceFromJSON: LeaveBalanceFromJSON,
    LeaveBalanceFromJSONTyped: LeaveBalanceFromJSONTyped,
    LeaveBalanceToJSON: LeaveBalanceToJSON,
    LeaveBalanceToJSONTyped: LeaveBalanceToJSONTyped,
    LeaveBalanceUnitEnum: LeaveBalanceUnitEnum,
    LeaveEligibilityDetailEvaluationResultEnum: LeaveEligibilityDetailEvaluationResultEnum,
    LeaveEligibilityDetailFromJSON: LeaveEligibilityDetailFromJSON,
    LeaveEligibilityDetailFromJSONTyped: LeaveEligibilityDetailFromJSONTyped,
    LeaveEligibilityDetailToJSON: LeaveEligibilityDetailToJSON,
    LeaveEligibilityDetailToJSONTyped: LeaveEligibilityDetailToJSONTyped,
    LeaveEligibilityFromJSON: LeaveEligibilityFromJSON,
    LeaveEligibilityFromJSONTyped: LeaveEligibilityFromJSONTyped,
    LeaveEligibilityToJSON: LeaveEligibilityToJSON,
    LeaveEligibilityToJSONTyped: LeaveEligibilityToJSONTyped,
    LeaveEligibleOverrideDtlFromJSON: LeaveEligibleOverrideDtlFromJSON,
    LeaveEligibleOverrideDtlFromJSONTyped: LeaveEligibleOverrideDtlFromJSONTyped,
    LeaveEligibleOverrideDtlToJSON: LeaveEligibleOverrideDtlToJSON,
    LeaveEligibleOverrideDtlToJSONTyped: LeaveEligibleOverrideDtlToJSONTyped,
    LinksFromJSON: LinksFromJSON,
    LinksFromJSONTyped: LinksFromJSONTyped,
    LinksToJSON: LinksToJSON,
    LinksToJSONTyped: LinksToJSONTyped,
    ListBankMetadataResponseSchemaFromJSON: ListBankMetadataResponseSchemaFromJSON,
    ListBankMetadataResponseSchemaFromJSONTyped: ListBankMetadataResponseSchemaFromJSONTyped,
    ListBankMetadataResponseSchemaToJSON: ListBankMetadataResponseSchemaToJSON,
    ListBankMetadataResponseSchemaToJSONTyped: ListBankMetadataResponseSchemaToJSONTyped,
    ListBanksResponseIncludedItemFromJSON: ListBanksResponseIncludedItemFromJSON,
    ListBanksResponseIncludedItemFromJSONTyped: ListBanksResponseIncludedItemFromJSONTyped,
    ListBanksResponseIncludedItemToJSON: ListBanksResponseIncludedItemToJSON,
    ListBanksResponseIncludedItemToJSONTyped: ListBanksResponseIncludedItemToJSONTyped,
    ListBanksResponseSchemaFromJSON: ListBanksResponseSchemaFromJSON,
    ListBanksResponseSchemaFromJSONTyped: ListBanksResponseSchemaFromJSONTyped,
    ListBanksResponseSchemaToJSON: ListBanksResponseSchemaToJSON,
    ListBanksResponseSchemaToJSONTyped: ListBanksResponseSchemaToJSONTyped,
    ListBidPackagesResponseSchemaFromJSON: ListBidPackagesResponseSchemaFromJSON,
    ListBidPackagesResponseSchemaFromJSONTyped: ListBidPackagesResponseSchemaFromJSONTyped,
    ListBidPackagesResponseSchemaToJSON: ListBidPackagesResponseSchemaToJSON,
    ListBidPackagesResponseSchemaToJSONTyped: ListBidPackagesResponseSchemaToJSONTyped,
    ListDataElementsFilterParameterFromJSON: ListDataElementsFilterParameterFromJSON,
    ListDataElementsFilterParameterFromJSONTyped: ListDataElementsFilterParameterFromJSONTyped,
    ListDataElementsFilterParameterToJSON: ListDataElementsFilterParameterToJSON,
    ListDataElementsFilterParameterToJSONTyped: ListDataElementsFilterParameterToJSONTyped,
    ListDataElementsResponseSchemaFromJSON: ListDataElementsResponseSchemaFromJSON,
    ListDataElementsResponseSchemaFromJSONTyped: ListDataElementsResponseSchemaFromJSONTyped,
    ListDataElementsResponseSchemaToJSON: ListDataElementsResponseSchemaToJSON,
    ListDataElementsResponseSchemaToJSONTyped: ListDataElementsResponseSchemaToJSONTyped,
    ListShiftsResponseSchemaFromJSON: ListShiftsResponseSchemaFromJSON,
    ListShiftsResponseSchemaFromJSONTyped: ListShiftsResponseSchemaFromJSONTyped,
    ListShiftsResponseSchemaToJSON: ListShiftsResponseSchemaToJSON,
    ListShiftsResponseSchemaToJSONTyped: ListShiftsResponseSchemaToJSONTyped,
    MasterPolicyFromJSON: MasterPolicyFromJSON,
    MasterPolicyFromJSONTyped: MasterPolicyFromJSONTyped,
    MasterPolicyToJSON: MasterPolicyToJSON,
    MasterPolicyToJSONTyped: MasterPolicyToJSONTyped,
    MetaFromJSON: MetaFromJSON,
    MetaFromJSONTyped: MetaFromJSONTyped,
    MetaToJSON: MetaToJSON,
    MetaToJSONTyped: MetaToJSONTyped,
    ModelErrorFromJSON: ModelErrorFromJSON,
    ModelErrorFromJSONTyped: ModelErrorFromJSONTyped,
    ModelErrorToJSON: ModelErrorToJSON,
    ModelErrorToJSONTyped: ModelErrorToJSONTyped,
    ModuleErrorFromJSON: ModuleErrorFromJSON,
    ModuleErrorFromJSONTyped: ModuleErrorFromJSONTyped,
    ModuleErrorToJSON: ModuleErrorToJSON,
    ModuleErrorToJSONTyped: ModuleErrorToJSONTyped,
    ModuleFromJSON: ModuleFromJSON,
    ModuleFromJSONTyped: ModuleFromJSONTyped,
    ModuleToJSON: ModuleToJSON,
    ModuleToJSONTyped: ModuleToJSONTyped,
    NextQuestionOptionFromJSON: NextQuestionOptionFromJSON,
    NextQuestionOptionFromJSONTyped: NextQuestionOptionFromJSONTyped,
    NextQuestionOptionMatchingTypeEnum: NextQuestionOptionMatchingTypeEnum,
    NextQuestionOptionToJSON: NextQuestionOptionToJSON,
    NextQuestionOptionToJSONTyped: NextQuestionOptionToJSONTyped,
    NumberFormatOptionsFromJSON: NumberFormatOptionsFromJSON,
    NumberFormatOptionsFromJSONTyped: NumberFormatOptionsFromJSONTyped,
    NumberFormatOptionsStyleEnum: NumberFormatOptionsStyleEnum,
    NumberFormatOptionsToJSON: NumberFormatOptionsToJSON,
    NumberFormatOptionsToJSONTyped: NumberFormatOptionsToJSONTyped,
    OverlapRuleInfoFromJSON: OverlapRuleInfoFromJSON,
    OverlapRuleInfoFromJSONTyped: OverlapRuleInfoFromJSONTyped,
    OverlapRuleInfoToJSON: OverlapRuleInfoToJSON,
    OverlapRuleInfoToJSONTyped: OverlapRuleInfoToJSONTyped,
    OvertimeTypeRelationshipDataFromJSON: OvertimeTypeRelationshipDataFromJSON,
    OvertimeTypeRelationshipDataFromJSONTyped: OvertimeTypeRelationshipDataFromJSONTyped,
    OvertimeTypeRelationshipDataMetaFromJSON: OvertimeTypeRelationshipDataMetaFromJSON,
    OvertimeTypeRelationshipDataMetaFromJSONTyped: OvertimeTypeRelationshipDataMetaFromJSONTyped,
    OvertimeTypeRelationshipDataMetaLookupFromJSON: OvertimeTypeRelationshipDataMetaLookupFromJSON,
    OvertimeTypeRelationshipDataMetaLookupFromJSONTyped: OvertimeTypeRelationshipDataMetaLookupFromJSONTyped,
    OvertimeTypeRelationshipDataMetaLookupToJSON: OvertimeTypeRelationshipDataMetaLookupToJSON,
    OvertimeTypeRelationshipDataMetaLookupToJSONTyped: OvertimeTypeRelationshipDataMetaLookupToJSONTyped,
    OvertimeTypeRelationshipDataMetaToJSON: OvertimeTypeRelationshipDataMetaToJSON,
    OvertimeTypeRelationshipDataMetaToJSONTyped: OvertimeTypeRelationshipDataMetaToJSONTyped,
    OvertimeTypeRelationshipDataToJSON: OvertimeTypeRelationshipDataToJSON,
    OvertimeTypeRelationshipDataToJSONTyped: OvertimeTypeRelationshipDataToJSONTyped,
    OvertimeTypeRelationshipDataTypeEnum: OvertimeTypeRelationshipDataTypeEnum,
    OvertimeTypeRelationshipFromJSON: OvertimeTypeRelationshipFromJSON,
    OvertimeTypeRelationshipFromJSONTyped: OvertimeTypeRelationshipFromJSONTyped,
    OvertimeTypeRelationshipToJSON: OvertimeTypeRelationshipToJSON,
    OvertimeTypeRelationshipToJSONTyped: OvertimeTypeRelationshipToJSONTyped,
    PageDataFromJSON: PageDataFromJSON,
    PageDataFromJSONTyped: PageDataFromJSONTyped,
    PageDataToJSON: PageDataToJSON,
    PageDataToJSONTyped: PageDataToJSONTyped,
    PageMetadataFromJSON: PageMetadataFromJSON,
    PageMetadataFromJSONTyped: PageMetadataFromJSONTyped,
    PageMetadataToJSON: PageMetadataToJSON,
    PageMetadataToJSONTyped: PageMetadataToJSONTyped,
    PayCodeCardAttributesFromJSON: PayCodeCardAttributesFromJSON,
    PayCodeCardAttributesFromJSONTyped: PayCodeCardAttributesFromJSONTyped,
    PayCodeCardAttributesToJSON: PayCodeCardAttributesToJSON,
    PayCodeCardAttributesToJSONTyped: PayCodeCardAttributesToJSONTyped,
    PayCodeCardFromJSON: PayCodeCardFromJSON,
    PayCodeCardFromJSONTyped: PayCodeCardFromJSONTyped,
    PayCodeCardToJSON: PayCodeCardToJSON,
    PayCodeCardToJSONTyped: PayCodeCardToJSONTyped,
    PayCodeRelationshipDataFromJSON: PayCodeRelationshipDataFromJSON,
    PayCodeRelationshipDataFromJSONTyped: PayCodeRelationshipDataFromJSONTyped,
    PayCodeRelationshipDataToJSON: PayCodeRelationshipDataToJSON,
    PayCodeRelationshipDataToJSONTyped: PayCodeRelationshipDataToJSONTyped,
    PayCodeRelationshipFromJSON: PayCodeRelationshipFromJSON,
    PayCodeRelationshipFromJSONTyped: PayCodeRelationshipFromJSONTyped,
    PayCodeRelationshipToJSON: PayCodeRelationshipToJSON,
    PayCodeRelationshipToJSONTyped: PayCodeRelationshipToJSONTyped,
    PayCodeRelationshipsDataInnerFromJSON: PayCodeRelationshipsDataInnerFromJSON,
    PayCodeRelationshipsDataInnerFromJSONTyped: PayCodeRelationshipsDataInnerFromJSONTyped,
    PayCodeRelationshipsDataInnerToJSON: PayCodeRelationshipsDataInnerToJSON,
    PayCodeRelationshipsDataInnerToJSONTyped: PayCodeRelationshipsDataInnerToJSONTyped,
    PayCodeRelationshipsFromJSON: PayCodeRelationshipsFromJSON,
    PayCodeRelationshipsFromJSONTyped: PayCodeRelationshipsFromJSONTyped,
    PayCodeRelationshipsToJSON: PayCodeRelationshipsToJSON,
    PayCodeRelationshipsToJSONTyped: PayCodeRelationshipsToJSONTyped,
    PayRuleAttributesFromJSON: PayRuleAttributesFromJSON,
    PayRuleAttributesFromJSONTyped: PayRuleAttributesFromJSONTyped,
    PayRuleAttributesToJSON: PayRuleAttributesToJSON,
    PayRuleAttributesToJSONTyped: PayRuleAttributesToJSONTyped,
    PayRuleCollectionResponseSchemaFromJSON: PayRuleCollectionResponseSchemaFromJSON,
    PayRuleCollectionResponseSchemaFromJSONTyped: PayRuleCollectionResponseSchemaFromJSONTyped,
    PayRuleCollectionResponseSchemaToJSON: PayRuleCollectionResponseSchemaToJSON,
    PayRuleCollectionResponseSchemaToJSONTyped: PayRuleCollectionResponseSchemaToJSONTyped,
    PayRuleConstraintAttributesFromJSON: PayRuleConstraintAttributesFromJSON,
    PayRuleConstraintAttributesFromJSONTyped: PayRuleConstraintAttributesFromJSONTyped,
    PayRuleConstraintAttributesToJSON: PayRuleConstraintAttributesToJSON,
    PayRuleConstraintAttributesToJSONTyped: PayRuleConstraintAttributesToJSONTyped,
    PayRuleConstraintCollectionResponseSchemaFromJSON: PayRuleConstraintCollectionResponseSchemaFromJSON,
    PayRuleConstraintCollectionResponseSchemaFromJSONTyped: PayRuleConstraintCollectionResponseSchemaFromJSONTyped,
    PayRuleConstraintCollectionResponseSchemaToJSON: PayRuleConstraintCollectionResponseSchemaToJSON,
    PayRuleConstraintCollectionResponseSchemaToJSONTyped: PayRuleConstraintCollectionResponseSchemaToJSONTyped,
    PayRuleConstraintFromJSON: PayRuleConstraintFromJSON,
    PayRuleConstraintFromJSONTyped: PayRuleConstraintFromJSONTyped,
    PayRuleConstraintRelationshipsFromJSON: PayRuleConstraintRelationshipsFromJSON,
    PayRuleConstraintRelationshipsFromJSONTyped: PayRuleConstraintRelationshipsFromJSONTyped,
    PayRuleConstraintRelationshipsToJSON: PayRuleConstraintRelationshipsToJSON,
    PayRuleConstraintRelationshipsToJSONTyped: PayRuleConstraintRelationshipsToJSONTyped,
    PayRuleConstraintToJSON: PayRuleConstraintToJSON,
    PayRuleConstraintToJSONTyped: PayRuleConstraintToJSONTyped,
    PayRuleConstraintTypeEnum: PayRuleConstraintTypeEnum,
    PayRuleFromJSON: PayRuleFromJSON,
    PayRuleFromJSONTyped: PayRuleFromJSONTyped,
    PayRuleIncludedObjectAttributesFromJSON: PayRuleIncludedObjectAttributesFromJSON,
    PayRuleIncludedObjectAttributesFromJSONTyped: PayRuleIncludedObjectAttributesFromJSONTyped,
    PayRuleIncludedObjectAttributesToJSON: PayRuleIncludedObjectAttributesToJSON,
    PayRuleIncludedObjectAttributesToJSONTyped: PayRuleIncludedObjectAttributesToJSONTyped,
    PayRuleIncludedObjectFromJSON: PayRuleIncludedObjectFromJSON,
    PayRuleIncludedObjectFromJSONTyped: PayRuleIncludedObjectFromJSONTyped,
    PayRuleIncludedObjectToJSON: PayRuleIncludedObjectToJSON,
    PayRuleIncludedObjectToJSONTyped: PayRuleIncludedObjectToJSONTyped,
    PayRuleIncludedObjectTypeEnum: PayRuleIncludedObjectTypeEnum,
    PayRuleKeyValueRelationshipDataFromJSON: PayRuleKeyValueRelationshipDataFromJSON,
    PayRuleKeyValueRelationshipDataFromJSONTyped: PayRuleKeyValueRelationshipDataFromJSONTyped,
    PayRuleKeyValueRelationshipDataToJSON: PayRuleKeyValueRelationshipDataToJSON,
    PayRuleKeyValueRelationshipDataToJSONTyped: PayRuleKeyValueRelationshipDataToJSONTyped,
    PayRuleKeyValueRelationshipDataTypeEnum: PayRuleKeyValueRelationshipDataTypeEnum,
    PayRuleKeyValueRelationshipFromJSON: PayRuleKeyValueRelationshipFromJSON,
    PayRuleKeyValueRelationshipFromJSONTyped: PayRuleKeyValueRelationshipFromJSONTyped,
    PayRuleKeyValueRelationshipToJSON: PayRuleKeyValueRelationshipToJSON,
    PayRuleKeyValueRelationshipToJSONTyped: PayRuleKeyValueRelationshipToJSONTyped,
    PayRuleRelationshipsFromJSON: PayRuleRelationshipsFromJSON,
    PayRuleRelationshipsFromJSONTyped: PayRuleRelationshipsFromJSONTyped,
    PayRuleRelationshipsToJSON: PayRuleRelationshipsToJSON,
    PayRuleRelationshipsToJSONTyped: PayRuleRelationshipsToJSONTyped,
    PayRuleToJSON: PayRuleToJSON,
    PayRuleToJSONTyped: PayRuleToJSONTyped,
    PayRuleTypeEnum: PayRuleTypeEnum,
    PoliciesResponseSchemaFromJSON: PoliciesResponseSchemaFromJSON,
    PoliciesResponseSchemaFromJSONTyped: PoliciesResponseSchemaFromJSONTyped,
    PoliciesResponseSchemaToJSON: PoliciesResponseSchemaToJSON,
    PoliciesResponseSchemaToJSONTyped: PoliciesResponseSchemaToJSONTyped,
    PolicyAttributesFromJSON: PolicyAttributesFromJSON,
    PolicyAttributesFromJSONTyped: PolicyAttributesFromJSONTyped,
    PolicyAttributesToJSON: PolicyAttributesToJSON,
    PolicyAttributesToJSONTyped: PolicyAttributesToJSONTyped,
    PolicyFromJSON: PolicyFromJSON,
    PolicyFromJSONTyped: PolicyFromJSONTyped,
    PolicySetDetailRecordFromJSON: PolicySetDetailRecordFromJSON,
    PolicySetDetailRecordFromJSONTyped: PolicySetDetailRecordFromJSONTyped,
    PolicySetDetailRecordToJSON: PolicySetDetailRecordToJSON,
    PolicySetDetailRecordToJSONTyped: PolicySetDetailRecordToJSONTyped,
    PolicySetDetailsAttributesFromJSON: PolicySetDetailsAttributesFromJSON,
    PolicySetDetailsAttributesFromJSONTyped: PolicySetDetailsAttributesFromJSONTyped,
    PolicySetDetailsAttributesToJSON: PolicySetDetailsAttributesToJSON,
    PolicySetDetailsAttributesToJSONTyped: PolicySetDetailsAttributesToJSONTyped,
    PolicySetDetailsFromJSON: PolicySetDetailsFromJSON,
    PolicySetDetailsFromJSONTyped: PolicySetDetailsFromJSONTyped,
    PolicySetDetailsResponseSchemaFromJSON: PolicySetDetailsResponseSchemaFromJSON,
    PolicySetDetailsResponseSchemaFromJSONTyped: PolicySetDetailsResponseSchemaFromJSONTyped,
    PolicySetDetailsResponseSchemaToJSON: PolicySetDetailsResponseSchemaToJSON,
    PolicySetDetailsResponseSchemaToJSONTyped: PolicySetDetailsResponseSchemaToJSONTyped,
    PolicySetDetailsToJSON: PolicySetDetailsToJSON,
    PolicySetDetailsToJSONTyped: PolicySetDetailsToJSONTyped,
    PolicyToJSON: PolicyToJSON,
    PolicyToJSONTyped: PolicyToJSONTyped,
    PolicyTypeAttributesFromJSON: PolicyTypeAttributesFromJSON,
    PolicyTypeAttributesFromJSONTyped: PolicyTypeAttributesFromJSONTyped,
    PolicyTypeAttributesTableTypeEnum: PolicyTypeAttributesTableTypeEnum,
    PolicyTypeAttributesToJSON: PolicyTypeAttributesToJSON,
    PolicyTypeAttributesToJSONTyped: PolicyTypeAttributesToJSONTyped,
    PolicyTypeFromJSON: PolicyTypeFromJSON,
    PolicyTypeFromJSONTyped: PolicyTypeFromJSONTyped,
    PolicyTypeToJSON: PolicyTypeToJSON,
    PolicyTypeToJSONTyped: PolicyTypeToJSONTyped,
    PolicyTypesResponseSchemaFromJSON: PolicyTypesResponseSchemaFromJSON,
    PolicyTypesResponseSchemaFromJSONTyped: PolicyTypesResponseSchemaFromJSONTyped,
    PolicyTypesResponseSchemaToJSON: PolicyTypesResponseSchemaToJSON,
    PolicyTypesResponseSchemaToJSONTyped: PolicyTypesResponseSchemaToJSONTyped,
    PostBankProjectionIncludedItemFromJSON: PostBankProjectionIncludedItemFromJSON,
    PostBankProjectionIncludedItemFromJSONTyped: PostBankProjectionIncludedItemFromJSONTyped,
    PostBankProjectionIncludedItemToJSON: PostBankProjectionIncludedItemToJSON,
    PostBankProjectionIncludedItemToJSONTyped: PostBankProjectionIncludedItemToJSONTyped,
    PostBankProjectionResponseSchemaFromJSON: PostBankProjectionResponseSchemaFromJSON,
    PostBankProjectionResponseSchemaFromJSONTyped: PostBankProjectionResponseSchemaFromJSONTyped,
    PostBankProjectionResponseSchemaToJSON: PostBankProjectionResponseSchemaToJSON,
    PostBankProjectionResponseSchemaToJSONTyped: PostBankProjectionResponseSchemaToJSONTyped,
    PostTimesheetEntryIncludeItem: PostTimesheetEntryIncludeItem,
    PostTimesheetEntryIncludeItemFromJSON: PostTimesheetEntryIncludeItemFromJSON,
    PostTimesheetEntryIncludeItemFromJSONTyped: PostTimesheetEntryIncludeItemFromJSONTyped,
    PostTimesheetEntryIncludeItemToJSON: PostTimesheetEntryIncludeItemToJSON,
    PostTimesheetEntryIncludeItemToJSONTyped: PostTimesheetEntryIncludeItemToJSONTyped,
    PostTimesheetEntryResponseSchemaDataAttributesFromJSON: PostTimesheetEntryResponseSchemaDataAttributesFromJSON,
    PostTimesheetEntryResponseSchemaDataAttributesFromJSONTyped: PostTimesheetEntryResponseSchemaDataAttributesFromJSONTyped,
    PostTimesheetEntryResponseSchemaDataAttributesToJSON: PostTimesheetEntryResponseSchemaDataAttributesToJSON,
    PostTimesheetEntryResponseSchemaDataAttributesToJSONTyped: PostTimesheetEntryResponseSchemaDataAttributesToJSONTyped,
    PostTimesheetEntryResponseSchemaDataFromJSON: PostTimesheetEntryResponseSchemaDataFromJSON,
    PostTimesheetEntryResponseSchemaDataFromJSONTyped: PostTimesheetEntryResponseSchemaDataFromJSONTyped,
    PostTimesheetEntryResponseSchemaDataRelationshipsFromJSON: PostTimesheetEntryResponseSchemaDataRelationshipsFromJSON,
    PostTimesheetEntryResponseSchemaDataRelationshipsFromJSONTyped: PostTimesheetEntryResponseSchemaDataRelationshipsFromJSONTyped,
    PostTimesheetEntryResponseSchemaDataRelationshipsToJSON: PostTimesheetEntryResponseSchemaDataRelationshipsToJSON,
    PostTimesheetEntryResponseSchemaDataRelationshipsToJSONTyped: PostTimesheetEntryResponseSchemaDataRelationshipsToJSONTyped,
    PostTimesheetEntryResponseSchemaDataToJSON: PostTimesheetEntryResponseSchemaDataToJSON,
    PostTimesheetEntryResponseSchemaDataToJSONTyped: PostTimesheetEntryResponseSchemaDataToJSONTyped,
    PostTimesheetEntryResponseSchemaFromJSON: PostTimesheetEntryResponseSchemaFromJSON,
    PostTimesheetEntryResponseSchemaFromJSONTyped: PostTimesheetEntryResponseSchemaFromJSONTyped,
    PostTimesheetEntryResponseSchemaIncludedInnerFromJSON: PostTimesheetEntryResponseSchemaIncludedInnerFromJSON,
    PostTimesheetEntryResponseSchemaIncludedInnerFromJSONTyped: PostTimesheetEntryResponseSchemaIncludedInnerFromJSONTyped,
    PostTimesheetEntryResponseSchemaIncludedInnerToJSON: PostTimesheetEntryResponseSchemaIncludedInnerToJSON,
    PostTimesheetEntryResponseSchemaIncludedInnerToJSONTyped: PostTimesheetEntryResponseSchemaIncludedInnerToJSONTyped,
    PostTimesheetEntryResponseSchemaToJSON: PostTimesheetEntryResponseSchemaToJSON,
    PostTimesheetEntryResponseSchemaToJSONTyped: PostTimesheetEntryResponseSchemaToJSONTyped,
    ProjectionBalanceAttributesFromJSON: ProjectionBalanceAttributesFromJSON,
    ProjectionBalanceAttributesFromJSONTyped: ProjectionBalanceAttributesFromJSONTyped,
    ProjectionBalanceAttributesToJSON: ProjectionBalanceAttributesToJSON,
    ProjectionBalanceAttributesToJSONTyped: ProjectionBalanceAttributesToJSONTyped,
    ProjectionBalanceFromJSON: ProjectionBalanceFromJSON,
    ProjectionBalanceFromJSONTyped: ProjectionBalanceFromJSONTyped,
    ProjectionBalanceRelationshipsFromJSON: ProjectionBalanceRelationshipsFromJSON,
    ProjectionBalanceRelationshipsFromJSONTyped: ProjectionBalanceRelationshipsFromJSONTyped,
    ProjectionBalanceRelationshipsToJSON: ProjectionBalanceRelationshipsToJSON,
    ProjectionBalanceRelationshipsToJSONTyped: ProjectionBalanceRelationshipsToJSONTyped,
    ProjectionBalanceToJSON: ProjectionBalanceToJSON,
    ProjectionBalanceToJSONTyped: ProjectionBalanceToJSONTyped,
    ProjectionEntryFromJSON: ProjectionEntryFromJSON,
    ProjectionEntryFromJSONTyped: ProjectionEntryFromJSONTyped,
    ProjectionEntryRelationshipsContentFromJSON: ProjectionEntryRelationshipsContentFromJSON,
    ProjectionEntryRelationshipsContentFromJSONTyped: ProjectionEntryRelationshipsContentFromJSONTyped,
    ProjectionEntryRelationshipsContentToJSON: ProjectionEntryRelationshipsContentToJSON,
    ProjectionEntryRelationshipsContentToJSONTyped: ProjectionEntryRelationshipsContentToJSONTyped,
    ProjectionEntryRelationshipsContentTypeEnum: ProjectionEntryRelationshipsContentTypeEnum,
    ProjectionEntryRelationshipsFromJSON: ProjectionEntryRelationshipsFromJSON,
    ProjectionEntryRelationshipsFromJSONTyped: ProjectionEntryRelationshipsFromJSONTyped,
    ProjectionEntryRelationshipsToJSON: ProjectionEntryRelationshipsToJSON,
    ProjectionEntryRelationshipsToJSONTyped: ProjectionEntryRelationshipsToJSONTyped,
    ProjectionEntryToJSON: ProjectionEntryToJSON,
    ProjectionEntryToJSONTyped: ProjectionEntryToJSONTyped,
    ProjectionGapAttributesCategoryEnum: ProjectionGapAttributesCategoryEnum,
    ProjectionGapAttributesFromJSON: ProjectionGapAttributesFromJSON,
    ProjectionGapAttributesFromJSONTyped: ProjectionGapAttributesFromJSONTyped,
    ProjectionGapAttributesToJSON: ProjectionGapAttributesToJSON,
    ProjectionGapAttributesToJSONTyped: ProjectionGapAttributesToJSONTyped,
    ProjectionGapFromJSON: ProjectionGapFromJSON,
    ProjectionGapFromJSONTyped: ProjectionGapFromJSONTyped,
    ProjectionGapRelationshipsFromJSON: ProjectionGapRelationshipsFromJSON,
    ProjectionGapRelationshipsFromJSONTyped: ProjectionGapRelationshipsFromJSONTyped,
    ProjectionGapRelationshipsToJSON: ProjectionGapRelationshipsToJSON,
    ProjectionGapRelationshipsToJSONTyped: ProjectionGapRelationshipsToJSONTyped,
    ProjectionGapToJSON: ProjectionGapToJSON,
    ProjectionGapToJSONTyped: ProjectionGapToJSONTyped,
    ProjectionIncludeItem: ProjectionIncludeItem,
    ProjectionIncludeItemFromJSON: ProjectionIncludeItemFromJSON,
    ProjectionIncludeItemFromJSONTyped: ProjectionIncludeItemFromJSONTyped,
    ProjectionIncludeItemToJSON: ProjectionIncludeItemToJSON,
    ProjectionIncludeItemToJSONTyped: ProjectionIncludeItemToJSONTyped,
    ProjectionOverridesFromJSON: ProjectionOverridesFromJSON,
    ProjectionOverridesFromJSONTyped: ProjectionOverridesFromJSONTyped,
    ProjectionOverridesToJSON: ProjectionOverridesToJSON,
    ProjectionOverridesToJSONTyped: ProjectionOverridesToJSONTyped,
    ProjectionScopeFromJSON: ProjectionScopeFromJSON,
    ProjectionScopeFromJSONTyped: ProjectionScopeFromJSONTyped,
    ProjectionScopeToJSON: ProjectionScopeToJSON,
    ProjectionScopeToJSONTyped: ProjectionScopeToJSONTyped,
    QuestionTreeNodesReducedAttributesFromJSON: QuestionTreeNodesReducedAttributesFromJSON,
    QuestionTreeNodesReducedAttributesFromJSONTyped: QuestionTreeNodesReducedAttributesFromJSONTyped,
    QuestionTreeNodesReducedAttributesToJSON: QuestionTreeNodesReducedAttributesToJSON,
    QuestionTreeNodesReducedAttributesToJSONTyped: QuestionTreeNodesReducedAttributesToJSONTyped,
    QuestionTreeNodesReducedFromJSON: QuestionTreeNodesReducedFromJSON,
    QuestionTreeNodesReducedFromJSONTyped: QuestionTreeNodesReducedFromJSONTyped,
    QuestionTreeNodesReducedToJSON: QuestionTreeNodesReducedToJSON,
    QuestionTreeNodesReducedToJSONTyped: QuestionTreeNodesReducedToJSONTyped,
    QuestionTreeNodesRelationshipDataInnerFromJSON: QuestionTreeNodesRelationshipDataInnerFromJSON,
    QuestionTreeNodesRelationshipDataInnerFromJSONTyped: QuestionTreeNodesRelationshipDataInnerFromJSONTyped,
    QuestionTreeNodesRelationshipDataInnerToJSON: QuestionTreeNodesRelationshipDataInnerToJSON,
    QuestionTreeNodesRelationshipDataInnerToJSONTyped: QuestionTreeNodesRelationshipDataInnerToJSONTyped,
    QuestionTreeNodesRelationshipFromJSON: QuestionTreeNodesRelationshipFromJSON,
    QuestionTreeNodesRelationshipFromJSONTyped: QuestionTreeNodesRelationshipFromJSONTyped,
    QuestionTreeNodesRelationshipToJSON: QuestionTreeNodesRelationshipToJSON,
    QuestionTreeNodesRelationshipToJSONTyped: QuestionTreeNodesRelationshipToJSONTyped,
    RankingMethodsFromJSON: RankingMethodsFromJSON,
    RankingMethodsFromJSONTyped: RankingMethodsFromJSONTyped,
    RankingMethodsToJSON: RankingMethodsToJSON,
    RankingMethodsToJSONTyped: RankingMethodsToJSONTyped,
    ReasonCodeRelationshipDataFromJSON: ReasonCodeRelationshipDataFromJSON,
    ReasonCodeRelationshipDataFromJSONTyped: ReasonCodeRelationshipDataFromJSONTyped,
    ReasonCodeRelationshipDataMetaFromJSON: ReasonCodeRelationshipDataMetaFromJSON,
    ReasonCodeRelationshipDataMetaFromJSONTyped: ReasonCodeRelationshipDataMetaFromJSONTyped,
    ReasonCodeRelationshipDataMetaLookupFromJSON: ReasonCodeRelationshipDataMetaLookupFromJSON,
    ReasonCodeRelationshipDataMetaLookupFromJSONTyped: ReasonCodeRelationshipDataMetaLookupFromJSONTyped,
    ReasonCodeRelationshipDataMetaLookupToJSON: ReasonCodeRelationshipDataMetaLookupToJSON,
    ReasonCodeRelationshipDataMetaLookupToJSONTyped: ReasonCodeRelationshipDataMetaLookupToJSONTyped,
    ReasonCodeRelationshipDataMetaToJSON: ReasonCodeRelationshipDataMetaToJSON,
    ReasonCodeRelationshipDataMetaToJSONTyped: ReasonCodeRelationshipDataMetaToJSONTyped,
    ReasonCodeRelationshipDataToJSON: ReasonCodeRelationshipDataToJSON,
    ReasonCodeRelationshipDataToJSONTyped: ReasonCodeRelationshipDataToJSONTyped,
    ReasonCodeRelationshipDataTypeEnum: ReasonCodeRelationshipDataTypeEnum,
    ReasonCodeRelationshipFromJSON: ReasonCodeRelationshipFromJSON,
    ReasonCodeRelationshipFromJSONTyped: ReasonCodeRelationshipFromJSONTyped,
    ReasonCodeRelationshipToJSON: ReasonCodeRelationshipToJSON,
    ReasonCodeRelationshipToJSONTyped: ReasonCodeRelationshipToJSONTyped,
    RequestType: RequestType,
    RequestTypeFromJSON: RequestTypeFromJSON,
    RequestTypeFromJSONTyped: RequestTypeFromJSONTyped,
    RequestTypeToJSON: RequestTypeToJSON,
    RequestTypeToJSONTyped: RequestTypeToJSONTyped,
    RoleRelationshipDataFromJSON: RoleRelationshipDataFromJSON,
    RoleRelationshipDataFromJSONTyped: RoleRelationshipDataFromJSONTyped,
    RoleRelationshipDataMetaFromJSON: RoleRelationshipDataMetaFromJSON,
    RoleRelationshipDataMetaFromJSONTyped: RoleRelationshipDataMetaFromJSONTyped,
    RoleRelationshipDataMetaLookupFromJSON: RoleRelationshipDataMetaLookupFromJSON,
    RoleRelationshipDataMetaLookupFromJSONTyped: RoleRelationshipDataMetaLookupFromJSONTyped,
    RoleRelationshipDataMetaLookupToJSON: RoleRelationshipDataMetaLookupToJSON,
    RoleRelationshipDataMetaLookupToJSONTyped: RoleRelationshipDataMetaLookupToJSONTyped,
    RoleRelationshipDataMetaToJSON: RoleRelationshipDataMetaToJSON,
    RoleRelationshipDataMetaToJSONTyped: RoleRelationshipDataMetaToJSONTyped,
    RoleRelationshipDataToJSON: RoleRelationshipDataToJSON,
    RoleRelationshipDataToJSONTyped: RoleRelationshipDataToJSONTyped,
    RoleRelationshipDataTypeEnum: RoleRelationshipDataTypeEnum,
    RoleRelationshipFromJSON: RoleRelationshipFromJSON,
    RoleRelationshipFromJSONTyped: RoleRelationshipFromJSONTyped,
    RoleRelationshipToJSON: RoleRelationshipToJSON,
    RoleRelationshipToJSONTyped: RoleRelationshipToJSONTyped,
    RollbackAbsenceCaseHistoryEventRequestDataAttributesFromJSON: RollbackAbsenceCaseHistoryEventRequestDataAttributesFromJSON,
    RollbackAbsenceCaseHistoryEventRequestDataAttributesFromJSONTyped: RollbackAbsenceCaseHistoryEventRequestDataAttributesFromJSONTyped,
    RollbackAbsenceCaseHistoryEventRequestDataAttributesToJSON: RollbackAbsenceCaseHistoryEventRequestDataAttributesToJSON,
    RollbackAbsenceCaseHistoryEventRequestDataAttributesToJSONTyped: RollbackAbsenceCaseHistoryEventRequestDataAttributesToJSONTyped,
    RollbackAbsenceCaseHistoryEventRequestDataFromJSON: RollbackAbsenceCaseHistoryEventRequestDataFromJSON,
    RollbackAbsenceCaseHistoryEventRequestDataFromJSONTyped: RollbackAbsenceCaseHistoryEventRequestDataFromJSONTyped,
    RollbackAbsenceCaseHistoryEventRequestDataRelationshipsFromJSON: RollbackAbsenceCaseHistoryEventRequestDataRelationshipsFromJSON,
    RollbackAbsenceCaseHistoryEventRequestDataRelationshipsFromJSONTyped: RollbackAbsenceCaseHistoryEventRequestDataRelationshipsFromJSONTyped,
    RollbackAbsenceCaseHistoryEventRequestDataRelationshipsToJSON: RollbackAbsenceCaseHistoryEventRequestDataRelationshipsToJSON,
    RollbackAbsenceCaseHistoryEventRequestDataRelationshipsToJSONTyped: RollbackAbsenceCaseHistoryEventRequestDataRelationshipsToJSONTyped,
    RollbackAbsenceCaseHistoryEventRequestDataToJSON: RollbackAbsenceCaseHistoryEventRequestDataToJSON,
    RollbackAbsenceCaseHistoryEventRequestDataToJSONTyped: RollbackAbsenceCaseHistoryEventRequestDataToJSONTyped,
    RollbackAbsenceCaseHistoryEventRequestDataTypeEnum: RollbackAbsenceCaseHistoryEventRequestDataTypeEnum,
    RollbackAbsenceCaseHistoryEventRequestFromJSON: RollbackAbsenceCaseHistoryEventRequestFromJSON,
    RollbackAbsenceCaseHistoryEventRequestFromJSONTyped: RollbackAbsenceCaseHistoryEventRequestFromJSONTyped,
    RollbackAbsenceCaseHistoryEventRequestToJSON: RollbackAbsenceCaseHistoryEventRequestToJSON,
    RollbackAbsenceCaseHistoryEventRequestToJSONTyped: RollbackAbsenceCaseHistoryEventRequestToJSONTyped,
    RollbackAbsenceCaseHistoryEventResponseDataAttributesFromJSON: RollbackAbsenceCaseHistoryEventResponseDataAttributesFromJSON,
    RollbackAbsenceCaseHistoryEventResponseDataAttributesFromJSONTyped: RollbackAbsenceCaseHistoryEventResponseDataAttributesFromJSONTyped,
    RollbackAbsenceCaseHistoryEventResponseDataAttributesToJSON: RollbackAbsenceCaseHistoryEventResponseDataAttributesToJSON,
    RollbackAbsenceCaseHistoryEventResponseDataAttributesToJSONTyped: RollbackAbsenceCaseHistoryEventResponseDataAttributesToJSONTyped,
    RollbackAbsenceCaseHistoryEventResponseDataFromJSON: RollbackAbsenceCaseHistoryEventResponseDataFromJSON,
    RollbackAbsenceCaseHistoryEventResponseDataFromJSONTyped: RollbackAbsenceCaseHistoryEventResponseDataFromJSONTyped,
    RollbackAbsenceCaseHistoryEventResponseDataRelationshipsFromJSON: RollbackAbsenceCaseHistoryEventResponseDataRelationshipsFromJSON,
    RollbackAbsenceCaseHistoryEventResponseDataRelationshipsFromJSONTyped: RollbackAbsenceCaseHistoryEventResponseDataRelationshipsFromJSONTyped,
    RollbackAbsenceCaseHistoryEventResponseDataRelationshipsToJSON: RollbackAbsenceCaseHistoryEventResponseDataRelationshipsToJSON,
    RollbackAbsenceCaseHistoryEventResponseDataRelationshipsToJSONTyped: RollbackAbsenceCaseHistoryEventResponseDataRelationshipsToJSONTyped,
    RollbackAbsenceCaseHistoryEventResponseDataToJSON: RollbackAbsenceCaseHistoryEventResponseDataToJSON,
    RollbackAbsenceCaseHistoryEventResponseDataToJSONTyped: RollbackAbsenceCaseHistoryEventResponseDataToJSONTyped,
    RollbackAbsenceCaseHistoryEventResponseDataTypeEnum: RollbackAbsenceCaseHistoryEventResponseDataTypeEnum,
    RollbackAbsenceCaseHistoryEventResponseFromJSON: RollbackAbsenceCaseHistoryEventResponseFromJSON,
    RollbackAbsenceCaseHistoryEventResponseFromJSONTyped: RollbackAbsenceCaseHistoryEventResponseFromJSONTyped,
    RollbackAbsenceCaseHistoryEventResponseIncludedInnerFromJSON: RollbackAbsenceCaseHistoryEventResponseIncludedInnerFromJSON,
    RollbackAbsenceCaseHistoryEventResponseIncludedInnerFromJSONTyped: RollbackAbsenceCaseHistoryEventResponseIncludedInnerFromJSONTyped,
    RollbackAbsenceCaseHistoryEventResponseIncludedInnerToJSON: RollbackAbsenceCaseHistoryEventResponseIncludedInnerToJSON,
    RollbackAbsenceCaseHistoryEventResponseIncludedInnerToJSONTyped: RollbackAbsenceCaseHistoryEventResponseIncludedInnerToJSONTyped,
    RollbackAbsenceCaseHistoryEventResponseToJSON: RollbackAbsenceCaseHistoryEventResponseToJSON,
    RollbackAbsenceCaseHistoryEventResponseToJSONTyped: RollbackAbsenceCaseHistoryEventResponseToJSONTyped,
    SaveShiftRequestMetaSchemaFromJSON: SaveShiftRequestMetaSchemaFromJSON,
    SaveShiftRequestMetaSchemaFromJSONTyped: SaveShiftRequestMetaSchemaFromJSONTyped,
    SaveShiftRequestMetaSchemaToJSON: SaveShiftRequestMetaSchemaToJSON,
    SaveShiftRequestMetaSchemaToJSONTyped: SaveShiftRequestMetaSchemaToJSONTyped,
    SelectedOverrideChoice: SelectedOverrideChoice,
    SelectedOverrideChoiceFromJSON: SelectedOverrideChoiceFromJSON,
    SelectedOverrideChoiceFromJSONTyped: SelectedOverrideChoiceFromJSONTyped,
    SelectedOverrideChoiceToJSON: SelectedOverrideChoiceToJSON,
    SelectedOverrideChoiceToJSONTyped: SelectedOverrideChoiceToJSONTyped,
    SelectionConstraintRelationshipDataFromJSON: SelectionConstraintRelationshipDataFromJSON,
    SelectionConstraintRelationshipDataFromJSONTyped: SelectionConstraintRelationshipDataFromJSONTyped,
    SelectionConstraintRelationshipDataMetaFromJSON: SelectionConstraintRelationshipDataMetaFromJSON,
    SelectionConstraintRelationshipDataMetaFromJSONTyped: SelectionConstraintRelationshipDataMetaFromJSONTyped,
    SelectionConstraintRelationshipDataMetaLookupFromJSON: SelectionConstraintRelationshipDataMetaLookupFromJSON,
    SelectionConstraintRelationshipDataMetaLookupFromJSONTyped: SelectionConstraintRelationshipDataMetaLookupFromJSONTyped,
    SelectionConstraintRelationshipDataMetaLookupToJSON: SelectionConstraintRelationshipDataMetaLookupToJSON,
    SelectionConstraintRelationshipDataMetaLookupToJSONTyped: SelectionConstraintRelationshipDataMetaLookupToJSONTyped,
    SelectionConstraintRelationshipDataMetaToJSON: SelectionConstraintRelationshipDataMetaToJSON,
    SelectionConstraintRelationshipDataMetaToJSONTyped: SelectionConstraintRelationshipDataMetaToJSONTyped,
    SelectionConstraintRelationshipDataToJSON: SelectionConstraintRelationshipDataToJSON,
    SelectionConstraintRelationshipDataToJSONTyped: SelectionConstraintRelationshipDataToJSONTyped,
    SelectionConstraintRelationshipDataTypeEnum: SelectionConstraintRelationshipDataTypeEnum,
    SelectionConstraintRelationshipFromJSON: SelectionConstraintRelationshipFromJSON,
    SelectionConstraintRelationshipFromJSONTyped: SelectionConstraintRelationshipFromJSONTyped,
    SelectionConstraintRelationshipToJSON: SelectionConstraintRelationshipToJSON,
    SelectionConstraintRelationshipToJSONTyped: SelectionConstraintRelationshipToJSONTyped,
    Severity: Severity,
    SeverityFromJSON: SeverityFromJSON,
    SeverityFromJSONTyped: SeverityFromJSONTyped,
    SeverityToJSON: SeverityToJSON,
    SeverityToJSONTyped: SeverityToJSONTyped,
    ShiftEmployeeRelationshipDataFromJSON: ShiftEmployeeRelationshipDataFromJSON,
    ShiftEmployeeRelationshipDataFromJSONTyped: ShiftEmployeeRelationshipDataFromJSONTyped,
    ShiftEmployeeRelationshipDataMetaFromJSON: ShiftEmployeeRelationshipDataMetaFromJSON,
    ShiftEmployeeRelationshipDataMetaFromJSONTyped: ShiftEmployeeRelationshipDataMetaFromJSONTyped,
    ShiftEmployeeRelationshipDataMetaLookupFromJSON: ShiftEmployeeRelationshipDataMetaLookupFromJSON,
    ShiftEmployeeRelationshipDataMetaLookupFromJSONTyped: ShiftEmployeeRelationshipDataMetaLookupFromJSONTyped,
    ShiftEmployeeRelationshipDataMetaLookupToJSON: ShiftEmployeeRelationshipDataMetaLookupToJSON,
    ShiftEmployeeRelationshipDataMetaLookupToJSONTyped: ShiftEmployeeRelationshipDataMetaLookupToJSONTyped,
    ShiftEmployeeRelationshipDataMetaToJSON: ShiftEmployeeRelationshipDataMetaToJSON,
    ShiftEmployeeRelationshipDataMetaToJSONTyped: ShiftEmployeeRelationshipDataMetaToJSONTyped,
    ShiftEmployeeRelationshipDataToJSON: ShiftEmployeeRelationshipDataToJSON,
    ShiftEmployeeRelationshipDataToJSONTyped: ShiftEmployeeRelationshipDataToJSONTyped,
    ShiftEmployeeRelationshipDataTypeEnum: ShiftEmployeeRelationshipDataTypeEnum,
    ShiftEmployeeRelationshipFromJSON: ShiftEmployeeRelationshipFromJSON,
    ShiftEmployeeRelationshipFromJSONTyped: ShiftEmployeeRelationshipFromJSONTyped,
    ShiftEmployeeRelationshipToJSON: ShiftEmployeeRelationshipToJSON,
    ShiftEmployeeRelationshipToJSONTyped: ShiftEmployeeRelationshipToJSONTyped,
    ShiftEventRelationshipDataFromJSON: ShiftEventRelationshipDataFromJSON,
    ShiftEventRelationshipDataFromJSONTyped: ShiftEventRelationshipDataFromJSONTyped,
    ShiftEventRelationshipDataToJSON: ShiftEventRelationshipDataToJSON,
    ShiftEventRelationshipDataToJSONTyped: ShiftEventRelationshipDataToJSONTyped,
    ShiftEventRelationshipDataTypeEnum: ShiftEventRelationshipDataTypeEnum,
    ShiftEventRelationshipFromJSON: ShiftEventRelationshipFromJSON,
    ShiftEventRelationshipFromJSONTyped: ShiftEventRelationshipFromJSONTyped,
    ShiftEventRelationshipToJSON: ShiftEventRelationshipToJSON,
    ShiftEventRelationshipToJSONTyped: ShiftEventRelationshipToJSONTyped,
    ShiftIncludedObjectFromJSON: ShiftIncludedObjectFromJSON,
    ShiftIncludedObjectFromJSONTyped: ShiftIncludedObjectFromJSONTyped,
    ShiftIncludedObjectToJSON: ShiftIncludedObjectToJSON,
    ShiftIncludedObjectToJSONTyped: ShiftIncludedObjectToJSONTyped,
    SinglePayRuleResponseSchemaFromJSON: SinglePayRuleResponseSchemaFromJSON,
    SinglePayRuleResponseSchemaFromJSONTyped: SinglePayRuleResponseSchemaFromJSONTyped,
    SinglePayRuleResponseSchemaToJSON: SinglePayRuleResponseSchemaToJSON,
    SinglePayRuleResponseSchemaToJSONTyped: SinglePayRuleResponseSchemaToJSONTyped,
    SingleShiftAttributesFromJSON: SingleShiftAttributesFromJSON,
    SingleShiftAttributesFromJSONTyped: SingleShiftAttributesFromJSONTyped,
    SingleShiftAttributesStatusEnum: SingleShiftAttributesStatusEnum,
    SingleShiftAttributesToJSON: SingleShiftAttributesToJSON,
    SingleShiftAttributesToJSONTyped: SingleShiftAttributesToJSONTyped,
    SingleShiftBreakFromJSON: SingleShiftBreakFromJSON,
    SingleShiftBreakFromJSONTyped: SingleShiftBreakFromJSONTyped,
    SingleShiftBreakToJSON: SingleShiftBreakToJSON,
    SingleShiftBreakToJSONTyped: SingleShiftBreakToJSONTyped,
    SingleShiftFromJSON: SingleShiftFromJSON,
    SingleShiftFromJSONTyped: SingleShiftFromJSONTyped,
    SingleShiftRelationshipsFromJSON: SingleShiftRelationshipsFromJSON,
    SingleShiftRelationshipsFromJSONTyped: SingleShiftRelationshipsFromJSONTyped,
    SingleShiftRelationshipsToJSON: SingleShiftRelationshipsToJSON,
    SingleShiftRelationshipsToJSONTyped: SingleShiftRelationshipsToJSONTyped,
    SingleShiftResponseSchemaFromJSON: SingleShiftResponseSchemaFromJSON,
    SingleShiftResponseSchemaFromJSONTyped: SingleShiftResponseSchemaFromJSONTyped,
    SingleShiftResponseSchemaToJSON: SingleShiftResponseSchemaToJSON,
    SingleShiftResponseSchemaToJSONTyped: SingleShiftResponseSchemaToJSONTyped,
    SingleShiftToJSON: SingleShiftToJSON,
    SingleShiftToJSONTyped: SingleShiftToJSONTyped,
    SingleShiftTypeEnum: SingleShiftTypeEnum,
    Status: Status,
    StatusFromJSON: StatusFromJSON,
    StatusFromJSONTyped: StatusFromJSONTyped,
    StatusToJSON: StatusToJSON,
    StatusToJSONTyped: StatusToJSONTyped,
    SubmitTimeOffRequestBodyFromJSON: SubmitTimeOffRequestBodyFromJSON,
    SubmitTimeOffRequestBodyFromJSONTyped: SubmitTimeOffRequestBodyFromJSONTyped,
    SubmitTimeOffRequestBodyToJSON: SubmitTimeOffRequestBodyToJSON,
    SubmitTimeOffRequestBodyToJSONTyped: SubmitTimeOffRequestBodyToJSONTyped,
    SubmitTimeOffRequestDataFromJSON: SubmitTimeOffRequestDataFromJSON,
    SubmitTimeOffRequestDataFromJSONTyped: SubmitTimeOffRequestDataFromJSONTyped,
    SubmitTimeOffRequestDataRelationshipsFromJSON: SubmitTimeOffRequestDataRelationshipsFromJSON,
    SubmitTimeOffRequestDataRelationshipsFromJSONTyped: SubmitTimeOffRequestDataRelationshipsFromJSONTyped,
    SubmitTimeOffRequestDataRelationshipsToJSON: SubmitTimeOffRequestDataRelationshipsToJSON,
    SubmitTimeOffRequestDataRelationshipsToJSONTyped: SubmitTimeOffRequestDataRelationshipsToJSONTyped,
    SubmitTimeOffRequestDataToJSON: SubmitTimeOffRequestDataToJSON,
    SubmitTimeOffRequestDataToJSONTyped: SubmitTimeOffRequestDataToJSONTyped,
    SubmitTimeOffRequestDetailFromJSON: SubmitTimeOffRequestDetailFromJSON,
    SubmitTimeOffRequestDetailFromJSONTyped: SubmitTimeOffRequestDetailFromJSONTyped,
    SubmitTimeOffRequestDetailToJSON: SubmitTimeOffRequestDetailToJSON,
    SubmitTimeOffRequestDetailToJSONTyped: SubmitTimeOffRequestDetailToJSONTyped,
    SubmitTimeOffRequestFromJSON: SubmitTimeOffRequestFromJSON,
    SubmitTimeOffRequestFromJSONTyped: SubmitTimeOffRequestFromJSONTyped,
    SubmitTimeOffRequestToJSON: SubmitTimeOffRequestToJSON,
    SubmitTimeOffRequestToJSONTyped: SubmitTimeOffRequestToJSONTyped,
    SwipeAttributesFromJSON: SwipeAttributesFromJSON,
    SwipeAttributesFromJSONTyped: SwipeAttributesFromJSONTyped,
    SwipeAttributesSwipeDataEventTypeEnum: SwipeAttributesSwipeDataEventTypeEnum,
    SwipeAttributesSwipeDataFromJSON: SwipeAttributesSwipeDataFromJSON,
    SwipeAttributesSwipeDataFromJSONTyped: SwipeAttributesSwipeDataFromJSONTyped,
    SwipeAttributesSwipeDataToJSON: SwipeAttributesSwipeDataToJSON,
    SwipeAttributesSwipeDataToJSONTyped: SwipeAttributesSwipeDataToJSONTyped,
    SwipeAttributesToJSON: SwipeAttributesToJSON,
    SwipeAttributesToJSONTyped: SwipeAttributesToJSONTyped,
    SwipeFromJSON: SwipeFromJSON,
    SwipeFromJSONTyped: SwipeFromJSONTyped,
    SwipeRequestDataFromJSON: SwipeRequestDataFromJSON,
    SwipeRequestDataFromJSONTyped: SwipeRequestDataFromJSONTyped,
    SwipeRequestDataToJSON: SwipeRequestDataToJSON,
    SwipeRequestDataToJSONTyped: SwipeRequestDataToJSONTyped,
    SwipeRequestFromJSON: SwipeRequestFromJSON,
    SwipeRequestFromJSONTyped: SwipeRequestFromJSONTyped,
    SwipeRequestToJSON: SwipeRequestToJSON,
    SwipeRequestToJSONTyped: SwipeRequestToJSONTyped,
    SwipeToJSON: SwipeToJSON,
    SwipeToJSONTyped: SwipeToJSONTyped,
    TimeEntriesRelationshipDataInnerFromJSON: TimeEntriesRelationshipDataInnerFromJSON,
    TimeEntriesRelationshipDataInnerFromJSONTyped: TimeEntriesRelationshipDataInnerFromJSONTyped,
    TimeEntriesRelationshipDataInnerToJSON: TimeEntriesRelationshipDataInnerToJSON,
    TimeEntriesRelationshipDataInnerToJSONTyped: TimeEntriesRelationshipDataInnerToJSONTyped,
    TimeEntriesRelationshipFromJSON: TimeEntriesRelationshipFromJSON,
    TimeEntriesRelationshipFromJSONTyped: TimeEntriesRelationshipFromJSONTyped,
    TimeEntriesRelationshipToJSON: TimeEntriesRelationshipToJSON,
    TimeEntriesRelationshipToJSONTyped: TimeEntriesRelationshipToJSONTyped,
    TimeEntryResponseDataInnerFromJSON: TimeEntryResponseDataInnerFromJSON,
    TimeEntryResponseDataInnerFromJSONTyped: TimeEntryResponseDataInnerFromJSONTyped,
    TimeEntryResponseDataInnerToJSON: TimeEntryResponseDataInnerToJSON,
    TimeEntryResponseDataInnerToJSONTyped: TimeEntryResponseDataInnerToJSONTyped,
    TimeEntryResponseFromJSON: TimeEntryResponseFromJSON,
    TimeEntryResponseFromJSONTyped: TimeEntryResponseFromJSONTyped,
    TimeEntryResponseMetaFromJSON: TimeEntryResponseMetaFromJSON,
    TimeEntryResponseMetaFromJSONTyped: TimeEntryResponseMetaFromJSONTyped,
    TimeEntryResponseMetaPeriodsInnerFromJSON: TimeEntryResponseMetaPeriodsInnerFromJSON,
    TimeEntryResponseMetaPeriodsInnerFromJSONTyped: TimeEntryResponseMetaPeriodsInnerFromJSONTyped,
    TimeEntryResponseMetaPeriodsInnerToJSON: TimeEntryResponseMetaPeriodsInnerToJSON,
    TimeEntryResponseMetaPeriodsInnerToJSONTyped: TimeEntryResponseMetaPeriodsInnerToJSONTyped,
    TimeEntryResponseMetaToJSON: TimeEntryResponseMetaToJSON,
    TimeEntryResponseMetaToJSONTyped: TimeEntryResponseMetaToJSONTyped,
    TimeEntryResponseToJSON: TimeEntryResponseToJSON,
    TimeEntryResponseToJSONTyped: TimeEntryResponseToJSONTyped,
    TimeOffFromJSON: TimeOffFromJSON,
    TimeOffFromJSONTyped: TimeOffFromJSONTyped,
    TimeOffRequestDetailsInnerFromJSON: TimeOffRequestDetailsInnerFromJSON,
    TimeOffRequestDetailsInnerFromJSONTyped: TimeOffRequestDetailsInnerFromJSONTyped,
    TimeOffRequestDetailsInnerToJSON: TimeOffRequestDetailsInnerToJSON,
    TimeOffRequestDetailsInnerToJSONTyped: TimeOffRequestDetailsInnerToJSONTyped,
    TimeOffRequestEventDataAttributesEventStatusEnum: TimeOffRequestEventDataAttributesEventStatusEnum,
    TimeOffRequestEventDataAttributesFromJSON: TimeOffRequestEventDataAttributesFromJSON,
    TimeOffRequestEventDataAttributesFromJSONTyped: TimeOffRequestEventDataAttributesFromJSONTyped,
    TimeOffRequestEventDataAttributesToJSON: TimeOffRequestEventDataAttributesToJSON,
    TimeOffRequestEventDataAttributesToJSONTyped: TimeOffRequestEventDataAttributesToJSONTyped,
    TimeOffRequestEventDataFromJSON: TimeOffRequestEventDataFromJSON,
    TimeOffRequestEventDataFromJSONTyped: TimeOffRequestEventDataFromJSONTyped,
    TimeOffRequestEventDataRelationshipsFromJSON: TimeOffRequestEventDataRelationshipsFromJSON,
    TimeOffRequestEventDataRelationshipsFromJSONTyped: TimeOffRequestEventDataRelationshipsFromJSONTyped,
    TimeOffRequestEventDataRelationshipsToJSON: TimeOffRequestEventDataRelationshipsToJSON,
    TimeOffRequestEventDataRelationshipsToJSONTyped: TimeOffRequestEventDataRelationshipsToJSONTyped,
    TimeOffRequestEventDataToJSON: TimeOffRequestEventDataToJSON,
    TimeOffRequestEventDataToJSONTyped: TimeOffRequestEventDataToJSONTyped,
    TimeOffRequestEventFromJSON: TimeOffRequestEventFromJSON,
    TimeOffRequestEventFromJSONTyped: TimeOffRequestEventFromJSONTyped,
    TimeOffRequestEventResponseDataAttributesFromJSON: TimeOffRequestEventResponseDataAttributesFromJSON,
    TimeOffRequestEventResponseDataAttributesFromJSONTyped: TimeOffRequestEventResponseDataAttributesFromJSONTyped,
    TimeOffRequestEventResponseDataAttributesToJSON: TimeOffRequestEventResponseDataAttributesToJSON,
    TimeOffRequestEventResponseDataAttributesToJSONTyped: TimeOffRequestEventResponseDataAttributesToJSONTyped,
    TimeOffRequestEventResponseDataFromJSON: TimeOffRequestEventResponseDataFromJSON,
    TimeOffRequestEventResponseDataFromJSONTyped: TimeOffRequestEventResponseDataFromJSONTyped,
    TimeOffRequestEventResponseDataRelationshipsEventSubmittedByDataFromJSON: TimeOffRequestEventResponseDataRelationshipsEventSubmittedByDataFromJSON,
    TimeOffRequestEventResponseDataRelationshipsEventSubmittedByDataFromJSONTyped: TimeOffRequestEventResponseDataRelationshipsEventSubmittedByDataFromJSONTyped,
    TimeOffRequestEventResponseDataRelationshipsEventSubmittedByDataToJSON: TimeOffRequestEventResponseDataRelationshipsEventSubmittedByDataToJSON,
    TimeOffRequestEventResponseDataRelationshipsEventSubmittedByDataToJSONTyped: TimeOffRequestEventResponseDataRelationshipsEventSubmittedByDataToJSONTyped,
    TimeOffRequestEventResponseDataRelationshipsEventSubmittedByFromJSON: TimeOffRequestEventResponseDataRelationshipsEventSubmittedByFromJSON,
    TimeOffRequestEventResponseDataRelationshipsEventSubmittedByFromJSONTyped: TimeOffRequestEventResponseDataRelationshipsEventSubmittedByFromJSONTyped,
    TimeOffRequestEventResponseDataRelationshipsEventSubmittedByToJSON: TimeOffRequestEventResponseDataRelationshipsEventSubmittedByToJSON,
    TimeOffRequestEventResponseDataRelationshipsEventSubmittedByToJSONTyped: TimeOffRequestEventResponseDataRelationshipsEventSubmittedByToJSONTyped,
    TimeOffRequestEventResponseDataRelationshipsFromJSON: TimeOffRequestEventResponseDataRelationshipsFromJSON,
    TimeOffRequestEventResponseDataRelationshipsFromJSONTyped: TimeOffRequestEventResponseDataRelationshipsFromJSONTyped,
    TimeOffRequestEventResponseDataRelationshipsToJSON: TimeOffRequestEventResponseDataRelationshipsToJSON,
    TimeOffRequestEventResponseDataRelationshipsToJSONTyped: TimeOffRequestEventResponseDataRelationshipsToJSONTyped,
    TimeOffRequestEventResponseDataToJSON: TimeOffRequestEventResponseDataToJSON,
    TimeOffRequestEventResponseDataToJSONTyped: TimeOffRequestEventResponseDataToJSONTyped,
    TimeOffRequestEventResponseFromJSON: TimeOffRequestEventResponseFromJSON,
    TimeOffRequestEventResponseFromJSONTyped: TimeOffRequestEventResponseFromJSONTyped,
    TimeOffRequestEventResponseToJSON: TimeOffRequestEventResponseToJSON,
    TimeOffRequestEventResponseToJSONTyped: TimeOffRequestEventResponseToJSONTyped,
    TimeOffRequestEventToJSON: TimeOffRequestEventToJSON,
    TimeOffRequestEventToJSONTyped: TimeOffRequestEventToJSONTyped,
    TimeOffRequestExceptionFromJSON: TimeOffRequestExceptionFromJSON,
    TimeOffRequestExceptionFromJSONTyped: TimeOffRequestExceptionFromJSONTyped,
    TimeOffRequestExceptionToJSON: TimeOffRequestExceptionToJSON,
    TimeOffRequestExceptionToJSONTyped: TimeOffRequestExceptionToJSONTyped,
    TimeOffRequestListIncludedFromJSON: TimeOffRequestListIncludedFromJSON,
    TimeOffRequestListIncludedFromJSONTyped: TimeOffRequestListIncludedFromJSONTyped,
    TimeOffRequestListIncludedToJSON: TimeOffRequestListIncludedToJSON,
    TimeOffRequestListIncludedToJSONTyped: TimeOffRequestListIncludedToJSONTyped,
    TimeOffRequestRelationshipDataFromJSON: TimeOffRequestRelationshipDataFromJSON,
    TimeOffRequestRelationshipDataFromJSONTyped: TimeOffRequestRelationshipDataFromJSONTyped,
    TimeOffRequestRelationshipDataToJSON: TimeOffRequestRelationshipDataToJSON,
    TimeOffRequestRelationshipDataToJSONTyped: TimeOffRequestRelationshipDataToJSONTyped,
    TimeOffRequestRelationshipFromJSON: TimeOffRequestRelationshipFromJSON,
    TimeOffRequestRelationshipFromJSONTyped: TimeOffRequestRelationshipFromJSONTyped,
    TimeOffRequestRelationshipToJSON: TimeOffRequestRelationshipToJSON,
    TimeOffRequestRelationshipToJSONTyped: TimeOffRequestRelationshipToJSONTyped,
    TimeOffRequestResourceAttributesFromJSON: TimeOffRequestResourceAttributesFromJSON,
    TimeOffRequestResourceAttributesFromJSONTyped: TimeOffRequestResourceAttributesFromJSONTyped,
    TimeOffRequestResourceAttributesToJSON: TimeOffRequestResourceAttributesToJSON,
    TimeOffRequestResourceAttributesToJSONTyped: TimeOffRequestResourceAttributesToJSONTyped,
    TimeOffRequestResourceFromJSON: TimeOffRequestResourceFromJSON,
    TimeOffRequestResourceFromJSONTyped: TimeOffRequestResourceFromJSONTyped,
    TimeOffRequestResourceRelationshipsFromJSON: TimeOffRequestResourceRelationshipsFromJSON,
    TimeOffRequestResourceRelationshipsFromJSONTyped: TimeOffRequestResourceRelationshipsFromJSONTyped,
    TimeOffRequestResourceRelationshipsToJSON: TimeOffRequestResourceRelationshipsToJSON,
    TimeOffRequestResourceRelationshipsToJSONTyped: TimeOffRequestResourceRelationshipsToJSONTyped,
    TimeOffRequestResourceToJSON: TimeOffRequestResourceToJSON,
    TimeOffRequestResourceToJSONTyped: TimeOffRequestResourceToJSONTyped,
    TimeOffRequestResponseAttributesFromJSON: TimeOffRequestResponseAttributesFromJSON,
    TimeOffRequestResponseAttributesFromJSONTyped: TimeOffRequestResponseAttributesFromJSONTyped,
    TimeOffRequestResponseAttributesToJSON: TimeOffRequestResponseAttributesToJSON,
    TimeOffRequestResponseAttributesToJSONTyped: TimeOffRequestResponseAttributesToJSONTyped,
    TimeOffRequestResponseMetaFromJSON: TimeOffRequestResponseMetaFromJSON,
    TimeOffRequestResponseMetaFromJSONTyped: TimeOffRequestResponseMetaFromJSONTyped,
    TimeOffRequestResponseMetaToJSON: TimeOffRequestResponseMetaToJSON,
    TimeOffRequestResponseMetaToJSONTyped: TimeOffRequestResponseMetaToJSONTyped,
    TimeOffRequestResponseRelationshipsFromJSON: TimeOffRequestResponseRelationshipsFromJSON,
    TimeOffRequestResponseRelationshipsFromJSONTyped: TimeOffRequestResponseRelationshipsFromJSONTyped,
    TimeOffRequestResponseRelationshipsToJSON: TimeOffRequestResponseRelationshipsToJSON,
    TimeOffRequestResponseRelationshipsToJSONTyped: TimeOffRequestResponseRelationshipsToJSONTyped,
    TimeOffToJSON: TimeOffToJSON,
    TimeOffToJSONTyped: TimeOffToJSONTyped,
    TimesheetApprovalLayoutResponseDataInnerAttributesFromJSON: TimesheetApprovalLayoutResponseDataInnerAttributesFromJSON,
    TimesheetApprovalLayoutResponseDataInnerAttributesFromJSONTyped: TimesheetApprovalLayoutResponseDataInnerAttributesFromJSONTyped,
    TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerColumnTypeEnum: TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerColumnTypeEnum,
    TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerFromJSON: TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerFromJSON,
    TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerFromJSONTyped: TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerFromJSONTyped,
    TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerToJSON: TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerToJSON,
    TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerToJSONTyped: TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerToJSONTyped,
    TimesheetApprovalLayoutResponseDataInnerAttributesToJSON: TimesheetApprovalLayoutResponseDataInnerAttributesToJSON,
    TimesheetApprovalLayoutResponseDataInnerAttributesToJSONTyped: TimesheetApprovalLayoutResponseDataInnerAttributesToJSONTyped,
    TimesheetApprovalLayoutResponseDataInnerFromJSON: TimesheetApprovalLayoutResponseDataInnerFromJSON,
    TimesheetApprovalLayoutResponseDataInnerFromJSONTyped: TimesheetApprovalLayoutResponseDataInnerFromJSONTyped,
    TimesheetApprovalLayoutResponseDataInnerToJSON: TimesheetApprovalLayoutResponseDataInnerToJSON,
    TimesheetApprovalLayoutResponseDataInnerToJSONTyped: TimesheetApprovalLayoutResponseDataInnerToJSONTyped,
    TimesheetApprovalLayoutResponseFromJSON: TimesheetApprovalLayoutResponseFromJSON,
    TimesheetApprovalLayoutResponseFromJSONTyped: TimesheetApprovalLayoutResponseFromJSONTyped,
    TimesheetApprovalLayoutResponseToJSON: TimesheetApprovalLayoutResponseToJSON,
    TimesheetApprovalLayoutResponseToJSONTyped: TimesheetApprovalLayoutResponseToJSONTyped,
    TimesheetEntryAttributesRequestSchemaFromJSON: TimesheetEntryAttributesRequestSchemaFromJSON,
    TimesheetEntryAttributesRequestSchemaFromJSONTyped: TimesheetEntryAttributesRequestSchemaFromJSONTyped,
    TimesheetEntryAttributesRequestSchemaToJSON: TimesheetEntryAttributesRequestSchemaToJSON,
    TimesheetEntryAttributesRequestSchemaToJSONTyped: TimesheetEntryAttributesRequestSchemaToJSONTyped,
    TimesheetEntryDataFromJSON: TimesheetEntryDataFromJSON,
    TimesheetEntryDataFromJSONTyped: TimesheetEntryDataFromJSONTyped,
    TimesheetEntryDataIncludedInnerFromJSON: TimesheetEntryDataIncludedInnerFromJSON,
    TimesheetEntryDataIncludedInnerFromJSONTyped: TimesheetEntryDataIncludedInnerFromJSONTyped,
    TimesheetEntryDataIncludedInnerToJSON: TimesheetEntryDataIncludedInnerToJSON,
    TimesheetEntryDataIncludedInnerToJSONTyped: TimesheetEntryDataIncludedInnerToJSONTyped,
    TimesheetEntryDataToJSON: TimesheetEntryDataToJSON,
    TimesheetEntryDataToJSONTyped: TimesheetEntryDataToJSONTyped,
    TimesheetEntryIncludeItem: TimesheetEntryIncludeItem,
    TimesheetEntryIncludeItemFromJSON: TimesheetEntryIncludeItemFromJSON,
    TimesheetEntryIncludeItemFromJSONTyped: TimesheetEntryIncludeItemFromJSONTyped,
    TimesheetEntryIncludeItemToJSON: TimesheetEntryIncludeItemToJSON,
    TimesheetEntryIncludeItemToJSONTyped: TimesheetEntryIncludeItemToJSONTyped,
    TimesheetEntryRelationshipsRequestSchemaFromJSON: TimesheetEntryRelationshipsRequestSchemaFromJSON,
    TimesheetEntryRelationshipsRequestSchemaFromJSONTyped: TimesheetEntryRelationshipsRequestSchemaFromJSONTyped,
    TimesheetEntryRelationshipsRequestSchemaToJSON: TimesheetEntryRelationshipsRequestSchemaToJSON,
    TimesheetEntryRelationshipsRequestSchemaToJSONTyped: TimesheetEntryRelationshipsRequestSchemaToJSONTyped,
    TimesheetEntryResourceAttributesFromJSON: TimesheetEntryResourceAttributesFromJSON,
    TimesheetEntryResourceAttributesFromJSONTyped: TimesheetEntryResourceAttributesFromJSONTyped,
    TimesheetEntryResourceAttributesToJSON: TimesheetEntryResourceAttributesToJSON,
    TimesheetEntryResourceAttributesToJSONTyped: TimesheetEntryResourceAttributesToJSONTyped,
    TimesheetEntryResourceFromJSON: TimesheetEntryResourceFromJSON,
    TimesheetEntryResourceFromJSONTyped: TimesheetEntryResourceFromJSONTyped,
    TimesheetEntryResourceMetaFromJSON: TimesheetEntryResourceMetaFromJSON,
    TimesheetEntryResourceMetaFromJSONTyped: TimesheetEntryResourceMetaFromJSONTyped,
    TimesheetEntryResourceMetaToJSON: TimesheetEntryResourceMetaToJSON,
    TimesheetEntryResourceMetaToJSONTyped: TimesheetEntryResourceMetaToJSONTyped,
    TimesheetEntryResourceRelationshipsFromJSON: TimesheetEntryResourceRelationshipsFromJSON,
    TimesheetEntryResourceRelationshipsFromJSONTyped: TimesheetEntryResourceRelationshipsFromJSONTyped,
    TimesheetEntryResourceRelationshipsToJSON: TimesheetEntryResourceRelationshipsToJSON,
    TimesheetEntryResourceRelationshipsToJSONTyped: TimesheetEntryResourceRelationshipsToJSONTyped,
    TimesheetEntryResourceToJSON: TimesheetEntryResourceToJSON,
    TimesheetEntryResourceToJSONTyped: TimesheetEntryResourceToJSONTyped,
    TimesheetExceptionAttributesFromJSON: TimesheetExceptionAttributesFromJSON,
    TimesheetExceptionAttributesFromJSONTyped: TimesheetExceptionAttributesFromJSONTyped,
    TimesheetExceptionAttributesToJSON: TimesheetExceptionAttributesToJSON,
    TimesheetExceptionAttributesToJSONTyped: TimesheetExceptionAttributesToJSONTyped,
    TimesheetExceptionFromJSON: TimesheetExceptionFromJSON,
    TimesheetExceptionFromJSONTyped: TimesheetExceptionFromJSONTyped,
    TimesheetExceptionPatchRequestDataAttributesFromJSON: TimesheetExceptionPatchRequestDataAttributesFromJSON,
    TimesheetExceptionPatchRequestDataAttributesFromJSONTyped: TimesheetExceptionPatchRequestDataAttributesFromJSONTyped,
    TimesheetExceptionPatchRequestDataAttributesToJSON: TimesheetExceptionPatchRequestDataAttributesToJSON,
    TimesheetExceptionPatchRequestDataAttributesToJSONTyped: TimesheetExceptionPatchRequestDataAttributesToJSONTyped,
    TimesheetExceptionPatchRequestDataFromJSON: TimesheetExceptionPatchRequestDataFromJSON,
    TimesheetExceptionPatchRequestDataFromJSONTyped: TimesheetExceptionPatchRequestDataFromJSONTyped,
    TimesheetExceptionPatchRequestDataToJSON: TimesheetExceptionPatchRequestDataToJSON,
    TimesheetExceptionPatchRequestDataToJSONTyped: TimesheetExceptionPatchRequestDataToJSONTyped,
    TimesheetExceptionPatchRequestFromJSON: TimesheetExceptionPatchRequestFromJSON,
    TimesheetExceptionPatchRequestFromJSONTyped: TimesheetExceptionPatchRequestFromJSONTyped,
    TimesheetExceptionPatchRequestToJSON: TimesheetExceptionPatchRequestToJSON,
    TimesheetExceptionPatchRequestToJSONTyped: TimesheetExceptionPatchRequestToJSONTyped,
    TimesheetExceptionRelationshipsFromJSON: TimesheetExceptionRelationshipsFromJSON,
    TimesheetExceptionRelationshipsFromJSONTyped: TimesheetExceptionRelationshipsFromJSONTyped,
    TimesheetExceptionRelationshipsToJSON: TimesheetExceptionRelationshipsToJSON,
    TimesheetExceptionRelationshipsToJSONTyped: TimesheetExceptionRelationshipsToJSONTyped,
    TimesheetExceptionToJSON: TimesheetExceptionToJSON,
    TimesheetExceptionToJSONTyped: TimesheetExceptionToJSONTyped,
    TimesheetExceptionsIncludedFromJSON: TimesheetExceptionsIncludedFromJSON,
    TimesheetExceptionsIncludedFromJSONTyped: TimesheetExceptionsIncludedFromJSONTyped,
    TimesheetExceptionsIncludedToJSON: TimesheetExceptionsIncludedToJSON,
    TimesheetExceptionsIncludedToJSONTyped: TimesheetExceptionsIncludedToJSONTyped,
    TimesheetExceptionsMetaFromJSON: TimesheetExceptionsMetaFromJSON,
    TimesheetExceptionsMetaFromJSONTyped: TimesheetExceptionsMetaFromJSONTyped,
    TimesheetExceptionsMetaToJSON: TimesheetExceptionsMetaToJSON,
    TimesheetExceptionsMetaToJSONTyped: TimesheetExceptionsMetaToJSONTyped,
    TimesheetExceptionsResponseSchemaFromJSON: TimesheetExceptionsResponseSchemaFromJSON,
    TimesheetExceptionsResponseSchemaFromJSONTyped: TimesheetExceptionsResponseSchemaFromJSONTyped,
    TimesheetExceptionsResponseSchemaToJSON: TimesheetExceptionsResponseSchemaToJSON,
    TimesheetExceptionsResponseSchemaToJSONTyped: TimesheetExceptionsResponseSchemaToJSONTyped,
    TimesheetIncludeItem: TimesheetIncludeItem,
    TimesheetIncludeItemFromJSON: TimesheetIncludeItemFromJSON,
    TimesheetIncludeItemFromJSONTyped: TimesheetIncludeItemFromJSONTyped,
    TimesheetIncludeItemToJSON: TimesheetIncludeItemToJSON,
    TimesheetIncludeItemToJSONTyped: TimesheetIncludeItemToJSONTyped,
    TimesheetRelationshipDataFromJSON: TimesheetRelationshipDataFromJSON,
    TimesheetRelationshipDataFromJSONTyped: TimesheetRelationshipDataFromJSONTyped,
    TimesheetRelationshipDataToJSON: TimesheetRelationshipDataToJSON,
    TimesheetRelationshipDataToJSONTyped: TimesheetRelationshipDataToJSONTyped,
    TimesheetRelationshipFromJSON: TimesheetRelationshipFromJSON,
    TimesheetRelationshipFromJSONTyped: TimesheetRelationshipFromJSONTyped,
    TimesheetRelationshipToJSON: TimesheetRelationshipToJSON,
    TimesheetRelationshipToJSONTyped: TimesheetRelationshipToJSONTyped,
    TimesheetResponseFromJSON: TimesheetResponseFromJSON,
    TimesheetResponseFromJSONTyped: TimesheetResponseFromJSONTyped,
    TimesheetResponseIncludedInnerFromJSON: TimesheetResponseIncludedInnerFromJSON,
    TimesheetResponseIncludedInnerFromJSONTyped: TimesheetResponseIncludedInnerFromJSONTyped,
    TimesheetResponseIncludedInnerToJSON: TimesheetResponseIncludedInnerToJSON,
    TimesheetResponseIncludedInnerToJSONTyped: TimesheetResponseIncludedInnerToJSONTyped,
    TimesheetResponseToJSON: TimesheetResponseToJSON,
    TimesheetResponseToJSONTyped: TimesheetResponseToJSONTyped,
    TimesheetSchemaAttributesApprovalDataCategoryEnum: TimesheetSchemaAttributesApprovalDataCategoryEnum,
    TimesheetSchemaAttributesApprovalDataFromJSON: TimesheetSchemaAttributesApprovalDataFromJSON,
    TimesheetSchemaAttributesApprovalDataFromJSONTyped: TimesheetSchemaAttributesApprovalDataFromJSONTyped,
    TimesheetSchemaAttributesApprovalDataToJSON: TimesheetSchemaAttributesApprovalDataToJSON,
    TimesheetSchemaAttributesApprovalDataToJSONTyped: TimesheetSchemaAttributesApprovalDataToJSONTyped,
    TimesheetSchemaAttributesFromJSON: TimesheetSchemaAttributesFromJSON,
    TimesheetSchemaAttributesFromJSONTyped: TimesheetSchemaAttributesFromJSONTyped,
    TimesheetSchemaAttributesTimesheetStateApprovalStatusEnum: TimesheetSchemaAttributesTimesheetStateApprovalStatusEnum,
    TimesheetSchemaAttributesTimesheetStateFromJSON: TimesheetSchemaAttributesTimesheetStateFromJSON,
    TimesheetSchemaAttributesTimesheetStateFromJSONTyped: TimesheetSchemaAttributesTimesheetStateFromJSONTyped,
    TimesheetSchemaAttributesTimesheetStateToJSON: TimesheetSchemaAttributesTimesheetStateToJSON,
    TimesheetSchemaAttributesTimesheetStateToJSONTyped: TimesheetSchemaAttributesTimesheetStateToJSONTyped,
    TimesheetSchemaAttributesToJSON: TimesheetSchemaAttributesToJSON,
    TimesheetSchemaAttributesToJSONTyped: TimesheetSchemaAttributesToJSONTyped,
    TimesheetSchemaFromJSON: TimesheetSchemaFromJSON,
    TimesheetSchemaFromJSONTyped: TimesheetSchemaFromJSONTyped,
    TimesheetSchemaMetaFromJSON: TimesheetSchemaMetaFromJSON,
    TimesheetSchemaMetaFromJSONTyped: TimesheetSchemaMetaFromJSONTyped,
    TimesheetSchemaMetaToJSON: TimesheetSchemaMetaToJSON,
    TimesheetSchemaMetaToJSONTyped: TimesheetSchemaMetaToJSONTyped,
    TimesheetSchemaRelationshipsFromJSON: TimesheetSchemaRelationshipsFromJSON,
    TimesheetSchemaRelationshipsFromJSONTyped: TimesheetSchemaRelationshipsFromJSONTyped,
    TimesheetSchemaRelationshipsToJSON: TimesheetSchemaRelationshipsToJSON,
    TimesheetSchemaRelationshipsToJSONTyped: TimesheetSchemaRelationshipsToJSONTyped,
    TimesheetSchemaToJSON: TimesheetSchemaToJSON,
    TimesheetSchemaToJSONTyped: TimesheetSchemaToJSONTyped,
    UpdateAbsenceCaseOperationDataFromJSON: UpdateAbsenceCaseOperationDataFromJSON,
    UpdateAbsenceCaseOperationDataFromJSONTyped: UpdateAbsenceCaseOperationDataFromJSONTyped,
    UpdateAbsenceCaseOperationDataToJSON: UpdateAbsenceCaseOperationDataToJSON,
    UpdateAbsenceCaseOperationDataToJSONTyped: UpdateAbsenceCaseOperationDataToJSONTyped,
    UpdateAbsenceCaseOperationFromJSON: UpdateAbsenceCaseOperationFromJSON,
    UpdateAbsenceCaseOperationFromJSONTyped: UpdateAbsenceCaseOperationFromJSONTyped,
    UpdateAbsenceCaseOperationOpEnum: UpdateAbsenceCaseOperationOpEnum,
    UpdateAbsenceCaseOperationToJSON: UpdateAbsenceCaseOperationToJSON,
    UpdateAbsenceCaseOperationToJSONTyped: UpdateAbsenceCaseOperationToJSONTyped,
    UpdateCaseManagerOperationDataInnerFromJSON: UpdateCaseManagerOperationDataInnerFromJSON,
    UpdateCaseManagerOperationDataInnerFromJSONTyped: UpdateCaseManagerOperationDataInnerFromJSONTyped,
    UpdateCaseManagerOperationDataInnerToJSON: UpdateCaseManagerOperationDataInnerToJSON,
    UpdateCaseManagerOperationDataInnerToJSONTyped: UpdateCaseManagerOperationDataInnerToJSONTyped,
    UpdateCaseManagerOperationFromJSON: UpdateCaseManagerOperationFromJSON,
    UpdateCaseManagerOperationFromJSONTyped: UpdateCaseManagerOperationFromJSONTyped,
    UpdateCaseManagerOperationOpEnum: UpdateCaseManagerOperationOpEnum,
    UpdateCaseManagerOperationRefFromJSON: UpdateCaseManagerOperationRefFromJSON,
    UpdateCaseManagerOperationRefFromJSONTyped: UpdateCaseManagerOperationRefFromJSONTyped,
    UpdateCaseManagerOperationRefToJSON: UpdateCaseManagerOperationRefToJSON,
    UpdateCaseManagerOperationRefToJSONTyped: UpdateCaseManagerOperationRefToJSONTyped,
    UpdateCaseManagerOperationToJSON: UpdateCaseManagerOperationToJSON,
    UpdateCaseManagerOperationToJSONTyped: UpdateCaseManagerOperationToJSONTyped,
    UpdateLeaveEligibilityOperationDataAttributesFromJSON: UpdateLeaveEligibilityOperationDataAttributesFromJSON,
    UpdateLeaveEligibilityOperationDataAttributesFromJSONTyped: UpdateLeaveEligibilityOperationDataAttributesFromJSONTyped,
    UpdateLeaveEligibilityOperationDataAttributesQualificationResultEnum: UpdateLeaveEligibilityOperationDataAttributesQualificationResultEnum,
    UpdateLeaveEligibilityOperationDataAttributesToJSON: UpdateLeaveEligibilityOperationDataAttributesToJSON,
    UpdateLeaveEligibilityOperationDataAttributesToJSONTyped: UpdateLeaveEligibilityOperationDataAttributesToJSONTyped,
    UpdateLeaveEligibilityOperationDataFromJSON: UpdateLeaveEligibilityOperationDataFromJSON,
    UpdateLeaveEligibilityOperationDataFromJSONTyped: UpdateLeaveEligibilityOperationDataFromJSONTyped,
    UpdateLeaveEligibilityOperationDataToJSON: UpdateLeaveEligibilityOperationDataToJSON,
    UpdateLeaveEligibilityOperationDataToJSONTyped: UpdateLeaveEligibilityOperationDataToJSONTyped,
    UpdateLeaveEligibilityOperationFromJSON: UpdateLeaveEligibilityOperationFromJSON,
    UpdateLeaveEligibilityOperationFromJSONTyped: UpdateLeaveEligibilityOperationFromJSONTyped,
    UpdateLeaveEligibilityOperationOpEnum: UpdateLeaveEligibilityOperationOpEnum,
    UpdateLeaveEligibilityOperationToJSON: UpdateLeaveEligibilityOperationToJSON,
    UpdateLeaveEligibilityOperationToJSONTyped: UpdateLeaveEligibilityOperationToJSONTyped,
    UpdatePayRuleRequestSchemaBodyFromJSON: UpdatePayRuleRequestSchemaBodyFromJSON,
    UpdatePayRuleRequestSchemaBodyFromJSONTyped: UpdatePayRuleRequestSchemaBodyFromJSONTyped,
    UpdatePayRuleRequestSchemaBodyToJSON: UpdatePayRuleRequestSchemaBodyToJSON,
    UpdatePayRuleRequestSchemaBodyToJSONTyped: UpdatePayRuleRequestSchemaBodyToJSONTyped,
    UpdatePayRuleRequestSchemaDataFromJSON: UpdatePayRuleRequestSchemaDataFromJSON,
    UpdatePayRuleRequestSchemaDataFromJSONTyped: UpdatePayRuleRequestSchemaDataFromJSONTyped,
    UpdatePayRuleRequestSchemaDataToJSON: UpdatePayRuleRequestSchemaDataToJSON,
    UpdatePayRuleRequestSchemaDataToJSONTyped: UpdatePayRuleRequestSchemaDataToJSONTyped,
    UpdatePayRuleRequestSchemaDataTypeEnum: UpdatePayRuleRequestSchemaDataTypeEnum,
    UpdatePayRuleRequestSchemaFromJSON: UpdatePayRuleRequestSchemaFromJSON,
    UpdatePayRuleRequestSchemaFromJSONTyped: UpdatePayRuleRequestSchemaFromJSONTyped,
    UpdatePayRuleRequestSchemaToJSON: UpdatePayRuleRequestSchemaToJSON,
    UpdatePayRuleRequestSchemaToJSONTyped: UpdatePayRuleRequestSchemaToJSONTyped,
    UpdateProjectedUsageOperationDataFromJSON: UpdateProjectedUsageOperationDataFromJSON,
    UpdateProjectedUsageOperationDataFromJSONTyped: UpdateProjectedUsageOperationDataFromJSONTyped,
    UpdateProjectedUsageOperationDataToJSON: UpdateProjectedUsageOperationDataToJSON,
    UpdateProjectedUsageOperationDataToJSONTyped: UpdateProjectedUsageOperationDataToJSONTyped,
    UpdateProjectedUsageOperationFromJSON: UpdateProjectedUsageOperationFromJSON,
    UpdateProjectedUsageOperationFromJSONTyped: UpdateProjectedUsageOperationFromJSONTyped,
    UpdateProjectedUsageOperationOpEnum: UpdateProjectedUsageOperationOpEnum,
    UpdateProjectedUsageOperationToJSON: UpdateProjectedUsageOperationToJSON,
    UpdateProjectedUsageOperationToJSONTyped: UpdateProjectedUsageOperationToJSONTyped,
    UpdateShiftRelationshipsFromJSON: UpdateShiftRelationshipsFromJSON,
    UpdateShiftRelationshipsFromJSONTyped: UpdateShiftRelationshipsFromJSONTyped,
    UpdateShiftRelationshipsToJSON: UpdateShiftRelationshipsToJSON,
    UpdateShiftRelationshipsToJSONTyped: UpdateShiftRelationshipsToJSONTyped,
    UpdateShiftRequestSchemaBodyFromJSON: UpdateShiftRequestSchemaBodyFromJSON,
    UpdateShiftRequestSchemaBodyFromJSONTyped: UpdateShiftRequestSchemaBodyFromJSONTyped,
    UpdateShiftRequestSchemaBodyToJSON: UpdateShiftRequestSchemaBodyToJSON,
    UpdateShiftRequestSchemaBodyToJSONTyped: UpdateShiftRequestSchemaBodyToJSONTyped,
    UpdateShiftRequestSchemaDataFromJSON: UpdateShiftRequestSchemaDataFromJSON,
    UpdateShiftRequestSchemaDataFromJSONTyped: UpdateShiftRequestSchemaDataFromJSONTyped,
    UpdateShiftRequestSchemaDataToJSON: UpdateShiftRequestSchemaDataToJSON,
    UpdateShiftRequestSchemaDataToJSONTyped: UpdateShiftRequestSchemaDataToJSONTyped,
    UpdateShiftRequestSchemaDataTypeEnum: UpdateShiftRequestSchemaDataTypeEnum,
    UpdateShiftRequestSchemaFromJSON: UpdateShiftRequestSchemaFromJSON,
    UpdateShiftRequestSchemaFromJSONTyped: UpdateShiftRequestSchemaFromJSONTyped,
    UpdateShiftRequestSchemaToJSON: UpdateShiftRequestSchemaToJSON,
    UpdateShiftRequestSchemaToJSONTyped: UpdateShiftRequestSchemaToJSONTyped,
    UpdateTimesheetEntryRequestSchemaDataFromJSON: UpdateTimesheetEntryRequestSchemaDataFromJSON,
    UpdateTimesheetEntryRequestSchemaDataFromJSONTyped: UpdateTimesheetEntryRequestSchemaDataFromJSONTyped,
    UpdateTimesheetEntryRequestSchemaDataToJSON: UpdateTimesheetEntryRequestSchemaDataToJSON,
    UpdateTimesheetEntryRequestSchemaDataToJSONTyped: UpdateTimesheetEntryRequestSchemaDataToJSONTyped,
    UpdateTimesheetEntryRequestSchemaFromJSON: UpdateTimesheetEntryRequestSchemaFromJSON,
    UpdateTimesheetEntryRequestSchemaFromJSONTyped: UpdateTimesheetEntryRequestSchemaFromJSONTyped,
    UpdateTimesheetEntryRequestSchemaToJSON: UpdateTimesheetEntryRequestSchemaToJSON,
    UpdateTimesheetEntryRequestSchemaToJSONTyped: UpdateTimesheetEntryRequestSchemaToJSONTyped,
    UserCardAttributesFromJSON: UserCardAttributesFromJSON,
    UserCardAttributesFromJSONTyped: UserCardAttributesFromJSONTyped,
    UserCardAttributesToJSON: UserCardAttributesToJSON,
    UserCardAttributesToJSONTyped: UserCardAttributesToJSONTyped,
    UserCardFromJSON: UserCardFromJSON,
    UserCardFromJSONTyped: UserCardFromJSONTyped,
    UserCardToJSON: UserCardToJSON,
    UserCardToJSONTyped: UserCardToJSONTyped,
    UserRelationshipsDataInnerFromJSON: UserRelationshipsDataInnerFromJSON,
    UserRelationshipsDataInnerFromJSONTyped: UserRelationshipsDataInnerFromJSONTyped,
    UserRelationshipsDataInnerToJSON: UserRelationshipsDataInnerToJSON,
    UserRelationshipsDataInnerToJSONTyped: UserRelationshipsDataInnerToJSONTyped,
    UserRelationshipsFromJSON: UserRelationshipsFromJSON,
    UserRelationshipsFromJSONTyped: UserRelationshipsFromJSONTyped,
    UserRelationshipsToJSON: UserRelationshipsToJSON,
    UserRelationshipsToJSONTyped: UserRelationshipsToJSONTyped,
    WeeklyLimitsInnerFromJSON: WeeklyLimitsInnerFromJSON,
    WeeklyLimitsInnerFromJSONTyped: WeeklyLimitsInnerFromJSONTyped,
    WeeklyLimitsInnerToJSON: WeeklyLimitsInnerToJSON,
    WeeklyLimitsInnerToJSONTyped: WeeklyLimitsInnerToJSONTyped,
    instanceOfAbsenceCase: instanceOfAbsenceCase,
    instanceOfAbsenceCaseAttributes: instanceOfAbsenceCaseAttributes,
    instanceOfAbsenceCaseContactEmployeeRequest: instanceOfAbsenceCaseContactEmployeeRequest,
    instanceOfAbsenceCaseContactEmployeeRequestData: instanceOfAbsenceCaseContactEmployeeRequestData,
    instanceOfAbsenceCaseContactEmployeeRequestDataAttributes: instanceOfAbsenceCaseContactEmployeeRequestDataAttributes,
    instanceOfAbsenceCaseContactEmployeeRequestDataRelationships: instanceOfAbsenceCaseContactEmployeeRequestDataRelationships,
    instanceOfAbsenceCaseContactEmployeeResponse: instanceOfAbsenceCaseContactEmployeeResponse,
    instanceOfAbsenceCaseContactEmployeeResponseAttributes: instanceOfAbsenceCaseContactEmployeeResponseAttributes,
    instanceOfAbsenceCaseContactEmployeeResponseRelationships: instanceOfAbsenceCaseContactEmployeeResponseRelationships,
    instanceOfAbsenceCaseDetails: instanceOfAbsenceCaseDetails,
    instanceOfAbsenceCaseDetailsAttributes: instanceOfAbsenceCaseDetailsAttributes,
    instanceOfAbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInner: instanceOfAbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInner,
    instanceOfAbsenceCaseDetailsRelationships: instanceOfAbsenceCaseDetailsRelationships,
    instanceOfAbsenceCaseDocumentsReduced: instanceOfAbsenceCaseDocumentsReduced,
    instanceOfAbsenceCaseDocumentsReducedAttributes: instanceOfAbsenceCaseDocumentsReducedAttributes,
    instanceOfAbsenceCaseDocumentsRelationship: instanceOfAbsenceCaseDocumentsRelationship,
    instanceOfAbsenceCaseDocumentsRelationshipDataInner: instanceOfAbsenceCaseDocumentsRelationshipDataInner,
    instanceOfAbsenceCaseEditableAttributes: instanceOfAbsenceCaseEditableAttributes,
    instanceOfAbsenceCaseEventRelationship: instanceOfAbsenceCaseEventRelationship,
    instanceOfAbsenceCaseEventRelationshipData: instanceOfAbsenceCaseEventRelationshipData,
    instanceOfAbsenceCaseEventRelationshipDataAttributes: instanceOfAbsenceCaseEventRelationshipDataAttributes,
    instanceOfAbsenceCaseHistoryEvent: instanceOfAbsenceCaseHistoryEvent,
    instanceOfAbsenceCaseHistoryEventAttributes: instanceOfAbsenceCaseHistoryEventAttributes,
    instanceOfAbsenceCaseHistoryEventRelationship: instanceOfAbsenceCaseHistoryEventRelationship,
    instanceOfAbsenceCaseHistoryEventRelationshipData: instanceOfAbsenceCaseHistoryEventRelationshipData,
    instanceOfAbsenceCaseHistoryEventRelationships: instanceOfAbsenceCaseHistoryEventRelationships,
    instanceOfAbsenceCaseLeaveEligibilityReduced: instanceOfAbsenceCaseLeaveEligibilityReduced,
    instanceOfAbsenceCaseLeaveEligibilityReducedAttributes: instanceOfAbsenceCaseLeaveEligibilityReducedAttributes,
    instanceOfAbsenceCaseLeaveEligibilityRelationship: instanceOfAbsenceCaseLeaveEligibilityRelationship,
    instanceOfAbsenceCaseLeaveEligibilityRelationshipDataInner: instanceOfAbsenceCaseLeaveEligibilityRelationshipDataInner,
    instanceOfAbsenceCaseLeaveTypeReduced: instanceOfAbsenceCaseLeaveTypeReduced,
    instanceOfAbsenceCaseLeaveTypeReducedAttributes: instanceOfAbsenceCaseLeaveTypeReducedAttributes,
    instanceOfAbsenceCaseLeaveTypeRelationship: instanceOfAbsenceCaseLeaveTypeRelationship,
    instanceOfAbsenceCaseLeaveTypeRelationshipDataInner: instanceOfAbsenceCaseLeaveTypeRelationshipDataInner,
    instanceOfAbsenceCaseProjectedUsagesReduced: instanceOfAbsenceCaseProjectedUsagesReduced,
    instanceOfAbsenceCaseProjectedUsagesReducedAttributes: instanceOfAbsenceCaseProjectedUsagesReducedAttributes,
    instanceOfAbsenceCaseProjectedUsagesRelationship: instanceOfAbsenceCaseProjectedUsagesRelationship,
    instanceOfAbsenceCaseProjectedUsagesRelationshipDataInner: instanceOfAbsenceCaseProjectedUsagesRelationshipDataInner,
    instanceOfAbsenceCaseQuestion: instanceOfAbsenceCaseQuestion,
    instanceOfAbsenceCaseQuestionAttributes: instanceOfAbsenceCaseQuestionAttributes,
    instanceOfAbsenceCaseQuestionMeta: instanceOfAbsenceCaseQuestionMeta,
    instanceOfAbsenceCaseQuestionRelationships: instanceOfAbsenceCaseQuestionRelationships,
    instanceOfAbsenceCaseReasonReduced: instanceOfAbsenceCaseReasonReduced,
    instanceOfAbsenceCaseReasonReducedAttributes: instanceOfAbsenceCaseReasonReducedAttributes,
    instanceOfAbsenceCaseReasonRelationship: instanceOfAbsenceCaseReasonRelationship,
    instanceOfAbsenceCaseReasonRelationshipData: instanceOfAbsenceCaseReasonRelationshipData,
    instanceOfAbsenceCaseReduced: instanceOfAbsenceCaseReduced,
    instanceOfAbsenceCaseRelationship: instanceOfAbsenceCaseRelationship,
    instanceOfAbsenceCaseRelationshipData: instanceOfAbsenceCaseRelationshipData,
    instanceOfAbsenceCaseRelationships: instanceOfAbsenceCaseRelationships,
    instanceOfAbsenceCaseUpdateRequest: instanceOfAbsenceCaseUpdateRequest,
    instanceOfAbsenceCaseUpdateRequestAtomicOperationsInner: instanceOfAbsenceCaseUpdateRequestAtomicOperationsInner,
    instanceOfAbsenceCaseUpdateResponse: instanceOfAbsenceCaseUpdateResponse,
    instanceOfAbsenceCaseUpdateResponseAtomicResultsInner: instanceOfAbsenceCaseUpdateResponseAtomicResultsInner,
    instanceOfAbsenceCaseUpdateResponseAtomicResultsInnerData: instanceOfAbsenceCaseUpdateResponseAtomicResultsInnerData,
    instanceOfAbsenceCaseUpdateResult: instanceOfAbsenceCaseUpdateResult,
    instanceOfAbsenceCaseUpdateResultAttributes: instanceOfAbsenceCaseUpdateResultAttributes,
    instanceOfAbsenceCaseUpdateResultRelationships: instanceOfAbsenceCaseUpdateResultRelationships,
    instanceOfAbsenceCaseUploadDocumentsRequest: instanceOfAbsenceCaseUploadDocumentsRequest,
    instanceOfAbsenceCaseUploadDocumentsRequestData: instanceOfAbsenceCaseUploadDocumentsRequestData,
    instanceOfAbsenceCaseUploadDocumentsRequestDataAttributes: instanceOfAbsenceCaseUploadDocumentsRequestDataAttributes,
    instanceOfAbsenceCaseUploadDocumentsResponse: instanceOfAbsenceCaseUploadDocumentsResponse,
    instanceOfAbsenceCaseUploadDocumentsResponseAttributes: instanceOfAbsenceCaseUploadDocumentsResponseAttributes,
    instanceOfAbsenceCaseUploadDocumentsResponseRelationships: instanceOfAbsenceCaseUploadDocumentsResponseRelationships,
    instanceOfAbsenceCaseWorkflowEvent: instanceOfAbsenceCaseWorkflowEvent,
    instanceOfAbsenceCaseWorkflowEventAttributes: instanceOfAbsenceCaseWorkflowEventAttributes,
    instanceOfAbsenceCaseWorkflowEventEmployeeRelationship: instanceOfAbsenceCaseWorkflowEventEmployeeRelationship,
    instanceOfAbsenceCaseWorkflowEventEmployeeRelationshipData: instanceOfAbsenceCaseWorkflowEventEmployeeRelationshipData,
    instanceOfAbsenceCaseWorkflowEventRelationships: instanceOfAbsenceCaseWorkflowEventRelationships,
    instanceOfAbsenceCaseWorkflowEventTypeReduced: instanceOfAbsenceCaseWorkflowEventTypeReduced,
    instanceOfAbsenceCaseWorkflowEventTypeReducedAttributes: instanceOfAbsenceCaseWorkflowEventTypeReducedAttributes,
    instanceOfAbsenceCaseWorkflowEventTypeRelationship: instanceOfAbsenceCaseWorkflowEventTypeRelationship,
    instanceOfAbsenceCaseWorkflowEventTypeRelationshipData: instanceOfAbsenceCaseWorkflowEventTypeRelationshipData,
    instanceOfAbsenceCreateCaseRequest: instanceOfAbsenceCreateCaseRequest,
    instanceOfAbsenceCreateCaseRequestData: instanceOfAbsenceCreateCaseRequestData,
    instanceOfAbsenceCreateCaseRequestDataAttributes: instanceOfAbsenceCreateCaseRequestDataAttributes,
    instanceOfAbsenceCreateCaseRequestDataAttributesQuestionResponsesInner: instanceOfAbsenceCreateCaseRequestDataAttributesQuestionResponsesInner,
    instanceOfAbsenceCreateCaseRequestDataRelationships: instanceOfAbsenceCreateCaseRequestDataRelationships,
    instanceOfAbsenceCreateCaseResponse: instanceOfAbsenceCreateCaseResponse,
    instanceOfAbsenceCreateCaseResponseData: instanceOfAbsenceCreateCaseResponseData,
    instanceOfAbsenceCreateCaseResponseDataAttributes: instanceOfAbsenceCreateCaseResponseDataAttributes,
    instanceOfAbsenceLimitMeta: instanceOfAbsenceLimitMeta,
    instanceOfAbsenceLimitMetaOverlappingCustomRulesInner: instanceOfAbsenceLimitMetaOverlappingCustomRulesInner,
    instanceOfAbsenceLimits: instanceOfAbsenceLimits,
    instanceOfAbsenceLimitsCustomRulesInner: instanceOfAbsenceLimitsCustomRulesInner,
    instanceOfAbsenceLimitsDefaultRules: instanceOfAbsenceLimitsDefaultRules,
    instanceOfAbsenceReason: instanceOfAbsenceReason,
    instanceOfAbsenceReasonAttributes: instanceOfAbsenceReasonAttributes,
    instanceOfAbsenceType: instanceOfAbsenceType,
    instanceOfAbsenceTypeAttributes: instanceOfAbsenceTypeAttributes,
    instanceOfAbsenceTypeRelationship: instanceOfAbsenceTypeRelationship,
    instanceOfAbsenceTypeRelationshipData: instanceOfAbsenceTypeRelationshipData,
    instanceOfAbsenceTypeRelationships: instanceOfAbsenceTypeRelationships,
    instanceOfAbsenceTypeRelationshipsAllowedPayCodes: instanceOfAbsenceTypeRelationshipsAllowedPayCodes,
    instanceOfAbsenceTypeRelationshipsAllowedPayCodesDataInner: instanceOfAbsenceTypeRelationshipsAllowedPayCodesDataInner,
    instanceOfAbsenceTypeRelationshipsDefaultPayCode: instanceOfAbsenceTypeRelationshipsDefaultPayCode,
    instanceOfAbsenceTypeRelationshipsDefaultPayCodeData: instanceOfAbsenceTypeRelationshipsDefaultPayCodeData,
    instanceOfAcceptedSchema: instanceOfAcceptedSchema,
    instanceOfAcceptedSchemaData: instanceOfAcceptedSchemaData,
    instanceOfActivitiesLookupRelationship: instanceOfActivitiesLookupRelationship,
    instanceOfActivitiesLookupRelationshipSchedulingUnit: instanceOfActivitiesLookupRelationshipSchedulingUnit,
    instanceOfActivitiesLookupRelationshipSchedulingUnitMeta: instanceOfActivitiesLookupRelationshipSchedulingUnitMeta,
    instanceOfActivitiesLookupRelationshipSchedulingUnitMetaLookup: instanceOfActivitiesLookupRelationshipSchedulingUnitMetaLookup,
    instanceOfActivitiesLookupRelationshipTask: instanceOfActivitiesLookupRelationshipTask,
    instanceOfActivitiesLookupRelationshipTaskMeta: instanceOfActivitiesLookupRelationshipTaskMeta,
    instanceOfActivitiesLookupRelationshipTaskMetaLookup: instanceOfActivitiesLookupRelationshipTaskMetaLookup,
    instanceOfActivitiesRelationship: instanceOfActivitiesRelationship,
    instanceOfActivitiesRelationshipDataInner: instanceOfActivitiesRelationshipDataInner,
    instanceOfBalance: instanceOfBalance,
    instanceOfBalanceAttributes: instanceOfBalanceAttributes,
    instanceOfBalanceAttributesTimeUnit: instanceOfBalanceAttributesTimeUnit,
    instanceOfBalanceRelationships: instanceOfBalanceRelationships,
    instanceOfBalanceRelationshipsBank: instanceOfBalanceRelationshipsBank,
    instanceOfBalanceRelationshipsBankData: instanceOfBalanceRelationshipsBankData,
    instanceOfBank: instanceOfBank,
    instanceOfBankAttributes: instanceOfBankAttributes,
    instanceOfBankIncludeItem: instanceOfBankIncludeItem,
    instanceOfBankMetadata: instanceOfBankMetadata,
    instanceOfBankMetadataAttributes: instanceOfBankMetadataAttributes,
    instanceOfBankMetadataAttributesBalanceLabel: instanceOfBankMetadataAttributesBalanceLabel,
    instanceOfBankMetadataAttributesDisplayContexts: instanceOfBankMetadataAttributesDisplayContexts,
    instanceOfBankMetadataIncludeItem: instanceOfBankMetadataIncludeItem,
    instanceOfBankMetadataMeta: instanceOfBankMetadataMeta,
    instanceOfBankPolicyRelationship: instanceOfBankPolicyRelationship,
    instanceOfBankPolicyRelationshipData: instanceOfBankPolicyRelationshipData,
    instanceOfBankProjection: instanceOfBankProjection,
    instanceOfBankProjectionAttributes: instanceOfBankProjectionAttributes,
    instanceOfBankProjectionBalanceRelationships: instanceOfBankProjectionBalanceRelationships,
    instanceOfBankProjectionBalanceRelationshipsDataInner: instanceOfBankProjectionBalanceRelationshipsDataInner,
    instanceOfBankProjectionCreateRequest: instanceOfBankProjectionCreateRequest,
    instanceOfBankProjectionCreateRequestData: instanceOfBankProjectionCreateRequestData,
    instanceOfBankProjectionCreateRequestDataAttributes: instanceOfBankProjectionCreateRequestDataAttributes,
    instanceOfBankProjectionEntryRelationships: instanceOfBankProjectionEntryRelationships,
    instanceOfBankProjectionEntryRelationshipsDataInner: instanceOfBankProjectionEntryRelationshipsDataInner,
    instanceOfBankProjectionGapRelationships: instanceOfBankProjectionGapRelationships,
    instanceOfBankProjectionGapRelationshipsDataInner: instanceOfBankProjectionGapRelationshipsDataInner,
    instanceOfBankProjectionMeta: instanceOfBankProjectionMeta,
    instanceOfBankProjectionRequestRelationships: instanceOfBankProjectionRequestRelationships,
    instanceOfBankProjectionResponseRelationships: instanceOfBankProjectionResponseRelationships,
    instanceOfBid: instanceOfBid,
    instanceOfBidAttributes: instanceOfBidAttributes,
    instanceOfBidBlock: instanceOfBidBlock,
    instanceOfBidBlockAttributes: instanceOfBidBlockAttributes,
    instanceOfBidBlocksResponseSchema: instanceOfBidBlocksResponseSchema,
    instanceOfBidMeta: instanceOfBidMeta,
    instanceOfBidOptionsConfiguration: instanceOfBidOptionsConfiguration,
    instanceOfBidPackage: instanceOfBidPackage,
    instanceOfBidPackageAttributes: instanceOfBidPackageAttributes,
    instanceOfBidPackageMeta: instanceOfBidPackageMeta,
    instanceOfBidPackageRelationships: instanceOfBidPackageRelationships,
    instanceOfBidPackageResponseSchema: instanceOfBidPackageResponseSchema,
    instanceOfBidRelationships: instanceOfBidRelationships,
    instanceOfBidRelationshipsBidPackage: instanceOfBidRelationshipsBidPackage,
    instanceOfBidRelationshipsBidSelections: instanceOfBidRelationshipsBidSelections,
    instanceOfBidRelationshipsEmployee: instanceOfBidRelationshipsEmployee,
    instanceOfBidResourceData: instanceOfBidResourceData,
    instanceOfBidResponseSchema: instanceOfBidResponseSchema,
    instanceOfBiddingGroups: instanceOfBiddingGroups,
    instanceOfBiddingGroupsDataInner: instanceOfBiddingGroupsDataInner,
    instanceOfBidsResponseSchema: instanceOfBidsResponseSchema,
    instanceOfCaseType: instanceOfCaseType,
    instanceOfChildGroupPolicy: instanceOfChildGroupPolicy,
    instanceOfClockPunchMetadata: instanceOfClockPunchMetadata,
    instanceOfClockPunchMetadataAttributes: instanceOfClockPunchMetadataAttributes,
    instanceOfClockPunchMetadataRelationships: instanceOfClockPunchMetadataRelationships,
    instanceOfClockPunchMetadataRelationshipsLastPunch: instanceOfClockPunchMetadataRelationshipsLastPunch,
    instanceOfClockPunchMetadataResponseSchema: instanceOfClockPunchMetadataResponseSchema,
    instanceOfCreateBidRequestSchema: instanceOfCreateBidRequestSchema,
    instanceOfCreateBidRequestSchemaData: instanceOfCreateBidRequestSchemaData,
    instanceOfCreateBidpackageRequestSchema: instanceOfCreateBidpackageRequestSchema,
    instanceOfCreateBidpackageRequestSchemaData: instanceOfCreateBidpackageRequestSchemaData,
    instanceOfCreatePayRuleRequestSchema: instanceOfCreatePayRuleRequestSchema,
    instanceOfCreatePayRuleRequestSchemaBody: instanceOfCreatePayRuleRequestSchemaBody,
    instanceOfCreatePayRuleRequestSchemaData: instanceOfCreatePayRuleRequestSchemaData,
    instanceOfCreatePayRuleRequestSchemaDataRelationships: instanceOfCreatePayRuleRequestSchemaDataRelationships,
    instanceOfCreateShiftRelationships: instanceOfCreateShiftRelationships,
    instanceOfCreateShiftRequestSchema: instanceOfCreateShiftRequestSchema,
    instanceOfCreateShiftRequestSchemaBody: instanceOfCreateShiftRequestSchemaBody,
    instanceOfCreateShiftRequestSchemaData: instanceOfCreateShiftRequestSchemaData,
    instanceOfCreateSingleShiftBreak: instanceOfCreateSingleShiftBreak,
    instanceOfCreateTimesheetEntryRequestSchema: instanceOfCreateTimesheetEntryRequestSchema,
    instanceOfCreateTimesheetEntryRequestSchemaData: instanceOfCreateTimesheetEntryRequestSchemaData,
    instanceOfCreatedSwipeResponse: instanceOfCreatedSwipeResponse,
    instanceOfCreatedTimeOffResponse: instanceOfCreatedTimeOffResponse,
    instanceOfDailyDurationQuantity: instanceOfDailyDurationQuantity,
    instanceOfDailyDurationStartTimeQuantity: instanceOfDailyDurationStartTimeQuantity,
    instanceOfDailyDurationTime: instanceOfDailyDurationTime,
    instanceOfDataElement: instanceOfDataElement,
    instanceOfDataElementAttributes: instanceOfDataElementAttributes,
    instanceOfDataV1AbsenceReasonsFilterParameter: instanceOfDataV1AbsenceReasonsFilterParameter,
    instanceOfDataV1CaseChangesFilterParameter: instanceOfDataV1CaseChangesFilterParameter,
    instanceOfDataV1EmployeesFilterParameter: instanceOfDataV1EmployeesFilterParameter,
    instanceOfDayOfWeek: instanceOfDayOfWeek,
    instanceOfDeleteTimesheetEntryRequestSchema: instanceOfDeleteTimesheetEntryRequestSchema,
    instanceOfDeleteTimesheetEntryRequestSchemaData: instanceOfDeleteTimesheetEntryRequestSchemaData,
    instanceOfDiscriminatedFieldValue: instanceOfDiscriminatedFieldValue,
    instanceOfDurationDateTime: instanceOfDurationDateTime,
    instanceOfDurationQuantity: instanceOfDurationQuantity,
    instanceOfEligibleLeaveOverrideDtl: instanceOfEligibleLeaveOverrideDtl,
    instanceOfEmployee: instanceOfEmployee,
    instanceOfEmployeeAttributes: instanceOfEmployeeAttributes,
    instanceOfEmployeeBank: instanceOfEmployeeBank,
    instanceOfEmployeeBankAttributes: instanceOfEmployeeBankAttributes,
    instanceOfEmployeeBankAttributesTimeUnit: instanceOfEmployeeBankAttributesTimeUnit,
    instanceOfEmployeeBankMeta: instanceOfEmployeeBankMeta,
    instanceOfEmployeeBankRelationships: instanceOfEmployeeBankRelationships,
    instanceOfEmployeeCard: instanceOfEmployeeCard,
    instanceOfEmployeeCardAttributes: instanceOfEmployeeCardAttributes,
    instanceOfEmployeeRelationship: instanceOfEmployeeRelationship,
    instanceOfEmployeeRelationshipData: instanceOfEmployeeRelationshipData,
    instanceOfEmployeeRelationships: instanceOfEmployeeRelationships,
    instanceOfEmployeeRelationshipsWithLookup: instanceOfEmployeeRelationshipsWithLookup,
    instanceOfEmployeeRelationshipsWithLookupDataInner: instanceOfEmployeeRelationshipsWithLookupDataInner,
    instanceOfEmployeeRelationshipsWithLookupDataInnerMeta: instanceOfEmployeeRelationshipsWithLookupDataInnerMeta,
    instanceOfEmployeeRelationshipsWithLookupDataInnerMetaLookup: instanceOfEmployeeRelationshipsWithLookupDataInnerMetaLookup,
    instanceOfEmployeesJobResponse: instanceOfEmployeesJobResponse,
    instanceOfEmployeesJobsResponse: instanceOfEmployeesJobsResponse,
    instanceOfEntryType: instanceOfEntryType,
    instanceOfErrorResponse: instanceOfErrorResponse,
    instanceOfErrorSource: instanceOfErrorSource,
    instanceOfExceptionsRelationship: instanceOfExceptionsRelationship,
    instanceOfExceptionsRelationshipDataInner: instanceOfExceptionsRelationshipDataInner,
    instanceOfFieldValue: instanceOfFieldValue,
    instanceOfFormFieldRelationship: instanceOfFormFieldRelationship,
    instanceOfFormFieldRelationshipData: instanceOfFormFieldRelationshipData,
    instanceOfFormFieldsReduced: instanceOfFormFieldsReduced,
    instanceOfFormFieldsReducedAttributes: instanceOfFormFieldsReducedAttributes,
    instanceOfFormFieldsReducedAttributesOptionsInner: instanceOfFormFieldsReducedAttributesOptionsInner,
    instanceOfGeolocation: instanceOfGeolocation,
    instanceOfGetAbsenceCaseQuestionsFilterParameter: instanceOfGetAbsenceCaseQuestionsFilterParameter,
    instanceOfGetAbsenceCaseWorkflowEventsFilterParameter: instanceOfGetAbsenceCaseWorkflowEventsFilterParameter,
    instanceOfGetAbsenceCasesFilterParameter: instanceOfGetAbsenceCasesFilterParameter,
    instanceOfGetAbsenceCasesPageParameter: instanceOfGetAbsenceCasesPageParameter,
    instanceOfGetAbsenceTypesFilterParameter: instanceOfGetAbsenceTypesFilterParameter,
    instanceOfGetBankMetadataFilterParameter: instanceOfGetBankMetadataFilterParameter,
    instanceOfGetBanksFilterParameter: instanceOfGetBanksFilterParameter,
    instanceOfGetJobFilterParameter: instanceOfGetJobFilterParameter,
    instanceOfGetJobsFilterParameter: instanceOfGetJobsFilterParameter,
    instanceOfGetPoliciesFilterParameter: instanceOfGetPoliciesFilterParameter,
    instanceOfGetPolicySetDetailsFilterParameter: instanceOfGetPolicySetDetailsFilterParameter,
    instanceOfGetPolicyTypesFilterParameter: instanceOfGetPolicyTypesFilterParameter,
    instanceOfGetShiftsFilterParameter: instanceOfGetShiftsFilterParameter,
    instanceOfGetTimeEntriesByIdFilterParameter: instanceOfGetTimeEntriesByIdFilterParameter,
    instanceOfGetTimeOffRequestsFilterParameter: instanceOfGetTimeOffRequestsFilterParameter,
    instanceOfGetTimeOffRequestsPageParameter: instanceOfGetTimeOffRequestsPageParameter,
    instanceOfGetTimesheetApprovalLayoutFilterParameter: instanceOfGetTimesheetApprovalLayoutFilterParameter,
    instanceOfGetTimesheetEntriesFilterParameter: instanceOfGetTimesheetEntriesFilterParameter,
    instanceOfGetTimesheetExceptionsFilterParameter: instanceOfGetTimesheetExceptionsFilterParameter,
    instanceOfGetTimesheetsFilterParameter: instanceOfGetTimesheetsFilterParameter,
    instanceOfGroupRelationship: instanceOfGroupRelationship,
    instanceOfGroupRelationshipData: instanceOfGroupRelationshipData,
    instanceOfHelloResponseAttributes: instanceOfHelloResponseAttributes,
    instanceOfHelloResponseSchema: instanceOfHelloResponseSchema,
    instanceOfHelloResponseSchemaData: instanceOfHelloResponseSchemaData,
    instanceOfIncludeParamsForJobsItem: instanceOfIncludeParamsForJobsItem,
    instanceOfIncludedAbsenceTypeInformation: instanceOfIncludedAbsenceTypeInformation,
    instanceOfIncludedAbsenceTypeInformationAttributes: instanceOfIncludedAbsenceTypeInformationAttributes,
    instanceOfIncludedEmployeeInformation: instanceOfIncludedEmployeeInformation,
    instanceOfIncludedEmployeeInformationAttributes: instanceOfIncludedEmployeeInformationAttributes,
    instanceOfIncludedJobInformation: instanceOfIncludedJobInformation,
    instanceOfIncludedJobInformationAttributes: instanceOfIncludedJobInformationAttributes,
    instanceOfIncludedPayCodeWithEntryField: instanceOfIncludedPayCodeWithEntryField,
    instanceOfIncludedPayCodeWithEntryFieldAttributes: instanceOfIncludedPayCodeWithEntryFieldAttributes,
    instanceOfInlineObject: instanceOfInlineObject,
    instanceOfInlineObject1: instanceOfInlineObject1,
    instanceOfInlineObject10: instanceOfInlineObject10,
    instanceOfInlineObject11: instanceOfInlineObject11,
    instanceOfInlineObject1Links: instanceOfInlineObject1Links,
    instanceOfInlineObject1Meta: instanceOfInlineObject1Meta,
    instanceOfInlineObject1MetaPage: instanceOfInlineObject1MetaPage,
    instanceOfInlineObject2: instanceOfInlineObject2,
    instanceOfInlineObject2IncludedInner: instanceOfInlineObject2IncludedInner,
    instanceOfInlineObject3: instanceOfInlineObject3,
    instanceOfInlineObject3IncludedInner: instanceOfInlineObject3IncludedInner,
    instanceOfInlineObject4: instanceOfInlineObject4,
    instanceOfInlineObject4IncludedInner: instanceOfInlineObject4IncludedInner,
    instanceOfInlineObject5: instanceOfInlineObject5,
    instanceOfInlineObject5IncludedInner: instanceOfInlineObject5IncludedInner,
    instanceOfInlineObject6: instanceOfInlineObject6,
    instanceOfInlineObject7: instanceOfInlineObject7,
    instanceOfInlineObject8: instanceOfInlineObject8,
    instanceOfInlineObject8Included: instanceOfInlineObject8Included,
    instanceOfInlineObject9: instanceOfInlineObject9,
    instanceOfInlineObject9IncludedInnerOneOf: instanceOfInlineObject9IncludedInnerOneOf,
    instanceOfInlineObject9IncludedInnerOneOf1: instanceOfInlineObject9IncludedInnerOneOf1,
    instanceOfInlineObjectIncludedInner: instanceOfInlineObjectIncludedInner,
    instanceOfJobAttributes: instanceOfJobAttributes,
    instanceOfJobCard: instanceOfJobCard,
    instanceOfJobCardAttributes: instanceOfJobCardAttributes,
    instanceOfJobRelationship: instanceOfJobRelationship,
    instanceOfJobRelationshipData: instanceOfJobRelationshipData,
    instanceOfJobRelationships: instanceOfJobRelationships,
    instanceOfJobRelationshipsDataInner: instanceOfJobRelationshipsDataInner,
    instanceOfJobResource: instanceOfJobResource,
    instanceOfJobResourceRelationships: instanceOfJobResourceRelationships,
    instanceOfLeaveBalance: instanceOfLeaveBalance,
    instanceOfLeaveEligibility: instanceOfLeaveEligibility,
    instanceOfLeaveEligibilityDetail: instanceOfLeaveEligibilityDetail,
    instanceOfLeaveEligibleOverrideDtl: instanceOfLeaveEligibleOverrideDtl,
    instanceOfLinks: instanceOfLinks,
    instanceOfListBankMetadataResponseSchema: instanceOfListBankMetadataResponseSchema,
    instanceOfListBanksResponseSchema: instanceOfListBanksResponseSchema,
    instanceOfListBidPackagesResponseSchema: instanceOfListBidPackagesResponseSchema,
    instanceOfListDataElementsFilterParameter: instanceOfListDataElementsFilterParameter,
    instanceOfListDataElementsResponseSchema: instanceOfListDataElementsResponseSchema,
    instanceOfListShiftsResponseSchema: instanceOfListShiftsResponseSchema,
    instanceOfMasterPolicy: instanceOfMasterPolicy,
    instanceOfMeta: instanceOfMeta,
    instanceOfModelError: instanceOfModelError,
    instanceOfModule: instanceOfModule,
    instanceOfModuleError: instanceOfModuleError,
    instanceOfNextQuestionOption: instanceOfNextQuestionOption,
    instanceOfNumberFormatOptions: instanceOfNumberFormatOptions,
    instanceOfOverlapRuleInfo: instanceOfOverlapRuleInfo,
    instanceOfOvertimeTypeRelationship: instanceOfOvertimeTypeRelationship,
    instanceOfOvertimeTypeRelationshipData: instanceOfOvertimeTypeRelationshipData,
    instanceOfOvertimeTypeRelationshipDataMeta: instanceOfOvertimeTypeRelationshipDataMeta,
    instanceOfOvertimeTypeRelationshipDataMetaLookup: instanceOfOvertimeTypeRelationshipDataMetaLookup,
    instanceOfPageData: instanceOfPageData,
    instanceOfPageMetadata: instanceOfPageMetadata,
    instanceOfPayCodeCard: instanceOfPayCodeCard,
    instanceOfPayCodeCardAttributes: instanceOfPayCodeCardAttributes,
    instanceOfPayCodeRelationship: instanceOfPayCodeRelationship,
    instanceOfPayCodeRelationshipData: instanceOfPayCodeRelationshipData,
    instanceOfPayCodeRelationships: instanceOfPayCodeRelationships,
    instanceOfPayCodeRelationshipsDataInner: instanceOfPayCodeRelationshipsDataInner,
    instanceOfPayRule: instanceOfPayRule,
    instanceOfPayRuleAttributes: instanceOfPayRuleAttributes,
    instanceOfPayRuleCollectionResponseSchema: instanceOfPayRuleCollectionResponseSchema,
    instanceOfPayRuleConstraint: instanceOfPayRuleConstraint,
    instanceOfPayRuleConstraintAttributes: instanceOfPayRuleConstraintAttributes,
    instanceOfPayRuleConstraintCollectionResponseSchema: instanceOfPayRuleConstraintCollectionResponseSchema,
    instanceOfPayRuleConstraintRelationships: instanceOfPayRuleConstraintRelationships,
    instanceOfPayRuleIncludedObject: instanceOfPayRuleIncludedObject,
    instanceOfPayRuleIncludedObjectAttributes: instanceOfPayRuleIncludedObjectAttributes,
    instanceOfPayRuleKeyValueRelationship: instanceOfPayRuleKeyValueRelationship,
    instanceOfPayRuleKeyValueRelationshipData: instanceOfPayRuleKeyValueRelationshipData,
    instanceOfPayRuleRelationships: instanceOfPayRuleRelationships,
    instanceOfPoliciesResponseSchema: instanceOfPoliciesResponseSchema,
    instanceOfPolicy: instanceOfPolicy,
    instanceOfPolicyAttributes: instanceOfPolicyAttributes,
    instanceOfPolicySetDetailRecord: instanceOfPolicySetDetailRecord,
    instanceOfPolicySetDetails: instanceOfPolicySetDetails,
    instanceOfPolicySetDetailsAttributes: instanceOfPolicySetDetailsAttributes,
    instanceOfPolicySetDetailsResponseSchema: instanceOfPolicySetDetailsResponseSchema,
    instanceOfPolicyType: instanceOfPolicyType,
    instanceOfPolicyTypeAttributes: instanceOfPolicyTypeAttributes,
    instanceOfPolicyTypesResponseSchema: instanceOfPolicyTypesResponseSchema,
    instanceOfPostBankProjectionResponseSchema: instanceOfPostBankProjectionResponseSchema,
    instanceOfPostTimesheetEntryIncludeItem: instanceOfPostTimesheetEntryIncludeItem,
    instanceOfPostTimesheetEntryResponseSchema: instanceOfPostTimesheetEntryResponseSchema,
    instanceOfPostTimesheetEntryResponseSchemaData: instanceOfPostTimesheetEntryResponseSchemaData,
    instanceOfPostTimesheetEntryResponseSchemaDataAttributes: instanceOfPostTimesheetEntryResponseSchemaDataAttributes,
    instanceOfPostTimesheetEntryResponseSchemaDataRelationships: instanceOfPostTimesheetEntryResponseSchemaDataRelationships,
    instanceOfPostTimesheetEntryResponseSchemaIncludedInner: instanceOfPostTimesheetEntryResponseSchemaIncludedInner,
    instanceOfProjectionBalance: instanceOfProjectionBalance,
    instanceOfProjectionBalanceAttributes: instanceOfProjectionBalanceAttributes,
    instanceOfProjectionBalanceRelationships: instanceOfProjectionBalanceRelationships,
    instanceOfProjectionEntry: instanceOfProjectionEntry,
    instanceOfProjectionEntryRelationships: instanceOfProjectionEntryRelationships,
    instanceOfProjectionEntryRelationshipsContent: instanceOfProjectionEntryRelationshipsContent,
    instanceOfProjectionGap: instanceOfProjectionGap,
    instanceOfProjectionGapAttributes: instanceOfProjectionGapAttributes,
    instanceOfProjectionGapRelationships: instanceOfProjectionGapRelationships,
    instanceOfProjectionIncludeItem: instanceOfProjectionIncludeItem,
    instanceOfProjectionOverrides: instanceOfProjectionOverrides,
    instanceOfProjectionScope: instanceOfProjectionScope,
    instanceOfQuestionTreeNodesReduced: instanceOfQuestionTreeNodesReduced,
    instanceOfQuestionTreeNodesReducedAttributes: instanceOfQuestionTreeNodesReducedAttributes,
    instanceOfQuestionTreeNodesRelationship: instanceOfQuestionTreeNodesRelationship,
    instanceOfQuestionTreeNodesRelationshipDataInner: instanceOfQuestionTreeNodesRelationshipDataInner,
    instanceOfRankingMethods: instanceOfRankingMethods,
    instanceOfReasonCodeRelationship: instanceOfReasonCodeRelationship,
    instanceOfReasonCodeRelationshipData: instanceOfReasonCodeRelationshipData,
    instanceOfReasonCodeRelationshipDataMeta: instanceOfReasonCodeRelationshipDataMeta,
    instanceOfReasonCodeRelationshipDataMetaLookup: instanceOfReasonCodeRelationshipDataMetaLookup,
    instanceOfRequestType: instanceOfRequestType,
    instanceOfRoleRelationship: instanceOfRoleRelationship,
    instanceOfRoleRelationshipData: instanceOfRoleRelationshipData,
    instanceOfRoleRelationshipDataMeta: instanceOfRoleRelationshipDataMeta,
    instanceOfRoleRelationshipDataMetaLookup: instanceOfRoleRelationshipDataMetaLookup,
    instanceOfRollbackAbsenceCaseHistoryEventRequest: instanceOfRollbackAbsenceCaseHistoryEventRequest,
    instanceOfRollbackAbsenceCaseHistoryEventRequestData: instanceOfRollbackAbsenceCaseHistoryEventRequestData,
    instanceOfRollbackAbsenceCaseHistoryEventRequestDataAttributes: instanceOfRollbackAbsenceCaseHistoryEventRequestDataAttributes,
    instanceOfRollbackAbsenceCaseHistoryEventRequestDataRelationships: instanceOfRollbackAbsenceCaseHistoryEventRequestDataRelationships,
    instanceOfRollbackAbsenceCaseHistoryEventResponse: instanceOfRollbackAbsenceCaseHistoryEventResponse,
    instanceOfRollbackAbsenceCaseHistoryEventResponseData: instanceOfRollbackAbsenceCaseHistoryEventResponseData,
    instanceOfRollbackAbsenceCaseHistoryEventResponseDataAttributes: instanceOfRollbackAbsenceCaseHistoryEventResponseDataAttributes,
    instanceOfRollbackAbsenceCaseHistoryEventResponseDataRelationships: instanceOfRollbackAbsenceCaseHistoryEventResponseDataRelationships,
    instanceOfRollbackAbsenceCaseHistoryEventResponseIncludedInner: instanceOfRollbackAbsenceCaseHistoryEventResponseIncludedInner,
    instanceOfSaveShiftRequestMetaSchema: instanceOfSaveShiftRequestMetaSchema,
    instanceOfSelectedOverrideChoice: instanceOfSelectedOverrideChoice,
    instanceOfSelectionConstraintRelationship: instanceOfSelectionConstraintRelationship,
    instanceOfSelectionConstraintRelationshipData: instanceOfSelectionConstraintRelationshipData,
    instanceOfSelectionConstraintRelationshipDataMeta: instanceOfSelectionConstraintRelationshipDataMeta,
    instanceOfSelectionConstraintRelationshipDataMetaLookup: instanceOfSelectionConstraintRelationshipDataMetaLookup,
    instanceOfSeverity: instanceOfSeverity,
    instanceOfShiftEmployeeRelationship: instanceOfShiftEmployeeRelationship,
    instanceOfShiftEmployeeRelationshipData: instanceOfShiftEmployeeRelationshipData,
    instanceOfShiftEmployeeRelationshipDataMeta: instanceOfShiftEmployeeRelationshipDataMeta,
    instanceOfShiftEmployeeRelationshipDataMetaLookup: instanceOfShiftEmployeeRelationshipDataMetaLookup,
    instanceOfShiftEventRelationship: instanceOfShiftEventRelationship,
    instanceOfShiftEventRelationshipData: instanceOfShiftEventRelationshipData,
    instanceOfShiftIncludedObject: instanceOfShiftIncludedObject,
    instanceOfSinglePayRuleResponseSchema: instanceOfSinglePayRuleResponseSchema,
    instanceOfSingleShift: instanceOfSingleShift,
    instanceOfSingleShiftAttributes: instanceOfSingleShiftAttributes,
    instanceOfSingleShiftBreak: instanceOfSingleShiftBreak,
    instanceOfSingleShiftRelationships: instanceOfSingleShiftRelationships,
    instanceOfSingleShiftResponseSchema: instanceOfSingleShiftResponseSchema,
    instanceOfStatus: instanceOfStatus,
    instanceOfSubmitTimeOffRequest: instanceOfSubmitTimeOffRequest,
    instanceOfSubmitTimeOffRequestBody: instanceOfSubmitTimeOffRequestBody,
    instanceOfSubmitTimeOffRequestData: instanceOfSubmitTimeOffRequestData,
    instanceOfSubmitTimeOffRequestDataRelationships: instanceOfSubmitTimeOffRequestDataRelationships,
    instanceOfSubmitTimeOffRequestDetail: instanceOfSubmitTimeOffRequestDetail,
    instanceOfSwipe: instanceOfSwipe,
    instanceOfSwipeAttributes: instanceOfSwipeAttributes,
    instanceOfSwipeAttributesSwipeData: instanceOfSwipeAttributesSwipeData,
    instanceOfSwipeRequest: instanceOfSwipeRequest,
    instanceOfSwipeRequestData: instanceOfSwipeRequestData,
    instanceOfTimeEntriesRelationship: instanceOfTimeEntriesRelationship,
    instanceOfTimeEntriesRelationshipDataInner: instanceOfTimeEntriesRelationshipDataInner,
    instanceOfTimeEntryResponse: instanceOfTimeEntryResponse,
    instanceOfTimeEntryResponseDataInner: instanceOfTimeEntryResponseDataInner,
    instanceOfTimeEntryResponseMeta: instanceOfTimeEntryResponseMeta,
    instanceOfTimeEntryResponseMetaPeriodsInner: instanceOfTimeEntryResponseMetaPeriodsInner,
    instanceOfTimeOff: instanceOfTimeOff,
    instanceOfTimeOffRequestDetailsInner: instanceOfTimeOffRequestDetailsInner,
    instanceOfTimeOffRequestEvent: instanceOfTimeOffRequestEvent,
    instanceOfTimeOffRequestEventData: instanceOfTimeOffRequestEventData,
    instanceOfTimeOffRequestEventDataAttributes: instanceOfTimeOffRequestEventDataAttributes,
    instanceOfTimeOffRequestEventDataRelationships: instanceOfTimeOffRequestEventDataRelationships,
    instanceOfTimeOffRequestEventResponse: instanceOfTimeOffRequestEventResponse,
    instanceOfTimeOffRequestEventResponseData: instanceOfTimeOffRequestEventResponseData,
    instanceOfTimeOffRequestEventResponseDataAttributes: instanceOfTimeOffRequestEventResponseDataAttributes,
    instanceOfTimeOffRequestEventResponseDataRelationships: instanceOfTimeOffRequestEventResponseDataRelationships,
    instanceOfTimeOffRequestEventResponseDataRelationshipsEventSubmittedBy: instanceOfTimeOffRequestEventResponseDataRelationshipsEventSubmittedBy,
    instanceOfTimeOffRequestEventResponseDataRelationshipsEventSubmittedByData: instanceOfTimeOffRequestEventResponseDataRelationshipsEventSubmittedByData,
    instanceOfTimeOffRequestException: instanceOfTimeOffRequestException,
    instanceOfTimeOffRequestRelationship: instanceOfTimeOffRequestRelationship,
    instanceOfTimeOffRequestRelationshipData: instanceOfTimeOffRequestRelationshipData,
    instanceOfTimeOffRequestResource: instanceOfTimeOffRequestResource,
    instanceOfTimeOffRequestResourceAttributes: instanceOfTimeOffRequestResourceAttributes,
    instanceOfTimeOffRequestResourceRelationships: instanceOfTimeOffRequestResourceRelationships,
    instanceOfTimeOffRequestResponseAttributes: instanceOfTimeOffRequestResponseAttributes,
    instanceOfTimeOffRequestResponseMeta: instanceOfTimeOffRequestResponseMeta,
    instanceOfTimeOffRequestResponseRelationships: instanceOfTimeOffRequestResponseRelationships,
    instanceOfTimesheetApprovalLayoutResponse: instanceOfTimesheetApprovalLayoutResponse,
    instanceOfTimesheetApprovalLayoutResponseDataInner: instanceOfTimesheetApprovalLayoutResponseDataInner,
    instanceOfTimesheetApprovalLayoutResponseDataInnerAttributes: instanceOfTimesheetApprovalLayoutResponseDataInnerAttributes,
    instanceOfTimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInner: instanceOfTimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInner,
    instanceOfTimesheetEntryAttributesRequestSchema: instanceOfTimesheetEntryAttributesRequestSchema,
    instanceOfTimesheetEntryData: instanceOfTimesheetEntryData,
    instanceOfTimesheetEntryDataIncludedInner: instanceOfTimesheetEntryDataIncludedInner,
    instanceOfTimesheetEntryIncludeItem: instanceOfTimesheetEntryIncludeItem,
    instanceOfTimesheetEntryRelationshipsRequestSchema: instanceOfTimesheetEntryRelationshipsRequestSchema,
    instanceOfTimesheetEntryResource: instanceOfTimesheetEntryResource,
    instanceOfTimesheetEntryResourceAttributes: instanceOfTimesheetEntryResourceAttributes,
    instanceOfTimesheetEntryResourceMeta: instanceOfTimesheetEntryResourceMeta,
    instanceOfTimesheetEntryResourceRelationships: instanceOfTimesheetEntryResourceRelationships,
    instanceOfTimesheetException: instanceOfTimesheetException,
    instanceOfTimesheetExceptionAttributes: instanceOfTimesheetExceptionAttributes,
    instanceOfTimesheetExceptionPatchRequest: instanceOfTimesheetExceptionPatchRequest,
    instanceOfTimesheetExceptionPatchRequestData: instanceOfTimesheetExceptionPatchRequestData,
    instanceOfTimesheetExceptionPatchRequestDataAttributes: instanceOfTimesheetExceptionPatchRequestDataAttributes,
    instanceOfTimesheetExceptionRelationships: instanceOfTimesheetExceptionRelationships,
    instanceOfTimesheetExceptionsMeta: instanceOfTimesheetExceptionsMeta,
    instanceOfTimesheetExceptionsResponseSchema: instanceOfTimesheetExceptionsResponseSchema,
    instanceOfTimesheetIncludeItem: instanceOfTimesheetIncludeItem,
    instanceOfTimesheetRelationship: instanceOfTimesheetRelationship,
    instanceOfTimesheetRelationshipData: instanceOfTimesheetRelationshipData,
    instanceOfTimesheetResponse: instanceOfTimesheetResponse,
    instanceOfTimesheetResponseIncludedInner: instanceOfTimesheetResponseIncludedInner,
    instanceOfTimesheetSchema: instanceOfTimesheetSchema,
    instanceOfTimesheetSchemaAttributes: instanceOfTimesheetSchemaAttributes,
    instanceOfTimesheetSchemaAttributesApprovalData: instanceOfTimesheetSchemaAttributesApprovalData,
    instanceOfTimesheetSchemaAttributesTimesheetState: instanceOfTimesheetSchemaAttributesTimesheetState,
    instanceOfTimesheetSchemaMeta: instanceOfTimesheetSchemaMeta,
    instanceOfTimesheetSchemaRelationships: instanceOfTimesheetSchemaRelationships,
    instanceOfUpdateAbsenceCaseOperation: instanceOfUpdateAbsenceCaseOperation,
    instanceOfUpdateAbsenceCaseOperationData: instanceOfUpdateAbsenceCaseOperationData,
    instanceOfUpdateCaseManagerOperation: instanceOfUpdateCaseManagerOperation,
    instanceOfUpdateCaseManagerOperationDataInner: instanceOfUpdateCaseManagerOperationDataInner,
    instanceOfUpdateCaseManagerOperationRef: instanceOfUpdateCaseManagerOperationRef,
    instanceOfUpdateLeaveEligibilityOperation: instanceOfUpdateLeaveEligibilityOperation,
    instanceOfUpdateLeaveEligibilityOperationData: instanceOfUpdateLeaveEligibilityOperationData,
    instanceOfUpdateLeaveEligibilityOperationDataAttributes: instanceOfUpdateLeaveEligibilityOperationDataAttributes,
    instanceOfUpdatePayRuleRequestSchema: instanceOfUpdatePayRuleRequestSchema,
    instanceOfUpdatePayRuleRequestSchemaBody: instanceOfUpdatePayRuleRequestSchemaBody,
    instanceOfUpdatePayRuleRequestSchemaData: instanceOfUpdatePayRuleRequestSchemaData,
    instanceOfUpdateProjectedUsageOperation: instanceOfUpdateProjectedUsageOperation,
    instanceOfUpdateProjectedUsageOperationData: instanceOfUpdateProjectedUsageOperationData,
    instanceOfUpdateShiftRelationships: instanceOfUpdateShiftRelationships,
    instanceOfUpdateShiftRequestSchema: instanceOfUpdateShiftRequestSchema,
    instanceOfUpdateShiftRequestSchemaBody: instanceOfUpdateShiftRequestSchemaBody,
    instanceOfUpdateShiftRequestSchemaData: instanceOfUpdateShiftRequestSchemaData,
    instanceOfUpdateTimesheetEntryRequestSchema: instanceOfUpdateTimesheetEntryRequestSchema,
    instanceOfUpdateTimesheetEntryRequestSchemaData: instanceOfUpdateTimesheetEntryRequestSchemaData,
    instanceOfUserCard: instanceOfUserCard,
    instanceOfUserCardAttributes: instanceOfUserCardAttributes,
    instanceOfUserRelationships: instanceOfUserRelationships,
    instanceOfUserRelationshipsDataInner: instanceOfUserRelationshipsDataInner,
    instanceOfWeeklyLimitsInner: instanceOfWeeklyLimitsInner
});

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 */
var AdminAPIsApi = /** @class */ (function (_super) {
    __extends(AdminAPIsApi, _super);
    function AdminAPIsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Post the bid package creation, the API will return a `Location` header if the bid package is created immediately.
     * Create a bid package
     */
    AdminAPIsApi.prototype.createBidPackageRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, context, init;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/vnd.api+json';
                        urlPath = "/admin/v1/bid-packages";
                        context = {
                            path: urlPath,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: CreateBidpackageRequestSchemaToJSON(requestParameters['createBidpackageRequestSchema']),
                        };
                        return [4 /*yield*/, this.createApiRequestInit(context, initOverrides)];
                    case 1:
                        init = _a.sent();
                        return [2 /*return*/, this.request(context, init)
                                .catch(function (error) {
                                _this.reportApiNetworkError(init.handleErrors);
                                throw new FetchError(error);
                            })
                                .then(function (response) {
                                switch (response.status) {
                                    case 201: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return BidPackageResponseSchemaFromJSON(jsonValue); });
                                        return processedResponse;
                                    }
                                    case 400: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 401: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 403: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 404: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 500: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    default: {
                                        var processedResponse = new VoidApiResponse(response);
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                }
                            })];
                }
            });
        });
    };
    /**
     * Post the bid package creation, the API will return a `Location` header if the bid package is created immediately.
     * Create a bid package
     */
    AdminAPIsApi.prototype.createBidPackage = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createBidPackageRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Fetches a bid package.
     * Get bid package
     */
    AdminAPIsApi.prototype.getBidPackageRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, context, init;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['bidPackageId'] == null) {
                            throw new RequiredError('bidPackageId', 'Required parameter "bidPackageId" was null or undefined when calling getBidPackage().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        urlPath = "/admin/v1/bid-packages/{bidPackageId}";
                        urlPath = urlPath.replace("{" + "bidPackageId" + "}", encodeURIComponent(String(requestParameters['bidPackageId'])));
                        context = {
                            path: urlPath,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        };
                        return [4 /*yield*/, this.createApiRequestInit(context, initOverrides)];
                    case 1:
                        init = _a.sent();
                        return [2 /*return*/, this.request(context, init)
                                .catch(function (error) {
                                _this.reportApiNetworkError(init.handleErrors);
                                throw new FetchError(error);
                            })
                                .then(function (response) {
                                switch (response.status) {
                                    case 200: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return BidPackageResponseSchemaFromJSON(jsonValue); });
                                        return processedResponse;
                                    }
                                    case 400: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 401: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 403: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 404: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 500: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    default: {
                                        var processedResponse = new VoidApiResponse(response);
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                }
                            })];
                }
            });
        });
    };
    /**
     * Fetches a bid package.
     * Get bid package
     */
    AdminAPIsApi.prototype.getBidPackage = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBidPackageRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve all bid packages.
     * List all bid packages
     */
    AdminAPIsApi.prototype.listBidPackagesRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, context, init;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        urlPath = "/admin/v1/bid-packages";
                        context = {
                            path: urlPath,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        };
                        return [4 /*yield*/, this.createApiRequestInit(context, initOverrides)];
                    case 1:
                        init = _a.sent();
                        return [2 /*return*/, this.request(context, init)
                                .catch(function (error) {
                                _this.reportApiNetworkError(init.handleErrors);
                                throw new FetchError(error);
                            })
                                .then(function (response) {
                                switch (response.status) {
                                    case 200: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ListBidPackagesResponseSchemaFromJSON(jsonValue); });
                                        return processedResponse;
                                    }
                                    case 400: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 401: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 403: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 404: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 500: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    default: {
                                        var processedResponse = new VoidApiResponse(response);
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                }
                            })];
                }
            });
        });
    };
    /**
     * Retrieve all bid packages.
     * List all bid packages
     */
    AdminAPIsApi.prototype.listBidPackages = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listBidPackagesRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates a bid package.
     * Update a bid package
     */
    AdminAPIsApi.prototype.updateBidPackageRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, context, init;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['bidPackageId'] == null) {
                            throw new RequiredError('bidPackageId', 'Required parameter "bidPackageId" was null or undefined when calling updateBidPackage().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/vnd.api+json';
                        urlPath = "/admin/v1/bid-packages/{bidPackageId}";
                        urlPath = urlPath.replace("{" + "bidPackageId" + "}", encodeURIComponent(String(requestParameters['bidPackageId'])));
                        context = {
                            path: urlPath,
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: BidPackageResponseSchemaToJSON(requestParameters['bidPackageResponseSchema']),
                        };
                        return [4 /*yield*/, this.createApiRequestInit(context, initOverrides)];
                    case 1:
                        init = _a.sent();
                        return [2 /*return*/, this.request(context, init)
                                .catch(function (error) {
                                _this.reportApiNetworkError(init.handleErrors);
                                throw new FetchError(error);
                            })
                                .then(function (response) {
                                switch (response.status) {
                                    case 200: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return BidPackageResponseSchemaFromJSON(jsonValue); });
                                        return processedResponse;
                                    }
                                    case 400: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 401: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 403: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 404: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 409: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 500: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    default: {
                                        var processedResponse = new VoidApiResponse(response);
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                }
                            })];
                }
            });
        });
    };
    /**
     * Updates a bid package.
     * Update a bid package
     */
    AdminAPIsApi.prototype.updateBidPackage = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateBidPackageRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return AdminAPIsApi;
}(BaseAPI));

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 */
var ConfigAPIsApi = /** @class */ (function (_super) {
    __extends(ConfigAPIsApi, _super);
    function ConfigAPIsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new pay rule in the system.
     * Create a new pay rule
     */
    ConfigAPIsApi.prototype.createPayRuleRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, context, init;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/vnd.api+json';
                        urlPath = "/config/v1/pay-rules";
                        context = {
                            path: urlPath,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: CreatePayRuleRequestSchemaToJSON(requestParameters['createPayRuleRequestSchema']),
                        };
                        return [4 /*yield*/, this.createApiRequestInit(context, initOverrides)];
                    case 1:
                        init = _a.sent();
                        return [2 /*return*/, this.request(context, init)
                                .catch(function (error) {
                                _this.reportApiNetworkError(init.handleErrors);
                                throw new FetchError(error);
                            })
                                .then(function (response) {
                                switch (response.status) {
                                    case 201: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return SinglePayRuleResponseSchemaFromJSON(jsonValue); });
                                        return processedResponse;
                                    }
                                    case 400: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 401: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 403: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 500: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    default: {
                                        var processedResponse = new VoidApiResponse(response);
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                }
                            })];
                }
            });
        });
    };
    /**
     * Create a new pay rule in the system.
     * Create a new pay rule
     */
    ConfigAPIsApi.prototype.createPayRule = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createPayRuleRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a pay rule by id.
     * Delete a pay rule
     */
    ConfigAPIsApi.prototype.deletePayRuleRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, context, init;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['payRuleId'] == null) {
                            throw new RequiredError('payRuleId', 'Required parameter "payRuleId" was null or undefined when calling deletePayRule().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        urlPath = "/config/v1/pay-rules/{payRuleId}";
                        urlPath = urlPath.replace("{" + "payRuleId" + "}", encodeURIComponent(String(requestParameters['payRuleId'])));
                        context = {
                            path: urlPath,
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        };
                        return [4 /*yield*/, this.createApiRequestInit(context, initOverrides)];
                    case 1:
                        init = _a.sent();
                        return [2 /*return*/, this.request(context, init)
                                .catch(function (error) {
                                _this.reportApiNetworkError(init.handleErrors);
                                throw new FetchError(error);
                            })
                                .then(function (response) {
                                switch (response.status) {
                                    case 204: {
                                        var processedResponse = new VoidApiResponse(response);
                                        return processedResponse;
                                    }
                                    case 400: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 401: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 403: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 404: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 500: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    default: {
                                        var processedResponse = new VoidApiResponse(response);
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                }
                            })];
                }
            });
        });
    };
    /**
     * Delete a pay rule by id.
     * Delete a pay rule
     */
    ConfigAPIsApi.prototype.deletePayRule = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deletePayRuleRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve all pay rule constraints in the system.
     * Get pay rule constraints
     */
    ConfigAPIsApi.prototype.getPayRuleConstraintsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, context, init;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters['page'] != null) {
                            queryParameters['page'] = requestParameters['page'];
                        }
                        headerParameters = {};
                        urlPath = "/config/v1/pay-rule-constraints";
                        context = {
                            path: urlPath,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        };
                        return [4 /*yield*/, this.createApiRequestInit(context, initOverrides)];
                    case 1:
                        init = _a.sent();
                        return [2 /*return*/, this.request(context, init)
                                .catch(function (error) {
                                _this.reportApiNetworkError(init.handleErrors);
                                throw new FetchError(error);
                            })
                                .then(function (response) {
                                switch (response.status) {
                                    case 200: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return PayRuleConstraintCollectionResponseSchemaFromJSON(jsonValue); });
                                        return processedResponse;
                                    }
                                    case 400: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 401: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 403: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 500: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    default: {
                                        var processedResponse = new VoidApiResponse(response);
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                }
                            })];
                }
            });
        });
    };
    /**
     * Retrieve all pay rule constraints in the system.
     * Get pay rule constraints
     */
    ConfigAPIsApi.prototype.getPayRuleConstraints = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPayRuleConstraintsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve all pay rules in the system.
     * Get pay rules
     */
    ConfigAPIsApi.prototype.getPayRulesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, context, init;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters['page'] != null) {
                            queryParameters['page'] = requestParameters['page'];
                        }
                        headerParameters = {};
                        urlPath = "/config/v1/pay-rules";
                        context = {
                            path: urlPath,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        };
                        return [4 /*yield*/, this.createApiRequestInit(context, initOverrides)];
                    case 1:
                        init = _a.sent();
                        return [2 /*return*/, this.request(context, init)
                                .catch(function (error) {
                                _this.reportApiNetworkError(init.handleErrors);
                                throw new FetchError(error);
                            })
                                .then(function (response) {
                                switch (response.status) {
                                    case 200: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return PayRuleCollectionResponseSchemaFromJSON(jsonValue); });
                                        return processedResponse;
                                    }
                                    case 400: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 401: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 403: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 500: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    default: {
                                        var processedResponse = new VoidApiResponse(response);
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                }
                            })];
                }
            });
        });
    };
    /**
     * Retrieve all pay rules in the system.
     * Get pay rules
     */
    ConfigAPIsApi.prototype.getPayRules = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPayRulesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update an existing pay rule.
     * Update a pay rule
     */
    ConfigAPIsApi.prototype.patchPayRuleRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, context, init;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['payRuleId'] == null) {
                            throw new RequiredError('payRuleId', 'Required parameter "payRuleId" was null or undefined when calling patchPayRule().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/vnd.api+json';
                        urlPath = "/config/v1/pay-rules/{payRuleId}";
                        urlPath = urlPath.replace("{" + "payRuleId" + "}", encodeURIComponent(String(requestParameters['payRuleId'])));
                        context = {
                            path: urlPath,
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: UpdatePayRuleRequestSchemaToJSON(requestParameters['updatePayRuleRequestSchema']),
                        };
                        return [4 /*yield*/, this.createApiRequestInit(context, initOverrides)];
                    case 1:
                        init = _a.sent();
                        return [2 /*return*/, this.request(context, init)
                                .catch(function (error) {
                                _this.reportApiNetworkError(init.handleErrors);
                                throw new FetchError(error);
                            })
                                .then(function (response) {
                                switch (response.status) {
                                    case 200: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return SinglePayRuleResponseSchemaFromJSON(jsonValue); });
                                        return processedResponse;
                                    }
                                    case 400: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 401: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 403: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 404: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 409: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 500: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    default: {
                                        var processedResponse = new VoidApiResponse(response);
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                }
                            })];
                }
            });
        });
    };
    /**
     * Update an existing pay rule.
     * Update a pay rule
     */
    ConfigAPIsApi.prototype.patchPayRule = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.patchPayRuleRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return ConfigAPIsApi;
}(BaseAPI));

/* tslint:disable */
/* eslint-disable */
/**
 * WorkForce Suite APIs
 * The specification for the complete set of WorkForce Suite APIs.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: wfs-support@workforcesoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 */
var DataAPIsApi = /** @class */ (function (_super) {
    __extends(DataAPIsApi, _super);
    function DataAPIsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Post the Absence Case creation, the API will return a Absence Case Response if the Absence Case is created immediately.
     * Create an Absence Case
     */
    DataAPIsApi.prototype.createAbsenceCaseRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, context, init;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/vnd.api+json';
                        urlPath = "/data/v1/absence-cases";
                        context = {
                            path: urlPath,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: AbsenceCreateCaseRequestToJSON(requestParameters['absenceCreateCaseRequest']),
                        };
                        return [4 /*yield*/, this.createApiRequestInit(context, initOverrides)];
                    case 1:
                        init = _a.sent();
                        return [2 /*return*/, this.request(context, init)
                                .catch(function (error) {
                                _this.reportApiNetworkError(init.handleErrors);
                                throw new FetchError(error);
                            })
                                .then(function (response) {
                                switch (response.status) {
                                    case 201: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return AbsenceCreateCaseResponseFromJSON(jsonValue); });
                                        return processedResponse;
                                    }
                                    case 400: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 401: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 403: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 404: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 500: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    default: {
                                        var processedResponse = new VoidApiResponse(response);
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                }
                            })];
                }
            });
        });
    };
    /**
     * Post the Absence Case creation, the API will return a Absence Case Response if the Absence Case is created immediately.
     * Create an Absence Case
     */
    DataAPIsApi.prototype.createAbsenceCase = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createAbsenceCaseRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete shift. The API will allow the deleting of an existing shift record.
     * Delete a shift
     */
    DataAPIsApi.prototype.deleteShiftRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, context, init;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['shiftId'] == null) {
                            throw new RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling deleteShift().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        urlPath = "/data/v1/shifts/{shiftId}";
                        urlPath = urlPath.replace("{" + "shiftId" + "}", encodeURIComponent(String(requestParameters['shiftId'])));
                        context = {
                            path: urlPath,
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        };
                        return [4 /*yield*/, this.createApiRequestInit(context, initOverrides)];
                    case 1:
                        init = _a.sent();
                        return [2 /*return*/, this.request(context, init)
                                .catch(function (error) {
                                _this.reportApiNetworkError(init.handleErrors);
                                throw new FetchError(error);
                            })
                                .then(function (response) {
                                switch (response.status) {
                                    case 204: {
                                        var processedResponse = new VoidApiResponse(response);
                                        return processedResponse;
                                    }
                                    case 400: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 401: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 403: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 404: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 409: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 500: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    default: {
                                        var processedResponse = new VoidApiResponse(response);
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                }
                            })];
                }
            });
        });
    };
    /**
     * Delete shift. The API will allow the deleting of an existing shift record.
     * Delete a shift
     */
    DataAPIsApi.prototype.deleteShift = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteShiftRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the raw binary content of a document attached to an absence case.
     * Download absence case document content
     */
    DataAPIsApi.prototype.getAbsenceCaseDocumentContentRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, context, init;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['documentId'] == null) {
                            throw new RequiredError('documentId', 'Required parameter "documentId" was null or undefined when calling getAbsenceCaseDocumentContent().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        urlPath = "/data/v1/documents/{documentId}";
                        urlPath = urlPath.replace("{" + "documentId" + "}", encodeURIComponent(String(requestParameters['documentId'])));
                        context = {
                            path: urlPath,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        };
                        return [4 /*yield*/, this.createApiRequestInit(context, initOverrides)];
                    case 1:
                        init = _a.sent();
                        return [2 /*return*/, this.request(context, init)
                                .catch(function (error) {
                                _this.reportApiNetworkError(init.handleErrors);
                                throw new FetchError(error);
                            })
                                .then(function (response) {
                                switch (response.status) {
                                    case 200: {
                                        var processedResponse = new BlobApiResponse(response);
                                        return processedResponse;
                                    }
                                    case 400: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 401: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 403: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 404: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 500: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    default: {
                                        var processedResponse = new VoidApiResponse(response);
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                }
                            })];
                }
            });
        });
    };
    /**
     * Returns the raw binary content of a document attached to an absence case.
     * Download absence case document content
     */
    DataAPIsApi.prototype.getAbsenceCaseDocumentContent = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAbsenceCaseDocumentContentRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve **bank metadata** for an employee. This endpoint provides display and formatting information for banks.  Use this alongside the Bank and Projection APIs to properly format and label balance data for presentation to the user.  **Behavior**: - Exactly one of `employeeId` or `clientPersonId` must be provided; providing both results in an error. - If the employee has multiple jobs and no `filter[jobId]` is specified, returns   bank metadata for all jobs. - If `filter[asOfDate]` is not specified, uses today\'s date. - If the specified `filter[jobId]` does not exist, returns a 404 error. - If the specified `filter[jobId]` does not belong to the given employee, returns a 400 validation error. - If the calling user is not delegated to the specified employee, returns a 403 error.
     * Retrieve Bank Metadata
     */
    DataAPIsApi.prototype.getBankMetadataRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, context, init;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['filter'] == null) {
                            throw new RequiredError('filter', 'Required parameter "filter" was null or undefined when calling getBankMetadata().');
                        }
                        queryParameters = {};
                        if (requestParameters['filter'] != null) {
                            queryParameters['filter'] = requestParameters['filter'];
                        }
                        if (requestParameters['include'] != null) {
                            queryParameters['include'] = requestParameters['include'].join(COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters['page'] != null) {
                            queryParameters['page'] = requestParameters['page'];
                        }
                        headerParameters = {};
                        urlPath = "/data/v1/bank-metadata";
                        context = {
                            path: urlPath,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        };
                        return [4 /*yield*/, this.createApiRequestInit(context, initOverrides)];
                    case 1:
                        init = _a.sent();
                        return [2 /*return*/, this.request(context, init)
                                .catch(function (error) {
                                _this.reportApiNetworkError(init.handleErrors);
                                throw new FetchError(error);
                            })
                                .then(function (response) {
                                switch (response.status) {
                                    case 200: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ListBankMetadataResponseSchemaFromJSON(jsonValue); });
                                        return processedResponse;
                                    }
                                    case 400: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 401: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 403: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 404: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 500: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    default: {
                                        var processedResponse = new VoidApiResponse(response);
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                }
                            })];
                }
            });
        });
    };
    /**
     * Retrieve **bank metadata** for an employee. This endpoint provides display and formatting information for banks.  Use this alongside the Bank and Projection APIs to properly format and label balance data for presentation to the user.  **Behavior**: - Exactly one of `employeeId` or `clientPersonId` must be provided; providing both results in an error. - If the employee has multiple jobs and no `filter[jobId]` is specified, returns   bank metadata for all jobs. - If `filter[asOfDate]` is not specified, uses today\'s date. - If the specified `filter[jobId]` does not exist, returns a 404 error. - If the specified `filter[jobId]` does not belong to the given employee, returns a 400 validation error. - If the calling user is not delegated to the specified employee, returns a 403 error.
     * Retrieve Bank Metadata
     */
    DataAPIsApi.prototype.getBankMetadata = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBankMetadataRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve all **banks** that a user has access to.  **Banks** are responsible for generating and storing **balances**. They allow for the configuration of rules dictating how accrual, withdrawal, clearing, and transferring between other banks occurs. Once properly configured and associated with jobs, they automatically show up and are used in a variety of different contexts by the system.  The core **bank** object allows retrieval of current bank balances. For more flexible, but also more verbose, retrieval of historical, future, and forecasted bank data, please take a look at the **Bank Projection API**.  Note that this is currently a **read-only** collection that is ultimately generated by the user\'s underlying source system. The UUID is guaranteed to be stable.  **Supported Filter Parameters**: - Employee ID – Filter for all banks **associated with a specific employee** by their UUID. - Client Person ID – Filter for all banks **associated with a specific employee** by their   client-assigned person identifier (display employee ID). - Job – Filter for all banks **associated with a specific job.** - Bank Set – Filter banks by predefined set using `filter[bankSet]` (`timeOff`, `timeSheet`, `bankCard`). Multiple values are unioned together. - Bank Policy IDs – Filter banks by explicit policy identifiers using `filter[bankPolicyIds]`. Can be combined with `filter[bankSet]` for intersection filtering.  Either `employeeId` or `clientPersonId` must be provided. These are mutually exclusive — providing both will result in a 400 error.  **Default Sorting Behavior**: - `jobId`, `bankPolicyId` are used to sort. `bankPolicyId` is the primary sort key and   `jobId` is used to guarantee uniqueness.  **Cursor Structure**: - The cursor associated with this resource uses a **base64 encoded string** that is   provided using the `next` and `prev` fields of the response.
     * Retrieve Banks
     */
    DataAPIsApi.prototype.getBanksRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, context, init;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['filter'] == null) {
                            throw new RequiredError('filter', 'Required parameter "filter" was null or undefined when calling getBanks().');
                        }
                        queryParameters = {};
                        if (requestParameters['page'] != null) {
                            queryParameters['page'] = requestParameters['page'];
                        }
                        if (requestParameters['include'] != null) {
                            queryParameters['include'] = requestParameters['include'].join(COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters['filter'] != null) {
                            queryParameters['filter'] = requestParameters['filter'];
                        }
                        headerParameters = {};
                        urlPath = "/data/v1/banks";
                        context = {
                            path: urlPath,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        };
                        return [4 /*yield*/, this.createApiRequestInit(context, initOverrides)];
                    case 1:
                        init = _a.sent();
                        return [2 /*return*/, this.request(context, init)
                                .catch(function (error) {
                                _this.reportApiNetworkError(init.handleErrors);
                                throw new FetchError(error);
                            })
                                .then(function (response) {
                                switch (response.status) {
                                    case 200: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ListBanksResponseSchemaFromJSON(jsonValue); });
                                        return processedResponse;
                                    }
                                    case 400: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 401: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 403: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 500: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    default: {
                                        var processedResponse = new VoidApiResponse(response);
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                }
                            })];
                }
            });
        });
    };
    /**
     * Retrieve all **banks** that a user has access to.  **Banks** are responsible for generating and storing **balances**. They allow for the configuration of rules dictating how accrual, withdrawal, clearing, and transferring between other banks occurs. Once properly configured and associated with jobs, they automatically show up and are used in a variety of different contexts by the system.  The core **bank** object allows retrieval of current bank balances. For more flexible, but also more verbose, retrieval of historical, future, and forecasted bank data, please take a look at the **Bank Projection API**.  Note that this is currently a **read-only** collection that is ultimately generated by the user\'s underlying source system. The UUID is guaranteed to be stable.  **Supported Filter Parameters**: - Employee ID – Filter for all banks **associated with a specific employee** by their UUID. - Client Person ID – Filter for all banks **associated with a specific employee** by their   client-assigned person identifier (display employee ID). - Job – Filter for all banks **associated with a specific job.** - Bank Set – Filter banks by predefined set using `filter[bankSet]` (`timeOff`, `timeSheet`, `bankCard`). Multiple values are unioned together. - Bank Policy IDs – Filter banks by explicit policy identifiers using `filter[bankPolicyIds]`. Can be combined with `filter[bankSet]` for intersection filtering.  Either `employeeId` or `clientPersonId` must be provided. These are mutually exclusive — providing both will result in a 400 error.  **Default Sorting Behavior**: - `jobId`, `bankPolicyId` are used to sort. `bankPolicyId` is the primary sort key and   `jobId` is used to guarantee uniqueness.  **Cursor Structure**: - The cursor associated with this resource uses a **base64 encoded string** that is   provided using the `next` and `prev` fields of the response.
     * Retrieve Banks
     */
    DataAPIsApi.prototype.getBanks = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBanksRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get the list of bids. The API will return the list of bids.
     * Get bids based on bidPackageId
     */
    DataAPIsApi.prototype.getBidsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, context, init;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['bidPackageId'] == null) {
                            throw new RequiredError('bidPackageId', 'Required parameter "bidPackageId" was null or undefined when calling getBids().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        urlPath = "/data/v1/bids/{bidPackageId}";
                        urlPath = urlPath.replace("{" + "bidPackageId" + "}", encodeURIComponent(String(requestParameters['bidPackageId'])));
                        context = {
                            path: urlPath,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        };
                        return [4 /*yield*/, this.createApiRequestInit(context, initOverrides)];
                    case 1:
                        init = _a.sent();
                        return [2 /*return*/, this.request(context, init)
                                .catch(function (error) {
                                _this.reportApiNetworkError(init.handleErrors);
                                throw new FetchError(error);
                            })
                                .then(function (response) {
                                switch (response.status) {
                                    case 200: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return BidsResponseSchemaFromJSON(jsonValue); });
                                        return processedResponse;
                                    }
                                    case 400: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 401: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 403: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 404: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 500: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    default: {
                                        var processedResponse = new VoidApiResponse(response);
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                }
                            })];
                }
            });
        });
    };
    /**
     * Get the list of bids. The API will return the list of bids.
     * Get bids based on bidPackageId
     */
    DataAPIsApi.prototype.getBids = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBidsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieves the WT&A accrual bank balances for an employee. An error response will be returned if no `clientPersonId` is specified in the filter parameter. This API does not include balances related to scheduling, absences, or dynamic banks. A balance will be provided for each bank based on the `asOfDate` specified. If no date is provided, the balance as of the current date (GMT) will be returned.
     * Retrieve Employee Balances by clientPersonId
     */
    DataAPIsApi.prototype.getEmployeeBalancesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, context, init;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters['filter'] != null) {
                            queryParameters['filter'] = requestParameters['filter'];
                        }
                        if (requestParameters['fields'] != null) {
                            queryParameters['fields'] = requestParameters['fields'];
                        }
                        headerParameters = {};
                        urlPath = "/data/v1/employees/balances";
                        context = {
                            path: urlPath,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        };
                        return [4 /*yield*/, this.createApiRequestInit(context, initOverrides)];
                    case 1:
                        init = _a.sent();
                        return [2 /*return*/, this.request(context, init)
                                .catch(function (error) {
                                _this.reportApiNetworkError(init.handleErrors);
                                throw new FetchError(error);
                            })
                                .then(function (response) {
                                switch (response.status) {
                                    case 200: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return InlineObjectFromJSON(jsonValue); });
                                        return processedResponse;
                                    }
                                    case 400: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 401: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 403: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 404: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 500: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    default: {
                                        var processedResponse = new VoidApiResponse(response);
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                }
                            })];
                }
            });
        });
    };
    /**
     * Retrieves the WT&A accrual bank balances for an employee. An error response will be returned if no `clientPersonId` is specified in the filter parameter. This API does not include balances related to scheduling, absences, or dynamic banks. A balance will be provided for each bank based on the `asOfDate` specified. If no date is provided, the balance as of the current date (GMT) will be returned.
     * Retrieve Employee Balances by clientPersonId
     */
    DataAPIsApi.prototype.getEmployeeBalances = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getEmployeeBalancesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieves the WT&A accrual bank balances for the specified employee GUID. This does not include balances related to scheduling, absences, or dynamic banks. A balance will be provided for each bank based on the `asOfDate` specified. If no date is provided, the balance as of the current date (GMT) will be returned.
     * Retrieve Employee Balances by GUID
     */
    DataAPIsApi.prototype.getEmployeeBalancesByGuidRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, context, init;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['employeeGuid'] == null) {
                            throw new RequiredError('employeeGuid', 'Required parameter "employeeGuid" was null or undefined when calling getEmployeeBalancesByGuid().');
                        }
                        queryParameters = {};
                        if (requestParameters['filter'] != null) {
                            queryParameters['filter'] = requestParameters['filter'];
                        }
                        if (requestParameters['fields'] != null) {
                            queryParameters['fields'] = requestParameters['fields'];
                        }
                        headerParameters = {};
                        urlPath = "/data/v1/employees/{employeeGuid}/balances";
                        urlPath = urlPath.replace("{" + "employeeGuid" + "}", encodeURIComponent(String(requestParameters['employeeGuid'])));
                        context = {
                            path: urlPath,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        };
                        return [4 /*yield*/, this.createApiRequestInit(context, initOverrides)];
                    case 1:
                        init = _a.sent();
                        return [2 /*return*/, this.request(context, init)
                                .catch(function (error) {
                                _this.reportApiNetworkError(init.handleErrors);
                                throw new FetchError(error);
                            })
                                .then(function (response) {
                                switch (response.status) {
                                    case 200: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return InlineObjectFromJSON(jsonValue); });
                                        return processedResponse;
                                    }
                                    case 400: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 401: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 403: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 404: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 500: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    default: {
                                        var processedResponse = new VoidApiResponse(response);
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                }
                            })];
                }
            });
        });
    };
    /**
     * Retrieves the WT&A accrual bank balances for the specified employee GUID. This does not include balances related to scheduling, absences, or dynamic banks. A balance will be provided for each bank based on the `asOfDate` specified. If no date is provided, the balance as of the current date (GMT) will be returned.
     * Retrieve Employee Balances by GUID
     */
    DataAPIsApi.prototype.getEmployeeBalancesByGuid = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getEmployeeBalancesByGuidRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get shifts. The API will return list of shifts for the requested parameters.
     * Get shifts
     */
    DataAPIsApi.prototype.getShiftsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, context, init;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters['filter'] != null) {
                            queryParameters['filter'] = requestParameters['filter'];
                        }
                        headerParameters = {};
                        urlPath = "/data/v1/shifts";
                        context = {
                            path: urlPath,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        };
                        return [4 /*yield*/, this.createApiRequestInit(context, initOverrides)];
                    case 1:
                        init = _a.sent();
                        return [2 /*return*/, this.request(context, init)
                                .catch(function (error) {
                                _this.reportApiNetworkError(init.handleErrors);
                                throw new FetchError(error);
                            })
                                .then(function (response) {
                                switch (response.status) {
                                    case 200: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ListShiftsResponseSchemaFromJSON(jsonValue); });
                                        return processedResponse;
                                    }
                                    case 400: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 401: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 403: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 404: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 500: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    default: {
                                        var processedResponse = new VoidApiResponse(response);
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                }
                            })];
                }
            });
        });
    };
    /**
     * Get shifts. The API will return list of shifts for the requested parameters.
     * Get shifts
     */
    DataAPIsApi.prototype.getShifts = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getShiftsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Allows a user to get time off requests.  **Supported Filter Parameters**: - clientPersonId – Specified clientPersonId to retrieve time off requests for. - assignmentGroups – Array of assignment group identifiers to filter time off requests by specific groups of employees. - startDate – Start date (inclusive) for filtering time off requests. - endDate – End date (inclusive) for filtering time off requests. - statusList – Array of allowed statuses to be returned in the response; If no statusList specified, all statuses will be returned. - sort – Comma-separated list of fields to sort by, optionally prefixed with \'-\' for descending order. - page[size] – Number of items per page (1–50). - page[before], page[after] – Cursor values for pagination.  **Considerations when using filter[clientPersonId]** - If a filter[clientPersonId] is defined, the list of time off requests will be specific to the clientPersonId specified. - If filter[clientPersonId] is not specified, the list of time off requests will be for all of the delegates that the user has access over. - This does not include the user\'s own time off, unless the user belongs to a delegated group they have access over.  **Considerations when using filter[assignmentGroups]** - If filter[assignmentGroups] is defined, only time off requests for employees belonging to the specified assignment groups are returned. - Multiple assignment groups may be specified to return results across several groups. - If both filter[clientPersonId] and filter[assignmentGroups] are specified, results are returned for the specified employee only if they belong to one of the specified assignment groups. For employees with multiple assignments, only jobs within the specified groups are included.  **Considerations when using filter[startDate] and filter[endDate]** - If filter[startDate] and filter[endDate] are not defined, they will be defaulted as today and a year from today, respectively. - If only filter[startDate] is defined, filter[endDate] will be assumed to be the same as filter[startDate].
     * Get time-off requests
     */
    DataAPIsApi.prototype.getTimeOffRequestsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, context, init;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters['filter'] != null) {
                            queryParameters['filter'] = requestParameters['filter'];
                        }
                        if (requestParameters['include'] != null) {
                            queryParameters['include'] = requestParameters['include'].join(COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters['page'] != null) {
                            queryParameters['page'] = requestParameters['page'];
                        }
                        if (requestParameters['sort'] != null) {
                            queryParameters['sort'] = requestParameters['sort'];
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/vnd.api+json';
                        urlPath = "/data/v1/time-off-requests";
                        context = {
                            path: urlPath,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                            body: requestParameters['body'],
                        };
                        return [4 /*yield*/, this.createApiRequestInit(context, initOverrides)];
                    case 1:
                        init = _a.sent();
                        return [2 /*return*/, this.request(context, init)
                                .catch(function (error) {
                                _this.reportApiNetworkError(init.handleErrors);
                                throw new FetchError(error);
                            })
                                .then(function (response) {
                                switch (response.status) {
                                    case 200: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return InlineObject1FromJSON(jsonValue); });
                                        return processedResponse;
                                    }
                                    case 400: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 401: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 403: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 404: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 409: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 500: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 501: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 503: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    default: {
                                        var processedResponse = new VoidApiResponse(response);
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                }
                            })];
                }
            });
        });
    };
    /**
     * Allows a user to get time off requests.  **Supported Filter Parameters**: - clientPersonId – Specified clientPersonId to retrieve time off requests for. - assignmentGroups – Array of assignment group identifiers to filter time off requests by specific groups of employees. - startDate – Start date (inclusive) for filtering time off requests. - endDate – End date (inclusive) for filtering time off requests. - statusList – Array of allowed statuses to be returned in the response; If no statusList specified, all statuses will be returned. - sort – Comma-separated list of fields to sort by, optionally prefixed with \'-\' for descending order. - page[size] – Number of items per page (1–50). - page[before], page[after] – Cursor values for pagination.  **Considerations when using filter[clientPersonId]** - If a filter[clientPersonId] is defined, the list of time off requests will be specific to the clientPersonId specified. - If filter[clientPersonId] is not specified, the list of time off requests will be for all of the delegates that the user has access over. - This does not include the user\'s own time off, unless the user belongs to a delegated group they have access over.  **Considerations when using filter[assignmentGroups]** - If filter[assignmentGroups] is defined, only time off requests for employees belonging to the specified assignment groups are returned. - Multiple assignment groups may be specified to return results across several groups. - If both filter[clientPersonId] and filter[assignmentGroups] are specified, results are returned for the specified employee only if they belong to one of the specified assignment groups. For employees with multiple assignments, only jobs within the specified groups are included.  **Considerations when using filter[startDate] and filter[endDate]** - If filter[startDate] and filter[endDate] are not defined, they will be defaulted as today and a year from today, respectively. - If only filter[startDate] is defined, filter[endDate] will be assumed to be the same as filter[startDate].
     * Get time-off requests
     */
    DataAPIsApi.prototype.getTimeOffRequests = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTimeOffRequestsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update shift. The API will allow the updating an existing shift record.  **Note:** There may be a delay between a successful response and the shift being available in a GET request.
     * Update a shift
     */
    DataAPIsApi.prototype.patchShiftRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, context, init;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['shiftId'] == null) {
                            throw new RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling patchShift().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/vnd.api+json';
                        urlPath = "/data/v1/shifts/{shiftId}";
                        urlPath = urlPath.replace("{" + "shiftId" + "}", encodeURIComponent(String(requestParameters['shiftId'])));
                        context = {
                            path: urlPath,
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: UpdateShiftRequestSchemaToJSON(requestParameters['updateShiftRequestSchema']),
                        };
                        return [4 /*yield*/, this.createApiRequestInit(context, initOverrides)];
                    case 1:
                        init = _a.sent();
                        return [2 /*return*/, this.request(context, init)
                                .catch(function (error) {
                                _this.reportApiNetworkError(init.handleErrors);
                                throw new FetchError(error);
                            })
                                .then(function (response) {
                                switch (response.status) {
                                    case 201: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return SingleShiftResponseSchemaFromJSON(jsonValue); });
                                        return processedResponse;
                                    }
                                    case 400: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 401: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 403: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 404: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 409: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 500: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    default: {
                                        var processedResponse = new VoidApiResponse(response);
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                }
                            })];
                }
            });
        });
    };
    /**
     * Update shift. The API will allow the updating an existing shift record.  **Note:** There may be a delay between a successful response and the shift being available in a GET request.
     * Update a shift
     */
    DataAPIsApi.prototype.patchShift = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.patchShiftRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Send notification to employee.
     * Send notification to employee
     */
    DataAPIsApi.prototype.postAbsenceCaseContactEmployeeRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, context, init;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/vnd.api+json';
                        urlPath = "/data/v1/employee-notifications";
                        context = {
                            path: urlPath,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: AbsenceCaseContactEmployeeRequestToJSON(requestParameters['absenceCaseContactEmployeeRequest']),
                        };
                        return [4 /*yield*/, this.createApiRequestInit(context, initOverrides)];
                    case 1:
                        init = _a.sent();
                        return [2 /*return*/, this.request(context, init)
                                .catch(function (error) {
                                _this.reportApiNetworkError(init.handleErrors);
                                throw new FetchError(error);
                            })
                                .then(function (response) {
                                switch (response.status) {
                                    case 201: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return InlineObject4FromJSON(jsonValue); });
                                        return processedResponse;
                                    }
                                    case 400: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 401: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 403: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 404: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 500: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    default: {
                                        var processedResponse = new VoidApiResponse(response);
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                }
                            })];
                }
            });
        });
    };
    /**
     * Send notification to employee.
     * Send notification to employee
     */
    DataAPIsApi.prototype.postAbsenceCaseContactEmployee = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postAbsenceCaseContactEmployeeRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Upload documents related to an ACT case.
     * Upload documents related to an ACT case.
     */
    DataAPIsApi.prototype.postAbsenceCaseUploadDocumentRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, context, init;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/vnd.api+json';
                        urlPath = "/data/v1/absence-cases/upload-documents";
                        context = {
                            path: urlPath,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: AbsenceCaseUploadDocumentsRequestToJSON(requestParameters['absenceCaseUploadDocumentsRequest']),
                        };
                        return [4 /*yield*/, this.createApiRequestInit(context, initOverrides)];
                    case 1:
                        init = _a.sent();
                        return [2 /*return*/, this.request(context, init)
                                .catch(function (error) {
                                _this.reportApiNetworkError(init.handleErrors);
                                throw new FetchError(error);
                            })
                                .then(function (response) {
                                switch (response.status) {
                                    case 201: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return InlineObject9FromJSON(jsonValue); });
                                        return processedResponse;
                                    }
                                    case 400: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 401: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 403: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 404: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 500: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    default: {
                                        var processedResponse = new VoidApiResponse(response);
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                }
                            })];
                }
            });
        });
    };
    /**
     * Upload documents related to an ACT case.
     * Upload documents related to an ACT case.
     */
    DataAPIsApi.prototype.postAbsenceCaseUploadDocument = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postAbsenceCaseUploadDocumentRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Allows a user to create a **bank projection**.  A bank projection is a representation of the **preconditions to generate balances for a specified date range**. Projections support filtering by specific `employee` and `job` ids, and can project balances into both the future and past.  Bank projections are somewhat verbose for simpler use cases: they require a significant amount of ceremony to initialize and, although capable of running synchronously, are designed around being used in an asynchronous manner. **If simple retrieval of an employee\'s current balances is required, then consider using the Banks API!**  **Usage of the `balance`, `entry`, or `gap` include parameters have special semantics.** Under normal circumstances, this API is totally asynchronous: a response will immediately be returned when a projection resource is created. Including balances, entries, or gaps in the response requires waiting for multiple potential long-running calculations. This means that a response may not be transmitted for quite some time. Practically, using any of these parameters makes this a long-running synchronous API.  **Recommended usage:** Use `include=balance,gap` to receive balance records alongside gap markers that indicate periods where balance data is unavailable. Optionally add `entry` to the include list to receive ordered wrappers around each balance and gap — useful for pagination and deterministic traversal of the result set.  When creating a bank projection, the workflow depends on the date range specified. For a **single date**, the projection will generate a single balance or gap representing the state on that specific day. However, for a **date range**, the projection will include at least two balances or two gaps: one representing the initial state at the start of the range and another representing the final state at the end of the range. Additionally, **any** **changes occurring on intermediate days within the range will be reflected as day-specific balances or gaps**, providing a comprehensive view of balance transitions over time. Every `(bankPolicy, employee, jobs)` combination that appears anywhere in the projection is guaranteed to have either a balance or a gap at both the projection start and end dates.  **Shared vs. independent banks:** For employees with multiple jobs, some banks may be shared across jobs (the `jobs` relationship on the balance or gap will contain multiple job IDs), while others are independent per job (the `jobs` relationship will contain a single job ID). When filtering by job, a shared bank will still appear in the response with its full set of jobs if any of those jobs match the filter.  If an employee id is not provided, balances will be retrieved for the authenticated user\'s delegated employee ids (including the employee themselves). If jobs are not provided, all jobs associated with the relevant employees will be included in the projection.  **There are limitations around the usage of the `include` field**. Specifically, when attempting to include balances or gaps in an immediate response on the root projection object, the number of balances is limited to 2000, and the number of gaps is limited to 2000. attributes.scope supports bankSet or bankPolicyIds.
     * Create a Bank Projection
     */
    DataAPIsApi.prototype.postBankProjectionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, context, init;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['bankProjectionCreateRequest'] == null) {
                            throw new RequiredError('bankProjectionCreateRequest', 'Required parameter "bankProjectionCreateRequest" was null or undefined when calling postBankProjection().');
                        }
                        queryParameters = {};
                        if (requestParameters['include'] != null) {
                            queryParameters['include'] = requestParameters['include'].join(COLLECTION_FORMATS["csv"]);
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/vnd.api+json';
                        urlPath = "/data/v1/bank-projections";
                        context = {
                            path: urlPath,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: BankProjectionCreateRequestToJSON(requestParameters['bankProjectionCreateRequest']),
                        };
                        return [4 /*yield*/, this.createApiRequestInit(context, initOverrides)];
                    case 1:
                        init = _a.sent();
                        return [2 /*return*/, this.request(context, init)
                                .catch(function (error) {
                                _this.reportApiNetworkError(init.handleErrors);
                                throw new FetchError(error);
                            })
                                .then(function (response) {
                                switch (response.status) {
                                    case 201: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return PostBankProjectionResponseSchemaFromJSON(jsonValue); });
                                        return processedResponse;
                                    }
                                    case 400: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 401: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 403: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 404: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 500: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    default: {
                                        var processedResponse = new VoidApiResponse(response);
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                }
                            })];
                }
            });
        });
    };
    /**
     * Allows a user to create a **bank projection**.  A bank projection is a representation of the **preconditions to generate balances for a specified date range**. Projections support filtering by specific `employee` and `job` ids, and can project balances into both the future and past.  Bank projections are somewhat verbose for simpler use cases: they require a significant amount of ceremony to initialize and, although capable of running synchronously, are designed around being used in an asynchronous manner. **If simple retrieval of an employee\'s current balances is required, then consider using the Banks API!**  **Usage of the `balance`, `entry`, or `gap` include parameters have special semantics.** Under normal circumstances, this API is totally asynchronous: a response will immediately be returned when a projection resource is created. Including balances, entries, or gaps in the response requires waiting for multiple potential long-running calculations. This means that a response may not be transmitted for quite some time. Practically, using any of these parameters makes this a long-running synchronous API.  **Recommended usage:** Use `include=balance,gap` to receive balance records alongside gap markers that indicate periods where balance data is unavailable. Optionally add `entry` to the include list to receive ordered wrappers around each balance and gap — useful for pagination and deterministic traversal of the result set.  When creating a bank projection, the workflow depends on the date range specified. For a **single date**, the projection will generate a single balance or gap representing the state on that specific day. However, for a **date range**, the projection will include at least two balances or two gaps: one representing the initial state at the start of the range and another representing the final state at the end of the range. Additionally, **any** **changes occurring on intermediate days within the range will be reflected as day-specific balances or gaps**, providing a comprehensive view of balance transitions over time. Every `(bankPolicy, employee, jobs)` combination that appears anywhere in the projection is guaranteed to have either a balance or a gap at both the projection start and end dates.  **Shared vs. independent banks:** For employees with multiple jobs, some banks may be shared across jobs (the `jobs` relationship on the balance or gap will contain multiple job IDs), while others are independent per job (the `jobs` relationship will contain a single job ID). When filtering by job, a shared bank will still appear in the response with its full set of jobs if any of those jobs match the filter.  If an employee id is not provided, balances will be retrieved for the authenticated user\'s delegated employee ids (including the employee themselves). If jobs are not provided, all jobs associated with the relevant employees will be included in the projection.  **There are limitations around the usage of the `include` field**. Specifically, when attempting to include balances or gaps in an immediate response on the root projection object, the number of balances is limited to 2000, and the number of gaps is limited to 2000. attributes.scope supports bankSet or bankPolicyIds.
     * Create a Bank Projection
     */
    DataAPIsApi.prototype.postBankProjection = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postBankProjectionRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create shift. The API will allow the creation of a shift record.  **Note:** There may be a delay between a successful response and the shift being available in a GET request.
     * Create a shift
     */
    DataAPIsApi.prototype.postShiftRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, context, init;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/vnd.api+json';
                        urlPath = "/data/v1/shifts";
                        context = {
                            path: urlPath,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: CreateShiftRequestSchemaToJSON(requestParameters['createShiftRequestSchema']),
                        };
                        return [4 /*yield*/, this.createApiRequestInit(context, initOverrides)];
                    case 1:
                        init = _a.sent();
                        return [2 /*return*/, this.request(context, init)
                                .catch(function (error) {
                                _this.reportApiNetworkError(init.handleErrors);
                                throw new FetchError(error);
                            })
                                .then(function (response) {
                                switch (response.status) {
                                    case 201: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return SingleShiftResponseSchemaFromJSON(jsonValue); });
                                        return processedResponse;
                                    }
                                    case 400: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 401: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 403: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 409: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 500: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    default: {
                                        var processedResponse = new VoidApiResponse(response);
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                }
                            })];
                }
            });
        });
    };
    /**
     * Create shift. The API will allow the creation of a shift record.  **Note:** There may be a delay between a successful response and the shift being available in a GET request.
     * Create a shift
     */
    DataAPIsApi.prototype.postShift = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postShiftRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Post an employee swipe.  The API will either return a `Location` header if the swipe is created immediately.  If the swipe is still being processed, the API will return a `Content-Location` header indicating where the swipe will be available once created.
     * Record a Swipe
     */
    DataAPIsApi.prototype.postSwipeRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, context, init;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/vnd.api+json';
                        urlPath = "/data/v1/swipes";
                        context = {
                            path: urlPath,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: SwipeRequestToJSON(requestParameters['swipeRequest']),
                        };
                        return [4 /*yield*/, this.createApiRequestInit(context, initOverrides)];
                    case 1:
                        init = _a.sent();
                        return [2 /*return*/, this.request(context, init)
                                .catch(function (error) {
                                _this.reportApiNetworkError(init.handleErrors);
                                throw new FetchError(error);
                            })
                                .then(function (response) {
                                switch (response.status) {
                                    case 201: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return CreatedSwipeResponseFromJSON(jsonValue); });
                                        return processedResponse;
                                    }
                                    case 202: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return AcceptedSchemaFromJSON(jsonValue); });
                                        return processedResponse;
                                    }
                                    case 400: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 401: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 403: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 404: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 500: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    default: {
                                        var processedResponse = new VoidApiResponse(response);
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                }
                            })];
                }
            });
        });
    };
    /**
     * Post an employee swipe.  The API will either return a `Location` header if the swipe is created immediately.  If the swipe is still being processed, the API will return a `Content-Location` header indicating where the swipe will be available once created.
     * Record a Swipe
     */
    DataAPIsApi.prototype.postSwipe = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postSwipeRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Rollback a specific absence case history event.
     * Rollback Absence Case History Event
     */
    DataAPIsApi.prototype.rollbackAbsenceCaseHistoryEventRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, context, init;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['rollbackAbsenceCaseHistoryEventRequest'] == null) {
                            throw new RequiredError('rollbackAbsenceCaseHistoryEventRequest', 'Required parameter "rollbackAbsenceCaseHistoryEventRequest" was null or undefined when calling rollbackAbsenceCaseHistoryEvent().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/vnd.api+json';
                        urlPath = "/data/v1/absence-history-events";
                        context = {
                            path: urlPath,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: RollbackAbsenceCaseHistoryEventRequestToJSON(requestParameters['rollbackAbsenceCaseHistoryEventRequest']),
                        };
                        return [4 /*yield*/, this.createApiRequestInit(context, initOverrides)];
                    case 1:
                        init = _a.sent();
                        return [2 /*return*/, this.request(context, init)
                                .catch(function (error) {
                                _this.reportApiNetworkError(init.handleErrors);
                                throw new FetchError(error);
                            })
                                .then(function (response) {
                                switch (response.status) {
                                    case 200: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return RollbackAbsenceCaseHistoryEventResponseFromJSON(jsonValue); });
                                        return processedResponse;
                                    }
                                    case 400: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 401: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 403: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 404: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 500: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    default: {
                                        var processedResponse = new VoidApiResponse(response);
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                }
                            })];
                }
            });
        });
    };
    /**
     * Rollback a specific absence case history event.
     * Rollback Absence Case History Event
     */
    DataAPIsApi.prototype.rollbackAbsenceCaseHistoryEvent = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.rollbackAbsenceCaseHistoryEventRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates an absence case and its related resources using the JSON:API atomic operations pattern. All operations are processed in order and atomically — either all succeed or all fail together.  Clients MAY include any subset of operations.  **Editable resources and fields:** - `absenceCase` — caseType, startDate, endDate, usePaidTime, contactMethod, contactAddress, caseNotes. - `caseManagers` (relationship) — replace all case managers on the absence case. - `projectedUsage` (leaveEligibleOverrideDtl only) — allowedUsageStart, allowedUsageEnd, usageModifiedByHR. - `leaveEligibility` — leaveEligibility.hrOverride, leaveEligibleOverrideDtl.hrOverrideComments, leaveEligibleOverrideDtl.hrOverrideUser.
     * Update Absence Case and related resources by Id
     */
    DataAPIsApi.prototype.updateAbsenceCaseRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, context, init;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['absenceCaseId'] == null) {
                            throw new RequiredError('absenceCaseId', 'Required parameter "absenceCaseId" was null or undefined when calling updateAbsenceCase().');
                        }
                        if (requestParameters['absenceCaseUpdateRequest'] == null) {
                            throw new RequiredError('absenceCaseUpdateRequest', 'Required parameter "absenceCaseUpdateRequest" was null or undefined when calling updateAbsenceCase().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/vnd.api+json; ext=https://jsonapi.org/ext/atomic';
                        urlPath = "/data/v1/absence-cases/{absenceCaseId}";
                        urlPath = urlPath.replace("{" + "absenceCaseId" + "}", encodeURIComponent(String(requestParameters['absenceCaseId'])));
                        context = {
                            path: urlPath,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: AbsenceCaseUpdateRequestToJSON(requestParameters['absenceCaseUpdateRequest']),
                        };
                        return [4 /*yield*/, this.createApiRequestInit(context, initOverrides)];
                    case 1:
                        init = _a.sent();
                        return [2 /*return*/, this.request(context, init)
                                .catch(function (error) {
                                _this.reportApiNetworkError(init.handleErrors);
                                throw new FetchError(error);
                            })
                                .then(function (response) {
                                switch (response.status) {
                                    case 200: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return AbsenceCaseUpdateResponseFromJSON(jsonValue); });
                                        return processedResponse;
                                    }
                                    case 204: {
                                        var processedResponse = new VoidApiResponse(response);
                                        return processedResponse;
                                    }
                                    case 400: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 401: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 403: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 404: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 409: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 422: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    case 500: {
                                        var processedResponse = new JSONApiResponse(response, function (jsonValue) { return ErrorResponseFromJSON(jsonValue); });
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                    default: {
                                        var processedResponse = new VoidApiResponse(response);
                                        _this.reportApiErrorResponse(processedResponse, init.handleErrors);
                                        throw new ResponseError(response);
                                    }
                                }
                            })];
                }
            });
        });
    };
    /**
     * Updates an absence case and its related resources using the JSON:API atomic operations pattern. All operations are processed in order and atomically — either all succeed or all fail together.  Clients MAY include any subset of operations.  **Editable resources and fields:** - `absenceCase` — caseType, startDate, endDate, usePaidTime, contactMethod, contactAddress, caseNotes. - `caseManagers` (relationship) — replace all case managers on the absence case. - `projectedUsage` (leaveEligibleOverrideDtl only) — allowedUsageStart, allowedUsageEnd, usageModifiedByHR. - `leaveEligibility` — leaveEligibility.hrOverride, leaveEligibleOverrideDtl.hrOverrideComments, leaveEligibleOverrideDtl.hrOverrideUser.
     * Update Absence Case and related resources by Id
     */
    DataAPIsApi.prototype.updateAbsenceCase = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateAbsenceCaseRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return DataAPIsApi;
}(BaseAPI));

/* tslint:disable */
/* eslint-disable */

var GeneratedApis = /*#__PURE__*/Object.freeze({
    __proto__: null,
    AdminAPIsApi: AdminAPIsApi,
    ConfigAPIsApi: ConfigAPIsApi,
    DataAPIsApi: DataAPIsApi
});

/* tslint:disable */
/* eslint-disable */

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    AbsenceCaseAttributesFromJSON: AbsenceCaseAttributesFromJSON,
    AbsenceCaseAttributesFromJSONTyped: AbsenceCaseAttributesFromJSONTyped,
    AbsenceCaseAttributesToJSON: AbsenceCaseAttributesToJSON,
    AbsenceCaseAttributesToJSONTyped: AbsenceCaseAttributesToJSONTyped,
    AbsenceCaseContactEmployeeRequestDataAttributesFromJSON: AbsenceCaseContactEmployeeRequestDataAttributesFromJSON,
    AbsenceCaseContactEmployeeRequestDataAttributesFromJSONTyped: AbsenceCaseContactEmployeeRequestDataAttributesFromJSONTyped,
    AbsenceCaseContactEmployeeRequestDataAttributesToJSON: AbsenceCaseContactEmployeeRequestDataAttributesToJSON,
    AbsenceCaseContactEmployeeRequestDataAttributesToJSONTyped: AbsenceCaseContactEmployeeRequestDataAttributesToJSONTyped,
    AbsenceCaseContactEmployeeRequestDataFromJSON: AbsenceCaseContactEmployeeRequestDataFromJSON,
    AbsenceCaseContactEmployeeRequestDataFromJSONTyped: AbsenceCaseContactEmployeeRequestDataFromJSONTyped,
    AbsenceCaseContactEmployeeRequestDataRelationshipsFromJSON: AbsenceCaseContactEmployeeRequestDataRelationshipsFromJSON,
    AbsenceCaseContactEmployeeRequestDataRelationshipsFromJSONTyped: AbsenceCaseContactEmployeeRequestDataRelationshipsFromJSONTyped,
    AbsenceCaseContactEmployeeRequestDataRelationshipsToJSON: AbsenceCaseContactEmployeeRequestDataRelationshipsToJSON,
    AbsenceCaseContactEmployeeRequestDataRelationshipsToJSONTyped: AbsenceCaseContactEmployeeRequestDataRelationshipsToJSONTyped,
    AbsenceCaseContactEmployeeRequestDataToJSON: AbsenceCaseContactEmployeeRequestDataToJSON,
    AbsenceCaseContactEmployeeRequestDataToJSONTyped: AbsenceCaseContactEmployeeRequestDataToJSONTyped,
    AbsenceCaseContactEmployeeRequestFromJSON: AbsenceCaseContactEmployeeRequestFromJSON,
    AbsenceCaseContactEmployeeRequestFromJSONTyped: AbsenceCaseContactEmployeeRequestFromJSONTyped,
    AbsenceCaseContactEmployeeRequestToJSON: AbsenceCaseContactEmployeeRequestToJSON,
    AbsenceCaseContactEmployeeRequestToJSONTyped: AbsenceCaseContactEmployeeRequestToJSONTyped,
    AbsenceCaseContactEmployeeResponseAttributesFromJSON: AbsenceCaseContactEmployeeResponseAttributesFromJSON,
    AbsenceCaseContactEmployeeResponseAttributesFromJSONTyped: AbsenceCaseContactEmployeeResponseAttributesFromJSONTyped,
    AbsenceCaseContactEmployeeResponseAttributesToJSON: AbsenceCaseContactEmployeeResponseAttributesToJSON,
    AbsenceCaseContactEmployeeResponseAttributesToJSONTyped: AbsenceCaseContactEmployeeResponseAttributesToJSONTyped,
    AbsenceCaseContactEmployeeResponseFromJSON: AbsenceCaseContactEmployeeResponseFromJSON,
    AbsenceCaseContactEmployeeResponseFromJSONTyped: AbsenceCaseContactEmployeeResponseFromJSONTyped,
    AbsenceCaseContactEmployeeResponseRelationshipsFromJSON: AbsenceCaseContactEmployeeResponseRelationshipsFromJSON,
    AbsenceCaseContactEmployeeResponseRelationshipsFromJSONTyped: AbsenceCaseContactEmployeeResponseRelationshipsFromJSONTyped,
    AbsenceCaseContactEmployeeResponseRelationshipsToJSON: AbsenceCaseContactEmployeeResponseRelationshipsToJSON,
    AbsenceCaseContactEmployeeResponseRelationshipsToJSONTyped: AbsenceCaseContactEmployeeResponseRelationshipsToJSONTyped,
    AbsenceCaseContactEmployeeResponseToJSON: AbsenceCaseContactEmployeeResponseToJSON,
    AbsenceCaseContactEmployeeResponseToJSONTyped: AbsenceCaseContactEmployeeResponseToJSONTyped,
    AbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInnerFromJSON: AbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInnerFromJSON,
    AbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInnerFromJSONTyped: AbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInnerFromJSONTyped,
    AbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInnerToJSON: AbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInnerToJSON,
    AbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInnerToJSONTyped: AbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInnerToJSONTyped,
    AbsenceCaseDetailsAttributesContactMethodEnum: AbsenceCaseDetailsAttributesContactMethodEnum,
    AbsenceCaseDetailsAttributesFromJSON: AbsenceCaseDetailsAttributesFromJSON,
    AbsenceCaseDetailsAttributesFromJSONTyped: AbsenceCaseDetailsAttributesFromJSONTyped,
    AbsenceCaseDetailsAttributesToJSON: AbsenceCaseDetailsAttributesToJSON,
    AbsenceCaseDetailsAttributesToJSONTyped: AbsenceCaseDetailsAttributesToJSONTyped,
    AbsenceCaseDetailsAttributesUsePaidTimeEnum: AbsenceCaseDetailsAttributesUsePaidTimeEnum,
    AbsenceCaseDetailsFromJSON: AbsenceCaseDetailsFromJSON,
    AbsenceCaseDetailsFromJSONTyped: AbsenceCaseDetailsFromJSONTyped,
    AbsenceCaseDetailsRelationshipsFromJSON: AbsenceCaseDetailsRelationshipsFromJSON,
    AbsenceCaseDetailsRelationshipsFromJSONTyped: AbsenceCaseDetailsRelationshipsFromJSONTyped,
    AbsenceCaseDetailsRelationshipsToJSON: AbsenceCaseDetailsRelationshipsToJSON,
    AbsenceCaseDetailsRelationshipsToJSONTyped: AbsenceCaseDetailsRelationshipsToJSONTyped,
    AbsenceCaseDetailsToJSON: AbsenceCaseDetailsToJSON,
    AbsenceCaseDetailsToJSONTyped: AbsenceCaseDetailsToJSONTyped,
    AbsenceCaseDocumentsReducedAttributesFromJSON: AbsenceCaseDocumentsReducedAttributesFromJSON,
    AbsenceCaseDocumentsReducedAttributesFromJSONTyped: AbsenceCaseDocumentsReducedAttributesFromJSONTyped,
    AbsenceCaseDocumentsReducedAttributesStatusEnum: AbsenceCaseDocumentsReducedAttributesStatusEnum,
    AbsenceCaseDocumentsReducedAttributesToJSON: AbsenceCaseDocumentsReducedAttributesToJSON,
    AbsenceCaseDocumentsReducedAttributesToJSONTyped: AbsenceCaseDocumentsReducedAttributesToJSONTyped,
    AbsenceCaseDocumentsReducedAttributesTriggerTypeEnum: AbsenceCaseDocumentsReducedAttributesTriggerTypeEnum,
    AbsenceCaseDocumentsReducedFromJSON: AbsenceCaseDocumentsReducedFromJSON,
    AbsenceCaseDocumentsReducedFromJSONTyped: AbsenceCaseDocumentsReducedFromJSONTyped,
    AbsenceCaseDocumentsReducedToJSON: AbsenceCaseDocumentsReducedToJSON,
    AbsenceCaseDocumentsReducedToJSONTyped: AbsenceCaseDocumentsReducedToJSONTyped,
    AbsenceCaseDocumentsRelationshipDataInnerFromJSON: AbsenceCaseDocumentsRelationshipDataInnerFromJSON,
    AbsenceCaseDocumentsRelationshipDataInnerFromJSONTyped: AbsenceCaseDocumentsRelationshipDataInnerFromJSONTyped,
    AbsenceCaseDocumentsRelationshipDataInnerToJSON: AbsenceCaseDocumentsRelationshipDataInnerToJSON,
    AbsenceCaseDocumentsRelationshipDataInnerToJSONTyped: AbsenceCaseDocumentsRelationshipDataInnerToJSONTyped,
    AbsenceCaseDocumentsRelationshipFromJSON: AbsenceCaseDocumentsRelationshipFromJSON,
    AbsenceCaseDocumentsRelationshipFromJSONTyped: AbsenceCaseDocumentsRelationshipFromJSONTyped,
    AbsenceCaseDocumentsRelationshipToJSON: AbsenceCaseDocumentsRelationshipToJSON,
    AbsenceCaseDocumentsRelationshipToJSONTyped: AbsenceCaseDocumentsRelationshipToJSONTyped,
    AbsenceCaseEditableAttributesContactMethodEnum: AbsenceCaseEditableAttributesContactMethodEnum,
    AbsenceCaseEditableAttributesFromJSON: AbsenceCaseEditableAttributesFromJSON,
    AbsenceCaseEditableAttributesFromJSONTyped: AbsenceCaseEditableAttributesFromJSONTyped,
    AbsenceCaseEditableAttributesToJSON: AbsenceCaseEditableAttributesToJSON,
    AbsenceCaseEditableAttributesToJSONTyped: AbsenceCaseEditableAttributesToJSONTyped,
    AbsenceCaseEditableAttributesUsePaidTimeEnum: AbsenceCaseEditableAttributesUsePaidTimeEnum,
    AbsenceCaseEventRelationshipDataAttributesFromJSON: AbsenceCaseEventRelationshipDataAttributesFromJSON,
    AbsenceCaseEventRelationshipDataAttributesFromJSONTyped: AbsenceCaseEventRelationshipDataAttributesFromJSONTyped,
    AbsenceCaseEventRelationshipDataAttributesToJSON: AbsenceCaseEventRelationshipDataAttributesToJSON,
    AbsenceCaseEventRelationshipDataAttributesToJSONTyped: AbsenceCaseEventRelationshipDataAttributesToJSONTyped,
    AbsenceCaseEventRelationshipDataFromJSON: AbsenceCaseEventRelationshipDataFromJSON,
    AbsenceCaseEventRelationshipDataFromJSONTyped: AbsenceCaseEventRelationshipDataFromJSONTyped,
    AbsenceCaseEventRelationshipDataToJSON: AbsenceCaseEventRelationshipDataToJSON,
    AbsenceCaseEventRelationshipDataToJSONTyped: AbsenceCaseEventRelationshipDataToJSONTyped,
    AbsenceCaseEventRelationshipFromJSON: AbsenceCaseEventRelationshipFromJSON,
    AbsenceCaseEventRelationshipFromJSONTyped: AbsenceCaseEventRelationshipFromJSONTyped,
    AbsenceCaseEventRelationshipToJSON: AbsenceCaseEventRelationshipToJSON,
    AbsenceCaseEventRelationshipToJSONTyped: AbsenceCaseEventRelationshipToJSONTyped,
    AbsenceCaseFromJSON: AbsenceCaseFromJSON,
    AbsenceCaseFromJSONTyped: AbsenceCaseFromJSONTyped,
    AbsenceCaseHistoryEventAttributesFromJSON: AbsenceCaseHistoryEventAttributesFromJSON,
    AbsenceCaseHistoryEventAttributesFromJSONTyped: AbsenceCaseHistoryEventAttributesFromJSONTyped,
    AbsenceCaseHistoryEventAttributesToJSON: AbsenceCaseHistoryEventAttributesToJSON,
    AbsenceCaseHistoryEventAttributesToJSONTyped: AbsenceCaseHistoryEventAttributesToJSONTyped,
    AbsenceCaseHistoryEventFromJSON: AbsenceCaseHistoryEventFromJSON,
    AbsenceCaseHistoryEventFromJSONTyped: AbsenceCaseHistoryEventFromJSONTyped,
    AbsenceCaseHistoryEventRelationshipDataFromJSON: AbsenceCaseHistoryEventRelationshipDataFromJSON,
    AbsenceCaseHistoryEventRelationshipDataFromJSONTyped: AbsenceCaseHistoryEventRelationshipDataFromJSONTyped,
    AbsenceCaseHistoryEventRelationshipDataToJSON: AbsenceCaseHistoryEventRelationshipDataToJSON,
    AbsenceCaseHistoryEventRelationshipDataToJSONTyped: AbsenceCaseHistoryEventRelationshipDataToJSONTyped,
    AbsenceCaseHistoryEventRelationshipFromJSON: AbsenceCaseHistoryEventRelationshipFromJSON,
    AbsenceCaseHistoryEventRelationshipFromJSONTyped: AbsenceCaseHistoryEventRelationshipFromJSONTyped,
    AbsenceCaseHistoryEventRelationshipToJSON: AbsenceCaseHistoryEventRelationshipToJSON,
    AbsenceCaseHistoryEventRelationshipToJSONTyped: AbsenceCaseHistoryEventRelationshipToJSONTyped,
    AbsenceCaseHistoryEventRelationshipsFromJSON: AbsenceCaseHistoryEventRelationshipsFromJSON,
    AbsenceCaseHistoryEventRelationshipsFromJSONTyped: AbsenceCaseHistoryEventRelationshipsFromJSONTyped,
    AbsenceCaseHistoryEventRelationshipsToJSON: AbsenceCaseHistoryEventRelationshipsToJSON,
    AbsenceCaseHistoryEventRelationshipsToJSONTyped: AbsenceCaseHistoryEventRelationshipsToJSONTyped,
    AbsenceCaseHistoryEventToJSON: AbsenceCaseHistoryEventToJSON,
    AbsenceCaseHistoryEventToJSONTyped: AbsenceCaseHistoryEventToJSONTyped,
    AbsenceCaseLeaveEligibilityReducedAttributesFromJSON: AbsenceCaseLeaveEligibilityReducedAttributesFromJSON,
    AbsenceCaseLeaveEligibilityReducedAttributesFromJSONTyped: AbsenceCaseLeaveEligibilityReducedAttributesFromJSONTyped,
    AbsenceCaseLeaveEligibilityReducedAttributesToJSON: AbsenceCaseLeaveEligibilityReducedAttributesToJSON,
    AbsenceCaseLeaveEligibilityReducedAttributesToJSONTyped: AbsenceCaseLeaveEligibilityReducedAttributesToJSONTyped,
    AbsenceCaseLeaveEligibilityReducedFromJSON: AbsenceCaseLeaveEligibilityReducedFromJSON,
    AbsenceCaseLeaveEligibilityReducedFromJSONTyped: AbsenceCaseLeaveEligibilityReducedFromJSONTyped,
    AbsenceCaseLeaveEligibilityReducedToJSON: AbsenceCaseLeaveEligibilityReducedToJSON,
    AbsenceCaseLeaveEligibilityReducedToJSONTyped: AbsenceCaseLeaveEligibilityReducedToJSONTyped,
    AbsenceCaseLeaveEligibilityRelationshipDataInnerFromJSON: AbsenceCaseLeaveEligibilityRelationshipDataInnerFromJSON,
    AbsenceCaseLeaveEligibilityRelationshipDataInnerFromJSONTyped: AbsenceCaseLeaveEligibilityRelationshipDataInnerFromJSONTyped,
    AbsenceCaseLeaveEligibilityRelationshipDataInnerToJSON: AbsenceCaseLeaveEligibilityRelationshipDataInnerToJSON,
    AbsenceCaseLeaveEligibilityRelationshipDataInnerToJSONTyped: AbsenceCaseLeaveEligibilityRelationshipDataInnerToJSONTyped,
    AbsenceCaseLeaveEligibilityRelationshipFromJSON: AbsenceCaseLeaveEligibilityRelationshipFromJSON,
    AbsenceCaseLeaveEligibilityRelationshipFromJSONTyped: AbsenceCaseLeaveEligibilityRelationshipFromJSONTyped,
    AbsenceCaseLeaveEligibilityRelationshipToJSON: AbsenceCaseLeaveEligibilityRelationshipToJSON,
    AbsenceCaseLeaveEligibilityRelationshipToJSONTyped: AbsenceCaseLeaveEligibilityRelationshipToJSONTyped,
    AbsenceCaseLeaveTypeReducedAttributesFromJSON: AbsenceCaseLeaveTypeReducedAttributesFromJSON,
    AbsenceCaseLeaveTypeReducedAttributesFromJSONTyped: AbsenceCaseLeaveTypeReducedAttributesFromJSONTyped,
    AbsenceCaseLeaveTypeReducedAttributesToJSON: AbsenceCaseLeaveTypeReducedAttributesToJSON,
    AbsenceCaseLeaveTypeReducedAttributesToJSONTyped: AbsenceCaseLeaveTypeReducedAttributesToJSONTyped,
    AbsenceCaseLeaveTypeReducedFromJSON: AbsenceCaseLeaveTypeReducedFromJSON,
    AbsenceCaseLeaveTypeReducedFromJSONTyped: AbsenceCaseLeaveTypeReducedFromJSONTyped,
    AbsenceCaseLeaveTypeReducedToJSON: AbsenceCaseLeaveTypeReducedToJSON,
    AbsenceCaseLeaveTypeReducedToJSONTyped: AbsenceCaseLeaveTypeReducedToJSONTyped,
    AbsenceCaseLeaveTypeRelationshipDataInnerFromJSON: AbsenceCaseLeaveTypeRelationshipDataInnerFromJSON,
    AbsenceCaseLeaveTypeRelationshipDataInnerFromJSONTyped: AbsenceCaseLeaveTypeRelationshipDataInnerFromJSONTyped,
    AbsenceCaseLeaveTypeRelationshipDataInnerToJSON: AbsenceCaseLeaveTypeRelationshipDataInnerToJSON,
    AbsenceCaseLeaveTypeRelationshipDataInnerToJSONTyped: AbsenceCaseLeaveTypeRelationshipDataInnerToJSONTyped,
    AbsenceCaseLeaveTypeRelationshipFromJSON: AbsenceCaseLeaveTypeRelationshipFromJSON,
    AbsenceCaseLeaveTypeRelationshipFromJSONTyped: AbsenceCaseLeaveTypeRelationshipFromJSONTyped,
    AbsenceCaseLeaveTypeRelationshipToJSON: AbsenceCaseLeaveTypeRelationshipToJSON,
    AbsenceCaseLeaveTypeRelationshipToJSONTyped: AbsenceCaseLeaveTypeRelationshipToJSONTyped,
    AbsenceCaseProjectedUsagesReducedAttributesFromJSON: AbsenceCaseProjectedUsagesReducedAttributesFromJSON,
    AbsenceCaseProjectedUsagesReducedAttributesFromJSONTyped: AbsenceCaseProjectedUsagesReducedAttributesFromJSONTyped,
    AbsenceCaseProjectedUsagesReducedAttributesToJSON: AbsenceCaseProjectedUsagesReducedAttributesToJSON,
    AbsenceCaseProjectedUsagesReducedAttributesToJSONTyped: AbsenceCaseProjectedUsagesReducedAttributesToJSONTyped,
    AbsenceCaseProjectedUsagesReducedFromJSON: AbsenceCaseProjectedUsagesReducedFromJSON,
    AbsenceCaseProjectedUsagesReducedFromJSONTyped: AbsenceCaseProjectedUsagesReducedFromJSONTyped,
    AbsenceCaseProjectedUsagesReducedToJSON: AbsenceCaseProjectedUsagesReducedToJSON,
    AbsenceCaseProjectedUsagesReducedToJSONTyped: AbsenceCaseProjectedUsagesReducedToJSONTyped,
    AbsenceCaseProjectedUsagesRelationshipDataInnerFromJSON: AbsenceCaseProjectedUsagesRelationshipDataInnerFromJSON,
    AbsenceCaseProjectedUsagesRelationshipDataInnerFromJSONTyped: AbsenceCaseProjectedUsagesRelationshipDataInnerFromJSONTyped,
    AbsenceCaseProjectedUsagesRelationshipDataInnerToJSON: AbsenceCaseProjectedUsagesRelationshipDataInnerToJSON,
    AbsenceCaseProjectedUsagesRelationshipDataInnerToJSONTyped: AbsenceCaseProjectedUsagesRelationshipDataInnerToJSONTyped,
    AbsenceCaseProjectedUsagesRelationshipFromJSON: AbsenceCaseProjectedUsagesRelationshipFromJSON,
    AbsenceCaseProjectedUsagesRelationshipFromJSONTyped: AbsenceCaseProjectedUsagesRelationshipFromJSONTyped,
    AbsenceCaseProjectedUsagesRelationshipToJSON: AbsenceCaseProjectedUsagesRelationshipToJSON,
    AbsenceCaseProjectedUsagesRelationshipToJSONTyped: AbsenceCaseProjectedUsagesRelationshipToJSONTyped,
    AbsenceCaseQuestionAttributesFromJSON: AbsenceCaseQuestionAttributesFromJSON,
    AbsenceCaseQuestionAttributesFromJSONTyped: AbsenceCaseQuestionAttributesFromJSONTyped,
    AbsenceCaseQuestionAttributesToJSON: AbsenceCaseQuestionAttributesToJSON,
    AbsenceCaseQuestionAttributesToJSONTyped: AbsenceCaseQuestionAttributesToJSONTyped,
    AbsenceCaseQuestionFromJSON: AbsenceCaseQuestionFromJSON,
    AbsenceCaseQuestionFromJSONTyped: AbsenceCaseQuestionFromJSONTyped,
    AbsenceCaseQuestionMetaFromJSON: AbsenceCaseQuestionMetaFromJSON,
    AbsenceCaseQuestionMetaFromJSONTyped: AbsenceCaseQuestionMetaFromJSONTyped,
    AbsenceCaseQuestionMetaToJSON: AbsenceCaseQuestionMetaToJSON,
    AbsenceCaseQuestionMetaToJSONTyped: AbsenceCaseQuestionMetaToJSONTyped,
    AbsenceCaseQuestionRelationshipsFromJSON: AbsenceCaseQuestionRelationshipsFromJSON,
    AbsenceCaseQuestionRelationshipsFromJSONTyped: AbsenceCaseQuestionRelationshipsFromJSONTyped,
    AbsenceCaseQuestionRelationshipsToJSON: AbsenceCaseQuestionRelationshipsToJSON,
    AbsenceCaseQuestionRelationshipsToJSONTyped: AbsenceCaseQuestionRelationshipsToJSONTyped,
    AbsenceCaseQuestionToJSON: AbsenceCaseQuestionToJSON,
    AbsenceCaseQuestionToJSONTyped: AbsenceCaseQuestionToJSONTyped,
    AbsenceCaseReasonReducedAttributesFromJSON: AbsenceCaseReasonReducedAttributesFromJSON,
    AbsenceCaseReasonReducedAttributesFromJSONTyped: AbsenceCaseReasonReducedAttributesFromJSONTyped,
    AbsenceCaseReasonReducedAttributesToJSON: AbsenceCaseReasonReducedAttributesToJSON,
    AbsenceCaseReasonReducedAttributesToJSONTyped: AbsenceCaseReasonReducedAttributesToJSONTyped,
    AbsenceCaseReasonReducedFromJSON: AbsenceCaseReasonReducedFromJSON,
    AbsenceCaseReasonReducedFromJSONTyped: AbsenceCaseReasonReducedFromJSONTyped,
    AbsenceCaseReasonReducedToJSON: AbsenceCaseReasonReducedToJSON,
    AbsenceCaseReasonReducedToJSONTyped: AbsenceCaseReasonReducedToJSONTyped,
    AbsenceCaseReasonRelationshipDataFromJSON: AbsenceCaseReasonRelationshipDataFromJSON,
    AbsenceCaseReasonRelationshipDataFromJSONTyped: AbsenceCaseReasonRelationshipDataFromJSONTyped,
    AbsenceCaseReasonRelationshipDataToJSON: AbsenceCaseReasonRelationshipDataToJSON,
    AbsenceCaseReasonRelationshipDataToJSONTyped: AbsenceCaseReasonRelationshipDataToJSONTyped,
    AbsenceCaseReasonRelationshipFromJSON: AbsenceCaseReasonRelationshipFromJSON,
    AbsenceCaseReasonRelationshipFromJSONTyped: AbsenceCaseReasonRelationshipFromJSONTyped,
    AbsenceCaseReasonRelationshipToJSON: AbsenceCaseReasonRelationshipToJSON,
    AbsenceCaseReasonRelationshipToJSONTyped: AbsenceCaseReasonRelationshipToJSONTyped,
    AbsenceCaseReducedFromJSON: AbsenceCaseReducedFromJSON,
    AbsenceCaseReducedFromJSONTyped: AbsenceCaseReducedFromJSONTyped,
    AbsenceCaseReducedToJSON: AbsenceCaseReducedToJSON,
    AbsenceCaseReducedToJSONTyped: AbsenceCaseReducedToJSONTyped,
    AbsenceCaseRelationshipDataFromJSON: AbsenceCaseRelationshipDataFromJSON,
    AbsenceCaseRelationshipDataFromJSONTyped: AbsenceCaseRelationshipDataFromJSONTyped,
    AbsenceCaseRelationshipDataToJSON: AbsenceCaseRelationshipDataToJSON,
    AbsenceCaseRelationshipDataToJSONTyped: AbsenceCaseRelationshipDataToJSONTyped,
    AbsenceCaseRelationshipFromJSON: AbsenceCaseRelationshipFromJSON,
    AbsenceCaseRelationshipFromJSONTyped: AbsenceCaseRelationshipFromJSONTyped,
    AbsenceCaseRelationshipToJSON: AbsenceCaseRelationshipToJSON,
    AbsenceCaseRelationshipToJSONTyped: AbsenceCaseRelationshipToJSONTyped,
    AbsenceCaseRelationshipsFromJSON: AbsenceCaseRelationshipsFromJSON,
    AbsenceCaseRelationshipsFromJSONTyped: AbsenceCaseRelationshipsFromJSONTyped,
    AbsenceCaseRelationshipsToJSON: AbsenceCaseRelationshipsToJSON,
    AbsenceCaseRelationshipsToJSONTyped: AbsenceCaseRelationshipsToJSONTyped,
    AbsenceCaseToJSON: AbsenceCaseToJSON,
    AbsenceCaseToJSONTyped: AbsenceCaseToJSONTyped,
    AbsenceCaseUpdateRequestAtomicOperationsInnerFromJSON: AbsenceCaseUpdateRequestAtomicOperationsInnerFromJSON,
    AbsenceCaseUpdateRequestAtomicOperationsInnerFromJSONTyped: AbsenceCaseUpdateRequestAtomicOperationsInnerFromJSONTyped,
    AbsenceCaseUpdateRequestAtomicOperationsInnerOpEnum: AbsenceCaseUpdateRequestAtomicOperationsInnerOpEnum,
    AbsenceCaseUpdateRequestAtomicOperationsInnerToJSON: AbsenceCaseUpdateRequestAtomicOperationsInnerToJSON,
    AbsenceCaseUpdateRequestAtomicOperationsInnerToJSONTyped: AbsenceCaseUpdateRequestAtomicOperationsInnerToJSONTyped,
    AbsenceCaseUpdateRequestFromJSON: AbsenceCaseUpdateRequestFromJSON,
    AbsenceCaseUpdateRequestFromJSONTyped: AbsenceCaseUpdateRequestFromJSONTyped,
    AbsenceCaseUpdateRequestToJSON: AbsenceCaseUpdateRequestToJSON,
    AbsenceCaseUpdateRequestToJSONTyped: AbsenceCaseUpdateRequestToJSONTyped,
    AbsenceCaseUpdateResponseAtomicResultsInnerDataFromJSON: AbsenceCaseUpdateResponseAtomicResultsInnerDataFromJSON,
    AbsenceCaseUpdateResponseAtomicResultsInnerDataFromJSONTyped: AbsenceCaseUpdateResponseAtomicResultsInnerDataFromJSONTyped,
    AbsenceCaseUpdateResponseAtomicResultsInnerDataToJSON: AbsenceCaseUpdateResponseAtomicResultsInnerDataToJSON,
    AbsenceCaseUpdateResponseAtomicResultsInnerDataToJSONTyped: AbsenceCaseUpdateResponseAtomicResultsInnerDataToJSONTyped,
    AbsenceCaseUpdateResponseAtomicResultsInnerFromJSON: AbsenceCaseUpdateResponseAtomicResultsInnerFromJSON,
    AbsenceCaseUpdateResponseAtomicResultsInnerFromJSONTyped: AbsenceCaseUpdateResponseAtomicResultsInnerFromJSONTyped,
    AbsenceCaseUpdateResponseAtomicResultsInnerToJSON: AbsenceCaseUpdateResponseAtomicResultsInnerToJSON,
    AbsenceCaseUpdateResponseAtomicResultsInnerToJSONTyped: AbsenceCaseUpdateResponseAtomicResultsInnerToJSONTyped,
    AbsenceCaseUpdateResponseFromJSON: AbsenceCaseUpdateResponseFromJSON,
    AbsenceCaseUpdateResponseFromJSONTyped: AbsenceCaseUpdateResponseFromJSONTyped,
    AbsenceCaseUpdateResponseToJSON: AbsenceCaseUpdateResponseToJSON,
    AbsenceCaseUpdateResponseToJSONTyped: AbsenceCaseUpdateResponseToJSONTyped,
    AbsenceCaseUpdateResultAttributesContactMethodEnum: AbsenceCaseUpdateResultAttributesContactMethodEnum,
    AbsenceCaseUpdateResultAttributesFromJSON: AbsenceCaseUpdateResultAttributesFromJSON,
    AbsenceCaseUpdateResultAttributesFromJSONTyped: AbsenceCaseUpdateResultAttributesFromJSONTyped,
    AbsenceCaseUpdateResultAttributesToJSON: AbsenceCaseUpdateResultAttributesToJSON,
    AbsenceCaseUpdateResultAttributesToJSONTyped: AbsenceCaseUpdateResultAttributesToJSONTyped,
    AbsenceCaseUpdateResultAttributesUsePaidTimeEnum: AbsenceCaseUpdateResultAttributesUsePaidTimeEnum,
    AbsenceCaseUpdateResultFromJSON: AbsenceCaseUpdateResultFromJSON,
    AbsenceCaseUpdateResultFromJSONTyped: AbsenceCaseUpdateResultFromJSONTyped,
    AbsenceCaseUpdateResultRelationshipsFromJSON: AbsenceCaseUpdateResultRelationshipsFromJSON,
    AbsenceCaseUpdateResultRelationshipsFromJSONTyped: AbsenceCaseUpdateResultRelationshipsFromJSONTyped,
    AbsenceCaseUpdateResultRelationshipsToJSON: AbsenceCaseUpdateResultRelationshipsToJSON,
    AbsenceCaseUpdateResultRelationshipsToJSONTyped: AbsenceCaseUpdateResultRelationshipsToJSONTyped,
    AbsenceCaseUpdateResultToJSON: AbsenceCaseUpdateResultToJSON,
    AbsenceCaseUpdateResultToJSONTyped: AbsenceCaseUpdateResultToJSONTyped,
    AbsenceCaseUploadDocumentsRequestDataAttributesFromJSON: AbsenceCaseUploadDocumentsRequestDataAttributesFromJSON,
    AbsenceCaseUploadDocumentsRequestDataAttributesFromJSONTyped: AbsenceCaseUploadDocumentsRequestDataAttributesFromJSONTyped,
    AbsenceCaseUploadDocumentsRequestDataAttributesToJSON: AbsenceCaseUploadDocumentsRequestDataAttributesToJSON,
    AbsenceCaseUploadDocumentsRequestDataAttributesToJSONTyped: AbsenceCaseUploadDocumentsRequestDataAttributesToJSONTyped,
    AbsenceCaseUploadDocumentsRequestDataFromJSON: AbsenceCaseUploadDocumentsRequestDataFromJSON,
    AbsenceCaseUploadDocumentsRequestDataFromJSONTyped: AbsenceCaseUploadDocumentsRequestDataFromJSONTyped,
    AbsenceCaseUploadDocumentsRequestDataToJSON: AbsenceCaseUploadDocumentsRequestDataToJSON,
    AbsenceCaseUploadDocumentsRequestDataToJSONTyped: AbsenceCaseUploadDocumentsRequestDataToJSONTyped,
    AbsenceCaseUploadDocumentsRequestFromJSON: AbsenceCaseUploadDocumentsRequestFromJSON,
    AbsenceCaseUploadDocumentsRequestFromJSONTyped: AbsenceCaseUploadDocumentsRequestFromJSONTyped,
    AbsenceCaseUploadDocumentsRequestToJSON: AbsenceCaseUploadDocumentsRequestToJSON,
    AbsenceCaseUploadDocumentsRequestToJSONTyped: AbsenceCaseUploadDocumentsRequestToJSONTyped,
    AbsenceCaseUploadDocumentsResponseAttributesFromJSON: AbsenceCaseUploadDocumentsResponseAttributesFromJSON,
    AbsenceCaseUploadDocumentsResponseAttributesFromJSONTyped: AbsenceCaseUploadDocumentsResponseAttributesFromJSONTyped,
    AbsenceCaseUploadDocumentsResponseAttributesToJSON: AbsenceCaseUploadDocumentsResponseAttributesToJSON,
    AbsenceCaseUploadDocumentsResponseAttributesToJSONTyped: AbsenceCaseUploadDocumentsResponseAttributesToJSONTyped,
    AbsenceCaseUploadDocumentsResponseFromJSON: AbsenceCaseUploadDocumentsResponseFromJSON,
    AbsenceCaseUploadDocumentsResponseFromJSONTyped: AbsenceCaseUploadDocumentsResponseFromJSONTyped,
    AbsenceCaseUploadDocumentsResponseRelationshipsFromJSON: AbsenceCaseUploadDocumentsResponseRelationshipsFromJSON,
    AbsenceCaseUploadDocumentsResponseRelationshipsFromJSONTyped: AbsenceCaseUploadDocumentsResponseRelationshipsFromJSONTyped,
    AbsenceCaseUploadDocumentsResponseRelationshipsToJSON: AbsenceCaseUploadDocumentsResponseRelationshipsToJSON,
    AbsenceCaseUploadDocumentsResponseRelationshipsToJSONTyped: AbsenceCaseUploadDocumentsResponseRelationshipsToJSONTyped,
    AbsenceCaseUploadDocumentsResponseToJSON: AbsenceCaseUploadDocumentsResponseToJSON,
    AbsenceCaseUploadDocumentsResponseToJSONTyped: AbsenceCaseUploadDocumentsResponseToJSONTyped,
    AbsenceCaseWorkflowEventAttributesFromJSON: AbsenceCaseWorkflowEventAttributesFromJSON,
    AbsenceCaseWorkflowEventAttributesFromJSONTyped: AbsenceCaseWorkflowEventAttributesFromJSONTyped,
    AbsenceCaseWorkflowEventAttributesToJSON: AbsenceCaseWorkflowEventAttributesToJSON,
    AbsenceCaseWorkflowEventAttributesToJSONTyped: AbsenceCaseWorkflowEventAttributesToJSONTyped,
    AbsenceCaseWorkflowEventEmployeeRelationshipDataFromJSON: AbsenceCaseWorkflowEventEmployeeRelationshipDataFromJSON,
    AbsenceCaseWorkflowEventEmployeeRelationshipDataFromJSONTyped: AbsenceCaseWorkflowEventEmployeeRelationshipDataFromJSONTyped,
    AbsenceCaseWorkflowEventEmployeeRelationshipDataToJSON: AbsenceCaseWorkflowEventEmployeeRelationshipDataToJSON,
    AbsenceCaseWorkflowEventEmployeeRelationshipDataToJSONTyped: AbsenceCaseWorkflowEventEmployeeRelationshipDataToJSONTyped,
    AbsenceCaseWorkflowEventEmployeeRelationshipFromJSON: AbsenceCaseWorkflowEventEmployeeRelationshipFromJSON,
    AbsenceCaseWorkflowEventEmployeeRelationshipFromJSONTyped: AbsenceCaseWorkflowEventEmployeeRelationshipFromJSONTyped,
    AbsenceCaseWorkflowEventEmployeeRelationshipToJSON: AbsenceCaseWorkflowEventEmployeeRelationshipToJSON,
    AbsenceCaseWorkflowEventEmployeeRelationshipToJSONTyped: AbsenceCaseWorkflowEventEmployeeRelationshipToJSONTyped,
    AbsenceCaseWorkflowEventFromJSON: AbsenceCaseWorkflowEventFromJSON,
    AbsenceCaseWorkflowEventFromJSONTyped: AbsenceCaseWorkflowEventFromJSONTyped,
    AbsenceCaseWorkflowEventRelationshipsFromJSON: AbsenceCaseWorkflowEventRelationshipsFromJSON,
    AbsenceCaseWorkflowEventRelationshipsFromJSONTyped: AbsenceCaseWorkflowEventRelationshipsFromJSONTyped,
    AbsenceCaseWorkflowEventRelationshipsToJSON: AbsenceCaseWorkflowEventRelationshipsToJSON,
    AbsenceCaseWorkflowEventRelationshipsToJSONTyped: AbsenceCaseWorkflowEventRelationshipsToJSONTyped,
    AbsenceCaseWorkflowEventToJSON: AbsenceCaseWorkflowEventToJSON,
    AbsenceCaseWorkflowEventToJSONTyped: AbsenceCaseWorkflowEventToJSONTyped,
    AbsenceCaseWorkflowEventTypeReducedAttributesFromJSON: AbsenceCaseWorkflowEventTypeReducedAttributesFromJSON,
    AbsenceCaseWorkflowEventTypeReducedAttributesFromJSONTyped: AbsenceCaseWorkflowEventTypeReducedAttributesFromJSONTyped,
    AbsenceCaseWorkflowEventTypeReducedAttributesToJSON: AbsenceCaseWorkflowEventTypeReducedAttributesToJSON,
    AbsenceCaseWorkflowEventTypeReducedAttributesToJSONTyped: AbsenceCaseWorkflowEventTypeReducedAttributesToJSONTyped,
    AbsenceCaseWorkflowEventTypeReducedFromJSON: AbsenceCaseWorkflowEventTypeReducedFromJSON,
    AbsenceCaseWorkflowEventTypeReducedFromJSONTyped: AbsenceCaseWorkflowEventTypeReducedFromJSONTyped,
    AbsenceCaseWorkflowEventTypeReducedToJSON: AbsenceCaseWorkflowEventTypeReducedToJSON,
    AbsenceCaseWorkflowEventTypeReducedToJSONTyped: AbsenceCaseWorkflowEventTypeReducedToJSONTyped,
    AbsenceCaseWorkflowEventTypeRelationshipDataFromJSON: AbsenceCaseWorkflowEventTypeRelationshipDataFromJSON,
    AbsenceCaseWorkflowEventTypeRelationshipDataFromJSONTyped: AbsenceCaseWorkflowEventTypeRelationshipDataFromJSONTyped,
    AbsenceCaseWorkflowEventTypeRelationshipDataToJSON: AbsenceCaseWorkflowEventTypeRelationshipDataToJSON,
    AbsenceCaseWorkflowEventTypeRelationshipDataToJSONTyped: AbsenceCaseWorkflowEventTypeRelationshipDataToJSONTyped,
    AbsenceCaseWorkflowEventTypeRelationshipFromJSON: AbsenceCaseWorkflowEventTypeRelationshipFromJSON,
    AbsenceCaseWorkflowEventTypeRelationshipFromJSONTyped: AbsenceCaseWorkflowEventTypeRelationshipFromJSONTyped,
    AbsenceCaseWorkflowEventTypeRelationshipToJSON: AbsenceCaseWorkflowEventTypeRelationshipToJSON,
    AbsenceCaseWorkflowEventTypeRelationshipToJSONTyped: AbsenceCaseWorkflowEventTypeRelationshipToJSONTyped,
    AbsenceCreateCaseRequestDataAttributesFromJSON: AbsenceCreateCaseRequestDataAttributesFromJSON,
    AbsenceCreateCaseRequestDataAttributesFromJSONTyped: AbsenceCreateCaseRequestDataAttributesFromJSONTyped,
    AbsenceCreateCaseRequestDataAttributesQuestionResponsesInnerFromJSON: AbsenceCreateCaseRequestDataAttributesQuestionResponsesInnerFromJSON,
    AbsenceCreateCaseRequestDataAttributesQuestionResponsesInnerFromJSONTyped: AbsenceCreateCaseRequestDataAttributesQuestionResponsesInnerFromJSONTyped,
    AbsenceCreateCaseRequestDataAttributesQuestionResponsesInnerToJSON: AbsenceCreateCaseRequestDataAttributesQuestionResponsesInnerToJSON,
    AbsenceCreateCaseRequestDataAttributesQuestionResponsesInnerToJSONTyped: AbsenceCreateCaseRequestDataAttributesQuestionResponsesInnerToJSONTyped,
    AbsenceCreateCaseRequestDataAttributesToJSON: AbsenceCreateCaseRequestDataAttributesToJSON,
    AbsenceCreateCaseRequestDataAttributesToJSONTyped: AbsenceCreateCaseRequestDataAttributesToJSONTyped,
    AbsenceCreateCaseRequestDataFromJSON: AbsenceCreateCaseRequestDataFromJSON,
    AbsenceCreateCaseRequestDataFromJSONTyped: AbsenceCreateCaseRequestDataFromJSONTyped,
    AbsenceCreateCaseRequestDataRelationshipsFromJSON: AbsenceCreateCaseRequestDataRelationshipsFromJSON,
    AbsenceCreateCaseRequestDataRelationshipsFromJSONTyped: AbsenceCreateCaseRequestDataRelationshipsFromJSONTyped,
    AbsenceCreateCaseRequestDataRelationshipsToJSON: AbsenceCreateCaseRequestDataRelationshipsToJSON,
    AbsenceCreateCaseRequestDataRelationshipsToJSONTyped: AbsenceCreateCaseRequestDataRelationshipsToJSONTyped,
    AbsenceCreateCaseRequestDataToJSON: AbsenceCreateCaseRequestDataToJSON,
    AbsenceCreateCaseRequestDataToJSONTyped: AbsenceCreateCaseRequestDataToJSONTyped,
    AbsenceCreateCaseRequestFromJSON: AbsenceCreateCaseRequestFromJSON,
    AbsenceCreateCaseRequestFromJSONTyped: AbsenceCreateCaseRequestFromJSONTyped,
    AbsenceCreateCaseRequestToJSON: AbsenceCreateCaseRequestToJSON,
    AbsenceCreateCaseRequestToJSONTyped: AbsenceCreateCaseRequestToJSONTyped,
    AbsenceCreateCaseResponseDataAttributesFromJSON: AbsenceCreateCaseResponseDataAttributesFromJSON,
    AbsenceCreateCaseResponseDataAttributesFromJSONTyped: AbsenceCreateCaseResponseDataAttributesFromJSONTyped,
    AbsenceCreateCaseResponseDataAttributesToJSON: AbsenceCreateCaseResponseDataAttributesToJSON,
    AbsenceCreateCaseResponseDataAttributesToJSONTyped: AbsenceCreateCaseResponseDataAttributesToJSONTyped,
    AbsenceCreateCaseResponseDataFromJSON: AbsenceCreateCaseResponseDataFromJSON,
    AbsenceCreateCaseResponseDataFromJSONTyped: AbsenceCreateCaseResponseDataFromJSONTyped,
    AbsenceCreateCaseResponseDataToJSON: AbsenceCreateCaseResponseDataToJSON,
    AbsenceCreateCaseResponseDataToJSONTyped: AbsenceCreateCaseResponseDataToJSONTyped,
    AbsenceCreateCaseResponseFromJSON: AbsenceCreateCaseResponseFromJSON,
    AbsenceCreateCaseResponseFromJSONTyped: AbsenceCreateCaseResponseFromJSONTyped,
    AbsenceCreateCaseResponseToJSON: AbsenceCreateCaseResponseToJSON,
    AbsenceCreateCaseResponseToJSONTyped: AbsenceCreateCaseResponseToJSONTyped,
    AbsenceLimitMetaFromJSON: AbsenceLimitMetaFromJSON,
    AbsenceLimitMetaFromJSONTyped: AbsenceLimitMetaFromJSONTyped,
    AbsenceLimitMetaOverlappingCustomRulesInnerFromJSON: AbsenceLimitMetaOverlappingCustomRulesInnerFromJSON,
    AbsenceLimitMetaOverlappingCustomRulesInnerFromJSONTyped: AbsenceLimitMetaOverlappingCustomRulesInnerFromJSONTyped,
    AbsenceLimitMetaOverlappingCustomRulesInnerToJSON: AbsenceLimitMetaOverlappingCustomRulesInnerToJSON,
    AbsenceLimitMetaOverlappingCustomRulesInnerToJSONTyped: AbsenceLimitMetaOverlappingCustomRulesInnerToJSONTyped,
    AbsenceLimitMetaToJSON: AbsenceLimitMetaToJSON,
    AbsenceLimitMetaToJSONTyped: AbsenceLimitMetaToJSONTyped,
    AbsenceLimitsCustomRulesInnerFromJSON: AbsenceLimitsCustomRulesInnerFromJSON,
    AbsenceLimitsCustomRulesInnerFromJSONTyped: AbsenceLimitsCustomRulesInnerFromJSONTyped,
    AbsenceLimitsCustomRulesInnerToJSON: AbsenceLimitsCustomRulesInnerToJSON,
    AbsenceLimitsCustomRulesInnerToJSONTyped: AbsenceLimitsCustomRulesInnerToJSONTyped,
    AbsenceLimitsDefaultRulesFromJSON: AbsenceLimitsDefaultRulesFromJSON,
    AbsenceLimitsDefaultRulesFromJSONTyped: AbsenceLimitsDefaultRulesFromJSONTyped,
    AbsenceLimitsDefaultRulesToJSON: AbsenceLimitsDefaultRulesToJSON,
    AbsenceLimitsDefaultRulesToJSONTyped: AbsenceLimitsDefaultRulesToJSONTyped,
    AbsenceLimitsFromJSON: AbsenceLimitsFromJSON,
    AbsenceLimitsFromJSONTyped: AbsenceLimitsFromJSONTyped,
    AbsenceLimitsToJSON: AbsenceLimitsToJSON,
    AbsenceLimitsToJSONTyped: AbsenceLimitsToJSONTyped,
    AbsenceReasonAttributesFromJSON: AbsenceReasonAttributesFromJSON,
    AbsenceReasonAttributesFromJSONTyped: AbsenceReasonAttributesFromJSONTyped,
    AbsenceReasonAttributesToJSON: AbsenceReasonAttributesToJSON,
    AbsenceReasonAttributesToJSONTyped: AbsenceReasonAttributesToJSONTyped,
    AbsenceReasonFromJSON: AbsenceReasonFromJSON,
    AbsenceReasonFromJSONTyped: AbsenceReasonFromJSONTyped,
    AbsenceReasonToJSON: AbsenceReasonToJSON,
    AbsenceReasonToJSONTyped: AbsenceReasonToJSONTyped,
    AbsenceTypeAttributesFromJSON: AbsenceTypeAttributesFromJSON,
    AbsenceTypeAttributesFromJSONTyped: AbsenceTypeAttributesFromJSONTyped,
    AbsenceTypeAttributesToJSON: AbsenceTypeAttributesToJSON,
    AbsenceTypeAttributesToJSONTyped: AbsenceTypeAttributesToJSONTyped,
    AbsenceTypeFromJSON: AbsenceTypeFromJSON,
    AbsenceTypeFromJSONTyped: AbsenceTypeFromJSONTyped,
    AbsenceTypeRelationshipDataFromJSON: AbsenceTypeRelationshipDataFromJSON,
    AbsenceTypeRelationshipDataFromJSONTyped: AbsenceTypeRelationshipDataFromJSONTyped,
    AbsenceTypeRelationshipDataToJSON: AbsenceTypeRelationshipDataToJSON,
    AbsenceTypeRelationshipDataToJSONTyped: AbsenceTypeRelationshipDataToJSONTyped,
    AbsenceTypeRelationshipFromJSON: AbsenceTypeRelationshipFromJSON,
    AbsenceTypeRelationshipFromJSONTyped: AbsenceTypeRelationshipFromJSONTyped,
    AbsenceTypeRelationshipToJSON: AbsenceTypeRelationshipToJSON,
    AbsenceTypeRelationshipToJSONTyped: AbsenceTypeRelationshipToJSONTyped,
    AbsenceTypeRelationshipsAllowedPayCodesDataInnerFromJSON: AbsenceTypeRelationshipsAllowedPayCodesDataInnerFromJSON,
    AbsenceTypeRelationshipsAllowedPayCodesDataInnerFromJSONTyped: AbsenceTypeRelationshipsAllowedPayCodesDataInnerFromJSONTyped,
    AbsenceTypeRelationshipsAllowedPayCodesDataInnerToJSON: AbsenceTypeRelationshipsAllowedPayCodesDataInnerToJSON,
    AbsenceTypeRelationshipsAllowedPayCodesDataInnerToJSONTyped: AbsenceTypeRelationshipsAllowedPayCodesDataInnerToJSONTyped,
    AbsenceTypeRelationshipsAllowedPayCodesFromJSON: AbsenceTypeRelationshipsAllowedPayCodesFromJSON,
    AbsenceTypeRelationshipsAllowedPayCodesFromJSONTyped: AbsenceTypeRelationshipsAllowedPayCodesFromJSONTyped,
    AbsenceTypeRelationshipsAllowedPayCodesToJSON: AbsenceTypeRelationshipsAllowedPayCodesToJSON,
    AbsenceTypeRelationshipsAllowedPayCodesToJSONTyped: AbsenceTypeRelationshipsAllowedPayCodesToJSONTyped,
    AbsenceTypeRelationshipsDefaultPayCodeDataFromJSON: AbsenceTypeRelationshipsDefaultPayCodeDataFromJSON,
    AbsenceTypeRelationshipsDefaultPayCodeDataFromJSONTyped: AbsenceTypeRelationshipsDefaultPayCodeDataFromJSONTyped,
    AbsenceTypeRelationshipsDefaultPayCodeDataToJSON: AbsenceTypeRelationshipsDefaultPayCodeDataToJSON,
    AbsenceTypeRelationshipsDefaultPayCodeDataToJSONTyped: AbsenceTypeRelationshipsDefaultPayCodeDataToJSONTyped,
    AbsenceTypeRelationshipsDefaultPayCodeFromJSON: AbsenceTypeRelationshipsDefaultPayCodeFromJSON,
    AbsenceTypeRelationshipsDefaultPayCodeFromJSONTyped: AbsenceTypeRelationshipsDefaultPayCodeFromJSONTyped,
    AbsenceTypeRelationshipsDefaultPayCodeToJSON: AbsenceTypeRelationshipsDefaultPayCodeToJSON,
    AbsenceTypeRelationshipsDefaultPayCodeToJSONTyped: AbsenceTypeRelationshipsDefaultPayCodeToJSONTyped,
    AbsenceTypeRelationshipsFromJSON: AbsenceTypeRelationshipsFromJSON,
    AbsenceTypeRelationshipsFromJSONTyped: AbsenceTypeRelationshipsFromJSONTyped,
    AbsenceTypeRelationshipsToJSON: AbsenceTypeRelationshipsToJSON,
    AbsenceTypeRelationshipsToJSONTyped: AbsenceTypeRelationshipsToJSONTyped,
    AbsenceTypeToJSON: AbsenceTypeToJSON,
    AbsenceTypeToJSONTyped: AbsenceTypeToJSONTyped,
    AcceptedSchemaDataFromJSON: AcceptedSchemaDataFromJSON,
    AcceptedSchemaDataFromJSONTyped: AcceptedSchemaDataFromJSONTyped,
    AcceptedSchemaDataToJSON: AcceptedSchemaDataToJSON,
    AcceptedSchemaDataToJSONTyped: AcceptedSchemaDataToJSONTyped,
    AcceptedSchemaFromJSON: AcceptedSchemaFromJSON,
    AcceptedSchemaFromJSONTyped: AcceptedSchemaFromJSONTyped,
    AcceptedSchemaToJSON: AcceptedSchemaToJSON,
    AcceptedSchemaToJSONTyped: AcceptedSchemaToJSONTyped,
    ActivitiesLookupRelationshipFromJSON: ActivitiesLookupRelationshipFromJSON,
    ActivitiesLookupRelationshipFromJSONTyped: ActivitiesLookupRelationshipFromJSONTyped,
    ActivitiesLookupRelationshipSchedulingUnitFromJSON: ActivitiesLookupRelationshipSchedulingUnitFromJSON,
    ActivitiesLookupRelationshipSchedulingUnitFromJSONTyped: ActivitiesLookupRelationshipSchedulingUnitFromJSONTyped,
    ActivitiesLookupRelationshipSchedulingUnitMetaFromJSON: ActivitiesLookupRelationshipSchedulingUnitMetaFromJSON,
    ActivitiesLookupRelationshipSchedulingUnitMetaFromJSONTyped: ActivitiesLookupRelationshipSchedulingUnitMetaFromJSONTyped,
    ActivitiesLookupRelationshipSchedulingUnitMetaLookupFromJSON: ActivitiesLookupRelationshipSchedulingUnitMetaLookupFromJSON,
    ActivitiesLookupRelationshipSchedulingUnitMetaLookupFromJSONTyped: ActivitiesLookupRelationshipSchedulingUnitMetaLookupFromJSONTyped,
    ActivitiesLookupRelationshipSchedulingUnitMetaLookupToJSON: ActivitiesLookupRelationshipSchedulingUnitMetaLookupToJSON,
    ActivitiesLookupRelationshipSchedulingUnitMetaLookupToJSONTyped: ActivitiesLookupRelationshipSchedulingUnitMetaLookupToJSONTyped,
    ActivitiesLookupRelationshipSchedulingUnitMetaToJSON: ActivitiesLookupRelationshipSchedulingUnitMetaToJSON,
    ActivitiesLookupRelationshipSchedulingUnitMetaToJSONTyped: ActivitiesLookupRelationshipSchedulingUnitMetaToJSONTyped,
    ActivitiesLookupRelationshipSchedulingUnitToJSON: ActivitiesLookupRelationshipSchedulingUnitToJSON,
    ActivitiesLookupRelationshipSchedulingUnitToJSONTyped: ActivitiesLookupRelationshipSchedulingUnitToJSONTyped,
    ActivitiesLookupRelationshipSchedulingUnitTypeEnum: ActivitiesLookupRelationshipSchedulingUnitTypeEnum,
    ActivitiesLookupRelationshipTaskFromJSON: ActivitiesLookupRelationshipTaskFromJSON,
    ActivitiesLookupRelationshipTaskFromJSONTyped: ActivitiesLookupRelationshipTaskFromJSONTyped,
    ActivitiesLookupRelationshipTaskMetaFromJSON: ActivitiesLookupRelationshipTaskMetaFromJSON,
    ActivitiesLookupRelationshipTaskMetaFromJSONTyped: ActivitiesLookupRelationshipTaskMetaFromJSONTyped,
    ActivitiesLookupRelationshipTaskMetaLookupFromJSON: ActivitiesLookupRelationshipTaskMetaLookupFromJSON,
    ActivitiesLookupRelationshipTaskMetaLookupFromJSONTyped: ActivitiesLookupRelationshipTaskMetaLookupFromJSONTyped,
    ActivitiesLookupRelationshipTaskMetaLookupToJSON: ActivitiesLookupRelationshipTaskMetaLookupToJSON,
    ActivitiesLookupRelationshipTaskMetaLookupToJSONTyped: ActivitiesLookupRelationshipTaskMetaLookupToJSONTyped,
    ActivitiesLookupRelationshipTaskMetaToJSON: ActivitiesLookupRelationshipTaskMetaToJSON,
    ActivitiesLookupRelationshipTaskMetaToJSONTyped: ActivitiesLookupRelationshipTaskMetaToJSONTyped,
    ActivitiesLookupRelationshipTaskToJSON: ActivitiesLookupRelationshipTaskToJSON,
    ActivitiesLookupRelationshipTaskToJSONTyped: ActivitiesLookupRelationshipTaskToJSONTyped,
    ActivitiesLookupRelationshipTaskTypeEnum: ActivitiesLookupRelationshipTaskTypeEnum,
    ActivitiesLookupRelationshipToJSON: ActivitiesLookupRelationshipToJSON,
    ActivitiesLookupRelationshipToJSONTyped: ActivitiesLookupRelationshipToJSONTyped,
    ActivitiesRelationshipDataInnerFromJSON: ActivitiesRelationshipDataInnerFromJSON,
    ActivitiesRelationshipDataInnerFromJSONTyped: ActivitiesRelationshipDataInnerFromJSONTyped,
    ActivitiesRelationshipDataInnerToJSON: ActivitiesRelationshipDataInnerToJSON,
    ActivitiesRelationshipDataInnerToJSONTyped: ActivitiesRelationshipDataInnerToJSONTyped,
    ActivitiesRelationshipFromJSON: ActivitiesRelationshipFromJSON,
    ActivitiesRelationshipFromJSONTyped: ActivitiesRelationshipFromJSONTyped,
    ActivitiesRelationshipToJSON: ActivitiesRelationshipToJSON,
    ActivitiesRelationshipToJSONTyped: ActivitiesRelationshipToJSONTyped,
    AdminAPIsApi: AdminAPIsApi,
    BASE_PATH: BASE_PATH,
    BalanceAttributesFromJSON: BalanceAttributesFromJSON,
    BalanceAttributesFromJSONTyped: BalanceAttributesFromJSONTyped,
    BalanceAttributesTimeUnitFromJSON: BalanceAttributesTimeUnitFromJSON,
    BalanceAttributesTimeUnitFromJSONTyped: BalanceAttributesTimeUnitFromJSONTyped,
    BalanceAttributesTimeUnitToJSON: BalanceAttributesTimeUnitToJSON,
    BalanceAttributesTimeUnitToJSONTyped: BalanceAttributesTimeUnitToJSONTyped,
    BalanceAttributesToJSON: BalanceAttributesToJSON,
    BalanceAttributesToJSONTyped: BalanceAttributesToJSONTyped,
    BalanceFromJSON: BalanceFromJSON,
    BalanceFromJSONTyped: BalanceFromJSONTyped,
    BalanceRelationshipsBankDataFromJSON: BalanceRelationshipsBankDataFromJSON,
    BalanceRelationshipsBankDataFromJSONTyped: BalanceRelationshipsBankDataFromJSONTyped,
    BalanceRelationshipsBankDataToJSON: BalanceRelationshipsBankDataToJSON,
    BalanceRelationshipsBankDataToJSONTyped: BalanceRelationshipsBankDataToJSONTyped,
    BalanceRelationshipsBankFromJSON: BalanceRelationshipsBankFromJSON,
    BalanceRelationshipsBankFromJSONTyped: BalanceRelationshipsBankFromJSONTyped,
    BalanceRelationshipsBankToJSON: BalanceRelationshipsBankToJSON,
    BalanceRelationshipsBankToJSONTyped: BalanceRelationshipsBankToJSONTyped,
    BalanceRelationshipsFromJSON: BalanceRelationshipsFromJSON,
    BalanceRelationshipsFromJSONTyped: BalanceRelationshipsFromJSONTyped,
    BalanceRelationshipsToJSON: BalanceRelationshipsToJSON,
    BalanceRelationshipsToJSONTyped: BalanceRelationshipsToJSONTyped,
    BalanceToJSON: BalanceToJSON,
    BalanceToJSONTyped: BalanceToJSONTyped,
    BankAttributesFromJSON: BankAttributesFromJSON,
    BankAttributesFromJSONTyped: BankAttributesFromJSONTyped,
    BankAttributesToJSON: BankAttributesToJSON,
    BankAttributesToJSONTyped: BankAttributesToJSONTyped,
    BankFromJSON: BankFromJSON,
    BankFromJSONTyped: BankFromJSONTyped,
    BankIncludeItem: BankIncludeItem,
    BankIncludeItemFromJSON: BankIncludeItemFromJSON,
    BankIncludeItemFromJSONTyped: BankIncludeItemFromJSONTyped,
    BankIncludeItemToJSON: BankIncludeItemToJSON,
    BankIncludeItemToJSONTyped: BankIncludeItemToJSONTyped,
    BankMetadataAttributesBalanceLabelFromJSON: BankMetadataAttributesBalanceLabelFromJSON,
    BankMetadataAttributesBalanceLabelFromJSONTyped: BankMetadataAttributesBalanceLabelFromJSONTyped,
    BankMetadataAttributesBalanceLabelToJSON: BankMetadataAttributesBalanceLabelToJSON,
    BankMetadataAttributesBalanceLabelToJSONTyped: BankMetadataAttributesBalanceLabelToJSONTyped,
    BankMetadataAttributesDisplayContextsFromJSON: BankMetadataAttributesDisplayContextsFromJSON,
    BankMetadataAttributesDisplayContextsFromJSONTyped: BankMetadataAttributesDisplayContextsFromJSONTyped,
    BankMetadataAttributesDisplayContextsToJSON: BankMetadataAttributesDisplayContextsToJSON,
    BankMetadataAttributesDisplayContextsToJSONTyped: BankMetadataAttributesDisplayContextsToJSONTyped,
    BankMetadataAttributesFromJSON: BankMetadataAttributesFromJSON,
    BankMetadataAttributesFromJSONTyped: BankMetadataAttributesFromJSONTyped,
    BankMetadataAttributesToJSON: BankMetadataAttributesToJSON,
    BankMetadataAttributesToJSONTyped: BankMetadataAttributesToJSONTyped,
    BankMetadataFromJSON: BankMetadataFromJSON,
    BankMetadataFromJSONTyped: BankMetadataFromJSONTyped,
    BankMetadataIncludeItem: BankMetadataIncludeItem,
    BankMetadataIncludeItemFromJSON: BankMetadataIncludeItemFromJSON,
    BankMetadataIncludeItemFromJSONTyped: BankMetadataIncludeItemFromJSONTyped,
    BankMetadataIncludeItemToJSON: BankMetadataIncludeItemToJSON,
    BankMetadataIncludeItemToJSONTyped: BankMetadataIncludeItemToJSONTyped,
    BankMetadataMetaFromJSON: BankMetadataMetaFromJSON,
    BankMetadataMetaFromJSONTyped: BankMetadataMetaFromJSONTyped,
    BankMetadataMetaToJSON: BankMetadataMetaToJSON,
    BankMetadataMetaToJSONTyped: BankMetadataMetaToJSONTyped,
    BankMetadataToJSON: BankMetadataToJSON,
    BankMetadataToJSONTyped: BankMetadataToJSONTyped,
    BankPolicyRelationshipDataFromJSON: BankPolicyRelationshipDataFromJSON,
    BankPolicyRelationshipDataFromJSONTyped: BankPolicyRelationshipDataFromJSONTyped,
    BankPolicyRelationshipDataToJSON: BankPolicyRelationshipDataToJSON,
    BankPolicyRelationshipDataToJSONTyped: BankPolicyRelationshipDataToJSONTyped,
    BankPolicyRelationshipFromJSON: BankPolicyRelationshipFromJSON,
    BankPolicyRelationshipFromJSONTyped: BankPolicyRelationshipFromJSONTyped,
    BankPolicyRelationshipToJSON: BankPolicyRelationshipToJSON,
    BankPolicyRelationshipToJSONTyped: BankPolicyRelationshipToJSONTyped,
    BankProjectionAttributesFromJSON: BankProjectionAttributesFromJSON,
    BankProjectionAttributesFromJSONTyped: BankProjectionAttributesFromJSONTyped,
    BankProjectionAttributesStatusEnum: BankProjectionAttributesStatusEnum,
    BankProjectionAttributesToJSON: BankProjectionAttributesToJSON,
    BankProjectionAttributesToJSONTyped: BankProjectionAttributesToJSONTyped,
    BankProjectionBalanceRelationshipsDataInnerFromJSON: BankProjectionBalanceRelationshipsDataInnerFromJSON,
    BankProjectionBalanceRelationshipsDataInnerFromJSONTyped: BankProjectionBalanceRelationshipsDataInnerFromJSONTyped,
    BankProjectionBalanceRelationshipsDataInnerToJSON: BankProjectionBalanceRelationshipsDataInnerToJSON,
    BankProjectionBalanceRelationshipsDataInnerToJSONTyped: BankProjectionBalanceRelationshipsDataInnerToJSONTyped,
    BankProjectionBalanceRelationshipsFromJSON: BankProjectionBalanceRelationshipsFromJSON,
    BankProjectionBalanceRelationshipsFromJSONTyped: BankProjectionBalanceRelationshipsFromJSONTyped,
    BankProjectionBalanceRelationshipsToJSON: BankProjectionBalanceRelationshipsToJSON,
    BankProjectionBalanceRelationshipsToJSONTyped: BankProjectionBalanceRelationshipsToJSONTyped,
    BankProjectionCreateRequestDataAttributesFromJSON: BankProjectionCreateRequestDataAttributesFromJSON,
    BankProjectionCreateRequestDataAttributesFromJSONTyped: BankProjectionCreateRequestDataAttributesFromJSONTyped,
    BankProjectionCreateRequestDataAttributesToJSON: BankProjectionCreateRequestDataAttributesToJSON,
    BankProjectionCreateRequestDataAttributesToJSONTyped: BankProjectionCreateRequestDataAttributesToJSONTyped,
    BankProjectionCreateRequestDataFromJSON: BankProjectionCreateRequestDataFromJSON,
    BankProjectionCreateRequestDataFromJSONTyped: BankProjectionCreateRequestDataFromJSONTyped,
    BankProjectionCreateRequestDataToJSON: BankProjectionCreateRequestDataToJSON,
    BankProjectionCreateRequestDataToJSONTyped: BankProjectionCreateRequestDataToJSONTyped,
    BankProjectionCreateRequestDataTypeEnum: BankProjectionCreateRequestDataTypeEnum,
    BankProjectionCreateRequestFromJSON: BankProjectionCreateRequestFromJSON,
    BankProjectionCreateRequestFromJSONTyped: BankProjectionCreateRequestFromJSONTyped,
    BankProjectionCreateRequestToJSON: BankProjectionCreateRequestToJSON,
    BankProjectionCreateRequestToJSONTyped: BankProjectionCreateRequestToJSONTyped,
    BankProjectionEntryRelationshipsDataInnerFromJSON: BankProjectionEntryRelationshipsDataInnerFromJSON,
    BankProjectionEntryRelationshipsDataInnerFromJSONTyped: BankProjectionEntryRelationshipsDataInnerFromJSONTyped,
    BankProjectionEntryRelationshipsDataInnerToJSON: BankProjectionEntryRelationshipsDataInnerToJSON,
    BankProjectionEntryRelationshipsDataInnerToJSONTyped: BankProjectionEntryRelationshipsDataInnerToJSONTyped,
    BankProjectionEntryRelationshipsFromJSON: BankProjectionEntryRelationshipsFromJSON,
    BankProjectionEntryRelationshipsFromJSONTyped: BankProjectionEntryRelationshipsFromJSONTyped,
    BankProjectionEntryRelationshipsToJSON: BankProjectionEntryRelationshipsToJSON,
    BankProjectionEntryRelationshipsToJSONTyped: BankProjectionEntryRelationshipsToJSONTyped,
    BankProjectionFromJSON: BankProjectionFromJSON,
    BankProjectionFromJSONTyped: BankProjectionFromJSONTyped,
    BankProjectionGapRelationshipsDataInnerFromJSON: BankProjectionGapRelationshipsDataInnerFromJSON,
    BankProjectionGapRelationshipsDataInnerFromJSONTyped: BankProjectionGapRelationshipsDataInnerFromJSONTyped,
    BankProjectionGapRelationshipsDataInnerToJSON: BankProjectionGapRelationshipsDataInnerToJSON,
    BankProjectionGapRelationshipsDataInnerToJSONTyped: BankProjectionGapRelationshipsDataInnerToJSONTyped,
    BankProjectionGapRelationshipsFromJSON: BankProjectionGapRelationshipsFromJSON,
    BankProjectionGapRelationshipsFromJSONTyped: BankProjectionGapRelationshipsFromJSONTyped,
    BankProjectionGapRelationshipsToJSON: BankProjectionGapRelationshipsToJSON,
    BankProjectionGapRelationshipsToJSONTyped: BankProjectionGapRelationshipsToJSONTyped,
    BankProjectionMetaFromJSON: BankProjectionMetaFromJSON,
    BankProjectionMetaFromJSONTyped: BankProjectionMetaFromJSONTyped,
    BankProjectionMetaToJSON: BankProjectionMetaToJSON,
    BankProjectionMetaToJSONTyped: BankProjectionMetaToJSONTyped,
    BankProjectionRequestRelationshipsFromJSON: BankProjectionRequestRelationshipsFromJSON,
    BankProjectionRequestRelationshipsFromJSONTyped: BankProjectionRequestRelationshipsFromJSONTyped,
    BankProjectionRequestRelationshipsToJSON: BankProjectionRequestRelationshipsToJSON,
    BankProjectionRequestRelationshipsToJSONTyped: BankProjectionRequestRelationshipsToJSONTyped,
    BankProjectionResponseRelationshipsFromJSON: BankProjectionResponseRelationshipsFromJSON,
    BankProjectionResponseRelationshipsFromJSONTyped: BankProjectionResponseRelationshipsFromJSONTyped,
    BankProjectionResponseRelationshipsToJSON: BankProjectionResponseRelationshipsToJSON,
    BankProjectionResponseRelationshipsToJSONTyped: BankProjectionResponseRelationshipsToJSONTyped,
    BankProjectionToJSON: BankProjectionToJSON,
    BankProjectionToJSONTyped: BankProjectionToJSONTyped,
    BankToJSON: BankToJSON,
    BankToJSONTyped: BankToJSONTyped,
    BaseAPI: BaseAPI,
    BidAttributesFromJSON: BidAttributesFromJSON,
    BidAttributesFromJSONTyped: BidAttributesFromJSONTyped,
    BidAttributesToJSON: BidAttributesToJSON,
    BidAttributesToJSONTyped: BidAttributesToJSONTyped,
    BidBlockAttributesFromJSON: BidBlockAttributesFromJSON,
    BidBlockAttributesFromJSONTyped: BidBlockAttributesFromJSONTyped,
    BidBlockAttributesToJSON: BidBlockAttributesToJSON,
    BidBlockAttributesToJSONTyped: BidBlockAttributesToJSONTyped,
    BidBlockFromJSON: BidBlockFromJSON,
    BidBlockFromJSONTyped: BidBlockFromJSONTyped,
    BidBlockToJSON: BidBlockToJSON,
    BidBlockToJSONTyped: BidBlockToJSONTyped,
    BidBlocksResponseSchemaFromJSON: BidBlocksResponseSchemaFromJSON,
    BidBlocksResponseSchemaFromJSONTyped: BidBlocksResponseSchemaFromJSONTyped,
    BidBlocksResponseSchemaToJSON: BidBlocksResponseSchemaToJSON,
    BidBlocksResponseSchemaToJSONTyped: BidBlocksResponseSchemaToJSONTyped,
    BidFromJSON: BidFromJSON,
    BidFromJSONTyped: BidFromJSONTyped,
    BidMetaFromJSON: BidMetaFromJSON,
    BidMetaFromJSONTyped: BidMetaFromJSONTyped,
    BidMetaToJSON: BidMetaToJSON,
    BidMetaToJSONTyped: BidMetaToJSONTyped,
    BidOptionsConfigurationFromJSON: BidOptionsConfigurationFromJSON,
    BidOptionsConfigurationFromJSONTyped: BidOptionsConfigurationFromJSONTyped,
    BidOptionsConfigurationToJSON: BidOptionsConfigurationToJSON,
    BidOptionsConfigurationToJSONTyped: BidOptionsConfigurationToJSONTyped,
    BidPackageAttributesFromJSON: BidPackageAttributesFromJSON,
    BidPackageAttributesFromJSONTyped: BidPackageAttributesFromJSONTyped,
    BidPackageAttributesToJSON: BidPackageAttributesToJSON,
    BidPackageAttributesToJSONTyped: BidPackageAttributesToJSONTyped,
    BidPackageFromJSON: BidPackageFromJSON,
    BidPackageFromJSONTyped: BidPackageFromJSONTyped,
    BidPackageMetaFromJSON: BidPackageMetaFromJSON,
    BidPackageMetaFromJSONTyped: BidPackageMetaFromJSONTyped,
    BidPackageMetaToJSON: BidPackageMetaToJSON,
    BidPackageMetaToJSONTyped: BidPackageMetaToJSONTyped,
    BidPackageRelationshipsFromJSON: BidPackageRelationshipsFromJSON,
    BidPackageRelationshipsFromJSONTyped: BidPackageRelationshipsFromJSONTyped,
    BidPackageRelationshipsToJSON: BidPackageRelationshipsToJSON,
    BidPackageRelationshipsToJSONTyped: BidPackageRelationshipsToJSONTyped,
    BidPackageResponseSchemaFromJSON: BidPackageResponseSchemaFromJSON,
    BidPackageResponseSchemaFromJSONTyped: BidPackageResponseSchemaFromJSONTyped,
    BidPackageResponseSchemaToJSON: BidPackageResponseSchemaToJSON,
    BidPackageResponseSchemaToJSONTyped: BidPackageResponseSchemaToJSONTyped,
    BidPackageToJSON: BidPackageToJSON,
    BidPackageToJSONTyped: BidPackageToJSONTyped,
    BidRelationshipsBidPackageFromJSON: BidRelationshipsBidPackageFromJSON,
    BidRelationshipsBidPackageFromJSONTyped: BidRelationshipsBidPackageFromJSONTyped,
    BidRelationshipsBidPackageToJSON: BidRelationshipsBidPackageToJSON,
    BidRelationshipsBidPackageToJSONTyped: BidRelationshipsBidPackageToJSONTyped,
    BidRelationshipsBidSelectionsFromJSON: BidRelationshipsBidSelectionsFromJSON,
    BidRelationshipsBidSelectionsFromJSONTyped: BidRelationshipsBidSelectionsFromJSONTyped,
    BidRelationshipsBidSelectionsToJSON: BidRelationshipsBidSelectionsToJSON,
    BidRelationshipsBidSelectionsToJSONTyped: BidRelationshipsBidSelectionsToJSONTyped,
    BidRelationshipsEmployeeFromJSON: BidRelationshipsEmployeeFromJSON,
    BidRelationshipsEmployeeFromJSONTyped: BidRelationshipsEmployeeFromJSONTyped,
    BidRelationshipsEmployeeToJSON: BidRelationshipsEmployeeToJSON,
    BidRelationshipsEmployeeToJSONTyped: BidRelationshipsEmployeeToJSONTyped,
    BidRelationshipsFromJSON: BidRelationshipsFromJSON,
    BidRelationshipsFromJSONTyped: BidRelationshipsFromJSONTyped,
    BidRelationshipsToJSON: BidRelationshipsToJSON,
    BidRelationshipsToJSONTyped: BidRelationshipsToJSONTyped,
    BidResourceDataFromJSON: BidResourceDataFromJSON,
    BidResourceDataFromJSONTyped: BidResourceDataFromJSONTyped,
    BidResourceDataToJSON: BidResourceDataToJSON,
    BidResourceDataToJSONTyped: BidResourceDataToJSONTyped,
    BidResponseSchemaFromJSON: BidResponseSchemaFromJSON,
    BidResponseSchemaFromJSONTyped: BidResponseSchemaFromJSONTyped,
    BidResponseSchemaToJSON: BidResponseSchemaToJSON,
    BidResponseSchemaToJSONTyped: BidResponseSchemaToJSONTyped,
    BidToJSON: BidToJSON,
    BidToJSONTyped: BidToJSONTyped,
    BiddingGroupsDataInnerFromJSON: BiddingGroupsDataInnerFromJSON,
    BiddingGroupsDataInnerFromJSONTyped: BiddingGroupsDataInnerFromJSONTyped,
    BiddingGroupsDataInnerToJSON: BiddingGroupsDataInnerToJSON,
    BiddingGroupsDataInnerToJSONTyped: BiddingGroupsDataInnerToJSONTyped,
    BiddingGroupsFromJSON: BiddingGroupsFromJSON,
    BiddingGroupsFromJSONTyped: BiddingGroupsFromJSONTyped,
    BiddingGroupsToJSON: BiddingGroupsToJSON,
    BiddingGroupsToJSONTyped: BiddingGroupsToJSONTyped,
    BidsResponseSchemaFromJSON: BidsResponseSchemaFromJSON,
    BidsResponseSchemaFromJSONTyped: BidsResponseSchemaFromJSONTyped,
    BidsResponseSchemaToJSON: BidsResponseSchemaToJSON,
    BidsResponseSchemaToJSONTyped: BidsResponseSchemaToJSONTyped,
    BlobApiResponse: BlobApiResponse,
    COLLECTION_FORMATS: COLLECTION_FORMATS,
    CaseType: CaseType,
    CaseTypeFromJSON: CaseTypeFromJSON,
    CaseTypeFromJSONTyped: CaseTypeFromJSONTyped,
    CaseTypeToJSON: CaseTypeToJSON,
    CaseTypeToJSONTyped: CaseTypeToJSONTyped,
    ChildGroupPolicyFromJSON: ChildGroupPolicyFromJSON,
    ChildGroupPolicyFromJSONTyped: ChildGroupPolicyFromJSONTyped,
    ChildGroupPolicyToJSON: ChildGroupPolicyToJSON,
    ChildGroupPolicyToJSONTyped: ChildGroupPolicyToJSONTyped,
    ClockPunchMetadataAttributesFromJSON: ClockPunchMetadataAttributesFromJSON,
    ClockPunchMetadataAttributesFromJSONTyped: ClockPunchMetadataAttributesFromJSONTyped,
    ClockPunchMetadataAttributesToJSON: ClockPunchMetadataAttributesToJSON,
    ClockPunchMetadataAttributesToJSONTyped: ClockPunchMetadataAttributesToJSONTyped,
    ClockPunchMetadataFromJSON: ClockPunchMetadataFromJSON,
    ClockPunchMetadataFromJSONTyped: ClockPunchMetadataFromJSONTyped,
    ClockPunchMetadataRelationshipsFromJSON: ClockPunchMetadataRelationshipsFromJSON,
    ClockPunchMetadataRelationshipsFromJSONTyped: ClockPunchMetadataRelationshipsFromJSONTyped,
    ClockPunchMetadataRelationshipsLastPunchFromJSON: ClockPunchMetadataRelationshipsLastPunchFromJSON,
    ClockPunchMetadataRelationshipsLastPunchFromJSONTyped: ClockPunchMetadataRelationshipsLastPunchFromJSONTyped,
    ClockPunchMetadataRelationshipsLastPunchToJSON: ClockPunchMetadataRelationshipsLastPunchToJSON,
    ClockPunchMetadataRelationshipsLastPunchToJSONTyped: ClockPunchMetadataRelationshipsLastPunchToJSONTyped,
    ClockPunchMetadataRelationshipsToJSON: ClockPunchMetadataRelationshipsToJSON,
    ClockPunchMetadataRelationshipsToJSONTyped: ClockPunchMetadataRelationshipsToJSONTyped,
    ClockPunchMetadataResponseSchemaFromJSON: ClockPunchMetadataResponseSchemaFromJSON,
    ClockPunchMetadataResponseSchemaFromJSONTyped: ClockPunchMetadataResponseSchemaFromJSONTyped,
    ClockPunchMetadataResponseSchemaToJSON: ClockPunchMetadataResponseSchemaToJSON,
    ClockPunchMetadataResponseSchemaToJSONTyped: ClockPunchMetadataResponseSchemaToJSONTyped,
    ClockPunchMetadataToJSON: ClockPunchMetadataToJSON,
    ClockPunchMetadataToJSONTyped: ClockPunchMetadataToJSONTyped,
    ConfigAPIsApi: ConfigAPIsApi,
    Configuration: Configuration,
    CreateBidRequestSchemaDataFromJSON: CreateBidRequestSchemaDataFromJSON,
    CreateBidRequestSchemaDataFromJSONTyped: CreateBidRequestSchemaDataFromJSONTyped,
    CreateBidRequestSchemaDataToJSON: CreateBidRequestSchemaDataToJSON,
    CreateBidRequestSchemaDataToJSONTyped: CreateBidRequestSchemaDataToJSONTyped,
    CreateBidRequestSchemaFromJSON: CreateBidRequestSchemaFromJSON,
    CreateBidRequestSchemaFromJSONTyped: CreateBidRequestSchemaFromJSONTyped,
    CreateBidRequestSchemaToJSON: CreateBidRequestSchemaToJSON,
    CreateBidRequestSchemaToJSONTyped: CreateBidRequestSchemaToJSONTyped,
    CreateBidpackageRequestSchemaDataFromJSON: CreateBidpackageRequestSchemaDataFromJSON,
    CreateBidpackageRequestSchemaDataFromJSONTyped: CreateBidpackageRequestSchemaDataFromJSONTyped,
    CreateBidpackageRequestSchemaDataToJSON: CreateBidpackageRequestSchemaDataToJSON,
    CreateBidpackageRequestSchemaDataToJSONTyped: CreateBidpackageRequestSchemaDataToJSONTyped,
    CreateBidpackageRequestSchemaFromJSON: CreateBidpackageRequestSchemaFromJSON,
    CreateBidpackageRequestSchemaFromJSONTyped: CreateBidpackageRequestSchemaFromJSONTyped,
    CreateBidpackageRequestSchemaToJSON: CreateBidpackageRequestSchemaToJSON,
    CreateBidpackageRequestSchemaToJSONTyped: CreateBidpackageRequestSchemaToJSONTyped,
    CreatePayRuleRequestSchemaBodyFromJSON: CreatePayRuleRequestSchemaBodyFromJSON,
    CreatePayRuleRequestSchemaBodyFromJSONTyped: CreatePayRuleRequestSchemaBodyFromJSONTyped,
    CreatePayRuleRequestSchemaBodyToJSON: CreatePayRuleRequestSchemaBodyToJSON,
    CreatePayRuleRequestSchemaBodyToJSONTyped: CreatePayRuleRequestSchemaBodyToJSONTyped,
    CreatePayRuleRequestSchemaDataFromJSON: CreatePayRuleRequestSchemaDataFromJSON,
    CreatePayRuleRequestSchemaDataFromJSONTyped: CreatePayRuleRequestSchemaDataFromJSONTyped,
    CreatePayRuleRequestSchemaDataRelationshipsFromJSON: CreatePayRuleRequestSchemaDataRelationshipsFromJSON,
    CreatePayRuleRequestSchemaDataRelationshipsFromJSONTyped: CreatePayRuleRequestSchemaDataRelationshipsFromJSONTyped,
    CreatePayRuleRequestSchemaDataRelationshipsToJSON: CreatePayRuleRequestSchemaDataRelationshipsToJSON,
    CreatePayRuleRequestSchemaDataRelationshipsToJSONTyped: CreatePayRuleRequestSchemaDataRelationshipsToJSONTyped,
    CreatePayRuleRequestSchemaDataToJSON: CreatePayRuleRequestSchemaDataToJSON,
    CreatePayRuleRequestSchemaDataToJSONTyped: CreatePayRuleRequestSchemaDataToJSONTyped,
    CreatePayRuleRequestSchemaDataTypeEnum: CreatePayRuleRequestSchemaDataTypeEnum,
    CreatePayRuleRequestSchemaFromJSON: CreatePayRuleRequestSchemaFromJSON,
    CreatePayRuleRequestSchemaFromJSONTyped: CreatePayRuleRequestSchemaFromJSONTyped,
    CreatePayRuleRequestSchemaToJSON: CreatePayRuleRequestSchemaToJSON,
    CreatePayRuleRequestSchemaToJSONTyped: CreatePayRuleRequestSchemaToJSONTyped,
    CreateShiftRelationshipsFromJSON: CreateShiftRelationshipsFromJSON,
    CreateShiftRelationshipsFromJSONTyped: CreateShiftRelationshipsFromJSONTyped,
    CreateShiftRelationshipsToJSON: CreateShiftRelationshipsToJSON,
    CreateShiftRelationshipsToJSONTyped: CreateShiftRelationshipsToJSONTyped,
    CreateShiftRequestSchemaBodyFromJSON: CreateShiftRequestSchemaBodyFromJSON,
    CreateShiftRequestSchemaBodyFromJSONTyped: CreateShiftRequestSchemaBodyFromJSONTyped,
    CreateShiftRequestSchemaBodyStatusEnum: CreateShiftRequestSchemaBodyStatusEnum,
    CreateShiftRequestSchemaBodyToJSON: CreateShiftRequestSchemaBodyToJSON,
    CreateShiftRequestSchemaBodyToJSONTyped: CreateShiftRequestSchemaBodyToJSONTyped,
    CreateShiftRequestSchemaDataFromJSON: CreateShiftRequestSchemaDataFromJSON,
    CreateShiftRequestSchemaDataFromJSONTyped: CreateShiftRequestSchemaDataFromJSONTyped,
    CreateShiftRequestSchemaDataToJSON: CreateShiftRequestSchemaDataToJSON,
    CreateShiftRequestSchemaDataToJSONTyped: CreateShiftRequestSchemaDataToJSONTyped,
    CreateShiftRequestSchemaDataTypeEnum: CreateShiftRequestSchemaDataTypeEnum,
    CreateShiftRequestSchemaFromJSON: CreateShiftRequestSchemaFromJSON,
    CreateShiftRequestSchemaFromJSONTyped: CreateShiftRequestSchemaFromJSONTyped,
    CreateShiftRequestSchemaToJSON: CreateShiftRequestSchemaToJSON,
    CreateShiftRequestSchemaToJSONTyped: CreateShiftRequestSchemaToJSONTyped,
    CreateSingleShiftBreakFromJSON: CreateSingleShiftBreakFromJSON,
    CreateSingleShiftBreakFromJSONTyped: CreateSingleShiftBreakFromJSONTyped,
    CreateSingleShiftBreakToJSON: CreateSingleShiftBreakToJSON,
    CreateSingleShiftBreakToJSONTyped: CreateSingleShiftBreakToJSONTyped,
    CreateTimesheetEntryRequestSchemaDataFromJSON: CreateTimesheetEntryRequestSchemaDataFromJSON,
    CreateTimesheetEntryRequestSchemaDataFromJSONTyped: CreateTimesheetEntryRequestSchemaDataFromJSONTyped,
    CreateTimesheetEntryRequestSchemaDataToJSON: CreateTimesheetEntryRequestSchemaDataToJSON,
    CreateTimesheetEntryRequestSchemaDataToJSONTyped: CreateTimesheetEntryRequestSchemaDataToJSONTyped,
    CreateTimesheetEntryRequestSchemaFromJSON: CreateTimesheetEntryRequestSchemaFromJSON,
    CreateTimesheetEntryRequestSchemaFromJSONTyped: CreateTimesheetEntryRequestSchemaFromJSONTyped,
    CreateTimesheetEntryRequestSchemaToJSON: CreateTimesheetEntryRequestSchemaToJSON,
    CreateTimesheetEntryRequestSchemaToJSONTyped: CreateTimesheetEntryRequestSchemaToJSONTyped,
    CreatedSwipeResponseFromJSON: CreatedSwipeResponseFromJSON,
    CreatedSwipeResponseFromJSONTyped: CreatedSwipeResponseFromJSONTyped,
    CreatedSwipeResponseToJSON: CreatedSwipeResponseToJSON,
    CreatedSwipeResponseToJSONTyped: CreatedSwipeResponseToJSONTyped,
    CreatedTimeOffResponseFromJSON: CreatedTimeOffResponseFromJSON,
    CreatedTimeOffResponseFromJSONTyped: CreatedTimeOffResponseFromJSONTyped,
    CreatedTimeOffResponseToJSON: CreatedTimeOffResponseToJSON,
    CreatedTimeOffResponseToJSONTyped: CreatedTimeOffResponseToJSONTyped,
    DailyDurationFromJSON: DailyDurationFromJSON,
    DailyDurationFromJSONTyped: DailyDurationFromJSONTyped,
    DailyDurationQuantityFromJSON: DailyDurationQuantityFromJSON,
    DailyDurationQuantityFromJSONTyped: DailyDurationQuantityFromJSONTyped,
    DailyDurationQuantityToJSON: DailyDurationQuantityToJSON,
    DailyDurationQuantityToJSONTyped: DailyDurationQuantityToJSONTyped,
    DailyDurationStartTimeQuantityFromJSON: DailyDurationStartTimeQuantityFromJSON,
    DailyDurationStartTimeQuantityFromJSONTyped: DailyDurationStartTimeQuantityFromJSONTyped,
    DailyDurationStartTimeQuantityToJSON: DailyDurationStartTimeQuantityToJSON,
    DailyDurationStartTimeQuantityToJSONTyped: DailyDurationStartTimeQuantityToJSONTyped,
    DailyDurationTimeFromJSON: DailyDurationTimeFromJSON,
    DailyDurationTimeFromJSONTyped: DailyDurationTimeFromJSONTyped,
    DailyDurationTimeToJSON: DailyDurationTimeToJSON,
    DailyDurationTimeToJSONTyped: DailyDurationTimeToJSONTyped,
    DailyDurationToJSON: DailyDurationToJSON,
    DailyDurationToJSONTyped: DailyDurationToJSONTyped,
    DataAPIsApi: DataAPIsApi,
    DataElementAttributesFromJSON: DataElementAttributesFromJSON,
    DataElementAttributesFromJSONTyped: DataElementAttributesFromJSONTyped,
    DataElementAttributesToJSON: DataElementAttributesToJSON,
    DataElementAttributesToJSONTyped: DataElementAttributesToJSONTyped,
    DataElementFromJSON: DataElementFromJSON,
    DataElementFromJSONTyped: DataElementFromJSONTyped,
    DataElementToJSON: DataElementToJSON,
    DataElementToJSONTyped: DataElementToJSONTyped,
    DataV1AbsenceReasonsFilterParameterFromJSON: DataV1AbsenceReasonsFilterParameterFromJSON,
    DataV1AbsenceReasonsFilterParameterFromJSONTyped: DataV1AbsenceReasonsFilterParameterFromJSONTyped,
    DataV1AbsenceReasonsFilterParameterToJSON: DataV1AbsenceReasonsFilterParameterToJSON,
    DataV1AbsenceReasonsFilterParameterToJSONTyped: DataV1AbsenceReasonsFilterParameterToJSONTyped,
    DataV1CaseChangesFilterParameterFromJSON: DataV1CaseChangesFilterParameterFromJSON,
    DataV1CaseChangesFilterParameterFromJSONTyped: DataV1CaseChangesFilterParameterFromJSONTyped,
    DataV1CaseChangesFilterParameterToJSON: DataV1CaseChangesFilterParameterToJSON,
    DataV1CaseChangesFilterParameterToJSONTyped: DataV1CaseChangesFilterParameterToJSONTyped,
    DataV1EmployeesFilterParameterFromJSON: DataV1EmployeesFilterParameterFromJSON,
    DataV1EmployeesFilterParameterFromJSONTyped: DataV1EmployeesFilterParameterFromJSONTyped,
    DataV1EmployeesFilterParameterToJSON: DataV1EmployeesFilterParameterToJSON,
    DataV1EmployeesFilterParameterToJSONTyped: DataV1EmployeesFilterParameterToJSONTyped,
    DayOfWeek: DayOfWeek,
    DayOfWeekFromJSON: DayOfWeekFromJSON,
    DayOfWeekFromJSONTyped: DayOfWeekFromJSONTyped,
    DayOfWeekToJSON: DayOfWeekToJSON,
    DayOfWeekToJSONTyped: DayOfWeekToJSONTyped,
    DefaultConfig: DefaultConfig,
    DeleteTimesheetEntryRequestSchemaDataFromJSON: DeleteTimesheetEntryRequestSchemaDataFromJSON,
    DeleteTimesheetEntryRequestSchemaDataFromJSONTyped: DeleteTimesheetEntryRequestSchemaDataFromJSONTyped,
    DeleteTimesheetEntryRequestSchemaDataToJSON: DeleteTimesheetEntryRequestSchemaDataToJSON,
    DeleteTimesheetEntryRequestSchemaDataToJSONTyped: DeleteTimesheetEntryRequestSchemaDataToJSONTyped,
    DeleteTimesheetEntryRequestSchemaFromJSON: DeleteTimesheetEntryRequestSchemaFromJSON,
    DeleteTimesheetEntryRequestSchemaFromJSONTyped: DeleteTimesheetEntryRequestSchemaFromJSONTyped,
    DeleteTimesheetEntryRequestSchemaToJSON: DeleteTimesheetEntryRequestSchemaToJSON,
    DeleteTimesheetEntryRequestSchemaToJSONTyped: DeleteTimesheetEntryRequestSchemaToJSONTyped,
    DiscriminatedFieldValueDatatypeEnum: DiscriminatedFieldValueDatatypeEnum,
    DiscriminatedFieldValueFromJSON: DiscriminatedFieldValueFromJSON,
    DiscriminatedFieldValueFromJSONTyped: DiscriminatedFieldValueFromJSONTyped,
    DiscriminatedFieldValueToJSON: DiscriminatedFieldValueToJSON,
    DiscriminatedFieldValueToJSONTyped: DiscriminatedFieldValueToJSONTyped,
    DurationDateTimeFromJSON: DurationDateTimeFromJSON,
    DurationDateTimeFromJSONTyped: DurationDateTimeFromJSONTyped,
    DurationDateTimeToJSON: DurationDateTimeToJSON,
    DurationDateTimeToJSONTyped: DurationDateTimeToJSONTyped,
    DurationFromJSON: DurationFromJSON,
    DurationFromJSONTyped: DurationFromJSONTyped,
    DurationQuantityFromJSON: DurationQuantityFromJSON,
    DurationQuantityFromJSONTyped: DurationQuantityFromJSONTyped,
    DurationQuantityToJSON: DurationQuantityToJSON,
    DurationQuantityToJSONTyped: DurationQuantityToJSONTyped,
    DurationToJSON: DurationToJSON,
    DurationToJSONTyped: DurationToJSONTyped,
    EligibleLeaveOverrideDtlFromJSON: EligibleLeaveOverrideDtlFromJSON,
    EligibleLeaveOverrideDtlFromJSONTyped: EligibleLeaveOverrideDtlFromJSONTyped,
    EligibleLeaveOverrideDtlQualificationResultEnum: EligibleLeaveOverrideDtlQualificationResultEnum,
    EligibleLeaveOverrideDtlToJSON: EligibleLeaveOverrideDtlToJSON,
    EligibleLeaveOverrideDtlToJSONTyped: EligibleLeaveOverrideDtlToJSONTyped,
    EmployeeAttributesFromJSON: EmployeeAttributesFromJSON,
    EmployeeAttributesFromJSONTyped: EmployeeAttributesFromJSONTyped,
    EmployeeAttributesToJSON: EmployeeAttributesToJSON,
    EmployeeAttributesToJSONTyped: EmployeeAttributesToJSONTyped,
    EmployeeBankAttributesFromJSON: EmployeeBankAttributesFromJSON,
    EmployeeBankAttributesFromJSONTyped: EmployeeBankAttributesFromJSONTyped,
    EmployeeBankAttributesTimeUnitFromJSON: EmployeeBankAttributesTimeUnitFromJSON,
    EmployeeBankAttributesTimeUnitFromJSONTyped: EmployeeBankAttributesTimeUnitFromJSONTyped,
    EmployeeBankAttributesTimeUnitToJSON: EmployeeBankAttributesTimeUnitToJSON,
    EmployeeBankAttributesTimeUnitToJSONTyped: EmployeeBankAttributesTimeUnitToJSONTyped,
    EmployeeBankAttributesToJSON: EmployeeBankAttributesToJSON,
    EmployeeBankAttributesToJSONTyped: EmployeeBankAttributesToJSONTyped,
    EmployeeBankFromJSON: EmployeeBankFromJSON,
    EmployeeBankFromJSONTyped: EmployeeBankFromJSONTyped,
    EmployeeBankMetaFromJSON: EmployeeBankMetaFromJSON,
    EmployeeBankMetaFromJSONTyped: EmployeeBankMetaFromJSONTyped,
    EmployeeBankMetaToJSON: EmployeeBankMetaToJSON,
    EmployeeBankMetaToJSONTyped: EmployeeBankMetaToJSONTyped,
    EmployeeBankRelationshipsFromJSON: EmployeeBankRelationshipsFromJSON,
    EmployeeBankRelationshipsFromJSONTyped: EmployeeBankRelationshipsFromJSONTyped,
    EmployeeBankRelationshipsToJSON: EmployeeBankRelationshipsToJSON,
    EmployeeBankRelationshipsToJSONTyped: EmployeeBankRelationshipsToJSONTyped,
    EmployeeBankToJSON: EmployeeBankToJSON,
    EmployeeBankToJSONTyped: EmployeeBankToJSONTyped,
    EmployeeCardAttributesFromJSON: EmployeeCardAttributesFromJSON,
    EmployeeCardAttributesFromJSONTyped: EmployeeCardAttributesFromJSONTyped,
    EmployeeCardAttributesToJSON: EmployeeCardAttributesToJSON,
    EmployeeCardAttributesToJSONTyped: EmployeeCardAttributesToJSONTyped,
    EmployeeCardFromJSON: EmployeeCardFromJSON,
    EmployeeCardFromJSONTyped: EmployeeCardFromJSONTyped,
    EmployeeCardToJSON: EmployeeCardToJSON,
    EmployeeCardToJSONTyped: EmployeeCardToJSONTyped,
    EmployeeFromJSON: EmployeeFromJSON,
    EmployeeFromJSONTyped: EmployeeFromJSONTyped,
    EmployeeRelationshipDataFromJSON: EmployeeRelationshipDataFromJSON,
    EmployeeRelationshipDataFromJSONTyped: EmployeeRelationshipDataFromJSONTyped,
    EmployeeRelationshipDataToJSON: EmployeeRelationshipDataToJSON,
    EmployeeRelationshipDataToJSONTyped: EmployeeRelationshipDataToJSONTyped,
    EmployeeRelationshipFromJSON: EmployeeRelationshipFromJSON,
    EmployeeRelationshipFromJSONTyped: EmployeeRelationshipFromJSONTyped,
    EmployeeRelationshipToJSON: EmployeeRelationshipToJSON,
    EmployeeRelationshipToJSONTyped: EmployeeRelationshipToJSONTyped,
    EmployeeRelationshipsFromJSON: EmployeeRelationshipsFromJSON,
    EmployeeRelationshipsFromJSONTyped: EmployeeRelationshipsFromJSONTyped,
    EmployeeRelationshipsToJSON: EmployeeRelationshipsToJSON,
    EmployeeRelationshipsToJSONTyped: EmployeeRelationshipsToJSONTyped,
    EmployeeRelationshipsWithLookupDataInnerFromJSON: EmployeeRelationshipsWithLookupDataInnerFromJSON,
    EmployeeRelationshipsWithLookupDataInnerFromJSONTyped: EmployeeRelationshipsWithLookupDataInnerFromJSONTyped,
    EmployeeRelationshipsWithLookupDataInnerMetaFromJSON: EmployeeRelationshipsWithLookupDataInnerMetaFromJSON,
    EmployeeRelationshipsWithLookupDataInnerMetaFromJSONTyped: EmployeeRelationshipsWithLookupDataInnerMetaFromJSONTyped,
    EmployeeRelationshipsWithLookupDataInnerMetaLookupFromJSON: EmployeeRelationshipsWithLookupDataInnerMetaLookupFromJSON,
    EmployeeRelationshipsWithLookupDataInnerMetaLookupFromJSONTyped: EmployeeRelationshipsWithLookupDataInnerMetaLookupFromJSONTyped,
    EmployeeRelationshipsWithLookupDataInnerMetaLookupToJSON: EmployeeRelationshipsWithLookupDataInnerMetaLookupToJSON,
    EmployeeRelationshipsWithLookupDataInnerMetaLookupToJSONTyped: EmployeeRelationshipsWithLookupDataInnerMetaLookupToJSONTyped,
    EmployeeRelationshipsWithLookupDataInnerMetaToJSON: EmployeeRelationshipsWithLookupDataInnerMetaToJSON,
    EmployeeRelationshipsWithLookupDataInnerMetaToJSONTyped: EmployeeRelationshipsWithLookupDataInnerMetaToJSONTyped,
    EmployeeRelationshipsWithLookupDataInnerToJSON: EmployeeRelationshipsWithLookupDataInnerToJSON,
    EmployeeRelationshipsWithLookupDataInnerToJSONTyped: EmployeeRelationshipsWithLookupDataInnerToJSONTyped,
    EmployeeRelationshipsWithLookupFromJSON: EmployeeRelationshipsWithLookupFromJSON,
    EmployeeRelationshipsWithLookupFromJSONTyped: EmployeeRelationshipsWithLookupFromJSONTyped,
    EmployeeRelationshipsWithLookupToJSON: EmployeeRelationshipsWithLookupToJSON,
    EmployeeRelationshipsWithLookupToJSONTyped: EmployeeRelationshipsWithLookupToJSONTyped,
    EmployeeToJSON: EmployeeToJSON,
    EmployeeToJSONTyped: EmployeeToJSONTyped,
    EmployeesJobResponseFromJSON: EmployeesJobResponseFromJSON,
    EmployeesJobResponseFromJSONTyped: EmployeesJobResponseFromJSONTyped,
    EmployeesJobResponseToJSON: EmployeesJobResponseToJSON,
    EmployeesJobResponseToJSONTyped: EmployeesJobResponseToJSONTyped,
    EmployeesJobsResponseFromJSON: EmployeesJobsResponseFromJSON,
    EmployeesJobsResponseFromJSONTyped: EmployeesJobsResponseFromJSONTyped,
    EmployeesJobsResponseToJSON: EmployeesJobsResponseToJSON,
    EmployeesJobsResponseToJSONTyped: EmployeesJobsResponseToJSONTyped,
    EntryFieldFromJSON: EntryFieldFromJSON,
    EntryFieldFromJSONTyped: EntryFieldFromJSONTyped,
    EntryFieldToJSON: EntryFieldToJSON,
    EntryFieldToJSONTyped: EntryFieldToJSONTyped,
    EntryType: EntryType,
    EntryTypeFromJSON: EntryTypeFromJSON,
    EntryTypeFromJSONTyped: EntryTypeFromJSONTyped,
    EntryTypeToJSON: EntryTypeToJSON,
    EntryTypeToJSONTyped: EntryTypeToJSONTyped,
    ErrorResponseFromJSON: ErrorResponseFromJSON,
    ErrorResponseFromJSONTyped: ErrorResponseFromJSONTyped,
    ErrorResponseToJSON: ErrorResponseToJSON,
    ErrorResponseToJSONTyped: ErrorResponseToJSONTyped,
    ErrorSourceFromJSON: ErrorSourceFromJSON,
    ErrorSourceFromJSONTyped: ErrorSourceFromJSONTyped,
    ErrorSourceToJSON: ErrorSourceToJSON,
    ErrorSourceToJSONTyped: ErrorSourceToJSONTyped,
    ExceptionsRelationshipDataInnerFromJSON: ExceptionsRelationshipDataInnerFromJSON,
    ExceptionsRelationshipDataInnerFromJSONTyped: ExceptionsRelationshipDataInnerFromJSONTyped,
    ExceptionsRelationshipDataInnerToJSON: ExceptionsRelationshipDataInnerToJSON,
    ExceptionsRelationshipDataInnerToJSONTyped: ExceptionsRelationshipDataInnerToJSONTyped,
    ExceptionsRelationshipFromJSON: ExceptionsRelationshipFromJSON,
    ExceptionsRelationshipFromJSONTyped: ExceptionsRelationshipFromJSONTyped,
    ExceptionsRelationshipToJSON: ExceptionsRelationshipToJSON,
    ExceptionsRelationshipToJSONTyped: ExceptionsRelationshipToJSONTyped,
    FetchError: FetchError,
    FieldValueDatatypeEnum: FieldValueDatatypeEnum,
    FieldValueFromJSON: FieldValueFromJSON,
    FieldValueFromJSONTyped: FieldValueFromJSONTyped,
    FieldValueToJSON: FieldValueToJSON,
    FieldValueToJSONTyped: FieldValueToJSONTyped,
    FieldValueValueFromJSON: FieldValueValueFromJSON,
    FieldValueValueFromJSONTyped: FieldValueValueFromJSONTyped,
    FieldValueValueToJSON: FieldValueValueToJSON,
    FieldValueValueToJSONTyped: FieldValueValueToJSONTyped,
    FormFieldRelationshipDataFromJSON: FormFieldRelationshipDataFromJSON,
    FormFieldRelationshipDataFromJSONTyped: FormFieldRelationshipDataFromJSONTyped,
    FormFieldRelationshipDataToJSON: FormFieldRelationshipDataToJSON,
    FormFieldRelationshipDataToJSONTyped: FormFieldRelationshipDataToJSONTyped,
    FormFieldRelationshipFromJSON: FormFieldRelationshipFromJSON,
    FormFieldRelationshipFromJSONTyped: FormFieldRelationshipFromJSONTyped,
    FormFieldRelationshipToJSON: FormFieldRelationshipToJSON,
    FormFieldRelationshipToJSONTyped: FormFieldRelationshipToJSONTyped,
    FormFieldsReducedAttributesFormFieldTypeEnum: FormFieldsReducedAttributesFormFieldTypeEnum,
    FormFieldsReducedAttributesFromJSON: FormFieldsReducedAttributesFromJSON,
    FormFieldsReducedAttributesFromJSONTyped: FormFieldsReducedAttributesFromJSONTyped,
    FormFieldsReducedAttributesOptionsInnerFromJSON: FormFieldsReducedAttributesOptionsInnerFromJSON,
    FormFieldsReducedAttributesOptionsInnerFromJSONTyped: FormFieldsReducedAttributesOptionsInnerFromJSONTyped,
    FormFieldsReducedAttributesOptionsInnerToJSON: FormFieldsReducedAttributesOptionsInnerToJSON,
    FormFieldsReducedAttributesOptionsInnerToJSONTyped: FormFieldsReducedAttributesOptionsInnerToJSONTyped,
    FormFieldsReducedAttributesToJSON: FormFieldsReducedAttributesToJSON,
    FormFieldsReducedAttributesToJSONTyped: FormFieldsReducedAttributesToJSONTyped,
    FormFieldsReducedFromJSON: FormFieldsReducedFromJSON,
    FormFieldsReducedFromJSONTyped: FormFieldsReducedFromJSONTyped,
    FormFieldsReducedToJSON: FormFieldsReducedToJSON,
    FormFieldsReducedToJSONTyped: FormFieldsReducedToJSONTyped,
    GeolocationFromJSON: GeolocationFromJSON,
    GeolocationFromJSONTyped: GeolocationFromJSONTyped,
    GeolocationToJSON: GeolocationToJSON,
    GeolocationToJSONTyped: GeolocationToJSONTyped,
    GetAbsenceCaseQuestionsFilterParameterFromJSON: GetAbsenceCaseQuestionsFilterParameterFromJSON,
    GetAbsenceCaseQuestionsFilterParameterFromJSONTyped: GetAbsenceCaseQuestionsFilterParameterFromJSONTyped,
    GetAbsenceCaseQuestionsFilterParameterToJSON: GetAbsenceCaseQuestionsFilterParameterToJSON,
    GetAbsenceCaseQuestionsFilterParameterToJSONTyped: GetAbsenceCaseQuestionsFilterParameterToJSONTyped,
    GetAbsenceCaseWorkflowEventsFilterParameterFromJSON: GetAbsenceCaseWorkflowEventsFilterParameterFromJSON,
    GetAbsenceCaseWorkflowEventsFilterParameterFromJSONTyped: GetAbsenceCaseWorkflowEventsFilterParameterFromJSONTyped,
    GetAbsenceCaseWorkflowEventsFilterParameterToJSON: GetAbsenceCaseWorkflowEventsFilterParameterToJSON,
    GetAbsenceCaseWorkflowEventsFilterParameterToJSONTyped: GetAbsenceCaseWorkflowEventsFilterParameterToJSONTyped,
    GetAbsenceCasesFilterParameterCaseTypesEnum: GetAbsenceCasesFilterParameterCaseTypesEnum,
    GetAbsenceCasesFilterParameterFromJSON: GetAbsenceCasesFilterParameterFromJSON,
    GetAbsenceCasesFilterParameterFromJSONTyped: GetAbsenceCasesFilterParameterFromJSONTyped,
    GetAbsenceCasesFilterParameterToJSON: GetAbsenceCasesFilterParameterToJSON,
    GetAbsenceCasesFilterParameterToJSONTyped: GetAbsenceCasesFilterParameterToJSONTyped,
    GetAbsenceCasesPageParameterFromJSON: GetAbsenceCasesPageParameterFromJSON,
    GetAbsenceCasesPageParameterFromJSONTyped: GetAbsenceCasesPageParameterFromJSONTyped,
    GetAbsenceCasesPageParameterToJSON: GetAbsenceCasesPageParameterToJSON,
    GetAbsenceCasesPageParameterToJSONTyped: GetAbsenceCasesPageParameterToJSONTyped,
    GetAbsenceTypesFilterParameterFromJSON: GetAbsenceTypesFilterParameterFromJSON,
    GetAbsenceTypesFilterParameterFromJSONTyped: GetAbsenceTypesFilterParameterFromJSONTyped,
    GetAbsenceTypesFilterParameterToJSON: GetAbsenceTypesFilterParameterToJSON,
    GetAbsenceTypesFilterParameterToJSONTyped: GetAbsenceTypesFilterParameterToJSONTyped,
    GetBankMetadataFilterParameterFromJSON: GetBankMetadataFilterParameterFromJSON,
    GetBankMetadataFilterParameterFromJSONTyped: GetBankMetadataFilterParameterFromJSONTyped,
    GetBankMetadataFilterParameterToJSON: GetBankMetadataFilterParameterToJSON,
    GetBankMetadataFilterParameterToJSONTyped: GetBankMetadataFilterParameterToJSONTyped,
    GetBanksFilterParameterFromJSON: GetBanksFilterParameterFromJSON,
    GetBanksFilterParameterFromJSONTyped: GetBanksFilterParameterFromJSONTyped,
    GetBanksFilterParameterToJSON: GetBanksFilterParameterToJSON,
    GetBanksFilterParameterToJSONTyped: GetBanksFilterParameterToJSONTyped,
    GetJobFilterParameterFromJSON: GetJobFilterParameterFromJSON,
    GetJobFilterParameterFromJSONTyped: GetJobFilterParameterFromJSONTyped,
    GetJobFilterParameterToJSON: GetJobFilterParameterToJSON,
    GetJobFilterParameterToJSONTyped: GetJobFilterParameterToJSONTyped,
    GetJobsFilterParameterFromJSON: GetJobsFilterParameterFromJSON,
    GetJobsFilterParameterFromJSONTyped: GetJobsFilterParameterFromJSONTyped,
    GetJobsFilterParameterToJSON: GetJobsFilterParameterToJSON,
    GetJobsFilterParameterToJSONTyped: GetJobsFilterParameterToJSONTyped,
    GetPoliciesFilterParameterFromJSON: GetPoliciesFilterParameterFromJSON,
    GetPoliciesFilterParameterFromJSONTyped: GetPoliciesFilterParameterFromJSONTyped,
    GetPoliciesFilterParameterToJSON: GetPoliciesFilterParameterToJSON,
    GetPoliciesFilterParameterToJSONTyped: GetPoliciesFilterParameterToJSONTyped,
    GetPolicySetDetailsFilterParameterFromJSON: GetPolicySetDetailsFilterParameterFromJSON,
    GetPolicySetDetailsFilterParameterFromJSONTyped: GetPolicySetDetailsFilterParameterFromJSONTyped,
    GetPolicySetDetailsFilterParameterToJSON: GetPolicySetDetailsFilterParameterToJSON,
    GetPolicySetDetailsFilterParameterToJSONTyped: GetPolicySetDetailsFilterParameterToJSONTyped,
    GetPolicyTypesFilterParameterFromJSON: GetPolicyTypesFilterParameterFromJSON,
    GetPolicyTypesFilterParameterFromJSONTyped: GetPolicyTypesFilterParameterFromJSONTyped,
    GetPolicyTypesFilterParameterTableTypeEnum: GetPolicyTypesFilterParameterTableTypeEnum,
    GetPolicyTypesFilterParameterToJSON: GetPolicyTypesFilterParameterToJSON,
    GetPolicyTypesFilterParameterToJSONTyped: GetPolicyTypesFilterParameterToJSONTyped,
    GetShiftsFilterParameterFromJSON: GetShiftsFilterParameterFromJSON,
    GetShiftsFilterParameterFromJSONTyped: GetShiftsFilterParameterFromJSONTyped,
    GetShiftsFilterParameterToJSON: GetShiftsFilterParameterToJSON,
    GetShiftsFilterParameterToJSONTyped: GetShiftsFilterParameterToJSONTyped,
    GetTimeEntriesByIdFilterParameterFromJSON: GetTimeEntriesByIdFilterParameterFromJSON,
    GetTimeEntriesByIdFilterParameterFromJSONTyped: GetTimeEntriesByIdFilterParameterFromJSONTyped,
    GetTimeEntriesByIdFilterParameterToJSON: GetTimeEntriesByIdFilterParameterToJSON,
    GetTimeEntriesByIdFilterParameterToJSONTyped: GetTimeEntriesByIdFilterParameterToJSONTyped,
    GetTimeOffRequestsFilterParameterFromJSON: GetTimeOffRequestsFilterParameterFromJSON,
    GetTimeOffRequestsFilterParameterFromJSONTyped: GetTimeOffRequestsFilterParameterFromJSONTyped,
    GetTimeOffRequestsFilterParameterToJSON: GetTimeOffRequestsFilterParameterToJSON,
    GetTimeOffRequestsFilterParameterToJSONTyped: GetTimeOffRequestsFilterParameterToJSONTyped,
    GetTimeOffRequestsPageParameterFromJSON: GetTimeOffRequestsPageParameterFromJSON,
    GetTimeOffRequestsPageParameterFromJSONTyped: GetTimeOffRequestsPageParameterFromJSONTyped,
    GetTimeOffRequestsPageParameterToJSON: GetTimeOffRequestsPageParameterToJSON,
    GetTimeOffRequestsPageParameterToJSONTyped: GetTimeOffRequestsPageParameterToJSONTyped,
    GetTimesheetApprovalLayoutFilterParameterFromJSON: GetTimesheetApprovalLayoutFilterParameterFromJSON,
    GetTimesheetApprovalLayoutFilterParameterFromJSONTyped: GetTimesheetApprovalLayoutFilterParameterFromJSONTyped,
    GetTimesheetApprovalLayoutFilterParameterToJSON: GetTimesheetApprovalLayoutFilterParameterToJSON,
    GetTimesheetApprovalLayoutFilterParameterToJSONTyped: GetTimesheetApprovalLayoutFilterParameterToJSONTyped,
    GetTimesheetEntriesFilterParameterFromJSON: GetTimesheetEntriesFilterParameterFromJSON,
    GetTimesheetEntriesFilterParameterFromJSONTyped: GetTimesheetEntriesFilterParameterFromJSONTyped,
    GetTimesheetEntriesFilterParameterToJSON: GetTimesheetEntriesFilterParameterToJSON,
    GetTimesheetEntriesFilterParameterToJSONTyped: GetTimesheetEntriesFilterParameterToJSONTyped,
    GetTimesheetExceptionsFilterParameterFromJSON: GetTimesheetExceptionsFilterParameterFromJSON,
    GetTimesheetExceptionsFilterParameterFromJSONTyped: GetTimesheetExceptionsFilterParameterFromJSONTyped,
    GetTimesheetExceptionsFilterParameterToJSON: GetTimesheetExceptionsFilterParameterToJSON,
    GetTimesheetExceptionsFilterParameterToJSONTyped: GetTimesheetExceptionsFilterParameterToJSONTyped,
    GetTimesheetsFilterParameterFromJSON: GetTimesheetsFilterParameterFromJSON,
    GetTimesheetsFilterParameterFromJSONTyped: GetTimesheetsFilterParameterFromJSONTyped,
    GetTimesheetsFilterParameterToJSON: GetTimesheetsFilterParameterToJSON,
    GetTimesheetsFilterParameterToJSONTyped: GetTimesheetsFilterParameterToJSONTyped,
    GroupRelationshipDataFromJSON: GroupRelationshipDataFromJSON,
    GroupRelationshipDataFromJSONTyped: GroupRelationshipDataFromJSONTyped,
    GroupRelationshipDataToJSON: GroupRelationshipDataToJSON,
    GroupRelationshipDataToJSONTyped: GroupRelationshipDataToJSONTyped,
    GroupRelationshipFromJSON: GroupRelationshipFromJSON,
    GroupRelationshipFromJSONTyped: GroupRelationshipFromJSONTyped,
    GroupRelationshipToJSON: GroupRelationshipToJSON,
    GroupRelationshipToJSONTyped: GroupRelationshipToJSONTyped,
    HelloResponseAttributesFromJSON: HelloResponseAttributesFromJSON,
    HelloResponseAttributesFromJSONTyped: HelloResponseAttributesFromJSONTyped,
    HelloResponseAttributesToJSON: HelloResponseAttributesToJSON,
    HelloResponseAttributesToJSONTyped: HelloResponseAttributesToJSONTyped,
    HelloResponseSchemaDataFromJSON: HelloResponseSchemaDataFromJSON,
    HelloResponseSchemaDataFromJSONTyped: HelloResponseSchemaDataFromJSONTyped,
    HelloResponseSchemaDataToJSON: HelloResponseSchemaDataToJSON,
    HelloResponseSchemaDataToJSONTyped: HelloResponseSchemaDataToJSONTyped,
    HelloResponseSchemaFromJSON: HelloResponseSchemaFromJSON,
    HelloResponseSchemaFromJSONTyped: HelloResponseSchemaFromJSONTyped,
    HelloResponseSchemaToJSON: HelloResponseSchemaToJSON,
    HelloResponseSchemaToJSONTyped: HelloResponseSchemaToJSONTyped,
    IncludeParamsForJobsItem: IncludeParamsForJobsItem,
    IncludeParamsForJobsItemFromJSON: IncludeParamsForJobsItemFromJSON,
    IncludeParamsForJobsItemFromJSONTyped: IncludeParamsForJobsItemFromJSONTyped,
    IncludeParamsForJobsItemToJSON: IncludeParamsForJobsItemToJSON,
    IncludeParamsForJobsItemToJSONTyped: IncludeParamsForJobsItemToJSONTyped,
    IncludedAbsenceTypeInformationAttributesFromJSON: IncludedAbsenceTypeInformationAttributesFromJSON,
    IncludedAbsenceTypeInformationAttributesFromJSONTyped: IncludedAbsenceTypeInformationAttributesFromJSONTyped,
    IncludedAbsenceTypeInformationAttributesToJSON: IncludedAbsenceTypeInformationAttributesToJSON,
    IncludedAbsenceTypeInformationAttributesToJSONTyped: IncludedAbsenceTypeInformationAttributesToJSONTyped,
    IncludedAbsenceTypeInformationFromJSON: IncludedAbsenceTypeInformationFromJSON,
    IncludedAbsenceTypeInformationFromJSONTyped: IncludedAbsenceTypeInformationFromJSONTyped,
    IncludedAbsenceTypeInformationToJSON: IncludedAbsenceTypeInformationToJSON,
    IncludedAbsenceTypeInformationToJSONTyped: IncludedAbsenceTypeInformationToJSONTyped,
    IncludedAbsenceTypeResponseFromJSON: IncludedAbsenceTypeResponseFromJSON,
    IncludedAbsenceTypeResponseFromJSONTyped: IncludedAbsenceTypeResponseFromJSONTyped,
    IncludedAbsenceTypeResponseToJSON: IncludedAbsenceTypeResponseToJSON,
    IncludedAbsenceTypeResponseToJSONTyped: IncludedAbsenceTypeResponseToJSONTyped,
    IncludedEmployeeInformationAttributesFromJSON: IncludedEmployeeInformationAttributesFromJSON,
    IncludedEmployeeInformationAttributesFromJSONTyped: IncludedEmployeeInformationAttributesFromJSONTyped,
    IncludedEmployeeInformationAttributesToJSON: IncludedEmployeeInformationAttributesToJSON,
    IncludedEmployeeInformationAttributesToJSONTyped: IncludedEmployeeInformationAttributesToJSONTyped,
    IncludedEmployeeInformationFromJSON: IncludedEmployeeInformationFromJSON,
    IncludedEmployeeInformationFromJSONTyped: IncludedEmployeeInformationFromJSONTyped,
    IncludedEmployeeInformationToJSON: IncludedEmployeeInformationToJSON,
    IncludedEmployeeInformationToJSONTyped: IncludedEmployeeInformationToJSONTyped,
    IncludedJobInformationAttributesFromJSON: IncludedJobInformationAttributesFromJSON,
    IncludedJobInformationAttributesFromJSONTyped: IncludedJobInformationAttributesFromJSONTyped,
    IncludedJobInformationAttributesToJSON: IncludedJobInformationAttributesToJSON,
    IncludedJobInformationAttributesToJSONTyped: IncludedJobInformationAttributesToJSONTyped,
    IncludedJobInformationFromJSON: IncludedJobInformationFromJSON,
    IncludedJobInformationFromJSONTyped: IncludedJobInformationFromJSONTyped,
    IncludedJobInformationToJSON: IncludedJobInformationToJSON,
    IncludedJobInformationToJSONTyped: IncludedJobInformationToJSONTyped,
    IncludedPayCodeWithEntryFieldAttributesFromJSON: IncludedPayCodeWithEntryFieldAttributesFromJSON,
    IncludedPayCodeWithEntryFieldAttributesFromJSONTyped: IncludedPayCodeWithEntryFieldAttributesFromJSONTyped,
    IncludedPayCodeWithEntryFieldAttributesToJSON: IncludedPayCodeWithEntryFieldAttributesToJSON,
    IncludedPayCodeWithEntryFieldAttributesToJSONTyped: IncludedPayCodeWithEntryFieldAttributesToJSONTyped,
    IncludedPayCodeWithEntryFieldFromJSON: IncludedPayCodeWithEntryFieldFromJSON,
    IncludedPayCodeWithEntryFieldFromJSONTyped: IncludedPayCodeWithEntryFieldFromJSONTyped,
    IncludedPayCodeWithEntryFieldToJSON: IncludedPayCodeWithEntryFieldToJSON,
    IncludedPayCodeWithEntryFieldToJSONTyped: IncludedPayCodeWithEntryFieldToJSONTyped,
    InlineObject10FromJSON: InlineObject10FromJSON,
    InlineObject10FromJSONTyped: InlineObject10FromJSONTyped,
    InlineObject10ToJSON: InlineObject10ToJSON,
    InlineObject10ToJSONTyped: InlineObject10ToJSONTyped,
    InlineObject11FromJSON: InlineObject11FromJSON,
    InlineObject11FromJSONTyped: InlineObject11FromJSONTyped,
    InlineObject11ToJSON: InlineObject11ToJSON,
    InlineObject11ToJSONTyped: InlineObject11ToJSONTyped,
    InlineObject1FromJSON: InlineObject1FromJSON,
    InlineObject1FromJSONTyped: InlineObject1FromJSONTyped,
    InlineObject1LinksFromJSON: InlineObject1LinksFromJSON,
    InlineObject1LinksFromJSONTyped: InlineObject1LinksFromJSONTyped,
    InlineObject1LinksToJSON: InlineObject1LinksToJSON,
    InlineObject1LinksToJSONTyped: InlineObject1LinksToJSONTyped,
    InlineObject1MetaFromJSON: InlineObject1MetaFromJSON,
    InlineObject1MetaFromJSONTyped: InlineObject1MetaFromJSONTyped,
    InlineObject1MetaPageFromJSON: InlineObject1MetaPageFromJSON,
    InlineObject1MetaPageFromJSONTyped: InlineObject1MetaPageFromJSONTyped,
    InlineObject1MetaPageToJSON: InlineObject1MetaPageToJSON,
    InlineObject1MetaPageToJSONTyped: InlineObject1MetaPageToJSONTyped,
    InlineObject1MetaToJSON: InlineObject1MetaToJSON,
    InlineObject1MetaToJSONTyped: InlineObject1MetaToJSONTyped,
    InlineObject1ToJSON: InlineObject1ToJSON,
    InlineObject1ToJSONTyped: InlineObject1ToJSONTyped,
    InlineObject2FromJSON: InlineObject2FromJSON,
    InlineObject2FromJSONTyped: InlineObject2FromJSONTyped,
    InlineObject2IncludedInnerFromJSON: InlineObject2IncludedInnerFromJSON,
    InlineObject2IncludedInnerFromJSONTyped: InlineObject2IncludedInnerFromJSONTyped,
    InlineObject2IncludedInnerToJSON: InlineObject2IncludedInnerToJSON,
    InlineObject2IncludedInnerToJSONTyped: InlineObject2IncludedInnerToJSONTyped,
    InlineObject2ToJSON: InlineObject2ToJSON,
    InlineObject2ToJSONTyped: InlineObject2ToJSONTyped,
    InlineObject3FromJSON: InlineObject3FromJSON,
    InlineObject3FromJSONTyped: InlineObject3FromJSONTyped,
    InlineObject3IncludedInnerFromJSON: InlineObject3IncludedInnerFromJSON,
    InlineObject3IncludedInnerFromJSONTyped: InlineObject3IncludedInnerFromJSONTyped,
    InlineObject3IncludedInnerToJSON: InlineObject3IncludedInnerToJSON,
    InlineObject3IncludedInnerToJSONTyped: InlineObject3IncludedInnerToJSONTyped,
    InlineObject3ToJSON: InlineObject3ToJSON,
    InlineObject3ToJSONTyped: InlineObject3ToJSONTyped,
    InlineObject4FromJSON: InlineObject4FromJSON,
    InlineObject4FromJSONTyped: InlineObject4FromJSONTyped,
    InlineObject4IncludedInnerFromJSON: InlineObject4IncludedInnerFromJSON,
    InlineObject4IncludedInnerFromJSONTyped: InlineObject4IncludedInnerFromJSONTyped,
    InlineObject4IncludedInnerToJSON: InlineObject4IncludedInnerToJSON,
    InlineObject4IncludedInnerToJSONTyped: InlineObject4IncludedInnerToJSONTyped,
    InlineObject4ToJSON: InlineObject4ToJSON,
    InlineObject4ToJSONTyped: InlineObject4ToJSONTyped,
    InlineObject5FromJSON: InlineObject5FromJSON,
    InlineObject5FromJSONTyped: InlineObject5FromJSONTyped,
    InlineObject5IncludedInnerFromJSON: InlineObject5IncludedInnerFromJSON,
    InlineObject5IncludedInnerFromJSONTyped: InlineObject5IncludedInnerFromJSONTyped,
    InlineObject5IncludedInnerToJSON: InlineObject5IncludedInnerToJSON,
    InlineObject5IncludedInnerToJSONTyped: InlineObject5IncludedInnerToJSONTyped,
    InlineObject5ToJSON: InlineObject5ToJSON,
    InlineObject5ToJSONTyped: InlineObject5ToJSONTyped,
    InlineObject6FromJSON: InlineObject6FromJSON,
    InlineObject6FromJSONTyped: InlineObject6FromJSONTyped,
    InlineObject6ToJSON: InlineObject6ToJSON,
    InlineObject6ToJSONTyped: InlineObject6ToJSONTyped,
    InlineObject7FromJSON: InlineObject7FromJSON,
    InlineObject7FromJSONTyped: InlineObject7FromJSONTyped,
    InlineObject7ToJSON: InlineObject7ToJSON,
    InlineObject7ToJSONTyped: InlineObject7ToJSONTyped,
    InlineObject8FromJSON: InlineObject8FromJSON,
    InlineObject8FromJSONTyped: InlineObject8FromJSONTyped,
    InlineObject8IncludedFromJSON: InlineObject8IncludedFromJSON,
    InlineObject8IncludedFromJSONTyped: InlineObject8IncludedFromJSONTyped,
    InlineObject8IncludedToJSON: InlineObject8IncludedToJSON,
    InlineObject8IncludedToJSONTyped: InlineObject8IncludedToJSONTyped,
    InlineObject8ToJSON: InlineObject8ToJSON,
    InlineObject8ToJSONTyped: InlineObject8ToJSONTyped,
    InlineObject9FromJSON: InlineObject9FromJSON,
    InlineObject9FromJSONTyped: InlineObject9FromJSONTyped,
    InlineObject9IncludedInnerFromJSON: InlineObject9IncludedInnerFromJSON,
    InlineObject9IncludedInnerFromJSONTyped: InlineObject9IncludedInnerFromJSONTyped,
    InlineObject9IncludedInnerOneOf1FromJSON: InlineObject9IncludedInnerOneOf1FromJSON,
    InlineObject9IncludedInnerOneOf1FromJSONTyped: InlineObject9IncludedInnerOneOf1FromJSONTyped,
    InlineObject9IncludedInnerOneOf1ToJSON: InlineObject9IncludedInnerOneOf1ToJSON,
    InlineObject9IncludedInnerOneOf1ToJSONTyped: InlineObject9IncludedInnerOneOf1ToJSONTyped,
    InlineObject9IncludedInnerOneOf1TypeEnum: InlineObject9IncludedInnerOneOf1TypeEnum,
    InlineObject9IncludedInnerOneOfFromJSON: InlineObject9IncludedInnerOneOfFromJSON,
    InlineObject9IncludedInnerOneOfFromJSONTyped: InlineObject9IncludedInnerOneOfFromJSONTyped,
    InlineObject9IncludedInnerOneOfToJSON: InlineObject9IncludedInnerOneOfToJSON,
    InlineObject9IncludedInnerOneOfToJSONTyped: InlineObject9IncludedInnerOneOfToJSONTyped,
    InlineObject9IncludedInnerOneOfTypeEnum: InlineObject9IncludedInnerOneOfTypeEnum,
    InlineObject9IncludedInnerToJSON: InlineObject9IncludedInnerToJSON,
    InlineObject9IncludedInnerToJSONTyped: InlineObject9IncludedInnerToJSONTyped,
    InlineObject9ToJSON: InlineObject9ToJSON,
    InlineObject9ToJSONTyped: InlineObject9ToJSONTyped,
    InlineObjectFromJSON: InlineObjectFromJSON,
    InlineObjectFromJSONTyped: InlineObjectFromJSONTyped,
    InlineObjectIncludedInnerFromJSON: InlineObjectIncludedInnerFromJSON,
    InlineObjectIncludedInnerFromJSONTyped: InlineObjectIncludedInnerFromJSONTyped,
    InlineObjectIncludedInnerToJSON: InlineObjectIncludedInnerToJSON,
    InlineObjectIncludedInnerToJSONTyped: InlineObjectIncludedInnerToJSONTyped,
    InlineObjectToJSON: InlineObjectToJSON,
    InlineObjectToJSONTyped: InlineObjectToJSONTyped,
    JSONApiResponse: JSONApiResponse,
    JobAttributesFromJSON: JobAttributesFromJSON,
    JobAttributesFromJSONTyped: JobAttributesFromJSONTyped,
    JobAttributesToJSON: JobAttributesToJSON,
    JobAttributesToJSONTyped: JobAttributesToJSONTyped,
    JobCardAttributesFromJSON: JobCardAttributesFromJSON,
    JobCardAttributesFromJSONTyped: JobCardAttributesFromJSONTyped,
    JobCardAttributesToJSON: JobCardAttributesToJSON,
    JobCardAttributesToJSONTyped: JobCardAttributesToJSONTyped,
    JobCardFromJSON: JobCardFromJSON,
    JobCardFromJSONTyped: JobCardFromJSONTyped,
    JobCardToJSON: JobCardToJSON,
    JobCardToJSONTyped: JobCardToJSONTyped,
    JobRelationshipDataFromJSON: JobRelationshipDataFromJSON,
    JobRelationshipDataFromJSONTyped: JobRelationshipDataFromJSONTyped,
    JobRelationshipDataToJSON: JobRelationshipDataToJSON,
    JobRelationshipDataToJSONTyped: JobRelationshipDataToJSONTyped,
    JobRelationshipFromJSON: JobRelationshipFromJSON,
    JobRelationshipFromJSONTyped: JobRelationshipFromJSONTyped,
    JobRelationshipToJSON: JobRelationshipToJSON,
    JobRelationshipToJSONTyped: JobRelationshipToJSONTyped,
    JobRelationshipsDataInnerFromJSON: JobRelationshipsDataInnerFromJSON,
    JobRelationshipsDataInnerFromJSONTyped: JobRelationshipsDataInnerFromJSONTyped,
    JobRelationshipsDataInnerToJSON: JobRelationshipsDataInnerToJSON,
    JobRelationshipsDataInnerToJSONTyped: JobRelationshipsDataInnerToJSONTyped,
    JobRelationshipsFromJSON: JobRelationshipsFromJSON,
    JobRelationshipsFromJSONTyped: JobRelationshipsFromJSONTyped,
    JobRelationshipsToJSON: JobRelationshipsToJSON,
    JobRelationshipsToJSONTyped: JobRelationshipsToJSONTyped,
    JobResourceFromJSON: JobResourceFromJSON,
    JobResourceFromJSONTyped: JobResourceFromJSONTyped,
    JobResourceRelationshipsFromJSON: JobResourceRelationshipsFromJSON,
    JobResourceRelationshipsFromJSONTyped: JobResourceRelationshipsFromJSONTyped,
    JobResourceRelationshipsToJSON: JobResourceRelationshipsToJSON,
    JobResourceRelationshipsToJSONTyped: JobResourceRelationshipsToJSONTyped,
    JobResourceToJSON: JobResourceToJSON,
    JobResourceToJSONTyped: JobResourceToJSONTyped,
    JobResourceTypeEnum: JobResourceTypeEnum,
    LeaveBalanceFromJSON: LeaveBalanceFromJSON,
    LeaveBalanceFromJSONTyped: LeaveBalanceFromJSONTyped,
    LeaveBalanceToJSON: LeaveBalanceToJSON,
    LeaveBalanceToJSONTyped: LeaveBalanceToJSONTyped,
    LeaveBalanceUnitEnum: LeaveBalanceUnitEnum,
    LeaveEligibilityDetailEvaluationResultEnum: LeaveEligibilityDetailEvaluationResultEnum,
    LeaveEligibilityDetailFromJSON: LeaveEligibilityDetailFromJSON,
    LeaveEligibilityDetailFromJSONTyped: LeaveEligibilityDetailFromJSONTyped,
    LeaveEligibilityDetailToJSON: LeaveEligibilityDetailToJSON,
    LeaveEligibilityDetailToJSONTyped: LeaveEligibilityDetailToJSONTyped,
    LeaveEligibilityFromJSON: LeaveEligibilityFromJSON,
    LeaveEligibilityFromJSONTyped: LeaveEligibilityFromJSONTyped,
    LeaveEligibilityToJSON: LeaveEligibilityToJSON,
    LeaveEligibilityToJSONTyped: LeaveEligibilityToJSONTyped,
    LeaveEligibleOverrideDtlFromJSON: LeaveEligibleOverrideDtlFromJSON,
    LeaveEligibleOverrideDtlFromJSONTyped: LeaveEligibleOverrideDtlFromJSONTyped,
    LeaveEligibleOverrideDtlToJSON: LeaveEligibleOverrideDtlToJSON,
    LeaveEligibleOverrideDtlToJSONTyped: LeaveEligibleOverrideDtlToJSONTyped,
    LinksFromJSON: LinksFromJSON,
    LinksFromJSONTyped: LinksFromJSONTyped,
    LinksToJSON: LinksToJSON,
    LinksToJSONTyped: LinksToJSONTyped,
    ListBankMetadataResponseSchemaFromJSON: ListBankMetadataResponseSchemaFromJSON,
    ListBankMetadataResponseSchemaFromJSONTyped: ListBankMetadataResponseSchemaFromJSONTyped,
    ListBankMetadataResponseSchemaToJSON: ListBankMetadataResponseSchemaToJSON,
    ListBankMetadataResponseSchemaToJSONTyped: ListBankMetadataResponseSchemaToJSONTyped,
    ListBanksResponseIncludedItemFromJSON: ListBanksResponseIncludedItemFromJSON,
    ListBanksResponseIncludedItemFromJSONTyped: ListBanksResponseIncludedItemFromJSONTyped,
    ListBanksResponseIncludedItemToJSON: ListBanksResponseIncludedItemToJSON,
    ListBanksResponseIncludedItemToJSONTyped: ListBanksResponseIncludedItemToJSONTyped,
    ListBanksResponseSchemaFromJSON: ListBanksResponseSchemaFromJSON,
    ListBanksResponseSchemaFromJSONTyped: ListBanksResponseSchemaFromJSONTyped,
    ListBanksResponseSchemaToJSON: ListBanksResponseSchemaToJSON,
    ListBanksResponseSchemaToJSONTyped: ListBanksResponseSchemaToJSONTyped,
    ListBidPackagesResponseSchemaFromJSON: ListBidPackagesResponseSchemaFromJSON,
    ListBidPackagesResponseSchemaFromJSONTyped: ListBidPackagesResponseSchemaFromJSONTyped,
    ListBidPackagesResponseSchemaToJSON: ListBidPackagesResponseSchemaToJSON,
    ListBidPackagesResponseSchemaToJSONTyped: ListBidPackagesResponseSchemaToJSONTyped,
    ListDataElementsFilterParameterFromJSON: ListDataElementsFilterParameterFromJSON,
    ListDataElementsFilterParameterFromJSONTyped: ListDataElementsFilterParameterFromJSONTyped,
    ListDataElementsFilterParameterToJSON: ListDataElementsFilterParameterToJSON,
    ListDataElementsFilterParameterToJSONTyped: ListDataElementsFilterParameterToJSONTyped,
    ListDataElementsResponseSchemaFromJSON: ListDataElementsResponseSchemaFromJSON,
    ListDataElementsResponseSchemaFromJSONTyped: ListDataElementsResponseSchemaFromJSONTyped,
    ListDataElementsResponseSchemaToJSON: ListDataElementsResponseSchemaToJSON,
    ListDataElementsResponseSchemaToJSONTyped: ListDataElementsResponseSchemaToJSONTyped,
    ListShiftsResponseSchemaFromJSON: ListShiftsResponseSchemaFromJSON,
    ListShiftsResponseSchemaFromJSONTyped: ListShiftsResponseSchemaFromJSONTyped,
    ListShiftsResponseSchemaToJSON: ListShiftsResponseSchemaToJSON,
    ListShiftsResponseSchemaToJSONTyped: ListShiftsResponseSchemaToJSONTyped,
    MasterPolicyFromJSON: MasterPolicyFromJSON,
    MasterPolicyFromJSONTyped: MasterPolicyFromJSONTyped,
    MasterPolicyToJSON: MasterPolicyToJSON,
    MasterPolicyToJSONTyped: MasterPolicyToJSONTyped,
    MetaFromJSON: MetaFromJSON,
    MetaFromJSONTyped: MetaFromJSONTyped,
    MetaToJSON: MetaToJSON,
    MetaToJSONTyped: MetaToJSONTyped,
    ModelErrorFromJSON: ModelErrorFromJSON,
    ModelErrorFromJSONTyped: ModelErrorFromJSONTyped,
    ModelErrorToJSON: ModelErrorToJSON,
    ModelErrorToJSONTyped: ModelErrorToJSONTyped,
    ModuleErrorFromJSON: ModuleErrorFromJSON,
    ModuleErrorFromJSONTyped: ModuleErrorFromJSONTyped,
    ModuleErrorToJSON: ModuleErrorToJSON,
    ModuleErrorToJSONTyped: ModuleErrorToJSONTyped,
    ModuleFromJSON: ModuleFromJSON,
    ModuleFromJSONTyped: ModuleFromJSONTyped,
    ModuleToJSON: ModuleToJSON,
    ModuleToJSONTyped: ModuleToJSONTyped,
    NextQuestionOptionFromJSON: NextQuestionOptionFromJSON,
    NextQuestionOptionFromJSONTyped: NextQuestionOptionFromJSONTyped,
    NextQuestionOptionMatchingTypeEnum: NextQuestionOptionMatchingTypeEnum,
    NextQuestionOptionToJSON: NextQuestionOptionToJSON,
    NextQuestionOptionToJSONTyped: NextQuestionOptionToJSONTyped,
    NumberFormatOptionsFromJSON: NumberFormatOptionsFromJSON,
    NumberFormatOptionsFromJSONTyped: NumberFormatOptionsFromJSONTyped,
    NumberFormatOptionsStyleEnum: NumberFormatOptionsStyleEnum,
    NumberFormatOptionsToJSON: NumberFormatOptionsToJSON,
    NumberFormatOptionsToJSONTyped: NumberFormatOptionsToJSONTyped,
    OverlapRuleInfoFromJSON: OverlapRuleInfoFromJSON,
    OverlapRuleInfoFromJSONTyped: OverlapRuleInfoFromJSONTyped,
    OverlapRuleInfoToJSON: OverlapRuleInfoToJSON,
    OverlapRuleInfoToJSONTyped: OverlapRuleInfoToJSONTyped,
    OvertimeTypeRelationshipDataFromJSON: OvertimeTypeRelationshipDataFromJSON,
    OvertimeTypeRelationshipDataFromJSONTyped: OvertimeTypeRelationshipDataFromJSONTyped,
    OvertimeTypeRelationshipDataMetaFromJSON: OvertimeTypeRelationshipDataMetaFromJSON,
    OvertimeTypeRelationshipDataMetaFromJSONTyped: OvertimeTypeRelationshipDataMetaFromJSONTyped,
    OvertimeTypeRelationshipDataMetaLookupFromJSON: OvertimeTypeRelationshipDataMetaLookupFromJSON,
    OvertimeTypeRelationshipDataMetaLookupFromJSONTyped: OvertimeTypeRelationshipDataMetaLookupFromJSONTyped,
    OvertimeTypeRelationshipDataMetaLookupToJSON: OvertimeTypeRelationshipDataMetaLookupToJSON,
    OvertimeTypeRelationshipDataMetaLookupToJSONTyped: OvertimeTypeRelationshipDataMetaLookupToJSONTyped,
    OvertimeTypeRelationshipDataMetaToJSON: OvertimeTypeRelationshipDataMetaToJSON,
    OvertimeTypeRelationshipDataMetaToJSONTyped: OvertimeTypeRelationshipDataMetaToJSONTyped,
    OvertimeTypeRelationshipDataToJSON: OvertimeTypeRelationshipDataToJSON,
    OvertimeTypeRelationshipDataToJSONTyped: OvertimeTypeRelationshipDataToJSONTyped,
    OvertimeTypeRelationshipDataTypeEnum: OvertimeTypeRelationshipDataTypeEnum,
    OvertimeTypeRelationshipFromJSON: OvertimeTypeRelationshipFromJSON,
    OvertimeTypeRelationshipFromJSONTyped: OvertimeTypeRelationshipFromJSONTyped,
    OvertimeTypeRelationshipToJSON: OvertimeTypeRelationshipToJSON,
    OvertimeTypeRelationshipToJSONTyped: OvertimeTypeRelationshipToJSONTyped,
    PageDataFromJSON: PageDataFromJSON,
    PageDataFromJSONTyped: PageDataFromJSONTyped,
    PageDataToJSON: PageDataToJSON,
    PageDataToJSONTyped: PageDataToJSONTyped,
    PageMetadataFromJSON: PageMetadataFromJSON,
    PageMetadataFromJSONTyped: PageMetadataFromJSONTyped,
    PageMetadataToJSON: PageMetadataToJSON,
    PageMetadataToJSONTyped: PageMetadataToJSONTyped,
    PayCodeCardAttributesFromJSON: PayCodeCardAttributesFromJSON,
    PayCodeCardAttributesFromJSONTyped: PayCodeCardAttributesFromJSONTyped,
    PayCodeCardAttributesToJSON: PayCodeCardAttributesToJSON,
    PayCodeCardAttributesToJSONTyped: PayCodeCardAttributesToJSONTyped,
    PayCodeCardFromJSON: PayCodeCardFromJSON,
    PayCodeCardFromJSONTyped: PayCodeCardFromJSONTyped,
    PayCodeCardToJSON: PayCodeCardToJSON,
    PayCodeCardToJSONTyped: PayCodeCardToJSONTyped,
    PayCodeRelationshipDataFromJSON: PayCodeRelationshipDataFromJSON,
    PayCodeRelationshipDataFromJSONTyped: PayCodeRelationshipDataFromJSONTyped,
    PayCodeRelationshipDataToJSON: PayCodeRelationshipDataToJSON,
    PayCodeRelationshipDataToJSONTyped: PayCodeRelationshipDataToJSONTyped,
    PayCodeRelationshipFromJSON: PayCodeRelationshipFromJSON,
    PayCodeRelationshipFromJSONTyped: PayCodeRelationshipFromJSONTyped,
    PayCodeRelationshipToJSON: PayCodeRelationshipToJSON,
    PayCodeRelationshipToJSONTyped: PayCodeRelationshipToJSONTyped,
    PayCodeRelationshipsDataInnerFromJSON: PayCodeRelationshipsDataInnerFromJSON,
    PayCodeRelationshipsDataInnerFromJSONTyped: PayCodeRelationshipsDataInnerFromJSONTyped,
    PayCodeRelationshipsDataInnerToJSON: PayCodeRelationshipsDataInnerToJSON,
    PayCodeRelationshipsDataInnerToJSONTyped: PayCodeRelationshipsDataInnerToJSONTyped,
    PayCodeRelationshipsFromJSON: PayCodeRelationshipsFromJSON,
    PayCodeRelationshipsFromJSONTyped: PayCodeRelationshipsFromJSONTyped,
    PayCodeRelationshipsToJSON: PayCodeRelationshipsToJSON,
    PayCodeRelationshipsToJSONTyped: PayCodeRelationshipsToJSONTyped,
    PayRuleAttributesFromJSON: PayRuleAttributesFromJSON,
    PayRuleAttributesFromJSONTyped: PayRuleAttributesFromJSONTyped,
    PayRuleAttributesToJSON: PayRuleAttributesToJSON,
    PayRuleAttributesToJSONTyped: PayRuleAttributesToJSONTyped,
    PayRuleCollectionResponseSchemaFromJSON: PayRuleCollectionResponseSchemaFromJSON,
    PayRuleCollectionResponseSchemaFromJSONTyped: PayRuleCollectionResponseSchemaFromJSONTyped,
    PayRuleCollectionResponseSchemaToJSON: PayRuleCollectionResponseSchemaToJSON,
    PayRuleCollectionResponseSchemaToJSONTyped: PayRuleCollectionResponseSchemaToJSONTyped,
    PayRuleConstraintAttributesFromJSON: PayRuleConstraintAttributesFromJSON,
    PayRuleConstraintAttributesFromJSONTyped: PayRuleConstraintAttributesFromJSONTyped,
    PayRuleConstraintAttributesToJSON: PayRuleConstraintAttributesToJSON,
    PayRuleConstraintAttributesToJSONTyped: PayRuleConstraintAttributesToJSONTyped,
    PayRuleConstraintCollectionResponseSchemaFromJSON: PayRuleConstraintCollectionResponseSchemaFromJSON,
    PayRuleConstraintCollectionResponseSchemaFromJSONTyped: PayRuleConstraintCollectionResponseSchemaFromJSONTyped,
    PayRuleConstraintCollectionResponseSchemaToJSON: PayRuleConstraintCollectionResponseSchemaToJSON,
    PayRuleConstraintCollectionResponseSchemaToJSONTyped: PayRuleConstraintCollectionResponseSchemaToJSONTyped,
    PayRuleConstraintFromJSON: PayRuleConstraintFromJSON,
    PayRuleConstraintFromJSONTyped: PayRuleConstraintFromJSONTyped,
    PayRuleConstraintRelationshipsFromJSON: PayRuleConstraintRelationshipsFromJSON,
    PayRuleConstraintRelationshipsFromJSONTyped: PayRuleConstraintRelationshipsFromJSONTyped,
    PayRuleConstraintRelationshipsToJSON: PayRuleConstraintRelationshipsToJSON,
    PayRuleConstraintRelationshipsToJSONTyped: PayRuleConstraintRelationshipsToJSONTyped,
    PayRuleConstraintToJSON: PayRuleConstraintToJSON,
    PayRuleConstraintToJSONTyped: PayRuleConstraintToJSONTyped,
    PayRuleConstraintTypeEnum: PayRuleConstraintTypeEnum,
    PayRuleFromJSON: PayRuleFromJSON,
    PayRuleFromJSONTyped: PayRuleFromJSONTyped,
    PayRuleIncludedObjectAttributesFromJSON: PayRuleIncludedObjectAttributesFromJSON,
    PayRuleIncludedObjectAttributesFromJSONTyped: PayRuleIncludedObjectAttributesFromJSONTyped,
    PayRuleIncludedObjectAttributesToJSON: PayRuleIncludedObjectAttributesToJSON,
    PayRuleIncludedObjectAttributesToJSONTyped: PayRuleIncludedObjectAttributesToJSONTyped,
    PayRuleIncludedObjectFromJSON: PayRuleIncludedObjectFromJSON,
    PayRuleIncludedObjectFromJSONTyped: PayRuleIncludedObjectFromJSONTyped,
    PayRuleIncludedObjectToJSON: PayRuleIncludedObjectToJSON,
    PayRuleIncludedObjectToJSONTyped: PayRuleIncludedObjectToJSONTyped,
    PayRuleIncludedObjectTypeEnum: PayRuleIncludedObjectTypeEnum,
    PayRuleKeyValueRelationshipDataFromJSON: PayRuleKeyValueRelationshipDataFromJSON,
    PayRuleKeyValueRelationshipDataFromJSONTyped: PayRuleKeyValueRelationshipDataFromJSONTyped,
    PayRuleKeyValueRelationshipDataToJSON: PayRuleKeyValueRelationshipDataToJSON,
    PayRuleKeyValueRelationshipDataToJSONTyped: PayRuleKeyValueRelationshipDataToJSONTyped,
    PayRuleKeyValueRelationshipDataTypeEnum: PayRuleKeyValueRelationshipDataTypeEnum,
    PayRuleKeyValueRelationshipFromJSON: PayRuleKeyValueRelationshipFromJSON,
    PayRuleKeyValueRelationshipFromJSONTyped: PayRuleKeyValueRelationshipFromJSONTyped,
    PayRuleKeyValueRelationshipToJSON: PayRuleKeyValueRelationshipToJSON,
    PayRuleKeyValueRelationshipToJSONTyped: PayRuleKeyValueRelationshipToJSONTyped,
    PayRuleRelationshipsFromJSON: PayRuleRelationshipsFromJSON,
    PayRuleRelationshipsFromJSONTyped: PayRuleRelationshipsFromJSONTyped,
    PayRuleRelationshipsToJSON: PayRuleRelationshipsToJSON,
    PayRuleRelationshipsToJSONTyped: PayRuleRelationshipsToJSONTyped,
    PayRuleToJSON: PayRuleToJSON,
    PayRuleToJSONTyped: PayRuleToJSONTyped,
    PayRuleTypeEnum: PayRuleTypeEnum,
    PoliciesResponseSchemaFromJSON: PoliciesResponseSchemaFromJSON,
    PoliciesResponseSchemaFromJSONTyped: PoliciesResponseSchemaFromJSONTyped,
    PoliciesResponseSchemaToJSON: PoliciesResponseSchemaToJSON,
    PoliciesResponseSchemaToJSONTyped: PoliciesResponseSchemaToJSONTyped,
    PolicyAttributesFromJSON: PolicyAttributesFromJSON,
    PolicyAttributesFromJSONTyped: PolicyAttributesFromJSONTyped,
    PolicyAttributesToJSON: PolicyAttributesToJSON,
    PolicyAttributesToJSONTyped: PolicyAttributesToJSONTyped,
    PolicyFromJSON: PolicyFromJSON,
    PolicyFromJSONTyped: PolicyFromJSONTyped,
    PolicySetDetailRecordFromJSON: PolicySetDetailRecordFromJSON,
    PolicySetDetailRecordFromJSONTyped: PolicySetDetailRecordFromJSONTyped,
    PolicySetDetailRecordToJSON: PolicySetDetailRecordToJSON,
    PolicySetDetailRecordToJSONTyped: PolicySetDetailRecordToJSONTyped,
    PolicySetDetailsAttributesFromJSON: PolicySetDetailsAttributesFromJSON,
    PolicySetDetailsAttributesFromJSONTyped: PolicySetDetailsAttributesFromJSONTyped,
    PolicySetDetailsAttributesToJSON: PolicySetDetailsAttributesToJSON,
    PolicySetDetailsAttributesToJSONTyped: PolicySetDetailsAttributesToJSONTyped,
    PolicySetDetailsFromJSON: PolicySetDetailsFromJSON,
    PolicySetDetailsFromJSONTyped: PolicySetDetailsFromJSONTyped,
    PolicySetDetailsResponseSchemaFromJSON: PolicySetDetailsResponseSchemaFromJSON,
    PolicySetDetailsResponseSchemaFromJSONTyped: PolicySetDetailsResponseSchemaFromJSONTyped,
    PolicySetDetailsResponseSchemaToJSON: PolicySetDetailsResponseSchemaToJSON,
    PolicySetDetailsResponseSchemaToJSONTyped: PolicySetDetailsResponseSchemaToJSONTyped,
    PolicySetDetailsToJSON: PolicySetDetailsToJSON,
    PolicySetDetailsToJSONTyped: PolicySetDetailsToJSONTyped,
    PolicyToJSON: PolicyToJSON,
    PolicyToJSONTyped: PolicyToJSONTyped,
    PolicyTypeAttributesFromJSON: PolicyTypeAttributesFromJSON,
    PolicyTypeAttributesFromJSONTyped: PolicyTypeAttributesFromJSONTyped,
    PolicyTypeAttributesTableTypeEnum: PolicyTypeAttributesTableTypeEnum,
    PolicyTypeAttributesToJSON: PolicyTypeAttributesToJSON,
    PolicyTypeAttributesToJSONTyped: PolicyTypeAttributesToJSONTyped,
    PolicyTypeFromJSON: PolicyTypeFromJSON,
    PolicyTypeFromJSONTyped: PolicyTypeFromJSONTyped,
    PolicyTypeToJSON: PolicyTypeToJSON,
    PolicyTypeToJSONTyped: PolicyTypeToJSONTyped,
    PolicyTypesResponseSchemaFromJSON: PolicyTypesResponseSchemaFromJSON,
    PolicyTypesResponseSchemaFromJSONTyped: PolicyTypesResponseSchemaFromJSONTyped,
    PolicyTypesResponseSchemaToJSON: PolicyTypesResponseSchemaToJSON,
    PolicyTypesResponseSchemaToJSONTyped: PolicyTypesResponseSchemaToJSONTyped,
    PostBankProjectionIncludedItemFromJSON: PostBankProjectionIncludedItemFromJSON,
    PostBankProjectionIncludedItemFromJSONTyped: PostBankProjectionIncludedItemFromJSONTyped,
    PostBankProjectionIncludedItemToJSON: PostBankProjectionIncludedItemToJSON,
    PostBankProjectionIncludedItemToJSONTyped: PostBankProjectionIncludedItemToJSONTyped,
    PostBankProjectionResponseSchemaFromJSON: PostBankProjectionResponseSchemaFromJSON,
    PostBankProjectionResponseSchemaFromJSONTyped: PostBankProjectionResponseSchemaFromJSONTyped,
    PostBankProjectionResponseSchemaToJSON: PostBankProjectionResponseSchemaToJSON,
    PostBankProjectionResponseSchemaToJSONTyped: PostBankProjectionResponseSchemaToJSONTyped,
    PostTimesheetEntryIncludeItem: PostTimesheetEntryIncludeItem,
    PostTimesheetEntryIncludeItemFromJSON: PostTimesheetEntryIncludeItemFromJSON,
    PostTimesheetEntryIncludeItemFromJSONTyped: PostTimesheetEntryIncludeItemFromJSONTyped,
    PostTimesheetEntryIncludeItemToJSON: PostTimesheetEntryIncludeItemToJSON,
    PostTimesheetEntryIncludeItemToJSONTyped: PostTimesheetEntryIncludeItemToJSONTyped,
    PostTimesheetEntryResponseSchemaDataAttributesFromJSON: PostTimesheetEntryResponseSchemaDataAttributesFromJSON,
    PostTimesheetEntryResponseSchemaDataAttributesFromJSONTyped: PostTimesheetEntryResponseSchemaDataAttributesFromJSONTyped,
    PostTimesheetEntryResponseSchemaDataAttributesToJSON: PostTimesheetEntryResponseSchemaDataAttributesToJSON,
    PostTimesheetEntryResponseSchemaDataAttributesToJSONTyped: PostTimesheetEntryResponseSchemaDataAttributesToJSONTyped,
    PostTimesheetEntryResponseSchemaDataFromJSON: PostTimesheetEntryResponseSchemaDataFromJSON,
    PostTimesheetEntryResponseSchemaDataFromJSONTyped: PostTimesheetEntryResponseSchemaDataFromJSONTyped,
    PostTimesheetEntryResponseSchemaDataRelationshipsFromJSON: PostTimesheetEntryResponseSchemaDataRelationshipsFromJSON,
    PostTimesheetEntryResponseSchemaDataRelationshipsFromJSONTyped: PostTimesheetEntryResponseSchemaDataRelationshipsFromJSONTyped,
    PostTimesheetEntryResponseSchemaDataRelationshipsToJSON: PostTimesheetEntryResponseSchemaDataRelationshipsToJSON,
    PostTimesheetEntryResponseSchemaDataRelationshipsToJSONTyped: PostTimesheetEntryResponseSchemaDataRelationshipsToJSONTyped,
    PostTimesheetEntryResponseSchemaDataToJSON: PostTimesheetEntryResponseSchemaDataToJSON,
    PostTimesheetEntryResponseSchemaDataToJSONTyped: PostTimesheetEntryResponseSchemaDataToJSONTyped,
    PostTimesheetEntryResponseSchemaFromJSON: PostTimesheetEntryResponseSchemaFromJSON,
    PostTimesheetEntryResponseSchemaFromJSONTyped: PostTimesheetEntryResponseSchemaFromJSONTyped,
    PostTimesheetEntryResponseSchemaIncludedInnerFromJSON: PostTimesheetEntryResponseSchemaIncludedInnerFromJSON,
    PostTimesheetEntryResponseSchemaIncludedInnerFromJSONTyped: PostTimesheetEntryResponseSchemaIncludedInnerFromJSONTyped,
    PostTimesheetEntryResponseSchemaIncludedInnerToJSON: PostTimesheetEntryResponseSchemaIncludedInnerToJSON,
    PostTimesheetEntryResponseSchemaIncludedInnerToJSONTyped: PostTimesheetEntryResponseSchemaIncludedInnerToJSONTyped,
    PostTimesheetEntryResponseSchemaToJSON: PostTimesheetEntryResponseSchemaToJSON,
    PostTimesheetEntryResponseSchemaToJSONTyped: PostTimesheetEntryResponseSchemaToJSONTyped,
    ProjectionBalanceAttributesFromJSON: ProjectionBalanceAttributesFromJSON,
    ProjectionBalanceAttributesFromJSONTyped: ProjectionBalanceAttributesFromJSONTyped,
    ProjectionBalanceAttributesToJSON: ProjectionBalanceAttributesToJSON,
    ProjectionBalanceAttributesToJSONTyped: ProjectionBalanceAttributesToJSONTyped,
    ProjectionBalanceFromJSON: ProjectionBalanceFromJSON,
    ProjectionBalanceFromJSONTyped: ProjectionBalanceFromJSONTyped,
    ProjectionBalanceRelationshipsFromJSON: ProjectionBalanceRelationshipsFromJSON,
    ProjectionBalanceRelationshipsFromJSONTyped: ProjectionBalanceRelationshipsFromJSONTyped,
    ProjectionBalanceRelationshipsToJSON: ProjectionBalanceRelationshipsToJSON,
    ProjectionBalanceRelationshipsToJSONTyped: ProjectionBalanceRelationshipsToJSONTyped,
    ProjectionBalanceToJSON: ProjectionBalanceToJSON,
    ProjectionBalanceToJSONTyped: ProjectionBalanceToJSONTyped,
    ProjectionEntryFromJSON: ProjectionEntryFromJSON,
    ProjectionEntryFromJSONTyped: ProjectionEntryFromJSONTyped,
    ProjectionEntryRelationshipsContentFromJSON: ProjectionEntryRelationshipsContentFromJSON,
    ProjectionEntryRelationshipsContentFromJSONTyped: ProjectionEntryRelationshipsContentFromJSONTyped,
    ProjectionEntryRelationshipsContentToJSON: ProjectionEntryRelationshipsContentToJSON,
    ProjectionEntryRelationshipsContentToJSONTyped: ProjectionEntryRelationshipsContentToJSONTyped,
    ProjectionEntryRelationshipsContentTypeEnum: ProjectionEntryRelationshipsContentTypeEnum,
    ProjectionEntryRelationshipsFromJSON: ProjectionEntryRelationshipsFromJSON,
    ProjectionEntryRelationshipsFromJSONTyped: ProjectionEntryRelationshipsFromJSONTyped,
    ProjectionEntryRelationshipsToJSON: ProjectionEntryRelationshipsToJSON,
    ProjectionEntryRelationshipsToJSONTyped: ProjectionEntryRelationshipsToJSONTyped,
    ProjectionEntryToJSON: ProjectionEntryToJSON,
    ProjectionEntryToJSONTyped: ProjectionEntryToJSONTyped,
    ProjectionGapAttributesCategoryEnum: ProjectionGapAttributesCategoryEnum,
    ProjectionGapAttributesFromJSON: ProjectionGapAttributesFromJSON,
    ProjectionGapAttributesFromJSONTyped: ProjectionGapAttributesFromJSONTyped,
    ProjectionGapAttributesToJSON: ProjectionGapAttributesToJSON,
    ProjectionGapAttributesToJSONTyped: ProjectionGapAttributesToJSONTyped,
    ProjectionGapFromJSON: ProjectionGapFromJSON,
    ProjectionGapFromJSONTyped: ProjectionGapFromJSONTyped,
    ProjectionGapRelationshipsFromJSON: ProjectionGapRelationshipsFromJSON,
    ProjectionGapRelationshipsFromJSONTyped: ProjectionGapRelationshipsFromJSONTyped,
    ProjectionGapRelationshipsToJSON: ProjectionGapRelationshipsToJSON,
    ProjectionGapRelationshipsToJSONTyped: ProjectionGapRelationshipsToJSONTyped,
    ProjectionGapToJSON: ProjectionGapToJSON,
    ProjectionGapToJSONTyped: ProjectionGapToJSONTyped,
    ProjectionIncludeItem: ProjectionIncludeItem,
    ProjectionIncludeItemFromJSON: ProjectionIncludeItemFromJSON,
    ProjectionIncludeItemFromJSONTyped: ProjectionIncludeItemFromJSONTyped,
    ProjectionIncludeItemToJSON: ProjectionIncludeItemToJSON,
    ProjectionIncludeItemToJSONTyped: ProjectionIncludeItemToJSONTyped,
    ProjectionOverridesFromJSON: ProjectionOverridesFromJSON,
    ProjectionOverridesFromJSONTyped: ProjectionOverridesFromJSONTyped,
    ProjectionOverridesToJSON: ProjectionOverridesToJSON,
    ProjectionOverridesToJSONTyped: ProjectionOverridesToJSONTyped,
    ProjectionScopeFromJSON: ProjectionScopeFromJSON,
    ProjectionScopeFromJSONTyped: ProjectionScopeFromJSONTyped,
    ProjectionScopeToJSON: ProjectionScopeToJSON,
    ProjectionScopeToJSONTyped: ProjectionScopeToJSONTyped,
    QuestionTreeNodesReducedAttributesFromJSON: QuestionTreeNodesReducedAttributesFromJSON,
    QuestionTreeNodesReducedAttributesFromJSONTyped: QuestionTreeNodesReducedAttributesFromJSONTyped,
    QuestionTreeNodesReducedAttributesToJSON: QuestionTreeNodesReducedAttributesToJSON,
    QuestionTreeNodesReducedAttributesToJSONTyped: QuestionTreeNodesReducedAttributesToJSONTyped,
    QuestionTreeNodesReducedFromJSON: QuestionTreeNodesReducedFromJSON,
    QuestionTreeNodesReducedFromJSONTyped: QuestionTreeNodesReducedFromJSONTyped,
    QuestionTreeNodesReducedToJSON: QuestionTreeNodesReducedToJSON,
    QuestionTreeNodesReducedToJSONTyped: QuestionTreeNodesReducedToJSONTyped,
    QuestionTreeNodesRelationshipDataInnerFromJSON: QuestionTreeNodesRelationshipDataInnerFromJSON,
    QuestionTreeNodesRelationshipDataInnerFromJSONTyped: QuestionTreeNodesRelationshipDataInnerFromJSONTyped,
    QuestionTreeNodesRelationshipDataInnerToJSON: QuestionTreeNodesRelationshipDataInnerToJSON,
    QuestionTreeNodesRelationshipDataInnerToJSONTyped: QuestionTreeNodesRelationshipDataInnerToJSONTyped,
    QuestionTreeNodesRelationshipFromJSON: QuestionTreeNodesRelationshipFromJSON,
    QuestionTreeNodesRelationshipFromJSONTyped: QuestionTreeNodesRelationshipFromJSONTyped,
    QuestionTreeNodesRelationshipToJSON: QuestionTreeNodesRelationshipToJSON,
    QuestionTreeNodesRelationshipToJSONTyped: QuestionTreeNodesRelationshipToJSONTyped,
    RankingMethodsFromJSON: RankingMethodsFromJSON,
    RankingMethodsFromJSONTyped: RankingMethodsFromJSONTyped,
    RankingMethodsToJSON: RankingMethodsToJSON,
    RankingMethodsToJSONTyped: RankingMethodsToJSONTyped,
    ReasonCodeRelationshipDataFromJSON: ReasonCodeRelationshipDataFromJSON,
    ReasonCodeRelationshipDataFromJSONTyped: ReasonCodeRelationshipDataFromJSONTyped,
    ReasonCodeRelationshipDataMetaFromJSON: ReasonCodeRelationshipDataMetaFromJSON,
    ReasonCodeRelationshipDataMetaFromJSONTyped: ReasonCodeRelationshipDataMetaFromJSONTyped,
    ReasonCodeRelationshipDataMetaLookupFromJSON: ReasonCodeRelationshipDataMetaLookupFromJSON,
    ReasonCodeRelationshipDataMetaLookupFromJSONTyped: ReasonCodeRelationshipDataMetaLookupFromJSONTyped,
    ReasonCodeRelationshipDataMetaLookupToJSON: ReasonCodeRelationshipDataMetaLookupToJSON,
    ReasonCodeRelationshipDataMetaLookupToJSONTyped: ReasonCodeRelationshipDataMetaLookupToJSONTyped,
    ReasonCodeRelationshipDataMetaToJSON: ReasonCodeRelationshipDataMetaToJSON,
    ReasonCodeRelationshipDataMetaToJSONTyped: ReasonCodeRelationshipDataMetaToJSONTyped,
    ReasonCodeRelationshipDataToJSON: ReasonCodeRelationshipDataToJSON,
    ReasonCodeRelationshipDataToJSONTyped: ReasonCodeRelationshipDataToJSONTyped,
    ReasonCodeRelationshipDataTypeEnum: ReasonCodeRelationshipDataTypeEnum,
    ReasonCodeRelationshipFromJSON: ReasonCodeRelationshipFromJSON,
    ReasonCodeRelationshipFromJSONTyped: ReasonCodeRelationshipFromJSONTyped,
    ReasonCodeRelationshipToJSON: ReasonCodeRelationshipToJSON,
    ReasonCodeRelationshipToJSONTyped: ReasonCodeRelationshipToJSONTyped,
    RequestType: RequestType,
    RequestTypeFromJSON: RequestTypeFromJSON,
    RequestTypeFromJSONTyped: RequestTypeFromJSONTyped,
    RequestTypeToJSON: RequestTypeToJSON,
    RequestTypeToJSONTyped: RequestTypeToJSONTyped,
    RequiredError: RequiredError,
    ResponseError: ResponseError,
    RoleRelationshipDataFromJSON: RoleRelationshipDataFromJSON,
    RoleRelationshipDataFromJSONTyped: RoleRelationshipDataFromJSONTyped,
    RoleRelationshipDataMetaFromJSON: RoleRelationshipDataMetaFromJSON,
    RoleRelationshipDataMetaFromJSONTyped: RoleRelationshipDataMetaFromJSONTyped,
    RoleRelationshipDataMetaLookupFromJSON: RoleRelationshipDataMetaLookupFromJSON,
    RoleRelationshipDataMetaLookupFromJSONTyped: RoleRelationshipDataMetaLookupFromJSONTyped,
    RoleRelationshipDataMetaLookupToJSON: RoleRelationshipDataMetaLookupToJSON,
    RoleRelationshipDataMetaLookupToJSONTyped: RoleRelationshipDataMetaLookupToJSONTyped,
    RoleRelationshipDataMetaToJSON: RoleRelationshipDataMetaToJSON,
    RoleRelationshipDataMetaToJSONTyped: RoleRelationshipDataMetaToJSONTyped,
    RoleRelationshipDataToJSON: RoleRelationshipDataToJSON,
    RoleRelationshipDataToJSONTyped: RoleRelationshipDataToJSONTyped,
    RoleRelationshipDataTypeEnum: RoleRelationshipDataTypeEnum,
    RoleRelationshipFromJSON: RoleRelationshipFromJSON,
    RoleRelationshipFromJSONTyped: RoleRelationshipFromJSONTyped,
    RoleRelationshipToJSON: RoleRelationshipToJSON,
    RoleRelationshipToJSONTyped: RoleRelationshipToJSONTyped,
    RollbackAbsenceCaseHistoryEventRequestDataAttributesFromJSON: RollbackAbsenceCaseHistoryEventRequestDataAttributesFromJSON,
    RollbackAbsenceCaseHistoryEventRequestDataAttributesFromJSONTyped: RollbackAbsenceCaseHistoryEventRequestDataAttributesFromJSONTyped,
    RollbackAbsenceCaseHistoryEventRequestDataAttributesToJSON: RollbackAbsenceCaseHistoryEventRequestDataAttributesToJSON,
    RollbackAbsenceCaseHistoryEventRequestDataAttributesToJSONTyped: RollbackAbsenceCaseHistoryEventRequestDataAttributesToJSONTyped,
    RollbackAbsenceCaseHistoryEventRequestDataFromJSON: RollbackAbsenceCaseHistoryEventRequestDataFromJSON,
    RollbackAbsenceCaseHistoryEventRequestDataFromJSONTyped: RollbackAbsenceCaseHistoryEventRequestDataFromJSONTyped,
    RollbackAbsenceCaseHistoryEventRequestDataRelationshipsFromJSON: RollbackAbsenceCaseHistoryEventRequestDataRelationshipsFromJSON,
    RollbackAbsenceCaseHistoryEventRequestDataRelationshipsFromJSONTyped: RollbackAbsenceCaseHistoryEventRequestDataRelationshipsFromJSONTyped,
    RollbackAbsenceCaseHistoryEventRequestDataRelationshipsToJSON: RollbackAbsenceCaseHistoryEventRequestDataRelationshipsToJSON,
    RollbackAbsenceCaseHistoryEventRequestDataRelationshipsToJSONTyped: RollbackAbsenceCaseHistoryEventRequestDataRelationshipsToJSONTyped,
    RollbackAbsenceCaseHistoryEventRequestDataToJSON: RollbackAbsenceCaseHistoryEventRequestDataToJSON,
    RollbackAbsenceCaseHistoryEventRequestDataToJSONTyped: RollbackAbsenceCaseHistoryEventRequestDataToJSONTyped,
    RollbackAbsenceCaseHistoryEventRequestDataTypeEnum: RollbackAbsenceCaseHistoryEventRequestDataTypeEnum,
    RollbackAbsenceCaseHistoryEventRequestFromJSON: RollbackAbsenceCaseHistoryEventRequestFromJSON,
    RollbackAbsenceCaseHistoryEventRequestFromJSONTyped: RollbackAbsenceCaseHistoryEventRequestFromJSONTyped,
    RollbackAbsenceCaseHistoryEventRequestToJSON: RollbackAbsenceCaseHistoryEventRequestToJSON,
    RollbackAbsenceCaseHistoryEventRequestToJSONTyped: RollbackAbsenceCaseHistoryEventRequestToJSONTyped,
    RollbackAbsenceCaseHistoryEventResponseDataAttributesFromJSON: RollbackAbsenceCaseHistoryEventResponseDataAttributesFromJSON,
    RollbackAbsenceCaseHistoryEventResponseDataAttributesFromJSONTyped: RollbackAbsenceCaseHistoryEventResponseDataAttributesFromJSONTyped,
    RollbackAbsenceCaseHistoryEventResponseDataAttributesToJSON: RollbackAbsenceCaseHistoryEventResponseDataAttributesToJSON,
    RollbackAbsenceCaseHistoryEventResponseDataAttributesToJSONTyped: RollbackAbsenceCaseHistoryEventResponseDataAttributesToJSONTyped,
    RollbackAbsenceCaseHistoryEventResponseDataFromJSON: RollbackAbsenceCaseHistoryEventResponseDataFromJSON,
    RollbackAbsenceCaseHistoryEventResponseDataFromJSONTyped: RollbackAbsenceCaseHistoryEventResponseDataFromJSONTyped,
    RollbackAbsenceCaseHistoryEventResponseDataRelationshipsFromJSON: RollbackAbsenceCaseHistoryEventResponseDataRelationshipsFromJSON,
    RollbackAbsenceCaseHistoryEventResponseDataRelationshipsFromJSONTyped: RollbackAbsenceCaseHistoryEventResponseDataRelationshipsFromJSONTyped,
    RollbackAbsenceCaseHistoryEventResponseDataRelationshipsToJSON: RollbackAbsenceCaseHistoryEventResponseDataRelationshipsToJSON,
    RollbackAbsenceCaseHistoryEventResponseDataRelationshipsToJSONTyped: RollbackAbsenceCaseHistoryEventResponseDataRelationshipsToJSONTyped,
    RollbackAbsenceCaseHistoryEventResponseDataToJSON: RollbackAbsenceCaseHistoryEventResponseDataToJSON,
    RollbackAbsenceCaseHistoryEventResponseDataToJSONTyped: RollbackAbsenceCaseHistoryEventResponseDataToJSONTyped,
    RollbackAbsenceCaseHistoryEventResponseDataTypeEnum: RollbackAbsenceCaseHistoryEventResponseDataTypeEnum,
    RollbackAbsenceCaseHistoryEventResponseFromJSON: RollbackAbsenceCaseHistoryEventResponseFromJSON,
    RollbackAbsenceCaseHistoryEventResponseFromJSONTyped: RollbackAbsenceCaseHistoryEventResponseFromJSONTyped,
    RollbackAbsenceCaseHistoryEventResponseIncludedInnerFromJSON: RollbackAbsenceCaseHistoryEventResponseIncludedInnerFromJSON,
    RollbackAbsenceCaseHistoryEventResponseIncludedInnerFromJSONTyped: RollbackAbsenceCaseHistoryEventResponseIncludedInnerFromJSONTyped,
    RollbackAbsenceCaseHistoryEventResponseIncludedInnerToJSON: RollbackAbsenceCaseHistoryEventResponseIncludedInnerToJSON,
    RollbackAbsenceCaseHistoryEventResponseIncludedInnerToJSONTyped: RollbackAbsenceCaseHistoryEventResponseIncludedInnerToJSONTyped,
    RollbackAbsenceCaseHistoryEventResponseToJSON: RollbackAbsenceCaseHistoryEventResponseToJSON,
    RollbackAbsenceCaseHistoryEventResponseToJSONTyped: RollbackAbsenceCaseHistoryEventResponseToJSONTyped,
    SaveShiftRequestMetaSchemaFromJSON: SaveShiftRequestMetaSchemaFromJSON,
    SaveShiftRequestMetaSchemaFromJSONTyped: SaveShiftRequestMetaSchemaFromJSONTyped,
    SaveShiftRequestMetaSchemaToJSON: SaveShiftRequestMetaSchemaToJSON,
    SaveShiftRequestMetaSchemaToJSONTyped: SaveShiftRequestMetaSchemaToJSONTyped,
    SelectedOverrideChoice: SelectedOverrideChoice,
    SelectedOverrideChoiceFromJSON: SelectedOverrideChoiceFromJSON,
    SelectedOverrideChoiceFromJSONTyped: SelectedOverrideChoiceFromJSONTyped,
    SelectedOverrideChoiceToJSON: SelectedOverrideChoiceToJSON,
    SelectedOverrideChoiceToJSONTyped: SelectedOverrideChoiceToJSONTyped,
    SelectionConstraintRelationshipDataFromJSON: SelectionConstraintRelationshipDataFromJSON,
    SelectionConstraintRelationshipDataFromJSONTyped: SelectionConstraintRelationshipDataFromJSONTyped,
    SelectionConstraintRelationshipDataMetaFromJSON: SelectionConstraintRelationshipDataMetaFromJSON,
    SelectionConstraintRelationshipDataMetaFromJSONTyped: SelectionConstraintRelationshipDataMetaFromJSONTyped,
    SelectionConstraintRelationshipDataMetaLookupFromJSON: SelectionConstraintRelationshipDataMetaLookupFromJSON,
    SelectionConstraintRelationshipDataMetaLookupFromJSONTyped: SelectionConstraintRelationshipDataMetaLookupFromJSONTyped,
    SelectionConstraintRelationshipDataMetaLookupToJSON: SelectionConstraintRelationshipDataMetaLookupToJSON,
    SelectionConstraintRelationshipDataMetaLookupToJSONTyped: SelectionConstraintRelationshipDataMetaLookupToJSONTyped,
    SelectionConstraintRelationshipDataMetaToJSON: SelectionConstraintRelationshipDataMetaToJSON,
    SelectionConstraintRelationshipDataMetaToJSONTyped: SelectionConstraintRelationshipDataMetaToJSONTyped,
    SelectionConstraintRelationshipDataToJSON: SelectionConstraintRelationshipDataToJSON,
    SelectionConstraintRelationshipDataToJSONTyped: SelectionConstraintRelationshipDataToJSONTyped,
    SelectionConstraintRelationshipDataTypeEnum: SelectionConstraintRelationshipDataTypeEnum,
    SelectionConstraintRelationshipFromJSON: SelectionConstraintRelationshipFromJSON,
    SelectionConstraintRelationshipFromJSONTyped: SelectionConstraintRelationshipFromJSONTyped,
    SelectionConstraintRelationshipToJSON: SelectionConstraintRelationshipToJSON,
    SelectionConstraintRelationshipToJSONTyped: SelectionConstraintRelationshipToJSONTyped,
    Severity: Severity,
    SeverityFromJSON: SeverityFromJSON,
    SeverityFromJSONTyped: SeverityFromJSONTyped,
    SeverityToJSON: SeverityToJSON,
    SeverityToJSONTyped: SeverityToJSONTyped,
    ShiftEmployeeRelationshipDataFromJSON: ShiftEmployeeRelationshipDataFromJSON,
    ShiftEmployeeRelationshipDataFromJSONTyped: ShiftEmployeeRelationshipDataFromJSONTyped,
    ShiftEmployeeRelationshipDataMetaFromJSON: ShiftEmployeeRelationshipDataMetaFromJSON,
    ShiftEmployeeRelationshipDataMetaFromJSONTyped: ShiftEmployeeRelationshipDataMetaFromJSONTyped,
    ShiftEmployeeRelationshipDataMetaLookupFromJSON: ShiftEmployeeRelationshipDataMetaLookupFromJSON,
    ShiftEmployeeRelationshipDataMetaLookupFromJSONTyped: ShiftEmployeeRelationshipDataMetaLookupFromJSONTyped,
    ShiftEmployeeRelationshipDataMetaLookupToJSON: ShiftEmployeeRelationshipDataMetaLookupToJSON,
    ShiftEmployeeRelationshipDataMetaLookupToJSONTyped: ShiftEmployeeRelationshipDataMetaLookupToJSONTyped,
    ShiftEmployeeRelationshipDataMetaToJSON: ShiftEmployeeRelationshipDataMetaToJSON,
    ShiftEmployeeRelationshipDataMetaToJSONTyped: ShiftEmployeeRelationshipDataMetaToJSONTyped,
    ShiftEmployeeRelationshipDataToJSON: ShiftEmployeeRelationshipDataToJSON,
    ShiftEmployeeRelationshipDataToJSONTyped: ShiftEmployeeRelationshipDataToJSONTyped,
    ShiftEmployeeRelationshipDataTypeEnum: ShiftEmployeeRelationshipDataTypeEnum,
    ShiftEmployeeRelationshipFromJSON: ShiftEmployeeRelationshipFromJSON,
    ShiftEmployeeRelationshipFromJSONTyped: ShiftEmployeeRelationshipFromJSONTyped,
    ShiftEmployeeRelationshipToJSON: ShiftEmployeeRelationshipToJSON,
    ShiftEmployeeRelationshipToJSONTyped: ShiftEmployeeRelationshipToJSONTyped,
    ShiftEventRelationshipDataFromJSON: ShiftEventRelationshipDataFromJSON,
    ShiftEventRelationshipDataFromJSONTyped: ShiftEventRelationshipDataFromJSONTyped,
    ShiftEventRelationshipDataToJSON: ShiftEventRelationshipDataToJSON,
    ShiftEventRelationshipDataToJSONTyped: ShiftEventRelationshipDataToJSONTyped,
    ShiftEventRelationshipDataTypeEnum: ShiftEventRelationshipDataTypeEnum,
    ShiftEventRelationshipFromJSON: ShiftEventRelationshipFromJSON,
    ShiftEventRelationshipFromJSONTyped: ShiftEventRelationshipFromJSONTyped,
    ShiftEventRelationshipToJSON: ShiftEventRelationshipToJSON,
    ShiftEventRelationshipToJSONTyped: ShiftEventRelationshipToJSONTyped,
    ShiftIncludedObjectFromJSON: ShiftIncludedObjectFromJSON,
    ShiftIncludedObjectFromJSONTyped: ShiftIncludedObjectFromJSONTyped,
    ShiftIncludedObjectToJSON: ShiftIncludedObjectToJSON,
    ShiftIncludedObjectToJSONTyped: ShiftIncludedObjectToJSONTyped,
    SinglePayRuleResponseSchemaFromJSON: SinglePayRuleResponseSchemaFromJSON,
    SinglePayRuleResponseSchemaFromJSONTyped: SinglePayRuleResponseSchemaFromJSONTyped,
    SinglePayRuleResponseSchemaToJSON: SinglePayRuleResponseSchemaToJSON,
    SinglePayRuleResponseSchemaToJSONTyped: SinglePayRuleResponseSchemaToJSONTyped,
    SingleShiftAttributesFromJSON: SingleShiftAttributesFromJSON,
    SingleShiftAttributesFromJSONTyped: SingleShiftAttributesFromJSONTyped,
    SingleShiftAttributesStatusEnum: SingleShiftAttributesStatusEnum,
    SingleShiftAttributesToJSON: SingleShiftAttributesToJSON,
    SingleShiftAttributesToJSONTyped: SingleShiftAttributesToJSONTyped,
    SingleShiftBreakFromJSON: SingleShiftBreakFromJSON,
    SingleShiftBreakFromJSONTyped: SingleShiftBreakFromJSONTyped,
    SingleShiftBreakToJSON: SingleShiftBreakToJSON,
    SingleShiftBreakToJSONTyped: SingleShiftBreakToJSONTyped,
    SingleShiftFromJSON: SingleShiftFromJSON,
    SingleShiftFromJSONTyped: SingleShiftFromJSONTyped,
    SingleShiftRelationshipsFromJSON: SingleShiftRelationshipsFromJSON,
    SingleShiftRelationshipsFromJSONTyped: SingleShiftRelationshipsFromJSONTyped,
    SingleShiftRelationshipsToJSON: SingleShiftRelationshipsToJSON,
    SingleShiftRelationshipsToJSONTyped: SingleShiftRelationshipsToJSONTyped,
    SingleShiftResponseSchemaFromJSON: SingleShiftResponseSchemaFromJSON,
    SingleShiftResponseSchemaFromJSONTyped: SingleShiftResponseSchemaFromJSONTyped,
    SingleShiftResponseSchemaToJSON: SingleShiftResponseSchemaToJSON,
    SingleShiftResponseSchemaToJSONTyped: SingleShiftResponseSchemaToJSONTyped,
    SingleShiftToJSON: SingleShiftToJSON,
    SingleShiftToJSONTyped: SingleShiftToJSONTyped,
    SingleShiftTypeEnum: SingleShiftTypeEnum,
    Status: Status,
    StatusFromJSON: StatusFromJSON,
    StatusFromJSONTyped: StatusFromJSONTyped,
    StatusToJSON: StatusToJSON,
    StatusToJSONTyped: StatusToJSONTyped,
    SubmitTimeOffRequestBodyFromJSON: SubmitTimeOffRequestBodyFromJSON,
    SubmitTimeOffRequestBodyFromJSONTyped: SubmitTimeOffRequestBodyFromJSONTyped,
    SubmitTimeOffRequestBodyToJSON: SubmitTimeOffRequestBodyToJSON,
    SubmitTimeOffRequestBodyToJSONTyped: SubmitTimeOffRequestBodyToJSONTyped,
    SubmitTimeOffRequestDataFromJSON: SubmitTimeOffRequestDataFromJSON,
    SubmitTimeOffRequestDataFromJSONTyped: SubmitTimeOffRequestDataFromJSONTyped,
    SubmitTimeOffRequestDataRelationshipsFromJSON: SubmitTimeOffRequestDataRelationshipsFromJSON,
    SubmitTimeOffRequestDataRelationshipsFromJSONTyped: SubmitTimeOffRequestDataRelationshipsFromJSONTyped,
    SubmitTimeOffRequestDataRelationshipsToJSON: SubmitTimeOffRequestDataRelationshipsToJSON,
    SubmitTimeOffRequestDataRelationshipsToJSONTyped: SubmitTimeOffRequestDataRelationshipsToJSONTyped,
    SubmitTimeOffRequestDataToJSON: SubmitTimeOffRequestDataToJSON,
    SubmitTimeOffRequestDataToJSONTyped: SubmitTimeOffRequestDataToJSONTyped,
    SubmitTimeOffRequestDetailFromJSON: SubmitTimeOffRequestDetailFromJSON,
    SubmitTimeOffRequestDetailFromJSONTyped: SubmitTimeOffRequestDetailFromJSONTyped,
    SubmitTimeOffRequestDetailToJSON: SubmitTimeOffRequestDetailToJSON,
    SubmitTimeOffRequestDetailToJSONTyped: SubmitTimeOffRequestDetailToJSONTyped,
    SubmitTimeOffRequestFromJSON: SubmitTimeOffRequestFromJSON,
    SubmitTimeOffRequestFromJSONTyped: SubmitTimeOffRequestFromJSONTyped,
    SubmitTimeOffRequestToJSON: SubmitTimeOffRequestToJSON,
    SubmitTimeOffRequestToJSONTyped: SubmitTimeOffRequestToJSONTyped,
    SwipeAttributesFromJSON: SwipeAttributesFromJSON,
    SwipeAttributesFromJSONTyped: SwipeAttributesFromJSONTyped,
    SwipeAttributesSwipeDataEventTypeEnum: SwipeAttributesSwipeDataEventTypeEnum,
    SwipeAttributesSwipeDataFromJSON: SwipeAttributesSwipeDataFromJSON,
    SwipeAttributesSwipeDataFromJSONTyped: SwipeAttributesSwipeDataFromJSONTyped,
    SwipeAttributesSwipeDataToJSON: SwipeAttributesSwipeDataToJSON,
    SwipeAttributesSwipeDataToJSONTyped: SwipeAttributesSwipeDataToJSONTyped,
    SwipeAttributesToJSON: SwipeAttributesToJSON,
    SwipeAttributesToJSONTyped: SwipeAttributesToJSONTyped,
    SwipeFromJSON: SwipeFromJSON,
    SwipeFromJSONTyped: SwipeFromJSONTyped,
    SwipeRequestDataFromJSON: SwipeRequestDataFromJSON,
    SwipeRequestDataFromJSONTyped: SwipeRequestDataFromJSONTyped,
    SwipeRequestDataToJSON: SwipeRequestDataToJSON,
    SwipeRequestDataToJSONTyped: SwipeRequestDataToJSONTyped,
    SwipeRequestFromJSON: SwipeRequestFromJSON,
    SwipeRequestFromJSONTyped: SwipeRequestFromJSONTyped,
    SwipeRequestToJSON: SwipeRequestToJSON,
    SwipeRequestToJSONTyped: SwipeRequestToJSONTyped,
    SwipeToJSON: SwipeToJSON,
    SwipeToJSONTyped: SwipeToJSONTyped,
    TextApiResponse: TextApiResponse,
    TimeEntriesRelationshipDataInnerFromJSON: TimeEntriesRelationshipDataInnerFromJSON,
    TimeEntriesRelationshipDataInnerFromJSONTyped: TimeEntriesRelationshipDataInnerFromJSONTyped,
    TimeEntriesRelationshipDataInnerToJSON: TimeEntriesRelationshipDataInnerToJSON,
    TimeEntriesRelationshipDataInnerToJSONTyped: TimeEntriesRelationshipDataInnerToJSONTyped,
    TimeEntriesRelationshipFromJSON: TimeEntriesRelationshipFromJSON,
    TimeEntriesRelationshipFromJSONTyped: TimeEntriesRelationshipFromJSONTyped,
    TimeEntriesRelationshipToJSON: TimeEntriesRelationshipToJSON,
    TimeEntriesRelationshipToJSONTyped: TimeEntriesRelationshipToJSONTyped,
    TimeEntryResponseDataInnerFromJSON: TimeEntryResponseDataInnerFromJSON,
    TimeEntryResponseDataInnerFromJSONTyped: TimeEntryResponseDataInnerFromJSONTyped,
    TimeEntryResponseDataInnerToJSON: TimeEntryResponseDataInnerToJSON,
    TimeEntryResponseDataInnerToJSONTyped: TimeEntryResponseDataInnerToJSONTyped,
    TimeEntryResponseFromJSON: TimeEntryResponseFromJSON,
    TimeEntryResponseFromJSONTyped: TimeEntryResponseFromJSONTyped,
    TimeEntryResponseMetaFromJSON: TimeEntryResponseMetaFromJSON,
    TimeEntryResponseMetaFromJSONTyped: TimeEntryResponseMetaFromJSONTyped,
    TimeEntryResponseMetaPeriodsInnerFromJSON: TimeEntryResponseMetaPeriodsInnerFromJSON,
    TimeEntryResponseMetaPeriodsInnerFromJSONTyped: TimeEntryResponseMetaPeriodsInnerFromJSONTyped,
    TimeEntryResponseMetaPeriodsInnerToJSON: TimeEntryResponseMetaPeriodsInnerToJSON,
    TimeEntryResponseMetaPeriodsInnerToJSONTyped: TimeEntryResponseMetaPeriodsInnerToJSONTyped,
    TimeEntryResponseMetaToJSON: TimeEntryResponseMetaToJSON,
    TimeEntryResponseMetaToJSONTyped: TimeEntryResponseMetaToJSONTyped,
    TimeEntryResponseToJSON: TimeEntryResponseToJSON,
    TimeEntryResponseToJSONTyped: TimeEntryResponseToJSONTyped,
    TimeOffFromJSON: TimeOffFromJSON,
    TimeOffFromJSONTyped: TimeOffFromJSONTyped,
    TimeOffRequestDetailsInnerFromJSON: TimeOffRequestDetailsInnerFromJSON,
    TimeOffRequestDetailsInnerFromJSONTyped: TimeOffRequestDetailsInnerFromJSONTyped,
    TimeOffRequestDetailsInnerToJSON: TimeOffRequestDetailsInnerToJSON,
    TimeOffRequestDetailsInnerToJSONTyped: TimeOffRequestDetailsInnerToJSONTyped,
    TimeOffRequestEventDataAttributesEventStatusEnum: TimeOffRequestEventDataAttributesEventStatusEnum,
    TimeOffRequestEventDataAttributesFromJSON: TimeOffRequestEventDataAttributesFromJSON,
    TimeOffRequestEventDataAttributesFromJSONTyped: TimeOffRequestEventDataAttributesFromJSONTyped,
    TimeOffRequestEventDataAttributesToJSON: TimeOffRequestEventDataAttributesToJSON,
    TimeOffRequestEventDataAttributesToJSONTyped: TimeOffRequestEventDataAttributesToJSONTyped,
    TimeOffRequestEventDataFromJSON: TimeOffRequestEventDataFromJSON,
    TimeOffRequestEventDataFromJSONTyped: TimeOffRequestEventDataFromJSONTyped,
    TimeOffRequestEventDataRelationshipsFromJSON: TimeOffRequestEventDataRelationshipsFromJSON,
    TimeOffRequestEventDataRelationshipsFromJSONTyped: TimeOffRequestEventDataRelationshipsFromJSONTyped,
    TimeOffRequestEventDataRelationshipsToJSON: TimeOffRequestEventDataRelationshipsToJSON,
    TimeOffRequestEventDataRelationshipsToJSONTyped: TimeOffRequestEventDataRelationshipsToJSONTyped,
    TimeOffRequestEventDataToJSON: TimeOffRequestEventDataToJSON,
    TimeOffRequestEventDataToJSONTyped: TimeOffRequestEventDataToJSONTyped,
    TimeOffRequestEventFromJSON: TimeOffRequestEventFromJSON,
    TimeOffRequestEventFromJSONTyped: TimeOffRequestEventFromJSONTyped,
    TimeOffRequestEventResponseDataAttributesFromJSON: TimeOffRequestEventResponseDataAttributesFromJSON,
    TimeOffRequestEventResponseDataAttributesFromJSONTyped: TimeOffRequestEventResponseDataAttributesFromJSONTyped,
    TimeOffRequestEventResponseDataAttributesToJSON: TimeOffRequestEventResponseDataAttributesToJSON,
    TimeOffRequestEventResponseDataAttributesToJSONTyped: TimeOffRequestEventResponseDataAttributesToJSONTyped,
    TimeOffRequestEventResponseDataFromJSON: TimeOffRequestEventResponseDataFromJSON,
    TimeOffRequestEventResponseDataFromJSONTyped: TimeOffRequestEventResponseDataFromJSONTyped,
    TimeOffRequestEventResponseDataRelationshipsEventSubmittedByDataFromJSON: TimeOffRequestEventResponseDataRelationshipsEventSubmittedByDataFromJSON,
    TimeOffRequestEventResponseDataRelationshipsEventSubmittedByDataFromJSONTyped: TimeOffRequestEventResponseDataRelationshipsEventSubmittedByDataFromJSONTyped,
    TimeOffRequestEventResponseDataRelationshipsEventSubmittedByDataToJSON: TimeOffRequestEventResponseDataRelationshipsEventSubmittedByDataToJSON,
    TimeOffRequestEventResponseDataRelationshipsEventSubmittedByDataToJSONTyped: TimeOffRequestEventResponseDataRelationshipsEventSubmittedByDataToJSONTyped,
    TimeOffRequestEventResponseDataRelationshipsEventSubmittedByFromJSON: TimeOffRequestEventResponseDataRelationshipsEventSubmittedByFromJSON,
    TimeOffRequestEventResponseDataRelationshipsEventSubmittedByFromJSONTyped: TimeOffRequestEventResponseDataRelationshipsEventSubmittedByFromJSONTyped,
    TimeOffRequestEventResponseDataRelationshipsEventSubmittedByToJSON: TimeOffRequestEventResponseDataRelationshipsEventSubmittedByToJSON,
    TimeOffRequestEventResponseDataRelationshipsEventSubmittedByToJSONTyped: TimeOffRequestEventResponseDataRelationshipsEventSubmittedByToJSONTyped,
    TimeOffRequestEventResponseDataRelationshipsFromJSON: TimeOffRequestEventResponseDataRelationshipsFromJSON,
    TimeOffRequestEventResponseDataRelationshipsFromJSONTyped: TimeOffRequestEventResponseDataRelationshipsFromJSONTyped,
    TimeOffRequestEventResponseDataRelationshipsToJSON: TimeOffRequestEventResponseDataRelationshipsToJSON,
    TimeOffRequestEventResponseDataRelationshipsToJSONTyped: TimeOffRequestEventResponseDataRelationshipsToJSONTyped,
    TimeOffRequestEventResponseDataToJSON: TimeOffRequestEventResponseDataToJSON,
    TimeOffRequestEventResponseDataToJSONTyped: TimeOffRequestEventResponseDataToJSONTyped,
    TimeOffRequestEventResponseFromJSON: TimeOffRequestEventResponseFromJSON,
    TimeOffRequestEventResponseFromJSONTyped: TimeOffRequestEventResponseFromJSONTyped,
    TimeOffRequestEventResponseToJSON: TimeOffRequestEventResponseToJSON,
    TimeOffRequestEventResponseToJSONTyped: TimeOffRequestEventResponseToJSONTyped,
    TimeOffRequestEventToJSON: TimeOffRequestEventToJSON,
    TimeOffRequestEventToJSONTyped: TimeOffRequestEventToJSONTyped,
    TimeOffRequestExceptionFromJSON: TimeOffRequestExceptionFromJSON,
    TimeOffRequestExceptionFromJSONTyped: TimeOffRequestExceptionFromJSONTyped,
    TimeOffRequestExceptionToJSON: TimeOffRequestExceptionToJSON,
    TimeOffRequestExceptionToJSONTyped: TimeOffRequestExceptionToJSONTyped,
    TimeOffRequestListIncludedFromJSON: TimeOffRequestListIncludedFromJSON,
    TimeOffRequestListIncludedFromJSONTyped: TimeOffRequestListIncludedFromJSONTyped,
    TimeOffRequestListIncludedToJSON: TimeOffRequestListIncludedToJSON,
    TimeOffRequestListIncludedToJSONTyped: TimeOffRequestListIncludedToJSONTyped,
    TimeOffRequestRelationshipDataFromJSON: TimeOffRequestRelationshipDataFromJSON,
    TimeOffRequestRelationshipDataFromJSONTyped: TimeOffRequestRelationshipDataFromJSONTyped,
    TimeOffRequestRelationshipDataToJSON: TimeOffRequestRelationshipDataToJSON,
    TimeOffRequestRelationshipDataToJSONTyped: TimeOffRequestRelationshipDataToJSONTyped,
    TimeOffRequestRelationshipFromJSON: TimeOffRequestRelationshipFromJSON,
    TimeOffRequestRelationshipFromJSONTyped: TimeOffRequestRelationshipFromJSONTyped,
    TimeOffRequestRelationshipToJSON: TimeOffRequestRelationshipToJSON,
    TimeOffRequestRelationshipToJSONTyped: TimeOffRequestRelationshipToJSONTyped,
    TimeOffRequestResourceAttributesFromJSON: TimeOffRequestResourceAttributesFromJSON,
    TimeOffRequestResourceAttributesFromJSONTyped: TimeOffRequestResourceAttributesFromJSONTyped,
    TimeOffRequestResourceAttributesToJSON: TimeOffRequestResourceAttributesToJSON,
    TimeOffRequestResourceAttributesToJSONTyped: TimeOffRequestResourceAttributesToJSONTyped,
    TimeOffRequestResourceFromJSON: TimeOffRequestResourceFromJSON,
    TimeOffRequestResourceFromJSONTyped: TimeOffRequestResourceFromJSONTyped,
    TimeOffRequestResourceRelationshipsFromJSON: TimeOffRequestResourceRelationshipsFromJSON,
    TimeOffRequestResourceRelationshipsFromJSONTyped: TimeOffRequestResourceRelationshipsFromJSONTyped,
    TimeOffRequestResourceRelationshipsToJSON: TimeOffRequestResourceRelationshipsToJSON,
    TimeOffRequestResourceRelationshipsToJSONTyped: TimeOffRequestResourceRelationshipsToJSONTyped,
    TimeOffRequestResourceToJSON: TimeOffRequestResourceToJSON,
    TimeOffRequestResourceToJSONTyped: TimeOffRequestResourceToJSONTyped,
    TimeOffRequestResponseAttributesFromJSON: TimeOffRequestResponseAttributesFromJSON,
    TimeOffRequestResponseAttributesFromJSONTyped: TimeOffRequestResponseAttributesFromJSONTyped,
    TimeOffRequestResponseAttributesToJSON: TimeOffRequestResponseAttributesToJSON,
    TimeOffRequestResponseAttributesToJSONTyped: TimeOffRequestResponseAttributesToJSONTyped,
    TimeOffRequestResponseMetaFromJSON: TimeOffRequestResponseMetaFromJSON,
    TimeOffRequestResponseMetaFromJSONTyped: TimeOffRequestResponseMetaFromJSONTyped,
    TimeOffRequestResponseMetaToJSON: TimeOffRequestResponseMetaToJSON,
    TimeOffRequestResponseMetaToJSONTyped: TimeOffRequestResponseMetaToJSONTyped,
    TimeOffRequestResponseRelationshipsFromJSON: TimeOffRequestResponseRelationshipsFromJSON,
    TimeOffRequestResponseRelationshipsFromJSONTyped: TimeOffRequestResponseRelationshipsFromJSONTyped,
    TimeOffRequestResponseRelationshipsToJSON: TimeOffRequestResponseRelationshipsToJSON,
    TimeOffRequestResponseRelationshipsToJSONTyped: TimeOffRequestResponseRelationshipsToJSONTyped,
    TimeOffToJSON: TimeOffToJSON,
    TimeOffToJSONTyped: TimeOffToJSONTyped,
    TimesheetApprovalLayoutResponseDataInnerAttributesFromJSON: TimesheetApprovalLayoutResponseDataInnerAttributesFromJSON,
    TimesheetApprovalLayoutResponseDataInnerAttributesFromJSONTyped: TimesheetApprovalLayoutResponseDataInnerAttributesFromJSONTyped,
    TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerColumnTypeEnum: TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerColumnTypeEnum,
    TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerFromJSON: TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerFromJSON,
    TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerFromJSONTyped: TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerFromJSONTyped,
    TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerToJSON: TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerToJSON,
    TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerToJSONTyped: TimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInnerToJSONTyped,
    TimesheetApprovalLayoutResponseDataInnerAttributesToJSON: TimesheetApprovalLayoutResponseDataInnerAttributesToJSON,
    TimesheetApprovalLayoutResponseDataInnerAttributesToJSONTyped: TimesheetApprovalLayoutResponseDataInnerAttributesToJSONTyped,
    TimesheetApprovalLayoutResponseDataInnerFromJSON: TimesheetApprovalLayoutResponseDataInnerFromJSON,
    TimesheetApprovalLayoutResponseDataInnerFromJSONTyped: TimesheetApprovalLayoutResponseDataInnerFromJSONTyped,
    TimesheetApprovalLayoutResponseDataInnerToJSON: TimesheetApprovalLayoutResponseDataInnerToJSON,
    TimesheetApprovalLayoutResponseDataInnerToJSONTyped: TimesheetApprovalLayoutResponseDataInnerToJSONTyped,
    TimesheetApprovalLayoutResponseFromJSON: TimesheetApprovalLayoutResponseFromJSON,
    TimesheetApprovalLayoutResponseFromJSONTyped: TimesheetApprovalLayoutResponseFromJSONTyped,
    TimesheetApprovalLayoutResponseToJSON: TimesheetApprovalLayoutResponseToJSON,
    TimesheetApprovalLayoutResponseToJSONTyped: TimesheetApprovalLayoutResponseToJSONTyped,
    TimesheetEntryAttributesRequestSchemaFromJSON: TimesheetEntryAttributesRequestSchemaFromJSON,
    TimesheetEntryAttributesRequestSchemaFromJSONTyped: TimesheetEntryAttributesRequestSchemaFromJSONTyped,
    TimesheetEntryAttributesRequestSchemaToJSON: TimesheetEntryAttributesRequestSchemaToJSON,
    TimesheetEntryAttributesRequestSchemaToJSONTyped: TimesheetEntryAttributesRequestSchemaToJSONTyped,
    TimesheetEntryDataFromJSON: TimesheetEntryDataFromJSON,
    TimesheetEntryDataFromJSONTyped: TimesheetEntryDataFromJSONTyped,
    TimesheetEntryDataIncludedInnerFromJSON: TimesheetEntryDataIncludedInnerFromJSON,
    TimesheetEntryDataIncludedInnerFromJSONTyped: TimesheetEntryDataIncludedInnerFromJSONTyped,
    TimesheetEntryDataIncludedInnerToJSON: TimesheetEntryDataIncludedInnerToJSON,
    TimesheetEntryDataIncludedInnerToJSONTyped: TimesheetEntryDataIncludedInnerToJSONTyped,
    TimesheetEntryDataToJSON: TimesheetEntryDataToJSON,
    TimesheetEntryDataToJSONTyped: TimesheetEntryDataToJSONTyped,
    TimesheetEntryIncludeItem: TimesheetEntryIncludeItem,
    TimesheetEntryIncludeItemFromJSON: TimesheetEntryIncludeItemFromJSON,
    TimesheetEntryIncludeItemFromJSONTyped: TimesheetEntryIncludeItemFromJSONTyped,
    TimesheetEntryIncludeItemToJSON: TimesheetEntryIncludeItemToJSON,
    TimesheetEntryIncludeItemToJSONTyped: TimesheetEntryIncludeItemToJSONTyped,
    TimesheetEntryRelationshipsRequestSchemaFromJSON: TimesheetEntryRelationshipsRequestSchemaFromJSON,
    TimesheetEntryRelationshipsRequestSchemaFromJSONTyped: TimesheetEntryRelationshipsRequestSchemaFromJSONTyped,
    TimesheetEntryRelationshipsRequestSchemaToJSON: TimesheetEntryRelationshipsRequestSchemaToJSON,
    TimesheetEntryRelationshipsRequestSchemaToJSONTyped: TimesheetEntryRelationshipsRequestSchemaToJSONTyped,
    TimesheetEntryResourceAttributesFromJSON: TimesheetEntryResourceAttributesFromJSON,
    TimesheetEntryResourceAttributesFromJSONTyped: TimesheetEntryResourceAttributesFromJSONTyped,
    TimesheetEntryResourceAttributesToJSON: TimesheetEntryResourceAttributesToJSON,
    TimesheetEntryResourceAttributesToJSONTyped: TimesheetEntryResourceAttributesToJSONTyped,
    TimesheetEntryResourceFromJSON: TimesheetEntryResourceFromJSON,
    TimesheetEntryResourceFromJSONTyped: TimesheetEntryResourceFromJSONTyped,
    TimesheetEntryResourceMetaFromJSON: TimesheetEntryResourceMetaFromJSON,
    TimesheetEntryResourceMetaFromJSONTyped: TimesheetEntryResourceMetaFromJSONTyped,
    TimesheetEntryResourceMetaToJSON: TimesheetEntryResourceMetaToJSON,
    TimesheetEntryResourceMetaToJSONTyped: TimesheetEntryResourceMetaToJSONTyped,
    TimesheetEntryResourceRelationshipsFromJSON: TimesheetEntryResourceRelationshipsFromJSON,
    TimesheetEntryResourceRelationshipsFromJSONTyped: TimesheetEntryResourceRelationshipsFromJSONTyped,
    TimesheetEntryResourceRelationshipsToJSON: TimesheetEntryResourceRelationshipsToJSON,
    TimesheetEntryResourceRelationshipsToJSONTyped: TimesheetEntryResourceRelationshipsToJSONTyped,
    TimesheetEntryResourceToJSON: TimesheetEntryResourceToJSON,
    TimesheetEntryResourceToJSONTyped: TimesheetEntryResourceToJSONTyped,
    TimesheetExceptionAttributesFromJSON: TimesheetExceptionAttributesFromJSON,
    TimesheetExceptionAttributesFromJSONTyped: TimesheetExceptionAttributesFromJSONTyped,
    TimesheetExceptionAttributesToJSON: TimesheetExceptionAttributesToJSON,
    TimesheetExceptionAttributesToJSONTyped: TimesheetExceptionAttributesToJSONTyped,
    TimesheetExceptionFromJSON: TimesheetExceptionFromJSON,
    TimesheetExceptionFromJSONTyped: TimesheetExceptionFromJSONTyped,
    TimesheetExceptionPatchRequestDataAttributesFromJSON: TimesheetExceptionPatchRequestDataAttributesFromJSON,
    TimesheetExceptionPatchRequestDataAttributesFromJSONTyped: TimesheetExceptionPatchRequestDataAttributesFromJSONTyped,
    TimesheetExceptionPatchRequestDataAttributesToJSON: TimesheetExceptionPatchRequestDataAttributesToJSON,
    TimesheetExceptionPatchRequestDataAttributesToJSONTyped: TimesheetExceptionPatchRequestDataAttributesToJSONTyped,
    TimesheetExceptionPatchRequestDataFromJSON: TimesheetExceptionPatchRequestDataFromJSON,
    TimesheetExceptionPatchRequestDataFromJSONTyped: TimesheetExceptionPatchRequestDataFromJSONTyped,
    TimesheetExceptionPatchRequestDataToJSON: TimesheetExceptionPatchRequestDataToJSON,
    TimesheetExceptionPatchRequestDataToJSONTyped: TimesheetExceptionPatchRequestDataToJSONTyped,
    TimesheetExceptionPatchRequestFromJSON: TimesheetExceptionPatchRequestFromJSON,
    TimesheetExceptionPatchRequestFromJSONTyped: TimesheetExceptionPatchRequestFromJSONTyped,
    TimesheetExceptionPatchRequestToJSON: TimesheetExceptionPatchRequestToJSON,
    TimesheetExceptionPatchRequestToJSONTyped: TimesheetExceptionPatchRequestToJSONTyped,
    TimesheetExceptionRelationshipsFromJSON: TimesheetExceptionRelationshipsFromJSON,
    TimesheetExceptionRelationshipsFromJSONTyped: TimesheetExceptionRelationshipsFromJSONTyped,
    TimesheetExceptionRelationshipsToJSON: TimesheetExceptionRelationshipsToJSON,
    TimesheetExceptionRelationshipsToJSONTyped: TimesheetExceptionRelationshipsToJSONTyped,
    TimesheetExceptionToJSON: TimesheetExceptionToJSON,
    TimesheetExceptionToJSONTyped: TimesheetExceptionToJSONTyped,
    TimesheetExceptionsIncludedFromJSON: TimesheetExceptionsIncludedFromJSON,
    TimesheetExceptionsIncludedFromJSONTyped: TimesheetExceptionsIncludedFromJSONTyped,
    TimesheetExceptionsIncludedToJSON: TimesheetExceptionsIncludedToJSON,
    TimesheetExceptionsIncludedToJSONTyped: TimesheetExceptionsIncludedToJSONTyped,
    TimesheetExceptionsMetaFromJSON: TimesheetExceptionsMetaFromJSON,
    TimesheetExceptionsMetaFromJSONTyped: TimesheetExceptionsMetaFromJSONTyped,
    TimesheetExceptionsMetaToJSON: TimesheetExceptionsMetaToJSON,
    TimesheetExceptionsMetaToJSONTyped: TimesheetExceptionsMetaToJSONTyped,
    TimesheetExceptionsResponseSchemaFromJSON: TimesheetExceptionsResponseSchemaFromJSON,
    TimesheetExceptionsResponseSchemaFromJSONTyped: TimesheetExceptionsResponseSchemaFromJSONTyped,
    TimesheetExceptionsResponseSchemaToJSON: TimesheetExceptionsResponseSchemaToJSON,
    TimesheetExceptionsResponseSchemaToJSONTyped: TimesheetExceptionsResponseSchemaToJSONTyped,
    TimesheetIncludeItem: TimesheetIncludeItem,
    TimesheetIncludeItemFromJSON: TimesheetIncludeItemFromJSON,
    TimesheetIncludeItemFromJSONTyped: TimesheetIncludeItemFromJSONTyped,
    TimesheetIncludeItemToJSON: TimesheetIncludeItemToJSON,
    TimesheetIncludeItemToJSONTyped: TimesheetIncludeItemToJSONTyped,
    TimesheetRelationshipDataFromJSON: TimesheetRelationshipDataFromJSON,
    TimesheetRelationshipDataFromJSONTyped: TimesheetRelationshipDataFromJSONTyped,
    TimesheetRelationshipDataToJSON: TimesheetRelationshipDataToJSON,
    TimesheetRelationshipDataToJSONTyped: TimesheetRelationshipDataToJSONTyped,
    TimesheetRelationshipFromJSON: TimesheetRelationshipFromJSON,
    TimesheetRelationshipFromJSONTyped: TimesheetRelationshipFromJSONTyped,
    TimesheetRelationshipToJSON: TimesheetRelationshipToJSON,
    TimesheetRelationshipToJSONTyped: TimesheetRelationshipToJSONTyped,
    TimesheetResponseFromJSON: TimesheetResponseFromJSON,
    TimesheetResponseFromJSONTyped: TimesheetResponseFromJSONTyped,
    TimesheetResponseIncludedInnerFromJSON: TimesheetResponseIncludedInnerFromJSON,
    TimesheetResponseIncludedInnerFromJSONTyped: TimesheetResponseIncludedInnerFromJSONTyped,
    TimesheetResponseIncludedInnerToJSON: TimesheetResponseIncludedInnerToJSON,
    TimesheetResponseIncludedInnerToJSONTyped: TimesheetResponseIncludedInnerToJSONTyped,
    TimesheetResponseToJSON: TimesheetResponseToJSON,
    TimesheetResponseToJSONTyped: TimesheetResponseToJSONTyped,
    TimesheetSchemaAttributesApprovalDataCategoryEnum: TimesheetSchemaAttributesApprovalDataCategoryEnum,
    TimesheetSchemaAttributesApprovalDataFromJSON: TimesheetSchemaAttributesApprovalDataFromJSON,
    TimesheetSchemaAttributesApprovalDataFromJSONTyped: TimesheetSchemaAttributesApprovalDataFromJSONTyped,
    TimesheetSchemaAttributesApprovalDataToJSON: TimesheetSchemaAttributesApprovalDataToJSON,
    TimesheetSchemaAttributesApprovalDataToJSONTyped: TimesheetSchemaAttributesApprovalDataToJSONTyped,
    TimesheetSchemaAttributesFromJSON: TimesheetSchemaAttributesFromJSON,
    TimesheetSchemaAttributesFromJSONTyped: TimesheetSchemaAttributesFromJSONTyped,
    TimesheetSchemaAttributesTimesheetStateApprovalStatusEnum: TimesheetSchemaAttributesTimesheetStateApprovalStatusEnum,
    TimesheetSchemaAttributesTimesheetStateFromJSON: TimesheetSchemaAttributesTimesheetStateFromJSON,
    TimesheetSchemaAttributesTimesheetStateFromJSONTyped: TimesheetSchemaAttributesTimesheetStateFromJSONTyped,
    TimesheetSchemaAttributesTimesheetStateToJSON: TimesheetSchemaAttributesTimesheetStateToJSON,
    TimesheetSchemaAttributesTimesheetStateToJSONTyped: TimesheetSchemaAttributesTimesheetStateToJSONTyped,
    TimesheetSchemaAttributesToJSON: TimesheetSchemaAttributesToJSON,
    TimesheetSchemaAttributesToJSONTyped: TimesheetSchemaAttributesToJSONTyped,
    TimesheetSchemaFromJSON: TimesheetSchemaFromJSON,
    TimesheetSchemaFromJSONTyped: TimesheetSchemaFromJSONTyped,
    TimesheetSchemaMetaFromJSON: TimesheetSchemaMetaFromJSON,
    TimesheetSchemaMetaFromJSONTyped: TimesheetSchemaMetaFromJSONTyped,
    TimesheetSchemaMetaToJSON: TimesheetSchemaMetaToJSON,
    TimesheetSchemaMetaToJSONTyped: TimesheetSchemaMetaToJSONTyped,
    TimesheetSchemaRelationshipsFromJSON: TimesheetSchemaRelationshipsFromJSON,
    TimesheetSchemaRelationshipsFromJSONTyped: TimesheetSchemaRelationshipsFromJSONTyped,
    TimesheetSchemaRelationshipsToJSON: TimesheetSchemaRelationshipsToJSON,
    TimesheetSchemaRelationshipsToJSONTyped: TimesheetSchemaRelationshipsToJSONTyped,
    TimesheetSchemaToJSON: TimesheetSchemaToJSON,
    TimesheetSchemaToJSONTyped: TimesheetSchemaToJSONTyped,
    UpdateAbsenceCaseOperationDataFromJSON: UpdateAbsenceCaseOperationDataFromJSON,
    UpdateAbsenceCaseOperationDataFromJSONTyped: UpdateAbsenceCaseOperationDataFromJSONTyped,
    UpdateAbsenceCaseOperationDataToJSON: UpdateAbsenceCaseOperationDataToJSON,
    UpdateAbsenceCaseOperationDataToJSONTyped: UpdateAbsenceCaseOperationDataToJSONTyped,
    UpdateAbsenceCaseOperationFromJSON: UpdateAbsenceCaseOperationFromJSON,
    UpdateAbsenceCaseOperationFromJSONTyped: UpdateAbsenceCaseOperationFromJSONTyped,
    UpdateAbsenceCaseOperationOpEnum: UpdateAbsenceCaseOperationOpEnum,
    UpdateAbsenceCaseOperationToJSON: UpdateAbsenceCaseOperationToJSON,
    UpdateAbsenceCaseOperationToJSONTyped: UpdateAbsenceCaseOperationToJSONTyped,
    UpdateCaseManagerOperationDataInnerFromJSON: UpdateCaseManagerOperationDataInnerFromJSON,
    UpdateCaseManagerOperationDataInnerFromJSONTyped: UpdateCaseManagerOperationDataInnerFromJSONTyped,
    UpdateCaseManagerOperationDataInnerToJSON: UpdateCaseManagerOperationDataInnerToJSON,
    UpdateCaseManagerOperationDataInnerToJSONTyped: UpdateCaseManagerOperationDataInnerToJSONTyped,
    UpdateCaseManagerOperationFromJSON: UpdateCaseManagerOperationFromJSON,
    UpdateCaseManagerOperationFromJSONTyped: UpdateCaseManagerOperationFromJSONTyped,
    UpdateCaseManagerOperationOpEnum: UpdateCaseManagerOperationOpEnum,
    UpdateCaseManagerOperationRefFromJSON: UpdateCaseManagerOperationRefFromJSON,
    UpdateCaseManagerOperationRefFromJSONTyped: UpdateCaseManagerOperationRefFromJSONTyped,
    UpdateCaseManagerOperationRefToJSON: UpdateCaseManagerOperationRefToJSON,
    UpdateCaseManagerOperationRefToJSONTyped: UpdateCaseManagerOperationRefToJSONTyped,
    UpdateCaseManagerOperationToJSON: UpdateCaseManagerOperationToJSON,
    UpdateCaseManagerOperationToJSONTyped: UpdateCaseManagerOperationToJSONTyped,
    UpdateLeaveEligibilityOperationDataAttributesFromJSON: UpdateLeaveEligibilityOperationDataAttributesFromJSON,
    UpdateLeaveEligibilityOperationDataAttributesFromJSONTyped: UpdateLeaveEligibilityOperationDataAttributesFromJSONTyped,
    UpdateLeaveEligibilityOperationDataAttributesQualificationResultEnum: UpdateLeaveEligibilityOperationDataAttributesQualificationResultEnum,
    UpdateLeaveEligibilityOperationDataAttributesToJSON: UpdateLeaveEligibilityOperationDataAttributesToJSON,
    UpdateLeaveEligibilityOperationDataAttributesToJSONTyped: UpdateLeaveEligibilityOperationDataAttributesToJSONTyped,
    UpdateLeaveEligibilityOperationDataFromJSON: UpdateLeaveEligibilityOperationDataFromJSON,
    UpdateLeaveEligibilityOperationDataFromJSONTyped: UpdateLeaveEligibilityOperationDataFromJSONTyped,
    UpdateLeaveEligibilityOperationDataToJSON: UpdateLeaveEligibilityOperationDataToJSON,
    UpdateLeaveEligibilityOperationDataToJSONTyped: UpdateLeaveEligibilityOperationDataToJSONTyped,
    UpdateLeaveEligibilityOperationFromJSON: UpdateLeaveEligibilityOperationFromJSON,
    UpdateLeaveEligibilityOperationFromJSONTyped: UpdateLeaveEligibilityOperationFromJSONTyped,
    UpdateLeaveEligibilityOperationOpEnum: UpdateLeaveEligibilityOperationOpEnum,
    UpdateLeaveEligibilityOperationToJSON: UpdateLeaveEligibilityOperationToJSON,
    UpdateLeaveEligibilityOperationToJSONTyped: UpdateLeaveEligibilityOperationToJSONTyped,
    UpdatePayRuleRequestSchemaBodyFromJSON: UpdatePayRuleRequestSchemaBodyFromJSON,
    UpdatePayRuleRequestSchemaBodyFromJSONTyped: UpdatePayRuleRequestSchemaBodyFromJSONTyped,
    UpdatePayRuleRequestSchemaBodyToJSON: UpdatePayRuleRequestSchemaBodyToJSON,
    UpdatePayRuleRequestSchemaBodyToJSONTyped: UpdatePayRuleRequestSchemaBodyToJSONTyped,
    UpdatePayRuleRequestSchemaDataFromJSON: UpdatePayRuleRequestSchemaDataFromJSON,
    UpdatePayRuleRequestSchemaDataFromJSONTyped: UpdatePayRuleRequestSchemaDataFromJSONTyped,
    UpdatePayRuleRequestSchemaDataToJSON: UpdatePayRuleRequestSchemaDataToJSON,
    UpdatePayRuleRequestSchemaDataToJSONTyped: UpdatePayRuleRequestSchemaDataToJSONTyped,
    UpdatePayRuleRequestSchemaDataTypeEnum: UpdatePayRuleRequestSchemaDataTypeEnum,
    UpdatePayRuleRequestSchemaFromJSON: UpdatePayRuleRequestSchemaFromJSON,
    UpdatePayRuleRequestSchemaFromJSONTyped: UpdatePayRuleRequestSchemaFromJSONTyped,
    UpdatePayRuleRequestSchemaToJSON: UpdatePayRuleRequestSchemaToJSON,
    UpdatePayRuleRequestSchemaToJSONTyped: UpdatePayRuleRequestSchemaToJSONTyped,
    UpdateProjectedUsageOperationDataFromJSON: UpdateProjectedUsageOperationDataFromJSON,
    UpdateProjectedUsageOperationDataFromJSONTyped: UpdateProjectedUsageOperationDataFromJSONTyped,
    UpdateProjectedUsageOperationDataToJSON: UpdateProjectedUsageOperationDataToJSON,
    UpdateProjectedUsageOperationDataToJSONTyped: UpdateProjectedUsageOperationDataToJSONTyped,
    UpdateProjectedUsageOperationFromJSON: UpdateProjectedUsageOperationFromJSON,
    UpdateProjectedUsageOperationFromJSONTyped: UpdateProjectedUsageOperationFromJSONTyped,
    UpdateProjectedUsageOperationOpEnum: UpdateProjectedUsageOperationOpEnum,
    UpdateProjectedUsageOperationToJSON: UpdateProjectedUsageOperationToJSON,
    UpdateProjectedUsageOperationToJSONTyped: UpdateProjectedUsageOperationToJSONTyped,
    UpdateShiftRelationshipsFromJSON: UpdateShiftRelationshipsFromJSON,
    UpdateShiftRelationshipsFromJSONTyped: UpdateShiftRelationshipsFromJSONTyped,
    UpdateShiftRelationshipsToJSON: UpdateShiftRelationshipsToJSON,
    UpdateShiftRelationshipsToJSONTyped: UpdateShiftRelationshipsToJSONTyped,
    UpdateShiftRequestSchemaBodyFromJSON: UpdateShiftRequestSchemaBodyFromJSON,
    UpdateShiftRequestSchemaBodyFromJSONTyped: UpdateShiftRequestSchemaBodyFromJSONTyped,
    UpdateShiftRequestSchemaBodyToJSON: UpdateShiftRequestSchemaBodyToJSON,
    UpdateShiftRequestSchemaBodyToJSONTyped: UpdateShiftRequestSchemaBodyToJSONTyped,
    UpdateShiftRequestSchemaDataFromJSON: UpdateShiftRequestSchemaDataFromJSON,
    UpdateShiftRequestSchemaDataFromJSONTyped: UpdateShiftRequestSchemaDataFromJSONTyped,
    UpdateShiftRequestSchemaDataToJSON: UpdateShiftRequestSchemaDataToJSON,
    UpdateShiftRequestSchemaDataToJSONTyped: UpdateShiftRequestSchemaDataToJSONTyped,
    UpdateShiftRequestSchemaDataTypeEnum: UpdateShiftRequestSchemaDataTypeEnum,
    UpdateShiftRequestSchemaFromJSON: UpdateShiftRequestSchemaFromJSON,
    UpdateShiftRequestSchemaFromJSONTyped: UpdateShiftRequestSchemaFromJSONTyped,
    UpdateShiftRequestSchemaToJSON: UpdateShiftRequestSchemaToJSON,
    UpdateShiftRequestSchemaToJSONTyped: UpdateShiftRequestSchemaToJSONTyped,
    UpdateTimesheetEntryRequestSchemaDataFromJSON: UpdateTimesheetEntryRequestSchemaDataFromJSON,
    UpdateTimesheetEntryRequestSchemaDataFromJSONTyped: UpdateTimesheetEntryRequestSchemaDataFromJSONTyped,
    UpdateTimesheetEntryRequestSchemaDataToJSON: UpdateTimesheetEntryRequestSchemaDataToJSON,
    UpdateTimesheetEntryRequestSchemaDataToJSONTyped: UpdateTimesheetEntryRequestSchemaDataToJSONTyped,
    UpdateTimesheetEntryRequestSchemaFromJSON: UpdateTimesheetEntryRequestSchemaFromJSON,
    UpdateTimesheetEntryRequestSchemaFromJSONTyped: UpdateTimesheetEntryRequestSchemaFromJSONTyped,
    UpdateTimesheetEntryRequestSchemaToJSON: UpdateTimesheetEntryRequestSchemaToJSON,
    UpdateTimesheetEntryRequestSchemaToJSONTyped: UpdateTimesheetEntryRequestSchemaToJSONTyped,
    UserCardAttributesFromJSON: UserCardAttributesFromJSON,
    UserCardAttributesFromJSONTyped: UserCardAttributesFromJSONTyped,
    UserCardAttributesToJSON: UserCardAttributesToJSON,
    UserCardAttributesToJSONTyped: UserCardAttributesToJSONTyped,
    UserCardFromJSON: UserCardFromJSON,
    UserCardFromJSONTyped: UserCardFromJSONTyped,
    UserCardToJSON: UserCardToJSON,
    UserCardToJSONTyped: UserCardToJSONTyped,
    UserRelationshipsDataInnerFromJSON: UserRelationshipsDataInnerFromJSON,
    UserRelationshipsDataInnerFromJSONTyped: UserRelationshipsDataInnerFromJSONTyped,
    UserRelationshipsDataInnerToJSON: UserRelationshipsDataInnerToJSON,
    UserRelationshipsDataInnerToJSONTyped: UserRelationshipsDataInnerToJSONTyped,
    UserRelationshipsFromJSON: UserRelationshipsFromJSON,
    UserRelationshipsFromJSONTyped: UserRelationshipsFromJSONTyped,
    UserRelationshipsToJSON: UserRelationshipsToJSON,
    UserRelationshipsToJSONTyped: UserRelationshipsToJSONTyped,
    VoidApiResponse: VoidApiResponse,
    WeeklyLimitsInnerFromJSON: WeeklyLimitsInnerFromJSON,
    WeeklyLimitsInnerFromJSONTyped: WeeklyLimitsInnerFromJSONTyped,
    WeeklyLimitsInnerToJSON: WeeklyLimitsInnerToJSON,
    WeeklyLimitsInnerToJSONTyped: WeeklyLimitsInnerToJSONTyped,
    canConsumeForm: canConsumeForm,
    exists: exists,
    instanceOfAbsenceCase: instanceOfAbsenceCase,
    instanceOfAbsenceCaseAttributes: instanceOfAbsenceCaseAttributes,
    instanceOfAbsenceCaseContactEmployeeRequest: instanceOfAbsenceCaseContactEmployeeRequest,
    instanceOfAbsenceCaseContactEmployeeRequestData: instanceOfAbsenceCaseContactEmployeeRequestData,
    instanceOfAbsenceCaseContactEmployeeRequestDataAttributes: instanceOfAbsenceCaseContactEmployeeRequestDataAttributes,
    instanceOfAbsenceCaseContactEmployeeRequestDataRelationships: instanceOfAbsenceCaseContactEmployeeRequestDataRelationships,
    instanceOfAbsenceCaseContactEmployeeResponse: instanceOfAbsenceCaseContactEmployeeResponse,
    instanceOfAbsenceCaseContactEmployeeResponseAttributes: instanceOfAbsenceCaseContactEmployeeResponseAttributes,
    instanceOfAbsenceCaseContactEmployeeResponseRelationships: instanceOfAbsenceCaseContactEmployeeResponseRelationships,
    instanceOfAbsenceCaseDetails: instanceOfAbsenceCaseDetails,
    instanceOfAbsenceCaseDetailsAttributes: instanceOfAbsenceCaseDetailsAttributes,
    instanceOfAbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInner: instanceOfAbsenceCaseDetailsAttributesCaseQuestionsAndAnswersInner,
    instanceOfAbsenceCaseDetailsRelationships: instanceOfAbsenceCaseDetailsRelationships,
    instanceOfAbsenceCaseDocumentsReduced: instanceOfAbsenceCaseDocumentsReduced,
    instanceOfAbsenceCaseDocumentsReducedAttributes: instanceOfAbsenceCaseDocumentsReducedAttributes,
    instanceOfAbsenceCaseDocumentsRelationship: instanceOfAbsenceCaseDocumentsRelationship,
    instanceOfAbsenceCaseDocumentsRelationshipDataInner: instanceOfAbsenceCaseDocumentsRelationshipDataInner,
    instanceOfAbsenceCaseEditableAttributes: instanceOfAbsenceCaseEditableAttributes,
    instanceOfAbsenceCaseEventRelationship: instanceOfAbsenceCaseEventRelationship,
    instanceOfAbsenceCaseEventRelationshipData: instanceOfAbsenceCaseEventRelationshipData,
    instanceOfAbsenceCaseEventRelationshipDataAttributes: instanceOfAbsenceCaseEventRelationshipDataAttributes,
    instanceOfAbsenceCaseHistoryEvent: instanceOfAbsenceCaseHistoryEvent,
    instanceOfAbsenceCaseHistoryEventAttributes: instanceOfAbsenceCaseHistoryEventAttributes,
    instanceOfAbsenceCaseHistoryEventRelationship: instanceOfAbsenceCaseHistoryEventRelationship,
    instanceOfAbsenceCaseHistoryEventRelationshipData: instanceOfAbsenceCaseHistoryEventRelationshipData,
    instanceOfAbsenceCaseHistoryEventRelationships: instanceOfAbsenceCaseHistoryEventRelationships,
    instanceOfAbsenceCaseLeaveEligibilityReduced: instanceOfAbsenceCaseLeaveEligibilityReduced,
    instanceOfAbsenceCaseLeaveEligibilityReducedAttributes: instanceOfAbsenceCaseLeaveEligibilityReducedAttributes,
    instanceOfAbsenceCaseLeaveEligibilityRelationship: instanceOfAbsenceCaseLeaveEligibilityRelationship,
    instanceOfAbsenceCaseLeaveEligibilityRelationshipDataInner: instanceOfAbsenceCaseLeaveEligibilityRelationshipDataInner,
    instanceOfAbsenceCaseLeaveTypeReduced: instanceOfAbsenceCaseLeaveTypeReduced,
    instanceOfAbsenceCaseLeaveTypeReducedAttributes: instanceOfAbsenceCaseLeaveTypeReducedAttributes,
    instanceOfAbsenceCaseLeaveTypeRelationship: instanceOfAbsenceCaseLeaveTypeRelationship,
    instanceOfAbsenceCaseLeaveTypeRelationshipDataInner: instanceOfAbsenceCaseLeaveTypeRelationshipDataInner,
    instanceOfAbsenceCaseProjectedUsagesReduced: instanceOfAbsenceCaseProjectedUsagesReduced,
    instanceOfAbsenceCaseProjectedUsagesReducedAttributes: instanceOfAbsenceCaseProjectedUsagesReducedAttributes,
    instanceOfAbsenceCaseProjectedUsagesRelationship: instanceOfAbsenceCaseProjectedUsagesRelationship,
    instanceOfAbsenceCaseProjectedUsagesRelationshipDataInner: instanceOfAbsenceCaseProjectedUsagesRelationshipDataInner,
    instanceOfAbsenceCaseQuestion: instanceOfAbsenceCaseQuestion,
    instanceOfAbsenceCaseQuestionAttributes: instanceOfAbsenceCaseQuestionAttributes,
    instanceOfAbsenceCaseQuestionMeta: instanceOfAbsenceCaseQuestionMeta,
    instanceOfAbsenceCaseQuestionRelationships: instanceOfAbsenceCaseQuestionRelationships,
    instanceOfAbsenceCaseReasonReduced: instanceOfAbsenceCaseReasonReduced,
    instanceOfAbsenceCaseReasonReducedAttributes: instanceOfAbsenceCaseReasonReducedAttributes,
    instanceOfAbsenceCaseReasonRelationship: instanceOfAbsenceCaseReasonRelationship,
    instanceOfAbsenceCaseReasonRelationshipData: instanceOfAbsenceCaseReasonRelationshipData,
    instanceOfAbsenceCaseReduced: instanceOfAbsenceCaseReduced,
    instanceOfAbsenceCaseRelationship: instanceOfAbsenceCaseRelationship,
    instanceOfAbsenceCaseRelationshipData: instanceOfAbsenceCaseRelationshipData,
    instanceOfAbsenceCaseRelationships: instanceOfAbsenceCaseRelationships,
    instanceOfAbsenceCaseUpdateRequest: instanceOfAbsenceCaseUpdateRequest,
    instanceOfAbsenceCaseUpdateRequestAtomicOperationsInner: instanceOfAbsenceCaseUpdateRequestAtomicOperationsInner,
    instanceOfAbsenceCaseUpdateResponse: instanceOfAbsenceCaseUpdateResponse,
    instanceOfAbsenceCaseUpdateResponseAtomicResultsInner: instanceOfAbsenceCaseUpdateResponseAtomicResultsInner,
    instanceOfAbsenceCaseUpdateResponseAtomicResultsInnerData: instanceOfAbsenceCaseUpdateResponseAtomicResultsInnerData,
    instanceOfAbsenceCaseUpdateResult: instanceOfAbsenceCaseUpdateResult,
    instanceOfAbsenceCaseUpdateResultAttributes: instanceOfAbsenceCaseUpdateResultAttributes,
    instanceOfAbsenceCaseUpdateResultRelationships: instanceOfAbsenceCaseUpdateResultRelationships,
    instanceOfAbsenceCaseUploadDocumentsRequest: instanceOfAbsenceCaseUploadDocumentsRequest,
    instanceOfAbsenceCaseUploadDocumentsRequestData: instanceOfAbsenceCaseUploadDocumentsRequestData,
    instanceOfAbsenceCaseUploadDocumentsRequestDataAttributes: instanceOfAbsenceCaseUploadDocumentsRequestDataAttributes,
    instanceOfAbsenceCaseUploadDocumentsResponse: instanceOfAbsenceCaseUploadDocumentsResponse,
    instanceOfAbsenceCaseUploadDocumentsResponseAttributes: instanceOfAbsenceCaseUploadDocumentsResponseAttributes,
    instanceOfAbsenceCaseUploadDocumentsResponseRelationships: instanceOfAbsenceCaseUploadDocumentsResponseRelationships,
    instanceOfAbsenceCaseWorkflowEvent: instanceOfAbsenceCaseWorkflowEvent,
    instanceOfAbsenceCaseWorkflowEventAttributes: instanceOfAbsenceCaseWorkflowEventAttributes,
    instanceOfAbsenceCaseWorkflowEventEmployeeRelationship: instanceOfAbsenceCaseWorkflowEventEmployeeRelationship,
    instanceOfAbsenceCaseWorkflowEventEmployeeRelationshipData: instanceOfAbsenceCaseWorkflowEventEmployeeRelationshipData,
    instanceOfAbsenceCaseWorkflowEventRelationships: instanceOfAbsenceCaseWorkflowEventRelationships,
    instanceOfAbsenceCaseWorkflowEventTypeReduced: instanceOfAbsenceCaseWorkflowEventTypeReduced,
    instanceOfAbsenceCaseWorkflowEventTypeReducedAttributes: instanceOfAbsenceCaseWorkflowEventTypeReducedAttributes,
    instanceOfAbsenceCaseWorkflowEventTypeRelationship: instanceOfAbsenceCaseWorkflowEventTypeRelationship,
    instanceOfAbsenceCaseWorkflowEventTypeRelationshipData: instanceOfAbsenceCaseWorkflowEventTypeRelationshipData,
    instanceOfAbsenceCreateCaseRequest: instanceOfAbsenceCreateCaseRequest,
    instanceOfAbsenceCreateCaseRequestData: instanceOfAbsenceCreateCaseRequestData,
    instanceOfAbsenceCreateCaseRequestDataAttributes: instanceOfAbsenceCreateCaseRequestDataAttributes,
    instanceOfAbsenceCreateCaseRequestDataAttributesQuestionResponsesInner: instanceOfAbsenceCreateCaseRequestDataAttributesQuestionResponsesInner,
    instanceOfAbsenceCreateCaseRequestDataRelationships: instanceOfAbsenceCreateCaseRequestDataRelationships,
    instanceOfAbsenceCreateCaseResponse: instanceOfAbsenceCreateCaseResponse,
    instanceOfAbsenceCreateCaseResponseData: instanceOfAbsenceCreateCaseResponseData,
    instanceOfAbsenceCreateCaseResponseDataAttributes: instanceOfAbsenceCreateCaseResponseDataAttributes,
    instanceOfAbsenceLimitMeta: instanceOfAbsenceLimitMeta,
    instanceOfAbsenceLimitMetaOverlappingCustomRulesInner: instanceOfAbsenceLimitMetaOverlappingCustomRulesInner,
    instanceOfAbsenceLimits: instanceOfAbsenceLimits,
    instanceOfAbsenceLimitsCustomRulesInner: instanceOfAbsenceLimitsCustomRulesInner,
    instanceOfAbsenceLimitsDefaultRules: instanceOfAbsenceLimitsDefaultRules,
    instanceOfAbsenceReason: instanceOfAbsenceReason,
    instanceOfAbsenceReasonAttributes: instanceOfAbsenceReasonAttributes,
    instanceOfAbsenceType: instanceOfAbsenceType,
    instanceOfAbsenceTypeAttributes: instanceOfAbsenceTypeAttributes,
    instanceOfAbsenceTypeRelationship: instanceOfAbsenceTypeRelationship,
    instanceOfAbsenceTypeRelationshipData: instanceOfAbsenceTypeRelationshipData,
    instanceOfAbsenceTypeRelationships: instanceOfAbsenceTypeRelationships,
    instanceOfAbsenceTypeRelationshipsAllowedPayCodes: instanceOfAbsenceTypeRelationshipsAllowedPayCodes,
    instanceOfAbsenceTypeRelationshipsAllowedPayCodesDataInner: instanceOfAbsenceTypeRelationshipsAllowedPayCodesDataInner,
    instanceOfAbsenceTypeRelationshipsDefaultPayCode: instanceOfAbsenceTypeRelationshipsDefaultPayCode,
    instanceOfAbsenceTypeRelationshipsDefaultPayCodeData: instanceOfAbsenceTypeRelationshipsDefaultPayCodeData,
    instanceOfAcceptedSchema: instanceOfAcceptedSchema,
    instanceOfAcceptedSchemaData: instanceOfAcceptedSchemaData,
    instanceOfActivitiesLookupRelationship: instanceOfActivitiesLookupRelationship,
    instanceOfActivitiesLookupRelationshipSchedulingUnit: instanceOfActivitiesLookupRelationshipSchedulingUnit,
    instanceOfActivitiesLookupRelationshipSchedulingUnitMeta: instanceOfActivitiesLookupRelationshipSchedulingUnitMeta,
    instanceOfActivitiesLookupRelationshipSchedulingUnitMetaLookup: instanceOfActivitiesLookupRelationshipSchedulingUnitMetaLookup,
    instanceOfActivitiesLookupRelationshipTask: instanceOfActivitiesLookupRelationshipTask,
    instanceOfActivitiesLookupRelationshipTaskMeta: instanceOfActivitiesLookupRelationshipTaskMeta,
    instanceOfActivitiesLookupRelationshipTaskMetaLookup: instanceOfActivitiesLookupRelationshipTaskMetaLookup,
    instanceOfActivitiesRelationship: instanceOfActivitiesRelationship,
    instanceOfActivitiesRelationshipDataInner: instanceOfActivitiesRelationshipDataInner,
    instanceOfBalance: instanceOfBalance,
    instanceOfBalanceAttributes: instanceOfBalanceAttributes,
    instanceOfBalanceAttributesTimeUnit: instanceOfBalanceAttributesTimeUnit,
    instanceOfBalanceRelationships: instanceOfBalanceRelationships,
    instanceOfBalanceRelationshipsBank: instanceOfBalanceRelationshipsBank,
    instanceOfBalanceRelationshipsBankData: instanceOfBalanceRelationshipsBankData,
    instanceOfBank: instanceOfBank,
    instanceOfBankAttributes: instanceOfBankAttributes,
    instanceOfBankIncludeItem: instanceOfBankIncludeItem,
    instanceOfBankMetadata: instanceOfBankMetadata,
    instanceOfBankMetadataAttributes: instanceOfBankMetadataAttributes,
    instanceOfBankMetadataAttributesBalanceLabel: instanceOfBankMetadataAttributesBalanceLabel,
    instanceOfBankMetadataAttributesDisplayContexts: instanceOfBankMetadataAttributesDisplayContexts,
    instanceOfBankMetadataIncludeItem: instanceOfBankMetadataIncludeItem,
    instanceOfBankMetadataMeta: instanceOfBankMetadataMeta,
    instanceOfBankPolicyRelationship: instanceOfBankPolicyRelationship,
    instanceOfBankPolicyRelationshipData: instanceOfBankPolicyRelationshipData,
    instanceOfBankProjection: instanceOfBankProjection,
    instanceOfBankProjectionAttributes: instanceOfBankProjectionAttributes,
    instanceOfBankProjectionBalanceRelationships: instanceOfBankProjectionBalanceRelationships,
    instanceOfBankProjectionBalanceRelationshipsDataInner: instanceOfBankProjectionBalanceRelationshipsDataInner,
    instanceOfBankProjectionCreateRequest: instanceOfBankProjectionCreateRequest,
    instanceOfBankProjectionCreateRequestData: instanceOfBankProjectionCreateRequestData,
    instanceOfBankProjectionCreateRequestDataAttributes: instanceOfBankProjectionCreateRequestDataAttributes,
    instanceOfBankProjectionEntryRelationships: instanceOfBankProjectionEntryRelationships,
    instanceOfBankProjectionEntryRelationshipsDataInner: instanceOfBankProjectionEntryRelationshipsDataInner,
    instanceOfBankProjectionGapRelationships: instanceOfBankProjectionGapRelationships,
    instanceOfBankProjectionGapRelationshipsDataInner: instanceOfBankProjectionGapRelationshipsDataInner,
    instanceOfBankProjectionMeta: instanceOfBankProjectionMeta,
    instanceOfBankProjectionRequestRelationships: instanceOfBankProjectionRequestRelationships,
    instanceOfBankProjectionResponseRelationships: instanceOfBankProjectionResponseRelationships,
    instanceOfBid: instanceOfBid,
    instanceOfBidAttributes: instanceOfBidAttributes,
    instanceOfBidBlock: instanceOfBidBlock,
    instanceOfBidBlockAttributes: instanceOfBidBlockAttributes,
    instanceOfBidBlocksResponseSchema: instanceOfBidBlocksResponseSchema,
    instanceOfBidMeta: instanceOfBidMeta,
    instanceOfBidOptionsConfiguration: instanceOfBidOptionsConfiguration,
    instanceOfBidPackage: instanceOfBidPackage,
    instanceOfBidPackageAttributes: instanceOfBidPackageAttributes,
    instanceOfBidPackageMeta: instanceOfBidPackageMeta,
    instanceOfBidPackageRelationships: instanceOfBidPackageRelationships,
    instanceOfBidPackageResponseSchema: instanceOfBidPackageResponseSchema,
    instanceOfBidRelationships: instanceOfBidRelationships,
    instanceOfBidRelationshipsBidPackage: instanceOfBidRelationshipsBidPackage,
    instanceOfBidRelationshipsBidSelections: instanceOfBidRelationshipsBidSelections,
    instanceOfBidRelationshipsEmployee: instanceOfBidRelationshipsEmployee,
    instanceOfBidResourceData: instanceOfBidResourceData,
    instanceOfBidResponseSchema: instanceOfBidResponseSchema,
    instanceOfBiddingGroups: instanceOfBiddingGroups,
    instanceOfBiddingGroupsDataInner: instanceOfBiddingGroupsDataInner,
    instanceOfBidsResponseSchema: instanceOfBidsResponseSchema,
    instanceOfCaseType: instanceOfCaseType,
    instanceOfChildGroupPolicy: instanceOfChildGroupPolicy,
    instanceOfClockPunchMetadata: instanceOfClockPunchMetadata,
    instanceOfClockPunchMetadataAttributes: instanceOfClockPunchMetadataAttributes,
    instanceOfClockPunchMetadataRelationships: instanceOfClockPunchMetadataRelationships,
    instanceOfClockPunchMetadataRelationshipsLastPunch: instanceOfClockPunchMetadataRelationshipsLastPunch,
    instanceOfClockPunchMetadataResponseSchema: instanceOfClockPunchMetadataResponseSchema,
    instanceOfCreateBidRequestSchema: instanceOfCreateBidRequestSchema,
    instanceOfCreateBidRequestSchemaData: instanceOfCreateBidRequestSchemaData,
    instanceOfCreateBidpackageRequestSchema: instanceOfCreateBidpackageRequestSchema,
    instanceOfCreateBidpackageRequestSchemaData: instanceOfCreateBidpackageRequestSchemaData,
    instanceOfCreatePayRuleRequestSchema: instanceOfCreatePayRuleRequestSchema,
    instanceOfCreatePayRuleRequestSchemaBody: instanceOfCreatePayRuleRequestSchemaBody,
    instanceOfCreatePayRuleRequestSchemaData: instanceOfCreatePayRuleRequestSchemaData,
    instanceOfCreatePayRuleRequestSchemaDataRelationships: instanceOfCreatePayRuleRequestSchemaDataRelationships,
    instanceOfCreateShiftRelationships: instanceOfCreateShiftRelationships,
    instanceOfCreateShiftRequestSchema: instanceOfCreateShiftRequestSchema,
    instanceOfCreateShiftRequestSchemaBody: instanceOfCreateShiftRequestSchemaBody,
    instanceOfCreateShiftRequestSchemaData: instanceOfCreateShiftRequestSchemaData,
    instanceOfCreateSingleShiftBreak: instanceOfCreateSingleShiftBreak,
    instanceOfCreateTimesheetEntryRequestSchema: instanceOfCreateTimesheetEntryRequestSchema,
    instanceOfCreateTimesheetEntryRequestSchemaData: instanceOfCreateTimesheetEntryRequestSchemaData,
    instanceOfCreatedSwipeResponse: instanceOfCreatedSwipeResponse,
    instanceOfCreatedTimeOffResponse: instanceOfCreatedTimeOffResponse,
    instanceOfDailyDurationQuantity: instanceOfDailyDurationQuantity,
    instanceOfDailyDurationStartTimeQuantity: instanceOfDailyDurationStartTimeQuantity,
    instanceOfDailyDurationTime: instanceOfDailyDurationTime,
    instanceOfDataElement: instanceOfDataElement,
    instanceOfDataElementAttributes: instanceOfDataElementAttributes,
    instanceOfDataV1AbsenceReasonsFilterParameter: instanceOfDataV1AbsenceReasonsFilterParameter,
    instanceOfDataV1CaseChangesFilterParameter: instanceOfDataV1CaseChangesFilterParameter,
    instanceOfDataV1EmployeesFilterParameter: instanceOfDataV1EmployeesFilterParameter,
    instanceOfDayOfWeek: instanceOfDayOfWeek,
    instanceOfDeleteTimesheetEntryRequestSchema: instanceOfDeleteTimesheetEntryRequestSchema,
    instanceOfDeleteTimesheetEntryRequestSchemaData: instanceOfDeleteTimesheetEntryRequestSchemaData,
    instanceOfDiscriminatedFieldValue: instanceOfDiscriminatedFieldValue,
    instanceOfDurationDateTime: instanceOfDurationDateTime,
    instanceOfDurationQuantity: instanceOfDurationQuantity,
    instanceOfEligibleLeaveOverrideDtl: instanceOfEligibleLeaveOverrideDtl,
    instanceOfEmployee: instanceOfEmployee,
    instanceOfEmployeeAttributes: instanceOfEmployeeAttributes,
    instanceOfEmployeeBank: instanceOfEmployeeBank,
    instanceOfEmployeeBankAttributes: instanceOfEmployeeBankAttributes,
    instanceOfEmployeeBankAttributesTimeUnit: instanceOfEmployeeBankAttributesTimeUnit,
    instanceOfEmployeeBankMeta: instanceOfEmployeeBankMeta,
    instanceOfEmployeeBankRelationships: instanceOfEmployeeBankRelationships,
    instanceOfEmployeeCard: instanceOfEmployeeCard,
    instanceOfEmployeeCardAttributes: instanceOfEmployeeCardAttributes,
    instanceOfEmployeeRelationship: instanceOfEmployeeRelationship,
    instanceOfEmployeeRelationshipData: instanceOfEmployeeRelationshipData,
    instanceOfEmployeeRelationships: instanceOfEmployeeRelationships,
    instanceOfEmployeeRelationshipsWithLookup: instanceOfEmployeeRelationshipsWithLookup,
    instanceOfEmployeeRelationshipsWithLookupDataInner: instanceOfEmployeeRelationshipsWithLookupDataInner,
    instanceOfEmployeeRelationshipsWithLookupDataInnerMeta: instanceOfEmployeeRelationshipsWithLookupDataInnerMeta,
    instanceOfEmployeeRelationshipsWithLookupDataInnerMetaLookup: instanceOfEmployeeRelationshipsWithLookupDataInnerMetaLookup,
    instanceOfEmployeesJobResponse: instanceOfEmployeesJobResponse,
    instanceOfEmployeesJobsResponse: instanceOfEmployeesJobsResponse,
    instanceOfEntryType: instanceOfEntryType,
    instanceOfErrorResponse: instanceOfErrorResponse,
    instanceOfErrorSource: instanceOfErrorSource,
    instanceOfExceptionsRelationship: instanceOfExceptionsRelationship,
    instanceOfExceptionsRelationshipDataInner: instanceOfExceptionsRelationshipDataInner,
    instanceOfFieldValue: instanceOfFieldValue,
    instanceOfFormFieldRelationship: instanceOfFormFieldRelationship,
    instanceOfFormFieldRelationshipData: instanceOfFormFieldRelationshipData,
    instanceOfFormFieldsReduced: instanceOfFormFieldsReduced,
    instanceOfFormFieldsReducedAttributes: instanceOfFormFieldsReducedAttributes,
    instanceOfFormFieldsReducedAttributesOptionsInner: instanceOfFormFieldsReducedAttributesOptionsInner,
    instanceOfGeolocation: instanceOfGeolocation,
    instanceOfGetAbsenceCaseQuestionsFilterParameter: instanceOfGetAbsenceCaseQuestionsFilterParameter,
    instanceOfGetAbsenceCaseWorkflowEventsFilterParameter: instanceOfGetAbsenceCaseWorkflowEventsFilterParameter,
    instanceOfGetAbsenceCasesFilterParameter: instanceOfGetAbsenceCasesFilterParameter,
    instanceOfGetAbsenceCasesPageParameter: instanceOfGetAbsenceCasesPageParameter,
    instanceOfGetAbsenceTypesFilterParameter: instanceOfGetAbsenceTypesFilterParameter,
    instanceOfGetBankMetadataFilterParameter: instanceOfGetBankMetadataFilterParameter,
    instanceOfGetBanksFilterParameter: instanceOfGetBanksFilterParameter,
    instanceOfGetJobFilterParameter: instanceOfGetJobFilterParameter,
    instanceOfGetJobsFilterParameter: instanceOfGetJobsFilterParameter,
    instanceOfGetPoliciesFilterParameter: instanceOfGetPoliciesFilterParameter,
    instanceOfGetPolicySetDetailsFilterParameter: instanceOfGetPolicySetDetailsFilterParameter,
    instanceOfGetPolicyTypesFilterParameter: instanceOfGetPolicyTypesFilterParameter,
    instanceOfGetShiftsFilterParameter: instanceOfGetShiftsFilterParameter,
    instanceOfGetTimeEntriesByIdFilterParameter: instanceOfGetTimeEntriesByIdFilterParameter,
    instanceOfGetTimeOffRequestsFilterParameter: instanceOfGetTimeOffRequestsFilterParameter,
    instanceOfGetTimeOffRequestsPageParameter: instanceOfGetTimeOffRequestsPageParameter,
    instanceOfGetTimesheetApprovalLayoutFilterParameter: instanceOfGetTimesheetApprovalLayoutFilterParameter,
    instanceOfGetTimesheetEntriesFilterParameter: instanceOfGetTimesheetEntriesFilterParameter,
    instanceOfGetTimesheetExceptionsFilterParameter: instanceOfGetTimesheetExceptionsFilterParameter,
    instanceOfGetTimesheetsFilterParameter: instanceOfGetTimesheetsFilterParameter,
    instanceOfGroupRelationship: instanceOfGroupRelationship,
    instanceOfGroupRelationshipData: instanceOfGroupRelationshipData,
    instanceOfHelloResponseAttributes: instanceOfHelloResponseAttributes,
    instanceOfHelloResponseSchema: instanceOfHelloResponseSchema,
    instanceOfHelloResponseSchemaData: instanceOfHelloResponseSchemaData,
    instanceOfIncludeParamsForJobsItem: instanceOfIncludeParamsForJobsItem,
    instanceOfIncludedAbsenceTypeInformation: instanceOfIncludedAbsenceTypeInformation,
    instanceOfIncludedAbsenceTypeInformationAttributes: instanceOfIncludedAbsenceTypeInformationAttributes,
    instanceOfIncludedEmployeeInformation: instanceOfIncludedEmployeeInformation,
    instanceOfIncludedEmployeeInformationAttributes: instanceOfIncludedEmployeeInformationAttributes,
    instanceOfIncludedJobInformation: instanceOfIncludedJobInformation,
    instanceOfIncludedJobInformationAttributes: instanceOfIncludedJobInformationAttributes,
    instanceOfIncludedPayCodeWithEntryField: instanceOfIncludedPayCodeWithEntryField,
    instanceOfIncludedPayCodeWithEntryFieldAttributes: instanceOfIncludedPayCodeWithEntryFieldAttributes,
    instanceOfInlineObject: instanceOfInlineObject,
    instanceOfInlineObject1: instanceOfInlineObject1,
    instanceOfInlineObject10: instanceOfInlineObject10,
    instanceOfInlineObject11: instanceOfInlineObject11,
    instanceOfInlineObject1Links: instanceOfInlineObject1Links,
    instanceOfInlineObject1Meta: instanceOfInlineObject1Meta,
    instanceOfInlineObject1MetaPage: instanceOfInlineObject1MetaPage,
    instanceOfInlineObject2: instanceOfInlineObject2,
    instanceOfInlineObject2IncludedInner: instanceOfInlineObject2IncludedInner,
    instanceOfInlineObject3: instanceOfInlineObject3,
    instanceOfInlineObject3IncludedInner: instanceOfInlineObject3IncludedInner,
    instanceOfInlineObject4: instanceOfInlineObject4,
    instanceOfInlineObject4IncludedInner: instanceOfInlineObject4IncludedInner,
    instanceOfInlineObject5: instanceOfInlineObject5,
    instanceOfInlineObject5IncludedInner: instanceOfInlineObject5IncludedInner,
    instanceOfInlineObject6: instanceOfInlineObject6,
    instanceOfInlineObject7: instanceOfInlineObject7,
    instanceOfInlineObject8: instanceOfInlineObject8,
    instanceOfInlineObject8Included: instanceOfInlineObject8Included,
    instanceOfInlineObject9: instanceOfInlineObject9,
    instanceOfInlineObject9IncludedInnerOneOf: instanceOfInlineObject9IncludedInnerOneOf,
    instanceOfInlineObject9IncludedInnerOneOf1: instanceOfInlineObject9IncludedInnerOneOf1,
    instanceOfInlineObjectIncludedInner: instanceOfInlineObjectIncludedInner,
    instanceOfJobAttributes: instanceOfJobAttributes,
    instanceOfJobCard: instanceOfJobCard,
    instanceOfJobCardAttributes: instanceOfJobCardAttributes,
    instanceOfJobRelationship: instanceOfJobRelationship,
    instanceOfJobRelationshipData: instanceOfJobRelationshipData,
    instanceOfJobRelationships: instanceOfJobRelationships,
    instanceOfJobRelationshipsDataInner: instanceOfJobRelationshipsDataInner,
    instanceOfJobResource: instanceOfJobResource,
    instanceOfJobResourceRelationships: instanceOfJobResourceRelationships,
    instanceOfLeaveBalance: instanceOfLeaveBalance,
    instanceOfLeaveEligibility: instanceOfLeaveEligibility,
    instanceOfLeaveEligibilityDetail: instanceOfLeaveEligibilityDetail,
    instanceOfLeaveEligibleOverrideDtl: instanceOfLeaveEligibleOverrideDtl,
    instanceOfLinks: instanceOfLinks,
    instanceOfListBankMetadataResponseSchema: instanceOfListBankMetadataResponseSchema,
    instanceOfListBanksResponseSchema: instanceOfListBanksResponseSchema,
    instanceOfListBidPackagesResponseSchema: instanceOfListBidPackagesResponseSchema,
    instanceOfListDataElementsFilterParameter: instanceOfListDataElementsFilterParameter,
    instanceOfListDataElementsResponseSchema: instanceOfListDataElementsResponseSchema,
    instanceOfListShiftsResponseSchema: instanceOfListShiftsResponseSchema,
    instanceOfMasterPolicy: instanceOfMasterPolicy,
    instanceOfMeta: instanceOfMeta,
    instanceOfModelError: instanceOfModelError,
    instanceOfModule: instanceOfModule,
    instanceOfModuleError: instanceOfModuleError,
    instanceOfNextQuestionOption: instanceOfNextQuestionOption,
    instanceOfNumberFormatOptions: instanceOfNumberFormatOptions,
    instanceOfOverlapRuleInfo: instanceOfOverlapRuleInfo,
    instanceOfOvertimeTypeRelationship: instanceOfOvertimeTypeRelationship,
    instanceOfOvertimeTypeRelationshipData: instanceOfOvertimeTypeRelationshipData,
    instanceOfOvertimeTypeRelationshipDataMeta: instanceOfOvertimeTypeRelationshipDataMeta,
    instanceOfOvertimeTypeRelationshipDataMetaLookup: instanceOfOvertimeTypeRelationshipDataMetaLookup,
    instanceOfPageData: instanceOfPageData,
    instanceOfPageMetadata: instanceOfPageMetadata,
    instanceOfPayCodeCard: instanceOfPayCodeCard,
    instanceOfPayCodeCardAttributes: instanceOfPayCodeCardAttributes,
    instanceOfPayCodeRelationship: instanceOfPayCodeRelationship,
    instanceOfPayCodeRelationshipData: instanceOfPayCodeRelationshipData,
    instanceOfPayCodeRelationships: instanceOfPayCodeRelationships,
    instanceOfPayCodeRelationshipsDataInner: instanceOfPayCodeRelationshipsDataInner,
    instanceOfPayRule: instanceOfPayRule,
    instanceOfPayRuleAttributes: instanceOfPayRuleAttributes,
    instanceOfPayRuleCollectionResponseSchema: instanceOfPayRuleCollectionResponseSchema,
    instanceOfPayRuleConstraint: instanceOfPayRuleConstraint,
    instanceOfPayRuleConstraintAttributes: instanceOfPayRuleConstraintAttributes,
    instanceOfPayRuleConstraintCollectionResponseSchema: instanceOfPayRuleConstraintCollectionResponseSchema,
    instanceOfPayRuleConstraintRelationships: instanceOfPayRuleConstraintRelationships,
    instanceOfPayRuleIncludedObject: instanceOfPayRuleIncludedObject,
    instanceOfPayRuleIncludedObjectAttributes: instanceOfPayRuleIncludedObjectAttributes,
    instanceOfPayRuleKeyValueRelationship: instanceOfPayRuleKeyValueRelationship,
    instanceOfPayRuleKeyValueRelationshipData: instanceOfPayRuleKeyValueRelationshipData,
    instanceOfPayRuleRelationships: instanceOfPayRuleRelationships,
    instanceOfPoliciesResponseSchema: instanceOfPoliciesResponseSchema,
    instanceOfPolicy: instanceOfPolicy,
    instanceOfPolicyAttributes: instanceOfPolicyAttributes,
    instanceOfPolicySetDetailRecord: instanceOfPolicySetDetailRecord,
    instanceOfPolicySetDetails: instanceOfPolicySetDetails,
    instanceOfPolicySetDetailsAttributes: instanceOfPolicySetDetailsAttributes,
    instanceOfPolicySetDetailsResponseSchema: instanceOfPolicySetDetailsResponseSchema,
    instanceOfPolicyType: instanceOfPolicyType,
    instanceOfPolicyTypeAttributes: instanceOfPolicyTypeAttributes,
    instanceOfPolicyTypesResponseSchema: instanceOfPolicyTypesResponseSchema,
    instanceOfPostBankProjectionResponseSchema: instanceOfPostBankProjectionResponseSchema,
    instanceOfPostTimesheetEntryIncludeItem: instanceOfPostTimesheetEntryIncludeItem,
    instanceOfPostTimesheetEntryResponseSchema: instanceOfPostTimesheetEntryResponseSchema,
    instanceOfPostTimesheetEntryResponseSchemaData: instanceOfPostTimesheetEntryResponseSchemaData,
    instanceOfPostTimesheetEntryResponseSchemaDataAttributes: instanceOfPostTimesheetEntryResponseSchemaDataAttributes,
    instanceOfPostTimesheetEntryResponseSchemaDataRelationships: instanceOfPostTimesheetEntryResponseSchemaDataRelationships,
    instanceOfPostTimesheetEntryResponseSchemaIncludedInner: instanceOfPostTimesheetEntryResponseSchemaIncludedInner,
    instanceOfProjectionBalance: instanceOfProjectionBalance,
    instanceOfProjectionBalanceAttributes: instanceOfProjectionBalanceAttributes,
    instanceOfProjectionBalanceRelationships: instanceOfProjectionBalanceRelationships,
    instanceOfProjectionEntry: instanceOfProjectionEntry,
    instanceOfProjectionEntryRelationships: instanceOfProjectionEntryRelationships,
    instanceOfProjectionEntryRelationshipsContent: instanceOfProjectionEntryRelationshipsContent,
    instanceOfProjectionGap: instanceOfProjectionGap,
    instanceOfProjectionGapAttributes: instanceOfProjectionGapAttributes,
    instanceOfProjectionGapRelationships: instanceOfProjectionGapRelationships,
    instanceOfProjectionIncludeItem: instanceOfProjectionIncludeItem,
    instanceOfProjectionOverrides: instanceOfProjectionOverrides,
    instanceOfProjectionScope: instanceOfProjectionScope,
    instanceOfQuestionTreeNodesReduced: instanceOfQuestionTreeNodesReduced,
    instanceOfQuestionTreeNodesReducedAttributes: instanceOfQuestionTreeNodesReducedAttributes,
    instanceOfQuestionTreeNodesRelationship: instanceOfQuestionTreeNodesRelationship,
    instanceOfQuestionTreeNodesRelationshipDataInner: instanceOfQuestionTreeNodesRelationshipDataInner,
    instanceOfRankingMethods: instanceOfRankingMethods,
    instanceOfReasonCodeRelationship: instanceOfReasonCodeRelationship,
    instanceOfReasonCodeRelationshipData: instanceOfReasonCodeRelationshipData,
    instanceOfReasonCodeRelationshipDataMeta: instanceOfReasonCodeRelationshipDataMeta,
    instanceOfReasonCodeRelationshipDataMetaLookup: instanceOfReasonCodeRelationshipDataMetaLookup,
    instanceOfRequestType: instanceOfRequestType,
    instanceOfRoleRelationship: instanceOfRoleRelationship,
    instanceOfRoleRelationshipData: instanceOfRoleRelationshipData,
    instanceOfRoleRelationshipDataMeta: instanceOfRoleRelationshipDataMeta,
    instanceOfRoleRelationshipDataMetaLookup: instanceOfRoleRelationshipDataMetaLookup,
    instanceOfRollbackAbsenceCaseHistoryEventRequest: instanceOfRollbackAbsenceCaseHistoryEventRequest,
    instanceOfRollbackAbsenceCaseHistoryEventRequestData: instanceOfRollbackAbsenceCaseHistoryEventRequestData,
    instanceOfRollbackAbsenceCaseHistoryEventRequestDataAttributes: instanceOfRollbackAbsenceCaseHistoryEventRequestDataAttributes,
    instanceOfRollbackAbsenceCaseHistoryEventRequestDataRelationships: instanceOfRollbackAbsenceCaseHistoryEventRequestDataRelationships,
    instanceOfRollbackAbsenceCaseHistoryEventResponse: instanceOfRollbackAbsenceCaseHistoryEventResponse,
    instanceOfRollbackAbsenceCaseHistoryEventResponseData: instanceOfRollbackAbsenceCaseHistoryEventResponseData,
    instanceOfRollbackAbsenceCaseHistoryEventResponseDataAttributes: instanceOfRollbackAbsenceCaseHistoryEventResponseDataAttributes,
    instanceOfRollbackAbsenceCaseHistoryEventResponseDataRelationships: instanceOfRollbackAbsenceCaseHistoryEventResponseDataRelationships,
    instanceOfRollbackAbsenceCaseHistoryEventResponseIncludedInner: instanceOfRollbackAbsenceCaseHistoryEventResponseIncludedInner,
    instanceOfSaveShiftRequestMetaSchema: instanceOfSaveShiftRequestMetaSchema,
    instanceOfSelectedOverrideChoice: instanceOfSelectedOverrideChoice,
    instanceOfSelectionConstraintRelationship: instanceOfSelectionConstraintRelationship,
    instanceOfSelectionConstraintRelationshipData: instanceOfSelectionConstraintRelationshipData,
    instanceOfSelectionConstraintRelationshipDataMeta: instanceOfSelectionConstraintRelationshipDataMeta,
    instanceOfSelectionConstraintRelationshipDataMetaLookup: instanceOfSelectionConstraintRelationshipDataMetaLookup,
    instanceOfSeverity: instanceOfSeverity,
    instanceOfShiftEmployeeRelationship: instanceOfShiftEmployeeRelationship,
    instanceOfShiftEmployeeRelationshipData: instanceOfShiftEmployeeRelationshipData,
    instanceOfShiftEmployeeRelationshipDataMeta: instanceOfShiftEmployeeRelationshipDataMeta,
    instanceOfShiftEmployeeRelationshipDataMetaLookup: instanceOfShiftEmployeeRelationshipDataMetaLookup,
    instanceOfShiftEventRelationship: instanceOfShiftEventRelationship,
    instanceOfShiftEventRelationshipData: instanceOfShiftEventRelationshipData,
    instanceOfShiftIncludedObject: instanceOfShiftIncludedObject,
    instanceOfSinglePayRuleResponseSchema: instanceOfSinglePayRuleResponseSchema,
    instanceOfSingleShift: instanceOfSingleShift,
    instanceOfSingleShiftAttributes: instanceOfSingleShiftAttributes,
    instanceOfSingleShiftBreak: instanceOfSingleShiftBreak,
    instanceOfSingleShiftRelationships: instanceOfSingleShiftRelationships,
    instanceOfSingleShiftResponseSchema: instanceOfSingleShiftResponseSchema,
    instanceOfStatus: instanceOfStatus,
    instanceOfSubmitTimeOffRequest: instanceOfSubmitTimeOffRequest,
    instanceOfSubmitTimeOffRequestBody: instanceOfSubmitTimeOffRequestBody,
    instanceOfSubmitTimeOffRequestData: instanceOfSubmitTimeOffRequestData,
    instanceOfSubmitTimeOffRequestDataRelationships: instanceOfSubmitTimeOffRequestDataRelationships,
    instanceOfSubmitTimeOffRequestDetail: instanceOfSubmitTimeOffRequestDetail,
    instanceOfSwipe: instanceOfSwipe,
    instanceOfSwipeAttributes: instanceOfSwipeAttributes,
    instanceOfSwipeAttributesSwipeData: instanceOfSwipeAttributesSwipeData,
    instanceOfSwipeRequest: instanceOfSwipeRequest,
    instanceOfSwipeRequestData: instanceOfSwipeRequestData,
    instanceOfTimeEntriesRelationship: instanceOfTimeEntriesRelationship,
    instanceOfTimeEntriesRelationshipDataInner: instanceOfTimeEntriesRelationshipDataInner,
    instanceOfTimeEntryResponse: instanceOfTimeEntryResponse,
    instanceOfTimeEntryResponseDataInner: instanceOfTimeEntryResponseDataInner,
    instanceOfTimeEntryResponseMeta: instanceOfTimeEntryResponseMeta,
    instanceOfTimeEntryResponseMetaPeriodsInner: instanceOfTimeEntryResponseMetaPeriodsInner,
    instanceOfTimeOff: instanceOfTimeOff,
    instanceOfTimeOffRequestDetailsInner: instanceOfTimeOffRequestDetailsInner,
    instanceOfTimeOffRequestEvent: instanceOfTimeOffRequestEvent,
    instanceOfTimeOffRequestEventData: instanceOfTimeOffRequestEventData,
    instanceOfTimeOffRequestEventDataAttributes: instanceOfTimeOffRequestEventDataAttributes,
    instanceOfTimeOffRequestEventDataRelationships: instanceOfTimeOffRequestEventDataRelationships,
    instanceOfTimeOffRequestEventResponse: instanceOfTimeOffRequestEventResponse,
    instanceOfTimeOffRequestEventResponseData: instanceOfTimeOffRequestEventResponseData,
    instanceOfTimeOffRequestEventResponseDataAttributes: instanceOfTimeOffRequestEventResponseDataAttributes,
    instanceOfTimeOffRequestEventResponseDataRelationships: instanceOfTimeOffRequestEventResponseDataRelationships,
    instanceOfTimeOffRequestEventResponseDataRelationshipsEventSubmittedBy: instanceOfTimeOffRequestEventResponseDataRelationshipsEventSubmittedBy,
    instanceOfTimeOffRequestEventResponseDataRelationshipsEventSubmittedByData: instanceOfTimeOffRequestEventResponseDataRelationshipsEventSubmittedByData,
    instanceOfTimeOffRequestException: instanceOfTimeOffRequestException,
    instanceOfTimeOffRequestRelationship: instanceOfTimeOffRequestRelationship,
    instanceOfTimeOffRequestRelationshipData: instanceOfTimeOffRequestRelationshipData,
    instanceOfTimeOffRequestResource: instanceOfTimeOffRequestResource,
    instanceOfTimeOffRequestResourceAttributes: instanceOfTimeOffRequestResourceAttributes,
    instanceOfTimeOffRequestResourceRelationships: instanceOfTimeOffRequestResourceRelationships,
    instanceOfTimeOffRequestResponseAttributes: instanceOfTimeOffRequestResponseAttributes,
    instanceOfTimeOffRequestResponseMeta: instanceOfTimeOffRequestResponseMeta,
    instanceOfTimeOffRequestResponseRelationships: instanceOfTimeOffRequestResponseRelationships,
    instanceOfTimesheetApprovalLayoutResponse: instanceOfTimesheetApprovalLayoutResponse,
    instanceOfTimesheetApprovalLayoutResponseDataInner: instanceOfTimesheetApprovalLayoutResponseDataInner,
    instanceOfTimesheetApprovalLayoutResponseDataInnerAttributes: instanceOfTimesheetApprovalLayoutResponseDataInnerAttributes,
    instanceOfTimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInner: instanceOfTimesheetApprovalLayoutResponseDataInnerAttributesLayoutColumnsInner,
    instanceOfTimesheetEntryAttributesRequestSchema: instanceOfTimesheetEntryAttributesRequestSchema,
    instanceOfTimesheetEntryData: instanceOfTimesheetEntryData,
    instanceOfTimesheetEntryDataIncludedInner: instanceOfTimesheetEntryDataIncludedInner,
    instanceOfTimesheetEntryIncludeItem: instanceOfTimesheetEntryIncludeItem,
    instanceOfTimesheetEntryRelationshipsRequestSchema: instanceOfTimesheetEntryRelationshipsRequestSchema,
    instanceOfTimesheetEntryResource: instanceOfTimesheetEntryResource,
    instanceOfTimesheetEntryResourceAttributes: instanceOfTimesheetEntryResourceAttributes,
    instanceOfTimesheetEntryResourceMeta: instanceOfTimesheetEntryResourceMeta,
    instanceOfTimesheetEntryResourceRelationships: instanceOfTimesheetEntryResourceRelationships,
    instanceOfTimesheetException: instanceOfTimesheetException,
    instanceOfTimesheetExceptionAttributes: instanceOfTimesheetExceptionAttributes,
    instanceOfTimesheetExceptionPatchRequest: instanceOfTimesheetExceptionPatchRequest,
    instanceOfTimesheetExceptionPatchRequestData: instanceOfTimesheetExceptionPatchRequestData,
    instanceOfTimesheetExceptionPatchRequestDataAttributes: instanceOfTimesheetExceptionPatchRequestDataAttributes,
    instanceOfTimesheetExceptionRelationships: instanceOfTimesheetExceptionRelationships,
    instanceOfTimesheetExceptionsMeta: instanceOfTimesheetExceptionsMeta,
    instanceOfTimesheetExceptionsResponseSchema: instanceOfTimesheetExceptionsResponseSchema,
    instanceOfTimesheetIncludeItem: instanceOfTimesheetIncludeItem,
    instanceOfTimesheetRelationship: instanceOfTimesheetRelationship,
    instanceOfTimesheetRelationshipData: instanceOfTimesheetRelationshipData,
    instanceOfTimesheetResponse: instanceOfTimesheetResponse,
    instanceOfTimesheetResponseIncludedInner: instanceOfTimesheetResponseIncludedInner,
    instanceOfTimesheetSchema: instanceOfTimesheetSchema,
    instanceOfTimesheetSchemaAttributes: instanceOfTimesheetSchemaAttributes,
    instanceOfTimesheetSchemaAttributesApprovalData: instanceOfTimesheetSchemaAttributesApprovalData,
    instanceOfTimesheetSchemaAttributesTimesheetState: instanceOfTimesheetSchemaAttributesTimesheetState,
    instanceOfTimesheetSchemaMeta: instanceOfTimesheetSchemaMeta,
    instanceOfTimesheetSchemaRelationships: instanceOfTimesheetSchemaRelationships,
    instanceOfUpdateAbsenceCaseOperation: instanceOfUpdateAbsenceCaseOperation,
    instanceOfUpdateAbsenceCaseOperationData: instanceOfUpdateAbsenceCaseOperationData,
    instanceOfUpdateCaseManagerOperation: instanceOfUpdateCaseManagerOperation,
    instanceOfUpdateCaseManagerOperationDataInner: instanceOfUpdateCaseManagerOperationDataInner,
    instanceOfUpdateCaseManagerOperationRef: instanceOfUpdateCaseManagerOperationRef,
    instanceOfUpdateLeaveEligibilityOperation: instanceOfUpdateLeaveEligibilityOperation,
    instanceOfUpdateLeaveEligibilityOperationData: instanceOfUpdateLeaveEligibilityOperationData,
    instanceOfUpdateLeaveEligibilityOperationDataAttributes: instanceOfUpdateLeaveEligibilityOperationDataAttributes,
    instanceOfUpdatePayRuleRequestSchema: instanceOfUpdatePayRuleRequestSchema,
    instanceOfUpdatePayRuleRequestSchemaBody: instanceOfUpdatePayRuleRequestSchemaBody,
    instanceOfUpdatePayRuleRequestSchemaData: instanceOfUpdatePayRuleRequestSchemaData,
    instanceOfUpdateProjectedUsageOperation: instanceOfUpdateProjectedUsageOperation,
    instanceOfUpdateProjectedUsageOperationData: instanceOfUpdateProjectedUsageOperationData,
    instanceOfUpdateShiftRelationships: instanceOfUpdateShiftRelationships,
    instanceOfUpdateShiftRequestSchema: instanceOfUpdateShiftRequestSchema,
    instanceOfUpdateShiftRequestSchemaBody: instanceOfUpdateShiftRequestSchemaBody,
    instanceOfUpdateShiftRequestSchemaData: instanceOfUpdateShiftRequestSchemaData,
    instanceOfUpdateTimesheetEntryRequestSchema: instanceOfUpdateTimesheetEntryRequestSchema,
    instanceOfUpdateTimesheetEntryRequestSchemaData: instanceOfUpdateTimesheetEntryRequestSchemaData,
    instanceOfUserCard: instanceOfUserCard,
    instanceOfUserCardAttributes: instanceOfUserCardAttributes,
    instanceOfUserRelationships: instanceOfUserRelationships,
    instanceOfUserRelationshipsDataInner: instanceOfUserRelationshipsDataInner,
    instanceOfWeeklyLimitsInner: instanceOfWeeklyLimitsInner,
    mapValues: mapValues,
    querystring: querystring
});

/**
 * Get the API url corresponding to the API Gateway in the OCI tenancy.
 */
function getApiBaseUrl() {
    if (process.env.LOCAL_API_BASE_URL) {
        return process.env.LOCAL_API_BASE_URL;
    }
    // TODO: This url will have more components when we fully support multiple environments
    return "https://api.latest.wfs.cloud";
}

// Normalize ThemeValue ("768px" | number) -> number (pixels)
var toPx = function (val) {
    return typeof val === "number" ? val : parseInt(String(val).replace(/px$/, ""), 10);
};
/**
 * component used to determine the device based on screensize
 */
var useDeviceLayout = function () {
    var theme = useTheme();
    var minMdPx = toPx(lighthouseComponentLibrary.getMinBreakpoint("md")({ theme: theme }));
    var maxMdPx = toPx(lighthouseComponentLibrary.getMaxBreakpoint("md")({ theme: theme }));
    var isMobilePortrait = MediaQuery.useMediaQuery({
        maxWidth: minMdPx - 1,
        orientation: "portrait",
    });
    var isMobileLandscape = MediaQuery.useMediaQuery({
        maxWidth: maxMdPx,
        orientation: "landscape",
    });
    var isDesktopPortrait = MediaQuery.useMediaQuery({
        minWidth: minMdPx,
        orientation: "portrait",
    });
    var isDesktopLandscape = MediaQuery.useMediaQuery({
        minWidth: maxMdPx + 1,
        orientation: "landscape",
    });
    var isMobileLayout = isMobilePortrait || isMobileLandscape;
    return {
        isMobileLayout: isMobileLayout,
        isDesktopPortrait: isDesktopPortrait,
        isDesktopLandscape: isDesktopLandscape,
        isMobilePortrait: isMobilePortrait,
        isMobileLandscape: isMobileLandscape,
    };
};

var MFE_URL_PATTERN = /^REACT_APP_MFE_([A-Z0-9_]+)_URL$/;
var normalizeKey = function (key) {
    return key.toLowerCase().replace(/_/g, "-");
};
var getEnvValue = function (env, key) {
    var value = env[key];
    if (!value) {
        return undefined;
    }
    var trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : undefined;
};
var parsePrefixedVariables = function (env) {
    var configs = [];
    Object.keys(env).forEach(function (envKey) {
        var match = envKey.match(MFE_URL_PATTERN);
        if (!match) {
            return;
        }
        var rawKey = match[1];
        var keyRoot = "REACT_APP_MFE_" + rawKey;
        var deploymentUrl = getEnvValue(env, envKey);
        if (!deploymentUrl) {
            return;
        }
        var normalizedId = normalizeKey(rawKey);
        configs.push({
            id: getEnvValue(env, keyRoot + "_ID") || normalizedId,
            name: getEnvValue(env, keyRoot + "_NAME") || normalizedId,
            deploymentUrl: deploymentUrl,
            remoteEntryUrl: getEnvValue(env, keyRoot + "_REMOTE_ENTRY_URL"),
            remoteScope: getEnvValue(env, keyRoot + "_SCOPE"),
            remoteModule: getEnvValue(env, keyRoot + "_MODULE"),
            remoteExport: getEnvValue(env, keyRoot + "_EXPORT"),
        });
    });
    return configs;
};
var parseJsonConfig = function (env) {
    var raw = getEnvValue(env, "REACT_APP_MFE_DEPLOYMENTS");
    if (!raw) {
        return [];
    }
    try {
        var parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) {
            return [];
        }
        return parsed
            .filter(function (item) { return item && item.id && item.name && item.deploymentUrl; })
            .map(function (item) {
            return {
                id: item.id,
                name: item.name,
                deploymentUrl: item.deploymentUrl,
                remoteEntryUrl: item.remoteEntryUrl,
                remoteScope: item.remoteScope,
                remoteModule: item.remoteModule,
                remoteExport: item.remoteExport,
            };
        });
    }
    catch (error) {
        return [];
    }
};
var dedupeById = function (configs) {
    var byId = {};
    configs.forEach(function (config) {
        byId[config.id] = config;
    });
    return Object.keys(byId).map(function (id) { return byId[id]; });
};
var getMfeDeploymentConfigs = function (env) {
    if (env === void 0) { env = process.env; }
    var merged = parsePrefixedVariables(env).concat(parseJsonConfig(env));
    return dedupeById(merged);
};

var scriptLoadCache = {};
/**
 * Determines whether a value is a renderable React component type.
 */
var isReactComponent = function (candidate) {
    if (candidate === null || candidate === undefined) {
        return false;
    }
    if (typeof candidate === "function") {
        return true;
    }
    // Exotic types (forwardRef, memo) are objects with a $$typeof Symbol.
    if (typeof candidate === "object" && candidate.$$typeof) {
        return true;
    }
    return false;
};
/**
 * Tries to extract a React component from a module export.
 * Checks the value itself first, then its `.default` property (ESM interop),
 * then any named export that looks like a component.
 */
var resolveComponent = function (moduleExports, preferredExportName) {
    if (isReactComponent(moduleExports)) {
        return moduleExports;
    }
    if (moduleExports !== null && typeof moduleExports === "object") {
        var exports_1 = moduleExports;
        if (preferredExportName && isReactComponent(exports_1[preferredExportName])) {
            return exports_1[preferredExportName];
        }
        // Standard ESM default export
        if (isReactComponent(exports_1.default)) {
            return exports_1.default;
        }
        // Avoid arbitrarily selecting a random export; only fall back if exactly
        // one named export looks like a component.
        var namedCandidates = Object.keys(exports_1)
            .filter(function (key) { return key !== "default"; })
            .map(function (key) { return exports_1[key]; })
            .filter(isReactComponent);
        if (namedCandidates.length === 1) {
            return namedCandidates[0];
        }
    }
    return undefined;
};
var loadScript = function (scriptUrl) {
    var existingPromise = scriptLoadCache[scriptUrl];
    if (existingPromise) {
        return existingPromise;
    }
    var loadPromise = new Promise(function (resolve, reject) {
        var existingScript = document.querySelector("script[src=\"" + CSS.escape(scriptUrl) + "\"]");
        if (existingScript) {
            if (existingScript.dataset.loaded === "true") {
                resolve();
                return;
            }
            var readyState = existingScript.readyState;
            if (readyState === "loaded" || readyState === "complete") {
                existingScript.dataset.loaded = "true";
                resolve();
                return;
            }
            existingScript.addEventListener("load", function () { return resolve(); }, { once: true });
            existingScript.addEventListener("error", function () { return reject(new Error("Failed to load script: " + scriptUrl)); }, { once: true });
            return;
        }
        var script = document.createElement("script");
        script.src = scriptUrl;
        script.async = true;
        script.type = "text/javascript";
        script.onload = function () {
            script.dataset.loaded = "true";
            resolve();
        };
        script.onerror = function () {
            reject(new Error("Failed to load script: " + scriptUrl));
        };
        document.head.appendChild(script);
    });
    scriptLoadCache[scriptUrl] = loadPromise.catch(function (error) {
        // Allow retry after a transient network/CORS/server failure.
        delete scriptLoadCache[scriptUrl];
        throw error;
    });
    return scriptLoadCache[scriptUrl];
};
/**
 * Mounts a module-federation MFE into a host DOM node using the remote's own react runtime
 */
var mountIsolatedMfe = function (config, domNode) { return __awaiter(void 0, void 0, void 0, function () {
    var scriptUrl, hostWindow, mfeContainer, isolatedScope, moduleFactory, moduleExports, RemoteComponent, exportDescription, reactEntries, reactDomEntries, reactVersionKey, reactDomVersionKey, React18, reactDomExports, ReactDOM18, root;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!config.remoteScope) {
                    throw new Error("Missing remote scope for MFE '" + config.id + "'.");
                }
                scriptUrl = config.remoteEntryUrl || config.deploymentUrl;
                return [4 /*yield*/, loadScript(scriptUrl)];
            case 1:
                _a.sent();
                hostWindow = window;
                mfeContainer = hostWindow[config.remoteScope];
                if (!mfeContainer || typeof mfeContainer.get !== "function") {
                    throw new Error("Module federation container '" + config.remoteScope + "' is not available.");
                }
                isolatedScope = {};
                if (!(typeof mfeContainer.init === "function")) return [3 /*break*/, 3];
                return [4 /*yield*/, mfeContainer.init(isolatedScope)];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [4 /*yield*/, mfeContainer.get(config.remoteModule || "./App")];
            case 4:
                moduleFactory = _a.sent();
                moduleExports = moduleFactory();
                RemoteComponent = resolveComponent(moduleExports, config.remoteExport);
                if (!RemoteComponent) {
                    exportDescription = moduleExports !== null && typeof moduleExports === "object"
                        ? "object with keys: " + (Object.keys(moduleExports).join(", ") || "(none)")
                        : String(typeof moduleExports);
                    throw new Error("MFE '" + config.id + "' did not export a valid React component (" + exportDescription + ").");
                }
                reactEntries = isolatedScope.react, reactDomEntries = isolatedScope["react-dom"];
                reactVersionKey = reactEntries && Object.keys(reactEntries)[0];
                reactDomVersionKey = reactDomEntries && Object.keys(reactDomEntries)[0];
                if (!reactEntries ||
                    !reactVersionKey ||
                    !reactDomEntries ||
                    !reactDomVersionKey) {
                    throw new Error("Remote '" + config.id + "' did not register React in its share scope. " +
                        "Isolated-dom mount requires the remote to bundle React as a shared module.");
                }
                return [4 /*yield*/, reactEntries[reactVersionKey].get()];
            case 5:
                React18 = (_a.sent())();
                return [4 /*yield*/, reactDomEntries[reactDomVersionKey].get()];
            case 6:
                reactDomExports = (_a.sent())();
                ReactDOM18 = reactDomExports.default !== undefined
                    ? reactDomExports
                    : reactDomExports;
                if (typeof ReactDOM18.createRoot !== "function") {
                    throw new Error("react-dom from remote '" + config.id + "' does not expose createRoot. " +
                        "Ensure the remote bundles react-dom 18+.");
                }
                root = ReactDOM18.createRoot(domNode);
                root.render(React18.createElement(RemoteComponent));
                return [2 /*return*/, function () {
                        root.unmount();
                    }];
        }
    });
}); };

var Container = lighthouseComponentLibrary.styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 12px;\n"], ["\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 12px;\n"])));
var Label = lighthouseComponentLibrary.styled.label(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n"])));
var Select = lighthouseComponentLibrary.styled.select(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  min-height: 36px;\n"], ["\n  width: 100%;\n  min-height: 36px;\n"])));
var RemoteContainer = lighthouseComponentLibrary.styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  min-height: 200px;\n"], ["\n  min-height: 200px;\n"])));
var DetailRow = lighthouseComponentLibrary.styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  word-break: break-all;\n"], ["\n  word-break: break-all;\n"])));
var Message = lighthouseComponentLibrary.styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  min-height: 120px;\n  display: flex;\n  align-items: center;\n"], ["\n  min-height: 120px;\n  display: flex;\n  align-items: center;\n"])));
var MfeLoaderCard = function () {
    var featureFlags = useNamedFeatureFlags(exports.FeatureFlagKey.MfeSupport);
    var isMFESupportEnabled = featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags[exports.FeatureFlagKey.MfeSupport];
    var configs = React__namespace.useMemo(function () { return getMfeDeploymentConfigs(); }, []);
    var _a = React__namespace.useState(configs[0] ? configs[0].id : ""), selectedId = _a[0], setSelectedId = _a[1];
    var _b = React__namespace.useState(null), loadError = _b[0], setLoadError = _b[1];
    var isolatedContainerRef = React__namespace.useRef(null);
    var selectedConfig = React__namespace.useMemo(function () {
        return configs.find(function (config) { return config.id === selectedId; });
    }, [configs, selectedId]);
    // Mount the remote into a ref'd div using the remote's own React runtime,
    // fully isolated from the host React tree.
    React__namespace.useEffect(function () {
        if (!selectedConfig) {
            return;
        }
        var domNode = isolatedContainerRef.current;
        if (!domNode) {
            return;
        }
        var cleanup;
        var cancelled = false;
        setLoadError(null);
        mountIsolatedMfe(selectedConfig, domNode)
            .then(function (unmount) {
            if (cancelled) {
                unmount();
            }
            else {
                cleanup = unmount;
            }
        })
            .catch(function (error) {
            if (!cancelled) {
                setLoadError(error instanceof Error
                    ? error.message
                    : "Unable to load the selected MFE.");
            }
        });
        return function () {
            cancelled = true;
            if (cleanup) {
                cleanup();
            }
        };
    }, [selectedConfig]);
    var renderMfe = function () {
        if (!selectedConfig) {
            return (React__namespace.createElement(Message, null,
                React__namespace.createElement(lighthouseComponentLibrary.Typography, { use: "captionMedium" }, "No MFEs are configured. Add REACT_APP_MFE_*_URL environment variables.")));
        }
        if (loadError) {
            return (React__namespace.createElement(Message, null,
                React__namespace.createElement(lighthouseComponentLibrary.Typography, { use: "captionMedium" }, loadError)));
        }
        return (React__namespace.createElement(Message, null,
            React__namespace.createElement(lighthouseComponentLibrary.Typography, { use: "captionMedium" }, "Loading MFE...")));
    };
    if (!isMFESupportEnabled) {
        return null;
    }
    return (React__namespace.createElement(lighthouseComponentLibrary.Card, { "data-qa": "mfeLoaderCard" },
        React__namespace.createElement(lighthouseComponentLibrary.CardHeader, { title: "MFE Loader", headerIcon: "hub" }),
        React__namespace.createElement(lighthouseComponentLibrary.CardContent, null, !configs.length ? (React__namespace.createElement(Message, null,
            React__namespace.createElement(lighthouseComponentLibrary.Typography, { use: "captionMedium" }, "No MFEs are configured. Add REACT_APP_MFE_*_URL environment variables."))) : (React__namespace.createElement(Container, null,
            React__namespace.createElement(Label, null,
                React__namespace.createElement(lighthouseComponentLibrary.Typography, { use: "captionMedium" }, "Select MFE"),
                React__namespace.createElement(Select, { value: selectedId, onChange: function (event) { return setSelectedId(event.target.value); } }, configs.map(function (config) { return (React__namespace.createElement("option", { key: config.id, value: config.id }, config.name)); }))),
            selectedConfig && (React__namespace.createElement(DetailRow, null,
                React__namespace.createElement(lighthouseComponentLibrary.Typography, { use: "captionMedium" },
                    "Deployment URL: ",
                    selectedConfig.deploymentUrl))),
            renderMfe(),
            React__namespace.createElement(RemoteContainer, { ref: isolatedContainerRef }),
            ";")))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

var routes = [
    {
        id: "mfe-loader",
        route: "/mfeLoaderCard",
        component: MfeLoaderCard,
        restricted: true,
    },
];

var MFE_LOADER_CARD_ID = "mfe-loader/mfeLoaderCard";
var mfeLoaderCardSpec = {
    getId: function () { return MFE_LOADER_CARD_ID; },
    getName: function () { return "MFE Loader"; },
    getConfig: function () { return ({}); },
};
var create = function (cardSpecification, editMode, changeHubCardConfig) {
    if (cardSpecification.getId() === MFE_LOADER_CARD_ID) {
        return React__namespace.createElement(MfeLoaderCard, null);
    }
    throw new Error("Unknown card id: " + cardSpecification.getId());
};
var getMfeLoaderHubCard = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, [mfeLoaderCardSpec]];
    });
}); };

var mfeLoaderHubCardFactory = {
    create: create,
    getCardSpecifications: getMfeLoaderHubCard,
};
var MfeLoaderModule = {
    getId: function () { return "mfe-loader-ui"; },
    getName: function () { return "MfeLoader"; },
    setFrameworkInstance: setFrameworkInstance,
    getRouteSpecifications: function () { return routes; },
    getHubCardFactory: function () { return mfeLoaderHubCardFactory; },
};

function getEmployeeTimesheetUrlUsingGUIDJobId(jobGuidId, periodDate) {
    var relativeURL = "TimeEntry.do?action=viewMyTimesheet&securityMode=employeeSelfEntry&globalJobId=" + jobGuidId + "&asOfDate=" + periodDate;
    return getWTAURL(relativeURL);
}
function getManagerTimesheetUrlUsingGUIDJobId(employeeId, jobGuidId, periodEnd) {
    var relativeURL = "ManagerFrame.do?action=createManagerFrame&timeSchedType=TIME_ENTRY&validateCache=true" +
        ("&employee=" + employeeId + "&globalJobId=" + jobGuidId + "&ppEnd=" + periodEnd);
    return getWTAURL(relativeURL);
}

var createUrlToTimesheetUsingGUIDJobId = function (employeeId, jobGuidId, isManagerException, periodEndDate) {
    if (!periodEndDate || !jobGuidId) {
        return "";
    }
    // Create the relative url to view the timesheet for this exception
    if (isManagerException) {
        // For exceptions being viewed by the manager on one of their employee's timesheets,
        // need these fields to create the url to the manager view of that timesheet.
        // Prepare fields for use in WT&A timesheet url.
        // Remove dashes from period end date ('2019-12-13' -> '20191231');
        var formattedEndDate = periodEndDate.replace(/-/g, "");
        // Create the url to view the timesheet this exception is on in the hub.
        return getManagerTimesheetUrlUsingGUIDJobId(employeeId, jobGuidId, formattedEndDate);
    }
    return getEmployeeTimesheetUrlUsingGUIDJobId(jobGuidId, periodEndDate);
};

/**
 * Convert Suite REST API errors (fetch-based) to generic API error format
 * Compatible with the suite-rest-api generated runtime error types
 *
 * @param errorType - The ApiErrorType from suite-rest-api runtime ("network" | "timeout" | "bad_response")
 * @param status - HTTP status code (if available)
 * @param serviceName - the name of the service that the request was sent to
 */
var fetchApiErrorConverter = function (errorType, status, serviceName) {
    if (errorType === "network") {
        return [
            {
                type: exports.ApiErrorType.FAILED_TO_CONNECT,
                serviceName: serviceName,
            },
        ];
    }
    if (errorType === "timeout") {
        return [
            {
                type: exports.ApiErrorType.TIMEOUT_ERROR,
                serviceName: serviceName,
            },
        ];
    }
    if (errorType === "bad_response" && status) {
        if (status >= HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR) {
            return [
                {
                    type: exports.ApiErrorType.INTERNAL_SERVER_ERROR,
                    serviceName: serviceName,
                    errorId: undefined,
                },
            ];
        }
        return [
            {
                type: mapStatusCodeToErrorType(status),
                serviceName: serviceName,
                statusCode: status,
            },
        ];
    }
    return [
        {
            type: exports.ApiErrorType.BAD_RESPONSE_ERROR,
            serviceName: serviceName,
            statusCode: status !== null && status !== void 0 ? status : 0,
        },
    ];
};
var createFetchApiErrorHandler = function (serviceName) {
    return function (errorType, status) {
        var apiErrors = fetchApiErrorConverter(errorType, status, serviceName);
        var dispatch = getStore().dispatch;
        dispatch(addApiErrors(apiErrors));
    };
};

/**
 * Consolidated Object-based access for the generated typescript fetch API
 * see generated-code/suite-rest-api/apis for the apis that will
 * become available in the returned object
 *
 * @param authenticationManager - instance of AuthenticationManager to retrieve access tokens
 */
var initializeApi = function (authenticationManager) { return __awaiter(void 0, void 0, void 0, function () {
    var accessToken, apiInstances, _loop_1, _i, _a, _b, key, ApiClass;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, authenticationManager.getAccessToken()];
            case 1:
                accessToken = _c.sent();
                apiInstances = {};
                _loop_1 = function (key, ApiClass) {
                    if (typeof ApiClass === "function" &&
                        ApiClass.prototype instanceof BaseAPI) {
                        Object.defineProperty(apiInstances, key, {
                            get: function () {
                                return new ApiClass(new Configuration({
                                    basePath: getApiBaseUrl(),
                                    accessToken: "Bearer " + accessToken,
                                    defaultErrorHandler: createFetchApiErrorHandler(key),
                                }));
                            },
                            enumerable: true,
                            configurable: true,
                        });
                    }
                };
                for (_i = 0, _a = Object.entries(GeneratedApis); _i < _a.length; _i++) {
                    _b = _a[_i], key = _b[0], ApiClass = _b[1];
                    _loop_1(key, ApiClass);
                }
                return [2 /*return*/, apiInstances];
        }
    });
}); };

Object.defineProperty(exports, 'useHistory', {
    enumerable: true,
    get: function () { return reactRouterDom.useHistory; }
});
exports.AppPanel = AppPanel;
exports.AssistantCardUrgency = AssistantCardUrgency$1;
exports.AuthenticationManager = AuthenticationManager;
exports.DEEPLINK_HANDLER_ROUTE = DEEPLINK_HANDLER_ROUTE;
exports.DateTime = FormattedDateTime;
exports.DefaultProperties = defaultProperties;
exports.DefaultPropertyNames = defaultPropertyNames;
exports.DummyModuleForUseInWrapperTesting = DummyModuleForUseInWrapperTesting;
exports.FeatureFlagsContext = FeatureFlagsContext;
exports.FormatNumber = formatNumber$1;
exports.FrameworkConfigProperties = configProperties;
exports.FrameworkConfigPropertyNames = configPropertyNames;
exports.FrameworkContext = Context;
exports.HTTP_STATUS_CODES = HTTP_STATUS_CODES;
exports.HubCardManager = HubCardManager;
exports.HubCardManagerContext = HubCardManagerContext;
exports.MfeLoaderModule = MfeLoaderModule;
exports.MockPreferences = MockPreferences;
exports.Number = NumberFormat;
exports.RestApiClient = RestApiClient;
exports.RouteContext = RouteContext;
exports.RouteLink = RouteLink;
exports.SuiteRestApi = index;
exports.SuiteRestApiApis = GeneratedApis;
exports.SuiteRestApiModels = index$1;
exports.SuiteRestApiRuntime = runtime;
exports.TranslateFunctionAndTextDirectionProvider = TranslateFunctionAndTextDirectionProvider;
exports.UnsavedChangesAlert = UnsavedChangesAlert;
exports.asJestMock = asJestMock;
exports.asJestMockWithPartialResult = asJestMockWithPartialResult;
exports.asJestMocked = asJestMocked;
exports.changeLocale = changeLocale;
exports.closeSidebar = closeSidebar;
exports.createAndInitializeLighthouseFramework = createAndInitializeLighthouseFramework;
exports.createMockPreferences = createMockPreferences;
exports.createModuleUsePreferenceHook = createModuleUsePreferenceHook;
exports.createUrlToTimesheetUsingGUIDJobId = createUrlToTimesheetUsingGUIDJobId;
exports.createUseNamedFeatureFlagsMockImplementation = createUseNamedFeatureFlagsMockImplementation;
exports.deepPartialAsComplete = deepPartialAsComplete;
exports.embedExternalPage = embedExternalPage;
exports.formatDateTime = formatDateTime;
exports.generateHubCardDismissalNotification = generateHubCardDismissalNotification;
exports.getAccessToken = getAccessToken;
exports.getAccountInfo = getAccountInfo;
exports.getApiBaseUrl = getApiBaseUrl;
exports.getDeeplinkNativeRoute = getDeeplinkNativeRoute;
exports.getFrameworkInstance = getFrameworkInstance;
exports.getFullServiceURL = getFullServiceURL;
exports.getHubCardOrderWithAddedHubCard = getHubCardOrderWithAddedHubCard;
exports.getIsAppEmbeddedFromSearchParams = getIsAppEmbeddedFromSearchParams;
exports.getServiceUrl = getServiceUrl;
exports.getUserAvatar = getUserAvatar;
exports.getWTAURL = getWTAURL;
exports.graphqlServiceFactory = graphqlServiceFactory;
exports.hasValidWfxSession = hasValidWfxSession;
exports.initializeApi = initializeApi;
exports.isMobileDevice = isMobileDevice;
exports.literal = literal;
exports.navigateToRoute = navigateToRoute;
exports.openSidebar = openSidebar;
exports.openUrlOutsideSuite = openUrlOutsideSuite;
exports.partialAsComplete = partialAsComplete;
exports.redirectToUrl = redirectToCasUrl;
exports.reportCustomError = reportCustomError;
exports.routeIdPlaceholder = idPlaceholder;
exports.setFrameworkInstance = setFrameworkInstance;
exports.setPreviewTheme = setPreviewTheme;
exports.setSessionProperties = setSessionProperties;
exports.useBackCompatPreference = useBackCompatPreference;
exports.useBlockNavigation = useBlockNavigation;
exports.useDeviceLayout = useDeviceLayout;
exports.useHubCardManagerState = useHubCardManagerState;
exports.useLocaleStorageEventListener = useLocaleStorageEventListener;
exports.useNamedFeatureFlags = useNamedFeatureFlags;
exports.useTheme = useTheme;
exports.useTypedSelector = useTypedSelector;
exports.useWfxAppUrl = useWfxAppUrl;
exports.withDependencies = withDependencies;
//# sourceMappingURL=index.js.map
